(function ()
{
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.auth_login', {
            url      : '/auth/login',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            data: {
                requireLogin: false
            },
            bodyClass: 'login'
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login')
        .controller('LanLoginController', LanLoginController);
	
    function LanLoginController($http, $location, $timeout, $base64, $document, session, Notification, $window, PRAGMA, pragmaapi, $translate, $cookies, $scope,$rootScope, $mdDialog,event)
    {
        session.destroy();
        var vm = this;
        // Data
        vm.tenants=[];
        var solutionsFlag=false;
        vm.count=0;
		vm.fPass = false;
		
        
        vm.form =
        {
            username: "",
            password: ""
        };
        
        // Methods

        vm.handleLogin = handleLogin;
        vm.forgotPass = forgotPass;
        vm.applyRequest = applyRequest;
        
        //////////
        function handleLogin() {
            vm.authentication = vm.form.username + ":" + vm.form.password;
            pragmaapi.callRestService(PRAGMA.api, "/users/" + vm.form.username, "", true, vm.authentication, "GET").then(function(res) {
                vm.user = {
                     username:  vm.form.username,
                     password:  vm.form.password,
                     firstname: res.data.firstName,
                     lastname:  res.data.lastName,
                     role:      res.data.metadata.role
                }
                pragmaapi.callRestService(PRAGMA.api, "/tenants/", "?authUserId="+vm.form.username, true, vm.authentication, "GET").then(function(res) {
                    vm.tenants=res.data.results;
                    if( vm.tenants.length==0)
                    {
                        vm.user.currentTenant='';
                        vm.user.hasVerticals=false;
                        session.setUser(vm.user);
                        $window.location.href = PRAGMA.url + '/admin';
                    }
                    for(var i=0;i<vm.tenants.length;i++)
                    {
                        getSolutions(vm.tenants[i].authenticationToken);
                    }
                });

            }, function(reason) {
                showNotification($translate.instant("LOGIN.USER_AUTHENTICATION"), $translate.instant("LOGIN.INVALID"), "Error");
            });
        }
        function getSolutions(token)
        {
            pragmaapi.callRestService(PRAGMA.api, "/verticalSolutions/tenant/", token, true, vm.authentication, "GET").then(function(res) {
                vm.count++;
                if(!solutionsFlag)
                {
                    if(res.data.results.length>0)
                    {
                        solutionsFlag=true;
                        vm.user.currentTenant=token;
                        vm.user.hasVerticals=true;   
                    }
                    else
                    {
                        vm.user.hasVerticals=false;
                    }
                    session.setUser(vm.user);
                }

                if(vm.count==vm.tenants.length)
                {
                    checkUserVerticals();
                }
            });
        }
        function checkUserVerticals()
        {
            if(!vm.user.hasVerticals)
            {
                vm.user.currentModule='';
                vm.user.parentModule='';
                vm.user.modules=[];
                session.setUser(vm.user);
                $window.location.href = PRAGMA.url + '/dashboard';
            }
            else
            {
                vm.user.authentication=vm.user.username+":"+vm.user.password;
                pragmaapi.callRestService(PRAGMA.api, "/verticalSolutions/tenant/",  vm.user.currentTenant, true, vm.user.authentication, "GET", true, false).then(function(res) {
                    var solutions=res.data.results;
                    pragmaapi.callRestService(PRAGMA.api, "/userPreferences/userId/" + vm.user.username+"/", "", true, vm.user.authentication, "GET", true, false).then(function(res) {
                        vm.userPreferences = res.data;
                        vm.user.modules=vm.userPreferences.modules;
                        if(vm.userPreferences.modules.length>1)
                        {
                            for(var i=0;i<solutions.length;i++)
                            {
                                for(var j=0;j<vm.userPreferences.modules.length;j++)
                                {
                                    if(vm.userPreferences.modules[j]===solutions[i].token && solutions[i].parent==="#")
                                    {
                                        vm.user.currentModule=vm.userPreferences.modules[j];
                                        vm.user.parentModule='#';
                                        break;
                                    }
                                }
                            }
                        }
                        else
                        {
                            for(var i=0;i<solutions.length;i++)
                            {
                                if(vm.userPreferences.modules[0]===solutions[i].token)
                                {
                                    vm.user.currentModule=vm.userPreferences.modules[0];
                                    vm.user.parentModule=solutions[i].parent;
                                    break;
                                }
                            }
                        }
                        session.setUser(vm.user);
                        $window.location.href = PRAGMA.url + '/dashboard';
                    });
                });
            }
        }
		
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
		
		function forgotPass() {
			vm.fPass = true;
		}
		
		function applyRequest() {
			if (vm.user.username) {
				//for now use admin credentials hardcoded to call the user
				vm.authentication ="admin:password";
				pragmaapi.callRestService(PRAGMA.api, "/users/" + vm.user.username, "", true, vm.authentication, "GET").then(function(res) {
					vm.user = res.data;
					vm.user.metadata.forgot_token = generateUUID();
					vm.user.metadata.forgot_expires = moment().add(2, 'hours').format('YYYY-MM-DDTHH:mm:ss.000ZZ');
					//console.log(vm.user);
					
					var response={};
					response.username=vm.user.username;
					response.firstName=vm.user.firstName;
					response.lastName=vm.user.lastName;
					response.status=vm.user.status;
					response.metadata={};
					response.metadata.email= vm.user.metadata.email;
					response.metadata.role=vm.user.metadata.role;
					response.metadata.imageUrl=vm.user.metadata.imageUrl;
					response.metadata.forgot_token = vm.user.metadata.forgot_token;
					response.metadata.forgot_expires = vm.user.metadata.forgot_expires;
					if(vm.user.metadata.phone!="")
						response.metadata.phone= vm.user.metadata.phone;
					response.authorities=vm.user.authorities;
					
					pragmaapi.callRestService(PRAGMA.api,"/users/"+response.username,response,true,vm.authentication,"PUT", true, false).then(function(res){
						
					});
					vm.fPass = false;
					var r=
					{
						user:vm.user
					}
					$mdDialog.hide(r);

				}, function(reason) {
					showNotification($translate.instant("LOGIN.USER_AUTHENTICATION"), $translate.instant("LOGIN.NOT_FOUND"), "Error");
				});
			}
		}
		
        function showNotification(title, message, type) {
            if (type === "Error") {
                Notification.error({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Info") {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Warning") {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Success") {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }   
        }
        
    }
	
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login')
        .controller('ForgotPassController', ForgotPassController);
	
    function ForgotPassController($http, $location, $timeout, $base64, $document, session, Notification, $window, PRAGMA, pragmaapi, $translate, $mdDialog)
    {
        var vm = this;
        //console.log(thisUser);
		// Data
        vm.user={
            username:""
        };
        
        
        // Methods

        vm.applyRequest = applyRequest;
		vm.closeDialog = closeDialog;
        
        //////////
		
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
		
        function applyRequest() {
            //for now use admin credentials hardcoded to call the user
			vm.authentication ="admin:password";
            pragmaapi.callRestService(PRAGMA.api, "/users/" + vm.user.username, "", true, vm.authentication, "GET").then(function(res) {
                vm.user = res.data;
				vm.user.metadata.forgot_token = generateUUID();
				vm.user.metadata.forgot_expires = moment().add(2, 'hours').format('YYYY-MM-DDTHH:mm:ss.000ZZ');
				//console.log(vm.user);
				
                var response={};
                response.username=vm.user.username;
                response.firstName=vm.user.firstName;
                response.lastName=vm.user.lastName;
                response.status=vm.user.status;
                response.metadata={};
                response.metadata.email= vm.user.metadata.email;
                response.metadata.role=vm.user.metadata.role;
                response.metadata.imageUrl=vm.user.metadata.imageUrl;
				response.metadata.forgot_token = vm.user.metadata.forgot_token;
				response.metadata.forgot_expires = vm.user.metadata.forgot_expires;
                if(vm.user.metadata.phone!="")
                    response.metadata.phone= vm.user.metadata.phone;
                response.authorities=vm.user.authorities;
				
                pragmaapi.callRestService(PRAGMA.api,"/users/"+response.username,response,true,vm.authentication,"PUT", true, false).then(function(res){
                    
                });
				
                var r=
                {
                    user:vm.user
                }
                $mdDialog.hide(r);

            }, function(reason) {
                showNotification($translate.instant("LOGIN.USER_AUTHENTICATION"), $translate.instant("LOGIN.NOT_FOUND"), "Error");
            });
        }
		
        function closeDialog()
        {
            $mdDialog.cancel();
        }
		
        function showNotification(title, message, type) {
            if (type === "Error") {
                Notification.error({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Info") {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Warning") {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Success") {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }   
        }
        
    }
	
})();
(function ()
{
    'use strict';

    angular
        .module('app.rules', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.rules', {
            url      : '/rules',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/rules/rules.html',
                    controller : 'RulesController as vm'
                }
            },
            bodyClass: 'rules'
        });
		
        // Navigation
        msNavigationServiceProvider.saveItem('rules', {
            title : 'NAVIGATION.RULES',
            state: 'app.rules',
            group : true,
            weight: 1
        });
		
    }

})();
 (function ()
{
	'use strict';
	
	angular
		.module('app.rules')
		.controller('NewVariableController', NewVariableController)
		.filter('isEmpty', [function() {
			return function(object) {
				return angular.equals({}, object);
			}
		}]);
		
	function NewVariableController($scope, $mdDialog, event, index, session, PRAGMA, pragmaapi, Notification) {
		var vm = this;
		
		// User
		vm.user = session.getUser();
		
		vm.variable = {};
		vm.index = index;
		
		vm.currentModule = vm.user.currentModule;
		vm.parentModule = vm.user.parentModule;
		
		vm.allSites = [];
		vm.allDevices = [];
		vm.allMeasurements = [];
		
		vm.currentNodeSelects = {};
		vm.currentActionDevice = null;
		
		vm.getSiteDevices = getSiteDevices;
		vm.getDeviceMeasurements = getDeviceMeasurements;
		
		vm.createNewVariable = createNewVariable;
		vm.closeDialog = closeDialog;
		
		if(vm.currentModule === '' || vm.parentModule === '#') {
			vm.filter = {
				device:{},
				site:{},
				specification:{},
				includeDevices:true,
				includeMeasurements:true,
				specs:[],
				measurements:{}
			};
		}
		else {
			vm.filter = {
				device:[{modules:[vm.currentModule]}],
				site:{},
				specification:{},
				includeDevices:true,
				includeMeasurements:true,
				specs:[],
				measurements:{}
			};
		}
		
		refreshTree();
		
		$scope.$on('change.module', function(event, args) {
			vm.showTree = false;
			if(args.parent === '#') {
				vm.filter = {
					device:{},
					site:{},
					specification:{},
					includeDevices:true,
					includeMeasurements:true,
					specs:[],
					measurements:{}
				};
			}
			else {
				vm.filter = {
					device:[{modules:[args.token]}],
					site:{},
					specification:{},
					includeDevices:true,
					includeMeasurements:true,
					specs:[],
					measurements:{}
				};
			}
			refreshTree();
		});
		
		function refreshTree() {
			pragmaapi.getTreeDataFilter(vm.filter).then(function(treeData) {
				vm.treeData = processTreeData(treeData);
				vm.allSites = [];
				vm.allDevices = [];
				vm.allMeasurements = [];
				treeData.forEach(function(node, j) {
					switch (node.type) {
						case 'site':
							vm.allSites.push({
								id:node.id,
								parent:node.parent,
								text:node.text,
								token:node.token
							});
						break;
						case 'device':
							if (node.text != null) {
								var tempParent = node.parent;
								if (parentNodeType(node, 'deviceGroup')) {
									tempParent = findParentOfDeviceGroup(treeData, node.parent);
								}
								vm.allDevices.push({
									id:node.id,
									parent:tempParent,
									text:node.text,
									token:node.token
								});
							}
						break;
						case 'measurement':
							var parentDeviceText = 	findDeviceText(node.parent);
							//if (parentDeviceText != null) {
								node.parentDeviceText = parentDeviceText;
							//}
							vm.allMeasurements.push(node);
						break;
					}
					
				});
				
			});
		}
		
		function removeEmpty(tree,ids) {
			var fl = false;
			var groupT = -1;
			for(var j=0; j < ids.length; j++) {
				fl = false;
				groupT = -1;
				for(var i=0; i < tree.length; i++) {
					if (tree[i].id == ids[j]) {
						groupT = i;
					}
					if(tree[i].parent == ids[j]) {
						fl =true;
					}
				}
				if(!fl) {
					tree.splice(groupT, 1);
				}
			}
			return tree;
		}
		
		function processTreeData(treeData) {
			var groupIds = [];
			var siteIds = [];
			var tenantIds = [];
			var portfolioIds = [];
			for(var i=0; i < treeData.length; i++) {
				if(treeData[i].type === "deviceGroup") {
					groupIds.push(treeData[i].id)
				}
				else if(treeData[i].type === "site") {
					siteIds.push(treeData[i].id)
				}
				else if(treeData[i].type === "portfolio") {
					portfolioIds.push(treeData[i].id)
				}
				else if(treeData[i].type === "client") {
					tenantIds.push(treeData[i].id)
				}
			}
			treeData = removeEmpty(treeData, groupIds);
			treeData = removeEmpty(treeData, siteIds);
			treeData = removeEmpty(treeData, portfolioIds);
			treeData = removeEmpty(treeData, tenantIds);
			for(var i=0; i < treeData.length; i++) {
				treeData[i]["__uiNodeId"] = i+1;
			}
			return treeData;
        }
		
		function findParentOfDeviceGroup(array, id) {
			for (var i = 0; i < array.length; i++) {
				if (array[i].id === id) {
					return array[i].parent;
				}
			}
			return null;
		}
		
		function parentNodeType(node, type) {
			return node.parent.indexOf(type + "_") == 0;
		}
		
		function findDeviceText(id) {
			var text;
			vm.allDevices.forEach(function(node, j){
				if (node.id === id) {
					text = node.text;
				}
			});
			return text;
		}
		
		function getSiteDevices(site) {
			vm.devices = [];
			for (var i = 0; i < vm.allDevices.length; i++) {
				if (vm.allDevices[i].parent === site) {
					vm.devices.push(vm.allDevices[i]);
				}
			}
		}
		
		function getDeviceMeasurements(device) {
			vm.measurements = [];
			for (var i = 0; i < vm.allMeasurements.length; i++) {
				if (vm.allMeasurements[i].parent === device) {
					vm.measurements.push(vm.allMeasurements[i]);
				}
			}
		}
		
		function createNewVariable() {
			$mdDialog.hide(vm.variable);
		}
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
 (function ()
{
	'use strict';
	
	angular
		.module('app.rules')
		.controller('NewRuleController', NewRuleController);
		
	function NewRuleController($mdDialog, event, Notification) {
		var vm = this;
		
		vm.rule = {
			active: false,
			sendTo: {
				users: [],
				emails: []
			},
			title: "",
			description: "",
			status: "incomplete",
			triggered: {
				date:'2017-01-01T00:00:00.000Z',
				value:0,
				total:0
			},
			variableLibrary: [],
			conditions: [],
			actions: {
				title: '',
				description: '',
				selectedNotifications: [],
				repetition: {
					type: 'no'
				}
			},
			expiration: {
				startDate: new Date(),
				end: {
					type: 'noexpiration'
				},
				specificDays: [],
				specificTime: {
					from: 'null',
					to: 'null'
				}
			}
		};
		
		vm.createNewRule = createNewRule;
		vm.closeDialog = closeDialog;
		
		function createNewRule() {
			
			if(vm.rule.title == '' || !vm.rule.title) {
				Notification.warning({
					message: 'Please Fill in all the required fields!',
					delay: 3000,
					positionX:"right",
					positionY:"bottom"
					});
			}
			else {
				$mdDialog.hide(vm.rule);
			}
			
		}
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
 (function ()
{
	'use strict';
	
	angular
		.module('app.rules')
		.controller('NewConditionController', NewConditionController);
		
	function NewConditionController($rootScope, $mdDialog, event, index, variables, $filter, $translate, Notification) {
		var vm = this;
		
		vm.index = index;
		vm.variables = variables;
		vm.condition = {
				firstPart: {type:'variable'},
				secondPart: {type:'variable'}
		};
		
		// Select Fields
		vm.arguments = ['and','or'];
		vm.relations = ['==','!=','<','>','>=','<='];
		
		vm.changeSecondPart = changeSecondPart;
		
		vm.statisticalFirstChanged = statisticalFirstChanged;
		vm.statisticalSecondChanged = statisticalSecondChanged;
		
		vm.createNewCondition = createNewCondition;
		vm.closeDialog = closeDialog;
		
		function translateOptions(){
			vm.statusIndicator = {
				active: {title: $filter('translate')("RULES.OPTIONS.ACTIVE"), class: 'green-fg' },
				inactive: {title: $filter('translate')("RULES.OPTIONS.INACTIVE"), class: 'red-fg' },
				expired: {title: $filter('translate')("RULES.OPTIONS.EXPIRED"), class: 'grey-fg' },
				complete: {title: $filter('translate')("RULES.OPTIONS.COMPLETE"), class: 'green-fg' },
				incomplete: {title: $filter('translate')("RULES.OPTIONS.INCOMPLETE"), class: 'grey-fg' }
			};
			
			vm.activeIndicator = {
				active: {title: $filter('translate')("RULES.OPTIONS.ACTIVE"), class: 'green-fg' },
				inactive: {title: $filter('translate')("RULES.OPTIONS.INACTIVE"), class: 'red-fg' },
			};
			
			vm.expirationOptions = [
				{id:'noexpiration',title:$filter('translate')("RULES.OPTIONS.WITHOUT_EXPIRATION"),type:'noexpiration',value:null},
				{id:'number',title:$filter('translate')("RULES.OPTIONS.EXPIRATION_AFTER"),type:'number',value:1},
				{id:'date',title:$filter('translate')("RULES.OPTIONS.EXPIRATION_DATE"),type:'date',value:new Date()}
			];
			
			vm.notifications = [
				{id:'mail',title:$filter('translate')("RULES.OPTIONS.NOTIFICATION_MAIL")},
				{id:'sms',title:$filter('translate')("RULES.OPTIONS.NOTIFICATION_SMS")},
				{id:'platform',title:$filter('translate')("RULES.OPTIONS.NOTIFICATION_PLATFORM")}
			];
			
			vm.days = [
				{id:'MO',title:$filter('translate')("RULES.DAYS.MO")},
				{id:'TU',title:$filter('translate')("RULES.DAYS.TU")},
				{id:'WE',title:$filter('translate')("RULES.DAYS.WE")},
				{id:'TH',title:$filter('translate')("RULES.DAYS.TH")},
				{id:'FR',title:$filter('translate')("RULES.DAYS.FR")},
				{id:'SA',title:$filter('translate')("RULES.DAYS.SA")},
				{id:'SU',title:$filter('translate')("RULES.DAYS.SU")}
			];
			
			vm.statisticalRules = [
				{id:'CUR',title:$filter('translate')("RULES.STATISTICAL_LIST.CUR")},
				{id:'MEAN',title:$filter('translate')("RULES.STATISTICAL_LIST.MEAN")},
				{id:'SUM',title:$filter('translate')("RULES.STATISTICAL_LIST.SUM")},
				{id:'MIN',title:$filter('translate')("RULES.STATISTICAL_LIST.MIN")},
				{id:'MAX',title:$filter('translate')("RULES.STATISTICAL_LIST.MAX")}
			];
			
			vm.statisticalDurationTypes = [
				{id:'m',title:$filter('translate')("RULES.DURATION_TYPE_LIST.MIN")},
				{id:'h',title:$filter('translate')("RULES.DURATION_TYPE_LIST.HOU")},
				{id:'d',title:$filter('translate')("RULES.DURATION_TYPE_LIST.DAY")},
				{id:'M',title:$filter('translate')("RULES.DURATION_TYPE_LIST.MON")}
			];
			
			vm.durationTypes = [
				{id:'no',title:$filter('translate')("RULES.DURATION_TYPE_LIST.NONE")},
				{id:'m',title:$filter('translate')("RULES.DURATION_TYPE_LIST.MIN")},
				{id:'h',title:$filter('translate')("RULES.DURATION_TYPE_LIST.HOU")},
				{id:'d',title:$filter('translate')("RULES.DURATION_TYPE_LIST.DAY")},
				{id:'M',title:$filter('translate')("RULES.DURATION_TYPE_LIST.MON")}
			];
			
			
		}
		translateOptions();
		
		$rootScope.$on('$translateChangeSuccess', function () {
			translateOptions();
		});
		
		function changeSecondPart() {
			var type = vm.condition.secondPart.type;
			// reset secondPart
			vm.condition.secondPart = {type:type}
		}
		
		function statisticalFirstChanged() {
			if (vm.condition.firstPart.statistical == 'CUR') {
				if (vm.condition.firstPart.duration){
					vm.condition.firstPart.duration.type = null;
					vm.condition.firstPart.duration.value = null;
				}
			}
		}
		
		function statisticalSecondChanged() {
			if (vm.condition.secondPart.statistical == 'CUR') {
				if (vm.condition.secondPart.duration) {
					vm.condition.secondPart.duration.type = null;
					vm.condition.secondPart.duration.value = null;
				}
			}
		}
		
		function createNewCondition() {
			$mdDialog.hide(vm.condition);
		}
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.rules')
		.controller('EditRuleController', EditRuleController);
		
	function EditRuleController($mdDialog, event, user, rule, pragmaapi, PRAGMA, Notification) {
		var vm = this;
		vm.user = user;
		vm.url = PRAGMA.api;
		
		vm.rule = angular.copy(rule);
		
		vm.closeDialog = closeDialog;
		vm.saveRule = saveRule;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
		
		function saveRule() {
			if(vm.rule.title == '' || !vm.rule.title) {
				Notification.warning({
					message: 'Please Fill in all the required fields!',
					delay: 3000,
					positionX:"right",
					positionY:"bottom"
					});
			}
			else {
				$mdDialog.hide(vm.rule);
			}
		}
	}
})();
 (function ()
{
	'use strict';
	
	angular
		.module('app.rules')
		.controller('EditConditionController', EditConditionController);
		
	function EditConditionController($rootScope, $mdDialog, event, index, variables, condition, $filter, $translate, Notification) {
		var vm = this;
		
		vm.index = index;
		vm.variables = variables;
		vm.condition = angular.copy(condition);
		
		// Select Fields
		vm.arguments = ['and','or'];
		vm.relations = ['==','!=','<','>','>=','<='];
		
		vm.changeSecondPart = changeSecondPart;
		
		vm.statisticalFirstChanged = statisticalFirstChanged;
		vm.statisticalSecondChanged = statisticalSecondChanged;
		
		vm.saveCondition = saveCondition;
		vm.closeDialog = closeDialog;
		
		function translateOptions(){
			vm.statusIndicator = {
				active: {title: $filter('translate')("RULES.OPTIONS.ACTIVE"), class: 'green-fg' },
				inactive: {title: $filter('translate')("RULES.OPTIONS.INACTIVE"), class: 'red-fg' },
				expired: {title: $filter('translate')("RULES.OPTIONS.EXPIRED"), class: 'grey-fg' },
				complete: {title: $filter('translate')("RULES.OPTIONS.COMPLETE"), class: 'green-fg' },
				incomplete: {title: $filter('translate')("RULES.OPTIONS.INCOMPLETE"), class: 'grey-fg' }
			};
			
			vm.activeIndicator = {
				active: {title: $filter('translate')("RULES.OPTIONS.ACTIVE"), class: 'green-fg' },
				inactive: {title: $filter('translate')("RULES.OPTIONS.INACTIVE"), class: 'red-fg' },
			};
			
			vm.expirationOptions = [
				{id:'noexpiration',title:$filter('translate')("RULES.OPTIONS.WITHOUT_EXPIRATION"),type:'noexpiration',value:null},
				{id:'number',title:$filter('translate')("RULES.OPTIONS.EXPIRATION_AFTER"),type:'number',value:1},
				{id:'date',title:$filter('translate')("RULES.OPTIONS.EXPIRATION_DATE"),type:'date',value:new Date()}
			];
			
			vm.notifications = [
				{id:'mail',title:$filter('translate')("RULES.OPTIONS.NOTIFICATION_MAIL")},
				{id:'sms',title:$filter('translate')("RULES.OPTIONS.NOTIFICATION_SMS")},
				{id:'platform',title:$filter('translate')("RULES.OPTIONS.NOTIFICATION_PLATFORM")}
			];
			
			vm.days = [
				{id:'MO',title:$filter('translate')("RULES.DAYS.MO")},
				{id:'TU',title:$filter('translate')("RULES.DAYS.TU")},
				{id:'WE',title:$filter('translate')("RULES.DAYS.WE")},
				{id:'TH',title:$filter('translate')("RULES.DAYS.TH")},
				{id:'FR',title:$filter('translate')("RULES.DAYS.FR")},
				{id:'SA',title:$filter('translate')("RULES.DAYS.SA")},
				{id:'SU',title:$filter('translate')("RULES.DAYS.SU")}
			];
			
			vm.statisticalRules = [
				{id:'CUR',title:$filter('translate')("RULES.STATISTICAL_LIST.CUR")},
				{id:'MEAN',title:$filter('translate')("RULES.STATISTICAL_LIST.MEAN")},
				{id:'SUM',title:$filter('translate')("RULES.STATISTICAL_LIST.SUM")},
				{id:'MIN',title:$filter('translate')("RULES.STATISTICAL_LIST.MIN")},
				{id:'MAX',title:$filter('translate')("RULES.STATISTICAL_LIST.MAX")}
			];
			
			vm.statisticalDurationTypes = [
				{id:'m',title:$filter('translate')("RULES.DURATION_TYPE_LIST.MIN")},
				{id:'h',title:$filter('translate')("RULES.DURATION_TYPE_LIST.HOU")},
				{id:'d',title:$filter('translate')("RULES.DURATION_TYPE_LIST.DAY")},
				{id:'M',title:$filter('translate')("RULES.DURATION_TYPE_LIST.MON")}
			];
			
			vm.durationTypes = [
				{id:'no',title:$filter('translate')("RULES.DURATION_TYPE_LIST.NONE")},
				{id:'m',title:$filter('translate')("RULES.DURATION_TYPE_LIST.MIN")},
				{id:'h',title:$filter('translate')("RULES.DURATION_TYPE_LIST.HOU")},
				{id:'d',title:$filter('translate')("RULES.DURATION_TYPE_LIST.DAY")},
				{id:'M',title:$filter('translate')("RULES.DURATION_TYPE_LIST.MON")}
			];
			
			
		}
		translateOptions();
		
		$rootScope.$on('$translateChangeSuccess', function () {
			translateOptions();
		});
		
		function changeSecondPart() {
			var type = vm.condition.secondPart.type;
			// reset secondPart
			vm.condition.secondPart = {type:type}
		}
		
		function statisticalFirstChanged() {
			if (vm.condition.firstPart.statistical == 'CUR') {
				if (vm.condition.firstPart.duration){
					vm.condition.firstPart.duration.type = null;
					vm.condition.firstPart.duration.value = null;
				}
			}
		}
		
		function statisticalSecondChanged() {
			if (vm.condition.secondPart.statistical == 'CUR') {
				if (vm.condition.secondPart.duration) {
					vm.condition.secondPart.duration.type = null;
					vm.condition.secondPart.duration.value = null;
				}
			}
		}
		
		function saveCondition() {
			$mdDialog.hide(vm.condition);
		}
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.rules')
		.controller('DeleteRuleController', DeleteRuleController);
		
	function DeleteRuleController($mdDialog, event, rule) {
		var vm = this;
		vm.rule = rule;
		vm.closeDialog = closeDialog;
		vm.confirmDialog = confirmDialog;
		
		function confirmDialog() {
			$mdDialog.hide(vm.rule.token);
		}
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.rules')
		.controller('CopyRuleController', CopyRuleController);
		
	function CopyRuleController($mdDialog,event,rule,Notification) {
		var vm = this;
		vm.rule = rule;
		vm.newTitle = '';
		
		vm.closeDialog = closeDialog;
		vm.confirmDialog=confirmDialog;
		
		function confirmDialog() {
			if(vm.newTitle == '' || !vm.newTitle) {
				Notification.warning({
					message: 'Please Fill in all the required fields!',
					delay: 3000,
					positionX:"right",
					positionY:"bottom"
					});
			}
			else {
				vm.rule.title = vm.newTitle;
				$mdDialog.hide(vm.rule);
			}
		}
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.reporting', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.reporting', {
            url      : '/reporting',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/reporting/reporting.html',
                    controller : 'ReportingController as vm'
                }
            },
            bodyClass: 'reporting'
        });

        msNavigationServiceProvider.saveItem('reporting', {
            title : 'NAVIGATION.REPORTS',
            state: 'app.reporting',
            group : true,
            weight: 1
        });
		
    }

})();
(function ()
{
	'use strict';
	
	angular
		.module('app.reporting')
		.controller('WidgetDatesController', WidgetDatesController);
		
	function WidgetDatesController($mdDialog, event, index, widget) {
		var vm = this;
		
		vm.dates = [];
		
		//console.log(widget.dates);
		if (widget.dates.length > 0){
			vm.dates = widget.dates[0].date;
		}
		else {
			vm.dates = 'custom';
		}
		
		vm.closeDialog = closeDialog;
		vm.changeDates = changeDates;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
		
		function changeDates() {
			var response = {
				date: vm.dates,
			};
			$mdDialog.hide(response);
		}
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.reporting')
        .controller('ControlReportController', ControlReportController);

    function ControlReportController($mdDialog,event,report,action,user,url,Notification,pragmaapi,PRAGMA,$cookies)
    {
        var vm = this;
       
        vm.action=action;
        vm.closeDialog=closeDialog;
        vm.save=save;
        vm.user=user;
        vm.url=PRAGMA.api;
        vm.durations=
        [
            {
                type:"d",
                name:"Day"
            },
            {
                type:"w",
                name:"Week"
            },
            {
                type:"M",
                name:"Month"
            },
            {
                type:"y",
                name:"Year"
            }
        ];
        if(vm.action=='New')
        {
            vm.report=
            {
                token:generateUUID(),
                title:"",
                header:"",
                footer:"",
                userId: vm.user.username,
                tenants:[],
                pages:[],
                isTemplate:false,
                description:"",
                details:
                {
                    auto:true,
                    startDate:new Date(),
                    lastTriggered:"",
                    value:1,
                    type:"M"
                }
            };
        }
        else
        {
            vm.report=report;
            vm.report.details.startDate=new Date(vm.report.details.startDate);
        }
        if(vm.user.role!=='level04' && vm.user.role!=='level05')
        {
            getTenants();
        }
        function getTenants()
        {
            pragmaapi.callRestService(vm.url, "/tenants", "", true, vm.user.authentication, "GET", true, false).then(function(res) {
                vm.tenants=res.data.results;
            });
        }
        function save()
        {
            if(vm.action==="Duplicate")
            {
                var reportNew=vm.report;
                reportNew.title=vm.report.title+" (Duplicated)";
                reportNew.token=generateUUID();
                pragmaapi.callRestService(vm.url, "/reports", reportNew, true, vm.user.authentication, "POST", true, false).then(function(res){
                    Notification.success({
                       message: 'Report '+reportNew.title+' Duplicated Successfully!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                   });
                   $mdDialog.hide();
               });
            }
            else if(vm.action==="Delete")
            {
                pragmaapi.callRestService(vm.url, "/reports/"+vm.report.token+"?force=true", "", true, vm.user.authentication, "DELETE", true, false).then(function(res){
                    Notification.success({
                       message: 'Report '+vm.report.title+' Deleted Successfully!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                   });
                   $mdDialog.hide();
               });
            }
            else if(vm.action==="New")
            {
                if(vm.report.isTemplate)
                {
                    vm.report.details.auto=false;
                }
                pragmaapi.callRestService(vm.url, "/reports", vm.report, true, vm.user.authentication, "POST", true, false).then(function(res){
                    Notification.success({
                       message: 'Report '+vm.report.title+' Uploaded Successfully!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                   });
                   $mdDialog.hide();
               });
            } 
            else if(vm.action==="Edit")
            {
                if(vm.report.isTemplate)
                {
                    vm.report.details.auto=false;
                }
                pragmaapi.callRestService(vm.url, "/reports/"+vm.report.token,vm.report, true, vm.user.authentication, "PUT", true, false).then(function(res){
                    Notification.success({
                       message: 'Report '+vm.report.title+' Updated Successfully!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                   });
                   $mdDialog.hide();
               });
            }
			else if(vm.action==="Save")
			{
				
				if(vm.report.isTemplate)
                {
                    vm.report.details.auto=false;
                }
                pragmaapi.callRestService(vm.url, "/reports/"+vm.report.token,vm.report, true, vm.user.authentication, "PUT", true, false).then(function(res){
                    Notification.success({
                       message: 'Report '+vm.report.title+' Updated Successfully!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                   });
                   $mdDialog.hide();
               });
			}
			else if(vm.action==="Download")
			{
                console.log('download');
			}
			
			
			
        }
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.reporting')
		.controller('BlockPropertiesController', BlockPropertiesController);
		
	function BlockPropertiesController($mdDialog, $translate, $filter, event, parentIndex, index, block) {
		var vm = this;
		
		vm.block = angular.copy(block);
		
		vm.colorPickerApi = {
			onChange:  function(api, color, $event) {},
			onBlur:    function(api, color, $event) {},
			onOpen:    function(api, color, $event) {},
			onClose:   function(api, color, $event) {},
			onClear:   function(api, color, $event) {},
			onReset:   function(api, color, $event) {},
			onDestroy: function(api, color) {},
		};
		
		vm.fontcolor = {
			required: false,
			disabled: false,
			placeholder: 'Color',
			inputClass: '',
			id: "fontColor",
			name: "Test",
			format: 'rgb',
			restrictToFormat: true,
			hue: true,
			saturation: false,
			lightness: false, 
			alpha: false,
			case: 'lower',
			swatch: true,
			swatchPos: 'left',
			swatchBootstrap:true,
			swatchOnly: false,
			round: false,
			pos: 'top left',
			inline: false,
			show: {
				swatch: true,
				focus: true,
			},
			hide: {
				blur: true,
				escape: true,
				click: true,
			},
			close: {
				show: true,
				label: $filter('translate')("COLORPICKER.CLOSE"),
				class: '',
			},
			clear: {
				show: false,
				label: $filter('translate')("COLORPICKER.CLEAR"),
				class: '',
			},
			reset: {
				show: true,
				label: $filter('translate')("COLORPICKER.RESET"),
				class: '',
			}
		};
		
		vm.closeDialog = closeDialog;
		vm.changeProperties = changeProperties;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
		
		function changeProperties() {
			var response = {
				block: vm.block,
			};
			$mdDialog.hide(response);
		}
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.notification', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.notification', {
            url      : '/notification',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/notification/notification.html',
                    controller : 'NotificationController as vm'
                }
            },
            bodyClass: 'notification'
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.notification')
        .controller('EditCalendarNotificationController', EditCalendarNotificationController);

    function EditCalendarNotificationController($mdDialog,event,currentNotification,pragmaapi,PRAGMA,user)
    {
        var vm = this;
        vm.closeDialog=closeDialog;
        vm.notification=currentNotification.meta;
        vm.changeRead=changeRead;
        vm.user=user;
        function closeDialog()
        {
            $mdDialog.cancel();
        }
        function changeRead()
        {
            var message=
            {
                token:vm.notification.token,
                read:vm.notification.read,
                seen:vm.notification.seen,
                site:vm.notification.site,
                tenant:vm.notification.tenant,
                eventDate:vm.notification.eventDate,
                user:vm.notification.user,
                title:vm.notification.title,
                message:vm.notification.message,
                type:vm.notification.type
            };
            if(vm.notification.read)
            {
                 message.seen=true;
            }
            pragmaapi.callRestService(PRAGMA.api, "/notifications/"+message.token, message, true, vm.user.authentication, "PUT", true, false).then(function(res){
               $mdDialog.hide(true);
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mv', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.mv', {
            url      : '/mv',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/mv/mv.html',
                    controller : 'MvController as vm'
                }
            },
            bodyClass: 'mv'
        });
		
        $stateProvider.state('app.mv.general',            { tab: 0, url: '^/mv/general' });
		$stateProvider.state('app.mv.ecm',                { tab: 1, url: '^/mv/ecm' });
		$stateProvider.state('app.mv.base-period',        { tab: 2, url: '^/mv/base-period' });
		$stateProvider.state('app.mv.report-period',      { tab: 3, url: '^/mv/report-period' });
		$stateProvider.state('app.mv.adjust-typical',     { tab: 4, url: '^/mv/adjust-typical' });
		$stateProvider.state('app.mv.adjust-atypical',    { tab: 5, url: '^/mv/adjust-atypical' });
		$stateProvider.state('app.mv.estimation-model',   { tab: 6, url: '^/mv/estimation-model' });
		$stateProvider.state('app.mv.savings',            { tab: 7, url: '^/mv/savings' });
		
        // Navigation
        msNavigationServiceProvider.saveItem('mv', {
            title : 'NAVIGATION.MV',
            state: 'app.mv',
            group : true,
            weight: 1,
            hidden:false
        });
		
    }

})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('NewVariableController', NewVariableController);
		
	function NewVariableController($mdDialog,event) {
		var vm = this;
		
		vm.date = new Date();
		
		
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('NewPlanController', NewPlanController);
		
	function NewPlanController($mdDialog,event) {
		var vm = this;
		
		vm.protoTypes = [
			'IPMVP Option B',
			'IPMVP Option C'
		];
		vm.selectedProtoType = '';
		
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('NewFactorController', NewFactorController);
		
	function NewFactorController($mdDialog,event) {
		var vm = this;
		
		vm.date = new Date();
		
		vm.operators = ['+','-','*','/'];
		vm.selectedOperator = '+';
		
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('NewActionController', NewActionController);
		
	function NewActionController($mdDialog,event) {
		var vm = this;
		
		vm.date = new Date();
		
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('EditVariableController', EditVariableController);
		
	function EditVariableController($mdDialog,event,variable) {
		var vm = this;
		vm.variable = variable;
		
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('EditPlanController', EditPlanController);
		
	function EditPlanController($mdDialog,event,plan) {
		var vm = this;
		vm.plan = plan;
		vm.protoTypes = [
			'IPMVP Option A',
			'IPMVP Option B',
			'IPMVP Option C',
			'IPMVP Option D'
		];
		
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('EditFactorController', EditFactorController);
		
	function EditFactorController($mdDialog,event,factor) {
		var vm = this;
		vm.factor = factor;
		
		vm.operators = ['+','-','*','/'];
		vm.selectedOperator = factor.operator;
		
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('EditActionController', EditActionController);
		
	function EditActionController($mdDialog,event,action) {
		var vm = this;
		vm.action = action;
		
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			console.log(vm.action);
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('DeleteVariableController', DeleteVariableController);
		
	function DeleteVariableController($mdDialog, event, variable) {
		var vm = this;
		vm.variable = variable;
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('DeletePlanController', DeletePlanController);
		
	function DeletePlanController($mdDialog, event, plan) {
		var vm = this;
		vm.plan = plan;
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('DeleteFactorController', DeleteFactorController);
		
	function DeleteFactorController($mdDialog, event, factor) {
		var vm = this;
		vm.factor = factor;
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('DeleteActionController', DeleteActionController);
		
	function DeleteActionController($mdDialog, event, action) {
		var vm = this;
		vm.action = action;
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('CopyVariableController', CopyVariableController);
		
	function CopyVariableController($mdDialog,event,variable) {
		var vm = this;
		vm.variable = variable;
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('CopyPlanController', CopyPlanController);
		
	function CopyPlanController($mdDialog,event,plan) {
		var vm = this;
		vm.plan = plan;
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('CopyFactorController', CopyFactorController);
		
	function CopyFactorController($mdDialog,event,factor) {
		var vm = this;
		vm.factor = factor;
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('CopyActionController', CopyActionController);
		
	function CopyActionController($mdDialog,event,action) {
		var vm = this;
		vm.action = action;
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('AddDataController', AddDataController);
		
	function AddDataController($mdDialog, event, info, session, PRAGMA, pragmaapi, Notification) {
		var vm = this;
		var d = new Date().getTime();
		vm.info = info;
		console.log(vm.info);
		// User
		vm.user = session.getUser();
		
		vm.monitoredPoints = [
			{id:1,name:'Total Consumption',icon:'electricity'},
			{id:1,name:'Basement',icon:'electricity'},
			{id:1,name:'Floor',icon:'electricity'},
			{id:1,name:'Kitchen',icon:'electricity'},
			{id:1,name:'Lights',icon:'electricity'},
			{id:1,name:'Heating',icon:'gas'},
			{id:1,name:'Temperature',icon:'temperature'},
			{id:1,name:'Water Main',icon:'water'}
		];
		vm.selectedMonitoredPoint = info.monitoredpoint;
		
		vm.files = [
			{id:1,name:'file_1.csv',date:d},
			{id:2,name:'file_2.csv',date:d},
			{id:3,name:'file_3.csv',date:d},
			{id:4,name:'file_4.csv',date:d},
			{id:5,name:'file_5.csv',date:d}
		];
		
		vm.closeDialog = closeDialog;
		
		
		
		
		
		/*
		vm.date = {
			startDate: baseline.startdate,
			endDate: baseline.enddate
		};
		//console.log(vm.date);
		
        pragmaapi.getTreeData(true, true,true,true).then(function(treeData) {
            vm.treeData = treeData;
            vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow']);
            vm.versionNo++;
            vm.treeConfig.version = vm.versionNo;
        });
        vm.treeEvents = {
            'ready': readyCB,
            'create_node': createNodeCB,
            'select_node': getSelectedNodes,
            'deselect_node': getSelectedNodes
        }
        function getSelectedNodes() {
            if(vm.triggered)
            {
                 vm.triggered=false;
            }
            else
            {
                vm.triggered=true;
                vm.selected_nodes=[];
                vm.selectedNode = {};
                var siteToken="";
                var authenticationToken="";
                var jstree = vm.treeInstance.jstree(true);
                vm.selected_nodes = jstree.get_selected();
                if (vm.selected_nodes[0]) {
                    vm.selectedNode = jstree.get_node(vm.selected_nodes[0]);
                }
                for (var i = 0; i < vm.treeData.length; i++) {
                    if(vm.treeData[i].type=='measurement' && vm.treeData[i].id==vm.selectedNode.id)
                    {
                        vm.tenantAuthToken=vm.treeData[i].tenantAuthToken;
                        vm.measurement=vm.treeData[i].measure;
                        vm.selectedToken=vm.treeData[i].token;
                        vm.friendlyName=vm.treeData[i].text;
                        //vizualizeData();
                        break;
                    }
                }
            }
        }
        function createNodeCB() {}
        function readyCB() {}
		
		
		
        function vizualizeData() {
            vm.showGraph=false;
            var measurements=vm.measurement+","+vm.measurement+"_max,"+vm.measurement+"_min,"+vm.measurement+"_median";
            if(typeof vm.measurement!=='undefined')
            {
                pragmaapi.callRestService(PRAGMA.api,"/assignments/" +  vm.selectedToken + "/measurements/series","?page=1&pageSize=1000&startDate="+encodeURIComponent(moment(vm.date.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0300")+"&endDate="+encodeURIComponent(moment(vm.date.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0300")+"&measurementIds="+measurements+"&tenantAuthToken=" + vm.tenantAuthToken, true, vm.user.authentication, "GET", true).then(function(res){
                    if(res.data.length<4)
                    {
                        console.log(res.data);
						Notification("No Predicted Data Available!");
                    }
                    else
                    {
                        //console.log(vm.selectedNode);
						//console.log(JSON.stringify(res.data));
						console.log(res.data);
						
                    }
                });
            }
            else
            {
                 Notification("Please select a monitor point first!");
            }
        }
		*/
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('AddActionController', AddActionController);
		
	function AddActionController($mdDialog,event,actions) {
		var vm = this;
		var d = new Date().getTime();
		vm.actions = actions;
		
		vm.closeDialog = closeDialog;
		
		function closeDialog() {
			$mdDialog.cancel();
		}
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.landing', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.landing', {
            url      : '/landing',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.landing': {
                    templateUrl: 'app/main/landing/landing.html',
                    controller : 'LandingController as vm'
                }
            },
            data: {
                requireLogin: false
            },
            bodyClass: 'landing'
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.landing')
        .controller('RequestDemoController', RequestDemoController)
        .config(['noCAPTCHAProvider', function (noCaptchaProvider) {
            noCaptchaProvider.setTheme('light');
            noCaptchaProvider.setSiteKey('6LdtujIUAAAAALQjwzi34H9s2e5iCx_XPPn_gW7K');
        }]);

    function RequestDemoController($scope,$mdDialog,event,Notification,pragmaapi)
    {
        var vm = this;
        vm.request = {
            first_name  : "",
            last_name   : "",
            company     : "",
            phone_number: "",
            email       : "",
            subject     : "",
            message     : "",
            solution   : "SmartEnergy",
            gRecaptchaResponse: ""
        };
        vm.closeDialog = closeDialog;
        vm.SubmitDialog = SubmitDialog;
        
        vm.expiredCallback = function () {
            vm.request.gRecaptchaResponse = "";
        }
        
        function closeDialog()
        {
            $mdDialog.cancel();
        }
		
        function SubmitDialog()
        {
            console.log(vm.request);
            
            if (vm.request.gRecaptchaResponse == undefined || vm.request.gRecaptchaResponse == "") {
                Notification(pragmaapi.translate('LANDING.REQUEST.RU_A_ROBOT'));
            }
            else {
                var error = false;
                for (var prop in vm.request) {
                    if (prop != "message" && prop != "gRecaptchaResponse") {
                        if (vm.request[prop] == undefined || vm.request[prop] == "") {
                            error = true;
                            break;
                        }
                    }
                }
                if (error) {
                    Notification(pragmaapi.translate('LANDING.REQUEST.PLEASE_FILL'));
                }
                else {
                    pragmaapi.callRestService("https://smarteverything.gr/API","/form_proxy.php",vm.request,false,"","POST",true).then(function(res){
                        var result = res.data;
                        if (result.error != undefined) {
                            Notification(pragmaapi.translate('LANDING.REQUEST.' + result.error));
                        }
                        else {
                            Notification(pragmaapi.translate('LANDING.REQUEST.' + result.result));
                            $mdDialog.cancel();
                        }
                    });
                }
            }
        }
		
		vm.solutions = [
			 'SmartEnergy',
			 'SmartWater' ,
			 'SmartParking' ,
			 'SmartLighting' ,
			 'SmartGas' ,
			 'SmartHealth' 
		];
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.landing')
        .controller('ContactUsController', ContactUsController)
        .config(['noCAPTCHAProvider', function (noCaptchaProvider) {
            noCaptchaProvider.setTheme('light');
            noCaptchaProvider.setSiteKey('6LdtujIUAAAAALQjwzi34H9s2e5iCx_XPPn_gW7K');
        }]);

    function ContactUsController($scope,$mdDialog,event,Notification,pragmaapi)
    {
        var vm = this;
        vm.request = {
            first_name  : "",
            last_name   : "",
            email       : "",
            subject     : "",
            message     : "",
            gRecaptchaResponse: ""
        };
        vm.closeDialog = closeDialog;
        vm.SubmitDialog = SubmitDialog;
        
        vm.expiredCallback = function () {
            vm.request.gRecaptchaResponse = "";
        }
        
        function closeDialog()
        {
            $mdDialog.cancel();
        }
		
        function SubmitDialog()
        {
            if (vm.request.gRecaptchaResponse == undefined || vm.request.gRecaptchaResponse == "") {
                Notification(pragmaapi.translate('LANDING.REQUEST.RU_A_ROBOT'));
            }
            else {
                var error = false;
                for (var prop in vm.request) {
                    if (prop != "message" && prop != "gRecaptchaResponse") {
                        if (vm.request[prop] == undefined || vm.request[prop] == "") {
                            error = true;
                            break;
                        }
                    }
                }
                if (error) {
                    Notification(pragmaapi.translate('LANDING.REQUEST.PLEASE_FILL'));
                }
                else {
                    pragmaapi.callRestService("https://smarteverything.gr/API","/form_proxy.php",vm.request,false,"","POST",true).then(function(res){
                        var result = res.data;
                        if (result.error != undefined) {
                            Notification(pragmaapi.translate('LANDING.REQUEST.' + result.error));
                        }
                        else {
                            Notification(pragmaapi.translate('LANDING.REQUEST.' + result.result));
                            $mdDialog.cancel();
                        }
                    });
                }
            }
        }
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.home', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.home', {
            url      : '/home',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/home/home.html',
                    controller : 'HomeController as vm'
                }
            },
            resolve  : {
                weatherIcons: function (msApi)
                {
                    return msApi.resolve('weather-icons@get');
                },
                homeLocations: function (msApi)
                {
                    return msApi.resolve('home.locations@get');
                }
            },
            bodyClass: 'home'
        });

        // Api
        msApiProvider.register('weather-icons', ['app/data/home/weather-icons.json']);
		
		// Locations
		msApiProvider.register('home.locations', ['https://pragma.nextiotee.com/API/index.php/getLocations', [], {get: { isArray: true, withCredentials: true}}]);
		
		// Weather Forecast
		msApiProvider.register('home.forecast', ['https://pragma.nextiotee.com/API/index.php/getWeather', [], {get: { withCredentials: true}}]);
		
		// Data
		msApiProvider.register('home.data', ['https://pragma.nextiotee.com/API/index.php/getData', [], {get: { withCredentials: true}}]);
        msApiProvider.register('home.data_tenant', ['https://pragma.nextiotee.com/API/index.php/getDataTenant', [], {get: { withCredentials: true}}]);
        msApiProvider.register('home.weather', ['https://pragma.nextiotee.com/API/index.php/getDataWeather', [], {get: { withCredentials: true}}]);

		msApiProvider.register('home.compare_data', ['https://pragma.nextiotee.com/API/index.php/getCompareData', [], {get: { withCredentials: true}}]);
		
        // Navigation
        /*msNavigationServiceProvider.saveItem('home', {
            title : 'HOME',
            state: 'app.home',
            group : true,
            weight: 0
        });*/
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.home')
        .controller('LocationEditDialogController', LocationEditDialogController);

    /** @ngInject */
    function LocationEditDialogController($mdDialog, msApi, $http, Location, Locations, event)
    {
        var vm = this;

        // Data
        vm.location = angular.copy(Location);
        vm.locations = Locations
		vm.locationsave = Location;

        // Methods
        vm.saveLocation = saveLocation;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Save location
         */
        function saveLocation()
        {
			for (var i = 1; i < vm.locations.length; i++) {
				if (vm.location.id == vm.locations[i].id) {
					$http.post(
						'https://pragma.nextiotee.com/klictet/API/index.php/saveLocation',
						vm.location,
						{withCredentials: true}
					).then(function(response) {
						//vm.locations[i] = response.data;
						vm.locations[i] = vm.location;
						closeDialog();
					});
				}
			}
            
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin', [])
        .value('app_admin', 'app.admin.users')
        .config(config);

    /** @ngInject */
    function config($stateProvider, $urlRouterProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.admin', {
            url      : '/admin',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/admin/admin.html',
                    controller : 'AdminController as vm'
                }
            },
            bodyClass: 'admin'
        });
        
        $stateProvider.state('app.admin.users',           { tab: 0, url: '^/admin/users' });
        $stateProvider.state('app.admin.clients',         { tab: 1, url: '^/admin/clients' });
        $stateProvider.state('app.admin.portfolios',      { tab: 2, url: '^/admin/portfolios' });
        $stateProvider.state('app.admin.sites',           { tab: 3, url: '^/admin/sites' });
        $stateProvider.state('app.admin.costs',           { tab: 4, url: '^/admin/costs' });
        $stateProvider.state('app.admin.assets',          { tab: 5, url: '^/admin/assets' });
        $stateProvider.state('app.admin.specifications',  { tab: 6, url: '^/admin/specifications' });
        $stateProvider.state('app.admin.devices',         { tab: 7, url: '^/admin/devices' });
        $stateProvider.state('app.admin.device-groups',   { tab: 8, url: '^/admin/device-groups' });
        $stateProvider.state('app.admin.notifications',   { tab: 9, url: '^/admin/notifications' });
        
       
        /*
        msNavigationServiceProvider.saveItem('admin.users', {
            title : 'Users',
            state: 'app.admin.users'
        });

        msNavigationServiceProvider.saveItem('admin.clients', {
            title : 'Clients',
            state: 'app.admin.clients'
        });

        msNavigationServiceProvider.saveItem('admin.portfolios', {
            title : 'Portfolios',
            state: 'app.admin.portfolios'
        });

        msNavigationServiceProvider.saveItem('admin.sites', {
            title : 'Sites',
            state: 'app.admin.sites'
        });

        msNavigationServiceProvider.saveItem('admin.costs', {
            title : 'Costs',
            state: 'app.admin.costs'
        });

        msNavigationServiceProvider.saveItem('admin.assets', {
            title : 'Assets',
            state: 'app.admin.assets'
        });

        msNavigationServiceProvider.saveItem('admin.specifications', {
            title : 'Specifications',
            state: 'app.admin.specifications'
        });

        msNavigationServiceProvider.saveItem('admin.devices', {
            title : 'Devices',
            state: 'app.admin.devices'
        });

        msNavigationServiceProvider.saveItem('admin.device-groups', {
            title : 'Device Groups',
            state: 'app.admin.device-groups'
        });
        */
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewEventController', NewEventController)
        .config(function($mdDateLocaleProvider) {
            $mdDateLocaleProvider.formatDate = function(date) {
                return moment(date).format('MMM D, YYYY');
            }
        });

    function NewEventController($mdDialog, event, Notification, pragmaapi, thisUser, eventTypes, selectedNode)
    {
        var vm = this;
        
        vm.thisUser = thisUser;
        vm.eventTypes = eventTypes;
        
        if (selectedNode !== undefined) {
            vm.selectedNode = selectedNode;
        }
        else {
            vm.selectedNode = { type: "", token: "", tenantAuthToken: ""};
        }
        
        var cNode = vm.selectedNode.original
        
        vm.event = {
            type: "",
            eventDate: new Date(),
            title: "",
            text: "",
            publish: false,
            eventAttach: cNode.type,
            attachToken: cNode.token
        };
        
        vm.saveEvent = saveEvent;
        vm.closeDialog = closeDialog;
        
        function saveEvent() {
            // Required fields
            if (vm.event.type == "" || vm.event.eventDate == "" || vm.event.title == "") {
                Notification.warning(pragmaapi.translate('EVENTS.MESSAGE.PLEASE_FILL'));
            }
            else {
                var res = {};
                res.tenantAuthToken = cNode.tenantAuthToken;
                res.event = vm.event;
                $mdDialog.hide(res);
            }
        }
        
        
        function closeDialog() {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditEventController', EditEventController)
        .config(function($mdDateLocaleProvider) {
            $mdDateLocaleProvider.formatDate = function(date) {
                return moment(date).format('MMM D, YYYY');
            }
        });

    function EditEventController($mdDialog, event, Notification, pragmaapi, eventTypes, selectedNode, thisEvent)
    {
        var vm = this;
        vm.thisEvent=thisEvent;
        vm.eventTypes = eventTypes;
        if (selectedNode !== undefined) {
            vm.selectedNode = selectedNode;
        }
        else {
            vm.selectedNode = { type: "", token: "", tenantAuthToken: ""};
        }
        
        var cNode = vm.selectedNode.original
        
        vm.event = {
            type: vm.thisEvent.metadata.type,
            eventDate: new Date(vm.thisEvent.metadata.eventDate),
            title: vm.thisEvent.metadata.title,
            text: vm.thisEvent.metadata.text,
            publish: vm.thisEvent.metadata.publish,
            eventAttach: cNode.type,
            attachToken: cNode.token,
            token:vm.thisEvent.metadata.token
        };
        
        vm.saveEvent = saveEvent;
        vm.closeDialog = closeDialog;
        

        function saveEvent() {
            // Required fields
            if (vm.event.type == "" || vm.event.eventDate == "" || vm.event.title == "") {
                Notification.warning(pragmaapi.translate('EVENTS.MESSAGE.PLEASE_FILL'));
            }
            else {
                var res = {};
                res.tenantAuthToken = cNode.tenantAuthToken;
                res.event = vm.event;
                $mdDialog.hide(res);
            }
        }
        
        
        function closeDialog() {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteEventController', DeleteEventController);

    function DeleteEventController($mdDialog, event, audit, selectedNode)
    {
        var vm = this;
        vm.event = audit;
		
        if (selectedNode !== undefined) {
            vm.selectedNode = selectedNode;
        }
        else {
            vm.selectedNode = { type: "", token: "", tenantAuthToken: ""};
        }
        
        var cNode = vm.selectedNode.original
		
        vm.closeDialog = closeDialog;
        vm.confirmDialog = confirmDialog;

        function confirmDialog()
        {
            var res = {};
            res.tenantAuthToken = cNode.tenantAuthToken;
            res.event = vm.event;
            $mdDialog.hide(res);
			//$mdDialog.hide(vm.event);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.dashboard', {
            url      : '/dashboard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/dashboard/dashboard.html',
                    controller : 'DashboardController as vm'
                }
            },
            bodyClass: 'dashboard'
        });

        msNavigationServiceProvider.saveItem('dashboard', {
            title : 'NAVIGATION.DASHBOARD',
            state: 'app.dashboard',
            group : true,
            weight: 0
        });
		
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('NewWidgetController', NewWidgetController);

    function NewWidgetController($mdDialog,event,dashboard,pragmaapi,widget,action,$translate,$filter,dashboardDate,$timeout,$scope,session)
    {
        var vm = this;
        vm.dashboardDate=dashboardDate;
        vm.user = session.getUser();
        vm.preview=false;
        vm.currentModule=vm.user.currentModule;
        vm.parentModule=vm.user.parentModule;
        vm.currentTreeType='';
        vm.showFootfall=false;
        vm.showAgriculture=false;
        vm.showWaste=false;
        vm.showParking=false;
        vm.showLighting=false;
        vm.showPeriod=true;
        vm.toggledButton=0;
        vm.showPeriodResolution=true;
        vm.spaces=[];
        vm.showPeriodTime=true;
        vm.showPeriodRange=true;
        vm.showDetails=true;
        vm.treeData=[];
        vm.widget=
        {
            title:"",
            dates:[{date:"custom"}],
            clients:[]
        }
        vm.colorPickerApi={
            onChange:  function(api, color, $event) {},
            onBlur:    function(api, color, $event) {},
            onOpen:    function(api, color, $event) {},
            onClose:   function(api, color, $event) {},
            onClear:   function(api, color, $event) {},
            onReset:   function(api, color, $event) {},
            onDestroy: function(api, color) {},
        };
        vm.fontcolor=
        {
            required: false,
            disabled: false,
            placeholder: 'Color',
            inputClass: '',
            id: "fontColor",
            name: "Test",
            format: 'rgb',
            restrictToFormat: true,
            hue: true,
            saturation: false,
            lightness: false, 
            alpha: false,
            case: 'lower',
            swatch: true,
            swatchPos: 'left',
            swatchBootstrap:true,
            swatchOnly: false,
            round: false,
            pos: 'top left',
            inline: false,
            show: {
                swatch: true,
                focus: true,
            },
            hide: {
                blur: true,
                escape: true,
                click: true,
            },
            close: {
                show: true,
                label: $filter('translate')("COLORPICKER.CLOSE"),
                class: '',
            },
            clear: {
                show: false,
                label: $filter('translate')("COLORPICKER.CLEAR"),
                class: '',
            },
            reset: {
                show: true,
                label: $filter('translate')("COLORPICKER.RESET"),
                class: '',
            }
        };
        vm.bgcolor=
        {
            required: false,
            disabled: false,
            placeholder: 'Color',
            inputClass: '',
            id: "bgColor",
            name: "Test",
            format: 'rgb',
            restrictToFormat: true,
            hue: true,
            saturation: false,
            lightness: false, 
            alpha: true,
            case: 'lower',
            swatch: true,
            swatchPos: 'left',
            swatchBootstrap:true,
            swatchOnly: false,
            round: false,
            pos: 'top left',
            inline: false,
            show: {
                swatch: true,
                focus: true,
            },
            hide: {
                blur: true,
                escape: true,
                click: true,
            },
            close: {
                show: true,
                label: $filter('translate')("COLORPICKER.CLOSE"),
                class: '',
            },
            clear: {
                show: false,
                label: $filter('translate')("COLORPICKER.CLEAR"),
                class: '',
            },
            reset: {
                show: true,
                label: $filter('translate')("COLORPICKER.RESET"),
                class: '',
            }
        };
        vm.action=action;
        vm.showTree=false;
        vm.dashboard=dashboard;
        vm.treeEvents = 
        {
            'ready': readyCB,
            'create_node': createNodeCB,
            'select_node': getSelectedNodes,
            'deselect_node': getSelectedNodes
        };
        vm.treeEventsMax = 
        {
            'ready': readyCB,
            'create_node': createNodeCB,
            'select_node': getSelectedNodesMax,
            'deselect_node': getSelectedNodesMax
        };
        vm.applySearchTree = applySearchTree; 
        vm.closeDialog=closeDialog;
        vm.changeWidgetType=changeWidgetType;
        vm.saveWidget=saveWidget;
        vm.changeWidgetPreview=changeWidgetPreview;
        vm.change=change;

        function change()
        {
            vm.preview=false;
            setTimeout(function(){
                $scope.$apply(function () {
                    vm.preview=true;
                });},100)
        }
        function calculateSpaces()
        {
            vm.spaces=[];
            vm.widget.graph.spaces=[];
            for (var i=0;i<vm.widget.clients.length;i++)
            {
                var deviceMeta=JSON.parse(vm.widget.clients[i].device.metadata);
                var spaces=JSON.parse(deviceMeta.spaces);
                for(var l=0;l<Object.keys(spaces).length;l++)
                {
                    var tmp=
                    {
                        name:spaces[Object.keys(spaces)[l]],
                        value:Object.keys(spaces)[l]
                    }
                    vm.spaces.push(tmp)
                }   
            }
        }

        function changeWidgetPreview()
        {

        }

        init();

        function init()
        {
            if(vm.action==='new')
            {
                changeWidgetType(0,'measurements','',0);
            }
            else
            {
                vm.widget=widget;
                if(typeof vm.widget.graph.graphType!=='undefined')
                {
                    changeWidgetType(vm.widget.type,vm.widget.dataType,vm.widget.graph.graphType,vm.widget.sub);
                }
                else
                {
                    changeWidgetType(vm.widget.type,vm.widget.dataType,'',vm.widget.sub);
                }
            }
        }

        function changeWidgetType(type,tree,subtype,sub)
        {
            if(tree!=vm.currentTreeType)
            {
                vm.currentTreeType=tree;
                changeTree();
            }
            if(vm.action==='new')
            {
                initializeWidget(type,subtype,sub);
            }
            else
            {   
                initializeEditedWidget(type);
            }
           
        }
        
        function changeTree()
        {
            var filter={};
            vm.showFootfall=false;
            vm.showAgriculture=false;
            vm.showWaste=false;
            vm.showParking=false;
            vm.showLighting=false;
            if(vm.currentModule==='' || vm.parentModule==='#')
            {
                vm.showFootfall=true;
                vm.showAgriculture=true;
                vm.showWaste=true;
                vm.showParking=true;
                vm.showLighting=true;
            }
            else if(vm.currentModule==='505f04gp-0437-46ff-9qpz-0cbdf6cf4864')
            {
                vm.showFootfall=true;
            }
            else if(vm.currentModule==='72e28afc-ce5b-4931-8ace-756181d77bdb')
            {
                vm.showAgriculture=true;
            }
            else if(vm.currentModule==='505f04gp-0437-f0k3-9qpz-0cbdf6cf4864')
            {
                vm.showWaste=true;
            }
            else if(vm.currentModule==='fded0bc6-2d0c-4f67-844c-0d8e33b48109')
            {
                vm.showParking=true;
            }
            else if(vm.currentModule==='61e2d68e-2dbb-4c78-8772-49c61174e2fe')
            {
                vm.showLighting=true;
            }
            if(vm.currentTreeType!=='null')
            {
                vm.showTree=true;
                if(vm.currentTreeType==='measurements')
                {
                    if(vm.currentModule==='' || vm.parentModule==='#')
                    {
                        filter={
                            device:{},
                            site:{},
                            specification:{},
                            includeDevices:true,
                            includeMeasurements:true,
                            specs:[],
                            measurements:{}
                        };
                    }
                    else
                    {
                        filter={
                            device:[{modules:[vm.currentModule]}],
                            site:{},
                            specification:{},
                            includeDevices:true,
                            includeMeasurements:true,
                            specs:[],
                            measurements:{}
                        };
                    }
                }
                else if(vm.currentTreeType==='devices')
                {
                    if(vm.currentModule==='' || vm.parentModule==='#')
                    {
                        filter={
                            device:{},
                            site:{},
                            specification:{},
                            includeDevices:true,
                            includeMeasurements:false,
                            specs:[],
                            measurements:{}
                        };
                    }
                    else
                    {
                        filter={
                            device:[{modules:[vm.currentModule]}],
                            site:{},
                            specification:{},
                            includeDevices:true,
                            includeMeasurements:false,
                            specs:[],
                            measurements:{}
                        };
                    }
                }
                else
                {
                    if(vm.currentModule==='' || vm.parentModule==='#')
                    {
                        filter={
                            device:{},
                            site:{},
                            specification:{},
                            includeDevices:false,
                            includeMeasurements:false,
                            specs:[],
                            measurements:{}
                        };
                    }
                    else
                    {
                        filter={
                            device:[{modules:[vm.currentModule]}],
                            site:{},
                            specification:{},
                            includeDevices:false,
                            includeMeasurements:false,
                            specs:[],
                            measurements:{}
                        };
                    }
                }
                pragmaapi.getTreeDataFilter(filter).then(function(treeData) {
                    vm.treeData = processTreeData(treeData);
                    vm.treeDataMax = processTreeData(treeData);
                    vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'checkbox']);
                    vm.treeInstance.jstree(true).settings.core.data =  vm.treeData;
                    vm.treeInstance.jstree(true).refresh();
                    try {
                    vm.treeInstanceMax.jstree(true).settings.core.data =  vm.treeData;
                    vm.treeInstanceMax.jstree(true).refresh();
                    }
                    catch(err) {}
                });
            }
            else
            {
                vm.showTree=false;
            }
        }

        function processTreeData(treeData) {
            var groupIds=[];
            var siteIds=[];
            var tenantIds=[];
            var portfolioIds=[];
            for(var i=0;i<treeData.length;i++)
            {
                if(treeData[i].type==="deviceGroup")
                {
                    groupIds.push(treeData[i].id)
                }
                else if(treeData[i].type==="site")
                {
                    siteIds.push(treeData[i].id)
                }
                else if(treeData[i].type==="portfolio")
                {
                    portfolioIds.push(treeData[i].id)
                }
                else if(treeData[i].type==="client")
                {
                    tenantIds.push(treeData[i].id)
                }
            }
            treeData=removeEmpty(treeData,groupIds);
            treeData=removeEmpty(treeData,siteIds);
            treeData=removeEmpty(treeData,portfolioIds);
            treeData=removeEmpty(treeData,tenantIds);
            for(var i=0;i<treeData.length;i++)
            {
                treeData[i]["__uiNodeId"]=i+1;
            }
            return treeData;
        }

        function removeEmpty(tree,ids)
        {
            var fl=false;
            var groupT=-1;
            for(var j=0;j<ids.length;j++)
            {
                fl=false;
                groupT=-1;
                for(var i=0;i<tree.length;i++)
                {
                    if (tree[i].id==ids[j])
                    {
                        groupT=i;
                    }
                    if(tree[i].parent==ids[j])
                    {
                        fl=true;
                    }
                }
                if(!fl)
                {
                    tree.splice(groupT,1);
                }
            }
            return tree;
        }
        
        function createNodeCB() 
        {

        }

        function readyCB() 
        {
            if(vm.action!=='new')
                fillTree();
        }

        function getSelectedNodesMax()
        {
            var jstree = vm.treeInstanceMax.jstree(true);
            vm.selected_nodes = jstree.get_selected();
            var measurementsTemp=[];
            vm.widget.graph.maximumClients=[];
            for(var i=0;i<vm.selected_nodes.length;i++)
            {
                if(vm.selected_nodes[i].includes("measurement"))
                {
                    for(var l=0;l<vm.treeDataMax.length;l++)
                    {
                        if(vm.treeDataMax[l].id===vm.selected_nodes[i])
                        {
                            var tmp=
                            {
                                tenant:
                                {
                                    name:vm.treeDataMax[l].tenantName,
                                    token:vm.treeDataMax[l].tenantAuthToken
                                },
                                site:
                                {
                                    name:vm.treeDataMax[l].siteName,
                                    token:vm.treeDataMax[l].siteToken
                                },
                                device:
                                {
                                    name:vm.treeDataMax[l].device,
                                    token:vm.treeDataMax[l].token,
                                    hardwareId:vm.treeData[l].hardwareId
                                },
                                measurement:
                                {
                                    measure:vm.treeDataMax[l].measure,
                                    name:vm.treeDataMax[l].text
                                },
                                specs:vm.treeDataMax[l].specs
                            };
                            vm.widget.graph.maximumClients.push(tmp);
                            break;
                        }
                    }
                }
            }
        }

        function fillTree()
        {
            var cl=vm.widget.clients;
            var tmpArr=[];
            var included=false;
            if(vm.widget.dataType==='measurements')
            {
                for(var i=0;i<cl.length;i++)
                {
                    included=false;
                    for (var k=0;k<tmpArr.length;k++)
                    {
                        if(tmpArr[k].token==cl[i].device.token && tmpArr[k].measure==cl[i].measurement.measure)
                        {
                            included=true;
                        }
                    }
                    if(!included)
                    {
                        var tmp={token:cl[i].device.token, measure:cl[i].measurement.measure};
                        tmpArr.push(tmp);
                    }
                }
                for(var i=0;i<tmpArr.length;i++)
                {
                    for(var j=0;j<vm.treeData.length;j++)
                    {
                        if(vm.treeData[j].type==='measurement')
                        {
                            if(vm.treeData[j].measure==tmpArr[i].measure && vm.treeData[j].token==tmpArr[i].token)
                            {
                                vm.treeInstance.jstree(true).select_node(vm.treeData[j]['id']);
                                break;
                            }
                        }
                    }
                }
            }
            else if(vm.widget.dataType==='devices')
            {
                for(var i=0;i<cl.length;i++)
                {
                    included=false;
                    for (var k=0;k<tmpArr.length;k++)
                    {
                        if(tmpArr[k]==cl[i].device.token)
                        {
                            included=true;
                        }
                    }
                    if(!included)
                    {
                        tmpArr.push(cl[i].device.token);
                    }
                }
                for(var i=0;i<tmpArr.length;i++)
                {
                    for(var j=0;j<vm.treeData.length;j++)
                    {
                        if(vm.treeData[j].type==='device')
                        {
                            if(vm.treeData[j].token==tmpArr[i])
                            {
                                vm.treeInstance.jstree(true).select_node(vm.treeData[j]['id']);
                                break;
                            }
                        }
                    }
                }
            }
            
        }

        function getSelectedNodes()
        {
            var jstree = vm.treeInstance.jstree(true);
            vm.selected_nodes = jstree.get_selected();
            var measurementsTemp=[];
            vm.widget.clients=[];
            if(vm.currentTreeType==='measurements')
            {
                for(var i=0;i<vm.selected_nodes.length;i++)
                {
                    if(vm.selected_nodes[i].includes("measurement"))
                    {
                        for(var l=0;l<vm.treeData.length;l++)
                        {
                            if(vm.treeData[l].id===vm.selected_nodes[i])
                            {
                                var tmp=
                                {
                                    tenant:
                                    {
                                        name:vm.treeData[l].tenantName,
                                        token:vm.treeData[l].tenantAuthToken
                                    },
                                    site:
                                    {
                                        name:vm.treeData[l].siteName,
                                        token:vm.treeData[l].siteToken
                                    },
                                    device:
                                    {
                                        name:vm.treeData[l].device,
                                        token:vm.treeData[l].token,
                                        hardwareId:vm.treeData[l].hardwareId
                                    },
                                    measurement:
                                    {
                                        measure:vm.treeData[l].measure,
                                        name:vm.treeData[l].text
                                    },
                                    specs:vm.treeData[l].specs
                                };
                                vm.widget.clients.push(tmp);
                                break;
                            }
                        }
                    }
                }
            }
            else if(vm.currentTreeType==='devices')
            {
                for(var i=0;i<vm.selected_nodes.length;i++)
                {
                    if(vm.selected_nodes[i].includes("device_"))
                    {
                        for(var l=0;l<vm.treeData.length;l++)
                        {
                            if(vm.treeData[l].id===vm.selected_nodes[i])
                            {
                                var tmp=
                                {
                                    tenant:
                                    {
                                        name:vm.treeData[l].tenantName,
                                        token:vm.treeData[l].tenantAuthToken
                                    },
                                    site:
                                    {
                                        name:vm.treeData[l].siteName,
                                        token:vm.treeData[l].siteToken
                                    },
                                    device:
                                    {
                                        name:vm.treeData[l].text,
                                        token:vm.treeData[l].token,
                                        hardwareId:vm.treeData[l].hardwareId,
                                        metadata:vm.treeData[l].metadata
                                    }
                                };
                                vm.widget.clients.push(tmp);
                                break;
                            }
                        }
                    }
                }
                if(vm.widget.type>5 && vm.widget.type<11)
                {
                    calculateSpaces();
                }
            }
            else
            {
                for(var i=0;i<vm.selected_nodes.length;i++)
                {
                    if(vm.selected_nodes[i].includes("site_"))
                    {
                        for(var l=0;l<vm.treeData.length;l++)
                        {
                            if(vm.treeData[l].id===vm.selected_nodes[i])
                            {
                                var tmp=
                                {
                                    tenant:
                                    {
                                        name:vm.treeData[l].tenantName,
                                        token:vm.treeData[l].tenantAuthToken
                                    },
                                    site:
                                    {
                                        name:vm.treeData[l].text,
                                        token:vm.treeData[l].token
                                    }
                                };
                                vm.widget.clients.push(tmp);
                                break;
                            }
                        }
                    }
                }
            }
            change();
        }

        function closeDialog()
        {
            $mdDialog.cancel();
        }

        function applySearchTree()
        {
            if(vm.treeInstance) 
            {
                vm.treeInstance.jstree(true).search(vm.searchtree);
            }
        }

        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };

        function saveWidget()
        {
            if(vm.action==='new')
                vm.widget.token=generateUUID();
            var response=
            {
                widget:vm.widget,
                action:vm.action
            }
           $mdDialog.hide(response);
        }
        function initializeEditedWidget(type)
        {
            vm.showDetails=true;
            vm.showPeriod=true;
            vm.showPeriodResolution=true;
            vm.showPeriodTime=true;
            vm.showPeriodRange=true;
            if(type==0)
            {
                vm.showPeriodResolution=false;
            }
            else if(type==1)
            {

            }
            else if(type==2)
            {
                vm.showPeriodResolution=false;
            }
            else if(type==3)
            {
                vm.showPeriodResolution=false;
            }
            else if(type==4)
            {
                vm.showPeriodResolution=false;
            }
            else if(type==5)
            {
                vm.showDetails=false;
                vm.showPeriod=false;
            }
            else if(type==6)
            {

            }
            else if(type==7)
            {
                vm.showPeriodResolution=false;
            }
            else if(type==8)
            {
                vm.showPeriodResolution=false;
            }
            else if(type==9)
            {
                vm.showPeriodResolution=false;

            }
            else if(type==10)
            {

            }
            else if(type==11)
            {
                vm.showPeriodResolution=false;
                vm.showDetails=false;
            }
            else if(type==12)
            {
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
                vm.showDetails=false;
            }
            else if(type==13)
            {
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
            }
            else if(type==14)
            {
                vm.showPeriodResolution=false;
                vm.showPeriod=false;
                vm.showDetails=false;
            }
            else if(type==15)
            {
                vm.showPeriod=true;
                vm.showPeriodResolution=false;
                vm.showDetails=false;
            }
            else if(type==16)
            {
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
                vm.showDetails=false;
            }
            else if(type==17)
            {
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
                vm.showDetails=false;
            }
            else if(type==18)
            {

            }
            else if(type==19)
            {
                vm.showDetails=false;
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
            }
            else if(type==20)
            {
                vm.showDetails=true;
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
            }
            else if(type==22)
            {
                vm.showDetails=false;
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
            }
            else if(type==22)
            {
                vm.showDetails=true;
                vm.showPeriod=true;
                vm.showPeriodResolution=true;
            }
        }
        function initializeWidget(type,subtype,sub)
        {
            vm.toggledButton=sub;
            vm.showDetails=true;
            vm.showPeriod=true;
            vm.showPeriodResolution=true;
            vm.showPeriodTime=true;
            vm.showPeriodRange=true;
            if(type==0)
            {
                vm.showPeriodResolution=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 3,
                        y: 0,
                        height: 3
                    },
                    time:
                    {

                        type:"null",
                        start:"00:00", 
                        end:"23:59",  
                        minutes: 0  
                    },
                    clients:vm.widget.clients,
                    type: 0,
                    graph:
                    {
                        widgetHasColor:false,
                        widgetHasFontColor:false,
                        widgetColor:"rgb(3,169,244)",
                        orientation:'vertical',
                        graphType:'numeric',
                        aggregated:true,
                        fontColor:"rgb(0,0,0)",
                        type:"lastValue"
                    },
                    dataType:"measurements"
                }
            }
            else if(type==1)
            {
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 6,
                        y: 0,
                        height: 5
                    },
                    time:
                    {
                        resolutionType:"m",
                        resolutionValue: 15,
                        type:"null",
                        start:"00:00", 
                        end:"12:00",  
                        minutes: 0   
                    },
                    graph:
                    {
                        graphType:subtype,
                        point: "circle",
                        pointSize: 1,
                        fontColor:"rgb(0,0,0)",
                        backgroundColor:"rgb(3,169,244)",
                        fill:false,
                        type:"rawData",
                        aggregated:false,
                        total:false,
                        average:false,
                        max:false,
                        min:false
                    },
                    dataType:"measurements"
                }
            }
            else if(type==2)
            {
                vm.showPeriodResolution=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    time:
                    {

                        type:"null",
                        start:"00:00", 
                        end:"23:59",  
                        minutes: 0  
                    },
                    dimentions:
                    {
                        x: 0,
                        width: 4,
                        y: 0,
                        height: 4
                    },
                    graph:
                    {
                        graphType:subtype,
                        type:"lastValue",
                        other:false,
                        otherValueType: false,
                        maximumValue: 0,
                        maximumClients: [] 
                    },
                    dataType:"measurements"
                }
            }
            else if(type==3)
            {
                vm.showPeriodResolution=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    time:
                    {

                        type:"null",
                        start:"00:00", 
                        end:"23:59",  
                        minutes: 0  
                    },
                    dimentions:
                    {
                        x: 0,
                        width: 4,
                        y: 0,
                        height: 4
                    },
                    graph:
                    {
                        graphType:subtype,
                        foregroundColor:"rgb(3,169,244)",
                        backgroundColor:"rgb(176, 176, 176)",
                        thick: 10,
                        cap: "round",
                        style:"arch",
                        type:"lastValue",
                        maximumType: false,
                        maximumClients:[], 
                        maximumValue: 10,
                        error: 0,  
                        warning:0  
                    },
                    dataType:"measurements"
                }
            }
            else if(type==4)
            {
                vm.showPeriodResolution=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    time:
                    {

                        type:"null",
                        start:"00:00", 
                        end:"23:59",  
                        minutes: 0  
                    },
                    dimentions:
                    {
                        x: 0,
                        width: 4,
                        y: 0,
                        height: 4
                    },
                    graph:
                    {
                        graphType:'radar',
                        backgroundColor:"rgb(3,169,244)",
                        fill: true,
                        type:"lastValue",
                        other:false,
                        otherValueType: false,
                        maximumValue: 0,
                        maximumClients: []  
                    },
                    dataType:"measurements"
                }
            }
            else if(type==5)
            {
                vm.showDetails=false;
                vm.showPeriod=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 12,
                        y: 0,
                        height: 2
                    },
                    dataType:"none"
                }
            }
            else if(type==6)
            {
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 6,
                        y: 0,
                        height: 5
                    },
                    time:
                    {
                        resolutionType:"m",
                        resolutionValue: 15,
                        type:"null",
                        start:"00:00", 
                        end:"12:00",  
                        minutes: 0   
                    },
                    graph:
                    {
                        graphType:subtype,
                        point: "circle",
                        pointSize: 1,
                        value:"occupancy",
                        values:[],
                        spaces:[],
                        fontColor:"rgb(0,0,0)",
                        backgroundColor:"rgb(3,169,244)",
                        fill:false,
                        aggregated:false,
                        total:false,
                        average:false,
                        max:false,
                        min:false
                    },
                    dataType:"devices"
                }
            }
            else if(type==7)
            {
                vm.showPeriodResolution=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 6,
                        y: 0,
                        height: 5
                    },
                    time:
                    {
                        type:"null",
                        start:"00:00", 
                        end:"12:00",  
                        minutes: 0   
                    },
                    graph:
                    {
                        graphType:subtype,
                        value:"occupancy",
                        values:[],
                        spaces:[],
                        fontColor:"rgb(3,169,244)",
                        fill:false
                    },
                    dataType:"devices"
                }
            }
            else if(type==8)
            {
                vm.showPeriodResolution=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 6,
                        y: 0,
                        height: 5
                    },
                    time:
                    {
                        type:"null",
                        start:"00:00", 
                        end:"12:00",  
                        minutes: 0   
                    },
                    graph:
                    {
                        spaces:[]
                    },
                    dataType:"devices"
                }
            }
            else if(type==9)
            {
                vm.showPeriodResolution=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 6,
                        y: 0,
                        height: 5
                    },
                    time:
                    {
                        type:"null",
                        start:"00:00", 
                        end:"12:00",  
                        minutes: 0   
                    },
                    graph:
                    {
                        spaces:[]
                    },
                    dataType:"devices"
                }
            }
            else if(type==10)
            {
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 6,
                        y: 0,
                        height: 5
                    },
                    time:
                    {
                        resolutionType:"m",
                        resolutionValue: 15,
                        type:"null",
                        start:"00:00", 
                        end:"12:00",  
                        minutes: 0   
                    },
                    graph:
                    {
                        spaces:[],
                        value:"occupancy",
                        values:[],
                        hours:[],
                        fontColor:"rgb(0,0,0)"
                    },
                    dataType:"devices"
                }
            }
            else if(type==11)
            {
                vm.showPeriodResolution=false;
                vm.showDetails=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 6,
                        y: 0,
                        height: 5
                    },
                    time:
                    {
                        type:"null",
                        start:"00:00", 
                        end:"12:00",  
                        minutes: 0   
                    },
                    dataType:"devices"
                }
            }
            else if(type==12)
            {
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
                vm.showDetails=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 3,
                        y: 0,
                        height: 3
                    },
                    dataType:"devices"
                }
            }
            else if(type==13)
            {
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 3,
                        y: 0,
                        height: 3
                    },
                    graph:
                    {
                        fontColor:"rgb(0,0,0)",
                    },
                    dataType:"devices"
                }
            }
            else if(type==14)
            {
                vm.showPeriodResolution=false;
                vm.showPeriod=false;
                vm.showDetails=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 3,
                        y: 0,
                        height: 3
                    },
                    dataType:"devices"
                }
            }
            else if(type==15)
            {
                vm.showPeriod=true;
                vm.showPeriodResolution=false;
                vm.showDetails=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 6,
                        y: 0,
                        height: 3
                    },
                    time:
                    {
                        type:"null",
                        start:"00:00", 
                        end:"12:00",  
                        minutes: 0   
                    },
                    dataType:"devices"
                }
            }
            else if(type==16)
            {
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
                vm.showDetails=true;
                vm.widget=
                {
                    title:vm.widget.title,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 4,
                        y: 0,
                        height: 3
                    },
                    graph:
                    {
                        graphType:subtype, 
                        orientation:'vertical',
                        widgetHasColor:false,
                        widgetHasFontColor:false,
                        widgetColor:"rgb(3,169,244)",
                        fontColor:"rgb(0,0,0)"
                    },
                    dataType:"devices"
                }
            }
            else if(type==17)
            {
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
                vm.showDetails=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 6,
                        y: 0,
                        height: 5
                    },
                    dataType:"devices"
                }
            }
            else if(type==18)
            {
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 6,
                        y: 0,
                        height: 5
                    },
                    time:
                    {
                        resolutionType:"m",
                        resolutionValue: 15,
                        type:"null",
                        start:"00:00", 
                        end:"12:00",  
                        minutes: 0   
                    },
                    graph:
                    {
                        graphType:'table',
                        fontColor:"rgb(0,0,0)",
                        type:"rawData",
                        aggregated:false,
                        total:false,
                        average:false,
                        max:false,
                        min:false
                    },
                    dataType:"measurements"
                }
            } 
            else if(type==19)
            {
                vm.showDetails=false;
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 6,
                        y: 0,
                        height: 6
                    },
                    dataType:"devices"
                }
            }
            else if(type==20)
            {
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
                vm.showDetails=true;
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 3,
                        y: 0,
                        height: 3
                    },
                    clients:vm.widget.clients,
                    type: type,
                    graph:
                    {
                        graphType:subtype,
                        orientation:'vertical',
                        widgetHasColor:false,
                        widgetHasFontColor:false,
                        widgetColor:"rgb(3,169,244)",
                        fontColor:"rgb(0,0,0)"
                    },
                    dataType:"measurements"
                }
            }
            else if(type==21)
            {
                vm.showPeriod=false;
                vm.showPeriodResolution=false;
                vm.showDetails=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 3,
                        y: 0,
                        height: 3
                    },
                    clients:vm.widget.clients,
                    type: type,
                    graph:
                    {
                        graphType:subtype
                    },
                    dataType:"measurements"
                }
            }
            else if(type==22)
            {
                vm.showPeriodResolution=false;
                vm.widget=
                {
                    title:vm.widget.title,
                    dates:vm.widget.dates,
                    clients:vm.widget.clients,
                    type: type,
                    sub:sub,
                    dimentions:
                    {
                        x: 0,
                        width: 6,
                        y: 0,
                        height: 5
                    },
                    time:
                    {
                        type:"null",
                        start:"00:00", 
                        end:"12:00",  
                        minutes: 0   
                    },
                    graph:
                    {
                        reversed:[],
                        values:[],
                        value:"occupancy",
                        fontColor:"rgb(3,169,244)",
                        widgetHasColor:false,
                        widgetHasFontColor:false,
                        widgetColor:"rgb(3,169,244)",
                        orientation:'vertical'
                    },
                    dataType:"devices"
                }
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('ControlDashboardController', ControlDashboardController);

    function ControlDashboardController($mdDialog,event,dashboard,action,user,url,Notification,pragmaapi,PRAGMA,$cookies)
    {
        var vm = this;
        vm.dashboard=dashboard;
        vm.action=action;
        vm.closeDialog=closeDialog;
        vm.save=save;
        vm.dName="";
        vm.user=user;
        if(vm.user.hasVerticals)
        {
            vm.currentModule=vm.user.currentModule;
        }
        else
        {
            vm.currentModule="";
        }
        vm.url=url;
        if(vm.action==="Edit")
            vm.dName=vm.dashboard.name;
        function save()
        {
            if(vm.action==="New")
            {
                if(vm.dName=="")
                {
                    Notification.warning({
                        message: 'Please Fill in all the required fields!',
                        delay: 3000,
                        positionX:"right",
                        positionY:"bottom"
                        });
                }
                else
                {
                    var newDashboard=
                    {
                        token:generateUUID(),
                        name:vm.dName,
                        type:"",
                        userType:"",
                        userId:vm.user.username,
                        widgets:[],
                        data:{},
                        parent:"",
                        module:vm.currentModule
                    };
                    pragmaapi.callRestService(vm.url, "/dashboards", newDashboard, true, vm.user.authentication, "POST", true, false).then(function(res){
                         Notification.success({
                            message: 'Dashboard '+vm.dName+' Uploaded Successfully!',
                            delay: 3000,
                            positionX:"right",
                            positionY:"bottom"
                        });
                        var answer=
                        {
                            action:vm.action,
                            token:newDashboard.token
                        }
                        $mdDialog.hide(answer);
                    });
                }
            }
            else if(vm.action==="Edit")
            {
                if(vm.dName=="")
                {
                    Notification.warning({
                        message: 'Please Fill in all the required fields!',
                        delay: 3000,
                        positionX:"right",
                        positionY:"bottom"
                        });
                }
                else
                {
                    var newDashboard=
                    {
                        token:vm.dashboard.token,
                        name:vm.dName,
                        type:vm.dashboard.type,
                        userType:vm.dashboard.userType,
                        userId:vm.dashboard.userId,
                        widgets:vm.dashboard.widgets,
                        module:vm.dashboard.module
                    };
                    pragmaapi.callRestService(vm.url, "/dashboards/"+vm.dashboard.token, newDashboard, true, vm.user.authentication, "PUT", true, false).then(function(res){
                         Notification.success({
                            message: 'Dashboard '+vm.dName+' Updated Successfully!',
                            delay: 3000,
                            positionX:"right",
                            positionY:"bottom"
                        });
                        var answer=
                        {
                            action:vm.action,
                            token:newDashboard.token
                        }
                        $mdDialog.hide(answer);
                    });
                }
            }
            else if(vm.action==="Save")
            {
                var newDashboard=
                {
                    token:vm.dashboard.token,
                    name:vm.dashboard.name,
                    type:vm.dashboard.type,
                    userType:vm.dashboard.userType,
                    userId:vm.dashboard.userId,
                    widgets:vm.dashboard.widgets,
                    module:vm.dashboard.module
                };
                pragmaapi.callRestService(vm.url, "/dashboards/"+vm.dashboard.token, newDashboard, true, vm.user.authentication, "PUT", true, false).then(function(res){
                        Notification.success({
                        message: 'Dashboard '+vm.dName+' Saved Successfully!',
                        delay: 3000,
                        positionX:"right",
                        positionY:"bottom"
                    });
                    var answer=
                    {
                        action:vm.action,
                        token:newDashboard.token
                    }
                    $mdDialog.hide(answer);
                });
            }
            else if(vm.action==="Duplicate")
            {
                if(vm.dName=="")
                {
                    Notification.warning({
                        message: 'Please Fill in all the required fields!',
                        delay: 3000,
                        positionX:"right",
                        positionY:"bottom"
                        });
                }
                else
                {
                    var newDashboard=
                    {
                        token:generateUUID(),
                        name:vm.dName,
                        type:"",
                        userType:"",
                        userId:vm.user.username,
                        widgets:vm.dashboard.widgets,
                        module:vm.dashboard.module
                    };
                    pragmaapi.callRestService(vm.url, "/dashboards", newDashboard, true, vm.user.authentication, "POST", true, false).then(function(res){
                         Notification.success({
                            message: 'Dashboard '+vm.dashboard.name+' Duplicated Successfully!',
                            delay: 3000,
                            positionX:"right",
                            positionY:"bottom"
                        });
                        var answer=
                        {
                            action:vm.action,
                            token:newDashboard.token
                        }
                        $mdDialog.hide(answer);
                    });
                }
            }
            else if(vm.action==="Delete")
            {
                if(vm.dashboard.userId==="")
                {
                     pragmaapi.callRestService(vm.url, "/userPreferences/userId/"+vm.user.username+"/", "", true, vm.user.authentication, "GET", true, false).then(function(res){
                        vm.userPreferences=
                        {
                            language:res.data.language,
                            palette:res.data.palette,
                            token:res.data.token,
                            trees:res.data.trees,
                            userId:res.data.userId,
                            removedDashboards:res.data.removedDashboards
                        };
                        vm.userPreferences.removedDashboards.push(vm.dashboard.token);
                        pragmaapi.callRestService(vm.url, "/userPreferences/"+vm.userPreferences.token+"/", vm.userPreferences, true, vm.user.authentication, "PUT", true, false).then(function(res){
                            Notification.success({
                                message: 'Dashboard '+vm.dName+' Deleted Successfully!',
                                delay: 3000,
                                positionX:"right",
                                positionY:"bottom"
                            });
                            var answer=
                            {
                                action:vm.action,
                                token:null
                            }
                            $mdDialog.hide(answer);
                        });
                    });
                }
                else
                {
                    pragmaapi.callRestService(vm.url, "/dashboards/"+vm.dashboard.token, "?force=true", true, vm.user.authentication, "DELETE", true, false).then(function(res){
                        Notification.success({
                        message: 'Dashboard '+vm.dName+' Deleted Successfully!',
                        delay: 3000,
                        positionX:"right",
                        positionY:"bottom"
                    });
                    var answer=
                    {
                        action:vm.action,
                        token:null
                    }
                    $mdDialog.hide(answer);
                });
                }
            }
            else if(vm.action==="Restore")
            {
                pragmaapi.callRestService(vm.url, "/userPreferences/userId/"+vm.user.username+"/", "", true, vm.user.authentication, "GET", true, false).then(function(res){
                    vm.userPreferences=
                    {
                        language:res.data.language,
                        palette:res.data.palette,
                        token:res.data.token,
                        trees:res.data.trees,
                        userId:res.data.userId,
                        removedDashboards:[]
                    };
                    pragmaapi.callRestService(vm.url, "/userPreferences/"+vm.userPreferences.token+"/", vm.userPreferences, true, vm.user.authentication, "PUT", true, false).then(function(res){
                        Notification.success({
                            message: 'Default Dashboards Restored Successfully!',
                            delay: 3000,
                            positionX:"right",
                            positionY:"bottom"
                        });
                        var answer=
                        {
                            action:vm.action,
                            token:null
                        }
                        $mdDialog.hide(answer);
                    });
                });
            }
        }
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.breakdown', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.breakdown', {
            url      : '/breakdown',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/breakdown/breakdown.html',
                    controller : 'BreakdownController as vm'
                }
            },
            bodyClass: 'breakdown'
        });

        msNavigationServiceProvider.saveItem('breakdown', {
            title : 'NAVIGATION.BREAKDOWN',
            state: 'app.breakdown',
            group : true,
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.breakdown')
        .controller('SaveGraphController', SaveGraphController);

    function SaveGraphController($mdDialog, Notification, pragmaapi, chartType, savedGraph, savedGraphs)
    {
        var vm = this;
        
        var graph = inGraphs(savedGraph[chartType], savedGraphs, chartType);
        if (graph != null && !graph.is_default) {
            // Edit
            vm.graph = graph;
        }
        else {
            // New
            vm.graph = {
                id: generateUUID(),
                name: "",
                is_datasource: false,
                is_period: false,
                is_default: false,
                text: ""
            };
        }
        
        vm.saveGraph = function () {
            // Required fields
            if (vm.graph.name == "") {
                Notification.warning(pragmaapi.translate('BREAKDOWN.MESSAGE.PLEASE_FILL'));
            }
            else {
                $mdDialog.hide(vm.graph);
            }
        }
        
        vm.closeDialog = function () {
            $mdDialog.cancel();
        }
        
        function inGraphs(id, graphs, type) {
            if (graphs[type] != undefined) {
                for (var i = 0; i < graphs[type].length; i++) {
                    if (graphs[type][i].id == id) {
                        return graphs[type][i];
                    }
                }
            }
            return null;
        }
        
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.breakdown')
        .controller('DeleteEventController', DeleteEventController);

    function DeleteEventController($mdDialog, event, audit)
    {
        var vm = this;
        vm.event = audit;
        vm.closeDialog = closeDialog;
        vm.confirmDialog = confirmDialog;

        function confirmDialog()
        {
            $mdDialog.hide(vm.event);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.breakdown')
        .controller('BreakdownSearchController', BreakdownSearchController);

    function BreakdownSearchController($mdDialog, $q, $scope, event, user, PRAGMA, pragmaapi)
    {

        var vm = this;
        vm.closeDialog = closeDialog;
        
        user.authentication = user.username + ":" + user.password;
        
        vm.buildingTypes={
            "Residential": ['Detached','Semi-Detached','Terras','Appartment'],
            "Office": ['Administration','ICT','Government','Council','Telecoms','Medical','Shopping Centre','Housing Corporation'],
            "Recreation": ['Congress Centre','Church','Club House','Cinema','Theatre','Casino','Cafe','Restaurant','Cantine','Nightclub','Training','Museum','Child Care','Exhibition','Library'],
            "Sport": ['Swimming Baths','Tennis Hall','Gymnastics','Squash Courts','Sport Hall','Indoor Cycle Track','Fitness Centre','Bowling','Snooker','Shooting','Football Stadium'],
            "Loging": ['Hotel','Appartment Hotel','Motel','Bed & Breakfast','Asylum Centre'],
            "Retail": ['Local Shop','Indoor Shopping Centre','Super Market'],
            "Education": ['Junior School','Secondary School','Collage','University'],
            "Health": ['Cure','Care','unknown'],
            "Industry": ['Asfalt','Perishable Goods','Steel','Coffee','Koelinghouse','Dairy Produce','Meat','Rubber&Plastics','Chemical','Ceramics'],
            "Logistics": ['Transport','Storage','Transshipment'],
            "Parking": ['Indoor','Outdoor']
        };
        
        vm.floorTypes=['Concrete','Wood'];
        vm.wallTypes=['With Air Cavity','With Cavity insulation'];
        vm.roofInsulation=['Yes','No'];
        
        vm.heatingTypes=['Gas','Electricity','Diesel','Geothermal'];
        vm.aircoTypes=['Electricity','Geothermal'];
        vm.ventilationTypes=['Electricity','Geothermal'];
        
        vm.deviceTypes={'electricity': 'Electricity', 'gas': 'Gas', 'excess': 'PV Excess', 'water': 'Water'};
        
        vm.map = {
            center: {
                latitude: 0,
                longitude: 0
            },
            zoom: 12,
            markers: [],
            markersEvents: {
                click: function(marker, eventName, model) {
                    vm.map.window.model = model;
                    vm.map.window.show = true;
                }
            },
            control: {},
            window: {
                marker: {},
                show: false,
                closeClick: function() {
                    this.show = false;
                },
                options: {}
            }
        };
        
        _loadSites().then(function() {
            vm.map.markers = [];
            for (var i = 0; i < sites.length; i++) {
                var foo = {
                    id: sites[i].token,
                    labelContent: sites[i].name,
                    coords: {
                        latitude : sites[i].map.metadata.centerLatitude,
                        longitude: sites[i].map.metadata.centerLongitude
                    },
                    site: sites[i]
                };
                vm.map.markers.push(foo);
            }
        });
        
        /*
        $scope.map = {
            events: {
                tilesloaded: function (map) {
                    var isDrawing = false;
                    var overlay = new google.maps.OverlayView();
                    overlay.draw = function () {};
                    overlay.setMap(map);
                    var polyLine;
                    var parcelleHeig = Array();
                    google.maps.event.addListener(map, 'mousedown', function () {
                            isDrawing=true;
                            polyLine = new google.maps.Polyline({
                                map: map
                            });
                            $("#map").mousemove(function (e) {
                                if(isDrawing == true)
                                {
                                    var pageX = e.pageX;
                                    var pageY = e.pageY;
                                    var point = new google.maps.Point(parseInt(pageX), parseInt(pageY));

                                    var latLng = overlay.getProjection().fromDivPixelToLatLng(point);

                                    polyLine.getPath().push(latLng);

                                    latLng = String(latLng);
                                    latLng=latLng.replace("(","");
                                    latLng=latLng.replace(")","");

                                    var array_lng =  latLng.split(',');
                                    parcelleHeig.push(new google.maps.LatLng(array_lng[0],array_lng[1])) ;
                                }
                            });
                    });
                    google.maps.event.addListener(map, 'mouseup', function () {

                        isDrawing=false;
                        //console.log(parcelleHeig);

                        var polygoneParcelleHeig = new google.maps.Polygon({
                            paths: parcelleHeig,//sommets du polygone
                            strokeColor: "#0FF000",//couleur des bords du polygone
                            strokeOpacity: 0.8,//opacite des bords du polygone
                            strokeWeight: 2,//epaisseur des bords du polygone
                            fillColor: "#0FF000",//couleur de remplissage du polygone
                            fillOpacity: 0.35,////opacite de remplissage du polygone
                            editable:true,
                            geodesic: false

                        });
                        
                        //simplify polygon
                        var douglasPeuckerThreshold = 0.5; // in meters
                        polygoneParcelleHeig.douglasPeucker(360.0 / (2.0 * Math.PI * earthRadius));
                        
                        parcelleHeig=Array();
                        polygoneParcelleHeig.setMap(map);
                        polyLine.setMap(null);
                    });


                    var earthRadius = 6378137.0;

                    google.maps.Polygon.prototype.douglasPeucker = function(tolerance) {
                        
                        var res = null;

                        //adjust tolerance depending on the zoom level
                        tolerance = tolerance * Math.pow(2, 20 - map.getZoom());

                        if (this.getPath() && this.getPath().getLength()) {
                            var points = this.getPath().getArray();

                            var Line = function( p1, p2 ) {
                                this.p1 = p1;
                                this.p2 = p2;

                                this.distanceToPoint = function( point ) {
                                    // slope
                                    var m = ( this.p2.lat() - this.p1.lat() ) / ( this.p2.lng() - this.p1.lng() ),
                                        // y offset
                                        b = this.p1.lat() - ( m * this.p1.lng() ),
                                        d = [];
                                    // distance to the linear equation
                                    d.push( Math.abs( point.lat() - ( m * point.lng() ) - b ) / Math.sqrt( Math.pow( m, 2 ) + 1 ) );
                                    // distance to p1
                                    d.push( Math.sqrt( Math.pow( ( point.lng() - this.p1.lng() ), 2 ) + Math.pow( ( point.lat() - this.p1.lat() ), 2 ) ) );
                                    // distance to p2
                                    d.push( Math.sqrt( Math.pow( ( point.lng() - this.p2.lng() ), 2 ) + Math.pow( ( point.lat() - this.p2.lat() ), 2 ) ) );
                                    // return the smallest distance
                                    return d.sort( function( a, b ) {
                                        return ( a - b ); //causes an array to be sorted numerically and ascending
                                    } )[0];
                                };
                            };

                            var douglasPeucker = function( points, tolerance ) {
                                    
                                if ( points.length <= 2 ) {
                                    return [points[0]];
                                }
                                var returnPoints = [],
                                    // make line from start to end 
                                    line = new Line( points[0], points[points.length - 1] ),
                                    // find the largest distance from intermediate poitns to this line
                                    maxDistance = 0,
                                    maxDistanceIndex = 0,
                                    p;
                                for( var i = 1; i <= points.length - 2; i++ ) {
                                    var distance = line.distanceToPoint( points[ i ] );
                                    if( distance > maxDistance ) {
                                        maxDistance = distance;
                                        maxDistanceIndex = i;
                                    }
                                }
                                // check if the max distance is greater than our tollerance allows 
                                if ( maxDistance >= tolerance ) {
                                    p = points[maxDistanceIndex];
                                    line.distanceToPoint( p, true );
                                    // include this point in the output 
                                    returnPoints = returnPoints.concat( douglasPeucker( points.slice( 0, maxDistanceIndex + 1 ), tolerance ) );
                                    // returnPoints.push( points[maxDistanceIndex] );
                                    returnPoints = returnPoints.concat( douglasPeucker( points.slice( maxDistanceIndex, points.length ), tolerance ) );
                                } else {
                                    // ditching this point
                                    p = points[maxDistanceIndex];
                                    line.distanceToPoint( p, true );
                                    returnPoints = [points[0]];
                                }
                                return returnPoints;
                            };
                            res = douglasPeucker( points, tolerance );
                            // always have to push the very last point on so it doesn't get left off
                            res.push( points[points.length - 1 ] );
                            this.setPath(res);
                        }
                        return this;
                    }
                    
                    if (!google.maps.Polygon.prototype.getBounds) {
                        google.maps.Polygon.prototype.getBounds = function(latLng) {
                            var bounds = new google.maps.LatLngBounds(),
                                paths = this.getPaths(),
                                path,
                                p, i;

                            for (p = 0; p < paths.getLength(); p++) {
                                path = paths.getAt(p);
                                for (i = 0; i < path.getLength(); i++) {
                                    bounds.extend(path.getAt(i));
                                }
                            }
                            return bounds;
                        };
                    }

                    google.maps.Polygon.prototype.containsLatLng = function(latLng) {
                        var inPoly = false,
                            bounds, lat, lng,
                            numPaths, p, path, numPoints,
                            i, j, vertex1, vertex2;

                        // Arguments are a pair of lat, lng variables
                        if (arguments.length == 2) {
                            if (
                                typeof arguments[0] == "number" &&
                                typeof arguments[1] == "number"
                            ) {
                                lat = arguments[0];
                                lng = arguments[1];
                            }
                        } else if (arguments.length == 1) {
                            bounds = this.getBounds();

                            if (!bounds && !bounds.contains(latLng)) {
                                return false;
                            }
                            lat = latLng.lat();
                            lng = latLng.lng();
                        } else {
                            console.log("Wrong number of inputs in google.maps.Polygon.prototype.contains.LatLng");
                        }

                        numPaths = this.getPaths().getLength();
                        for (p = 0; p < numPaths; p++) {
                            path = this.getPaths().getAt(p);
                            numPoints = path.getLength();
                            j = numPoints - 1;

                            for (i = 0; i < numPoints; i++) {
                                vertex1 = path.getAt(i);
                                vertex2 = path.getAt(j);

                                if (
                                    vertex1.lng() <  lng &&
                                    vertex2.lng() >= lng ||
                                    vertex2.lng() <  lng &&
                                    vertex1.lng() >= lng
                                ) {
                                    if (
                                          vertex1.lat() +
                                          (lng - vertex1.lng()) /
                                          (vertex2.lng() - vertex1.lng()) *
                                          (vertex2.lat() - vertex1.lat()) <
                                          lat
                                    ) {
                                        inPoly = !inPoly;
                                    }
                                }

                                j = i;
                            }
                        }
                        return inPoly;
                    };
                }
            }
        }
        */
        
        // Sites
        var sites = [];
        var tenantAuthTokens = [];
        function _loadSites() {
            
            // Get All Tenants
            var tenantAuthTokens = [];
            return pragmaapi.callRestService(PRAGMA.api, "/users/" + user.username + "/tenants", "?includeRuntimeInfo=true", true, user.authentication, "GET").then(function(res) {
                var tenants = res.data;
                for (var i = 0; i < tenants.length; i++) {
                    if (!tenants[i].deleted && tenants[i].engineState.lifecycleStatus == "Started") {
                        tenantAuthTokens.push(tenants[i].authenticationToken);
                    }
                }
                
                // Load Sites
                var promises = tenantAuthTokens.map(function(tenantAuthToken) {
                    return pragmaapi.callRestService(PRAGMA.api, "/sites", "?tenantAuthToken=" + tenantAuthToken, true, user.authentication, "GET", true).then(function(res) {
                        if (!res.data.error && res.data.numResults) {
                            var results = res.data.results;
                            for (var i = 0; i < results.length; i++) {
                                sites.push(results[i]);
                            }
                        }
                    });
                });
                return $q.all(promises);
            });
        }
        
        function getLocations(tenant, site)
        {
            pragmaapi.callRestService(vm.url, "/sites/" + site, "?tenantAuthToken=" + tenant, true, user.authentication, "GET", true, false).then(function(res){
                var location=res.data;
                var temp = {
                    "id": location.token,
                    "labelContent": location.name,
                    "coords": {
                        latitude : location.map.metadata.centerLatitude,
                        longitude:location.map.metadata.centerLongitude
                    }
                };
                vm.googlmapLocations.push(temp);
                vm.googleMapCenter = angular.copy(vm.googlmapLocations[0].coords);
            });
        }
        
        function closeDialog()
        {
            $mdDialog.cancel();
        }
        
        /*
        var map = new google.maps.Map(document.getElementById("map"), options);

        var markers = [];

        */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('ReleaseAssignmentController', ReleaseAssignmentController);

    function ReleaseAssignmentController($mdDialog,event,device)
    {
        var vm = this;
        vm.device=device;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;
        function confirmDialog()
        {
           $mdDialog.hide(vm.device.assignment.token);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewVerticalController', NewVerticalController);

    function NewVerticalController($mdDialog,event,Notification,verticals)
    {
        var vm = this;
        vm.closeDialog = closeDialog;

        vm.saveVertical=saveVertical;
        vm.vertical=
        {
            name:"",
            primary:"",
            secondary:"",
            logo:"",
            parent:"#"
        }
        var tmp={
            name:"No Parent",
            token:"#"
        }
        vm.verticals=[];
        vm.verticals.push(tmp);
        for(var i=0;i<verticals.length;i++)
        {
            var tmp={
                name:verticals[i].name,
                token:verticals[i].token
            }
            vm.verticals.push(tmp);
        }
        function saveVertical()
        {
            if(vm.vertical.name==="" || vm.vertical.primary==="" || vm.vertical.logo==="" || vm.vertical.parent==="" || vm.vertical.secondary==="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                var response=vm.vertical;
                $mdDialog.hide(response);
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewUserController', NewUserController);

    function NewUserController($mdDialog,event,Notification,thisUser,pragmaapi,PRAGMA)
    {
        var vm = this;
        vm.file="";
        vm.userPreferences={solutions:[]};
        vm.solutions=[];
        vm.thisUser=thisUser;
        vm.closeDialog = closeDialog;
        vm.user={
            firstName:"",
            lastName:"",
            username:"",
            password:"",
            status:"Active",
            metadata:{
                role:"level05",
                imageUrl:"",
                email:"",
                phone:""
            }
        };
        vm.saveUser=saveUser;
        vm.userTypes = [
            {name: "Super Administrator", type: "level01"},
            {name: "Administrator", type: "level02"},
            {name: "White Label", type: "level03"},
            {name: "Portfolio User", type: "level04"},
            {name: "Site User", type: "level05"}
        ];
        if(vm.thisUser.hasVerticals)
        {
            pragmaapi.callRestService(PRAGMA.api, "/verticalSolutions/", "",true, vm.thisUser.authentication, "GET", true, false).then(function(res) {
                var modules=res.data.results;
                for(var i=0;i<modules.length;i++)
                {
                    for(var k=0;k<vm.thisUser.modules.length;k++)
                    {
                        if(vm.thisUser.modules[k]===modules[i].token)
                        {
                            vm.solutions.push(modules[i]);
                            break;
                        }
                    }
                }
            });
        }
        switch (vm.thisUser.role) {
            case "level04":
                vm.userTypes.shift();
            case "level03":
                vm.userTypes.shift();
            case "level02":
                vm.userTypes.shift();
                vm.userTypes.shift();
        }

        vm.statuses=['Active','Expired','Locked'];
        function saveUser()
        {
            if(vm.user.firstName=="" || vm.user.lastName=="" || vm.user.username=="" || vm.user.metadata.email=="" || vm.user.password=="" || (vm.thisUser.hasVerticals && vm.userPreferences.solutions.length==0))
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else if(!validateEmail(vm.user.metadata.email))
            {
                 Notification.warning({
                       message: "Please Fill in the user's email in correct form!",
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                });
            }
            else
            {
                var response={};
                response.username=vm.user.username;
                response.password=vm.user.password;
                response.firstName=vm.user.firstName;
                response.lastName=vm.user.lastName;
                response.status=vm.user.status;
                response.metadata={};
                response.metadata.email= vm.user.metadata.email;
                response.metadata.role=vm.user.metadata.role;
                response.metadata.imageUrl=vm.user.metadata.imageUrl;
                if(vm.user.metadata.phone!="")
                    response.metadata.phone= vm.user.metadata.phone;
                response.authorities=[];
                if(vm.user.metadata.role==="level01" || vm.user.metadata.role==="level02")
                    {
                        response.authorities.push("VIEW_SERVER_INFO");
                        response.authorities.push("REST");
                        response.authorities.push("ADMIN_CONSOLE");
                        response.authorities.push("ADMINISTER_USERS");
                        response.authorities.push("ADMINISTER_USER_SELF");
                        response.authorities.push("ADMINISTER_TENANTS");
                        response.authorities.push("ADMINISTER_TENANT_SELF");
                        response.authorities.push("ADMINISTER_SCHEDULES");
                        response.authorities.push("SCHEDULE_COMMANDS");
                        response.authorities.push("ADMINISTER_SITES");
                        response.authorities.push("ADMINISTER_SITE_SELF");
                    }
                    else if(vm.user.metadata.role==="level03")
                    {
                        response.authorities.push("REST");
                        response.authorities.push("ADMIN_CONSOLE");
                        response.authorities.push("ADMINISTER_USERS");
                        response.authorities.push("ADMINISTER_USER_SELF");
                        response.authorities.push("ADMINISTER_TENANT_SELF");
                        response.authorities.push("ADMINISTER_SCHEDULES");
                        response.authorities.push("SCHEDULE_COMMANDS");
                        response.authorities.push("ADMINISTER_SITE_SELF");
                    }
                    else if(vm.user.metadata.role==="level04")
                    {
                        response.authorities.push("REST");
                        response.authorities.push("ADMIN_CONSOLE");
                        response.authorities.push("ADMINISTER_USERS");
                        response.authorities.push("ADMINISTER_USER_SELF");
                        response.authorities.push("ADMINISTER_TENANT_SELF");
                        response.authorities.push("ADMINISTER_SITE_SELF");
                    }
                    else if(vm.user.metadata.role==="level05")
                    {
                        response.authorities.push("REST");
                        response.authorities.push("ADMIN_CONSOLE");
                        response.authorities.push("ADMINISTER_USER_SELF");
                        response.authorities.push("ADMINISTER_TENANT_SELF");
                        response.authorities.push("ADMINISTER_SITE_SELF");
                    }
                var r=
                {
                    user:response,
                    modules:vm.userPreferences.solutions
                }
                $mdDialog.hide(r);
            }
        }
        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewTenantController', NewTenantController);

    function NewTenantController($mdDialog,event,Notification,users,user)
    {
        var vm = this;
        vm.users=users;
        vm.user=user;
        vm.closeDialog = closeDialog;
        vm.tenant={
            id:generateUUID(),
            name:"",
            logoUrl:"",
            authenticationToken:generateUUID(),
            authorizedUserIds:[]
        };
        vm.tenant.id=(vm.tenant.id).replace(/-/g, '_');
        vm.saveTenant=saveTenant;
        function saveTenant()
        {
            if(vm.tenant.id=="" || vm.tenant.name=="" || vm.tenant.authenticationToken=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                vm.tenant.authorizedUserIds.push(vm.user.username);
                $mdDialog.hide(vm.tenant);
            }
        }
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewTariffController', NewTariffController);

    function NewTariffController($mdDialog,event,Notification,tenants,thisTenant,user)
    {
        var vm = this;
        vm.file="";
        vm.closeDialog = closeDialog;
        vm.tariff={
            token:generateUUID(),
            name:"",
            type:"unit",
            period:0,
            cost:0,
            vat:0,
            tenant:thisTenant
        };
        vm.tenants=tenants;
        vm.user=user;
        vm.clearFields=clearFields;
        vm.saveTariff=saveTariff;
        vm.tariffTypes=[ 
        {name:"Per Unit",type:"unit"},
        {name:"Fixed Tariff",type:"fixed"},
        {name:"Reward",type:"return"},
        {name:"Custom Formula",type:"formula"}];
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function clearFields()
        {
            vm.tariff.name="";
            vm.tariff.period=0;
            vm.tariff.cost=0;
            vm.tariff.vat=0;
        }
        function saveTariff()
        {
            if(vm.tariff.name=="" || vm.tariff.type=="" || vm.tariff.tenant=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                 var response={
                   message:{
                        name:vm.tariff.name,
                        token:vm.tariff.token,
                        type:vm.tariff.type,
                        period:vm.tariff.period,
                        cost:vm.tariff.cost,
                        vat:vm.tariff.vat,
                   },
                   tenant: vm.tariff.tenant
                };
                console.log(response)
                $mdDialog.hide(response);
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewSpecificationController', NewSpecificationController);

    function NewSpecificationController($mdDialog,event,Notification,tenants,user,$base64,$http,url,thisTenant)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.specification={
            name:"",
            token:generateUUID(),
            containerPolicy:"Standalone",
            assetId:"",
            assetModuleId:"",
            tenant:thisTenant,
            metadata:
            {
                priority:3,
                specs:{}
            }
        };
        vm.types=
        [
            {
                name:"Electricity",
                type:"electricity"
            },
            {
                name:"Cost",
                type:"cost"
            },
            {
                name:"Water",
                type:"water"
            },
            {
                name:"Gas",
                type:"gas"
            },
            {
                name:"Temperature",
                type:"temperature"
            },
            {
                name:"Humidity",
                type:"humidity"
            },
            {
                name:"Luminance",
                type:"brightness"
            }
        ];
        vm.user=user;
        vm.url=url;
        vm.specs=
        [
            {
                id:0,
                name:"",
                friendlyName:"",
                unit:"",
                type:"",
                cost:false,
                cumulative:false,
                aggregated:false,
                metadata:false,
                expert:false
            }
        ];
        vm.removeSpec=removeSpec;
        vm.addNewSpec=addNewSpec;
        function removeSpec(id)
        {
            if(vm.specs.length>1)
            {
                vm.specs.splice(id, 1);
                for(var i=0;i<vm.specs.length;i++)
                {
                    vm.specs[i].id=i;
                }
            }
        }
        function addNewSpec()
        {
            var tmp={
                id:vm.specs.length,
                name:"",
                friendlyName:"",
                unit:"",
                type:"",
                cost:false,
                cumulative:false,
                aggregated:false,
                metadata:false,
                expert:false
            };
            vm.specs.push(tmp);
        }
        vm.saveSpecification=saveSpecification;
        vm.assetModule=assetModule;
        vm.assetsFunction=assetsFunction;
        vm.tenants=tenants;
        assetModule(thisTenant);
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function assetsFunction(id)
        {
             vm.specification.assetId='';
              callRestService(vm.url,"/assets/categories/"+id+"/assets","?page=1&pageSize=2000&tenantAuthToken="+vm.specification.tenant,true,vm.user,"GET").then(function(res){
                vm.assets=res.data.results;
            });     
        }
        function assetModule(id)
        {
            vm.specification.assetModuleId='';
            vm.specification.assetId='';
             callRestService(vm.url,"/assets/categories","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user,"GET").then(function(res){
                vm.assetModules=res.data.results;
            });
        }
        function saveSpecification()
        {
            if(vm.specification.name=="" || vm.specification.token=="" || vm.specification.containerPolicy=="" || vm.specification.tenant=="" || vm.specification.assetId=="" || vm.specification.assetModuleId=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                for(var i=0;i<vm.specs.length;i++)
                {
                    vm.specification.metadata.specs[vm.specs[i].name]=
                    {
                        friendlyName:vm.specs[i].friendlyName,
                        unit:vm.specs[i].unit,
                        type:vm.specs[i].type,
                        cost:vm.specs[i].cost,
                        cumulative:vm.specs[i].cumulative,
                        aggregated:vm.specs[i].aggregated,
                        metadata:vm.specs[i].metadata,
                        expert:vm.specs[i].expert
                    }
                }
               /*for(var l=0;l<Object.keys(vm.specification.metadata.specs).length;l++)
               {
                    vm.specification.metadata.specs[Object.keys(vm.specification.metadata.specs)[l]]=JSON.stringify(vm.specification.metadata.specs[Object.keys(vm.specification.metadata.specs)[l]]); 
               }*/
               vm.specification.metadata.specs=JSON.stringify(vm.specification.metadata.specs); 
               vm.specification.metadata.priority=vm.specification.metadata.priority.toString();
               var response={
                   message:{
                        name:vm.specification.name,
                        token:vm.specification.token,
                        containerPolicy:vm.specification.containerPolicy,
                        assetId:vm.specification.assetId,
                        assetModuleId:vm.specification.assetModuleId,
                        metadata:vm.specification.metadata
                   },
                   tenant: vm.specification.tenant
                };
                $mdDialog.hide(response);
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }

         //Call Rest
        function callRestService(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            }) 
        }	
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewSiteGroupSiteController', NewSiteGroupSiteController);

    function NewSiteGroupSiteController($mdDialog,event,Notification,thisTenant,currentGroup,sites)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.siteIds=[];
        vm.sites=sites;
        vm.siteIdsTemp=[];
        vm.currentGroup=currentGroup;
        for(var i=0;i<vm.currentGroup.elements.length;i++)
        {
            vm.siteIdsTemp.push(vm.currentGroup.elements[i].token);
        }
        vm.saveDeviceGroupDevice=saveDeviceGroupDevice;
        function saveDeviceGroupDevice()
        {
            vm.currentGroup.elements=[];
            for(var i=0;i<vm.siteIdsTemp.length;i++)
            {
                var tmp=
                {
                    type:"site",
                    token:vm.siteIdsTemp[i]
                }
                vm.currentGroup.elements.push(tmp);
            }
            var response={
                message:
                {
                    token:vm.currentGroup.token,
                    name:vm.currentGroup.name,
                    parent:"",
                    site:"",
                    type:"site",
                    userId:vm.currentGroup.userId,
                    description:vm.currentGroup.description,
                    elements:vm.currentGroup.elements
                },
                tenant: thisTenant
            };
            $mdDialog.hide(response);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewSiteGroupController', NewSiteGroupController);

    function NewSiteGroupController($mdDialog,event,Notification,tenants,thisTenant,user,users,url,$base64,$http)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.deviceGroup={
            name:"",
            token:generateUUID(),
            description:"",
            roles:[],
            tenant:thisTenant
        };
        vm.url=url;
        vm.user=user;
        vm.users=users.results;
        vm.saveDeviceGroup=saveDeviceGroup;
        vm.tenants=tenants;
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function saveDeviceGroup()
        {
            if(vm.deviceGroup.name=="" || vm.deviceGroup.token=="" || vm.deviceGroup.tenant=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {  
                if(vm.deviceGroup.roles.length>0)
                {
                    for(var i=0;i<vm.tenants.length;i++)
                    {
                        if(vm.tenants[i].authenticationToken===vm.deviceGroup.tenant)
                        {
                            var thisTenant=vm.tenants[i];
                        }
                    }
                    var flTenant=false;
                    for(var j=0;j<vm.deviceGroup.roles.length;j++)
                    {
                        var fl=0;
                        for(var i=0;i<thisTenant.authorizedUserIds.length;i++)
                        {
                            if(vm.deviceGroup.roles[j]===thisTenant.authorizedUserIds[i])
                                fl=1;
                        }
                        if(!fl)
                        {
                            thisTenant.authorizedUserIds.push(vm.deviceGroup.roles[j]);
                            flTenant=true;
                        }
                            
                    }
                    if(flTenant)
                    {
                        callRestService(vm.url,"/tenants/"+thisTenant.id,thisTenant,true,vm.user.authentication,"PUT").then(function(res){});
                    }
                }
                var response={
                    message:{
                            parent:"",
                            type:"site",
                            name:vm.deviceGroup.name,
                            token:vm.deviceGroup.token,
                            description:vm.deviceGroup.description,
                            userId:vm.deviceGroup.roles,
                            elements:[],
                            site:""
                    },
                    tenant: vm.deviceGroup.tenant
                    };
                    $mdDialog.hide(response);
            }
        }
        function callRestService(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            });
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewSiteController', NewSiteController);

    function NewSiteController($mdDialog,event,Notification,tenants,thisTenant,$http,$base64,user,url,$scope,users)
    {
        var vm = this;
        vm.users=users;
        vm.map= {
        center: {
            latitude: 51.93828582950888,
            longitude:5.410594940185547
        },
        markers: [],
        events: {
            click: function (map, eventName, originalEventArgs) {
                var e = originalEventArgs[0];
                var lat = e.latLng.lat(),lon = e.latLng.lng();
                var marker = {
                    id: Date.now(),
                    coords: {
                        latitude: lat,
                        longitude: lon
                    }
                };
                vm.site.map.metadata.centerLatitude=marker.coords.latitude;
                vm.site.map.metadata.centerLongitude=marker.coords.longitude;
                vm.map.markers[0]=marker;
                $scope.$apply();
            }
        }
        };
        vm.closeDialog = closeDialog;
        vm.file="";
        vm.url=url;
        vm.user=user;
        vm.site={
            name:"",
            token:generateUUID(),
            description:"",
            imageUrl:"",
            authorizedUserIds:[],
            metadata:{
                heating:"unknown",
                airconditioning:"unknown",
                ventilation:"unknown",
                wallStructure:"unknown",
                groundFloor:"unknown",
                roofInsulation:"No",
                roofInsulationType:"",
                buildingType:"unknown",
                buildingSubType:"unknown",
                energyLabel:"unknown",
                year:1970,
                workingArea:0,
                occupants:0,
                dimensionsX:0,
                dimensionsY:0,
                dimensionsZ:0,
                street:"",
                houseNumber:"",
                postCode:"",
                city:""
            },
            map:{
                type:"openstreetmap",
                metadata:{
                    zoomLevel:8,
                    centerLatitude:"",
                    centerLongitude:""
                }
            },
            tenant:thisTenant
        };
        vm.buildingTypes={
            Residential:['Detached','Semi-Detached','Terras','Appartment','unknown'],
            Office:['Administration','ICT','Government','Council','Telecoms','Medical','Shopping Centre','Housing Corporation','unknown'],
            Recreation :['Congress Centre','Church','Club House','Cinema','Theatre','Casino','Cafe','Restaurant','Cantine','Nightclub','Training','Museum','Child Care','Exhibition','Library','unknown'],
            Sport:['Swimming Baths','Tennis Hall','Gymnastics','Squash Courts','Sport Hall','Indoor Cycle Track','Fitness Centre','Bowling','Snooker','Shooting','Football Stadium','unknown'],
            Loging:['Hotel','Appartment Hotel','Motel','Bed & Breakfast','Asylum Centre','unknown'],
            Retail:['Local Shop','Indoor Shopping Centre','Super Market','unknown'],
            Education:['Junior School','Secondary School','Collage','University','unknown'],
            Health:['Cure','Care','unknown'],
            Industry:['Asfalt','Perishable Goods','Steel','Coffee','Koelinghouse','Dairy Produce','Meat','Rubber&Plastics','Chemical','Ceramics','unknown'],
            Logistics:['Transport','Storage','Transshipment','unknown'],
            Parking:['Indoor','Outdoor','unknown'],
            unknown:['unknown']
        };
        vm.heatingTypes=['Gas','Electricity','Diesel','Geothermal','unknown'];
        vm.aircoTypes=['Electricity','Geothermal','unknown'];
        vm.ventilationTypes=['Electricity','Geothermal','unknown'];
        vm.roofInsulationTypes=['Concrete','Foam','unknown'];
        vm.wallTypes=['With Air Cavity','With Cavity insulation','unknown'];
        vm.siteTypes=['Building','Lighting','Parking','Waste'];
        vm.floorTypes=['Concrete','Wood','unknown'];
        vm.roofInsulation=['Yes','No'];
        vm.energyLabels=['A++++','A+++','A++','A+','A','B','C','D','E','F','G','unknown'];
        vm.saveSite=saveSite;
        vm.tenants=tenants;
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function saveSite()
        {   
            if(vm.site.metadata.siteType=="" || vm.site.metadata.houseNumber=="" || typeof vm.site.metadata.houseNumber=="undefined" || vm.site.metadata.postCode=="" || typeof vm.site.metadata.postCode=="undefined"  || vm.site.name=="" || vm.site.token=="" || vm.site.map.type=="" || vm.site.tenant=="" || vm.site.map.metadata.centerLatitude=="" || vm.site.map.metadata.centerLongitude=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
               var response={
                   message:{
                        name:vm.site.name,
                        token:vm.site.token,
                        description:vm.site.description,
                        imageUrl:vm.site.imageUrl,
                        authorizedUserIds:vm.site.authorizedUserIds,
                        map:{
                            type:vm.site.map.type,
                            metadata:{
                                zoomLevel:vm.site.map.metadata.zoomLevel,
                                centerLatitude:vm.site.map.metadata.centerLatitude,
                                centerLongitude:vm.site.map.metadata.centerLongitude
                            }
                        },
                        metadata:vm.site.metadata
                   },
                   tenant: vm.site.tenant
                };
                vm.asset={
                    name:vm.site.name,
                    id:vm.site.token,
                    assetType:"Location"
                }
                vm.assetCategory={
                    name:vm.site.name+" Building",
                    id:vm.site.token,
                    imageUrl:'https://hydra.iti.gr/assets/location.png',
                    latitude:vm.site.map.metadata.centerLatitude,
                    longitude:vm.site.map.metadata.centerLongitude,
                    elevation:1
                };
                callRestService(vm.url,"/assets/categories?tenantAuthToken="+vm.site.tenant,vm.asset,true,vm.user.authentication,"POST").then(function(res){
                    callRestService(vm.url,"/assets/categories/"+vm.asset.id+"/locations?tenantAuthToken="+vm.site.tenant,vm.assetCategory,true,vm.user.authentication,"POST").then(function(res){
                    },function(reason) {
                    })
                },function(reason) {
                });
               
    
                for(var i=0;i<vm.tenants.length;i++)
                {
                    if(vm.tenants[i].authenticationToken===vm.site.tenant)
                    {
                        vm.tenant=vm.tenants[i];
                    }
                }
               var tTenant={
                    id:vm.tenant.id,
                    name:vm.tenant.name,
                    logoUrl:vm.tenant.logoUrl,
                    authenticationToken:vm.tenant.authenticationToken,
                    authorizedUserIds:vm.tenant.authorizedUserIds,
                    metadata:vm.tenant.metadata
                };
                var fl=0;
                var flTenant=false;
                for(var j=0;j<response.message.authorizedUserIds.length;j++)
                {
                    fl=0;
                    for(var i=0;i<tTenant.authorizedUserIds.length;i++)
                    {
                        if(tTenant.authorizedUserIds[i]===response.message.authorizedUserIds[j])
                            fl=1;
                    }
                    if(!fl)
                    {
                        tTenant.authorizedUserIds.push(response.message.authorizedUserIds[j]);
                        flTenant=true;
                    }     
                }
                if(flTenant)
                {
                    callRestService(vm.url,"/tenants/"+tTenant.id,tTenant,true,vm.user.authentication,"PUT").then(function(res){});
                }
                $mdDialog.hide(response);
            }
        }
        //Call Rest
        function callRestService(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            });
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewNotificationController', NewNotificationController);

    function NewNotificationController($mdDialog,event, pragmaapi, Notification,user,url,$scope)
    {
        var vm = this;
        vm.group1 = "MBP";
        vm.user=user;
        vm.intervalNum = 0;
        vm.showTree=false;
        vm.closeDialog = closeDialog;
        vm.notification=
        {
            "type":"Prediction",
            "group":false,
            "function":"SUM",
            "groupByType":"m",
            "groupByVal":15,
            "typePeriod":"custom",
            "periodType":"h",
            "period":4,
            "name":"",
            "portal":true,
            "mail":false,
            "sms":false
        };
        vm.activeNotification=false;
        vm.checkboxes =
        [{
            name: "Median Based Prediction",
            value: "MBP"
        },
        {
            name: "Regression Based Prediction",
            value: "RBP"
        }]
        vm.time={
            value: new Date(1970, 0, 1, 12, 0, 0)
        };
        vm.notificationsPeriod=
        [
            {
                name:"Fixed Time",
                type:"custom"
            },
            {
                name:"Interval Time",
                type:"interval"
            }
        ]
        vm.notifications=
        [
            {
                name:"Custom Timer",
                type:"custom"
            },
            {
                name:"Device Interval",
                type:"interval"
            }
        ];
        vm.periods=
        [
            {
                name:"Seconds",
                type:"s"
            },
            {
                name:"Minutes",
                type:"m"
            },
            {
                name:"Hours",
                type:"h"
            },
            {
                name:"Days",
                type:"d"
            }
        ];
        vm.notificationTypes=
        [
            {
                name:"Prediction",
                type:"Prediction"
            },
            {
                name:"Degradation",
                type:"Degradation"
            },
            {
                name:"Disaggregation",
                type:"Disaggregation"
            }
        ];
        vm.groupByTypes=
        [
            {
                name:"Minutes",
                type:"m"
            },
            {
                name:"Hours",
                type:"h"
            },
            {
                name:"Days",
                type:"d"
            }
        ];
        vm.functions=
        [
            {
                name:"Total Value",
                type:"SUM"
            },
            {
                name:"Average Value",
                type:"MEAN"
            },
            {
                name:"Median Value",
                type:"MEDIAN"
            },
            {
                name:"Minimum Value",
                type:"MIN"
            },
            {
                name:"Maximum Value",
                type:"MAX"
            }
        ];
        vm.url=url;
        vm.saveNotification=saveNotification;
        vm.widget={};
        vm.widget.clients = [];
        vm.currentModule=vm.user.currentModule;
        vm.parentModule=vm.user.parentModule;
        if(vm.currentModule==='' || vm.parentModule==='#')
        {
            vm.filter={
                device:{},
                site:{},
                specification:{},
                includeDevices:true,
                includeMeasurements:true,
                specs:[],
                measurements:{}
            };
        }
        else
        {
            vm.filter={
                device:[{modules:[vm.currentModule]}],
                site:{},
                specification:{},
                includeDevices:true,
                includeMeasurements:true,
                specs:[],
                measurements:{}
            };
        }
        $scope.$on('change.module', function(event, args) {
            vm.showTree=false;
            if(args.parent==='#')
            {
                vm.filter={
                    device:{},
                    site:{},
                    specification:{},
                    includeDevices:true,
                    includeMeasurements:true,
                    specs:[],
                    measurements:{}
                };
            }
            else
            {
                vm.filter={
                    device:[{modules:[args.token]}],
                    site:{},
                    specification:{},
                    includeDevices:true,
                    includeMeasurements:true,
                    specs:[],
                    measurements:{}
                };
            }
            vm.refreshTree(false);
        });
        initTree();
        function initTree()
        {
           /* pragmaapi.getTreeData(true, true,true,true).then(function(treeData) {
                vm.treeData = treeData;
                vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow']);
                vm.versionNo++;
                vm.treeConfig.version = vm.versionNo;
            });*/
            pragmaapi.getTreeDataFilter(vm.filter).then(function(treeData) {
                vm.treeData = treeData;
                vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow']);
                vm.versionNo++;
                vm.treeConfig.version = vm.versionNo;
                vm.showTree=true;
            });
        }

        vm.treeEvents = 
        {
            'ready': readyCB,
            'create_node': createNodeCB,
            'select_node': getSelectedNodes,
            'deselect_node': getSelectedNodes
        }

        function createNodeCB() {}
        vm.applySearch = function (){
            if(vm.treeInstance) {
            vm.treeInstance.jstree(true).search(vm.searchtree);
            }
        };

        function readyCB() {
            
        }
        function getSelectedNodes()
        {
            var jstree = vm.treeInstance.jstree(true);
            vm.selected_nodes = jstree.get_selected();
            var measurementsTemp=[];
            vm.widget.clients=[];
            for(var i=0;i<vm.selected_nodes.length;i++)
            {
                if(vm.selected_nodes[i].includes("measurement"))
                {
                    for(var l=0;l<vm.treeData.length;l++)
                    {
                        if(vm.treeData[l].id===vm.selected_nodes[i])
                        {
                            vm.notification.site=vm.treeData[l].siteToken;
                            vm.notification.tenant = vm.treeData[l].tenantAuthToken;
                            vm.notification.assignment = vm.treeData[l].token;
                            vm.notification.measurement = vm.treeData[l].measure;
                            break;
                        }
                    }
                }
            }
        }


        function saveNotification()
        {
            pragmaapi.callRestService(vm.url, "/tenants/authtoken/",vm.notification.tenant , true, vm.user.authentication, "GET", true, false).then(function(res){
                if(vm.notification.type==='Degradation' || vm.notification.type==='Prediction')
                {
                    if(vm.notification.name=="" || vm.notification.tenant=="")
                    {
                        Notification.warning({
                            message: 'Please Fill in all the required fields!',
                            delay: 3000,
                            positionX:"right",
                            positionY:"bottom"
                        });
                    }
                    else
                    {
                        var time = "";
                        if (vm.notification.type==="Degradation")
                        {
                            vm.group1='';
                        }
                        if (vm.notification.typePeriod == "custom")
                        {
                            vm.intervalNum = 0;
                            var h;
                            var m;
                            var s;
                            if (vm.time.value.getHours() < 10) h="0"+vm.time.value.getHours().toString(); else h=vm.time.value.getHours().toString();
                            if (vm.time.value.getMinutes() < 10) m="0"+vm.time.value.getMinutes().toString(); else m=vm.time.value.getMinutes().toString();
                            if (vm.time.value.getSeconds() < 10) s="0"+vm.time.value.getSeconds().toString(); else s=vm.time.value.getSeconds().toString();
                            time=h+":"+m+":"+s;
                        }
                        var response={
                            message:{
                                title: vm.notification.name,
                                type: vm.notification.type,
                                userId: vm.user.username,
                                tenant: vm.notification.tenant,
                                active: vm.activeNotification,
                                interval: vm.intervalNum,
                                lastTriggered: 1506160747568,
                                arguments: {
                                    type:vm.group1,
                                    database: res.data.id,
                                    assignment: vm.notification.assignment,
                                    measurement: vm.notification.measurement,
                                    group:(vm.notification.group).toString(),
                                    function:vm.notification.function,
                                    groupBy:vm.notification.groupByVal+vm.notification.groupByType
                                },
                                fixedTime: time
                            }
                        };
                        pragmaapi.callRestService(vm.url, "/assignments/",vm.notification.assignment+"?tenantAuthToken="+vm.notification.tenant , true, vm.user.authentication, "GET", true, false).then(function(res){
                            var assign=res.data.device.hardwareId;
                            pragmaapi.callRestService(vm.url, "/devices/",assign+"?tenantAuthToken="+vm.notification.tenant , true, vm.user.authentication, "GET", true, false).then(function(res){
                                var meta=res.data.metadata;
                                if(typeof meta.prediction=="undefined")
                                {
                                    meta.prediction=vm.notification.measurement
                                }
                                else
                                {
                                    if(meta.prediction=="")
                                    {
                                        meta.prediction=vm.notification.measurement
                                    }
                                    else
                                    {
                                        meta.prediction=meta.prediction+","+vm.notification.measurement
                                    }
                                }
                                var dev=
                                {
                                    hardwareId: res.data.hardwareId,
                                    siteToken: res.data.siteToken,
                                    specificationToken: res.data.specificationToken,
                                    comments:res.data.comments,
                                    metadata:meta,
                                    modules:res.data.modules
                                };
                                callRestService(vm.url,"/devices/"+assign+"?tenantAuthToken="+vm.notification.tenant,dev,true,vm.user.authentication,"PUT").then(function(res){
                                    pragmaapi.callRestService(vm.url, "/batchNotifications", response.message, true, vm.user.authentication, "POST", true, false).then(function(res){
                                        $mdDialog.hide(true);
                                    });
                                });
                            });
                        });
                    }
                }
            });
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewDeviceGroupDeviceController', NewDeviceGroupDeviceController);

    function NewDeviceGroupDeviceController($mdDialog,event,Notification,thisTenant,groups,devices,currentGroup,url,user,$http,$base64)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.groups=groups;
        vm.devices=devices;
        vm.currentGroup=currentGroup;
        vm.fillDevices=fillDevices;
        vm.deviceIds=[];
        vm.type="device";
        vm.types=
        [
            {name:"Device",type:"device"},
            {name:"Group",type:"group"}
        ];
        for(var i=0;i<vm.currentGroup.elements.length;i++)
        {
            vm.deviceIds.push(vm.currentGroup.elements[i].token);
        }
        fillDevices();
        function fillDevices()
        {
            vm.listDevices=[];
            vm.listGroups=[];
            for(var i=0;i<vm.devices.length;i++)
            {
                var tmp=
                {
                    type:'device',
                    name:vm.devices[i].metadata.name,
                    token:vm.devices[i].hardwareId,
                    image:vm.devices[i].specification.assetImageUrl
                };
                vm.listDevices.push(tmp);
            }
            for(var j=0;j<vm.groups.length;j++)
            {
                if(vm.groups[j].token!= vm.currentGroup.token)
                {
                    var tmp=
                    {
                        type:'group',
                        name:vm.groups[j].name,
                        token:vm.groups[j].token
                    };
                    vm.listGroups.push(tmp);
                }
            }
        }
        vm.saveDeviceGroupDevice=saveDeviceGroupDevice;
        function saveDeviceGroupDevice()
        {
           if(vm.deviceIds.length==0)
           {
                Notification.warning({
                    message: 'Please Fill in all the required fields!',
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
           }
           else
           {
               var tmpElements=[];
               for(var i=0;i< vm.deviceIds.length;i++)
               {
                    for(var j=0;j<vm.devices.length;j++)
                    {
                        if(vm.deviceIds[i]===vm.devices[j].hardwareId)
                        {
                            var tmp=
                            {
                                type:'device',
                                token:vm.deviceIds[i],
                            };
                            tmpElements.push(tmp);
                            break;
                        }
                    }
                    for(var k=0;k<vm.groups.length;k++)
                    {
                        if(vm.deviceIds[i]===vm.groups[k].token)
                        {
                            var tmp=
                            {
                                type:'group',
                                token:vm.deviceIds[i],
                            };
                            tmpElements.push(tmp);
                            var toSend=
                            {
                                token:vm.groups[k].token,
                                name:vm.groups[k].name,
                                site:vm.groups[k].site,
                                description:vm.groups[k].description,
                                userId:vm.groups[k].userId,
                                parent:"hasParent",
                                type:vm.groups[k].type,
                                elements:vm.groups[k].elements
                            };
                            callRestService2(url,"/groups/"+toSend.token+"?tenantAuthToken="+thisTenant,toSend,true,user.authentication,"PUT").then(function(res){});
                            break;
                        }
                    }
               }
                var response={
                    message:
                    {
                        token:vm.currentGroup.token,
                        name:vm.currentGroup.name,
                        parent:vm.currentGroup.parent,
                        site:vm.currentGroup.site,
                        type:vm.currentGroup.type,
                        userId:vm.currentGroup.userId,
                        description:vm.currentGroup.description,
                        elements:tmpElements
                    },
                    tenant: thisTenant
                };
               $mdDialog.hide(response);
           }
        }
        function callRestService2(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT" || method==="DELETE")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            }); 
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        } 
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewDeviceGroupController', NewDeviceGroupController);

    function NewDeviceGroupController($mdDialog,event,Notification,tenants,thisTenant,sites,thisSite,$http,$base64,user,url)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.deviceGroup={
            name:"",
            token:generateUUID(),
            description:"",
            tenant:thisTenant,
            site:thisSite,
            siteName:""
        };
        vm.url=url;
        vm.saveDeviceGroup=saveDeviceGroup;
        vm.user=user;
        vm.tenants=tenants;
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        vm.fillSites=fillSites;
        fillSites(thisTenant,'start');
        function fillSites(id,type)
        {
            vm.deviceGroup.siteToken='';
            callRestService(vm.url,"/sites","?page=1&pageSize=1000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.sites=res.data.results;
                if(type==='start')
                {
                    vm.deviceGroup.site=thisSite;
                }
                else
                {
                    vm.deviceGroup.site=vm.sites[0].token;
                }
            });
        }
        function saveDeviceGroup()
        {
            if(vm.deviceGroup.name=="" || vm.deviceGroup.site=="" || vm.deviceGroup.tenant=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {  
                var response={
                    message:{
                        parent:"",
                        type:"device",
                        name:vm.deviceGroup.name,
                        token:vm.deviceGroup.token,
                        description:vm.deviceGroup.description,
                        userId:[vm.user.username],
                        elements:[],
                        site:vm.deviceGroup.site
                    },
                    tenant: vm.deviceGroup.tenant
                };
                $mdDialog.hide(response);
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
         //Call Rest
        function callRestService(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            }) 
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewDeviceController', NewDeviceController);

    function NewDeviceController($mdDialog,event,Notification,tenants,$http,$base64,user,url,thisTenant,thisSite,PRAGMA,pragmaapi)
    {
        var vm = this;
        vm.user=user;
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.closeDialog = closeDialog;
        vm.tenants=tenants;
        vm.solutions=[];
        vm.notifications=
        [
            {
                name:"Custom Timer",
                type:"custom"
            },
            {
                name:"Device Interval",
                type:"interval"
            }
        ]
        vm.notificationTime=15;
        vm.device={
            hardwareId: generateUUID(),
            siteToken: thisSite,
            specificationToken: "",
            comments: "",
            tenant:thisTenant,
            modules:[],
            metadata:{
                gateway:"Raspberry",
                token:"CFnBbOzCU0KQJXinHY37pGo3GpKkOMCnegNiMp9b",
                id:"",
                type:"",
                name:"",
                notification:false,
                notificationType:"interval",
                notificationTime:""
            }
        }
        vm.deviceTypes=[
            'Central Panel',
            'Lighting',
            'Cooling',
            'Heating',
            'Refrigeration',
            'Ventilation',
            'Water Heating',
            'Plug Loads',
            'Cooking',
            'EV Charging',
            'Hvac',
            'Renewable Energy Resources',
            'Other'
        ];
        vm.deviceGoups={};
        vm.specifications={};
        vm.sites={};
        vm.fillSitesAndSpecifications=fillSitesAndSpecifications;
        vm.url=url;
        vm.saveDevice=saveDevice;
        vm.gateways=['Raspberry','Ealyze','Open Weather'];
        fillSitesAndSpecificationsStart(thisTenant);
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function fillSitesAndSpecificationsStart(id)
        {
            vm.device.specificationToken="";
            callRestService(vm.url,"/sites","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.sites=res.data.results;
            });
            callRestService(vm.url,"/specifications","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.specifications=res.data.results;
             });
            if(vm.user.hasVerticals)
            {
                pragmaapi.callRestService(PRAGMA.api, "/verticalSolutions/tenant/", id, true, vm.user.authentication, "GET", true, false).then(function(res) {
                    vm.solutions=[];
                    var modules=res.data.results;
                    for(var i=0;i<modules.length;i++)
                    {
                        if(modules[i].parent!=="#")
                        {
                            for(var k=0;k<vm.user.modules.length;k++)
                            {
                                if(vm.user.modules[k]===modules[i].token)
                                {
                                    vm.solutions.push(modules[i]);
                                    break;
                                }
                            }
                        }
                    }
                });
            }
        }
        function fillSitesAndSpecifications(id)
        {
            vm.device.specificationToken="";
            callRestService(vm.url,"/sites","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.sites=res.data.results;
            });
            callRestService(vm.url,"/specifications","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.specifications=res.data.results;
             });
            if(vm.user.hasVerticals)
            {
                pragmaapi.callRestService(PRAGMA.api, "/verticalSolutions/tenant/", id, true, vm.user.authentication, "GET", true, false).then(function(res) {
                    vm.solutions=[];
                    vm.device.modules=[];
                    var modules=res.data.results;
                    for(var i=0;i<modules.length;i++)
                    {
                        if(modules[i].parent!=="#")
                        {
                            for(var k=0;k<vm.user.modules.length;k++)
                            {
                                if(vm.user.modules[k]===modules[i].token)
                                {
                                    vm.solutions.push(modules[i]);
                                    break;
                                }
                            }
                        }
                    }
                });
            }
        }
        function saveDevice()
        {
            vm.device.metadata.notification=vm.device.metadata.notification.toString();
            vm.device.metadata.notificationTime=vm.notificationTime.toString();
            if(vm.device.hardwareId=="" || vm.device.siteToken=="" || vm.device.specificationToken=="" || vm.device.tenant=="" || vm.device.metadata.type==""|| vm.device.metadata.name=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                var response={
                    message:{
                        hardwareId: vm.device.hardwareId,
                        siteToken: vm.device.siteToken,
                        specificationToken: vm.device.specificationToken,
                        comments: vm.device.comments,
                        modules:vm.device.modules,
                        metadata:vm.device.metadata
                    },
                    tenant: vm.device.tenant
                };
                callRestService(vm.url,"/devices?tenantAuthToken="+response.tenant,response.message,true,vm.user.authentication,"POST").then(function(res){
                    $mdDialog.hide(true);
                });
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
         //Call Rest
        function callRestService(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            }) 
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewCostProfileController', NewCostProfileController);

    function NewCostProfileController($mdDialog,event,Notification,tenants,thisTenant,user,costs,url,sites,thisSite,$base64,$http)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.url=url;
        vm.changeClient=changeClient;
        vm.costProfile={
            name:"",
            token:generateUUID(),
            measure:"electricity",
            startDate:"",
            siteIds:[],
            tenant:thisTenant
        };
        vm.costProfile.siteIds.push(thisSite);
        vm.user=user;
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.saveCostProfile=saveCostProfile;
        vm.tenants=tenants;
        vm.sites=sites.results;
        vm.costs=costs.results;
        vm.measureTypes=[ 
        {name:"Electricity",type:"electricity"},
        {name:"Gas",type:"gas"},
        {name:"Water",type:"water"},
        {name:"Aluminium",type:"recycle_aluminium"},
        {name:"Glass",type:"recycle_glass"},
        {name:"Paper",type:"recycle_paper"},
        {name:"Plastic",type:"recycle_plastic"}];

        function changeClient(id)
        {
            vm.costProfile.siteIds=[];
            callRestService(vm.url,"/costs","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.costs=res.data.results;
            });
            callRestService(vm.url,"/sites","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.sites=res.data.results;
            });
        }
        function saveCostProfile()
        {
            if(vm.costProfile.name=="" || vm.costProfile.token=="" || vm.costProfile.tenant=="" || vm.costProfile.measure=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {   
                if (vm.costProfile.startDate) {
                    var dDate = moment(vm.costProfile.startDate).format('YYYY-MM-DDTHH:mm:ss.000ZZ');
                }
                else {
                    var dDate = "1900-01-01T00:00:00.000+0000";
                }
                var response={
                    message:{
                        name:vm.costProfile.name,
                        token:vm.costProfile.token,
                        measure:vm.costProfile.measure,
                        startDate:dDate,
                        siteIds:vm.costProfile.siteIds
                    },
                    tenant: vm.costProfile.tenant
                };
                $mdDialog.hide(response);
            }
        }
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function callRestService(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            });
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewCostController', NewCostController);

    function NewCostController($mdDialog, event, user, Notification, thisTenant, thisCostProfile)
    {
        var vm = this;
        
        // User
        vm.user = user;
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        vm.tariffsPerUnit=[];
        vm.tariffsScedule=[];
        vm.deleteTariffScedule=deleteTariffScedule;
        vm.deleteTariffPerUnit=deleteTariffPerUnit;
        // Tenant
        var tenant = thisTenant;
        vm.newTariffPerUnit=newTariffPerUnit;
        vm.newTariffScedule=newTariffScedule;
        // Selects
        vm.tariffTypes = [
            {name: "Per Unit", type:"unit"},
            {name: "Fixed", type:"fixed"},
            {name: "Reward", type:"return"},
            {name: "Formula", type:"formula"}
        ];
        vm.tariffPeriods = [
            {name: "Day", type: "1"},
            {name: "Month", type: "30"},
            {name: "2 Months", type: "60"},
            {name: "Quarter", type: "120"},
            {name: "Half Year", type: "180"},
            {name: "Year", type: "365"}
        ];
        vm.formulaTypes = [
            {name: "Cost", type: "cost"},
            {name: "Benefit", type: "benefit"}
        ];
        
        // New object
        vm.cost = {
            id: "",
            name: "",
            token: generateUUID(),
            type: "fixed",
            tariffs: [{name: "", cost: "", period: "", vat: ""}],
            schedule: [],
            profileToken: thisCostProfile.token,
            inTotal: true
        };
        
        // Schedule flag
        vm.schedule = false;
        
        // HotTable
        vm.scheduleTariffs = [];
        var hotTable = fillHotTable(24, 7, 1);
        
        vm.hotTableSettings = {
            data: hotTable,
            columns: getColummnHeaders(), colWidths: 35, height: 206,
            rowHeaders: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            autoColumnSize: false, autoRowSize: false, allowEmpty: false, colHeaders: true,
            maxRows:hotTable.length, maxCols:hotTable[0].length, minRows:hotTable.length, minCols:hotTable[0].length,
            afterRender: afterRender
        }
        
        function fillHotTable(columns, rows, tariff) {
            var data = [];
            for (var i = 0; i < rows; i++) {
                data[i] = [];
                for (var j = 0; j < columns; j++) {
                    data[i][j] = 'T' + tariff;
                }
            }
            return data;
        }
        function newTariffScedule()
        {
            var tmp=
            {
                above:0,
                tariffs:[]
            };
            for(var i=0;i<vm.scheduleTariffs.length;i++)
            {
                var tt=
                {
                    cost:vm.scheduleTariffs[i].cost,
                    name:vm.scheduleTariffs[i].name,
                    vat:vm.scheduleTariffs[i].vat
                };
                tmp.tariffs.push(tt);
            }
            vm.tariffsScedule.push(tmp);
        }
        function newTariffPerUnit()
        {
           
            var tmp=
            {
                cost:0,
                vat:0,
                above:0
            }
            vm.tariffsPerUnit.push(tmp);
        }
        Array.prototype.remove = function(from, to) {
            var rest = this.slice((to || from) + 1 || this.length);
            this.length = from < 0 ? this.length + from : from;
            return this.push.apply(this, rest);
        };
        function deleteTariffPerUnit(id)
        {
            vm.tariffsPerUnit.remove(id);
        }
        function deleteTariffScedule(id)
        {
            vm.tariffsScedule.remove(id);
        }
        function getColummnHeaders() {
            var columns = [];
            for (var i = 0; i < 24; i++) {
                columns.push({title: ("00" + i).substr(-2, 2) + ':00'});
            }
            return columns;
        }
        
        var emptyNotified = false;
        function afterRender(isForced) {
            if (!isForced) return;
            if (!emptyNotified && !hotTableComplete()) {
                Notification.warning({
                     message: 'Empty values are not allowed...',
                     delay: 3000,
                     positionX: "right",
                     positionY: "bottom"
                });
                emptyNotified = true;
            }
            // Add new tariffs
            for (var i = 0; i < hotTable.length; i++) {
                for (var j = 0; j < hotTable[i].length; j++) {
                    if (hotTable[i][j] != "") {
                        if (!inTariffs(hotTable[i][j])) {
                            vm.scheduleTariffs.push({name: hotTable[i][j], cost: "", period: "", vat: ""});
                        }
                    }
                }
            }
            
            // Remove not used tariffs
            for (var i = 0; i < vm.scheduleTariffs.length; i++) {
                if (!inHotTable(vm.scheduleTariffs[i].name)) {
                    vm.scheduleTariffs.splice(i, 1);
                }
            }
            
        }
        
        function hotTableComplete() {
            for (var i = 0; i < hotTable.length; i++) {
                for (var j = 0; j < hotTable[i].length; j++) {
                    if (hotTable[i][j] == "") {
                        return false;
                    }
                }
            }
            return true;
        }
        
        function scheduleComplete() {
            if (hotTableComplete()) {
                for (var i = 0; i < vm.scheduleTariffs.length; i++) {
                    if (vm.scheduleTariffs[i].cost == "") {
                        return false;
                    }
                }
            }
            else {
                return false;
            }
            return true;
        }
        
        function inTariffs(needle) {
            for (var i = 0; i < vm.scheduleTariffs.length; i++) {
                if (vm.scheduleTariffs[i].name == needle) {
                    return true;
                }
            }
            return false;
        }
        
        function inHotTable(needle) {
            for (var i = 0; i < hotTable.length; i++) {
                for (var j = 0; j < hotTable[i].length; j++) {
                    if (hotTable[i][j] == needle) {
                        return true;
                    }
                }
            }
            return false;
        }
        
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };

        ////////
        
        vm.getLabel = getLabel;
        vm.resetType = resetType
        vm.saveCost = saveCost;
        vm.closeDialog = closeDialog;
        
        function getLabel(type) {
            var label = "Cost";
            for (var i = 0; i < vm.tariffTypes.length; i++) {
                if (vm.tariffTypes[i].type == type) {
                    if (type == 'formula') {
                        label = vm.tariffTypes[i].name;
                    }
                    else if (type == 'return') {
                        label = vm.tariffTypes[i].name + " benefit";
                    }
                    else {
                        label = vm.tariffTypes[i].name + " cost"; 
                    }
                    break;
                }
            };
            return label;
        }
        
        function resetType() {
          if (vm.cost.type != 'unit') vm.schedule = false;
        }
        
        function saveCost()
        {
            if (vm.cost.type =="") {
                   Notification.warning({
                       message: 'Please fill all required fields!',
                       delay: 3000,
                       positionX: "right",
                       positionY: "bottom"
                    });
            }
            else {
                if (vm.schedule) {
                    var tmp=
                    {
                        above:null,
                        tariffs:[]
                    };
                    for(var i=0;i<vm.scheduleTariffs.length;i++)
                    {
                        var tt=
                        {
                            cost:vm.scheduleTariffs[i].cost,
                            name:vm.scheduleTariffs[i].name,
                            vat:vm.scheduleTariffs[i].vat
                        };
                        tmp.tariffs.push(tt);
                    }
                    vm.tempTariffs=[];
                    vm.tempTariffs.push(tmp);
                    for(var i=0;i<vm.tariffsScedule.length;i++)
                    {
                        vm.tempTariffs.push(vm.tariffsScedule[i]);
                    }
                    var response = {
                        message: {
                            name: vm.cost.name,
                            token: vm.cost.token,
                            type: vm.cost.type,
                            profileTokens: [thisCostProfile.token],
                            id: vm.cost.id,
                            inTotal: vm.cost.inTotal,
                            schedule: hotTable,
                            tariffs: vm.tempTariffs
                        },
                        tenant: tenant
                    };
                }
                else {
                    if(vm.cost.type=='unit')
                    {
                        vm.tempTariffs=[];
                        var tmp=
                        {
                            cost:vm.cost.tariffs[0].cost,
                            vat:vm.cost.tariffs[0].vat,
                            above:null
                        }
                        vm.tempTariffs.push(tmp);
                        for(var i=0;i<vm.tariffsPerUnit.length;i++)
                        {
                            vm.tempTariffs.push(vm.tariffsPerUnit[i]);
                        }
                        var response = {
                            message: {
                                name: vm.cost.name,
                                token: vm.cost.token,
                                type: vm.cost.type,
                                profileTokens: [thisCostProfile.token],
                                id: vm.cost.id,
                                inTotal: vm.cost.inTotal,
                                tariffs: vm.tempTariffs
                            },
                            tenant: tenant
                        };
                    }
                    else
                    {
                        var response = {
                            message: {
                                name: vm.cost.name,
                                token: vm.cost.token,
                                type: vm.cost.type,
                                profileTokens: [thisCostProfile.token],
                                id: vm.cost.id,
                                inTotal: vm.cost.inTotal,
                                tariffs: vm.cost.tariffs
                            },
                            tenant: tenant
                        };
                    }
                }
                console.log(response)
                $mdDialog.hide(response);
            }
        }

        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewAssetCategoryController', NewAssetCategoryController);

    function NewAssetCategoryController($mdDialog,event,Notification,type)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.type=type;
        vm.assetCategory={
            name:"",
            id:generateUUID(),
            imageUrl:"",
            properties:{}
        };
        if(vm.type=="Device" || vm.type=="Hardware")
        {
            vm.assetCategory.sku='';
            vm.assetCategory.description='';
        }
        else if(vm.type=="Location")
        {
            vm.assetCategory.latitude='';
            vm.assetCategory.longitude='';
            vm.assetCategory.elevation='';
        }
        else
        {
            vm.assetCategory.userName='';
            vm.assetCategory.emailAddress='';
            vm.assetCategory.roles=[];
        }
        vm.saveAssetCategory=saveAssetCategory;
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function saveAssetCategory()
        {
            if((vm.assetCategory.name=="" || vm.assetCategory.id=="") || ((vm.type=="Device"||vm.type=="Hardware") && (vm.assetCategory.sku=="")) || ((vm.type=="Location") && (vm.assetCategory.latitude=="" || vm.assetCategory.longitude=="" ||vm.assetCategory.elevation==="")) || ((vm.type=="Person") && (vm.assetCategory.userName=="" || vm.assetCategory.emailAddress=="")))
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else if(vm.type=="Person" && !validateEmail(vm.assetCategory.emailAddress))
            {
                 Notification.warning({
                       message: "Please Fill in the user's email in correct form!",
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                });
            }
            else
            {
                var response=vm.assetCategory;
                $mdDialog.hide(response);
            }
        }
        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('NewAssetController', NewAssetController);

    function NewAssetController($mdDialog,event,Notification)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.asset={
            name:"",
            id:generateUUID(),
            assetType:"Device"
        };
        vm.assetTypes=['Device','Hardware','Location','Person'];
        vm.saveAsset=saveAsset;
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function saveAsset()
        {
            if(vm.asset.name=="" || vm.asset.id=="" || vm.asset.assetType=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                var response=vm.asset;
                $mdDialog.hide(response);
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditVerticalController', EditVerticalController);

    function EditVerticalController($mdDialog,event,Notification,verticals,thisVertical)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.saveVertical=saveVertical;
        vm.vertical=angular.copy(thisVertical);
        var tmp={
            name:"No Parent",
            token:"#"
        }
        vm.verticals=[];
        vm.verticals.push(tmp);
        for(var i=0;i<verticals.length;i++)
        {
            var tmp={
                name:verticals[i].name,
                token:verticals[i].token
            }
            vm.verticals.push(tmp);
        }
        function saveVertical()
        {
            if(vm.vertical.name==="" || vm.vertical.primary==="" || vm.vertical.logo==="" || vm.vertical.parent==="" || vm.vertical.secondary==="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                var response=vm.vertical;
                $mdDialog.hide(response);
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditUserController', EditUserController);

    function EditUserController($mdDialog,event,Notification,user,thisUser,pragmaapi,PRAGMA)
    {
        var vm = this;
        vm.thisUser = thisUser;
        vm.closeDialog = closeDialog;
        vm.user = user;
        vm.userPreferences={modules:[]};
        vm.solutions=[];
        vm.userTypes = [
            {name: "Super Administrator", type: "level01"},
            {name: "Administrator", type: "level02"},
            {name: "White Label", type: "level03"},
            {name: "Portfolio User", type: "level04"},
            {name: "Site User", type: "level05"}
        ];
        
        switch (vm.thisUser.role) {
            case "level04":
                vm.userTypes.shift();
            case "level03":
                vm.userTypes.shift();
            case "level02":
                vm.userTypes.shift();
                vm.userTypes.shift();
        }
        if(vm.thisUser.hasVerticals)
        {
            pragmaapi.callRestService(PRAGMA.api, "/verticalSolutions/", "",true, vm.thisUser.authentication, "GET", true, false).then(function(res) {
                var modules=res.data.results;
                for(var i=0;i<modules.length;i++)
                {
                    for(var k=0;k<vm.thisUser.modules.length;k++)
                    {
                        if(vm.thisUser.modules[k]===modules[i].token)
                        {
                            vm.solutions.push(modules[i]);
                            break;
                        }
                    }
                }
            });
        }
        pragmaapi.callRestService(PRAGMA.api, "/userPreferences/userId/" + vm.user.username+"/", "", true, vm.thisUser.authentication, "GET", true, false).then(function(res){
            var mods=res.data.modules;
            for(var i=0;i<mods.length;i++)
            {
                vm.userPreferences.modules.push(mods[i]);
            }
            vm.userPreferences.token=res.data.token;
            vm.userPreferences.userId=res.data.userId;
            vm.userPreferences.palette=res.data.palette;
            vm.userPreferences.language=res.data.language;
            vm.userPreferences.removedDashboards=res.data.removedDashboards;
            vm.userPreferences.trees=res.data.trees;
            vm.userPreferences.data=res.data.data;
        });
        vm.saveUser=saveUser;
        vm.statuses=['Active','Expired','Locked'];
        function saveUser()
        {
            if(vm.user.firstName=="" || vm.user.lastName=="" || vm.user.username=="" || vm.user.metadata.email=="" || vm.user.password=="" || (vm.thisUser.hasVerticals && vm.userPreferences.modules.length==0))
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else if(!validateEmail(vm.user.metadata.email))
            {
                 Notification.warning({
                       message: "Please Fill in the user's email in correct form!",
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                });
            }
            else
            {
                 var response={};
                response.username=vm.user.username;
                response.password=vm.user.password;
                response.firstName=vm.user.firstName;
                response.lastName=vm.user.lastName;
                response.status=vm.user.status;
                response.metadata={};
                response.metadata.email= vm.user.metadata.email;
                response.metadata.role=vm.user.metadata.role;
                response.metadata.imageUrl=vm.user.metadata.imageUrl;
                if(vm.user.metadata.phone!="")
                    response.metadata.phone= vm.user.metadata.phone;
                response.authorities=[];
                if(vm.user.metadata.role==="level01" || vm.user.metadata.role==="level02")
                {
                    response.authorities.push("VIEW_SERVER_INFO");
                    response.authorities.push("REST");
                    response.authorities.push("ADMIN_CONSOLE");
                    response.authorities.push("ADMINISTER_USERS");
                    response.authorities.push("ADMINISTER_USER_SELF");
                    response.authorities.push("ADMINISTER_TENANTS");
                    response.authorities.push("ADMINISTER_TENANT_SELF");
                    response.authorities.push("ADMINISTER_SCHEDULES");
                    response.authorities.push("SCHEDULE_COMMANDS");
                    response.authorities.push("ADMINISTER_SITES");
                    response.authorities.push("ADMINISTER_SITE_SELF");
                }
                else if(vm.user.metadata.role==="level03")
                {
                    response.authorities.push("REST");
                    response.authorities.push("ADMIN_CONSOLE");
                    response.authorities.push("ADMINISTER_USERS");
                    response.authorities.push("ADMINISTER_USER_SELF");
                    response.authorities.push("ADMINISTER_TENANT_SELF");
                    response.authorities.push("ADMINISTER_SCHEDULES");
                    response.authorities.push("SCHEDULE_COMMANDS");
                    response.authorities.push("ADMINISTER_SITE_SELF");
                }
                else if(vm.user.metadata.role==="level04")
                {
                    response.authorities.push("REST");
                    response.authorities.push("ADMIN_CONSOLE");
                    response.authorities.push("ADMINISTER_USERS");
                    response.authorities.push("ADMINISTER_USER_SELF");
                    response.authorities.push("ADMINISTER_TENANT_SELF");
                    response.authorities.push("ADMINISTER_SITE_SELF");
                }
                else if(vm.user.metadata.role==="level05")
                {
                    response.authorities.push("REST");
                    response.authorities.push("ADMIN_CONSOLE");
                    response.authorities.push("ADMINISTER_USER_SELF");
                    response.authorities.push("ADMINISTER_TENANT_SELF");
                    response.authorities.push("ADMINISTER_SITE_SELF");
                }
                var r=
                {
                    user:response,
                    preferences:vm.userPreferences
                }
                $mdDialog.hide(r);
            }
        }
        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditTenantController', EditTenantController);

    function EditTenantController($mdDialog,event,Notification,users,tenant,user,$http,$base64)
    {
        var vm = this;
        vm.users=users;
        vm.user=user;
        vm.closeDialog = closeDialog;
        vm.tenant={
            id:angular.copy(tenant.id),
            name:angular.copy(tenant.name),
            logoUrl:angular.copy(tenant.logoUrl),
            authenticationToken:angular.copy(tenant.authenticationToken),
            authorizedUserIds:angular.copy(tenant.authorizedUserIds),
            metadata:angular.copy(tenant.metadata)
        };
        vm.saveTenant=saveTenant;
        function saveTenant()
        {
            if(vm.tenant.id=="" || vm.tenant.name=="" || vm.tenant.authenticationToken=="" || vm.tenant.authorizedUserIds.length==0)
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                $mdDialog.hide(vm.tenant);
            }
        }
        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditTariffController', EditTariffController);

    function EditTariffController($mdDialog,event,Notification,tenants,thisTenant,user,tariff)
    {
        var vm = this;
        vm.file="";
        vm.closeDialog = closeDialog;
        vm.tariff=tariff;
        vm.tariff.tenant=thisTenant;
        vm.tenants=tenants;
        vm.user=user;
        vm.clearFields=clearFields;
        vm.saveTariff=saveTariff;
        vm.tariffTypes=[ 
        {name:"Per Unit",type:"unit"},
        {name:"Fixed Tariff",type:"fixed"},
        {name:"Reward",type:"return"},
        {name:"Custom Formula",type:"formula"}];
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function clearFields()
        {
            vm.tariff.name="";
            vm.tariff.period=0;
            vm.tariff.cost=0;
            vm.tariff.vat=0;
        }
        function saveTariff()
        {
            if(vm.tariff.name=="" || vm.tariff.type=="" || vm.tariff.tenant=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                 var response={
                   message:{
                        name:vm.tariff.name,
                        token:vm.tariff.token,
                        type:vm.tariff.type,
                        period:vm.tariff.period,
                        cost:vm.tariff.cost,
                        vat:vm.tariff.vat,
                   },
                   tenant: vm.tariff.tenant
                };
                $mdDialog.hide(response);
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditSpecificationController', EditSpecificationController);

    function EditSpecificationController($mdDialog,event,Notification,tenants,thisTenant,specification,user,$base64,$http,url)
    {
        var vm = this;
		
        vm.closeDialog = closeDialog;
        vm.specification=angular.copy(specification);
        vm.specification.metadata.priority=parseInt(vm.specification.metadata.priority);
        vm.specification.metadata.specs=JSON.parse(vm.specification.metadata.specs);
        vm.specs=[];
        for(var l=0;l<Object.keys(vm.specification.metadata.specs).length;l++)
        {
            var temp=vm.specs.length;
            var tmp={
                id:vm.specs.length,
                name:Object.keys(vm.specification.metadata.specs)[l],
                friendlyName:vm.specification.metadata.specs[Object.keys(vm.specification.metadata.specs)[l]].friendlyName,
                unit:vm.specification.metadata.specs[Object.keys(vm.specification.metadata.specs)[l]].unit,
                type:vm.specification.metadata.specs[Object.keys(vm.specification.metadata.specs)[l]].type,
                cost:Boolean(vm.specification.metadata.specs[Object.keys(vm.specification.metadata.specs)[l]].cost),
                cumulative:Boolean(vm.specification.metadata.specs[Object.keys(vm.specification.metadata.specs)[l]].cumulative),
                aggregated:Boolean(vm.specification.metadata.specs[Object.keys(vm.specification.metadata.specs)[l]].aggregated),
                metadata:Boolean(vm.specification.metadata.specs[Object.keys(vm.specification.metadata.specs)[l]].metadata),
                expert:Boolean(vm.specification.metadata.specs[Object.keys(vm.specification.metadata.specs)[l]].expert)
            };
            vm.specs.push(tmp); 
        }
        vm.specification.tenant=thisTenant;
        vm.user=user;
        vm.url=url;
        vm.saveSpecification=saveSpecification;
        vm.assetModule=assetModule;
        vm.assetsFunction=assetsFunction;
        vm.tenants=tenants;
        vm.types=
        [
            {
                name:"Electricity",
                type:"electricity"
            },
            {
                name:"Cost",
                type:"cost"
            },
            {
                name:"Water",
                type:"water"
            },
            {
                name:"Gas",
                type:"gas"
            },
            {
                name:"Temperature",
                type:"temperature"
            },
            {
                name:"Humidity",
                type:"humidity"
            },
            {
                name:"Luminance",
                type:"brightness"
            }
        ];
        vm.removeSpec=removeSpec;
        vm.addNewSpec=addNewSpec;
        function removeSpec(id)
        {
            if(vm.specs.length>1)
            {
                vm.specs.splice(id, 1);
                for(var i=0;i<vm.specs.length;i++)
                {
                    vm.specs[i].id=i;
                }
            }
        }
        function addNewSpec()
        {
            var tmp={
                id:vm.specs.length,
                name:"",
                friendlyName:"",
                unit:"",
                type:"",
                cost:false,
                cumulative:false,
                aggregated:false,
                metadata:false,
                expert:false
            };
            vm.specs.push(tmp);
        }
        assetModuleStart(vm.specification.tenant);
        function assetsFunction(id)
        {
             vm.specification.assetId='';
              callRestService(vm.url,"/assets/categories/"+id+"/assets","?page=1&pageSize=2000&tenantAuthToken="+vm.specification.tenant,true,vm.user,"GET").then(function(res){
                vm.assets=res.data.results;
            });     
        }
        function assetModule(id)
        {
            vm.specification.assetModuleId='';
            vm.specification.assetId='';
             callRestService(vm.url,"/assets/categories","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user,"GET").then(function(res){
                vm.assetModules=res.data.results;
            });
        }
        function assetsFunctionStart(id)
        {
              callRestService(vm.url,"/assets/categories/"+id+"/assets","?page=1&pageSize=2000&tenantAuthToken="+vm.specification.tenant,true,vm.user,"GET").then(function(res){
                vm.assets=res.data.results;
            });     
        }
        function assetModuleStart(id)
        {
             callRestService(vm.url,"/assets/categories","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user,"GET").then(function(res){
                vm.assetModules=res.data.results;
                assetsFunctionStart(vm.specification.assetModuleId);
            });
        }
        function saveSpecification()
        {
            if(vm.specification.name=="" || vm.specification.token=="" || vm.specification.containerPolicy=="" || vm.specification.tenant=="" || vm.specification.assetId=="" || vm.specification.assetModuleId=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
               var response={
                   message:{
                        name:vm.specification.name,
                        token:vm.specification.token,
                        containerPolicy:vm.specification.containerPolicy,
                        assetId:vm.specification.assetId,
                        assetModuleId:vm.specification.assetModuleId
                   },
                   tenant: vm.specification.tenant
                };
                $mdDialog.hide(response);
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }

         //Call Rest
        function callRestService(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            }) 
        }	
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditSiteGroupController', EditSiteGroupController);

    function EditSiteGroupController($mdDialog,event,Notification,tenants,deviceGroup,thisTenant,user,users,url,$base64,$http)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.deviceGroup=angular.copy(deviceGroup);
        vm.deviceGroup.tenant=thisTenant;
        vm.saveDeviceGroup=saveDeviceGroup;
        vm.tenants=tenants;
        vm.url=url;
        vm.user=user;
        vm.users=users.results;
        function saveDeviceGroup()
        {
            if(vm.deviceGroup.name=="" || vm.deviceGroup.token=="" || vm.deviceGroup.tenant=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                if(vm.deviceGroup.roles.length>0)
                {
                    for(var i=0;i<vm.tenants.length;i++)
                    {
                        if(vm.tenants[i].authenticationToken===vm.deviceGroup.tenant)
                        {
                            var thisTenant1=vm.tenants[i];
                        }
                    }
                    var flTenant=false;
                    for(var j=0;j<vm.deviceGroup.roles.length;j++)
                    {
                        var fl=0;
                        for(var i=0;i<thisTenant1.authorizedUserIds.length;i++)
                        {
                            if(vm.deviceGroup.roles[j]===thisTenant1.authorizedUserIds[i])
                                fl=1;
                        }
                        if(!fl)
                        {
                            thisTenant1.authorizedUserIds.push(vm.deviceGroup.roles[j]);
                            flTenant=true;
                        }
                           
                    }
                    if(flTenant)
                    {
                        callRestService(vm.url,"/tenants/"+thisTenant1.id,thisTenant1,true,vm.user.authentication,"PUT").then(function(res){});
                    }
                }
                var response={
                    message:{
                            parent:"",
                            type:"site",
                            name:vm.deviceGroup.name,
                            token:vm.deviceGroup.token,
                            description:vm.deviceGroup.description,
                            userId:vm.deviceGroup.userId,
                            elements:vm.deviceGroup.elements,
                            site:""
                    },
                    tenant: vm.deviceGroup.tenant
                    };
                $mdDialog.hide(response);
            }
        }
        function callRestService(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            });
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditSiteController', EditSiteController);

    function EditSiteController($mdDialog,event,Notification,tenants,site,thisTenant,$scope,$http,$base64,user,url,users)
    {
        var vm = this;
        vm.lastSiteName=site.name;
        vm.closeDialog = closeDialog;
        vm.site=angular.copy(site);
        vm.users=users;
        vm.site.metadata.year=parseInt(site.metadata.year);
        vm.site.metadata.workingArea=parseInt(site.metadata.workingArea);
        vm.site.metadata.occupants=parseInt(site.metadata.occupants);
        vm.site.metadata.dimensionsX=parseFloat(site.metadata.dimensionsX);
        vm.site.metadata.dimensionsY=parseFloat(site.metadata.dimensionsY);
        vm.site.metadata.dimensionsZ=parseFloat(site.metadata.dimensionsZ);
        vm.site.metadata.houseNumber=site.metadata.houseNumber;
        vm.site.metadata.postCode=site.metadata.postCode;
        vm.url=url;
        vm.user=user;
        vm.site.tenant=thisTenant;
        vm.site.map.metadata.centerLatitude=parseFloat(vm.site.map.metadata.centerLatitude);
        vm.site.map.metadata.centerLongitude=parseFloat(vm.site.map.metadata.centerLongitude);
        vm.site.map.metadata.zoomLevel=parseFloat(vm.site.map.metadata.zoomLevel);
        vm.buildingTypes={
            Residential:['Detached','Semi-Detached','Terras','Appartment','unknown'],
            Office:['Administration','ICT','Government','Council','Telecoms','Medical','Shopping Centre','Housing Corporation','unknown'],
            Recreation :['Congress Centre','Church','Club House','Cinema','Theatre','Casino','Cafe','Restaurant','Cantine','Nightclub','Training','Museum','Child Care','Exhibition','Library','unknown'],
            Sport:['Swimming Baths','Tennis Hall','Gymnastics','Squash Courts','Sport Hall','Indoor Cycle Track','Fitness Centre','Bowling','Snooker','Shooting','Football Stadium','unknown'],
            Loging:['Hotel','Appartment Hotel','Motel','Bed & Breakfast','Asylum Centre','unknown'],
            Retail:['Local Shop','Indoor Shopping Centre','Super Market','unknown'],
            Education:['Junior School','Secondary School','Collage','University','unknown'],
            Health:['Cure','Care','unknown'],
            Industry:['Asfalt','Perishable Goods','Steel','Coffee','Koelinghouse','Dairy Produce','Meat','Rubber&Plastics','Chemical','Ceramics','unknown'],
            Logistics:['Transport','Storage','Transshipment','unknown'],
            Parking:['Indoor','Outdoor','unknown'],
            unknown:['unknown']
        };
        vm.siteTypes=['Building','Lighting','Parking','Waste'];
        vm.heatingTypes=['Gas','Electricity','Diesel','Geothermal','unknown'];
        vm.aircoTypes=['Electricity','Geothermal','unknown'];
        vm.ventilationTypes=['Electricity','Geothermal','unknown'];
        vm.roofInsulationTypes=['Concrete','Foam','unknown'];
        vm.wallTypes=['With Air Cavity','With Cavity insulation','unknown'];
        vm.floorTypes=['Concrete','Wood','unknown'];
        vm.roofInsulation=['Yes','No'];
        vm.energyLabels=['A++++','A+++','A++','A+','A','B','C','D','E','F','G','unknown'];
        vm.maps=
        [
            {name:"OpenStreet Map",type:"openstreetmap"},
            {name:"MapQuest World Map",type:"mapquest"},
            {name:"GeoServer Layer",type:"gpragmaerver"},
        ];
        vm.map= {
            center: {
                latitude: vm.site.map.metadata.centerLatitude,
                longitude:vm.site.map.metadata.centerLongitude
            },
            markers: [{id: Date.now(),
                coords: {
                            latitude: vm.site.map.metadata.centerLatitude,
                            longitude: vm.site.map.metadata.centerLongitude
                    }}],
            events: {
                click: function (map, eventName, originalEventArgs) {
                    var e = originalEventArgs[0];
                    var lat = e.latLng.lat(),lon = e.latLng.lng();
                    var marker = {
                        id: Date.now(),
                        coords: {
                            latitude: lat,
                            longitude: lon
                        }
                    };
                    vm.site.map.metadata.centerLatitude=marker.coords.latitude;
                    vm.site.map.metadata.centerLongitude=marker.coords.longitude;
                    vm.map.markers[0]=marker;
                    $scope.$apply();
                }
            }
        };
        vm.saveSite=saveSite;
        vm.tenants=tenants;
    
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function saveSite()
        {
            if(vm.site.metadata.houseNumber=="" || typeof vm.site.metadata.houseNumber=="undefined" || vm.site.metadata.postCode=="" || typeof vm.site.metadata.postCode=="undefined" || vm.site.name=="" || vm.site.token=="" || vm.site.map.type=="" || vm.site.tenant=="" || vm.site.map.metadata.centerLatitude=="" || vm.site.map.metadata.centerLongitude=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                callRestService(vm.url,"/assets/categories","?page=1&pageSize=1000&tenantAuthToken="+thisTenant,true,vm.user.authentication,"GET").then(function(res){
                    vm.assets=res.data.results;
                    for(var i=0;i<vm.assets.length;i++)
                    {
                        if(vm.assets[i].id===vm.site.token)
                        {
                             var asset={
                                name:vm.site.name,
                                id:vm.assets[i].id,
                                assetType:"Location"
                            };
                            callRestService(vm.url,"/assets/categories/"+asset.id+"/assets","?page=1&pageSize=1000&tenantAuthToken="+thisTenant,true,vm.user.authentication,"GET").then(function(res){
                                vm.assetsDevices=res.data.results;
                                for(var i=0;i<vm.assetsDevices.length;i++)
                                {
                                    if(vm.assetsDevices[i].id===vm.site.token)
                                    {
                                        var assetDevice={
                                            name:vm.site.name+" Building",
                                            id:vm.assetsDevices[i].id,
                                            imageUrl:'https://hydra.iti.gr/assets/location.png',
                                            latitude:vm.assetsDevices[i].latitude,
                                            longitude:vm.assetsDevices[i].longitude,
                                            elevation:vm.assetsDevices[i].elevation
                                        };
                                        callRestService(vm.url,"/assets/categories/"+asset.id+"/locations/"+assetDevice.id+"?tenantAuthToken="+thisTenant,assetDevice,true,vm.user.authentication,"PUT").then(function(res){
                                            callRestService(vm.url,"/assets/categories/"+asset.id+"?tenantAuthToken="+thisTenant,asset,true,vm.user.authentication,"PUT").then(function(res){
                                            });
                                        });
                                    }
                                }
                             });
                        }
                    }
                 });
                var response={
                    message:{
                        name:vm.site.name,
                        token:vm.site.token,
                        description:vm.site.description,
                        imageUrl:vm.site.imageUrl,
                        authorizedUserIds:vm.site.authorizedUserIds,
                        map:{
                            type:vm.site.map.type,
                            metadata:{
                                zoomLevel:vm.site.map.metadata.zoomLevel,
                                centerLatitude:vm.site.map.metadata.centerLatitude,
                                centerLongitude:vm.site.map.metadata.centerLongitude
                            }
                        },
                        metadata:vm.site.metadata
                    },
                    tenant: vm.site.tenant
                };
                for(var i=0;i<vm.tenants.length;i++)
                {
                    if(vm.tenants[i].authenticationToken===vm.site.tenant)
                    {
                        vm.tenant=vm.tenants[i];
                    }
                }
               var tTenant={
                    id:vm.tenant.id,
                    name:vm.tenant.name,
                    logoUrl:vm.tenant.logoUrl,
                    authenticationToken:vm.tenant.authenticationToken,
                    authorizedUserIds:vm.tenant.authorizedUserIds,
                    metadata:vm.tenant.metadata
                };
                var fl=0;
                var flTenant=false;
                for(var j=0;j<response.message.authorizedUserIds.length;j++)
                {
                    fl=0;
                    for(var i=0;i<tTenant.authorizedUserIds.length;i++)
                    {
                        if(tTenant.authorizedUserIds[i]===response.message.authorizedUserIds[j])
                            fl=1;
                    }
                    if(!fl)
                    {
                        tTenant.authorizedUserIds.push(response.message.authorizedUserIds[j]);
                        flTenant=true;
                    }
                        
                }
                if(flTenant)
                {
                    callRestService(vm.url,"/tenants/"+tTenant.id,tTenant,true,vm.user.authentication,"PUT").then(function(res){});
                }
                $mdDialog.hide(response);
            }
        }
        //Call Rest
        function callRestService(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            });
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditNotificationController', EditNotificationController);

    function EditNotificationController($mdDialog,event, pragmaapi, Notification,user,notification,url)
    {
        var vm = this;
        vm.notification=notification;
        vm.user=user;
        vm.closeDialog = closeDialog;
        vm.notificationsPeriod=
        [
            {
                name:"Fixed Time",
                type:"custom"
            },
            {
                name:"Interval Time",
                type:"interval"
            }
        ]
        vm.notification={
            //typePeriod: vm.notification.typePeriod,
            tenant: vm.notification.tenant,
            assignment:vm.notification.assignment,
            measurement:vm.notification.measurement,
            type: vm.notification.type
        }
        
        vm.notification.name=notification.title;
        if (notification.fixedTime == '') 
            {
                vm.time={
                    value: new Date(1970, 0, 1, 12, 0, 0)
                };
            }
        else
            {
                var time = notification.fixedTime.split(':');
                vm.time={
                    value: new Date(1970, 0, 1, parseInt(time[0], 10), parseInt(time[1], 10), parseInt(time[2], 10))
                };
            }

        if (notification.interval === 0) vm.notification.typePeriod = vm.notificationsPeriod[0];
        else vm.notification.typePeriod = vm.notificationsPeriod[1];
        vm.group1=notification.arguments.type;
        

        

        
        vm.intervalNum=notification.interval;
        vm.activeNotification=notification.active;

        vm.checkboxes =
        [{
            name: "Median Based Prediction",
            value: "MBP"
        },
        {
            name: "Regression Based Prediction",
            value: "RBP"
        }]
        vm.notifications=
        [
            {
                name:"Custom Timer",
                type:"custom"
            },
            {
                name:"Device Interval",
                type:"interval"
            }
        ]
        vm.periods=
        [
            {
                name:"Seconds",
                type:"s"
            },
            {
                name:"Minutes",
                type:"m"
            },
            {
                name:"Hours",
                type:"h"
            },
            {
                name:"Days",
                type:"d"
            }
        ];
        vm.notificationTypes=
        [
            {
                name:"Prediction",
                type:"Prediction"
            },
            {
                name:"Degradation",
                type:"Degradation"
            }
        ];
        vm.url=url;
        vm.saveNotification=saveNotification;
        vm.gateways=['Raspberry','Ealyze','Open Weather'];
        vm.widget={};
        vm.widget.clients = [];
        initTree();
        function initTree()
        {
            pragmaapi.getTreeData(true, true,true,true).then(function(treeData) {
                vm.treeData = treeData;
                vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow']);
                vm.versionNo++;
                vm.treeConfig.version = vm.versionNo;
                startTree();
            });
        }

        function startTree()
        { 
            for(var k=0;k<vm.treeData.length;k++)
                {
                    if ((vm.notification.assignment == vm.treeData[k].token) && (vm.notification.measurement == vm.treeData[k].measure))
                        {

                            vm.treeInstance.jstree(true).select_node(vm.treeData[k].id); 
                        }
                }
        
        }

        vm.treeEvents = 
        {
            'ready': readyCB,
            'create_node': createNodeCB,
            'select_node': getSelectedNodes,
            'deselect_node': getSelectedNodes
        }

        function createNodeCB() {}
        vm.applySearch = function (){
            if(vm.treeInstance) {
            vm.treeInstance.jstree(true).search(vm.searchtree);
            }
        };

        function readyCB() {
            
        }

        function getSelectedNodes()
        {
            var tenantTokens=[];
            var clientsTemp=[];
            vm.selected_nodes=[];
            var measurementsTemp=[];
            vm.selectedNode = {};
            var jstree = vm.treeInstance.jstree(true);
            vm.selected_nodes = jstree.get_selected();
            if (vm.selected_nodes[0]) {
                vm.selectedNode = jstree.get_node(vm.selected_nodes[0]);
            }
            for(var i=0;i<vm.selected_nodes.length;i++)
            {
                if(vm.selected_nodes[i].includes("measurement"))
                    measurementsTemp.push(vm.selected_nodes[i]);
            }
            for(var i=0;i<vm.treeData.length;i++)
            {
                for(var j=0;j<measurementsTemp.length;j++)
                {
                    if(vm.treeData[i].id===measurementsTemp[j])
                    {
                        var fl=0;
                        for(var k=0;k<vm.treeData.length;k++)
                        {
                            if(vm.treeData[k].type==="site" && vm.treeData[k].text===vm.treeData[i].site)
                                var tSiteToken=vm.treeData[k].token;
                                
                        }
                        for(var l=0;l<tenantTokens.length;l++)
                        {
                            if(tenantTokens[l]===vm.treeData[i].tenantAuthToken)
                            {
                                fl=1;
                            }
                        }
                        if(!fl)
                        {
                            tenantTokens.push(vm.treeData[i].tenantAuthToken)
                            var tempCl=
                            {
                                token:vm.treeData[i].tenantAuthToken,
                                sites:[]
                            };
                            var tempSi=
                            {
                                token:tSiteToken,
                                name:vm.treeData[i].site,
                                assignments:[]
                            };
                            var tempAssignments=
                            {
                                token:vm.treeData[i].token,
                                measurements:[vm.treeData[i].measure]
                            };
                            tempSi.assignments.push(tempAssignments);
                            tempCl.sites.push(tempSi)
                            clientsTemp.push(tempCl);
                        }
                        else
                        {
                            for(var l=0;l<clientsTemp.length;l++)
                            {
                                if(clientsTemp[l].token===vm.treeData[i].tenantAuthToken)
                                {
                                    var thisCl=l;
                                }
                            }
                            for(var k=0;k<vm.treeData.length;k++)
                            {
                                if(vm.treeData[k].type==="site" && vm.treeData[k].text===vm.treeData[i].site)
                                    var tSiteToken=vm.treeData[k].token;
                            }
                            var flS=0;
                            for(var l=0;l<clientsTemp[thisCl].sites.length;l++)
                            {
                                if(clientsTemp[thisCl].sites[l].token===tSiteToken)
                                {
                                    flS=1;
                                    var thisS=l;
                                }
                            }
                            if(!flS)
                            {
                                var tempSi=
                                {
                                    token:tSiteToken,
                                    name:vm.treeData[i].site,
                                    assignments:[]
                                };
                                var tempAssignments=
                                {
                                    token:vm.treeData[i].token,
                                    measurements:[vm.treeData[i].measure]
                                };
                                tempSi.assignments.push(tempAssignments);
                                clientsTemp[thisCl].sites.push(tempSi);
                            }
                            else
                            {
                                var flA=0;
                                for(var l=0;l<clientsTemp[thisCl].sites[thisS].assignments.length;l++)
                                { 
                                    if(clientsTemp[thisCl].sites[thisS].assignments[l].token===vm.treeData[i].token)
                                    {
                                        flA=1;
                                        var thisA=l;
                                    }
                                }
                                if(!flA)
                                {
                                    var tempAssignments=
                                    {
                                        token:vm.treeData[i].token,
                                        measurements:[vm.treeData[i].measure]
                                    };
                                    clientsTemp[thisCl].sites[thisS].assignments.push(tempAssignments);
                                }
                                else
                                {
                                    clientsTemp[thisCl].sites[thisS].assignments[thisA].measurements.push(vm.treeData[i].measure);
                                }
                            }
                        }
                    }
                }
            }
            vm.widget.clients=clientsTemp;
            vm.notification.tenant = vm.widget.clients[0].token;
            vm.notification.assignment = vm.widget.clients[0].sites[0].assignments[0].token;
            vm.notification.measurement = vm.widget.clients[0].sites[0].assignments[0].measurements[0];
            
        }

        function saveNotification()
        {
            var time;
            var h;
            var m;
            var s;
            if (vm.time.value.getHours() < 10) h="0"+vm.time.value.getHours().toString(); else h=vm.time.value.getHours().toString();
            if (vm.time.value.getMinutes() < 10) m="0"+vm.time.value.getMinutes().toString(); else m=vm.time.value.getMinutes().toString();
            if (vm.time.value.getSeconds() < 10) s="0"+vm.time.value.getSeconds().toString(); else s=vm.time.value.getSeconds().toString();
            time=h+":"+m+":"+s;
            


            if(vm.notification.name=="" || vm.notification.type==undefined || vm.notification.typePeriod==undefined || vm.notification.tenant=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                pragmaapi.callRestService(vm.url, "/tenants/authtoken/",vm.notification.tenant , true, vm.user.authentication, "GET", true, false).then(function(res){
                    if (vm.notification.type==vm.notificationTypes[1]) vm.group1='';
                    if (vm.notification.typePeriod.type == "custom") vm.intervalNum = 0;
                    if (vm.notification.typePeriod.type == "interval") time = "";
                    var response={
                        message:{
                            token: notification.token,
                            title: vm.notification.name,
                            type: vm.notification.type,
                            userId: vm.user.username,
                            tenant: vm.notification.tenant,
                            active: vm.activeNotification,
                            interval: vm.intervalNum,
                            lastTriggered: 1506160747568,
                            arguments: {
                                type:vm.group1,
                                database:  res.data.id,
                                assignment: vm.notification.assignment,
                                measurement: vm.notification.measurement
                            },
                            fixedTime: time,
                            
                        }
                    };
                    
                    pragmaapi.callRestService(vm.url, "/batchNotifications/"+notification.token, response.message, true, vm.user.authentication, "PUT", true, false).then(function(res){
                        $mdDialog.hide(true);
                    });
                });
                
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditDeviceController', EditDeviceController);

    function EditDeviceController($mdDialog,event,Notification,tenants,$http,$base64,user,device,url,thisTenant,PRAGMA,pragmaapi)
    {
        var vm = this;
        vm.user=user;
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.solutions=[];
        vm.closeDialog = closeDialog;
        vm.tenants=tenants;
        vm.device=angular.copy(device);
        vm.device={
            hardwareId: angular.copy(device.hardwareId),
            siteToken: angular.copy(device.siteToken),
            specificationToken: angular.copy(device.specification.token),
            comments: angular.copy(device.comments),
            tenant:thisTenant,
            modules:angular.copy(device.modules),
            metadata:angular.copy(device.metadata)
        }
        vm.notificationTime=parseInt(vm.device.metadata.notificationTime);
        vm.device.metadata.notification=(vm.device.metadata.notification==='true');
        vm.notifications=
        [
            {
                name:"Custom Timer",
                type:"custom"
            },
            {
                name:"Device Interval",
                type:"interval"
            }
        ]
        vm.specifications={};
        vm.sites={};
        vm.deviceTypes=[
            'Central Panel',
            'Lighting',
            'Cooling',
            'Heating',
            'Refrigeration',
            'Ventilation',
            'Water Heating',
            'Plug Loads',
            'Cooking',
            'EV Charging',
            'Hvac',
            'Renewable Energy Resources',
            'Other'
        ];
        vm.fillSitesAndSpecifications=fillSitesAndSpecifications;
        vm.url=url;
        vm.saveDevice=saveDevice;
        fillSitesAndSpecifications(thisTenant);
        function fillSitesAndSpecifications(id)
        {
            callRestService(vm.url,"/sites","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.sites=res.data.results;
            });
            callRestService(vm.url,"/specifications","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.specifications=res.data.results;
             });
            if(vm.user.hasVerticals)
            {
                pragmaapi.callRestService(PRAGMA.api, "/verticalSolutions/tenant/", id, true, vm.user.authentication, "GET", true, false).then(function(res) {
                    vm.solutions=[];
                    var modules=res.data.results;
                    for(var i=0;i<modules.length;i++)
                    {
                        if(modules[i].parent!=="#")
                        {
                            for(var k=0;k<vm.user.modules.length;k++)
                            {
                                if(vm.user.modules[k]===modules[i].token)
                                {
                                    vm.solutions.push(modules[i]);
                                    break;
                                }
                            }
                        }
                    }
                });
            }
        }
        function saveDevice()
        {
            vm.device.metadata.notification=vm.device.metadata.notification.toString();
            vm.device.metadata.notificationTime=vm.notificationTime.toString();
            if(vm.device.hardwareId=="" || vm.device.siteToken=="" || vm.device.specificationToken=="" || vm.device.tenant=="" || vm.device.metadata.type==""|| vm.device.metadata.name=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                var response={
                    hardwareId: vm.device.hardwareId,
                    siteToken: vm.device.siteToken,
                    specificationToken: vm.device.specificationToken,
                    comments: vm.device.comments,
                    metadata:vm.device.metadata,
                    modules:vm.device.modules
                };
                $mdDialog.hide(response);
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
         //Call Rest
        function callRestService(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            }) 
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditDeviceGroupController', EditDeviceGroupController);

    function EditDeviceGroupController($mdDialog,event,Notification,tenants,deviceGroup,$http,$base64,user,url,thisTenant)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.deviceGroup=angular.copy(deviceGroup);
        vm.deviceGroup.tenant=thisTenant;
        vm.deviceGroup.site=deviceGroup.site;
        vm.saveDeviceGroup=saveDeviceGroup;
        vm.tenants=tenants;
        vm.url=url;
        vm.user=user;
        vm.tenants=tenants;
        vm.fillSites=fillSites;
        fillSites(thisTenant,'start');
        function fillSites(id,type)
        {
            vm.deviceGroup.siteToken='';
            callRestService(vm.url,"/sites","?page=1&pageSize=1000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.sites=res.data.results;
                if(type==='start')
                {
                    vm.deviceGroup.site=deviceGroup.site;
                }
                else
                {
                    vm.deviceGroup.site=vm.sites[0].token;
                }
            });
        }
        function saveDeviceGroup()
        {
            if(vm.deviceGroup.name=="" ||  vm.deviceGroup.tenant=="" ||  vm.deviceGroup.site=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                var response={
                    message:{
                        parent:vm.deviceGroup.parent,
                        type:"device",
                        name:vm.deviceGroup.name,
                        token:vm.deviceGroup.token,
                        description:vm.deviceGroup.description,
                        userId:vm.deviceGroup.userId,
                        elements:vm.deviceGroup.elements,
                        site:vm.deviceGroup.site
                    },
                    tenant: vm.deviceGroup.tenant
                };
                $mdDialog.hide(response);
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
         //Call Rest
        function callRestService(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            }) 
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditCostProfileController', EditCostProfileController);

    function EditCostProfileController($mdDialog,event,Notification,costProfile,tenants,thisTenant,user,costs,sites)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.costProfile=angular.copy(costProfile);
        vm.costProfile.tenant=thisTenant;
        vm.user=user;
        vm.saveCostProfile=saveCostProfile;
        vm.tenants=tenants;
        vm.sites=sites.results;
        vm.costs=costs.results;
        vm.measureTypes=[ 
            {name:"Electricity",type:"electricity"},
            {name:"Gas",type:"gas"},
            {name:"Water",type:"water"},
            {name:"Aluminium",type:"recycle_aluminium"},
            {name:"Glass",type:"recycle_glass"},
            {name:"Paper",type:"recycle_paper"},
            {name:"Plastic",type:"recycle_plastic"}];
        vm.costProfile.startDate=new Date(vm.costProfile.startDate);
        function saveCostProfile()
        {
            if(vm.costProfile.name=="" || vm.costProfile.token=="" || vm.costProfile.tenant=="" || vm.costProfile.measure=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {  
                if (vm.costProfile.startDate) {
                    var dDate = moment(vm.costProfile.startDate).format('YYYY-MM-DDTHH:mm:ss.000ZZ');
                }
                else {
                    var dDate = "1900-01-01T00:00:00.000+0000";
                }
                var response={
                    message:{
                        name:vm.costProfile.name,
                        token:vm.costProfile.token,
                        measure:vm.costProfile.measure,
                        startDate:dDate,
                        siteIds:vm.costProfile.siteIds
                    },
                    tenant: vm.costProfile.tenant
                };
               $mdDialog.hide(response);
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditCostController', EditCostController);

    function EditCostController($mdDialog, event, user, Notification, thisTenant, thisCostProfile, cost)
    {
        var vm = this;
        
        // User
        vm.user = user;
        
        // Tenant
        var tenant = thisTenant;
        
        // Selects
        vm.tariffTypes = [
            {name: "Per Unit", type:"unit"},
            {name: "Fixed", type:"fixed"},
            {name: "Reward", type:"return"},
            {name: "Formula", type:"formula"}
        ];
        
        vm.tariffPeriods = [
            {name: "Day", type: "1"},
            {name: "Month", type: "30"},
            {name: "2 Months", type: "60"},
            {name: "Quarter", type: "120"},
            {name: "Half Year", type: "180"},
            {name: "Year", type: "365"}
        ];
        
        vm.formulaTypes = [
            {name: "Cost", type: "cost"},
            {name: "Benefit", type: "benefit"}
        ];
        
        // New object
        vm.cost = angular.copy(cost);
        var hotTable = [];
        vm.scheduleTariffs = [];
        
        // Schedule
        vm.schedule = false;
        //if (vm.cost.schedule) {
		if (vm.cost.schedule.length !== 0) { //Object not empty
            vm.schedule = true;
            vm.scheduleTariffs = vm.cost.tariffs;
            hotTable = vm.cost.schedule;
        }
        else {
            hotTable = fillHotTable(24, 7, 1);
        }
        
        vm.hotTableSettings = {
            data: hotTable,
            columns: getColummnHeaders(), colWidths: 35, height: 206,
            rowHeaders: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            autoColumnSize: false, autoRowSize: false, allowEmpty: false, colHeaders: true,
            maxRows:hotTable.length, maxCols:hotTable[0].length, minRows:hotTable.length, minCols:hotTable[0].length,
            afterRender: afterRender
        }
        
        function fillHotTable(columns, rows, tariff) {
            var data = [];
            for (var i = 0; i < rows; i++) {
                data[i] = [];
                for (var j = 0; j < columns; j++) {
                    data[i][j] = 'T' + tariff;
                }
            }
            return data;
        }
        
        function getColummnHeaders() {
            var columns = [];
            for (var i = 0; i < 24; i++) {
                columns.push({title: ("00" + i).substr(-2, 2) + ':00'});
            }
            return columns;
        }
        
        var emptyNotified = false;
        function afterRender(isForced) {
            if (!isForced) return;
            if (!emptyNotified && !hotTableComplete()) {
                Notification.warning({
                     message: 'Empty values are not allowed...',
                     delay: 3000,
                     positionX: "right",
                     positionY: "bottom"
                });
                emptyNotified = true;
            }
            // Add new tariffs
            for (var i = 0; i < hotTable.length; i++) {
                for (var j = 0; j < hotTable[i].length; j++) {
                    if (hotTable[i][j] != "") {
                        if (!inTariffs(hotTable[i][j])) {
                            vm.scheduleTariffs.push({name: hotTable[i][j], cost: "", period: "", vat: ""});
                        }
                    }
                }
            }
            
            // Remove not used tariffs
            for (var i = 0; i < vm.scheduleTariffs.length; i++) {
                if (!inHotTable(vm.scheduleTariffs[i].name)) {
                    vm.scheduleTariffs.splice(i, 1);
                }
            }
            
        }
        
        function hotTableComplete() {
            for (var i = 0; i < hotTable.length; i++) {
                for (var j = 0; j < hotTable[i].length; j++) {
                    if (hotTable[i][j] == "") {
                        return false;
                    }
                }
            }
            return true;
        }
        
        function scheduleComplete() {
            if (hotTableComplete()) {
                for (var i = 0; i < vm.scheduleTariffs.length; i++) {
                    if (vm.scheduleTariffs[i].cost == "") {
                        return false;
                    }
                }
            }
            else {
                return false;
            }
            return true;
        }
        
        function inTariffs(needle) {
            for (var i = 0; i < vm.scheduleTariffs.length; i++) {
                if (vm.scheduleTariffs[i].name == needle) {
                    return true;
                }
            }
            return false;
        }
        
        function inHotTable(needle) {
            for (var i = 0; i < hotTable.length; i++) {
                for (var j = 0; j < hotTable[i].length; j++) {
                    if (hotTable[i][j] == needle) {
                        return true;
                    }
                }
            }
            return false;
        }
        
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };

        ////////
        
        vm.getLabel = getLabel;
        vm.resetType = resetType;
        vm.saveCost = saveCost;
        vm.closeDialog = closeDialog;
        
        function getLabel(type) {
            var label = "Cost";
            for (var i = 0; i < vm.tariffTypes.length; i++) {
                if (vm.tariffTypes[i].type == type) {
                    if (type == 'formula') {
                        label = vm.tariffTypes[i].name;
                    }
                    else if (type == 'return') {
                        label = vm.tariffTypes[i].name + " benefit";
                    }
                    else {
                        label = vm.tariffTypes[i].name + " cost"; 
                    }
                    break;
                }
            };
            return label;
        }
        
        function resetType() {
          if (vm.cost.type != 'unit') vm.schedule = false;
        }
        
        function saveCost()
        {
            if (
                (vm.cost.type == "" || vm.cost.token == "" || vm.cost.tenant == "") ||
                (vm.schedule && !scheduleComplete()) || 
                (!vm.schedule && vm.cost.type == "unit" && (vm.cost.tariffs[0].cost == "")) ||
                (!vm.schedule && vm.cost.type != "unit" && (vm.cost.tariffs[0].cost == "" || vm.cost.tariffs[0].period == ""))
            ) {
                   Notification.warning({
                       message: 'Please fill all required fields!',
                       delay: 3000,
                       positionX: "right",
                       positionY: "bottom"
                    });
            }
            else {
                if (vm.schedule) {
                    var response = {
                        message: {
                            token: vm.cost.token,
                            name: vm.cost.name,
                            type: vm.cost.type,
                            profileToken: [thisCostProfile.token], 
                            id: vm.cost.id, 
                            schedule: hotTable,
                            inTotal: vm.cost.inTotal,
                            tariffs: vm.scheduleTariffs
                        },
                        tenant: tenant
                    };
                }
                else {
                    var response = {
                        message: {
                            token: vm.cost.token,
                            name: vm.cost.name,
                            type: vm.cost.type,
                            profileToken: [thisCostProfile.token], 
                            id: vm.cost.id, 
                            inTotal: vm.cost.inTotal,
                            tariffs: vm.cost.tariffs
                        },
                        tenant: tenant
                    };
                }
                $mdDialog.hide(response);
            }
        }

        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditAssetCategoryController', EditAssetCategoryController);

    function EditAssetCategoryController($mdDialog,event,Notification,assetCategory,type)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.type=type;
        vm.assetCategory=angular.copy(assetCategory);
        vm.saveAssetCategory=saveAssetCategory;
        function saveAssetCategory()
        {
            if((vm.assetCategory.name=="" || vm.assetCategory.id=="") || ((vm.type=="Device"||vm.type=="Hardware") && (vm.assetCategory.sku=="")) || ((vm.type=="Location") && (vm.assetCategory.latitude=="" || vm.assetCategory.longitude=="" ||vm.assetCategory.elevation==="")) || ((vm.type=="Person") && (vm.assetCategory.userName=="" || vm.assetCategory.emailAddress=="")))
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else if(vm.type=="Person" && !validateEmail(vm.assetCategory.emailAddress))
            {
                 Notification.warning({
                       message: "Please Fill in the user's email in correct form!",
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                });
            }
            else
            {
                var response=vm.assetCategory;
                $mdDialog.hide(response);
            }
        }
        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('EditAssetController', EditAssetController);

    function EditAssetController($mdDialog,event,Notification,asset)
    {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.asset=angular.copy(asset);
        vm.assetTypes=['Device','HardWare','Location','Person'];
        vm.saveAsset=saveAsset;
        function saveAsset()
        {
            if(vm.asset.name=="" || vm.asset.id=="" || vm.asset.assetType=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                var response=vm.asset;
                $mdDialog.hide(response);
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteVerticalController', DeleteVerticalController);

    function DeleteVerticalController($mdDialog,event,vertical)
    {
        var vm = this;
        vm.vertical=vertical;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            $mdDialog.hide(vm.vertical.token);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteUserController', DeleteUserController);

    function DeleteUserController($mdDialog,event,user)
    {
        var vm = this;
        vm.user=user;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            $mdDialog.hide(vm.user.username);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteTenantController', DeleteTenantController);

    function DeleteTenantController($mdDialog,event,tenant)
    {
        var vm = this;
        vm.tenant=tenant;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            $mdDialog.hide(vm.tenant);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteTariffController', DeleteTariffController);

    function DeleteTariffController($mdDialog,event,tariff)
    {
        var vm = this;
        vm.tariff=tariff;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            $mdDialog.hide(vm.tariff.token);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteSpecificationController', DeleteSpecificationController);

    function DeleteSpecificationController($mdDialog,event,specification)
    {
        var vm = this;
        vm.specification=specification;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            $mdDialog.hide(vm.specification.token);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteSiteGroupSiteController', DeleteSiteGroupSiteController);

    function DeleteSiteGroupSiteController($mdDialog,event,thisGroup,thisTenant,site,sites)
    {
        var vm = this;
        vm.sites=sites;
        for(var i=0;i<vm.sites.results.length;i++)
        {
            if(vm.sites.results[i].token===site.token)
            {
                vm.currentSite=vm.sites.results[i].name;
            }
        }
        vm.thisGroup=thisGroup;
        vm.thisTenant=thisTenant;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;
        function confirmDialog()
        {
            var index=-1;
            for(var i=0;i<vm.thisGroup.elements.length;i++)
            {
                if(vm.thisGroup.elements[i].token===site.token)
                {
                    index=i;
                }
            }
            if (index > -1) {
                vm.thisGroup.elements.splice(index, 1);
            }
            var response={
                tenant:vm.thisTenant,
                message:{
                    token:vm.thisGroup.token,
                    name:vm.thisGroup.name,
                    site:"",
                    description:vm.thisGroup.description,
                    userId:vm.thisGroup.userId,
                    parent:"",
                    type:"site",
                    elements:vm.thisGroup.elements
                }
            };
            $mdDialog.hide(response);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteSiteGroupController', DeleteSiteGroupController);

    function DeleteSiteGroupController($mdDialog,event,deviceGroup)
    {
        var vm = this;
        vm.deviceGroup=deviceGroup;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            $mdDialog.hide(vm.deviceGroup.token);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteSiteController', DeleteSiteController);

    function DeleteSiteController($mdDialog,event,site)
    {
        var vm = this;
        vm.site=site;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            $mdDialog.hide(vm.site.token);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteNotificationController', DeleteNotificationController);

    function DeleteNotificationController($mdDialog,event,notification)
    {
        var vm = this;
        vm.notification=notification;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            var response=
            {
                type:vm.notification.notificationService,
                message:vm.notification.token
            }
            $mdDialog.hide(response);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteDeviceGroupDeviceController', DeleteDeviceGroupDeviceController);

    function DeleteDeviceGroupDeviceController($mdDialog,event,device,thisGroup,thisTenant,groups,user,url,$http,$base64)
    {
        var vm = this;
        vm.device=device;
        vm.groups=groups;
        vm.thisGroup=thisGroup;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            var index=-1;
            for(var i=0;i<vm.thisGroup.elements.length;i++)
            {
                if(vm.thisGroup.elements[i].token===vm.device.token)
                {
                    index=i;
                }
            }
            if (index > -1) {
                if(vm.device.type==='group')
                {
                    var fl=false;
                    for(var j=0;j<vm.groups.length;j++)
                    {
                        var foo=vm.groups[j];
                        if(foo.token!==vm.thisGroup.token)
                        {
                            for(var k=0;k<foo.elements.length;k++)
                            {
                                if(foo.elements[k].type==="group" && foo.elements[k].token===vm.device.token)
                                {
                                    fl=true;
                                }
                            }
                        }
                    }
                    if(!fl)
                    {
                        for(var i=0;i<vm.groups.length;i++)
                        {
                            if(vm.groups[i].token===vm.device.token)
                            {
                                var toSend=
                                {
                                    token:vm.groups[i].token,
                                    name:vm.groups[i].name,
                                    site:vm.groups[i].site,
                                    description:vm.groups[i].description,
                                    userId:vm.groups[i].userId,
                                    parent:"",
                                    type:vm.groups[i].type,
                                    elements:vm.groups[i].elements
                                };
                                callRestService2(url,"/groups/"+toSend.token+"?tenantAuthToken="+thisTenant,toSend,true,user.authentication,"PUT").then(function(res){});
                            }
                        }
                    }
                }
                vm.thisGroup.elements.splice(index, 1);
            }
            var response={
                tenant:thisTenant,
                message:{
                    token:vm.thisGroup.token,
                    name:vm.thisGroup.name,
                    site:vm.thisGroup.site,
                    description:vm.thisGroup.description,
                    userId:vm.thisGroup.userId,
                    parent:vm.thisGroup.parent,
                    type:"device",
                    elements:vm.thisGroup.elements
                }
            };
            $mdDialog.hide(response);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }

        function callRestService2(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT" || method==="DELETE")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            }); 
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteDeviceGroupController', DeleteDeviceGroupController);

    function DeleteDeviceGroupController($mdDialog,event,deviceGroup)
    {
        var vm = this;
        vm.deviceGroup=deviceGroup;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            $mdDialog.hide(vm.deviceGroup.token);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteCostProfileController', DeleteCostProfileController);

    function DeleteCostProfileController($mdDialog,event,costProfile)
    {
        var vm = this;
        vm.costProfile=costProfile;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            $mdDialog.hide(vm.costProfile.token);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteDeviceController', DeleteDeviceController);

    function DeleteDeviceController($mdDialog,event,device)
    {
        var vm = this;
        vm.device=device;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            $mdDialog.hide(vm.device.hardwareId);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteCostController', DeleteCostController);

    function DeleteCostController($mdDialog,event,cost)
    {
        var vm = this;
        vm.cost=cost;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            $mdDialog.hide(vm.cost.token);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteAssetCategoryController', DeleteAssetCategoryController);

    function DeleteAssetCategoryController($mdDialog,event,assetCategory,type)
    {
        var vm = this;
        vm.assetCategory=assetCategory;
        vm.type=type;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;
        function confirmDialog()
        {
            $mdDialog.hide(vm.assetCategory.id);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('DeleteAssetController', DeleteAssetController);

    function DeleteAssetController($mdDialog,event,asset)
    {
        var vm = this;
        vm.asset=asset;
        vm.closeDialog = closeDialog;
        vm.confirmDialog=confirmDialog;

        function confirmDialog()
        {
            $mdDialog.hide(vm.asset.id);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('AssignDeviceController', AssignDeviceController);

    function AssignDeviceController($mdDialog,event,Notification,thisTenant,user,$base64,$http,device,url)
    {

        var vm = this;
        vm.closeDialog = closeDialog;
        vm.device=device;
        vm.assignment={
            deviceHardwareId:vm.device.hardwareId,
            assignmentType:"Associated",
            assetModuleId:"",
            assetId:""
        }
        vm.user=user;
        vm.url=url;
        vm.saveAsset=saveAsset;
        vm.assetModule=assetModule;
        vm.assetsFunction=assetsFunction;
        vm.thisTenant=thisTenant;
        assetModule(vm.thisTenant);
        function assetsFunction(id)
        {
            vm.assignment.assetId="";
            callRestService(vm.url,"/assets/categories/"+id+"/assets","?page=1&pageSize=2000&tenantAuthToken="+vm.thisTenant,true,vm.user,"GET").then(function(res){
                vm.assets=res.data.results;
            });     
        }
        function assetModule(id)
        {
            vm.assignment.assetModuleId="";
            vm.assignment.assetId="";
            callRestService(vm.url,"/assets/categories","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user,"GET").then(function(res){
                vm.assetModules=res.data.results;
            });
        }
        function saveAsset()
        {
            if(vm.assignment.deviceHardwareId=="" || vm.assignment.assignmentType=="" || vm.assignment.assetModuleId=="" || vm.assignment.assetId=="")
            {
                   Notification.warning({
                       message: 'Please Fill in all the required fields!',
                       delay: 3000,
                       positionX:"right",
                       positionY:"bottom"
                    });
            }
            else
            {
                var response=vm.assignment;
                $mdDialog.hide(response);
            }
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }

         //Call Rest
        function callRestService(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            }) 
        }	
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('OvenOptionsController', OvenOptionsController);

    function OvenOptionsController($mdDialog,event,program, duration, temp)
    {
        var vm = this;
        vm.program=program;
        vm.closeDialog = closeDialog;
        vm.applyOptions=applyOptions;
        vm.checkSecs=checkSecs;
		//vm.program.key = key;
		var key = vm.program.key;
		vm.program.hours = 0;
		//default duration always 1 min
		vm.program.mins = duration;
		vm.program.secs = 0;
		vm.program.temp = temp;
		vm.isDisabled = false;
		vm.isMax = 0;
		
		if(key === 'HotAir' || key === 'PizzaSetting') {
			vm.isMax = 275;
		}
        else {
			vm.isMax = 300;
		}
		
		function checkSecs(H, M)
        {
            if(H === 23 && M === 59) {
				vm.program.secs = 0;
				vm.isDisabled = true;
			}
			else {
				vm.isDisabled = false;
			}
        }
        function applyOptions()
        {
                var response=vm.program;
                $mdDialog.hide(response);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('OvenInfoController', OvenInfoController);

    function OvenInfoController($mdDialog,event,program)
    {
        var vm = this;
        vm.program=program;
        vm.closeDialog = closeDialog;
		console.log(vm.program);
		
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('LaundryOptionsController', LaundryOptionsController);

    function LaundryOptionsController($mdDialog,event,temp,speed,program)
    {
        var vm = this;
        vm.program=program;
        vm.closeDialog = closeDialog;
        vm.applyOptions=applyOptions;
		//vm.program.key = key;
		vm.program.temperature = temp;
		vm.program.rpm = speed;
		vm.temperature = {
			'Cotton' : {
						1:0,
						2:20,
						3:30,
						4:40,
						5:50,
						6:60,
						7:70,
						8:80,
						9:90
					  },
			'EasyCare' : {
						1:0,
						2:20,
						3:30,
						4:40,
						5:50,
						6:60
					  },
			'Mix' : {
						1:0,
						2:20,
						3:30,
						4:40
					  },
			'DelicatesSilk' : {
						1:0,
						2:20,
						3:30,
						4:40
					  },
			'Wool' : {
						1:0,
						2:20,
						3:30,
						4:40
					  }
		};
		vm.rpm = {
			'Cotton' : {
						1:0,
						2:400,
						3:600,
						4:800,
						5:1000,
						6:1200,
						7:1400,
						8:1600
					  },
			'EasyCare' : {
						1:0,
						2:400,
						3:600,
						4:800,
						5:1000,
						6:1200
					  },
			'Mix' : {
						1:0,
						2:400,
						3:600,
						4:800,
						5:1000,
						6:1200,
						7:1400,
						8:1600
					  },
			'DelicatesSilk' : {
						1:0,
						2:400,
						3:600,
						4:800
					  },
			'Wool' : {
						1:0,
						2:400,
						3:600,
						4:800
					  }
		};
        function applyOptions()
        {
                var response=vm.program;
                $mdDialog.hide(response);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('LaundryInfoController', LaundryInfoController);

    function LaundryInfoController($mdDialog,event,program)
    {
        var vm = this;
        vm.program=program;
        vm.closeDialog = closeDialog;
		console.log(vm.program);
		
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DryerOptionsController', DryerOptionsController);

    function DryerOptionsController($mdDialog,$filter,$translate,event,program,optkey)
    {
        var vm = this;
        console.log(program);
		vm.program=program;
        vm.closeDialog = closeDialog;
        vm.applyOptions=applyOptions;
		//vm.program.progkey = key;
		vm.program.optkey = optkey;
		vm.Options = {
			'IronDry' : {
						name : $filter('translate')("DASHBOARD.WIDGET.IRONDRY"),
						icon : 'pragma-icon-dryer-options-irondry',
						descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.IRONDRY")
					  },
			'CupboardDry' : {
							name : $filter('translate')("DASHBOARD.WIDGET.CUPBOARDDRY"),
							icon : 'pragma-icon-dryer-options-closetdry',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.CUPBOARDDRY")
						  },
			'CupboardDryPlus' : {
								name : $filter('translate')("DASHBOARD.WIDGET.CUPBOARDDRYPLUS"),
								icon : "pragma-icon-dryer-options-extraclosetdry",
								descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.CUPBOARDDRYPLUS")
							  }

		};
		
        function applyOptions()
        {
                var response=vm.program;
                $mdDialog.hide(response);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DryerInfoController', DryerInfoController);

    function DryerInfoController($mdDialog,event,program)
    {
        var vm = this;
        vm.program=program;
        vm.closeDialog = closeDialog;
		console.log(vm.program);
		
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('OptionsController', OptionsController);

    function OptionsController($mdDialog,event,program)
    {
        var vm = this;
        vm.program=program;
        vm.closeDialog = closeDialog;
        vm.applyOptions=applyOptions;
        vm.checkSecs=checkSecs;
		//vm.program.key = key;
		vm.program.hours = 0;
		vm.program.mins = 0;
		vm.program.secs = 0;
		vm.isDisabled = false;
        function checkSecs(H, M)
        {
            if(H === 23 && M === 59) {
				vm.program.secs = 0;
				vm.isDisabled = true;
			}
			else {
				vm.isDisabled = false;
			}
        }
		function applyOptions()
        {
                var response=vm.program;
                $mdDialog.hide(response);
        }
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('InfoController', InfoController);

    function InfoController($mdDialog,event,program)
    {
        var vm = this;
        vm.program=program;
        vm.closeDialog = closeDialog;
		console.log(vm.program);
		
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.compare', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.compare', {
            url      : '/compare',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/compare/compare.html',
                    controller : 'CompareController as vm'
                }
            },
            bodyClass: 'compare'
        });

        msNavigationServiceProvider.saveItem('compare', {
            title : 'NAVIGATION.COMPARE',
            state: 'app.compare',
            group : true,
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.compare')
        .controller('CompareFilterController', CompareFilterController);

    function CompareFilterController($mdDialog, $q, $scope, $timeout, user, filter, PRAGMA, pragmaapi)
    {

        var vm = this;
        vm.filter = {};
        
        user.authentication = user.username + ":" + user.password;
        
        // Schedule
        var isMouseDown = false, isHighlighted;
        
        var dOfWeek = [];
        var currentLocaleData = moment.localeData();
        var firstDayOfWeek = currentLocaleData.firstDayOfWeek();
        for (var i = firstDayOfWeek; i < 7; i++) {
            dOfWeek.push(i);
        }
        for (var i = 0; i < firstDayOfWeek; i++) {
            dOfWeek.push(i);
        }
        
        vm.scheduleChanged = false;
        if (filter.schedule == undefined) {
            vm.filter.schedule = {days: [], times: [], schedule: []};
            vm.filter.schedule.days = Array.apply(null, Array(7)).map(function (_, i) {return moment(i, 'e').format('dddd');});
            for (var i = 0; i < 24; i++) {
                vm.filter.schedule.times.push(pad(i, 2) + ":00");
            }
            resetSchedule(1);
        }
        else {
            vm.filter.schedule = filter.schedule;
            $timeout(function () { redrawSchedule() }, 0, false);
        }
        
        jQuery('body')
            .off("mousedown", ".schedulePicker td")
            .on("mousedown", ".schedulePicker td", function(e) {
                isMouseDown = true;
                vm.scheduleChanged = true;
                jQuery(this).toggleClass("highlighted");
                isHighlighted = jQuery(this).hasClass("highlighted");
                $scope.$apply();
                return false; // prevent text selection
            })
            .off("mouseover", ".schedulePicker td")
            .on("mouseover", ".schedulePicker td", function (e) {
                if (isMouseDown) {
                    jQuery(this).toggleClass("highlighted", isHighlighted);
                }
            })
            .off("selectstart", ".schedulePicker td")
            .on("selectstart", ".schedulePicker td", function () {
                return false;
            })
            .off("mouseup")
            .on("mouseup", function (e) {
                isMouseDown = false;
            });
        
        function resetSchedule(val) {
            vm.scheduleChanged = false;
            vm.filter.schedule.schedule = getSchedule(val);
            $timeout(function () { redrawSchedule() }, 0, false);
        }
        
        function redrawSchedule() {
            jQuery(".schedulePicker td").removeClass("highlighted");
            jQuery(".schedulePicker td").each(function () {
                if (vm.filter.schedule.schedule[jQuery(this).data("i")][jQuery(this).data("j")] == 1) {
                    jQuery(this).addClass("highlighted");
                }
            });
        }
        
        function getSchedule(val) {
            var schedule = []
            for (var i = firstDayOfWeek; i < 7; i++) {
                schedule[i] = [];
                for (var j = 0; j < 24; j++) {
                    schedule[i][j] = val;
                }
            }
            for (var i = 0; i < firstDayOfWeek; i++) {
                schedule[i] = [];
                for (var j = 0; j < 24; j++) {
                    schedule[i][j] = val;
                }
            }
            return schedule;
        }
        
        vm.apply = function() {
            jQuery(".schedulePicker td").each(function () {
                vm.filter.schedule.schedule[jQuery(this).data("i")][jQuery(this).data("j")] = jQuery(this).hasClass("highlighted") ? 1 : 0;
            });            
            $mdDialog.hide(vm.filter);
        }
        
        vm.buildingTypes={
            "Residential": ['Detached','Semi-Detached','Terras','Appartment'],
            "Office": ['Administration','ICT','Government','Council','Telecoms','Medical','Shopping Centre','Housing Corporation'],
            "Recreation": ['Congress Centre','Church','Club House','Cinema','Theatre','Casino','Cafe','Restaurant','Cantine','Nightclub','Training','Museum','Child Care','Exhibition','Library'],
            "Sport": ['Swimming Baths','Tennis Hall','Gymnastics','Squash Courts','Sport Hall','Indoor Cycle Track','Fitness Centre','Bowling','Snooker','Shooting','Football Stadium'],
            "Loging": ['Hotel','Appartment Hotel','Motel','Bed & Breakfast','Asylum Centre'],
            "Retail": ['Local Shop','Indoor Shopping Centre','Super Market'],
            "Education": ['Junior School','Secondary School','Collage','University'],
            "Health": ['Cure','Care','unknown'],
            "Industry": ['Asfalt','Perishable Goods','Steel','Coffee','Koelinghouse','Dairy Produce','Meat','Rubber&Plastics','Chemical','Ceramics'],
            "Logistics": ['Transport','Storage','Transshipment'],
            "Parking": ['Indoor','Outdoor']
        };
        
        vm.floorTypes=['Concrete','Wood'];
        vm.wallTypes=['With Air Cavity','With Cavity insulation'];
        vm.roofInsulation=['Yes','No'];
        
        vm.heatingTypes=['Gas','Electricity','Diesel','Geothermal'];
        vm.aircoTypes=['Electricity','Geothermal'];
        vm.ventilationTypes=['Electricity','Geothermal'];
        
        vm.deviceTypes={'electricity': 'Electricity', 'gas': 'Gas', 'excess': 'PV Excess', 'water': 'Water'};
        
        vm.map = {
            center: {
                latitude: 0,
                longitude: 0
            },
            zoom: 12,
            markers: [],
            markersEvents: {
                click: function(marker, eventName, model) {
                    vm.map.window.model = model;
                    vm.map.window.show = true;
                }
            },
            control: {},
            window: {
                marker: {},
                show: false,
                closeClick: function() {
                    this.show = false;
                },
                options: {}
            }
        };
        
        /*
        _loadSites().then(function() {
            vm.map.markers = [];
            for (var i = 0; i < sites.length; i++) {
                var foo = {
                    id: sites[i].token,
                    labelContent: sites[i].name,
                    coords: {
                        latitude : sites[i].map.metadata.centerLatitude,
                        longitude: sites[i].map.metadata.centerLongitude
                    },
                    site: sites[i]
                };
                vm.map.markers.push(foo);
            }
        });
        */
        
        function ucwords(str) {
            str = str.replace(/_/g, ' ');
            return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        }        
        
        function ucfirst(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
        
        function pad(n, width, z) {
          z = z || '0';
          n = n + '';
          return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        
        /*
        $scope.map = {
            events: {
                tilesloaded: function (map) {
                    var isDrawing = false;
                    var overlay = new google.maps.OverlayView();
                    overlay.draw = function () {};
                    overlay.setMap(map);
                    var polyLine;
                    var parcelleHeig = Array();
                    google.maps.event.addListener(map, 'mousedown', function () {
                            isDrawing=true;
                            polyLine = new google.maps.Polyline({
                                map: map
                            });
                            $("#map").mousemove(function (e) {
                                if(isDrawing == true)
                                {
                                    var pageX = e.pageX;
                                    var pageY = e.pageY;
                                    var point = new google.maps.Point(parseInt(pageX), parseInt(pageY));

                                    var latLng = overlay.getProjection().fromDivPixelToLatLng(point);

                                    polyLine.getPath().push(latLng);

                                    latLng = String(latLng);
                                    latLng=latLng.replace("(","");
                                    latLng=latLng.replace(")","");

                                    var array_lng =  latLng.split(',');
                                    parcelleHeig.push(new google.maps.LatLng(array_lng[0],array_lng[1])) ;
                                }
                            });
                    });
                    google.maps.event.addListener(map, 'mouseup', function () {

                        isDrawing=false;
                        //console.log(parcelleHeig);

                        var polygoneParcelleHeig = new google.maps.Polygon({
                            paths: parcelleHeig,//sommets du polygone
                            strokeColor: "#0FF000",//couleur des bords du polygone
                            strokeOpacity: 0.8,//opacite des bords du polygone
                            strokeWeight: 2,//epaisseur des bords du polygone
                            fillColor: "#0FF000",//couleur de remplissage du polygone
                            fillOpacity: 0.35,////opacite de remplissage du polygone
                            editable:true,
                            geodesic: false

                        });
                        
                        //simplify polygon
                        var douglasPeuckerThreshold = 0.5; // in meters
                        polygoneParcelleHeig.douglasPeucker(360.0 / (2.0 * Math.PI * earthRadius));
                        
                        parcelleHeig=Array();
                        polygoneParcelleHeig.setMap(map);
                        polyLine.setMap(null);
                    });


                    var earthRadius = 6378137.0;

                    google.maps.Polygon.prototype.douglasPeucker = function(tolerance) {
                        
                        var res = null;

                        //adjust tolerance depending on the zoom level
                        tolerance = tolerance * Math.pow(2, 20 - map.getZoom());

                        if (this.getPath() && this.getPath().getLength()) {
                            var points = this.getPath().getArray();

                            var Line = function( p1, p2 ) {
                                this.p1 = p1;
                                this.p2 = p2;

                                this.distanceToPoint = function( point ) {
                                    // slope
                                    var m = ( this.p2.lat() - this.p1.lat() ) / ( this.p2.lng() - this.p1.lng() ),
                                        // y offset
                                        b = this.p1.lat() - ( m * this.p1.lng() ),
                                        d = [];
                                    // distance to the linear equation
                                    d.push( Math.abs( point.lat() - ( m * point.lng() ) - b ) / Math.sqrt( Math.pow( m, 2 ) + 1 ) );
                                    // distance to p1
                                    d.push( Math.sqrt( Math.pow( ( point.lng() - this.p1.lng() ), 2 ) + Math.pow( ( point.lat() - this.p1.lat() ), 2 ) ) );
                                    // distance to p2
                                    d.push( Math.sqrt( Math.pow( ( point.lng() - this.p2.lng() ), 2 ) + Math.pow( ( point.lat() - this.p2.lat() ), 2 ) ) );
                                    // return the smallest distance
                                    return d.sort( function( a, b ) {
                                        return ( a - b ); //causes an array to be sorted numerically and ascending
                                    } )[0];
                                };
                            };

                            var douglasPeucker = function( points, tolerance ) {
                                    
                                if ( points.length <= 2 ) {
                                    return [points[0]];
                                }
                                var returnPoints = [],
                                    // make line from start to end 
                                    line = new Line( points[0], points[points.length - 1] ),
                                    // find the largest distance from intermediate poitns to this line
                                    maxDistance = 0,
                                    maxDistanceIndex = 0,
                                    p;
                                for( var i = 1; i <= points.length - 2; i++ ) {
                                    var distance = line.distanceToPoint( points[ i ] );
                                    if( distance > maxDistance ) {
                                        maxDistance = distance;
                                        maxDistanceIndex = i;
                                    }
                                }
                                // check if the max distance is greater than our tollerance allows 
                                if ( maxDistance >= tolerance ) {
                                    p = points[maxDistanceIndex];
                                    line.distanceToPoint( p, true );
                                    // include this point in the output 
                                    returnPoints = returnPoints.concat( douglasPeucker( points.slice( 0, maxDistanceIndex + 1 ), tolerance ) );
                                    // returnPoints.push( points[maxDistanceIndex] );
                                    returnPoints = returnPoints.concat( douglasPeucker( points.slice( maxDistanceIndex, points.length ), tolerance ) );
                                } else {
                                    // ditching this point
                                    p = points[maxDistanceIndex];
                                    line.distanceToPoint( p, true );
                                    returnPoints = [points[0]];
                                }
                                return returnPoints;
                            };
                            res = douglasPeucker( points, tolerance );
                            // always have to push the very last point on so it doesn't get left off
                            res.push( points[points.length - 1 ] );
                            this.setPath(res);
                        }
                        return this;
                    }
                    
                    if (!google.maps.Polygon.prototype.getBounds) {
                        google.maps.Polygon.prototype.getBounds = function(latLng) {
                            var bounds = new google.maps.LatLngBounds(),
                                paths = this.getPaths(),
                                path,
                                p, i;

                            for (p = 0; p < paths.getLength(); p++) {
                                path = paths.getAt(p);
                                for (i = 0; i < path.getLength(); i++) {
                                    bounds.extend(path.getAt(i));
                                }
                            }
                            return bounds;
                        };
                    }

                    google.maps.Polygon.prototype.containsLatLng = function(latLng) {
                        var inPoly = false,
                            bounds, lat, lng,
                            numPaths, p, path, numPoints,
                            i, j, vertex1, vertex2;

                        // Arguments are a pair of lat, lng variables
                        if (arguments.length == 2) {
                            if (
                                typeof arguments[0] == "number" &&
                                typeof arguments[1] == "number"
                            ) {
                                lat = arguments[0];
                                lng = arguments[1];
                            }
                        } else if (arguments.length == 1) {
                            bounds = this.getBounds();

                            if (!bounds && !bounds.contains(latLng)) {
                                return false;
                            }
                            lat = latLng.lat();
                            lng = latLng.lng();
                        } else {
                            console.log("Wrong number of inputs in google.maps.Polygon.prototype.contains.LatLng");
                        }

                        numPaths = this.getPaths().getLength();
                        for (p = 0; p < numPaths; p++) {
                            path = this.getPaths().getAt(p);
                            numPoints = path.getLength();
                            j = numPoints - 1;

                            for (i = 0; i < numPoints; i++) {
                                vertex1 = path.getAt(i);
                                vertex2 = path.getAt(j);

                                if (
                                    vertex1.lng() <  lng &&
                                    vertex2.lng() >= lng ||
                                    vertex2.lng() <  lng &&
                                    vertex1.lng() >= lng
                                ) {
                                    if (
                                          vertex1.lat() +
                                          (lng - vertex1.lng()) /
                                          (vertex2.lng() - vertex1.lng()) *
                                          (vertex2.lat() - vertex1.lat()) <
                                          lat
                                    ) {
                                        inPoly = !inPoly;
                                    }
                                }

                                j = i;
                            }
                        }
                        return inPoly;
                    };
                }
            }
        }
        */
        
        // Sites
        var sites = [];
        var tenantAuthTokens = [];
        function _loadSites() {
            
            // Get All Tenants
            var tenantAuthTokens = [];
            return pragmaapi.callRestService(PRAGMA.api, "/users/" + user.username + "/tenants", "?includeRuntimeInfo=true", true, user.authentication, "GET").then(function(res) {
                var tenants = res.data;
                for (var i = 0; i < tenants.length; i++) {
                    if (!tenants[i].deleted && tenants[i].engineState.lifecycleStatus == "Started") {
                        tenantAuthTokens.push(tenants[i].authenticationToken);
                    }
                }
                
                // Load Sites
                var promises = tenantAuthTokens.map(function(tenantAuthToken) {
                    return pragmaapi.callRestService(PRAGMA.api, "/sites", "?tenantAuthToken=" + tenantAuthToken, true, user.authentication, "GET", true).then(function(res) {
                        if (!res.data.error && res.data.numResults) {
                            var results = res.data.results;
                            for (var i = 0; i < results.length; i++) {
                                sites.push(results[i]);
                            }
                        }
                    });
                });
                return $q.all(promises);
            });
        }
        
        function getLocations(tenant, site)
        {
            pragmaapi.callRestService(vm.url, "/sites/" + site, "?tenantAuthToken=" + tenant, true, user.authentication, "GET", true, false).then(function(res){
                var location=res.data;
                var temp = {
                    "id": location.token,
                    "labelContent": location.name,
                    "coords": {
                        latitude : location.map.metadata.centerLatitude,
                        longitude:location.map.metadata.centerLongitude
                    }
                };
                vm.googlmapLocations.push(temp);
                vm.googleMapCenter = angular.copy(vm.googlmapLocations[0].coords);
            });
        }
        
        vm.closeDialog = function closeDialog()
        {
            $mdDialog.cancel();
        }
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($http, $location, $rootScope, $timeout, $base64, $document, session, Notification, $window, PRAGMA, pragmaapi, $translate, $cookies, $mdDialog, $filter)
    {
        session.destroy();
        
        // Data
        var vm = this;
        vm.form =
        {
            username: "",
            password: ""
        };
        
        moment.locale('en');
        // vm.loginBackground = "url('assets/images/backgrounds/" + moment().format("MMMM").toLowerCase() + ".jpg') no-repeat";

        // Language
        var lang = $cookies.get("lang");
        if (lang != undefined) {
            $translate.use(lang);
        }
        
        // Methods

        vm.handleLogin = handleLogin;
		vm.openForgotPassDialog = openForgotPassDialog;
        vm.tenants=[];
        var solutionsFlag=false;
        vm.count=0;
        //////////
        function handleLogin() {
            vm.authentication = vm.form.username + ":" + vm.form.password;
            pragmaapi.callRestService(PRAGMA.api, "/users/" + vm.form.username, "", true, vm.authentication, "GET").then(function(res) {
                if (res.data.status == "Active") {
					vm.user = {
						 username:  vm.form.username,
						 password:  vm.form.password,
						 firstname: res.data.firstName,
						 lastname:  res.data.lastName,
						 role:      res.data.metadata.role
					}
					pragmaapi.callRestService(PRAGMA.api, "/tenants/", "?authUserId="+vm.form.username, true, vm.authentication, "GET").then(function(res) {
						vm.tenants=res.data.results;
						if( vm.tenants.length==0)
						{
							vm.user.currentTenant='';
							vm.user.hasVerticals=false;
							session.setUser(vm.user);
							$window.location.href = PRAGMA.url + '/admin';
						}
						for(var i=0;i<vm.tenants.length;i++)
						{
							getSolutions(vm.tenants[i].authenticationToken);
						}
					});
				}
				else if (res.data.status == "Expired") {
					showNotification($translate.instant("LOGIN.USER_AUTHENTICATION"), $translate.instant("LOGIN.EXPIRED"), "Error");
				}
				else {
					showNotification($translate.instant("LOGIN.USER_AUTHENTICATION"), $translate.instant("LOGIN.LOCKED"), "Error");
				}
            }, function(reason) {
                showNotification($translate.instant("LOGIN.USER_AUTHENTICATION"), $translate.instant("LOGIN.INVALID"), "Error");
            });
        }
        function getSolutions(token)
        {
            pragmaapi.callRestService(PRAGMA.api, "/verticalSolutions/tenant/", token, true, vm.authentication, "GET").then(function(res) {
                vm.count++;
                if(!solutionsFlag)
                {
                    if(res.data.results.length>0)
                    {
                        solutionsFlag=true;
                        vm.user.currentTenant=token;
                        vm.user.hasVerticals=true;   
                    }
                    else
                    {
                        vm.user.hasVerticals=false;
                    }
                    session.setUser(vm.user);
                }
                if(vm.count==vm.tenants.length)
                {
                    checkUserVerticals();
                }
            });
        }
        function checkUserVerticals()
        {
            if(!vm.user.hasVerticals)
            {
                vm.user.currentModule='';
                vm.user.parentModule='';
                vm.user.modules=[];
                session.setUser(vm.user);
                $window.location.href = PRAGMA.url + '/dashboard';
            }
            else
            {
                vm.user.authentication=vm.user.username+":"+vm.user.password;
                pragmaapi.callRestService(PRAGMA.api, "/verticalSolutions/tenant/",  vm.user.currentTenant, true, vm.user.authentication, "GET", true, false).then(function(res) {
                    var solutions=res.data.results;
                    pragmaapi.callRestService(PRAGMA.api, "/userPreferences/userId/" + vm.user.username+"/", "", true, vm.user.authentication, "GET", true, false).then(function(res) {
                        vm.userPreferences = res.data;
                        vm.user.modules=vm.userPreferences.modules;
                        if(vm.userPreferences.modules.length>1)
                        {
                            for(var i=0;i<solutions.length;i++)
                            {
                                for(var j=0;j<vm.userPreferences.modules.length;j++)
                                {
                                    if(vm.userPreferences.modules[j]===solutions[i].token && solutions[i].parent==="#")
                                    {
                                        vm.user.currentModule=vm.userPreferences.modules[j];
                                        vm.user.parentModule='#';
                                        break;
                                    }
                                }
                            }
                        }
                        else
                        {
                            for(var i=0;i<solutions.length;i++)
                            {
                                if(vm.userPreferences.modules[0]===solutions[i].token)
                                {
                                    vm.user.currentModule=vm.userPreferences.modules[0];
                                    vm.user.parentModule=solutions[i].parent;
                                    break;
                                }
                            }
                        }
                        session.setUser(vm.user);
                        $window.location.href = PRAGMA.url + '/dashboard';
                    });
                });
            }
        }
		
        function translateMail() {
            vm.mailTo = {
				title : $filter('translate')("LOGIN.MAIL_TITLE"),
				body  : $filter('translate')("LOGIN.MAIL_BODY")
			}
        }
        translateMail();
        
        $rootScope.$on('$translateChangeSuccess', function () {
            translateMail();
        });
		
        function openForgotPassDialog(ev)
        {
            $mdDialog.show({
                controller         : 'ForgotPassController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/auth/login/dialogs/ForgotPass/forgot_pass.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    thisUser:vm.user
                }
            }).then(function (answer)
            {	
				if (answer.user.metadata.forgot_token) {
					
					var forward_url = PRAGMA.url + '/change_pass/' + answer.user.metadata.forgot_token;
					
					/* body = '<h2>Smart Everything Platform: Request password change service.</h2>';
					body += '<p>You have requested to change your password.</p>';
					body += '<p>Please click the following link below</p>';
					body += '<p><a href=\"'+ forward_url +'\">'+ forward_url +'</a></p>';
					body += '<p>You will be forwarded to the requested form.</p>';
					body += '<h3>Attention!</h3>';
					body += '<p>This process will expire in two days!</p>';*/
					
					var body = 'Smart Everything Platform: Request password change service.\n\n';
					body += 'You have requested to change your password.\n';
					body += 'Please click the following link below\n\n';
					body += forward_url + '\n\n';
					body += 'You will be forwarded to the requested form.\n\n';
					body += 'Attention!\n\n';
					body += 'This process will expire in two hours!';
					
					var send_to = {
						subject : "Smart Everything Platform: Request password change service.",
						body    : body,
						to      : answer.user.metadata.email
					}
					
					//pragmaapi.callRestService(PRAGMA.api,"/mail/send",send_to,false,'',"POST",true,false).then(function(res){
					pragmaapi.callRestService(PRAGMA.api,"/mail/send",send_to,true,'admin:password',"POST",true,false).then(function(res){
						showNotification("User Notification", $translate.instant("LOGIN.MAIL_SENT"),"Success");
					},function(reason) {
						showNotification("User Notification","Something Went Wrong!","Error");
					});
					
				}
                
            },function () {});
        }
		
        function showNotification(title, message, type) {
            if (type === "Error") {
                Notification.error({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Info") {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Warning") {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Success") {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }   
        }
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'chart.js',
                'gridshore.c3js.chart',
                'nvd3',
                'pascalprecht.translate',
                'timer',
                'ui.router',
                'uiGmapgoogle-maps',
                'textAngular',
                'ui.sortable',
                'ng-sortable',
                'xeditable',
                'moment-picker',
                'rzModule',
                'ui.gravatar',
                'ngLoadingSpinner',
                'angAccordion',
                'ui-notification',
                'md.data.table',
                'amChartsDirective',
                'base64',
                'ngJsTree',
                'gridstack-angular',
                'simpleHandsontable',
                'daterangepicker',
                'color.picker',
                'vAccordion',
                'ngAnimate',
                'angular-notification-icons',
                'ui.calendar',
                'angularjs-gauge',
                'angular-dygraphs',
                'vAccordion',
                'ui.tinymce',
                'noCAPTCHA',
                'internationalPhoneNumber',
                'angular-carousel-3d',
                'ngVis',
                'ds.clock'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('PRAGMA.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Home',
                        'icon'       : 'icon-home',
                        'state'      : 'app.home',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'home',
                        '_path'      : 'apps.home',
                        'uisref'     : 'app.home',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('PRAGMA.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('PRAGMA.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, pragmaConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( pragmaConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( pragmaConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, pragmaGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: pragmaGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: pragmaGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.rules')
		.filter('unique', unique)
		.filter('htmlToPlaintext', function() {
			return function(text) {
				return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
			};
		})
		.controller('RulesController', RulesController);
	
	// unique item filter
	function unique() {
		return function(collection, keyname) {
			var output = [], 
				keys = [];
			
			angular.forEach(collection, function(item) {
				var key = item[keyname];
				if(keys.indexOf(key) === -1) {
					keys.push(key); 
					output.push(item);
				}
			});
			return output;
		};
	}
	
	/** @ngInject */
	function RulesController($scope, $rootScope, $state, $filter, $translate, $mdSidenav, $mdDialog, $document, session, PRAGMA, pragmaapi, filterFilter, Notification, dateFilter) {
		
		var vm = this;
		
		var dtZone = new Date().toString().split(" ");
		var timeZoneFormattedArray = dtZone[5].split("GMT");
		vm.timeZone = timeZoneFormattedArray[1];
		
		// User
		vm.user = session.getUser();
		console.log(vm.user);
		// Stepper Linear
		vm.isLinear = true;
		
		vm.ruleShow = 0;
		vm.rulesTable = {};
		vm.currentRule = {};
		
		vm.allSites = [];
		vm.allDevices = [];
		vm.allMeasurements = [];
		
		vm.currentNodeSelects = {};
		vm.currentActionDevice = null;
		
		// Select Fields
		vm.arguments = ['and','or'];
		vm.relations = ['==','!=','<','>','>=','<='];
		
		// Methods
		vm.manageRule = manageRule;
		
		vm.openNewRuleDialog = openNewRuleDialog;
		vm.openEditRuleDialog = openEditRuleDialog;
		vm.openCopyRuleDialog = openCopyRuleDialog;
		vm.openDeleteRuleDialog = openDeleteRuleDialog;
		
		vm.openNewConditionDialog = openNewConditionDialog;
		vm.openEditConditionDialog = openEditConditionDialog;
		
		vm.openNewVariableDialog = openNewVariableDialog;
		
		vm.removeNode = removeNode;
		vm.removeVariable = removeVariable;
		
		//vm.addNewCondition = addNewCondition;
		vm.removeCondition = removeCondition;
		
		vm.checkboxSelected = checkboxSelected;
		vm.checkboxToggle = checkboxToggle;
		
		vm.checkboxObjectSelected = checkboxObjectSelected;
		vm.checkboxObjectToggle = checkboxObjectToggle;
		
		vm.getSiteDevices = getSiteDevices;
		vm.getDeviceMeasurements = getDeviceMeasurements;
		
		//vm.changeSecondPart = changeSecondPart;
		vm.changeExpiration = changeExpiration;
		
		//vm.statisticalFirstChanged = statisticalFirstChanged;
		//vm.statisticalSecondChanged = statisticalSecondChanged;
		
		vm.submitRule = submitRule;
		
		fillRulesTable();
		
		function fillRulesTable() {
            pragmaapi.callRestService(PRAGMA.api, "/ruleEngine/userId/" + vm.user.username + "?includeDeleted=false", "", true, vm.user.authentication, "GET").then(function(res) {
				vm.rules = res.data.results;
				
				//console.log(vm.rules);
				
				vm.rulesTable.limitOptions = [5, 10, 15, {
					label: 'All',
					value: function () {
						return vm.rules.length ? vm.rules.length : 0;
					}
				}];
				vm.rulesTable.options = {
					rowSelection: false,
					multiSelect: false,
					autoSelect: false,
					decapitate: false,
					largeEditDialog: false,
					boundaryLinks: false,
					limitSelect: true,
					pageSelect: true
				};
				vm.rulesTable.query = {
					order: 'createdDate',
					limit: 10,
					page: 1
				};
				vm.rulesTable.filter = {
					search: ''
				};
				
			});
		}
		
		function translateOptions(){
			vm.statusIndicator = {
				active: {title: $filter('translate')("RULES.OPTIONS.ACTIVE"), class: 'green-fg' },
				inactive: {title: $filter('translate')("RULES.OPTIONS.INACTIVE"), class: 'red-fg' },
				expired: {title: $filter('translate')("RULES.OPTIONS.EXPIRED"), class: 'grey-fg' },
				complete: {title: $filter('translate')("RULES.OPTIONS.COMPLETE"), class: 'green-fg' },
				incomplete: {title: $filter('translate')("RULES.OPTIONS.INCOMPLETE"), class: 'grey-fg' }
			};
			
			vm.activeIndicator = {
				active: {title: $filter('translate')("RULES.OPTIONS.ACTIVE"), class: 'green-fg' },
				inactive: {title: $filter('translate')("RULES.OPTIONS.INACTIVE"), class: 'red-fg' },
			};
			
			vm.expirationOptions = [
				{id:'noexpiration',title:$filter('translate')("RULES.OPTIONS.WITHOUT_EXPIRATION"),type:'noexpiration',value:null},
				{id:'number',title:$filter('translate')("RULES.OPTIONS.EXPIRATION_AFTER"),type:'number',value:1},
				{id:'date',title:$filter('translate')("RULES.OPTIONS.EXPIRATION_DATE"),type:'date',value:new Date()}
			];
			
			vm.notifications = [
				{id:'mail',title:$filter('translate')("RULES.OPTIONS.NOTIFICATION_MAIL")},
				{id:'sms',title:$filter('translate')("RULES.OPTIONS.NOTIFICATION_SMS")},
				{id:'platform',title:$filter('translate')("RULES.OPTIONS.NOTIFICATION_PLATFORM")}
			];
			
			vm.days = [
				{id:'MO',title:$filter('translate')("RULES.DAYS.MO")},
				{id:'TU',title:$filter('translate')("RULES.DAYS.TU")},
				{id:'WE',title:$filter('translate')("RULES.DAYS.WE")},
				{id:'TH',title:$filter('translate')("RULES.DAYS.TH")},
				{id:'FR',title:$filter('translate')("RULES.DAYS.FR")},
				{id:'SA',title:$filter('translate')("RULES.DAYS.SA")},
				{id:'SU',title:$filter('translate')("RULES.DAYS.SU")}
			];
			
			vm.statisticalRules = [
				{id:'CUR',title:$filter('translate')("RULES.STATISTICAL_LIST.CUR")},
				{id:'MEAN',title:$filter('translate')("RULES.STATISTICAL_LIST.MEAN")},
				{id:'SUM',title:$filter('translate')("RULES.STATISTICAL_LIST.SUM")},
				{id:'MIN',title:$filter('translate')("RULES.STATISTICAL_LIST.MIN")},
				{id:'MAX',title:$filter('translate')("RULES.STATISTICAL_LIST.MAX")}
			];
			
			vm.statisticalDurationTypes = [
				{id:'m',title:$filter('translate')("RULES.DURATION_TYPE_LIST.MIN")},
				{id:'h',title:$filter('translate')("RULES.DURATION_TYPE_LIST.HOU")},
				{id:'d',title:$filter('translate')("RULES.DURATION_TYPE_LIST.DAY")},
				{id:'M',title:$filter('translate')("RULES.DURATION_TYPE_LIST.MON")}
			];
			
			vm.durationTypes = [
				{id:'no',title:$filter('translate')("RULES.DURATION_TYPE_LIST.NONE")},
				{id:'m',title:$filter('translate')("RULES.DURATION_TYPE_LIST.MIN")},
				{id:'h',title:$filter('translate')("RULES.DURATION_TYPE_LIST.HOU")},
				{id:'d',title:$filter('translate')("RULES.DURATION_TYPE_LIST.DAY")},
				{id:'M',title:$filter('translate')("RULES.DURATION_TYPE_LIST.MON")}
			];
			
			
		}
		translateOptions();
		
		$rootScope.$on('$translateChangeSuccess', function () {
			translateOptions();
		});
		
		vm.currentModule = vm.user.currentModule;
		vm.parentModule = vm.user.parentModule;
		if(vm.currentModule === '' || vm.parentModule === '#') {
			vm.filter = {
				device:{},
				site:{},
				specification:{},
				includeDevices:true,
				includeMeasurements:true,
				specs:[],
				measurements:{}
			};
		}
		else {
			vm.filter = {
				device:[{modules:[vm.currentModule]}],
				site:{},
				specification:{},
				includeDevices:true,
				includeMeasurements:true,
				specs:[],
				measurements:{}
			};
		}
		
		refreshTree();
		
		$scope.$on('change.module', function(event, args) {
			vm.showTree = false;
			if(args.parent === '#') {
				vm.filter = {
					device:{},
					site:{},
					specification:{},
					includeDevices:true,
					includeMeasurements:true,
					specs:[],
					measurements:{}
				};
			}
			else {
				vm.filter = {
					device:[{modules:[args.token]}],
					site:{},
					specification:{},
					includeDevices:true,
					includeMeasurements:true,
					specs:[],
					measurements:{}
				};
			}
			refreshTree();
		});
		
		
		
		
		function refreshTree() {
			pragmaapi.getTreeDataFilter(vm.filter).then(function(treeData) {
				vm.treeData = processTreeData(treeData);
				vm.allSites = [];
				vm.allDevices = [];
				vm.allMeasurements = [];
				treeData.forEach(function(node, j) {
					switch (node.type) {
						case 'site':
							vm.allSites.push({
								id:node.id,
								parent:node.parent,
								text:node.text,
								token:node.token
							});
						break;
						case 'device':
							if (node.text != null) {
								var tempParent = node.parent;
								if (parentNodeType(node, 'deviceGroup')) {
									//console.log(node);
									tempParent = findParentOfDeviceGroup(treeData, node.parent);
								}
								vm.allDevices.push({
									id:node.id,
									parent:tempParent,
									text:node.text,
									token:node.token
								});
								//console.log(node);
							}
						break;
						case 'measurement':
							var parentDeviceText = 	findDeviceText(node.parent);
							//if (parentDeviceText != null) {
								node.parentDeviceText = parentDeviceText;
							//}
							vm.allMeasurements.push(node);
						break;
					}
					
				});
				//console.log(vm.allDevices);
				
			});
		}
		
		function removeEmpty(tree,ids) {
			var fl = false;
			var groupT = -1;
			for(var j=0; j < ids.length; j++) {
				fl = false;
				groupT = -1;
				for(var i=0; i < tree.length; i++) {
					if (tree[i].id == ids[j]) {
						groupT = i;
					}
					if(tree[i].parent == ids[j]) {
						fl =true;
					}
				}
				if(!fl) {
					tree.splice(groupT, 1);
				}
			}
			return tree;
		}
		
		/*pragmaapi.getTreeData(true, true, true, true).then(function(treeData) {
			treeData.forEach(function(node, j) {
				switch (node.type) {
					case 'site':
						vm.allSites.push({
							id:node.id,
							parent:node.parent,
							text:node.text,
							token:node.token
						});
					break;
					case 'device':
						if (node.text != null) {
							var tempParent = node.parent;
							if (parentNodeType(node, 'deviceGroup')) {
								tempParent = findParentOfDeviceGroup(treeData, node.parent);
							}
							vm.allDevices.push({
								id:node.id,
								parent:tempParent,
								text:node.text,
								token:node.token
							});
						}
					break;
					case 'measurement':
						var parentDeviceText = 	findDeviceText(node.parent);
						//if (parentDeviceText != null) {
							node.parentDeviceText = parentDeviceText;
						//}
						vm.allMeasurements.push(node);
					break;
				}
				
			});
			
		});*/
		function processTreeData(treeData) {
			var groupIds = [];
			var siteIds = [];
			var tenantIds = [];
			var portfolioIds = [];
			for(var i=0; i < treeData.length; i++) {
				if(treeData[i].type === "deviceGroup") {
					groupIds.push(treeData[i].id)
				}
				else if(treeData[i].type === "site") {
					siteIds.push(treeData[i].id)
				}
				else if(treeData[i].type === "portfolio") {
					portfolioIds.push(treeData[i].id)
				}
				else if(treeData[i].type === "client") {
					tenantIds.push(treeData[i].id)
				}
			}
			treeData = removeEmpty(treeData, groupIds);
			treeData = removeEmpty(treeData, siteIds);
			treeData = removeEmpty(treeData, portfolioIds);
			treeData = removeEmpty(treeData, tenantIds);
			for(var i=0; i < treeData.length; i++) {
				treeData[i]["__uiNodeId"] = i+1;
			}
			return treeData;
        }
		
		function findParentOfDeviceGroup(array, id) {
			for (var i = 0; i < array.length; i++) {
				if (array[i].id === id) {
					return array[i].parent;
				}
			}
			return null;
		}
		
		function parentNodeType(node, type) {
			return node.parent.indexOf(type + "_") == 0;
		}
		
		function findDeviceText(id) {
			var text;
			vm.allDevices.forEach(function(node, j){
				if (node.id === id) {
					text = node.text;
				}
			});
			return text;
		}
		
		function getSiteDevices(site) {
			vm.devices = [];
			for (var i = 0; i < vm.allDevices.length; i++) {
				if (vm.allDevices[i].parent === site) {
					vm.devices.push(vm.allDevices[i]);
				}
			}
			//vm.devices = ($filter('filter')(, {parent:site}));
		}
		
		function getDeviceMeasurements(device) {
			vm.measurements = [];
			for (var i = 0; i < vm.allMeasurements.length; i++) {
				if (vm.allMeasurements[i].parent === device) {
					vm.measurements.push(vm.allMeasurements[i]);
				}
			}
			//vm.measurements = ($filter('filter')(vm.allMeasurements, {parent:device}));
		}
		
		function removeNode(index) {
			vm.currentRule.variableLibrary.splice(index, 1);
		}
		
		function removeVariable(index) {
			vm.currentRule.variableLibrary.splice(index, 1);
		}
		
		/*
		function addNewCondition() {
			//vm.currentRule.conditions.push(newCondition());
		}
		*/
		
		function removeCondition(index) {
			vm.currentRule.conditions.splice(index, 1);
			if (vm.currentRule.conditions.length != 0) {
				vm.currentRule.conditions[0].argument = '';
			}
		}
		
		/*
		function newCondition() {
			var newObjectCondition = {
				firstPart: {type:'variable'},
				secondPart: {type:'variable'}
			};
			
			if (vm.currentRule.conditions.length > 0) {
				newObjectCondition.argument = 'and';
			}
			return newObjectCondition;
		}
		*/
		
		/*
		function changeSecondPart(index) {
			var type = vm.currentRule.conditions[index].secondPart.type;
			// reset secondPart
			vm.currentRule.conditions[index].secondPart = {type:type}
		}
		*/
		
		function changeExpiration(type) {
			
			var endObject;
			
			switch (type) {
				case 'noexpiration':
					endObject = {
						type: 'noexpiration'
					};
				break;
				case 'number':
					endObject = {
						type: 'number'
					};
				break;
				case 'date':
					endObject = {
						type: 'date',
						value: new Date()
					};
				break;
			}
			// reset expiration
			vm.currentRule.expiration.end = endObject;
			
		}
		
		/*
		function statisticalFirstChanged(index) {
			if (vm.currentRule.conditions[index].firstPart.statistical == 'CUR') {
				if (vm.currentRule.conditions[index].firstPart.duration){
					vm.currentRule.conditions[index].firstPart.duration.type = null;
					vm.currentRule.conditions[index].firstPart.duration.value = null;
				}
			}
		}
		
		function statisticalSecondChanged(index) {
			if (vm.currentRule.conditions[index].secondPart.statistical == 'CUR') {
				if (vm.currentRule.conditions[index].secondPart.duration) {
					vm.currentRule.conditions[index].secondPart.duration.type = null;
					vm.currentRule.conditions[index].secondPart.duration.value = null;
				}
			}
		}
		*/
		
		function checkboxObjectSelected(item, list) {
			return list.map(function(o) { return o.id; }).indexOf(item.id) > -1;
		}
		
		function checkboxObjectToggle(item, list) {
			var idx = list.map(function(o) { return o.id; }).indexOf(item.id);
			
			if (idx > -1) {
				list.splice(idx, 1);
			}
			else {
				list.push(item);
			}
		}
		
		function checkboxSelected(item, list) {
			return list.indexOf(item) > -1;
		}
		
		function checkboxToggle(item, list) {
			var idx = list.indexOf(item);
			
			if (idx > -1) {
				list.splice(idx, 1);
			}
			else {
				list.push(item);
			}
		}
		
		vm.addMailAccountField = addMailAccountField;
		vm.removeMailAccountField = removeMailAccountField;
		
		function addMailAccountField() {
			vm.currentRule.sendTo.emails.push('');
		}
		
		function removeMailAccountField(index) {
			vm.currentRule.sendTo.emails.splice(index, 1);
		}
		
		
		function manageRule(rule) {
			// Reset
			vm.devices = [];
			vm.measurements = [];
			vm.currentNodeSelects = {};
			
			vm.ruleShow = 1;
			vm.currentRule = rule;
			
			if(vm.user.role!=='level04' && vm.user.role!=='level05') {
				pragmaapi.callRestService(PRAGMA.api, "/users", "?includeDeleted=false&count=100", true, vm.user.authentication, "GET", true, false).then(function(res) {
					vm.users = [];
					if (vm.user.role == 'level02' || vm.user.role == 'level03') {
						for (var i = 0; i < res.data.results.length; i++) {
							var user = res.data.results[i];
							if (user.createdBy == vm.user.username) {
								vm.users.push(user);
							}
						}
					}
					else {
						for (var i=0; i < res.data.results.length; i++) {
							var user = res.data.results[i];
							if (user.username != vm.user.username){
								vm.users.push(user);
							}
						}
					}
					//console.log(vm.users);
				});
			}
			
			vm.currentRule.expiration.startDate = new Date(rule.expiration.startDate);
			
			if (vm.currentRule.expiration.specificTime.from != 'null') {
				vm.currentRule.expiration.specificTime.from = new Date(rule.expiration.specificTime.from);
			}
			else {
				delete vm.currentRule.expiration.specificTime.from;
			}
			if (vm.currentRule.expiration.specificTime.to != 'null') {
				vm.currentRule.expiration.specificTime.to = new Date(rule.expiration.specificTime.to);
			}
			else {
				delete vm.currentRule.expiration.specificTime.to;
			}
			if (vm.currentRule.expiration.end.type == 'date') {
				vm.currentRule.expiration.end.value = new Date(rule.expiration.end.value);
			}
		}
		
		function submitRule() {
			var tempRule = angular.copy(vm.currentRule);
			
			tempRule.status = 'complete';
			if (tempRule.expiration.specificTime.from == null) {
				tempRule.expiration.specificTime.from = 'null';
			}
			if (tempRule.expiration.specificTime.to == null) {
				tempRule.expiration.specificTime.to = 'null';
			}
			
			pragmaapi.callRestService(PRAGMA.api,"/ruleEngine/" + tempRule.token, tempRule, true, vm.user.authentication, "PUT").then(function(res){
				vm.ruleShow = 0;
				fillRulesTable();
				showNotification("Rule Notification", "Rule Updated Successfully!", "Success");
			},function(reason) {
				showNotification("Rule Notification", "Something Went Wrong!", "Error");
			});
		}
		
		function openNewRuleDialog(ev) {
			$mdDialog.show({
				controller         : 'NewRuleController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/rules/dialogs/newRule/new-rule.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					user:vm.user
				}
			}).then(function (answer) {	
				
				var newRule = answer;
				
				newRule.token = generateUUID()
				newRule.userId = vm.user.username;
				
				pragmaapi.callRestService(PRAGMA.api,"/ruleEngine", newRule, true, vm.user.authentication, "POST").then(function(res) {
					fillRulesTable();
					showNotification("Rule Notification", "Rule Inserted Successfully!", "Success");
				},function(reason) {
					showNotification("Rule Notification", "Something Went Wrong!", "Error");
				});
				
			}, function () {});
		}
		
		function openEditRuleDialog(ev,rule) {
			$mdDialog.show({
				controller         : 'EditRuleController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/rules/dialogs/editRule/edit-rule.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					user:vm.user,
					rule:rule
				}
			}).then(function (answer) {	
				pragmaapi.callRestService(PRAGMA.api,"/ruleEngine/" + answer.token, answer, true, vm.user.authentication, "PUT").then(function(res){
					fillRulesTable();
					showNotification("Rule Notification", "Rule Updated Successfully!", "Success");
				},function(reason) {
					showNotification("Rule Notification", "Something Went Wrong!", "Error");
				});
			}, function () {});
		}
		
		function openCopyRuleDialog(ev,rule) {
			$mdDialog.show({
				controller         : 'CopyRuleController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/rules/dialogs/copyRule/copy-rule.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					rule:rule
				}
			}).then(function (answer) {	
				
				var copyRule = answer;
				
				copyRule.token = generateUUID()
				//copyRule.title = copyRule.title + ':Dublicate';
				
				pragmaapi.callRestService(PRAGMA.api,"/ruleEngine", copyRule, true, vm.user.authentication, "POST").then(function(res) {
					fillRulesTable();
					showNotification("Rule Notification", "Rule Copied Successfully!", "Success");
				},function(reason) {
					showNotification("Rule Notification", "Something Went Wrong!", "Error");
				});
				
			}, function () {});
		}
		
		function openDeleteRuleDialog(ev,rule) {
			$mdDialog.show({
				controller         : 'DeleteRuleController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/rules/dialogs/deleteRule/delete-rule.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					rule:rule
				}
			}).then(function (answer) {	
				pragmaapi.callRestService(PRAGMA.api, "/ruleEngine/" + answer+ "?force=true","", true, vm.user.authentication, "DELETE").then(function(res){
					fillRulesTable();
					showNotification("Rule Notification", "Rule Deleted Successfully!", "Success");
				},function(reason) {
					showNotification("Rule Notification", "Something Went Wrong!", "Error");
				});
			}, function () {});
		}
		
		function openNewConditionDialog(ev,index,variables) {
			$mdDialog.show({
				controller         : 'NewConditionController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/rules/dialogs/newCondition/new-condition.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event:ev,
					index:index,
					variables:variables
				}
			}).then(function (answer) {	
				var newCondition = answer;
				vm.currentRule.conditions.push(answer);
			}, function () {});
		}
		
		function openEditConditionDialog(ev,index,condition,variables) {
			$mdDialog.show({
				controller         : 'EditConditionController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/rules/dialogs/editCondition/edit-condition.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event:ev,
					index:index,
					variables:variables,
					condition:condition
				}
			}).then(function (answer) {	
				var condition = answer;
				vm.currentRule.conditions[index] = answer;
			}, function () {});
		}
		
		function openNewVariableDialog(ev,index) {
			$mdDialog.show({
				controller         : 'NewVariableController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/rules/dialogs/newVariable/new-variable.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event:ev,
					index:index
				}
			}).then(function (answer) {	
				var exists = vm.currentRule.variableLibrary.some(function(item){
					return item.id.includes(answer.id);
				});
				
				if (!exists) {
					vm.currentRule.variableLibrary.push(answer);
				}
				else {
					showNotification("Rule Notification", "The measurement is already in your variable Library!", "Error");
				}
			}, function () {});
		}
		
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
		
		function showNotification(title, message, type) {
			if (type === "Error") {
				Notification.error({
					title:title,
					message: message,
					delay: 3000,
					positionX:"right",
					positionY:"bottom"
				});
			}
			else if (type === "Info") {
				Notification.info({
					title:title,
					message: message,
					delay: 3000,
					positionX:"right",
					positionY:"bottom"
				});
			}
			else if (type === "Warning") {
				Notification.warning({
					title:title,
					message: message,
					delay: 3000,
					positionX:"right",
					positionY:"bottom"
				});
			}
			else if (type === "Success") {   
				Notification.success({
					title:title,
					message: message,
					delay: 3000,
					positionX:"right",
					positionY:"bottom"
				});
			}   
		}
		
	}
	
})();
(function ()
{
    'use strict';

    angular
        .module('app.reports', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.reports', {
                abstract : true,
                url      : '/reports',
                bodyClass: 'reports'
            })
            
            // Home
            .state('app.reports.index', {
                url      : '/index',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/reports/reports.html',
                        controller : 'ReportsController as vm'
                    }
                },
            })
            
            // Report
            .state('app.reports.report', {
                url    : '/:id',
                views  : {
                    'content@app'                                  : {
                        templateUrl: 'app/main/reports/report.html',
                        controller : 'ReportController as vm'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('reports', {
            title : 'NAVIGATION.REPORTS',
            state: 'app.reports.index',
            group : true,
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsController', ReportsController);

    /** @ngInject */
    function ReportsController($scope, $rootScope, $filter, session, PRAGMA, pragmaapi, pragmaTheming)
    {
        var vm = this;	
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        
        // Reports
        // pragmaapi.loadUserData("reports").then(function(reports) { vm.reports = reports; });
        vm.reports = [
            {
                id: "foo",
                name: "Energy consumption",
                settings: {
                    subscribed: false
                },
                pages: [
                    {}
                ]
            }
        ];
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportController', ReportController);

    /** @ngInject */
    function ReportController($scope, $rootScope, $stateParams, $filter, $timeout, session, PRAGMA, pragmaapi, pragmaTheming)
    {
        var vm = this;	
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        
        // Reports
        vm.selectedReport = $stateParams.id;
        // pragmaapi.loadUserData("reports").then(function(reports) { vm.reports = reports; });
        vm.reports = [
            {
                id: "foo",
                name: "Energy consumption",
                settings: {
                    subscribed: false
                },
                header: "HEADER",
                footer: "<p style='text-align: right;'>Page {{PAGE.num}}</p>",
                pages: [
                    { content: "<h1>Holistic IoT Solution</h1><h2>Smarteverything is a complete end to end platform as a service solution for the IoT world. The smarteverything ecosystem provides turnkey IoT solutions that include hardware, software and networking frameworks for a variety of verticals including energy, lighting, agriculture, parking, health, environmental and water management.</h2><h2>We leverage the power of the IoT and Analytics to create engagement and business value for its customers.</h2><p>&nbsp;</p><table class='table-fill' style='background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; border-radius: 3px; border-collapse: collapse; height: 320px; margin: auto; max-width: 600px; padding: 5px; width: 590px; box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 10px; animation: float 5s infinite; color: #000000; font-family: Roboto, helvetica, arial, sans-serif; font-size: 16px; letter-spacing: normal;'><thead><tr style='border-top: none; color: #666b85; text-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px; border-bottom: none;'><th class='text-left' style='color: #d5dde5; background: #1b1e24; border-bottom: 4px solid #9ea7af; border-right: 1px solid #343a45; font-size: 23px; font-weight: 100; padding: 24px; text-shadow: rgba(0, 0, 0, 0.1) 0px 1px 1px; vertical-align: middle; border-top-left-radius: 3px;'>Month</th><th class='text-left' style='color: #d5dde5; background: #1b1e24; border-bottom: 4px solid #9ea7af; border-right: none; font-size: 23px; font-weight: 100; padding: 24px; text-shadow: rgba(0, 0, 0, 0.1) 0px 1px 1px; vertical-align: middle; border-top-right-radius: 3px;'>Sales</th></tr></thead><tbody class='table-hover'><tr style='border-top: none; color: #666b85; text-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px;'><td class='text-left' style='background: #ebebeb; padding: 20px; vertical-align: middle; font-size: 18px; text-shadow: rgba(0, 0, 0, 0.1) -1px -1px 1px; border-right: 1px solid #c1c3d1;'>January</td><td class='text-left' style='background: #ebebeb; padding: 20px; vertical-align: middle; font-size: 18px; text-shadow: rgba(0, 0, 0, 0.1) -1px -1px 1px; border-right: 0px;'>$ 50,000.00</td></tr><tr style='border-top: 1px solid #c1c3d1; color: #666b85; text-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px;'><td class='text-left' style='background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 20px; vertical-align: middle; font-size: 18px; text-shadow: rgba(0, 0, 0, 0.1) -1px -1px 1px; border-right: 1px solid #c1c3d1;'>February</td><td class='text-left' style='background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 20px; vertical-align: middle; font-size: 18px; text-shadow: rgba(0, 0, 0, 0.1) -1px -1px 1px; border-right: 0px;'>$ 10,000.00</td></tr><tr style='border-top: 1px solid #c1c3d1; color: #666b85; text-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px;'><td class='text-left' style='background: #4e5066; padding: 20px; vertical-align: middle; font-size: 18px; text-shadow: rgba(0, 0, 0, 0.1) -1px -1px 1px; border-right: 1px solid #c1c3d1; color: #ffffff; border-top: 1px solid #22262e;'>March</td><td class='text-left' style='background: #4e5066; padding: 20px; vertical-align: middle; font-size: 18px; text-shadow: rgba(0, 0, 0, 0.1) -1px -1px 1px; border-right: 0px; color: #ffffff; border-top: 1px solid #22262e;'>$ 85,000.00</td></tr><tr style='border-top: 1px solid #c1c3d1; color: #666b85; text-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px;'><td class='text-left' style='background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 20px; vertical-align: middle; font-size: 18px; text-shadow: rgba(0, 0, 0, 0.1) -1px -1px 1px; border-right: 1px solid #c1c3d1;'>April</td><td class='text-left' style='background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial; padding: 20px; vertical-align: middle; font-size: 18px; text-shadow: rgba(0, 0, 0, 0.1) -1px -1px 1px; border-right: 0px;'>$ 56,000.00</td></tr><tr style='border-top: 1px solid #c1c3d1; color: #666b85; text-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px; border-bottom: none;'><td class='text-left' style='background: #ebebeb; padding: 20px; vertical-align: middle; font-size: 18px; text-shadow: rgba(0, 0, 0, 0.1) -1px -1px 1px; border-right: 1px solid #c1c3d1; border-bottom-left-radius: 3px;'>May</td><td class='text-left' style='background: #ebebeb; padding: 20px; vertical-align: middle; font-size: 18px; text-shadow: rgba(0, 0, 0, 0.1) -1px -1px 1px; border-right: 0px; border-bottom-right-radius: 3px;'>$ 98,000.00</td></tr></tbody></table>" },
                    { content: "test" }
                ]
            }
        ];
        vm.report = $filter('filter')(vm.reports, {'id': vm.selectedReport})[0];
        
        // Layouts
        vm.layouts = [
            {
                id: "single",
                name: "Single column",
                content: ""
            },
            {
                id: "two-columns",
                name: "Two columns",
                content: ""
            },
            {
                id: "three-columns",
                name: "Three columns",
                content: ""
            },
            {
                id: "four-columns",
                name: "Four columns",
                content: ""
            }
        ];
        
        // Theming
        
		vm.themes = pragmaTheming.themes;
        var isDark = (vm.themes.active.name.indexOf('Dark') >= 0);
        
        // Tiny MCE
        
        vm.tinymceOptions = {
            inline: true,
            selector: '.page > div',
            setup: function(editor) {
                editor.on("init", function() {
                
                });
                editor.on("click", function() {
                
                });
            }
        };
        
        vm.logModel = function logModel() {
            console.log(vm.report.pages[0]);
        }
        
        // Date Range
        
        vm.date = {
          startDate: moment().startOf('month'),
          endDate: moment()
        };
        
        function translateDateRange() {
            var ranges = {}
            ranges[$filter('translate')("DATERANGE.LAST_7_DAYS")] = [moment().subtract(6, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.LAST_30_DAYS")] = [moment().subtract(29, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.THIS_MONTH")] = [moment().startOf('month'), moment()]
            ranges[$filter('translate')("DATERANGE.LAST_MONTH")] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
            ranges[$filter('translate')("DATERANGE.THIS_YEAR")] = [moment().startOf('year'), moment()];
            
            vm.dateOptions = {
                applyClass: 'md-button md-raised',
                alwaysShowCalendars: true,
                autoUpdateInput: true,
                autoApply: true,
                locale: {
                    applyLabel: $filter('translate')("DATERANGE.APPLY"),
                    fromLabel: $filter('translate')("DATERANGE.FROM"),
                    format: "ll",
                    toLabel: $filter('translate')("DATERANGE.TO"),
                    cancelLabel: $filter('translate')("DATERANGE.CANCEL"),
                    customRangeLabel: $filter('translate')("DATERANGE.CUSTOM_RANGE"),
                    daysOfWeek: [
                        $filter('translate')("DATERANGE.SU"),
                        $filter('translate')("DATERANGE.MO"),
                        $filter('translate')("DATERANGE.TU"),
                        $filter('translate')("DATERANGE.WE"),
                        $filter('translate')("DATERANGE.TH"),
                        $filter('translate')("DATERANGE.FR"),
                        $filter('translate')("DATERANGE.SA")
                    ],
                    monthNames: [
                        $filter('translate')("DATERANGE.JANUARY"),
                        $filter('translate')("DATERANGE.FEBRUARY"),
                        $filter('translate')("DATERANGE.MARCH"),
                        $filter('translate')("DATERANGE.APRIL"),
                        $filter('translate')("DATERANGE.MAY"),
                        $filter('translate')("DATERANGE.JUNE"),
                        $filter('translate')("DATERANGE.JULY"),
                        $filter('translate')("DATERANGE.AUGUST"),
                        $filter('translate')("DATERANGE.SEPTEMBER"),
                        $filter('translate')("DATERANGE.OCTOBER"),
                        $filter('translate')("DATERANGE.NOVEMBER"),
                        $filter('translate')("DATERANGE.DECEMBER")
                    ],
                },
                ranges: ranges,
                eventHandlers: {
                    'apply.daterangepicker': changePeriod
                }
            }
        }
        translateDateRange();
        
        $rootScope.$on('$translateChangeSuccess', function () {
            translateDateRange();
        });
        
        angular.element('body').on('click', '.daterangepicker .month', function() {
            var lang = $cookies.get('lang');
            if (lang != undefined) {
                var drp = angular.element('#daterange').data('daterangepicker');
                var momentDate = moment('1 ' + angular.element(this).text(), "D MMM YYYY", lang);
                drp.setStartDate(momentDate.startOf('month'));
                drp.setEndDate(momentDate.endOf('month'));
                drp.clickApply();
            }
        })
        
        function changePeriod() {
            cache = {};
            resetChart();
            addAllNodesToGraph(selectedNodes);
        }
        
        // Zoom
        vm.zoom = 1;
        vm.zoomDocument = function (zoom) {
            switch (zoom) {
                case "in":
                    vm.zoom += 0.1;
                break;
                case "out":
                    vm.zoom -= 0.1;
                break;
                default:
                    vm.zoom = zoom;
            }
            if (vm.zoom < 0.1) vm.zoom = 0.1;
            jQuery("#report").css({"-ms-transform" : "scale(" + vm.zoom + ")", "-webkit-transform" : "scale(" + vm.zoom + ")", "transform" : "scale(" + vm.zoom + ")"});
        }
        
        // Download
        vm.downloadPDF = function() {
            var zoom = vm.zoom;
            vm.zoomDocument(1);
            var element = document.getElementById('report');
            html2pdf(element, {
                margin:       10,
                filename:     'myfile.pdf',
                image:        { type: 'jpeg', quality: 0.98 },
                html2canvas:  { dpi: 192, letterRendering: true },
                jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' }
            });
            vm.zoomDocument(zoom);
        }
        
        // Left sidebar
        
        vm.lockLeft = true;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleClose = toggleClose;
        vm.changeStatusL = changeStatusL;
        
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
        
        function toggleClose(sidenavId) {
            $mdSidenav(sidenavId).close();
        }
        
        function changeStatusL(sidenavId) {
                $mdSidenav(sidenavId).close();
                if(vm.lockLeft)
                vm.lockLeft=!vm.lockLeft;
        }
        
        
        
        
    }
})();
(function ()
{
	'use strict';
	
	angular
		.module('app.reporting')
		.controller('ReportingController', ReportingController)
		.directive('uiDraggableResizable', function() {
			return {
				restrict:'A',
				scope: {
					enabled: '=',
					callback: '&onDragResizeEvent'
				},
				link: function(scope, element, attrs) {
					
					var item = scope.$parent.block;
					
					element.css({
						'top':  item.top,
						'left': item.left,
						'width':  item.width,
						'height': item.height,
						'z-index': (100 + scope.$parent.$index)
					});
						
					element.draggable({
						containment: "parent",
						handle: ".handle",
						cursor: "move",
						create: function() {},
						start: function() {
							$(this).addClass('active'); 
						},
						stop: function() {
							$(this).removeClass('active'); 
						}
					});
					
					element.resizable({
						containment: "parent",
						minHeight: 45,
						minWidth: 45,
						create: function() {},
						start: function() {
							$(this).addClass('active'); 
						},
						stop: function() {
							$(this).removeClass('active'); 
						}
					});
					
					element.on('dragstop', function (evt, ui) {
						scope.$apply(function() {
							if (scope.callback) { 
								scope.callback({ $evt: evt, $ui: ui }); 
							}                
						})
					});
					
					element.on('resizestop', function (evt, ui) {
						scope.$apply(function() {
							if (scope.callback) { 
								scope.callback({ $evt: evt, $ui: ui }); 
							}                
						})
					});	
					
					scope.$watch('enabled', function (val) {
						element.draggable(val === true ? 'enable' : 'disable');
						element.resizable(val === true ? 'enable' : 'disable');
					});
				}
			};
		});
		
	function ReportingController($rootScope, $q, $filter, $http, $window, $translate, $cookies, $timeout, msApi, $mdSidenav, $mdDialog, $document, $scope, session, pragmaapi, PRAGMA, pragmaTheming, $base64, Notification) {
		var vm = this;
		
		vm.user = session.getUser();
		vm.user.authentication = vm.user.username + ":" + vm.user.password;
		vm.url = PRAGMA.api;
		var imagesUrl=PRAGMA.imagesURL;
		vm.currentModule = "";
		if (vm.user.hasVerticals) {
			vm.currentModule = vm.user.currentModule;
		}
		
		vm.date = {
			startDate: moment().startOf('day'),
			endDate: moment()
		};
		
		/*
		vm.smartThemes = [
			{
				name: "red",
				title: "Red",
				color: "rgb(244,67,54)"
			},
			{
				name: "orange",
				title: "Orange",
				color: "rgb(255,152,0)"
			},
			{
				name: "purple",
				title: "Purple",
				color: "rgb(156,39,176)"
			},
			{
				name: "indigo",
				title: "Indigo",
				color: "rgb(63,81,181)"
			},
			{
				name: "blue",
				title: "Blue",
				color: "rgb(59,97,166)"
			},
			{
				name: "teal",
				title: "Teal",
				color: "rgb(0,150,136)"
			},
			{
				name: "blue-grey",
				title: "Blue-Grey",
				color: "rgb(96,125,139)"
			}
		];
		vm.selectedTheme = vm.smartThemes[4];
		*/
		
		vm.blockStyle = [{
			'color': '',
			'background': '',
			'border-width': 0,
			'border-style': 'none',
			'border-color': '',
			'border-radius': 0
		}];
		
		vm.widgetTypes = {
			numeric: {
				icon: 'icon-numeric-5-box-outline'
			},
			bar: {
				icon: 'icon-chart-bar'
			},
			line: {
				icon: 'icon-chart-line'
			},
			step: {
				icon: 'icon-chart-histogram'
			},
			bubble: {
				icon: 'pragma-icon-bubble-chart'
			},
			pie: {
				icon: 'icon-chart-pie'
			},
			doughnut: {
				icon: 'icon-chart-arc'
			},
			polar: {
				icon: 'pragma-icon-polar-chart'
			},
			radar: {
				icon: 'pragma-icon-spider-chart'
			}
		};
		
		/*
		vm.widgetTypes = [
			{id:0, type: "numeric-card", name:"Numeric Widget", icon:"icon-numeric-5-box-outline", support:true},
			{id:1, type: "plot-card", name:"Bar Chart Widget", icon:"icon-chart-bar", support:true},
			{id:2, type: "plot-card", name:"Line Chart Widget", icon:"icon-chart-line", support:true},
			{id:3, type: "plot-card", name:"Step Line Chart Widget", icon:"icon-chart-histogram", support:true},
			{id:4, type: "pie-card", name:"Pie Chart Widget", icon:"icon-chart-pie", support:true},
			{id:5, type: "pie-card", name:"Doughnut Chart Widget", icon:"icon-chart-arc", support:true},
			{id:6, type: "map-card", name:"Map Widget", icon:"icon-google-maps", support:false},
			{id:7, type: "", name:"Device Control Widget", icon:"icon-television", support:false},
			{id:8, type: "hvac-card", name:"Hvac Control Widget", icon:"icon-fan", support:false},
			{id:9, type: "", name:"Entries Exits Widget", icon:"icon-repeat", support:false},
			{id:10, type: "occupancy-card", name:"Current Occupancy Widget", icon:"icon-account-multiple", support:false},
			{id:11, type: "gauge-card", name:"Gauge Widget", icon:"icon-speedometer", support:false},
			{id:12, type: "spyder-card", name:"Spyder Widget", icon:"pragma-icon-spider-chart", support:false},
			{id:13, type: "polar-card", name:"Polar Widget", icon:"pragma-icon-polar-chart", support:true},
			{id:14, type: "plot-card", name:"Bubble Widget", icon:"pragma-icon-bubble-chart", support:true},
			{id:15, type: "", name:"Light Control Widget", icon:"icon-lightbulb", support:false},
			{id:16, type: "parking-demand-hour", name:"Parking Demand Hour Widget", icon:"pragma-icon-parking-peak-hour", support:false},
			{id:17, type: "parking-occupancy", name:"Parking Occupancy Widget", icon:"pragma-icon-parking-occupancy", support:false},
			{id:18, type: "", name:"PuE Widget", icon:"icon-flash", support:false},
			{id:19, type: "lighting-status", name:"Lighting Widget", icon:"pragma-icon-lamp", support:false},
			{id:20, type: "section-widget", name:"Section Widget", icon:"icon-tag-text-outline", support:false},
			{id:21, type: "parking-lot", name:"Parking Lot Widget", icon:"icon-parking", support:false},
			{id:22, type: "waste-bin", name:"Waste Bin Widget", icon:"icon-delete-variant", support:false},
			{id:23, type: "waste-table", name:"Waste Table Widget", icon:"icon-table-large", support:false},
			{id:24, type: "ph-card", name:"PH Widget", icon:"pragma-icon-ph", support:false},
			{id:25, type: "wind-direction", name:"Wind Direction Widget", icon:"pragma-icon-windspeed", support:false},
			{id:26, type: "floor-plan", name:"Floor Plan Widget", icon:"pragma-icon-heatmap-chart", support:false}
		];
		*/
		
		vm.lang = $cookies.get("lang");
		vm.dashboardOrder = "order";
		
		// Theming
		vm.themes = pragmaTheming.themes;
		vm.themeClass = 'light';
		if (vm.themes.active.name.indexOf('Dark') >= 0) {
			vm.themeClass = 'dark';
		}
		
		vm.reportLocked = true;
		vm.activePage = null;
		vm.activeBlock = null;
		
		vm.widgetHovered = -1;
		vm.templateHovered = -1;
		//vm.layoutHovered = -1;
		vm.blockHovered = -1;
		
		vm.controlReport = controlReport;
		vm.changeReport = changeReport;
		vm.lockReport = lockReport;
		
		//vm.addTemplateToReport = addTemplateToReport;
		//vm.addThemeToReport = addThemeToReport;
		
		vm.activatePage = activatePage;
		vm.addPage = addPage;
		vm.removePage = removePage;
		
		vm.changeBlockProperties = changeBlockProperties;
		
		vm.changeWidgetDates = changeWidgetDates;
		vm.addWidgetToReport = addWidgetToReport;
		vm.removeWidgetFromReport = removeWidgetFromReport;
		vm.checkSupportedWidgetType = checkSupportedWidgetType;
		
		$scope.$on('change.module', function(event, args) {
			vm.currentModule = args.token;
			getDashboards();
		});
		
		$scope.onDragResizeEvent = function(evt,ui) {
			switch (evt.type) {
				case 'dragstop':
					vm.selectedReport.pages[vm.activePage].blocks[vm.activeBlock].top = ui.position.top;
					vm.selectedReport.pages[vm.activePage].blocks[vm.activeBlock].left = ui.position.left;
				break;
				case 'resizestop':
					vm.selectedReport.pages[vm.activePage].blocks[vm.activeBlock].width = ui.size.width;
					vm.selectedReport.pages[vm.activePage].blocks[vm.activeBlock].height = ui.size.height;
				break;
			}
		}
		
		angular.element('body')
			.on('click', '#report .blocks', function() {
				var blocks = document.getElementsByClassName('blocks');
				var zIndexMax = 0;
				for (var i = 0; i < blocks.length; ++i) {
					var zIndex = blocks[i].style.zIndex;  
					if (zIndex > zIndexMax) {
						zIndexMax = parseInt(zIndex);
					}
				}
				$(this).css('z-index', zIndexMax + 1);
			})
		
		vm.tinymceHeaderFooterOptions = {
			inline: true,
			menubar: false,
			language: vm.lang,
			plugins: ["image"],
			toolbar: "undo redo | bold italic underline strikethrough | alignleft aligncenter alignright | image",
			image_list: function(success) {
				success(vm.imageList);
			}
		};
		
		vm.tinymceOptions = {
			inline: true,
			language: vm.lang,
			selector: '',
			plugins: [
				"advlist autolink lists link image charmap print preview anchor",
				"searchreplace visualblocks code fullscreen",
				"insertdatetime media table contextmenu paste textcolor"
			],
			toolbar: "insertfile undo redo | styleselect | bold italic | forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image",
			image_list: function(success) {
				success(vm.imageList);
			},
			style_formats: [
				{title: 'Headers', items: [
					{title: 'h1', block: 'h1'},
					{title: 'h2', block: 'h2'},
					{title: 'h3', block: 'h3'},
					{title: 'h4', block: 'h4'},
					{title: 'h5', block: 'h5'},
					{title: 'h6', block: 'h6'}
				]},
				{title: 'Blocks', items: [
					{title: 'p', block: 'p'},
					{title: 'div', block: 'div'}
				]}
			],
			setup: function(editor) {
				editor.on("init", function() { });
				editor.on("click", function() { });
			}
		};
		
		init();
		
		function init() {
			getReports();
			getDashboards();
			if (vm.user.role != 'level04' && vm.user.role != 'level05') {
				getReportsTemplates();
			}
			//getTemplates();
			imageList();
		}
		
		/*
		// Themes
		function addThemeToReport(theme) {
			vm.selectedTheme = theme;
		}
		*/
		
		// Widgets
		function addWidgetToReport(type,item) {
			if (vm.activePage != null) {
				switch (type) {
					case 'format':
						var blockFormat = findObjectById(vm.blockFormats, item.id);
						var block = {type: 'format', widget: '', html: blockFormat.html, top: blockFormat.top, left: blockFormat.left, width: blockFormat.width, height: blockFormat.height, style: []};
						vm.selectedReport.pages[vm.activePage].blocks.push(block);
					break;
					case 'widget':
						if (item.dates.length == 0){
							item.dates.push({date:'custom'});
						}
						var block = {type: 'widget', widget: item, html:'', top:45, left:0, width:'698px', height:'485px', style: []};
						vm.selectedReport.pages[vm.activePage].blocks.push(block);
					break;
				}
			}
			else {
				showNotification('Insert', 'No page selected! Click on a page to insert your widget or block element!', 'Warning')
			}
		}
		
		function removeWidgetFromReport(index) {
			vm.selectedReport.pages[vm.activePage].blocks.splice(index, 1);
		}
		
		function changeWidgetDates(ev, index, widget) {
			$mdDialog.show({
				controller         : 'WidgetDatesController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/reporting/dialogs/widgetDates/widgetDates.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					index: index,
					widget: widget
				}
			}).then(function (answer) {	
				vm.selectedReport.pages[vm.activePage].blocks[index].widget.dates[0].date = answer.date;
			});
		}
		
		function checkSupportedWidgetType(type) {
			var supportedWidgetTypes = [0,1,2,4];
			if (supportedWidgetTypes.indexOf(type) === -1) {
				return false;
			}
			return true;
		}
		
		// Blocks
		function changeBlockProperties(ev, parentIndex, index, block) {
			$mdDialog.show({
				controller         : 'BlockPropertiesController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/reporting/dialogs/blockProperties/blockProperties.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					parentIndex: parentIndex,
					index: index,
					block: block
				}
			}).then(function (answer) {	

				vm.selectedReport.pages[vm.activePage].blocks[index].style = answer.block.style;
			});
		}
		
		// Pages
		function activatePage(index) {
			if (!vm.reportLocked) {
				vm.activePage = index;
			}
		}
		
		function addPage(layoutId) {
			vm.selectedReport.pages.push({blocks: []});
		}
		
		function removePage(index) {
			vm.selectedReport.pages.splice(index, 1);
		}
		
		/*
		// Templates
		function addTemplateToReport(template) {
			vm.selectedTemplate = template;
		}
		
		function getTemplates() {
			pragmaapi.callRestService(vm.url, "/reports/template/"+vm.user.currentTenant+"/", "", true, vm.user.authentication, "GET", true, false).then(function(res) {
				vm.templates = res.data.results;
			});
		}
		*/
		
		// Reports
		function getReports() {
			pragmaapi.callRestService(vm.url, "/reports/userId/"+vm.user.username+"/", "?includeTemplates=false", true, vm.user.authentication, "GET", true, false).then(function(res) {
				vm.reports = res.data.results;
			});
		}
		
		function getReportsTemplates() {
			pragmaapi.callRestService(vm.url, "/reports/userId/"+vm.user.username+"/", "?includeTemplates=true", true, vm.user.authentication, "GET", true, false).then(function(res) {
				vm.reportsTemplates = res.data.results;
			});
		}
		
		function changeReport(report) {
			vm.reportLocked = true;
			resetPageEditing()
			vm.selectedReport = report
		}
		
		function lockReport() {
			resetPageEditing()
			vm.reportLocked = !vm.reportLocked;
		}
		
		function controlReport(ev, report, action) {
			$mdDialog.show({
				controller         : 'ControlReportController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/reporting/dialogs/controlReport/controlReport.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					report:report,
					action:action,
					user:vm.user,
					url:vm.url
				}
			}).then(function(answer) {	
				getReports();
				if(vm.user.role!='level04' && vm.user.role!='level05') {
					getReportsTemplates();
				}
				//getTemplates();
			});
		}
		
		// Dashboards
		function getDashboards() {
			pragmaapi.callRestService(vm.url, "/userPreferences/userId/" + vm.user.username+"/", "", true, vm.user.authentication, "GET", true, false).then(function(res) {
				vm.userPreferencesDashboards = res.data.removedDashboards;
				pragmaapi.callRestService(vm.url, "/dashboards/userId/"+vm.user.username+"/", "?orderBy=" + vm.dashboardOrder + "&module="+vm.currentModule, true, vm.user.authentication, "GET", true, false).then(function(res) {
					vm.dashboards = [];
					for (var i = 0; i < res.data.results.length; i++) {
						var fl = 0;
						for (var j = 0; j < vm.userPreferencesDashboards.length; j++) {
							if (res.data.results[i].token === vm.userPreferencesDashboards[j]) {
								fl = 1;
							}
						}
						if (!fl) {
							vm.dashboards.push(res.data.results[i]);
						}
					}
				});
			});
		}
		
		// PDF Download
		vm.downloadPDF = downloadPDF;
		
		function downloadPDF() {
			var element = document.getElementById('report');
			jQuery(element).css({"-ms-transform" : "scale(1)", "-webkit-transform" : "scale(1)", "transform" : "scale(1)"}); // Scale back to 1
			
			var images = element.getElementsByTagName('img');
			for (i = 0; i < images.length; i++) {
				var image = images[i];
				if (image.getAttribute('width') != null) {
					image.style.width = image.getAttribute('width') + 'px';
				}
				if (image.getAttribute('height') != null) {
					image.style.height = image.getAttribute('height') + 'px';
				}
			}
			
			var request = $http({
				method: "post",
				url: PRAGMA.pdfServer+'index.php',
				data: element.outerHTML,
				headers : {
					'Access-Control-Allow-Origin' : '*',
					'Access-Control-Allow-Methods': 'HEAD, GET, POST, PUT, PATCH, DELETE, OPTIONS',
					'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
					'Authorization' : 'Basic' + $base64.encode(vm.user.authentication),
					'Content-Type' : 'text/html; charset=UTF-8'
				}
			}).then(function successCallback(response) {
				$window.open(PRAGMA.pdfServer+'cache/' + response.data.message);
				//showNotification('Pdf Creation', 'Your Report has been created!', 'Success')
			}, function errorCallback(error) {
				showNotification('Pdf Creation', 'Something went wrong!', 'Error')
			});
			
		}
		
		function findObjectById(array, id) {
			for (var i = 0; i < array.length; i++) {
				if (array[i].id === id) {
					return array[i];
				}
			}
			return null;
		}
		
		// Helper Grid
		vm.toggleGrid = toggleGrid;
		
		function toggleGrid() {
			vm.gridOnPage = !vm.gridOnPage;
		}
		
		// Reset Page Editing
		function resetPageEditing() {
			vm.activePage = null;
			vm.activeBlock = null;
			vm.gridOnPage = false;
			vm.zoomReport(1);
		}
		
		// Zoom
		vm.zoom = 1;
		vm.zoomReport = function (zoom) {
			switch (zoom) {
				case "in":
					vm.zoom += 0.1;
				break;
				case "out":
					vm.zoom -= 0.1;
				break;
				default:
					vm.zoom = zoom;
			}
			if (vm.zoom < 0.1) vm.zoom = 0.1;
			jQuery("#report").css({"-ms-transform" : "scale(" + vm.zoom + ")", "-webkit-transform" : "scale(" + vm.zoom + ")", "transform" : "scale(" + vm.zoom + ")"});
		}
		
		// Logos Directory Listing
		vm.imageList = [];
		function imageList() {
			$http({
				method: 'GET',
				url: imagesUrl,
				headers : {
					'Access-Control-Allow-Origin' : '*',
					'Access-Control-Allow-Methods': 'HEAD, GET, POST, PUT, PATCH, DELETE, OPTIONS',
					'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
					'Content-Type' : 'text/html; charset=UTF-8'
				}
			}).then(function successCallback(response) {
				for (var i = 0; i < response.data.length; i++) {
					var img = response.data[i];
					vm.imageList.push({title: img, value: 'assets/images/report/' + img});
				}
			}, function errorCallback(response) {
				console.log('Could not retrieve image list');
			});
		}
		
		// Sidenav
		vm.lockLeft = true;
		vm.lockRight = true;
		vm.showLeftSideNav = true;
		vm.toggleSidenav = toggleSidenav;
		vm.changeStatusL = changeStatusL;
		vm.changeStatusR = changeStatusR;
		vm.toggleClose = toggleClose;
		
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}
		
		function toggleClose(sidenavId) {
			$mdSidenav(sidenavId).close();
		}
		
		function changeStatusR(sidenavId) {
			$mdSidenav(sidenavId).close();
			if(vm.lockRight)
			vm.lockRight=!vm.lockRight;
		}
		
		function changeStatusL(sidenavId) {
			$mdSidenav(sidenavId).close();
			if(vm.lockLeft)
			vm.lockLeft=!vm.lockLeft;
		}
		
		// Translations
		function translateDateRange() {
			var ranges = {}
			ranges[$filter('translate')("DATERANGE.LAST_7_DAYS")] = [moment().subtract(6, 'days'), moment()];
			ranges[$filter('translate')("DATERANGE.LAST_30_DAYS")] = [moment().subtract(29, 'days'), moment()];
			ranges[$filter('translate')("DATERANGE.THIS_MONTH")] = [moment().startOf('month'), moment()]
			ranges[$filter('translate')("DATERANGE.LAST_MONTH")] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
			ranges[$filter('translate')("DATERANGE.THIS_YEAR")] = [moment().startOf('year'), moment()];
			
			vm.dateOptions = {
				applyClass: 'md-button md-raised',
				alwaysShowCalendars: true,
				locale: {
					applyLabel: $filter('translate')("DATERANGE.APPLY"),
					fromLabel: $filter('translate')("DATERANGE.FROM"),
					format: "ll",
					toLabel: $filter('translate')("DATERANGE.TO"),
					cancelLabel: $filter('translate')("DATERANGE.CANCEL"),
					customRangeLabel: $filter('translate')("DATERANGE.CUSTOM_RANGE"),
					daysOfWeek: [
						$filter('translate')("DATERANGE.SU"),
						$filter('translate')("DATERANGE.MO"),
						$filter('translate')("DATERANGE.TU"),
						$filter('translate')("DATERANGE.WE"),
						$filter('translate')("DATERANGE.TH"),
						$filter('translate')("DATERANGE.FR"),
						$filter('translate')("DATERANGE.SA")
					],
					monthNames: [
						$filter('translate')("DATERANGE.JANUARY"),
						$filter('translate')("DATERANGE.FEBRUARY"),
						$filter('translate')("DATERANGE.MARCH"),
						$filter('translate')("DATERANGE.APRIL"),
						$filter('translate')("DATERANGE.MAY"),
						$filter('translate')("DATERANGE.JUNE"),
						$filter('translate')("DATERANGE.JULY"),
						$filter('translate')("DATERANGE.AUGUST"),
						$filter('translate')("DATERANGE.SEPTEMBER"),
						$filter('translate')("DATERANGE.OCTOBER"),
						$filter('translate')("DATERANGE.NOVEMBER"),
						$filter('translate')("DATERANGE.DECEMBER")
					],
				},
				ranges: ranges,
				eventHandlers: {
					'apply.daterangepicker': vizualizeData
				}
			}
			
			vm.blockFormats = [
				{
					id:'h1',
					icon:'icon-format-header-1',
					title:$filter('translate')("REPORTS.HEADING"),
					html: '<h1></h1>',
					top:10,
					left:10,
					width:'698px',
					height:'45px'
				},
				{
					id:'p',
					icon:'icon-format-paragraph',
					title:$filter('translate')("REPORTS.PARAGRAPH"),
					html: '<p></p>',
					top:10,
					left:10,
					width:'349px',
					height:'485px'
				}
			];
			
			// Page Layouts
			vm.layouts = [
				{
					id: "empty-page",
					name: $filter('translate')("REPORTS.PAGE_LAYOUTS.EMPTY_PAGE"),
					blocks: []
				},
				{
					id: "single-column",
					name: $filter('translate')("REPORTS.PAGE_LAYOUTS.SINGLE_COLUMN"),
					blocks: [
						{top:0,  left:0, width:'698px', height:'45px'},
						{top:45, left:0, width:'698px', height:'925px'}
					]
				},
				{
					id: "two-rows",
					name: $filter('translate')("REPORTS.PAGE_LAYOUTS.TWO_ROWS"),
					blocks: [
						{top:0,   left:0, width:'698px', height:'485px'},
						{top:485, left:0, width:'698px', height:'485px'}
					]
				},
				{
					id: "two-columns",
					name: $filter('translate')("REPORTS.PAGE_LAYOUTS.TWO_COLUMNS"),
					blocks: [
						{top:0, left:0,    width:'698px', height:'45px'},
						{top:45, left:0,   width:'349px', height:'925px'},
						{top:45, left:349, width:'349px', height:'925px'}
					]
				},
				{
					id: "one-column-two-rows",
					name: $filter('translate')("REPORTS.PAGE_LAYOUTS.ONE_COLUMN_TWO_ROWS"),
					blocks: [
						{top:0,   left:0,   width:'349px', height:'970px'},
						{top:0,   left:349, width:'349px', height:'485px'},
						{top:485, left:349, width:'349px', height:'485px'}
					]
				},
				{
					id: "four-grid",
					name: $filter('translate')("REPORTS.PAGE_LAYOUTS.FOUR_GRID"),
					blocks: [
						{top:0,   left:0,   width:'349px', height:'485px'},
						{top:0,   left:349, width:'349px', height:'485px'},
						{top:485, left:0,   width:'349px', height:'485px'},
						{top:485, left:349, width:'349px', height:'485px'}
					]
				}
			];
			
        }
		translateDateRange();
		
		function vizualizeData(){}
		
		$rootScope.$on('$translateChangeSuccess', function () {
			translateDateRange();
		});
		
		function showNotification(title, message, type) {
			if (type === "Error") {
				Notification.error({
					title:title,
					message: message,
					delay: 3000,
					positionX:"right",
					positionY:"bottom"
				});
			}
			else if (type === "Info") {
				Notification.info({
					title:title,
					message: message,
					delay: 3000,
					positionX:"right",
					positionY:"bottom"
				});
			}
			else if (type === "Warning") {
				Notification.warning({
					title:title,
					message: message,
					delay: 3000,
					positionX:"right",
					positionY:"bottom"
				});
			}
			else if (type === "Success") {   
				Notification.success({
					title:title,
					message: message,
					delay: 3000,
					positionX:"right",
					positionY:"bottom"
				});
			}   
		}
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.preferences', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.preferences', {
            url      : '/preferences',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/preferences/preferences.html',
                    controller : 'PreferencesController as vm'
                }
            },
            bodyClass: 'home'
        });

		
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.preferences')
        .controller('PreferencesController', PreferencesController);

    /** @ngInject */
    function PreferencesController($state, $scope, $mdSidenav, session, pragmaTheming, PRAGMA, pragmaapi, $translate, $cookies, ipnConfig, Notification)
    {
        var vm = this;
		vm.master = {
                language:"en",
                palette:"default"
            };
		vm.checkDialCode = checkDialCode;
		vm.submit = submit;
		
		ipnConfig.nationalMode = false;
		//ipnConfig.numberType = "FIXED_LINE";
		//Default placehorder number type is mobile
		//ipnConfig.numberType = "MOBILE";
		
		// Theming
		vm.themes = pragmaTheming.themes;
		// Languages
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'PREFERENCES.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
			el: {
                'title'      : 'Greek',
                'translation': 'PREFERENCES.GREEK',
                'code'       : 'el',
                'flag'       : 'el'
			}
        };
		
		// User
		vm.user = session.getUser();
		vm.user.authentication = vm.user.username + ":" + vm.user.password;
		
		// User Data
		pragmaapi.callRestService(PRAGMA.api, "/users/" + vm.user.username+"/", "", true, vm.user.authentication, "GET", true, false).then(function(res){
            //console.log(res.data);
			vm.master.userData = {
				username:res.data.username,
				firstName:res.data.firstName,
				lastName:res.data.lastName,
				metadata:res.data.metadata
			};
			if(!res.data.metadata.phone)
				vm.master.userData.metadata["phone"]="";
			//	console.log(vm.master.userData);
		});
		
		// User Preferences
		pragmaapi.callRestService(PRAGMA.api, "/userPreferences/userId/" + vm.user.username+"/", "", true, vm.user.authentication, "GET", true, false).then(function(res){
            vm.userPreferences=res.data;
			if(vm.userPreferences.language!=="")
                vm.master.language=vm.userPreferences.language;
            if(Object.keys(vm.userPreferences.palette).length>0)
                vm.master.palette=Object.keys(vm.userPreferences.palette)[0];
		});
		
		function submit(master) {
            
			var tmp={};
            tmp[master.palette]=vm.themes.list[master.palette]
            var message=
            {
                token:vm.userPreferences.token,
                removedDashboards:vm.userPreferences.removedDashboards,
                trees:vm.userPreferences.trees,
                userId:vm.userPreferences.userId,
                language:master.language,
                palette:tmp
            }
            
			pragmaapi.callRestService(PRAGMA.api, "/userPreferences/" + message.token, message, true, vm.user.authentication, "PUT", true, false).then(function(res){
                $translate.use(message.language);
                moment.locale(message.language)
                // Cookie
                var expireDate = new Date();
                expireDate.setDate(expireDate.getDate() + 365);
                $cookies.put("lang", message.language, {'expires': expireDate})                
                pragmaTheming.setActiveTheme(Object.keys(message.palette)[0]);
            });
			
			var user=
			{
				username:vm.master.userData.username,
				firstName:vm.master.userData.firstName,
				lastName:vm.master.userData.lastName,
				metadata:vm.master.userData.metadata
			};
			if (vm.master.userData.password)
				user["password"] = vm.master.userData.password;
			if(vm.master.userData.metadata.phone==="" || vm.master.userData.metadata.phone===angular.element("#phone").intlTelInput("getSelectedCountryData").dialCode)
				delete vm.master.userData.metadata.phone;
			else
				vm.master.userData.metadata.phone=angular.element("#phone").intlTelInput("getNumber");
			console.log(user);
			
			pragmaapi.callRestService(PRAGMA.api,"/users/"+vm.user.username,user,true,vm.user.authentication,"PUT").then(function(res){
				showNotification($translate.instant("PREFERENCES.USER_PREFERENCES"), $translate.instant("PREFERENCES.SUCCESS"),"Success");
			},function(reason) {
				showNotification($translate.instant("PREFERENCES.USER_PREFERENCES"), $translate.instant("PREFERENCES.ERROR"), "Error");
			});
			//$state.go("app.dashboard");
		}
		
		function checkDialCode(el){
			if (vm.master.userData.metadata.phone===angular.element("#phone").intlTelInput("getSelectedCountryData").dialCode) {
				el.preferencesForm.$setPristine();
			}
		}
		
        function showNotification(title, message, type) {
            if (type === "Error") {
                Notification.error({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Info") {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Warning") {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Success") {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }   
        }
		
    };

})();
(function ()
{
    'use strict';

    angular
        .module('app.prediction', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.prediction', {
            url      : '/prediction',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/prediction/prediction.html',
                    controller : 'PredictionController as vm'
                }
            },
            bodyClass: 'prediction'
        });

        msNavigationServiceProvider.saveItem('prediction', {
            title : 'NAVIGATION.PREDICTION',
            state: 'app.prediction',
            group : true,
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.prediction')
        .controller('PredictionController', PredictionController);

    function PredictionController($q, $scope, $element, $http, $filter, $cookies, $mdSidenav, msApi, session, $rootScope, $mdDialog, $document, $base64, Notification, filterFilter, dateFilter, PRAGMA, pragmaapi, $translate)
    {
        var vm = this;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        vm.toggleSidenav = toggleSidenav;
        vm.changeStatusL=changeStatusL;
        vm.lockLeft=true;
        vm.triggered=false;
        vm.setChartType=setChartType;
        vm.chartAggregated=null;
        vm.showGraph=false;
        vm.saveImage=saveImage;
        vm.exportCsv=exportCsv;
		vm.applyD = false;

        function exportCsv() 
        {
            
            if (vm.chartAggregated != null) {
                var csvContent = "data:text/csv;charset=utf-8,";
                for(var i=0;i<vm.chartAggregated.data.datasets.length;i++)
                {
                    var label=vm.chartAggregated.data.datasets[i].label;
                    csvContent+='"'+label+'"'+";";
                }
                csvContent+='"timestamp"'+"";
                csvContent+="\n";
                for(var j=0;j<vm.chartAggregated.data.datasets[0].data.length;j++)
                {
                    for(var i=0;i<vm.chartAggregated.data.datasets.length;i++)
                    {
                        var label=vm.chartAggregated.data.datasets[i].data[j];
                        csvContent+='"'+label+'"'+";";
                    }
                    var label=vm.chartAggregated.data.labels[j];
                    csvContent+='"'+label+'"'+"";
                    csvContent+="\n";
                }
                var encodedUri = encodeURI(csvContent);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", "raw_data.csv");
                document.body.appendChild(link); // Required for FF
                link.click();
            }
            else
            {
                Notification("No Predicted Data Available!");
            }
        }

        function saveImage(element) 
        {
            if (vm.chartAggregated != null) {
                var url_base64 = document.getElementById(element).toDataURL('image/png');
                var link = document.createElement("a");
                link.setAttribute("href", url_base64);
                link.setAttribute("download", "prediction.png");
                document.body.appendChild(link); // Required for FF
                link.click();
            }
            else
            {
                Notification("No Predicted Data Available!");
            }
        }
        vm.chartType='line';
        var filter={
            device:{},
            site:{},
            specification:{},
            includeDevices:true,
            includeMeasurements:true,
            specs:[],
            measurements:{}
        };
        vm.currentModule=vm.user.currentModule;
        vm.parentModule=vm.user.parentModule;
        if(vm.currentModule==='' || vm.parentModule==='#')
        {
            vm.filter={
                device:{},
                site:{},
                specification:{},
                includeDevices:true,
                includeMeasurements:true,
                specs:[],
                measurements:{}
            };
        }
        else
        {
            vm.filter={
                device:[{modules:[vm.currentModule]}],
                site:{},
                specification:{},
                includeDevices:true,
                includeMeasurements:true,
                specs:[],
                measurements:{}
            };
        }
        $scope.$on('change.module', function(event, args) {
            vm.showTree=false;
            if(args.parent==='#')
            {
                vm.filter={
                    device:{},
                    site:{},
                    specification:{},
                    includeDevices:true,
                    includeMeasurements:true,
                    specs:[],
                    measurements:{}
                };
            }
            else
            {
                vm.filter={
                    device:[{modules:[args.token]}],
                    site:{},
                    specification:{},
                    includeDevices:true,
                    includeMeasurements:true,
                    specs:[],
                    measurements:{}
                };
            }
            refreshTree();
        });
        refreshTree();
        function refreshTree()
        {
            pragmaapi.getTreeDataFilter(vm.filter).then(function(treeData) {
                vm.treeData =processTreeData(treeData);
                vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow']);
                vm.versionNo++;
                vm.treeConfig.version = vm.versionNo;
                vm.showTree=true;
            });
        }
        function processTreeData(treeData) {
            var groupIds=[];
            var siteIds=[];
            var tenantIds=[];
            var portfolioIds=[];
            treeData=removeNoPrediction(treeData);
            for(var i=0;i<treeData.length;i++)
            {
                if(treeData[i].type==="deviceGroup")
                {
                    groupIds.push(treeData[i].id)
                }
                else if(treeData[i].type==="site")
                {
                    siteIds.push(treeData[i].id)
                }
                else if(treeData[i].type==="portfolio")
                {
                    portfolioIds.push(treeData[i].id)
                }
                else if(treeData[i].type==="client")
                {
                    tenantIds.push(treeData[i].id)
                }
            }
            treeData=removeEmpty(treeData,groupIds);
            treeData=removeEmpty(treeData,siteIds);
            treeData=removeEmpty(treeData,portfolioIds);
            treeData=removeEmpty(treeData,tenantIds);
            for(var i=0;i<treeData.length;i++)
            {
                treeData[i]["__uiNodeId"]=i+1;
            }
            return treeData;
        }

        function removeNoPrediction(treeData)
        {
            for(var i=0;i<treeData.length;i++)
            {
                if(treeData[i].type==="device")
                {
                    var meta=JSON.parse(treeData[i].metadata)
                    if(typeof meta.prediction==='undefined')
                    {
                        for(var k=0;k<treeData.length;k++)
                        {
                            if(treeData[k].type==="measurement")
                            {
                                if(treeData[k].parent===treeData[i].id)
                                {
                                    treeData.splice(k,1);
                                    k--;
                                }
                            }
                        }
                        treeData.splice(i,1);
                        i--;
                    }
                    else
                    {
                        if(meta.prediction=="")
                        {
                            for(var k=0;k<treeData.length;k++)
                            {
                                if(treeData[k].type==="measurement")
                                {
                                    if(treeData[k].parent===treeData[i].id)
                                    {
                                        treeData.splice(k,1);
                                        k--;
                                    }
                                }
                            }
                            treeData.splice(i,1);
                            i--;
                        }
                        else
                        {
                            var predVars=meta.prediction.split(",");
                            for(var k=0;k<treeData.length;k++)
                            {
                                if(treeData[k].type==="measurement")
                                {
                                    if(treeData[k].parent===treeData[i].id)
                                    {
                                        var fl=false;
                                        for(var l=0;l<predVars.length;l++)
                                        {
                                            if(treeData[k].measure==predVars[l])
                                            {
                                                fl=true;
                                            }
                                        }
                                        if(!fl)
                                        {
                                            treeData.splice(k,1);
                                            k--;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return treeData;
        }
        function removeEmpty(tree,ids)
        {
            var fl=false;
            var groupT=-1;
            for(var j=0;j<ids.length;j++)
            {
                fl=false;
                groupT=-1;
                for(var i=0;i<tree.length;i++)
                {
                    if (tree[i].id==ids[j])
                    {
                        groupT=i;
                    }
                    if(tree[i].parent==ids[j])
                    {
                        fl=true;
                    }
                }
                if(!fl)
                {
                    tree.splice(groupT,1);
                }
            }
            return tree;
        }
        /*pragmaapi.getTreeData(true, true,true,true).then(function(treeData) {
            vm.treeData = treeData;
            vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow']);
            vm.versionNo++;
            vm.treeConfig.version = vm.versionNo;
        });*/
        // Date Range
        vm.date = {
          startDate: moment().startOf('day'),
          endDate: moment()
        };
        function setChartType(chartType) {
            vm.chartType = chartType;
            angular.element(".chartType-button").removeClass('active').addClass('md-raised');
            angular.element("." + chartType + "-button").removeClass('md-raised').addClass('active');
            vm.chartType=chartType;
            vizualizeData();
        }
        vm.applySearch = function () {
            if (vm.treeInstance) {
                vm.treeInstance.jstree(true).search(vm.searchtree);
            }
        };
        vm.treeEvents = {
            'ready': readyCB,
            'create_node': createNodeCB,
            'select_node': getSelectedNodes,
            'deselect_node': getSelectedNodes
        }
        function getSelectedNodes() {
            if(vm.triggered)
            {
                 vm.triggered=false;
            }
            else
            {
                vm.triggered=true;
                vm.selected_nodes=[];
                vm.selectedNode = {};
                var siteToken="";
                var authenticationToken="";
                var jstree = vm.treeInstance.jstree(true);
                vm.selected_nodes = jstree.get_selected();
                if (vm.selected_nodes[0]) {
                    vm.selectedNode = jstree.get_node(vm.selected_nodes[0]);
                }
                for (var i = 0; i < vm.treeData.length; i++) {
                    if(vm.treeData[i].type=='measurement' && vm.treeData[i].id==vm.selectedNode.id)
                    {
                        vm.tenantAuthToken=vm.treeData[i].tenantAuthToken;
                        vm.measurement=vm.treeData[i].measure;
                        vm.unit=vm.treeData[i].specs.unit;
                        vm.selectedToken=vm.treeData[i].token;
                        vm.friendlyName=vm.treeData[i].text;
                        vizualizeData();
                        break;
                    }
                }
            }
        }

        function createNodeCB() {}
        
        function readyCB() {}

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
        function changeStatusL(sidenavId) {
            $mdSidenav(sidenavId).close();
            if(vm.lockLeft)
                vm.lockLeft=!vm.lockLeft;
        }
        translateDateRange();
        
        $rootScope.$on('$translateChangeSuccess', function () {
            translateDateRange();
        });

        function translateDateRange() {
            var ranges = {}
            ranges[$filter('translate')("DATERANGE.LAST_7_DAYS")] = [moment().subtract(6, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.LAST_30_DAYS")] = [moment().subtract(29, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.THIS_MONTH")] = [moment().startOf('month'), moment()]
            ranges[$filter('translate')("DATERANGE.LAST_MONTH")] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
            ranges[$filter('translate')("DATERANGE.THIS_YEAR")] = [moment().startOf('year'), moment()];
            
            vm.dateOptions = {
                applyClass: 'md-button md-raised',
                alwaysShowCalendars: true,
                locale: {
                    applyLabel: $filter('translate')("DATERANGE.APPLY"),
                    fromLabel: $filter('translate')("DATERANGE.FROM"),
                    format: "ll",
                    toLabel: $filter('translate')("DATERANGE.TO"),
                    cancelLabel: $filter('translate')("DATERANGE.CANCEL"),
                    customRangeLabel: $filter('translate')("DATERANGE.CUSTOM_RANGE"),
                    daysOfWeek: [
                        $filter('translate')("DATERANGE.SU"),
                        $filter('translate')("DATERANGE.MO"),
                        $filter('translate')("DATERANGE.TU"),
                        $filter('translate')("DATERANGE.WE"),
                        $filter('translate')("DATERANGE.TH"),
                        $filter('translate')("DATERANGE.FR"),
                        $filter('translate')("DATERANGE.SA")
                    ],
                    monthNames: [
                        $filter('translate')("DATERANGE.JANUARY"),
                        $filter('translate')("DATERANGE.FEBRUARY"),
                        $filter('translate')("DATERANGE.MARCH"),
                        $filter('translate')("DATERANGE.APRIL"),
                        $filter('translate')("DATERANGE.MAY"),
                        $filter('translate')("DATERANGE.JUNE"),
                        $filter('translate')("DATERANGE.JULY"),
                        $filter('translate')("DATERANGE.AUGUST"),
                        $filter('translate')("DATERANGE.SEPTEMBER"),
                        $filter('translate')("DATERANGE.OCTOBER"),
                        $filter('translate')("DATERANGE.NOVEMBER"),
                        $filter('translate')("DATERANGE.DECEMBER")
                    ],
                },
                ranges: ranges,
                eventHandlers: {
                    'apply.daterangepicker': vizualizeData
                }
            }
        }
        
        vm.options = {
			maintainAspectRatio: false,
			spanGaps: false,
            legend: {
                display: true,
                position: "top"
            },
            tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        return parseFloat(tooltipItem.yLabel).toFixed(2) + " " + vm.unit;
                    }
                }
            },
            responsive: true,
            animation: {
                duration: 800
            },
			elements: {
				line: {
					tension: 0.000001
				}
			},
			scales: {
				yAxes: [{
					stacked: false
				}]
			},
			plugins: {
				filler: {
					propagate: false
				},
				samples_filler_analyser: {
					target: 'chart-aggregated-canvas'
				}
			}
		};
        var fillBetweenLinesPlugin = {
            afterDatasetsDraw: function (chart) {
                var ctx = chart.chart.ctx;
                var xaxis = chart.scales['x-axis-0'];
                var yaxis = chart.scales['y-axis-0'];
                var datasets = chart.data.datasets;
                ctx.save();

                for (var d = 0; d < datasets.length; d++) {
                    var dataset = datasets[d];
                    if (dataset.fillBetweenSet == undefined) {
                        continue;
                    }

                    // get meta for both data sets
                    var meta1 = chart.getDatasetMeta(d);
                    var meta2 = chart.getDatasetMeta(dataset.fillBetweenSet);
                    
                    // do not draw fill if one of the datasets is hidden
                    if (meta1.hidden || meta2.hidden) continue;
                    
                    // create fill areas in pairs
                    for (var p = 0; p < meta1.data.length-1;p++) {
                        // if null skip
                    if (dataset.data[p] == null || dataset.data[p+1] == null) continue;
                    
                    ctx.beginPath();
                    
                    // trace line 1
                    var curr = meta1.data[p];
                    var next = meta1.data[p+1];
                    ctx.moveTo(curr._view.x, curr._view.y);
                    ctx.lineTo(curr._view.x, curr._view.y);
                    if (curr._view.steppedLine === true) {
                        ctx.lineTo(next._view.x, curr._view.y);
                        ctx.lineTo(next._view.x, next._view.y);
                    }
                    else if (next._view.tension === 0) {
                        ctx.lineTo(next._view.x, next._view.y);
                    }
                    else {
                        ctx.bezierCurveTo(
                            curr._view.controlPointNextX,
                            curr._view.controlPointNextY,
                            next._view.controlPointPreviousX,
                            next._view.controlPointPreviousY,
                            next._view.x,
                            next._view.y
                        );
                                    }
                    
                    // connect dataset1 to dataset2
                    var curr = meta2.data[p+1];
                    var next = meta2.data[p];
                    ctx.lineTo(curr._view.x, curr._view.y);

                    // trace BACKWORDS set2 to complete the box
                    if (curr._view.steppedLine === true) {
                        ctx.lineTo(curr._view.x, next._view.y);
                        ctx.lineTo(next._view.x, next._view.y);
                    }
                    else if (next._view.tension === 0) {
                        ctx.lineTo(next._view.x, next._view.y);
                    }
                    else {
                        // reverse bezier
                        ctx.bezierCurveTo(
                        curr._view.controlPointPreviousX,
                        curr._view.controlPointPreviousY,
                        next._view.controlPointNextX,
                        next._view.controlPointNextY,
                        next._view.x,
                        next._view.y
                        );
                    }

                                    // close the loop and fill with shading
                    ctx.closePath();
                    ctx.fillStyle = dataset.fillBetweenColor || "rgba(0,0,0,0.1)";
                    ctx.fill();
                    } // end for p loop
                }
            } // end afterDatasetsDraw
        }; // end fillBetweenLinesPlugin
        Chart.pluginService.register(fillBetweenLinesPlugin);
        function checkIfOk()
        {
            vm.ifOk++;
            if(vm.ifOk==4)
            {
                vm.showGraph=true;
                var type=vm.chartType;
                var ctx = document.getElementById("chart-aggregated-canvas");
                if(vm.chartAggregated==null)
                {
                        vm.chartAggregated = new Chart(ctx, {
                        type: type,
                        data: { labels: vm.labels, datasets : vm.datasets },
                        options: vm.options
                    });
                }
                else
                {
                    vm.chartAggregated.destroy();
                    vm.chartAggregated = new Chart(ctx, {
                        type: type,
                        data: { labels: vm.labels, datasets : vm.datasets },
                        options: vm.options
                    });
                }
            }
        }
        function vizualizeData() {
            if (vm.applyD) {
				console.log("Apply only the Date");
				//do not redraw the chart just apply the date
				vm.applyD = false;
				return;
			}
			vm.datasets=[{},{},{},{}];
            vm.labels=[];
            vm.ifOk=0;
            vm.showGraph=false;
            var aggregatedType="mean";
            if(vm.measurement==="entries")
            {
                aggregatedType="sum";
            }
            var measurements=vm.measurement+","+vm.measurement+"_max,"+vm.measurement+"_min,"+vm.measurement+"_median,"+vm.measurement+"_ci_lower,"+vm.measurement+"_ci_upper,"+vm.measurement+"_preds";
            var upperM=vm.measurement+"_ci_upper";
            var lowerM=vm.measurement+"_ci_lower";
            var predsM=vm.measurement+"_preds";
            if(typeof vm.measurement!=='undefined')
            {
               /* pragmaapi.callRestService(PRAGMA.api,"/assignments/" +  vm.selectedToken + "/measurementsAggregated","?page=1&pageSize=1000&startDate="+encodeURIComponent(moment(vm.date.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0200")+"&endDate="+encodeURIComponent(moment(vm.date.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0200")+"&resolutionType=m&resolution=5&type="+aggregatedType+"&measuredParameter="+vm.measurement+"&tenantAuthToken=" + vm.tenantAuthToken, true, vm.user.authentication, "GET", true).then(function(res){
                    var foo=res.data.data;
                    var tmpData=[];
                    for(var i=0;i<foo.length;i++)
                    {
                        tmpData.push(foo[i].d);
                        var dt=moment.unix(foo[i].t/1000).format("DD/MM HH:mm");
                        vm.labels.push(dt);
                    }
                    vm.datasets[0]={
                        pointRadius:1,
                        backgroundColor:"rgba(4,9,242,0)",
                        borderColor:"rgba(4,9,242,1)",
                        label:vm.friendlyName,
                        type:vm.chartType,
                        data:tmpData,
                        fill:false,
                        hidden:false
                    };
                    checkIfOk();
                });
                pragmaapi.callRestService(PRAGMA.api,"/assignments/" +  vm.selectedToken + "/measurementsAggregated","?page=1&pageSize=1000&startDate="+encodeURIComponent(moment(vm.date.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0200")+"&endDate="+encodeURIComponent(moment(vm.date.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0200")+"&resolutionType=m&resolution=5&type="+aggregatedType+"&measuredParameter="+upperM+"&tenantAuthToken=" + vm.tenantAuthToken, true, vm.user.authentication, "GET", true).then(function(res){
                    var foo=res.data.data;
                    var tmpData=[];
                    for(var i=0;i<foo.length;i++)
                    {
                        tmpData.push(foo[i].d);
                    }
                    vm.datasets[1]={
                        pointRadius:1,
                        backgroundColor:"rgba(255,152,0,0)",
                        borderColor:"rgba(255,152,0,1)",
                        label:"Maximum Predicted Value",
                        type:"line",
                        data:tmpData,
                        fill:false,
                        hidden:false,
                        fillBetweenSet:2,
                        fillBetweenColor: "rgba(255,152,0, 0.2)"
                    };
                    checkIfOk();
                });
                pragmaapi.callRestService(PRAGMA.api,"/assignments/" +  vm.selectedToken + "/measurementsAggregated","?page=1&pageSize=1000&startDate="+encodeURIComponent(moment(vm.date.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0200")+"&endDate="+encodeURIComponent(moment(vm.date.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0200")+"&resolutionType=m&resolution=5&type="+aggregatedType+"&measuredParameter="+lowerM+"&tenantAuthToken=" + vm.tenantAuthToken, true, vm.user.authentication, "GET", true).then(function(res){
                    var foo=res.data.data;
                    var tmpData=[];
                    for(var i=0;i<foo.length;i++)
                    {
                        tmpData.push(foo[i].d);
                    }
                    vm.datasets[2]={
                        pointRadius:1,
                        backgroundColor:"rgba(255,152,0,0)",
                        borderColor:"rgba(255,152,0,1)",
                        label:"Minimum Predicted Value",
                        type:"line",
                        data:tmpData,
                        fill:false,
                        hidden:false
                    };
                    checkIfOk();
                });
                pragmaapi.callRestService(PRAGMA.api,"/assignments/" +  vm.selectedToken + "/measurementsAggregated","?page=1&pageSize=1000&startDate="+encodeURIComponent(moment(vm.date.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0200")+"&endDate="+encodeURIComponent(moment(vm.date.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0200")+"&resolutionType=m&resolution=5&type="+aggregatedType+"&measuredParameter="+predsM+"&tenantAuthToken=" + vm.tenantAuthToken, true, vm.user.authentication, "GET", true).then(function(res){
                    var foo=res.data.data;
                    var tmpData=[];
                    for(var i=0;i<foo.length;i++)
                    {
                        tmpData.push(foo[i].d);
                    }
                    vm.datasets[3]={
                        pointRadius:1,
                        backgroundColor:"rgba(0,204,24,0)",
                        borderColor:"rgba(0,204,24,1)",
                        label:"Mean Predicted Value",
                        type:vm.chartType,
                        data:tmpData,
                        fill:false,
                        hidden:false,
                        borderDash: [6, 2]
                    };
                    checkIfOk();
                });*/
                    var dtZone = new Date(vm.date.startDate).toString().split(" ");
                    var timeZoneFormattedArray = dtZone[5].split("GMT");
                    vm.timeZone=timeZoneFormattedArray[1];
					pragmaapi.callRestService(PRAGMA.api,"/assignments/" +  vm.selectedToken + "/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.date.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.date.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+measurements+"&tenantAuthToken=" + vm.tenantAuthToken, true, vm.user.authentication, "GET", true).then(function(res){
                    if(res.data.length<4)
                    {
                        Notification("No Predicted Data Available!");
                        vm.chartAggregated=null;
                    }
                    else
                    {
                        vm.showGraph=true;
                        var type=vm.chartType;
                        var datasets=[];
                        var labels=[];
                        var tmpMin=0
						
						var count = res.data[0].entries.length - 1;
						if (vm.date.endDate.format('DDD') !== moment(res.data[0].entries[count].measurementDate).format('DDD')) {
							vm.applyD = true;
							vm.date.endDate = moment(res.data[0].entries[count].measurementDate);
							//reApply datepicker
							var drp = angular.element('#daterange').data('daterangepicker');
							drp.autoUpdateInput = true;
							drp.setEndDate(vm.date.endDate);
							drp.clickApply();
							showNotification($translate.instant("EXPLORE.OUT_OF_RANGE"), $translate.instant("EXPLORE.OVER_LIMIT"),"Info");
						}
						else {
							console.log("in range");
						}
						
						
                        for(var i=0;i<res.data.length;i++)
                        {
                            var fooFill=res.data[i];
                            if(fooFill.measurementId==vm.measurement+"_min" || fooFill.measurementId==vm.measurement+"_ci_lower")
                            {
                                tmpMin=i;
                            }
                        }
                        for(var i=0;i<res.data.length;i++)
                        {
                            var foo=res.data[i];
                            var tmpData=[];
                            for(var j=0;j<foo.entries.length;j++)
                            {
                                tmpData.push(foo.entries[j].value)
                                if(foo.measurementId===vm.measurement+"_max" || foo.measurementId===vm.measurement+"_ci_upper")
                                {
                                    var dd=new Date(foo.entries[j].measurementDate);
                                    var date=moment(dd).format("HH:mm (D/M)")
                                    labels.push(date)
                                }
                            }
                            if(foo.measurementId===vm.measurement+"_max" || foo.measurementId===vm.measurement+"_ci_upper")
                            {
                                var tmpDataset={
                                    pointRadius:1,
                                    backgroundColor:"rgba(255,152,0,0)",
                                    borderColor:"rgba(255,152,0,1)",
                                    label:"Maximum Predicted Value",
                                    type:"line",
                                    data:tmpData,
                                    fill:false,
                                    hidden:false,
                                    fillBetweenSet:tmpMin,
                                    fillBetweenColor: "rgba(255,152,0, 0.2)"
                                };
                            }
                            else if(foo.measurementId===vm.measurement+"_min" || foo.measurementId===vm.measurement+"_ci_lower")
                            {
                                var tmpDataset={
                                    pointRadius:1,
                                    backgroundColor:"rgba(255,152,0,0)",
                                    borderColor:"rgba(255,152,0,1)",
                                    label:"Minimum Predicted Value",
                                    type:"line",
                                    data:tmpData,
                                    fill:false,
                                    hidden:false
                                };
                            }
                            else if(foo.measurementId===vm.measurement+"_median" || foo.measurementId===vm.measurement+"_preds")
                            {
                                var tmpDataset={
                                    pointRadius:1,
                                    backgroundColor:"rgba(0,204,24,0)",
                                    borderColor:"rgba(0,204,24,1)",
                                    label:"Mean Predicted Value",
                                    type:vm.chartType,
                                    data:tmpData,
                                    fill:false,
                                    hidden:false,
                                    borderDash: [6, 2]
                                };
                            }
                            else
                            {
                                var tmpDataset={
                                    pointRadius:1,
                                    backgroundColor:"rgba(4,9,242,0)",
                                    borderColor:"rgba(4,9,242,1)",
                                    label:vm.friendlyName,
                                    type:vm.chartType,
                                    data:tmpData,
                                    fill:false,
                                    hidden:false
                                };
                            }
                            datasets.push(tmpDataset)
                        }
                        var ctx = document.getElementById("chart-aggregated-canvas");
                        if(vm.chartAggregated==null)
                        {
                             vm.chartAggregated = new Chart(ctx, {
                                type: type,
                                data: { labels: labels, datasets : datasets },
                                options: vm.options
                            });
                        }
                        else
                        {
                            vm.chartAggregated.destroy();
                            vm.chartAggregated = new Chart(ctx, {
                                type: type,
                                data: { labels: labels, datasets : datasets },
                                options: vm.options
                            });
                        }
                    }
                });
            }
            else
            {
                 Notification("Please select a monitor point first!");
            }
        }
		
        function showNotification(title, message, type) {
            if (type === "Error") {
                Notification.error({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Info") {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: 10000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Warning") {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Success") {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }   
        }
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notification')
        .controller('NotificationController', NotificationController);

    /** @ngInject */
    function NotificationController($rootScope,$q, msApi, $mdSidenav, $mdDialog, $document, $scope, session, pragmaapi,PRAGMA,$timeout)
    {
        var vm = this;	
        // User
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        vm.notifications=[];
        vm.currentPage=1;
        vm.calendarEvents = [[]];
        vm.siteTokens=[];
        vm.toggleSidenav = toggleSidenav;
        vm.calendarType="today";
        vm.sitesService="all";
        vm.PageSize=5;
        vm.showcalendar=false;
        vm.changeStatusL = changeStatusL;
        vm.dirty=true;
        vm.triggered=false;
        vm.table={};
        vm.lockLeft=true;
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
        function changeStatusL(sidenavId) {
            $mdSidenav(sidenavId).close();
            if(vm.lockLeft)
                vm.lockLeft=!vm.lockLeft;
        }
        vm.date = {
          startDate: moment().startOf('month'),
          endDate: moment()
        };
        getNotifications();
        vm.eventsOptions = {
            scrollEl: '#notificationsScroll'
        };
        vm.changeCalendarDate=changeCalendarDate;
        vm.selectedNode = {};
        vm.applySearch = function () {
            if (vm.treeInstance) {
                vm.treeInstance.jstree(true).search(vm.searchtree);
            }
        };
        pragmaapi.getTreeData(true, false,false,false).then(function(treeData) {
            vm.treeData = treeData;
            vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'checkbox']);
        });
        vm.treeEvents = {
            'ready': readyCB,
            'create_node': createNodeCB,
            'select_node': getSelectedNodes,
            'deselect_node': getSelectedNodes
        }
        function readyCB() {
        }
  
        function createNodeCB(){}
        function getSelectedNodes() 
        {
            if(vm.triggered)
            {
                 vm.triggered=false;
            }
            else
            {
                vm.triggered=true;
                var sitesTemp=[];
                vm.siteTokens=[];
                vm.selected_nodes=[];
                vm.selectedNode = {};
                var jstree = vm.treeInstance.jstree(true);
                
                vm.selected_nodes = jstree.get_selected();
                if (vm.selected_nodes[0]) {
                    vm.selectedNode = jstree.get_node(vm.selected_nodes[0]);
                }
                for (var i = 0; i < vm.selected_nodes.length; i++) {
                    if (vm.selected_nodes[i].includes("site")) {
                        sitesTemp.push(vm.selected_nodes[i]);
                    }
                }
                for (var i = 0; i < vm.treeData.length; i++) {
                    for (var j = 0; j < sitesTemp.length; j++) {
                        if (vm.treeData[i].id === sitesTemp[j]) {
                            vm.siteTokens.push(vm.treeData[i].token);
                        }
                    }
                }
                vm.dirty=true;
                vm.currentPage=1;
                vm.notifications=[];
                vm.calendarEvents = [[]];
                
                vm.sitesService="";
                if(vm.siteTokens.length>0)
                {
                    for(var i=0;i<vm.siteTokens.length;i++)
                    {
                        vm.sitesService+=vm.siteTokens+",";
                    }
                    vm.sitesService = vm.sitesService.slice(0, -1);
                }
                else
                {
                    vm.sitesService="all";
                }
                getNotifications();
            }
           
        }

        function changeCalendarDate(type)
        {
            vm.calendarType=type;
            if(type=='prev')
            {
                vm.date = {
                    startDate: moment(vm.date.startDate).subtract(1, 'month').startOf('month'),
                    endDate: moment(vm.date.startDate).subtract(1, 'month').endOf('month'),
                };
            }
            else if(type=='next')
            {
                vm.date = {
                    startDate: moment(vm.date.startDate).add(1, 'month').startOf('month'),
                    endDate: moment(vm.date.startDate).add(1, 'month').endOf('month'),
                };
            }
            else
            {
                vm.date = {
                    startDate: moment().startOf('month'),
                    endDate: moment().endOf('month'),
                };
            }

           
            vm.dirty=true;
            vm.currentPage=1;
            vm.notifications=[];
            vm.calendarEvents = [[]];
            getNotifications();
        }
        vm.calendarEvents = [[]];

        vm.calendarUiConfig = {
            calendar: {
                firstDay:1,
                weekends: true ,
                fixedWeekCount:false,
                height: 600,
                editable          : true,
                eventLimit        : true,
                header:{
                    left: '',
                    center: 'title',
                    right: ''
                },
                handleWindowResize: true,
                aspectRatio       : 1,
                dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                eventClick        : claendarEventDetail,
                selectable        : false,
                selectHelper      : false,
                select            : calendarSelect
            }
        };
        function claendarEventDetail(e,ev)
        {
            $mdDialog.show({
                controller         : 'EditCalendarNotificationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/notification/dialogs/edit-calendar-notification/edit-calendar-notification.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    currentNotification:e,
                    user:vm.user
                }
            }).then(function(answer) {	
                vm.dirty=true;
                vm.currentPage=1;
                vm.notifications=[];
                vm.calendarEvents = [[]];
                getNotifications();
            });
        }
        function calendarSelect()
        {

        }
        vm.buttonToggle=buttonToggle;
        vm.onlyUnRead=false;
        vm.currentPage = 1;
        vm.totalPages = 3;
        vm.user = session.getUser();
        vm.getNotifications=getNotifications;
        vm.toggleRead=toggleRead;
        vm.presentationType="timeline";
        vm.setPresentationType=setPresentationType;
        function setPresentationType(presentationType) {
            vm.presentationType=presentationType;
            angular.element(".presentationType-button").removeClass('active').addClass('md-raised');
            angular.element("." + presentationType + "-button").removeClass('md-raised').addClass('active');
            vm.dirty=true;
            vm.currentPage=1;
            vm.notifications=[];
            vm.calendarEvents = [[]];
            if(presentationType==='timeline')
            {
                vm.PageSize=5;
            }
            else if(presentationType==='table')
            {
                vm.PageSize=1000;
            }
            else
            {
                vm.PageSize=1000;
            }
             getNotifications();
        }
        function shortByDate(a,b) {
            if (a.eventDate > b.eventDate)
                return -1;
            if (a.eventDate < b.eventDate)
                return 1;
            return 0;
        }
        function shortByRead(a,b) {
            if (a.read && !b.read)
                return 1;
            if (b.read && !a.read)
                return -1;
            return 0;
        }
        function buttonToggle(type) {
            vm[type] = (vm[type]) ? false : true;
            if (vm[type]) {
                angular.element("." + type + "-button").removeClass('md-raised').addClass('active');
                vm.onlyUnRead=true;
            }
            else {
                angular.element("." + type + "-button").removeClass('active').addClass('md-raised');
                vm.onlyUnRead=false;
            }
            vm.dirty=true;
            vm.currentPage=1;
            vm.notifications=[];
            vm.calendarEvents = [[]];
            getNotifications();
        }
        function toggleRead(notification)
        {
            var message=
            {
                token:notification.token,
                read:notification.read,
                seen:notification.seen,
                site:notification.site,
                tenant:notification.tenant,
                eventDate:notification.eventDate,
                user:notification.user,
                title:notification.title,
                message:notification.message,
                type:notification.type
            };
            if(notification.read)
            {
                message.read=false;
            }
            else
            {
                message.seen=true;
                message.read=true;
            }
            pragmaapi.callRestService(PRAGMA.api, "/notifications/"+message.token, message, true, vm.user.authentication, "PUT", true, false).then(function(res){
                vm.dirty=true;
                vm.currentPage=1;
                vm.notifications=[];
                vm.calendarEvents = [[]];
                getNotifications();
            });
        }
        function getNotifications()
        {
            if(vm.presentationType=='calendar')
            {
                vm.showcalendar=false;
                 pragmaapi.callRestService(PRAGMA.api, "/notifications/userId/" + vm.user.username+"?site="+vm.sitesService+"&startDate="+encodeURIComponent(moment(vm.date.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0000")+"&endDate="+encodeURIComponent(moment(vm.date.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0000")+"&pageStart=1&pageSize="+vm.PageSize, "", true, vm.user.authentication, "GET", true, false).then(function(res){
                    var notifications=res.data.results;
                    var cl="";
                    for(var i=0;i<notifications.length;i++)
                    {
                        if(typeof notifications[i].eventDate!=='undefined')
                        {
                            if(notifications[i].type==="Info")
                            {
                                cl="#5bc0de";
                            }
                            else if(notifications[i].type==="Warning")
                            {
                                cl="#f0ad4e";
                            }
                            else if(notifications[i].type==="Success")
                            {
                            cl="#5cb85c";
                            }
                            else
                            {
                            cl="#d9534f";
                            }
                            if(vm.onlyUnRead)
                            {
                                if(!notifications[i].read)
                                {
                                    var temp=
                                    {
                                        id   : notifications[i].token,
                                        title: notifications[i].title,
                                        start: new Date(notifications[i].eventDate),
                                        allDay:true,
                                        forceEventDuration:true,
                                        meta:notifications[i],
                                        color:cl,
                                        textColor:"white"
                                    }
                                    vm.notifications.push(notifications[i]);
                                    vm.calendarEvents[0].push(temp)
                                }
                            }
                            else
                            {
                                var temp=
                                {
                                    id   : notifications[i].token,
                                    title: notifications[i].title,
                                    start: new Date(notifications[i].eventDate),
                                    allDay:true,
                                    forceEventDuration:true,
                                    meta:notifications[i],
                                    color:cl,
                                    textColor:"white"
                                }
                                vm.notifications.push(notifications[i]);
                                vm.calendarEvents[0].push(temp)
                            }
                        }
                    }
                    vm.showcalendar=true;
                    $timeout(function() {
                        $scope.$apply(function () {
                            $('#calendarView').fullCalendar('gotoDate',vm.date.startDate);
                        });
                    },0);  
                 });
            }
            else
            {
                var deferred = $q.defer();
                if (vm.dirty) {
                    pragmaapi.callRestService(PRAGMA.api, "/notifications/userId/" + vm.user.username+"?site="+vm.sitesService+"&pageStart="+vm.currentPage+"&pageSize="+vm.PageSize, "", true, vm.user.authentication, "GET", true, false).then(function(res){
                        vm.currentPage++;
                        if(notifications=res.data.results.length==0)
                        {
                            vm.dirty=false;
                        }
                        var notifications=res.data.results;
                        for(var i=0;i<notifications.length;i++)
                        {
                            notifications[i].isOpen=false;
                            if(notifications[i].type==="Info")
                            {
                                notifications[i].color="#5bc0de";
                                notifications[i].typeIcon="icon-information";
                            }
                            else if(notifications[i].type==="Warning")
                            {
                                notifications[i].color="#f0ad4e";
                                notifications[i].typeIcon="icon-alert";
                            }
                            else if(notifications[i].type==="Success")
                            {
                                notifications[i].color="#5cb85c";
                                notifications[i].typeIcon="icon-checkbox-marked-circle";
                            }
                            else
                            {
                                notifications[i].color="#d9534f";
                                notifications[i].typeIcon="icon-alert-octagon";
                            }
                            if(notifications[i].read)
                            {
                                notifications[i].readIcon="icon-eye";
                            }
                            else
                            {
                                notifications[i].readIcon="icon-eye-off";
                            }
                            notifications[i].template = "app/main/notification/templates/notification-card.html";
                            if(vm.onlyUnRead)
                            {
                                if(!notifications[i].read)
                                {
                                    vm.notifications.push(notifications[i]);
                                }
                            }
                            else
                            {
                                vm.notifications.push(notifications[i]);
                            }
                        }
                        vm.table.limitOptions = [5, 10, 15, {
                                label: 'All',
                                value: function () {
                                    return vm.notifications.length ? vm.notifications.length : 0;
                                }
                        }];
                        vm.table.options = {
                            rowSelection: false,
                            multiSelect: false,
                            autoSelect: false,
                            decapitate: false,
                            largeEditDialog: false,
                            boundaryLinks: false,
                            limitSelect: true,
                            pageSelect: true
                        };
                        vm.table.query = {
                            order: '',
                            limit: 10,
                            page: 1
                        };
                        vm.table.filter = {
                            search: ''
                        };
                        deferred.resolve(vm.notifications);
                    
                    });
                }
                else
                {
                    vm.dirty = false;
                    deferred.reject("No more notifications");
                }
                return deferred.promise;
            }
        }
        
    }

})();
(function ()
{
	'use strict';
	
	angular
		.module('app.mv')
		.controller('MvController', MvController);
	
	/** @ngInject */
	function MvController($scope, $rootScope, $state, $filter, $translate, $mdSidenav, $mdDialog, $document, session, PRAGMA, pragmaapi, Notification, dateFilter, pragmaTheming) {
		
		var vm = this;
		
		var d = new Date();
		//d.setFullYear(2020);
		
		// Date Range
		vm.dates = {
			now: new Date()
		};
		
        // Theming
		vm.themes = pragmaTheming.themes;
        var isDark = (vm.themes.active.name.indexOf('Dark') >= 0);
		
		vm.plans = [];
		vm.viewType = 'list';
		vm.planShow = 0;
		vm.variableShow = 0;
		vm.lockLeft=true;
		vm.lockRight=true;
		
		// User
		vm.user = session.getUser();
		
		vm.currentPlan = {};
		vm.currentVariable = {};
		vm.currentFactor = {};
		
		vm.selectedTab = $state.current.tab;
		
		// Methods
		vm.setViewType = setViewType;
		vm.toggleSidenav = toggleSidenav;
        vm.changeStatusL = changeStatusL;
        vm.toggleClose = toggleClose;
		vm.managePlan = managePlan;
		vm.manageVariable = manageVariable;
		
		vm.openNewPlanDialog = openNewPlanDialog;
		vm.openEditPlanDialog = openEditPlanDialog;
		vm.openCopyPlanDialog = openCopyPlanDialog;
		vm.openDeletePlanDialog = openDeletePlanDialog;
		
		vm.openAddActionDialog = openAddActionDialog;
		vm.openNewActionDialog = openNewActionDialog;
		vm.openEditActionDialog = openEditActionDialog;
		vm.openCopyActionDialog = openCopyActionDialog;
		vm.openDeleteActionDialog = openDeleteActionDialog;
		
		vm.openAddDataDialog = openAddDataDialog;
		
		vm.openNewVariableDialog = openNewVariableDialog;
		vm.openEditVariableDialog = openEditVariableDialog;
		vm.openCopyVariableDialog = openCopyVariableDialog;
		vm.openDeleteVariableDialog = openDeleteVariableDialog;
		
		vm.openNewFactorDialog = openNewFactorDialog;
		vm.openEditFactorDialog = openEditFactorDialog;
		vm.openCopyFactorDialog = openCopyFactorDialog;
		vm.openDeleteFactorDialog = openDeleteFactorDialog;
		
		vm.protoTypes = [
			'IPMVP Option B',
			'IPMVP Option C'
		];
		
		vm.units = ['Watt','Volt', 'KWh'];
		vm.selectedUnit = 'Watt';
		
		vm.modelVariables = ['Variable 1','Variable 2','Variable 3','Variable 4','Variable 5','Variable 6'];
		vm.selectedModelVariables = [];
		
		function translateOptions(){
			
			vm.ordOpts = [
				$filter('translate')("MV.OPTIONS.PLAN_ORDER.USER_PREFERENCES"),
				$filter('translate')("MV.OPTIONS.PLAN_ORDER.LAST_UPDATE"),
				$filter('translate')("MV.OPTIONS.PLAN_ORDER.PLAN_NAME")
			];
			vm.selectedOrder = $filter('translate')("MV.OPTIONS.PLAN_ORDER.USER_PREFERENCES");
			
			vm.periods = [
				$filter('translate')("MV.OPTIONS.PERIODS.ALL"),
				$filter('translate')("MV.OPTIONS.PERIODS.DAY"),
				$filter('translate')("MV.OPTIONS.PERIODS.WEEK"),
				$filter('translate')("MV.OPTIONS.PERIODS.MONTH"),
				$filter('translate')("MV.OPTIONS.PERIODS.YEAR")
			];
			vm.selectedPeriod = $filter('translate')("MV.OPTIONS.PERIODS.ALL");
			
			vm.equations = [
				$filter('translate')("MV.OPTIONS.EQUATIONS.SUM"),
				$filter('translate')("MV.OPTIONS.EQUATIONS.AVERAGE"),
				$filter('translate')("MV.OPTIONS.EQUATIONS.MINIMUM"),
				$filter('translate')("MV.OPTIONS.EQUATIONS.MAXIMUM")
			];
			vm.selectedEquation = $filter('translate')("MV.OPTIONS.EQUATIONS.SUM");
			
			vm.graphs = [
				$filter('translate')("MV.OPTIONS.GRAPHS.DATA"),
				$filter('translate')("MV.OPTIONS.GRAPHS.CORRELATION"),
			];
			vm.selectedGraph = $filter('translate')("MV.OPTIONS.GRAPHS.DATA");
			
			vm.modelTypes = [
				$filter('translate')("MV.OPTIONS.MODEL_TYPES.SIMPLE_LINEAR_REGRESSION")
			];
			vm.selectedModelType = $filter('translate')("MV.OPTIONS.MODEL_TYPES.SIMPLE_LINEAR_REGRESSION");
			
			vm.modelDays = [
				$filter('translate')("MV.OPTIONS.MODEL_DAYS.ALL"),
				$filter('translate')("MV.OPTIONS.MODEL_DAYS.WORKING_DAYS"),
				$filter('translate')("MV.OPTIONS.MODEL_DAYS.WEEKENDS")
			];
			vm.selectedModelDay = $filter('translate')("MV.OPTIONS.MODEL_DAYS.ALL");
			
		}
		translateOptions()
		
		$rootScope.$on('$translateChangeSuccess', function () {
			translateOptions();
		});
		
		vm.applySearch = function () {
			if (vm.treeInstance) {
				vm.treeInstance.jstree(true).search(vm.searchtree);
			}
		};
		
        pragmaapi.getTreeData(true, true,true,true).then(function(treeData) {
            vm.treeData = treeData;
            vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow']);
            vm.versionNo++;
            vm.treeConfig.version = vm.versionNo;
        });
        vm.treeEvents = {
            'ready': readyCB,
            'create_node': createNodeCB,
            'select_node': getSelectedNodes,
            'deselect_node': getSelectedNodes
        }
        function getSelectedNodes() {
            if(vm.triggered)
            {
                 vm.triggered=false;
            }
            else
            {
                vm.triggered=true;
                vm.selected_nodes=[];
                vm.selectedNode = {};
                var siteToken="";
                var authenticationToken="";
                var jstree = vm.treeInstance.jstree(true);
                vm.selected_nodes = jstree.get_selected();
                if (vm.selected_nodes[0]) {
                    vm.selectedNode = jstree.get_node(vm.selected_nodes[0]);
                }
                for (var i = 0; i < vm.treeData.length; i++) {
                    if(vm.treeData[i].type=='measurement' && vm.treeData[i].id==vm.selectedNode.id)
                    {
                        vm.tenantAuthToken=vm.treeData[i].tenantAuthToken;
                        vm.measurement=vm.treeData[i].measure;
                        vm.selectedToken=vm.treeData[i].token;
                        vm.friendlyName=vm.treeData[i].text;
                        //vizualizeData();
                        break;
                    }
                }
            }
        }
        function createNodeCB() {}
        function readyCB() {}
		
		/*
		vm.plans = [
			{id:1,title:'KWh testing',type:'IPMVP Option B',cost:100,date:d,progress:100,actions:[{id:1,title:'Action 1',reference:'',startdate:d,enddate:d}],variables:[{id:1,title:'Variable 1',description:''}],factors:[{id:4,title:'Factor 4',startdate:d,enddate:d}]},
			{id:2,title:'Verification on energy measurements',type:'IPMVP Option C',cost:477,date:d,progress:60,actions:[{id:2,title:'Action 2',reference:'',startdate:d,enddate:d}],variables:[{id:1,title:'Variable 1',description:''}],factors:[{id:6,title:'Factor 6',startdate:d,enddate:d}]},
			{id:3,title:'Cost calculation',type:'IPMVP Option B',cost:99,date:d,progress:80,actions:[{id:3,title:'Action 3',reference:'',startdate:d,enddate:d}],variables:[{id:1,title:'Variable 3',description:''}],factors:[{id:1,title:'Factor 1',startdate:d,enddate:d}]},
			{id:4,title:'Plan on energy findings',type:'IPMVP Option B',cost:2000,date:d,progress:76,actions:[{id:4,title:'Action 4',reference:'',startdate:d,enddate:d}],variables:[{id:1,title:'Variable 2',description:''}],factors:[{id:5,title:'Factor 5',startdate:d,enddate:d}]},
			{id:5,title:'Verify with different values',type:'IPMVP Option C',cost:50,date:d,progress:100,actions:[{id:5,title:'Action 5',reference:'',startdate:d,enddate:d}],variables:[{id:1,title:'Variable 4',description:''}],factors:[{id:2,title:'Factor 2',startdate:d,enddate:d}]},
			{id:6,title:'Compare electricity measurements',type:'IPMVP Option C',cost:600,date:d,progress:100,actions:[{id:6,title:'Action 6',reference:'',startdate:d,enddate:d}],variables:[{id:1,title:'Variable 7',description:''}],factors:[{id:3,title:'Factor 3',startdate:d,enddate:d}]}
		];
		*/
		
		
		
		/*
		var data = [];
		for (var i = 0; i < 120; i++) {
			data.push([i, (Math.random() * (3.0 - 0.3) + 0.3)
			]);
		}
		
		
		
		var tempdata = [];
		for (var i = 0; i < 300; i++) {
			tempdata.push([(Math.random() * (5.0 - 0.3) + 0.3)
			]);
		}
		tempdata.sort(function(a,b){return a-b});
		
		
		
		
		var data = [];
		for (var j=0; j < tempdata.length; j++){
			data.push([tempdata[j][0], (tempdata[j][0] + (Math.random() * (5.3 - 0.3) + 0.3))]);
		}
		
		
		// coefficients of regression for each series.
		// if coeffs = [ null, [1, 2], null ] then we draw a regression for series 1
		// only. The regression line is y = 1 + 2 * x.
		var coeffs = [ null, null, null ];
		
		function regression(series) {
			// Only run the regression over visible points.
			var range = data.length;
			
			var sum_xy = 0.0, sum_x = 0.0, sum_y = 0.0, sum_x2 = 0.0, sum_y2 = 0.0, num = 0;
			for (var i = 0; i < range; i++) {
				var x = data[i][0];
				//if (x < range[0] || x > range[1]) continue;
				
				var y = data[i][1];
				if (y == null) continue;
				if (y.length == 2) {
					// using fractions
					y = y[0] / y[1];
				}
				
				num++;
				sum_x += x;
				sum_y += y;
				sum_xy += x * y;
				sum_x2 += x * x;
				sum_y2 += y * y;
			}
			
			var a = (sum_xy - sum_x * sum_y / num) / (sum_x2 - sum_x * sum_x / num);
			var b = (sum_y - a * sum_x) / num;
			
			var R = ( (num * sum_xy) - (sum_x * sum_y) ) / (Math.sqrt( ( (num * sum_x2) - (sum_x * sum_x) ) * ( (num * sum_y2) - (sum_y * sum_y) ) ) );
			
			coeffs[1] = [b, a];
			if (typeof(console) != 'undefined') {
				console.log("coeffs(" + 1 + "): [b: " + b + ", a: " + a + ", R: " + R + "]");
				
			}
			
			//g.updateOptions({});  // forces a redraw.
		}
		
		regression(1);
		
		*/
		

		
		
		
		
		
		/*
		var data = [];
		
		vm.test = {
			data: data,
			options: {
				labels: ['X', 'Y1'],
				drawPoints: true,
				strokeWidth: 0.0,
				underlayCallback: drawLines,
			}
		};
		*/
		
		

		
		
		
		
		
		
		
		
		
		
		
		vm.actions = [
			{
				id:1,
				title:'Automatic Light Management',
				description:'Automatically turn off lights of the facility [00:00 - 06:00]',
				reference:'ref01',
				startdate:new Date(Date.parse("12,24,2017")),
				enddate:new Date(Date.parse("1,7,2018"))
			}
		];
		
		
		vm.variables = [
			{
				id: 1,
				title: 'Weather Conditions - Temperature',
				description: 'Weather conditions affect energy consumption throughout reporting period.',
				monitoredpoint: 'Temperature'
			}
		];
		
		
		
		vm.factors = [
			{
				id: 1,
				title: 'Number of weekly production shifts',
				operator:'-',
				value: 5,
				description: 'Applied static factor for a certain window of time in reporting period or during the whole period',
				startdate:new Date(Date.parse("12,24,2017")),
				enddate:new Date(Date.parse("1,7,2018"))
			}
		];
		
		
		vm.plans = [
			{
				id          : 1,
				title       : 'Energy Management Program',
				type        : 'IPMVP Option C',
				cost        : 1000,
				date        : new Date(Date.parse("12, 15, 2016")),
				description : 'Used to help manage the total energy performance of the whole SmartHouse (connected to measurements of total energy performance)',
				progress : 100,
				baseline : {
					description: 'A normal operating cycle – min & max energy consumption/demand, usually for Option C – 12months',
					period: 'All',
					startdate:new Date(Date.parse("12,1,2017")),
					enddate:new Date(Date.parse("12,31,2017")),
					monitoredpoint: 'Total Consumption'
				},
				report : {
					description: 'Should include at least one normal operating cycle',
					period: 'All',
					startdate:new Date(Date.parse("1,1,2018")),
					enddate:new Date(Date.parse("1,30,2018")),
					monitoredpoint: 'Total Consumption'
				},
				actions: [
					vm.actions[0]
				],
				variables: [
					vm.variables[0]
				],
				factors: [
					vm.factors[0]
				],
				model: {
					description: 'This type of Model will probably be the optimal option for saving energy during the holidays'
				},
				savings: {
					description: 'Conclusions of the plan'
				}
			}
		];
		
		
		
		// Chart 
		vm.chart = {
			baseline: {
				data: generateDates(vm.plans[0].baseline.startdate, vm.plans[0].baseline.enddate, 2.3, 30.1),
				options: {
					labels: ["Date", "Consumption"],
					ylabel: "Consumption (KWh)",
					fillGraph: true,
					connectSeparatedPoints: true,
					showRangeSelector: true
				},
				legend: {
					series: {
						A: {
							label: "Consumption"
						}
					}
				}
			},
			report: {
				data: generateDates(vm.plans[0].report.startdate, vm.plans[0].report.enddate, 2.3, 30.1),
				options: {
					//plotter: barChartPlotter,
					labels: ["Date", "Consumption"],
					ylabel: "Consumption (KWh)",
					fillGraph: true,
					connectSeparatedPoints: true,
					showRangeSelector: true
				},
				legend: {
					series: {
						A: {
							label: "Consumption"
						}
					}
				}
			},
			variable: {
				data: generateDates(vm.plans[0].baseline.startdate, vm.plans[0].report.enddate, 10.0, 40.0),
				options: {
					plotter: barChartPlotter,
					labels: ["Date", "Temerature"],
					ylabel: "Temperature (Celcius)",
					fillGraph: true,
					connectSeparatedPoints: true,
					showRangeSelector: true,
					//animatedZooms: true,
					underlayCallback: function(canvas, area, g) {
						var highlight_start = new Date('2017/12/24');
						var highlight_end = new Date('2018/01/06');
						
						var bottom_left = g.toDomCoords(highlight_start,0);
						var top_right = g.toDomCoords(highlight_end,2500); 
						//console.log(bottom_left);				
						//console.log(top_right);
						
						var left = bottom_left[0];
						var right = top_right[0];
						
						canvas.fillStyle = "rgba(255, 255, 255, 0.1)";
						canvas.fillRect(left, area.y, right - left, area.h);
					}
				},
				legend: {
					series: {
						A: {
							label: "Temperature"
						}
					}
				}
			}
		};
		
		
		
		
		
		vm.plotVariableCorrelationGraph = plotVariableCorrelationGraph;
		vm.plotModelCorrelationGraph = plotModelCorrelationGraph;
		
		
		vm.plotSavingsGraph = plotSavingsGraph;
		
		
		function plotSavingsGraph() {
			console.log('plot');
			
			var tempData = generateSavingsDates(vm.plans[0].baseline.startdate, vm.plans[0].report.enddate, 2.3, 30.1);
			
			var actualTotal = 0;
			var calculatedTotal = 0;
			var cost = 0.16988; // €/kWh
			
			for(var i in tempData) {
				actualTotal += tempData[i][1];
				calculatedTotal += tempData[i][2];
			}
			
			//console.log(actualTotal);
			//console.log(calculatedTotal);
			
			vm.savingsGraph = {
				data: tempData,
				savings: {
					actualTotal: Number(actualTotal.toFixed(3)),
					actualTotalCost: Number((actualTotal*cost).toFixed(3)),
					calculatedTotal: Number(calculatedTotal.toFixed(3)),
					calculatedTotalCost: Number((calculatedTotal*cost).toFixed(3)),
					savings: Number((actualTotal - calculatedTotal).toFixed(3)),
					savingsCost: Number(((actualTotal*cost) - (calculatedTotal*cost)).toFixed(3))
				},
				options: {
					labels: ["Date", "Actual", "Calculated"],
					ylabel: "Consumption (KWh)",
					connectSeparatedPoints: true,
					showRangeSelector: true
				}
			};
			
			
			
			
			console.log(tempData);
			
		}
		
		
		function plotVariableCorrelationGraph() {
			console.log('plot');
			var tempData = (generateVariableCorrelationValues(vm.chart.variable.data, 1));
			
			vm.correlationVariable = {
				data: tempData.data,
				coeffs: tempData.coeffs,
				options: {
					labels: ['Temperature (C)', 'Consumption (KWh)'],
					xlabel: "Temperature (C)",
					ylabel: "Consumption (KWh)",
					drawPoints: true,
					strokeWidth: 0.0,
					underlayCallback: drawVariableLines
				}
			};
			
		}
		
		
		function plotModelCorrelationGraph() {
			console.log('plot');
			var tempData = (generateModelCorrelationValues(vm.chart.report.data, 1));
			
			vm.correlationModel = {
				data: tempData.data,
				coeffs: tempData.coeffs,
				options: {
					labels: ['Predicted Consumption (KWh)', 'Actual Consumption (KWh)'],
					xlabel: "Predicted Consumption (KWh)",
					ylabel: "Actual Consumption (KWh)",
					drawPoints: true,
					strokeWidth: 0.0,
					underlayCallback: drawModelLines
				}
			};
			
		}
		
		
		
		
		
		
		function toHex(rgb) {
			return 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
		}
		
		function drawVariableLines(ctx, area, layout, g) {
			
			var coeffs = vm.correlationVariable.coeffs;
			console.log(coeffs);
			//if (typeof(g) == 'undefined') return;  // won't be set on the initial draw.
			
			var range = g.xAxisRange();
			for (var i = 0; i < coeffs.length; i++) {
				if (!coeffs[i]) continue;
				var a = coeffs[i][1];
				var b = coeffs[i][0];
				
				var x1 = range[0];
				var y1 = a * x1 + b;
				var x2 = range[1];
				var y2 = a * x2 + b;
				
				var p1 = g.toDomCoords(x1, y1);
				var p2 = g.toDomCoords(x2, y2);
				
				var c = Dygraph.toRGB_(g.getColors()[i - 1]);
				c.r = Math.floor(255 - 0.5 * (255 - c.r));
				c.g = Math.floor(255 - 0.5 * (255 - c.g));
				c.b = Math.floor(255 - 0.5 * (255 - c.b));
				var color = toHex(c);
				ctx.save();
				ctx.strokeStyle = color;
				ctx.lineWidth = 1.0;
				ctx.beginPath();
				ctx.moveTo(p1[0], p1[1]);
				ctx.lineTo(p2[0], p2[1]);
				ctx.closePath();
				ctx.stroke();
				ctx.restore();
			}
		}
		
		
		function drawModelLines(ctx, area, layout, g) {
			
			var coeffs = vm.correlationModel.coeffs;
			console.log(coeffs);
			//if (typeof(g) == 'undefined') return;  // won't be set on the initial draw.
			
			var range = g.xAxisRange();
			for (var i = 0; i < coeffs.length; i++) {
				if (!coeffs[i]) continue;
				var a = coeffs[i][1];
				var b = coeffs[i][0];
				
				var x1 = range[0];
				var y1 = a * x1 + b;
				var x2 = range[1];
				var y2 = a * x2 + b;
				
				var p1 = g.toDomCoords(x1, y1);
				var p2 = g.toDomCoords(x2, y2);
				
				var c = Dygraph.toRGB_(g.getColors()[i - 1]);
				c.r = Math.floor(255 - 0.5 * (255 - c.r));
				c.g = Math.floor(255 - 0.5 * (255 - c.g));
				c.b = Math.floor(255 - 0.5 * (255 - c.b));
				var color = toHex(c);
				ctx.save();
				ctx.strokeStyle = color;
				ctx.lineWidth = 1.0;
				ctx.beginPath();
				ctx.moveTo(p1[0], p1[1]);
				ctx.lineTo(p2[0], p2[1]);
				ctx.closePath();
				ctx.stroke();
				ctx.restore();
			}
		}
		
		
		
		
		
		
		
		//console.log(vm.correlationChart.variable.data);
		
		// This function draws bars for a single series. See
		// multiColumnBarPlotter below for a plotter which can draw multi-series
		// bar charts.
		function barChartPlotter(e) {
			var ctx = e.drawingContext;
			var points = e.points;
			var y_bottom = e.dygraph.toDomYCoord(0);
			
			ctx.fillStyle = e.color;
			
			// Find the minimum separation between x-values.
			// This determines the bar width.
			var min_sep = Infinity;
			for (var i = 1; i < points.length; i++) {
				var sep = points[i].canvasx - points[i - 1].canvasx;
				if (sep < min_sep) min_sep = sep;
			}
			var bar_width = Math.floor(2.0 / 3 * min_sep);
			
			// Do the actual plotting.
			for (var i = 0; i < points.length; i++) {
				var p = points[i];
				var center_x = p.canvasx;
				
				ctx.fillRect(center_x - bar_width / 2, p.canvasy,
					bar_width, y_bottom - p.canvasy);
				
				ctx.strokeRect(center_x - bar_width / 2, p.canvasy,
					bar_width, y_bottom - p.canvasy);
			}
		}
		
		
		
		
		// coefficients of regression for each series.
		// if coeffs = [ null, [1, 2], null ] then we draw a regression for series 1
		// only. The regression line is y = 1 + 2 * x.
		
		
		function regression(data, series) {
			var coeffs = [ null, null, null ];
			// Only run the regression over visible points.
			var range = data.length;
			
			var sum_xy = 0.0, sum_x = 0.0, sum_y = 0.0, sum_x2 = 0.0, sum_y2 = 0.0, num = 0;
			for (var i = 0; i < range; i++) {
				var x = data[i][0];
				//if (x < range[0] || x > range[1]) continue;
				
				var y = data[i][series];
				if (y == null) continue;
				if (y.length == 2) {
					// using fractions
					y = y[0] / y[1];
				}
				
				num++;
				sum_x += x;
				sum_y += y;
				sum_xy += x * y;
				sum_x2 += x * x;
				sum_y2 += y * y;
			}
			
			var a = (sum_xy - sum_x * sum_y / num) / (sum_x2 - sum_x * sum_x / num);
			var b = (sum_y - a * sum_x) / num;
			
			var R = ( (num * sum_xy) - (sum_x * sum_y) ) / (Math.sqrt( ( (num * sum_x2) - (sum_x * sum_x) ) * ( (num * sum_y2) - (sum_y * sum_y) ) ) );
			
			coeffs[series] = [Number(b.toFixed(2)), Number(a.toFixed(2)), Number(R.toFixed(2))];
			return coeffs;
			//if (typeof(console) != 'undefined') {
			//	console.log("coeffs(" + 1 + "): [b: " + b + ", a: " + a + ", R: " + R + "]");
			//}
			
			//g.updateOptions({});  // forces a redraw.
		}
		
		
		
		
		function generateVariableCorrelationValues(data, series) {
			var tempdata = [];
			for (var i = 0; i < data.length; i++) {
				tempdata.push([data[i][series]]);
			}
			tempdata.sort(function(a,b){return a-b});
			
			//console.log(tempdata);
			
			var sortedData = [];
			for (var j=0; j < tempdata.length; j++){
				sortedData.push([tempdata[j][0], (tempdata[j][0] + (Math.random() * (5.3 - 0.3) + 0.3))]);
			}
			
			//console.log(sortedData);
			
			var corrValues = {
				data: sortedData,
				coeffs: regression(sortedData, series)
			};
			
			return corrValues;
			
		}
		
		function generateModelCorrelationValues(data, series) {
			var tempdata = [];
			for (var i = 0; i < data.length; i++) {
				tempdata.push([data[i][series]]);
			}
			tempdata.sort(function(a,b){return a-b});
			
			//console.log(tempdata);
			
			var sortedData = [];
			for (var j=0; j < tempdata.length; j++){
				sortedData.push([(tempdata[j][0] - (Math.random() * (5.3 - 0.3) + 0.3)), tempdata[j][0]]);
			}
			
			//console.log(sortedData);
			
			var corrValues = {
				data: sortedData,
				coeffs: regression(sortedData, series)
			};
			
			return corrValues;
			
		}
		
		
		function generateDates(startDate, endDate, min, max) {
			var dates = [];
			
			var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
			
			var startBaseTime = new Date(startDate);
			var endBaseTime = new Date(endDate);
			
			var diff = Math.round(Math.abs((startBaseTime.getTime() - endBaseTime.getTime())/(oneDay))); // No of days
			
			var num = 12 * diff; // Every 2 Hours
			
			for (var i = 0; i < num; i++) {
				var generatedDate = new Date(Date.parse(startBaseTime) + i * 2 * 60 * 60 * 1000);
				
				dates.push([
					generatedDate,
					Number((Math.random() * (max - min) + min).toFixed(2))
				]);
				
			}
			
			return dates;
		}
		
		function generateSavingsDates(startDate, endDate, min, max) {
			var dates = [];
			
			var oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds
			
			var startBaseTime = new Date(startDate);
			var endBaseTime = new Date(endDate);
			
			var diff = Math.round(Math.abs((startBaseTime.getTime() - endBaseTime.getTime())/(oneDay))); // No of days
			
			var num = 12 * diff; // Every 2 Hours
			
			for (var i = 0; i < num; i++) {
				var generatedDate = new Date(Date.parse(startBaseTime) + i * 2 * 60 * 60 * 1000);
				var actualValue = Number((Math.random() * (max - min) + min).toFixed(2));
				var calulatedValue = Number((actualValue - (Math.random() * (5.0 - 1.2) + 1.2)).toFixed(2));
				
				dates.push([
					generatedDate,
					actualValue,
					calulatedValue
				]);
				
			}
			
			return dates;
		}
		
		
		
		
		
		
        function vizualizeData() {
            vm.showGraph=false;
            var measurements=vm.measurement+","+vm.measurement+"_max,"+vm.measurement+"_min,"+vm.measurement+"_median";
            if(typeof vm.measurement!=='undefined')
            {
                pragmaapi.callRestService(PRAGMA.api,"/assignments/" +  vm.selectedToken + "/measurements/series","?page=1&pageSize=1000&startDate="+encodeURIComponent(moment(vm.date.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0300")+"&endDate="+encodeURIComponent(moment(vm.date.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0300")+"&measurementIds="+measurements+"&tenantAuthToken=" + vm.tenantAuthToken, true, vm.user.authentication, "GET", true).then(function(res){
                    if(res.data.length<4)
                    {
                        Notification("No Predicted Data Available!");
                    }
                    else
                    {
                        console.log(vm.selectedNode);
						
						console.log(JSON.stringify(res.data));
						
                    }
                });
            }
            else
            {
                 Notification("Please select a monitor point first!");
            }
        }
		
		
		
		
		
		
		
		
		function managePlan(plan){
			vm.planShow = 1;
			vm.currentPlan = plan;
		}
		
		function manageVariable(variable){
			vm.variableShow = 1;
			vm.currentVariable = variable;
		}
		
		function openNewFactorDialog(ev) {
			$mdDialog.show({
				controller         : 'NewFactorController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/newFactor/new-factor.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openEditFactorDialog(ev,factor) {
			$mdDialog.show({
				controller         : 'EditFactorController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/editFactor/edit-factor.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					factor:factor
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openCopyFactorDialog(ev,factor) {
			$mdDialog.show({
				controller         : 'CopyFactorController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/copyFactor/copy-factor.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					factor:factor
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openDeleteFactorDialog(ev,factor) {
			$mdDialog.show({
				controller         : 'DeleteFactorController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/deleteFactor/delete-factor.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					factor:factor
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openNewVariableDialog(ev) {
			$mdDialog.show({
				controller         : 'NewVariableController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/newVariable/new-variable.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openEditVariableDialog(ev,variable) {
			$mdDialog.show({
				controller         : 'EditVariableController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/editVariable/edit-variable.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					variable:variable
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openCopyVariableDialog(ev,variable) {
			$mdDialog.show({
				controller         : 'CopyVariableController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/copyVariable/copy-variable.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					variable:variable
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openDeleteVariableDialog(ev,variable) {
			$mdDialog.show({
				controller         : 'DeleteVariableController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/deleteVariable/delete-variable.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					variable:variable
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openNewPlanDialog(ev) {
			$mdDialog.show({
				controller         : 'NewPlanController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/newPlan/new-plan.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openEditPlanDialog(ev,plan) {
			$mdDialog.show({
				controller         : 'EditPlanController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/editPlan/edit-plan.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					plan:plan
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openCopyPlanDialog(ev,plan) {
			$mdDialog.show({
				controller         : 'CopyPlanController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/copyPlan/copy-plan.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					plan:plan
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openDeletePlanDialog(ev,plan) {
			$mdDialog.show({
				controller         : 'DeletePlanController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/deletePlan/delete-plan.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					plan:plan
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openAddDataDialog(ev, info) {
			$mdDialog.show({
				controller         : 'AddDataController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/addData/add-data.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					info:info
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openAddActionDialog(ev, actions) {
			$mdDialog.show({
				controller         : 'AddActionController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/addAction/add-action.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					actions:actions
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openNewActionDialog(ev) {
			$mdDialog.show({
				controller         : 'NewActionController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/newAction/new-action.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openEditActionDialog(ev,action) {
			$mdDialog.show({
				controller         : 'EditActionController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/editAction/edit-action.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					action:action
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openCopyActionDialog(ev,action) {
			$mdDialog.show({
				controller         : 'CopyActionController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/copyAction/copy-action.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					action:action
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		function openDeleteActionDialog(ev,action) {
			$mdDialog.show({
				controller         : 'DeleteActionController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/mv/dialogs/deleteAction/delete-action.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: true,
				locals             : {
					event: ev,
					action:action
				}
			}).then(function (answer) {	
				
			}, function () {});
		}
		
		
        function setViewType(viewType) {
            vm.viewType = viewType;
            angular.element(".viewType-button").removeClass('active').addClass('md-raised');
            angular.element("." + viewType + "-button").removeClass('md-raised').addClass('active');
        }
		
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}
		
		function toggleClose(sidenavId) {
			$mdSidenav(sidenavId).close();
		}
		
		function changeStatusL(sidenavId) {
			$mdSidenav(sidenavId).close();
			if(vm.lockLeft)
				vm.lockLeft=!vm.lockLeft;
		}
	
	}
	
})();
(function ()
{
    'use strict';

    angular
        .module('app.landing')
        .controller('LandingController', LandingController);

    /** @ngInject */
    function LandingController($http, $scope, $location, $document, session, $window, PRAGMA, pragmaapi, $translate, $cookies, $mdDialog, $timeout, $anchorScroll, Notification)
    {
        session.destroy();
         var vm = this;
        moment.locale('en');
		
		$scope.activeMenu = 'Home';
		$scope.activeLang = 'en';
		
       // Language
        /* var lang = $cookies.get("lang");
        if (lang != undefined) {
            //$translate.use(lang);
			setlang(lang);
        }*/
		
		setlang('en');
		
		vm.setlang = setlang;
		
		function setlang(lang) {
			$translate.use(lang);	
			if (lang=="el") {
				$scope.activeLang = 'ελ';
			}
			else {
				$scope.activeLang = lang;
			}
		}
		
		vm.openShowRequestDialogue = openShowRequestDialogue;
		vm.openShowContactDialogue = openShowContactDialogue;
		vm.openShowLoginDialogue = openShowLoginDialogue;
		vm.SmoothScroll = SmoothScroll;
		
		$scope.scrollTo = function(id) {
			if (id=="case_studies") {
				$scope.activeMenu = 'Case Studies';
			}
			else {
				$scope.activeMenu = id;
			}
			$location.hash(id);
			//console.log($location.hash());
			$anchorScroll();
		};
		
		function SmoothScroll (id){
			var checker = document.querySelector('#toggle-nav');
			if (checker.checked === true) { checker.checked = false }
			// 
			if (id=="case_studies") {
				$scope.activeMenu = 'Case Studies';
			}
			else {
				$scope.activeMenu = id;
			}
			id = '#'+id;
			$timeout(smoothscrolling(id), 150);
		}
		
		function smoothscrolling (id){
			document.querySelector(id).scrollIntoView({ 
				behavior: 'smooth',
                block: "start"
			});
		}
		
		function openShowRequestDialogue (ev){
			
            $mdDialog.show({
                controller         : 'RequestDemoController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/landing/dialogs/RequestDemo/request_demo.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev
                }
            }).then(function (answer)
            {	
                // whatever
            },function () {});
			
		}
		
		
		function openShowContactDialogue (ev){
			
            $mdDialog.show({
                controller         : 'ContactUsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/landing/dialogs/ContactUs/contact_us.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev
                }
            }).then(function (answer)
            {	
                // whatever
            },function () {});
			
		}
		
		
		function openShowLoginDialogue (ev){
			
            $mdDialog.show({
                controller         : 'LanLoginController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/auth/login/dialogs/LanLogin/lan_login.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev
                }
            }).then(function (answer)
            {	
				if (answer.user.metadata.forgot_token) {
					
					var forward_url = PRAGMA.url + '/change_pass/' + answer.user.metadata.forgot_token;
					
					/* body = '<h2>Smart Everything Platform: Request password change service.</h2>';
					body += '<p>You have requested to change your password.</p>';
					body += '<p>Please click the following link below</p>';
					body += '<p><a href=\"'+ forward_url +'\">'+ forward_url +'</a></p>';
					body += '<p>You will be forwarded to the requested form.</p>';
					body += '<h3>Attention!</h3>';
					body += '<p>This process will expire in two days!</p>';*/
					
					var body = 'Smart Everything Platform: Request password change service.\n\n';
					body += 'You have requested to change your password.\n';
					body += 'Please click the following link below\n\n';
					body += forward_url + '\n\n';
					body += 'You will be forwarded to the requested form.\n\n';
					body += 'Attention!\n\n';
					body += 'This process will expire in two hours!';
					
					var send_to = {
						subject : "Smart Everything Platform: Request password change service.",
						body    : body,
						to      : answer.user.metadata.email
					}
					
					pragmaapi.callRestService(PRAGMA.api,"/mail/send",send_to,true,'admin:password',"POST",true,false).then(function(res){
						showNotification("User Notification", $translate.instant("LOGIN.MAIL_SENT"),"Success");
					},function(reason) {
						showNotification("User Notification","Something Went Wrong!","Error");
					});
					
				}
            },function () {});
			
		}		
		
        function showNotification(title, message, type) {
            if (type === "Error") {
                Notification.error({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Info") {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Warning") {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Success") {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }   
        }
		
		/*function offset(elm) {
			try {return elm.offset();} catch(e) {}
			var rawDom = elm;
			var _y = 0;
			var body = document.documentElement || document.body;
			var scrollY = window.pageYOffset || body.scrollTop;
			_y = rawDom.getBoundingClientRect().top + scrollY;
			return _y;
		}*/
		
		/*var someElement = document.getElementById('toggle-case-studies');
		someElement.checked = true;
		alert(someElement.checked);*/
		
		/*var options = {
			duration: 700,
			easing: 'easeInQuad',
			offset: 400,
			callbackBefore: function (element) {
				console.log('about to scroll to element', element);
			},
			callbackAfter: function (element) {
				console.log('scrolled to element', element);
			}
		};
		
		var someElement = document.getElementById('case_studies');
		smoothScroll(someElement, options);
		
		$('#back-top a').on("click", function(){
			$('html, body').animate({
				scrollTop: 0
			}, 800);
			return false;
		});*/
		
		/*vm.login = login;
		
		function login() {
			$window.location.href = PRAGMA.url + '/auth/login';
		}*/
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.home')
        .controller('HomeController', HomeController);

    /** @ngInject */
    function HomeController($scope, $interval, $http, $mdSidenav, $mdDialog, $document, msApi, weatherIcons, homeLocations, session, $timeout, dateFilter, toTrustedFilter,Notification,$rootScope)
    {
		var cnt = 10;
		var TabbedNotification;
		var CustomTabs;
		var idname = '';
		var tabid = '';
		TabbedNotification = function(options) {
			var message = "<div id='ntf" + cnt + "' class='text alert-" + options.type + "' style='display:none'><span class='notificationHeader'><i class='icon-bell' ></i> " + options.title +
			"</span><div class='close'><a href='javascript:;' class='notification_close'><i class='icon-close' style='color:grey'></i></a></div><p style='bottom:20px;'>" + options.text + "</p></div>";

			if (!document.getElementById('custom_notifications')) {
			alert('doesnt exists');
			} else {
			$('#custom_notifications ul.notifications').append("<li><a id='ntlink" + cnt + "' class='alert-" + options.type + "' href='#ntf" + cnt + "'><i class='icon-bell' id='n"+options.id+"' style='color:grey'></i></a></li>");
			$('#custom_notifications #notif-group').append(message);
			cnt++;
			CustomTabs(options);
			}
		};

CustomTabs = function(options) {
    $('.tabbed_notifications > div').hide();
    $('.tabbed_notifications > div:first-of-type').show();
    $('#custom_notifications').removeClass('dsp_none');
    $('.notifications a').click(function(e) {
    e.preventDefault();
    var $this = $(this),
        tabbed_notifications = '#' + $this.parents('.notifications').data('tabbed_notifications'),
        others = $this.closest('li').siblings().children('a'),
        target = $this.attr('href');
    others.removeClass('active');
    $this.addClass('active');
    $(tabbed_notifications).children('div').hide();
    $(target).show();
    });
};

CustomTabs();

if($rootScope.HomeStarted)
{
	$rootScope.HomeStarted=false;
	
}

        var vm = this;
		// User
		vm.user = session.getUser();

		
		// Color palette
		vm.palette = [
			"3,169,244",
			"146,39,143",
			"170,198,6",
			"242,135,6",
			"0,191,118",
			"102,45,145",
			"236,0,140",
			"0,148,68",
			"249,237,50",
			"239,65,54"
		];
		
		// Notifications
    /*
		vm.notifications=$rootScope.notifications;
		console.log($rootScope.notifications)
		for(var i=0;i<vm.notifications.data.length;i++)
		{
			if(!vm.notifications.data[i].shown)
			{
				if(vm.notifications.data[i].type==="Warning")
				{
					var type='warning';
				}
				else
				{
					type="error";
				}
				new TabbedNotification({
				title: vm.notifications.data[i].type,
				type: type,
				id:vm.notifications.data[i].id,
				text: '<i class="icon-crosshairs-gps"></i> '+vm.notifications.data[i].assetId+'<br/><i class="icon-note"></i> '+vm.notifications.data[i].message+'<br/><i class="icon-calendar"></i> '+vm.notifications.data[i].eventDate
				});
			}
		}
    */
		vm.showCompareBuildings=true;
		vm.showContractDetails=true;
		// Home Radar Chart Config
		vm.radar = [{},{},{}];
		vm.radar[0].show = false;
		vm.radar[0].series = ["Building Summary"];
		vm.radar[0].options = {
			legend: {
				display: true,
				position: "bottom"
			}, 
			responsive: true,
			scale: {
				reverse: false,
				ticks: {
					beginAtZero: true,
					display: false
				},
				pointLabels: {
					fontSize: 12
				}
			}
		};
		// Dates plots config
		vm.datesPlot={};
        vm.datesPlot.colors= [{
            lineTension: 0,
            backgroundColor: "rgba(242,135,6,0)",
            borderColor: "rgba(242,135,6,1)",
            pointBackgroundColor: "rgba(242,135,6,1)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgba(242,135,6,1)"
        },{
            lineTension: 0,
            backgroundColor: "rgba(35,160,4,0)",
            borderColor: "rgba(35,160,4,1)",
            pointBackgroundColor: "rgba(35,160,4,1)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgba(35,160,4,1)"
        }];
        vm.datesPlot.series = ['Date A','Date B'];
		// Dates plots config
		vm.buildingsPlot={};
        vm.buildingsPlot.colors= [{
			lineTension: 0,
			backgroundColor: "rgba(146,39,143,0)",
			borderColor: "rgba(146,39,143,1)",
			pointBackgroundColor: "rgba(146,39,143,1)",
			pointBorderColor: "#fff",
			pointHoverBackgroundColor: "#fff",
			pointHoverBorderColor: "rgba(146,39,143,1)"
		},{
			lineTension: 0,
			backgroundColor: "rgba(170,198,6,0)",
			borderColor: "rgba(170,198,6,1)",
			pointBackgroundColor: "rgba(170,198,6,1)",
			pointBorderColor: "#fff",
			pointHoverBackgroundColor: "#fff",
			pointHoverBorderColor: "rgba(170,198,6,1)"
		},{
			lineTension: 0,
			backgroundColor: "rgba(39,170,225,0)",
			borderColor: "rgba(39,170,225,1)",
			pointBackgroundColor: "rgba(39,170,225,1)",
			pointBorderColor: "#fff",
			pointHoverBackgroundColor: "#fff",
			pointHoverBorderColor: "rgba(39,170,225,1)"
		},
		{
			lineTension: 0,
			backgroundColor: "rgba(242,135,6,0)",
			borderColor: "rgba(242,135,6,1)",
			pointBackgroundColor: "rgba(242,135,6,1)",
			pointBorderColor: "#fff",
			pointHoverBackgroundColor: "#fff",
			pointHoverBorderColor: "rgba(242,135,6,1)"
		},
		{
			lineTension: 0,
			backgroundColor: "rgba(0,191,118,0)",
			borderColor: "rgba(0,191,118,1)",
			pointBackgroundColor: "rgba(0,191,118,1)",
			pointBorderColor: "#fff",
			pointHoverBackgroundColor: "#fff",
			pointHoverBorderColor: "rgba(0,191,118,1)"
		},
		{
			lineTension: 0,
			backgroundColor: "rgba(102,45,145,0)",
			borderColor: "rgba(102,45,145,1)",
			pointBackgroundColor: "rgba(102,45,145,1)",
			pointBorderColor: "#fff",
			pointHoverBackgroundColor: "#fff",
			pointHoverBorderColor: "rgba(102,45,145,1)"
		},
		{
			lineTension: 0,
			backgroundColor: "rgba(236,0,140,0)",
			borderColor: "rgba(236,0,140,1)",
			pointBackgroundColor: "rgba(236,0,140,1)",
			pointBorderColor: "#fff",
			pointHoverBackgroundColor: "#fff",
			pointHoverBorderColor: "rgba(236,0,140,1)"
		},
		{
			lineTension: 0,
			backgroundColor: "rgba(0,148,68,0)",
			borderColor: "rgba(0,148,68,1)",
			pointBackgroundColor: "rgba(0,148,68,1)",
			pointBorderColor: "#fff",
			pointHoverBackgroundColor: "#fff",
			pointHoverBorderColor: "rgba(0,148,68,1)"
		},
		{
			lineTension: 0,
			backgroundColor: "rgba(249,237,50,0)",
			borderColor: "rgba(249,237,50,1)",
			pointBackgroundColor: "rgba(249,237,50,1)",
			pointBorderColor: "#fff",
			pointHoverBackgroundColor: "#fff",
			pointHoverBorderColor: "rgba(249,237,50,1)"
		},
		{
			lineTension: 0,
			backgroundColor: "rgba(239,65,54,0)",
			borderColor: "rgba(239,65,54,1)",
			pointBackgroundColor: "rgba(239,65,54,1)",
			pointBorderColor: "#fff",
			pointHoverBackgroundColor: "#fff",
			pointHoverBorderColor: "rgba(239,65,54,1)"
		}];
		vm.buildingsPlot.series=[];
		angular.copy(vm.radar[0], vm.radar[1]);
		angular.copy(vm.radar[0], vm.radar[2]);
		
		// Details Chart Config
		vm.details = {};
		vm.details.loaded = false;
		
		// Line Chart Config
		vm.line = [{},{},{}];
		vm.line[0].options = {
			responsive: true,
      /*
			pan: {
				enabled: true,
				mode: 'x'
			},
			zoom: {
				enabled: true,
				mode: 'x'
			},
      */
			legend: {
				display: true,
				position: "bottom"
			},
			scales: {
				yAxes: [{
					type: "linear",
					display: true,
					position: "left"
				}]
			}
		};
		angular.copy(vm.line[0], vm.line[1]);
		angular.copy(vm.line[0], vm.line[2]);
		
		// Weather widget
		vm.weather = [];
		vm.weatherIcons = weatherIcons;
		vm.weatherWidget = {
			tempUnit: "C",
			speedUnit: "KMH"
		};
		
		// Now widget
		vm.nowWidget = {
			now   : {
				second: '',
				minute: '',
				hour  : '',
				day   : '',
				month : '',
				year  : ''
			},
			ticker: function ()
			{
				var now = moment();
				vm.nowWidget.now = {
					second : now.format('ss'),
					minute : now.format('mm'),
					hour   : now.format('HH'),
					day    : now.format('D'),
					weekDay: now.format('dddd'),
					month  : now.format('MMMM'),
					year   : now.format('YYYY')
				};
			}
		};
		
		// Data
		vm.data = [];
		vm.cdata = [];
		
		// Ranges
		vm.ranges = {
			"SL": "Selected Dates",
			"TD": "Today",
			"LD": "Yesterday",
			"TM": "This Month",
			"LM": "Last Month",
			"TY": "This Year",
			"LY": "Last Year"
		};
		vm.opposites = {
			"SL": "SL",
			"TD": "LD",
			"LD": "TD",
			"TM": "LM",
			"LM": "TM",
			"TY": "LY",
			"LY": "TY"
		};
		vm.range = [[],[],[]];
		vm.range[0].selected = "TM"; // Defaults to "This Month"
		vm.range[1].selected = "LM"; // Defaults to "Last Month"
		vm.range[2].selected = "TM"; // Defaults to "This Month"
		
		// Dates
		vm.dates 	= [];
		vm.maxDate = new Date();
		
		// Locations
		vm.locations = homeLocations
		vm.selectedLocation = [];
		if(vm.locations.length > 1)
		{
			var tempLocation={};
			tempLocation.id='all';
			tempLocation.address="All Sites";
			tempLocation.name="All Sites";
			tempLocation.city="";
			vm.locations.unshift(tempLocation)
		}
		selectLocation(vm.locations[0]);
		
		// Compare buildings
		vm.compareLocations = [];
		vm.selectAll = "Select All";
		vm.selectAllSelected = false;
		
		// Methods
		vm.toggleSidenav 	= toggleSidenav;
		vm.selectLocation 	= selectLocation;
		vm.selectRange 		= selectRange;
		vm.selectDates 		= selectDates;
		vm.refreshWeather 	= refreshWeather;
		vm.onTabSelected 	= onTabSelected;
		vm.selectAllLocations 	= selectAllLocations;
		vm.openLocationEditDialog = openLocationEditDialog;
		vm.downloadCanvasPng = downloadCanvasPng;
		vm.downloadSvgPng = downloadSvgPng;
		vm.downloadExcel = downloadExcel;
    vm.tickformat = tickformat;
    
    
    function tickformat(d) {
        return d3.time.format("%Y-%m-%d %H:%M")(new Date(d));
    }
		
        /**
         * Open Location Edit dialog
         *
         * @param ev
         * @param location
         */
        function openLocationEditDialog(ev, location)
        {
            $mdDialog.show({
                controller         : 'LocationEditDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/home/dialogs/location-edit/location-edit-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Location : location,
                    Locations: vm.locations,
                    event: ev
                }
            });
        }
		
		function downloadCanvasPng(element) {
      var el = document.getElementById(element);
      Canvas2Image.saveAsPNG(el, el.width, el.height, element);
    }
    
		function downloadSvgPng(element) {
			d3.selectAll("svg text").style({ 'font-size':'12px'});
			d3.selectAll(".c3-line").style({ 'fill':'none'});
			d3.selectAll(".c3-brush").style({ 'fill':'none'});
			d3.selectAll(".c3-axis path").style({ 'fill':'none', 'stroke': '#000' });
			d3.selectAll(".c3-chart-arc path").style({ 'stroke': '#FFFFFF' });
			d3.selectAll(".c3-chart-arc text").style({ 'fill': '#FFFFFF' });
			var el = document.getElementById(element).querySelector('svg');
			saveSvgAsPng(el, element);
			d3.selectAll(".c3-brush").style({ 'fill':'rgba(144,144,144,0.8)'});
    	}
    
    
		function downloadExcel(label) {
			var form = document.createElement("form");
			form.setAttribute("action", "https://pragma.nextiotee.com/klictet/API/index.php/getData?action=download&tag=" + label);
			form.setAttribute("method", "get");
			form.setAttribute("target", "_blank");
			
			var hiddenEle1 = document.createElement("input");
			hiddenEle1.setAttribute("type", "hidden");
			hiddenEle1.setAttribute("name", "action");
			hiddenEle1.setAttribute("value", "download");
			form.append(hiddenEle1);
	
			var hiddenEle2 = document.createElement("input");
			hiddenEle2.setAttribute("type", "hidden");
			hiddenEle2.setAttribute("name", "tag");
			hiddenEle2.setAttribute("value", label);
			form.append(hiddenEle2);
	
			var hiddenEle3 = document.createElement("input");
			hiddenEle3.setAttribute("type", "hidden");
			hiddenEle3.setAttribute("name", "assetId");
			hiddenEle3.setAttribute("value", vm.selectedLocation.id);
			form.append(hiddenEle3);
			
			var hiddenEle4 = document.createElement("input");
			hiddenEle4.setAttribute("type", "hidden");
			hiddenEle4.setAttribute("name", "startDate");
			hiddenEle4.setAttribute("value", moment(vm.dates[0].from).format());
			form.append(hiddenEle4);
			
			var hiddenEle5 = document.createElement("input");
			hiddenEle5.setAttribute("type", "hidden");
			hiddenEle5.setAttribute("name", "endDate");
			hiddenEle5.setAttribute("value", moment(vm.dates[0].to).format());
			form.append(hiddenEle5);
      
      document.body.appendChild(form);
			
			form.submit();
      
      document.body.removeChild(form);
		}
		
        // Select/Unselect All
		function selectAllLocations()
		{
			vm.selectAllSelected = (vm.selectAllSelected) ? false : true;
			
			vm.compareLocations = [];
			if (vm.selectAllSelected) {
				for (var i = 1; i < vm.locations.length; i++) {
					if (vm.locations[i].id != vm.selectedLocation.id) {
						vm.compareLocations.push(vm.locations[i].id);
					}
				}
				vm.selectAll = "Clear";
			}
			else {
				vm.selectAll = "Select All";
			}
			
		}
		
        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select location
         */
        function selectLocation(location)
        {
			// Reset
			vm.selectedTab = 0;
			angular.element('#home-content').animate({ scrollTop: 0 });
			vm.data[1] = vm.data[2] = undefined;
			vm.selectedLocation = location;
			
      vm.googleMapZoom = 8;
			vm.googlmapLocations = [];
      if (vm.locations.length > 1) {
        for (var i = 1; i < vm.locations.length; i++) {
          var temp = {
            "id": vm.locations[i].id,
            "labelContent": vm.locations[i].name,
            "coords": {
              latitude : vm.locations[i].lat,
              longitude: vm.locations[i].lon
            }
          };
          vm.googlmapLocations.push(temp);
        }
      }
      else {
          var temp = {
            "id": vm.locations[0].id,
            "labelContent": vm.locations[0].name,
            "coords": {
              latitude : vm.locations[0].lat,
              longitude: vm.locations[0].lon
            }
          };
          vm.googlmapLocations.push(temp);
      }
			vm.googleMapCenter = angular.copy(vm.googlmapLocations[0].coords);
      
			if (location.id !== "all") {
				if (vm.locations.length > 1) {
					vm.showCompareBuildings = true;
				}
				else {
					vm.showCompareBuildings = false;
				}
				vm.showContractDetails = true;
				
				vm.selectedLocation.coords = {
					latitude : vm.selectedLocation.lat,
					longitude: vm.selectedLocation.lon
				}
        // Home page map
        vm.googleMapCenter = angular.copy(vm.selectedLocation.coords);
        
        // Contracts page map
				vm.selectedLocation.center = angular.copy(vm.selectedLocation.coords);
			}
			else {
				vm.showCompareBuildings = false;
				vm.showContractDetails = false;
			}
			
          setData(vm.selectedLocation, vm.range[0].selected);
        }
		
		
        /**
         * Select range
         */
        function selectRange(dataset, also_update)
		{
			also_update = typeof also_update !== "undefined" ? also_update : 0;
			var r = vm.range[dataset].selected;
			
			if (r == "SL") {
				selectDates(dataset);
			}
			else {
				// In "Compare Dates" ranges are opposite
				if (dataset < 2) {
					var opposite = (dataset == 0) ? 1 : 0;
					if (vm.range[opposite].selected != "SL") {
						vm.range[opposite].selected = vm.opposites[r];
					}
				}
				
				if (!dataset) {
					setData(vm.selectedLocation, r);
					if (also_update) {
						loadCompareData(also_update, vm.range[also_update].selected);
					}
				}
				else {
					loadCompareData(dataset, r);
					if (also_update) {
						setData(vm.selectedLocation, vm.range[0].selected);
					}
				}
			}
        }
		
        /**
         * Select dates
         */
		function selectDates(dataset)
		{
			var d = vm.dates[dataset];
			
			if (!dataset) {
				setData(vm.selectedLocation, "", d);
			}
			else {
				loadCompareData(dataset, "", d);
			}
		}
		function setData(location, range, dates) {
			range = typeof range !== "undefined" ? range : '';
			dates = typeof dates !== "undefined" ? dates : false;
			if(location.id!=="all")
			{
				//var locationId='ea-location-'+location.city.toLowerCase();
				//locationId=locationId.replace(/ /g , "_");
				var params = {};
				var paramsTenant = {};
				if (dates) {
					params = {assetId: location.id, startDate: dates.from, endDate: dates.to}; //locationId:locationId, startDate: dates.from, endDate: dates.to};
				}
				else {
					params = {assetId: location.id, range: range}; // locationId:locationId, range: range};
				}
				msApi.request("home.data@get", params)
					.then(function(response) {
						vm.data[0] = response;
						redraw();
					}
				);
				setWeather(location);
			}
			else
			{
				var locations="";
				for(var i=1;i<vm.locations.length;i++)
				{
					locations+=vm.locations[i].id+",";
				}
				locations = locations.slice(0, -1);
				if (dates) {
					params = {assetId: locations, startDate: dates.from, endDate: dates.to};
				}
				else {
					params = {assetId: locations, range: range};
				}
				msApi.request("home.data_tenant@get", params)
					.then(function(response) {
						vm.data[0] = response;
						redraw();
					}
				);
				setWeather(vm.locations[1]);
			}
		}
		function redrawSite()
		{
			var v=vm.siteData.data;
			vm.data[0].buildings="Site";
			vm.data[0].data={};
			for(var i=0; i<Object.keys(v).length;i++)
			{
				vm.data[0].data[Object.keys(v)[i]]={};
				vm.data[0].data[Object.keys(v)[i]].buildingsCompare=v[Object.keys(v)[i]].buildingsCompare;
				vm.data[0].data[Object.keys(v)[i]].color=v[Object.keys(v)[i]].color;
				vm.data[0].data[Object.keys(v)[i]].datesCompare=v[Object.keys(v)[i]].datesCompare;
				vm.data[0].data[Object.keys(v)[i]].flip=v[Object.keys(v)[i]].flip;
				vm.data[0].data[Object.keys(v)[i]].historical=v[Object.keys(v)[i]].historical;
				vm.data[0].data[Object.keys(v)[i]].icon=v[Object.keys(v)[i]].icon;
				vm.data[0].data[Object.keys(v)[i]].id=v[Object.keys(v)[i]].id;
				vm.data[0].data[Object.keys(v)[i]].label=v[Object.keys(v)[i]].label;
				vm.data[0].data[Object.keys(v)[i]].overview=v[Object.keys(v)[i]].overview;
				vm.data[0].data[Object.keys(v)[i]].data=[];
				vm.data[0].data[Object.keys(v)[i]].rawData=[];
				for(var j=0;j<v[Object.keys(v)[i]].data.length;j++)
				{
					var temp={};
					temp.unit=v[Object.keys(v)[i]].data[j].unit;
					temp.count=[];
					var tempCount=0;
					for(var k=0;k<v[Object.keys(v)[i]].data[j].count.length;k++)
					{
						tempCount+=v[Object.keys(v)[i]].data[j].count[k];
					}
					temp.count[0]=tempCount;
					vm.data[0].data[Object.keys(v)[i]].data.push(temp);
				}
				vm.data[0].data[Object.keys(v)[i]].rawData[0]=v[Object.keys(v)[i]].rawData[0];
				for(var j=1;j<v[Object.keys(v)[i]].rawData.length;j++)
				{
					vm.data[0].data[Object.keys(v)[i]].rawData[j]=[];
					vm.data[0].data[Object.keys(v)[i]].rawData[j][0]=[];
					for(var k=0;k<v[Object.keys(v)[i]].rawData[j][0].length;k++)
					{
						var count=0;
						for(var g=0;g<v[Object.keys(v)[i]].rawData[j].length;g++)
						{
							count+=v[Object.keys(v)[i]].rawData[j][g][k];
						}
						vm.data[0].data[Object.keys(v)[i]].rawData[j][0].push(count);
					}
				}
			}
			redraw();
		}
		function loadCompareData(dataset, range, dates) {
			range = typeof range !== "undefined" ? range : '';
			dates = typeof dates !== "undefined" ? dates : false;
			
			var params = {};
			if(vm.selectedLocation.id!="all")
			{
				switch (dataset) {
				// Dataset: 1 => Compare dates, 2 => Compare Buildings
				case 1:
					var assetId = vm.selectedLocation.id;
				break;
				case 2:
					var assetId = vm.compareLocations.join(",");
				break;
				}
				if (dates) {
					params = {assetId: assetId, startDate: dates.from, endDate: dates.to};
				}
				else {
					params = {assetId: assetId, range: range};
				}
				
				msApi.request("home.compare_data@get", params)
					.then(function(response) {
						vm.cdata[dataset] = response;
						compareRedraw(dataset);
					}
				);
			}
			else
			{
				var locations="";
				for(var i=1;i<vm.locations.length;i++)
				{
					locations+=vm.locations[i].id+",";
				}
				locations = locations.slice(0, -1);
				if (dates) {
					params = {assetId: locations, startDate: dates.from, endDate: dates.to};
				}
				else {
					params = {assetId: locations, range: range};
				}
					msApi.request("home.data_tenant@get", params)
						.then(function(response) {
							vm.cdata[dataset] = response;
							compareRedraw(dataset);
						}
					);
				}
		}
		
        /**
         * Redraw
         */
		function redraw()
		{
			var d = vm.data[0];
			// Date-picker
			vm.dates[0] = [];
			vm.dates[0].from = new Date(d.startDate);
			vm.dates[0].to = new Date(d.endDate);
			
			// Range selector
			vm.range[0].selected = d.range;
			
			// Compare buildings list
			if (vm.locations.length > 1) {
				for (var i = 1; i < vm.locations.length; i++) {
					if (vm.locations[i].id != vm.selectedLocation.id) {
						vm.compareLocations = [vm.locations[i].id];
						break;
					}
				}
			}
			
			var x = d.data;
			
			if (Object.keys(x).length > 1) {
				
				d.empty = false;
				
				// Home widgets and data charts
				var j = 0;
				for (var i in x) {
					x[i].flex = getLayout(j, Object.keys(x).length);
					x[i].colors = [getColors(x[i].color)];
					x[i].series = [x[i].label];
					x[i].color = "rgb(" + x[i].color + ")";
					j++;
				}
				vm.comperable_prediction={};
				vm.comperable_prediction.series=[];
				vm.comperable_prediction.colors=[];
				vm.comperable_prediction.rawData=[];
				vm.comperable_prediction.rawData[1]=[];
				vm.comperable_prediction.rawData[2]=[];
				vm.comperable_production={};
				vm.comperable_production.series=[];
				vm.comperable_production.colors=[];
				vm.comperable_production.rawData=[];
				vm.comperable_production.rawData[1]=[];
				vm.comperable_production.rawData[2]=[];
				for (var i in x)
				{
					if(x[i].label==="PV Excess" || x[i].label==="Model Prediction" || x[i].label==="Nominal Prediction")
					{
						vm.comperable_prediction.series.push(x[i].label);
						vm.comperable_prediction.colors.push(x[i].colors[0]);
						vm.comperable_prediction.rawData[0]=x[i].rawData[0];
						vm.comperable_prediction.rawData[1].push(x[i].rawData[1][0]);
						vm.comperable_prediction.rawData[2].push(x[i].rawData[2][0]);
					}
					if(x[i].label==="PV Excess" || x[i].label==="Electricity")
					{
						vm.comperable_production.series.push(x[i].label);
						vm.comperable_production.colors.push(x[i].colors[0]);
						vm.comperable_production.rawData[0]=x[i].rawData[0];
						vm.comperable_production.rawData[1].push(x[i].rawData[1][0]);
						vm.comperable_production.rawData[2].push(x[i].rawData[2][0]);
					}
				}
				if(vm.comperable_prediction.series.length>1)
				{
					vm.comperable_prediction.show=true;
				}
				else
				{
					vm.comperable_prediction.show=false;
				}
				if(vm.comperable_production.series.length>1)
				{
					vm.comperable_production.show=true;
					vm.data[0].data.electricity.historical=false;
				}
				else
				{
					vm.comperable_production.show=false;
				}

				// Radar
				var r = vm.radar[0];
				r.data = [[]];
				r.labels = [];
				if (Object.keys(x).length >= 2) {
					r.show = true;
					r.colors = [getColors(vm.palette[0])];
					for (var i in x) {
						if(x[i].overview)
						{
							r.labels.push(x[i].label);
							r.data[0].push(x[i].data[0].count[0]);
							if (i == "total") {
								r.labels.push("C02-Emissions");
								r.data[0].push(x[i].data[1].count[0]);
							}
							if (i == "production" && typeof x[i].data[1] != "undefined") {
								r.labels.push("C02-Savings");
								r.data[0].push(x[i].data[1].count[0]);
							}
						}
					}
				}
				else {
					r.show = false;
				}
				
				// Raw values
				var v = vm.details;
				v.x = {"id": "x", "name": "Timeseries"};
				v.columns = [];
				var j = 0;
				for (var i in x) {
					if (i == 'gas' || i == 'electricity' || i == 'production') {
						v.columns[j] = {
							id: 	x[i].id,
							name:	x[i].label,
							type:	"area-spline",
							color:	d3.rgb(x[i].color)
						}
						j++;
					}
				}
        if (d.x !== null) {
          v.data = [];
          var found = false;
          for (var i = 0; i < d.x.length; i++) {
            var foo = { 'x': dateFilter(new Date(d.x[i]), "yyyy-MM-dd HH:mm:ss") };
            for (var j in x) {
              if (j == 'gas' || j == 'electricity' || j == 'production') {
                foo[j] = x[j].details[i];
                if (foo[j]) found = true;
              }
            }
            v.data.push(foo);
          }
          if (found) {
            v.extent = dateFilter(new Date(d.x[(d.x.length - 97)]), "yyyy-MM-dd HH:mm:ss") + "," + dateFilter(new Date(d.x[(d.x.length -1)]), "yyyy-MM-dd HH:mm:ss");
            v.loaded = true;
          }
        }
				
				for (var i = 1; i <= 2; i++) {
					if (typeof vm.data[i] != 'undefined' && typeof vm.cdata[i] != 'undefined') {
						vm.data[i] = fuseDatasets(vm.data[0], vm.cdata[i], i);
					}
				}
			}
			else {
				d.empty = true;
			}
		}
		
        /**
         * Compare Redraw
         */
		function compareRedraw(dataset)
		{
			if (vm.data[0].$resolved) {
				// Compare
				var c = vm.cdata[dataset];
				
				// Date-picker
				vm.dates[dataset] = [];
				vm.dates[dataset].from = new Date(c.startDate);
				vm.dates[dataset].to = new Date(c.endDate);
				
				// Range selector
				vm.range[dataset].selected = c.range;
				
				vm.data[dataset] = fuseDatasets(vm.data[0], c, dataset);
				
				// Radar
				vm.radar[dataset] = fuseRadars(vm.radar[0], c, dataset);
			}
			else {
				$timeout(compareRedraw(dataset), 500);
			}
		}
		
		function fuseDatasets(d, c, dataset)
		{
			for (var i in vm.locations)
			if(vm.locations[i].id===d.buildings)
				var thisBuildngName=vm.locations[i].name;
			var res = {data: {}};
			angular.copy(d.data, res.data);
			
			var locations = c.buildings.split(",");
			
			var x = c.data;
			var y = res.data;
			for (var i in x) {
				if (typeof y[i] != 'undefined') {
					y[i].series=[];
					y[i].series.push(thisBuildngName)
					switch (dataset) {
						case 1:
							// Label
							y[i].series.push(vm.ranges[vm.range[1].selected]);
							// Color
							y[i].colors.push(getColors(vm.palette[1]));
							// Difference
							y[i].difference = [];
							y[i].difference[0] = d.data[i].data[0].count[0] - x[i].data[0].count[0];
							y[i].difference[1] = d.data[i].data[1].count[0] - x[i].data[1].count[0];
						break;
						case 2:
							// Label
							for (var j = 0; j < locations.length; j++) {
								y[i].series.push(getLocationName(locations[j]));
								// Color
								y[i].colors.push(getColors(vm.palette[1 + j]));
							}
						break;
					}
					y[i].rawData[0] = [];
					for (var j = 0; j < x[i].rawData[1][0].length; j++) {
						y[i].rawData[0].push("");
					}
					for (var j = 0; j < c.data[i].rawData[1].length; j++) {
						y[i].rawData[1].push(x[i].rawData[1][j]);
						y[i].rawData[2].push(x[i].rawData[2][j]);
					}
					vm.buildingsPlot.series=y[i].series;
				}
			}
			return res;
		}
		
		function fuseRadars(a, c, dataset)
		{
			var res = {};
			angular.copy(a, res);
			
			var locations = c.buildings.split(",");
			
			var r = res;
			var x = c.data;
			if (Object.keys(x).length >= 2) {
				r.show = true;
				switch (dataset) {
					case 1:
						r.series.push(vm.ranges[vm.range[1].selected]);
						r.colors.push(getColors(vm.palette[1]));
					break;
					case 2:
						for (var j = 0; j < locations.length; j++) {
							r.series.push(getLocationName(locations[j]));
							r.colors.push(getColors(vm.palette[1 + j]));
						}
					break;
				}
				
				for (var j = 0; j < locations.length; j++) {
					r.data[j + 1] = [];
					for (var i in x) {
						r.data[j + 1].push(x[i].data[0].count[0]);
						if (i == "total") {
							r.data[j].push(x[i].data[1].count[0]);
						}
						if (i == "PV Excess" && typeof x[i].data[1] != "undefined") {
							r.data[j + 1].push(x[i].data[1].count[0]);
						}
					}
				}
			}
			else {
				r.show = false;
			}
			
			return res;
		}
		
		function getColors(color) {
			return {
				lineTension:0,
				borderColor:				"rgba(" + color + ",1)",
				backgroundColor: 			"rgba(" + color + ",0.1)",
				pointBorderColor:			"#fff",
				pointBackgroundColor:		"rgba(" + color + ",1)",
				pointHoverBorderColor:		"rgba(" + color + ",1)",
				pointHoverBackgroundColor:	"#fff"
			}
		}
		
		function getLocationName(id) {
			for (var i = 0; i < vm.locations.length; i++) {
				if (vm.locations[i].id == id) {
					return vm.locations[i].name;
				}
			}
		}
		
		function onTabSelected(dataset) {
			if (typeof vm.data[dataset] == 'undefined') {
				selectRange(dataset);
			}
		}
		
		
        /**
         * Get layout of home widgets
         */
		function getLayout(i, length) {
			if (length == 1) {
				return 100;
			}
			else if (length % 2) {
				if (i == length - 1) {
					return 100;
				}
			}
			return 50;
		}
		
        /**
         * Set weather
         */
		function setWeather(location, refresh) {
			// Default: do not refresh
			refresh = typeof refresh !== "undefined" ? refresh : false;
			if (refresh || !vm.weather[location.id]) {
				msApi.request('home.forecast@get', {lat: location.lat, lon: location.lon})
					.then(function(response) {
						vm.weather[location.id] = response;
						var w = vm.weather[location.id];
						var x = vm.weather[location.id].list[0];
						// Location
						w.name = w.city.name;
						w.main = x.main;
						
						// Weather
						w.weather = [x];
						w.weather[0].icon = getWeatherIcon(x.weather[0].id);	
						// Wind
						w.wind = [];
						w.wind.speed = x.wind.speed * 3.6; // Convert to km/h
						w.wind.icon = 'wi wi-wind from-' + parseInt(x.wind.deg) + '-deg';
						if (x.wind.deg < 11.25) w.wind.dir = 'N';
							else if (x.wind.deg < 33.75) w.wind.dir = 'NNE';
							else if (x.wind.deg < 56.25) w.wind.dir = 'NE';
							else if (x.wind.deg < 78.75) w.wind.dir = 'ENE';
							else if (x.wind.deg < 101.25) w.wind.dir = 'E';
							else if (x.wind.deg < 123.75) w.wind.dir = 'ESE';
							else if (x.wind.deg < 146.25) w.wind.dir = 'SE';
							else if (x.wind.deg < 168.75) w.wind.dir = 'SSE';
							else if (x.wind.deg < 191.25) w.wind.dir = 'S';
							else if (x.wind.deg < 213.75) w.wind.dir = 'SSW';
							else if (x.wind.deg < 236.25) w.wind.dir = 'SW';
							else if (x.wind.deg < 258.75) w.wind.dir = 'WSW';
							else if (x.wind.deg < 281.25) w.wind.dir = 'W';
							else if (x.wind.deg < 303.75) w.wind.dir = 'WNW';
							else if (x.wind.deg < 326.25) w.wind.dir = 'NW';
							else if (x.wind.deg < 348.75) w.wind.dir = 'NNW';
							else w.wind.dir = 'N';
						
						// Forecast
						var j = 0;
						w.forecast = [];
						for (var i = 0; i < 40; i++) {
							x = vm.weather[location.id].list[i];
							if (moment(x.dt_txt).format('H') == 15) {
								w.forecast[j] = {};
								w.forecast[j].name = moment(x.dt_txt).format('dddd');
								w.forecast[j].temp = x.main.temp;
								w.forecast[j].icon = getWeatherIcon(x.weather[0].id);
								j++;
							}
							if (j > 2) break;
						}
					}
				);
			}
		}
		
        /**
         * Refresh weather
         */
		function refreshWeather() {
			setWeather(vm.selectedLocation, true);
		}
		
        /**
         * Get weather icon
         */
		function getWeatherIcon(code) {
			var icon = weatherIcons[code].icon;
			if (!(code > 699 && code < 800) && !(code > 899 && code < 1000)) {
				icon = 'day-' + icon;
			}						
			return 'wi wi-' + icon;
		}
		
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.graphs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.graphs', {
            url      : '/graphs',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/graphs/graphs.html',
                    controller : 'GraphsController as vm'
                }
            },
            bodyClass: 'graphs'
        });

        msNavigationServiceProvider.saveItem('graphs', {
            title : 'NAVIGATION.RAW_DATA',
            state: 'app.graphs',
            group : true,
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.graphs')
        .controller('GraphsController', GraphsController);

    function GraphsController($scope, $element, $http, $mdSidenav, msApi, session, $rootScope, $mdDialog, $document, $base64, Notification, filterFilter, dateFilter, PRAGMA, pragmaapi)
    {
        // Declare Variables 
        var dFrom;
        var dTo;
            var vm = this;	
            vm.user = session.getUser();
        vm.tenants=[];
        vm.selected_nodes=[];
        vm.counter=0;
        vm.selectedTenant={};
        var dfrom=new Date();
        vm.timeout="";
        dfrom.setDate(dfrom.getDate()-1);
        vm.portCounter=0;
        vm.date={
          from:dfrom,
          to:new Date()
        };
        // Tree
        pragmaapi.getTreeData(true, true,true,true).then(function(treeData) {
            vm.treeData = treeData;
            vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'checkbox']);
        });
        vm.refreshTree = function() {
            pragmaapi.getTreeData(true, true,true,true).then(function(treeData) {
                vm.treeData = treeData;
                vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow','checkbox']);
            });
        }


		vm.applySearch = function (){
			if(vm.treeInstance) {
			vm.treeInstance.jstree(true).search(vm.searchtree);
			}
		};
		
		vm.treeEvents = {
            'ready': readyCB,
            'create_node': createNodeCB,
            'select_node': getSelectedNodes,
            'deselect_node': getSelectedNodes
        }

        vm.selectedNode = {};
        function getSelectedNodes() {
			vm.selected_nodes=[];
            vm.selectedNode = {};
            var jstree = vm.treeInstance.jstree(true);
            vm.selected_nodes = jstree.get_selected();
            if (vm.selected_nodes[0]) {
                vm.selectedNode = jstree.get_node(vm.selected_nodes[0]);
            }
			vm.vizualizeData();
        }
        
        function readyCB() {
        }
        
        function createNodeCB() {
        }

		// showNotification("Info","Please select data to display!","Info");
		vm.tree= [];
		vm.tempDetails=[];
		vm.url = PRAGMA.api;
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
		vm.toggleSidenav = toggleSidenav;
		vm.saveImage=saveImage;
		vm.exportCsv=exportCsv;
		vm.vizualizeData=vizualizeData;
		vm.changeDate=changeDate;
		vm.showCalendar=0;
		vm.chart;
		vm.onbrush=onbrush;
		vm.toggleCalendar=toggleCalendar;
		vm.chartCallBack=chartCallBack;
		
		vm.graphColors=[
			d3.rgb(242,135,6),
			d3.rgb(35,160,4),
			d3.rgb(146,39,143),
			d3.rgb(170,198,6),
			d3.rgb(39,170,225),
			d3.rgb(242,135,6),
			d3.rgb(0,191,118),
			d3.rgb(102,45,145),
			d3.rgb(39,170,225)
		];
		vm.friendlyNames={
			kwhCons: "Electricity",
			kwhProd: "PV Excess",
			m3Cons: "Gas",
			kwhConsReading: "Electricity Reading",
			kwhProdReading: "PV Excess Reading",
			m3ConsReading: "Gas Reading",
			kwhConsreading: "Electricity Reading",
			kwhProdreading: "PV Excess Reading",
			m3Consreading: "Gas Reading",
			V_L1_N: "Line 1 to Neutral Voltage",
			V_L2_N: "Line 2 to Neutral Voltage",
			V_L3_N: "Line 3 to Neutral Voltage",
			V_L1_L2: "Line 1 to Line 2 Voltage",
			V_L2_L3: "Line 2 to Line 3 Voltage",
			V_L3_L1: "Line 3 to Line 1 Voltage",
			A_L1: "Amperage Line 1",
			A_L2: "Amperage Line 2",
			A_L3: "Amperage Line 3",
			W_L1: "Active Power Line 1 (Watt)",
			W_L2: "Active Power Line 2 (Watt)",
			W_L3: "Active Power Line 3 (Watt)",
			VA_L1: "Apparent Power Line 1",
			VA_L2: "Apparent Power Line 2",
			VA_L3: "Apparent Power Line 3",
			VAR_L1: "Reactive Power Line 1",
			VAR_L2: "Reactive Power Line 2",
			VAR_L3: "Reactive Power Line 3",
			V_L_N_S: "Total Line to Neutral Voltage",
			V_L_L_S: "Total Line to Line Voltage",
			W_S: "Total Active Power (Watt)",
			VA_S: "Total Apparent Power",
			VAR_S: "Total Reactive Power",
			PF_L1: "Power Factor Line 1",
			PF_L2: "Power Factor Line 2",
			PF_L3: "Power Factor Line 3",
			PF_S: "Total Power Factor",
			Hz: "Frequency",
			KWh_S: "Total Active Energy (kWh)",
			Kvarh_Tot: "Total Reactive Energy (kVarh)"
		}
		vm.details={
			x:null,
			columns:null,
			data:null
		};
		vm.graphType='area-spline';
		vm.graphTypes=[
			{type:"area-spline",name:"Spline Area Chart"},
			{type:"area",name:"Area Chart"},
			{type:"scatter",name:"Scatter Chart"},
			{type:"area-step",name:"Step Area Chart"},
			{type:"step",name:"Step Chart"},
			{type:"line",name:"Line Chart"},
			{type:"spline",name:"Spline Chart"},
			{type:"bar",name:"Bar Chart"}
		];
    
    vm.tickformat = tickformat;
    function tickformat(d) {
        return d3.time.format("%Y-%m-%d %H:%M")(new Date(d));
    }
    
		
		function visualizeAfterTimeout()
		{
     
			vm.selectedAssignments=[];
			var measurementsTemp=[];
			for(var i=0;i<vm.selected_nodes.length;i++)
			{
				if(vm.selected_nodes[i].includes("measurement"))
					measurementsTemp.push(vm.selected_nodes[i]);
			}
			for(var i=0;i<vm.treeData.length;i++)
			{
				for(var j=0;j<measurementsTemp.length;j++)
				{
					if(vm.treeData[i].id===measurementsTemp[j])
					{

						var temp=vm.treeData[i].tenantAuthToken+":"+vm.treeData[i].token+":"+vm.treeData[i].measure+":"+vm.treeData[i].site;
						vm.selectedAssignments.push(temp);
					}
				}
			}
			vm.showgraph=0;
			if(vm.date.from!=="" && vm.date.to!=="" && vm.selectedAssignments.length>0)
			{
        		angular.element(".graph-message p").html('<img src="assets/images/throbber.gif"> Loading data. Please wait...');
        
				dFrom=dateTransform(vm.date.from);
				dTo=dateTransform(vm.date.to);
				dFrom+="T00:00:00.000%2B0200";
				dTo+="T23:59:00.000%2B0200";
				vm.details={
					x:{
						id: "x", 
						name: "Timeseries"
					},
					columns:[],
					data:[]
				};
				vm.counter=0;
				vm.tempDetails=[];
				for(var dev=0;dev<vm.selectedAssignments.length;dev++)
				{
					drawChart(vm.selectedAssignments[dev]);
				}
			}
			else
			{
          		angular.element(".graph-message p").text("Please select data to display...");
			}
		}
		function onbrush(dates)
		{
			var from=new Date(dates[0]);
			var to=new Date(dates[1]);
			var from_=Date.parse(from)/1000;
			var to_=Date.parse(to)/1000;
			var def=to_-from_;
			var day=86400;
			if(def<=day) // Day raw data
			{

			}
			else if(def<=3*day) // Hour aggregated data
			{

			}
			else if(def<=day*56) // 8 weeks
			{

			}
			else if(def<=day*84) //12 weeks
			{

			}
			else
			{

			}
		}
		function vizualizeData()
		{
      visualizeAfterTimeout();
			/*if(vm.timeout!=="")
				clearTimeout(vm.timeout);
			vm.timeout=setTimeout(visualizeAfterTimeout,100);
      */
		}
		function changeDate(date)
		{
			var from=new Date();
			var to= new Date();
			switch (date)
			{
				case 'year':
					from.setMonth(0);
					from.setDate(1);
				break;
				case 'month':
				from.setDate(1);
				break;
				case 'week':
					from.setDate(from.getDate() - from.getDay());
				break;
				case 'yesterday':
					from.setDate(from.getDate()-1);
					to.setDate(to.getDate()-1);
				break;
			}
			vm.date={
				from:from,
				to:to
			};
			vizualizeData();
		}
		function drawChart(selected)
		{
			var temp=[];
			temp=selected.split(":");
      
			pragmaapi.callRestService(vm.url,"/assignments/"+temp[1]+"/measurements","?startDate="+dFrom+"&endDate="+dTo+"&page=1&pageSize=2000&tenantAuthToken="+temp[0],true,vm.user.authentication,"GET",true).then(function(res){
				vm.measurements = res.data.results;
				if(vm.measurements.length>0)
				{
					var j = 0;
					for(var k=0;k<Object.keys(vm.measurements[0].measurements).length;k++)
					{
						if(Object.keys(vm.measurements[0].measurements)[k]===temp[2])
						{
							if(typeof vm.friendlyNames[temp[2]]!=="undefined")
							{
								var temp1={
								id: 	vm.friendlyNames[temp[2]]+" ("+temp[3]+")",
								name:	vm.friendlyNames[temp[2]]+" ("+temp[3]+")",
								type:	vm.graphType,
								color:	vm.graphColors[vm.details.columns.length]
								}
							}
							else
							{
								var temp1={
								id: 	temp[2]+" ("+temp[3]+")",
								name:	temp[2]+" ("+temp[3]+")",
								type:	vm.graphType,
								color:	vm.graphColors[vm.details.columns.length]
								}
							}
							vm.details.columns.push(temp1);
						}	
					}
					for (var i = 0; i < vm.measurements.length; i++) 
					{
						var foo = { 
							x: dateFilter(new Date(vm.measurements[i].eventDate), "yyyy-MM-dd HH:mm:ss")
						};
						for (var j in vm.measurements[i].measurements) 
						{
							for(var k=0;k<vm.details.columns.length;k++)
							{
								if(typeof vm.friendlyNames[j]!=="undefined")
								{
									if ((vm.friendlyNames[j]+" ("+temp[3]+")") == vm.details.columns[k].id) 
									{
										var t=vm.friendlyNames[j]+" ("+temp[3]+")";
										foo[t] = vm.measurements[i].measurements[j];
									}
								}
								else
								{
									if ((j+" ("+temp[3]+")") == vm.details.columns[k].id) 
									{
										var t=j+" ("+temp[3]+")";
										foo[t] = vm.measurements[i].measurements[j];
									}
								}
							}
						}
						vm.tempDetails.push(foo);
					}
    
					vm.counter++
					finalChart();
				}
        else {
          angular.element(".graph-message p").text("No data found...");
        }
			});
		}
		function finalChart()
		{
			if(vm.counter==vm.selectedAssignments.length)
			{
        angular.element(".graph-message p").html('<img src="assets/images/throbber.gif"> Preparing graph. Please wait...');
				var tempDates=[];
				for(var i=0;i<vm.tempDetails.length;i++)
				{
					var flag=0;
					for(var k=0;k<tempDates.length;k++)
					{
						if(tempDates[k]===vm.tempDetails[i].x)
							flag=1;
					}
					if(flag==0)
						tempDates.push(vm.tempDetails[i].x)
				}
				vm.details.data=[];
				for(var i=0;i<tempDates.length;i++)
				{
					var temp={};
					temp.x=tempDates[i];
					for(var k=0;k<vm.tempDetails.length;k++)
					{
						if(vm.tempDetails[k].x===tempDates[i])
						{
							for (var j=0;j<Object.keys(vm.tempDetails[k]).length;j++)
							{
								if(Object.keys(vm.tempDetails[k])[j]!=="x")
								{
									temp[Object.keys(vm.tempDetails[k])[j]]=vm.tempDetails[k][Object.keys(vm.tempDetails[k])[j]];
								}
							}
						}
					}
					vm.details.data.push(temp);
				}
				vm.showgraph=1;
			}
		}	
		function putTreeMeasurements(site,group,device,measurements)
		{
			for(var i=0;i<vm.tree.length;i++)
			{
				if(vm.tree[i].label===site)
					var siteNum=i;
			}
			if(typeof siteNum!=="undefined")
			{
				for(var j=0;j<vm.tree[siteNum].children.length;j++)
				{
					if(vm.tree[siteNum].children[j].label===group)
						var groupNum=j;
				}
				if(typeof groupNum !=="undefined")
				{
					for(var k=0;k<vm.tree[siteNum].children[groupNum].children.length;k++)
					{
						if(vm.tree[siteNum].children[groupNum].children[k].label===device.device.metadata.name)
							var deviceNum=k;
					}
					if(typeof deviceNum !=="undefined")
					{
						for (var n=0;n<measurements.length;n++)
						{
							var temp={};

							if(typeof vm.friendlyNames[measurements[n]]!=="undefined")
							{
								temp.label=vm.friendlyNames[measurements[n]];
								temp.value=measurements[n]+":"+device.device.assignment.token+":"+site+":"+device.device.metadata.name;
								vm.tree[siteNum].children[groupNum].children[deviceNum].children.push(temp);
							}
							else
							{
								temp.label=measurements[n];
								temp.value=measurements[n]+":"+device.device.assignment.token+":"+site+":"+device.device.metadata.name;
								vm.tree[siteNum].children[groupNum].children[deviceNum].children.push(temp);
							}
						}
					}
				}
			}
		}
		function exportCsv()
		{
      if (vm.details.data != null) {
          var csvContent = "data:text/csv;charset=utf-8,";
          // Header
          for(var k=0;k<Object.keys(vm.details.data[0]).length;k++)
          {
              var label = '';
              if (Object.keys(vm.details.data[0])[k] == 'x') {
                  label = 'timestamp';
              }
              else {
                label = Object.keys(vm.details.data[0])[k];
              }
              csvContent+='"'+label+'"'+";";
          }
          csvContent=csvContent.slice(0, -1);
          csvContent+="\n";
          for(var i=0;i<vm.details.data.length;i++)
          {
            for(var k=0;k<Object.keys(vm.details.data[i]).length;k++)
            {
              //csvContent+=Object.keys(vm.details.data[i])[k]+",";
              csvContent+='"'+vm.details.data[i][Object.keys(vm.details.data[i])[k]]+'"'+";";
            }
            csvContent=csvContent.slice(0, -1);
            csvContent+="\n";
          }
          var encodedUri = encodeURI(csvContent);
          var link = document.createElement("a");
          link.setAttribute("href", encodedUri);
          link.setAttribute("download", "raw_data.csv");
          document.body.appendChild(link); // Required for FF

          link.click();
      }
		}
		function dateTransform(date)
		{
			var YY=date.getFullYear();
			var DD;
			var MM;
			if(date.getMonth()+1<10)
				MM="0"+(date.getMonth()+1);
			else
				MM=date.getMonth()+1;
			if(date.getDate()<10)
				DD="0"+date.getDate();
			else
				DD=date.getDate();
			var thisDate=YY+"-"+MM+"-"+DD;
			return thisDate;
		}
		function showNotification(title,message,type)
        {
            if(type==="Error")
            {
                Notification.error({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if(type==="Info")
            {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if(type==="Warning")
            {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if(type==="Success")
            {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }   
        }
		function saveImage(element) {
			d3.selectAll("svg text").style({ 'font-size':'12px'});
			d3.selectAll(".c3-line").style({ 'fill':'none'});
			d3.selectAll(".c3-brush").style({ 'fill':'none'});
			d3.selectAll(".c3-axis path").style({ 'fill':'none', 'stroke': '#000' });
			d3.selectAll(".c3-chart-arc path").style({ 'stroke': '#FFFFFF' });
			d3.selectAll(".c3-chart-arc text").style({ 'fill': '#FFFFFF' });
			var el = document.getElementById(element).querySelector('svg');
			saveSvgAsPng(el, element);
			d3.selectAll(".c3-brush").style({ 'fill':'rgba(144,144,144,0.8)'});
    	}	
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
		function toggleCalendar()
		{
			if(vm.showCalendar)
				vm.showCalendar=0;
			else
				vm.showCalendar=1;
		}
		function chartCallBack(chart)
		{
			vm.chart=chart;
      angular.element(".graph-message p").html('');
		}
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.explore', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.explore', {
            url      : '/explore',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/explore/explore.html',
                    controller : 'ExploreController as vm'
                }
            },
            bodyClass: 'explore'
        });

        msNavigationServiceProvider.saveItem('explore', {
            title : 'NAVIGATION.EXPLORE',
            state: 'app.explore',
            group : true,
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.explore')
        .controller('ExploreController', ExploreController);

    /** @ngInject */
    function ExploreController($scope, $element, $http, $q, $timeout, $cookies, $filter, $mdSidenav, msApi, session, $rootScope, $mdDialog, $document, $base64, Notification, filterFilter, dateFilter, PRAGMA, pragmaapi, pragmaTheming, $translate)
    {
        var vm = this;	
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
		
        var cache = {};
		
        // Timezone
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        
        // Theming
        
		vm.themes = pragmaTheming.themes;
        var isDark = (vm.themes.active.name.indexOf('Dark') >= 0);
        
        
        // Chart 
        
        vm.chart = {};
        resetChart();
        
        vm.units = [];
        vm.sites = [];
        vm.labels = [];
        vm.applyD = false;
		
        // Chart zoom
        vm.chartZoom = '';
        vm.setZoom = function (zoom) {
            angular.element('#zoom-ctrl button').removeClass('active');
            angular.element('.zoom-' + zoom.slice(-1)).addClass('active');
            vm.chartZoom = zoom;
            updateStatus(pragmaapi.translate('EXPLORE.PREPARING_DATA'), true);
            
            // Timeout to give time for status to update
            $timeout(function() { drawChart(); }, 50);
        }
        
        $scope.croshair = _.memoize(function() {
            return new Dygraph.Plugins.Crosshair({
                            direction: "vertical"
                        });
        });
        
        function resetChart() {
            vm.chart = {
                data: [],
                options: {
                    labels: ["Date"],
                    ylabel: "Primary y-axis",
                    y2label: "Secondary y-axis",
                    series: {},
                    strokeWidth: 1,
                    axisLineColor: vm.themes.active.theme.background.hue1.contrast3,
                    gridLineColor: vm.themes.active.theme.background.hue1.contrast4,
                    fillGraph: true,
                    connectSeparatedPoints: true,
                    showRangeSelector: true,
                    interactionModel : {
                        mousedown : downV3,
                        mousemove : moveV3,
                        mouseup : upV3,
                        dblclick : dblClickV3
                    },
                    legendFormatter: function(data) {
                        if (data.x == null) return '';  // no selection
                        var html = data.xHTML;
                        data.series.forEach(function(series, i) {
                            if (!series.isVisible) return;
                            if (series.y == undefined) return;
                            var labeledData = '<span style="color:' + series.color + '">' + getAssetName(selectedNodes[i]) + '</span>: ' + filterNumber(series.y) + vm.units[i];
                            if (series.isHighlighted) {
                                labeledData = '<b>' + labeledData + '</b>';
                            }
                            html += ' &nbsp; ' + labeledData;
                        });
                        return html;
                    },
                    plugins: [ $scope.croshair ],
                    axes: {
                        x: {
                            drawAxis: true
                        },
                        y: {
                            drawAxis: true
                        },
                        y2: {
                            drawAxis: true
                        }
                    }
                }
            }
        }
        
        
        // Tabs
        
        vm.selectedTab = 'chart';
        vm.selectTab = function(tab) {
            vm.selectedTab = tab;
        }
        
        
        // Table
        
        vm.exploreTable = {};
        vm.exploreTable.limitOptions = [5, 10, 15, {
            label: 'All',
            value: function () {
                  return vm.chart.data.length ? vm.chart.data.length : 0;
            }
        }];
        vm.exploreTable.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: false,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: false,
            limitSelect: true,
            pageSelect: true
        };
        vm.exploreTable.query = {
            order: 'date',
            limit: 10,
            page: 1
        };
        vm.exploreTable.filter = {
            search: ''
        };
        
        
        // Date Range
        
        vm.date = {
          startDate: moment().startOf('day'),
          endDate: moment()
        };
        
        function translateDateRange() {
            var ranges = {}
            ranges[$filter('translate')("DATERANGE.LAST_7_DAYS")] = [moment().subtract(6, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.LAST_30_DAYS")] = [moment().subtract(29, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.THIS_MONTH")] = [moment().startOf('month'), moment()]
            ranges[$filter('translate')("DATERANGE.LAST_MONTH")] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
            ranges[$filter('translate')("DATERANGE.THIS_YEAR")] = [moment().startOf('year'), moment()];
            
            vm.dateOptions = {
                applyClass: 'md-button md-raised',
                alwaysShowCalendars: true,
                autoUpdateInput: true,
                autoApply: true,
                locale: {
                    applyLabel: $filter('translate')("DATERANGE.APPLY"),
                    fromLabel: $filter('translate')("DATERANGE.FROM"),
                    format: "ll",
                    toLabel: $filter('translate')("DATERANGE.TO"),
                    cancelLabel: $filter('translate')("DATERANGE.CANCEL"),
                    customRangeLabel: $filter('translate')("DATERANGE.CUSTOM_RANGE"),
                    daysOfWeek: [
                        $filter('translate')("DATERANGE.SU"),
                        $filter('translate')("DATERANGE.MO"),
                        $filter('translate')("DATERANGE.TU"),
                        $filter('translate')("DATERANGE.WE"),
                        $filter('translate')("DATERANGE.TH"),
                        $filter('translate')("DATERANGE.FR"),
                        $filter('translate')("DATERANGE.SA")
                    ],
                    monthNames: [
                        $filter('translate')("DATERANGE.JANUARY"),
                        $filter('translate')("DATERANGE.FEBRUARY"),
                        $filter('translate')("DATERANGE.MARCH"),
                        $filter('translate')("DATERANGE.APRIL"),
                        $filter('translate')("DATERANGE.MAY"),
                        $filter('translate')("DATERANGE.JUNE"),
                        $filter('translate')("DATERANGE.JULY"),
                        $filter('translate')("DATERANGE.AUGUST"),
                        $filter('translate')("DATERANGE.SEPTEMBER"),
                        $filter('translate')("DATERANGE.OCTOBER"),
                        $filter('translate')("DATERANGE.NOVEMBER"),
                        $filter('translate')("DATERANGE.DECEMBER")
                    ],
                },
                ranges: ranges,
                eventHandlers: {
                    'apply.daterangepicker': changePeriod
                }
            }
        }
        translateDateRange();
        
        $rootScope.$on('$translateChangeSuccess', function () {
            translateDateRange();
        });
        
        angular.element('body').on('click', '.daterangepicker .month', function() {
            var lang = $cookies.get('lang');
            if (lang != undefined) {
                var drp = angular.element('#daterange').data('daterangepicker');
                var momentDate = moment('1 ' + angular.element(this).text(), "D MMM YYYY", lang);
                drp.setStartDate(momentDate.startOf('month'));
                drp.setEndDate(momentDate.endOf('month'));
                drp.clickApply();
            }
        })
        vm.showTree=false;
        function changePeriod() {
            if (vm.applyD) {
				console.log("Apply only the Date");
				//do not refresh the data just apply the date
				vm.applyD = false;
				return;
			}
			else {
				cache = {};
				resetChart();
				addAllNodesToGraph(selectedNodes);
			}

        }
        vm.currentModule=vm.user.currentModule;
        vm.parentModule=vm.user.parentModule;
        if(vm.currentModule==='' || vm.parentModule==='#')
        {
            vm.filter={
                device:{},
                site:{},
                specification:{},
                includeDevices:true,
                includeMeasurements:true,
                specs:[],
                measurements:{}
            };
        }
        else
        {
            vm.filter={
                device:[{modules:[vm.currentModule]}],
                site:{},
                specification:{},
                includeDevices:true,
                includeMeasurements:true,
                specs:[],
                measurements:{}
            };
        }
        $scope.$on('change.module', function(event, args) {
            vm.showTree=false;
            if(args.parent==='#')
            {
                vm.filter={
                    device:{},
                    site:{},
                    specification:{},
                    includeDevices:true,
                    includeMeasurements:true,
                    specs:[],
                    measurements:{}
                };
            }
            else
            {
                vm.filter={
                    device:[{modules:[args.token]}],
                    site:{},
                    specification:{},
                    includeDevices:true,
                    includeMeasurements:true,
                    specs:[],
                    measurements:{}
                };
            }
            vm.refreshTree(false);
        });
        // Tree
        
        vm.refreshTree = function(refresh) {
            pragmaapi.getTreeDataFilter(vm.filter).then(function(treeData) {
                vm.treeData = processTreeData(treeData);
                vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'checkbox', 'state']);
                vm.treeConfig.checkbox = { three_state : false };
                vm.treeConfig.state = { key : "explore" };
                vm.showTree=true;
            });
            /*pragmaapi.getTreeData(true, true, true, true).then(function(treeData) {
                vm.treeData = processTreeData(treeData);
                vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'checkbox', 'state']);
                vm.treeConfig.checkbox = { three_state : false };
                vm.treeConfig.state = { key : "explore" };
            });*/
        }
        vm.refreshTree(false);
        
		vm.applySearch = function () {
			if (vm.treeInstance) {
                vm.treeInstance.jstree(true).search(vm.searchtree);
			}
		};
        
        vm.openTree = function () {
			if (vm.treeInstance) {
                vm.treeInstance.jstree().open_all();
			}
		};
        
        vm.closeTree = function () {
			if (vm.treeInstance) {
                vm.treeInstance.jstree().close_all();
			}
		};
        
        vm.resetTree = function () {
			if (vm.treeInstance) {
                cache = {};
                vm.treeInstance.jstree().deselect_all();
			}
		};
		
		vm.treeEvents = {
            'select_node': selectNode,
            'deselect_node': deselectNode,
            'deselect_all': deselectNode,
            'hover_node': hoverNode
        }
        
        function hoverNode(e, data){
            jQuery("#" + data.node.id + "_anchor").prop('title', data.node.text);
        };

        var loading = 0;
        var selectedNodes = [];
        function selectNode(e, data) {
            if (data.instance.is_leaf(data.node)) {
                selectedNodes.push(data.node);
                loading++;
                // Natural order
                selectedNodes.sort(function(a, b) {return (parseInt(a.id.substring(12)) > parseInt(b.id.substring(12))) ? 1 : ((parseInt(b.id.substring(12)) > parseInt(a.id.substring(12))) ? -1 : 0);});
                addNodeToGraph(data.node);
            }
        }
        
        function deselectNode(e, data) {
            if (data.node.id == null) { // Deselect all
                selectedNodes = [];
                resetChart();
            }
            else {
                if (data.instance.is_leaf(data.node)) {
                    var pos = jQuery.inArray(data.node, selectedNodes);
                    selectedNodes.splice(pos, 1);
                    removeNodeFromGraph(data.node);
                }
            }
        }
        
        function processTreeData(treeData) {
            var texts = {};
            treeData.forEach(function(node, j) {
                if (!nodeType(node, "client")) {
                    texts[node.id] = node.text;
                }
            });
            treeData.forEach(function(node, j) {
                if (node.text != null) {
                    var foo = node.text;
                    if (node.text.search(texts[node.parent]) == 0) {
                        node.text = node.text.replace(texts[node.parent], "");
                        node.text = node.text.trim();
                        if (/^\d+$/.test(node.text)) {
                            node.text = "#" + node.text;
                        }
                    }
                    if (!nodeType(node, "measurement")) {
                        node.state = { checkbox_disabled: true };
                    }
                    // Restore
                    if (node.text == "") node.text = foo;
                }

            });
            
            var pos = 0;
            var parent = '';
            var children = [];
            var foo = _.clone(treeData);
            foo.forEach(function(node, j) {
                if (nodeType(node, "measurement")) {
                    if (node.parent != parent) {
                        if (children.length) {
                            // Sort measurements
                            children.sort(function(a, b) {
                                var nameA = a.specs.friendlyName.toLowerCase(), nameB = b.specs.friendlyName.toLowerCase()
                                if (nameA < nameB) // Sort string ascending
                                    return -1 
                                if (nameA > nameB)
                                    return 1
                                return 0 // efault return value (no sorting)
                            });
                            
                            // Insert new sorted array in place of old values
                            treeData.splice.apply(treeData, [pos, children.length].concat(children));
                        }
                        
                        pos = j;
                        children = [];
                        children.push(node);
                        parent = node.parent;
                    }
                    else {
                        children.push(node);
                    }
                }
            });
            var groupIds=[];
            var siteIds=[];
            var tenantIds=[];
            var portfolioIds=[];
            for(var i=0;i<treeData.length;i++)
            {
                if(treeData[i].type==="deviceGroup")
                {
                    groupIds.push(treeData[i].id)
                }
                else if(treeData[i].type==="site")
                {
                    siteIds.push(treeData[i].id)
                }
                else if(treeData[i].type==="portfolio")
                {
                    portfolioIds.push(treeData[i].id)
                }
                else if(treeData[i].type==="client")
                {
                    tenantIds.push(treeData[i].id)
                }
            }
            treeData=removeEmpty(treeData,groupIds);
            treeData=removeEmpty(treeData,siteIds);
            treeData=removeEmpty(treeData,portfolioIds);
            treeData=removeEmpty(treeData,tenantIds);
            for(var i=0;i<treeData.length;i++)
            {
                treeData[i]["__uiNodeId"]=i+1;
            }
            
            return treeData;
        }
        function removeEmpty(tree,ids)
        {
            var fl=false;
            var groupT=-1;
            for(var j=0;j<ids.length;j++)
            {
                fl=false;
                groupT=-1;
                for(var i=0;i<tree.length;i++)
                {
                    if (tree[i].id==ids[j])
                    {
                        groupT=i;
                    }
                    if(tree[i].parent==ids[j])
                    {
                        fl=true;
                    }
                }
                if(!fl)
                {
                    tree.splice(groupT,1);
                }
            }
            return tree;
        }
        function nodeType(node, type) {
            return node.id.indexOf(type + "_") == 0;
        }
        
        
        // Chart Utilities
        
        // Darken a color
        function darkenColor(colorStr) {
            // Defined in dygraph-utils.js
            var color = Dygraph.toRGB_(colorStr);
            color.r = Math.floor((255 + color.r) / 2);
            color.g = Math.floor((255 + color.g) / 2);
            color.b = Math.floor((255 + color.b) / 2);
            return 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')';
        }
        
        // This function draws bars for a single series
        function barChartPlotter(e) {
            var ctx = e.drawingContext;
            var points = e.points;
            var y_bottom = e.dygraph.toDomYCoord(0);

            ctx.fillStyle = darkenColor(e.color);

            // Find the minimum separation between x-values.
            // This determines the bar width.
            var min_sep = Infinity;
            for (var i = 1; i < points.length; i++) {
                var sep = points[i].canvasx - points[i - 1].canvasx;
                if (sep < min_sep) min_sep = sep;
            }
            var bar_width = Math.floor(2.0 / 3 * min_sep);

            // Do the actual plotting.
            for (var i = 0; i < points.length; i++) {
                var p = points[i];
                var center_x = p.canvasx;

                ctx.fillRect(center_x - bar_width / 2, p.canvasy,
                    bar_width, y_bottom - p.canvasy);

                ctx.strokeRect(center_x - bar_width / 2, p.canvasy,
                    bar_width, y_bottom - p.canvasy);
            }
        }
        
        // Multiple column bar chart
        function multiColumnBarPlotter(e) {
            // We need to handle all the series simultaneously.
            if (e.seriesIndex !== 0) return;

            var g = e.dygraph;
            var ctx = e.drawingContext;
            var sets = e.allSeriesPoints;
            var y_bottom = e.dygraph.toDomYCoord(0);

            // Find the minimum separation between x-values.
            // This determines the bar width.
            var min_sep = Infinity;
            for (var j = 0; j < sets.length; j++) {
                var points = sets[j];
                for (var i = 1; i < points.length; i++) {
                    var sep = points[i].canvasx - points[i - 1].canvasx;
                    if (sep < min_sep) min_sep = sep;
                }
            }
            var bar_width = Math.floor(2.0 / 3 * min_sep);

            var fillColors = [];
            var strokeColors = g.getColors();
            for (var i = 0; i < strokeColors.length; i++) {
                fillColors.push(darkenColor(strokeColors[i]));
            }

            for (var j = 0; j < sets.length; j++) {
                ctx.fillStyle = fillColors[j];
                ctx.strokeStyle = strokeColors[j];
                for (var i = 0; i < sets[j].length; i++) {
                    var p = sets[j][i];
                    var center_x = p.canvasx;
                    var x_left = center_x - (bar_width / 2) * (1 - j/(sets.length-1));

                    ctx.fillRect(x_left, p.canvasy,
                        bar_width/sets.length, y_bottom - p.canvasy);

                    ctx.strokeRect(x_left, p.canvasy,
                        bar_width/sets.length, y_bottom - p.canvasy);
                }
            }
        }
        
        
        // Color palette
        var palette = {
            color0: "3,169,244",
            color1: "146,39,143",
            color2: "170,198,6",
            color3: "242,135,6",
            color4: "0,191,118",
            color5: "102,45,145",
            color6: "236,0,140",
            color7: "0,148,68",
            color8: "249,237,50",
            color9: "239,65,54"
        };
        
        function getColor(index) {
            return 'rgb(' + palette['color' + index] + ')';
        }
        
        
        // Asset Name
        
        function getAssetName(node, utf) {
            var cNode = node.original;
            if (utf == null) utf = true;
            var assetName = cNode.site;
            if (selectedNodes.length == 1 || vm.sites.length < 2) {
                assetName = "";
            }
            if (utf) {
                if (assetName) assetName += " → ";
            }
            else {
                if (assetName) assetName += " > ";
            }
            assetName += cNode.specs.friendlyName;
            return assetName;
        }
        
        function addNodeToGraph(node) {
			if (vm.date.startDate !== "" && vm.date.endDate!== "") {
                var period = vm.date.startDate + "-" + vm.date.endDate;
                if (cache[period] == undefined) cache[period] = {};
                if (cache[period][node.original.token] == undefined) {
                    cache[period][node.original.token] = {};
                    updateStatus(pragmaapi.translate('EXPLORE.LOADING_DATA'), true);
                    loadData(node)
                        .then(function(res) {
                            loading--;
                            graphData(node);
                        })
                        
                }
                else {
                    loading--;
                    graphData(node);
                }
            }
            else {
                loading--;
                updateStatus(pragmaapi.translate('EXPLORE.SELECT_DATES'));
            }
        }
		
        function addAllNodesToGraph(nodes) {
            if (selectedNodes.length) {
                if (vm.date.startDate !== "" && vm.date.endDate!== "") {
                    var period = vm.date.startDate + "-" + vm.date.endDate;
                    if (cache[period] == null) cache[period] = {};
                    updateStatus(pragmaapi.translate('EXPLORE.LOADING_DATA'), true);
                    loadAllData(nodes)
                        .then(function(res) {
                            updateStatus(pragmaapi.translate('EXPLORE.PREPARING_DATA'), true);
                            
                            // Timeout to give time for status to update
                            $timeout(function() { drawChart(); }, 50);
                        })
                }
                else {
                    updateStatus(pragmaapi.translate('EXPLORE.SELECT_DATES'));
                }
            }
            else {
                updateStatus(pragmaapi.translate('EXPLORE.SELECT_DATA'));
            }
        }
        
        function removeNodeFromGraph(node) {
            resetChart();
            if (selectedNodes.length) {
                updateStatus(pragmaapi.translate('EXPLORE.PREPARING_DATA'), true);
                
                // Timeout to give time for status to update
                $timeout(function() { drawChart(); }, 50);
            }
            else {
                updateStatus(pragmaapi.translate('EXPLORE.SELECT_DATA'));
            }
        }
        
        // Load data
        function loadData(node) {
            var cNode = node.original;
            // Dates
			vm.applyD = false;
            var from = encodeURIComponent(moment(vm.date.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone);
            var to = encodeURIComponent(moment(vm.date.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone);
            return pragmaapi.callRestService(PRAGMA.api, "/assignments/" + cNode.token + "/measurements/series",
                        "?startDate=" + from + "&endDate=" + to + "&page=1&pageSize=3000&tenantAuthToken=" + cNode.tenantAuthToken,
                        true, vm.user.authentication, "GET", true)
                .then(function(res) {
					var period = vm.date.startDate + "-" + vm.date.endDate;
                    cache[period][cNode.token] = res.data;
                });
        }
        
        // Load all data
        function loadAllData(nodes) {
            // Dates
			vm.applyD = false;
            var from = encodeURIComponent(moment(vm.date.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone);
            var to = encodeURIComponent(moment(vm.date.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone);
            
            var promises = nodes.map(function(node) {
                var cNode = node.original;
				return pragmaapi.callRestService(PRAGMA.api, "/assignments/" + cNode.token + "/measurements/series",
                        "?startDate=" + from + "&endDate=" + to + "&page=1&pageSize=3000&tenantAuthToken=" + cNode.tenantAuthToken,
                        true, vm.user.authentication, "GET", true)
                .then(function(res) {
					var count = res.data[0].entries.length - 1;
					if (vm.date.endDate.format('DDD') !== moment(res.data[0].entries[count].measurementDate).format('DDD')) {
						console.log("out of range");
						vm.date.endDate = moment(res.data[0].entries[count].measurementDate);
						//reApply datepicker only to change data shown without reseting the chart
						vm.applyD = true;
						var drp = angular.element('#daterange').data('daterangepicker');
						drp.autoUpdateInput = true;
						drp.setEndDate(vm.date.endDate);
						drp.clickApply();
						showNotification($translate.instant("EXPLORE.OUT_OF_RANGE"), $translate.instant("EXPLORE.OVER_LIMIT"),"Info");
					}
					else {
						console.log("in range");
					}
					
					var period = vm.date.startDate + "-" + vm.date.endDate;
					if (cache[period] == undefined) cache[period] = {};
                    cache[period][cNode.token] = res.data;
                });
            });
            return $q.all(promises);
        }
        
        // Graph Data
        function graphData(node) {
            if (!loading) {
                var period = vm.date.startDate + "-" + vm.date.endDate;
                var pos = measurementInCache(node);
                if (pos >= 0) {
                    
                    updateStatus(pragmaapi.translate('EXPLORE.PREPARING_DATA'), true);
                    
                    // Timeout to give time for status to update
                    $timeout(function() { drawChart(); }, 50);
                }
                else {
                    updateStatus(pragmaapi.translate('EXPLORE.NO_DATA_FOUND'));
                }
            }
        }
        
        function drawChart() {
            var period = vm.date.startDate + "-" + vm.date.endDate;
            var measurements = cache[period];
            if (measurements != null) {
                
                vm.labels = [];
                vm.units = [];
                vm.names = [];
                resetChart();
                
                var options = vm.chart.options;
                
                // Align data
                
                // Find all timestamps
                var foo = [];
                for (var i = 0; i < selectedNodes.length; i++) {
                    var token = selectedNodes[i].original.token;
                    if (measurements[token].length) {
                        var pos = measurementInCache(selectedNodes[i]);
                        if (pos >= 0) {
                            for (var j = 0; j < measurements[token][pos]["entries"].length; j++) {
                                var date = measurements[token][pos]["entries"][j]["measurementDate"];
                                if (foo[date] == undefined) {
                                    foo[date] = [new Date(date)];
                                }
                            }
                        }
                    }
                }

                var k = 0;
                for (var i = 0; i < selectedNodes.length; i++) {
                    
                    var cNode = selectedNodes[i].original;
                    
                    var pos = measurementInCache(selectedNodes[i]);
                    if (pos >= 0) {
                        
                        var entries = measurements[cNode.token][pos]["entries"];
                        
                        for (var j = 0; j < entries.length; j++) {
                            var date = entries[j].measurementDate;
                            foo[date].push(entries[j].value);
                        };
                        
                        // Add missing values
                        for (var date in foo) {
                            if (foo[date].length < k + 2) {
                                foo[date][foo[date].length] = null;
                            }
                        }
                        
                        var label = selectedNodes[i].id;
                        var unit = selectedNodes[i].original.specs.unit;
                        options.labels.push(label);
                        options.series[label] = {
                            title: getAssetName(selectedNodes[i], false),
                            color: getColor(k),
                            axis: "y1"
                        };
                        
                        vm.labels.push(label);
                        
                        var unit = cNode.specs.unit;
                        vm.units.push(unit);
                        if (vm.names[unit] == undefined) vm.names[unit] = [];
                        if (jQuery.inArray(cNode.specs.friendlyName, vm.names[unit]) < 0) {
                            vm.names[unit].push(cNode.specs.friendlyName);
                        }
                        
                        var site = cNode.site
                        vm.sites.push(site);
                        
                        k++;
                    }
                }
                
                vm.sites = _.uniq(vm.sites);
                
                var bar = [];
                for (var date in foo) {
                    bar.push(foo[date]);
                }
                
                if (bar[0].length > 2) {
                    bar.sort(function(a, b) {return (a[0] < b[0]) ? -1 : 1;});
                }
                
                // Axes
                
                // Y1 axis
                options.ylabel = getAxisLabel(vm.units[0]);
                
                var units = _.uniq(vm.units);
                if (units.length > 1) {
                    for (var i = 1; i < vm.units.length; i++) {
                        if (vm.units[i] != vm.units[0]) {
                            if (options.y2label == "Secondary y-axis") {
                                // Y2 axis
                                options.y2label = getAxisLabel(vm.units[i]);
                            }
                            else {
                                // Too many units
                            }
                            options.series[vm.labels[i]].axis = "y2";
                        }
                    }
                    // Show axis
                    jQuery("body").removeClass("hidey2");
                }
                else {
                    // Always show y2 axis. Add a ghost point
                    options.labels.push("foo");
                    options.series["foo"] = { axis : "y2" };
                    bar[0].push(null);
                    // Hide axis
                    jQuery("body").addClass("hidey2");
                }
                
                updateStatus(pragmaapi.translate('EXPLORE.PREPARING_GRAPH'), true);
                
                vm.chart.options = options;
                
                // Timeout to give time for status to update
                $timeout(function() { setChartData(bar) }, 50);
                
            }
        }
        
        function getAxisLabel(unit) {
            var label = "";
            for (var i = 0; i < vm.names[unit].length; i++) {
                label += vm.names[unit][i] + ", ";
            }
            label = label.slice(0, -2);
            label += " (" + unit + ")";
            return label;
        }
        
        function setChartData(data) {
            vm.chart.data = data;
            if (vm.chart.data.length) {
                updateStatus(pragmaapi.translate('EXPLORE.READY'));
            }
            else {
                updateStatus(pragmaapi.translate('EXPLORE.NO_DATA_FOUND'));
            }
        }
        
        function measurementInCache(node) {
            var pos = -1;
            var cNode = node.original;
            var period = vm.date.startDate + "-" + vm.date.endDate;
            var measurements = cache[period];
            for (var i = 0; i < measurements[cNode.token].length; i++) {
                if (measurements[cNode.token][i].measurementId == cNode.measure) {
                    pos = i;
                    break;
                }
            }
            return pos;
        }
        
        function updateStatus(msg, spin) {
            if (spin == undefined) spin = false;
            jQuery(".status").html('<span class="msg-spinner' + (spin ? '' : ' static') + '"></span> &nbsp; ' + msg);
        }
        
        
        // Left sidebar
        vm.lockLeft = true;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleClose = toggleClose;
        vm.changeStatusL = changeStatusL;
        
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
        
        function toggleClose(sidenavId) {
            $mdSidenav(sidenavId).close();
        }
        
        function changeStatusL(sidenavId) {
                $mdSidenav(sidenavId).close();
                if(vm.lockLeft)
                vm.lockLeft=!vm.lockLeft;
        }
        
        // Download CSV
        vm.exportCSV = exportCSV;
		function exportCSV () {
            if (vm.chart.data.length) {
                var csvContent = "data:text/csv;charset=utf-8,";
                // Header
                csvContent += '"Timestamp";';
                for (var prop in vm.chart.options.series) {
                    var label = vm.chart.options.series[prop].title;
                    csvContent += '"' + label + '";';
                }
                csvContent = csvContent.slice(0, -1);
                csvContent += "\n";
                for (var i = 0; i < vm.chart.data.length; i++) {
                    for (var j = 0; j < vm.chart.data[i].length; j++) {
                        csvContent += '"' + vm.chart.data[i][j] + '";';
                    }
                    csvContent = csvContent.slice(0, -1);
                    csvContent += "\n";
                }
                var encodedUri = encodeURI(csvContent);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", "raw_data.csv");
                document.body.appendChild(link); // Required for FF
                link.click();
            }
        }
		
		// Download Image
		vm.saveImage = saveImage;
        function saveImage(el) {
			var dg = document.getElementById(el);
				//var graph_div = dg.getElementsByTagName('div')[1];

			html2canvas(dg).then(function(canvas) {
				var url_base64 = canvas.toDataURL('image/png');
				var link = document.createElement("a");
				link.setAttribute("href", url_base64);
				link.setAttribute("download", "explore.png");
				document.body.appendChild(link); // Required for FF
				link.click();
			});
		}
        
        // Utilities
        function filterNumber(number) {
            if (Math.abs(number) < 10) {
                return $filter('number')(number, 3);
            }
            if (Math.abs(number) < 100) {
                return $filter('number')(number, 2);
            }
            else if (Math.abs(number) < 1000) {
                return $filter('number')(number, 1);
            }
            else {
                return $filter('number')(number, 0);
            }
        }
        
        function ucwords(str) {
            str = str.replace(/_/g, ' ');
            return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        }        
        
        function ucfirst(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
        
        function pad(n, width, z) {
          z = z || '0';
          n = n + '';
          return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }   
        
        
        // Dygraphs interaction model
        
        function downV3(event, g, context) {
          context.initializeMouseDown(event, g, context);
          if (event.altKey || event.shiftKey) {
            Dygraph.startPan(event, g, context);
          } else {
            Dygraph.startZoom(event, g, context);
          }
        }

        function moveV3(event, g, context) {
          if (context.isPanning) {
            Dygraph.movePan(event, g, context);
          } else if (context.isZooming) {
            Dygraph.moveZoom(event, g, context);
          }
        }

        function upV3(event, g, context) {
          if (context.isPanning) {
            Dygraph.endPan(event, g, context);
          } else if (context.isZooming) {
            Dygraph.endZoom(event, g, context);
          }
        }

        function dblClickV3(event, g, context) {
          restorePositioning(g);
        }

        function restorePositioning(g) {
          g.updateOptions({
            dateWindow: null,
            valueRange: null
          });
        }
		
        function showNotification(title, message, type) {
            if (type === "Error") {
                Notification.error({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Info") {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: 10000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Warning") {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Success") {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }   
        }
		
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.expert', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.expert', {
            url      : '/expert',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/expert/expert.html',
                    controller : 'ExpertController as vm'
                }
            },
            bodyClass: 'expert'
        });

        msNavigationServiceProvider.saveItem('expert', {
            title : 'EXPERT',
            state: 'app.expert',
            group : true,
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.expert')
        .controller('ExpertController', ExpertController);

    function ExpertController($q, $scope, $element, $http, $filter, $mdSidenav, msApi, session, $rootScope, $mdDialog, $document, $base64, Notification, filterFilter, dateFilter, PRAGMA, pragmaapi)
    {
        
        var vm = this;
        
        // User
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        
        // Chart
        var chartTmp = {
          colors: [],
          series: [],
          override: [],
          labels: [],
          data: []
        };
        vm.chartLegend = "";
        vm.chartKPI = "measurements";
        vm.chartType = "bar";
        vm.chartZoom = '1 d';
        vm.chartUnits = [];
        vm.stacked = true;
        resetChart();
		
        var chartObj;
        $scope.$on('chart-create', function (evt, chart) {
            chartObj = chart;
            //vm.chartLegend = chartObj.generateLegend();
        });
        /*
        // Hook into main event handler
        var parentEventHandler = Chart.Controller.prototype.eventHandler;
        Chart.Controller.prototype.eventHandler = function() {
          var ret = parentEventHandler.apply(this, arguments);
          this.clear();
          this.draw();
          // Draw the vertical line here
          var eventPosition = Chart.helpers.getRelativePosition(arguments[0], this.chart);
          this.chart.ctx.beginPath();
          this.chart.ctx.moveTo(eventPosition.x, 30);
          this.chart.ctx.strokeStyle = "#ff0000";
          this.chart.ctx.lineTo(eventPosition.x, 340);
          this.chart.ctx.stroke();
          return ret;
        };            
        */
        // Color palette
        var palette = {
            total: "75,193,247",
            electricity: "255,152,0",
            gas: "244,67,54",
            electricity_excess: "76,175,80",
            color1: "3,169,244",
            color2: "146,39,143",
            color3: "170,198,6",
            color4: "242,135,6",
            color5: "0,191,118",
            color6: "102,45,145",
            color7: "236,0,140",
            color8: "0,148,68",
            color9: "249,237,50",
            color10: "239,65,54"
        };
        
        // Measure types
        vm.selectMeasureType = selectMeasureType;
        vm.selectedMeasureType = 'all';
        vm.measureTypes = [];

        // Units
        vm.selectUnit = selectUnit;
        vm.selectedUnit = 'kWh';
        vm.units = [];

        // Date Range
        vm.date = {
          startDate: moment().startOf('month'),
          endDate: moment()
        };
        vm.dateOptions = {
            applyClass: 'md-button md-raised',
            alwaysShowCalendars: true,
            locale: {
                applyLabel: "Apply",
                fromLabel: "From",
                format: "ll",
                toLabel: "To",
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            },
            ranges: {
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment()],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],             
                'This Year': [moment().startOf('year'), moment()],
            },
            eventHandlers: {
                'apply.daterangepicker': vizualizeData
            }
        }
    
        // Tree
        vm.refreshTree = function(refresh) {
            pragmaapi.getTreeData(false, refresh).then(function(treeData) {
                vm.treeData = treeData;
                // Reload tree
                vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'checkbox']);
                loadSpecifications(treeData);
            });
        }
        vm.refreshTree(false);
        
        vm.applySearch = function() {
          if (vm.treeInstance) {
            vm.treeInstance.jstree(true).search(vm.searchtree);
          }
        };
		
        vm.treeEvents = {
            'ready': readyCB,
            'create_node': createNodeCB,
            'select_node': getSelectedNodes,
            'deselect_node': getSelectedNodes
        }

        var selectedNodes = [];
        function getSelectedNodes() {
            vizualizeData();
        }
        
        function readyCB() {
        }
        
        function createNodeCB() {
        }
        
        // Functions
        vm.setKPI = setKPI;
        vm.setZoom = setZoom;
        vm.setChartType = setChartType;
        vm.stackToggle = stackToggle;
        vm.toggleSidenav = toggleSidenav;
        vm.saveImage = saveImage;
        vm.exportCSV = exportCSV;
        
        // Device Specifications
        vm.deviceSpecifications = {};
        function loadSpecifications(treeData) {
            var tenantAuthTokens = [];
            for (var i = 0; i < treeData.length; i++) {
                if (tenantAuthTokens.indexOf(treeData[i].tenantAuthToken) < 0) {
                    tenantAuthTokens.push(treeData[i].tenantAuthToken);
                }
            }
            var promises = tenantAuthTokens.map(function(tenantAuthToken) {
                return pragmaapi.callRestService(PRAGMA.api, "/specifications", "?tenantAuthToken=" + tenantAuthToken, true, vm.user.authentication, "GET", true).then(function(res) {
                    if (!res.data.error && res.data.numResults) {
                        var results = res.data.results;
                        vm.deviceSpecifications[tenantAuthToken] = {};
                        for (var j = 0; j < results.length; j++) {
                            if (results[j].metadata.specs != undefined) {
                                var specs = JSON.parse(results[j].metadata.specs);
                                for (var measure in specs) {
                                    if (specs[measure].type == "electricity excess") specs[measure].type = "electricity_excess";
                                    specs.type = specs[measure].type;
                                    // Priority
                                    if (results[j].metadata.priority != undefined) {
                                        specs[measure].priority = results[j].metadata.priority;
                                    }
                                }
                                vm.deviceSpecifications[tenantAuthToken][results[j].token] = specs;
                            }
                        }
                    }
                });
            });
            return $q.all(promises);
        }
        
        // Selected Assignments
        var selectedAssignments = [];
        function getSelectedAssignments() {
            // Manipulates
            selectedAssignments = [];
            
            vm.measureTypes = [{id: 'all', name: 'All measures'}];
            
            var jstree = vm.treeInstance.jstree(true);
            
            //var topSelectedNodes = jstree.get_top_selected(true);
            
            // Find all selected devices
            var foo = [];
            selectedNodes = jstree.get_selected(true);
            for (var i = 0; i < selectedNodes.length; i++) {
                if (selectedNodes[i].id.indexOf("device_") === 0) {
                    foo.push(selectedNodes[i]);
                }
            }
            
            // Find all selected devices which have a valid specification and keep defaults
            var assignmentsToken = [];
            var promises = foo.map(function(treeDatum) {
                var tenantAuthToken = treeDatum.original.tenantAuthToken;
                return pragmaapi.callRestService(PRAGMA.api, "/assignments/" + treeDatum.original.token, "?tenantAuthToken=" + tenantAuthToken,true, vm.user.authentication, "GET", true).then(function(res) {
                    var assignment = res.data;
                    if (!assignment.error) {
                        var bar = vm.deviceSpecifications[tenantAuthToken][assignment.device.specificationToken];
                        if (bar != undefined) {
                            if (assignmentsToken.indexOf(assignment.token) < 0) { // Don't include assignments twice
                                assignmentsToken.push(assignment.token);
                                assignment.path = jstree.get_path(treeDatum.id, false, true);
                                var measures = [];
                                for (var prop in bar) {
                                    var measure = bar[prop];
                                    if (measure.type != undefined) {
                                        measure.deviceId = assignment.device.assetId;
                                        measure.name = prop;
                                        measures.push(measure);
                                    }
                                }
                                if (measures.length) {
                                    if (!inMeasureTypes(measures[0].type)) {
                                        vm.measureTypes.push({id: measures[0].type, name: toTitleCase(measures[0].type)});
                                    }
                                    assignment.specs = measures;
                                    assignment.tenantAuthToken = tenantAuthToken;
                                    selectedAssignments.push(assignment);
                                }
                            }
                        }
                    }
                });
            });
            return $q.all(promises);
        }
        
        // Visualize Data
        function vizualizeData() {
			
            // Reset Chart
            resetChart();
			
            if (vm.date.startDate !== "" && vm.date.endDate!== "") {
                
                getSelectedAssignments().then(function(res) {
                    // console.log(selectedAssignments);
                    if (selectedAssignments.length > 0) {
                        
                        angular.element(".graph-message p").html('<img src="assets/images/throbber.gif"> Loading data. Please wait...');
                                    
                        // Dates
                        vm.chart.from = encodeURIComponent(moment(vm.date.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0000");
                        vm.chart.to = encodeURIComponent(moment(vm.date.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + "+0000");
                        
                        // Prioritize assignments
                        prioritizeAssignments();
                                    
                        loadData().then(function(res) {
                          
                            angular.element(".graph-message p").html('<img src="assets/images/throbber.gif"> Preparing graph. Please wait...');
                            
                            vm.chart.measurements_original = angular.copy(vm.chart.measurements); // Keep for manipulation
                            
                            // Prepare data
                            prepareData();
                            
                            // Align Data
                            alignData();
                            
                            // Draw Chart
                            drawChart();
                            
                        });
                    }
                    else {
                        vm.units = [];
                        vm.measureTypes = [];
                        angular.element(".graph-message p").text("Please select data to display...");
                    }
                });
            }
            else {
                angular.element(".graph-message p").text("Please select a time period...");
            }
        }
        
        // Keep only top level and top priority assignments
        function prioritizeAssignments() {
            var prioritizedAssignments = {};
            
            var found = [];
            
            var jstree = vm.treeInstance.jstree(true);
            var topSelectedNodes = jstree.get_top_selected();
            for (var i = 0; i < topSelectedNodes.length; i++) {
                var topSelectedNode = topSelectedNodes[i];
                for (var j = 0; j < selectedAssignments.length; j++) {
                    var selectedAssignment = selectedAssignments[j];
                    if (selectedAssignment.path.indexOf(topSelectedNode) >= 0) {
                        var level = selectedAssignment.path.length;
                        if (prioritizedAssignments[level] == undefined) prioritizedAssignments[level] = {};
                        var priority = selectedAssignment.specs[0].priority;
                        if (prioritizedAssignments[level][priority] == undefined) prioritizedAssignments[level][priority] = [];
                        prioritizedAssignments[level][priority].push(selectedAssignment);
                    }
                }
            }
            
            selectedAssignments = [];
            for (var level in prioritizedAssignments) {
                for (var priority in prioritizedAssignments[level]) {
                    for (var i = 0; i < prioritizedAssignments[level][priority].length; i++) {
                        if (!foundBetterAssignment(found, level, priority, prioritizedAssignments[level][priority][i].specs[0].type)) {
                            found.push({level: level, priority: priority, type: prioritizedAssignments[level][priority][i].specs[0].type});
                            selectedAssignments.push(prioritizedAssignments[level][priority][i]);
                        }
                    }
                }
            }
        }
        
        function foundBetterAssignment(arr, level, priority, type) {
            var res = false;
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].type == type && arr[i].level <= level && arr[i].priority < priority) {
                    res = true;
                    break;
                }
            }
            return res;
        }
        
        function loadData() {
            var promises = selectedAssignments.map(function(selectedAssignment, i) {
                var measure = selectedAssignment.specs[0];
                var parts = vm.chartZoom.split(" ");
                return pragmaapi.callRestService(PRAGMA.api,"/assignments/" + selectedAssignment.token + "/measurementsAggregated","?resolution=" + parts[0] + "&resolutionType=" + parts[1] + "&startDate=" + vm.chart.from + "&endDate=" + vm.chart.to + "&measuredParameter=" + measure.name + "&page=1&pageSize=2000&tenantAuthToken=" + selectedAssignment.tenantAuthToken, true, vm.user.authentication, "GET", true).then(function(res){
                    var measurements = res.data.data;
                    vm.chart.measurements[i] = measurements;
                });
            });
            return $q.all(promises);
        }
		
        function prepareData() {
            vm.chartUnits = [];
            var k = 0;
            var isMain = false;
            var isCost = (vm.chartKPI == 'cost');
            
            for (var i = 0; i < selectedAssignments.length; i++) {
                var measurements = vm.chart.measurements[i];
                if (measurements.length) {
                    var selectedAssignment = selectedAssignments[i];
                    var measure = selectedAssignment.specs[0];
                    isMain = (measure.deviceId == 419 || measure.deviceId == 420);
                    vm.chartUnits[k] = measure.unit;
                    
                    // Convert Wh to kWh
                    if (measure.unit == "Wh") {
                        vm.chartUnits[k] = "kWh";
                        measurements.forEach(function(measurement, j) {
                            vm.chart.measurements[i][j].d = measurement.d / 1000;
                        });
                    }
                    
                    // Convert W to kWh
                    if (measure.unit == "W") {
                        vm.chartUnits[k] = "kWh";
                        measurements.forEach(function(measurement, j) {
                            vm.chart.measurements[i][j].d = measurement.d / 1000 * 4; // This applies only to measurements which occur every 15min
                        });
                    }
                    
                    // Calculate cost
                    if (isCost) {
                        vm.chartUnits[k] = "€";
                        
                        var days = moment(vm.date.endDate).diff(moment(vm.date.startDate), 'days'); // Default = selected period
                        if (vm.chart.measurements[i][(vm.chart.measurements[i].length - 2)] != undefined) {
                            days = (vm.chart.measurements[i][(vm.chart.measurements[i].length - 1)].t - vm.chart.measurements[i][(vm.chart.measurements[i].length - 2)].t) / 1000 / 60 / 60 / 24;
                        }
                        
                        var profile = {};
                        if (profile = pragmaapi.findCostProfile(measure.type, selectedAssignment.site.token)) {
                            
                            var scheduledCostFound = false;
                            
                            profile.costs.forEach(function(cost) {
                                if (cost.type == "unit" && cost.schedule.length) {
                                    
                                    scheduledCostFound = true;
                                    
                                    // Find blocks
                                    var blocks = findBlocks(0, 0, cost.schedule);
                                    
                                    // Sort by number of blocks
                                    var maxLength = 0;
                                    var sortedTariffs = {};
                                    for (var i = 0; i < cost.tariffs.length; i++) {
                                        var length = blocks[cost.tariffs[i].name].length;
                                        if (maxLength < length) maxLength = length;
                                        if (sortedTariffs[length] == undefined) sortedTariffs[length] = [];
                                        sortedTariffs[length].push(blocks[cost.tariffs[i].name]);
                                    }
                                    
                                    // Remove last tarrif, it will be caclulated
                                    var lastTariff = sortedTariffs[maxLength].pop();
                                    
                                    // Prepare tarrifs to load
                                    var loadTariffs = [];
                                    for (var i in sortedTariffs) {
                                        for (var j = 0; j < sortedTariffs[i].length; j++) {
                                            for (var k = 0; k < sortedTariffs[i][j].length; k++) {
                                                loadTariffs.push({ tag: sortedTariffs[i][j][k].tag, assignment: selectedAssignment, startHourOfDay: sortedTariffs[i][j][k].topLeft.x * 60 * 60 + 1, endHourOfDay:  (sortedTariffs[i][j][k].bottomRight.x + 1) * 60 * 60 });
                                            }
                                        }
                                    }
                                    
                                    // Load tarrifs measurements
                                    loadTariffsMesurements(loadTariffs).then(function() {
                                        console.log(tariffsMeasurements);
                                        // Prepare tarrifs measurements
                                        measurements.forEach(function(measurement, j) {
                                            vm.chart.measurements[i][j].d = pragmaapi.calculateCost(measurement.d, days, measure.type, selectedAssignment.site.token, isMain);
                                        });
                                    });
                                    // Only one scheduled cost per cost profile
                                    return;
                                }
                            });
                            
                            if (!scheduledCostFound) {
                                measurements.forEach(function(measurement, j) {
                                    vm.chart.measurements[i][j].d = pragmaapi.calculateCost(measurement.d, days, measure.type, selectedAssignment.site.token, isMain);
                                });
                            }
                        }
                        else {
                            measurements.forEach(function(measurement, j) {
                                vm.chart.measurements[i][j].d = pragmaapi.calculateCost(measurement.d, days, measure.type, selectedAssignment.site.token, isMain);
                            });
                        }
                    }
                    
                    // Convert m3 to kWh
                    if (!isCost && measure.unit == "m3") {
                        vm.chartUnits[k] = "kWh";
                        measurements.forEach(function(measurement, j) {
                            vm.chart.measurements[i][j].d = pragmaapi.m3tokWh(measurement.d);
                        });
                    }
                    
                    // Negate electricity excess
                    if (measure.type == 'electricity_excess') {
                        measurements.forEach(function(measurement, j) {
                            vm.chart.measurements[i][j].d = 0 - measurement.d;
                        });
                    }
                    k++;
                }
            }
            
            // scaleLabel
            setScaleLabel(isCost, isMain);
        }
        
        var tariffsMeasurements = {};
        function loadTariffsMesurements(loadTarrifs) {
            tariffsMeasurements = {};
            var promises = loadTarrifs.map(function(tarrif) {
                var selectedAssignment = tarrif.assignment;
                var measure = selectedAssignment.specs[0];
                var parts = vm.chartZoom.split(" ");
                return pragmaapi.callRestService(PRAGMA.api,"/assignments/" + selectedAssignment.token + "/measurementsAggregated","?resolution=" + parts[0] + "&resolutionType=" + parts[1] + "&startDate=" + vm.chart.from + "&endDate=" + vm.chart.to + "&measuredParameter=" + measure.name + "&startHourOfDay=" + tarrif.startHourOfDay + "&endHourOfDay=" + tarrif.endHourOfDay + "&page=1&pageSize=2000&tenantAuthToken=" + selectedAssignment.tenantAuthToken, true, vm.user.authentication, "GET", true).then(function(res){
                    var measurements = res.data.data;
                    if (tariffsMeasurements[tarrif.tag] == undefined) tariffsMeasurements[tarrif.tag] = [];
                    tariffsMeasurements[tarrif.tag].push(measurements);
                });
            });
            return $q.all(promises);
        }
		
        // This is not very clever, only finds vertical blocks
        var blocks = {};
        function findBlocks(x, y, schedule) {
            if (x < schedule[0].length) {
                var tag = schedule[y][x];
                if (blocks[tag] == undefined) blocks[tag] = [];
                var index = blocks[tag].length;
                blocks[tag][index] = { tag: tag, topLeft: {x: x, y: y}, bottomRight: {x: x, y: y} };
                for (var i = y; i < schedule.length; i++) {
                    for (var j = x; j < schedule[i].length; j++) {
                        if (schedule[i][j] == tag) {
                            if (i >= blocks[tag][index].bottomRight.y) {
                                blocks[tag][index].bottomRight.y = i;
                                if (j > blocks[tag][index].bottomRight.x) {
                                    blocks[tag][index].bottomRight.x = j;
                                }
                            }
                        }
                        else {
                            break;
                        }
                    }
                }
                findBlocks(blocks[tag][index].bottomRight.x + 1, blocks[tag][index].topLeft.y, schedule);
            }
            return blocks;
        }
        
        function setScaleLabel(isCost, isMain) {
            var scaleLabel = "";
            if (isCost) {
                scaleLabel += "Cost indication in ";
            }
            else {
                scaleLabel += "Units in ";
            }
            scaleLabel += vm.chartUnits[0];
            if (isCost) {
                if (isMain) {
                    scaleLabel += " (including fixed costs)";
                }
                else {
                    scaleLabel += " (fixed costs not included)";
                }
            }
            vm.chart.options.scales.yAxes[0].scaleLabel = { display: true, labelString: scaleLabel};
        }
        
        function alignData() {
            var foo = [];
            for (var i = 0; i < selectedAssignments.length; i++) {
                var measurements = vm.chart.measurements[i];
                if (measurements.length) {
                    for (var j = 0; j < measurements.length; j++) {
                        if (foo.indexOf(measurements[j].t) < 0) {
                            foo.push(measurements[j].t);
                        }
                    }
                }
            }
            foo.sort();
            for (var i = 0; i < selectedAssignments.length; i++) {
                var measurements = vm.chart.measurements[i];
                if (measurements.length) {
                    for (var j = 0; j < foo.length; j++) {
                        if (measurements[j] == undefined || measurements[j].t != foo[j]) {
                            measurements.splice(j, 0, {t: foo[j], d: 0});
                        }
                    }
                }
            }
        }
		
        function drawChart() {
            
            var isCost = (vm.chartKPI == 'cost');
            
            // Measure types
            if (!inMeasureTypes(vm.selectedMeasureType)) {
                vm.selectedMeasureType = 'all'; // Reset selected measure type
            }
            
            // Units
            if (isCost) {
                vm.units = []; // Hide units
            }
            else {
                if (inMeasureTypes("gas") && (vm.selectedMeasureType == "gas" || inMeasureTypesAll(["all", "gas"]))) {
                    vm.units = ["kWh", "m3", "kg CO2"];
                }
                else {
                    vm.units = ["kWh", "kg CO2"];
                    if (vm.selectedUnit == "m3") {
                        vm.selectedUnit = "kWh";
                    }
                }
                vm.chartUnits[0] = vm.selectedUnit;
                setScaleLabel(false);
            }
            
            chartTmp = {
                colors: [],
                series: [],
                override: [],
                labels: [],
                data: []
            };
            for (var i = 0; i < selectedAssignments.length; i++) {
                var measurements = vm.chart.measurements[i];
                if (measurements.length) {
                    var selectedAssignment = selectedAssignments[i];
                    var measure = selectedAssignment.specs[0];
                    if (vm.selectedMeasureType == 'all' || measure.type == vm.selectedMeasureType) {
                        /*
                        if (vm.chartZoom == "h") { // if (zoom is hour)
                            vm.chartType = "line";
                            angular.element(".chartType-button").removeClass('active').addClass('md-raised');
                            angular.element("." + vm.chartType + "-button").removeClass('md-raised').addClass('active');
                        }
                        */
                        chartTmp.override.push({type: vm.chartType});
                        if (measurements.length > 100) { // Remove datapoints
                            chartTmp.override[chartTmp.override.length - 1].pointRadius = 0;
                        }                    
                        if (selectedAssignment.device.metadata.name != undefined) {
                            chartTmp.series.push(selectedAssignment.device.metadata.name);
                        }
                        else {
                            chartTmp.series.push(selectedAssignment.assetName);
                        }
                        chartTmp.colors.push(getColors(measure.type));
                        chartTmp.labels = measurements.map(getLabel);
                        chartTmp.data.push(measurements.map(function(measurement, j) {
                            if (!isCost && vm.selectedUnit == "kg CO2") {
                                return $filter('number')(pragmaapi.kWhtoCO2(measurement.d, 'NL'), 2);
                            }
                            else if (!isCost && vm.selectedUnit == "m3") {
                                return $filter('number')(vm.chart.measurements_original[i][j].d, 2);
                            }
                            else {
                                return $filter('number')(measurement.d, 2);
                            }
                        }));
                    }
                }
            }
            for (var prop in chartTmp) {
              vm.chart[prop] = chartTmp[prop];
            }
            getStats();
            angular.element(".graph-message p").html('');
        }
        
        function getLabel(measurement) {
            var format = "";
            switch (vm.chartZoom) {
                case '15 m':
                case '1 h':
                    if (moment(measurement.t).format("HH:mm") == "00:00") {
                        format = "MMM D";
                    }
                    else {
                        format = "HH:mm"
                    }
                break;
                case '1 d':
                    format = "MMM D"
                break;
                case '1 w':
                    format = "Wo YYYY"
                break;
                case '1 M':
                    format = "MMM"
                break;
            }
            return moment(measurement.t).format(format);
        }
        
        function getStats() {
            var total = 0; var avg = 0;
            var min = Number.MAX_SAFE_INTEGER;
            var max = -Number.MAX_SAFE_INTEGER;
            
            for (var i = 0; i < vm.chart.data.length; i++) {
                for (var j= 0; j< vm.chart.data[i].length; j++) {
                    var data = parseFloat(vm.chart.data[i][j]);
                    total += data;
                    if (data < min) min = data;
                    if (data > max) max = data;
                }
            }
            if (vm.chart.data[0].length > 0) {
                avg = total / vm.chart.data[0].length;
            }
            
            // if (max == 0) min = 0;
            
            vm.chart.stats = {
                total: filterNumber(total),
                avg: filterNumber(avg),
                min: filterNumber(min),
                max: filterNumber(max)
            }
            
            // Add annotation for avg
            if (vm.stacked) {
                vm.chart.options.annotation.annotations = [{
                    id: 'avg', // optional
                    type: 'line',
                    mode: 'horizontal',
                    scaleID: 'y-axis-0',
                    value: vm.chart.stats.avg,
                    borderColor: 'rgba(3,169,244,1)',
                    borderWidth: 2,
                    borderDash: [6, 3],
                    drawTime: 'afterDatasetsDraw',
                    label: {
                        enabled: true,
                        position: "right",
                        backgroundColor: 'rgba(3,169,244,0.8)',
                        content: "avg: " + vm.chart.stats.avg + " " + vm.chartUnits[0]
                    }
                }];
            }
            else {
                vm.chart.options.annotation = {};
            }
        }
        
        function filterNumber(number) {
            if (Math.abs(number) < 100) {
                return $filter('number')(number, 2);
            }
            else if (Math.abs(number) < 1000) {
                return $filter('number')(number, 1);
            }
            else {
                return $filter('number')(number, 0);
            }
        }
        
        function resetChart() {
            vm.chart = {
                from: '', to: '',
                labels: [],
                data: [],
                measurements: [],
                measurements_original: [],
                options: {
                    /*
                    pan: {
                        enabled: true,
                        mode: 'x'
                    },
                    zoom: {
                        enabled: true,
                        mode: 'x',
                    },
                    */
                    legend: {
                      display: true,
                      position: "right"
                    }, 
                    responsive: true,
                    scales: {
                        xAxes: [{ticks: {maxRotation: 0, fontSize: 10, autoSkipPadding: 10}}],
                        yAxes: [{scaleLabel: { display: true, labelString: ''}, stacked: vm.stacked}]
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                return tooltipItem.yLabel + " " + vm.chartUnits[tooltipItem.datasetIndex];
                            }
                        }
                    },
                    multiTooltipTemplate: "<%=datasetLabel%> : <%= value %>",
                    annotation: {
                    }
                },
                series: [],
                override: [],
                click: function() {},
                hover: function() {
                },
                colors: [],
                stats: {
                  total: 0, avg: 0,
                  min: 0, max: 0
                }
            };
        }

        function selectMeasureType() {
            drawChart();
        }
        
        function selectUnit() {
            drawChart();
        }
        
        function setKPI(KPI) {
            angular.element('#kpi-ctrl button').removeClass('md-primary');
            angular.element('.kpi-' + KPI).addClass('md-primary');
            vm.chartKPI = KPI;
            vizualizeData();
        }
        
        function setZoom(zoom) {
            angular.element('#zoom-ctrl button').removeClass('active');
            angular.element('.zoom-' + zoom.slice(-1)).addClass('active');
            vm.chartZoom = zoom;
            vizualizeData();
        }
        
        function stackToggle() {
            vm.stacked = (vm.stacked) ? false : true;
            if (vm.stacked) {
                angular.element(".stack-button").removeClass('active').addClass('md-raised');
            }
            else {
                angular.element(".stack-button").removeClass('md-raised').addClass('active');
            }
            vizualizeData();
        }
        
        function setChartType(chartType) {
            vm.chartType = chartType;
            angular.element(".chartType-button").removeClass('active').addClass('md-raised');
            angular.element("." + chartType + "-button").removeClass('md-raised').addClass('active');
            drawChart();
        }
        
        function getColors(type) {
            var color = '';
            if (vm.stacked) {
                color = palette[type];
            }
            else {
                color = palette['color' + chartTmp.series.length];
            }
            if (vm.chartType == 'line') {
                return {
                    lineTension : 0.4,
                    borderColor: "rgba(" + color + ",1)",
                    backgroundColor: "rgba(" + color + ",0.1)",
                    pointBorderColor: "#fff",
                    pointBackgroundColor: "rgba(" + color + ",1)",
                    pointHoverBorderColor: "rgba(" + color + ",1)",
                    pointHoverBackgroundColor: "#fff"
                }
            }
            return {
                lineTension : 0.4,
                borderColor: "rgba(" + color + ",1)",
                backgroundColor: "rgba(" + color + ",0.6)",
                pointBorderColor: "#fff",
                pointBackgroundColor: "rgba(" + color + ",1)",
                pointHoverBorderColor: "rgba(" + color + ",1)",
                pointHoverBackgroundColor: "#fff"
            }
        }
        
        function inMeasureTypes(type) {
            var res = false;
            for (var i = 0; i < vm.measureTypes.length; i++) {
                if (vm.measureTypes[i].id == type) {
                    res = true;
                    break;
                }
            }
            return res;
        }
        
        function inMeasureTypesAll(arr) {
            var res = true;
            for (var i = 0; i < vm.measureTypes.length; i++) {
                if (arr.indexOf(vm.measureTypes[i].id) < 0) {
                    res = false;
                    break;
                }
            }
            return res;
        }
        
        function toTitleCase(str) {
            str = str.replace(/_/g, ' ');
            return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        }        
        
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
        
    
        function exportCSV() {
          if (vm.details.data != null) {
              var csvContent = "data:text/csv;charset=utf-8,";
              // Header
              for(var k=0;k<Object.keys(vm.details.data[0]).length;k++)
              {
                  var label = '';
                  if (Object.keys(vm.details.data[0])[k] == 'x') {
                      label = 'timestamp';
                  }
                  else {
                    label = Object.keys(vm.details.data[0])[k];
                  }
                  csvContent+='"'+label+'"'+";";
              }
              csvContent=csvContent.slice(0, -1);
              csvContent+="\n";
              for(var i=0;i<vm.details.data.length;i++)
              {
                for(var k=0;k<Object.keys(vm.details.data[i]).length;k++)
                {
                  //csvContent+=Object.keys(vm.details.data[i])[k]+",";
                  csvContent+='"'+vm.details.data[i][Object.keys(vm.details.data[i])[k]]+'"'+";";
                }
                csvContent=csvContent.slice(0, -1);
                csvContent+="\n";
              }
              var encodedUri = encodeURI(csvContent);
              var link = document.createElement("a");
              link.setAttribute("href", encodedUri);
              link.setAttribute("download", "raw_data.csv");
              document.body.appendChild(link); // Required for FF
              link.click();
          }
        }

        function saveImage(element) {
          var url_base64 = document.getElementById(element).toDataURL('image/png');
          var link = document.createElement("a");
          link.setAttribute("href", url_base64);
          link.setAttribute("download", "breakdown.png");
          document.body.appendChild(link); // Required for FF
          link.click();
        }
        
        function showNotification(title,message,type) {
            if(type==="Error")
            {
                Notification.error({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if(type==="Info")
            {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if(type==="Warning")
            {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if(type==="Success")
            {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }   
        }
    }
        
})();
(function ()
{
    'use strict';

    angular
        .module('app.events', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.events', {
                url      : '/events',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/events/events.html',
                        controller : 'EventsController as vm'
                    }
                },
                bodyClass: 'events'
            });

        // Navigation
        msNavigationServiceProvider.saveItem('events', {
            title : 'NAVIGATION.EVENTS',
            state: 'app.events',
            group : true,
            weight: 1
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.events')
        .controller('EventsController', EventsController);
        
    /** @ngInject */
    function EventsController($rootScope, $q, $timeout, $cookies, msApi, $mdSidenav, $mdDialog, $document, $scope, session, PRAGMA, pragmaapi, Notification, toTrustedFilter, $filter, pragmaTheming)
    {
        var vm = this;
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        
        var cache = {};
        
        // Timezone
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        
        // Theming
		vm.themes = pragmaTheming.themes;
        var isDark = (vm.themes.active.name.indexOf('Dark') >= 0);
        
        // Event Types
        vm.eventTypes = [
            { type: "appliance", name: "Appliance", icon: "icon-power", color: "md-blue-500-bg"},
            { type: "behavior", name: "Behavior", icon: "icon-human", color: "md-orange-500-bg"},
            { type: "equipment", name: "Equipment", icon: "icon-cog", color: "md-green-500-bg"},
            { type: "policy", name: "Policy", icon: "icon-document", color: "md-purple-500-bg"}
        ];
        
        // Dates
        vm.date = {
          startDate: moment().startOf('day'),
            endDate: moment()
        };        
		
		vm.showDates=false;
		
        function translateDateRange() {
            var ranges = {}
            ranges[$filter('translate')("DATERANGE.LAST_7_DAYS")] = [moment().subtract(6, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.LAST_30_DAYS")] = [moment().subtract(29, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.THIS_MONTH")] = [moment().startOf('month'), moment()]
            ranges[$filter('translate')("DATERANGE.LAST_MONTH")] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
            ranges[$filter('translate')("DATERANGE.THIS_YEAR")] = [moment().startOf('year'), moment()];
            
            vm.dateOptions = {
                applyClass: 'md-button md-raised',
                alwaysShowCalendars: true,
                locale: {
                    applyLabel: $filter('translate')("DATERANGE.APPLY"),
                    fromLabel: $filter('translate')("DATERANGE.FROM"),
                    format: "ll",
                    toLabel: $filter('translate')("DATERANGE.TO"),
                    cancelLabel: $filter('translate')("DATERANGE.CANCEL"),
                    customRangeLabel: $filter('translate')("DATERANGE.CUSTOM_RANGE"),
                    daysOfWeek: [
                        $filter('translate')("DATERANGE.SU"),
                        $filter('translate')("DATERANGE.MO"),
                        $filter('translate')("DATERANGE.TU"),
                        $filter('translate')("DATERANGE.WE"),
                        $filter('translate')("DATERANGE.TH"),
                        $filter('translate')("DATERANGE.FR"),
                        $filter('translate')("DATERANGE.SA")
                    ],
                    monthNames: [
                        $filter('translate')("DATERANGE.JANUARY"),
                        $filter('translate')("DATERANGE.FEBRUARY"),
                        $filter('translate')("DATERANGE.MARCH"),
                        $filter('translate')("DATERANGE.APRIL"),
                        $filter('translate')("DATERANGE.MAY"),
                        $filter('translate')("DATERANGE.JUNE"),
                        $filter('translate')("DATERANGE.JULY"),
                        $filter('translate')("DATERANGE.AUGUST"),
                        $filter('translate')("DATERANGE.SEPTEMBER"),
                        $filter('translate')("DATERANGE.OCTOBER"),
                        $filter('translate')("DATERANGE.NOVEMBER"),
                        $filter('translate')("DATERANGE.DECEMBER")
                    ],
                },
                ranges: ranges,
                eventHandlers: {
                    'apply.daterangepicker': vizualizeData
                }
            }
        }
        translateDateRange();
        
        $rootScope.$on('$translateChangeSuccess', function () {
            translateDateRange();
        });
		
        // Make months clickable
        angular.element('body').on('click', '.daterangepicker .month', function() {
            var lang = $cookies.get('lang');
            if (lang != undefined) {
                var drp = angular.element('#daterange').data('daterangepicker');
                var momentDate = moment('1 ' + angular.element(this).text(), "D MMM YYYY", lang);
                drp.setStartDate(momentDate.startOf('month'));
                drp.setEndDate(momentDate.endOf('month'));
                drp.clickApply();
            }
        })
		
		function vizualizeData(){
			console.log(vm.date);
		}
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
        // Chart
        vm.chart = {};
        resetChart();
        
        $scope.croshair = _.memoize(function() {
            return new Dygraph.Plugins.Crosshair({
                            direction: "vertical"
                        });
        });
        
        function resetChart() {
            vm.chart = {
                data: [],
                options: {
                    labels: ["Date"],
                    ylabel: pragmaapi.translate('EVENTS.CONSUMPTION'),
                    series: {},
                    strokeWidth: 1,
                    axisLineColor: vm.themes.active.theme.background.hue1.contrast3,
                    gridLineColor: vm.themes.active.theme.background.hue1.contrast4,
                    fillGraph: true,
                    plotter: barChartPlotter,
                    highlightSeriesBackgroundColor: vm.themes.active.theme.background.hue1.color,
                    highlightSeriesOpts: {
                      strokeWidth: 2,
                    },
                    legendFormatter: function(data) {
                        if (data.x == null) return '';  // no selection
                        var html = data.xHTML;
                        data.series.forEach(function(series, i) {
                            if (!series.isVisible) return;
                            if (series.y == undefined) return;
                            var labeledData = '<span style="color:' + series.color + '">' + series.label + '</span>: ' + filterNumber(series.y) + vm.units[i];
                            if (series.isHighlighted) {
                                labeledData = '<b>' + labeledData + '</b>';
                            }
                            html += ' &nbsp; ' + labeledData;
                        });
                        return html;
                    },
                    plugins: [ $scope.croshair ],
                    underlayCallback: function(canvas, area, g) {

                        canvas.fillStyle = "rgb(255,0,0)";

                        function highlight_period(x_start, x_end) {
                           var canvas_left_x = g.toDomXCoord(x_start);
                           var canvas_right_x = g.toDomXCoord(x_end);
                           var canvas_width = canvas_right_x - canvas_left_x;
                           canvas.fillRect(canvas_left_x, area.y, canvas_width, area.h);
                        }
                        
                        var min_data_x = g.getValue(0,0);
                        for (var i = 0; i < vm.events.length; i++) {
                            var d = moment(vm.events[i].date).format("x");
                            for (var j = 0; j < g.numRows(); j++) {
                                if (g.getValue(j, 0) == d) {
                                    var x_start = min_data_x + (j - 0.5) * (24*3600*1000);
                                    var x_end = min_data_x + (j + 0.5) * (24*3600*1000);
                                    highlight_period(x_start, x_end);
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }
        
        
        // Chart Utilities
        
        // Darken a color
        function darkenColor(colorStr) {
            // Defined in dygraph-utils.js
            var color = Dygraph.toRGB_(colorStr);
            color.r = Math.floor((255 + color.r) / 2);
            color.g = Math.floor((255 + color.g) / 2);
            color.b = Math.floor((255 + color.b) / 2);
            return 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')';
        }
        
        // This function draws bars for a single series
        function barChartPlotter(e) {
            var ctx = e.drawingContext;
            var points = e.points;
            var y_bottom = e.dygraph.toDomYCoord(0);

            ctx.fillStyle = darkenColor(e.color);

            // Find the minimum separation between x-values.
            // This determines the bar width.
            var min_sep = Infinity;
            for (var i = 1; i < points.length; i++) {
                var sep = points[i].canvasx - points[i - 1].canvasx;
                if (sep < min_sep) min_sep = sep;
            }
            var bar_width = Math.floor(2.0 / 3 * min_sep);

            // Do the actual plotting.
            for (var i = 0; i < points.length; i++) {
                var p = points[i];
                var center_x = p.canvasx;

                ctx.fillRect(center_x - bar_width / 2, p.canvasy,
                    bar_width, y_bottom - p.canvasy);

                ctx.strokeRect(center_x - bar_width / 2, p.canvasy,
                    bar_width, y_bottom - p.canvasy);
            }
        }
        
        // Tree
       
        var treeData_orig = [];
        vm.currentModule=vm.user.currentModule;
        vm.parentModule=vm.user.parentModule;
        if(vm.currentModule==='' || vm.parentModule==='#')
        {
            vm.filter={
                device:{},
                site:{},
                specification:{},
                includeDevices:true,
                includeMeasurements:true,
                specs:[],
                measurements:{}
            };
        }
        else
        {
            vm.filter={
                device:[{modules:[vm.currentModule]}],
                site:{},
                specification:{},
                includeDevices:true,
                includeMeasurements:true,
                specs:[],
                measurements:{}
            };
        }
        $scope.$on('change.module', function(event, args) {
            vm.events = [];
			vm.showTree=false;
            if(args.parent==='#')
            {
                vm.filter={
                    device:{},
                    site:{},
                    specification:{},
                    includeDevices:true,
                    includeMeasurements:true,
                    specs:[],
                    measurements:{}
                };
            }
            else
            {
                vm.filter={
                    device:[{modules:[args.token]}],
                    site:{},
                    specification:{},
                    includeDevices:true,
                    includeMeasurements:true,
                    specs:[],
                    measurements:{}
                };
            }
            vm.refreshTree(false);
        });
		
		var loadingProcessedData = false;
        vm.refreshTree = function(refresh) {
            pragmaapi.getTreeDataFilter(vm.filter).then(function(treeData) {
				treeData_orig = treeData;
				loadingProcessedData = true;
				var processedTreeData = processTreeData(treeData);
				if (processedTreeData.length > 0 && !loadingProcessedData){
					vm.treeData = processedTreeData;
					// Reload tree
					vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'state']);
					vm.treeConfig.state = { key : "events" };
					vm.showTree=true;
				}
            });
            /*pragmaapi.getTreeData(true, true, true, true).then(function(treeData) {
                treeData_orig = treeData;
                vm.treeData = processTreeData(treeData);
                // Reload tree
                vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'state']);
                vm.treeConfig.state = { key : "events" };
            });*/
        }
        vm.refreshTree(false);
        
		vm.applySearch = function () {
			if (vm.treeInstance) {
                vm.treeInstance.jstree(true).search(vm.searchtree);
			}
		};
        
        vm.openTree = function () {
			if (vm.treeInstance) {
                vm.treeInstance.jstree().open_all();
			}
		};
        
        vm.closeTree = function () {
			if (vm.treeInstance) {
                vm.treeInstance.jstree().close_all();
			}
		};
        
        vm.resetTree = function () {
			if (vm.treeInstance) {
                cache = {};
                vm.treeInstance.jstree().deselect_all();
			}
		};
        
        vm.events = [];
        vm.eventsOptions = {
            scrollEl: '#timeline-content'
        };
        
        vm.treeEvents = {
            'select_node': selectNode,
            'deselect_node': deselectNode,
            'deselect_all': deselectNode,
            'hover_node': hoverNode
        }
        
        var loading = 0;        
        vm.selectedNode = {};
        function selectNode(e, data) {
            if (data.node) {
                loading++;
                vm.selectedNode = data.node;
                addNode(vm.selectedNode);
            }
        }
        
        function deselectNode(e, data) {
            loading = 0;
            vm.selectedNode = {};
            resetChart();
            updateStatus(pragmaapi.translate('EXPLORE.SELECT_DATA'));
        }
        
        function reloadNode(node) {
            loading = 0;
            
            var cNode = node.original;
            cache[cNode.tenantAuthToken].eventsData = undefined;
            loading++;
            vm.selectedNode = node;
            addNode(vm.selectedNode);
        }
        
        function hoverNode(e, data){
            jQuery("#" + data.node.id + "_anchor").prop('title', data.node.text);
        };
        
        vm.treeData = [];
        function processTreeData(treeData) {
            vm.treeData = treeData;
            var texts = {};
            treeData.forEach(function(node, j) {
                if (!nodeType(node, "client")) {
                    texts[node.id] = node.text;
                }
            });
            treeData.forEach(function(node, j) {
                if (node.text != null) {
                    if (node.text.search(texts[node.parent]) == 0) {
                        node.text = node.text.replace(texts[node.parent], "");
                        node.text = node.text.trim();
                        if (/^\d+$/.test(node.text)) {
                            node.text = "#" + node.text;
                        }
                    }
                }
            });
            var foo = [];
            treeData.forEach(function(node, j) {
                if (!nodeType(node, "measurement")) {
                    foo.push(node);
                }
            });
            var groupIds=[];
            var siteIds=[];
            var tenantIds=[];
            var portfolioIds=[];
            for(var i=0;i<foo.length;i++)
            {
                if(foo[i].type==="deviceGroup")
                {
                    groupIds.push(foo[i].id)
                }
                else if(foo[i].type==="site")
                {
                    siteIds.push(foo[i].id)
                }
                else if(foo[i].type==="portfolio")
                {
                    portfolioIds.push(foo[i].id)
                }
                else if(foo[i].type==="client")
                {
                    tenantIds.push(foo[i].id)
                }
            }
            foo=removeEmpty(foo,groupIds);
            foo=removeEmpty(foo,siteIds);
            foo=removeEmpty(foo,portfolioIds);
            foo=removeEmpty(foo,tenantIds);
            for(var i=0;i<foo.length;i++)
            {
                foo[i]["__uiNodeId"]=i+1;
            }
			loadingProcessedData = false;
            return foo;
        }
        function removeEmpty(tree,ids)
        {
            var fl=false;
            var groupT=-1;
            for(var j=0;j<ids.length;j++)
            {
                fl=false;
                groupT=-1;
                for(var i=0;i<tree.length;i++)
                {
                    if (tree[i].id==ids[j])
                    {
                        groupT=i;
                    }
                    if(tree[i].parent==ids[j])
                    {
                        fl=true;
                    }
                }
                if(!fl)
                {
                    tree.splice(groupT,1);
                }
            }
            return tree;
        }
        
        function nodeType(node, type) {
            return node.id.indexOf(type + "_") == 0;
        }
        
        
        // Color palette
        
        var palette = {
            color0: "3,169,244",
            color1: "146,39,143",
            color2: "170,198,6",
            color3: "242,135,6",
            color4: "0,191,118",
            color5: "102,45,145",
            color6: "236,0,140",
            color7: "0,148,68",
            color8: "249,237,50",
            color9: "239,65,54"
        };
        
        function getColor(index) {
            return 'rgb(' + palette['color' + index] + ')';
        }
        
        
        // Period
        
        vm.period = 7;
        vm.periods = [
            { value: 7, name: "7 " + pragmaapi.translate('EVENTS.DAYS') },
            { value: 15, name: "15 " + pragmaapi.translate('EVENTS.DAYS') },
            { value: 30, name: "30 " + pragmaapi.translate('EVENTS.DAYS') }
        ];
        
        vm.applyPeriod = function (period) {
            if (vm.selectedNode != {}) {
                loading++;
                addNode(vm.selectedNode);
            }
        }
        
        var selectedNodes = {};
        function addNode(node) {
            resetChart();
            if (node != {}) {
                var cNode = node.original;
                
                // Selected nodes
                selectedNodes = {}; // static
                getSelectedNodes(cNode);
                
                if (cache[cNode.tenantAuthToken] == undefined || cache[cNode.tenantAuthToken].eventsData == undefined) {
                    cache[cNode.tenantAuthToken] = {events: [], eventsData: [], measurements: {}};
                    updateStatus(pragmaapi.translate('EXPLORE.LOADING_DATA'), true);
                    loadEvents(node)
                        .then(function(res) {
                            loading--;
                            processEvents(cache[cNode.tenantAuthToken].eventsData, node);
                        });
                }
                else {
                    loading--;
                    processEvents(cache[cNode.tenantAuthToken].eventsData, node);
                }
            }
        }
        
        var selectedAssignments = [];
        function processEvents(events, node) {
            var cNode = node.original;
            vm.units = [];
            cache[cNode.tenantAuthToken].events = [];
            if (!loading) {
                if (events.length) {
                    for (var i = 0; i < events.length; i++) {
                        if (!events[i]['deleted']) {
                            if (selectedNodes[events[i].attachToken] != undefined) {
                                if (events[i].publish || events[i].createdBy == vm.user.username) {
                                    var foo = {};
                                    
                                    // Dates
                                    var date = moment(moment(events[i].eventDate).format("YYYY-MM-DD"));
                                    if (cache[cNode.tenantAuthToken].events.length == 0) {
                                        vm.date.startDate = moment(date).subtract(vm.period + 1, "days");
                                        vm.date.endDate = moment(date).add(vm.period + 1, "days");
                                    }
                                    if (moment(date).subtract(vm.period + 1, "days") < vm.date.startDate) vm.date.startDate = moment(date).subtract(vm.period + 1, "days");
                                    if (moment(date).add(vm.period + 1, "days") > vm.date.endDate) vm.date.endDate = moment(date).add(vm.period + 1, "days");
                                    foo.date = date;
                                    foo.formattedDate = date.format('MMM D, YYYY');
                                    
                                    // Prepare event
                                    var type= getType(events[i].type)
                                    foo.icon = type.icon;
                                    foo.color = type.color;
                                    foo.event = type.name;
                                    foo.attachedTo = selectedNodes[events[i].attachToken].text;
                                    foo.attachedToNode = selectedNodes[events[i].attachToken];
                                    foo.metadata = {
                                        type: events[i].type,
                                        eventDate: events[i].eventDate,
                                        title: events[i].title,
                                        text: events[i].text,
                                        token: events[i].token,
                                        publish: events[i].publish
                                    };
                                    foo.card = {};
                                    foo.card.title = events[i].title;
                                    foo.card.text = events[i].text;
                                    foo.card.template = "app/main/events/templates/event-card.html";
                                    cache[cNode.tenantAuthToken].events.push(foo);
                                }
                            }
                        }
                    }
                    
                    // Load measurements
                    selectedAssignments = []; // static
                    findAssignments(cNode);
                    var events = cache[cNode.tenantAuthToken].events;
                    if (events.length) {
                        for (var i = 0; i < events.length; i++) {
                            loadMeasurements(events[i])
                                .then(function(events) {
                                    var bar = {};
                                    var options = vm.chart.options;
                                    var foo = { before: [], after: [] };
                                    var measure = selectedAssignments[0].specs
                                    var type = measure.type;
                                    var unit = measure.unit;
                                    
                                    var event = eventInEvents(events[0].metadata.token, cache[selectedAssignments[0].tenantAuthToken].events);
                                    
                                    if (event != null) {
                                        for (var i = 0; i < selectedAssignments.length; i++) {
                                            if (inPath(selectedAssignments[i].token, event.attachedToNode.id)) {
                                                var measurements = cache[selectedAssignments[i].tenantAuthToken]["measurements"][vm.period + "d"]
                                                    [selectedAssignments[i].token][selectedAssignments[i].measure][events[i].metadata.token];
                                                
                                                for (var j = 0; j < measurements.data.length; j++) {
                                                    var date = moment(measurements.data[j].t).format("YYYY-MM-DD");
                                                    if (bar[date] != undefined) {
                                                        bar[date] += measurements.data[j].d;
                                                    }
                                                    else {
                                                        bar[date] = measurements.data[j].d;
                                                    }
                                                }
                                            }
                                        }
                                        
                                        // Convert Wh to kWh
                                        if (measure.unit == "Wh") {
                                            unit = "kWh";
                                            for (var date in bar) {
                                                bar[date] = bar[date] / 1000;
                                            };
                                        }
                                        
                                        // Convert W to kWh
                                        if (measure.unit == "W") {
                                            unit = "kWh";
                                            for (var date in bar) {
                                                bar[date] = bar[date] / (1000 * 4); // This applies only to measurements which occur every 15min
                                            };
                                        }
                                        
                                        for (var date in bar) {
                                            if (moment(date) < event.date) {
                                                foo.before.push(bar[date]);
                                            }
                                            else if (moment(date) > event.date) {
                                                foo.after.push(bar[date]);
                                            }
                                        }
                                        
                                        foo.before = pragmaapi.calculateCost(getAverage(foo.before), vm.period, type);
                                        foo.after = pragmaapi.calculateCost(getAverage(foo.after), vm.period, type);
                                        event.card.barChart = {
                                            labels  : [pragmaapi.translate('EVENTS.BEFORE'), pragmaapi.translate('EVENTS.AFTER')],
                                            data    : [$filter('number')(foo.before, 2), $filter('number')(foo.after, 2)],
                                            options : {
                                                scales: {
                                                    yAxes: [{
                                                        ticks: {
                                                            suggestedMin: Math.min(foo.before, foo.after) - Math.abs(foo.before - foo.after)
                                                        }
                                                    }]
                                                },
                                                tooltips : {
                                                    callbacks: {
                                                        label: function(tooltipItem, data) { return tooltipItem.yLabel + " €"; }
                                                    }
                                                }
                                            }
                                        };
                                        event.itemLoaded = true;
                                        
                                        // Graph
                                        if (vm.chart.data.length) {
                                            var j = 0;
                                            var date = vm.date.startDate;
                                            while (date <= vm.date.endDate) {
                                                var foo = date.format("YYYY-MM-DD");
                                                if (bar[foo] != undefined) {
                                                    vm.chart.data[j].push(bar[foo]);
                                                }
                                                else {
                                                    vm.chart.data[j].push(null);
                                                }
                                                date = moment(date).add(1, "days");
                                                j++;
                                            }
                                        }
                                        else {
                                            var date = vm.date.startDate;
                                            while (date <= vm.date.endDate) {
                                                vm.chart.data.push([new Date(date)]);
                                                var j = vm.chart.data.length - 1;
                                                var foo = date.format("YYYY-MM-DD");
                                                if (bar[foo] != undefined) {
                                                    vm.chart.data[j].push(bar[foo]);
                                                }
                                                else {
                                                    vm.chart.data[j].push(null);
                                                }
                                                date = moment(date).add(1, "days");
                                            }
                                        }
                                        
                                        var label = event.metadata.title;
                                        var color = event.color.split("-");
                                        options.labels.push(label);
                                        options.series[label] = {
                                            color: color[1],
                                            axis: "y1"
                                        };
                                        vm.units.push(unit);
                                    }
                                    
                                });
                        }
                        updateStatus(pragmaapi.translate('EXPLORE.READY'));
                        vm.events = events;
                    }
                    else {
                        updateStatus(pragmaapi.translate('EVENTS.NO_DATA_FOUND'));
                        vm.events = [];
                    }
                }
                else {
                    updateStatus(pragmaapi.translate('EVENTS.NO_DATA_FOUND'));
                    vm.events = [];
                }
            }
        }
        
        function inPath(token, parent) {
            if (selectedNodes[token].parent != "#") {
                if (selectedNodes[token].id == parent) {
                    return true;
                }
                else {
                    // Find parent
                    for (var i = 0; i < vm.treeData.length; i++) {
                        if (vm.treeData[i].id == selectedNodes[token].parent) {
                            if (vm.treeData[i].parent == parent) {
                                return true;
                            }
                            return inPath(vm.treeData[i].token, parent)
                        }
                    }
                }
            }
            return false;
        }
        
        function eventInEvents(token, events) {
            for (var i = 0; i < events.length; i++) {
                if (events[i].metadata.token == token) {
                    return events[i];
                }
            }
            return null;
        }
        
        function dateInMeasurements(date, measurements) {
            for (var i = 0; i < measurements.length; i++) {
                if (moment(measurements[i].t).format("YYYY-MM-DD") == date.format("YYYY-MM-DD")) {
                    return i;
                }
            }
            return -1;
        }
        
        function findAssignments(cNode, parent) {
            if (cNode.specs != undefined) {
                if (cNode.specs.cost == "true" && cNode.specs.aggregated == "true") {
                    selectedAssignments.push({name: parent.text, token: parent.token, measure: cNode.measure, tenantAuthToken: cNode.tenantAuthToken, specs: cNode.specs});
                }
            }
            for (var i = 0; i < treeData_orig.length; i++) {
                if (treeData_orig[i].parent == cNode.id) {
                    findAssignments(treeData_orig[i], cNode);
                }
            }
        }
        
        function getSelectedNodes(cNode) {
            selectedNodes[cNode.token] = cNode;
            for (var i = 0; i < vm.treeData.length; i++) {
                if (vm.treeData[i].parent == cNode.id) {
                    getSelectedNodes(vm.treeData[i]);
                }
            }
        }
        
        // Load events
        function loadEvents(node) {
            var cNode = node.original;
            return pragmaapi.callRestService(PRAGMA.api, "/audits",
                    "?page=1&pageSize=35040&tenantAuthToken=" + cNode.tenantAuthToken,
                    true, vm.user.authentication, "GET", true)
                .then(function(res) {
                    cache[cNode.tenantAuthToken].eventsData = res.data.results;
                });
        }
        
        // Load measurements
        function loadMeasurements(event) {
            var from = encodeURIComponent(moment(event.date).subtract(vm.period, "days").format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone);
            var to = encodeURIComponent(moment(event.date).add(vm.period + 1, "days").format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone);
            var date = moment(event.date).format("YYYY-MM-DD");
            var promises = selectedAssignments.map(function(assignment, i) {
                
                if (cache[assignment.tenantAuthToken]["measurements"][vm.period + "d"] == undefined)
                    cache[assignment.tenantAuthToken]["measurements"][vm.period + "d"] = {};
                if (cache[assignment.tenantAuthToken]["measurements"][vm.period + "d"][assignment.token] == undefined)
                    cache[assignment.tenantAuthToken]["measurements"][vm.period + "d"][assignment.token] = {}
                if (cache[assignment.tenantAuthToken]["measurements"][vm.period + "d"][assignment.token][assignment.measure] == undefined)
                    cache[assignment.tenantAuthToken]["measurements"][vm.period + "d"][assignment.token][assignment.measure] = {}
                
                if (cache[assignment.tenantAuthToken]["measurements"][vm.period + "d"][assignment.token][assignment.measure][event.metadata.token] == undefined) {
                    return pragmaapi.callRestService(PRAGMA.api,"/assignments/" + assignment.token + "/measurementsAggregated",
                            "?resolution=1&resolutionType=d&startDate=" + from + "&endDate=" + to + "&measuredParameter=" + assignment.measure + "&page=1&pageSize=2000&tenantAuthToken=" + assignment.tenantAuthToken,
                            true, vm.user.authentication, "GET", true)
                        .then(function(res) {
                            cache[assignment.tenantAuthToken]["measurements"][vm.period + "d"][assignment.token]
                                [assignment.measure][event.metadata.token] = {event: event, data: res.data.data};
                            return event;
                        });
                }
                else {
                    return cache[assignment.tenantAuthToken]["measurements"][vm.period + "d"][assignment.token][assignment.measure][event.metadata.token].event;
                }
            });
            return $q.all(promises);
        }
        
        function updateStatus(msg, spin) {
            if (spin == undefined) spin = false;
            jQuery(".status").html('<span class="msg-spinner' + (spin ? '' : ' static') + '"></span> &nbsp; ' + msg);
        }
        
        function getAverage(arr) {
            var avg = 0;
            if (arr.length) {
                avg = getSum(arr) / arr.length;
            }
            return avg;
        }
        
        function getSum(arr) {
            var sum = 0;
            for (var i = 0; i < arr.length; i++ ) {
                sum += parseFloat(arr[i]);
            }
            return sum;
        }
        
        function getType(type) {
            var res = false;
            angular.forEach(vm.eventTypes, function(val) {
                if (val.type == type) {
                    res = val;
                }
            });
            return res;
        }
        
        //////////
        
       vm.openNewEventDialog = function openNewEventDialog(ev) {
            $mdDialog.show({
                controller         : 'NewEventController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/events/dialogs/newEvent/new-event.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    thisUser: vm.user,
                    eventTypes: vm.eventTypes,
                    selectedNode: vm.selectedNode
                }
            }).then(function(res) {
                pragmaapi.callRestService(PRAGMA.api, "/audits?tenantAuthToken=" + res.tenantAuthToken, res.event, true, vm.user.authentication, "POST", true).then(function(res) {
                    Notification.success(pragmaapi.translate('EVENTS.MESSAGE.ADD_SUCCESS'));
                    reloadNode(vm.selectedNode);
                },function(reason) {
                    Notification.error(pragmaapi.translate('EVENTS.MESSAGE.ADD_ERROR'));
                });
            },function () {});
        }

        vm.openEditEventDialog = function openEditEventDialog(ev,event) {
            $mdDialog.show({
                controller         : 'EditEventController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/events/dialogs/editEvent/edit-event.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    eventTypes: vm.eventTypes,
                    selectedNode: vm.selectedNode,
                    thisEvent: event
                }
            }).then(function(res) {
                pragmaapi.callRestService(PRAGMA.api, "/audits/" + res.event.token + "?tenantAuthToken=" + res.tenantAuthToken, res.event, true, vm.user.authentication, "PUT", true).then(function(res) {
                    Notification.success(pragmaapi.translate('EVENTS.MESSAGE.EDIT_SUCCESS'));
                    reloadNode(vm.selectedNode);
                },function(reason) {
                    Notification.error(pragmaapi.translate('EVENTS.MESSAGE.EDIT_ERROR'));
                });
            },function () {});
        }

        vm.openDeleteEventDialog = function openDeleteEventDialog(ev, event) {
            $mdDialog.show({
                controller         : 'DeleteEventController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/events/dialogs/deleteEvent/delete-event.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
					selectedNode: vm.selectedNode,
                    audit: event
                }
            }).then(function (res)
            {	
				pragmaapi.callRestService(PRAGMA.api, "/audits/" + res.event.metadata.token + "?tenantAuthToken=" + res.tenantAuthToken, "&force=true", true, vm.user.authentication, "DELETE", true).then(function(res){
                    Notification.success(pragmaapi.translate('EVENTS.MESSAGE.DELETE_SUCCESS'));
                    reloadNode(vm.selectedNode);
                },function(reason) {
                    Notification.error(pragmaapi.translate('EVENTS.MESSAGE.DELETE_ERROR'));
                });
            },function () {});
        }
        

        function updateStatus(msg, spin) {
            if (spin == undefined) spin = false;
            jQuery(".status").html('<span class="msg-spinner' + (spin ? '' : ' static') + '"></span> &nbsp; ' + msg);
        }
        
        
        // Left sidebar
        
        vm.lockLeft = true;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleClose = toggleClose;
        vm.changeStatusL = changeStatusL;
        
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
        
        function toggleClose(sidenavId) {
            $mdSidenav(sidenavId).close();
        }
        
        function changeStatusL(sidenavId) {
                $mdSidenav(sidenavId).close();
                if(vm.lockLeft)
                vm.lockLeft=!vm.lockLeft;
        }
        
        
        // Utilities
        
        function filterNumber(number) {
            if (Math.abs(number) < 10) {
                return $filter('number')(number, 3);
            }
            if (Math.abs(number) < 100) {
                return $filter('number')(number, 2);
            }
            else if (Math.abs(number) < 1000) {
                return $filter('number')(number, 1);
            }
            else {
                return $filter('number')(number, 0);
            }
        }
        
        
        // Dygraphs interaction model
        
        function downV3(event, g, context) {
          context.initializeMouseDown(event, g, context);
          if (event.altKey || event.shiftKey) {
            Dygraph.startPan(event, g, context);
          } else {
            Dygraph.startZoom(event, g, context);
          }
        }

        function moveV3(event, g, context) {
          if (context.isPanning) {
            Dygraph.movePan(event, g, context);
          } else if (context.isZooming) {
            Dygraph.moveZoom(event, g, context);
          }
        }

        function upV3(event, g, context) {
          if (context.isPanning) {
            Dygraph.endPan(event, g, context);
          } else if (context.isZooming) {
            Dygraph.endZoom(event, g, context);
          }
        }

        function dblClickV3(event, g, context) {
          restorePositioning(g);
        }

        function restorePositioning(g) {
          g.updateOptions({
            dateWindow: null,
            valueRange: null
          });
        }
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    // DashboardController.inject = ['$q','msApi', '$mdSidenav', '$mdDialog', '$document', '$scope', 'session', 'pragmaapi','PRAGMA'];
    function DashboardController($rootScope, $q, $filter, $translate, $cookies, $timeout, msApi, $mdSidenav, $mdDialog, $document, $scope, session, pragmaapi, PRAGMA) {
        var vm = this;
        vm.lockLeft=true;
        vm.lockRight=true;
        vm.triggered=false;
        vm.showLeftSideNav=false;
        vm.getDashboards=getDashboards;
        vm.dashboardOrder="order";
        vm.toggleSidenav = toggleSidenav;
        vm.changeStatusL = changeStatusL;
        vm.changeStatusR = changeStatusR;
        vm.toggleClose = toggleClose;
        vm.changeDashboard=changeDashboard;
        vm.addWidget=addWidget;
        vm.controlDashboard=controlDashboard;
        vm.removeWidget=removeWidget;
        vm.vizualizeData=vizualizeData;
        vm.user=session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.url=PRAGMA.api;
        vm.dashboards={};
        vm.dashboardLocked=true;
        vm.lockDashboard=lockDashboard;
        vm.selectedDashboard={userId:""};
        vm.clients=[];
        vm.gridId={};
        if(vm.user.hasVerticals)
        {
            vm.currentModule=vm.user.currentModule;
        }
        else
        {
            vm.currentModule="";
        }
        getDashboards('Start', null);
        vm.gridStackOptions = {
            float: false,
            swapping: true,
            disableDrag :true,
            disableResize:true,
            alwaysShowResizeHandle: false
        };
        $scope.$on('change.module', function(event, args) {
            vm.currentModule=args.token;
            getDashboards('Start', null);
        });
        function lockDashboard()
        {
            try
            {
                vm.gridId=$('.grid-stack').data('gridstack');
                vm.dashboardLocked=!vm.dashboardLocked;
                if(vm.dashboardLocked)
                {
                    vm.gridId.disable();
                }
                else
                {
                    vm.gridId.enable();
                }
            }
            catch(err){}
           
        }
        vm.applySearch = function () {
            if (vm.treeInstance) {
                vm.treeInstance.jstree(true).search(vm.searchtree);
            }
        };
          var filter={
                device:{},
                site:{},
                specification:{},
                includeDevices:false,
                includeMeasurements:false,
                specs:[],
                measurements:{}
            };
            pragmaapi.getTreeDataFilter(filter).then(function(treeData) {
                vm.treeData = treeData;
                vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'checkbox']);
            });
        /*pragmaapi.getTreeData(true, false,false,false).then(function(treeData) {
            vm.treeData = treeData;
            vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'checkbox']);
        });*/
        vm.treeEvents = {
            'ready': readyCB,
            'create_node': createNodeCB,
            'select_node': getSelectedNodes,
            'deselect_node': getSelectedNodes
        }

        vm.sortableOptions = {
            update: function(e, ui) {
            },
            stop: function(e, ui) {
                changeDashboardOrder();
            }
        };
        function changeDashboardOrder()
        {
            var counter=0;
            for(var i=0;i<vm.dashboards.length;i++)
            {
                var foo=vm.dashboards[i];
                if(foo.userId!=="")
                {
                    foo.order=counter;
                    counter++;
                    updateDashboard(foo);
                }
            }
        }
        function updateDashboard(dashboard)
        {
            pragmaapi.callRestService(vm.url, "/dashboards/"+dashboard.token, dashboard, true, vm.user.authentication, "PUT", true, false).then(function(res){
            });
        }
        vm.selectedNode = {};
        function getSelectedNodes() {
            if(vm.triggered)
            {
                 vm.triggered=false;
            }
            else
            {
                vm.triggered=true;
                var sitesTemp=[];
                var tenantTokens=[];
                var clientsTemp=[];
                vm.selected_nodes=[];
                vm.selectedNode = {};
                var jstree = vm.treeInstance.jstree(true);
                
                vm.selected_nodes = jstree.get_selected();
                if (vm.selected_nodes[0]) {
                    vm.selectedNode = jstree.get_node(vm.selected_nodes[0]);
                }
                for (var i = 0; i < vm.selected_nodes.length; i++) {
                    if (vm.selected_nodes[i].includes("site")) {
                        sitesTemp.push(vm.selected_nodes[i]);
                    }
                }
                for (var i = 0; i < vm.treeData.length; i++) {
                    for (var j = 0; j < sitesTemp.length; j++) {
                        if (vm.treeData[i].id === sitesTemp[j]) {
                            var fl = 0;
                            for (var l = 0; l < tenantTokens.length; l++) {
                                if (tenantTokens[l] === vm.treeData[i].tenantAuthToken) {
                                    fl = 1;
                                }
                            }
                            if (!fl) {
                                tenantTokens.push(vm.treeData[i].tenantAuthToken)
                                var tempCl= {
                                    token: vm.treeData[i].tenantAuthToken,
                                    sites: []
                                };
                                var tempSi= {
                                    token: vm.treeData[i].token,
                                    name: vm.treeData[i].text
                                };
                                tempCl.sites.push(tempSi)
                                clientsTemp.push(tempCl);
                            }
                            else {
                                for (var l = 0; l < clientsTemp.length; l++) {
                                    if (clientsTemp[l].token === vm.treeData[i].tenantAuthToken) {
                                        var tempSi= {
                                            token: vm.treeData[i].token,
                                            name: vm.treeData[i].text
                                        };
                                        clientsTemp[l].sites.push(tempSi)
                                    }
                                }
                            }
                        }
                    }
                }
                vm.clients=clientsTemp;
                vm.triggered=false;
            }
        }
        
        function readyCB() {
            if (vm.treeData.length > 0) {
               vm.treeInstance.jstree(true).select_node(vm.treeData[0].id);
            }
        }
        
        function createNodeCB() {
        }
        
       vm.date = {
            startDate: moment().startOf('day'),
            endDate: moment()
        };

        function translateDateRange() {
            var ranges = {}
            ranges[$filter('translate')("DATERANGE.LAST_7_DAYS")] = [moment().subtract(6, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.LAST_30_DAYS")] = [moment().subtract(29, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.THIS_MONTH")] = [moment().startOf('month'), moment()]
            ranges[$filter('translate')("DATERANGE.LAST_MONTH")] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
            ranges[$filter('translate')("DATERANGE.THIS_YEAR")] = [moment().startOf('year'), moment()];
            
            vm.dateOptions = {
                applyClass: 'md-button md-raised',
                alwaysShowCalendars: true,
                locale: {
                    applyLabel: $filter('translate')("DATERANGE.APPLY"),
                    fromLabel: $filter('translate')("DATERANGE.FROM"),
                    format: "ll",
                    toLabel: $filter('translate')("DATERANGE.TO"),
                    cancelLabel: $filter('translate')("DATERANGE.CANCEL"),
                    customRangeLabel: $filter('translate')("DATERANGE.CUSTOM_RANGE"),
                    daysOfWeek: [
                        $filter('translate')("DATERANGE.SU"),
                        $filter('translate')("DATERANGE.MO"),
                        $filter('translate')("DATERANGE.TU"),
                        $filter('translate')("DATERANGE.WE"),
                        $filter('translate')("DATERANGE.TH"),
                        $filter('translate')("DATERANGE.FR"),
                        $filter('translate')("DATERANGE.SA")
                    ],
                    monthNames: [
                        $filter('translate')("DATERANGE.JANUARY"),
                        $filter('translate')("DATERANGE.FEBRUARY"),
                        $filter('translate')("DATERANGE.MARCH"),
                        $filter('translate')("DATERANGE.APRIL"),
                        $filter('translate')("DATERANGE.MAY"),
                        $filter('translate')("DATERANGE.JUNE"),
                        $filter('translate')("DATERANGE.JULY"),
                        $filter('translate')("DATERANGE.AUGUST"),
                        $filter('translate')("DATERANGE.SEPTEMBER"),
                        $filter('translate')("DATERANGE.OCTOBER"),
                        $filter('translate')("DATERANGE.NOVEMBER"),
                        $filter('translate')("DATERANGE.DECEMBER")
                    ],
                },
                ranges: ranges,
                eventHandlers: {
                    'apply.daterangepicker': vizualizeData
                }
            }
        }
        translateDateRange();
        
        $rootScope.$on('$translateChangeSuccess', function () {
            translateDateRange();
        });
        
        // Make months clickable
        angular.element('body').on('click', '.daterangepicker .month', function() {
            var lang = $cookies.get('lang');
            if (lang != undefined) {
                var drp = angular.element('#daterange').data('daterangepicker');
                var momentDate = moment('1 ' + angular.element(this).text(), "D MMM YYYY", lang);
                drp.setStartDate(momentDate.startOf('month'));
                drp.setEndDate(momentDate.endOf('month'));
                drp.clickApply();
            }
        })
        
        // Get User Dashboards
        
        function getDashboards(action, token) {
            pragmaapi.callRestService(vm.url, "/userPreferences/userId/" + vm.user.username+"/", "", true, vm.user.authentication, "GET", true, false).then(function(res) {
                vm.userPreferencesDashboards = res.data.removedDashboards;
                pragmaapi.callRestService(vm.url, "/dashboards/userId/"+vm.user.username+"/", "?orderBy="+vm.dashboardOrder+"&module="+vm.currentModule, true, vm.user.authentication, "GET", true, false).then(function(res) {
                    vm.dashboards = [];
                    for (var i = 0; i < res.data.results.length; i++) {
                        var fl = 0;
                        for (var j = 0; j < vm.userPreferencesDashboards.length; j++) {
                            if (res.data.results[i].token === vm.userPreferencesDashboards[j]) {
                                fl = 1;
                            }
                        }
                        if (!fl) {
                            vm.dashboards.push(res.data.results[i]);
                        }
                    }
                    if (action === "Start" || action === "Delete" || action === "Restore") {
                        if (vm.dashboards.length > 0) {
                            changeDashboard(vm.dashboards[0]);
                            checkDashboardDates();
                        }
                    }
                    else if (action === "Duplicate" || action === "New" || action === "Edit") {
                        for (var i = 0; i < vm.dashboards.length; i++) {
                            if (vm.dashboards[i].token === token) {
                                changeDashboard(vm.dashboards[i]);
                                checkDashboardDates();
                                break;
                            }
                        }
                    }
                });
            });
        }
        
        function controlDashboard(ev, dashboard, action) {
            $mdDialog.show({
                controller         : 'ControlDashboardController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dashboard/dialogs/controlDashboard/controlDashboard.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    dashboard:dashboard,
                    action:action,
                    user:vm.user,
                    url:vm.url
                }
            }).then(function(answer) {	
                getDashboards(answer.action, answer.token);
            });
        }
        
        function addWidget(ev, dashboard, widget, action) {
            if (action === "edit") {
                vm.selectedWidget = widget;
            }
            $mdDialog.show({
                controller         : 'NewWidgetController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dashboard/dialogs/newWidget/newWidget.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    dashboard:dashboard,
                    widget:widget,
                    action:action,
                    dashboardDate:vm.date
                }
            }).then(function(answer) {	
                if (answer.action === "new") {
                    vm.selectedDashboard.widgets.push(answer.widget);
                }
                else {
                    vm.selectedWidget=answer.widget;
                }
                vm.gridId=$('.grid-stack').data('gridstack');
                vm.gridId.disable();
                setTimeout(function(){vm.gridId.enable()},500)

            });
        }
        
        function removeWidget(w) {
            var index = vm.selectedDashboard.widgets.indexOf(w);
            vm.selectedDashboard.widgets.splice(index, 1);
        };
        
        function vizualizeData(){
        }
        
        function checkDashboardDates()
        {
            var widgets=vm.selectedDashboard.widgets;
            vm.showDates=true;
            var sD1='';
            var sD2='';
            for(var i=0;i<widgets.length;i++)
            {
                try{
                    sD1= widgets[i].graph.type;
                }
                catch (err){
                    sD1="aggregatedValue";
                }
                try{
                    sD2= widgets[i].dates[0].date;
                }
                catch (err){
                    sD2="today";
                }
                if(sD1!='lastValue' && sD2=="custom")
                {
                    vm.showDates=false;
                    break;
                }
            }
        }
        
        function changeDashboard(dashboard) {
            var selectedD=dashboard;
            var widgets=selectedD.widgets;
            for (var i=0;i<widgets.length;i++)
            {
                widgets[i].dimentions.val=widgets[i].dimentions.y+widgets[i].dimentions.x;
            }
            widgets.sort(function(a, b){ // sort object by age field
                return a.dimentions.val-b.dimentions.val
            });
            selectedD.widgets=widgets;
            vm.selectedDashboard = selectedD;
            checkDashboardDates();
            if(vm.selectedDashboard.userId==="")
            {
                vm.showLeftSideNav=true;
            }
            else
            {
                vm.showLeftSideNav=false;
            }
            $timeout(function() {
                try{
                    vm.gridId=$('.grid-stack').data('gridstack');
                    if(vm.dashboardLocked)
                    {
                        vm.gridId.disable();
                    }
                    else
                    {
                        vm.gridId.enable();
                    }
                }
                catch(err)
                {

                }
                
            }, 200);
            $rootScope.$broadcast('stop-timmer');
        }
        
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function toggleClose(sidenavId) {
            $mdSidenav(sidenavId).close();
        }

        function changeStatusR(sidenavId) {
            $mdSidenav(sidenavId).close();
            if(vm.lockRight)
            vm.lockRight=!vm.lockRight;
        }

        function changeStatusL(sidenavId) {
            $mdSidenav(sidenavId).close();
            if(vm.lockLeft)
            vm.lockLeft=!vm.lockLeft;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.compare')
        .controller('CompareController', CompareController);

    function CompareController($q, $scope, $element, $http, $filter, $cookies, $timeout, $mdSidenav, msApi, session, $rootScope, $mdDialog, $document, $base64, Notification, filterFilter, dateFilter, PRAGMA, pragmaapi, pragmaTheming)
    {
        
        var vm = this;
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        
        // Timezone
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        
		// Theming
		vm.themes = pragmaTheming.themes;
        Chart.defaults.global.defaultFontFamily = 'Roboto, "Helvetica Neue", sans-serif';
        Chart.defaults.global.defaultFontColor = vm.themes.active.theme.background.hue1.contrast1;
        Chart.defaults.global.defaultColor = vm.themes.active.theme.background.hue1.contrast1;
        
        // Cache
        var cache = {};
        vm.data = {left: {}, right: {}};
        vm.stats = {left: {}, right: {}};
        
        // Sidebars
        
        vm.sidebarLock = {left: true, right: true};
        
        vm.toggleSidenav = function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
        
        vm.toggleClose = function toggleClose(sidenavId) {
            $mdSidenav(sidenavId).close();
        }
        
        vm.changeStatus = function changeStatus(sidenavId, dir) {
            $mdSidenav(sidenavId).close();
            if (vm.sidebarLock[dir])
                vm.sidebarLock[dir] =! vm.sidebarLock[dir];
        }
        
        
        // Chart
        
        // Color palette
        var palette = {
            total: "75,193,247",
            electricity: "255,152,0",
            gas: "244,67,54",
            electricity_excess: "76,175,80",
            Aluminium: "75,24,125",
            Glass: "3,169,244",
            Paper: "30,74,158",
            Plastic: "231,197,19",
            color1: "3,169,244",
            color2: "146,39,143",
            color3: "170,198,6",
            color4: "242,135,6",
            color5: "0,191,118",
            color6: "102,45,145",
            color7: "236,0,140",
            color8: "0,148,68",
            color9: "249,237,50",
            color10: "239,65,54",
            color100: "201,201,208"
        };
        
        // Options
        vm.chartTitle = "";
        vm.chartLegend = "";
        vm.chartScaleLabel = "";
        vm.chartKPI = "cost";
        vm.chartType = "bar";
        vm.chartZoom = '1 d';
        vm.chartUnits = [];
        vm.chartMeasures = [];
        vm.chartUnitsShown = [];
        vm.stacked = false;
        vm.temperature = false;
        vm.chartMode = {left: "avg", right: "avg"};
        
        // Measures
        vm.selectedMeasureType = 'all';
        vm.measureTypes = [];

        // Units
        vm.selectedUnit = 'kWh';
        vm.units = [];
        
        var maxNumberOfPoints = 300;
        
        function resetChart() {
            vm.data = {left: {}, right: {}};
            vm.stats = {left: {}, right: {}};
            vm.chart = {
                data: [],
                colors: [],
                labels: [],
                series: [],
                override: [],
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: { duration: 800 },
                    title: {
                        display: true,
                        position: "top",
                        fontSize: 16,
                        text: ""
                    },
                    legend: {
                        display: true,
                        position: "bottom"
                    },
                    scales: {
                        xAxes: [{
                            categoryPercentage: 0.8,
                            barPercentage: 1.0
                        }],
						yAxes: [{
							ticks: {
								beginAtZero: true
							}
						}]
                    },
                    tooltips: {}
                    /*,
					pan: {
                        sensitivity: 0,
                        enabled: true,
                        mode: 'x'
                    },
                    zoom: {
                        sensitivity: 0,
                        enabled: true,
                        mode: 'x',
                    }*/
                },
                click: function() {},
                hover: function() {}
            };
        }
        resetChart();
        
        var chartAggregated = null;
        $scope.$on('chart-create', function (e, chart) {
            chartAggregated = chart;
        });
        
        
        // Chart zoom
        
        var $dragging = null;
        var $offset = 0, $left = 0, $right = 0;
        jQuery('body')
            .off("mousemove")
            .on("mousemove", function(e) {
                if ($dragging) {
                    var $zc = $dragging.parent();
                    var zoom = getZoomDimensions($dragging);
                    var left = e.pageX - $offset;
                    var right = zoom.ch_l + zoom.ch_w;
                    if ($dragging.hasClass('zoom-box')) {
                        if (left > zoom.ch_l - zoom.zl_w / 2 && left < right - zoom.zc_w + zoom.zr_w / 2) {
                            $zc.offset({ left: left });
                        }
                    }
                    else if ($dragging.hasClass('zoom-left')) {
                        if (left > zoom.ch_l - zoom.zl_w / 2 && left < zoom.zr_l - zoom.zl_w / 2 - zoom.zr_w / 2) {
                            $zc.offset({ left: left }).outerWidth($right - left);
                        }
                    }
                    else if ($dragging.hasClass('zoom-right')) {
                        var width = ($right - $left);
                        if (left + width > $left + zoom.zl_w + zoom.zr_w && left + width < right + zoom.zr_w / 2) {
                            $zc.outerWidth(width - ($left - left));
                        }
                    }
                    zoomIndexScale(zoom);
                }
            })
            .off("mousedown", ".zoom-ctrl")
            .on("mousedown", ".zoom-ctrl", function (e) {
                $dragging = jQuery(e.target);
                var $zc = $dragging.parent();
                $left = $zc.offset().left;
                $right = $left + $zc.outerWidth();
                $offset = e.pageX - $left;
            })
            .off("mouseup")
            .on("mouseup", function (e) {
                if ($dragging) {
                    var zoom = getZoomDimensions($dragging);
                    zoomIndexScale(zoom);
                    $dragging = null;
                }
            })
            .off("mouseleave")
            .on("mouseleave", function (e) {
                if ($dragging) {
                    var zoom = getZoomDimensions($dragging);
                    zoomIndexScale(zoom);
                    $dragging = null;
                }
            })
            .off("click", ".zoom-ctrl")
            .on("click", ".zoom-ctrl", function (e) {
                $dragging = null;
            })
            .off("dblclick", ".zoom-ctrl")
            .on("dblclick", ".zoom-ctrl", function (e) {
                $dragging = jQuery(e.target);
                var $zc = $dragging.parent();
                var zoom = getZoomDimensions($dragging);
                $zc.offset({ left: zoom.ch_l - (zoom.zl_w / 2) }).outerWidth(zoom.ch_w + zoom.zr_w);
                zoomReset(zoom);
                $dragging = null;
            });
        
        function zoomIndexScale(zoom) {
          var ratio = zoom.zb_w / zoom.ch_w;
          var center = zoom.zb_l - zoom.ch_l + zoom.zb_w / 2;
          var width = zoom.ch_w;
          for (var prop in chartAggregated.scales) {
              var scale = chartAggregated.scales[prop];
              if (scale.isHorizontal()) {
                  var labels = scale.chart.data.labels;
                  var minIndex = 0, maxIndex = 0;
                  
                  var centerpoint = parseInt(center / width * labels.length);
                  var bounds = parseInt(labels.length * ratio / 2);
                  
                  minIndex = centerpoint - bounds;
                  maxIndex = centerpoint + bounds;
                  scale.options.ticks.min = labels[minIndex];
                  scale.options.ticks.max = labels[maxIndex];
              }
          }
          chartAggregated.update(0);
        }

        function zoomReset(zoom) {
          for (var prop in chartAggregated.scales) {
              var scale = chartAggregated.scales[prop];
              if (scale.isHorizontal()) {
                  var labels = scale.chart.data.labels;
                  var minIndex = 0, maxIndex = labels.length;
                  
                  scale.options.ticks.min = labels[minIndex];
                  scale.options.ticks.max = labels[maxIndex];
              }
          }
          chartAggregated.update(0);
        }

        function getZoomDimensions($dragging) {
            var zoom = {};
            
            var $zc = $dragging.parent();
            var $zl = $zc.find('.zoom-left');
            var $zb = $zc.find('.zoom-box');
            var $zr = $zc.find('.zoom-right');
            
            zoom.zc_w = $zc.outerWidth();
            zoom.zb_l = $zb.offset().left;
            zoom.zb_w = $zb.outerWidth();
            zoom.zl_l = $zl.offset().left;
            zoom.zl_w = $zl.outerWidth();
            zoom.zr_l = $zr.offset().left;
            zoom.zr_w = $zr.outerWidth();
            
            zoom.ch_l = $zc.parent().offset().left;
            zoom.ch_w = $zc.parent().outerWidth();
            return zoom;
        }
        
        // Saved graphs
        
        var select_graph = pragmaapi.translate("BREAKDOWN.SELECT_GRAPH")
        
        vm.savedGraph = {
            bar         : "none",
            line        : "none",
            pie         : "none",
            heatmap     : "none",
            functional  : "none",
        };
        
        vm.savedGraphs = {
            bar         : [{
                id: "none",
                name: select_graph,
                is_default: true
            }],
            line        : [{
                id: "none",
                name: select_graph,
                is_default: true
            }],
            pie         : [{
                id: "none",
                name: select_graph,
                is_default: true
            }]
        }
        
        pragmaapi.loadUserData("savedGraphs").then(function(userSavedGraphs) {
            vm.savedGraphs = mergeSavedGraphs(vm.savedGraphs, userSavedGraphs);
        });
        
        function mergeSavedGraphs(arr1, arr2) {
            for (var chartType in arr1) {
                if (arr2[chartType] != undefined) {
                    for (var i = 0; i < arr1[chartType].length; i++) {
                        var graph = inGraphs(arr1[chartType][i], arr2, chartType);
                        if (graph != null) {
                            // Overwrite
                            arr1[chartType][i] = graph;
                        }
                    }
                }
            }
            for (var chartType in arr2) {
                if (arr2[chartType] != undefined) {
                    for (var i = 0; i < arr2[chartType].length; i++) {
                        var graph = inGraphs(arr2[chartType][i], arr1, chartType);
                        if (graph == null) {
                            // Add
                            arr1[chartType].push(graph);
                        }
                    }
                }
            }
            return arr1;
        }
        
        vm.isDefault = function (id) {
            var graph = inGraphs(id, vm.savedGraphs, vm.chartType);
            if (graph != null) {
                return graph.is_default;
            }
            return true;
        }
        
        vm.loadGraph = function (id) {
            var graph = inGraphs(id, vm.savedGraphs, vm.chartType);
            if (graph != null) {
                vm.savedGraph[vm.chartType] = graph.id;
                if (graph.is_period)
                    loadPeriod(graph.period, graph.options);
                
                if (graph.is_datasource)
                    loadDatasource(graph.datasource);
                
                loadOptions(graph.options);
                
                visualizeData();
            }
        }
        
        function loadPeriod(period, options) {
            if (period != undefined) {
                if (period.last != undefined) {
                    if (period.last.from) {
                        if (period.last.from == "auto") {
                            if (options != undefined) {
                                var width = jQuery("#chart-aggregated-canvas").width() - 96; // -96 remove axis space
                                if (options.heatmap != undefined && options.heatmap.Radius != undefined) {
                                    // Heatmap
                                    var days = width / (2 * (options.heatmap.Radius - 2)); // -2 remove item border
                                    vm.date.startDate = moment().subtract(days, "days");
                                }
                            }
                        }
                        else {
                            var parts = period.last.from.split(" ");
                            vm.date.startDate = moment().subtract(parts[0], parts[1])
                        }
                    }
                    if (period.last.to) {
                        var parts = period.last.from.split(" ");
                        vm.date.endDate = moment().subtract(parts[0], parts[1])
                    }
                    else {
                        vm.date.endDate = moment(); // now
                    }
                }
                else {
                    vm.date.startDate = period.startDate;
                    vm.date.endDate = period.endDate;
                }
                updateDaterange(vm.date.startDate, vm.date.endDate);
            }
        }
        
        function loadDatasource(datasource) {
        }
        
        function loadOptions(options) {
            if (options != undefined) {
                // KPI
                if (options.chartKPI != undefined)
                    setKPI(options.chartKPI, true);
                // Zoom
                if (options.chartZoom != undefined)
                    setZoom(options.chartZoom, true);
                // Stacked
                if (options.stacked != undefined)
                    setOption("stacked", options.stacked, true);
                // Temperature
                if (options.temperature != undefined)
                    setOption("temperature", options.temperature);
                // Measure type
                if (options.selectedMeasureType != undefined)
                    vm["selectedMeasureType"] = options.selectedMeasureType;
                // Unit
                if (options.selectedUnit != undefined)
                    vm["selectedUnit"] = options.selectedUnit;
                // Compensates
                if (options.selectedCompensate != undefined) {
                    // Unselect all
                    selectCompensate("", true);
                    if (options.selectedCompensate.length) {
                        for (var i = 0; options.selectedCompensate.length; i++) {
                            selectCompensate(options.selectedCompensate[i], true);
                        }
                    }
                }
                // Heatmap
                if (options.heatmap != undefined) {
                    for (var option in options.heatmap) {
                        vm["heatmap" + option] = options.heatmap[option];
                    }
                }
                // Period
                if (options.period != undefined) {
                    loadPeriod(options.period);
                }
            }
        }
        
        function getOptions() {
            return angular.copy({
                        period              : vm.date,
                        chartKPI            : vm.chartKPI,
                        chartZoom           : vm.chartZoom,
                        stacked             : vm.stacked,
                        temperature         : vm.temperature,
                        selectedCompensate  : vm.selectedCompensate,
                        selectedMeasureType : vm.selectedMeasureType,
                        selectedUnit        : vm.selectedUnit,
                        heatmap             : {
                            Levels       : vm.heatmapLevels,
                            Radius       : vm.heatmapRadius,
                            RadiusLocked : vm.heatmapRadiusLocked,
                            PointStyle   : vm.heatmapPointStyle,
                            Color        : vm.heatmapColor,
                            Distribution : vm.heatmapDistribution
                        }
                    });
        }
        
        function inGraphs(id, graphs, type) {
            if (graphs[type] != undefined) {
                for (var i = 0; i < graphs[type].length; i++) {
                    if (graphs[type][i].id == id) {
                        return graphs[type][i];
                    }
                }
            }
            return null;
        }

        // Filters
        vm.filter = {left: {}, right: {}};
        
        // Date Range
        
        vm.date = {};
        vm.dateOptions = {};
        
        vm.date.left = {
          startDate: moment().startOf('month'),
          endDate: moment()
        };
        
        vm.date.right = {
            startDate: moment().startOf('month'),
            endDate: moment()
        };
        function translateDateRange() {
			var ranges = {}
            ranges[$filter('translate')("DATERANGE.LAST_7_DAYS")] = [moment().subtract(6, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.LAST_30_DAYS")] = [moment().subtract(29, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.THIS_MONTH")] = [moment().startOf('month'), moment()]
            ranges[$filter('translate')("DATERANGE.LAST_MONTH")] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
            ranges[$filter('translate')("DATERANGE.THIS_YEAR")] = [moment().startOf('year'), moment()];
            
            vm.dateOptions.left = {
                applyClass: 'md-button md-raised',
                alwaysShowCalendars: true,
                autoUpdateInput: true,
                autoApply: true,
                locale: {
                    applyLabel: $filter('translate')("DATERANGE.APPLY"),
                    fromLabel: $filter('translate')("DATERANGE.FROM"),
                    format: "ll",
                    toLabel: $filter('translate')("DATERANGE.TO"),
                    cancelLabel: $filter('translate')("DATERANGE.CANCEL"),
                    customRangeLabel: $filter('translate')("DATERANGE.CUSTOM_RANGE"),
                    daysOfWeek: [
                        $filter('translate')("DATERANGE.SU"),
                        $filter('translate')("DATERANGE.MO"),
                        $filter('translate')("DATERANGE.TU"),
                        $filter('translate')("DATERANGE.WE"),
                        $filter('translate')("DATERANGE.TH"),
                        $filter('translate')("DATERANGE.FR"),
                        $filter('translate')("DATERANGE.SA")
                    ],
                    monthNames: [
                        $filter('translate')("DATERANGE.JANUARY"),
                        $filter('translate')("DATERANGE.FEBRUARY"),
                        $filter('translate')("DATERANGE.MARCH"),
                        $filter('translate')("DATERANGE.APRIL"),
                        $filter('translate')("DATERANGE.MAY"),
                        $filter('translate')("DATERANGE.JUNE"),
                        $filter('translate')("DATERANGE.JULY"),
                        $filter('translate')("DATERANGE.AUGUST"),
                        $filter('translate')("DATERANGE.SEPTEMBER"),
                        $filter('translate')("DATERANGE.OCTOBER"),
                        $filter('translate')("DATERANGE.NOVEMBER"),
                        $filter('translate')("DATERANGE.DECEMBER")
                    ],
                },
                ranges: ranges,
                eventHandlers: {
                    'apply.daterangepicker': setDateL
                }
            }
            vm.dateOptions.right = _.merge({}, vm.dateOptions.left, {opens: "left", eventHandlers: { 'apply.daterangepicker': setDateR } });
        }
        translateDateRange();
        
        $rootScope.$on('$translateChangeSuccess', function () {
            translateDateRange();
        });
        
        jQuery('body').on('click', '.daterangepicker .month', function() {
            var lang = $cookies.get('lang');
            if (lang != undefined) {
                
                var picker = "R";
                if (jQuery(this).closest(".daterangepicker").hasClass("opensright")) picker = "L";
                
                var drp = jQuery('#daterange' + picker).data('daterangepicker');
                
                var momentDate = moment('1 ' + jQuery(this).text(), "D MMM YYYY", lang);
                drp.setStartDate(momentDate.startOf('month'));
                drp.setEndDate(momentDate.endOf('month'));
                drp.clickApply();
            }
        })
		
        function updateDaterange(startDate, endDate, picker) {
            var lang = $cookies.get('lang');
            if (lang != undefined) {
                var drp = jQuery('#daterange' + picker).data('daterangepicker');
                drp.setStartDate(startDate);
                drp.setEndDate(endDate);
                var input = jQuery('#daterange' + picker);
                input.val(moment(startDate).format("D MMM YYYY", lang) + " - " + moment(endDate).format("D MMM YYYY", lang));
            }
        }
        
        function setDateL() {
			setDate("left");
            if (vm.lock){
				vm.date.right = vm.date.left;
				setDate("right");
			}
		}
        function setDateR() { setDate("right"); }
        function setDate(dir) {
			loading[dir] = selectedNodes[dir].length;
            addNodesToGraph(selectedNodes[dir], dir);
        }
        
        
        // Tree
        
        vm.treeData = {};
        vm.treeConfig = {};
        vm.treeInstance = {};
        vm.searchtree = {}
        vm.currentModule=vm.user.currentModule;
        vm.parentModule=vm.user.parentModule;
        if(vm.currentModule==='' || vm.parentModule==='#')
        {
            vm.filterTree={
                device:{},
                site:{},
                specification:{},
                includeDevices:true,
                includeMeasurements:true,
                specs:[],
                measurements:{}
            };
        }
        else
        {
            vm.filterTree={
                device:[{modules:[vm.currentModule]}],
                site:{},
                specification:{},
                includeDevices:true,
                includeMeasurements:true,
                specs:[],
                measurements:{}
            };
        }
        $scope.$on('change.module', function(event, args) {
            vm.showTree=false;
            if(args.parent==='#')
            {
                vm.filterTree={
                    device:{},
                    site:{},
                    specification:{},
                    includeDevices:true,
                    includeMeasurements:true,
                    specs:[],
                    measurements:{}
                };
            }
            else
            {
                vm.filterTree={
                    device:[{modules:[args.token]}],
                    site:{},
                    specification:{},
                    includeDevices:true,
                    includeMeasurements:true,
                    specs:[],
                    measurements:{}
                };
            }
            vm.refreshTrees(false);
        });
		
		var loadingProcessedData = false;
		
        vm.refreshTrees = function(refresh) {
			pragmaapi.getTreeDataFilter(vm.filterTree).then(function(treeData) {
				loadingProcessedData = true;
				var processedTreeData = processTreeData(treeData);
				if (processedTreeData.length > 0 && !loadingProcessedData){
					vm.treeData.original = treeData;
					vm.treeData.left = processedTreeData;
					vm.treeData.right = _.clone(vm.treeData.left, true)
					// Reload tree
					vm.treeConfig.left = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'checkbox', 'state']);
					vm.treeConfig.right = _.clone(vm.treeConfig.left, true)
					vm.treeConfig.left.state = { key : "compareLeft" };
					vm.treeConfig.right.state = { key : "compareRight" };
					vm.showTree=true;
				}
            });
            /*pragmaapi.getTreeData(true, true, true, true).then(function(treeData) {
                vm.treeData.original = treeData;
                vm.treeData.left = processTreeData(treeData);
                vm.treeData.right = _.clone(vm.treeData.left, true)
                // Reload tree
                vm.treeConfig.left = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'checkbox', 'state']);
                vm.treeConfig.right = _.clone(vm.treeConfig.left, true)
                vm.treeConfig.left.state = { key : "compareLeft" };
                vm.treeConfig.right.state = { key : "compareRight" };
            });*/
        }
        vm.refreshTrees(false);
		
		vm.applySearch = function (dir) {
			if (vm.treeInstance[dir]) {
                vm.treeInstance[dir].jstree(true).search(vm.searchtree[dir]);
			}
		};
        
        vm.openTree = function (dir) {
			if (vm.treeInstance[dir]) {
                vm.treeInstance[dir].jstree().open_all();
			}
		};
        
        vm.closeTree = function (dir) {
			if (vm.treeInstance[dir]) {
                vm.treeInstance[dir].jstree().close_all();
			}
		};
        
        vm.resetTree = function (dir) {
			if (vm.treeInstance[dir]) {
                cache = {};
                vm.treeInstance[dir].jstree().deselect_all();
			}
		};
		
		vm.treeEvents = {
            left: {
                'select_node': selectNode,
                'deselect_node': selectNode,
                'deselect_all': selectNode,
                'hover_node': hoverNode
            },
            right: {
                'select_node': selectNode,
                'deselect_node': selectNode,
                'deselect_all': selectNode,
                'hover_node': hoverNode
            }
        }

        var loading = {left: 0, right: 0};
        var selectedNodes = {left: [], right: []};
		
		vm.modeCtrl = {left: true, right: true};
		
        function selectNode(e, data) {
			
            var jstree = data.instance;
            
            var dir = "right";
            if (jstree.element[0].id == "left-tree") dir = "left";
            
            loading[dir] = 0;
            selectedNodes[dir] = [];
            
            var foo = jstree.get_selected(true);
            for (var i = 0; i < foo.length; i++) {
                if (foo[i].id.indexOf("device_") === 0) {
                    selectedNodes[dir].push(foo[i]);
                    loading[dir]++;
                }
            }
			
            if (selectedNodes[dir].length) {
				selectedNodes[dir].sort(function(a, b) {return (parseInt(a.id.substring(12)) > parseInt(b.id.substring(12))) ? 1 : ((parseInt(b.id.substring(12)) > parseInt(a.id.substring(12))) ? -1 : 0);});
                updateStatus(pragmaapi.translate('COMPARE.LOADING_DATA'), true);
				$timeout(function() { addNodesToGraph(selectedNodes[dir], dir) }, 200);
            }
            else {
				if (dir == "right") {
					removeRight();
                }
                else {
                    resetChart();
                    vm.treeInstance["right"].jstree().deselect_all();
                    updateStatus(pragmaapi.translate('COMPARE.SELECT_DATA'), false);
                }
            }
			
			// Enable/Disable mode ctrl [sum/avg] 
			if (selectedNodes[dir].length >= 2){
				vm.modeCtrl[dir] = false;
			}
			else {
				vm.modeCtrl[dir] = true;
			}
			
        }
		
        function hoverNode(e, data){
            jQuery("#" + data.node.id + "_anchor").prop('title', data.node.text);
        };
        
        function processTreeData(treeData) {
			var texts = {};
            var foo = [];
            treeData.forEach(function(node, j) {
                if (!nodeType(node, "measurement")) {
                    foo.push(node);
                }
            });
            foo.forEach(function(node, j) {
                if (!nodeType(node, "client")) {
                    texts[node.id] = node.text;
                }
            });
            foo.forEach(function(node, j) {
                if (node.text != null) {
                    var foo = node.text;
                    if (node.text.search(texts[node.parent]) == 0) {
                        node.text = node.text.replace(texts[node.parent], "");
                        node.text = node.text.trim();
                        if (/^\d+$/.test(node.text)) {
                            node.text = "#" + node.text;
                        }
                        // Restore
                        if (node.text == "") node.text = foo;
                    }
                }
            });
            var groupIds=[];
            var siteIds=[];
            var tenantIds=[];
            var portfolioIds=[];
            for(var i=0;i<foo.length;i++)
            {
                if(foo[i].type==="deviceGroup")
                {
                    groupIds.push(foo[i].id)
                }
                else if(foo[i].type==="site")
                {
                    siteIds.push(foo[i].id)
                }
                else if(foo[i].type==="portfolio")
                {
                    portfolioIds.push(foo[i].id)
                }
                else if(foo[i].type==="client")
                {
                    tenantIds.push(foo[i].id)
                }
            }
            foo=removeEmpty(foo,groupIds);
            foo=removeEmpty(foo,siteIds);
            foo=removeEmpty(foo,portfolioIds);
            foo=removeEmpty(foo,tenantIds);
            for(var i=0;i<foo.length;i++)
            {
                foo[i]["__uiNodeId"]=i+1;
            }
			loadingProcessedData = false;
            return foo;
        }
        function removeEmpty(tree,ids)
        {
            var fl=false;
            var groupT=-1;
            for(var j=0;j<ids.length;j++)
            {
                fl=false;
                groupT=-1;
                for(var i=0;i<tree.length;i++)
                {
                    if (tree[i].id==ids[j])
                    {
                        groupT=i;
                    }
                    if(tree[i].parent==ids[j])
                    {
                        fl=true;
                    }
                }
                if(!fl)
                {
                    tree.splice(groupT,1);
                }
            }
            return tree;
        }
        function nodeType(node, type) {
            return node.id.indexOf(type + "_") == 0;
        }        
        
        
        // Main
		
        function addNodesToGraph(nodes, dir) {
			if (vm.date[dir].startDate !== "" && vm.date[dir].endDate!== "") {
                var period = vm.date[dir].startDate + "-" + vm.date[dir].endDate;
                if (cache[period] == undefined) cache[period] = {};
                for (var i = 0; i < nodes.length; i++) {
                    var node = nodes[i];
                    if (cache[period][node.original.token] == undefined) {
                        cache[period][node.original.token] = {};
						loadData(node, dir)
                            .then(function(res) {
                                loading[dir]--;
                                graphData(dir);
                            })
                    }
                    else {
						loading[dir]--;
                        graphData(dir);
                    }
                }
            }
            else {
                updateStatus(pragmaapi.translate('COMPARE.SELECT_DATES'));
            }
			
        }
        
        var measures = {left: null, right: null};
        function graphData(dir, force) {
			if (loading[dir] == 0 || force) {
                // drawChart
                updateStatus(pragmaapi.translate('COMPARE.PREPARING_DATA'), true);
                $timeout(function() { drawChart(dir) }, 150);
            }
        }
        
        function drawChart(dir) {
			vm.data[dir] = {};
            var period = vm.date[dir].startDate + "-" + vm.date[dir].endDate;
            var measurements = cache[period];
            if (measurements != null) {
				measures[dir] = findMeasures(selectedNodes[dir], dir);
				for (var token in measures[dir]) {
					if (measurements[token].length) {
                        
						var measure = measures[dir][token];
                        var pos = measurementInCache(measurements[token], measure.measure);
                        if (pos >= 0) {
                            
                            if (measure.specs.aggregated == "true") {
                                vm.data[dir][token] = aggregateData(measurements[token][pos]["entries"], vm.chartZoom, dir);
                            }
                            else {
                                vm.data[dir][token] = accumulateData(measurements[token][pos]["entries"], vm.chartZoom, dir);
                            }
                            
                            vm.chartUnits[(dir == "left" ? 0 : 1)] = measure.specs.unit;
                            vm.chartMeasures[(dir == "left" ? 0 : 1)] = measure.specs.type;
                            
                            // Convert Wh to kWh
                            if (measure.specs.unit == "Wh") {
                                vm.chartUnits[(dir == "left" ? 0 : 1)] = "kWh";
                                vm.data[dir][token].forEach(function(measurement, i) {
                                    vm.data[dir][token][i].d = measurement.d / 1000;
                                });
                            }
                            
                            // Convert W to kWh
                            if (measure.specs.unit == "W") {
                                vm.chartUnits[(dir == "left" ? 0 : 1)] = "kWh";
                                vm.data[dir][token].forEach(function(measurement, i) {
                                    vm.data[dir][token][i].d = measurement.d / (1000 * 4);
                                });
                            }
                            
                            // Convert g to kg
                            if (measure.specs.unit == "g") {
                                vm.chartUnits[(dir == "left" ? 0 : 1)] = "kg";
                                vm.data[dir][token].forEach(function(measurement, i) {
                                    vm.data[dir][token][i].d = measurement.d / 1000;
                                });
                            }
                        }
                    }
                }
                
                // Align data
                // TBD
				
				if (selectedNodes[dir].length){
					// SUM
					var count = 0;
					var total = 0;
					var sum = [];
					for (var token in vm.data[dir]) {
						for (var i = 0; i < vm.data[dir][token].length; i++) {
							if (sum[i] == undefined) sum[i] = 0;
							sum[i] += vm.data[dir][token][i].d;
						}
						count++;
					}
					vm.data[dir].sum = sum;
					
					// AVG
					vm.data[dir].avg = [];
					for (var i = 0; i < vm.data[dir]["sum"].length; i++) {
						vm.data[dir]["avg"][i] = (vm.data[dir]["sum"][i] / count);
						if (vm.chartKPI == "cost") {
							vm.chartUnits[(dir == "left" ? 0 : 1)] = "€";
							vm.data[dir]["avg"][i] = pragmaapi.calculateCost(vm.data[dir]["avg"][i], 1, vm.chartMeasures[(dir == "left" ? 0 : 1)]);
							vm.data[dir]["sum"][i] = pragmaapi.calculateCost(vm.data[dir]["sum"][i], 1, vm.chartMeasures[(dir == "left" ? 0 : 1)]);
						}
					}
					
					for (var i = 0; i < vm.data[dir]["sum"].length; i++) {
						vm.data[dir]["avg"][i] = vm.data[dir]["avg"][i].toFixed(2);
						vm.data[dir]["sum"][i] = vm.data[dir]["sum"][i].toFixed(2);
					}
					
					if (dir == "left") {
						vm.chart.series[0] = "Left";
						vm.chart.override[0] = {type: vm.chartType};
						vm.chart.colors[0] = getColors(0);
						vm.chart.data[0] = vm.data["left"][vm.chartMode["left"]];
						vm.chart.labels = [];
						for (var i = 0; i < vm.data["left"][vm.chartMode["left"]].length; i++) {
							vm.chart.labels.push("");
						}
					}
				
				
				}
				
                if ((vm.data["left"]["sum"] != undefined && vm.data["right"]["sum"] != undefined)) {
					updateStatus(pragmaapi.translate('COMPARE.PREPARING_GRAPH'), true);
                    // Timeout to give time for status to update
                    $timeout(function() { _drawChart() }, 150);
                }
                else {
                    updateStatus(pragmaapi.translate('COMPARE.PLEASE_SELECT_RIGHT'), false);
                }
            }
        }
        
        function _drawChart(dir) {
			
            // Left
            vm.chart.series[0] = "Left";
            vm.chart.override[0] = {type: vm.chartType};
            vm.chart.colors[0] = getColors(0);
            vm.chart.data[0] = vm.data["left"][vm.chartMode["left"]];
            
            // Right
            vm.chart.series[1] = "Right";
            vm.chart.override[1] = {type: vm.chartType};
            vm.chart.colors[1] = getColors(1);
            vm.chart.data[1] = vm.data["right"][vm.chartMode["right"]];
			
            var max = Math.max(vm.data["left"][vm.chartMode["left"]].length, vm.data["right"][vm.chartMode["right"]].length);
            vm.chart.labels = [];
            for (var i = 0; i < max; i++) {
                vm.chart.labels.push("");
            }
            
            // Add what's needed for bar charts
            vm.chart.options.scales = {
                xAxes: [{id: 'Ax', gridLines: {color: vm.themes.active.theme.background.hue1.contrast3}, ticks: { maxRotation: 0, fontSize: 10, autoSkipPadding: 10}}],
                yAxes: [{id: 'Ay', gridLines: {color: vm.themes.active.theme.background.hue1.contrast4}, scaleLabel: { display: true, labelString: vm.chartScaleLabel }, stacked: vm.stacked, ticks: {beginAtZero: true}}]
            };
			
            if (vm.temperature) {
                vm.chart.options.scales.xAxes.push({id: 'Bx', ticks: { maxRotation: 0, fontSize: 10, autoSkipPadding: 10}, position: 'top', display: false});
                vm.chart.options.scales.yAxes.push({id: 'By', position: 'right', gridLines: { display: false }, scaleLabel: { display: true, labelString: 'Temperature in °C'}, stacked: false, ticks: {beginAtZero: true}});
            }
            vm.chart.options.tooltips = {
                callbacks: {
                    label: function(tooltipItem, data) {
                        return tooltipItem.yLabel + " " + vm.chartUnits[tooltipItem.datasetIndex];
                    }
                }
            };
            
            if (max > maxNumberOfPoints) {
                vm.chart.options.animation.duration = 0;
                //vm.chart.options.legend.position = "top";
                //drawZoomChart();
            }
            else {
                vm.chart.options.animation.duration = 800;
                //vm.chart.options.legend.position = "bottom";
            }
            
            getStats();
            
            updateStatus(pragmaapi.translate('COMPARE.READY'), false);
            
        }
        
        function aggregateData(data, zoom, dir) {
            
            var aggregated = {};
            var format = "";
            
            switch (zoom) {
                case '15 m':
                    format = "YYYY-MM-DD HH:mm";
                break;
                case '1 h':
                    format = "YYYY-MM-DD HH";
                break;
                case '1 d':
                    format = "YYYY-MM-DD";
                break;
                case '1 w':
                    format = "YYYY WW";
                break;
                case '1 M':
                    format = "YYYY-MM-01";
                break;
            }
            
            for (var i = 0; i < data.length; i++) {
                if (data[i].h == undefined) {
                    var h = moment(data[i].measurementDate).format("H");
                    var d = moment(data[i].measurementDate).format("d");
                    data[i].h = h;
                    data[i].da = d;
                }
                else {
                    h = data[i].h;
                    d = data[i].da;
                }
                var date = moment(data[i].measurementDate).format(format);
                if (zoom == "1 w") {
                    var t = parseInt(moment(moment(data[i].measurementDate).format("YYYY-01-01")).format("X")) +
                            (parseInt(moment(data[i].measurementDate).format("W")) * 7 * 24 * 60 * 60);
                }
                else {
                    var t = parseInt(moment(date).format("X"));
                }
                if (aggregated[date] == undefined) aggregated[date] = {d: 0, t: t};
                if (vm.filter[dir].schedule != undefined) {
                    if (vm.filter[dir].schedule.schedule[d][h] == 1) {
                        aggregated[date].d += parseFloat(data[i].value);
                    }
                }
                else {
                    aggregated[date].d += parseFloat(data[i].value);
                }
            }
            
            // Flatten
            var aggregated = Object.keys(aggregated).map(function (key) { return aggregated[key]; });
            
            return aggregated;
        }
        
        function accumulateData(data, zoom, dir) {
            
            var accumulated = {};
            var format = "";
            
            switch (zoom) {
                case '15 m':
                    format = "YYYY-MM-DD HH:mm";
                break;
                case '1 h':
                    format = "YYYY-MM-DD HH";
                break;
                case '1 d':
                    format = "YYYY-MM-DD";
                break;
                case '1 w':
                    format = "YYYY WW";
                break;
                case '1 M':
                    format = "YYYY-MM-01";
                break;
            }
            
            for (var i = 0; i < data.length; i++) {
                if (data[i].h == undefined) {
                    var h = moment(data[i].measurementDate).format("H");
                    var d = moment(data[i].measurementDate).format("d");
                    data[i].h = h;
                    data[i].da = d;
                }
                else {
                    h = data[i].h;
                    d = data[i].da;
                }
                var date = moment(data[i].measurementDate).format(format);
                if (zoom == "1 w") {
                    var t = parseInt(moment(moment(data[i].measurementDate).format("YYYY-01-01")).format("X")) +
                            (parseInt(moment(data[i].measurementDate).format("W")) * 7 * 24 * 60 * 60);
                }
                else {
                    var t = parseInt(moment(date).format("X"));
                }
                if (accumulated[date] == undefined) accumulated[date] = {d: 0, t: t};
                if (vm.filter[dir].schedule != undefined) {
                    if (vm.filter[dir].schedule.schedule[d][h] == 1) {
                        accumulated[date].d = parseFloat(data[i].value);
                    }
                }
                else {
                    accumulated[date].d = parseFloat(data[i].value);
                }
            }
            
            // Flatten
            var accumulated = Object.keys(accumulated).map(function (key) { return accumulated[key]; });
            
            // Fix gaps
            for (var j = 0; j < accumulated.length; j++) {
                if (accumulated[j].d <= 0) {
                    // Find closest non null value (go down)
                    var k = 1;
                    for (var k = 1; k <= j; k++) {
                        if (accumulated[j - k].d > 0) {
                            accumulated[j].d = accumulated[j - k].d;
                            break;
                        }
                    }
                    if (accumulated[j].d <= 0) {
                        // Find closest non null value (go up)
                        var k = 1;
                        for (var k = 1; k < accumulated.length; k++) {
                            if (accumulated[j + k].d > 0) {
                                accumulated[j].d = accumulated[j + k].d;
                                break;
                            }
                        }
                    }
                    else {
                        // All values are zero
                    }
                }
            }
            
            for (var j = accumulated.length - 1; j > 0; j--) {
                var foo = accumulated[j].d - accumulated[j-1].d;
                if (foo >= 0) {
                    accumulated[j].d = foo;
                }
            };
            accumulated.shift();
            
            return accumulated;
        }
        
        // Load data
        function loadData(node, dir) {
            var cNode = node.original;
            
            var cumulative = false;
            var foo = getMeasures(node);
            for (var j = 0; j < foo.length; j++) {
                if (foo[j].specs.cost == "true" && foo[j].specs.cumulative == "true") {
                    cumulative = true;
                    break;
                }
            }
            
            // Dates
            if (cumulative) {
                var parts = vm.chartZoom.split(" ");
                var from = subtractPeriod(vm.date[dir].startDate, parts[0], parts[1]);
            }
            else {
                var from = encodeURIComponent(moment(vm.date[dir].startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone);
            }
            var to = encodeURIComponent(moment(vm.date[dir].endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone);
            
            return pragmaapi.callRestService(PRAGMA.api, "/assignments/" + cNode.token + "/measurements/series",
                        "?startDate=" + from + "&endDate=" + to + "&page=1&pageSize=35040&tenantAuthToken=" + cNode.tenantAuthToken,
                        true, vm.user.authentication, "GET", true)
                .then(function(res) {
                    var period = vm.date[dir].startDate + "-" + vm.date[dir].endDate;
                    cache[period][cNode.token] = res.data;
                });
        }
        
        function subtractPeriod(date, resolution, resolutionType) {
            switch (resolutionType) {
                case 'm':
                    resolutionType = "minutes";
                break;
                case '1 h':
                    resolutionType = "hours";
                break;
                case '1 d':
                    resolutionType = "days";
                break;
                case '1 w':
                    resolutionType = "weeks";
                break;
                case '1 M':
                    resolutionType = "months";
                break;
            }
            return encodeURIComponent(moment(date).subtract(resolution, resolutionType).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone);
        }
        
        
        function findMeasures(nodes, dir) {
            measures[dir] = {};
            for (var i = 0; i < nodes.length; i++) {
                var foo = getMeasures(nodes[i]);
                for (var j = 0; j < foo.length; j++) {
                    if (foo[j].specs.cost == "true" && (foo[j].specs.aggregated == "true" || foo[j].specs.cumulative == "true")) {
                        measures[dir][nodes[i].original.token] = foo[j];
                    }
                }
            }
            return measures[dir];
        }
        
        function getMeasures(node) {
            var measures = [];
            for (var i = 0; i < vm.treeData.original.length; i++) {
                if (vm.treeData.original[i].parent == node.id) {
                    measures.push(vm.treeData.original[i]);
                }
            }
            return measures;
        }
        
        function measurementInCache(measurements, name) {
            var pos = -1;
            for (var i = 0; i < measurements.length; i++) {
                if (measurements[i].measurementId == name) {
                    pos = i;
                    break;
                }
            }
            return pos;
        }
        
        function getColors(index) {
            var color = palette['color' + (index + 1)];
            return {
                borderColor: "rgba(" + color + ",1)",
                backgroundColor: "rgba(" + color + ",0.6)",
            }
        }
        
        function removeRight() {
            
			if (vm.chart.data.length) {
                vm.stats = {left: {}, right: {}};
                vm.chart.data = [vm.chart.data[0]]
                vm.chart.series = [vm.chart.series[0]]
                vm.chart.colors = [vm.chart.colors[0]]
                vm.chart.override = [vm.chart.override[0]]
                vm.chart.labels = [];
                for (var i = 0; i < vm.chart.data[0].length; i++) {
                    vm.chart.labels.push("");
                }
				vm.data['right'] = {};
                updateStatus(pragmaapi.translate('COMPARE.PLEASE_SELECT_RIGHT'), false);
            }
        }
        
        function getStats() {
            for (i = 0; i <= 1; i++) {
                if (vm.chart.data[i].length) {
                    var total = 0; var avg = 0;
                    var totalavg = 0;
                    var min = Number.MAX_SAFE_INTEGER;
                    var max = -Number.MAX_SAFE_INTEGER;
                    
                    for (var j = 0; j < vm.chart.data[i].length; j++) {
                        var datasum = parseFloat(vm.data[(i == 0 ? "left" : "right")]["sum"][j]);
                        var dataavg = parseFloat(vm.data[(i == 0 ? "left" : "right")]["avg"][j]);
                        total += datasum;
                        totalavg += dataavg;
                        if (vm.chartMode[(i == 0 ? "left" : "right")] == "avg") {
                            if (dataavg < min) min = dataavg;
                            if (dataavg > max) max = dataavg;
                        }
                        else {
                            if (datasum < min) min = datasum;
                            if (datasum > max) max = datasum;
                        }
                    }
                    if (vm.data[(i == 0 ? "left" : "right")]["sum"].length > 0) {
                        if (vm.chartMode[(i == 0 ? "left" : "right")] == "avg") {
                            avg = totalavg / vm.data[(i == 0 ? "left" : "right")]["sum"].length;
                        }
                        else {
                            avg = total / vm.data[(i == 0 ? "left" : "right")]["sum"].length;
                        }
                    }
                    
                    vm.stats[(i == 0 ? "left" : "right")] = {
                        total: filterNumber(total),
                        avg: filterNumber(avg),
                        min: filterNumber(min),
                        max: filterNumber(max)
                    }
                }
            }
        }
        
        function filterNumber(number) {
            if (Math.abs(number) < 100) {
                return $filter('number')(number, 2);
            }
            else if (Math.abs(number) < 1000) {
                return $filter('number')(number, 1);
            }
            else {
                return $filter('number')(number, 0);
            }
        }
        
        var chartSmall = null;
        function drawZoomChart() {
            if (chartSmall != null) { chartSmall.destroy(); chartSmall = null; }
            var ctx = document.getElementById("chart-zoom-canvas");
            var datasets = [];
            vm.chart.data.forEach(function(data, i) { 
                var foo = {};
                angular.extend(foo, getColors('tavg', 99));
                angular.extend(foo, vm.chart.override[i]);
                if (vm.chart.override[i].type == "line") {
                    foo.borderWidth = 1;
                    foo.radius = 2;
                }
                foo.data = vm.chart.data[i];
                foo.label = vm.chart.series[i];
                datasets.push(foo);
            });
            var foo = angular.copy(vm.chart.options);
            foo.title = { display: false };
            foo.legend = { display: false };
            foo.scales.xAxes[0].gridLines = {display: false};
            foo.scales.yAxes[0].display = false;
            if (foo.scales.yAxes[1] != undefined) {
                foo.scales.yAxes[1].display = false;
            }
            foo.tooltips.enabled = false;
            foo.hover = {mode: null};
            foo.annotation = {};
            if (vm.temperature) {
                jQuery(".chart-aggregated-zoom").css("margin", "0 55px");
            }
            else {
                jQuery(".chart-aggregated-zoom").css("margin", "0 50px 0 60px");
            }
            chartSmall = new Chart(ctx, {
                type: "bar",
                data: { labels: vm.chart.labels.map(function(data, i) { return ""}), datasets : datasets },
                options: foo
            });
            jQuery(".chart-aggregated-zoom").css('display', 'block');
            var zoom = getZoomDimensions(jQuery('.zoom-left'));
            zoomIndexScale(zoom);
        }
        
        function removeZoomChart() {
            if (chartSmall != null) { chartSmall.destroy(); chartSmall = null; }
            jQuery(".chart-aggregated-zoom").css('display', 'none');
        }
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        function vizualizeData() {
        }
        
        
        
        
        vm.changeOptions = function changeOptions() {
            drawChart();
        }
        
        vm.selectMeasureType = function selectMeasureType() {
            drawChart();
        }
        
        vm.selectUnit = function selectUnit() {
            drawChart();
        }
        
        vm.selectCompensate = function selectCompensate(type, no_refresh) {
            if (type != '') {
                var pos = jQuery.inArray(type, vm.selectedCompensate);
                if (pos < 0) {
                    addToScaleLabel(type);
                    vm.selectedCompensate.push(type);
                }
                else {
                    removeFromScaleLabel(type);
                    vm.selectedCompensate.splice(pos, 1);
                }
            }
            else {
                for (var i = 0; i < vm.selectedCompensate.length; i++) {
                    removeFromScaleLabel(vm.selectedCompensate[i]);
                }
                vm.selectedCompensate = [];
            }
            
            if (vm.selectedCompensate.length) {
                jQuery(".compensate-button").removeClass('md-raised').addClass('active');
            }
            else {
                jQuery(".compensate-button").removeClass('active').addClass('md-raised');
            }
            
            if (!no_refresh) {
                if (vm.selectedCompensate.indexOf('degree-days') >= 0) {
                    visualizeData();
                }
                else {
                    drawChart();
                }
            }
        }
        
        vm.setMode = function setMode(mode, dir, no_refresh) {
            jQuery("#mode-ctrl-" + dir + " button").removeClass('md-accent');
            jQuery(".mode-" + dir + "-" + mode).addClass('md-accent');
            vm.chartMode[dir] = mode;
            if (!no_refresh) {
                // drawChart
                graphData(dir, true);
            }
        }
        
        vm.setKPI = function setKPI(KPI, no_refresh) {
            jQuery('#kpi-ctrl button').removeClass('md-accent');
            jQuery('.kpi-' + KPI).addClass('md-accent');
            vm.chartKPI = KPI;
            if (!no_refresh) {
                updateGraph();
            }
        }
        
        vm.setZoom = function setZoom(zoom, no_refresh) {
            jQuery('#zoom-ctrl button').removeClass('active');
            jQuery('.zoom-' + zoom.slice(-1)).addClass('active');
            vm.chartZoom = zoom;
            if (!no_refresh) {
                updateGraph();
            }
        }
		
        vm.lock = false;
        vm.buttonToggle = function buttonToggle(type, inverse) {
            vm[type] = (vm[type]) ? false : true;
			if (inverse) {
                if (vm[type]) {
                    jQuery("." + type + "-button").removeClass('active').addClass('md-raised');
					vm.buttonAction('to_right');
                }
                else {
                    jQuery("." + type + "-button").removeClass('md-raised').addClass('active');
                }
            }
            else {
                if (vm[type]) {
                    jQuery("." + type + "-button").removeClass('md-raised').addClass('active');
					vm.buttonAction('to_right');
                }
                else {
                    jQuery("." + type + "-button").removeClass('active').addClass('md-raised');
                }
            }
            //graphData(dir, true);
        }
        
		vm.buttonAction = function buttonAction(action) {
			if (action == 'to_left'){
				vm.date.left = vm.date.right;
				var drp = jQuery('#daterangeL').data('daterangepicker');
			}
			else {
				vm.date.right = vm.date.left;
				var drp = jQuery('#daterangeR').data('daterangepicker');
			}
			drp.clickApply();
		}
		
        function setOption(type, option, inverse) {
            vm[type] = option;
            if (inverse) {
                if (option) {
                    jQuery("." + type + "-button").removeClass('active').addClass('md-raised');
                }
                else {
                    jQuery("." + type + "-button").removeClass('md-raised').addClass('active');
                }
            }
            else {
                if (option) {
                    jQuery("." + type + "-button").removeClass('md-raised').addClass('active');
                }
                else {
                    jQuery("." + type + "-button").removeClass('active').addClass('md-raised');
                }
            }
        }
        
        function setChartType(chartType) {
            
            var should_update = false;
            
            if (vm.chartType == "functional") should_update = true;
            
            if (vm.chartType == "heatmap") {
                loadOptions(vm.graphOptionsCache);
                should_update = true
            }
            
            vm.chartType = chartType;
            jQuery(".chartType-button").removeClass('active').addClass('md-raised');
            jQuery("." + chartType + "-button").removeClass('md-raised').addClass('active');
            
            if (chartType == "heatmap") {
                // Load default graph
                vm.graphOptionsCache = getOptions();
                vm.loadGraph("default");
                should_update = false;
            }
            
            if (chartType == "functional" || should_update) {
                visualizeData();
            }
            else {
                drawChart();
            }
        }
        
        function updateGraph() {
			graphData("left", true);
            graphData("right", true);
        }
        
        function setOptions(dir) {
            vm.optionsData.dates = moment(vm.date.startDate).format("MMM D, YYYY") + " - " + moment(vm.date.endDate).format("MMM D, YYYY");
            vm.optionsData.chartType = ucfirst(vm.chartType) + " chart";
            vm.optionsData.temperature = (vm.temperature) ? "On" : "Off";
            vm.optionsData.compare = (vm.stacked) ? "Off" : "On";
            vm.optionsData.compensate = "";
            for (var i = 0; i < vm.compensates.length; i++) {
                if (vm.selectedCompensate.indexOf(vm.compensates[i].id) >= 0) {
                    vm.optionsData.compensate += vm.compensates[i].name + ", ";
                }
            }
            if (vm.optionsData.compensate == "") {
                vm.optionsData.compensate = "None";
            }
            else {
                vm.optionsData.compensate = vm.optionsData.compensate.substring(0, vm.optionsData.compensate.length - 2);
            }
            vm.optionsData.chartKPI = ucfirst(vm.chartKPI);
            switch (vm.chartZoom) {
                case "15 m": vm.optionsData.chartZoom = "15Min"; break;
                case "1 h": vm.optionsData.chartZoom =  "Hourly";  break;
                case "1 d": vm.optionsData.chartZoom =  "Day";   break;
                case "1 w": vm.optionsData.chartZoom =  "Week";  break;
                case "1 M": vm.optionsData.chartZoom =  "Month"; break;
            }
        }
		
		/*
		vm.exportCSV = exportCSV;
        function exportCSV() {
		  if (vm.details.data != null) {
              var csvContent = "data:text/csv;charset=utf-8,";
              // Header
              for(var k=0;k<Object.keys(vm.details.data[0]).length;k++)
              {
                  var label = '';
                  if (Object.keys(vm.details.data[0])[k] == 'x') {
                      label = 'timestamp';
                  }
                  else {
                    label = Object.keys(vm.details.data[0])[k];
                  }
                  csvContent+='"'+label+'"'+";";
              }
              csvContent=csvContent.slice(0, -1);
              csvContent+="\n";
              for(var i=0;i<vm.details.data.length;i++)
              {
                for(var k=0;k<Object.keys(vm.details.data[i]).length;k++)
                {
                  //csvContent+=Object.keys(vm.details.data[i])[k]+",";
                  csvContent+='"'+vm.details.data[i][Object.keys(vm.details.data[i])[k]]+'"'+";";
                }
                csvContent=csvContent.slice(0, -1);
                csvContent+="\n";
              }
			  var encodedUri = encodeURI(csvContent);
              var link = document.createElement("a");
			  link.setAttribute("href", encodedUri);
              link.setAttribute("download", "raw_data.csv");
              document.body.appendChild(link); // Required for FF
              link.click();
          }
        }
		*/
		
		vm.saveImage = saveImage;
        function saveImage(element) {
		  var url_base64 = document.getElementById(element).toDataURL('image/png');
          var link = document.createElement("a");
		  link.setAttribute("href", url_base64);
          link.setAttribute("download", "compare.png");
          document.body.appendChild(link); // Required for FF
		  link.click();
        }
        
        function ucwords(str) {
            str = str.replace(/_/g, ' ');
            return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        }        
        
        function ucfirst(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
        
        function pad(n, width, z) {
          z = z || '0';
          n = n + '';
          return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        
        function updateStatus(msg, spin) {
            if (spin == undefined) spin = false;
            jQuery(".status").html('<span class="msg-spinner' + (spin ? '' : ' static') + '"></span> &nbsp; ' + msg);
        }
        
        //////////
        
        vm.openFilters = function (dir)
        {
            $mdDialog.show({
                controller         : 'CompareFilterController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/compare/dialogs/compare-filter.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
                locals             : {
                    user: vm.user,
                    filter: vm.filter[dir]
                }
            }).then(function (res) {
                vm.filter[dir] = res;
                // drawChart
                updateStatus(pragmaapi.translate('COMPARE.PREPARING_DATA'), true);
                $timeout(function() { drawChart(dir) }, 150);
            },function () {});
        }
        
        vm.resetFilters = function (dir)
        {
            vm.filter[dir] = {};
            // drawChart
            updateStatus(pragmaapi.translate('COMPARE.PREPARING_DATA'), true);
            $timeout(function() { drawChart(dir) }, 150);
        }
        
        vm.saveGraph = function (ev) {
            $mdDialog.show({
                controller         : 'SaveGraphController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/breakdown/dialogs/saveGraph/save-graph.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    chartType      : vm.chartType,
                    savedGraph     : vm.savedGraph,
                    savedGraphs    : vm.savedGraphs
                }
            }).then(function(res) {
            },function () {});
        }

        vm.deleteGraph = function openDeleteGraphDialog(ev, event) {
            $mdDialog.show({
                controller         : 'DeleteGraphController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/breakdown/dialogs/deleteGraph/delete-graph.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    audit: event
                }
            }).then(function (res) {
                
            },function () {});
        }
        
    }
        
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login')
        .controller('ChangePassController', ChangePassController)
		.filter('isEmpty', [function() {
			return function(object) {
				return angular.equals({}, object);
			}
		}]);

    /** @ngInject */
    function ChangePassController($state, $scope, $stateParams, session, PRAGMA, pragmaapi, $translate, $cookies, Notification, $filter, $timeout)
    {
        var vm = this;
		
		vm.submit = submit;
		vm.checkPass = checkPass;
		vm.changePassClass = 'changePass_auth';
		var $login_state = "";
		
		if (PRAGMA.loginPage === "/landing" ) {
			$login_state = "app.landing";
			vm.changePassClass = 'changePass_landing';
		}
		else {
			$login_state = "app.auth_login";
			vm.changePassClass = 'changePass_auth';
		}
		
		if ($stateParams.token === '') {
			$state.go($login_state);
			return;
		}
		else {
            //for now use admin credentials hardcoded to call the user
			vm.authentication ="admin:password";
            pragmaapi.callRestService(PRAGMA.api, "/users/", "", true, vm.authentication, "GET").then(function(res) {
                vm.users = res.data.results;
				vm.user = findObjectByToken(vm.users, $stateParams.token);
				if (vm.user == null) {
					$state.go($login_state);

				}
				else {
					var today = moment().format('YYYY-MM-DDTHH:mm:ss.000ZZ');
					if (today > vm.user.metadata.forgot_expires) {
						showNotification($translate.instant("LOGIN.USER_AUTHENTICATION"), $translate.instant("LOGIN.TOKEN_EXPIRED"), "Error");
						$timeout(function() { $state.go($login_state); }, 5000);
					}
				}

            });

			
		}
		
		function submit(master) {
			if ($stateParams.token != '') {
				
				if (master.userData.password != master.userData.confirm_password) {
					showNotification($translate.instant("LOGIN.USER_AUTHENTICATION"), $translate.instant("LOGIN.ERRORS.PASSWORD_NOT_MATCH"), "Error");
					return;
				}
				else {
					var response={};
					response.username=vm.user.username;
					response.password=master.userData.password;
					response.firstName=vm.user.firstName;
					response.lastName=vm.user.lastName;
					response.status=vm.user.status;
					response.metadata={};
					response.metadata.email= vm.user.metadata.email;
					response.metadata.role=vm.user.metadata.role;
					response.metadata.imageUrl=vm.user.metadata.imageUrl;
					if(vm.user.metadata.phone!="")
						response.metadata.phone= vm.user.metadata.phone;
					response.authorities=vm.user.authorities;
					
					pragmaapi.callRestService(PRAGMA.api,"/users/"+response.username,response,true,vm.authentication,"PUT", true, false).then(function(res){
						showNotification($translate.instant("LOGIN.USER_AUTHENTICATION"), $translate.instant("LOGIN.SUCCESS_CHANGE"), "Success");
						$timeout(function() { $state.go($login_state); }, 5000);
					});
				}
			}
		}
		
		function findObjectByToken(array, token) {
			for (var i = 0; i < array.length; i++) {
				if (array[i].metadata.forgot_token === token) {
					return array[i];
				}
			}
			return null;
		}
		
		function checkPass(pass, confirm_pass) {
			if (pass != confirm_pass) {
				vm.cPass = "not_match";
			}
			else {
				vm.cPass = "match";
			}
		}
		
        function showNotification(title, message, type) {
            if (type === "Error") {
                Notification.error({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Info") {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Warning") {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if (type === "Success") {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }   
        }
		
    };

})();
(function ()
{
    'use strict';

    angular
        .module('app.breakdown')
        .controller('BreakdownController', BreakdownController);

    function BreakdownController($q, $scope, $element, $http, $filter, $cookies, $timeout, $mdSidenav, msApi, session, $rootScope, $mdDialog, $document, $base64, Notification, filterFilter, dateFilter, PRAGMA, pragmaapi, pragmaTheming)
    {
        
        var vm = this;
		
        pragmaapi.loadCostProfiles();
        
        // Timezone
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        
		// Theming
		vm.themes = pragmaTheming.themes;
		
        // User
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        
        
		// Schedules
        
        var dOfWeek = [];
        var currentLocaleData = moment.localeData();
        var firstDayOfWeek = currentLocaleData.firstDayOfWeek();
        for (var i = firstDayOfWeek; i < 7; i++) {
            dOfWeek.push(i);
        }
        for (var i = 0; i < firstDayOfWeek; i++) {
            dOfWeek.push(i);
        }
        
        vm.scheduleChanged = false;
        vm.schedule = {days: [], times: [], schedule: []};
        vm.schedule.days = Array.apply(null, Array(7)).map(function (_, i) {return moment(i, 'e').format('dddd');});
        for (var i = 0; i < 24; i++) {
            vm.schedule.times.push(pad(i, 2) + ":00");
        }
        vm.schedule.is_disabled = pragmaapi.translate("BREAKDOWN.NO_SITES_SCHEDULE");
        resetSchedule(0);
        
        var isMouseDown = false, isHighlighted;
        jQuery('body')
            .off("mousedown", ".schedulePicker td")
            .on("mousedown", ".schedulePicker td", function(e) {
                isMouseDown = true;
                vm.scheduleChanged = true;
                jQuery(this).toggleClass("highlighted");
                isHighlighted = jQuery(this).hasClass("highlighted");
                $scope.$apply();
                return false; // prevent text selection
            })
            .off("mouseover", ".schedulePicker td")
            .on("mouseover", ".schedulePicker td", function (e) {
                if (isMouseDown) {
                    jQuery(this).toggleClass("highlighted", isHighlighted);
                }
            })
            .off("selectstart", ".schedulePicker td")
            .on("selectstart", ".schedulePicker td", function () {
                return false;
            });
        
        pragmaapi.loadUserData("schedules").then(function(schedules) { vm.schedules = schedules; });
        
        vm.applySchedule = function () {
            if (vm.selectedSites.length == 1) { // Schedule can be changed when only one site is selected
                jQuery(".schedulePicker td").each(function () {
                    vm.schedule.schedule[jQuery(this).data("i")][jQuery(this).data("j")] = jQuery(this).hasClass("highlighted") ? 1 : 0;
                });
                saveSchedule(vm.schedule.schedule, vm.selectedSites[0].token);
            }
        }
        
        function saveSchedule(schedule, site) {
            if (vm.schedules != undefined) {
                var nschedule = [];
                for (var i = 0; i < 7; i++) {
                    nschedule[dOfWeek[i]] = [];
                    for (var j = 0; j < 24; j++) {
                        nschedule[dOfWeek[i]][j] = schedule[i][j];
                    }
                }
                vm.schedules[site] = nschedule;
                pragmaapi.saveUserData("schedules", vm.schedules);
                visualizeData();
            }
        }
        
        function loadSchedule(sites) {
            var multiple = (sites.length > 1);
            var nschedule = [];
            for (var i = 0; i < sites.length; i++) {
                if (vm.schedules[sites[i].token] != undefined) {
                    var schedule = vm.schedules[sites[i].token];
                }
                else {
                    var schedule = getSchedule(1);
                }
                for (var j = 0; j < 7; j++) {
                    if (nschedule[j] == undefined) nschedule[j] = [];
                    for (var k = 0; k < 24; k++) {
                        if (multiple) {
                            if (nschedule[j][k] != undefined) {
                                if (nschedule[j][k] == 0) {
                                    if (schedule[dOfWeek[j]][k] == 1) {
                                        nschedule[j][k] = -1;
                                    }
                                }
                                else if (nschedule[j][k] == 1) {
                                    if (schedule[dOfWeek[j]][k] == 0) {
                                        nschedule[j][k] = -1;
                                    }
                                }
                            }
                            else {
                                nschedule[j][k] = schedule[dOfWeek[j]][k];
                            }
                        }
                        else {
                            nschedule[j][k] = schedule[dOfWeek[j]][k];
                        }
                    }
                }
            }
            vm.schedule.is_disabled = multiple ? pragmaapi.translate("BREAKDOWN.MULTIPLE_SITES_SCHEDULE") : "";
            vm.schedule.schedule = nschedule;
            $timeout(function() { redrawSchedule(); }, 50);
        }
        
        function resetSchedule(val) {
            vm.scheduleChanged = false;
            vm.schedule.schedule = getSchedule(val);
            redrawSchedule();
        }
        
        function redrawSchedule() {
            jQuery(".schedulePicker td").removeClass("highlighted").removeClass("semi-highlighted");
            jQuery(".schedulePicker td").each(function () {
                if (vm.schedule.schedule[jQuery(this).data("i")][jQuery(this).data("j")] == 1) {
                    jQuery(this).addClass("highlighted");
                }
                else if (vm.schedule.schedule[jQuery(this).data("i")][jQuery(this).data("j")] == -1) {
                    jQuery(this).addClass("semi-highlighted");
                }
            });
        }
        
        function getSchedule(val) {
            var schedule = []
            for (var i = firstDayOfWeek; i < 7; i++) {
                schedule[i] = [];
                for (var j = 0; j < 24; j++) {
                    schedule[i][j] = val;
                }
            }
            for (var i = 0; i < firstDayOfWeek; i++) {
                schedule[i] = [];
                for (var j = 0; j < 24; j++) {
                    schedule[i][j] = val;
                }
            }
            return schedule;
        }
        
        // Notifications
        vm.notifications = [];
        
        // Left sidebar
        vm.lockLeft = true;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleClose = toggleClose;
        vm.changeStatusL = changeStatusL;
        
        // Compensate
        vm.selectedCompensate = [];
        vm.selectCompensate = selectCompensate;
        vm.compensates = [
            { id: 'area', translation: 'BREAKDOWN.FLOOR_AREA', name: 'Floor area (m2)', label: ' / m2'},
            { id: 'volume', translation: 'BREAKDOWN.BUILDING_VOLUME', name: 'Building volume (m3)', label: ' / m3' },
            { id: 'degree-days', translation: 'BREAKDOWN.DEGREE_DAYS', name: 'Degree days (°C)', label: ' / °C' }
        ];
        
        
        // Saved graphs
        
        var select_graph = pragmaapi.translate("BREAKDOWN.SELECT_GRAPH")
        
        vm.savedGraph = {
            bar         : "none",
            line        : "none",
            pie         : "none",
            heatmap     : "none",
            functional  : "none",
        };
        
        vm.savedGraphs = {
            bar         : [{
                id: "none",
                name: select_graph,
                is_default: true
            }],
            line        : [{
                id: "none",
                name: select_graph,
                is_default: true
            }],
            pie         : [{
                id: "none",
                name: select_graph,
                is_default: true
            }],
            heatmap     : [
                {   id: "none",
                    name: select_graph,
                    is_default: true },
                {   id: "default",
                    name: pragmaapi.translate("BREAKDOWN.GRAPH_DEFAULT"),
                    is_default: true,
                    is_datasource: false,
                    is_period: true,
                    period: {
                        last: {
                            from: "auto"
                        }
                    },
                    options: {
                        chartKPI : "cost",
                        chartZoom : '1 h',
                        stacked: true,
                        temperature: false,
                        selectedCompensate : [],
                        selectedMeasureType : "all",
                        selectedUnit : "kg",
                        heatmap: {
                            Levels : 4,
                            Radius : 10,
                            RadiusLocked : true,
                            PointStyle : "rect",
                            Color : "spectrum",
                            Distribution : "linear"
                        }
                    }},
                {   id: "bubbles",
                    name: pragmaapi.translate("BREAKDOWN.GRAPH_BUBBLES"),
                    is_default: true,
                    is_datasource: false,
                    is_period: true,
                    period: {
                        last: {
                            from: "auto"
                        }
                    },
                    options: {
                        chartKPI : "cost",
                        chartZoom : '1 h',
                        stacked: true,
                        temperature: false,
                        selectedCompensate : [],
                        selectedMeasureType : "all",
                        selectedUnit : "kg",
                        heatmap: {
                            Levels : 4,
                            Radius : 15,
                            RadiusLocked : false,
                            PointStyle : "circle",
                            Color : "spectrum",
                            Distribution : "linear"
                        }
                    }},
                {   id: "burlington",
                    name: "Burlington",
                    is_default: true,
                    is_datasource: false,
                    is_period: true,
                    period: {
                        last: {
                            from: "auto"
                        }
                    },
                    options: {
                        chartKPI : "cost",
                        chartZoom : '1 h',
                        stacked: true,
                        temperature: false,
                        selectedCompensate : [],
                        selectedMeasureType : "all",
                        selectedUnit : "kg",
                        heatmap: {
                            Levels : 4,
                            Radius : 10,
                            RadiusLocked : true,
                            PointStyle : "rectRot",
                            Color : "spectrum",
                            Distribution : "linear"
                        }
                    }},
                {   id: "embroidery",
                    name: pragmaapi.translate("BREAKDOWN.GRAPH_EMBROIDERY"),
                    is_default: true,
                    is_datasource: false,
                    is_period: true,
                    period: {
                        last: {
                            from: "auto"
                        }
                    },
                    options: {
                        chartKPI : "cost",
                        chartZoom : '1 h',
                        stacked: true,
                        temperature: false,
                        selectedCompensate : [],
                        selectedMeasureType : "all",
                        selectedUnit : "kg",
                        heatmap: {
                            Levels : 4,
                            Radius : 10,
                            RadiusLocked : true,
                            PointStyle : "crossRot",
                            Color : "spectrum",
                            Distribution : "linear"
                        }
                    }},
            ],
            functional  : [{
                id: "none",
                name: select_graph,
                is_default: true
            }]
        }
        
        pragmaapi.loadUserData("savedGraphs").then(function(userSavedGraphs) {
            vm.savedGraphs = mergeSavedGraphs(vm.savedGraphs, userSavedGraphs);
        });
        
        function mergeSavedGraphs(arr1, arr2) {
            for (var chartType in arr1) {
                if (arr2[chartType] != undefined) {
                    for (var i = 0; i < arr1[chartType].length; i++) {
                        var graph = inGraphs(arr1[chartType][i], arr2, chartType);
                        if (graph != null) {
                            // Overwrite
                            arr1[chartType][i] = graph;
                        }
                    }
                }
            }
            for (var chartType in arr2) {
                if (arr2[chartType] != undefined) {
                    for (var i = 0; i < arr2[chartType].length; i++) {
                        var graph = inGraphs(arr2[chartType][i], arr1, chartType);
                        if (graph == null) {
                            // Add
                            arr1[chartType].push(graph);
                        }
                    }
                }
            }
            return arr1;
        }
        
        vm.isDefault = function (id) {
            var graph = inGraphs(id, vm.savedGraphs, vm.chartType);
            if (graph != null) {
                return graph.is_default;
            }
            return true;
        }
        
        vm.loadGraph = function (id) {
            var graph = inGraphs(id, vm.savedGraphs, vm.chartType);
            if (graph != null) {
                vm.savedGraph[vm.chartType] = graph.id;
                if (graph.is_period)
                    loadPeriod(graph.period, graph.options);
                
                if (graph.is_datasource)
                    loadDatasource(graph.datasource);
                
                loadOptions(graph.options);
                
                visualizeData();
            }
        }
        
        function loadPeriod(period, options) {
            if (period != undefined) {
                if (period.last != undefined) {
                    if (period.last.from) {
                        if (period.last.from == "auto") {
                            if (options != undefined) {
                                var width = jQuery("#chart-aggregated-canvas").width() - 96; // -96 remove axis space
                                if (options.heatmap != undefined && options.heatmap.Radius != undefined) {
                                    // Heatmap
                                    var days = width / (2 * (options.heatmap.Radius - 2)); // -2 remove item border
                                    vm.date.startDate = moment().subtract(days, "days");
                                }
                            }
                        }
                        else {
                            var parts = period.last.from.split(" ");
                            vm.date.startDate = moment().subtract(parts[0], parts[1])
                        }
                    }
                    if (period.last.to) {
                        var parts = period.last.from.split(" ");
                        vm.date.endDate = moment().subtract(parts[0], parts[1])
                    }
                    else {
                        vm.date.endDate = moment(); // now
                    }
                }
                else {
                    vm.date.startDate = period.startDate;
                    vm.date.endDate = period.endDate;
                }
                updateDaterange(vm.date.startDate, vm.date.endDate);
            }
        }
        
        function loadDatasource(datasource) {
        }
        
        function loadOptions(options) {
            if (options != undefined) {
                // KPI
                if (options.chartKPI != undefined)
                    setKPI(options.chartKPI, true);
                // Zoom
                if (options.chartZoom != undefined)
                    setZoom(options.chartZoom, true);
                // Stacked
                if (options.stacked != undefined)
                    setOption("stacked", options.stacked, true);
                // Temperature
                if (options.temperature != undefined)
                    setOption("temperature", options.temperature);
                // Measure type
                if (options.selectedMeasureType != undefined)
                    vm["selectedMeasureType"] = options.selectedMeasureType;
                // Unit
                if (options.selectedUnit != undefined)
                    vm["selectedUnit"] = options.selectedUnit;
                // Compensates
                if (options.selectedCompensate != undefined) {
                    // Unselect all
                    selectCompensate("", true);
                    if (options.selectedCompensate.length) {
                        for (var i = 0; options.selectedCompensate.length; i++) {
                            selectCompensate(options.selectedCompensate[i], true);
                        }
                    }
                }
                // Heatmap
                if (options.heatmap != undefined) {
                    for (var option in options.heatmap) {
                        vm["heatmap" + option] = options.heatmap[option];
                    }
                }
                // Period
                if (options.period != undefined) {
                    loadPeriod(options.period);
                }
            }
        }
        
        function getOptions() {
            return angular.copy({
                        period              : vm.date,
                        chartKPI            : vm.chartKPI,
                        chartZoom           : vm.chartZoom,
                        stacked             : vm.stacked,
                        temperature         : vm.temperature,
                        selectedCompensate  : vm.selectedCompensate,
                        selectedMeasureType : vm.selectedMeasureType,
                        selectedUnit        : vm.selectedUnit,
                        heatmap             : {
                            Levels       : vm.heatmapLevels,
                            Radius       : vm.heatmapRadius,
                            RadiusLocked : vm.heatmapRadiusLocked,
                            PointStyle   : vm.heatmapPointStyle,
                            Color        : vm.heatmapColor,
                            Distribution : vm.heatmapDistribution
                        }
                    });
        }
        
        function inGraphs(id, graphs, type) {
            if (graphs[type] != undefined) {
                for (var i = 0; i < graphs[type].length; i++) {
                    if (graphs[type][i].id == id) {
                        return graphs[type][i];
                    }
                }
            }
            return null;
        }
        
        // Chart
        var chartTmp = {
          colors: [],
          series: [],
          override: [],
          labels: [],
          data: []
        };
        vm.chartTitle = "";
        vm.chartLegend = "";
        vm.chartScaleLabel = "";
        vm.chartKPI = "cost";
        vm.chartType = "bar";
        vm.chartZoom = '1 d';
        vm.chartUnits = [];
        vm.chartUnitsShown = [];
        vm.stacked = true;
        vm.temperature = false;
        
        // Heatmap
        vm.heatmapLevels = 4;
        vm.heatmapRadiusLocked = false;
        vm.heatmapRadius = 20;
        vm.heatmapPointStyle = "circle"
        vm.heatmapPointStyles = [
            { id: 'circle', translation: 'BREAKDOWN.POINT_CIRCLE', name: 'Circle'},
            { id: 'rect', translation: 'BREAKDOWN.POINT_RECTANGLE', name: 'Rectangle'},
            { id: 'rectRot', translation: 'BREAKDOWN.POINT_RHOMBUS', name: 'Rhombus'},
            { id: 'crossRot', translation: 'BREAKDOWN.POINT_X', name: 'X'},
            { id: 'star', translation: 'BREAKDOWN.POINT_STAR', name: 'Star'},
            { id: 'triangle', translation: 'BREAKDOWN.POINT_TRIANGLE', name: 'Triangle'}
        ];
        vm.heatmapColor = 'spectrum';
        vm.heatmapColors = [
            { id: 'spectrum', translation: 'BREAKDOWN.COLOR_SPECTRUM', name: 'Spectrum', css: "background: #99ff00; background: -moz-linear-gradient(-45deg, #99ff00 0%, #ff0000 100%); background: -webkit-linear-gradient(-45deg, #99ff00 0%,#ff0000 100%); background: linear-gradient(135deg, #99ff00 0%,#ff0000 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#99ff00', endColorstr='#ff0000',GradientType=1);"},
            { id: 'red', translation: 'BREAKDOWN.COLOR_RED', name: 'Red', css: 'background: #f44'},
            { id: 'green', translation: 'BREAKDOWN.COLOR_GREEN', name: 'Green', css: 'background: #4a4'},
            { id: 'blue', translation: 'BREAKDOWN.COLOR_BLUE', name: 'Blue', css: 'background: #4af'}
        ];
        vm.heatmapDistribution = 'linear';
        vm.heatmapDistributions = [
            { id: 'linear', translation: 'BREAKDOWN.DISTRIBUTION_LINEAR', name: 'Linear'},
            { id: 'uniform', translation: 'BREAKDOWN.DISTRIBUTION_UNIFORM', name: 'Uniform'},
            //{ id: 'normal', translation: 'BREAKDOWN.DISTRIBUTION_NORMAL', name: 'Normal'}
        ];
        vm.changeOptions = changeOptions;
        resetChart();
        
        var maxNumberOfPoints = 300;
		
        var chartObj;
        $scope.$on('chart-create', function (evt, chart) {
            chartObj = chart;
            //vm.chartLegend = chartObj.generateLegend();
        });
        
        // Details & Options
        vm.optionsData = {};
        vm.detailsData = [];
        vm.tableOptions = {
            order: 'site',
            limit: 10,
            page: 1,
            limitOptions : [5, 10, 15, {
                label: 'All',
                value: function () {
                    return vm.detailsData.length ? vm.detailsData.length : 0;
                }
            }]
        }
        
        var resizeId;
        $(window).resize(function() {
            clearTimeout(resizeId);
            resizeId = setTimeout(setLegendPosition, 100);
        });
        
        function setLegendPosition() {
            if ($(window).width() < 600) {
                vm.chart.options.legend.position = 'top';
            }
            else {
                vm.chart.options.legend.position = 'top';
            }
        }
        
        // Color palette
        var palette = {
            total: "75,193,247",
            electricity: "255,152,0",
            water: "36,112,172",
            gas: "244,67,54",
            weight: "3,169,244",
            electricity_excess: "76,175,80",
            recycle_aluminium: "88,17,126",
            Glass: "3,169,244",
            recycle_paper: "30,74,158",
            recycle_plastic: "231,197,19",
            color1: "3,169,244",
            color2: "146,39,143",
            color3: "170,198,6",
            color4: "242,135,6",
            color5: "0,191,118",
            color6: "102,45,145",
            color7: "236,0,140",
            color8: "0,148,68",
            color9: "249,237,50",
            color10: "239,65,54",
            color100: "201,201,208"
        };
        
        // Measure types
        vm.selectMeasureType = selectMeasureType;
        vm.selectedMeasureType = 'all';
        vm.measureTypes = [];

        // Units
        vm.selectUnit = selectUnit;
        vm.selectedUnit = 'kwh';
        vm.units = [];

        // Date Range
        vm.date = {
          startDate: moment().startOf('month'),
          endDate: moment()
        };
        function translateDateRange() {
            var ranges = {}
            ranges[$filter('translate')("DATERANGE.LAST_7_DAYS")] = [moment().subtract(6, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.LAST_30_DAYS")] = [moment().subtract(29, 'days'), moment()];
            ranges[$filter('translate')("DATERANGE.THIS_MONTH")] = [moment().startOf('month'), moment()]
            ranges[$filter('translate')("DATERANGE.LAST_MONTH")] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
            ranges[$filter('translate')("DATERANGE.THIS_YEAR")] = [moment().startOf('year'), moment()];
            
            vm.dateOptions = {
                applyClass: 'md-button md-raised',
                alwaysShowCalendars: true,
                locale: {
                    applyLabel: $filter('translate')("DATERANGE.APPLY"),
                    fromLabel: $filter('translate')("DATERANGE.FROM"),
                    format: "ll",
                    toLabel: $filter('translate')("DATERANGE.TO"),
                    cancelLabel: $filter('translate')("DATERANGE.CANCEL"),
                    customRangeLabel: $filter('translate')("DATERANGE.CUSTOM_RANGE"),
                    daysOfWeek: [
                        $filter('translate')("DATERANGE.SU"),
                        $filter('translate')("DATERANGE.MO"),
                        $filter('translate')("DATERANGE.TU"),
                        $filter('translate')("DATERANGE.WE"),
                        $filter('translate')("DATERANGE.TH"),
                        $filter('translate')("DATERANGE.FR"),
                        $filter('translate')("DATERANGE.SA")
                    ],
                    monthNames: [
                        $filter('translate')("DATERANGE.JANUARY"),
                        $filter('translate')("DATERANGE.FEBRUARY"),
                        $filter('translate')("DATERANGE.MARCH"),
                        $filter('translate')("DATERANGE.APRIL"),
                        $filter('translate')("DATERANGE.MAY"),
                        $filter('translate')("DATERANGE.JUNE"),
                        $filter('translate')("DATERANGE.JULY"),
                        $filter('translate')("DATERANGE.AUGUST"),
                        $filter('translate')("DATERANGE.SEPTEMBER"),
                        $filter('translate')("DATERANGE.OCTOBER"),
                        $filter('translate')("DATERANGE.NOVEMBER"),
                        $filter('translate')("DATERANGE.DECEMBER")
                    ],
                },
                ranges: ranges,
                eventHandlers: {
                    'apply.daterangepicker': visualizeData
                }
            }
        }
        translateDateRange();
        
        $rootScope.$on('$translateChangeSuccess', function () {
            translateDateRange();
        });
        
        jQuery('body').on('click', '.daterangepicker .month', function() {
            var lang = $cookies.get('lang');
            if (lang != undefined) {
                var drp = jQuery('#daterange').data('daterangepicker');
                var momentDate = moment('1 ' + jQuery(this).text(), "D MMM YYYY", lang);
                drp.setStartDate(momentDate.startOf('month'));
                drp.setEndDate(momentDate.endOf('month'));
                drp.clickApply();
            }
        })
        
        function updateDaterange(startDate, endDate) {
            var lang = $cookies.get('lang');
            if (lang != undefined) {
                var drp = jQuery('#daterange').data('daterangepicker');
                drp.setStartDate(startDate);
                drp.setEndDate(endDate);
                var input = jQuery('#daterange');
                input.val(moment(startDate).format("D MMM YYYY", lang) + " - " + moment(endDate).format("D MMM YYYY", lang));
            }
        }
        
        setOptions();
        
        var $dragging = null;
        var $offset = 0, $left = 0, $right = 0;
        jQuery('body')
            .off("mousemove")
            .on("mousemove", function(e) {
                if ($dragging) {
                    var $zc = $dragging.parent();
                    var zoom = getZoomDimensions($dragging);
                    var left = e.pageX - $offset;
                    var right = zoom.ch_l + zoom.ch_w;
                    if ($dragging.hasClass('zoom-box')) {
                        if (left > zoom.ch_l - zoom.zl_w / 2 && left < right - zoom.zc_w + zoom.zr_w / 2) {
                            $zc.offset({ left: left });
                        }
                    }
                    else if ($dragging.hasClass('zoom-left')) {
                        if (left > zoom.ch_l - zoom.zl_w / 2 && left < zoom.zr_l - zoom.zl_w / 2 - zoom.zr_w / 2) {
                            $zc.offset({ left: left }).outerWidth($right - left);
                        }
                    }
                    else if ($dragging.hasClass('zoom-right')) {
                        var width = ($right - $left);
                        if (left + width > $left + zoom.zl_w + zoom.zr_w && left + width < right + zoom.zr_w / 2) {
                            $zc.outerWidth(width - ($left - left));
                        }
                    }
                    zoomIndexScale(zoom);
                }
            })
            .off("mousedown", ".zoom-ctrl")
            .on("mousedown", ".zoom-ctrl", function (e) {
                $dragging = jQuery(e.target);
                var $zc = $dragging.parent();
                $left = $zc.offset().left;
                $right = $left + $zc.outerWidth();
                $offset = e.pageX - $left;
            })
            .off("mouseup")
            .on("mouseup", function (e) {
                isMouseDown = false; // Required by schedule
                if ($dragging) {
                    var zoom = getZoomDimensions($dragging);
                    zoomIndexScale(zoom);
                    $dragging = null;
                }
            })
            .off("mouseleave")
            .on("mouseleave", function (e) {
                if ($dragging) {
                    var zoom = getZoomDimensions($dragging);
                    zoomIndexScale(zoom);
                    $dragging = null;
                }
            })
            .off("click", ".zoom-ctrl")
            .on("click", ".zoom-ctrl", function (e) {
                $dragging = null;
            })
            .off("dblclick", ".zoom-ctrl")
            .on("dblclick", ".zoom-ctrl", function (e) {
                $dragging = jQuery(e.target);
                var $zc = $dragging.parent();
                var zoom = getZoomDimensions($dragging);
                $zc.offset({ left: zoom.ch_l - (zoom.zl_w / 2) }).outerWidth(zoom.ch_w + zoom.zr_w);
                zoomReset(zoom);
                $dragging = null;
            });
        
        function zoomIndexScale(zoom) {
          var ratio = zoom.zb_w / zoom.ch_w;
          var center = zoom.zb_l - zoom.ch_l + zoom.zb_w / 2;
          var width = zoom.ch_w;
          for (var prop in chartAggregated.scales) {
              var scale = chartAggregated.scales[prop];
              if (scale.isHorizontal()) {
                  var labels = scale.chart.data.labels;
                  var minIndex = 0, maxIndex = 0;
                  
                  var centerpoint = parseInt(center / width * labels.length);
                  var bounds = parseInt(labels.length * ratio / 2);
                  
                  minIndex = centerpoint - bounds;
                  maxIndex = centerpoint + bounds;
                  scale.options.ticks.min = labels[minIndex];
                  scale.options.ticks.max = labels[maxIndex];
              }
          }
          chartAggregated.update(0);
        }

        function zoomReset(zoom) {
          for (var prop in chartAggregated.scales) {
              var scale = chartAggregated.scales[prop];
              if (scale.isHorizontal()) {
                  var labels = scale.chart.data.labels;
                  var minIndex = 0, maxIndex = labels.length;
                  
                  scale.options.ticks.min = labels[minIndex];
                  scale.options.ticks.max = labels[maxIndex];
              }
          }
          chartAggregated.update(0);
        }

        function getZoomDimensions($dragging) {
            var zoom = {};
            
            var $zc = $dragging.parent();
            var $zl = $zc.find('.zoom-left');
            var $zb = $zc.find('.zoom-box');
            var $zr = $zc.find('.zoom-right');
            
            zoom.zc_w = $zc.outerWidth();
            zoom.zb_l = $zb.offset().left;
            zoom.zb_w = $zb.outerWidth();
            zoom.zl_l = $zl.offset().left;
            zoom.zl_w = $zl.outerWidth();
            zoom.zr_l = $zr.offset().left;
            zoom.zr_w = $zr.outerWidth();
            
            zoom.ch_l = $zc.parent().offset().left;
            zoom.ch_w = $zc.parent().outerWidth();
            return zoom;
        }
        vm.currentModule=vm.user.currentModule;
        vm.parentModule=vm.user.parentModule;
        if(vm.currentModule==='' || vm.parentModule==='#')
        {
            vm.filter={
                device:{},
                site:{},
                specification:{},
                includeDevices:true,
                includeMeasurements:false,
                specs:[],
                measurements:{}
            };
        }
        else
        {
            vm.filter={
                device:[{modules:[vm.currentModule]}],
                site:{},
                specification:{},
                includeDevices:true,
                includeMeasurements:false,
                specs:[],
                measurements:{}
            };
        }
        $scope.$on('change.module', function(event, args) {
            vm.showTree=false;
            if(args.parent==='#')
            {
                vm.filter={
                    device:{},
                    site:{},
                    specification:{},
                    includeDevices:true,
                    includeMeasurements:false,
                    specs:[],
                    measurements:{}
                };
            }
            else
            {
                vm.filter={
                    device:[{modules:[args.token]}],
                    site:{},
                    specification:{},
                    includeDevices:true,
                    includeMeasurements:false,
                    specs:[],
                    measurements:{}
                };
            }
            vm.refreshTree(false);
        });
        // Tree
        vm.refreshTree = function(refresh) {
            pragmaapi.getTreeDataFilter(vm.filter).then(function(treeData) {
                loadSpecifications(treeData).then(function() {
                    vm.treeData = processTreeData(treeData);
                    // Reload tree
                    vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'checkbox', 'state']);
                    vm.treeConfig.state = { key : "breakdown" };
                    vm.showTree=true;
                });
            });
           /*pragmaapi.getTreeData(true, true, true, false).then(function(treeData) {
                loadSpecifications(treeData).then(function() {
                    vm.treeData = treeData;
                    // Reload tree
                    vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'checkbox', 'state']);
                    vm.treeConfig.state = { key : "breakdown" };
                });
            });*/
        }
        function processTreeData(treeData) {
            var groupIds=[];
            var siteIds=[];
            var tenantIds=[];
            var portfolioIds=[];
            for(var i=0;i<treeData.length;i++)
            {
                if(treeData[i].type==="deviceGroup")
                {
                    groupIds.push(treeData[i].id)
                }
                else if(treeData[i].type==="site")
                {
                    siteIds.push(treeData[i].id)
                }
                else if(treeData[i].type==="portfolio")
                {
                    portfolioIds.push(treeData[i].id)
                }
                else if(treeData[i].type==="client")
                {
                    tenantIds.push(treeData[i].id)
                }
            }
            treeData=removeEmpty(treeData,groupIds);
            treeData=removeEmpty(treeData,siteIds);
            treeData=removeEmpty(treeData,portfolioIds);
            treeData=removeEmpty(treeData,tenantIds);
            for(var i=0;i<treeData.length;i++)
            {
                treeData[i]["__uiNodeId"]=i+1;
            }
            return treeData;
        }
        function removeEmpty(tree,ids)
        {
            var fl=false;
            var groupT=-1;
            for(var j=0;j<ids.length;j++)
            {
                fl=false;
                groupT=-1;
                for(var i=0;i<tree.length;i++)
                {
                    if (tree[i].id==ids[j])
                    {
                        groupT=i;
                    }
                    if(tree[i].parent==ids[j])
                    {
                        fl=true;
                    }
                }
                if(!fl)
                {
                    tree.splice(groupT,1);
                }
            }
            return tree;
        }
        vm.refreshTree(false);
        
        vm.applySearch = function() {
          if (vm.treeInstance) {
            vm.treeInstance.jstree(true).search(vm.searchtree);
          }
        };
		
        vm.treeEvents = {
            'select_node': getSelectedNodes,
            'deselect_node': getSelectedNodes,
            'hover_node': hoverNode
        }

        var loading = false;
        var selectedNodes = [];
        function getSelectedNodes() {
            if (!loading) {
                loading = true;
                visualizeData();
            }
        }
        
        vm.openTree = function () {
			if (vm.treeInstance) {
                vm.treeInstance.jstree().open_all();
			}
		};
        
        vm.closeTree = function () {
			if (vm.treeInstance) {
                vm.treeInstance.jstree().close_all();
			}
		};
        
        vm.resetTree = function () {
			if (vm.treeInstance) {
                vm.treeInstance.jstree().deselect_all();
                getSelectedNodes();
			}
		};
        
        function hoverNode(e, data){
            jQuery("#" + data.node.id + "_anchor").prop('title', data.node.text);
        };
        
        // Functions
        vm.setKPI = setKPI;
        vm.setZoom = setZoom;
        vm.setChartType = setChartType;
        vm.buttonToggle = buttonToggle;
        vm.toggleSidenav = toggleSidenav;
        vm.saveImage = saveImage;
        vm.exportCSV = exportCSV;
        
        // Device Specifications
        vm.deviceSpecifications = {};
        function loadSpecifications(treeData) {
            var tenantAuthTokens = [];
            for (var i = 0; i < treeData.length; i++) {
                if (tenantAuthTokens.indexOf(treeData[i].tenantAuthToken) < 0) {
                    tenantAuthTokens.push(treeData[i].tenantAuthToken);
                }
            }
            var promises = tenantAuthTokens.map(function(tenantAuthToken) {
                return pragmaapi.callRestService(PRAGMA.api, "/specifications", "?tenantAuthToken=" + tenantAuthToken, true, vm.user.authentication, "GET", true).then(function(res) {
                    if (!res.data.error && res.data.numResults) {
                        var results = res.data.results;
                        vm.deviceSpecifications[tenantAuthToken] = {};
                        for (var j = 0; j < results.length; j++) {
                            if (results[j].metadata.specs != undefined) {
                                var specs = JSON.parse(results[j].metadata.specs);
                                for (var measure in specs) {
                                    specs[measure].name = measure;
                                    if (specs[measure].type == "electricity excess") specs[measure].type = "electricity_excess";
                                    specs.type = specs[measure].type;
                                    //specs[measure].type = results[j].metadata.type;
                                    // Priority
                                    if (results[j].metadata.priority != undefined) {
                                        specs[measure].priority = results[j].metadata.priority;
                                    }
                                }
                                vm.deviceSpecifications[tenantAuthToken][results[j].token] = specs;
                            }
                        }
                    }
                });
            });
            return $q.all(promises);
        }
        
        // Selected Assignments
        vm.selectedAssignments = [];
        function getSelectedAssignments() {
            
            updateStatus(pragmaapi.translate('BREAKDOWN.FINDING_ASSIGNMENTS'), true);
            
            // Manipulates
            vm.selectedAssignments = [];
            
            vm.measureTypes = [{id: 'all', translation: 'BREAKDOWN.ALL_MEASURES', name: 'All measures'}];
            
            var jstree = vm.treeInstance.jstree(true);
            
            //var topSelectedNodes = jstree.get_top_selected(true);
            
            // Find all selected devices
            var foo = [];
            selectedNodes = jstree.get_selected(true);
            for (var i = 0; i < selectedNodes.length; i++) {
                if (selectedNodes[i].id.indexOf("device_") === 0) {
                    foo.push(selectedNodes[i]);
                }
            }
            
            // Find all selected devices which have a valid specification and keep defaults
            var assignmentsToken = [];
            var promises = foo.map(function(treeDatum) {
                var tenantAuthToken = treeDatum.original.tenantAuthToken;
                return pragmaapi.callRestService(PRAGMA.api, "/assignments/" + treeDatum.original.token, "?tenantAuthToken=" + tenantAuthToken,true, vm.user.authentication, "GET", true).then(function(res) {
                    var assignment = res.data;
                    if (!assignment.error) {
                        var bar = vm.deviceSpecifications[tenantAuthToken][assignment.device.specificationToken];
                        if (bar != undefined) {
                            if (assignmentsToken.indexOf(assignment.token) < 0) { // Don't include assignments twice
                                assignmentsToken.push(assignment.token);
                                assignment.path = jstree.get_path(treeDatum.id, false, true);
                                var measures = [];
                                for (var prop in bar) {
                                    var measure = bar[prop];
                                    if (measure.cost == "true" && (measure.aggregated == "true" || measure.cumulative=="true")) {
                                        measure.deviceId = assignment.device.assetId;
                                        measure.name = prop;
                                        measures.push(measure);
                                    }
                                }
                                if (measures.length) {
                                    if (!inMeasureTypes(measures[0].type)) {
                                        vm.measureTypes.push({id: measures[0].type, translation: pragmaapi.translateLabel('BREAKDOWN', measures[0].type), name: ucwords(measures[0].type)});
                                    }
                                    assignment.specs = measures;
                                    assignment.tenantAuthToken = tenantAuthToken;
                                    vm.selectedAssignments.push(assignment);
                                }
                            }
                        }
                    }
                });
            });
            return $q.all(promises);
        }
        
        // Visualize Data
        function visualizeData() {
          
            // Reset Chart
            resetChart();
            setOptions();
            setLegendPosition();
            vm.detailsData = [];
			
            if (vm.date.startDate !== "" && vm.date.endDate!== "") {
                
                getSelectedAssignments().then(function(res) {
                    loading = false;
                    if (vm.selectedAssignments.length > 0) {
                      
                        updateStatus(pragmaapi.translate('BREAKDOWN.LOADING_DATA'), true);
                                    
                        // Dates
                        vm.chart.from = encodeURIComponent(moment(vm.date.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone);
                        vm.chart.to = encodeURIComponent(moment(vm.date.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone);
                        
                        // Prioritize assignments
                        prioritizeAssignments();
                        sortAssignments();
                        
                        // Set other data
                        calculatedDegreeDays = [];
                        setSelectedSites();
                        
                        loadData().then(function(res) {
                            var pos = vm.selectedCompensate.indexOf('degree-days');
                            if (vm.temperature || pos >= 0) {
                                updateStatus(pragmaapi.translate('BREAKDOWN.LOADING_WEATHER_DATA'), true);
                                loadTemperatures().then(function(res) {
                                    updateStatus(pragmaapi.translate('BREAKDOWN.PREPARING_GRAPH'), true);
                                    $timeout(function() { _visualizeData(); }, 50);
                                });
                            }
                            else {
                                updateStatus(pragmaapi.translate('BREAKDOWN.PREPARING_GRAPH'), true);
                                $timeout(function() { _visualizeData(); }, 50);
                            }
                        });
                    }
                    else {
                        vm.units = [];
                        vm.measureTypes = [];
                        vm.selectedSites = [];
                        
                        vm.schedule.is_disabled = pragmaapi.translate("BREAKDOWN.NO_SITES_SCHEDULE");
                        resetSchedule(0);
                        
                        if (chartAggregated != null) { chartAggregated.destroy(); chartAggregated = null; }
                        removeZoomChart();
                        if (selectedNodes.length) {
                            updateStatus(pragmaapi.translate('BREAKDOWN.NO_DATA_FOUND'));
                        }
                        else {
                            updateStatus(pragmaapi.translate('BREAKDOWN.SELECT_DATA'));
                        }
                    }
                });
            }
            else {
                angular.element(".graph-message p").text(pragmaapi.translate('BREAKDOWN.SELECT_PERIOD'));
            }
        }
        
        function _visualizeData() {
          
            vm.chart.measurements_original = angular.copy(vm.chart.measurements); // Keep original measurements
            
            // Prepare data
            prepareData();
            
        }
        
        // Keep only top level and top priority assignments
        function prioritizeAssignments() {
            var prioritizedAssignments = {};
            
            var found = [];
            
            var jstree = vm.treeInstance.jstree(true);
            var topSelectedNodes = jstree.get_top_selected();
            for (var i = 0; i < topSelectedNodes.length; i++) {
                var topSelectedNode = topSelectedNodes[i];
                for (var j = 0; j < vm.selectedAssignments.length; j++) {
                    var selectedAssignment = vm.selectedAssignments[j];
                    if (selectedAssignment.path.indexOf(topSelectedNode) >= 0) {
                        var level = selectedAssignment.path.length;
                        if (prioritizedAssignments[level] == undefined) prioritizedAssignments[level] = {};
                        var priority = (selectedAssignment.device.metadata.central == "true") ? 0 : selectedAssignment.specs[0].priority;
                        if (prioritizedAssignments[level][priority] == undefined) prioritizedAssignments[level][priority] = [];
                        prioritizedAssignments[level][priority].push(selectedAssignment);
                    }
                }
            }
            vm.selectedAssignments = [];
            for (var level in prioritizedAssignments) {
                for (var priority in prioritizedAssignments[level]) {
                    for (var i = 0; i < prioritizedAssignments[level][priority].length; i++) {
                        if (!foundBetterAssignment(found, level, priority, prioritizedAssignments[level][priority][i].specs[0].type)) {
                            found.push({level: level, priority: priority, type: prioritizedAssignments[level][priority][i].specs[0].type, isMain: prioritizedAssignments[level][priority][i].device.metadata.central});
                            vm.selectedAssignments.push(prioritizedAssignments[level][priority][i]);
                        }
                    }
                }
            }
        }
        
        function foundBetterAssignment(arr, level, priority, type) {
            var res = false;
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].type == type && arr[i].level <= level && arr[i].priority < priority) {
                    res = true;
                    break;
                }
            }
            return res;
        }
        
        function sortAssignments() {
            vm.selectedAssignments.sort(function(a, b) {
                var x = a.specs[0].type;
                var y = b.specs[0].type;
                return x < y ? -1 : x > y ? 1 : 0;
            });
        }
        
        vm.selectedSites = [];
        function setSelectedSites() {
            vm.selectedSites = [];
            for (var i = 0; i < vm.selectedAssignments.length; i++) {
                var site = vm.selectedAssignments[i].site;
                
                // Compensate (area & volume)
                site.metadata.area = parseFloat(site.metadata.dimensionsX) * parseFloat(site.metadata.dimensionsY);
                site.metadata.volume = parseFloat(site.metadata.dimensionsX) * parseFloat(site.metadata.dimensionsY) * parseFloat(site.metadata.dimensionsZ);
                
                // Site assignments
                var found = inSelectedSites(site.token);
                if (found >= 0) {
                    vm.selectedSites[found].assignmentIndices.push(i);
                }
                else {
                    site.assignmentIndices = [i];
                    vm.selectedSites.push(site);
                }
            }
        }
        // Load data
        function loadData() {
            var promises = vm.selectedAssignments.map(function(selectedAssignment, i) {
                var measure = selectedAssignment.specs[0];
                
                if (vm.chartType == "functional") {
                    var parts = ["1", "h"];
                }
                else {
                    var parts = vm.chartZoom.split(" ");
                }
                var aggregationType = "sum";
                var startDate= vm.chart.from;
                if (measure.cumulative == "true") {
                    aggregationType = "last";
                    // startDate = subtractPeriod(vm.date.startDate, parts[0], parts[1]);
                }
                return pragmaapi.callRestService(PRAGMA.api,"/assignments/" + selectedAssignment.token + "/measurementsAggregated","?type=" + aggregationType + "&resolution=" + parts[0] + "&resolutionType=" + parts[1] + "&startDate=" + startDate + "&endDate=" + vm.chart.to + "&measuredParameter=" + measure.name + "&page=1&pageSize=2000&tenantAuthToken=" + selectedAssignment.tenantAuthToken, true, vm.user.authentication, "GET", true).then(function(res){
                    var measurements = res.data.data;
                    vm.chart.measurements[i] = measurements;
                });
            });
            return $q.all(promises);
        }
        
        function subtractPeriod(date, resolution, resolutionType) {
            switch (resolutionType) {
                case 'm':
                    resolutionType = "minutes";
                break;
                case '1 h':
                    resolutionType = "hours";
                break;
                case '1 d':
                    resolutionType = "days";
                break;
                case '1 w':
                    resolutionType = "weeks";
                break;
                case '1 M':
                    resolutionType = "months";
                break;
            }
            return encodeURIComponent(moment(date).subtract(resolution, resolutionType).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone);
        }
        
        
        // Load temperatures
        function loadTemperatures() {
            var promises = vm.selectedSites.map(function(selectedSite, i) {
                var measure = vm.selectedAssignments[selectedSite.assignmentIndices[0]].specs[0];
                var parts = vm.chartZoom.split(" ");
                return pragmaapi.callRestService(PRAGMA.weather,"/getAvgTemp","?resolution=" + parts[0] + "&resolutionType=" + parts[1] + "&startDate=" + vm.chart.from + "&endDate=" + vm.chart.to + "&lat=" + selectedSite.map.metadata.centerLatitude + "&lon=" + selectedSite.map.metadata.centerLongitude, false, "", "GET", "", true).then(function(res){
                    var temperatures = res.data.data;
                    if (res.data.name) {
                        var pos = vm.chart.stations.indexOf(res.data.name);
                        if (pos < 0) {
                            vm.chart.stations.push(res.data.name);
                            vm.chart.temperatures.push(temperatures);
                            selectedSite.weather = 0;
                        }
                        else {
                            selectedSite.weather = pos;
                        }
                    }
                    else {
                        var msg = 'Weather data for site "' + selectedSite.name  + '" is not available...';
                        if (vm.notifications.indexOf(msg) < 0) {
                            vm.notifications.push(msg);
                            Notification(msg);
                        }
                    }
                });
            });
            return $q.all(promises);
        }
        
        var scheduledCostFound = false;
        function prepareData() {
            vm.chartUnits = [];
            scheduledCostFound = false;
            var k = 0;
            var isMain = false;
            var isCost = (vm.chartKPI == 'cost');
            
            for (var i = 0; i < vm.selectedAssignments.length; i++) {
                var measurements = vm.chart.measurements[i];
                if (measurements != undefined) {
                    if (measurements.length) {
                        var selectedAssignment = vm.selectedAssignments[i];
                        var measure = selectedAssignment.specs[0];
                        isMain = (measure.deviceId == 419 || measure.deviceId == 420 || selectedAssignment.device.metadata.central == "true");
                        vm.chartUnits[k] = measure.unit;
                        // Convert Wh to kWh
                        if (measure.unit == "Wh") {
                            vm.chartUnits[k] = "kWh";
                            measurements.forEach(function(measurement, j) {
                                vm.chart.measurements[i][j].d = measurement.d / 1000;
                            });
                        }
                        
                        // Convert W to kWh
                        if (measure.unit == "W") {
                            vm.chartUnits[k] = "kWh";
                            measurements.forEach(function(measurement, j) {
                                vm.chart.measurements[i][j].d = measurement.d / (1000 * 4); // This applies only to measurements which occur every 15min
                            });
                        }
                        
                        // This is a reading
                        if (measure.cumulative == "true") {
                            // Fix gaps
                            for (var j = 0; j < vm.chart.measurements[i].length; j++) {
                                if (vm.chart.measurements[i][j].d <= 0) {
                                    // Find closest non null value (go down)
                                    var l = 1;
                                    for (var l = 1; l <= j; l++) {
                                        if (vm.chart.measurements[i][j - l].d > 0) {
                                            vm.chart.measurements[i][j].d = vm.chart.measurements[i][j - l].d;
                                            break;
                                        }
                                    }
                                    if (vm.chart.measurements[i][j].d <= 0) {
                                        // Find closest non null value (go up)
                                        var l = 1;
                                        for (var l = 1; l < vm.chart.measurements[i].length; l++) {
                                            if (vm.chart.measurements[i][j + l].d > 0) {
                                                vm.chart.measurements[i][j].d = vm.chart.measurements[i][j + l].d;
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        // All values are zero
                                    }
                                }
                            }
                            for (var j = vm.chart.measurements[i].length - 1; j > 0; j--) {
                                var foo = vm.chart.measurements[i][j].d - vm.chart.measurements[i][j-1].d;
                                if (foo >= 0) {
                                    vm.chart.measurements[i][j].d = foo;
                                }
                            };
                            // Remove first
                            vm.chart.measurements[i].shift();
                            //console.log(vm.chart.measurements[i]);
                        }
                        
                        
                        // Calculate cost
                        if (isCost) {
                            vm.chartUnits[k] = "€";
                            
                            var days = moment(vm.date.endDate).diff(moment(vm.date.startDate), 'days'); // Default = selected period
                            if (vm.chart.measurements[i][(vm.chart.measurements[i].length - 2)] != undefined) { // If have more than one measurement get period from measurements
                                days = (vm.chart.measurements[i][(vm.chart.measurements[i].length - 1)].t - vm.chart.measurements[i][(vm.chart.measurements[i].length - 2)].t) / 1000 / 60 / 60 / 24;
                            }
                            
                            var profile = {};
                            if (profile = pragmaapi.findCostProfile(measure.type, selectedAssignment.site.token)) {
                                
                                profile.costs.forEach(function(cost) {
                                    if (cost.type == "unit" && cost.schedule.length) {
                                        
                                        scheduledCostFound = true;
                                        
                                        // Find blocks
                                        var blocks = findBlocks(0, 0, cost.schedule, true);
                                        
                                        // Sort by number of blocks
                                        var maxLength = 0;
                                        var sortedTariffs = {};
                                        for (var j = 0; j < cost.tariffs.length; j++) {
                                            var length = blocks[cost.tariffs[j].name].length;
                                            if (maxLength < length) maxLength = length;
                                            if (sortedTariffs[length] == undefined) sortedTariffs[length] = [];
                                            sortedTariffs[length].push(blocks[cost.tariffs[j].name]);
                                        }
                                        
                                        // Remove last tariff, it will be caclulated
                                        var lastTariff = sortedTariffs[maxLength].pop();
                                        lastTariff = lastTariff[0].tag;
                                        
                                        // Prepare tariffs to load
                                        var loadTariffs = [];
                                        for (var l in sortedTariffs) {
                                            for (var m = 0; m < sortedTariffs[l].length; m++) {
                                                for (var n = 0; n < sortedTariffs[l][m].length; n++) {
                                                    loadTariffs.push({ tag: sortedTariffs[l][m][n].tag, assignment: selectedAssignment, startHourOfDay: ("00" + (sortedTariffs[l][m][n].topLeft.x + 1)).substr(-2,2) + ':00:00', endHourOfDay:  ("00" + sortedTariffs[l][m][n].bottomRight.x).substr(-2,2) + ':59:59' });
                                                }
                                            }
                                        }
                                        
                                        // Load tariffs measurements
                                        
                                        // Save i before continuing
                                        var index = i;
                                        loadTariffsMesurements(loadTariffs).then(function() {
                                            
                                            // Calculate last tariff
                                            tariffsMeasurements[lastTariff] = []
                                            measurements.forEach(function(measurement, j) {
                                                var foo = 0; foo += vm.chart.measurements[index][j].d;
                                                for (var l in tariffsMeasurements) {
                                                    if (l!= lastTariff) {
                                                        foo -= tariffsMeasurements[l][j].d;
                                                    }
                                                }
                                                tariffsMeasurements[lastTariff][j] = { d: foo, t: measurement.t };
                                            });
                                            
                                            for (var l in tariffsMeasurements) {
                                                // Convert Wh to kWh
                                                if (measure.unit == "Wh") {
                                                    tariffsMeasurements[l].forEach(function(measurement, j) {
                                                        tariffsMeasurements[l][j].d = measurement.d / 1000;
                                                    });
                                                }
                                                
                                                // Convert W to kWh
                                                if (measure.unit == "W") {
                                                    tariffsMeasurements[l].forEach(function(measurement, j) {
                                                        tariffsMeasurements[l][j].d = measurement.d / 1000 * 4; // This applies only to measurements which occur every 15min
                                                    });
                                                }
                                            }
                                            measurements.forEach(function(measurement, j) {
                                                var foo = [];
                                                for (var l = 0; l < cost.tariffs.length; l++) {
                                                    foo.push(tariffsMeasurements[cost.tariffs[l].name][j].d);
                                                }
                                                vm.chart.measurements[index][j].d = pragmaapi.calculateCost(foo, days, measure.type, selectedAssignment.site.token, isMain);
                                            });
                                            alignData();
                                            drawChart();
                                        });
                                        
                                        // Only one scheduled cost per cost profile
                                        return;
                                    }
                                });
                                
                                if (!scheduledCostFound) {
                                    measurements.forEach(function(measurement, j) {
                                        vm.chart.measurements[i][j].d = pragmaapi.calculateCost(measurement.d, days, measure.type, selectedAssignment.site.token, isMain);
                                    });
                                }
                            }
                            else {
                                measurements.forEach(function(measurement, j) {
                                    vm.chart.measurements[i][j].d = pragmaapi.calculateCost(measurement.d, days, measure.type, selectedAssignment.site.token, isMain);
                                });
                            }
                        }
                        
                        // Convert g to kg
                        if (!isCost && measure.unit == "g") {
                            vm.chartUnits[k] = "kg";
                            measurements.forEach(function(measurement, j) {
                                vm.chart.measurements[i][j].d = measurement.d / 1000;
                            });
                        }
                        
                        // Convert m3 to kWh
                        if (!isCost && measure.unit == "m3") {
                            vm.chartUnits[k] = "kWh";
                            measurements.forEach(function(measurement, j) {
                                vm.chart.measurements[i][j].d = pragmaapi.m3tokWh(measurement.d);
                            });
                        }
                        
                        // Negate electricity excess
                        if (measure.type == 'electricity_excess') {
                            measurements.forEach(function(measurement, j) {
                                vm.chart.measurements[i][j].d = 0 - measurement.d;
                            });
                        }
                        k++;
                    }
                }
            }
            
            // scaleLabel
            setScaleLabel(isCost, isMain);
            
            if (vm.temperature) {
                for (var i = 0; i < vm.chart.temperatures.length; i++) {
                    vm.chartUnits[k] = "°C";
                    k++;
                }
            }
            
            // Align Data
            if (!scheduledCostFound) {
                alignData();
            }
            
        }
        
        var tariffsMeasurements = {};
        function loadTariffsMesurements(loadTariffs) {
            tariffsMeasurements = {};
            var promises = loadTariffs.map(function(tariff) {
                var selectedAssignment = tariff.assignment;
                var measure = selectedAssignment.specs[0];
                var parts = vm.chartZoom.split(" ");
                return pragmaapi.callRestService(PRAGMA.api,"/assignments/" + selectedAssignment.token + "/measurementsAggregated","?resolution=" + parts[0] + "&resolutionType=" + parts[1] + "&startDate=" + vm.chart.from + "&endDate=" + vm.chart.to + "&measuredParameter=" + measure.name + "&startHourOfDay=" + tariff.startHourOfDay + "&endHourOfDay=" + tariff.endHourOfDay + "&page=1&pageSize=2000&tenantAuthToken=" + selectedAssignment.tenantAuthToken, true, vm.user.authentication, "GET", true).then(function(res){
                    var measurements = res.data.data;
                    if (tariffsMeasurements[tariff.tag] == undefined) tariffsMeasurements[tariff.tag] = [];
                    tariffsMeasurements[tariff.tag] = measurements;
                });
            });
            return $q.all(promises);
        }
		
        var blocks = {};
        // This is not very clever, only finds vertical blocks
        function findBlocks(x, y, schedule, reset) {
            if (reset) {
                blocks = {};
            }
            if (x < schedule[0].length) {
                var tag = schedule[y][x];
                if (blocks[tag] == undefined) blocks[tag] = [];
                var index = blocks[tag].length;
                blocks[tag][index] = { tag: tag, topLeft: {x: x, y: y}, bottomRight: {x: x, y: y} };
                for (var i = y; i < schedule.length; i++) {
                    for (var j = x; j < schedule[i].length; j++) {
                        if (schedule[i][j] == tag) {
                            if (i >= blocks[tag][index].bottomRight.y) {
                                blocks[tag][index].bottomRight.y = i;
                                if (j > blocks[tag][index].bottomRight.x) {
                                    blocks[tag][index].bottomRight.x = j;
                                }
                            }
                        }
                        else {
                            break;
                        }
                    }
                }
                findBlocks(blocks[tag][index].bottomRight.x + 1, blocks[tag][index].topLeft.y, schedule, false);
            }
            return blocks;
        }
        
        function setScaleLabel(isCost, isMain) {
            vm.chartScaleLabel = "";
            if (isCost) {
                vm.chartScaleLabel += pragmaapi.translate("BREAKDOWN.COST_INDICATION_IN") + " ";
            }
            else {
                vm.chartScaleLabel += pragmaapi.translate("BREAKDOWN.MEASUREMENTS_IN") + " ";
            }
            vm.chartScaleLabel += vm.chartUnits[0];
            if (isCost) {
                if (isMain) {
                    vm.chartScaleLabel += " (" + pragmaapi.translate("BREAKDOWN.INCLUDING_FIXED") + ")";
                }
                else {
                    vm.chartScaleLabel += " (" + pragmaapi.translate("BREAKDOWN.ΝΟΤ_INCLUDING_FIXED") + ")";
                }
            }
        }
        
        function alignData() {
            var foo = [];
            for (var i = 0; i < vm.selectedAssignments.length; i++) {
                var measurements = vm.chart.measurements[i];
                if (measurements != undefined) {
                    if (measurements.length) {
                        for (var j = 0; j < measurements.length; j++) {
                            if (foo.indexOf(measurements[j].t) < 0) {
                                foo.push(measurements[j].t);
                            }
                        }
                    }
                }
            }
            foo.sort();
            for (var i = 0; i < vm.selectedAssignments.length; i++) {
                var measurements = vm.chart.measurements[i];
                if (measurements != undefined) {
                    if (measurements.length) {
                        for (var j = 0; j < foo.length; j++) {
                            if (measurements[j] == undefined || measurements[j].t != foo[j]) {
                                measurements.splice(j, 0, {t: foo[j], d: 0});
                            }
                        }
                    }
                }
            }
            if (vm.temperature && !(vm.chartZoom == '1 w' || vm.chartZoom == '1 M')) {
                for (var i = 0; i < vm.chart.temperatures.length; i++) {
                    var temperatures = vm.chart.temperatures[i];
                    for (var j = 0; j < foo.length; j++) {
                        if (temperatures[j] == undefined || temperatures[j].t != foo[j]) {
                            temperatures.splice(j, 0, {t: foo[j], d: null});
                        }
                    }
                }
            }

            // Draw Chart
            drawChart();
        }
		
        function drawChart() {
            
            removeZoomChart();
            
            if (vm.chart.measurements.length) {
                var isCost = (vm.chartKPI == 'cost');
                
                // Measure types
                if (!inMeasureTypes(vm.selectedMeasureType)) {
                    vm.selectedMeasureType = 'all'; // Reset selected measure type
                }
                
                // Units
                if (isCost) {
                    vm.units = []; // Hide units
                }
                else {
                    if (inMeasureTypes("gas") && (vm.selectedMeasureType == "gas" || inMeasureTypesAll(["all", "gas"]))) {
                        vm.units = ["kWh", "m3", "kg CO2"];
                    }
                    else {
                        vm.units = _.uniq(vm.chartUnits);
                        vm.selectedUnit=vm.units[0];
                        if (vm.units == ["kWh"]) {
                            vm.units = ["kWh", "kg CO2"];
                            if (vm.selectedUnit == "m3") {
                                vm.selectedUnit = "kWh";
                            }
                        }
                        else if (vm.units.length < 2) {
                            vm.units = []; // Hide units
                        }
                    }
                    vm.chartUnits[0] = vm.selectedUnit;
                    setScaleLabel(false);
                }
                
                chartTmp = {
                    colors: [],
                    series: [],
                    override: [],
                    labels: [],
                    data: []
                };
                
                if (vm.chartType == 'pie') { // Pie Chart
                    for (var i = 0; i < vm.selectedAssignments.length; i++) {
                        var measurements = vm.chart.measurements[i];
                        if (measurements.length) {
                            var selectedAssignment = vm.selectedAssignments[i];
                            var measure = selectedAssignment.specs[0];
                            if (vm.selectedMeasureType == 'all' || measure.type == vm.selectedMeasureType) {
                                chartTmp.override[0] = {type: vm.chartType};
                                chartTmp.colors.push(getColors(measure.type));
                                chartTmp.labels.push(getAssetName(selectedAssignment));
                                if (!isCost && vm.selectedUnit == "kg CO2") {
                                    chartTmp.data.push(parseFloat(measurements.reduce(function(a, b) { return a + pragmaapi.kWhtoCO2(b.d, 'NL'); }, 0).toFixed(2)));
                                }
                                else if (!isCost && vm.selectedUnit == "m3") {
                                    chartTmp.data.push(parseFloat(measurements.reduce(function(a, b, j) { return a + vm.chart.measurements_original[i][j].d; }, 0).toFixed(2)));
                                }
                                else {
                                    chartTmp.data.push(parseFloat(measurements.reduce(function(a, b) { return a + Math.abs(b.d); }, 0).toFixed(2)));
                                }
                            }
                        }
                    }
                    for (var prop in chartTmp) {
                      vm.chart[prop] = chartTmp[prop];
                    }
                    // Remove what's not needed for pie charts
                    delete (vm.chart.options.scales);
                    
                    // Add what's needed for pie charts
                    vm.chart.options.tooltips = {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                return data.labels[tooltipItem.index] + ": " + $filter('number')(data.datasets[0].data[tooltipItem.index]) + " " + vm.chartUnits[0];
                            }
                        }
                    };
                    vm.chart.options.animation.duration = 800;
                    setChartTitle();
                    getStats();
                    
                    drawjQueryChart("pie");
                    
                }
                else if (vm.chartType == 'heatmap') { // Heatmap
                    // Calculate totals per label
                    var foo = {};
                    var xLabels = {};
                    for (var i = 0; i < vm.selectedAssignments.length; i++) {
                        var measurements = angular.copy(vm.chart.measurements[i]);
                        if (measurements != undefined) {
                            if (measurements.length) {
                                var selectedAssignment = vm.selectedAssignments[i];
                                var measure = selectedAssignment.specs[0];
                                if (vm.selectedMeasureType == 'all' || measure.type == vm.selectedMeasureType) {
                                    measurements.map(function(measurement, j) {
                                        var bar = getLabel(measurement);
                                        if (foo[bar] == undefined) {
                                            foo[bar] = measurement;
                                        }
                                        else {
                                            foo[bar].d += measurement.d;
                                        }
                                        foo[bar].i = i;
                                        var h = moment(measurement.t).format("H");
                                        switch (vm.chartZoom) {
                                            case '15 m':
                                                var m = moment(measurement.t).format("m");
                                                foo[bar].y = (h * 4) + (m / 15);
                                                var t = moment(measurement.t).format("MMM D");
                                                xLabels[t] = [moment(measurement.t).format("dd"), t];
                                            break;
                                            case '1 h':
                                                foo[bar].y = h;
                                                var t = moment(measurement.t).format("MMM D");
                                                xLabels[t] = [moment(measurement.t).format("dd"), t];
                                            break;
                                            case '1 d':
                                                foo[bar].y = 0;
                                                var t = moment(measurement.t).format("MMM D");
                                                xLabels[t] = [moment(measurement.t).format("dd"), t];
                                            break;
                                            case '1 w':
                                            case '1 M':
                                                foo[bar].y = 0;
                                                xLabels[bar] = bar;
                                            break;
                                        }
                                    });
                                }
                            }
                        }
                    }
                    
                    // Normalize
                    normalize(foo);
                    
                    // Flatten
                    var totals = Object.keys(foo).map(function (key) { return foo[key]; });
                    var xLabels = Object.keys(xLabels).map(function (key) { return xLabels[key]; });
                    xLabels.unshift("");
                    
                    var k = 0;
                    totals = totals.map(function(measurement, j) {
                        if (measurement.y == 0) k++;
                        switch (vm.chartZoom) {
                            case '15 m':
                            case '1 h':
                                return {x: k + 1, y: measurement.y, t: measurement.t, r: parseFloat(measurement.r).toFixed(2), d: parseFloat(measurement.d.toFixed(2))};
                            break;
                            case '1 d':
                            case '1 w':
                            case '1 M':
                                return {x: k, y: 12, t: measurement.t, r: parseFloat(measurement.r).toFixed(2), d: parseFloat(measurement.d.toFixed(2))};
                            break;
                        }
                    });
                    chartTmp.heatmapData = splitTotals(totals, vm.heatmapLevels, vm.heatmapDistribution);
                    
                    for (var i = 0; i < vm.heatmapLevels; i++) {
                        vm.chartUnitsShown[i] = vm.chartUnits[0];
                        chartTmp.colors.push(getHeatmapColors(i));
                        chartTmp.labels.push(getHeatmapLabels(i));
                    }
                    
                    for (var prop in chartTmp) {
                      vm.chart[prop] = chartTmp[prop];
                    }
                    
                    // Add what's needed for heatmap charts
                    vm.chart.options.scales = { 
                        xAxes: [{id: 'Ax', gridLines: {color: vm.themes.active.theme.background.hue1.contrast3}, ticks: { beginAtZero: true, max: xLabels.length, stepSize: 1, maxRotation: 0, fontSize: 10, autoSkipPadding: 10,
                            callback: function(value, index, values) {
                                return xLabels[index];
                            }
                        }}],
                        yAxes: [{id: 'Ay', gridLines: {color: vm.themes.active.theme.background.hue1.contrast4}, ticks: { beginAtZero: true, max: ((vm.chartZoom == "15 m") ? 96 : 24), stepSize: ((vm.chartZoom == "15 m") ? 4 : 1),
                            callback: function(value, index, values) {
                                switch (vm.chartZoom) {
                                    case '15 m':
                                    case '1 h':
                                        if (index > 0) {
                                            return pad((24 - index), 2) + ":00";
                                        }
                                    break;
                                }
                                return "";
                            }
                        }}]
                    };
                    
                    vm.chart.options.tooltips = {
                        mode: 'nearest',
                        intersect: true,
                        callbacks: {
                            label: function(tooltipItem, data) {
                                if (vm.chart.heatmapData != undefined) {
                                    return vm.chart.heatmapData[tooltipItem.datasetIndex][tooltipItem.index].d + " " + vm.chartUnitsShown[0];
                                }
                                else {
                                    return "";
                                }
                            }
                        }
                    };
                    
                    vm.chart.options.elements.point = {
                        pointStyle : vm.heatmapPointStyle
                    };
                    
                    vm.chart.options.animation.duration = 0;
                    vm.chart.options.legend.position = "bottom";
                    
                    setChartTitle();
                    
                    // Hide stats
                    vm.chart.stats.total = null;
                    vm.chart.options.annotation = {};
                    
                    drawjQueryChart("bubble");
                    
                }
                else if (vm.chartType == 'functional') { // Functional analysis
                    loadSchedule(vm.selectedSites);
                    
                    // Calculate totals per label
                    var foo = {};
                    var xLabels = {};
                    for (var i = 0; i < vm.selectedAssignments.length; i++) {
                        var measurements = angular.copy(vm.chart.measurements[i]);
                        if (measurements.length) {
                            var selectedAssignment = vm.selectedAssignments[i];
                            var measure = selectedAssignment.specs[0];
                            if (vm.selectedMeasureType == 'all' || measure.type == vm.selectedMeasureType) {
                                var schedule = vm.schedules[selectedAssignment.siteToken];
                                if (schedule == undefined) schedule = getSchedule(1);
                                measurements.map(function(measurement, j) {
                                    var h = moment(measurement.t).format("H");
                                    var d = moment(measurement.t).format("d");
                                    var bar = getLabel(measurement);
                                    if (foo[bar] == undefined) {
                                        foo[bar] = angular.copy(measurement);
                                        if (schedule[d][h] == 0) {
                                            foo[bar].d = 0;
                                            foo[bar].e = measurement.d;
                                        }
                                        else {
                                            foo[bar].e = 0;
                                        }
                                    }
                                    else {
                                        if (schedule[d][h] == 0) {
                                            foo[bar].e += measurement.d;
                                        }
                                        else {
                                            foo[bar].d += measurement.d;
                                        }
                                    }
                                    xLabels[bar] = bar;
                                });
                            }
                        }
                    }
                    
                    // Flatten
                    var totals = Object.keys(foo).map(function (key) { return foo[key]; });
                    var xLabels = Object.keys(xLabels).map(function (key) { return xLabels[key]; });
                    
                    chartTmp.scheduleData = splitScheduleTotals(totals);
                    for (var i = 0; i < chartTmp.scheduleData.length; i++) {
                        chartTmp.scheduleData[i] = chartTmp.scheduleData[i].map(function(measurement, j) {
                            if (!isCost && vm.selectedUnit == "kg CO2") {
                                return parseFloat(pragmaapi.kWhtoCO2(measurement, 'NL').toFixed(2));
                            }
                            else {
                                return parseFloat(measurement.toFixed(2));
                            }
                        });
                    }
                    
                    chartTmp.labels = xLabels;
                    
                    vm.chartUnitsShown = [vm.chartUnits[0], vm.chartUnits[0]];
                    chartTmp.colors.push(getColors("", 3));
                    chartTmp.colors.push(getColors("", 7));
                    chartTmp.series.push(pragmaapi.translate("BREAKDOWN.FUNCTIONAL"));
                    chartTmp.series.push(pragmaapi.translate("BREAKDOWN.NON_FUNCTIONAL"));
                    
                    chartTmp.data.push(measurements.map(function(measurement, j) {
                        if (!isCost && vm.selectedUnit == "kg CO2") {
                            return parseFloat(pragmaapi.kWhtoCO2(measurement.d, 'NL').toFixed(2));
                        }
                        else if (!isCost && vm.selectedUnit == "m3") {
                            return parseFloat(vm.chart.measurements_original[i][j].d.toFixed(2));
                        }
                        else {
                            return parseFloat(measurement.d.toFixed(2));
                        }
                    }));
                    
                    for (var prop in chartTmp) {
                      vm.chart[prop] = chartTmp[prop];
                    }
                    
                    // Add what's needed for functional (bar) charts
                    vm.chart.options.scales = {
                        xAxes: [{id: 'Ax', gridLines: {color: vm.themes.active.theme.background.hue1.contrast3}, ticks: { maxRotation: 0, fontSize: 10, autoSkipPadding: 10}}],
                        yAxes: [{id: 'Ay', gridLines: {color: vm.themes.active.theme.background.hue1.contrast4}, scaleLabel: { display: true, labelString: vm.chartScaleLabel }, stacked: vm.stacked}]
                    };

                    vm.chart.options.tooltips = {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                return tooltipItem.yLabel + " " + vm.chartUnitsShown[tooltipItem.datasetIndex];
                            }
                        }
                    };
                    
                    if ((vm.stacked && vm.chart.scheduleData[0].length > maxNumberOfPoints) || (!vm.stacked && 2 * vm.chart.scheduleData[0].length > maxNumberOfPoints)) {
                        vm.chart.options.animation.duration = 0;
                        vm.chart.options.legend.position = "top";
                    }
                    else {
                        vm.chart.options.animation.duration = 800;
                        vm.chart.options.legend.position = "bottom";
                    }
                    
                    setChartTitle();
                    getScheduleStats();
                    
                    drawjQueryChart("schedule");
                    
                    if ((vm.stacked && vm.chart.scheduleData[0].length > maxNumberOfPoints) || (!vm.stacked && 2 * vm.chart.scheduleData[0].length > maxNumberOfPoints)) {
                        drawZoomChart();
                    }
                    
                }
                else { // Bar - Line Chart
                    var k = 0, l = 0;
                    for (var i = 0; i < vm.selectedAssignments.length; i++) {
                        var measurements = vm.chart.measurements[i];
                        if (measurements.length) {
                            var selectedAssignment = vm.selectedAssignments[i];
                            var measure = selectedAssignment.specs[0];
                            if (vm.selectedMeasureType == 'all' || measure.type == vm.selectedMeasureType) {
                                chartTmp.override.push({type: vm.chartType});
                                if (measurements.length > 100) { // Remove datapoints
                                    chartTmp.override[chartTmp.override.length - 1].pointRadius = 0;
                                }
                                chartTmp.series.push(getAssetName(selectedAssignment));
                                chartTmp.colors.push(getColors(measure.type));
                                chartTmp.labels = measurements.map(getLabel);
                                chartTmp.data.push(measurements.map(function(measurement, j) {
                                    if (!isCost && vm.selectedUnit == "kg CO2") {
                                        return parseFloat(pragmaapi.kWhtoCO2(measurement.d, 'NL').toFixed(2));
                                    }
                                    else if (!isCost && vm.selectedUnit == "m3") {
                                        return parseFloat(vm.chart.measurements_original[i][j].d.toFixed(2));
                                    }
                                    else {
                                        return parseFloat(measurement.d.toFixed(2));
                                    }
                                }));
                                // Compensate
                                if (vm.selectedCompensate.length) {
                                    for (var j = 0; j < vm.selectedCompensate.length; j++) {
                                        compensateFor(vm.selectedCompensate[j], i, chartTmp.data.length - 1);
                                    }
                                }
                                vm.chartUnitsShown[l] = vm.chartUnits[k];
                                l++;
                            }
                            k++;
                        }
                    }
                    
                    // Average Temperature
                    if (vm.temperature) {
                        var measurements = vm.chart.measurements[0];
                        for (var i = 0; i < vm.chart.temperatures.length; i++) {
                            
                            var foo = [];
                            var index = 0; var count = 0;
                            var temperatures = vm.chart.temperatures[i];
                            switch (vm.chartZoom) {
                                case '15 m':
                                case '1 h':
                                case '1 d':
                                    foo = angular.copy(temperatures);
                                break;
                                case '1 w':
                                case '1 M':
                                    for (var j = 0; j < temperatures.length; j++) {
                                        if (foo[index] == undefined) {
                                            foo[index] = angular.copy(temperatures[j]);
                                            count++;
                                        }
                                        else if (measurements[index + 1] != undefined && temperatures[j].t >= measurements[index + 1].t) {
                                            foo[index].d = parseFloat((foo[index].d / count).toFixed(1));
                                            count = 0;
                                            index++;
                                            foo[index] = angular.copy(temperatures[j]);
                                        }
                                        else {
                                            foo[index].d += temperatures[j].d;
                                            count++;
                                        }
                                    }
                                    // One more time
                                    foo[index].d = parseFloat((foo[index].d / count).toFixed(1));
                                break;
                            }
                            chartTmp.override.push({ xAxisID: 'Bx', yAxisID: 'By', type: 'line', spanGaps: true, });
                            chartTmp.series.push(vm.chart.stations[i]);
                            chartTmp.colors.push(getColors('tavg', i));
                            chartTmp.data.push(foo.map(function(temperature, j) {
                                return temperature.d;
                            }));
                            vm.chartUnitsShown[l] = vm.chartUnits[k];
                            l++; k++;
                        }
                        // chartTmp.xlabels = vm.chart.temperatures[i].map(function(temperature) {return moment(temperature.t).format("MMM D");});
                    }
                    
                    for (var prop in chartTmp) {
                      vm.chart[prop] = chartTmp[prop];
                    }
                    
                    // Add what's needed for bar/line charts
                    vm.chart.options.scales = {
                        xAxes: [{id: 'Ax', gridLines: {color: vm.themes.active.theme.background.hue1.contrast3}, ticks: { maxRotation: 0, fontSize: 10, autoSkipPadding: 10}}],
                        yAxes: [{id: 'Ay', gridLines: {color: vm.themes.active.theme.background.hue1.contrast4}, scaleLabel: { display: true, labelString: vm.chartScaleLabel }, stacked: vm.stacked}]
                    };
                    if (vm.temperature) {
                        vm.chart.options.scales.xAxes.push({id: 'Bx', ticks: { maxRotation: 0, fontSize: 10, autoSkipPadding: 10}, position: 'top', display: false});
                        vm.chart.options.scales.yAxes.push({id: 'By', position: 'right', gridLines: { display: false }, scaleLabel: { display: true, labelString: 'Temperature in °C'}, stacked: false});
                    }
                    vm.chart.options.tooltips = {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                return tooltipItem.yLabel + " " + vm.chartUnitsShown[tooltipItem.datasetIndex];
                            }
                        }
                    };
                    
                    if ((vm.stacked && vm.chart.measurements[0].length > maxNumberOfPoints) || (!vm.stacked && vm.chart.data.length * vm.chart.measurements[0].length > maxNumberOfPoints)) {
                        vm.chart.options.animation.duration = 0;
                        vm.chart.options.legend.position = "top";
                    }
                    else {
                        vm.chart.options.animation.duration = 800;
                        vm.chart.options.legend.position = "bottom";
                    }
                    
                    setChartTitle();
                    getStats();
                    
                    drawjQueryChart("bar");
                    
                    if ((vm.stacked && vm.chart.measurements[0].length > maxNumberOfPoints) || (!vm.stacked && vm.chart.data.length * vm.chart.measurements[0].length > maxNumberOfPoints)) {
                        drawZoomChart();
                    }
                }
                
                // Details
                vm.detailsData = angular.copy(vm.selectedAssignments);
                vm.detailsData.forEach(function(data, i) {
                    if (vm.chart.measurements_original[i] != undefined) {
                        vm.detailsData[i].value = parseFloat(vm.chart.measurements_original[i].reduce(function(a, b) { return a + b.d; }, 0).toFixed(2));
                        vm.detailsData[i].unit = data.specs[0].unit;
                    }
                });
                
                // Options
                setOptions();
                
            }
        }
        
        function splitTotals(totals, levels, distribution) {
            var foo = [];
            switch (distribution) {
                case "linear":
                    for (var i = 0; i < levels; i++) {
                        foo[i] = [];
                        for (var j = 0; j < totals.length; j++) {
                            if (totals[j].r == 1 && i == levels - 1) {
                                foo[i].push(totals[j]);
                            }
                            else {
                                var lower = i / levels;
                                var upper = (i + 1) / levels;
                                if (totals[j].r >= lower && totals[j].r < upper) {
                                    foo[i].push(totals[j]);
                                }
                            }
                        }
                    }
                break;
                case "uniform":
                    totals.sort(function(a, b) {
                        return parseFloat(a.d) - parseFloat(b.d);
                    });
                    var length = Math.ceil(totals.length / levels);
                    for (var i = 0; i < levels; i++) {
                        foo[i] = [];
                        for (var j = 0; j < length; j++) {
                            if (totals[i * length + j] != undefined) {
                                foo[i].push(totals[i * length + j]);
                            }
                        }
                    }
                break;
                case "normal":
                    totals.sort(function(a, b) {
                        return parseFloat(a.d) - parseFloat(b.d);
                    });
                    var total = 0;
                    for (var j = 0; j < totals.length; j++) {
                        total += totals[i].d;
                    }
                    var mean = total / totals.length;
                    
                break;
            }
            return foo;
        }
        
        function splitScheduleTotals(totals) {
            var foo = [[], []];
            for (var i = 0; i < totals.length; i++) {
                foo[0].push(totals[i].d);
                foo[1].push(totals[i].e);
            }
            return foo;
        }
        
        function normalize(foo) {
            // Find max value
            var max = -Number.MAX_SAFE_INTEGER;
            for (var prop in foo) {
                if (foo[prop].d > max) {
                    max = foo[prop].d;
                }
            }
            for (var prop in foo) {
                foo[prop].r = foo[prop].d / max;
            }
        }
        
        var chartAggregated = null;
        function drawjQueryChart(type) {
            if (chartAggregated != null) { chartAggregated.destroy(); chartAggregated = null; }
            var ctx = document.getElementById("chart-aggregated-canvas");
            if (type == "pie") {
                var datasets = [];
                vm.chart.data.forEach(function(data, i) {
                   for (var prop in vm.chart.colors[i]) {
                      if (i == 0) {
                          datasets[prop] = [];
                      }
                      datasets[prop].push(vm.chart.colors[i][prop])
                   }
                });
                datasets.data = vm.chart.data;
                chartAggregated = new Chart(ctx, {
                    type: type,
                    data: { labels: vm.chart.labels, datasets : [ datasets ] },
                    options: vm.chart.options
                });
            }
            else if (type == "bubble") {
                var datasets = [];
                vm.chart.heatmapData.forEach(function(data, i) { 
                    var foo = {};
                    angular.extend(foo, vm.chart.colors[i]);
                    foo.data = vm.chart.heatmapData[i].map(function(d, j) {
                        if (d.r > 0) {
                            if (vm.heatmapRadiusLocked) {
                                d.r = vm.heatmapRadius;
                            }
                            else {
                                d.r *= vm.heatmapRadius;
                            }
                        }
                        else d.r = 0.001; // Bubbles with zero radius have some....
                        return d;
                    });
                    foo.label = vm.chart.labels[i];
                    datasets.push(foo);
                });
                chartAggregated = new Chart(ctx, {
                    type: type,
                    data: { labels: vm.chart.labels, datasets : datasets },
                    options: vm.chart.options
                });
            }
            else if (type == "schedule") {
                var datasets = [];
                vm.chart.scheduleData.forEach(function(data, i) { 
                    var foo = {};
                    angular.extend(foo, vm.chart.colors[i]);
                    vm.chart.override[i] = "bar";
                    foo.data = vm.chart.scheduleData[i];
                    foo.label = vm.chart.series[i];
                    datasets.push(foo);
                });
                
                chartAggregated = new Chart(ctx, {
                    type: "bar",
                    data: { labels: vm.chart.labels, datasets : datasets },
                    options: vm.chart.options
                });
            }
            else {
                var datasets = [];
                vm.chart.data.forEach(function(data, i) { 
                    var foo = {};
                    angular.extend(foo, vm.chart.colors[i]);
                    angular.extend(foo, vm.chart.override[i]);
                    foo.data = vm.chart.data[i];
                    foo.label = vm.chart.series[i];
                    datasets.push(foo);
                });
                chartAggregated = new Chart(ctx, {
                    type: type,
                    data: { labels: vm.chart.labels, datasets : datasets },
                    options: vm.chart.options
                });
            }
        }
        
        var chartSmall = null;
        function drawZoomChart() {
            if (chartSmall != null) { chartSmall.destroy(); chartSmall = null; }
            var ctx = document.getElementById("chart-zoom-canvas");
            var datasets = [];
            vm.chart.data.forEach(function(data, i) { 
                var foo = {};
                angular.extend(foo, getColors('tavg', 99));
                angular.extend(foo, vm.chart.override[i]);
                if (vm.chart.override[i].type == "line") {
                    foo.borderWidth = 1;
                    foo.radius = 2;
                }
                foo.data = vm.chart.data[i];
                foo.label = vm.chart.series[i];
                datasets.push(foo);
            });
            var foo = angular.copy(vm.chart.options);
            foo.title = { display: false };
            foo.legend = { display: false };
            foo.scales.xAxes[0].gridLines = {display: false};
            foo.scales.yAxes[0].display = false;
            if (foo.scales.yAxes[1] != undefined) {
                foo.scales.yAxes[1].display = false;
            }
            foo.tooltips.enabled = false;
            foo.hover = {mode: null};
            foo.annotation = {};
            if (vm.temperature) {
                jQuery(".chart-aggregated-zoom").css("margin", "0 55px");
            }
            else {
                jQuery(".chart-aggregated-zoom").css("margin", "0 50px 0 60px");
            }
            chartSmall = new Chart(ctx, {
                type: "bar",
                data: { labels: vm.chart.labels.map(function(data, i) { return ""}), datasets : datasets },
                options: foo
            });
            jQuery(".chart-aggregated-zoom").css('display', 'block');
            var zoom = getZoomDimensions(jQuery('.zoom-left'));
            zoomIndexScale(zoom);
        }
        
        function removeZoomChart() {
            if (chartSmall != null) { chartSmall.destroy(); chartSmall = null; }
            jQuery(".chart-aggregated-zoom").css('display', 'none');
        }
        
        function compensateFor(type, assignmentIndex, dataIndex) {
            
            addToScaleLabel(type);
            
            var siteIndex = assignmentInSelectedSites(assignmentIndex);
            
            switch (type) {
                
                case 'area':
                    if (vm.selectedSites[siteIndex].metadata.area > 0) {
                        var measurements = chartTmp.data[dataIndex];
                        measurements.forEach(function(measurement, k) {
                            chartTmp.data[dataIndex][k] = (measurement / vm.selectedSites[siteIndex].metadata.area).toFixed(4);
                        });
                    }
                    else {
                        var msg = 'Floor area for site "' + vm.selectedSites[siteIndex].name  + '" is not defined...';
                        if (vm.notifications.indexOf(msg) < 0) {
                            vm.notifications.push(msg);
                            Notification(msg);
                        }
                    }
                break;
                
                case 'volume':
                    if (vm.selectedSites[siteIndex].metadata.volume > 0) {
                        var measurements = chartTmp.data[dataIndex];
                        measurements.forEach(function(measurement, k) {
                            chartTmp.data[dataIndex][k] = (measurement / vm.selectedSites[siteIndex].metadata.volume).toFixed(4);
                        });
                    }
                    else {
                        var msg = 'Building volume for site "' + vm.selectedSites[siteIndex].name  + '" is not defined...';
                        if (vm.notifications.indexOf(msg) < 0) {
                            vm.notifications.push(msg);
                            Notification(msg);
                        }
                    }
                break;
                
                case 'degree-days':
                    if (vm.selectedSites[siteIndex].metadata.heatingBaseTemp == undefined || vm.selectedSites[siteIndex].metadata.heatingBaseTemp == 0) {
                        var msg = 'Heating degree days base temperature for site "' + vm.selectedSites[siteIndex].name  + '" is not defined. Using default value of 18 oC...';
                        if (vm.notifications.indexOf(msg) < 0) {
                            vm.notifications.push(msg);
                            Notification(msg);
                        }
                    }
                    if (vm.selectedSites[siteIndex].metadata.coolingBaseTemp == undefined || vm.selectedSites[siteIndex].metadata.coolingBaseTemp == 0) {
                        var msg = 'Cooling degree days base temperature for site "' + vm.selectedSites[siteIndex].name  + '" is not defined. Using default value of 24 oC...';
                        if (vm.notifications.indexOf(msg) < 0) {
                            vm.notifications.push(msg);
                            Notification(msg);
                        }
                    }
                    
                    var degreeDays = calculateDegreeDays(siteIndex);
                    // calculate sums
                    var measurements = vm.chart.measurements[0];
                    var foo = [];
                    var index = 0;
                    switch (vm.chartZoom) {
                        case '15 m':
                        case '1 h':
                        break;
                        case '1 d':
                            foo = angular.copy(degreeDays.values);
                        break;
                        case '1 w':
                        case '1 M':
                            for (var j = 0; j < degreeDays.values.length; j++) {
                                if (j == 0) {
                                    foo[index] = angular.copy(degreeDays.values[j]);
                                }
                                else if (measurements[index + 1] != undefined && degreeDays.values[j].t > measurements[index + 1].t) {
                                    index++;
                                    foo[index] = angular.copy(degreeDays.values[j]);
                                }
                                else {
                                    foo[index].d += degreeDays.values[j].d;
                                }
                            }
                        break;
                    }
                    var measurements = chartTmp.data[dataIndex];
                    measurements.forEach(function(measurement, k) {
                        if (foo[k] != undefined && foo[k].d > 0) {
                            chartTmp.data[dataIndex][k] = (measurement / foo[k].d).toFixed(4);
                        }
                        else {
                            chartTmp.data[dataIndex][k] = 0;
                        }
                    });
                break;
            }
        }
        
        var calculatedDegreeDays = [];
        function calculateDegreeDays(siteIndex) {
            if (typeof calculatedDegreeDays[siteIndex] != "undefined") {
                return calculatedDegreeDays[siteIndex];
            }
            else {
                var heatingBaseTemp = 18;
                var coolingBaseTemp = 24;
                if (vm.selectedSites[siteIndex].metadata.heatingBaseTemp > 0) {
                    heatingBaseTemp = parseFloat(vm.selectedSites[siteIndex].metadata.heatingBaseTemp);
                }
                if (vm.selectedSites[siteIndex].metadata.coolingBaseTemp > 0) {
                    coolingBaseTemp = parseFloat(vm.selectedSites[siteIndex].metadata.coolingBaseTemp);
                }
                return _calculateDegreeDays(siteIndex, heatingBaseTemp, coolingBaseTemp);
            }
        }
        
        function _calculateDegreeDays(siteIndex, heatingBaseTemp, coolingBaseTemp) {
            for (var i = 0; i < vm.selectedSites; i++) {
                if (vm.selectedSites[i].weather == vm.selectedSites[siteIndex].weather && calculatedDegreeDays[i] != "undefined") {
                    return calculatedDegreeDays[i];
                }
            }
            var temperatures = vm.chart.temperatures[vm.selectedSites[siteIndex].weather];
            var cooling = []; var heating = [];
            var coolingIndex = 0; var heatingIndex = 0;
            temperatures.forEach(function(temperature, k) {
                cooling[k] = {}; heating[k] = {};
                cooling[k].t = temperature.t;
                heating[k].t = temperature.t;
                if (temperature.d != null) {
                    if (temperature.d > coolingBaseTemp) {
                        coolingIndex++;
                        cooling[k].d = temperature.d - coolingBaseTemp;
                        heating[k].d = 0;
                    }
                    else if (temperature.d < heatingBaseTemp) {
                        heatingIndex++;
                        cooling[k].d = 0;
                        heating[k].d = heatingBaseTemp - temperature.d;
                    }
                    else {
                        cooling[k].d = 0;
                        heating[k].d = 0;
                    }
                }
                else {
                    cooling[k].d = -1;
                    heating[k].d = -1;
                }
            });
            if (coolingIndex > heatingIndex) {
                calculatedDegreeDays[siteIndex] = {type: "cooling", values: cooling};
            }
            else {
                calculatedDegreeDays[siteIndex] = {type: "heating", values: heating};
            }
            return calculatedDegreeDays[siteIndex];
        }
        
        function addToScaleLabel(type, remove) {
            if (vm.chartScaleLabel != '') {
                remove = typeof remove !== "undefined" ? remove : false;
                
                var i = inCompensates(type);
                if (i >= 0) {
                    var ereg = new RegExp(vm.compensates[i].label);
                    if (remove) {
                        if (ereg.test(vm.chartScaleLabel)) {
                            vm.chartScaleLabel = vm.chartScaleLabel.replace(vm.compensates[i].label, '');
                        }
                        if (ereg.test(vm.chartUnits[0])) {
                            vm.chartUnits[0] = vm.chartUnits[0].replace(vm.compensates[i].label, '');
                        }
                        
                    }
                    else {
                        if (!ereg.test(vm.chartScaleLabel)) {
                            vm.chartScaleLabel += vm.compensates[i].label;
                        }
                        if (!ereg.test(vm.chartUnits[0])) {
                            vm.chartUnits[0] += vm.compensates[i].label;
                        }
                    }
                }
            }
        }
        
        function removeFromScaleLabel(type) {
            addToScaleLabel(type, true);
        }
        
        function getAssetName(assignment) {
            var assetName = assignment.site.name;
            if (vm.selectedSites.length == 1) {
                assetName = "";
            }
            if ((vm.selectedSites.length == 1 && vm.chartType == "pie") || assignment.device.metadata.name != undefined && assignment.specs[0].type != vm.selectedMeasureType) {
                if (assetName) {
                    assetName += " → ";
                }
                if (assignment.device.metadata.name != undefined) {
                    assetName += assignment.device.metadata.name;
                }
            }
            return assetName;
        }
        
        function setChartTitle() {
            vm.chartTitle = "";
            if (vm.selectedSites.length == 1) {
                vm.chartTitle = vm.selectedSites[0].name;
            }
            else {
                vm.chartTitle = pragmaapi.translate("BREAKDOWN.MULTIPLE_SITES");
            }
            vm.chartTitle += " (" + getMeasureTypeName(vm.selectedMeasureType) + " " + pragmaapi.translate("BREAKDOWN.IN")  + " " + vm.chartUnits[0] + ")";
            vm.chart.options.title.text = vm.chartTitle;
        }
        
        function getLabel(measurement) {
            var format = "";
            switch (vm.chartZoom) {
                case '15 m':
                case '1 h':
                    format = "HH:mm (D/M)";
                    return moment(measurement.t).format(format);
                break;
                case '1 d':
                    format = "MMM D";
                    return [moment(measurement.t).format("dd"), moment(measurement.t).format(format)];
                break;
                case '1 w':
                    format = "Wo YYYY";
                    return moment(measurement.t).format(format);
                break;
                case '1 M':
                    format = "MMM";
                    return moment(measurement.t).format(format);
                break;
            }
        }
        
        function getStats() {
            if (vm.chart.data.length) {
                var total = 0; var avg = 0;
                var min = Number.MAX_SAFE_INTEGER;
                var max = -Number.MAX_SAFE_INTEGER;
                
                if (vm.chartType == 'pie') {
                    for (var i = 0; i < vm.chart.data.length; i++) {
                        var data = parseFloat(vm.chart.data[i]);
                        total += data;
                        if (data < min) min = data;
                        if (data > max) max = data;
                    }
                    avg = total / vm.chart.data.length;
                }
                else {
                    for (var i = 0; i < vm.chart.data.length; i++) {
                        if (vm.chart.override[i] == undefined || vm.chart.override[i].yAxisID == undefined) {
                            for (var j= 0; j< vm.chart.data[i].length; j++) {
                                var data = parseFloat(vm.chart.data[i][j]);
                                total += data;
                                if (data < min) min = data;
                                if (data > max) max = data;
                            }
                        }
                    }
                    if (vm.chart.data[0].length > 0) {
                        avg = total / vm.chart.data[0].length;
                    }
                }
                
                // if (max == 0) min = 0;
                
                vm.chart.stats = {
                    total: filterNumber(total),
                    avg: filterNumber(avg),
                    min: filterNumber(min),
                    max: filterNumber(max)
                }
                
                // Add annotation for avg
                if (vm.stacked && vm.chartType != 'pie') {
                    vm.chart.options.annotation = {}
                    vm.chart.options.annotation.annotations = [{
                        id: 'avg', // optional
                        type: 'line',
                        mode: 'horizontal',
                        scaleID: 'Ay',
                        value: vm.chart.stats.avg,
                        borderColor: 'rgba(3,169,244,1)',
                        borderWidth: 2,
                        borderDash: [6, 3],
                        drawTime: 'afterDatasetsDraw',
                        label: {
                            enabled: true,
                            position: "right",
                            backgroundColor: 'rgba(3,169,244,0.8)',
                            content: "avg: " + vm.chart.stats.avg + " " + vm.chartUnits[0]
                        }
                    }];
                }
                else {
                    delete vm.chart.options.annotation;
                }
            }
        }
        
        function getScheduleStats() {
            if (vm.chart.scheduleData.length) {
                var total = 0; var func = [0, 0];
                var ratio = 100;
                
                for (var i = 0; i < vm.chart.scheduleData.length; i++) {
                    for (var j= 0; j< vm.chart.scheduleData[i].length; j++) {
                        var data = parseFloat(vm.chart.scheduleData[i][j]);
                        total += data;
                        func[i] += data;
                    }
                }
                
                if (total) {
                    ratio = filterNumber(func[0] / total * 100);
                }
                
                vm.chart.stats = {
                    total: filterNumber(total),
                    func: filterNumber(func[0]),
                    nfunc: filterNumber(func[1]),
                    ratio: filterNumber(ratio)
                }
            }
        }
        
        function filterNumber(number) {
            if (Math.abs(number) < 100) {
                return $filter('number')(number, 2);
            }
            else if (Math.abs(number) < 1000) {
                return $filter('number')(number, 1);
            }
            else {
                return $filter('number')(number, 0);
            }
        }
        
        function resetChart() {
            Chart.defaults.global.defaultFontFamily = 'Roboto, "Helvetica Neue", sans-serif';
			Chart.defaults.global.defaultFontColor = vm.themes.active.theme.background.hue1.contrast1;
			Chart.defaults.global.defaultColor = vm.themes.active.theme.background.hue1.contrast1;
			
            vm.chart = {
                from: '', to: '',
                labels: [],
                data: [],
                measurements: [],
                measurements_original: [],
                stations: [],
                temperatures: [],
                options: {
					pan: {
                        sensitivity: 0,
                        enabled: true,
                        mode: 'x'
                    },
                    zoom: {
                        sensitivity: 0,
                        enabled: true,
                        mode: 'x',
                    },
                    title: {
                        display: true,
                        position: "top",
                        fontSize: 16,
                        text: ""
                    },
                    legend: {
                        display: true,
                        position: "top"
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: {
                      duration: 800
                    },
                    scales: {},
                    tooltips: {},
                    elements: {
                        point: {
                            pointStyle: 'circle'
                        }
                    }
                },
                series: [],
                override: [],
                click: function() {},
                hover: function() {
                },
                colors: [],
                stats: {
                    total: 0, avg: 0,
                    min: 0, max: 0
                }
            };
            vm.smallChart = {};
        }

        function changeOptions() {
            drawChart();
        }
        
        function selectMeasureType() {
            drawChart();
        }
        
        function selectUnit() {
            drawChart();
        }
        
        function selectCompensate(type, no_refresh) {
            if (type != '') {
                var pos = jQuery.inArray(type, vm.selectedCompensate);
                if (pos < 0) {
                    addToScaleLabel(type);
                    vm.selectedCompensate.push(type);
                }
                else {
                    removeFromScaleLabel(type);
                    vm.selectedCompensate.splice(pos, 1);
                }
            }
            else {
                for (var i = 0; i < vm.selectedCompensate.length; i++) {
                    removeFromScaleLabel(vm.selectedCompensate[i]);
                }
                vm.selectedCompensate = [];
            }
            
            if (vm.selectedCompensate.length) {
                jQuery(".compensate-button").removeClass('md-raised').addClass('active');
            }
            else {
                jQuery(".compensate-button").removeClass('active').addClass('md-raised');
            }
            
            if (!no_refresh) {
                if (vm.selectedCompensate.indexOf('degree-days') >= 0) {
                    visualizeData();
                }
                else {
                    drawChart();
                }
            }
        }
        
        function setKPI(KPI, no_refresh) {
            jQuery('#kpi-ctrl button').removeClass('md-accent');
            jQuery('.kpi-' + KPI).addClass('md-accent');
            vm.chartKPI = KPI;
            if (!no_refresh) {
                visualizeData();
            }
        }
        
        function setZoom(zoom, no_refresh) {
            jQuery('#zoom-ctrl button').removeClass('active');
            jQuery('.zoom-' + zoom.slice(-1)).addClass('active');
            vm.chartZoom = zoom;
            if (!no_refresh) {
                visualizeData();
            }
        }
        
        function buttonToggle(type, inverse) {
            vm[type] = (vm[type]) ? false : true;
            if (inverse) {
                if (vm[type]) {
                    jQuery("." + type + "-button").removeClass('active').addClass('md-raised');
                }
                else {
                    jQuery("." + type + "-button").removeClass('md-raised').addClass('active');
                }
            }
            else {
                if (vm[type]) {
                    jQuery("." + type + "-button").removeClass('md-raised').addClass('active');
                }
                else {
                    jQuery("." + type + "-button").removeClass('active').addClass('md-raised');
                }
            }
            visualizeData();
        }
        
        function setOption(type, option, inverse) {
            vm[type] = option;
            if (inverse) {
                if (option) {
                    jQuery("." + type + "-button").removeClass('active').addClass('md-raised');
                }
                else {
                    jQuery("." + type + "-button").removeClass('md-raised').addClass('active');
                }
            }
            else {
                if (option) {
                    jQuery("." + type + "-button").removeClass('md-raised').addClass('active');
                }
                else {
                    jQuery("." + type + "-button").removeClass('active').addClass('md-raised');
                }
            }
        }
        
        function setChartType(chartType) {
            
            var should_update = false;
            
            if (vm.chartType == "functional") should_update = true;
            
            if (vm.chartType == "heatmap") {
                loadOptions(vm.graphOptionsCache);
                should_update = true
            }
            
            vm.chartType = chartType;
            jQuery(".chartType-button").removeClass('active').addClass('md-raised');
            jQuery("." + chartType + "-button").removeClass('md-raised').addClass('active');
            
            if (chartType == "heatmap") {
                // Load default graph
                vm.graphOptionsCache = getOptions();
                vm.loadGraph("default");
                should_update = false;
            }
            
            if (chartType == "functional" || should_update) {
                visualizeData();
            }
            else {
                drawChart();
            }
        }
        
        function getColors(type, index) {
            var color = '';
            if (type == 'tavg') {
                color = palette['color' + (index + 1)];
                return {
                    lineTension : 0.4,
                    borderColor: "rgba(" + color + ",1)",
                    backgroundColor: "rgba(" + color + ",0)",
                    pointBorderColor: "#fff",
                    pointBackgroundColor: "rgba(" + color + ",1)",
                    pointHoverBorderColor: "rgba(" + color + ",1)",
                    pointHoverBackgroundColor: "#fff"
                }
            }
            else if (vm.chartType == 'functional') {
                color = palette['color' + index];
            }
            else if (vm.chartType == 'pie') {
               /* if (vm.selectedSites.length == 1) {
                    color = palette[type];
                }
                else {
                    color = palette['color' + (chartTmp.labels.length + 1)];
                }*/
                color = palette['color' + (chartTmp.labels.length + 1)];
            }
            else if (vm.stacked) {
                color = palette[type];
            }
            else {
              /*  if (vm.selectedSites.length == 1) {
                    color = palette[type];
                }
                else {
                    color = palette['color' + chartTmp.series.length];
                }*/
                color = palette['color' + chartTmp.series.length];
            }
            switch (vm.chartType) {
                case 'line':
                    return {
                        lineTension : 0.4,
                        borderColor: "rgba(" + color + ",1)",
                        backgroundColor: "rgba(" + color + ",0.1)",
                        pointBorderColor: "#fff",
                        pointBackgroundColor: "rgba(" + color + ",1)",
                        pointHoverBorderColor: "rgba(" + color + ",1)",
                        pointHoverBackgroundColor: "#fff"
                    }
                break;
                case 'pie':
                case 'bar':
                case 'functional':
                    return {
                        borderColor: "rgba(" + color + ",1)",
                        backgroundColor: "rgba(" + color + ",0.6)",
                    }
                break;
            }
        }
        
        function getHeatmapColors(index) {
            var color = 0;
            var base = 0.2;
            var step = 0.2;
            var l = 50;
            switch (vm.heatmapColor) {
                case 'spectrum':
                    color = Math.floor(90 * (1 - ((index + 1) / vm.heatmapLevels)));
                    base = 0.6;
                    step = 0.1;
                break;
                case 'red':
                    color = 0;
                break;
                case 'green':
                    color = 120;
                    l = 30;
                break;
                case 'blue':
                    color = 210;
                break;
            }
            return {
                borderColor: "hsla(" + color + ", 90%, " + l + "%," + (base + (index * step)) + ")",
                backgroundColor: "hsla(" + color + ", 90%, " + l + "%," + (base + (index * step)) + ")"
            }
        }
        
        function getHeatmapLabels(index) {
            var res = pragmaapi.translate('BREAKDOWN.HEATMAP_NO_VALUES');
            if (chartTmp.heatmapData[index].length) {
                var minmax = getMinMax(chartTmp.heatmapData[index]);
                if (index == 0) {
                    res = "<= " + minmax.max;
                }
                else if (index == vm.heatmapLevels - 1) {
                    res = ">= " + minmax.min;
                }
                else {
                    if (minmax.min == minmax.max) {
                        res = minmax.min;
                    }
                    else {
                        res = minmax.min + " - " + minmax.max;
                    }
                }
            }
            return res;
        }
        
        function getMinMax(array) {
            var min = Number.MAX_SAFE_INTEGER;
            var max = -Number.MAX_SAFE_INTEGER;
            for (var i = 0; i < array.length; i++) {
                if (array[i].d > max) max = array[i].d;
                if (array[i].d < min) min = array[i].d;
            }
            return {min: min, max: max}
        }
        
        function inCompensates(type) {
            for (var i = 0; i < vm.compensates.length; i++) {
                if (vm.compensates[i].id == type) {
                    return i;
                }
            }
            return -1;
        }
        
        function inSelectedSites(token) {
            var res = -1;
            for (var i = 0; i < vm.selectedSites.length; i++) {
                if (vm.selectedSites[i].token == token) {
                    res = i;
                    break;
                }
            }
            return res;
        }
        
        function assignmentInSelectedSites(index) {
            var res = -1;
            for (var i = 0; i < vm.selectedSites.length; i++) {
                if (vm.selectedSites[i].assignmentIndices.indexOf(index) >= 0) {
                    res = i;
                    break;
                }
            }
            return res;
        }
        
        function inMeasureTypes(type) {
            var res = false;
            for (var i = 0; i < vm.measureTypes.length; i++) {
                if (vm.measureTypes[i].id == type) {
                    res = true;
                    break;
                }
            }
            return res;
        }
        
        function inMeasureTypesAll(arr) {
            var res = true;
            for (var i = 0; i < vm.measureTypes.length; i++) {
                if (arr.indexOf(vm.measureTypes[i].id) < 0) {
                    res = false;
                    break;
                }
            }
            return res;
        }
        
        function getMeasureTypeName(type) {
            var res = "";
            for (var i = 0; i < vm.measureTypes.length; i++) {
                if (vm.measureTypes[i].id == type) {
                    res = pragmaapi.translate(vm.measureTypes[i].translation);
                    break;
                }
            }
            return res;
        }
        
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
        
        function toggleClose(sidenavId) {
            $mdSidenav(sidenavId).close();
        }
        
        function changeStatusL(sidenavId) {
                $mdSidenav(sidenavId).close();
                if(vm.lockLeft)
                vm.lockLeft=!vm.lockLeft;
        }
        
        function setOptions() {
            vm.optionsData.dates = moment(vm.date.startDate).format("MMM D, YYYY") + " - " + moment(vm.date.endDate).format("MMM D, YYYY");
            vm.optionsData.chartType = ucfirst(vm.chartType) + " chart";
            vm.optionsData.temperature = (vm.temperature) ? "On" : "Off";
            vm.optionsData.compare = (vm.stacked) ? "Off" : "On";
            vm.optionsData.compensate = "";
            for (var i = 0; i < vm.compensates.length; i++) {
                if (vm.selectedCompensate.indexOf(vm.compensates[i].id) >= 0) {
                    vm.optionsData.compensate += vm.compensates[i].name + ", ";
                }
            }
            if (vm.optionsData.compensate == "") {
                vm.optionsData.compensate = "None";
            }
            else {
                vm.optionsData.compensate = vm.optionsData.compensate.substring(0, vm.optionsData.compensate.length - 2);
            }
            vm.optionsData.chartKPI = ucfirst(vm.chartKPI);
            switch (vm.chartZoom) {
                case "15 m": vm.optionsData.chartZoom = "15Min"; break;
                case "1 h": vm.optionsData.chartZoom =  "Hourly";  break;
                case "1 d": vm.optionsData.chartZoom =  "Day";   break;
                case "1 w": vm.optionsData.chartZoom =  "Week";  break;
                case "1 M": vm.optionsData.chartZoom =  "Month"; break;
            }
        }
    
        function exportCSV() {
			if (chartAggregated != null) {
				var csvContent = '';
				for(var i=0; i < chartAggregated.data.datasets.length; i++) {
					var label = chartAggregated.data.datasets[i].label;
					label = label.split(',').join('.');
					csvContent += label + ",";
				}
				csvContent += 'Timestamp' + "";
				csvContent += "\n";
				
				for(var j=0; j < chartAggregated.data.datasets[0].data.length; j++) {
					for(var k=0; k < chartAggregated.data.datasets.length; k++) {
						var label = chartAggregated.data.datasets[k].data[j];
						csvContent += label + ",";
					}
					var t = moment(vm.chart.measurements[0][j].t).format('YYYY-MM-DDTHH:mm:ss');
					csvContent+=t;
					csvContent+="\n";
				}
				
				var encodedUri = encodeURI(csvContent);
				var link = document.createElement("a");
				link.setAttribute("href", "data:text/csv;charset=utf-8," + encodedUri);
				link.setAttribute("download", "breakdown_raw_data_" + $filter('date')(new Date(),'yyyy_MM_dd') + ".csv");
				document.body.appendChild(link); // Required for FF
				link.click();
				
			}
        }

        function saveImage(element) {
            var canvas = document.getElementById(element);			
			canvas.style.color="black";
            var ctx = canvas.getContext("2d");
			
			var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
			//console.log(imgData);
			
            var url_base64 = canvas.toDataURL('image/png');
            var link = document.createElement("a");
            link.setAttribute("href", url_base64);
            link.setAttribute("download", "breakdown.png");
            document.body.appendChild(link); // Required for FF
            link.click();
        }
        
        function ucwords(str) {
            str = str.replace(/_/g, ' ');
            return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        }        
        
        function ucfirst(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
        
        function pad(n, width, z) {
          z = z || '0';
          n = n + '';
          return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        
        function updateStatus(msg, spin) {
            if (spin == undefined) spin = false;
            jQuery(".status").html('<span class="msg-spinner' + (spin ? '' : ' static') + '"></span> &nbsp; ' + msg);
        }
        
        //////////
        
       vm.saveGraph = function (ev) {
            $mdDialog.show({
                controller         : 'SaveGraphController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/breakdown/dialogs/saveGraph/save-graph.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    chartType      : vm.chartType,
                    savedGraph     : vm.savedGraph,
                    savedGraphs    : vm.savedGraphs
                }
            }).then(function(res) {
            },function () {});
        }

        vm.deleteGraph = function openDeleteGraphDialog(ev, event) {
            $mdDialog.show({
                controller         : 'DeleteGraphController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/breakdown/dialogs/deleteGraph/delete-graph.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    audit: event
                }
            }).then(function (res) {
                
            },function () {});
        }
        
        vm.openSearchDialog = function openSearchDialog(ev)
        {
            $mdDialog.show({
                controller         : 'BreakdownSearchController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/breakdown/dialogs/breakdownSearch/breakdown-search.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    user: vm.user
                }
            }).then(function (answer)
            {
            },function () {});
        }
    }
        
})();
(function ()
{
    'use strict';

    angular
        .module('app.admin')
        .controller('AdminController', AdminController);

    function AdminController($cookies,msNavigationService, pragmaapi,$scope, $element, $state, $http, $mdSidenav, msApi, session, $rootScope, $mdDialog, $document, $base64, Notification, filterFilter, PRAGMA)
    {
        // Declare Variables 
        var vm = this;
        vm.user = session.getUser();
        
        vm.spinner=false;
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.usersTable={};
        vm.notificationTable={};
        vm.tariffsTable={};
        vm.costsTable={};
        vm.costProfilesTable={};
        vm.tenantsTable={};
        vm.sitesTable={};
        vm.assetsTable={};
        vm.assetCategoriesTable={};
        vm.siteGroupsTable={};
        vm.specificationsTable={};
        vm.assetCategories=[];
        vm.deviceGroupsTable={};
        vm.users={};
        vm.tariffs={};
        vm.costs=[];
        vm.costProfiles={};
        vm.tenants=[];
        vm.selectedTenant={};
        vm.selectedTab = 0;
        vm.allFields = false;
        vm.sitesTenant="";
        vm.devicesSite="";
        vm.specifications=[];
        vm.verticalsTable={};
        vm.deviceGroups=[];
        vm.deviceGroupDevices=[];
        vm.deviceGroupDevicesTable={};
        vm.deviceGroupTable={};
        vm.sites={};
		vm.selectedSite='';
        vm.notifications={};
        vm.devices=[];
        vm.verticals=[];
        vm.deviceTable={};
        vm.assets=[];
        vm.currentSites={};
        vm.currentAsset={};
        vm.currentDeviceGroup={};
        vm.currentCostProfile={};
        vm.assetShow=0;
        vm.searchTenant='';
        vm.searchSite='';
        vm.siteGroupSitesTable={};
        vm.url = PRAGMA.api;
        vm.pragmaApi=PRAGMA.pragma;
        vm.toggleSidenav = toggleSidenav;
        vm.openNewUserDialog = openNewUserDialog;
        vm.openNewTenantDialog = openNewTenantDialog;
        vm.openEditUserDialog = openEditUserDialog;
        vm.openDeleteUserDialog = openDeleteUserDialog;
        vm.openDeleteTenantDialog = openDeleteTenantDialog;
        vm.openEditTenantDialog=openEditTenantDialog;
        vm.startStopTenant=startStopTenant;
        vm.fillSitesTable=fillSitesTable;
        vm.fillTariffsTable=fillTariffsTable;
        vm.fillCostProfilesTable=fillCostProfilesTable;
        vm.fillAssetsTable=fillAssetsTable;
        vm.openNewSiteDialog=openNewSiteDialog;
        vm.openDeleteSiteDialog=openDeleteSiteDialog;
        vm.openEditSiteDialog=openEditSiteDialog;
        vm.openNewAssetDialog=openNewAssetDialog;
        vm.openEditAssetDialog=openEditAssetDialog;
        vm.openDeleteAssetDialog=openDeleteAssetDialog;
        vm.fillAssetsCategoryTable=fillAssetsCategoryTable;
        vm.openNewAssetCategoryDialog=openNewAssetCategoryDialog;
        vm.openDeleteAssetCategoryDialog=openDeleteAssetCategoryDialog;
        vm.openEditAssetCategoryDialog=openEditAssetCategoryDialog;
        vm.fillSpecificationsTable=fillSpecificationsTable;
        vm.openNewSpecificationDialog=openNewSpecificationDialog;
        vm.openEditSpecificationDialog=openEditSpecificationDialog;
        vm.openDeleteSpecificationDialog=openDeleteSpecificationDialog;
        vm.fillPortfoliosTable=fillPortfoliosTable;
        vm.fillDeviceSitesTable=fillDeviceSitesTable;
        vm.fillDeviceTable=fillDeviceTable;
        vm.openNewDeviceDialog=openNewDeviceDialog;
        vm.openEditDeviceDialog=openEditDeviceDialog;
        vm.openDeleteDeviceDialog=openDeleteDeviceDialog;
        vm.openReleaseAssignmentDialog=openReleaseAssignmentDialog;
        vm.openAssignDeviceDialog=openAssignDeviceDialog;
        vm.fillAllTenants=fillAllTenants;
        vm.stopPropagation=stopPropagation;
        vm.clearSearchTenant=clearSearchTenant;
        vm.openNewSiteGroupDialog=openNewSiteGroupDialog;
        vm.fillSiteGroupSitesTable=fillSiteGroupSitesTable;
        
        vm.openNewSiteGroupSitesDialog=openNewSiteGroupSitesDialog;
        vm.openDeleteSiteGroupSitesDialog=openDeleteSiteGroupSitesDialog;
        vm.openEditSiteGroupDialog=openEditSiteGroupDialog;
        vm.openDeleteSiteGroupDialog=openDeleteSiteGroupDialog;
        vm.openNewTariffDialog=openNewTariffDialog;
        vm.openEditTariffDialog=openEditTariffDialog;
        vm.openDeleteTariffDialog=openDeleteTariffDialog;
        vm.openNewCostDialog=openNewCostDialog;
        vm.openEditCostDialog=openEditCostDialog;
        vm.openDeleteCostDialog=openDeleteCostDialog;
        vm.openNewCostProfileDialog=openNewCostProfileDialog;
        vm.openEditCostProfileDialog=openEditCostProfileDialog;
        vm.openDeleteCostProfileDialog=openDeleteCostProfileDialog;
        vm.fillCostProfileCostsTable=fillCostProfileCostsTable;
        vm.openNewNotificationDialog=openNewNotificationDialog;
        vm.openEditNotificationDialog=openEditNotificationDialog;
        vm.openDeleteNotificationDialog=openDeleteNotificationDialog;
        vm.openNewDeviceGroupDialog=openNewDeviceGroupDialog;
        vm.openDeleteDeviceGroupDialog=openDeleteDeviceGroupDialog;
        vm.openEditDeviceGroupDialog=openEditDeviceGroupDialog;
        vm.fillDeviceGroupDevicesTable=fillDeviceGroupDevicesTable;
        vm.openNewDeviceGroupDevicesDialog=openNewDeviceGroupDevicesDialog;
        vm.openDeleteDeviceGroupDevicesDialog=openDeleteDeviceGroupDevicesDialog
        vm.selectedTab = $state.current.tab;
        vm.changeTab=changeTab;
        vm.changeStatusL=changeStatusL;
        vm.openNewVerticalDialog=openNewVerticalDialog;
        vm.openEditVerticalDialog=openEditVerticalDialog;
        vm.openDeleteVerticalDialog=openDeleteVerticalDialog;
        vm.lockLeft=true;
        fillUsersTable();
        fillVerticalsTable();
        fillNotificationTable();
        vm.versionNo=0;
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
        function changeStatusL(sidenavId) {
            $mdSidenav(sidenavId).close();
            if(vm.lockLeft)
                vm.lockLeft=!vm.lockLeft;
        }
        $scope.$on('change.module', function(event, args) {
			if(args.parent==='#')
            {
                var tmp="";
            }
            else
            {
                var tmp=args.token
            }
            fillDeviceTableModule(vm.devicesSite,tmp);
        });
        function fillDeviceTableModule(id,tmp)
        {
			callRestService(vm.url,"/devices/","?site="+id+"&page=1&pageSize=1000&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken="+vm.sitesTenant,true,vm.user.authentication,"GET").then(function(res){
                var devices=res.data.results;
                vm.devices=[];
                if(!tmp)
                {
                    vm.devices=res.data.results;
                }
                else
                {
                    if(tmp=='')
                    {
                        vm.devices=res.data.results;
                    }
                    else
                    {
                        for(var i=0;i<devices.length;i++)
                        {
                            if(devices[i].modules.indexOf(tmp)>-1)
                            {
                                vm.devices.push(devices[i]);
                            }
                               
                        }
                    }
                }
                vm.deviceTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                    return vm.devices.length ? vm.devices.length : 0;
                    }
                }];
                vm.deviceTable.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.deviceTable.query = {
                    order: 'name',
                    limit: 10,
                    page: 1
                };
                vm.deviceTable.filter = {
                    search: ''
                };
            });
        }  
        function changeTab(id)
        {
            vm.selectedTab=id;
            if(vm.selectedTab==2 || vm.selectedTab==3 || vm.selectedTab==4 || vm.selectedTab==5 || vm.selectedTab==6 || vm.selectedTab==10)
            {
                var filter={
                    device:{},
                    site:{},
                    specification:{},
                    includeSites:false,
                    includeDevices:false,
                    includeMeasurements:false,
                    specs:[],
                    measurements:{}
                };
                pragmaapi.getTreeDataFilter(filter).then(function(treeData) {
                    vm.treeData = treeData;
                    vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'state']);
                    vm.versionNo++;
                    vm.treeConfig.version = vm.versionNo;
                });
            }
            else
            {
                var filter={
                    device:{},
                    site:{},
                    specification:{},
                    includeSites:true,
                    includeDevices:false,
                    includeMeasurements:false,
                    specs:[],
                    measurements:{}
                };
                pragmaapi.getTreeDataFilter(filter).then(function(treeData) {
                    vm.treeData = treeData;
                    vm.treeConfig = pragmaapi.getTreeConfig(['types', 'search', 'wholerow', 'state']);
                    vm.versionNo++;
                    vm.treeConfig.version = vm.versionNo;
                });
            }
        }
        vm.applySearch = function () {
            if (vm.treeInstance) {
                vm.treeInstance.jstree(true).search(vm.searchtree);
            }
        };
        vm.treeEvents = {
            'ready': readyCB,
            'create_node': createNodeCB,
            'select_node': getSelectedNodes,
            'deselect_node': getSelectedNodes
        }
        function getSelectedNodes() {
            vm.selected_nodes=[];
            vm.selectedNode = {};
            var siteToken="";
            var authenticationToken="";
            var jstree = vm.treeInstance.jstree(true);
            vm.selected_nodes = jstree.get_selected();
            if (vm.selected_nodes[0]) {
                vm.selectedNode = jstree.get_node(vm.selected_nodes[0]);
            }
            if(vm.selectedTab==2 || vm.selectedTab==3 || vm.selectedTab==4 || vm.selectedTab==5 || vm.selectedTab==6)
            {
                for (var i = 0; i < vm.treeData.length; i++) {
                    if(vm.treeData[i].type=='client' && vm.treeData[i].id==vm.selectedNode.id)
                    {
                        authenticationToken=vm.treeData[i].tenantAuthToken;
                        break;
                    }
                }
                for(var i=0;i<vm.tenants.length;i++)
                {
                    if(vm.tenants[i].authenticationToken==authenticationToken)
                    {
                        vm.selectedTenant=vm.tenants[i];
                        vm.sitesTenant=vm.tenants[i].authenticationToken;
                        break;
                    }
                }
                fillAllTenants();
            }
            else
            {
                for (var i = 0; i < vm.treeData.length; i++) {
                    if(vm.treeData[i].type=='site' && vm.treeData[i].id==vm.selectedNode.id)
                    {
                        vm.selectedSite=vm.selectedNode.text;
						authenticationToken=vm.treeData[i].tenantAuthToken;
                        siteToken=vm.treeData[i].token;
                        vm.devicesSite=siteToken;
                        break;
                    }
                }
                for(var i=0;i<vm.tenants.length;i++)
                {
                    if(vm.tenants[i].authenticationToken==authenticationToken)
                    {
                        vm.selectedTenant=vm.tenants[i];
                        vm.sitesTenant=vm.tenants[i].authenticationToken;
                        fillDeviceTable(siteToken);
                        fillDeviceGroupTable(siteToken);
                        break;
                    }
                }
            }
        }
        
        function readyCB() {
        }
        function createNodeCB() {
        }
        function clearSearchTenant()
        {
            vm.searchTenant='';
            vm.searchSite='';
        }
        function stopPropagation(ev)
        {
            ev.stopPropagation();
        }

         // Notifications
        function fillNotificationTable()
        {
            vm.notifications=[];
            callRestService(vm.url,"/streamNotifications/userId/"+vm.user.username,"?count="+1000,true,vm.user.authentication,"GET").then(function(res){
                for(var i=0;i<res.data.results.length;i++)
                {
                    var tmp=res.data.results[i];
                    tmp.notificationService="streamNotifications";
                    vm.notifications.push(tmp);
                }
                callRestService(vm.url,"/batchNotifications/userId/"+vm.user.username,"?count="+1000,true,vm.user.authentication,"GET").then(function(res){
                    for(var i=0;i<res.data.results.length;i++)
                    {
                        var tmp=res.data.results[i];
                        tmp.notificationService="batchNotifications";
                        vm.notifications.push(tmp);
                    }
                    vm.notificationTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                    return vm.notifications.length ? vm.notifications.length : 0;
                    }
                    }];
                    vm.notificationTable.options = {
                        rowSelection: false,
                        multiSelect: false,
                        autoSelect: false,
                        decapitate: false,
                        largeEditDialog: false,
                        boundaryLinks: false,
                        limitSelect: true,
                        pageSelect: true
                    };
                    vm.notificationTable.query = {
                        order: 'name',
                        limit: 10,
                        page: 1
                    };
                    vm.notificationTable.filter = {
                        search: ''
                    };
                });
            });
        }
        function openNewNotificationDialog(ev,notification)
        {
            $mdDialog.show({
                controller         : 'NewNotificationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newNotification/new-notification.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tenants:vm.tenants,
                    user:vm.user,
                    url:vm.url
                }
            }).then(function (answer)
            {  
                fillNotificationTable();
            },function () {});
        }
        function openEditNotificationDialog(ev,notification)
        {
            $mdDialog.show({
                controller         : 'EditNotificationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editNotification/edit-notification.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    notification:notification,
                    user:vm.user,
                    url:vm.url
                }
            }).then(function (answer)
            {  
                fillNotificationTable();
            },function () {});
        }
        function openDeleteNotificationDialog(ev,notification)
        {
            $mdDialog.show({
                controller         : 'DeleteNotificationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteNotification/delete-notification.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    notification:notification
                }
            }).then(function (answer)
            { 
                callRestService(vm.url,"/"+answer.type+"/"+answer.message,"?force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    fillNotificationTable();
                    showNotification("Notification","Notification Type Deleted Successfully!","Success");
                },function(reason) {
                    showNotification("Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }   

        // Assignments
        function openAssignDeviceDialog(ev,device)
        {
            $mdDialog.show({
                controller         : 'AssignDeviceController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/assignDevice/assign-device.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    device:device,
                    thisTenant:vm.sitesTenant,
                    user:vm.user.authentication,
                    url:vm.url
                }
            }).then(function (answer)
            {		
                callRestService(vm.url,"/assignments?tenantAuthToken="+vm.sitesTenant,answer,true,vm.user.authentication,"POST").then(function(res){
                    fillDeviceTable(vm.devicesSite);
                    showNotification("Assignment Notification","Device Assigned Successfully!","Success");
                },function(reason) {
                    fillDeviceTable(vm.devicesSite);
                    showNotification("Assignment Notification","Device Assigned Successfully!","Success");
                });
            },function () {});
        }
        function openReleaseAssignmentDialog(ev,device)
        {
            $mdDialog.show({
                controller         : 'ReleaseAssignmentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/releaseAssignment/release-assignment.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    device:device
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/assignments/"+answer+"/end?tenantAuthToken="+vm.sitesTenant,"",true,vm.user.authentication,"POST").then(function(res){
                    fillDeviceTable(vm.devicesSite);
                    showNotification("Assignment Notification","Assignment Released from the Device Successfully!","Success");
                },function(reason) {
                    fillDeviceTable(vm.devicesSite);
                    showNotification("Assignment Notification","Assignment Released from the Device Successfully!","Success");
                });
            },function () {});
        }

        // Devices
        function fillDeviceTable(id)
        {
            vm.currentModule=vm.user.currentModule;
            vm.parentModule=vm.user.parentModule;
            if(vm.currentModule==='' || vm.parentModule==='#')
            {   
                callRestService(vm.url,"/devices/","?site="+id+"&page=1&pageSize=1000&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken="+vm.sitesTenant,true,vm.user.authentication,"GET").then(function(res){
                    vm.devices=res.data.results;
                    vm.deviceTable.limitOptions = [5, 10, 15, {
                        label: 'All',
                        value: function () {
                        return vm.devices.length ? vm.devices.length : 0;
                        }
                    }];
                    vm.deviceTable.options = {
                        rowSelection: false,
                        multiSelect: false,
                        autoSelect: false,
                        decapitate: false,
                        largeEditDialog: false,
                        boundaryLinks: false,
                        limitSelect: true,
                        pageSelect: true
                    };
                    vm.deviceTable.query = {
                        order: 'name',
                        limit: 10,
                        page: 1
                    };
                    vm.deviceTable.filter = {
                        search: ''
                    };
                });
            }
            else
            {
                fillDeviceTableModule(id,vm.currentModule);
            }
        }   
        function fillDeviceSitesTable(id)
        {
            
            if(vm.user.role!=="level05" && vm.user.role!=="level04")
            {
                 callRestService(vm.url,"/sites","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                    vm.currentSites=res.data;
                    vm.devicesSite=vm.currentSites.results[0].token;
                    fillDeviceTable(vm.devicesSite);
                });
            }
            else
            {
                 callRestService(vm.url,"/sites/"+vm.user.username+"/user","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                      vm.currentSites={
                         results:res.data
                     };
                    vm.devicesSite=vm.currentSites.results[0].token;
                    fillDeviceTable(vm.devicesSite);
                 });
            }
        }
        function openNewDeviceDialog(ev)
        {
            $mdDialog.show({
                controller         : 'NewDeviceController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newDevice/new-device.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tenants:vm.tenants,
                    user:vm.user,
                    url:vm.url,
                    thisTenant: vm.sitesTenant,
                    thisSite:vm.devicesSite
                }
            }).then(function (answer)
            {		
                fillDeviceTable(vm.devicesSite);
                /*callRestService(vm.url,"/devices?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"POST").then(function(res){
                   
                   showNotification("Device Notification","Device Inserted Successfully!","Success");
                },function(reason) {
                    showNotification("Device Notification","Something Went Wrong!","Error");
                });*/
            },function () {});
        }
        function openEditDeviceDialog(ev,device)
        {
            $mdDialog.show({
                controller         : 'EditDeviceController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editDevice/edit-device.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    device:device,
                    tenants:vm.tenants,
                    thisTenant:vm.sitesTenant,
                    user:vm.user,
                    url:vm.url
                }
            }).then(function (answer)
            {		
               callRestService(vm.url,"/devices/"+answer.hardwareId+"?tenantAuthToken="+vm.sitesTenant,answer,true,vm.user.authentication,"PUT").then(function(res){
                    fillDeviceTable(vm.devicesSite);
                    showNotification("Device Notification","Device Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Device Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openDeleteDeviceDialog(ev,device)
        {
            $mdDialog.show({
                controller         : 'DeleteDeviceController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteDevice/delete-device.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    device:device
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/devices/",answer+"?tenantAuthToken="+vm.sitesTenant+"&force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    fillDeviceTable(vm.devicesSite);
                    showNotification("Device Notification","Device Deleted Successfully!","Success");
                },function(reason) {
                    showNotification("Device Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function fillDeviceGroupDevicesTable(id)
        {
            vm.deviceGroupDevices=[];
            vm.assetShow=2;
            vm.currentDeviceGroup=id;
            for(var i=0;i<vm.currentDeviceGroup.elements.length;i++)
            {
                if(vm.currentDeviceGroup.elements[i].type==="device")
                {
                    for(var j=0;j<vm.devices.length;j++)
                    {
                        if(vm.currentDeviceGroup.elements[i].token===vm.devices[j].hardwareId)
                        {
                            var tmp=
                            {
                                token:vm.devices[j].hardwareId,
                                name:vm.devices[j].metadata.name,
                                image:vm.devices[j].specification.assetImageUrl,                             
                                type:"device"
                            }
                            vm.deviceGroupDevices.push(tmp);
                            break;
                        }
                    }
                }
                else
                {
                    for(var j=0;j<vm.deviceGroups.length;j++)
                    {
                        if(vm.currentDeviceGroup.elements[i].token===vm.deviceGroups[j].token)
                        {
                            var tmp=
                            {
                                token:vm.deviceGroups[j].token,
                                name:vm.deviceGroups[j].name,
                                image:"",                             
                                type:"group"
                            }
                            vm.deviceGroupDevices.push(tmp);
                            break;
                        }
                    }
                } 
            }
            vm.deviceGroupDevicesTable={};
            vm.deviceGroupDevicesTable.limitOptions = [5, 10, 15, {
                label: 'All',
                value: function () {
                return vm.deviceGroupDevices.length ? vm.deviceGroupDevices.length : 0;
                }
            }];
            vm.deviceGroupDevicesTable.options = {
                rowSelection: false,
                multiSelect: false,
                autoSelect: false,
                decapitate: false,
                largeEditDialog: false,
                boundaryLinks: false,
                limitSelect: true,
                pageSelect: true
            };
            vm.deviceGroupDevicesTable.query = {
                order: 'name',
                limit: 10,
                page: 1
            };
            vm.deviceGroupDevicesTable.filter = {
                search: ''
            };
        }
        function fillSiteGroupSitesTable(id)
        {
            vm.siteGroupSites=[];
            vm.currentDeviceGroup=id;
           
            for(var i=0;i<vm.currentDeviceGroup.elements.length;i++)
            {
                for(var j=0;j<vm.sites.results.length;j++)
                {
                    if(vm.sites.results[j].token===vm.currentDeviceGroup.elements[i].token)
                    {
                        var tmp=
                        {
                            token:vm.sites.results[j].token,
                            name:vm.sites.results[j].name,
                            users:vm.sites.results[j].authorizedUserIds
                        }
                        vm.siteGroupSites.push(tmp);
                        break;
                    }
                }
            }
            vm.siteGroupSitesTable={};
            vm.assetShow=3;
            vm.siteGroupSitesTable.limitOptions = [5, 10, 15, {
                label: 'All',
                value: function () {
                return vm.siteGroupSites.length ? vm.siteGroupSites.length : 0;
                }
            }];
            vm.siteGroupSitesTable.options = {
                rowSelection: false,
                multiSelect: false,
                autoSelect: false,
                decapitate: false,
                largeEditDialog: false,
                boundaryLinks: false,
                limitSelect: true,
                pageSelect: true
            };
            vm.siteGroupSitesTable.query = {
                order: 'name',
                limit: 10,
                page: 1
            };
            vm.siteGroupSitesTable.filter = {
                search: ''
            };
        }
        function openNewSiteGroupSitesDialog(ev)
        {
             $mdDialog.show({
                controller         : 'NewSiteGroupSiteController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newSiteGroupSites/new-site-group-site.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    thisTenant:vm.sitesTenant,
                    currentGroup:vm.currentDeviceGroup,
                    sites:vm.sites
                }
            }).then(function (answer)
            {		
                callRestService(vm.url,"/groups/"+vm.currentDeviceGroup.token+"?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"PUT").then(function(res){
                   fillSiteGroupSitesTable(vm.currentDeviceGroup);
                   showNotification("Group Sites Notification","Sites Inserted into Group Successfully!","Success");
                },function(reason) {
                    showNotification("Group Sites Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function fillDeviceGroupTableNew(id)
        {
            callRestService(vm.url,"/groups/deviceGroups","?page=1&pageSize=1000&userId="+vm.user.username+"&site="+id+"&tenantAuthToken="+vm.sitesTenant,true,vm.user.authentication,"GET").then(function(res){
                vm.deviceGroups=res.data.results;
                vm.deviceGroupsTable={};
                vm.deviceGroupsTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                    return vm.deviceGroups.length ? vm.deviceGroups.length : 0;
                    }
                }];
                vm.deviceGroupsTable.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.deviceGroupsTable.query = {
                    order: 'name',
                    limit: 10,
                    page: 1
                };
                vm.deviceGroupsTable.filter = {
                    search: ''
                };
                for(var i=0;i<vm.deviceGroups.length;i++)
                {
                    if(vm.deviceGroups[i].token===vm.currentDeviceGroup.token)
                    {
                        vm.currentDeviceGroup=vm.deviceGroups[i];
                        fillDeviceGroupDevicesTable(vm.currentDeviceGroup);
                    }
                }
            });
        }
        function openNewDeviceGroupDevicesDialog(ev)
        {
            $mdDialog.show({
                controller         : 'NewDeviceGroupDeviceController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newDeviceGroupDevices/new-device-group-device.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    thisTenant:vm.sitesTenant,
                    currentGroup:vm.currentDeviceGroup,
                    devices:vm.devices,
                    groups:vm.deviceGroups,
                    user:vm.user,
                    url:vm.url
                }
            }).then(function (answer)
            {		
                callRestService(vm.url,"/groups/"+vm.currentDeviceGroup.token+"?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"PUT").then(function(res){
                    fillDeviceGroupTableNew(vm.devicesSite);
                   showNotification("Group Devices Notification","Devices Inserted into Group Successfully!","Success");
                },function(reason) {
                    showNotification("Group Devices Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openDeleteDeviceGroupDevicesDialog(ev,device)
        {
            $mdDialog.show({
                controller         : 'DeleteDeviceGroupDeviceController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteDeviceGroupDevices/delete-device-group-device.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    device:device,
                    thisGroup:vm.currentDeviceGroup,
                    thisTenant:vm.sitesTenant,
                    groups:vm.deviceGroups,
                    user:vm.user,
                    url:vm.url
                }
            }).then(function (answer)
            {	
                 callRestService2(vm.url,"/groups/"+vm.currentDeviceGroup.token+"?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"PUT").then(function(res){
                    fillDeviceGroupTableNew(vm.devicesSite);
                     showNotification("Group Devices Notification","Device Deleted from Group Successfully!","Success");
                },function(reason) {
                    showNotification("Group Devices Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openDeleteSiteGroupSitesDialog(ev,site)
        {
            $mdDialog.show({
                controller         : 'DeleteSiteGroupSiteController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteSiteGroupSites/delete-site-group-site.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    site:site,
                    sites:vm.sites,
                    thisTenant:vm.sitesTenant,
                    thisGroup:vm.currentDeviceGroup
                }
            }).then(function (answer)
            {	
                 callRestService2(vm.url,"/groups/"+vm.currentDeviceGroup.token+"?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"PUT").then(function(res){
                     fillSiteGroupSitesTable(vm.currentDeviceGroup);
                     showNotification("Group Sites Notification","Site Deleted from Group Successfully!","Success");
                },function(reason) {
                    showNotification("Group Sites Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openNewSiteGroupDialog(ev)
        {
            $mdDialog.show({
                controller         : 'NewSiteGroupController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newSiteGroup/new-site-group.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tenants:vm.tenants,
                    thisTenant: vm.sitesTenant,
                    user:vm.user,
                    users:vm.users,
                    url:vm.url,
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/groups?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"POST").then(function(res){
                   fillPortfoliosTable(vm.sitesTenant);
                   showNotification("Site Group Notification","Site Group Inserted Successfully!","Success");
                },function(reason) {
                    showNotification("Site Group Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }

        // Device Groups
        function fillDeviceGroupTable(id)
        {
            callRestService(vm.url,"/groups/deviceGroups","?page=1&pageSize=1000&userId="+vm.user.username+"&site="+id+"&tenantAuthToken="+vm.sitesTenant,true,vm.user.authentication,"GET").then(function(res){
                vm.deviceGroups=res.data.results;
                vm.deviceGroupsTable={};
                vm.deviceGroupsTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                    return vm.deviceGroups.length ? vm.deviceGroups.length : 0;
                    }
                }];
                vm.deviceGroupsTable.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.deviceGroupsTable.query = {
                    order: 'name',
                    limit: 10,
                    page: 1
                };
                vm.deviceGroupsTable.filter = {
                    search: ''
                };
            });
        }
        // Portfolios
        function fillPortfoliosTable(id)
        {
            callRestService(vm.url,"/groups/portfolios","?page=1&pageSize=1000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.portfolios=res.data.results;
                vm.siteGroupsTable={};
                vm.siteGroupsTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                    return vm.portfolios.length ? vm.portfolios.length : 0;
                    }
                }];
                vm.siteGroupsTable.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.siteGroupsTable.query = {
                    order: 'name',
                    limit: 10,
                    page: 1
                };
                vm.siteGroupsTable.filter = {
                    search: ''
                };
            });
        }

        function openEditSiteGroupDialog(ev,deviceGroup)
        {
            $mdDialog.show({
                controller         : 'EditSiteGroupController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editSiteGroup/edit-site-group.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tenants:vm.tenants,
                    deviceGroup:deviceGroup,
                    thisTenant: vm.sitesTenant,
                    user:vm.user,
                    users:vm.users,
                    url:vm.url
                }
            }).then(function (answer)
            {		
               callRestService(vm.url,"/groups/"+answer.message.token+"?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"PUT").then(function(res){
                    fillPortfoliosTable(vm.sitesTenant);
                    showNotification("Site Group Notification","Site Group Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Site Group Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openNewDeviceGroupDialog(ev)
        {
            $mdDialog.show({
                controller         : 'NewDeviceGroupController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newDeviceGroup/new-device-group.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tenants:vm.tenants,
                    thisTenant: vm.sitesTenant,
                    user:vm.user,
                    sites:vm.sites,
                    thisSite:vm.devicesSite,
                    url:vm.url
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/groups?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"POST").then(function(res){
                    fillDeviceGroupTable(vm.devicesSite);
                   showNotification("Device Group Notification","Device Group Inserted Successfully!","Success");
                },function(reason) {
                    showNotification("Device Group Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openEditDeviceGroupDialog(ev,deviceGroup)
        {
            $mdDialog.show({
                controller         : 'EditDeviceGroupController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editDeviceGroup/edit-device-group.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    deviceGroup:deviceGroup,
                    tenants:vm.tenants,
                    thisTenant: vm.sitesTenant,
                    user:vm.user,
                    sites:vm.sites,
                    thisSite:vm.devicesSite,
                    url:vm.url
                }
            }).then(function (answer)
            {		
               callRestService(vm.url,"/groups/"+answer.message.token+"?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"PUT").then(function(res){
                    fillDeviceGroupTable(vm.devicesSite);
                    showNotification("Device Group Notification","Device Group Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Device Group Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openDeleteSiteGroupDialog(ev,deviceGroup)
        {
            $mdDialog.show({
                controller         : 'DeleteSiteGroupController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteSiteGroup/delete-site-group.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    deviceGroup:deviceGroup
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/groups/",answer+"?tenantAuthToken="+vm.sitesTenant+"&force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    fillPortfoliosTable(vm.sitesTenant);
                    showNotification("Site Group Notification","Site Group Deleted Successfully!","Success");
                },function(reason) {
                    showNotification("Site Group Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }

        function openDeleteDeviceGroupDialog(ev,deviceGroup)
        {
            $mdDialog.show({
                controller         : 'DeleteDeviceGroupController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteDeviceGroup/delete-device-group.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    deviceGroup:deviceGroup
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/groups/",answer+"?tenantAuthToken="+vm.sitesTenant+"&force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    fillDeviceGroupTable(vm.devicesSite);
                    showNotification("Device Group Notification","Device Group Deleted Successfully!","Success");
                },function(reason) {
                    showNotification("Device Group Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }

        // Specifications
        function fillSpecificationsTable(id)
        {
            callRestService(vm.url,"/specifications","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.specifications=res.data.results;
                vm.specificationsTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                    return vm.specifications.length ? vm.specifications.length : 0;
                    }
                }];
                vm.specificationsTable.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.specificationsTable.query = {
                    order: 'name',
                    limit: 10,
                    page: 1
                };
                vm.specificationsTable.filter = {
                    search: ''
                };
            });
        }
        function openNewSpecificationDialog(ev)
        {
             $mdDialog.show({
                controller         : 'NewSpecificationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newSpecification/new-specification.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tenants:vm.tenants,
                    user:vm.user.authentication,
                    url:vm.url,
                    thisTenant: vm.sitesTenant,
                }
            }).then(function (answer)
            {		
                callRestService(vm.url,"/specifications?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"POST").then(function(res){
                   fillSpecificationsTable(vm.sitesTenant);
                   showNotification("Specification Notification","Specification Inserted Successfully!","Success");
                },function(reason) {
                    showNotification("Specification Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openEditSpecificationDialog(ev,specification)
        {
            $mdDialog.show({
                controller         : 'EditSpecificationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editSpecification/edit-specification.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tenants:vm.tenants,
                    user:vm.user.authentication,
                    specification:specification,
                    thisTenant: vm.sitesTenant,
                    url:vm.url
                }
            }).then(function (answer)
            {		
               callRestService(vm.url,"/specifications/"+answer.message.token+"?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"PUT").then(function(res){
                    fillSitesTable(vm.sitesTenant);
                    showNotification("Specification Notification","Specification Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Specification Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openDeleteSpecificationDialog(ev,specification)
        {
             $mdDialog.show({
                controller         : 'DeleteSpecificationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteSpecification/delete-specification.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    specification:specification
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/specifications/",answer+"?tenantAuthToken="+vm.sitesTenant+"&force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    fillSpecificationsTable(vm.sitesTenant);
                    showNotification("Specification Notification","Specification Deleted Successfully!","Success");
                },function(reason) {
                    showNotification("Specification Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }

        // Current Asset Category
        function fillAssetsCategoryTable(id)
        {
            vm.currentAsset=id;
            callRestService(vm.url,"/assets/categories/"+vm.currentAsset.id+"/assets","?page=1&pageSize=2000&tenantAuthToken="+vm.sitesTenant,true,vm.user.authentication,"GET").then(function(res){
                vm.assetCategories=res.data.results;
                vm.assetShow=1;
                vm.assetCategoriesTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                    return vm.assetCategories.length ? vm.assetCategories.length : 0;
                    }
                }];
                vm.assetCategoriesTable.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.assetCategoriesTable.query = {
                    order: 'name',
                    limit: 10,
                    page: 1
                };
                vm.assetCategoriesTable.filter = {
                    search: ''
                };
            });
        }
        function openNewAssetCategoryDialog(ev)
        {
             $mdDialog.show({
                controller         : 'NewAssetCategoryController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newAssetCategory/new-asset-category.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    type:vm.currentAsset.assetType
                }
            }).then(function (answer)
            {		
                var tempType="";
                if(vm.currentAsset.assetType=="Device"|| vm.currentAsset.assetType=="Hardware")
                {
                    tempType='hardware';
                }
                else if(vm.currentAsset.assetType=="Location")
                {
                    tempType='locations';
                }
                else
                {
                    tempType='persons';
                }
            
                callRestService(vm.url,"/assets/categories/"+vm.currentAsset.id+"/"+tempType+"?tenantAuthToken="+vm.sitesTenant,answer,true,vm.user.authentication,"POST").then(function(res){
                   fillAssetsCategoryTable(vm.currentAsset);
                   showNotification("Asset Notification","Asset Inserted Successfully!","Success");
                },function(reason) {
                    showNotification("Asset Notification","Something Went Wrong!","Error");
                })
            },function () {});
        }
        function openEditAssetCategoryDialog(ev,assetCategory)
        {
            $mdDialog.show({
                controller         : 'EditAssetCategoryController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editAssetCategory/edit-asset-category.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    assetCategory:assetCategory,
                    type:vm.currentAsset.assetType
                }
            }).then(function (answer)
            {		
                var tempType="";
                if(vm.currentAsset.assetType=="Device"|| vm.currentAsset.assetType=="Hardware")
                {
                    tempType='hardware';
                }
                else if(vm.currentAsset.assetType=="Location")
                {
                    tempType='locations';
                }
                else
                {
                    tempType='persons';
                }
                callRestService(vm.url,"/assets/categories/"+vm.currentAsset.id+"/"+tempType+"/"+answer.id+"?tenantAuthToken="+vm.sitesTenant,answer,true,vm.user.authentication,"PUT").then(function(res){
                    fillAssetsCategoryTable(vm.currentAsset);
                    showNotification("Asset Notification","Asset Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Asset Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openDeleteAssetCategoryDialog(ev,assetCategory)
        {
            $mdDialog.show({
                controller         : 'DeleteAssetCategoryController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteAssetCategory/delete-asset-category.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    assetCategory:assetCategory,
                    type:vm.currentAsset.assetType
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/assets/categories/",vm.currentAsset.id+"/assets/"+answer+"?tenantAuthToken="+vm.sitesTenant,true,vm.user.authentication,"DELETE").then(function(res){
                    fillAssetsCategoryTable(vm.currentAsset);
                    showNotification("Asset Notification","Asset Deleted Successfully!","Success");
                },function(reason) {
                    showNotification("Asset Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }

        // Asset Categories
        function fillAssetsTable(id)
        {
             callRestService(vm.url,"/assets/categories","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.assets=res.data.results;
                vm.assetsTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                    return vm.assetsTable.length ? vm.assetsTable.length : 0;
                    }
                }];
                vm.assetsTable.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.assetsTable.query = {
                    order: 'assetType',
                    limit: 10,
                    page: 1
                };
                vm.assetsTable.filter = {
                    search: ''
                };
            });
        }
        function openNewAssetDialog(ev)
        {
             $mdDialog.show({
                controller         : 'NewAssetController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newAsset/new-asset.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tenants:vm.tenants
                }
            }).then(function (answer)
            {		
               callRestService(vm.url,"/assets/categories?tenantAuthToken="+vm.sitesTenant,answer,true,vm.user.authentication,"POST").then(function(res){
                   fillAssetsTable(vm.sitesTenant);
                   showNotification("Asset Category Notification","Asset Category Inserted Successfully!","Success");
                },function(reason) {
                    showNotification("Asset Category Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openEditAssetDialog(ev,asset)
        {
            $mdDialog.show({
                controller         : 'EditAssetController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editAsset/edit-asset.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    asset:asset
                }
            }).then(function (answer)
            {		
               callRestService(vm.url,"/assets/categories/"+answer.id+"?tenantAuthToken="+vm.sitesTenant,answer,true,vm.user.authentication,"PUT").then(function(res){
                    fillAssetsTable(vm.sitesTenant);
                    showNotification("Asset Category Notification","Asset Category Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Asset Category Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openDeleteAssetDialog(ev,asset)
        {
            $mdDialog.show({
                controller         : 'DeleteAssetController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteAsset/delete-asset.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    asset:asset
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/assets/categories/",answer+"?tenantAuthToken="+vm.sitesTenant+"&force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    fillAssetsTable(vm.sitesTenant);
                    showNotification("Asset Category Notification","Asset Category Deleted Successfully!","Success");
                },function(reason) {
                    showNotification("Asset Category Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }

        // Sites
        function fillSitesPortfolio()
        {
             vm.sitesTable.limitOptions = [5, 10, 15, {
                label: 'All',
                value: function () {
                    return vm.sites.numResults ? vm.sites.numResults : 0;
                }
            }];
            vm.sitesTable.options = {
                rowSelection: false,
                multiSelect: false,
                autoSelect: false,
                decapitate: false,
                largeEditDialog: false,
                boundaryLinks: false,
                limitSelect: true,
                pageSelect: true
            };
            vm.sitesTable.query = {
                order: 'timestamp',
                limit: 10,
                page: 1
            };
            vm.sitesTable.filter = {
                search: ''
            };
        }
        function fillSitesTable(id)
        {
            if(vm.user.role!=="level05" && vm.user.role!=="level04")
            {
                 callRestService(vm.url,"/sites","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                    vm.sites=res.data;
					vm.selectedSite=vm.sites.results[0].name;
                    vm.sitesTable.limitOptions = [5, 10, 15, {
                        label: 'All',
                        value: function () {
                            return vm.sites.numResults ? vm.sites.numResults : 0;
                        }
                    }];
                    vm.sitesTable.options = {
                        rowSelection: false,
                        multiSelect: false,
                        autoSelect: false,
                        decapitate: false,
                        largeEditDialog: false,
                        boundaryLinks: false,
                        limitSelect: true,
                        pageSelect: true
                    };
                    vm.sitesTable.query = {
                        order: 'name',
                        limit: 10,
                        page: 1
                    };
                    vm.sitesTable.filter = {
                        search: ''
                    };
                });
            }
            else
            {

                 callRestService(vm.url,"/sites/"+vm.user.username+"/user","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                     vm.sites={
                         results:res.data
                     };
                    vm.sitesTable.limitOptions = [5, 10, 15, {
                        label: 'All',
                        value: function () {
                            return vm.sites.numResults ? vm.sites.numResults : 0;
                        }
                    }];
                    vm.sitesTable.options = {
                        rowSelection: false,
                        multiSelect: false,
                        autoSelect: false,
                        decapitate: false,
                        largeEditDialog: false,
                        boundaryLinks: false,
                        limitSelect: true,
                        pageSelect: true
                    };
                    vm.sitesTable.query = {
                        order: 'name',
                        limit: 10,
                        page: 1
                    };
                    vm.sitesTable.filter = {
                        search: ''
                    };
                });
            }
           
        }
        function openNewVerticalDialog(ev)
        {
            $mdDialog.show({
                controller         : 'NewVerticalController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newVertical/new-vertical.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    verticals:vm.verticals
                }
            }).then(function (answer)
            {		
               callRestService(vm.url,"/verticalSolutions/",answer,true,vm.user.authentication,"POST").then(function(res){
                    fillVerticalsTable();
                    showNotification("Vertical Solutions Notification","Vertical Solution Inserted Successfully!","Success");
                },function(reason) {
                    showNotification("Vertical Solutions Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openDeleteVerticalDialog(ev,vertical)
        {
            $mdDialog.show({
                controller         : 'DeleteVerticalController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteVertical/delete-vertical.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    vertical:vertical
                }
            }).then(function (answer)
            {		
                callRestService(vm.url,"/verticalSolutions/",answer+"&force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    fillVerticalsTable();
                    showNotification("Vertical Solutions Notification","Vertical Solution Deleted Successfully!","Success");
                },function(reason) {
                    showNotification("Vertical Solutions Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openEditVerticalDialog(ev,vertical)
        {
            $mdDialog.show({
                controller         : 'EditVerticalController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editVertical/edit-vertical.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    verticals:vm.verticals,
                    thisVertical:vertical
                }
            }).then(function (answer)
            {		
               callRestService(vm.url,"/verticalSolutions/"+answer.token,answer,true,vm.user.authentication,"PUT").then(function(res){
                    fillVerticalsTable();
                    showNotification("Vertical Solutions Notification","Vertical Solution Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Vertical Solutions Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openNewSiteDialog(ev)
        {
             $mdDialog.show({
                controller         : 'NewSiteController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newSite/new-site.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tenants:vm.tenants,
                    thisTenant:vm.sitesTenant,
                    user:vm.user,
                    url:vm.url,
                    users:vm.users.results
                }
            }).then(function (answer)
            {		
               callRestService(vm.url,"/sites/?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"POST").then(function(res){
                   fillSitesTable(vm.sitesTenant);
                   fillAssetsTable(vm.sitesTenant);
                   fillPortfoliosTable(vm.sitesTenant);
                   showNotification("Site Notification","Site Inserted Successfully!","Success");
                },function(reason) {
                    showNotification("Site Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openEditSiteDialog(ev,site)
        {
            $mdDialog.show({
                controller         : 'EditSiteController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editSite/edit-site.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tenants:vm.tenants,
                    site:site,
                    thisTenant: vm.sitesTenant,                   
                    user:vm.user,
                    url:vm.url,
                    users:vm.users.results
                }
            }).then(function (answer)
            {		
               callRestService(vm.url,"/sites/"+answer.message.token+"?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"PUT").then(function(res){
                    fillSitesTable(vm.sitesTenant);
                    fillAssetsTable(vm.sitesTenant);
                    fillPortfoliosTable(vm.sitesTenant);
                    showNotification("Site Notification","Site Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Site Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openDeleteSiteDialog(ev,site)
        {
            $mdDialog.show({
                controller         : 'DeleteSiteController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteSite/delete-site.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    site:site
                }
            }).then(function (answer)
            {
                callRestService(vm.url,"/sites/",answer+"?tenantAuthToken="+vm.sitesTenant+"&force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    fillSitesTable(vm.sitesTenant);
                    callRestService(vm.url,"/groups/portfolios","?page=1&pageSize=1000&tenantAuthToken="+vm.sitesTenant,true,vm.user.authentication,"GET").then(function(res){
                        var portfolios=res.data.results;
                         for(var i=0;i<portfolios.length;i++)
                         {
                             var index=-1;
                             for(var j=0;j<portfolios[i].elements.length;j++)
                             {
                                 if(portfolios[i].elements[j].token===answer)
                                 {
                                     index=1;
                                     portfolios[i].elements.splice(j, 1);
                                     j=0;
                                 }
                             }
                             if (index > -1) {
                                 var temporary={
                                     token:portfolios[i].token,
                                     name:portfolios[i].name,
                                     site:"",
                                     description:portfolios[i].description,
                                     userId:portfolios[i].userId,
                                     parent:"",
                                     type:"site",
                                     elements:portfolios[i].elements
                                 };
                                 callRestService2(vm.url,"/groups/"+portfolios[i].token+"?tenantAuthToken="+vm.sitesTenant,temporary,true,vm.user.authentication,"PUT").then(function(res){
                                    fillPortfoliosTable(vm.sitesTenant);
                                 });
                             }
                         }
                     });
                     callRestService(vm.url,"/assets/categories/"+answer,"?tenantAuthToken="+vm.sitesTenant+"&force=true",true,vm.user.authentication,"DELETE").then(function(res){
                        fillAssetsTable(vm.sitesTenant);
                    });
                    showNotification("Site Notification","Site Deleted Successfully!","Success");
                },function(reason) {
                    showNotification("Site Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        // Tenants
        function fillTenantsTable()
        {
             callRestService(vm.url,"/users/"+vm.user.username+"/tenants","",true,vm.user.authentication,"GET").then(function(res){
                vm.tenants=res.data;
                vm.selectedTenant=vm.tenants[0];
                vm.sitesTenant=vm.tenants[0].authenticationToken;
                fillAllTenants();
                for(var i=0;i< vm.tenants.length;i++)
                {
                     callRestService(vm.url,"/tenants/",vm.tenants[i].id+"?includeRuntimeInfo=true",true,vm.user.authentication,"GET").then(function(res){
                        for(var i=0;i< vm.tenants.length;i++)
                        {
                            if(vm.tenants[i].id==res.data.id)
                            {
                                vm.tenants[i].lifecycleStatus=res.data.engineState.lifecycleStatus;
                            }
                        }
                     });
                }
                vm.tenantsTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                    return vm.tenants.length ? vm.tenants.length : 0;
                    }
                }];
                vm.tenantsTable.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.tenantsTable.query = {
                    order: 'name',
                    limit: 10,
                    page: 1
                };
                vm.tenantsTable.filter = {
                    search: ''
                };
            });
        }
        function fillAllTenants()
        {
            if(vm.user.role==="level04")
                getPortfolios(vm.sitesTenant);
            else
                fillSitesTable(vm.sitesTenant);
            fillAssetsTable(vm.sitesTenant);
            fillSpecificationsTable(vm.sitesTenant);
            fillPortfoliosTable(vm.sitesTenant);
            fillDeviceSitesTable(vm.sitesTenant);
            fillCostProfilesTable(vm.sitesTenant);
        }
        function getPortfolios(tenant)
		{
			callRestService(vm.url,"/devicegroups","?page=1&pageSize=2000&tenantAuthToken="+tenant,true,vm.user.authentication,"GET").then(function(res){
				vm.userPortfolio=[];
				for(var i=0;i<res.data.results.length;i++)
				{
					if(res.data.results[i].metadata.type==="Portfolio")
					{
						var fl=0;
						for(var j=0;j<res.data.results[i].roles.length;j++)
						{
							if(res.data.results[i].roles[j]===vm.user.username)
								fl=1;
						}
						if(fl)
							vm.userPortfolio.push(res.data.results[i])
					}
				}
				vm.selectedPortfolio=vm.userPortfolio[0];
				getSitesPortfolio(vm.selectedPortfolio);
			});
		}
        function getSitesPortfolio(portfolio)
		{
			vm.selectedPortfolio=portfolio;
			 callRestService(vm.url,"/devicegroups/"+portfolio.token+"/elements","?page=1&pageSize=2000&includeDetails=true&tenantAuthToken="+vm.selectedTenant.authenticationToken,true,vm.user.authentication,"GET").then(function(res){
				vm.sites={
                    results:[]
                };
				vm.portCounter=0;
				vm.portSites=res.data.results;
				for(var i=0;i<vm.portSites.length;i++)
				{
					getSitePortfolio(vm.portSites[i]);
				}
			 });
		}
        function getSitePortfolio(portSite)
		{
			callRestService(vm.url,"/sites/"+portSite.elementId,"?tenantAuthToken="+vm.selectedTenant.authenticationToken,true,vm.user.authentication,"GET").then(function(res){
				vm.sites.results.push(res.data);
				vm.portCounter++;
				if(vm.portCounter==vm.portSites.length)
                    fillSitesPortfolio();
			});
		}
        function startStopTenant(action,tenant)
        {
            callRestService(vm.url,"/tenants/"+tenant.id+"/engine/"+action,"",true,vm.user.authentication,"POST").then(function(res){
                fillTenantsTable();
                showNotification("Tenant Notification","Tenant Updated Successfully!","Success");
            },function(reason) {
                    showNotification("Tenant Notification","Something Went Wrong!","Error");
                });
        }
        function openNewTenantDialog(ev)
        {
            $mdDialog.show({
                controller         : 'NewTenantController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newTenant/new-tenant.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    users:vm.users.results,
                    user:vm.user 
                }
            }).then(function (answer)
            {		
                vm.spinner=true;
                callRestService(vm.url,"/tenants",answer,true,vm.user.authentication,"POST").then(function(res){
                    var params={
                        clientId:answer.id
                    };
                    callRestService(vm.url,"/tenants/"+params.clientId,"/engine/configuration/json",true,vm.user.authentication,"GET").then(function(res){
                        var conf=res.data;
                        for(var i=0;i<conf.children.length;i++)
                        {
                            if(conf.children[i].name==="tenant-configuration")
                            {
                                for(var j=0;j<conf.children[i].children.length;j++)
                                {
                                    if(conf.children[i].children[j].name==="tenant-datastore")
                                    {
                                        for(var k=0;k<conf.children[i].children[j].children.length;k++)
                                        {
                                        
                                            if(conf.children[i].children[j].children[k].name==="mongo-influxdb-tenant-datastore")
                                            {
                                                var temp=
                                                {
                                                    name:"database",
                                                    value:params.clientId
                                                };
                                                conf.children[i].children[j].children[k].attributes.push(temp);
                                                callRestService(vm.url,"/tenants/"+params.clientId+"/engine/configuration/json",conf,true,vm.user.authentication,"POST").then(function(res){
                                                     callRestService(vm.url,"/tenants/"+params.clientId+"/engine/start","",true,vm.user.authentication,"POST").then(function(res){
                                                         var tickScript=
                                                         {
                                                            tenant:params.clientId,
                                                            notificationScriptType:"StreamNotification"
                                                         }
                                                         callRestService(vm.url,"/notifications/kapacitor/new",tickScript,true,vm.user.authentication,"POST").then(function(res){
                                                         });
                                                         var tickScript=
                                                         {
                                                            tenant:params.clientId,
                                                            notificationScriptType:"CostCalculator"
                                                         }
                                                         callRestService(vm.url,"/notifications/kapacitor/new",tickScript,true,vm.user.authentication,"POST").then(function(res){
                                                            showNotification("Tenant Notification","Tenant Inserted Successfully!","Success");
                                                            fillTenantsTable();
                                                            vm.spinner=false;
                                                         });
                                                     });
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    });
                },function(reason) {
                    showNotification("Tenant Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openDeleteTenantDialog(ev,tenant)
        {
            $mdDialog.show({
                controller         : 'DeleteTenantController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteTenant/delete-tenant.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tenant:tenant
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/tenants/",answer.id+"?force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    fillTenantsTable();
                    showNotification("Tenant Notification","Tenant Deleted Successfully!","Success");
                },function(reason) {
                    showNotification("Tenant Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openEditTenantDialog(ev,tenant)
        {
            $mdDialog.show({
                controller         : 'EditTenantController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editTenant/edit-tenant.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    users:vm.users.results,
                    tenant:tenant,
                    user:vm.user,
                    pragmaApi:vm.pragmaApi
                }
            }).then(function (answer)
            {		
                callRestService(vm.url,"/tenants/"+answer.id,answer,true,vm.user.authentication,"PUT").then(function(res){
                    showNotification("Tenant Notification","Tenant Updated Successfully!","Success");
                    fillTenantsTable();
                },function(reason) {
                    showNotification("Tenant Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }

        //Cost Profiles
        function fillCostProfilesTable(id)
        {
            callRestService(vm.url,"/costProfiles","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.costProfiles=res.data;
                vm.costProfilesTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                        return vm.costProfiles.numResults ? vm.costProfiles.numResults : 0;
                    }
                }];
                vm.costProfilesTable.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.costProfilesTable.query = {
                    order: 'name',
                    limit: 10,
                    page: 1
                };
                vm.costProfilesTable.filter = {
                    search: ''
                };
            });
        }
        function openNewCostProfileDialog(ev)
        {
            $mdDialog.show({
                controller         : 'NewCostProfileController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newCostProfile/new-costProfile.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tenants:vm.tenants,
                    thisTenant:vm.sitesTenant,
                    thisSite:vm.devicesSite,
                    user:vm.user,
                    costs:vm.costs,
                    sites:vm.sites,
                    url:vm.url
                }
            }).then(function (answer)
            {		
                 callRestService(vm.url,"/costProfiles?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"POST").then(function(res){
                    fillCostProfilesTable(vm.sitesTenant);
                    showNotification("Cost Profile Notification","Cost Profile Inserted Successfully!","Success");
                },function(reason) {
                    showNotification("Cost Profile Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openEditCostProfileDialog(ev,costProfile)
        {
            $mdDialog.show({
                controller         : 'EditCostProfileController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editCostProfile/edit-costProfile.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    costProfile:costProfile,
                    thisTenant:vm.sitesTenant,
                    tenants:vm.tenants,
                    user:vm.user,
                    costs:vm.costs,
                    sites:vm.sites
                }
            }).then(function (answer)
            {		
               callRestService(vm.url,"/costProfiles/"+answer.message.token+"?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"PUT").then(function(res){
                     fillCostProfilesTable(vm.sitesTenant);
                    showNotification("Cost Profile Notification","Cost Profile Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Cost Profile Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openDeleteCostProfileDialog(ev,costProfile)
        {
            $mdDialog.show({
                controller         : 'DeleteCostProfileController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteCostProfile/delete-costProfile.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    costProfile:costProfile
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/costProfiles/",answer+"?tenantAuthToken="+vm.sitesTenant+"&force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    fillCostProfilesTable(vm.sitesTenant);
                    showNotification("Cost Profile Notification","Cost Profile Deleted Successfully!","Success");
                },function(reason) {
                    showNotification("Cost Profile Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }


        // Costs
        function fillCostProfileCostsTable(id) {
            vm.currentCostProfile = id;
            vm.costs = [];
            callRestService(vm.url, "/costs/profileToken/"+vm.currentCostProfile.token, "?page=1&pageSize=1000&tenantAuthToken=" + vm.sitesTenant, true, vm.user.authentication, "GET").then(function(res) {
                vm.costs=res.data.results;
                /*var foo = res.data.results;
                for (var i = 0; i < foo.length; i++) {
                    delete foo[i].schedule;
                    var bar = foo[i].tariffs[0];
                    if (bar.profileToken.indexOf(vm.currentCostProfile.token) >= 0) {
                        for (var prop in bar) {
                            foo[i][prop] = bar[prop];
                        }
                        vm.costs.push(foo[i]);
                    }
                }*/
                vm.assetShow = 4;
                vm.costsTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                        return vm.costs.length ? vm.costs.length : 0;
                    }
                }];
                vm.costsTable.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.costsTable.query = {
                    order: 'name',
                    limit: 10,
                    page: 1
                };
                vm.costsTable.filter = {
                    search: ''
                };
            });
        }
        
        function openNewCostDialog(ev)
        {
            $mdDialog.show({
                controller         : 'NewCostController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newCost/new-cost.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    thisTenant:vm.sitesTenant,
                    thisCostProfile:vm.currentCostProfile,
                    user:vm.user,
                }
            }).then(function (answer)
            {		
                 callRestService(vm.url,"/costs?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"POST").then(function(res){
    
                    fillCostProfileCostsTable(vm.currentCostProfile);
                    showNotification("Cost Notification","Cost inserted successfully!","Success");
                },function(reason) {
                    showNotification("Cost Notification","Something went wrong!","Error");
                });
            },function () {});
        }
        function openEditCostDialog(ev,cost)
        {
           $mdDialog.show({
                controller         : 'EditCostController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editCost/edit-cost.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    cost:cost,
                    thisTenant:vm.sitesTenant,
                    thisCostProfile:vm.currentCostProfile,
                    user:vm.user,
                }
            }).then(function (answer)
            {		
               callRestService(vm.url,"/costs/"+answer.message.token+"?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"PUT").then(function(res){
                     fillCostProfileCostsTable(vm.currentCostProfile);
                    showNotification("Cost Notification","Cost updated successfully!","Success");
                },function(reason) {
                    showNotification("Cost Notification","Something went wrong!","Error");
                });
            },function () {});
        }
        function openDeleteCostDialog(ev,cost)
        {
            $mdDialog.show({
                controller         : 'DeleteCostController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteCost/delete-cost.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    cost:cost
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/costs/",answer+"?tenantAuthToken="+vm.sitesTenant+"&force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    fillCostProfileCostsTable(vm.currentCostProfile);
                    showNotification("Cost Notification","Cost Deleted Successfully!","Success");
                },function(reason) {
                    showNotification("Cost Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }

        // Tariffs
        function fillTariffsTable(id)
        {
            callRestService(vm.url,"/tariffs","?page=1&pageSize=2000&tenantAuthToken="+id,true,vm.user.authentication,"GET").then(function(res){
                vm.tariffs=res.data;
                vm.tariffsTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                        return vm.tariffs.numResults ? vm.tariffs.numResults : 0;
                    }
                }];
                vm.tariffsTable.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.tariffsTable.query = {
                    order: 'name',
                    limit: 10,
                    page: 1
                };
                vm.tariffsTable.filter = {
                    search: ''
                };
            });
        }
        function openNewTariffDialog(ev)
        {
            $mdDialog.show({
                controller         : 'NewTariffController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newTariff/new-tariff.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tenants:vm.tenants,
                    thisTenant:vm.sitesTenant,
                    user:vm.user
                }
            }).then(function (answer)
            {		
                 callRestService(vm.url,"/tariffs?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"POST").then(function(res){
                    fillTariffsTable(vm.sitesTenant);
                    showNotification("Tariff Notification","Tariff Inserted Successfully!","Success");
                },function(reason) {
                    showNotification("Tariff Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openEditTariffDialog(ev,tariff)
        {
            $mdDialog.show({
                controller         : 'EditTariffController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editTariff/edit-tariff.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tariff:tariff,
                    user:vm.user,
                    tenants:vm.tenants,
                    thisTenant: vm.sitesTenant
                }
            }).then(function (answer)
            {		
               callRestService(vm.url,"/tariffs/"+answer.message.token+"?tenantAuthToken="+answer.tenant,answer.message,true,vm.user.authentication,"PUT").then(function(res){
                     fillTariffsTable(vm.sitesTenant);
                    showNotification("Tariff Notification","Tariff Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Tariff Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openDeleteTariffDialog(ev,tariff)
        {
            $mdDialog.show({
                controller         : 'DeleteTariffController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteTariff/delete-tariff.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    tariff:tariff
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/tariffs/",answer+"?tenantAuthToken="+vm.sitesTenant+"&force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    fillTariffsTable(vm.sitesTenant);
                    showNotification("Tariff Notification","Tariff Deleted Successfully!","Success");
                },function(reason) {
                    showNotification("Tariff Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }

        // Users
        function fillUsersAdmin(tempUsers) {
            for (var i = 0; i < vm.users.results.length; i++) {
                var fl = 0;
                for (var j = 0; j < tempUsers.length; j++) {
                    if (tempUsers[j].createdBy === vm.users.results[i].username) {
                        fl = 1;
                        vm.users.results.push(tempUsers[j]);
                    }
                }
            }
        }
        function fillVerticalsTable()
        {
            callRestService(vm.url, "/verticalSolutions", "", true, vm.user.authentication, "GET").then(function(res) {
              
                vm.verticals=res.data.results;
                vm.verticalsTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                          return vm.verticals.length ? vm.verticals.length : 0;
                    }
                }];
                vm.verticalsTable.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.verticalsTable.query = {
                    order: 'name',
                    limit: 10,
                    page: 1
                };
                vm.verticalsTable.filter = {
                    search: ''
                };
            });
        }
        function fillUsersTable() {
            
            callRestService(vm.url, "/users", "", true, vm.user.authentication, "GET").then(function(res) {
                var tempUsers = res.data.results;
                var tempUsersAdmin = [];
                vm.users = {};
                vm.users.numResults = 0;
                vm.users.results = [];
                if(vm.user.role==='level01') {
                    vm.users.results = res.data.results;
                }
                else if(vm.user.role === 'level02') {
                    for (var i = 0; i < tempUsers.length; i++) {
                        if ((tempUsers[i].metadata.role === 'level03' || tempUsers[i].metadata.role === 'level04' || tempUsers[i].metadata.role === 'level05') && tempUsers[i].createdBy === vm.user.username) {
                        vm.users.results.push(tempUsers[i]);
                        }
                    }
                // fillUsersAdmin(tempUsers);
                }
                else if(vm.user.role === 'level03') {
                    for (var i = 0; i < tempUsers.length; i++) {
                        if((tempUsers[i].metadata.role === 'level04' || tempUsers[i].metadata.role === 'level05') && tempUsers[i].createdBy === vm.user.username) {
                        vm.users.results.push(tempUsers[i]);
                        }
                    }
                    //fillUsersAdmin(tempUsers);
                }
                else if (vm.user.role === 'level04') {
                    for (var i = 0; i < tempUsers.length; i++) {
                        if (tempUsers[i].metadata.role === 'level05' && tempUsers[i].createdBy === vm.user.username) {
                        vm.users.results.push(tempUsers[i]);
                        }
                    }
                }
                vm.users.numResults = vm.users.results.length;
                var tempUsers = res.data.results;
                var tempUsersAdmin = [];
                vm.users = {};
                vm.users.numResults = 0;
                vm.users.results = [];
                if(vm.user.role==='level01') {
                    vm.users.results = res.data.results;
                }
                else if(vm.user.role === 'level02') {
                    for (var i = 0; i < tempUsers.length; i++) {
                        if ((tempUsers[i].metadata.role === 'level03' || tempUsers[i].metadata.role === 'level04' || tempUsers[i].metadata.role === 'level05') && tempUsers[i].createdBy === vm.user.username) {
                        vm.users.results.push(tempUsers[i]);
                        }
                    }
                // fillUsersAdmin(tempUsers);
                }
                else if(vm.user.role === 'level03') {
                    for (var i = 0; i < tempUsers.length; i++) {
                        if((tempUsers[i].metadata.role === 'level04' || tempUsers[i].metadata.role === 'level05') && tempUsers[i].createdBy === vm.user.username) {
                        vm.users.results.push(tempUsers[i]);
                        }
                    }
                    //fillUsersAdmin(tempUsers);
                }
                else if (vm.user.role === 'level04') {
                    for (var i = 0; i < tempUsers.length; i++) {
                        if (tempUsers[i].metadata.role === 'level05' && tempUsers[i].createdBy === vm.user.username) {
                        vm.users.results.push(tempUsers[i]);
                        }
                    }
                }
                vm.users.numResults = vm.users.results.length;
                vm.usersTable.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                        return vm.users.numResults ? vm.users.numResults : 0;
                    }
                }];
                vm.usersTable.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.usersTable.query = {
                    order: 'username',
                    limit: 10,
                    page: 1
                };
                vm.usersTable.filter = {
                    search: ''
                };
                fillTenantsTable();
            });
        }
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
        function openNewUserDialog(ev)
        {
            $mdDialog.show({
                controller         : 'NewUserController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/newUser/new-user.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    thisUser:vm.user
                }
            }).then(function (answer)
            {	
                var userpref=
                {
                    token:generateUUID(),
                    userId:answer.user.username,
                    palette:{},
                    language:"en",
                    removedDashboards:[],
                    trees:[],
                    modules:answer.modules,
                    data:[]
                }
                callRestService(vm.url,"/userPreferences",userpref,true,vm.user.authentication,"POST").then(function(res){

                });	
                callRestService(vm.url,"/users",answer.user,true,vm.user.authentication,"POST").then(function(res){
                    fillUsersTable();
                    showNotification("User Notification","User Inserted Successfully!","Success");
                },function(reason) {
                    showNotification("User Notification","Something Went Wrong!","Error");
                });
                
            },function () {});
        }
        function openEditUserDialog(ev,user)
        {
            $mdDialog.show({
                controller         : 'EditUserController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/editUser/edit-user.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    user:user,
                    thisUser:vm.user
                }
            }).then(function (answer)
            {
                callRestService(vm.url,"/userPreferences/"+answer.preferences.token,answer.preferences,true,vm.user.authentication,"PUT").then(function(res){

                });		
                callRestService(vm.url,"/users/"+answer.user.username,answer.user,true,vm.user.authentication,"PUT").then(function(res){
                    fillUsersTable();
                    showNotification("User Notification","User Updated Successfully!","Success");
                },function(reason) {
                    showNotification("User Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }
        function openDeleteUserDialog(ev,user)
        {
            $mdDialog.show({
                controller         : 'DeleteUserController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/admin/dialogs/deleteUser/delete-user.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    user:user
                }
            }).then(function (answer)
            {	
                callRestService(vm.url,"/userPreferences/userId/",answer,true,vm.user.authentication,"GET").then(function(res){
                    callRestService(vm.url,"/userPreferences/",res.data.token+"?force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    });
                });	
               callRestService(vm.url,"/users/",answer+"?force=true",true,vm.user.authentication,"DELETE").then(function(res){
                    showNotification("User Notification","User Deleted Successfully!","Success");
                    fillUsersTable();
                },function(reason) {
                    showNotification("User Notification","Something Went Wrong!","Error");
                });
            },function () {});
        }

        //Call Rest
        function callRestService(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            });
        }
        function callRestService2(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT" || method==="DELETE")
            {
                this_url=url_in+service;
                this_data=params;
                this_headers['Access-Control-Allow-Origin']="*";
                this_headers['Content-Type']="application/json";
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            }); 
        }
        function callRestServiceEos(url_in,service,params,useCredentials,auth,method)
        {
            var this_url;
            var this_headers={};
            var this_data={};
            if(method==="POST" || method==="PUT")
            {
                this_url=url_in+service;
                this_data=params;
            }
            else 
            {
                this_url=url_in+service+params;
            }
            if(useCredentials)
            {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization']="Basic "+ this_auth;
            }
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                data:this_data
            });
        }
        function showNotification(title,message,type)
        {
            if(type==="Error")
            {
                Notification.error({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if(type==="Info")
            {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if(type==="Warning")
            {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }
            else if(type==="Success")
            {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: 3000,
                    positionX:"right",
                    positionY:"bottom"
                });
            }   
        }	
    }
})();
(function() {
    'use strict';

    angular.module('app.directives', [
        
    ]);
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('windDirection', windDirection);

    function windDirection() {
        var directive = {
            templateUrl:"app/directives/wind-direction/wind-direction.html",
            controller: WindDirectionController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function WindDirectionController ($scope,session,PRAGMA,pragmaapi,$rootScope,pragmaTheming,$q) {
        var vm =this;
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
		vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(255,255,255)";
            }
            vm.datesColor="rgb(255,255,255)";
        }
        else
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(0,0,0)";
            }
            vm.datesColor="rgb(0,0,0)";
        }
        $scope.$on('new.measurement.broadcast', function(event, args) {
            fillWidgetMqtt(args);
        });
        function fillWidgetMqtt(device)
        {
            for (var i=0;i<vm.widget.clients.length;i++)
            {
                if(vm.widget.clients[i].device.token===device.deviceAssignmentToken)
                {
                    getMeasurements();
                    break;
                }
            }
        }
        getMeasurements();
        function getMeasurements()
        {
            pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[0].device.token+"/measurements/lastValue","?measuredParameter=windDirection&tenantAuthToken="+vm.widget.clients[0].tenant.token,true,vm.user.authentication,"GET",true,false).then(function(res){
                var measurements=res.data;
                vm.tempResult=measurements.windDirection;
                if(vm.tempResult=="S")
                {
                    vm.icon='pragma-icon-winds';
                    vm.result="South";
                }
                else if(vm.tempResult=="SW" || vm.tempResult=="WS" || vm.tempResult=="WSW" || vm.tempResult=="SSW" || vm.tempResult=="SWS" || vm.tempResult=="WWS")
                {
                    vm.icon='pragma-icon-windsw';
                    vm.result="South West";
                }
                else if(vm.tempResult=="SE" || vm.tempResult=="ES" || vm.tempResult=="ESE" || vm.tempResult=="SES" || vm.tempResult=="EES" || vm.tempResult=="SSE")
                {
                    vm.icon='pragma-icon-windse';
                    vm.result="South East";
                }
                else if(vm.tempResult=="N")
                {
                    vm.icon='pragma-icon-windn';
                    vm.result="North";
                }
                else if(vm.tempResult=="NW" || vm.tempResult=="WN" || vm.tempResult=="WNW" || vm.tempResult=="NWN" || vm.tempResult=="WWN" || vm.tempResult=="NNW")
                {
                    vm.icon='pragma-icon-windnw';
                    vm.result="North West";
                }
                else if(vm.tempResult=="NE" || vm.tempResult=="EN" || vm.tempResult=="ENE" || vm.tempResult=="NEN" || vm.tempResult=="EEN" || vm.tempResult=="NNE")
                {
                    vm.icon='pragma-icon-windne';
                    vm.result="North East";
                }
                else if(vm.tempResult=="E")
                {
                    vm.icon='pragma-icon-winde';
                    vm.result="East";
                }
                else if(vm.tempResult=="W")
                {
                    vm.icon='pragma-icon-windw';
                    vm.result="West";
                }
                vm.dateResult=measurements.timestamp;
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('wasteTable', wasteTable);

    function wasteTable() {
        var directive = {
            templateUrl:"app/directives/waste-table/waste-table.html",
            controller: WasteTableController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function WasteTableController ($rootScope,$scope,session,PRAGMA,pragmaapi,$q) {
        var vm =this;
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        vm.triggered=false;
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom")
                {
                    fillWidget();
                }
            }
        });
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today")
            {
                fillWidgetMqtt(args);
            } 
        });

        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        fillWidget();
        function fillWidget()
        {
            vm.triggered=false;
            vm.table={};
            vm.results=[];
            if(vm.widget.dates[0].date==="custom")
            {
                vm.dates=$scope.dashboardDate;
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            getMeasurements();
        }

        function getMeasurements()
        {
            var promises = [];
            for (var i=0;i<vm.widget.clients.length;i++)
            {
                promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+vm.widget.clients[i].device.token+"/measurements","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&tenantAuthToken=" + vm.widget.clients[i].tenant.token, true, vm.user.authentication, "GET", true));
            }
            $q.all(promises).then(function(resArray) {
                for (var i=0;i<resArray.length;i++)
                {  
                    var devName=JSON.parse(vm.widget.clients[i].device.metadata);
                    var foo=resArray[i].data.results;
                    for(var j=0;j<foo.length;j++)
                    {
                        if(typeof foo[j].measurements.delta!=='undefined')
                        {
                            var tmp=
                            {
                                wasteBin:devName.name,
                                delta: parseFloat(foo[j].measurements.delta).toFixed(2),
                                weight: parseFloat(foo[j].measurements.weight).toFixed(2),
                                timestamp:new Date(foo[j].eventDate),
                                cardId:foo[j].metadata.cardid
                            }
                            vm.results.push(tmp);
                        }
                       
                    }
                }
                vm.table.limitOptions = [5, 10, 15, {
                    label: 'All',
                    value: function () {
                        return vm.results.length ? vm.results.length : 0;
                    }
                }];

                vm.table.options = {
                    rowSelection: false,
                    multiSelect: false,
                    autoSelect: false,
                    decapitate: false,
                    largeEditDialog: false,
                    boundaryLinks: false,
                    limitSelect: true,
                    pageSelect: true
                };
                vm.table.query = {
                    order: 'wasteBin',
                    limit: 10,
                    page: 1
                };
                vm.table.filter = {
                    search: ''
                };
                vm.triggered=true;
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('wasteBin', wasteBin);

    function wasteBin() {
        var directive = {
            templateUrl:"app/directives/waste-bin/waste-bin.html",
            controller: WasteBinController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function WasteBinController ($rootScope,$scope,session,PRAGMA,pragmaapi,$timeout,pragmaTheming,$q) {
        var vm =this;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        vm.plotId=generateUUID();
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
		vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        vm.triggered=false;
        $scope.$on('new.measurement.broadcast', function(event, args) {
            fillWidgetMqtt(args);
        });
        function fillWidgetMqtt(device)
        {
            for (var i=0;i<vm.widget.clients.length;i++)
            {
                if(vm.widget.clients[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        getMeasurements();
                    }
                    break;
                }
            }
        }
        function fillWidget()
        {
            vm.triggered=false;
            pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[0].device.token,"?tenantAuthToken="+vm.widget.clients[0].tenant.token,true,vm.user.authentication,"GET",true,false).then(function(res){
                vm.specToken=res.data.device.specificationToken;
                getMeasurements();
            });
        }
        fillWidget();
        function getMeasurements(centralMeter)
        {
            vm.dates = {
                startDate: moment().startOf('day'),
                endDate: moment()
            };
            var promises = [
                pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[0].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter=delta&resolutionType=M&resolution=20&includeTotalSum=true&tenantAuthToken="+vm.widget.clients[0].tenant.token,true,vm.user.authentication,"GET",true,false),
                pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[0].device.token+"/measurements/lastValue","?measuredParameter=weight&tenantAuthToken="+vm.widget.clients[0].tenant.token,true,vm.user.authentication,"GET",true,false),
                pragmaapi.callRestService(vm.url,"/specifications/"+vm.specToken,"?tenantAuthToken="+vm.widget.clients[0].tenant.token,true,vm.user.authentication,"GET",true,false)
            ];
            $q.all(promises).then(function(resArray) {
                var res=resArray;
                var specs=res[2].data.metadata;
                if(typeof res[1].data!=="undefined")
                {
                    var full=parseInt(specs.full);
                    var weight=parseFloat(res[1].data.weight/1000).toFixed(2);
                    var percentage=parseInt(100*weight/full);
                    if(percentage>100)
                    {
                        percentage=100;
                    }
                    var fullness=parseInt(140*percentage/100);
                    var left=full-weight;
                    vm.result=
                    {
                        fullness:fullness,
                        weight:weight,
                        full:full,
                        left:left,
                        percentage:percentage,
                        binType:specs.type,
                        today:0
                    }
                }
                if(res[0].data.data.length>0)
                {
                    vm.result.today=(res[0].data.data[0].d/1000).toFixed(2);
                }
                else
                {
                    vm.result.today=0;
                }
                fillBin();
                vm.triggered=true;
            });
        }

        function fillBin()
        {
            var c = document.getElementById(vm.plotId);
            var ctx = c.getContext("2d");
            ctx.clearRect(0, 0, 1000, 1000);
            var  clr="#000";
            if(isDark)
            {
                var  clr="#fff";
            }
            else
            {
                var  clr="#000";
            }
            var binImg = new Image();
            binImg.src = "assets/images/waste/Bin-"+vm.result.binType+".png";
            binImg.onload = function() {
                var totalTxt=vm.result.full+" kg";
                var fullnessTxt=vm.result.percentage+" %";
                var weightTxt=vm.result.weight+" kg";
                var fontcolor="rgba(255,255,255,1)";
                var fillcolor="#8cce52";
                var todayTxt=vm.result.today+" kg";
                if(vm.result.percentage>=75)
                {
                    fillcolor="#e55845";
                }
                else if(vm.result.percentage>=50)
                {
                    fillcolor="#e29447";
                }
                else if(vm.result.percentage>=25)
                {
                    fillcolor="#e0ce48";
                }
                ctx.fillStyle=fontcolor;
                ctx.fillStyle="#dddddd";
                ctx.fillRect(120,146,50,-140);
                ctx.fillStyle=fillcolor;
                ctx.fillRect(120,146,50,-vm.result.fullness);
                ctx.drawImage(binImg,90, 0, 110, 148);
                ctx.fillStyle=clr;
                ctx.font="16px Arial";
                ctx.fillText("Total",210,15);
                ctx.font="Bold 18px Arial";
                ctx.fillText(totalTxt,210,35);
                ctx.fillText(weightTxt,10,80);
                ctx.font="16px Arial";
                ctx.fillText(fullnessTxt,40,100);
                ctx.fillText("Today",210,115);
                ctx.fillText("Fullness",10,62);
                ctx.font="Bold 18px Arial";
                ctx.fillText(todayTxt,210,135);
            };
        }

        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('tvCard', tvCard);

    function tvCard() {
        var directive = {
            templateUrl:"app/directives/tv-card/tv-card.html",
            controller: TvCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function TvCardController ($scope,$timeout,pragmaapi) {
        var vm =this;
        vm.device={};
        vm.widget=$scope.widget;
        var ip="https://smarthome.iti.gr:5005/";
        var servicePost="tv/postValue";
        vm.changeTVState=changeTVState;
        function changeTVState(action)
        {
            var message=
            {
                device:"SCREEN-TV",
                action:action
            };
            pragmaapi.callRestService(ip,servicePost,message,true,"","POST",true,false).then(function(res){
            });
            if(action==='powerOff')
            {
                setTimeout(function(){ changeTVState('powerOn'); }, 1000);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.directives')
		.directive('tableCard', tableCard)

    function tableCard() {
        var directive = {
            templateUrl:"app/directives/table-card/table-card.html",
            controller: TableCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }

    /** @ngInject */
    function TableCardController ($scope,session,PRAGMA,pragmaapi,pragmaTheming,$q) {
        var vm =this;
		$scope.plotHasFinished = false;
		
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.dates=[];
        vm.result=0;
        vm.triggered=false;
        vm.unit="";
        vm.counter=0;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(255,255,255)";
            }
            vm.gridLinesColor="rgba(255,255,255,";
        }
        else
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(0,0,0)";
            }
            vm.gridLinesColor="rgba(0,0,0,";
        }
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        fillWidget();
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom")
                {
                    fillWidget();
                }
				
				if($scope.report)
				{
					$scope.plotHasFinished = false;
					fillWidget();
				}
				
            }
        });
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today")
            {
                fillWidgetMqtt(args);
            } 
        });

        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        function fillWidget()
        {
            vm.triggered=false;
            vm.tmpResults=[];
            if(vm.widget.dates[0].date==="custom")
            {
				if($scope.report)
				{
					vm.dates = {
						startDate: moment().startOf('day'),
						endDate: moment()
					};
				}
				else {
					vm.dates=$scope.dashboardDate;
				}
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            vm.resolutionType=vm.widget.time.resolutionType;
            vm.resolutionValue=vm.widget.time.resolutionValue;
            var dF = Date.parse(vm.dates.startDate) / 1000;
            var dT = Date.parse(vm.dates.endDate) / 1000;
            var def=dT-dF;
            var day = 86400;
            vm.resolutionMinutes=0;
            if (def > day && def <= day * 30 && vm.resolutionType==='m' && vm.resolutionValue<60) { 
                vm.resolutionType="d";
                vm.resolutionValue=1;
            }
            else if (def > day * 30 && vm.resolutionType!=='d' && vm.resolutionType!=='M'){
                vm.resolutionType = "M";
                vm.resolutionValue = 1;
            }
            if(vm.resolutionType==='m')
            {
                vm.resolutionMinutes=vm.resolutionValue;
            }
            else if(vm.resolutionType==='h')
            {
                vm.resolutionMinutes=vm.resolutionValue*60;
            }
            else if(vm.resolutionType==='d')
            {
                vm.resolutionMinutes=vm.resolutionValue*60*24;
            }
            else if(vm.resolutionType==='M')
            {
                vm.resolutionMinutes=vm.resolutionValue*60*24*30;
            }
            vm.datesCumulative={};
			angular.copy(vm.dates,vm.datesCumulative);
            vm.datesCumulative.startDate = vm.datesCumulative.startDate.subtract(vm.resolutionMinutes, 'minutes');
            vm.result = {
                chart: {
                    data: [],
                    labels: [],
                    series: []
                }
            };
            getMeasurements();
        }
       
        function getMeasurements()
        {
            var devices=vm.widget.clients;
            vm.unit=devices[0].specs.unit;
            var promises = [];
            for (var i=0;i<devices.length;i++)
            {
                if(vm.widget.graph.type==='rawData')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                }
                else if(vm.widget.graph.type==='aggregatedValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType="+vm.resolutionType+"&resolution="+vm.resolutionValue+"&includeTotalSum=false&type=sum&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType="+vm.resolutionType+"&resolution="+vm.resolutionValue+"&includeTotalSum=false&type=mean&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='maxValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType="+vm.resolutionType+"&resolution="+vm.resolutionValue+"&includeTotalMax=true&type=max&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='minValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType="+vm.resolutionType+"&resolution="+vm.resolutionValue+"&includeTotalMin=true&type=min&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
            }
            $q.all(promises).then(function(resArray) {
                var devices=vm.widget.clients;
                for(var i=0;i<resArray.length;i++)
                {
                    var measurements=resArray[i].data;
                    if(vm.widget.graph.type==='rawData')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateRaw(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateRaw(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='aggregatedValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='meanValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMean(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMean(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='maxValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMax(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMax(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='minValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMin(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMin(measurements,false));
                        }
                    }
                }
                vm.triggered=true;
                calculateEnd();
            });
        }
        function calculateMetadata()
        {
            vm.metadata={
                total:0,
                mean:0,
                min:0,
                max:0
            }
            var counter=0;
            vm.metadata.total=0;
            vm.metadata.max=vm.result.chart.data[0][0];
            vm.metadata.min=vm.result.chart.data[0][0];
            for(var i=0;i<vm.result.chart.data.length;i++)
            {
                for(var j=0;j<vm.result.chart.data[i].length;j++)
                {
                    vm.metadata.total+=vm.result.chart.data[i][j];
                    counter++;
                    if(vm.result.chart.data[i][j]>vm.metadata.max)
                    {
                        vm.metadata.max=vm.result.chart.data[i][j];
                    }
                    if(vm.result.chart.data[i][j]<vm.metadata.min)
                    {
                        vm.metadata.min=vm.result.chart.data[i][j];
                    }
                }
            }
            vm.metadata.mean=vm.metadata.total/counter;
            $scope.plotHasFinished = true;
            vm.response={
                data:[],
                count:[],
                series:[],
                timestamp:[],
                cli:[]
            };
            var cc=0;
            var cl1=0;
            for(var i=0;i<vm.result.chart.data.length;i++)
            {

                vm.response.series.push(vm.result.chart.series[i]);
                vm.response.count.push(cc);
                for(var j=0;j<vm.result.chart.data[i].length;j++)
                {
                    if(i==0)
                    {
                        vm.response.data.push([]);
                        vm.response.timestamp.push(vm.result.chart.labelsUnformated[j]);
                        vm.response.cli.push(cl1);
                        cl1++;
                    }
                    vm.response.data[j].push(vm.result.chart.data[i][j])
                }
                cc++;
            }
        }
        function calculateEnd()
        {
            var devices=vm.widget.clients;
            vm.results=[];
            if(vm.widget.graph.aggregated)
            {
                if(vm.widget.graph.type==='aggregatedValue')
                {
                    vm.result.chart.series=[];
                    vm.result.chart.series.push(vm.widget.title);
                    vm.result.chart.data=[];
                    vm.result.chart.data.push([]);
                    vm.result.chart.labels=[];
                    vm.result.chart.labelsUnformated=[];
                    for(var i=0;i<vm.tmpResults.length;i++)
                    {
                        for(var j=0;j<vm.tmpResults[i].length;j++)
                        {
                            if(i==0)
                            {
                                vm.result.chart.data[0].push(vm.tmpResults[0][j].value)
                                if(vm.resolutionType==='m' || vm.resolutionType==='h')
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[0][j].timestamp).format('HH:mm'));
                                    vm.result.chart.labelsUnformated.push(moment(vm.tmpResults[0][j].timestamp).format('DD/MM/YYYY HH:mm'));
                                }
                                else
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[0][j].timestamp).format('DD/MM'));
                                    vm.result.chart.labelsUnformated.push(moment(vm.tmpResults[0][j].timestamp).format('DD/MM/YYYY HH:mm'))
                                }
                            }
                            else
                            {
                                vm.result.chart.data[0][j]=vm.result.chart.data[0][j]+vm.tmpResults[i][j].value;
                            }
                        }
                    }
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    vm.result.chart.series=[];
                    vm.result.chart.series.push(vm.widget.title);
                    vm.result.chart.data=[];
                    vm.result.chart.data.push([]);
                    vm.result.chart.labels=[];
                    vm.result.chart.labelsUnformated=[];
                    for(var i=0;i<vm.tmpResults.length;i++)
                    {
                        for(var j=0;j<vm.tmpResults[i].length;j++)
                        {
                            if(i==0)
                            {
                                vm.result.chart.data[0].push(vm.tmpResults[0][j].value)
                                if(vm.resolutionType==='m' || vm.resolutionType==='h')
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[0][j].timestamp).format('HH:mm'));
                                    vm.result.chart.labelsUnformated.push(moment(vm.tmpResults[0][j].timestamp).format('DD/MM/YYYY HH:mm'));
                                }
                                else
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[0][j].timestamp).format('DD/MM'));
                                    vm.result.chart.labelsUnformated.push(moment(vm.tmpResults[0][j].timestamp).format('DD/MM/YYYY HH:mm'));
                                }
                            }
                            else
                            {
                                vm.result.chart.data[0][j]=vm.result.chart.data[0][j]+vm.tmpResults[i][j].value;
                            }
                        }
                    }
                    for(var i=0;i<vm.result.chart.data[0].length;i++)
                    {
                        vm.result.chart.data[0][i]=vm.result.chart.data[0][i]/vm.tmpResults.length;
                    }
                }
                else
                {
                    vm.result.chart.series=[];
                    vm.result.chart.data=[];
                    vm.result.chart.labels=[];
                    vm.result.chart.labelsUnformated=[];
                    var maxDates=0
                    if(vm.tmpResults.length>1)
                    {
                        for(var i=1;i<vm.tmpResults.length;i++)
                        {
                            if(vm.tmpResults[i].length>vm.tmpResults[i-1].length)
                            {
                                maxDates=i;
                            }
                        }
                    }
                    for(var i=0;i<vm.tmpResults.length;i++)
                    {
                        vm.result.chart.series.push(devices[i].site.name+" -> "+devices[i].device.name+" ("+devices[i].measurement.name+" )");
                        vm.result.chart.data.push([]);
                        for(var j=0;j<vm.tmpResults[i].length;j++)
                        {
                            vm.result.chart.data[i].push(vm.tmpResults[i][j].value)
                            if(i==maxDates)
                            {
                                if(vm.resolutionType==='m' || vm.resolutionType==='h')
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[i][j].timestamp).format('HH:mm'));
                                    vm.result.chart.labelsUnformated.push(moment(vm.tmpResults[i][j].timestamp).format('DD/MM/YYYY HH:mm'));
                                }
                                else
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[i][j].timestamp).format('DD/MM'));
                                    vm.result.chart.labelsUnformated.push(moment(vm.tmpResults[i][j].timestamp).format('DD/MM/YYYY HH:mm'))
                                }
                            }
                        }
                    }
                }
            }
            else
            {
                vm.result.chart.series=[];
                vm.result.chart.data=[];
                vm.result.chart.labels=[];
                vm.result.chart.labelsUnformated=[];
                var maxDates=0
                if(vm.tmpResults.length>1)
                {
                    for(var i=1;i<vm.tmpResults.length;i++)
                    {
                        if(vm.tmpResults[i].length>vm.tmpResults[i-1].length)
                        {
                            maxDates=i;
                        }
                    }
                }
                for(var i=0;i<vm.tmpResults.length;i++)
                {
                    vm.result.chart.series.push(devices[i].site.name+" -> "+devices[i].device.name+" ("+devices[i].measurement.name+" )");
                    vm.result.chart.data.push([]);
                    for(var j=0;j<vm.tmpResults[i].length;j++)
                    {
                        vm.result.chart.data[i].push(vm.tmpResults[i][j].value)
                        if(i==maxDates)
                        {
                            if(vm.resolutionType==='m' || vm.resolutionType==='h')
                            {
                                vm.result.chart.labels.push(moment(vm.tmpResults[i][j].timestamp).format('HH:mm'));
                                vm.result.chart.labelsUnformated.push(moment(vm.tmpResults[i][j].timestamp).format('DD/MM/YYYY HH:mm'));
                            }
                            else
                            {
                                vm.result.chart.labels.push(moment(vm.tmpResults[i][j].timestamp).format('DD/MM'));
                                vm.result.chart.labelsUnformated.push(moment(vm.tmpResults[i][j].timestamp).format('DD/MM/YYYY HH:mm'))
                            }
                        }
                    }
                }
            }
            calculateMetadata();
        }

        function calculateRaw(measurements,cumulative)
        {
            var response=[];
            if(cumulative)
            {
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements[0].entries;
                for(var i=0;i<foo.length;i++)
                {
                    var tmp=
                    {
                        value:foo[i].value,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    response.push(tmp);
                }
            }
            return response;
        }

        function calculateAggregated(measurements,cumulative)
        {
            var response=[];
            if(cumulative)
            {
                var tmpResponse=[];
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    tmpResponse.push(tmp);
                }
                var tmpArray=[];
                var counter=0;
                var current=tmpResponse[0].timestamp;
                var tmpWid=
                {
                    timestamp:current,
                    values:[]
                }
                tmpArray.push(tmpWid);
                for(var i=0;i<tmpResponse.length;i++)
                {
                    if(tmpResponse[i].timestamp-current>=vm.resolutionMinutes*60000)
                    {
                        current=tmpResponse[i].timestamp;
                        var tmpWid=
                        {
                            timestamp:current,
                            values:[]
                        }
                        tmpWid.values.push(tmpResponse[i].value)
                        tmpArray.push(tmpWid);
                        counter++;
                    }
                    else
                    {
                        tmpArray[counter].values.push(tmpResponse[i].value)
                    }
                }
                for(var i=0;i<tmpArray.length;i++)
                {
                    var count=0;
                    for (var j=0;j<tmpArray[i].values.length;j++)
                    {
                        count+=tmpArray[i].values[j];
                    }
                    var tmp=
                    {
                        value:count,
                        timestamp:tmpArray[i].timestamp
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements.data;
                for(var i=0;i<foo.length;i++)
                {
                    var tmp=
                    {
                        value:foo[i].d,
                        timestamp:foo[i].t
                    }
                    response.push(tmp);
                }
            }
            return response;
        }

        function calculateMean(measurements,cumulative)
        {
            var response=[];
            if(cumulative)
            {
                var tmpResponse=[];
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    tmpResponse.push(tmp);
                }
                var tmpArray=[];
                var counter=0;
                var current=tmpResponse[0].timestamp;
                var tmpWid=
                {
                    timestamp:current,
                    values:[]
                }
                tmpArray.push(tmpWid);
                for(var i=0;i<tmpResponse.length;i++)
                {
                    if(tmpResponse[i].timestamp-current>=vm.resolutionMinutes*60000)
                    {
                        current=tmpResponse[i].timestamp;
                        var tmpWid=
                        {
                            timestamp:current,
                            values:[]
                        }
                        tmpWid.values.push(tmpResponse[i].value)
                        tmpArray.push(tmpWid);
                        counter++;
                    }
                    else
                    {
                        tmpArray[counter].values.push(tmpResponse[i].value)
                    }
                }
                for(var i=0;i<tmpArray.length;i++)
                {
                    var count=0;
                    for (var j=0;j<tmpArray[i].values.length;j++)
                    {
                        count+=tmpArray[i].values[j];
                    }
                    var tmp=
                    {
                        value:count/tmpArray[i].values.length,
                        timestamp:tmpArray[i].timestamp
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements.data;
                for(var i=0;i<foo.length;i++)
                {
                    var tmp=
                    {
                        value:foo[i].d,
                        timestamp:foo[i].t
                    }
                    response.push(tmp);
                }
            }
            return response;
        }

        function calculateMax(measurements,cumulative)
        {
            var response=[];
            if(cumulative)
            {
                var tmpResponse=[];
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    tmpResponse.push(tmp);
                }
                var tmpArray=[];
                var counter=0;
                var current=tmpResponse[0].timestamp;
                var tmpWid=
                {
                    timestamp:current,
                    values:[]
                }
                tmpArray.push(tmpWid);
                for(var i=0;i<tmpResponse.length;i++)
                {
                    if(tmpResponse[i].timestamp-current>=vm.resolutionMinutes*60000)
                    {
                        current=tmpResponse[i].timestamp;
                        var tmpWid=
                        {
                            timestamp:current,
                            values:[]
                        }
                        tmpWid.values.push(tmpResponse[i].value)
                        tmpArray.push(tmpWid);
                        counter++;
                    }
                    else
                    {
                        tmpArray[counter].values.push(tmpResponse[i].value)
                    }
                }
                for(var i=0;i<tmpArray.length;i++)
                {
                    var max=tmpArray[i].values[0];
                    for (var j=0;j<tmpArray[i].values.length;j++)
                    {
                        if(tmpArray[i].values[j]>max)
                        {
                            max=tmpArray[i].values[j];
                        }
                    }
                    var tmp=
                    {
                        value:max,
                        timestamp:tmpArray[i].timestamp
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements.data;
                for(var i=0;i<foo.length;i++)
                {
                    var tmp=
                    {
                        value:foo[i].d,
                        timestamp:foo[i].t
                    }
                    response.push(tmp);
                }
            }
            return response;
        }

        function calculateMin(measurements,cumulative)
        {
            var response=[];
            if(cumulative)
            {
                var tmpResponse=[];
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    tmpResponse.push(tmp);
                }
                var tmpArray=[];
                var counter=0;
                var current=tmpResponse[0].timestamp;
                var tmpWid=
                {
                    timestamp:current,
                    values:[]
                }
                tmpArray.push(tmpWid);
                for(var i=0;i<tmpResponse.length;i++)
                {
                    if(tmpResponse[i].timestamp-current>=vm.resolutionMinutes*60000)
                    {
                        current=tmpResponse[i].timestamp;
                        var tmpWid=
                        {
                            timestamp:current,
                            values:[]
                        }
                        tmpWid.values.push(tmpResponse[i].value)
                        tmpArray.push(tmpWid);
                        counter++;
                    }
                    else
                    {
                        tmpArray[counter].values.push(tmpResponse[i].value)
                    }
                }
                for(var i=0;i<tmpArray.length;i++)
                {
                    var min=tmpArray[i].values[0];
                    for (var j=0;j<tmpArray[i].values.length;j++)
                    {
                        if(tmpArray[i].values[j]<min)
                        {
                            min=tmpArray[i].values[j];
                        }
                    }
                    var tmp=
                    {
                        value:min,
                        timestamp:tmpArray[i].timestamp
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements.data;
                for(var i=0;i<foo.length;i++)
                {
                    var tmp=
                    {
                        value:foo[i].d,
                        timestamp:foo[i].t
                    }
                    response.push(tmp);
                }
            }
            return response;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('stringCard', stringCard);

    function stringCard() {
        var directive = {
            templateUrl:"app/directives/string-card/string-card.html",
            controller: StringCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function StringCardController ($scope,$http,session,PRAGMA,$base64,pragmaapi,$rootScope) {
        var vm =this;
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
		vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.result='';
        fillWidget();
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.device.assignment===args.deviceAssignmentToken)
            {
                vm.result=args.metadata.room;
                vm.eventTime = args.eventDate;
            }
        });
        function fillWidget()
        {
            vm.device={};
            vm.cClients=[];
            vm.clients=vm.widget.clients;
            for(var i=0;i<vm.clients.length;i++)
            {
                for(var j=0;j<vm.clients[i].sites.length;j++)
                {
                    var tmp={
                        token:vm.clients[i].token,
                        site:vm.clients[i].sites[j]
                    };
                    vm.cClients.push(tmp);
                }
            }
            for (var cc=0;cc<vm.cClients.length;cc++)
            {
                getDevicesCustom(vm.cClients[cc].token,vm.cClients[cc].site);
            }
        }
        function getDevicesCustom(tenant,site)
        {
            pragmaapi.callRestService(vm.url,"/devices/","?site="+site.token+"&page=1&pageSize=100&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken="+tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
                var devices=res.data.results;
                var centralMeter=null;
                for(var i=0;i<devices.length;i++)
                {
                    for(var j=0;j<site.assignments.length;j++)
                    {
                        if(devices[i].assignment.token==site.assignments[j].token)
                        {                   
                            for(var mea=0;mea<site.assignments[j].measurements.length;mea++)
                            {
                                centralMeter=
                                {
                                    "assignment":devices[i].assignment.token,
                                    "tenant":tenant
                                };
                                vm.device=centralMeter;
                            }
                            break;
                        }
                    }
                }
                getMeasurementsCustom(vm.device);
            });
        }
        function getMeasurementsCustom(centralMeter)
        {         
            pragmaapi.callRestService(vm.url,"/assignments/"+centralMeter.assignment+"/measurements/lastValue","?tenantAuthToken="+centralMeter.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
    
                vm.result=res.data.room;
                vm.eventTime = res.data.timestamp;
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('spyderCard', spyderCard)
		.directive('spyderCardReport', ['pragmaapi','PRAGMA', spyderCardReport]);

    function spyderCard() {
        var directive = {
            templateUrl:"app/directives/spyder-card/spyder-card.html",
            controller: SpyderCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"=",
                dashboardClients:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    function spyderCardReport(pragmaapi,PRAGMA) {
        var directive = {
            templateUrl:"app/directives/spyder-card/spyder-card-report.html",
            controller: SpyderCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"=",
                dashboardClients:"=",
				report:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
			scope.$watch('plotHasFinished', function(newValue, oldValue){
				if (newValue == true) {
					scope.loadingProcess = false;
					var imageContainer = angular.element(element[0].querySelector('#report-image-container'));
					
					var params = {
						widget: scope.vm.widget,
						results: {
							unit: "",
							chart: scope.vm.chart
						}
					};
					
					//console.log(params);
					
					pragmaapi.callRestService(PRAGMA.graphServer, '/chart/', params, true, '', 'POST', true, false).then(function(res){
						//console.log(res);
						scope.loadingProcess = true;
						imageContainer.replaceWith('<div id="report-image-container"><img class="graph" src="' + res.data.base64 + '" alt="graph" /></div>');
					});
					
				}
			}, true);
			
        }
    }
	
    /** @ngInject */
    function SpyderCardController ($scope,session,PRAGMA,pragmaapi,pragmaTheming,$q) {
        var vm =this;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        vm.triggered=false;
		$scope.plotHasFinished = false;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.gridLinesColor="rgba(255,255,255,";
        }
        else
        {
            vm.gridLinesColor="rgba(0,0,0,";
        }
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.dates=[];
        vm.result=0;
        vm.unit="";
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.datesColor="rgb(255,255,255)";
        }
        else
        {
            vm.datesColor="rgb(0,0,0)";
        }
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        fillWidget();
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom" && vm.widget.graph.type!=='lastValue')
                {
                    fillWidget();
                }
				
				if($scope.report)
				{
					$scope.plotHasFinished = false;
					fillWidget();
				}
				
            }
        });

        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today" || vm.widget.graph.type==='lastValue')
            {
                fillWidgetMqtt(args);
            } 
        });

        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        function fillWidget()
        {
            vm.triggered=false;
            vm.totalMax=0;
            vm.tmpResults=[];
            vm.tmpResultsMax=[];
            if(vm.widget.dates[0].date==="custom")
            {
				if($scope.report)
				{
					vm.dates = {
						startDate: moment().startOf('day'),
						endDate: moment()
					};
				}
				else {
					vm.dates=$scope.dashboardDate;
				}
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            vm.chart=
            {
                data:[[]],
                labels:[],
                colors:[],
                options:{
                    scale: {
                        ticks: {
                          beginAtZero: true,
                          fontColor: vm.gridLinesColor+"0.4)", // labels such as 10, 20, etc
                          showLabelBackdrop: false // hide square behind text
                        },
                        pointLabels: {
                          fontColor: vm.gridLinesColor+"0.4)" // labels around the edge like 'Running'
                        },
                        gridLines: {
                          color: vm.gridLinesColor+"0.2)"
                        },
                        angleLines: {
                          color: vm.gridLinesColor+"0.2)" // lines radiating from the center
                        }
                      },
                    legend: {
                        labels: {
                            fontColor: vm.gridLinesColor+"0.8)"
                        },
                        display: false,
                        position: "bottom"
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    return data.labels[tooltipItem.index]+" -> "+ parseFloat(data.datasets[0].data[tooltipItem.index]).toFixed(2) + " "+ vm.unit;
                                }
                            }
                        }
                }
            };
            var tmp = vm.widget.graph.backgroundColor.split("rgb(");
            var tmp2=tmp[1].split(")");
            var lastTmp=tmp2[0].split(",");
            var clr=lastTmp;
            if(!vm.widget.graph.fill)
            {
                var bgclr="rgba("+clr+",0)";
            }
            else
            {
                var bgclr="rgba("+clr+",0.2)";
            }
            vm.chart.colors.push({
                borderColor: vm.widget.graph.backgroundColor,
                backgroundColor: bgclr,
                pointBorderColor: "#fff",
                pointBackgroundColor: vm.widget.graph.backgroundColor,
                pointHoverBorderColor: vm.widget.graph.backgroundColor,
                pointHoverBackgroundColor: "#fff"
            });
            getMeasurements();
            if(vm.widget.graph.other)
            {
                if (vm.widget.graph.otherValueType)
                {
                    getMeasurementsMax();
                }
                else
                {
                    vm.otherValue=vm.widget.graph.maximumValue;
                }
            }
        }
       
        function getMeasurementsMax()
        {
            var devices=vm.widget.graph.maximumClients;
            var promises = [];
            for (var i=0;i<devices.length;i++)
            {
                if(vm.widget.graph.type==='lastValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/checkSensor","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/lastValue","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='aggregatedValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=sum&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=mean&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='maxValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMax=true&type=max&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='minValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMin=true&type=min&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
            }
            $q.all(promises).then(function(resArray) {
                var devices=vm.widget.graph.maximumClients;
                for(var i=0;i<resArray.length;i++)
                {
                    var measurements=resArray[i].data;
                    if(vm.widget.graph.type==='lastValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateLast(measurements,true,devices[i].measurement.measure));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateLast(measurements,false,devices[i].measurement.measure));
                        }
                    }
                    else if(vm.widget.graph.type==='aggregatedValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateAggregated(measurements,true));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateAggregated(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='meanValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateMean(measurements,true));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateMean(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='maxValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateMax(measurements,true));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateMax(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='minValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateMin(measurements,true));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateMin(measurements,false));
                        }
                    }
                }
                calculateEndMax();
            });
        }

        function calculateEndMax()
        {
            var devices=vm.widget.graph.maximumClients;
            vm.results=[];
            if(vm.widget.graph.type==='aggregatedValue' || vm.widget.graph.type==='lastValue')
            {
                var count=0;
                for(var i=0;i<vm.tmpResultsMax.length;i++)
                {
                    count+=vm.tmpResultsMax[i].value;
                }
                vm.otherValue=count;
            }
            else if(vm.widget.graph.type==='meanValue')
            {
                var count=0;
                for(var i=0;i<vm.tmpResultsMax.length;i++)
                {
                    count+=vm.tmpResultsMax[i].value;
                }
                vm.otherValue=count/vm.tmpResultsMax.length;
            }
            else if(vm.widget.graph.type==='maxValue')
            {
                var max=vm.tmpResultsMax[0].value;
                for(var i=0;i<vm.tmpResultsMax.length;i++)
                {
                    if(vm.tmpResultsMax[i].value>max)
                    {
                        max=vm.tmpResultsMax[i].value;
                    }
                }
                vm.otherValue=max;
            }
            else if(vm.widget.graph.type==='minValue')
            {
                var min=vm.tmpResultsMax[0].value;
                for(var i=0;i<vm.tmpResultsMax.length;i++)
                {
                    if(vm.tmpResultsMax[i].value<min)
                    {
                        min=vm.tmpResultsMax[i].value;
                    }
                }
                vm.otherValue=min;
            }
            calculateEndMaxWithClients();
        } 
        function calculateEndMaxWithClients()
        {
            vm.totalMax+=1;
            if(vm.totalMax==2)
            {
                var other=vm.otherValue-vm.count;
                vm.chart.data[0].push(other);
                vm.chart.labels.push("Other");
            }
        }
        function getMeasurements()
        {
            var devices=vm.widget.clients;
            vm.icon='pragma-icon-'+devices[0].specs.type;
            vm.unit=devices[0].specs.unit;
            var promises = [];
            for (var i=0;i<devices.length;i++)
            {
                if(vm.widget.graph.type==='lastValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/checkSensor","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/lastValue","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='aggregatedValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=sum&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=mean&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='maxValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMax=true&type=max&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='minValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMin=true&type=min&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
            }
            $q.all(promises).then(function(resArray) {
                var devices=vm.widget.clients;
                for(var i=0;i<resArray.length;i++)
                {
                    var measurements=resArray[i].data;
                    if(vm.widget.graph.type==='lastValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateLast(measurements,true,devices[i].measurement.measure));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateLast(measurements,false,devices[i].measurement.measure));
                        }
                    }
                    else if(vm.widget.graph.type==='aggregatedValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='meanValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMean(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMean(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='maxValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMax(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMax(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='minValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMin(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMin(measurements,false));
                        }
                    }
                }
                vm.triggered=true;
                calculateEnd();
            });
        }
        function calculateEnd()
        {
            var devices=vm.widget.clients;
            vm.chart.data=[];
            vm.chart.data[0]=[];
            vm.chart.labels=[];
            vm.count=0;
            for(var i=0;i<vm.tmpResults.length;i++)
            {
                if(vm.widget.graph.other)
                {
                    vm.count+=vm.tmpResults[i].value;
                }
                vm.chart.data[0].push(vm.tmpResults[i].value);
                vm.chart.labels.push(devices[i].site.name+" -> "+devices[i].device.name+"( "+devices[i].measurement.name+" )");
            }
            if(vm.widget.graph.other)
            {
                if(vm.widget.graph.otherValueType)
                {
                    calculateEndMaxWithClients();
                }
                else
                {
                    var other=vm.otherValue-vm.count;
                    vm.chart.data[0].push(other);
                    vm.chart.labels.push("Other");
                }
            }
			$scope.plotHasFinished = true;
        }

        function calculateLast(measurements,cumulative,measure)
        {
            if(cumulative)
            {
                if(measurements.length==2)
                {
                    var first=measurements[1][measure];
                    var last=measurements[0][measure];
                    var val=last-first;
                    if(val<0)
                    {
                        val=last;
                    }
                    var response=
                    {
                        value:val,
                        timestamp:measurements[0].timestamp
                    }
                }  
            }
            else
            {
                var response=
                {
                    value:measurements[measure],
                    timestamp:measurements.timestamp
                }
            }
            return response;
        }

        function calculateAggregated(measurements,cumulative)
        {
            if(cumulative)
            {
                var first=measurements[0].entries[0];
                var last=measurements[0].entries[measurements[0].entries.length-1];
                var val=last.value-first.value;
                if(val<0)
                {
                    val=last.value;
                }
                var response=
                {
                    value:val,
                    timestamp:last.measurementDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }

        function calculateMean(measurements,cumulative)
        {
            if(cumulative)
            {
                var foo=measurements[0].entries;
                var tmp=[];
                for (var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var t=val;
                    tmp.push(t);
                }
                var count=0;
                for (var i=0;i<tmp.length;i++)
                {
                    count+=tmp[i];
                }
                var response=
                {
                    value:count/tmp.length,
                    timestamp:foo[foo.length-1].measurementDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }

        function calculateMax(measurements,cumulative)
        {
            if(cumulative)
            {
                var foo=measurements[0].entries;
                var tmp=[];
                for (var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var t={value:val,timestamp:foo[i].measurementDate};
                    tmp.push(t);
                }
                var max=tmp[0].value;
                var maxDate=tmp[0].timestamp;
                for (var i=0;i<tmp.length;i++)
                {
                    if(tmp[i].value>max)
                    {
                        max=tmp[i].value;
                        maxDate=tmp[i].timestamp;
                    }

                }
                var response=
                {
                    value:max,
                    timestamp:maxDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }

        function calculateMin(measurements,cumulative)
        {
            if(cumulative)
            {
                var foo=measurements[0].entries;
                var tmp=[];
                for (var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var t={value:val,timestamp:foo[i].measurementDate};
                    tmp.push(t);
                }
                var min=tmp[0].value;
                var minDate=tmp[0].timestamp;
                for (var i=0;i<tmp.length;i++)
                {
                    if(tmp[i].value<min)
                    {
                        min=tmp[i].value;
                        minDate=tmp[i].timestamp;
                    }

                }
                var response=
                {
                    value:min,
                    timestamp:minDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('sectionWidget', sectionWidget);

    function sectionWidget() {
        var directive = {
            templateUrl:"app/directives/section-widget/section-widget.html",
            controller: SectionWidgetController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function SectionWidgetController ($scope) {
        var vm =this;
        vm.widget=$scope.widget;

    }
})();
(function () {
    'use strict';

    angular
        .module('app.directives')
        .directive('presenceCard', presenceCard);

    function presenceCard() {
        var directive = {
            templateUrl: "app/directives/presence-card/presence-card.html",
            controller: PresenceCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate: "="
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }

    /** @ngInject */
    function PresenceCardController($rootScope, $scope, $http, $base64, $timeout, session, pragmaapi, pragmaTheming, PRAGMA) {
        var vm = this;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);

        vm.widget = $scope.widget;
        vm.devices = null;
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        vm.url = PRAGMA.api;
        vm.dateColor="#6a6a6a";
        if (isDark) {
            vm.dateColor="rgb(255,255,255)";
        }

        activate();

        function activate() {
            fillWidget();

            $scope.$on('new.measurement.broadcast', function (event, args) {
                if(vm.devices) {
                    var i=0,l=vm.devices.length;
                    for (i;i<l;i++) {
                        if(vm.devices[i].assignment===args.deviceAssignmentToken) {
                            $scope.$apply(function() {
                                if(args.measurements && args.measurements.bulgrarAlarm!=undefined) {
                                    vm.devices[i].measurements = args.measurements;
                                }
                                if(args.eventDate) {
                                    vm.devices[i].measurements.timestamp = args.eventDate;
                                }
                            });
                        }
                    }
                }
            });
        }
        
        
        function fillWidget() {
            vm.clients = vm.widget.clients;
            vm.devices = [];
            for (var i = 0; i < vm.clients.length; i++) {
                for (var j = 0; j < vm.clients[i].sites.length; j++) {
                    getDevicesCustom(vm.clients[i].token, vm.clients[i].sites[j])
                }
            }
        }

        function getDevicesCustom(tenant, site) {
            pragmaapi.callRestService(vm.url, "/devices/", "?site=" + site.token + "&page=1&pageSize=2000&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken=" + tenant, true, vm.user.authentication, "GET", true, false).then(function (res) {
                var devices = res.data.results;
                var centralMeter = null;
                for (var i = 0; i < devices.length; i++) {
                    for (var j = 0; j < site.assignments.length; j++) {
                        if (devices[i].assignment.token == site.assignments[j].token) {
                            centralMeter = {
                                "assignment": devices[i].assignment.token,
                                "name": devices[i].metadata.name,
                                "type": devices[i].metadata.type,
                                "tenant": tenant,
                                "specs": JSON.parse(devices[i].specification.metadata.specs),
                                "binType": devices[i].metadata.binType
                            };
                            vm.devices.push(centralMeter);
                        }
                    }
                }

                if(vm.devices.length) {
                    var i=0, l=vm.devices.length;
                    for(i;i<l;i++) {
                        getMeasurementsCustom(vm.devices[i]);
                    }
                }
            });
        }

        function getMeasurementsCustom(centralMeter) {
            pragmaapi.callRestService(vm.url, "/assignments/" + centralMeter.assignment + "/measurements/lastValue", "?measuredParameter=bulgrarAlarm&tenantAuthToken=" + centralMeter.tenant, true, vm.user.authentication, "GET", true, false).then(function (res) {
                if(res.data) {
                    centralMeter.measurements = res.data;
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
		.directive('predictionPlot', predictionPlot);

    function predictionPlot() {
        var directive = {
            templateUrl:"app/directives/prediction-plot/prediction-plot.html",
            controller: PredictionPlotController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }

    /** @ngInject */
    function PredictionPlotController ($scope,session,PRAGMA,$q,pragmaapi,pragmaTheming) {
        var vm =this;
		var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        var themes = pragmaTheming.themes;
        vm.chartAggregated=null;
        vm.chartType='line';
        vm.plotId=generateUUID();
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.gridLinesColor="rgba(255,255,255,";
        }
        else
        {
            vm.gridLinesColor="rgba(0,0,0,";
        }
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.dates=[];
        fillWidget();
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                fillWidget();
            }
        });  
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };   
        function fillWidget() {
            vm.triggered=false;
            vm.tmpResults=[];
            if(vm.widget.graph.graphType==='step') {
                vm.step = true;
            }
            else if(vm.widget.graph.graphType==='bar')
            {
               vm.graphType="bar";
            }
            else if(vm.widget.graph.graphType==='bubble')
            {
                vm.showLine=false;
            }
            if(vm.widget.dates[0].date==="custom")
            {
				if($scope.report)
				{
					vm.dates = {
						startDate: moment().startOf('day'),
						endDate: moment()
					};
				}
				else {
					vm.dates=$scope.dashboardDate;
				}
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment().endOf('day')
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            vm.resolutionType=vm.widget.time.resolutionType;
            vm.resolutionValue=vm.widget.time.resolutionValue;
            var dF = Date.parse(vm.dates.startDate) / 1000;
            var dT = Date.parse(vm.dates.endDate) / 1000;
            var def=dT-dF;
            var day = 86400;
            vm.resolutionMinutes=0;
            if (def > day && def <= day * 30 && vm.resolutionType==='m' && vm.resolutionValue<60) { 
                vm.resolutionType="d";
                vm.resolutionValue=1;
            }
            else if (def > day * 30 && vm.resolutionType!=='d' && vm.resolutionType!=='M'){
                vm.resolutionType = "M";
                vm.resolutionValue = 1;
            }
            if(vm.resolutionType==='m')
            {
                vm.resolutionMinutes=vm.resolutionValue;
            }
            else if(vm.resolutionType==='h')
            {
                vm.resolutionMinutes=vm.resolutionValue*60;
            }
            else if(vm.resolutionType==='d')
            {
                vm.resolutionMinutes=vm.resolutionValue*60*24;
            }
            else if(vm.resolutionType==='M')
            {
                vm.resolutionMinutes=vm.resolutionValue*60*24*30;
            }
            vm.datesCumulative={};
			angular.copy(vm.dates,vm.datesCumulative);
            vm.datesCumulative.startDate = vm.datesCumulative.startDate.subtract(vm.resolutionMinutes, 'minutes');
            getMeasurements();
        }

        var fillBetweenLinesPlugin = {
            afterDatasetsDraw: function (chart) {
                var ctx = chart.chart.ctx;
                var xaxis = chart.scales['x-axis-0'];
                var yaxis = chart.scales['y-axis-0'];
                var datasets = chart.data.datasets;
                ctx.save();

                for (var d = 0; d < datasets.length; d++) {
                    var dataset = datasets[d];
                    if (dataset.fillBetweenSet == undefined) {
                        continue;
                    }

                    // get meta for both data sets
                    var meta1 = chart.getDatasetMeta(d);
                    var meta2 = chart.getDatasetMeta(dataset.fillBetweenSet);
                    
                    // do not draw fill if one of the datasets is hidden
                    if (meta1.hidden || meta2.hidden) continue;
                    
                    // create fill areas in pairs
                    for (var p = 0; p < meta1.data.length-1;p++) {
                        // if null skip
                    if (dataset.data[p] == null || dataset.data[p+1] == null) continue;
                    
                    ctx.beginPath();
                    
                    // trace line 1
                    var curr = meta1.data[p];
                    var next = meta1.data[p+1];
                    ctx.moveTo(curr._view.x, curr._view.y);
                    ctx.lineTo(curr._view.x, curr._view.y);
                    if (curr._view.steppedLine === true) {
                        ctx.lineTo(next._view.x, curr._view.y);
                        ctx.lineTo(next._view.x, next._view.y);
                    }
                    else if (next._view.tension === 0) {
                        ctx.lineTo(next._view.x, next._view.y);
                    }
                    else {
                        ctx.bezierCurveTo(
                            curr._view.controlPointNextX,
                            curr._view.controlPointNextY,
                            next._view.controlPointPreviousX,
                            next._view.controlPointPreviousY,
                            next._view.x,
                            next._view.y
                        );
                                    }
                    
                    // connect dataset1 to dataset2
                    var curr = meta2.data[p+1];
                    var next = meta2.data[p];
                    ctx.lineTo(curr._view.x, curr._view.y);

                    // trace BACKWORDS set2 to complete the box
                    if (curr._view.steppedLine === true) {
                        ctx.lineTo(curr._view.x, next._view.y);
                        ctx.lineTo(next._view.x, next._view.y);
                    }
                    else if (next._view.tension === 0) {
                        ctx.lineTo(next._view.x, next._view.y);
                    }
                    else {
                        // reverse bezier
                        ctx.bezierCurveTo(
                        curr._view.controlPointPreviousX,
                        curr._view.controlPointPreviousY,
                        next._view.controlPointNextX,
                        next._view.controlPointNextY,
                        next._view.x,
                        next._view.y
                        );
                    }

                                    // close the loop and fill with shading
                    ctx.closePath();
                    ctx.fillStyle = dataset.fillBetweenColor || "rgba(0,0,0,0.1)";
                    ctx.fill();
                    } // end for p loop
                }
            } // end afterDatasetsDraw
        }; // end fillBetweenLinesPlugin
        Chart.pluginService.register(fillBetweenLinesPlugin);
        vm.options = {

			spanGaps: false,
            legend: {
                labels: {
                    fontColor: vm.gridLinesColor+"0.6)"
                },
                display: true,
                position: "bottom"
            },
            tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        return parseFloat(tooltipItem.yLabel).toFixed(2) + " " + vm.unit;
                    }
                }
            },
            responsive: true,
            animation: {
                duration: 800
            },
			elements: {
				line: {
					tension: 0.000001
				}
			},
			scales: {
                xAxes: [
                    {
                        gridLines: {
                            display: true ,
                            color: vm.gridLinesColor+"0.2)"
                          },
                        ticks: {
                            maxRotation: 0,
                            fontSize: 10,
                            autoSkipPadding: 10,
                            fontColor: vm.gridLinesColor+"0.6)"
                        }
                    }
                ],
                yAxes: [
                    {
                        gridLines: {
                            display: true ,
                            color: vm.gridLinesColor+"0.2)"
                        },
                        ticks: {
                            maxRotation: 0,
                            fontSize: 10,
                            autoSkipPadding: 10,
                            fontColor: vm.gridLinesColor+"0.6)"
                        },
                        scaleLabel: { 
                            display: false,
                            labelString: '',
                        }
                    }
                ]
            },
			plugins: {
				filler: {
					propagate: false
				},
				samples_filler_analyser: {
					target: vm.plotId
				}
			}
        };
        function getMeasurements()
        {
            if(vm.widget.graph.algorithm==='long_prediction')
            {
                vm.unit=vm.widget.clients[0].specs.unit;   
                var measure=vm.widget.clients[0].measurement.measure;
                var measurements=measure+","+measure+"_max,"+measure+"_min,"+measure+"_median,"+measure+"_ci_lower,"+measure+"_ci_upper,"+measure+"_preds";
                vm.labels=[];
                vm.showGraph=false;
                pragmaapi.callRestService(PRAGMA.api,"/assignments/" +  vm.widget.clients[0].device.token + "/measurements/series","?page=1&pageSize=2000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDT23:59:59.000') + vm.timeZone)+"&measurementIds="+measurements+"&tenantAuthToken=" + vm.widget.clients[0].tenant.token, true, vm.user.authentication, "GET", true).then(function(res){
                    if(res.data.length<4)
                    {
                        vm.showGraph=false;
                    }
                    else
                    {
                        var datasets=[];
                        var labels=[];
                        var tmpMin=0
                        for(var i=0;i<res.data.length;i++)
                        {
                            var fooFill=res.data[i];
                            if(fooFill.measurementId==measure+"_min" || fooFill.measurementId==measure+"_ci_lower")
                            {
                                tmpMin=i;
                            }
                        }
                        for(var i=0;i<res.data.length;i++)
                        {
                            var foo=res.data[i];
                            var tmpData=[];
                            for(var j=0;j<foo.entries.length;j++)
                            {
                                tmpData.push(foo.entries[j].value)
                                if(foo.measurementId===measure+"_max" || foo.measurementId===measure+"_ci_upper")
                                {
                                    var dd=new Date(foo.entries[j].measurementDate);
                                    var date=moment(dd).format("HH:mm (D/M)")
                                    labels.push(date)
                                }
                            }
                            if(foo.measurementId===measure+"_max" || foo.measurementId===measure+"_ci_upper")
                            {
                                var tmpDataset={
                                    pointRadius:1,
                                    backgroundColor:"rgba(255,152,0,0)",
                                    borderColor:"rgba(255,152,0,1)",
                                    label:"Maximum Predicted Value",
                                    type:"line",
                                    data:tmpData,
                                    fill:false,
                                    hidden:false,
                                    fillBetweenSet:tmpMin,
                                    fillBetweenColor: "rgba(255,152,0, 0.1)"
                                };
                            }
                            else if(foo.measurementId===measure+"_min" || foo.measurementId===measure+"_ci_lower")
                            {
                                var tmpDataset={
                                    pointRadius:1,
                                    backgroundColor:"rgba(255,152,0,0)",
                                    borderColor:"rgba(255,152,0,1)",
                                    label:"Minimum Predicted Value",
                                    type:"line",
                                    data:tmpData,
                                    fill:false,
                                    hidden:false
                                };
                            }
                            else if(foo.measurementId===measure+"_median" || foo.measurementId===measure+"_preds")
                            {
                                var tmpDataset={
                                    pointRadius:1,
                                    backgroundColor:"rgba(0,204,24,0)",
                                    borderColor:"rgba(0,204,24,1)",
                                    label:"Mean Predicted Value",
                                    type:vm.chartType,
                                    data:tmpData,
                                    fill:false,
                                    hidden:false,
                                    borderDash: [6, 2]
                                };
                            }
                            else
                            {
                                var tmpDataset={
                                    pointRadius:1,
                                    backgroundColor:"rgba(4,9,242,0)",
                                    borderColor:"rgba(4,9,242,1)",
                                    label:measure +"("+vm.widget.clients[0].device.name+")",
                                    type:vm.chartType,
                                    data:tmpData,
                                    fill:false,
                                    hidden:false
                                };
                            }
                            datasets.push(tmpDataset)
                        }
                        var ctx = document.getElementById(vm.plotId);
                        if(vm.chartAggregated==null)
                        {
                             vm.chartAggregated = new Chart(ctx, {
                                type: vm.chartType,
                                data: { labels: labels, datasets : datasets },
                                options: vm.options
                            });
                            vm.showGraph=true;
                        }
                        else
                        {
                            vm.chartAggregated.destroy();
                            vm.chartAggregated = new Chart(ctx, {
                                type: vm.chartType,
                                data: { labels: labels, datasets : datasets },
                                options: vm.options
                            });
                            vm.showGraph=true;
                        }
                    }
                });
            }
            else if(vm.widget.graph.algorithm==='short_prediction')
            {
                vm.unit=vm.widget.clients[0].specs.unit;   
                var measure=vm.widget.clients[0].measurement.measure;
                var measurements=measure+","+measure+"_ci_lower_short,"+measure+"_ci_upper_short,"+measure+"_preds_short";
                vm.labels=[];
                vm.showGraph=false;
                pragmaapi.callRestService(PRAGMA.api,"/assignments/" +  vm.widget.clients[0].device.token + "/measurements/series","?page=1&pageSize=2000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDT23:59:59.000') + vm.timeZone)+"&measurementIds="+measurements+"&tenantAuthToken=" + vm.widget.clients[0].tenant.token, true, vm.user.authentication, "GET", true).then(function(res){
                    if(res.data.length<4)
                    {
                        vm.showGraph=false;
                    }
                    else
                    {
                        var datasets=[];
                        var labels=[];
                        var tmpMin=0
                        for(var i=0;i<res.data.length;i++)
                        {
                            var fooFill=res.data[i];
                            if(fooFill.measurementId==measure+"_ci_lower_short")
                            {
                                tmpMin=i;
                            }
                        }
                        for(var i=0;i<res.data.length;i++)
                        {
                            var foo=res.data[i];
                            var tmpData=[];
                            for(var j=0;j<foo.entries.length;j++)
                            {
                                tmpData.push(foo.entries[j].value)
                                if(foo.measurementId===measure+"_ci_upper_short")
                                {
                                    var dd=new Date(foo.entries[j].measurementDate);
                                    var date=moment(dd).format("HH:mm (D/M)")
                                    labels.push(date)
                                }
                            }
                            if(foo.measurementId===measure+"_ci_upper_short")
                            {
                                var tmpDataset={
                                    pointRadius:1,
                                    backgroundColor:"rgba(255,152,0,0)",
                                    borderColor:"rgba(255,152,0,1)",
                                    label:"Maximum Predicted Value",
                                    type:"line",
                                    data:tmpData,
                                    fill:false,
                                    hidden:false,
                                    fillBetweenSet:tmpMin,
                                    fillBetweenColor: "rgba(255,152,0, 0.1)"
                                };
                            }
                            else if(foo.measurementId===measure+"_ci_lower_short")
                            {
                                var tmpDataset={
                                    pointRadius:1,
                                    backgroundColor:"rgba(255,152,0,0)",
                                    borderColor:"rgba(255,152,0,1)",
                                    label:"Minimum Predicted Value",
                                    type:"line",
                                    data:tmpData,
                                    fill:false,
                                    hidden:false
                                };
                            }
                            else if(foo.measurementId===measure+"_preds_short")
                            {
                                var tmpDataset={
                                    pointRadius:1,
                                    backgroundColor:"rgba(0,204,24,0)",
                                    borderColor:"rgba(0,204,24,1)",
                                    label:"Mean Predicted Value",
                                    type:vm.chartType,
                                    data:tmpData,
                                    fill:false,
                                    hidden:false,
                                    borderDash: [6, 2]
                                };
                            }
                            else
                            {
                                var tmpDataset={
                                    pointRadius:1,
                                    backgroundColor:"rgba(4,9,242,0)",
                                    borderColor:"rgba(4,9,242,1)",
                                    label:measure +"("+vm.widget.clients[0].device.name+")",
                                    type:vm.chartType,
                                    data:tmpData,
                                    fill:false,
                                    hidden:false
                                };
                            }
                            datasets.push(tmpDataset)
                        }
                        var ctx = document.getElementById(vm.plotId);
                        if(vm.chartAggregated==null)
                        {
                             vm.chartAggregated = new Chart(ctx, {
                                type: vm.chartType,
                                data: { labels: labels, datasets : datasets },
                                options: vm.options
                            });
                            vm.showGraph=true;
                        }
                        else
                        {
                            vm.chartAggregated.destroy();
                            vm.chartAggregated = new Chart(ctx, {
                                type: vm.chartType,
                                data: { labels: labels, datasets : datasets },
                                options: vm.options
                            });
                            vm.showGraph=true;
                        }
                    }
                });
            }
            else
            {
                vm.unit=vm.widget.clients[0].specs.unit;                
                vm.datasets=[];
                vm.labels=[];
                vm.showGraph=false;
                var measure=vm.widget.clients[0].measurement.measure;
                var measurements=measure+"_dis";
                var promises=[];
                promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/" +  vm.widget.clients[0].device.token + "/measurementsAggregated","?measuredParameter="+measure+"&resolutionType=m&resolution=5&includeTotalMin=false&includeTotalMax=false&includeTotalAvg=false&includeTotalSum=false&type=mean&page=1&pageSize=2000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&tenantAuthToken=" + vm.widget.clients[0].tenant.token, true, vm.user.authentication, "GET", true))
                promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/" +  vm.widget.clients[0].device.token + "/measurementsAggregated","?measuredParameter="+measurements+"&resolutionType=m&resolution=5&includeTotalMin=false&includeTotalMax=false&includeTotalAvg=false&includeTotalSum=false&type=mean&page=1&pageSize=2000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&tenantAuthToken=" + vm.widget.clients[0].tenant.token, true, vm.user.authentication, "GET", true))
                $q.all(promises).then(function(resArray) {
                    var tmpData=[];
                    var res=resArray[0].data.data;
                    for (var i=0;i<res.length;i++)
                    {
                        tmpData.push(res[i].d);
                    }
                    var tmpDataset={
                        pointRadius:1,
                        backgroundColor:"rgba(4,9,242,0)",
                        borderColor:"rgba(4,9,242,1)",
                        label:measure+"("+vm.widget.clients[0].device.name+")",
                        type:vm.chartType,
                        data:tmpData,
                        fill:false,
                        hidden:false
                    };
                    vm.datasets.push(tmpDataset);
                    var tmpData=[];
                    var res=resArray[1].data.data;
                    for (var i=0;i<res.length;i++)
                    {
                        tmpData.push(res[i].d);
                        var dd=new Date(res[i].t);
                        var date=moment(dd).format("HH:mm (D/M)")
                        vm.labels.push(date)
                    }
                    var tmpDataset={
                        pointRadius:1,
                        backgroundColor:"rgba(0,204,24,0)",
                        borderColor:"rgba(0,204,24,1)",
                        label:"Predicted Value",
                        type:vm.chartType,
                        data:tmpData,
                        fill:false,
                        hidden:false,
                        borderDash: [6, 2]
                    };
                    vm.datasets.push(tmpDataset);
                    var ctx = document.getElementById(vm.plotId);
                    if(vm.chartAggregated==null)
                    {
                            vm.chartAggregated = new Chart(ctx, {
                            type: vm.chartType,
                            data: { labels: vm.labels, datasets : vm.datasets },
                            options: vm.options
                        });
                        vm.showGraph=true;
                    }
                    else
                    {
                        vm.chartAggregated.destroy();
                        vm.chartAggregated = new Chart(ctx, {
                            type: vm.chartType,
                            data: { labels: vm.labels, datasets : vm.datasets },
                            options: vm.options
                        });
                        vm.showGraph=true;
                    }
                });
            }
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('plugwiseCard', plugwiseCard);

    function plugwiseCard() {
        var directive = {
            templateUrl:"app/directives/plugwise-card/plugwise-card.html",
            controller: PlugwiseCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function PlugwiseCardController ($rootScope,$scope,session,PRAGMA,pragmaapi,pragmaTheming,$q) {
        var vm =this;
        vm.device={};
        vm.timeout=null;
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
		vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.changeStatus=changeStatus;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(255,255,255)";
            }
        }
        else
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(0,0,0)";
            }
        }
        $scope.$on('new.measurement.broadcast', function(event, args) {
            fillWidgetMqtt(args);
        });
        fillWidget();
        function fillWidget()
        {
            vm.tmpResults=[];
            getMeasurements();
        }
        function getMeasurements()
        {

            var promises=[];
            for (var i=0;i<vm.widget.clients.length;i++)
            {
                promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[i].device.token+"/measurements/lastValue","?measuredParameter=consumption&tenantAuthToken="+vm.widget.clients[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[i].device.token+"/measurements/lastValue","?measuredParameter=status&tenantAuthToken="+vm.widget.clients[i].tenant.token,true,vm.user.authentication,"GET",true,false));

            }
            $q.all(promises).then(function(resArray) {
                vm.tmpResults=[];
                for(var i=0;i<resArray.length;i=i+2)
                {
                    var res=resArray[i].data; 
                    var res2=resArray[i+1].data; 
                    var st=true;
                    if(res2.status==0)
                    {
                        st=false;
                    }
                    var tmp={
                        consumption:res.consumption,
                        status:st,
                        hardwareId:vm.widget.clients[i/2].device.hardwareId,
                        deviceName:vm.widget.clients[i/2].device.name
                    } 
                    vm.tmpResults.push(tmp)
                }
                vm.results=vm.tmpResults;
            });
        }
        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    fillWidget();
                    break;
                }
            }
        }
        function changeStatus(device)
        {
            var message=device.hardwareId+"|";
            if(device.status)
                message+="On";
            else
                message+="Off"
            var topic="/plugwise/"+device.hardwareId+"/control";
            $rootScope.client.publish(topic, message);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.directives')
		.directive('plotCard', plotCard)
		.directive('plotCardReport', ['pragmaapi','PRAGMA', plotCardReport]);

    function plotCard() {
        var directive = {
            templateUrl:"app/directives/plot-card/plot-card.html",
            controller: PlotCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    function plotCardReport(pragmaapi,PRAGMA) {
        var directive = {
            templateUrl:"app/directives/plot-card/plot-card-report.html",
            controller: PlotCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"=",
				report:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
			
			scope.$watch('plotHasFinished', function(newValue, oldValue){
				if (newValue == true) {
					scope.loadingProcess = false;
					var imageContainer = angular.element(element[0].querySelector('#report-image-container'));
					
					var params = {
						widget: scope.vm.widget,
						results: {
							unit: '',
							chart: scope.vm.result.chart
						}
					};
					
					pragmaapi.callRestService(PRAGMA.graphServer, '/chart/', params, true, '', 'POST', true, false).then(function(res){
						scope.loadingProcess = true;
						imageContainer.replaceWith('<div id="report-image-container"><img class="graph" src="' + res.data.base64 + '" alt="graph" /></div>');
					});
				}
			}, true);
        }
    }

    /** @ngInject */
    function PlotCardController ($scope,session,PRAGMA,pragmaapi,pragmaTheming,$q) {
        var vm =this;
		$scope.plotHasFinished = false;
		
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.dates=[];
        vm.result=0;
        vm.triggered=false;
        vm.unit="";
        vm.counter=0;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(255,255,255)";
            }
            vm.gridLinesColor="rgba(255,255,255,";
        }
        else
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(0,0,0)";
            }
            vm.gridLinesColor="rgba(0,0,0,";
        }
        vm.colors=
        [
            "3,169,244",
            "146,39,143",
            "170,198,6",
            "242,135,6",
            "191, 0, 255",
            "0,191,118",
            "102,45,145",
            "236,0,140",
            "0,148,68",
            "249,237,50",
            "239,65,54",
        ];
        vm.fill="0";
        if(vm.widget.graph.fill)
        {
            vm.fill="0.2";
        }
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        fillWidget();
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom")
                {
                    fillWidget();
                }
				
				if($scope.report)
				{
					$scope.plotHasFinished = false;
					fillWidget();
				}
				
            }
        });
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today")
            {
                fillWidgetMqtt(args);
            } 
        });

        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        function fillWidget()
        {
            vm.triggered=false;
            vm.tmpResults=[];
            vm.step = false;
            vm.graphType="line";
            vm.showLine=true;
            if(vm.widget.graph.graphType==='step') {
                vm.step = true;
            }
            else if(vm.widget.graph.graphType==='bar')
            {
               vm.graphType="bar";
            }
            else if(vm.widget.graph.graphType==='bubble')
            {
                vm.showLine=false;
            }
            if(vm.widget.dates[0].date==="custom")
            {
				if($scope.report)
				{
					vm.dates = {
						startDate: moment().startOf('day'),
						endDate: moment()
					};
				}
				else {
					vm.dates=$scope.dashboardDate;
				}
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            vm.resolutionType=vm.widget.time.resolutionType;
            vm.resolutionValue=vm.widget.time.resolutionValue;
            var dF = Date.parse(vm.dates.startDate) / 1000;
            var dT = Date.parse(vm.dates.endDate) / 1000;
            var def=dT-dF;
            var day = 86400;
            vm.resolutionMinutes=0;
            if (def > day && def <= day * 30 && vm.resolutionType==='m' && vm.resolutionValue<60) { 
                vm.resolutionType="d";
                vm.resolutionValue=1;
            }
            else if (def > day * 30 && vm.resolutionType!=='d' && vm.resolutionType!=='M'){
                vm.resolutionType = "M";
                vm.resolutionValue = 1;
            }
            if(vm.resolutionType==='m')
            {
                vm.resolutionMinutes=vm.resolutionValue;
            }
            else if(vm.resolutionType==='h')
            {
                vm.resolutionMinutes=vm.resolutionValue*60;
            }
            else if(vm.resolutionType==='d')
            {
                vm.resolutionMinutes=vm.resolutionValue*60*24;
            }
            else if(vm.resolutionType==='M')
            {
                vm.resolutionMinutes=vm.resolutionValue*60*24*30;
            }
            vm.datesCumulative={};
			angular.copy(vm.dates,vm.datesCumulative);
            vm.datesCumulative.startDate = vm.datesCumulative.startDate.subtract(vm.resolutionMinutes, 'minutes');
            vm.result = {
                chart: {
                    data: [],
                    labels: [],
                    series: [],
                    colors: [],
                    override: [],
                    options: {
                        legend: {
                            labels: {
                                fontColor: vm.gridLinesColor+"0.6)"
                            },
                            display: true,
                            position: "bottom"
                        },
                        elements: {
							point: {
								pointStyle: vm.widget.graph.point
							}
						},
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [
                                {
                                    gridLines: {
                                        display: true ,
                                        color: vm.gridLinesColor+"0.2)"
                                      },
                                    ticks: {
                                        maxRotation: 0,
                                        fontSize: 10,
                                        autoSkipPadding: 10,
                                        fontColor: vm.gridLinesColor+"0.6)"
                                    }
                                }
                            ],
                            yAxes: [
                                {
                                    gridLines: {
                                        display: true ,
                                        color: vm.gridLinesColor+"0.2)"
                                    },
                                    ticks: {
                                        maxRotation: 0,
                                        fontSize: 10,
                                        autoSkipPadding: 10,
                                        fontColor: vm.gridLinesColor+"0.6)"
                                    },
                                    scaleLabel: { 
                                        display: false,
                                        labelString: '',
                                    }
                                }
                            ]
                        },
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    var unit=vm.unit
                                    return parseFloat(tooltipItem.yLabel).toFixed(2) + " " + unit;
                                }
                            }
                        }
                    }
                }
            };
            getMeasurements();
        }
       
        function getMeasurements()
        {
            var devices=vm.widget.clients;
            vm.unit=devices[0].specs.unit;
            var promises = [];
            for (var i=0;i<devices.length;i++)
            {
                if(vm.widget.graph.type==='rawData')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                }
                else if(vm.widget.graph.type==='aggregatedValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType="+vm.resolutionType+"&resolution="+vm.resolutionValue+"&includeTotalSum=false&type=sum&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType="+vm.resolutionType+"&resolution="+vm.resolutionValue+"&includeTotalSum=false&type=mean&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='maxValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType="+vm.resolutionType+"&resolution="+vm.resolutionValue+"&includeTotalMax=true&type=max&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='minValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType="+vm.resolutionType+"&resolution="+vm.resolutionValue+"&includeTotalMin=true&type=min&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
            }
            $q.all(promises).then(function(resArray) {
                var devices=vm.widget.clients;
                for(var i=0;i<resArray.length;i++)
                {
                    var measurements=resArray[i].data;
                    if(vm.widget.graph.type==='rawData')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateRaw(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateRaw(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='aggregatedValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='meanValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMean(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMean(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='maxValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMax(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMax(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='minValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMin(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMin(measurements,false));
                        }
                    }
                }
                vm.triggered=true;
                calculateEnd();
            });
        }
        function calculateMetadata()
        {
            vm.metadata={
                total:0,
                mean:0,
                min:0,
                max:0
            }
            var counter=0;
            vm.metadata.total=0;
            vm.metadata.max=vm.result.chart.data[0][0];
            vm.metadata.min=vm.result.chart.data[0][0];
            for(var i=0;i<vm.result.chart.data.length;i++)
            {
                for(var j=0;j<vm.result.chart.data[i].length;j++)
                {
                    vm.metadata.total+=vm.result.chart.data[i][j];
                    counter++;
                    if(vm.result.chart.data[i][j]>vm.metadata.max)
                    {
                        vm.metadata.max=vm.result.chart.data[i][j];
                    }
                    if(vm.result.chart.data[i][j]<vm.metadata.min)
                    {
                        vm.metadata.min=vm.result.chart.data[i][j];
                    }
                }
            }
            vm.metadata.mean=vm.metadata.total/counter;
			$scope.plotHasFinished = true;
        }
        function calculateEnd()
        {
            var devices=vm.widget.clients;
            vm.results=[];
            if(vm.widget.graph.aggregated)
            {
                if(vm.widget.graph.type==='aggregatedValue')
                {
                    vm.result.chart.series=[];
                    vm.result.chart.series.push(vm.widget.title);
                    vm.result.chart.colors=[];
                    var tmp = vm.widget.graph.backgroundColor.split("rgb(");
                    var tmp2=tmp[1].split(")");
                    var lastTmp=tmp2[0].split(",");
                    var clr=lastTmp;
                    if(!vm.widget.graph.fill)
                    {
                        var bgclr="rgba("+clr+",0)";
                    }
                    else
                    {
                        var bgclr="rgba("+clr+",0.2)";
                    }
                    vm.result.chart.colors.push({
                        type:vm.graphType,
                        showLine: vm.showLine,
                        steppedLine: vm.step,
                        lineTension : 0,
                        pointHoverRadius:(vm.widget.graph.pointSize)+3,
                        pointRadius:vm.widget.graph.pointSize,
                        borderColor: vm.widget.graph.backgroundColor,
                        backgroundColor: bgclr,
                        pointBorderColor: vm.widget.graph.backgroundColor,
                        pointBackgroundColor: vm.widget.graph.backgroundColor,
                        pointHoverBorderColor: vm.widget.graph.backgroundColor,
                        pointHoverBackgroundColor: vm.widget.graph.backgroundColor
                    });
                    vm.result.chart.data=[];
                    vm.result.chart.data.push([]);
                    vm.result.chart.labels=[];
                    for(var i=0;i<vm.tmpResults.length;i++)
                    {
                        for(var j=0;j<vm.tmpResults[i].length;j++)
                        {
                            if(i==0)
                            {
                                vm.result.chart.data[0].push(vm.tmpResults[0][j].value)
                                if(vm.resolutionType==='m' || vm.resolutionType==='h')
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[0][j].timestamp).format('HH:mm'))
                                }
                                else
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[0][j].timestamp).format('DD/MM'))
                                }
                            }
                            else
                            {
                                vm.result.chart.data[0][j]=vm.result.chart.data[0][j]+vm.tmpResults[i][j].value;
                            }
                        }
                    }
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    vm.result.chart.series=[];
                    vm.result.chart.series.push(vm.widget.title);
                    vm.result.chart.colors=[];
                    var tmp = vm.widget.graph.backgroundColor.split("rgb(");
                    var tmp2=tmp[1].split(")");
                    var lastTmp=tmp2[0].split(",");
                    var clr=lastTmp;
                    if(!vm.widget.graph.fill)
                    {
                        var bgclr="rgba("+clr+",0)";
                    }
                    else
                    {
                        var bgclr="rgba("+clr+",0.2)";
                    }
                    vm.result.chart.colors.push({
                        type:vm.graphType,
                        showLine: vm.showLine,
                        steppedLine: vm.step,
                        lineTension : 0,
                        pointHoverRadius:(vm.widget.graph.pointSize)+3,
                        pointRadius:vm.widget.graph.pointSize,
                        borderColor: vm.widget.graph.backgroundColor,
                        backgroundColor: bgclr,
                        pointBorderColor: vm.widget.graph.backgroundColor,
                        pointBackgroundColor: vm.widget.graph.backgroundColor,
                        pointHoverBorderColor: vm.widget.graph.backgroundColor,
                        pointHoverBackgroundColor: vm.widget.graph.backgroundColor
                    });
                    vm.result.chart.data=[];
                    vm.result.chart.data.push([]);
                    vm.result.chart.labels=[];
                    for(var i=0;i<vm.tmpResults.length;i++)
                    {
                        for(var j=0;j<vm.tmpResults[i].length;j++)
                        {
                            if(i==0)
                            {
                                vm.result.chart.data[0].push(vm.tmpResults[0][j].value)
                                if(vm.resolutionType==='m' || vm.resolutionType==='h')
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[0][j].timestamp).format('HH:mm'))
                                }
                                else
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[0][j].timestamp).format('DD/MM'))
                                }
                            }
                            else
                            {
                                vm.result.chart.data[0][j]=vm.result.chart.data[0][j]+vm.tmpResults[i][j].value;
                            }
                        }
                    }
                    for(var i=0;i<vm.result.chart.data[0].length;i++)
                    {
                        vm.result.chart.data[0][i]=vm.result.chart.data[0][i]/vm.tmpResults.length;
                    }
                }
                else
                {
                    vm.result.chart.series=[];
                    vm.result.chart.colors=[];
                    vm.result.chart.data=[];
                    vm.result.chart.labels=[];
                    var maxDates=0
                    if(vm.tmpResults.length>1)
                    {
                        for(var i=1;i<vm.tmpResults.length;i++)
                        {
                            if(vm.tmpResults[i].length>vm.tmpResults[i-1].length)
                            {
                                maxDates=i;
                            }
                        }
                    }
                    for(var i=0;i<vm.tmpResults.length;i++)
                    {
                        vm.result.chart.series.push(devices[i].site.name+" -> "+devices[i].device.name+" ("+devices[i].measurement.name+" )");
                        vm.result.chart.data.push([]);
                        vm.result.chart.colors.push({
                            type:vm.graphType,
                            showLine: vm.showLine,
                            steppedLine: vm.step,
                            lineTension : 0,
                            pointHoverRadius:(vm.widget.graph.pointSize)+3,
                            pointRadius:vm.widget.graph.pointSize,
                            borderColor: "rgba(" + vm.colors[i] + ",1)",
                            backgroundColor: "rgba(" + vm.colors[i] + ","+vm.fill+")",
                            pointBorderColor: "rgba(" + vm.colors[i] + ",1)",
                            pointBackgroundColor: "rgba(" + vm.colors[i] + ",1)",
                            pointHoverBorderColor: "rgba(" + vm.colors[i] + ",1)",
                            pointHoverBackgroundColor: "rgba(" + vm.colors[i] + ",1)"
                        });
                        for(var j=0;j<vm.tmpResults[i].length;j++)
                        {
                            vm.result.chart.data[i].push(vm.tmpResults[i][j].value)
                            if(i==maxDates)
                            {
                                if(vm.resolutionType==='m' || vm.resolutionType==='h')
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[i][j].timestamp).format('HH:mm'))
                                }
                                else
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[i][j].timestamp).format('DD/MM'))
                                }
                            }
                        }
                    }
                }
            }
            else
            {
                vm.result.chart.series=[];
                vm.result.chart.colors=[];
                vm.result.chart.data=[];
                vm.result.chart.labels=[];
                var maxDates=0
                if(vm.tmpResults.length>1)
                {
                    for(var i=1;i<vm.tmpResults.length;i++)
                    {
                        if(vm.tmpResults[i].length>vm.tmpResults[i-1].length)
                        {
                            maxDates=i;
                        }
                    }
                }
                for(var i=0;i<vm.tmpResults.length;i++)
                {
                    vm.result.chart.series.push(devices[i].site.name+" -> "+devices[i].device.name+" ("+devices[i].measurement.name+" )");
                    vm.result.chart.data.push([]);
                    vm.result.chart.colors.push({
                        type:vm.graphType,
                        showLine: vm.showLine,
                        steppedLine: vm.step,
                        lineTension : 0,
                        pointHoverRadius:(vm.widget.graph.pointSize)+3,
                        pointRadius:vm.widget.graph.pointSize,
                        borderColor: "rgba(" + vm.colors[i] + ",1)",
                        backgroundColor: "rgba(" + vm.colors[i] + ","+vm.fill+")",
                        pointBorderColor: "rgba(" + vm.colors[i] + ",1)",
                        pointBackgroundColor: "rgba(" + vm.colors[i] + ",1)",
                        pointHoverBorderColor: "rgba(" + vm.colors[i] + ",1)",
                        pointHoverBackgroundColor: "rgba(" + vm.colors[i] + ",1)"
                    });
                    for(var j=0;j<vm.tmpResults[i].length;j++)
                    {
                        vm.result.chart.data[i].push(vm.tmpResults[i][j].value)
                        if(i==maxDates)
                        {
                            if(vm.resolutionType==='m' || vm.resolutionType==='h')
                            {
                                vm.result.chart.labels.push(moment(vm.tmpResults[i][j].timestamp).format('HH:mm'))
                            }
                            else
                            {
                                vm.result.chart.labels.push(moment(vm.tmpResults[i][j].timestamp).format('DD/MM'))
                            }
                        }
                    }
                }
            }
            calculateMetadata();
        }

        function calculateRaw(measurements,cumulative)
        {
            var response=[];
            if(cumulative)
            {
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements[0].entries;
                for(var i=0;i<foo.length;i++)
                {
                    var tmp=
                    {
                        value:foo[i].value,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    response.push(tmp);
                }
            }
            return response;
        }

        function calculateAggregated(measurements,cumulative)
        {
            var response=[];
            if(cumulative)
            {
                var tmpResponse=[];
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    tmpResponse.push(tmp);
                }
                var tmpArray=[];
                var counter=0;
                var current=tmpResponse[0].timestamp;
                var tmpWid=
                {
                    timestamp:current,
                    values:[]
                }
                tmpArray.push(tmpWid);
                for(var i=0;i<tmpResponse.length;i++)
                {
                    if(tmpResponse[i].timestamp-current>=vm.resolutionMinutes*60000)
                    {
                        current=tmpResponse[i].timestamp;
                        var tmpWid=
                        {
                            timestamp:current,
                            values:[]
                        }
                        tmpWid.values.push(tmpResponse[i].value)
                        tmpArray.push(tmpWid);
                        counter++;
                    }
                    else
                    {
                        tmpArray[counter].values.push(tmpResponse[i].value)
                    }
                }
                for(var i=0;i<tmpArray.length;i++)
                {
                    var count=0;
                    for (var j=0;j<tmpArray[i].values.length;j++)
                    {
                        count+=tmpArray[i].values[j];
                    }
                    var tmp=
                    {
                        value:count,
                        timestamp:tmpArray[i].timestamp
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements.data;
                for(var i=0;i<foo.length;i++)
                {
                    var tmp=
                    {
                        value:foo[i].d,
                        timestamp:foo[i].t
                    }
                    response.push(tmp);
                }
            }
            return response;
        }

        function calculateMean(measurements,cumulative)
        {
            var response=[];
            if(cumulative)
            {
                var tmpResponse=[];
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    tmpResponse.push(tmp);
                }
                var tmpArray=[];
                var counter=0;
                var current=tmpResponse[0].timestamp;
                var tmpWid=
                {
                    timestamp:current,
                    values:[]
                }
                tmpArray.push(tmpWid);
                for(var i=0;i<tmpResponse.length;i++)
                {
                    if(tmpResponse[i].timestamp-current>=vm.resolutionMinutes*60000)
                    {
                        current=tmpResponse[i].timestamp;
                        var tmpWid=
                        {
                            timestamp:current,
                            values:[]
                        }
                        tmpWid.values.push(tmpResponse[i].value)
                        tmpArray.push(tmpWid);
                        counter++;
                    }
                    else
                    {
                        tmpArray[counter].values.push(tmpResponse[i].value)
                    }
                }
                for(var i=0;i<tmpArray.length;i++)
                {
                    var count=0;
                    for (var j=0;j<tmpArray[i].values.length;j++)
                    {
                        count+=tmpArray[i].values[j];
                    }
                    var tmp=
                    {
                        value:count/tmpArray[i].values.length,
                        timestamp:tmpArray[i].timestamp
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements.data;
                for(var i=0;i<foo.length;i++)
                {
                    var tmp=
                    {
                        value:foo[i].d,
                        timestamp:foo[i].t
                    }
                    response.push(tmp);
                }
            }
            return response;
        }

        function calculateMax(measurements,cumulative)
        {
            var response=[];
            if(cumulative)
            {
                var tmpResponse=[];
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    tmpResponse.push(tmp);
                }
                var tmpArray=[];
                var counter=0;
                var current=tmpResponse[0].timestamp;
                var tmpWid=
                {
                    timestamp:current,
                    values:[]
                }
                tmpArray.push(tmpWid);
                for(var i=0;i<tmpResponse.length;i++)
                {
                    if(tmpResponse[i].timestamp-current>=vm.resolutionMinutes*60000)
                    {
                        current=tmpResponse[i].timestamp;
                        var tmpWid=
                        {
                            timestamp:current,
                            values:[]
                        }
                        tmpWid.values.push(tmpResponse[i].value)
                        tmpArray.push(tmpWid);
                        counter++;
                    }
                    else
                    {
                        tmpArray[counter].values.push(tmpResponse[i].value)
                    }
                }
                for(var i=0;i<tmpArray.length;i++)
                {
                    var max=tmpArray[i].values[0];
                    for (var j=0;j<tmpArray[i].values.length;j++)
                    {
                        if(tmpArray[i].values[j]>max)
                        {
                            max=tmpArray[i].values[j];
                        }
                    }
                    var tmp=
                    {
                        value:max,
                        timestamp:tmpArray[i].timestamp
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements.data;
                for(var i=0;i<foo.length;i++)
                {
                    var tmp=
                    {
                        value:foo[i].d,
                        timestamp:foo[i].t
                    }
                    response.push(tmp);
                }
            }
            return response;
        }

        function calculateMin(measurements,cumulative)
        {
            var response=[];
            if(cumulative)
            {
                var tmpResponse=[];
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    tmpResponse.push(tmp);
                }
                var tmpArray=[];
                var counter=0;
                var current=tmpResponse[0].timestamp;
                var tmpWid=
                {
                    timestamp:current,
                    values:[]
                }
                tmpArray.push(tmpWid);
                for(var i=0;i<tmpResponse.length;i++)
                {
                    if(tmpResponse[i].timestamp-current>=vm.resolutionMinutes*60000)
                    {
                        current=tmpResponse[i].timestamp;
                        var tmpWid=
                        {
                            timestamp:current,
                            values:[]
                        }
                        tmpWid.values.push(tmpResponse[i].value)
                        tmpArray.push(tmpWid);
                        counter++;
                    }
                    else
                    {
                        tmpArray[counter].values.push(tmpResponse[i].value)
                    }
                }
                for(var i=0;i<tmpArray.length;i++)
                {
                    var min=tmpArray[i].values[0];
                    for (var j=0;j<tmpArray[i].values.length;j++)
                    {
                        if(tmpArray[i].values[j]<min)
                        {
                            min=tmpArray[i].values[j];
                        }
                    }
                    var tmp=
                    {
                        value:min,
                        timestamp:tmpArray[i].timestamp
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements.data;
                for(var i=0;i<foo.length;i++)
                {
                    var tmp=
                    {
                        value:foo[i].d,
                        timestamp:foo[i].t
                    }
                    response.push(tmp);
                }
            }
            return response;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('pieCard', pieCard)
		.directive('pieCardReport', ['pragmaapi','PRAGMA', pieCardReport]);

    function pieCard() {
        var directive = {
            templateUrl:"app/directives/pie-card/pie-card.html",
            controller: PieCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"=",
                dashboardClients:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    function pieCardReport(pragmaapi,PRAGMA) {
        var directive = {
            templateUrl:"app/directives/pie-card/pie-card-report.html",
            controller: PieCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"=",
                dashboardClients:"=",
				report:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
			scope.$watch('plotHasFinished', function(newValue, oldValue){
				if (newValue == true) {
					scope.loadingProcess = false;
					var imageContainer = angular.element(element[0].querySelector('#report-image-container'));
					
					var params = {
						widget: scope.vm.widget,
						results: {
							unit: "",
							chart: scope.vm.chart
						}
					};
					
					if (params.widget.graph.graphType == 'polar') {
						params.widget.graph.graphType = 'polarArea';
					}
					
					pragmaapi.callRestService(PRAGMA.graphServer, '/chart/', params, true, '', 'POST', true, false).then(function(res){
						scope.loadingProcess = true;
						imageContainer.replaceWith('<div id="report-image-container"><img class="graph" src="' + res.data.base64 + '" alt="graph" /></div>');
					});
				}
			}, true);
			
        }
    }
	
    /** @ngInject */
    function PieCardController ($scope,session,PRAGMA,pragmaapi,pragmaTheming,$q) {
        var vm =this;
        vm.showPie=true;
        vm.totalMax=0;
		$scope.plotHasFinished = false;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.gridLinesColor="rgba(255,255,255,";
        }
        else
        {
            vm.gridLinesColor="rgba(0,0,0,";
        }
        vm.colors=
        [
            {
                color:"3,169,244",
                fill:"0.2"
            },
            {
                color:"146,39,143",
                fill:"0.2"
            },
            {
                color:"170,198,6",
                fill:"0.2"
            },
            {
                color:"242,135,6",
                fill:"0.2"
            },
            {
                color:"236,0,140",
                fill:"0.2"
            },
            {
                color:"0,148,68",
                fill:"0.2"
            },
            {
                color:"249,237,50",
                fill:"0.2"
            },
            {
                color:"239,65,54",
                fill:"0.2"
            },
            {
                color:"191, 0, 255",
                fill:"0.2"
            },
            {
                color:"0,191,118",
                fill:"0.2"
            },
            {
                color:"102,45,145",
                fill:"0.2"
            },
        ];
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.dates=[];
        vm.result=0;
        vm.unit="";
        vm.triggered=false;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.datesColor="rgb(255,255,255)";
        }
        else
        {
            vm.datesColor="rgb(0,0,0)";
        }
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        fillWidget();
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom" && vm.widget.graph.type!=='lastValue')
                {
                    fillWidget();
                }
				
				if($scope.report)
				{
					$scope.plotHasFinished = false;
					fillWidget();
				}
            }
        });
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today" || vm.widget.graph.type==='lastValue')
            {
                fillWidgetMqtt(args);
            } 
        });

        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        function fillWidget()
        {
            vm.triggered=false;
            vm.totalMax=0;
            vm.tmpResults=[];
            vm.tmpResultsMax=[];
            if(vm.widget.dates[0].date==="custom")
            {
				if($scope.report)
				{
					vm.dates = {
						startDate: moment().startOf('day'),
						endDate: moment()
					};
				}
				else {
					vm.dates=$scope.dashboardDate;
				}
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            vm.chart=
            {
                data:[],
                labels:[],
                colors:[],
                options:{
                    segmentShowStroke: false,
                    legend: {
                        labels: {
                            fontColor:  vm.gridLinesColor+"0.6)"
                        },
                        display: true,
                        position: "bottom"
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    return data.labels[tooltipItem.index]+" -> "+ parseFloat(data.datasets[0].data[tooltipItem.index]).toFixed(2) + " "+ vm.unit;
                                }
                            }
                        }
                }
            };
            getMeasurements();
            if(vm.widget.graph.other)
            {
                if (vm.widget.graph.otherValueType)
                {
                    getMeasurementsMax();
                }
                else
                {
                    vm.otherValue=vm.widget.graph.maximumValue;
                }
            }
        }
       
        function getMeasurementsMax()
        {
            var devices=vm.widget.graph.maximumClients;
            var promises = [];
            for (var i=0;i<devices.length;i++)
            {
                if(vm.widget.graph.type==='lastValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/checkSensor","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/lastValue","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='aggregatedValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=sum&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=mean&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='maxValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMax=true&type=max&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='minValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMin=true&type=min&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
            }
            $q.all(promises).then(function(resArray) {
                var devices=vm.widget.graph.maximumClients;
                for(var i=0;i<resArray.length;i++)
                {
                    var measurements=resArray[i].data;
                    if(vm.widget.graph.type==='lastValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateLast(measurements,true,devices[i].measurement.measure));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateLast(measurements,false,devices[i].measurement.measure));
                        }
                    }
                    else if(vm.widget.graph.type==='aggregatedValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateAggregated(measurements,true));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateAggregated(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='meanValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateMean(measurements,true));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateMean(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='maxValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateMax(measurements,true));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateMax(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='minValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateMin(measurements,true));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateMin(measurements,false));
                        }
                    }
                }
                calculateEndMax();
            });
        }

        function calculateEndMax()
        {
            var devices=vm.widget.graph.maximumClients;
            vm.results=[];
            if(vm.widget.graph.type==='aggregatedValue' || vm.widget.graph.type==='lastValue')
            {
                var count=0;
                for(var i=0;i<vm.tmpResultsMax.length;i++)
                {
                    count+=vm.tmpResultsMax[i].value;
                }
                vm.otherValue=count;
            }
            else if(vm.widget.graph.type==='meanValue')
            {
                var count=0;
                for(var i=0;i<vm.tmpResultsMax.length;i++)
                {
                    count+=vm.tmpResultsMax[i].value;
                }
                vm.otherValue=count/vm.tmpResultsMax.length;
            }
            else if(vm.widget.graph.type==='maxValue')
            {
                var max=vm.tmpResultsMax[0].value;
                for(var i=0;i<vm.tmpResultsMax.length;i++)
                {
                    if(vm.tmpResultsMax[i].value>max)
                    {
                        max=vm.tmpResultsMax[i].value;
                    }
                }
                vm.otherValue=max;
            }
            else if(vm.widget.graph.type==='minValue')
            {
                var min=vm.tmpResultsMax[0].value;
                for(var i=0;i<vm.tmpResultsMax.length;i++)
                {
                    if(vm.tmpResultsMax[i].value<min)
                    {
                        min=vm.tmpResultsMax[i].value;
                    }
                }
                vm.otherValue=min;
            }
            calculateEndMaxWithClients();
        } 
        function calculateEndMaxWithClients()
        {
            vm.totalMax+=1;
            if(vm.totalMax==2)
            {
                var other=vm.otherValue-vm.count;
                vm.chart.data.push(other);
                vm.chart.labels.push("Other");
                vm.chart.colors.push({
                    borderColor: "rgba(" + vm.colors[vm.tmpResults.length].color + ",0)",
                    backgroundColor: "rgba(" + vm.colors[vm.tmpResults.length].color + ","+vm.colors[vm.tmpResults.length].fill+")",
                    pointBorderColor: "#fff",
                    pointBackgroundColor: "rgba(" + vm.colors[vm.tmpResults.length].color + ",0.6)",
                    pointHoverBorderColor: "rgba(" + vm.colors[vm.tmpResults.length].color + ",0.6)",
                    pointHoverBackgroundColor: "#fff"
                });
            }
        }
        function getMeasurements()
        {
            var devices=vm.widget.clients;
            vm.icon='pragma-icon-'+devices[0].specs.type;
            vm.unit=devices[0].specs.unit;
            var promises = [];
            for (var i=0;i<devices.length;i++)
            {
                if(vm.widget.graph.type==='lastValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/checkSensor","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/lastValue","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='aggregatedValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=sum&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=mean&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='maxValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMax=true&type=max&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='minValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMin=true&type=min&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
            }
            $q.all(promises).then(function(resArray) {
                var devices=vm.widget.clients;
                for(var i=0;i<resArray.length;i++)
                {
                    var measurements=resArray[i].data;
                    if(vm.widget.graph.type==='lastValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateLast(measurements,true,devices[i].measurement.measure));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateLast(measurements,false,devices[i].measurement.measure));
                        }
                    }
                    else if(vm.widget.graph.type==='aggregatedValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='meanValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMean(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMean(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='maxValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMax(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMax(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='minValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMin(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMin(measurements,false));
                        }
                    }
                }
                vm.triggered=true;
                calculateEnd();
            });
        }
        function calculateEnd()
        {
            var devices=vm.widget.clients;
            vm.chart.data=[];
            vm.chart.labels=[];
            vm.chart.colors=[];
            vm.count=0;
            for(var i=0;i<vm.tmpResults.length;i++)
            {
                if(vm.widget.graph.other)
                {
                    vm.count+=vm.tmpResults[i].value;
                }
                vm.chart.data.push(vm.tmpResults[i].value);
                vm.chart.labels.push(devices[i].site.name+" -> "+devices[i].device.name+"( "+devices[i].measurement.name+" )");
                vm.chart.colors.push({
                    borderColor: "rgba(" + vm.colors[i].color + ",0)",
                    backgroundColor: "rgba(" + vm.colors[i].color + ","+vm.colors[i].fill+")",
                    pointBorderColor: "#fff",
                    pointBackgroundColor: "rgba(" + vm.colors[i].color + ",0.6)",
                    pointHoverBorderColor: "rgba(" + vm.colors[i].color + ",0.6)",
                    pointHoverBackgroundColor: "#fff"
                });
            }
            if(vm.widget.graph.other)
            {
                if(vm.widget.graph.otherValueType)
                {
                    calculateEndMaxWithClients();
                }
                else
                {
                    var other=vm.otherValue-vm.count;
                    vm.chart.data.push(other);
                    vm.chart.labels.push("Other");
                    vm.chart.colors.push({
                        borderColor: "rgba(" + vm.colors[vm.tmpResults.length].color + ",0)",
                        backgroundColor: "rgba(" + vm.colors[vm.tmpResults.length].color + ","+vm.colors[vm.tmpResults.length].fill+")",
                        pointBorderColor: "#fff",
                        pointBackgroundColor: "rgba(" + vm.colors[vm.tmpResults.length].color + ",0.6)",
                        pointHoverBorderColor: "rgba(" + vm.colors[vm.tmpResults.length].color + ",0.6)",
                        pointHoverBackgroundColor: "#fff"
                    });
                }
            }
			$scope.plotHasFinished = true;
        }

        function calculateLast(measurements,cumulative,measure)
        {
            if(cumulative)
            {
                if(measurements.length==2)
                {
                    var first=measurements[1][measure];
                    var last=measurements[0][measure];
                    var val=last-first;
                    if(val<0)
                    {
                        val=last;
                    }
                    var response=
                    {
                        value:val,
                        timestamp:measurements[0].timestamp
                    }
                }  
            }
            else
            {
                var response=
                {
                    value:measurements[measure],
                    timestamp:measurements.timestamp
                }
            }
            return response;
        }

        function calculateAggregated(measurements,cumulative)
        {
            if(cumulative)
            {
                var first=measurements[0].entries[0];
                var last=measurements[0].entries[measurements[0].entries.length-1];
                var val=last.value-first.value;
                if(val<0)
                {
                    val=last.value;
                }
                var response=
                {
                    value:val,
                    timestamp:last.measurementDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }

        function calculateMean(measurements,cumulative)
        {
            if(cumulative)
            {
                var foo=measurements[0].entries;
                var tmp=[];
                for (var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var t=val;
                    tmp.push(t);
                }
                var count=0;
                for (var i=0;i<tmp.length;i++)
                {
                    count+=tmp[i];
                }
                var response=
                {
                    value:count/tmp.length,
                    timestamp:foo[foo.length-1].measurementDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }

        function calculateMax(measurements,cumulative)
        {
            if(cumulative)
            {
                var foo=measurements[0].entries;
                var tmp=[];
                for (var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var t={value:val,timestamp:foo[i].measurementDate};
                    tmp.push(t);
                }
                var max=tmp[0].value;
                var maxDate=tmp[0].timestamp;
                for (var i=0;i<tmp.length;i++)
                {
                    if(tmp[i].value>max)
                    {
                        max=tmp[i].value;
                        maxDate=tmp[i].timestamp;
                    }

                }
                var response=
                {
                    value:max,
                    timestamp:maxDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }

        function calculateMin(measurements,cumulative)
        {
            if(cumulative)
            {
                var foo=measurements[0].entries;
                var tmp=[];
                for (var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var t={value:val,timestamp:foo[i].measurementDate};
                    tmp.push(t);
                }
                var min=tmp[0].value;
                var minDate=tmp[0].timestamp;
                for (var i=0;i<tmp.length;i++)
                {
                    if(tmp[i].value<min)
                    {
                        min=tmp[i].value;
                        minDate=tmp[i].timestamp;
                    }

                }
                var response=
                {
                    value:min,
                    timestamp:minDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }
    
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('phCard', phCard);

    function phCard() {
        var directive = {
            templateUrl:"app/directives/ph-card/ph-card.html",
            controller: PhCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function PhCardController ($rootScope,$scope,session,PRAGMA,pragmaapi,pragmaTheming,$q) {
        var vm =this;
        vm.plotId=generateUUID();
        vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.triggered=false;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.gridLinesColor="rgba(255,255,255,0.8)";
        }
        else
        {
            vm.gridLinesColor="rgba(0,0,0,0.8)";
        }
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        $scope.$on('new.measurement.broadcast', function(event, args) {
            fillWidgetMqtt(args);
        });
        function fillWidgetMqtt(device)
        {
            for (var i=0;i<vm.widget.clients.length;i++)
            {
                if(vm.widget.clients[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        getMeasurements();
                    }
                    break;
                }
            }
        }
        getMeasurements();
        function getMeasurements()
        {
            vm.triggered=false;
            vm.result=0;
            pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[0].device.token+"/measurements/lastValue","?measuredParameter=ph&tenantAuthToken="+vm.widget.clients[0].tenant.token,true,vm.user.authentication,"GET",true,false).then(function(res){
                var measurements=res.data;
                vm.result=parseInt(measurements.ph);
                vm.triggered=true;
                fillPH();
            });
        }

        function fillPH()
        {
            var c = document.getElementById(vm.plotId);
            var ctx = c.getContext("2d");
            ctx.clearRect(0, 0, 1000, 1000);
                var phTxt="";
                if(vm.result<7)
                {
                    phTxt="Acidic";
                }
                else if(vm.result==7)
                {
                    phTxt="Neutral";
                }
                else
                {
                    phTxt="Alkaline";
                }
                var numberCounter=4;
                var fl=0;
                var colors=["#e80032","#ee6337","#f6c43f","#f5eb4a","#b7d34c","#88c350","#56b754","#40a953",
                    "#37b46f", "#2ebab4","#4c92c9","#3a55a0","#5a539e","#634799","#462e7f"];
                for(var i=0;i<colors.length;i++)
                {
                    ctx.fillStyle=colors[i];
                    ctx.fillRect(i*20,60,20,30);
                    if(vm.result!=i)
                    {
                        ctx.font="14px Arial";
                        ctx.fillStyle=vm.gridLinesColor;
                        ctx.fillText(i,numberCounter,50);
                    }
                    else
                    {
                        ctx.font="bold 24px Arial";
                        ctx.fillStyle=colors[i];
                        ctx.fillText(i,numberCounter,50);
                        fl=i;
                    }
                   
                    numberCounter+=20;
                }
                ctx.fillStyle=colors[fl];
                ctx.fillRect(fl*20-8,55,35,40);
                ctx.font="bold 20px Arial";
                ctx.fillText(phTxt,125,30);
                ctx.moveTo(0,92);
                ctx.lineTo(140,92);
                ctx.moveTo(160,92);
                ctx.lineTo(300,92);
                ctx.lineWidth = 1;
                ctx.strokeStyle = vm.gridLinesColor;
                ctx.stroke();
                ctx.fillStyle=vm.gridLinesColor;
                ctx.font="14px Arial";
                ctx.fillText("Acidic",0,105);
                ctx.fillText("Neutral",130,105);
                ctx.fillText("Alkaline",250,105);
        }

        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('parkingOccupancy', parkingOccupancy);

    function parkingOccupancy() {
        var directive = {
            templateUrl:"app/directives/parking-occupancy/parking-occupancy.html",
            controller: ParkingOccupancyController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"=",
                dashboardClients:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function ParkingOccupancyController ($rootScope,$scope,$http,session,PRAGMA,$base64,pragmaapi,$timeout) {
        var vm =this;
        vm.devices=[];
        vm.counter=0;
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
		vm.url=PRAGMA.api;
        vm.result=0;
        vm.widget=$scope.widget;
        fillWidget();
        $scope.$on('new.measurement.broadcast', function(event, args) {
            fillWidgetMqtt(args);
        });
        function fillWidget()
        {
            vm.counter=0;
            vm.tempResult=
            {
                occupied:0,
                available:0
            }
            vm.devices=[];
            vm.clients=vm.widget.clients;
            for(var i=0;i<vm.clients.length;i++)
            {
                for(var j=0;j<vm.clients[i].sites.length;j++)
                {
                    getDevicesCustom(vm.clients[i].token,vm.clients[i].sites[j])
                }
            }
        }
        function fillWidgetMqtt(device)
        {
            for (var i=0;i<vm.devices.length;i++)
            {
                if(vm.devices[i].assignment===device.deviceAssignmentToken)
                {
                    setTimeout(function(){  fillWidget(); }, 1000);
                    break;
                }
            }
        }
        function getDevicesCustom(tenant,site)
        {
                pragmaapi.callRestService(vm.url,"/devices/","?site="+site.token+"&page=1&pageSize=2000&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken="+tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
                var devices=res.data.results;
                var centralMeter=null;
                for(var i=0;i<devices.length;i++)
                {
                    for(var j=0;j<site.assignments.length;j++)
                    {
                        if(devices[i].assignment.token==site.assignments[j].token)
                        {                   
                            for(var mea=0;mea<site.assignments[j].measurements.length;mea++)
                            {
                                centralMeter=
                                {
                                    "assignment":devices[i].assignment.token,
                                    "tenant":tenant,
                                    "site":site.token,
                                    "specs":JSON.parse(devices[i].specification.metadata.specs)
                                };
                                for(var k=0;k<Object.keys(centralMeter.specs).length;k++)
                                {
                                    if(site.assignments[j].measurements[mea]===Object.keys(centralMeter.specs)[k])
                                    {
                                        centralMeter.specification=centralMeter.specs[Object.keys(centralMeter.specs)[k]];
                                        centralMeter.measure=site.assignments[j].measurements[mea];
                                        break;
                                    }
                                }
                                vm.devices.push(centralMeter);
                            }
                            break;
                        }
                    }
                }
                for(var i=0;i<vm.devices.length;i++)
                {
                    getMeasurementsCustom(vm.devices[i]);
                }
            });
        }
        function getMeasurementsCustom(centralMeter)
        {
            pragmaapi.callRestService(vm.url,"/assignments/"+centralMeter.assignment+"/measurements/lastValue","?measuredParameter="+centralMeter.measure+"&tenantAuthToken="+centralMeter.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
                vm.counter++;
               var data=res.data[centralMeter.measure];
               if(data)
               {
                   vm.tempResult.occupied++;
               }
               else
               {
                   vm.tempResult.available++;
               }
               if(vm.counter==vm.devices.length)
               {
                   if(vm.widget.graph.widgetType==="occupancy")
                   {
                       vm.result=(vm.tempResult.occupied*100)/vm.devices.length;
                   }
                   else
                   {
                       vm.result= vm.tempResult;
                   }
               }
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('parkingLot', parkingLot);

    function parkingLot() {
        var directive = {
            templateUrl:"app/directives/parking-lot/parking-lot.html",
            controller: ParkingLotController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"=",
                dashboardClients:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function ParkingLotController ($rootScope,$scope,$http,session,PRAGMA,$base64,pragmaapi,$timeout) {
        var vm =this;
        vm.plotId=generateUUID();
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
		vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        fillWidget();
        $scope.$on('new.measurement.broadcast', function(event, args) {
            fillWidgetMqtt(args);
        });
        function fillCanvasEnd()
        {
            var lots=Object.keys(vm.result).length;
            var upLots=0;
            var lowLots=0;
            var xTopCount=100;
            var moveUp=70;
            var textUp=10;
            var lineUp=120;
            var moveDown=70;
            var textDown=10;
            var lineDown=120;
            var carUp=-5;
            var carDown=-5;
            var loadCount=0;
            var upCount=0;
            var lowCount=0;
            var c = document.getElementById(vm.plotId);
            var ctx = c.getContext("2d");
            ctx.clearRect(0, 0, 1000, 1000);
            var autoUp = new Image();
            var autoDown = new Image();
            lowLots=parseInt(lots);
            c.width = 100*lowLots+22;
            c.height = 300;
            ctx.moveTo(0,150);
            ctx.lineTo(100*lowLots+20,150);
            autoUp.src = "assets/images/parking/auto-up.png";
            autoDown.src = "assets/images/parking/auto-down.png";
            ctx.font="20px Arial";
            ctx.fillStyle = '#fff';
            autoUp.onload = function() {
                loadCount++;
                for(upCount=0;upCount<upLots;upCount++)
                {
                    
                    var txt="P0"+(upCount+1);
                    var state=vm.result[Object.keys(vm.result)[upCount]];
                    ctx.moveTo(moveUp,0);
                    ctx.lineTo(lineUp,150);
                    ctx.fillText(txt,textUp,30);
                    if(state==1)
                    {
                        ctx.drawImage(autoUp, carUp, 10, 118, 142);
                    }
                    textUp+=100;
                    moveUp+=100;
                    lineUp+=100;
                    carUp+=100;
                }
                if(loadCount==2)
                {
                    ctx.lineWidth = 3;
                    ctx.strokeStyle = "rgba(255,255,255,0.6)";
                    ctx.stroke();
                }
            };
            autoDown.onload = function() {
                loadCount++;
                for(lowCount=0;lowCount<lowLots;lowCount++)
                {
                    var txt="P0"+(upCount+lowCount+1);
                    var state=vm.result[Object.keys(vm.result)[upCount+lowCount]];
                    ctx.moveTo(moveDown,300);
                    ctx.lineTo(lineDown,150);
                    ctx.fillText(txt,textDown,280);
                    if(state==1)
                    {
                        ctx.drawImage(autoDown, carDown, 155, 118, 142);
                    }
                    textDown+=100;
                    moveDown+=100;
                    lineDown+=100;
                    carDown+=100;
                }
                if(loadCount==2)
                {
                    ctx.lineWidth = 3;
                    ctx.strokeStyle = "rgba(255,255,255,0.6)";
                    ctx.stroke();
                }
            };
        }
        function fillWidget()
        {
            vm.result={};
            vm.tmpResult={};
            getMeasurements();
        }
        function fillWidgetMqtt(device)
        {
            for (var i=0;i<vm.widget.clients.length;i++)
            {
                if(vm.widget.clients[i].device.token===device.deviceAssignmentToken)
                {
                    fillWidget();
                    break;
                }
            }
        }

        function getMeasurements()
        {
            var promises = [];
            for (var i=0;i<vm.widget.clients.length;i++)
            {
                promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[i].device.token+"/measurements/lastValue","?tenantAuthToken="+vm.widget.clients[i].tenant.token,true,vm.user.authentication,"GET",true,false));
            }
            $q.all(promises).then(function(resArray) {
                for(var j=0;j<resArray.length;j++)
                {
                    var data=resArray[j].data;
                    for(var i=0;i<Object.keys(data).length;i++)
                    {
                        if(Object.keys(data)[i]!=='timestamp')
                        {
                            vm.tmpResult[Object.keys(data)[i]]=data[Object.keys(data)[i]];
                        }
                    }
                }
                var keys = [],
                k, i, len;
                
                for (k in vm.tmpResult) {
                    if (vm.tmpResult.hasOwnProperty(k)) {
                    keys.push(k);
                    }
                }            
                keys.sort();    
                len = keys.length;      
                for (i = 0; i < len; i++) {
                    k = keys[i];
                    vm.result[k]=vm.tmpResult[k];
                }
                fillCanvasEnd();
            });
        }

        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('parkingDemandHour', parkingDemandHour);

    function parkingDemandHour() {
        var directive = {
            templateUrl:"app/directives/parking-demand-hour/parking-demand-hour.html",
            controller: ParkingDemandHourController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"=",
                dashboardClients:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function ParkingDemandHourController ($rootScope,$scope,$http,session,PRAGMA,$base64,pragmaapi,$timeout) {
        var vm =this;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        vm.devices=[];
        vm.tempResult=0;
        vm.counter=0;
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
		vm.url=PRAGMA.api;
        vm.result=0;
        vm.widget=$scope.widget;
        var peakHourArray=[];
        fillWidget();
        $scope.$on('new.measurement.broadcast', function(event, args) {
            fillWidgetMqtt(args);
        });
      
        function fillWidget()
        {
            vm.devices=[];
            var current=new Date().getHours();
            peakHourArray=[];
            for(var i=0;i<current+1;i++)
            {
                peakHourArray.push(0);
            }
            vm.dates = {
                startDate: moment().startOf('day'),
                endDate: moment()
            };
            vm.counter=0;
            vm.tempResult=
            {
                occupied:0,
                available:0
            }
            vm.clients=vm.widget.clients;
            for(var i=0;i<vm.clients.length;i++)
            {
                for(var j=0;j<vm.clients[i].sites.length;j++)
                {
                    getDevicesCustom(vm.clients[i].token,vm.clients[i].sites[j])
                }
            }
        }
        function fillWidgetMqtt(device)
        {
            for (var i=0;i<vm.devices.length;i++)
            {
                if(vm.devices[i].assignment===device.deviceAssignmentToken)
                {
                    fillWidget();
                    break;
                }
            }
        }
        function getDevicesCustom(tenant,site)
        {
            pragmaapi.callRestService(vm.url,"/devices/","?site="+site.token+"&page=1&pageSize=2000&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken="+tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
            var devices=res.data.results;
            var centralMeter=null;
            for(var i=0;i<devices.length;i++)
            {
                for(var j=0;j<site.assignments.length;j++)
                {
                    if(devices[i].assignment.token==site.assignments[j].token)
                    {                   
                        for(var mea=0;mea<site.assignments[j].measurements.length;mea++)
                        {
                            centralMeter=
                            {
                                "assignment":devices[i].assignment.token,
                                "tenant":tenant,
                                "site":site.token,
                                "specs":JSON.parse(devices[i].specification.metadata.specs)
                            };
                            for(var k=0;k<Object.keys(centralMeter.specs).length;k++)
                            {
                                if(site.assignments[j].measurements[mea]===Object.keys(centralMeter.specs)[k])
                                {
                                    centralMeter.specification=centralMeter.specs[Object.keys(centralMeter.specs)[k]];
                                    centralMeter.measure=site.assignments[j].measurements[mea];
                                    break;
                                }
                            }
                            vm.devices.push(centralMeter);
                        }
                        break;
                    }
                }
            }
            for(var i=0;i<vm.devices.length;i++)
            {
                getMeasurementsCustom(vm.devices[i]);
            }
            });
        }
        function getMeasurementsCustom(centralMeter)
        {
            pragmaapi.callRestService(PRAGMA.api,"/assignments/"+centralMeter.assignment+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+centralMeter.measure+"&tenantAuthToken=" + centralMeter.tenant, true, vm.user.authentication, "GET", true).then(function(res){
                vm.counter++;
                if(res.data.length>0)
                {
                    var data=res.data[0].entries;
                    for(var j=0;j<data.length;j++)
                    {
                        peakHourArray[new Date(data[j].measurementDate).getHours()]++;
                    }
                }
                if(vm.counter==vm.devices.length)
                {
                    var max=0;
                    var min=0;
                    var maxVal=peakHourArray[0];
                    var minVal=peakHourArray[0];
                    for(var i=1;i<peakHourArray.length;i++)
                    {
                        if(peakHourArray[i]>maxVal)
                        {
                            maxVal=peakHourArray[i];
                            max=i;
                        }
                        if(peakHourArray[i]<minVal)
                        {
                            minVal=peakHourArray[i];
                            min=i;
                        }
                    }
                    if(vm.widget.graph.widgetType==='peak')
                    {
                        if(max<9)
                        {
                            vm.result="0"+max+":00 - 0"+(max+1)+":00";
                        }
                        else if(max<10)
                        {
                            vm.result="0"+max+":00 - "+(max+1)+":00";
                        }
                        else
                        {
                            vm.result=""+max+":00 - "+(max+1)+":00";
                        }
                    }
                    else
                    {
                        if(min<9)
                        {
                            vm.result="0"+min+":00 - 0"+(min+1)+":00";
                        }
                        else if(min<10)
                        {
                            vm.result="0"+min+":00 - "+(min+1)+":00";
                        }
                        else
                        {
                            vm.result=""+min+":00 - "+(min+1)+":00";
                        }
                    }
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('panicButton', panicButton);

    function panicButton() {
        var directive = {
            templateUrl:"app/directives/panic-button/panic-button.html",
            controller: PanicButtonController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }

    /** @ngInject */
    function PanicButtonController ($scope, pragmaapi, session, PRAGMA) {
        var vm = this;

        vm.stopAnimation = stopAnimation;
        vm.buttonActive = false;
        
        vm.widget = $scope.widget;
        vm.device = null;
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        vm.url = PRAGMA.api;
        
        activate();

        function stopAnimation() {
            vm.buttonActive = false;
        }

        function activate() {
            fillWidget();

            $scope.$on('new.measurement.broadcast', function (event, args) {
                if (vm.device && vm.device.assignment === args.deviceAssignmentToken) {
                    $scope.$apply(function() {
                        console.log(args.deviceAssignmentToken);
                        vm.buttonActive = true;
                    })
                }
            });
        }
        
        
        function fillWidget() {
            vm.clients = vm.widget.clients;
            vm.device = {};
            for (var i = 0; i < vm.clients.length; i++) {
                for (var j = 0; j < vm.clients[i].sites.length; j++) {
                    getDevicesCustom(vm.clients[i].token, vm.clients[i].sites[j])
                }
            }
        }

        function getDevicesCustom(tenant, site) {
            pragmaapi.callRestService(vm.url, "/devices/", "?site=" + site.token + "&page=1&pageSize=2000&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken=" + tenant, true, vm.user.authentication, "GET", true, false).then(function (res) {
                var devices = res.data.results;
                var centralMeter = null;
                for (var i = 0; i < devices.length; i++) {
                    for (var j = 0; j < site.assignments.length; j++) {
                        if (devices[i].assignment.token == site.assignments[j].token) {
                            centralMeter = {
                                "assignment": devices[i].assignment.token,
                                "name": devices[i].metadata.name,
                                "type": devices[i].metadata.type,
                                "tenant": tenant,
                                "specs": JSON.parse(devices[i].specification.metadata.specs),
                                "binType": devices[i].metadata.binType
                            };
                            vm.device = centralMeter;
                            break;
                        }
                    }
                }
            });
        }


    }

})();
(function () {
    'use strict';

    angular
        .module('app.directives')
        .directive('oximeterCard', oximeterCard);

    function oximeterCard() {
        var directive = {
            templateUrl: "app/directives/oximeter-card/oximeter-card.html",
            controller: OximeterCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate: "="
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }

    /** @ngInject */
    function OximeterCardController($rootScope, $scope, $http, $base64, $timeout, session, pragmaapi, pragmaTheming, PRAGMA) {
        var vm = this;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);

        vm.widget = $scope.widget;
        vm.device = null;
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        vm.url = PRAGMA.api;
        vm.labelColor = "#6a6a6a"
        vm.dateColor="#6a6a6a";
        if (isDark) {
            vm.labelColor ="rgb(255,255,255)";
            vm.dateColor = "rgb(255,255,255)";
        }

        activate();

        function activate() {
            fillWidget();

            $scope.$on('new.measurement.broadcast', function (event, args) {
                if (vm.device && vm.device.assignment === args.deviceAssignmentToken) {
                    $scope.$apply(function() {
                        if(args.measurements) {
                            for(var key in vm.device.measurements) {
                                if(args.measurements[key]!=undefined) {
                                    vm.device.measurements[key] = args.measurements[key];
                                }
                            }
                        }

                        if(args.eventDate) {
                            vm.device.measurements.timestamp = args.eventDate;
                        }
                    })
                }
            });
        }
        
        
        function fillWidget() {
            vm.clients = vm.widget.clients;
            vm.device = {};
            for (var i = 0; i < vm.clients.length; i++) {
                for (var j = 0; j < vm.clients[i].sites.length; j++) {
                    getDevicesCustom(vm.clients[i].token, vm.clients[i].sites[j])
                }
            }
        }

        function getDevicesCustom(tenant, site) {
            pragmaapi.callRestService(vm.url, "/devices/", "?site=" + site.token + "&page=1&pageSize=2000&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken=" + tenant, true, vm.user.authentication, "GET", true, false).then(function (res) {
                var devices = res.data.results;
                var centralMeter = null;
                for (var i = 0; i < devices.length; i++) {
                    for (var j = 0; j < site.assignments.length; j++) {
                        if (devices[i].assignment.token == site.assignments[j].token) {
                            centralMeter = {
                                "assignment": devices[i].assignment.token,
                                "name": devices[i].metadata.name,
                                "type": devices[i].metadata.type,
                                "tenant": tenant,
                                "specs": JSON.parse(devices[i].specification.metadata.specs),
                                "binType": devices[i].metadata.binType
                            };
                            vm.device = centralMeter;
                            break;
                        }
                    }
                }
                getMeasurementsCustom(vm.device);
            });
        }

        function getMeasurementsCustom(centralMeter) {
            pragmaapi.callRestService(vm.url, "/assignments/" + centralMeter.assignment + "/measurements/lastValue", "?tenantAuthToken=" + centralMeter.tenant, true, vm.user.authentication, "GET", true, false).then(function (res) {
                if(res.data) {
                    centralMeter.measurements = res.data;
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('occupancyCard', occupancyCard);

    function occupancyCard() {
        var directive = {
            templateUrl:"app/directives/occupancy-card/occupancy-card.html",
            controller: OccupancyCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"=",
                dashboardClients:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function OccupancyCardController ($rootScope,$scope,session,PRAGMA,$q,pragmaapi,pragmaTheming) {
        var vm =this;
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
		vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(255,255,255)";
            }
            vm.datesColor="rgb(255,255,255)";
        }
        else
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(0,0,0)";
            }
            vm.datesColor="rgb(0,0,0)";
        }
        fillWidget();
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom" && vm.widget.graph.type!=='lastValue')
                {
                    fillWidget();
                }
				
				if ($scope.report)
				{
					fillWidget();
				}
            }
        });
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today" || vm.widget.graph.type==='lastValue')
            {
                fillWidgetMqtt(args);
            } 
        });
        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        function fillWidget()
        {
            vm.triggered=false;
            vm.tmpResults=[];
            if(vm.widget.dates[0].date==="custom")
            {
                vm.dates=$scope.dashboardDate;
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            getMeasurements();
        }
        function getMeasurements()
        {
            vm.tmpResult=
            {
                entries:0,
                exits:0,
                occupancy:0,
                timestamp:null
            }
            var devices=vm.widget.clients;
            var promises = [];
            for(var i=0;i<devices.length;i++)
            {
                promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds=event&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
            }
            $q.all(promises).then(function(resArray) {
                for(var i=0;i<resArray.length;i++)
                {
                    var token=vm.widget.clients[i].device.token;
                    var reversed=vm.widget.graph.reversed;
                    var isReversed=false;
                    if(reversed.indexOf(token) > -1)
                    {
                        isReversed=true;
                    }
                    var measurements=resArray[i].data;
                    for(var j=0;j<measurements.length;j++)
                    {
                        if(measurements[j].measurementId==='event')
                        {
                            var foo=measurements[j].entries;
                            for(var k=0;k<foo.length;k++)
                            {
                                if(isReversed)
                                {
                                    if(foo[k].value<0)
                                        vm.tmpResult.entries-=foo[k].value;
                                    else
                                        vm.tmpResult.exits+=foo[k].value;
                                }
                                else
                                {
                                    if(foo[k].value>0)
                                        vm.tmpResult.entries+=foo[k].value;
                                    else
                                        vm.tmpResult.exits-=foo[k].value
                                }
                                var date1=new Date(foo[k].measurementDate);
                                if(vm.tmpResult.timestamp==null)
                                {
                                    vm.tmpResult.timestamp=date1;
                                }
                                else if(date1>vm.tmpResult.timestamp)
                                {
                                    vm.tmpResult.timestamp=date1;
                                }
                            }
                        }
                    }
                }
                if(vm.tmpResult.exits>vm.tmpResult.entries)
                {
                    vm.tmpResult.occupancy=0;
                    vm.tmpResult.moderated=true;
                    vm.tmpResult.entries=vm.tmpResult.exits;
                }
                else
                {
                    vm.tmpResult.occupancy=vm.tmpResult.entries-vm.tmpResult.exits;
                    vm.tmpResult.moderated=false;
                }
                vm.result=vm.tmpResult;
                if(vm.widget.graph.value==='entriesExits')
                {
                    if(vm.widget.graph.values.indexOf('entries') > -1)
                    {
                        vm.result.showEntries=true;
                    }
                    if(vm.widget.graph.values.indexOf('exits') > -1)
                    {
                        vm.result.showExits=true;
                    }
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('numericCard', numericCard);

    function numericCard() {
        var directive = {
            templateUrl:"app/directives/numeric-card/numeric-card.html",
            controller: NumeriCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"=",
				report:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function NumeriCardController ($scope,session,PRAGMA,pragmaapi,convertapi,pragmaTheming,$q) {
        var vm =this;
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.dates=[];
        vm.result=0;
        vm.unit="";
        vm.counter=0;
        vm.triggered=false;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(255,255,255)";
            }
            vm.datesColor="rgb(255,255,255)";
        }
        else
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(0,0,0)";
            }
            vm.datesColor="rgb(0,0,0)";
        }
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        fillWidget();
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom" && vm.widget.graph.type!=='lastValue')
                {
                    fillWidget();
                }
				
				if ($scope.report)
				{
					fillWidget();
				}
            }
        });
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today" || vm.widget.graph.type==='lastValue')
            {
                fillWidgetMqtt(args);
            } 
        });

        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        function fillWidget()
        {
            vm.triggered=false;
            vm.tmpResults=[];
            if(vm.widget.dates[0].date==="custom")
            {
                vm.dates=$scope.dashboardDate;
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            getMeasurements();
        }
       

        function getMeasurements()
        {
            var devices=vm.widget.clients;
            vm.icon='pragma-icon-'+devices[0].specs.type;
            vm.unit=devices[0].specs.unit;
            var promises = [];
            for (var i=0;i<devices.length;i++)
            {
                if(vm.widget.graph.type==='lastValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/checkSensor","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/lastValue","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='aggregatedValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=sum&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=mean&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='maxValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMax=true&type=max&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='minValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMin=true&type=min&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
            }
            $q.all(promises).then(function(resArray) {
                var devices=vm.widget.clients;
                for(var i=0;i<resArray.length;i++)
                {
                    var measurements=resArray[i].data;
                    if(vm.widget.graph.type==='lastValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateLast(measurements,true,devices[i].measurement.measure));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateLast(measurements,false,devices[i].measurement.measure));
                        }
                    }
                    else if(vm.widget.graph.type==='aggregatedValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='meanValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMean(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMean(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='maxValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMax(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMax(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='minValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMin(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMin(measurements,false));
                        }
                    }
                }
                vm.triggered=true;
                calculateEnd();
            });
        }
        function calculateEnd()
        {
            var devices=vm.widget.clients;
            vm.results=[];
            if(vm.widget.graph.aggregated)
            {
                if(vm.widget.graph.type==='aggregatedValue')
                {
                    var count=0;
                    for(var i=0;i<vm.tmpResults.length;i++)
                    {
                        count+=vm.tmpResults[i].value;
                    }
                    var tmp=
                    {
                        value:count,
                        timestamp:vm.tmpResults[vm.tmpResults.length-1].timestamp,
                        deviceName:'',
                        siteName:'',
                        measure:'',
                        unit:devices[0].specs.unit,
                        icon:'pragma-icon-'+devices[0].specs.type
                    }
                    vm.results.push(tmp);
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    var count=0;
                    for(var i=0;i<vm.tmpResults.length;i++)
                    {
                        count+=vm.tmpResults[i].value;
                    }
                    var tmp=
                    {
                        value:count/vm.tmpResults.length,
                        timestamp:vm.tmpResults[vm.tmpResults.length-1].timestamp,
                        deviceName:'',
                        siteName:'',
                        measure:'',
                        unit:devices[0].specs.unit,
                        icon:'pragma-icon-'+devices[0].specs.type
                    }
                    vm.results.push(tmp);
                }
                else 
                {
                    for(var i=0;i<vm.tmpResults.length;i++)
                    {
                        var tmp=
                        {
                            value:vm.tmpResults[i].value,
                            timestamp:vm.tmpResults[i].timestamp,
                            deviceName:devices[i].device.name,
                            siteName:devices[i].site.name,
                            measure:devices[i].measurement.name,
                            unit:devices[i].specs.unit,
                            icon:'pragma-icon-'+devices[i].specs.type
                        }
                        vm.results.push(tmp);
                    }
                }
            }
            else
            {
                for(var i=0;i<vm.tmpResults.length;i++)
                {
                    var tmp=
                    {
                        value:vm.tmpResults[i].value,
                        timestamp:vm.tmpResults[i].timestamp,
                        deviceName:devices[i].device.name,
                        siteName:devices[i].site.name,
                        measure:devices[i].measurement.name,
                        unit:devices[i].specs.unit,
                        icon:'pragma-icon-'+devices[i].specs.type
                    }
                    vm.results.push(tmp);
                }
            }
            
            // Convert units
            for (var i = 0; i < vm.results.length; i++) {
                var result = vm.results[i];
                if (convertapi.describe(result.unit)) {
                    var best = convertapi.convert(result.value).from(result.unit).toBest();
                    result.value = best.val;
                    result.unit = best.unit;
                }
            }
        }

        function calculateLast(measurements,cumulative,measure)
        {
            if(cumulative)
            {
                if(measurements.length==2)
                {
                    var first=measurements[1][measure];
                    var last=measurements[0][measure];
                    var response=
                    {
                        value:last-first,
                        timestamp:measurements[0].timestamp
                    }
                }  
            }
            else
            {
                var response=
                {
                    value:measurements[measure],
                    timestamp:measurements.timestamp
                }
            }
            return response;
        }

        function calculateAggregated(measurements,cumulative)
        {
            if(cumulative)
            {
                var first=measurements[0].entries[0];
                var last=measurements[0].entries[measurements[0].entries.length-1];
                var val=last.value-first.value;
                if(val<0)
                {
                    val=last.value;
                }
                var response=
                {
                    value:val,
                    timestamp:last.measurementDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }

        function calculateMean(measurements,cumulative)
        {
            if(cumulative)
            {
                var foo=measurements[0].entries;
                var tmp=[];
                for (var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var t=val;
                    tmp.push(t);
                }
                var count=0;
                for (var i=0;i<tmp.length;i++)
                {
                    count+=tmp[i];
                }
                var response=
                {
                    value:count/tmp.length,
                    timestamp:foo[foo.length-1].measurementDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }

        function calculateMax(measurements,cumulative)
        {
            if(cumulative)
            {
                var foo=measurements[0].entries;
                var tmp=[];
                for (var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var t={value:val,timestamp:foo[i].measurementDate};
                    tmp.push(t);
                }
                var max=tmp[0].value;
                var maxDate=tmp[0].timestamp;
                for (var i=0;i<tmp.length;i++)
                {
                    if(tmp[i].value>max)
                    {
                        max=tmp[i].value;
                        maxDate=tmp[i].timestamp;
                    }

                }
                var response=
                {
                    value:max,
                    timestamp:maxDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }

        function calculateMin(measurements,cumulative)
        {
            if(cumulative)
            {
                var foo=measurements[0].entries;
                var tmp=[];
                for (var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var t={value:val,timestamp:foo[i].measurementDate};
                    tmp.push(t);
                }
                var min=tmp[0].value;
                var minDate=tmp[0].timestamp;
                for (var i=0;i<tmp.length;i++)
                {
                    if(tmp[i].value<min)
                    {
                        min=tmp[i].value;
                        minDate=tmp[i].timestamp;
                    }

                }
                var response=
                {
                    value:min,
                    timestamp:minDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('mapCard', mapCard)

    function mapCard() {
        var directive = {
            templateUrl:"app/directives/map-card/map-card.html",
            controller: MapCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function MapCardController ($scope,session,PRAGMA,pragmaapi,uiGmapGoogleMapApi, uiGmapIsReady,$q) {
        var vm =this;
        vm.mapControl = {};
        vm.options=
        {
            gestureHandling:"cooperative",

            zoomControl: true,
            zoomControlOptions: {
                position: 3 //=RIGHT_TOP
            } 
        };
        vm.googleMapZoom = 8;
        vm.googlmapLocations=[];
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
		vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.windowOpt={labelClass: "marker-labels"};
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        fillWidget();
        var mapMinZoom = 12;
        var mapMaxZoom = 15;
        function fillWidget()
        {
            vm.googlmapLocations=[];
            uiGmapGoogleMapApi.then(function(maps) {
                getLocations();
            });
        }
        function getLocations()
        {
            var tenants=[];
            var promises=[];
            for(var i=0;i<vm.widget.clients.length;i++)
            {
                if(tenants.indexOf(vm.widget.clients[i].tenant.token)==-1)
                    tenants.push(vm.widget.clients[i].tenant.token)
            }
            for(var i=0;i<tenants.length;i++)
            {
                promises.push(pragmaapi.callRestService(vm.url,"/sites","?tenantAuthToken="+tenants[i],true,vm.user.authentication,"GET",true,false));
            }
            $q.all(promises).then(function(resArray) {
                for(var l=0;l<resArray.length;l++)
                {
                    var sites=resArray[l].data.results;
                    for(var i=0;i<sites.length;i++)
                    {
                        for(var j=0;j<vm.widget.clients.length;j++)
                        {
                            if(sites[i].token==vm.widget.clients[j].site.token)
                            {
                                if (typeof sites[i].metadata.siteType!=='undefined')
                                    vm.widget.clients[j].site.type=sites[i].metadata.siteType;
                                else
                                    vm.widget.clients[j].site.type='Building';
                                vm.widget.clients[j].site.longitude=sites[i].map.metadata.centerLongitude;
                                vm.widget.clients[j].site.latitude=sites[i].map.metadata.centerLatitude;
                                break;
                            }
                        }
                    }
                }
                for(var j=0;j<vm.widget.clients.length;j++)
                {
                    var icon='';
                    if (vm.widget.clients[j].site.type==="Lighting")
                    {
                         icon='assets/images/light_marker_on.png'
                    }
                    else if (vm.widget.clients[j].site.type==="Parking")
                    {
                        icon='assets/images/parking_marker.png';
                    }
                    else if (vm.widget.clients[j].site.type==="Waste")
                    {
                         icon='assets/images/waste_marker.png';
                    }
                    else
                    {
                        icon='assets/images/home_marker.png';
                    }
                    var temp = {
                        id: vm.widget.clients[j].site.token,
                        tenant:vm.widget.clients[j].tenant.token,
                        title: vm.widget.clients[j].site.name,
                        type:vm.widget.clients[j].site.type,
                        coords: {
                            latitude : vm.widget.clients[j].site.latitude,
                            longitude: vm.widget.clients[j].site.longitude
                        },
                        markerOptions:{
                            animation:2,
                            icon:icon
                        },
                        text:{}
                    };
                    vm.googlmapLocations.push(temp);
                }
                for(var j=0;j<vm.widget.clients.length;j++)
                {
                    if(vm.widget.clients[j].site.type==="Lighting")
                    {
                        var l=j;
                        pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[j].device.token+"/measurements/checkSensor","?tenantAuthToken="+vm.widget.clients[j].tenant.token,true,vm.user.authentication,"GET",true,false).then(function(res){
                            var foo=res.data;
                            if(foo[0].status)
                            {
                                vm.googlmapLocations[l].text=
                                {
                                    dimming:foo[0].dimming,
                                    status:"ON",
                                    consumption:foo[0].current_W - foo[1].current_W,
                                    state:true
                                }
                            }   
                            else
                            {
                                vm.googlmapLocations[l].text=
                                {
                                    dimming:foo[0].dimming,
                                    status:"OFF",
                                    consumption:foo[0].current_W - foo[1].current_W,
                                    state:false
                                }
                                vm.googlmapLocations[l].markerOptions={
                                    animation:2,
                                    icon:'assets/images/light_marker_off.png'
                                }
                            }
                        });
                    }
                    else if (vm.widget.clients[j].site.type==="Parking")
                    {
                        var p=j;
                        pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[j].device.token+"/measurements/lastValue","?tenantAuthToken="+vm.widget.clients[j].tenant.token,true,vm.user.authentication,"GET",true,false).then(function(res){
                            var foo=res.data;
                            
                            var res=
                            {
                                state:"",
                                since:new Date(foo.timestamp)
                            }
                            if(typeof foo.state !=="undefined")
                            {
                                if(foo.state==1)
                                {
                                    res.state="Occupied";
                                }
                                else
                                {
                                    res.state="Available";
                                }
                            }
                            else
                            {
                                res.state="Available";
                            }       
                            vm.googlmapLocations[p].text=res;
                        });
                    }
                    else if (vm.widget.clients[j].site.type==="Waste")
                    {
                        var w=j;
                        vm.dates = {
                            startDate: moment().startOf('day'),
                            endDate: moment()
                        };
                        var promises=[
                            pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[j].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter=delta&resolutionType=M&resolution=20&includeTotalSum=true&tenantAuthToken="+vm.widget.clients[j].tenant.token,true,vm.user.authentication,"GET",true,false),
                            pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[j].device.token+"/measurements/lastValue","?measuredParameter=weight&tenantAuthToken="+vm.widget.clients[j].tenant.token,true,vm.user.authentication,"GET",true,false)
                        ];
                        $q.all(promises).then(function(resArray) {
                            var res=resArray;
                            if (res[0].data.data[0].d > 1000)
                            {
                                var t=(res[0].data.data[0].d/1000).toFixed(2)+ " kg";
                            }
                            else
                            {
                                var t=(res[0].data.data[0].d).toFixed(2) + " g";
                            }
                            if (res[1].data.weight > 1000)
                            {
                                var c=(res[1].data.weight/1000).toFixed(2)+ " kg";
                            }
                            else
                            {
                                var c=(res[1].data.weight).toFixed(2) + " g";
                            }
                            var txt=
                            {
                                current:c,
                                total:t,
                                name:vm.widget.clients[w].device.name
                            }
                            vm.googlmapLocations[w].text=txt;
                        });
                    }
                    else
                    {
                       var b=j;
                       pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[j].device.token,"?tenantAuthToken="+vm.widget.clients[j].tenant.token,true,vm.user.authentication,"GET",true,false).then(function(res){
                            vm.specToken=res.data.device.specificationToken;
                            pragmaapi.callRestService(vm.url,"/specifications/"+vm.specToken,"?tenantAuthToken="+vm.widget.clients[b].tenant.token,true,vm.user.authentication,"GET",true,false).then(function(res){
                                var specs=JSON.parse(res.data.metadata.specs);
                                var sp=
                                {
                                    measure:'',
                                    cumulative:'',
                                    unit:'',
                                    type:''
                                }
                                for(var i=0;i<Object.keys(specs).length;i++)
                                {
                                    if(specs[Object.keys(specs)[i]]['cost']==="true")
                                    {
                                        sp.measure=Object.keys(specs)[i];
                                        sp.unit=specs[Object.keys(specs)[i]]['unit'];
                                        sp.type=specs[Object.keys(specs)[i]]['type'];
                                        sp.cumulative=specs[Object.keys(specs)[i]]['cumulative'];
                                        break;
                                    }
                                }
                                vm.dates = {
                                    startDate: moment().startOf('day'),
                                    endDate: moment()
                                };
                                var promises=[
                                    pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[b].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter=cost&resolutionType=M&resolution=20&includeTotalSum=true&tenantAuthToken="+vm.widget.clients[b].tenant.token,true,vm.user.authentication,"GET",true,false)
                                ];
                                if(sp.cumulative==="true")
                                {
                                    promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[b].device.token+"/measurements/checkSensor","?measuredParameter="+sp.measure+"&tenantAuthToken="+vm.widget.clients[b].tenant.token,true,vm.user.authentication,"GET",true,false))
                                }
                                else
                                {
                                    promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[b].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+sp.measure+"&resolutionType=M&resolution=20&includeTotalSum=true&tenantAuthToken="+vm.widget.clients[b].tenant.token,true,vm.user.authentication,"GET",true,false))
                                }
                                $q.all(promises).then(function(resArray) {
                                    var txt=
                                    {
                                        cost:0,
                                        cons:0,
                                        unit: sp.unit,
                                        type:sp.type
                                    }
                                    txt.cost=(resArray[0].data.data[0].d).toFixed(2);
                                    if(sp.cumulative==="true")
                                    {
                                        txt.cons=(resArray[1].data[0][sp.measure] - resArray[1].data[1][sp.measure]).toFixed(2);
                                    }
                                    else
                                    {
                                        txt.cons=(resArray[1].data.data[0].d).toFixed(2);
                                    }
                                    vm.googlmapLocations[b].text=txt;
                                });
                            });
                        });
                    }
                }
                vm.googleMapCenter = angular.copy(vm.googlmapLocations[0].coords);
                var bounds = new google.maps.LatLngBounds();

                for(var ll=0;ll<vm.googlmapLocations.length;ll++)
                {
                    bounds.extend(new google.maps.LatLng(vm.googlmapLocations[ll].coords.latitude, vm.googlmapLocations[ll].coords.longitude));
                }
                if (vm.googlmapLocations.length > 1) {
                    uiGmapIsReady.promise().then(function (maps) {
                         maps[0].map.fitBounds(bounds);
                         var center = bounds.getCenter();
                         vm.googleMapCenter = {latitude: center.lat(), longitude: center.lng()};
                    });
                }
            });
        }
        function getBuildingStatus(id,device)
        {
            vm.dates = {
                startDate: moment().startOf('day'),
                endDate: moment()
            };
            var dtZone = new Date().toString().split(" ");
            var timeZoneFormattedArray = dtZone[5].split("GMT");
            vm.timeZone=timeZoneFormattedArray[1];
            var specs=JSON.parse(device.specification.metadata.specs);
            for(var i=0;i<Object.keys(specs).length;i++)
            {
                if(specs[Object.keys(specs)[i]].unit=="kWh")
                {
                    var thisSpec=
                    {
                        name:Object.keys(specs)[i],
                        cumulative:specs[Object.keys(specs)[i]].cumulative
                    }
                    if(specs[Object.keys(specs)[i]].cumulative==="false")
                    {
                        break;
                    }
                }
            }
            if(thisSpec.cumulative=="true")
            {
                pragmaapi.callRestService(PRAGMA.api,"/assignments/"+device.assignment.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+thisSpec.name+"&tenantAuthToken=" + vm.googlmapLocations[id].tenant, true, vm.user.authentication, "GET", true).then(function(res){
                    if(res.data[0].entries.length>0)
                    {
                        var startValue=res.data[0].entries[0].value;
                        var endValue=res.data[0].entries[res.data[0].entries.length-1].value;
                        var tmpValue=endValue-startValue;
                        vm.googlmapLocations[id].text.consumption=tmpValue % 1 === 0 ? tmpValue : parseFloat(tmpValue.toFixed(1));
                    }
               });
            }
            else
            {
                pragmaapi.callRestService(vm.url,"/assignments/"+device.assignment.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+thisSpec.name+"&resolutionType=M&resolution=20&includeTotalSum=true&tenantAuthToken="+vm.googlmapLocations[id].tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
                    var tmpValue=res.data["total_sum"];
                    vm.googlmapLocations[id].text.consumption=tmpValue % 1 === 0 ? tmpValue : parseFloat(tmpValue.toFixed(1));
                });
            }
            pragmaapi.callRestService(vm.url,"/assignments/"+device.assignment.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter=cost&resolutionType=M&resolution=20&includeTotalSum=true&tenantAuthToken="+vm.googlmapLocations[id].tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
                var tmpValue=res.data["total_sum"];
                vm.googlmapLocations[id].text.cost=tmpValue % 1 === 0 ? tmpValue : parseFloat(tmpValue.toFixed(1));
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('localization', localization)

    function localization() {
        var directive = {
            templateUrl:"app/directives/localization/localization.html",
            controller: LocalizationController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function LocalizationController ($scope,$http,session,PRAGMA,$base64,pragmaapi) {
        var vm =this;
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.result=
        {
            x:0,
            y:0
        };
        fillWidget();
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.device.assignment===args.deviceAssignmentToken)
            {
                vm.result.x = args.measurements.x;
                vm.result.y = args.measurements.y;
                generateFloorplan();
            }
        });

        function fillWidget()
        {
            vm.device={};
            vm.cClients=[];
            vm.clients=vm.widget.clients;
            for(var i=0;i<vm.clients.length;i++)
            {
                for(var j=0;j<vm.clients[i].sites.length;j++)
                {
                    var tmp={
                        token:vm.clients[i].token,
                        site:vm.clients[i].sites[j]
                    };
                    vm.cClients.push(tmp);
                }
            }
            for (var cc=0;cc<vm.cClients.length;cc++)
            {
                getDevicesCustom(vm.cClients[cc].token,vm.cClients[cc].site);
            }
        }
        
        function drawPoint(context, x, y, clr) {
            context.beginPath();
            context.arc(x, y, 15, 0, 2 * Math.PI);
            context.fillStyle = clr;
            context.fill();
        }
        
        function generateFloorplan() {
            var floorplanCanvas = document.getElementById("floorplanCanvas");
            var floorplanContext = floorplanCanvas.getContext("2d"); 
            floorplanContext.clearRect(0, 0, floorplanCanvas.width, floorplanCanvas.height);
            var imageObj = new Image(); 
            imageObj.onload = function() {
                 floorplanContext.drawImage(imageObj, 0, 0);

                drawPoint(floorplanContext, vm.result.x, vm.result.y, "red");                              
            };
            imageObj.src ='assets/images/katopsi.png';
			return floorplanCanvas;
		}
        
        function getDevicesCustom(tenant,site)
        {
            pragmaapi.callRestService(vm.url,"/devices/","?site="+site.token+"&page=1&pageSize=100&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken="+tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
                var devices=res.data.results;
                var centralMeter=null;
                for(var i=0;i<devices.length;i++)
                {
                    for(var j=0;j<site.assignments.length;j++)
                    {
                        if(devices[i].assignment.token==site.assignments[j].token)
                        {                   
                            for(var mea=0;mea<site.assignments[j].measurements.length;mea++)
                            {
                                centralMeter=
                                {
                                    "assignment":devices[i].assignment.token,
                                    "tenant":tenant
                                };
                                vm.device=centralMeter;
                                break;
                            }
                        }
                    }
                }
                getMeasurementsCustom(vm.device);
            });
        }

        function getMeasurementsCustom(centralMeter)
        {
            pragmaapi.callRestService(vm.url,"/assignments/"+centralMeter.assignment+"/measurements/lastValue","?tenantAuthToken="+centralMeter.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
                vm.result.x = res.data.x;
                vm.result.y = res.data.y;
                generateFloorplan();
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('lightingCard', lightingCard);

    function lightingCard() {
        var directive = {
            templateUrl:"app/directives/lighting-card/lighting-card.html",
            controller: LightingCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function LightingCardController ($scope,session,PRAGMA,$q,pragmaapi,$rootScope,pragmaTheming) {
        var vm =this;
        vm.user = session.getUser();
        vm.url=PRAGMA.api;
        vm.dimInteli=dimInteli;
        vm.widget=$scope.widget;
        vm.changeStatusDim=changeStatusDim;
        vm.dimmed=true;
        vm.triggered=false;
        $scope.$on('new.measurement.broadcast', function(event, args) {
            fillWidgetMqtt(args);
        });
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(255,255,255)";
            }
        }
        else
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(0,0,0)";
            }
        }
        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        fillWidget();
        function fillWidget()
        {
            vm.triggered=false;
            vm.results=[];
            if(vm.widget.graph.graphType==='inteli')
            {
                getMeasurementsInteli();
            }
            else if(vm.widget.graph.graphType==='finot')
            {
                getMeasurementsFinot();
            }
            else if(vm.widget.graph.graphType==='enocean')
            {
                getMeasurementsEnocean();
            }
        }
        function getMeasurementsEnocean()
        {
            var promises=[];
            for (var i=0;i<vm.widget.clients.length;i++)
            {
                promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[i].device.token+"/measurements/lastValue","?measuredParameter="+vm.widget.clients[i].measurement.measure+"&tenantAuthToken="+vm.widget.clients[i].tenant.token,true,vm.user.authentication,"GET",true,false));
            }
            $q.all(promises).then(function(resArray) {
                vm.tmpResult=
                {
                    consumption:0,
                    dim:0
                }
                for(var i=0;i<resArray.length;i++)
                {
                    var res=resArray[i].data;  
                    if(typeof res.dimming!=='undefined')
                    {
                        vm.tmpResult.dim=res.dimming;
                        vm.tmpResult.hardwareId=vm.widget.clients[i].device.hardwareId;
                    }
                    if(typeof res.consumption!=='undefined')
                    {
                        vm.tmpResult.consumption=res.consumption;
                    }
                }
                vm.result= vm.tmpResult;
            });
        }
        function changeStatusDim(device,type)
        {
            if(vm.dimmed)
            {
                vm.dimmed=false;
                setTimeout(function(){
                     changeStatus(device);
                },2000);
            }
           
        }
        function changeStatus(device)
        {
            var topic="/enOcean/dimming";
            var message=
            {
                "deviceId":device.hardwareId,
                "value":device.dim
            };
            vm.dimmed=true;
            $rootScope.client.publish(topic,JSON.stringify(message));
        }
        function dimInteli(device)
        {
            if(vm.dimmed)
            {
                vm.dimmed=false;
                setTimeout(function(){
                    var devUi='70b3d5bf100008b6';
                    if(device.token=='ce71c4cc-2c83-4c3c-a20b-9d1ffccc00c2' || device.token=='bcb41086-2677-41f3-bd32-22964d6b6ed4')
                    {
                        devUi='70b3d5bf100008b5';
                    }
                    vm.dimmed=true;
                    var topic='intelilights/tx';
                    var msg={
                        op:'var_set',
                        deveui:devUi,
                        var:'nviLampLevel',
                        value:device.dim
                    };
                    var url='wss://pragma.iti.gr/wss/'
                    var client = mqtt.connect(url, {keepalive: 120});
                    client.on('connect', function () {
                        client.publish(topic,JSON.stringify(msg))
                        setTimeout(function(){
                            var msg= "{ \"op\": \"var_get_list\", \"deveui\": \"70b3d5bf100008b6\", \"var\": \"nviLampLevel,nvoVolt,nvoCurrent,nvoPowerAct\", \"use_cache\": \"0\"}";
                            client.publish(topic,msg)
                            client.end();
                        },15000)
                    });
                },5000);
            }
        }


        function getMeasurementsInteli()
        {
            vm.icon='pragma-icon-lamp';
            vm.unit='W';
            var promises = [];
            for (var i=0;i<vm.widget.clients.length;i++)
            {
                promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[i].device.token+"/measurements/lastValue","?measuredParameter=nvoPowerAct&tenantAuthToken="+vm.widget.clients[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[i].device.token+"/measurements/lastValue","?measuredParameter=nviLampLevel&tenantAuthToken="+vm.widget.clients[i].tenant.token,true,vm.user.authentication,"GET",true,false));
            }
            $q.all(promises).then(function(resArray) {
                var counter=0;
                for(var i=0;i<resArray.length;i=i+2)
                {
                    var color=''
                    if(resArray[i+1].data.nviLampLevel!=0)
                    {
                        color='rgb(241,144,34)'
                    }
                    else
                    {
                        color='#b1b1b1'
                    }
                    var tmp={
                        cons:resArray[i].data.nvoPowerAct,
                        dim:resArray[i+1].data.nviLampLevel,
                        color:color,
                        timestamp:resArray[i].data.timestamp,
                        deviceName:vm.widget.clients[counter].device.name,
                        token:vm.widget.clients[counter].device.token
                    }
                    counter++;
                    vm.results.push(tmp)
                }
            });
        }
        function getMeasurementsFinot()
        {
            vm.icon='pragma-icon-lamp';
            vm.unit='W';
            var promises = [];
            for (var i=0;i<vm.widget.clients.length;i++)
            {
                promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[i].device.token+"/measurements/lastValue","?measuredParameter=dimming&tenantAuthToken="+vm.widget.clients[i].tenant.token,true,vm.user.authentication,"GET",true,false));  
                promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[i].device.token+"/measurements/checkSensor","?measuredParameter=current_W&tenantAuthToken="+vm.widget.clients[i].tenant.token,true,vm.user.authentication,"GET",true,false));            
            }
            $q.all(promises).then(function(resArray) {
                var counter=0;
                for(var i=0;i<resArray.length;i=i+2)
                {
                    var color=''
                    if(resArray[i].data.dimming!=0)
                    {
                        color='rgb(241,144,34)'
                    }
                    else
                    {
                        color='#b1b1b1'
                    }
                    var watt=resArray[i+1].data[1].current_W-resArray[i+1].data[0].current_W;
                    var tmp={
                        cons:watt,
                        dim:resArray[i].data.dimming,
                        color:color,
                        timestamp:resArray[i].data.timestamp,
                        deviceName:vm.widget.clients[counter].device.name,
                        token:vm.widget.clients[counter].device.token
                    }
                    counter++;
                    vm.results.push(tmp)
                }
                vm.triggered=true;
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('lampCard', lampCard);

    function lampCard() {
        var directive = {
            templateUrl:"app/directives/lamp-card/lamp-card.html",
            controller: LampCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function LampCardController ($scope,pragmaapi) {
        var vm =this;
        vm.device={};
        vm.widget=$scope.widget;
        vm.device["name"]=vm.widget.title;
        vm.device.lampId=vm.widget.graph.id;
        vm.device.lampType=vm.widget.graph.device;
        var ip="https://smarthome.iti.gr:5005";
        var serviceGet="/lamps/getValue?id="+vm.device.lampId;
        var servicePost="/lamps/postValue?id="+vm.device.lampId;
        getStatus();
        function getStatus()
        {
            pragmaapi.callRestService(ip,serviceGet,"",true,"","GET",true,false).then(function(res){
                vm.device.bri=res.data.state.bri;
                vm.device.percent=parseInt(100*vm.device.bri/255);
                vm.device.state=res.data.state.on;
                if( vm.device.lampType=='lamp')
                {
                    if(res.data.state.xy[0]<=0.15)
                    {
                        vm.device.color='blue';
                    }
                    else if(res.data.state.xy[0]<=0.30)
                    {
                        vm.device.color='green';
                    }
                    else if(res.data.state.xy[0]<=0.46)
                    {
                        vm.device.color='#ffea00';
                    }
                    else
                    {
                        vm.device.color='red';
                    }
                }
            });
        }
        vm.changePlugState=changePlugState;
        function changePlugState(action,type)
        {
            if(type==='on')
            {
                var message=
                {
                    on:action
                };
            }
            else if(type==='bri')
            {
                var message=
                {
                    bri:parseInt(action)
                };
            }
            else
            {
                var msg=[0.459597,0.41171];
                if(action==='red')
                {
                    msg=[0.6400,0.3300]; 
                }
                else if(action==='green')
                {   
                    msg=[0.3000,0.6000];
                }
                else if(action==='blue')
                {
                    msg=[0.1500,0.0600];
                }
                var message=
                {
                    xy:msg
                };
            }
            var ip="https://smarthome.iti.gr:5005";
            var servicePost="/lamps/postValue?id="+vm.device.lampId;
            pragmaapi.callRestService(ip,servicePost,message,true,"","POST",true,false).then(function(res){
                getStatus();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('hvacCard', hvacCard);

    function hvacCard() {
        var directive = {
            templateUrl:"app/directives/hvac-card/hvac-card.html",
            controller: HvacCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"=",
                dashboardClients:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function HvacCardController ($rootScope,$scope,session,PRAGMA,pragmaapi,pragmaTheming,$q) {
        var vm =this;
        vm.device={};
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
		vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.changeStatus=changeStatus;
        vm.hvacSetFanSpeed=hvacSetFanSpeed;
        vm.hvacSetOperationMode=hvacSetOperationMode;
        $scope.$on('new.measurement.broadcast', function(event, args) {
            fillWidgetMqtt(args);
        });
        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    var measurements=device.measurements;
                    var status=measurements['status'];
                    if(status==1)
                        status=true;
                    else
                        status=false;
                    $scope.$apply(function () {
                        vm.result.operationMode=measurements['operationMode'];
                        vm.result.fanSpeed=measurements['fanSpeed'];
                        vm.result.temperature=measurements['setTemp'];
                        vm.result.actTemperature=measurements['tempAct'];
                        vm.result.status=status;
                    });
                    break;
                }
            }
        }
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.gridLinesColor="rgb(255,255,255)";
        }
        else
        {
            vm.gridLinesColor="rgb(0,0,0)";
        }
        fillWidget();
        function fillWidget()
        {
            vm.result={};
            getMeasurements();
        }

        
        function getMeasurements()
        {
            var promises=[];
            for (var i=0;i<vm.widget.clients.length;i++)
            {
                promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[i].device.token+"/measurements/lastValue","?tenantAuthToken="+vm.widget.clients[i].tenant.token,true,vm.user.authentication,"GET",true,false));
            }
            $q.all(promises).then(function(resArray) {
                
                for(var i=0;i<resArray.length;i++)
                {
                    var res=resArray[i];
                    var measurements=res.data;
                    var temperature=measurements['setTemp'];
                    var actTemperature=measurements['tempAct'];
                    var status=measurements['status'];
                    var operationMode=measurements['operationMode'];
                    var fanSpeed=measurements['fanSpeed'];
                    if(status==1)
                        status=true;
                    else
                        status=false;
                    vm.result={
                        operationMode:operationMode,
                        fanSpeed:fanSpeed,
                        temperature:temperature,
                        actTemperature:actTemperature,
                        status:status,
                        name:vm.widget.clients[i].device.name,
                        hardwareId:vm.widget.clients[i].device.hardwareId
                    };
                }
            });
        }
        function hvacSetFanSpeed(device,type)
        {
            var message=device.hardwareId+"|UControlFanSpeed|";
            message+=type;
            var topic="/hvacs/"+device.hardwareId+"/control";
            $rootScope.client.publish(topic, message)
        }
        function hvacSetOperationMode(device,type)
        {
            var message=device.hardwareId+"|UControlOperationMode|";
            message+=type;
            var topic="/hvacs/"+device.hardwareId+"/control";
            $rootScope.client.publish(topic, message)
        }
        function changeStatus(device,type)
        {
            if(type=="On|Off")
            {
                var message=device.hardwareId+"|UCtrlOnOff|";
                if(device.status)
                    message+="1";
                else
                    message+="0"
            }
            else if(type=="up")
            {
                if(device.temperature<30)
                    device.temperature++;
                 var message=device.hardwareId+"|UControlTempSetPoint|";
                 message+=device.temperature;
            }
            else if(type=="down")
            {
                if(device.temperature>18)
                    device.temperature--;
                 var message=device.hardwareId+"|UControlTempSetPoint|";
                 message+=device.temperature;
            }
            var topic="/hvacs/"+device.hardwareId+"/control";
            $rootScope.client.publish(topic, message)
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('hubaTransitions', hubaTransitions);
    function hubaTransitions() {
        var directive = {
            templateUrl:"app/directives/hubaTransitions/hubaTransitions.html",
            controller: HubaTransitionsController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }

    /** @ngInject */
    function HubaTransitionsController ($scope,session,PRAGMA,pragmaapi,pragmaTheming,$q) {
        var vm =this;
        vm.widget=$scope.widget;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        vm.hubaUrl=PRAGMA.huba;
        vm.triggered=false;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.gridLinesColor="#e0e0e0";
        }
        else
        {
            vm.gridLinesColor="#000000";
        }
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom")
                {
                    fillWidget();
                }
            }
        });
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today")
            {
                fillWidgetMqtt(args);
            } 
        });
        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        fillWidget();
        function fillWidget()
        {
            console.log('mpike')
            vm.triggered=false;
            vm.spaces={};
            vm.selectedSpaces=[];
            vm.numericResults=[];
            if(vm.widget.dates[0].date==="custom")
            {
                vm.dates=$scope.dashboardDate;
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            getAllSpaces();
            getSelectedSpaces();
            getMeasurements();
        }

        function getMeasurements()
        {
            var promises = [];
            for(var i=0;i<vm.widget.clients.length;i++)
            {
                var dPost=
                {
                    dates:vm.dates,
                    assignment:vm.widget.clients[i].device.token,
                    tenant:vm.widget.clients[i].tenant.token
                }
                promises.push(pragmaapi.callRestService(vm.hubaUrl,"/transitionsTotal",dPost,false,"","POST",false,false))
            }
            $q.all(promises).then(function(resArray) {
                var nodes=[];
                var edges=[];
                for(var res=0;res<resArray.length;res++)
                {
                     var measurements=resArray[res].data;
                     var tofl=false;
                     var fromfl=false;
                     for(var i=0;i<measurements.length;i++)
                     {
                         tofl=false;
                         fromfl=false;
                         for(var k=0;k<vm.selectedSpaces.length;k++)
                         {
                             if(measurements[i].from===vm.selectedSpaces[k])
                             {
                                 fromfl=true;
                             }
                             if(measurements[i].to===vm.selectedSpaces[k])
                             {
                                 tofl=true;
                             }
                         }
                         if((fromfl || tofl) && measurements[i].from!=='inside' && measurements[i].to!=='inside')
                         {
                             var tmp={};
                             tmp['from']=measurements[i].from;
                             tmp['to']=measurements[i].to;
                             tmp['value']=measurements[i].transitions;
                             vm.numericResults.push(tmp)
                         }
                     }
                     
                     for(var k=0;k<vm.numericResults.length;k++)
                     {
                        if(vm.numericResults[k].value==0)
                        {
                            vm.numericResults.splice(k,1);
                            k--;
                        }
                     }
                     for(var k=0;k<vm.numericResults.length;k++)
                     {
                        var f=vm.numericResults[k].from;
                        var t=vm.numericResults[k].to;
                        if(vm.selectedSpaces.indexOf(f) == -1)
                        {
                            vm.selectedSpaces.push(f);
                        }
                        if(vm.selectedSpaces.indexOf(t) == -1)
                        {
                            vm.selectedSpaces.push(t);
                        }
                     }
                     for(var k=0;k<vm.selectedSpaces.length;k++)
                     {
                         var tmp={};
                         tmp['id']=vm.selectedSpaces[k];
                         if(typeof vm.spaces[vm.selectedSpaces[k]]!=='undefined')
                         {
                             tmp['label']=vm.spaces[vm.selectedSpaces[k]];
                         }
                         else
                         {
                             tmp['label']=vm.selectedSpaces[k];
                         }
                         tmp['group']="office";
                         tmp['value']=0;
                         nodes.push(tmp);
                     }
                     for(var k=0;k<vm.numericResults.length;k++)
                     {
                         var tmp={};
                         tmp['from']=vm.numericResults[k].from;
                         tmp['to']=vm.numericResults[k].to;
                         tmp['label']=vm.numericResults[k].value;
                         edges.push(tmp);
                     }
                }
                vm.options = {
                    autoResize: true,
                    height: '85%',
                    width: '100%',
                    nodes: {
                        scaling: {
                        },
                        font:
                        {
                            size:18,
                            color:'white'
                        }
                    },
                    edges: {
                        width:4,
                        length:350,
                        color:"green",

                        smooth: true,
                        font:
                        {
                            size:18,
                            color:vm.gridLinesColor
                        },
                        arrows:
                        {
                            to:{
                                enabled:true,
                                scaleFactor:1
                            }
                        }
                    },
                    interaction:{
                    dragNodes:true,
                    dragView: true,
                    hideEdgesOnDrag: false,
                    hideNodesOnDrag: false,
                    hover: true,
                    hoverConnectedEdges: true,
                    keyboard: {
                      enabled: false,
                      speed: {x: 10, y: 10, zoom: 0.02},
                      bindToWindow: false
                    },
                    multiselect: true,
                    navigationButtons: true,
                    selectable: true,
                    selectConnectedEdges: true,
                    tooltipDelay: 300,
                    zoomView: false
                  },
                    physics: {
                        barnesHut: {
                            gravitationalConstant: -30000
                        },
                        stabilization: {
                            iterations: 2500
                        }
                    },
                    groups: {
                        'office': {
                            shape: 'box',
                             color: '#3b6289'
                        }
                    }
                };
                vm.data = {
                    nodes: nodes,
                    edges: edges
                };
                vm.triggered=true;
             });
        }

        function getAllSpaces()
        {
            for(var i=0;i<vm.widget.clients.length;i++)
            {
                var tmp=JSON.parse(vm.widget.clients[i].device.metadata)
                var sp=JSON.parse(tmp.spaces)
                for(var j=0;j<Object.keys(sp).length;j++)
                {
                    vm.spaces[Object.keys(sp)[j]]=sp[Object.keys(sp)[j]]
                }
            }
        }

        function getSelectedSpaces()
        {
            vm.selectedSpaces=vm.widget.graph.spaces;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('hubaTotal', hubaTotal)
        .filter('capitalize', function() {
            return function(input) {
              return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
            }
        });

    function hubaTotal() {
        var directive = {
            templateUrl:"app/directives/hubaTotal/hubaTotal.html",
            controller: HubaTotalController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }

    /** @ngInject */
    function HubaTotalController ($scope,session,PRAGMA,pragmaapi,pragmaTheming,$q) {
        var vm =this;
        vm.widget=$scope.widget;
        var dtZone = new Date().toString().split(" ");
        vm.triggered=false;
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        vm.hubaUrl=PRAGMA.huba;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(255,255,255)";
            }
            vm.gridLinesColor="rgba(255,255,255,";
        }
        else
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(0,0,0)";
            }
            vm.gridLinesColor="rgba(0,0,0,";
        }
        vm.colors=
        [
            "3,169,244",
            "146,39,143",
            "170,198,6",
            "242,135,6",
            "191, 0, 255",
            "0,191,118",
            "102,45,145",
            "236,0,140",
            "0,148,68",
            "249,237,50",
            "239,65,54"
        ];
        vm.fill="0";
        if(vm.widget.graph.fill)
        {
            vm.fill="0.2";
        }
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom")
                {
                    fillWidget();
                }
            }
        });
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today")
            {
                fillWidgetMqtt(args);
            } 
        });
        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        fillWidget();
        function fillWidget()
        {
            vm.triggered=false;
            vm.numericResults=[];
            vm.spaces={};
            vm.selectedSpaces=[];
            if(vm.widget.dates[0].date==="custom")
            {
                vm.dates=$scope.dashboardDate;
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            getAllSpaces();
            getSelectedSpaces();
            getMeasurements();
        }

        function getAllSpaces()
        {
            for(var i=0;i<vm.widget.clients.length;i++)
            {
                var tmp=JSON.parse(vm.widget.clients[i].device.metadata)
                var sp=JSON.parse(tmp.spaces)
                for(var j=0;j<Object.keys(sp).length;j++)
                {
                    vm.spaces[Object.keys(sp)[j]]=sp[Object.keys(sp)[j]]
                }
            }
        }

        function getSelectedSpaces()
        {
            vm.selectedSpaces=vm.widget.graph.spaces;
        }

        function getMeasurements()
        {
            var promises = [];
            if(vm.widget.graph.value==='occupancy')
            {
                for(var i=0;i<vm.widget.clients.length;i++)
                {
                    var dPost=
                    {
                        dates:vm.dates,
                        assignment:vm.widget.clients[i].device.token,
                        tenant:vm.widget.clients[i].tenant.token,
                    }
                    promises.push(pragmaapi.callRestService(vm.hubaUrl,"/occupancyTotal",dPost,false,"","POST",false,false))
                }
                $q.all(promises).then(function(resArray) {
                    vm.unit="Occupants";
                    vm.icon="pragma-icon-occupancy";
                    for(var res=0;res<resArray.length;res++)
                    {
                        var measurements=resArray[res].data;
                        for (var i=0;i<Object.keys(measurements).length;i++)
                        {
                            for(var k=0;k<vm.selectedSpaces.length;k++)
                            {
                                if(Object.keys(measurements)[i]==vm.selectedSpaces[k])
                                {
                                    var tmp={};
                                    if(typeof vm.spaces[Object.keys(measurements)[i]]!=='undefined')
                                    {
                                        tmp[vm.spaces[Object.keys(measurements)[i]]]=measurements[Object.keys(measurements)[i]];
                                    }
                                    else
                                    {
                                        tmp[Object.keys(measurements)[i]]=measurements[Object.keys(measurements)[i]];
                                    }
                                    vm.numericResults.push(tmp);
                                }
                            }
                        }
                    }
                    if(vm.numericResults.length==1)
                    {
                        vm.widget.graph.graphType='numeric';
                    }
                    else if(vm.numericResults.length<3 && (vm.widget.graph.graphType=='numeric' || vm.widget.graph.graphType=='radar'))
                    {
                        vm.widget.graph.graphType='bar';
                        vm.result = {
                            unit : "",
                            chart: {
                                data: [],
                                labels: [],
                                series: [],
                                colors: [],
                                override: [],
                                options: {
                                    legend: {
                                        labels: {
                                            fontColor: vm.gridLinesColor+"0.6)"
                                        },
                                        display: true,
                                        position: "bottom"
                                    },
                                    elements: {
                                        point: {
                                            pointStyle: vm.widget.graph.point
                                        }
                                    },
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    scales: {
                                        xAxes: [
                                            {
                                                gridLines: {
                                                    display: true ,
                                                    color: vm.gridLinesColor+"0.2)"
                                                  },
                                                ticks: {
                                                    maxRotation: 0,
                                                    fontSize: 10,
                                                    autoSkipPadding: 10,
                                                    fontColor: vm.gridLinesColor+"0.6)"
                                                }
                                            }
                                        ],
                                        yAxes: [
                                            {
                                                gridLines: {
                                                    display: true ,
                                                    color: vm.gridLinesColor+"0.2)"
                                                },
                                                ticks: {
                                                    min:0,
                                                    maxRotation: 0,
                                                    fontSize: 10,
                                                    autoSkipPadding: 10,
                                                    fontColor: vm.gridLinesColor+"0.6)"
                                                },
                                                scaleLabel: { 
                                                    display: false,
                                                    labelString: '',
                                                }
                                            }
                                        ]
                                    },
                                    tooltips: {
                                        callbacks: {
                                            label: function(tooltipItem, data) {
                                                var unit=vm.result.unit
                                                return data.datasets[tooltipItem.datasetIndex].label+": "+parseFloat(tooltipItem.yLabel).toFixed(2) + " " + unit;
                                            }
                                        }
                                    }
                                }
                            }
                        };
                    }
                    if(vm.widget.graph.graphType=='numeric')
                    {

                    }
                    else if(vm.widget.graph.graphType=='bar')
                    {
                        var tmp = vm.widget.graph.fontColor.split("rgb(");
                        var tmp2=tmp[1].split(")");
                        var lastTmp=tmp2[0].split(",");
                        var clr=lastTmp;
                        if(!vm.widget.graph.fill)
                        {
                            var bgclr="rgba("+clr+",0)";
                        }
                        else
                        {
                            var bgclr="rgba("+clr+",0.2)";
                        }
                        vm.result.chart.data=[];
                        vm.result.chart.series=[];
                        vm.result.chart.colors=[];
                        vm.result.chart.labels=[];
                        vm.result.unit='Occupants';
                        vm.result.chart.colors.push({
                            type:vm.widget.graph.graphType,
                            pointHoverRadius:(vm.widget.graph.pointSize)+3,
                            pointRadius:vm.widget.graph.pointSize,
                            borderColor: vm.widget.graph.fontColor,
                            backgroundColor: bgclr,
                            pointBorderColor: vm.widget.graph.fontColor,
                            pointBackgroundColor: vm.widget.graph.fontColor,
                            pointHoverBorderColor: vm.widget.graph.fontColor,
                            pointHoverBackgroundColor: vm.widget.graph.fontColor
                        });
                        vm.result.chart.series.push("Occupancy");
                        vm.result.chart.data[0]=[];
                        for(var i=0;i<vm.numericResults.length;i++)
                        {
                            vm.result.chart.labels.push(Object.keys(vm.numericResults[i])[0]);
                            vm.result.chart.data[0].push(vm.numericResults[i][Object.keys(vm.numericResults[i])[0]]);
                        }
                    }
                    else
                    {
                        vm.result = {
                            unit : "",
                            chart: {
                                data: [],
                                labels: [],
                                series: [],
                                colors: [],
                                override: [],
                                options: {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    scale: {
                                        ticks: {
                                          beginAtZero: true,
                                          fontColor: vm.gridLinesColor+"0.4)", // labels such as 10, 20, etc
                                          showLabelBackdrop: false // hide square behind text
                                        },
                                        pointLabels: {
                                          fontColor: vm.gridLinesColor+"0.4)" // labels around the edge like 'Running'
                                        },
                                        gridLines: {
                                          color: vm.gridLinesColor+"0.2)"
                                        },
                                        angleLines: {
                                          color: vm.gridLinesColor+"0.2)" // lines radiating from the center
                                        }
                                      },
                                    legend: {
                                        labels: {
                                            fontColor: vm.gridLinesColor+"0.8)"
                                        },
                                        display: true,
                                        position: "bottom"
                                    },
                                    tooltips: {
                                        callbacks: {
                                            label: function(tooltipItem, data) {
                                                var unit=vm.result.unit
                                                return data.datasets[tooltipItem.datasetIndex].label+": "+parseFloat(tooltipItem.yLabel).toFixed(2) + " " + unit;
                                            }
                                        }
                                    }
                                }
                            }
                        };

                        var tmp = vm.widget.graph.fontColor.split("rgb(");
                        var tmp2=tmp[1].split(")");
                        var lastTmp=tmp2[0].split(",");
                        var clr=lastTmp;
                        if(!vm.widget.graph.fill)
                        {
                            var bgclr="rgba("+clr+",0)";
                        }
                        else
                        {
                            var bgclr="rgba("+clr+",0.2)";
                        }
                        vm.result.chart.data=[];
                        vm.result.chart.series=[];
                        vm.result.chart.colors=[];
                        vm.result.chart.labels=[];
                        vm.result.unit='Occupants';
                        vm.result.chart.colors.push({
                            pointHoverRadius:(vm.widget.graph.pointSize)+3,
                            pointRadius:vm.widget.graph.pointSize,
                            borderColor:vm.widget.graph.fontColor,
                            backgroundColor: bgclr,
                            pointBorderColor: vm.widget.graph.fontColor,
                            pointBackgroundColor: vm.widget.graph.fontColor,
                            pointHoverBorderColor: vm.widget.graph.fontColor,
                            pointHoverBackgroundColor: vm.widget.graph.fontColor
                        });
                        vm.result.chart.series.push("Occupancy");
                        vm.result.chart.data[0]=[];
                        for(var i=0;i<vm.numericResults.length;i++)
                        {
                            vm.result.chart.labels.push(Object.keys(vm.numericResults[i])[0]);
                            vm.result.chart.data[0].push(vm.numericResults[i][Object.keys(vm.numericResults[i])[0]]);
                        }
                    }
                    vm.triggered=true;
                 });
            }
            else
            {
                for(var i=0;i<vm.widget.clients.length;i++)
                {
                    var dPost=
                    {
                        dates:vm.dates,
                        assignment:vm.widget.clients[i].device.token,
                        tenant:vm.widget.clients[i].tenant.token,
                    }
                    promises.push(pragmaapi.callRestService(vm.hubaUrl,"/entriesExitsTotal",dPost,false,"","POST",false,false))
                }
                $q.all(promises).then(function(resArray) {
                    vm.unit='Occupants';
                    vm.icon="pragma-icon-entries-exits";
                    for(var res=0;res<resArray.length;res++)
                    {
                        var measurements=resArray[res].data;
                        for (var i=0;i<Object.keys(measurements).length;i++)
                        {
                            for(var k=0;k<vm.selectedSpaces.length;k++)
                            {
                                if(Object.keys(measurements)[i]==vm.selectedSpaces[k])
                                {
                                    var tmp={};
                                    if(typeof vm.spaces[Object.keys(measurements)[i]]!=='undefined')
                                    {
                                        tmp[vm.spaces[Object.keys(measurements)[i]]]={};
                                        for (var l=0;l<vm.widget.graph.values.length;l++)
                                        {
                                            tmp[vm.spaces[Object.keys(measurements)[i]]][vm.widget.graph.values[l]]=measurements[Object.keys(measurements)[i]][vm.widget.graph.values[l]];
                                        }
                                    }
                                    else
                                    {
                                        tmp[Object.keys(measurements)[i]]={};
                                        for (var l=0;l<vm.widget.graph.values.length;l++)
                                        {
                                            tmp[Object.keys(measurements)[i]][vm.widget.graph.values[l]]=measurements[Object.keys(measurements)[i]][vm.widget.graph.values[l]];
                                        }
                                    }
                                    vm.numericResults.push(tmp);
                                }
                            }
                        }
                    }
                    if(vm.numericResults.length==1)
                    {
                        vm.widget.graph.graphType='numeric';
                    }
                    else if(vm.numericResults.length<3 && (vm.widget.graph.graphType=='numeric' || vm.widget.graph.graphType=='radar'))
                    {
                        vm.widget.graph.graphType='bar';
                        vm.result = {
                            unit : "",
                            chart: {
                                data: [],
                                labels: [],
                                series: [],
                                colors: [],
                                override: [],
                                options: {
                                    legend: {
                                        labels: {
                                            fontColor: vm.gridLinesColor+"0.6)"
                                        },
                                        display: true,
                                        position: "bottom"
                                    },
                                    elements: {
                                        point: {
                                            pointStyle: vm.widget.graph.point
                                        }
                                    },
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    scales: {
                                        xAxes: [
                                            {
                                                gridLines: {
                                                    display: true ,
                                                    color: vm.gridLinesColor+"0.2)"
                                                  },
                                                ticks: {
                                                    maxRotation: 0,
                                                    fontSize: 10,
                                                    autoSkipPadding: 10,
                                                    fontColor: vm.gridLinesColor+"0.6)"
                                                }
                                            }
                                        ],
                                        yAxes: [
                                            {
                                                gridLines: {
                                                    display: true ,
                                                    color: vm.gridLinesColor+"0.2)"
                                                },
                                                ticks: {
                                                    beginAtZero:true,
                                                    maxRotation: 0,
                                                    fontSize: 10,
                                                    autoSkipPadding: 10,
                                                    fontColor: vm.gridLinesColor+"0.6)"
                                                },
                                                scaleLabel: { 
                                                    display: false,
                                                    labelString: '',
                                                }
                                            }
                                        ]
                                    },
                                    tooltips: {
                                        callbacks: {
                                            label: function(tooltipItem, data) {
                                                var unit=vm.result.unit
                                                return data.datasets[tooltipItem.datasetIndex].label+": "+parseFloat(tooltipItem.yLabel).toFixed(2) + " " + unit;
                                            }
                                        }
                                    }
                                }
                            }
                        };
                    }
                    if(vm.widget.graph.graphType=='numeric')
                    {

                    }
                    else if(vm.widget.graph.graphType=='bar')
                    {
                        vm.result.chart.data=[];
                        vm.result.chart.series=[];
                        vm.result.chart.colors=[];
                        vm.result.chart.labels=[];
                        vm.result.unit='Occupants';
                        for (var l=0;l<vm.widget.graph.values.length;l++)
                        {
                            if(vm.widget.graph.values.length==1)
                            {
                                var tmp = vm.widget.graph.fontColor.split("rgb(");
                                var tmp2=tmp[1].split(")");
                                var lastTmp=tmp2[0].split(",");
                                var clr=lastTmp;
                                if(!vm.widget.graph.fill)
                                {
                                    var bgclr="rgba("+clr+",0)";
                                }
                                else
                                {
                                    var bgclr="rgba("+clr+",0.2)";
                                }
                                vm.result.chart.colors.push({
                                    type:vm.widget.graph.graphType,
                                    pointHoverRadius:(vm.widget.graph.pointSize)+3,
                                    pointRadius:vm.widget.graph.pointSize,
                                    borderColor: vm.widget.graph.fontColor,
                                    backgroundColor: bgclr,
                                    pointBorderColor: vm.widget.graph.fontColor,
                                    pointBackgroundColor: vm.widget.graph.fontColor,
                                    pointHoverBorderColor: vm.widget.graph.fontColor,
                                    pointHoverBackgroundColor: vm.widget.graph.fontColor
                                });
                            }
                            else
                            {
                                vm.result.chart.colors.push({
                                    type:vm.widget.graph.graphType,
                                    pointHoverRadius:(vm.widget.graph.pointSize)+3,
                                    pointRadius:vm.widget.graph.pointSize,
                                    borderColor: "rgba(" + vm.colors[l] + ",1)",
                                    backgroundColor: "rgba(" + vm.colors[l] + ","+vm.fill+")",
                                    pointBorderColor: "rgba(" + vm.colors[l] + ",1)",
                                    pointBackgroundColor: "rgba(" + vm.colors[l] + ",1)",
                                    pointHoverBorderColor: "rgba(" + vm.colors[l] + ",1)",
                                    pointHoverBackgroundColor: "rgba(" + vm.colors[l] + ",1)"
                                });
                            }
                            vm.result.chart.series.push(vm.widget.graph.values[l]);
                            vm.result.chart.data[l]=[];
                            for(var i=0;i<vm.numericResults.length;i++)
                            {
                                if(l==0)
                                {
                                    vm.result.chart.labels.push(Object.keys(vm.numericResults[i])[0]);
                                }
                                vm.result.chart.data[l].push(vm.numericResults[i][Object.keys(vm.numericResults[i])[0]][vm.widget.graph.values[l]]);
                            }
                        }
                    }
                    else
                    {
                        vm.result = {
                            unit : "",
                            chart: {
                                data: [],
                                labels: [],
                                series: [],
                                colors: [],
                                override: [],
                                options: {
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    scale: {
                                        ticks: {
                                          beginAtZero: true,
                                          fontColor: vm.gridLinesColor+"0.4)", // labels such as 10, 20, etc
                                          showLabelBackdrop: false // hide square behind text
                                        },
                                        pointLabels: {
                                          fontColor: vm.gridLinesColor+"0.4)" // labels around the edge like 'Running'
                                        },
                                        gridLines: {
                                          color: vm.gridLinesColor+"0.2)"
                                        },
                                        angleLines: {
                                          color: vm.gridLinesColor+"0.2)" // lines radiating from the center
                                        }
                                      },
                                    legend: {
                                        labels: {
                                            fontColor: vm.gridLinesColor+"0.8)"
                                        },
                                        display: true,
                                        position: "bottom"
                                    },
                                    tooltips: {
                                        callbacks: {
                                            label: function(tooltipItem, data) {
                                                var unit=vm.result.unit
                                                return data.datasets[tooltipItem.datasetIndex].label+": "+parseFloat(tooltipItem.yLabel).toFixed(2) + " " + unit;
                                            }
                                        }
                                    }
                                }
                            }
                        };
                        vm.result.chart.data=[];
                        vm.result.chart.series=[];
                        vm.result.chart.colors=[];
                        vm.result.chart.labels=[];
                        vm.result.unit='Occupants';
                        for (var l=0;l<vm.widget.graph.values.length;l++)
                        {
                            if(vm.widget.graph.values.length==1)
                            {
                                var tmp = vm.widget.graph.fontColor.split("rgb(");
                                var tmp2=tmp[1].split(")");
                                var lastTmp=tmp2[0].split(",");
                                var clr=lastTmp;
                                if(!vm.widget.graph.fill)
                                {
                                    var bgclr="rgba("+clr+",0)";
                                }
                                else
                                {
                                    var bgclr="rgba("+clr+",0.2)";
                                }
                                vm.result.chart.colors.push({
                                    pointHoverRadius:(vm.widget.graph.pointSize)+3,
                                    pointRadius:vm.widget.graph.pointSize,
                                    borderColor: vm.widget.graph.fontColor,
                                    backgroundColor: bgclr,
                                    pointBorderColor: vm.widget.graph.fontColor,
                                    pointBackgroundColor: vm.widget.graph.fontColor,
                                    pointHoverBorderColor: vm.widget.graph.fontColor,
                                    pointHoverBackgroundColor: vm.widget.graph.fontColor
                                });
                            }
                            else
                            {
                                vm.result.chart.colors.push({
                                    pointHoverRadius:(vm.widget.graph.pointSize)+3,
                                    pointRadius:vm.widget.graph.pointSize,
                                    borderColor: "rgba(" + vm.colors[l] + ",1)",
                                    backgroundColor: "rgba(" + vm.colors[l] + ","+vm.fill+")",
                                    pointBorderColor: "rgba(" + vm.colors[l] + ",1)",
                                    pointBackgroundColor: "rgba(" + vm.colors[l] + ",1)",
                                    pointHoverBorderColor: "rgba(" + vm.colors[l] + ",1)",
                                    pointHoverBackgroundColor: "rgba(" + vm.colors[l] + ",1)"
                                });
                            }
                            vm.result.chart.series.push(vm.widget.graph.values[l]);
                            vm.result.chart.data[l]=[];
                            for(var i=0;i<vm.numericResults.length;i++)
                            {
                                if(l==0)
                                {
                                    vm.result.chart.labels.push(Object.keys(vm.numericResults[i])[0]);
                                }
                                vm.result.chart.data[l].push(vm.numericResults[i][Object.keys(vm.numericResults[i])[0]][vm.widget.graph.values[l]]);
                            }
                        }
                    }
                    vm.triggered=true;
                 });
            }
        }
    }
})();
(function() {
    'use strict';
    angular
        .module('app.directives')
        .directive('hubaPlot', hubaPlot);
    function hubaPlot() {
        var directive = {
            templateUrl:"app/directives/hubaPlot/hubaPlot.html",
            controller: HubaPlotController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function HubaPlotController ($scope,session,PRAGMA,pragmaapi,pragmaTheming,$q) {
        var vm =this;
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.hubaUrl=PRAGMA.huba;
        vm.widget=$scope.widget;
        vm.dates=[];
        vm.triggered=false;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(255,255,255)";
            }
            vm.gridLinesColor="rgba(255,255,255,";
        }
        else
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(0,0,0)";
            }
            vm.gridLinesColor="rgba(0,0,0,";
        }
        vm.colors=
        [
            "3,169,244",
            "146,39,143",
            "170,198,6",
            "242,135,6",
            "191, 0, 255",
            "0,191,118",
            "102,45,145",
            "236,0,140",
            "0,148,68",
            "249,237,50",
            "239,65,54"
        ];
        vm.fill="0";
        if(vm.widget.graph.fill)
        {
            vm.fill="0.2";
        }
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        fillWidget();
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom")
                {
                    fillWidget();
                }
            }
        });
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today")
            {
                fillWidgetMqtt(args);
            } 
        });
        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        function fillWidget()
        {
            vm.spaces={};
            vm.triggered=false;
            vm.selectedSpaces=[];
            vm.step = false;
            vm.graphType="line";
            vm.showLine=true;
            if(vm.widget.graph.graphType==='step') {
                vm.step = true;
            }
            else if(vm.widget.graph.graphType==='bar')
            {
               vm.graphType="bar";
            }
            else if(vm.widget.graph.graphType==='bubble')
            {
                vm.showLine=false;
            }
            if(vm.widget.dates[0].date==="custom")
            {
                vm.dates=$scope.dashboardDate;
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            vm.resolutionType=vm.widget.time.resolutionType;
            vm.resolutionValue=vm.widget.time.resolutionValue;
            var dF = Date.parse(vm.dates.startDate) / 1000;
            var dT = Date.parse(vm.dates.endDate) / 1000;
            var def=dT-dF;
            var day = 86400;
            vm.resolutionMinutes=0;
            if (def > day && def <= day * 30 && vm.resolutionType==='m' && vm.resolutionValue<60) { 
                vm.resolutionType="d";
                vm.resolutionValue=1;
            }
            else if (def > day * 30 && vm.resolutionType!=='d' && vm.resolutionType!=='M'){
                vm.resolutionType = "M";
                vm.resolutionValue = 1;
            }
            if(vm.resolutionType==='m')
            {
                vm.resolutionMinutes=vm.resolutionValue;
            }
            else if(vm.resolutionType==='h')
            {
                vm.resolutionMinutes=vm.resolutionValue*60;
            }
            else if(vm.resolutionType==='d')
            {
                vm.resolutionMinutes=vm.resolutionValue*60*24;
            }
            else if(vm.resolutionType==='M')
            {
                vm.resolutionMinutes=vm.resolutionValue*60*24*30;
            }
            vm.result = {
                chart: {
                    data: [],
                    labels: [],
                    series: [],
                    colors: [],
                    override: [],
                    options: {
                        legend: {
                            labels: {
                                fontColor: vm.gridLinesColor+"0.6)"
                            },
                            display: true,
                            position: "bottom"
                        },
                        elements: {
							point: {
								pointStyle: vm.widget.graph.point
							}
						},
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [
                                {
                                    gridLines: {
                                        display: true ,
                                        color: vm.gridLinesColor+"0.2)"
                                      },
                                    ticks: {
                                        maxRotation: 0,
                                        fontSize: 10,
                                        autoSkipPadding: 10,
                                        fontColor: vm.gridLinesColor+"0.6)"
                                    }
                                }
                            ],
                            yAxes: [
                                {
                                    gridLines: {
                                        display: true ,
                                        color: vm.gridLinesColor+"0.2)"
                                    },
                                    ticks: {
                                        maxRotation: 0,
                                        fontSize: 10,
                                        autoSkipPadding: 10,
                                        fontColor: vm.gridLinesColor+"0.6)"
                                    },
                                    scaleLabel: { 
                                        display: false,
                                        labelString: '',
                                    }
                                }
                            ]
                        },
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    var unit=vm.unit
                                    return data.datasets[tooltipItem.datasetIndex].label+": "+parseFloat(tooltipItem.yLabel).toFixed(2) + " " + unit;
                                }
                            }
                        }
                    }
                }
            };
            getAllSpaces();
            getSelectedSpaces();
            getMeasurements();
        }

        function getAllSpaces()
        {
            for(var i=0;i<vm.widget.clients.length;i++)
            {
                var tmp=JSON.parse(vm.widget.clients[i].device.metadata)
                var sp=JSON.parse(tmp.spaces)
                for(var j=0;j<Object.keys(sp).length;j++)
                {
                    vm.spaces[Object.keys(sp)[j]]=sp[Object.keys(sp)[j]]
                }
            }
        }

        function getSelectedSpaces()
        {
            vm.selectedSpaces=vm.widget.graph.spaces;
        }
        function calculateMetadataEntriesExits()
        {
            vm.metadata={
                entries:{
                    total:0,
                    mean:0,
                    min:100000,
                    max:-100000
                },
                exits:{
                    total:0,
                    mean:0,
                    min:100000,
                    max:-100000
                }
            }
            var counterEntries=0;
            var counterExits=0;
            for(var i=0;i<vm.result.chart.data.length;i++)
            {
                var txt=vm.result.chart.series[i];
                if(txt.includes('entries'))
                {
                    for(var j=0;j<vm.result.chart.data[i].length;j++)
                    {
                        vm.metadata.entries.total+=vm.result.chart.data[i][j];
                        if(vm.result.chart.data[i][j]>0)
                        {
                            counterEntries++;
                        }
                        if(vm.result.chart.data[i][j]>vm.metadata.entries.max)
                        {
                            vm.metadata.entries.max=vm.result.chart.data[i][j];
                        }
                        if(vm.result.chart.data[i][j]<vm.metadata.entries.min && vm.result.chart.data[i][j]>0)
                        {
                            vm.metadata.entries.min=vm.result.chart.data[i][j];
                        }
                    }
                }
                else
                {
                    for(var j=0;j<vm.result.chart.data[i].length;j++)
                    {
                        vm.metadata.exits.total+=vm.result.chart.data[i][j];
                        if(vm.result.chart.data[i][j]>0)
                        {
                            counterExits++;
                        }
                        if(vm.result.chart.data[i][j]>vm.metadata.exits.max)
                        {
                            vm.metadata.exits.max=vm.result.chart.data[i][j];
                        }
                        if(vm.result.chart.data[i][j]<vm.metadata.exits.min && vm.result.chart.data[i][j]>0)
                        {
                            vm.metadata.exits.min=vm.result.chart.data[i][j];
                        }
                    }
                }
            }
            vm.meta=
            {
                entries:false,
                exits:false
            }
            for(var i=0;i<vm.widget.graph.values.length;i++)
            {
                if(vm.widget.graph.values[i]==='entries')
                {
                    vm.meta.entries=true;
                    if(vm.metadata.entries.min==100000)
                    {
                        vm.metadata.entries.min=0;
                    }
                    vm.metadata.entries.mean=vm.metadata.entries.total/counterEntries;
                }
                if(vm.widget.graph.values[i]==='exits')
                {
                    vm.meta.exits=true;
                    if(vm.metadata.exits.min==100000)
                    {
                        vm.metadata.exits.min=0;
                    }
                    vm.metadata.exits.mean=vm.metadata.exits.total/counterExits;
                }
            }
        }
        function calculateMetadataOccupancy()
        {
            vm.metadata={
                total:0,
                mean:0,
                min:100000,
                max:0
            }
            var counter=0;
            vm.metadata.max=vm.result.chart.data[0][0];
            for(var i=0;i<vm.result.chart.data.length;i++)
            {
                for(var j=0;j<vm.result.chart.data[i].length;j++)
                {
                    vm.metadata.total+=vm.result.chart.data[i][j];
                    
                    if(vm.result.chart.data[i][j]>0)
                    {
                        counter++;
                    }
                    if(vm.result.chart.data[i][j]>vm.metadata.max)
                    {
                        vm.metadata.max=vm.result.chart.data[i][j];
                    }
                    if(vm.result.chart.data[i][j]<vm.metadata.min && vm.result.chart.data[i][j]>0)
                    {
                        vm.metadata.min=vm.result.chart.data[i][j];
                    }
                }
            }
            if(vm.metadata.min==100000)
            {
                vm.metadata.min=0;
            }
            vm.metadata.mean=vm.metadata.total/counter;
        }
        function getMeasurements()
        {
            var promises = [];
            if(vm.widget.graph.value==='occupancy')
            {
                for(var i=0;i<vm.widget.clients.length;i++)
                {
                    var dPost=
                    {
                        dates:vm.dates,
                        assignment:vm.widget.clients[i].device.token,
                        tenant:vm.widget.clients[i].tenant.token,
                        minutes:vm.resolutionMinutes
                    }
                    promises.push(pragmaapi.callRestService(vm.hubaUrl,"/occupancyAggregation",dPost,false,"","POST",false,false))
                }
                $q.all(promises).then(function(resArray) {
                    var counter=0;
                    vm.result.chart.data=[];
                    vm.result.chart.series=[];
                    vm.result.chart.colors=[];
                    vm.result.chart.labels=[];
                    vm.unit='Occupants';
                    if(vm.widget.graph.aggregated)
                    {
                        var tmp = vm.widget.graph.backgroundColor.split("rgb(");
                        var tmp2=tmp[1].split(")");
                        var lastTmp=tmp2[0].split(",");
                        var clr=lastTmp;
                        if(!vm.widget.graph.fill)
                        {
                            var bgclr="rgba("+clr+",0)";
                        }
                        else
                        {
                            var bgclr="rgba("+clr+",0.2)";
                        }
                        vm.result.chart.series.push("Occupancy");
                        vm.result.chart.data.push([]);
                        vm.result.chart.colors.push({
                            type:vm.graphType,
                            showLine: vm.showLine,
                            steppedLine: vm.step,
                            lineTension : 0,
                            pointHoverRadius:(vm.widget.graph.pointSize)+3,
                            pointRadius:vm.widget.graph.pointSize,
                            borderColor: vm.widget.graph.backgroundColor,
                            backgroundColor: bgclr,
                            pointBorderColor: vm.widget.graph.backgroundColor,
                            pointBackgroundColor: vm.widget.graph.backgroundColor,
                            pointHoverBorderColor: vm.widget.graph.backgroundColor,
                            pointHoverBackgroundColor: vm.widget.graph.backgroundColor
                        });
                        for(var res=0;res<resArray.length;res++)
                        {
                            var measurements=resArray[res].data;
                            for (var i=0;i<Object.keys(measurements).length;i++)
                            {
                                for(var k=0;k<vm.selectedSpaces.length;k++)
                                {
                                    if(Object.keys(measurements)[i]==vm.selectedSpaces[k])
                                    {
                                        var foo=measurements[Object.keys(measurements)[i]].occupancy;
                                        for (var j=0;j<foo.length;j++)
                                        {
                                            if(counter==0)
                                            {
                                                if(vm.resolutionMinutes<1440)
                                                {
                                                    vm.result.chart.labels.push(moment(foo[j].timestamp).format('HH:mm'));
                                                }
                                                else if(vm.resolutionMinutes<44600)
                                                {
                                                    vm.result.chart.labels.push(moment(foo[j].timestamp).format('DD/MM'));
                                                }
                                                else
                                                {
                                                    vm.result.chart.labels.push(moment(foo[j].timestamp).format('MM/YYYY'));
                                                }
                                                
                                            }
                                            if(counter==0)
                                            {
                                                vm.result.chart.data[counter].push(foo[j].value);
                                            }
                                            else
                                            {
                                                vm.result.chart.data[0][j]+=foo[j].value;
                                            }
                                        }
                                        counter++;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    else
                    {
                        for(var res=0;res<resArray.length;res++)
                        {
                            var measurements=resArray[res].data;
                            for (var i=0;i<Object.keys(measurements).length;i++)
                            {
                                for(var k=0;k<vm.selectedSpaces.length;k++)
                                {
                                    if(Object.keys(measurements)[i]==vm.selectedSpaces[k])
                                    {
                                        vm.result.chart.series.push(vm.spaces[Object.keys(measurements)[i]]+"-occupancy");
                                        vm.result.chart.data[counter]=[];
                                        var foo=measurements[Object.keys(measurements)[i]].occupancy;
                                        for (var j=0;j<foo.length;j++)
                                        {
                                            if(counter==0)
                                            {
                                                if(vm.resolutionMinutes<1440)
                                                {
                                                    vm.result.chart.labels.push(moment(foo[j].timestamp).format('HH:mm'));
                                                }
                                                else if(vm.resolutionMinutes<44600)
                                                {
                                                    vm.result.chart.labels.push(moment(foo[j].timestamp).format('DD/MM'));
                                                }
                                                else
                                                {
                                                    vm.result.chart.labels.push(moment(foo[j].timestamp).format('MM/YYYY'));
                                                }
                                                
                                            }
                                            vm.result.chart.data[counter].push(foo[j].value);
                                        }
                                        vm.result.chart.colors.push({
                                            type:vm.graphType,
                                            showLine: vm.showLine,
                                            steppedLine: vm.step,
                                            lineTension : 0,
                                            pointHoverRadius:(vm.widget.graph.pointSize)+3,
                                            pointRadius:vm.widget.graph.pointSize,
                                            borderColor: "rgba(" + vm.colors[counter] + ",1)",
                                            backgroundColor: "rgba(" + vm.colors[counter] + ","+vm.fill+")",
                                            pointBorderColor: "rgba(" + vm.colors[counter] + ",1)",
                                            pointBackgroundColor: "rgba(" + vm.colors[counter] + ",1)",
                                            pointHoverBorderColor: "rgba(" + vm.colors[counter] + ",1)",
                                            pointHoverBackgroundColor: "rgba(" + vm.colors[counter] + ",1)"
                                        });
                                        counter++;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    vm.triggered=true;
                    calculateMetadataOccupancy();
                });
            }
            else
            {
                vm.minutes=vm.widget.graph.time;
                for(var i=0;i<vm.widget.clients.length;i++)
                {
                    var dPost=
                    {
                        dates:vm.dates,
                        assignment:vm.widget.clients[i].device.token,
                        tenant:vm.widget.clients[i].tenant.token,
                        minutes:vm.resolutionMinutes
                    }
                    promises.push(pragmaapi.callRestService(vm.hubaUrl,"/entriesExitsAggregation",dPost,false,"","POST",false,false))
                }
                $q.all(promises).then(function(resArray) {
                    vm.unit='Occupants';
                    vm.result.chart.data=[];
                    vm.result.chart.series=[];
                    vm.result.chart.colors=[];
                    vm.result.chart.labels=[];
                    var counter=0;
                    var count=[];
                    if(vm.widget.graph.aggregated)
                    {
                        for (var l=0;l<vm.widget.graph.values.length;l++)
                        {
                            vm.result.chart.series.push(vm.widget.graph.values[l]);
                            vm.result.chart.data.push([]);
                            if(vm.widget.graph.values.length==1)
                            {
                                var tmp = vm.widget.graph.backgroundColor.split("rgb(");
                                var tmp2=tmp[1].split(")");
                                var lastTmp=tmp2[0].split(",");
                                var clr=lastTmp;
                                if(!vm.widget.graph.fill)
                                {
                                    var bgclr="rgba("+clr+",0)";
                                }
                                else
                                {
                                    var bgclr="rgba("+clr+",0.2)";
                                }
                                vm.result.chart.series.push("Occupancy");
                                vm.result.chart.data.push([]);
                                vm.result.chart.colors.push({
                                    type:vm.graphType,
                                    showLine: vm.showLine,
                                    steppedLine: vm.step,
                                    lineTension : 0,
                                    pointHoverRadius:(vm.widget.graph.pointSize)+3,
                                    pointRadius:vm.widget.graph.pointSize,
                                    borderColor: vm.widget.graph.backgroundColor,
                                    backgroundColor: bgclr,
                                    pointBorderColor: vm.widget.graph.backgroundColor,
                                    pointBackgroundColor: vm.widget.graph.backgroundColor,
                                    pointHoverBorderColor: vm.widget.graph.backgroundColor,
                                    pointHoverBackgroundColor: vm.widget.graph.backgroundColor
                                });
                            }
                            else
                            {
                                vm.result.chart.colors.push({
                                    type:vm.graphType,
                                    showLine: vm.showLine,
                                    steppedLine: vm.step,
                                    lineTension : 0,
                                    pointHoverRadius:(vm.widget.graph.pointSize)+3,
                                    pointRadius:vm.widget.graph.pointSize,
                                    borderColor: "rgba(" + vm.colors[l] + ",1)",
                                    backgroundColor: "rgba(" + vm.colors[l] + ","+vm.fill+")",
                                    pointBorderColor: "rgba(" + vm.colors[l] + ",1)",
                                    pointBackgroundColor: "rgba(" + vm.colors[l] + ",1)",
                                    pointHoverBorderColor: "rgba(" + vm.colors[l] + ",1)",
                                    pointHoverBackgroundColor: "rgba(" + vm.colors[l] + ",1)"
                                });
                            }
                            count.push(0);
                        }
                        for(var res=0;res<resArray.length;res++)
                        {
                            var measurements=resArray[res].data;
                            for (var l=0;l<vm.widget.graph.values.length;l++)
                            {
                                for (var i=0;i<Object.keys(measurements).length;i++)
                                {
                                    for(var k=0;k<vm.selectedSpaces.length;k++)
                                    {
                                        if(Object.keys(measurements)[i]==vm.selectedSpaces[k])
                                        {
                                            var foo=measurements[Object.keys(measurements)[i]][vm.widget.graph.values[l]];
                                            for (var j=0;j<foo.length;j++)
                                            {
                                                if(counter==0)
                                                {
                                                    if(vm.resolutionMinutes<1440)
                                                    {
                                                        vm.result.chart.labels.push(moment(foo[j].timestamp).format('HH:mm'));
                                                    }
                                                    else if(vm.resolutionMinutes<44600)
                                                    {
                                                        vm.result.chart.labels.push(moment(foo[j].timestamp).format('DD/MM'));
                                                    }
                                                    else
                                                    {
                                                        vm.result.chart.labels.push(moment(foo[j].timestamp).format('MM/YYYY'));
                                                    }
                                                    
                                                }
                                                if(count[l]==0)
                                                {
                                                    vm.result.chart.data[l].push(foo[j].value);
                                                }
                                                else
                                                {
                                                    vm.result.chart.data[l][j]+=foo[j].value;
                                                }
                                                
                                            }
                                            count[l]++;
                                            counter++;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else
                    {
                        for(var res=0;res<resArray.length;res++)
                        {
                            var measurements=resArray[res].data;
                            for (var l=0;l<vm.widget.graph.values.length;l++)
                            {
                                for (var i=0;i<Object.keys(measurements).length;i++)
                                {
                                    for(var k=0;k<vm.selectedSpaces.length;k++)
                                    {
                                        if(Object.keys(measurements)[i]==vm.selectedSpaces[k])
                                        {
                                            var str=vm.spaces[Object.keys(measurements)[i]]+"-"+vm.widget.graph.values[l];
                                            vm.result.chart.series.push(str);
                                            vm.result.chart.data[counter]=[];
                                            var foo=measurements[Object.keys(measurements)[i]][vm.widget.graph.values[l]];
                                            for (var j=0;j<foo.length;j++)
                                            {
                                                if(counter==0)
                                                {
                                                    if(vm.resolutionMinutes<1440)
                                                    {
                                                        vm.result.chart.labels.push(moment(foo[j].timestamp).format('HH:mm'));
                                                    }
                                                    else if(vm.resolutionMinutes<44600)
                                                    {
                                                        vm.result.chart.labels.push(moment(foo[j].timestamp).format('DD/MM'));
                                                    }
                                                    else
                                                    {
                                                        vm.result.chart.labels.push(moment(foo[j].timestamp).format('MM/YYYY'));
                                                    }
                                                    
                                                }
                                                vm.result.chart.data[counter].push(foo[j].value);
                                            }
                                            vm.result.chart.colors.push({
                                                type:vm.graphType,
                                                showLine: vm.showLine,
                                                steppedLine: vm.step,
                                                lineTension : 0,
                                                pointHoverRadius:(vm.widget.graph.pointSize)+3,
                                                pointRadius:vm.widget.graph.pointSize,
                                                borderColor: "rgba(" + vm.colors[counter] + ",1)",
                                                backgroundColor: "rgba(" + vm.colors[counter] + ","+vm.fill+")",
                                                pointBorderColor: "rgba(" + vm.colors[counter] + ",1)",
                                                pointBackgroundColor: "rgba(" + vm.colors[counter] + ",1)",
                                                pointHoverBorderColor: "rgba(" + vm.colors[counter] + ",1)",
                                                pointHoverBackgroundColor: "rgba(" + vm.colors[counter] + ",1)"
                                            });
                                            counter++;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    vm.triggered=true;
                    calculateMetadataEntriesExits();
                 }); 
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('hubaPeak', hubaPeak)   
        .filter('capitalize', function() {
            return function(input) {
              return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
            }
        });
    function hubaPeak() {
        var directive = {
            templateUrl:"app/directives/hubaPeak/hubaPeak.html",
            controller: HubaPeakController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }

    /** @ngInject */
    function HubaPeakController ($scope,session,PRAGMA,pragmaapi,pragmaTheming,$q) {
        var vm =this;
        vm.mode='table';
        vm.widget=$scope.widget;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        vm.hubaUrl=PRAGMA.huba;
        vm.triggered=false;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.gridLinesColor="#e0e0e0";
            vm.clockTheme="blue-light";
        }
        else
        {
            vm.gridLinesColor="#000000";
            vm.clockTheme="light";
        }
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom")
                {
                    fillWidget();
                }
            }
        });
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today")
            {
                fillWidgetMqtt(args);
            } 
        });
        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        fillWidget();
        function fillWidget()
        {
            vm.triggered=false;
            vm.table={};
            vm.spaces={};
            vm.selectedSpaces=[];
            vm.numericResults=[];
            if(vm.widget.dates[0].date==="custom")
            {
                vm.dates=$scope.dashboardDate;
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            vm.resolutionType=vm.widget.time.resolutionType;
            vm.resolutionValue=vm.widget.time.resolutionValue;
            var dF = Date.parse(vm.dates.startDate) / 1000;
            var dT = Date.parse(vm.dates.endDate) / 1000;
            var def=dT-dF;
            var day = 86400;
            vm.resolutionMinutes=0;
            if (def > day && def <= day * 30 && vm.resolutionType==='m' && vm.resolutionValue<60) { 
                vm.resolutionType="d";
                vm.resolutionValue=1;
            }
            else if (def > day * 30 && vm.resolutionType!=='d' && vm.resolutionType!=='M'){
                vm.resolutionType = "M";
                vm.resolutionValue = 1;
            }
            if(vm.resolutionType==='m')
            {
                vm.resolutionMinutes=vm.resolutionValue;
            }
            else if(vm.resolutionType==='h')
            {
                vm.resolutionMinutes=vm.resolutionValue*60;
            }
            else if(vm.resolutionType==='d')
            {
                vm.resolutionMinutes=vm.resolutionValue*60*24;
            }
            else if(vm.resolutionType==='M')
            {
                vm.resolutionMinutes=vm.resolutionValue*60*24*30;
            }
            getAllSpaces();
            getSelectedSpaces();
            getMeasurements();
        }

        function getAllSpaces()
        {
            for(var i=0;i<vm.widget.clients.length;i++)
            {
                var tmp=JSON.parse(vm.widget.clients[i].device.metadata)
                var sp=JSON.parse(tmp.spaces)
                for(var j=0;j<Object.keys(sp).length;j++)
                {
                    vm.spaces[Object.keys(sp)[j]]=sp[Object.keys(sp)[j]]
                }
            }
        }

        function getSelectedSpaces()
        {
            vm.selectedSpaces=vm.widget.graph.spaces;
        }

        function getMeasurements()
        {
            vm.peakFl=false;
            vm.lowFl=false;
            for (var i=0;i<vm.widget.graph.hours.length;i++)
            {
                if(vm.widget.graph.hours[i]==='peak')
                {
                    vm.peakFl=true;
                }
                if(vm.widget.graph.hours[i]==='low')
                {
                    vm.lowFl=true;
                }
            }
            var promises = [];
            if(vm.widget.graph.value==='occupancy')
            {
                for(var i=0;i<vm.widget.clients.length;i++)
                {
                    var dPost=
                    {
                        dates:vm.dates,
                        assignment:vm.widget.clients[i].device.token,
                        tenant:vm.widget.clients[i].tenant.token,
                        minutes:vm.resolutionMinutes
                    }
                    promises.push(pragmaapi.callRestService(vm.hubaUrl,"/occupancyPeak",dPost,false,"","POST",false,false))
                }
                $q.all(promises).then(function(resArray) {
                    for(var res=0;res<resArray.length;res++)
                    {
                        var measurements=resArray[res].data;
                        for (var i=0;i<Object.keys(measurements).length;i++)
                        {
                            for(var k=0;k< vm.selectedSpaces.length;k++)
                            {
                                if(Object.keys(measurements)[i]== vm.selectedSpaces[k])
                                {
                                    var tmp={};
                                    if(typeof vm.spaces[Object.keys(measurements)[i]]!=='undefined')
                                    {
                                        tmp['space']=vm.spaces[Object.keys(measurements)[i]];
                                    }
                                    else
                                    {
                                        tmp['space']=Object.keys(measurements)[i];
                                    }
                                    if(vm.peakFl)
                                    {
                                        var tmlcl=new Date(measurements[Object.keys(measurements)[i]]['occupancy']['peak']['timestamp']);
                                        tmlcl.setMinutes(tmlcl.getMinutes()+(vm.resolutionMinutes/2));
                                        tmp['peakClockTime']= Date.parse(tmlcl);
                                        tmp['peakHourStart']=measurements[Object.keys(measurements)[i]]['occupancy']['peak']['timestamp'];
                                        tmp['peakHourEnd']=new Date(measurements[Object.keys(measurements)[i]]['occupancy']['peak']['timestamp']);
                                        tmp['peakHourEnd'].setMinutes(tmp['peakHourEnd'].getMinutes()+vm.resolutionMinutes);
                                        tmp['peakValue']=measurements[Object.keys(measurements)[i]]['occupancy']['peak']['value'];
                                    }
                                    if(vm.lowFl)
                                    {
                                        var tmlcl=new Date(measurements[Object.keys(measurements)[i]]['occupancy']['low']['timestamp']);
                                        tmlcl.setMinutes(tmlcl.getMinutes()+(vm.resolutionMinutes/2));
                                        tmp['lowClockTime']= Date.parse(tmlcl);
                                        tmp['lowHourStart']=measurements[Object.keys(measurements)[i]]['occupancy']['low']['timestamp'];
                                        tmp['lowHourEnd']=new Date(measurements[Object.keys(measurements)[i]]['occupancy']['low']['timestamp']);
                                        tmp['lowHourEnd'].setMinutes(tmp['lowHourEnd'].getMinutes()+vm.resolutionMinutes);
                                        tmp['lowValue']=measurements[Object.keys(measurements)[i]]['occupancy']['low']['value'];
                                    }
                                    tmp['type']='occupancy';
                                    vm.numericResults.push(tmp);
                                }
                            }
                        }
                    }
                    if(vm.numericResults.length==1 && vm.widget.graph.hours.length==1)
                    {
                        vm.mode='numeric';
                    }
                    else
                    {
                        vm.table.limitOptions = [5, 10, 15, {
                            label: 'All',
                            value: function () {
                                return vm.numericResults.length ? vm.numericResults.length : 0;
                            }
                        }];
                        vm.table.options = {
                            rowSelection: false,
                            multiSelect: false,
                            autoSelect: false,
                            decapitate: false,
                            largeEditDialog: false,
                            boundaryLinks: false,
                            limitSelect: true,
                            pageSelect: true
                        };
                        vm.table.query = {
                            order: 'space',
                            limit: 10,
                            page: 1
                        };
                        vm.table.filter = {
                            search: ''
                        };
                    }
                });
            }
            else
            {
                for(var i=0;i<vm.widget.clients.length;i++)
                {
                    var dPost=
                    {
                        dates:vm.dates,
                        assignment:vm.widget.clients[i].device.token,
                        tenant:vm.widget.clients[i].tenant.token,
                        minutes:vm.resolutionMinutes
                    }
                    promises.push(pragmaapi.callRestService(vm.hubaUrl,"/entriesExitsPeak",dPost,false,"","POST",false,false))
                }
                $q.all(promises).then(function(resArray) {
                    for(var res=0;res<resArray.length;res++)
                    {
                        var measurements=resArray[res].data;
                        for (var i=0;i<Object.keys(measurements).length;i++)
                        {
                            for(var k=0;k<vm.selectedSpaces.length;k++)
                            {
                                if(Object.keys(measurements)[i]==vm.selectedSpaces[k])
                                {
                                    for (var l=0;l<vm.widget.graph.values.length;l++)
                                    {
                                        var tmp={};
                                        if(typeof vm.spaces[Object.keys(measurements)[i]]!=='undefined')
                                        {
                                            tmp['space']=vm.spaces[Object.keys(measurements)[i]];
                                        }
                                        else
                                        {
                                            tmp['space']=Object.keys(measurements)[i];
                                        }
                                        if(vm.peakFl)
                                        {
                                            var tmlcl=new Date(new Date(measurements[Object.keys(measurements)[i]][vm.widget.graph.values[l]]['peak']['timestamp']));
                                            tmlcl.setMinutes(tmlcl.getMinutes()+(vm.resolutionMinutes/2));
                                            tmp['peakClockTime']= Date.parse(tmlcl);
                                            tmp['peakHourStart']=measurements[Object.keys(measurements)[i]][vm.widget.graph.values[l]]['peak']['timestamp'];
                                            tmp['peakHourEnd']=new Date(measurements[Object.keys(measurements)[i]][vm.widget.graph.values[l]]['peak']['timestamp']);
                                            tmp['peakHourEnd'].setMinutes(tmp['peakHourEnd'].getMinutes()+vm.resolutionMinutes);
                                            tmp['peakValue']=measurements[Object.keys(measurements)[i]][vm.widget.graph.values[l]]['peak']['value'];
                                        }
                                        if(vm.lowFl)
                                        {
                                            var tmlcl=new Date(new Date(measurements[Object.keys(measurements)[i]][vm.widget.graph.values[l]]['low']['timestamp']));
                                            tmlcl.setMinutes(tmlcl.getMinutes()+(vm.resolutionMinutes/2));
                                            tmp['lowClockTime']= Date.parse(tmlcl);
                                            tmp['lowHourStart']=measurements[Object.keys(measurements)[i]][vm.widget.graph.values[l]]['low']['timestamp'];
                                            tmp['lowHourEnd']=new Date(measurements[Object.keys(measurements)[i]][vm.widget.graph.values[l]]['low']['timestamp']);
                                            tmp['lowHourEnd'].setMinutes(tmp['lowHourEnd'].getMinutes()+vm.resolutionMinutes);
                                            tmp['lowValue']=measurements[Object.keys(measurements)[i]][vm.widget.graph.values[l]]['low']['value'];
                                        }
                                        tmp['type']=vm.widget.graph.values[l];
                                        vm.numericResults.push(tmp);
                                    }   
                                }
                            }
                        }
                    }
                    if(vm.numericResults.length==1 && vm.widget.graph.hours.length==1)
                    {
                        vm.mode='numeric';
                    }
                    else
                    {
                        vm.table.limitOptions = [5, 10, 15, {
                            label: 'All',
                            value: function () {
                                return vm.numericResults.length ? vm.numericResults.length : 0;
                            }
                        }];
                        vm.table.options = {
                            rowSelection: false,
                            multiSelect: false,
                            autoSelect: false,
                            decapitate: false,
                            largeEditDialog: false,
                            boundaryLinks: false,
                            limitSelect: true,
                            pageSelect: true
                        };
                        vm.table.query = {
                            order: 'space',
                            limit: 10,
                            page: 1
                        };
                        vm.table.filter = {
                            search: ''
                        };
                    }
                    vm.triggered=true;
                });
            }
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('hubaHours', hubaHours);

    function hubaHours() {
        var directive = {
            templateUrl:"app/directives/hubaHours/hubaHours.html",
            controller: HubaHoursController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }

    /** @ngInject */
    function HubaHoursController ($scope,session,PRAGMA,pragmaapi,pragmaTheming,$q) {
        var vm =this;
        vm.plotId=generateUUID();
        vm.widget=$scope.widget;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        vm.hubaUrl=PRAGMA.huba;
        vm.triggered=false;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.gridLinesColor="#d5d5d5";
        }
        else
        {
            vm.gridLinesColor="#e7e7e7";
        }
        vm.colors=
        [
        "rgb(3,169,244)",
        "rgb(146,39,143)",
        "rgb(170,198,6)",
        "rgb(242,135,6)",
        "rgb(191, 0, 255)",
        "rgb(0,191,118)",
        "rgb(102,45,145)",
        "rgb(236,0,140)",
        "rgb(0,148,68)",
        "rgb(249,237,50)",
        "rgb(239,65,54)"
        ];
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom")
                {
                    fillWidget();
                }
            }
        });
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today")
            {
                fillWidgetMqtt(args);
            } 
        });
        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        fillWidget();
        function fillWidget()
        {
            vm.triggered=false;
            vm.numericResults=[];
            vm.spaces={};
            vm.selectedSpaces=[];
            if(vm.widget.dates[0].date==="custom")
            {
                vm.dates=$scope.dashboardDate;
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            vm.options=
            {
                colors:vm.colors,
                timeline: { colorByRowLabel: true },
                backgroundColor: vm.gridLinesColor
            }
            getAllSpaces();
            getSelectedSpaces();
            getMeasurements();
        }

        function getMeasurements()
        {
            var promises = [];
            for(var i=0;i<vm.widget.clients.length;i++)
            {
                var dPost=
                {
                    dates:vm.dates,
                    assignment:vm.widget.clients[i].device.token,
                    tenant:vm.widget.clients[i].tenant.token
                }
                promises.push(pragmaapi.callRestService(vm.hubaUrl,"/occupancyHours",dPost,false,"","POST",false,false))
            }
            $q.all(promises).then(function(resArray) {
               for(var res=0;res<resArray.length;res++)
               {
                    var measurements=resArray[res].data;
                    for (var i=0;i<Object.keys(measurements).length;i++)
                    {
                        for(var k=0;k<vm.selectedSpaces.length;k++)
                        {
                            if(Object.keys(measurements)[i]==vm.selectedSpaces[k])
                            {
                                if(typeof vm.spaces[Object.keys(measurements)[i]]!=='undefined')
                                {
                                    vm.numericResults[vm.spaces[Object.keys(measurements)[i]]]=measurements[Object.keys(measurements)[i]];
                                }
                                else
                                {
                                    vm.numericResults[Object.keys(measurements)[i]]=measurements[Object.keys(measurements)[i]];
                                }
                            }
                        }
                    }
               }
               vm.triggered=true;
                google.charts.load('current', {'packages':['timeline']});
                google.charts.setOnLoadCallback(drawChart);
            });
            
        }

        function drawChart()
        {
            var container = document.getElementById(vm.plotId);
            var chart = new google.visualization.Timeline(container);
            var dataTable = new google.visualization.DataTable();
            dataTable.addColumn({ type: 'string', id: 'Occupancy' });
            dataTable.addColumn({ type: 'date', id: 'Start' });
            dataTable.addColumn({ type: 'date', id: 'End' });
            var arrayOfHours=[];
            for(var i=0;i<Object.keys(vm.numericResults).length;i++)
            {
                for(var k=0;k<vm.numericResults[Object.keys(vm.numericResults)[i]]['hours'].length;k++)
                {
                    if(vm.numericResults[Object.keys(vm.numericResults)[i]]['hours'][k]['value']==1)
                    {
                        var fr=new Date(vm.numericResults[Object.keys(vm.numericResults)[i]]['hours'][k]['from'])
                        var to=new Date(vm.numericResults[Object.keys(vm.numericResults)[i]]['hours'][k]['to'])
                        var tmpArray=[Object.keys(vm.numericResults)[i],fr,to];
                        arrayOfHours.push(tmpArray)
                    }
                }
            }
            dataTable.addRows(arrayOfHours);
            chart.draw(dataTable,vm.options);
        }

        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        }

        function getAllSpaces()
        {
            for(var i=0;i<vm.widget.clients.length;i++)
            {
                var tmp=JSON.parse(vm.widget.clients[i].device.metadata)
                var sp=JSON.parse(tmp.spaces)
                for(var j=0;j<Object.keys(sp).length;j++)
                {
                    vm.spaces[Object.keys(sp)[j]]=sp[Object.keys(sp)[j]]
                }
            }
        }

        function getSelectedSpaces()
        {
            vm.selectedSpaces=vm.widget.graph.spaces;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('haOven', haOven)

    function haOven() {
        var directive = {
            templateUrl:"app/directives/ha-oven/ha-oven.html",
            controller: HaOvenController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
				widget: "=",
				dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function HaOvenController ($scope,$rootScope,$filter,$translate,$http,session,PRAGMA,$base64,pragmaapi,$cookies,$mdDialog,$document,pragmaTheming) {
		var vm = this;
		
		vm.widget = $scope.widget;
		
		vm.user = session.getUser();
		vm.assignment = '6a3376db-69e9-4a09-8f47-3dad54925f7f';
		vm.consup_token = '67ade86d-deea-40a9-84e9-d16c968fedc9';
		vm.tenant = '0817e7f4-f555-4b5c-9ae5-69b460b7b15d';
		var fillWidgetIsRunning=false;
		vm.user.authentication = vm.user.username + ":" + vm.user.password;
		vm.url = PRAGMA.api;
		var myTimeout=null;
		vm.server_url = PRAGMA.appliancesUrl;
		vm.haid = 'SIEMENS-HM638GRS6-68A40E02CD22';
		vm.CheckState = CheckState;
		vm.CheckSlideClass = CheckSlideClass;
		vm.SelectProgram = SelectProgram;
		vm.StopProgram = StopProgram;
		$scope.selectedProg = null;
		vm.ChangePowerState = ChangePowerState;
		vm.evaluate = evaluate;
		vm.selectedClick = selectedClick;
		vm.unselected = '';
		vm.oven={};
		
		translateOptions();
		
        // Theming
        
		vm.themes = pragmaTheming.themes;
		var isDark = (vm.themes.active.name.indexOf('Dark') >= 0);
		if (isDark) {
			switch (vm.themes.active.name) {
				case 'Dark-Blue':
					vm.unselected = 'unselected-Dark-Blue';
				break;
				case 'Dark-Night':
					vm.unselected = 'unselected-Dark-Night';
				break;
				case 'Dark-Purple':
					vm.unselected = 'unselected-Dark-Purple';
				break;
				default:
					vm.unselected = 'unselected-dark';
			}
		}
		else {
			vm.unselected = 'unselected';
		}
		
        vm.options = {
            visible: 3,
            perspective: 35,
            startSlide: 0,
            border: 1,
            dir: 'ltr',
            width: 250,
            height: 180,
            space: 130,
            loop: true,
			controls: true
        };
		
        $scope.$on('new.measurement.broadcast', function(event, args) {
			fillWidgetMqtt(args);
			
        });
		
        function fillWidgetMqtt(device)
        {
                if(device.deviceAssignmentToken===vm.assignment)
                {
					setTimeout(fillWidget,3000);
                }
                else if(device.deviceAssignmentToken===vm.consup_token)
                {
					getConsumption();
                }
         }
		
		function translateOptions(){
			vm.dState = {
				'2':$filter('translate')("DASHBOARD.WIDGET.DOOR_LOCKED"),
				'1':$filter('translate')("DASHBOARD.WIDGET.DOOR_OPEN"),
				'0':$filter('translate')("DASHBOARD.WIDGET.DOOR_CLOSED"),
			};
			
			//PreHeating not yet supported
			vm.Progs = {
				/*'PreHeating' : {
							name : $filter('translate')("DASHBOARD.WIDGET.PREHEATING"),
							icon : 'pragma-icon-oven-preheating',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.PREHEATING")
						  },*/
				'HotAir' : {
							name : $filter('translate')("DASHBOARD.WIDGET.HOTAIR"),
							icon : 'pragma-icon-oven-hot-air',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.HOTAIR"),
							style : {
										"padding" : "2px 0 0 6px"
							}
						  },
				'TopBottomHeating' : {
							name : $filter('translate')("DASHBOARD.WIDGET.TOPBOTTOM"),
							icon : "pragma-icon-oven-top-bottom-heating",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.TOPBOTTOM"),
							style : {
										"padding" : "2px 0 0 6px"
							}
						  },
				'PizzaSetting' : {
							name : $filter('translate')("DASHBOARD.WIDGET.PIZZASETTING"),
							icon : "pragma-icon-oven-pizza-setting",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.PIZZASETTING"),
							style : {
										"padding" : "2px 0 0 6px"
							}
						  }
			};
			
			//Use array of objects to create the slides for the carousel
			vm.slides = [
							{
							key : "HotAir",
							name : $filter('translate')("DASHBOARD.WIDGET.HOTAIR"),
							icon : 'pragma-icon-oven-hot-air',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.HOTAIR"),
							style : {
										"padding" : "2px 0 0 6px"
									}
							},
							{
							key: "TopBottomHeating",
							name : $filter('translate')("DASHBOARD.WIDGET.TOPBOTTOM"),
							icon : "pragma-icon-oven-top-bottom-heating",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.TOPBOTTOM"),
							style : {
										"padding" : "2px 0 0 6px"
									}
							},
							{
							key : "PizzaSetting",
							name : $filter('translate')("DASHBOARD.WIDGET.PIZZASETTING"),
							icon : "pragma-icon-oven-pizza-setting",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.PIZZASETTING"),
							style : {
										"padding" : "2px 0 0 6px"
									}
							}
			];
		}
		
		$rootScope.$on('$translateChangeSuccess', function () {
			translateOptions();
		});
		
		fillWidget();
		function fillWidget() {
            if(!fillWidgetIsRunning)
            {
                if(myTimeout!==null)
                {
                    clearTimeout(myTimeout);
                    myTimeout=null;
                }
                fillWidgetIsRunning=true;
				getMeasurementsCustom();
			}
			else {
				myTimeout=setTimeout(fillWidget,3000);
			}
		}
		
		function getMeasurementsCustom() {
			pragmaapi.callRestService(vm.url,"/assignments/"+vm.assignment+"/measurements/lastValue","?tenantAuthToken="+vm.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
				console.log(res.data);
				vm.oven = res.data;
				//vm.oven.operationState='Run';
				//vm.oven.elapseTime = 1500;
				//vm.oven.progress = 100;
				//vm.oven.program = 'PizzaSetting';
				vm.oven.elapseTime = Math.floor(vm.oven.elapseTime/60);
				vm.oven.duration = Math.floor(vm.oven.duration/60);
				vm.oven.remainingProgramTime = Math.floor(vm.oven.remainingProgramTime/60);
				fillWidgetIsRunning=false;
				
				if (vm.oven.powerState === 0) {
					vm.oven.powerState = false;
				}
				else {
					vm.oven.powerState = true;
				}
				if (vm.oven.operationState === 'Ready' && vm.oven.program !== '') {
					$scope.selectedProg = vm.oven.program;
					vm.disStart = true;
				}
				else if (vm.oven.operationState === 'Run' || vm.oven.operationState === 'DelayedStart') {
					$scope.selectedProg = vm.oven.program;
					vm.disStart = false;
				}
				else {
					vm.disStart = true;
				}
			}).then(function(res){
				getConsumption();
			});
			
			/*vm.oven.program='Auto2';
			vm.oven.operationState='Run';
			vm.oven.remainingProgramTime=590.0;
			vm.oven.elapseTime = Math.floor(vm.oven.elapseTime/60);
			vm.oven.progress=88.0;
			vm.oven.doorState=0.0;*/
			
		}
		
		function getConsumption() {
			pragmaapi.callRestService(vm.url,"/assignments/"+vm.consup_token+"/measurements/lastValue","?measuredParameter=W_L&tenantAuthToken="+vm.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
				vm.oven.consumption = res.data.W_L.toFixed(2);
			});
		}
		
		$scope.doOptionsAction = function(ev, program, duration, temp) {
            $mdDialog.show({
                controller         : 'OvenOptionsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/directives/ha-oven/dialogs/Options/options.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    program:program,
					duration:duration,
					temp:temp
                }
            }).then(function (answer)
            {		
               var duration = 0;
               var temperature = 0;
			   duration += answer.secs;
			   duration += answer.mins*60;
			   duration += answer.hours*3600;
			   temperature += answer.temp;
			   if (vm.oven.operationState === 'Ready' && vm.oven.program !== '') {
					var prog_key = "Cooking.Oven.Program.HeatingMode."+answer.key;
					var jsonData = {
					  data: {
						key: prog_key,
						options: [
							{
								key: "BSH.Common.Option.Duration",
								value: duration
							},
							{
								key: "Cooking.Oven.Option.SetpointTemperature",
								value: temperature
							}
						]
					  }
					};
					
				pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/programs/active", JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
				});
			   }
			   /*callRestService(vm.url,"/assets/categories/"+answer.id+"?tenantAuthToken="+vm.sitesTenant,answer,true,vm.user.authentication,"PUT").then(function(res){
                    fillAssetsTable(vm.sitesTenant);
                    showNotification("Asset Category Notification","Asset Category Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Asset Category Notification","Something Went Wrong!","Error");
                });*/
            },function () {});
		};
		
		$scope.doInfoAction = function(ev, program) {
            $mdDialog.show({
                controller         : 'OvenInfoController',
                controllerAs       : 'vm',
                templateUrl        : 'app/directives/ha-oven/dialogs/Info/info.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    program:program
                }
            });
		};
		
		function CheckState(prog) {
			if (vm.oven.powerState) {
				if (vm.oven.operationState === 'Ready') {
					if ($scope.selectedProg != prog) {
						$scope.selectedProg = prog;
						SelectProgram(prog);
					}
				}
			}
			else {
				$scope.selectedProg = null;
			}
		}
		
		function SelectProgram(prog) {
			var prog_key = "Cooking.Oven.Program.HeatingMode."+prog;
			var jsonData = {
			  data: {
				key: prog_key,
				options: []
			  }
			};
            pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/programs/selected", JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
				//vm.disStart = false;
			});
			
		}
		
		function StopProgram() {
			
            pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/programs/active", '', false, vm.user.authentication, "DELETE", true, false).then(function(res){
			});
			
		}
		
		function ChangePowerState(power) {
			var valuekey = '';
			if (power) {
				valuekey = "BSH.Common.EnumType.PowerState.On";
			}
			else {
				valuekey = "BSH.Common.EnumType.PowerState.Standby";
			}
			var statekey = "BSH.Common.Setting.PowerState";
			var jsonData = {
			  data: {
				key: statekey,
				value: valuekey
			  }
			};
			
			pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/settings/"+statekey, JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
			});
			
		}
		
		function evaluate(){
			if (vm.oven.operationState === 'Aborting' || vm.oven.operationState === 'Disconnected') {
				return false;
			}
			else {
				return true;
			}
		}
		function CheckSlideClass(prog){
			if ($scope.selectedProg === prog) {
				return 'selectedProg';
			}
			else {
				return vm.unselected;
			}
		}
		function selectedClick(index){
			CheckState(vm.slides[index].key);
		}
	}
	

	
})();

(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('haLaundry', haLaundry)

    function haLaundry() {
        var directive = {
            templateUrl:"app/directives/ha-laundry/ha-laundry.html",
            controller: HaLaundryController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
				widget: "=",
				dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function HaLaundryController ($scope,$rootScope,$filter,$translate,$http,session,PRAGMA,$base64,pragmaapi,$cookies,$mdDialog,$document,pragmaTheming) {
		var vm = this;
		
		vm.widget = $scope.widget;
		
		vm.user = session.getUser();
		vm.assignment = 'ead9fd95-1beb-4da6-aa65-f717a09e33e3';
		vm.consup_token = 'b2605c01-b712-443f-b50b-d54e735de9ba';
		vm.tenant = '0817e7f4-f555-4b5c-9ae5-69b460b7b15d';
		var fillWidgetIsRunning=false;
		vm.user.authentication = vm.user.username + ":" + vm.user.password;
		vm.url = PRAGMA.api;
		var myTimeout=null;
		vm.server_url = PRAGMA.appliancesUrl;
		vm.haid = 'SIEMENS-WM16W6H0EU-68A40E0274B5';
		vm.CheckState = CheckState;
		vm.CheckSlideClass = CheckSlideClass;
		vm.SelectProgram = SelectProgram;
		vm.StopProgram = StopProgram;
		$scope.selectedProg = null;
		vm.ChangePowerState = ChangePowerState;
		vm.evaluate = evaluate;
		vm.selectedClick = selectedClick;
		vm.unselected = '';
		vm.laundry={};
		
		translateOptions();
		
        // Theming
        
		vm.themes = pragmaTheming.themes;
		var isDark = (vm.themes.active.name.indexOf('Dark') >= 0);
		if (isDark) {
			switch (vm.themes.active.name) {
				case 'Dark-Blue':
					vm.unselected = 'unselected-Dark-Blue';
				break;
				case 'Dark-Night':
					vm.unselected = 'unselected-Dark-Night';
				break;
				case 'Dark-Purple':
					vm.unselected = 'unselected-Dark-Purple';
				break;
				default:
					vm.unselected = 'unselected-dark';
			}
		}
		else {
			vm.unselected = 'unselected';
		}
		
        vm.options = {
            visible: 3,
            perspective: 35,
            startSlide: 0,
            border: 1,
            dir: 'ltr',
            width: 250,
            height: 180,
            space: 130,
            loop: true,
			controls: true
        };
		
        $scope.$on('new.measurement.broadcast', function(event, args) {
			fillWidgetMqtt(args);
			
        });
		
        function fillWidgetMqtt(device)
        {
                if(device.deviceAssignmentToken===vm.assignment)
                {
					setTimeout(fillWidget,3000);
                }
                else if(device.deviceAssignmentToken===vm.consup_token)
                {
					getConsumption();
                }
         }
		
		function translateOptions(){
			vm.dState = {
				'2':$filter('translate')("DASHBOARD.WIDGET.DOOR_LOCKED"),
				'1':$filter('translate')("DASHBOARD.WIDGET.DOOR_OPEN"),
				'0':$filter('translate')("DASHBOARD.WIDGET.DOOR_CLOSED"),
			};
			vm.Progs = {
				'Cotton' : {
							name : $filter('translate')("DASHBOARD.WIDGET.COTTON"),
							icon : 'pragma-icon-washer-cottons',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.COTTON2"),
							style : {
										"padding" : "2px 0 0 0"
							}
						  },
				'EasyCare' : {
							name : $filter('translate')("DASHBOARD.WIDGET.EASYCARE"),
							icon : 'pragma-icon-washer-easycare',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.EASYCARE"),
							style : {
										"padding" : "0 0 0 0"
							}
						  },
				'Mix' : {
							name : $filter('translate')("DASHBOARD.WIDGET.MIX"),
							icon : "pragma-icon-washer-mixedfabrics",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.MIX2"),
							style : {
										"padding" : "0 0 0 2px"
							}
						  },
				'DelicatesSilk' : {
							name : $filter('translate')("DASHBOARD.WIDGET.SILK"),
							icon : "pragma-icon-washer-silk",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.SILK"),
							style : {
										"padding" : "0 0 0 6px"
							}
						  },
				'Wool' : {
							name : $filter('translate')("DASHBOARD.WIDGET.WOOL"),
							icon : "pragma-icon-washer-wool",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.WOOL"),
							style : {
										"padding" : "0"
							}
						  }

			};
			
			//Use array of objects to create the slides for the carousel
			vm.slides = [
							{
							key : "Cotton",
							name : $filter('translate')("DASHBOARD.WIDGET.COTTON"),
							icon : 'pragma-icon-washer-cottons',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.COTTON2"),
							style : {
										"padding" : "2px 0 0 0"
									}
							},
							{
							key: "EasyCare",
							name : $filter('translate')("DASHBOARD.WIDGET.EASYCARE"),
							icon : 'pragma-icon-washer-easycare',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.EASYCARE"),
							style : {
										"padding" : "0 0 0 0"
									}
							},
							{
							key : "Mix",
							name : $filter('translate')("DASHBOARD.WIDGET.MIX"),
							icon : "pragma-icon-washer-mixedfabrics",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.MIX2"),
							style : {
										"padding" : "0 0 0 2px"
									}
							},
							{
							key : "DelicatesSilk",
							name : $filter('translate')("DASHBOARD.WIDGET.SILK"),
							icon : "pragma-icon-washer-silk",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.SILK"),
							style : {
										"padding" : "0 0 0 6px"
									}
							},
							{
							key : "Wool",
							name : $filter('translate')("DASHBOARD.WIDGET.WOOL"),
							icon : "pragma-icon-washer-wool",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.WOOL"),
							style : {
										"padding" : "0"
									}
							}
			];
		}
		
		$rootScope.$on('$translateChangeSuccess', function () {
			translateOptions();
		});
		
		fillWidget();
		function fillWidget() {
            if(!fillWidgetIsRunning)
            {
                if(myTimeout!==null)
                {
                    clearTimeout(myTimeout);
                    myTimeout=null;
                }
                fillWidgetIsRunning=true;
				getMeasurementsCustom();
			}
			else {
				myTimeout=setTimeout(fillWidget,3000);
			}
		}
		
		function getMeasurementsCustom() {
			pragmaapi.callRestService(vm.url,"/assignments/"+vm.assignment+"/measurements/lastValue","?tenantAuthToken="+vm.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
				vm.laundry = res.data;
				//vm.laundry.operationState='Run';
				//vm.laundry.remainingProgramTime = 1500;
				//vm.laundry.progress = 100;
				//vm.laundry.program = 'Cotton';
				vm.laundry.remainingProgramTime = Math.floor(vm.laundry.remainingProgramTime/60);
				fillWidgetIsRunning=false;
				
				if (vm.laundry.powerState === 0) {
					vm.laundry.powerState = false;
				}
				else {
					vm.laundry.powerState = true;
				}
				if (vm.laundry.operationState === 'Ready' && vm.laundry.program !== '') {
					$scope.selectedProg = vm.laundry.program;
					vm.disStart = true;
				}
				else if (vm.laundry.operationState === 'Run' || vm.laundry.operationState === 'DelayedStart') {
					$scope.selectedProg = vm.laundry.program;
					vm.disStart = false;
				}
				else {
					vm.disStart = true;
				}
			}).then(function(res){
				getConsumption();
			});
			
			/*vm.laundry.program='Auto2';
			vm.laundry.operationState='Run';
			vm.laundry.remainingProgramTime=590.0;
			vm.laundry.remainingProgramTime = Math.floor(vm.laundry.remainingProgramTime/60);
			vm.laundry.progress=88.0;
			vm.laundry.doorState=0.0;*/
			
		}
		
		function getConsumption() {
			pragmaapi.callRestService(vm.url,"/assignments/"+vm.consup_token+"/measurements/lastValue","?measuredParameter=consumption&tenantAuthToken="+vm.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
				vm.laundry.consumption = res.data.consumption.toFixed(2);
			});
		}
		
		$scope.doOptionsAction = function(ev, temp, speed, program) {
            $mdDialog.show({
                controller         : 'LaundryOptionsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/directives/ha-laundry/dialogs/Options/options.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    program:program,
					temp:temp,
					speed:speed
                }
            }).then(function (answer)
            {		
			   if (vm.laundry.operationState === 'Ready' && vm.laundry.program !== '') {
					var prog_key = "LaundryCare.Washer.Program."+answer.key;
					var temp_val = '';
					var speed_val = '';
					if (answer.temperature === 0) {
						temp_val = 'Cold';
					}
					else {
						temp_val = 'GC'+answer.temperature;
					}
					if (answer.rpm === 0) {
						speed_val = 'Off';
					}
					else {
						speed_val = 'RPM'+answer.rpm;
					}
					var jsonData = {
					  data: {
						key: prog_key,
						options: [
							{
								key: "LaundryCare.Washer.Option.Temperature",
								value: "LaundryCare.Washer.EnumType.Temperature."+temp_val
							},
							{
								key: "LaundryCare.Washer.Option.SpinSpeed",
								value: "LaundryCare.Washer.EnumType.SpinSpeed."+speed_val
							}
						]
					  }
					};
					pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/programs/active", JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
					});
			   }
			   /*callRestService(vm.url,"/assets/categories/"+answer.id+"?tenantAuthToken="+vm.sitesTenant,answer,true,vm.user.authentication,"PUT").then(function(res){
                    fillAssetsTable(vm.sitesTenant);
                    showNotification("Asset Category Notification","Asset Category Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Asset Category Notification","Something Went Wrong!","Error");
                });*/
            },function () {});
		};
		
		$scope.doInfoAction = function(ev, program) {
            $mdDialog.show({
                controller         : 'LaundryInfoController',
                controllerAs       : 'vm',
                templateUrl        : 'app/directives/ha-laundry/dialogs/Info/info.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    program:program
                }
            });
		};
		
		function CheckState(prog) {
			if (vm.laundry.powerState) {
				if (vm.laundry.operationState === 'Ready') {
					if ($scope.selectedProg != prog) {
						$scope.selectedProg = prog;
						SelectProgram(prog);
					}
				}
			}
			else {
				$scope.selectedProg = null;
			}
		}
		
		function SelectProgram(prog) {
			var prog_key = "LaundryCare.Washer.Program."+prog;
			var jsonData = {
			  data: {
				key: prog_key,
				options: []
			  }
			};
            pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/programs/selected", JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
				//vm.disStart = false;
			});
			
		}
		
		function StopProgram() {
			
            pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/programs/active", '', false, vm.user.authentication, "DELETE", true, false).then(function(res){
			});
			
		}
		
		function ChangePowerState(power) {
			var valuekey = '';
			if (power) {
				valuekey = "BSH.Common.EnumType.PowerState.On";
			}
			else {
				valuekey = "BSH.Common.EnumType.PowerState.Off";
			}
			var statekey = "BSH.Common.Setting.PowerState";
			var jsonData = {
			  data: {
				key: statekey,
				value: valuekey
			  }
			};
			
			pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/settings/"+statekey, JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
			});
			
		}
		
		function evaluate(){
			if (vm.laundry.operationState === 'Aborting' || vm.laundry.operationState === 'Disconnected') {
				return false;
			}
			else {
				return true;
			}
		}
		function CheckSlideClass(prog){
			if ($scope.selectedProg === prog) {
				return 'selectedProg';
			}
			else {
				return vm.unselected;
			}
		}
		function selectedClick(index){
			CheckState(vm.slides[index].key);
		}
	}
	

	
})();

(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('haFridge', haFridge)

    function haFridge() {
        var directive = {
            templateUrl:"app/directives/ha-fridge/ha-fridge.html",
            controller: HaFridgeController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
				widget: "=",
				dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function HaFridgeController ($scope,$rootScope,$filter,$translate,$http,session,PRAGMA,$base64,pragmaapi,$cookies) {
		var vm = this;
		
		vm.widget = $scope.widget;
		
		vm.user = session.getUser();
		vm.assignment = '6103a652-c734-4d7d-a4a9-6321749ca5b4';
		vm.consup_token = '7d4e8313-f362-481d-b030-1865c2c02b27';
		vm.tenant = '0817e7f4-f555-4b5c-9ae5-69b460b7b15d';
		vm.server_url = PRAGMA.appliancesUrl;
		vm.haid = 'SIEMENS-KG36NHI32-68A40E01EDFB';
		var fillWidgetIsRunning=false;
		var myTimeout=null;
		vm.user.authentication = vm.user.username + ":" + vm.user.password;
		vm.url = PRAGMA.api;
		vm.fridge = {};
		vm.ChangeInpState = ChangeInpState;
		vm.ChangeSuperState = ChangeSuperState;
		vm.FridgeShow = true;
		vm.FreezerShow = true;
		
		vm.Refrigeration=
		{
			fridge:
			{
				key:         'tempFridge',
				setkey:      'Refrigeration.FridgeFreezer.Setting.SetpointTemperatureRefrigerator',
				setsuperkey: 'Refrigeration.FridgeFreezer.Setting.SuperModeRefrigerator'
				
			},
			freezer:
			{
				key:         'tempFreezer',
				setkey:      'Refrigeration.FridgeFreezer.Setting.SetpointTemperatureFreezer',
				setsuperkey: 'Refrigeration.FridgeFreezer.Setting.SuperModeFreezer'
			}
		};
		
        $scope.$on('new.measurement.broadcast', function(event, args) {
			fillWidgetMqtt(args);
			
        });
		
        function fillWidgetMqtt(device)
        {
                if(device.deviceAssignmentToken===vm.assignment)
                {
					setTimeout(fillWidget,3000);
                }
                else if(device.deviceAssignmentToken===vm.consup_token)
                {
					getConsumption();
                }
         }
		
		function translateOptions(){
			vm.dState = {
				'1':$filter('translate')("DASHBOARD.WIDGET.DOOR_OPEN"),
				'0':$filter('translate')("DASHBOARD.WIDGET.DOOR_CLOSED")
			};
		}
		translateOptions()
		
		$rootScope.$on('$translateChangeSuccess', function () {
			translateOptions();
		});
		
		fillWidget();
		
		function fillWidget() {
            if(!fillWidgetIsRunning)
            {
                if(myTimeout!==null)
                {
                    clearTimeout(myTimeout);
                    myTimeout=null;
                }
                fillWidgetIsRunning=true;
				getMeasurementsCustom();
			}
			else {
				myTimeout=setTimeout(fillWidget,3000);
			}
		}
		
		function ChangeInpState(type, temp) {
			if (type==='fridge') {
				vm.FridgeShow = !vm.FridgeShow;
			}
			else {
				vm.FreezerShow = !vm.FreezerShow;
			}
			if (temp) {
				var jsonData = {
				  data: {
					key: vm.Refrigeration[type].setkey,
					value: temp
				  }
				};
				
				pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/settings/"+vm.Refrigeration[type].setkey, JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
				});
			}
		}
		
		function ChangeSuperState(type, Rvalue) {
			var jsonData = {
			  data: {
				key: vm.Refrigeration[type].setsuperkey,
				value: Rvalue
			  }
			};
			
			pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/settings/"+vm.Refrigeration[type].setsuperkey, JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
			});
		}
		
		function getMeasurementsCustom() {
			pragmaapi.callRestService(vm.url,"/assignments/"+vm.assignment+"/measurements/lastValue","?tenantAuthToken="+vm.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
				vm.fridge = res.data;
				fillWidgetIsRunning=false;
				
				if (vm.fridge.superModeRefrigerator === 0) {
					vm.fridge.superModeRefrigerator = false;
				}
				else {
					vm.fridge.superModeRefrigerator = true;
				}
				if (vm.fridge.superModeFreezer === 0) {
					vm.fridge.superModeFreezer = false;
				}
				else {
					vm.fridge.superModeFreezer = true;
				}
			}).then(function(res){
				getConsumption();
			});
			
			
		}
		function getConsumption() {
			pragmaapi.callRestService(vm.url,"/assignments/"+vm.consup_token+"/measurements/lastValue","?measuredParameter=consumption&tenantAuthToken="+vm.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
				vm.fridge.consumption = res.data.consumption.toFixed(2);
			});
		}
		
	}
	

	
})();

(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('haDryer', haDryer)

    function haDryer() {
        var directive = {
            templateUrl:"app/directives/ha-dryer/ha-dryer.html",
            controller: HaDryerController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
				widget: "=",
				dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function HaDryerController ($scope,$rootScope,$filter,$translate,$http,session,PRAGMA,$base64,pragmaapi,$cookies,$mdDialog,$document,pragmaTheming) {
		var vm = this;
		
		vm.widget = $scope.widget;
		
		vm.user = session.getUser();
		vm.assignment = '4a4fd1dd-0bb7-44e2-a9c7-d625ce4d8357';
		vm.consup_token = 'c234c1e0-28f8-4982-ac76-27ff1c4256f1';
		vm.tenant = '0817e7f4-f555-4b5c-9ae5-69b460b7b15d';
		var fillWidgetIsRunning=false;
		vm.user.authentication = vm.user.username + ":" + vm.user.password;
		vm.url = PRAGMA.api;
		var myTimeout=null;
		vm.server_url =  PRAGMA.appliancesUrl;
		vm.haid = 'SIEMENS-WT4HW569DN-68A40E032796';
		vm.CheckState = CheckState;
		vm.CheckSlideClass = CheckSlideClass;
		vm.SelectProgram = SelectProgram;
		vm.StopProgram = StopProgram;
		$scope.selectedProg = null;
		vm.ChangePowerState = ChangePowerState;
		vm.evaluate = evaluate;
		vm.selectedClick = selectedClick;
		vm.unselected = '';
		vm.dryer={};
		
		translateOptions();
		
        // Theming
        
		vm.themes = pragmaTheming.themes;
		var isDark = (vm.themes.active.name.indexOf('Dark') >= 0);
		if (isDark) {
			switch (vm.themes.active.name) {
				case 'Dark-Blue':
					vm.unselected = 'unselected-Dark-Blue';
				break;
				case 'Dark-Night':
					vm.unselected = 'unselected-Dark-Night';
				break;
				case 'Dark-Purple':
					vm.unselected = 'unselected-Dark-Purple';
				break;
				default:
					vm.unselected = 'unselected-dark';
			}
		}
		else {
			vm.unselected = 'unselected';
		}
		
        vm.options = {
            visible: 3,
            perspective: 35,
            startSlide: 0,
            border: 1,
            dir: 'ltr',
            width: 250,
            height: 180,
            space: 130,
            loop: true,
			controls: true
        };
		
        $scope.$on('new.measurement.broadcast', function(event, args) {
			fillWidgetMqtt(args);
			
        });
		
        function fillWidgetMqtt(device)
        {
                if(device.deviceAssignmentToken===vm.assignment)
                {
					setTimeout(fillWidget,3000);
                }
                else if(device.deviceAssignmentToken===vm.consup_token)
                {
					getConsumption();
                }
         }
		
		function translateOptions(){
			vm.dState = {
				'1':$filter('translate')("DASHBOARD.WIDGET.DOOR_OPEN"),
				'0':$filter('translate')("DASHBOARD.WIDGET.DOOR_CLOSED"),
			};
			vm.Progs = {
				'Cotton' : {
							name : $filter('translate')("DASHBOARD.WIDGET.COTTON"),
							icon : 'pragma-icon-dryer-cotton',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.COTTON"),
							style : {
										"padding-top" : "5px"
							}
						  },
				'Synthetic' : {
							name : $filter('translate')("DASHBOARD.WIDGET.SYNTHETIC"),
							icon : 'pragma-icon-dryer-synthetic',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.SYNTHETIC"),
							style : {
										"padding" : "0"
							}
						  },
				'Mix'   : {
							name : $filter('translate')("DASHBOARD.WIDGET.MIX"),
							icon : "pragma-icon-dryer-mix",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.MIX"),
							style : {
										"padding-top" : "5px"
							}
						  }

			};
			
			//Use array of objects to create the slides for the carousel
			vm.slides = [
							{
							key : "Cotton",
							name : $filter('translate')("DASHBOARD.WIDGET.COTTON"),
							icon : 'pragma-icon-dryer-cotton',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.COTTON"),
							style : {
										"padding-top" : "5px"
									}
							},
							{
							key: "Synthetic",
							name : $filter('translate')("DASHBOARD.WIDGET.SYNTHETIC"),
							icon : 'pragma-icon-dryer-synthetic',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.SYNTHETIC"),
							style : {
										"padding" : "0"
									}
							},
							{
							key : "Mix",
							name : $filter('translate')("DASHBOARD.WIDGET.MIX"),
							icon : "pragma-icon-dryer-mix",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.MIX"),
							style : {
										"padding-top" : "5px"
									}
							}
			];
		}
		
		$rootScope.$on('$translateChangeSuccess', function () {
			translateOptions();
		});
		
		fillWidget();
		function fillWidget() {
            if(!fillWidgetIsRunning)
            {
                if(myTimeout!==null)
                {
                    clearTimeout(myTimeout);
                    myTimeout=null;
                }
                fillWidgetIsRunning=true;
				getMeasurementsCustom();
			}
			else {
				myTimeout=setTimeout(fillWidget,3000);
			}
		}
		
		
		
		function getMeasurementsCustom() {
			pragmaapi.callRestService(vm.url,"/assignments/"+vm.assignment+"/measurements/lastValue","?tenantAuthToken="+vm.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
				vm.dryer = res.data;
				//vm.dryer.operationState='Run';
				//vm.dryer.remainingProgramTime = 1500;
				//vm.dryer.progress = 100;
				//vm.dryer.program = 'Synthetic';
				//vm.dryer.program = 'Mix';
				//vm.dryer.program = 'Cotton';
				vm.dryer.finishInRelative = Math.floor(vm.dryer.finishInRelative/60);
				vm.dryer.remainingProgramTime = Math.floor(vm.dryer.remainingProgramTime/60);
				fillWidgetIsRunning=false;
				
				if (vm.dryer.powerState === 0) {
					vm.dryer.powerState = false;
				}
				else {
					vm.dryer.powerState = true;
				}
				if (vm.dryer.operationState === 'Ready' && vm.dryer.program !== '') {
					$scope.selectedProg = vm.dryer.program;
					vm.disStart = true;
				}
				else if (vm.dryer.operationState === 'Run') {
					$scope.selectedProg = vm.dryer.program;
					vm.disStart = false;
				}
				else {
					vm.disStart = true;
				}
			}).then(function(res){
				getConsumption();
			});
		}
		
		function getConsumption() {
			pragmaapi.callRestService(vm.url,"/assignments/"+vm.consup_token+"/measurements/lastValue","?measuredParameter=consumption&tenantAuthToken="+vm.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
				vm.dryer.consumption = res.data.consumption.toFixed(2);
			});
		}
		
		$scope.doOptionsAction = function(ev, program, optkey) {
            $mdDialog.show({
                controller         : 'DryerOptionsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/directives/ha-dryer/dialogs/Options/options.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    program:program,
					optkey:optkey
                }
            }).then(function (answer)
            {		
			   if (vm.dryer.operationState === 'Ready' && vm.dryer.program !== '') {
					var prog_key = "LaundryCare.Dryer.Program."+answer.key;
					var jsonData = {
					  data: {
						key: prog_key,
						options: [
							{
								key: "LaundryCare.Dryer.Option.DryingTarget",
								value: "LaundryCare.Dryer.EnumType.DryingTarget."+answer.optkey
							}
						]
					  }
					};
					
				pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/programs/active", JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
				});
			   }
			   /*callRestService(vm.url,"/assets/categories/"+answer.id+"?tenantAuthToken="+vm.sitesTenant,answer,true,vm.user.authentication,"PUT").then(function(res){
                    fillAssetsTable(vm.sitesTenant);
                    showNotification("Asset Category Notification","Asset Category Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Asset Category Notification","Something Went Wrong!","Error");
                });*/
            },function () {});
		};
		
		$scope.doInfoAction = function(ev, program) {
            $mdDialog.show({
                controller         : 'DryerInfoController',
                controllerAs       : 'vm',
                templateUrl        : 'app/directives/ha-dryer/dialogs/Info/info.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    program:program
                }
            });
		};
		
		function CheckState(prog) {
			if (vm.dryer.powerState) {
				if (vm.dryer.operationState === 'Ready') {
					if ($scope.selectedProg != prog) {
						$scope.selectedProg = prog;
						SelectProgram(prog);
					}
				}
			}
			else {
				$scope.selectedProg = null;
			}
		}
		
		function SelectProgram(prog) {
			var prog_key = "LaundryCare.Dryer.Program."+prog;
			var jsonData = {
			  data: {
				key: prog_key,
				options: []
			  }
			};
            pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/programs/selected", JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
			});
			
		}
		
		function StopProgram() {
			
            pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/programs/active", '', false, vm.user.authentication, "DELETE", true, false).then(function(res){
			});
			
		}
		
		function ChangePowerState(power) {
			var valuekey = '';
			if (power) {
				valuekey = "BSH.Common.EnumType.PowerState.On";
			}
			else {
				valuekey = "BSH.Common.EnumType.PowerState.Off";
			}
			var statekey = "BSH.Common.Setting.PowerState";
			var jsonData = {
			  data: {
				key: statekey,
				value: valuekey
			  }
			};
			
			pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/settings/"+statekey, JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
			});
			
		}
		
		function evaluate(){
			if (vm.dryer.operationState === 'Aborting' || vm.dryer.operationState === 'Disconnected') {
				return false;
			}
			else {
				return true;
			}
		}
		function CheckSlideClass(prog){
			if ($scope.selectedProg === prog) {
				return 'selectedProg';
			}
			else {
				return vm.unselected;
			}
		}
		function selectedClick(index){
			CheckState(vm.slides[index].key);
		}
	}
	

	
})();

(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('haDishwasher', haDishwasher)

    function haDishwasher() {
        var directive = {
            templateUrl:"app/directives/ha-dishwasher/ha-dishwasher.html",
            controller: HaDishwasherController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
				widget: "=",
				dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function HaDishwasherController ($scope,$rootScope,$filter,$translate,$http,session,PRAGMA,$base64,pragmaapi,$cookies,$mdDialog,$document,pragmaTheming) {
		var vm = this;
		
		vm.widget = $scope.widget;
		
		vm.user = session.getUser();
		vm.assignment = '527353ae-698a-49ed-b7b4-547eaadd2ad2';
		vm.consup_token = 'e9210e17-a691-4bab-b878-69a278c185b9';
		vm.tenant = '0817e7f4-f555-4b5c-9ae5-69b460b7b15d';
		var fillWidgetIsRunning=false;
		vm.user.authentication = vm.user.username + ":" + vm.user.password;
		vm.url = PRAGMA.api;
		var myTimeout=null;
		vm.server_url = PRAGMA.appliancesUrl;
		vm.haid = 'SIEMENS-SN578S36TE-68A40E03D1B0';
		vm.CheckState = CheckState;
		vm.CheckSlideClass = CheckSlideClass;
		vm.SelectProgram = SelectProgram;
		vm.StartProgram = StartProgram;
		vm.StopProgram = StopProgram;
		$scope.selectedProg = null;
		vm.ChangePowerState = ChangePowerState;
		vm.evaluate = evaluate;
		vm.selectedClick = selectedClick;
		vm.unselected = '';
		vm.dishwasher={};
		
		translateOptions();
		
        // Theming
        
		vm.themes = pragmaTheming.themes;
		var isDark = (vm.themes.active.name.indexOf('Dark') >= 0);
		if (isDark) {
			switch (vm.themes.active.name) {
				case 'Dark-Blue':
					vm.unselected = 'unselected-Dark-Blue';
				break;
				case 'Dark-Night':
					vm.unselected = 'unselected-Dark-Night';
				break;
				case 'Dark-Purple':
					vm.unselected = 'unselected-Dark-Purple';
				break;
				default:
					vm.unselected = 'unselected-dark';
			}
		}
		else {
			vm.unselected = 'unselected';
		}
		
        vm.options = {
            visible: 3,
            perspective: 35,
            startSlide: 0,
            border: 1,
            dir: 'ltr',
            width: 250,
            height: 180,
            space: 130,
            loop: true,
			controls: true
        };
		
        $scope.$on('new.measurement.broadcast', function(event, args) {
			fillWidgetMqtt(args);
			
        });
		
        function fillWidgetMqtt(device)
        {
                if(device.deviceAssignmentToken===vm.assignment)
                {
					setTimeout(fillWidget,3000);
                }
                else if(device.deviceAssignmentToken===vm.consup_token)
                {
					getConsumption();
                }
         }
		
		
		
		function translateOptions(){
			vm.dState = {
				'1':$filter('translate')("DASHBOARD.WIDGET.DOOR_OPEN"),
				'0':$filter('translate')("DASHBOARD.WIDGET.DOOR_CLOSED"),
			};
			vm.Progs = {
				'Eco50' : {
							name : $filter('translate')("DASHBOARD.WIDGET.ECO50"),
							icon : 'pragma-icon-dishwasher-eco',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.ECO50"),
							style : ""
						  },
				'Auto2' : {
							name : $filter('translate')("DASHBOARD.WIDGET.AUTO2"),
							icon : 'pragma-icon-dishwasher-auto',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.AUTO2"),
							style : ""
						  },
				'Quick45' : {
							name : $filter('translate')("DASHBOARD.WIDGET.QUICK45"),
							icon : "pragma-icon-dishwasher-quick45",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.QUICK45"),
							style : {
										"padding-top" : "5px"
							}
						  }

			};
			
			//Use array of objects to create the slides for the carousel
			vm.slides = [
							{
							key : "Eco50",
							name : $filter('translate')("DASHBOARD.WIDGET.ECO50"),
							icon : 'pragma-icon-dishwasher-eco',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.ECO50"),
							style : ""
							},
							{
							key: "Auto2",
							name : $filter('translate')("DASHBOARD.WIDGET.AUTO2"),
							icon : 'pragma-icon-dishwasher-auto',
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.AUTO2"),
							style : ""
							},
							{
							key : "Quick45",
							name : $filter('translate')("DASHBOARD.WIDGET.QUICK45"),
							icon : "pragma-icon-dishwasher-quick45",
							descr : $filter('translate')("DASHBOARD.WIDGET.MESSAGE.QUICK45"),
							style : {
										"padding-top" : "5px"
									}
							}
			];
		}
		
		
		$rootScope.$on('$translateChangeSuccess', function () {
			translateOptions();
		});
		
		fillWidget();
		function fillWidget() {
            if(!fillWidgetIsRunning)
            {
                if(myTimeout!==null)
                {
                    clearTimeout(myTimeout);
                    myTimeout=null;
                }
                fillWidgetIsRunning=true;
				getMeasurementsCustom();
			}
			else {
				myTimeout=setTimeout(fillWidget,3000);
			}
		}
		
		function getMeasurementsCustom() {
			pragmaapi.callRestService(vm.url,"/assignments/"+vm.assignment+"/measurements/lastValue","?tenantAuthToken="+vm.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
				vm.dishwasher = res.data;
				//vm.dishwasher.operationState='Run';
				//vm.dishwasher.remainingProgramTime = 1500;
				//vm.dishwasher.startInRelative = 1500;
				//vm.dishwasher.progress = 100;
				//vm.dishwasher.program = 'Eco50';
				//vm.dishwasher.program = 'Auto2';
				//vm.dishwasher.program = 'Quick45';
				vm.dishwasher.remainingProgramTime = Math.floor(vm.dishwasher.remainingProgramTime/60);
				vm.dishwasher.startInRelative = Math.floor(vm.dishwasher.startInRelative/60);
				fillWidgetIsRunning=false;
				
				if (vm.dishwasher.powerState === 0) {
					vm.dishwasher.powerState = false;
				}
				else {
					vm.dishwasher.powerState = true;
				}
				if (vm.dishwasher.operationState === 'Ready' && vm.dishwasher.program !== '') {
					$scope.selectedProg = vm.dishwasher.program;
					vm.disStart = true;
				}
				else if (vm.dishwasher.operationState === 'Run' || vm.dishwasher.operationState === 'DelayedStart') {
					$scope.selectedProg = vm.dishwasher.program;
					vm.disStart = false;
				}
				else {
					vm.disStart = true;
				}
			}).then(function(res){
				getConsumption();
			});
			
			/*vm.dishwasher.program='Quick45';
			vm.dishwasher.operationState='Run';
			vm.dishwasher.remainingProgramTime=590.0;
			vm.dishwasher.remainingProgramTime = Math.floor(vm.dishwasher.remainingProgramTime/60);
			vm.dishwasher.progress=100.0;
			vm.dishwasher.doorState=0.0;*/
			
		}
		
		function getConsumption() {
			pragmaapi.callRestService(vm.url,"/assignments/"+vm.consup_token+"/measurements/lastValue","?measuredParameter=consumption&tenantAuthToken="+vm.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
				vm.dishwasher.consumption = res.data.consumption.toFixed(2);
			});
		}
		
		$scope.doOptionsAction = function(ev, program) {
            $mdDialog.show({
                controller         : 'OptionsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/directives/ha-dishwasher/dialogs/Options/options.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    program:program
                }
            }).then(function (answer)
            {		
               var startinrelative = 0;
			   startinrelative += answer.secs;
			   startinrelative += answer.mins*60;
			   startinrelative += answer.hours*3600;
			   if (vm.dishwasher.operationState === 'Ready' && vm.dishwasher.program !== '') {
					var prog_key = "Dishcare.Dishwasher.Program."+answer.key;
					var jsonData = {
					  data: {
						key: prog_key,
						options: [
							{
								key: "BSH.Common.Option.StartInRelative",
								value: startinrelative
							}
						]
					  }
					};
					
				pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/programs/active", JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
				});
			   }
			   /*callRestService(vm.url,"/assets/categories/"+answer.id+"?tenantAuthToken="+vm.sitesTenant,answer,true,vm.user.authentication,"PUT").then(function(res){
                    fillAssetsTable(vm.sitesTenant);
                    showNotification("Asset Category Notification","Asset Category Updated Successfully!","Success");
                },function(reason) {
                    showNotification("Asset Category Notification","Something Went Wrong!","Error");
                });*/
            },function () {});
		};
		
		$scope.doInfoAction = function(ev, program) {
            $mdDialog.show({
                controller         : 'InfoController',
                controllerAs       : 'vm',
                templateUrl        : 'app/directives/ha-dishwasher/dialogs/Info/info.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    event: ev,
                    program:program
                }
            });
		};
		
		function CheckState(prog) {
			if (vm.dishwasher.powerState) {
				if (vm.dishwasher.operationState === 'Ready') {
					if ($scope.selectedProg != prog) {
						$scope.selectedProg = prog;
						SelectProgram(prog);
					}
				}
			}
			else {
				$scope.selectedProg = null;
			}
		}
		
		function SelectProgram(prog) {
			var prog_key = "Dishcare.Dishwasher.Program."+prog;
			var jsonData = {
			  data: {
				key: prog_key,
				options: []
			  }
			};
            pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/programs/selected", JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
				//vm.disStart = false;
			});
			
		}
			
		function StartProgram() {
			/*if (vm.dishwasher.startInRelative) {
				var opt = {
					key: 'BSH.Common.Option.StartInRelative',
					value: 10
					}
			}*/
			var prog_key = "Dishcare.Dishwasher.Program."+$scope.selectedProg;
			var jsonData = {
			  data: {
				key: prog_key,
				options: [opt]
			  }
			};
			
            /*pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/programs/active", JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
			});*/
			
		}
		
		function StopProgram() {
			
            pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/programs/active", '', false, vm.user.authentication, "DELETE", true, false).then(function(res){
			});
			
		}
		
		function ChangePowerState(power) {
			var valuekey = '';
			if (power) {
				valuekey = "BSH.Common.EnumType.PowerState.On";
			}
			else {
				valuekey = "BSH.Common.EnumType.PowerState.Off";
			}
			var statekey = "BSH.Common.Setting.PowerState";
			var jsonData = {
			  data: {
				key: statekey,
				value: valuekey
			  }
			};
			
			pragmaapi.callRestService(vm.server_url, "/homeappliances/"+vm.haid+"/settings/"+statekey, JSON.stringify(jsonData), false, vm.user.authentication, "PUT", true, false).then(function(res){
			});
			
		}
		
		function evaluate(){
			if (vm.dishwasher.operationState === 'Aborting' || vm.dishwasher.operationState === 'Disconnected') {
				return false;
			}
			else {
				return true;
			}
		}	
		function CheckSlideClass(prog){
			if ($scope.selectedProg === prog) {
				return 'selectedProg';
			}
			else {
				return vm.unselected;
			}
		}
		function selectedClick(index){
			CheckState(vm.slides[index].key);
		}
	}
	

	
})();

(function () {
    'use strict';

    angular
        .module('app.directives')
        .directive('glucoseCard', glucoseCard);

    function glucoseCard() {
        var directive = {
            templateUrl: "app/directives/glucose-card/glucose-card.html",
            controller: GlucoseCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate: "="
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }

    /** @ngInject */
    function GlucoseCardController($rootScope, $scope, $http, $base64, $timeout, $q, session, pragmaapi, pragmaTheming, PRAGMA) {
        var vm = this;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);

        vm.widget = $scope.widget;
        vm.device = null;
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        vm.url = PRAGMA.api;
        vm.labelColor = "#6a6a6a"
        vm.dateColor="#6a6a6a";
        if (isDark) {
            vm.labelColor ="rgb(255,255,255)";
            vm.dateColor="rgb(255,255,255)";
        }

        activate();

        function activate() {
            fillWidget();

            $scope.$on('new.measurement.broadcast', function (event, args) {
                if (vm.device && vm.device.assignment === args.deviceAssignmentToken) {
                    $scope.$apply(function() {
                        if(args.measurements) {
                            for(var key in vm.device.measurements) {
                                if(args.measurements[key]!=undefined) {
                                    vm.device.measurements[key] = args.measurements[key];
                                }
                            }
                        }

                        if(args.eventDate) {
                            vm.device.measurements.timestamp = args.eventDate;
                        }
                    });
                }
            });
        }
        
        
        function fillWidget() {
            vm.clients = vm.widget.clients;
            vm.device = {};
            for (var i = 0; i < vm.clients.length; i++) {
                for (var j = 0; j < vm.clients[i].sites.length; j++) {
                    getDevicesCustom(vm.clients[i].token, vm.clients[i].sites[j])
                }
            }
        }

        function getDevicesCustom(tenant, site) {
            pragmaapi.callRestService(vm.url, "/devices/", "?site=" + site.token + "&page=1&pageSize=2000&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken=" + tenant, true, vm.user.authentication, "GET", true, false).then(function (res) {
                var devices = res.data.results;
                var centralMeter = null;
                for (var i = 0; i < devices.length; i++) {
                    for (var j = 0; j < site.assignments.length; j++) {
                        if (devices[i].assignment.token == site.assignments[j].token) {
                            centralMeter =
                                {
                                    "assignment": devices[i].assignment.token,
                                    "name": devices[i].metadata.name,
                                    "type": devices[i].metadata.type,
                                    "tenant": tenant,
                                    "specs": JSON.parse(devices[i].specification.metadata.specs),
                                    "binType": devices[i].metadata.binType
                                };
                            vm.device = centralMeter;
                            break;
                        }
                    }
                }
                getMeasurementsCustom(vm.device);
            });
        }

        function getMeasurementsCustom(centralMeter) {
            // pragmaapi.callRestService(vm.url, "/assignments/" + centralMeter.assignment + "/measurements/lastValue", "?tenantAuthToken=" + centralMeter.tenant, true, vm.user.authentication, "GET", true, false).then(function (res) {
            //     if(res.data) {
            //         centralMeter.measurements = res.data;
            //         console.log(JSON.stringify(centralMeter))
            //     }
            // });
            var promises = [
                pragmaapi.callRestService(vm.url, "/assignments/" + centralMeter.assignment + "/measurements/lastValue", "?measuredParameter=glucose&tenantAuthToken=" + centralMeter.tenant, true, vm.user.authentication, "GET", true, false),
                pragmaapi.callRestService(vm.url, "/assignments/" + centralMeter.assignment + "/measurements/lastValue", "?measuredParameter=glucoseType&tenantAuthToken=" + centralMeter.tenant, true, vm.user.authentication, "GET", true, false)
            ];

            $q.all(promises).then(function(resArray) {
                if(resArray && resArray.length){
                    centralMeter.measurements = {};

                    var i=0, l=resArray.length;
                    for(i;i<l;i++) {
                        var res = resArray[i];
                        if(res.data) {
                            for(var key in res.data) {
                                centralMeter.measurements[key] = res.data[key];
                            }
                        }
                    }
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('gaugeCard', gaugeCard);

    function gaugeCard() {
        var directive = {
            templateUrl:"app/directives/gauge-card/gauge-card.html",
            controller: GaugeCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function GaugeCardController ($scope,session,PRAGMA,pragmaapi,$q) {
        var vm =this;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.dates=[];
        vm.result=0;
        vm.totalMax=0;
        vm.unit="";
        vm.triggered=false;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        fillWidget();
        
        $scope.$watch(function() {
            
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom" && vm.widget.graph.type!=='lastValue')
                {
                    fillWidget();
                }
            }
        });

        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today" || vm.widget.graph.type==='lastValue')
            {
                fillWidgetMqtt(args);
            } 
        });

        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        function fillWidget()
        {
            vm.triggered=false;
            vm.totalMax=0;
            vm.max=0;
            vm.result=0;
            vm.tmpResults=[];
            vm.tmpResultsMax=[];
            if(vm.widget.dates[0].date==="custom")
            {
                vm.dates=$scope.dashboardDate;
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            getMeasurements();
            if (vm.widget.graph.maximumType)
            {
                getMeasurementsMax();
            }
            else
            {
                vm.max=vm.widget.graph.maximumValue;
                if(vm.widget.graph.graphType==='pue')
                {
                    calculatePue();
                }
            }
        }
       
        function getMeasurementsMax()
        {
            var devices=vm.widget.graph.maximumClients;
            var promises = [];
            for (var i=0;i<devices.length;i++)
            {
                if(vm.widget.graph.type==='lastValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/checkSensor","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/lastValue","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='aggregatedValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=sum&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=mean&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='maxValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMax=true&type=max&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='minValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMin=true&type=min&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
            }
            $q.all(promises).then(function(resArray) {
                var devices=vm.widget.graph.maximumClients;
                for(var i=0;i<resArray.length;i++)
                {
                    var measurements=resArray[i].data;
                    if(vm.widget.graph.type==='lastValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateLast(measurements,true,devices[i].measurement.measure));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateLast(measurements,false,devices[i].measurement.measure));
                        }
                    }
                    else if(vm.widget.graph.type==='aggregatedValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateAggregated(measurements,true));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateAggregated(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='meanValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateMean(measurements,true));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateMean(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='maxValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateMax(measurements,true));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateMax(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='minValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResultsMax.push(calculateMin(measurements,true));
                        }
                        else
                        {
                            vm.tmpResultsMax.push(calculateMin(measurements,false));
                        }
                    }
                }
                calculateEndMax();
            });
        }

        function calculatePue()
        {
            vm.totalMax+=1;
            if(vm.totalMax==2)
            {
                vm.unit="";
                vm.result=vm.max/vm.result;
                vm.max=vm.widget.graph.error;
                if(vm.result<=vm.widget.graph.warning)
                {
                    vm.widget.graph.foregroundColor="rgb(40,255,0)";
                }
                else if(vm.result>vm.widget.graph.warning && vm.result<=vm.widget.graph.error)
                {
                    vm.widget.graph.foregroundColor="rgb(239,146,0)";
                }
                else
                {
                    vm.max=vm.widget.graph.error+(vm.widget.graph.error)*0.2;
                    vm.widget.graph.foregroundColor="rgb(222,0,0)";
                }
            }
        }

        function calculateEndMax()
        {
            var devices=vm.widget.graph.maximumClients;
            if(vm.widget.graph.type==='aggregatedValue' || vm.widget.graph.type==='lastValue')
            {
                var count=0;
                for(var i=0;i<vm.tmpResultsMax.length;i++)
                {
                    count+=vm.tmpResultsMax[i].value;
                }
                vm.max=count;
            }
            else if(vm.widget.graph.type==='meanValue')
            {
                var count=0;
                for(var i=0;i<vm.tmpResultsMax.length;i++)
                {
                    count+=vm.tmpResultsMax[i].value;
                }
                vm.max=count/vm.tmpResultsMax.length;
            }
            else if(vm.widget.graph.type==='maxValue')
            {
                var max=vm.tmpResultsMax[0].value;
                for(var i=0;i<vm.tmpResultsMax.length;i++)
                {
                    if(vm.tmpResultsMax[i].value>max)
                    {
                        max=vm.tmpResultsMax[i].value;
                    }
                }
                vm.max=max;
            }
            else if(vm.widget.graph.type==='minValue')
            {
                var min=vm.tmpResultsMax[0].value;
                for(var i=0;i<vm.tmpResultsMax.length;i++)
                {
                    if(vm.tmpResultsMax[i].value<min)
                    {
                        min=vm.tmpResultsMax[i].value;
                    }
                }
                vm.max=min;
            }
            if(vm.widget.graph.graphType==='pue')
            {
                calculatePue();
            }
        } 
        function getMeasurements()
        {
            var devices=vm.widget.clients;
            vm.icon='pragma-icon-'+devices[0].specs.type;
            vm.unit=devices[0].specs.unit;
            var promises = [];
            for (var i=0;i<devices.length;i++)
            {
                if(vm.widget.graph.type==='lastValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/checkSensor","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurements/lastValue","?measuredParameter="+devices[i].measurement.measure+"&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='aggregatedValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=sum&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=M&resolution=20&includeTotalSum=false&type=mean&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='maxValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMax=true&type=max&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='minValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType=d&resolution=60&includeTotalMin=true&type=min&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
            }
            $q.all(promises).then(function(resArray) {
                var devices=vm.widget.clients;
                for(var i=0;i<resArray.length;i++)
                {
                    var measurements=resArray[i].data;
                    if(vm.widget.graph.type==='lastValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateLast(measurements,true,devices[i].measurement.measure));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateLast(measurements,false,devices[i].measurement.measure));
                        }
                    }
                    else if(vm.widget.graph.type==='aggregatedValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='meanValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMean(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMean(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='maxValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMax(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMax(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='minValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMin(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMin(measurements,false));
                        }
                    }
                }
                vm.triggered=true;
                calculateEnd();
            });
        }
        function calculateEnd()
        {
            var devices=vm.widget.clients;
            if(vm.widget.graph.type==='aggregatedValue' || vm.widget.graph.type==='lastValue')
            {
                var count=0;
                for(var i=0;i<vm.tmpResults.length;i++)
                {
                    count+=vm.tmpResults[i].value;
                }
                vm.result=count;
            }
            else if(vm.widget.graph.type==='meanValue')
            {
                var count=0;
                for(var i=0;i<vm.tmpResults.length;i++)
                {
                    count+=vm.tmpResults[i].value;
                }
                vm.result=count/vm.tmpResults.length;
            }
            else if(vm.widget.graph.type==='maxValue')
            {
                var max=vm.tmpResults[0].value;
                for(var i=0;i<vm.tmpResults.length;i++)
                {
                    if(vm.tmpResults[i].value>max)
                    {
                        max=vm.tmpResults[i].value;
                    }
                }
                vm.result=max;
            }
            else if(vm.widget.graph.type==='minValue')
            {
                var min=vm.tmpResults[0].value;
                for(var i=0;i<vm.tmpResults.length;i++)
                {
                    if(vm.tmpResults[i].value<min)
                    {
                        min=vm.tmpResults[i].value;
                    }
                }
                vm.result=min;
            }
            if(vm.widget.graph.graphType==='pue')
            {
                calculatePue();
            }
        }

        function calculateLast(measurements,cumulative,measure)
        {
            if(cumulative)
            {
                if(measurements.length==2)
                {
                    var first=measurements[1][measure];
                    var last=measurements[0][measure];
                    var val=last-first;
                    if(val<0)
                    {
                        val=last;
                    }
                    var response=
                    {
                        value:val,
                        timestamp:measurements[0].timestamp
                    }
                }  
            }
            else
            {
                var response=
                {
                    value:measurements[measure],
                    timestamp:measurements.timestamp
                }
            }
            return response;
        }

        function calculateAggregated(measurements,cumulative)
        {
            if(cumulative)
            {
                var first=measurements[0].entries[0];
                var last=measurements[0].entries[measurements[0].entries.length-1];
                var val=last.value-first.value;
                if(val<0)
                {
                    val=last.value;
                }
                var response=
                {
                    value:val,
                    timestamp:last.measurementDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }

        function calculateMean(measurements,cumulative)
        {
            if(cumulative)
            {
                var foo=measurements[0].entries;
                var tmp=[];
                for (var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var t=val;
                    tmp.push(t);
                }
                var count=0;
                for (var i=0;i<tmp.length;i++)
                {
                    count+=tmp[i];
                }
                var response=
                {
                    value:count/tmp.length,
                    timestamp:foo[foo.length-1].measurementDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }

        function calculateMax(measurements,cumulative)
        {
            if(cumulative)
            {
                var foo=measurements[0].entries;
                var tmp=[];
                for (var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var t={value:val,timestamp:foo[i].measurementDate};
                    tmp.push(t);
                }
                var max=tmp[0].value;
                var maxDate=tmp[0].timestamp;
                for (var i=0;i<tmp.length;i++)
                {
                    if(tmp[i].value>max)
                    {
                        max=tmp[i].value;
                        maxDate=tmp[i].timestamp;
                    }

                }
                var response=
                {
                    value:max,
                    timestamp:maxDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }

        function calculateMin(measurements,cumulative)
        {
            if(cumulative)
            {
                var foo=measurements[0].entries;
                var tmp=[];
                for (var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var t={value:val,timestamp:foo[i].measurementDate};
                    tmp.push(t);
                }
                var min=tmp[0].value;
                var minDate=tmp[0].timestamp;
                for (var i=0;i<tmp.length;i++)
                {
                    if(tmp[i].value<min)
                    {
                        min=tmp[i].value;
                        minDate=tmp[i].timestamp;
                    }

                }
                var response=
                {
                    value:min,
                    timestamp:minDate
                }
            }
            else
            {
                var foo=measurements.data;
                var response=
                {
                    value:foo[0].d,
                    timestamp:foo[0].t
                }
            }
            return response;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('fridgeDitector', fridgeDitector);

    function fridgeDitector() {
        var directive = {
            templateUrl:"app/directives/fridge-ditector/fridge-ditector.html",
            controller: FridgeDitectorController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardClients:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function FridgeDitectorController ($rootScope,$scope,$http,session,PRAGMA,$base64,pragmaapi,$timeout,pragmaTheming) {
        var vm =this;
        var fillWidgetIsRunning=false;
        vm.device={};
        var assignment='7c49c915-0afb-49f7-9b8f-364711ed28a6';
        var tenant='0817e7f4-f555-4b5c-9ae5-69b460b7b15d';
        vm.tempResult=0;
        vm.counter=0;
        vm.things=
        [
            {
                name:'bottle',
                color:'#4EA2C6',
                exists:false
            },
            {
                name:'bowl',
                color:'#4EA2C6',
                exists:false
            },
            {
                name:'banana',
                color:'#FDDD27',
                exists:false
            },
            {
                name:'sandwich',
                color:'#F7B346',
                exists:false
            },
            {
                name:'orange',
                color:'#E57713',
                exists:false
            },
            {
                name:'broccoli',
                color:'#40A516',
                exists:false
            },
            {
                name:'carrot',
                color:'#E57713',
                exists:false
            },
            {
                name:'pizza',
                color:'#F7B346',
                exists:false
            },
            {
                name:'donut',
                color:'#D683F6',
                exists:false
            },
            {
                name:'cake',
                color:'#D683F6',
                exists:false
            },
            {
                name:'apple',
                color:'#FF6D6D',
                exists:false
            }
        ];
        vm.fridge=
        {
            shelf:
            [
                [],
                [],
                []
            ],
            door:
            [
                [],
                [],
                []
            ],
            missing:
            []
        };
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
		vm.url=PRAGMA.api;
        vm.result=0;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.gridLinesColor="rgb(255,255,255)";
            vm.fontColor="rgb(255,255,255)";
        }
        else
        {
            vm.gridLinesColor="rgb(255,255,255)";
            vm.fontColor="rgb(0,0,0)";
        }
        $scope.$on('new.measurement.broadcast', function(event, args) {
            fillWidgetMqtt(args);
        });
        function fillWidgetMqtt(device)
        {
            $timeout(function() {
                $scope.$apply(function () {
                    if(assignment===device.deviceAssignmentToken)
                    {
                        getMeasurements();
                    }
                });
            }, 100);
        }
        fillWidget();
        function fillWidget()
        {
            getMeasurements();
        }
        function getMeasurements()
        {
            pragmaapi.callRestService(vm.url,"/assignments/"+assignment+"/measurements/lastValue","?tenantAuthToken="+tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
                vm.date=res.data.timestamp;
                vm.tmpRes=JSON.parse(res.data.data);
                vm.thingsExists=[];
                for(var i=0;i<vm.tmpRes.detections.length;i++)
                {
                    for(var j=0;j<vm.things.length;j++)
                    {
                        if(vm.things[j].name===vm.tmpRes.detections[i].label)
                        {
                            vm.things[j].exists=true;
                            var tmp=
                            {
                                name:vm.things[j].name,
                                color:vm.things[j].color,
                                space:vm.tmpRes.detections[i].camera,
                                thesi:vm.tmpRes.detections[i].level
                            }
                            vm.thingsExists.push(tmp)
                            break;
                        }
                    }
                }
                vm.fridge=
                {
                    shelf:
                    [
                        [],
                        [],
                        []
                    ],
                    door:
                    [
                        [],
                        [],
                        []
                    ],
                    missing:
                    []
                };
                for(var i=0;i<vm.thingsExists.length;i++)
                {
                    vm.fridge[vm.thingsExists[i].space][3-vm.thingsExists[i].thesi].push(vm.thingsExists[i]);
                }
                for(var i=0;i<vm.fridge.shelf.length;i++)
                {
                    if(vm.fridge.shelf[i].length==0)
                    {
                        vm.fridge.shelf[i].push(null)
                    }
                }
                for(var i=0;i<vm.fridge.door.length;i++)
                {
                    if(vm.fridge.door[i].length==0)
                    {
                        vm.fridge.door[i].push(null)
                    }
                }
                for(var j=0;j<vm.things.length;j++)
                {
                    if(!vm.things[j].exists)
                    {
                        vm.fridge.missing.push(vm.things[j]);
                    }
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('floorPlan', floorPlan)

    function floorPlan() {
        var directive = {
            templateUrl:"app/directives/floor-plan/floor-plan.html",
            controller: FloorPlanController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
				widget: "=",
				dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function FloorPlanController ($scope,$http,session,PRAGMA,$base64,pragmaTheming,pragmaapi,$cookies) {
		var vm = this;
		var vm = this;
		var xml;
		var pointsArray = [];
		var buildingCoordinates = [];
		var buildingXML = [];
		var floorsVar = [];
		var floorToShow = -34;
		var jsonDevices1 ={};
		var container, canvas;
		var scene, scene1, scene2, camera = new THREE.Raycaster(), renderer;
        var RmincartesianX=500;
        var RmaxcartesianX=-12;
        var RmincartesianY=500;
        var RmaxcartesianY=-12;
        var mincartesianX=100;
        var maxcartesianX=-50;
        var mincartesianY=200;
        var maxcartesianY=-100;
		var buildingWidth;
		var buildingHeight;
		vm.widget = $scope.widget;
		vm.dates = [];
		vm.user = session.getUser();
		vm.user.authentication = vm.user.username + ":" + vm.user.password;
		vm.url = PRAGMA.api;
		vm.total = 0;
		vm.max = 0;
		vm.min = 0;
		var themes = pragmaTheming.themes;
		var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.gridLinesColor="rgb(255,255,255)";
        }
        else
        {
            vm.gridLinesColor="rgb(172,172,172)";
		}
		vm.plotId=generateUUID();
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
		vm.timeZone=timeZoneFormattedArray[1];
		$scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom")
                {
                    fillWidget();
                }
            }
        });
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today")
            {
                fillWidgetMqtt(args);
            } 
        });
        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
					
					vm.dates = {
						startDate: moment().startOf('day'),
						endDate: moment()
					};
					if(vm.widget.time.type==='minutes')
					{
						angular.copy(vm.dates.endDate,vm.dates.startDate);
						vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
					}
					else if(vm.widget.time.type==='time')
					{
						var dtime=parseInt(vm.timeZone)/100;
						var startDate=new Date(vm.widget.time.start);
						var startHours=startDate.getHours();
						var startMinutes=startDate.getMinutes();
						var endDate=new Date(vm.widget.time.end);
						var endHours=endDate.getHours();
						var endMinutes=endDate.getMinutes();
						vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
						vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
					}
                    gatherPoints();
                    break;
                }
            }
		}
		
		fillWidget();

		function fillWidget()
        {
			buildingCoordinates = [];
			buildingXML = [];
            if(vm.widget.dates[0].date==="custom")
            {
                vm.dates=$scope.dashboardDate;
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            xmlRead();
		}
		
		function xmlRead(){
			var meta=JSON.parse(vm.widget.clients[0].device.metadata);
			xml = "assets/gbxml/"+meta.gbxml;
			var xhr = new XMLHttpRequest();
			xhr.open("GET", xml)
			xhr.onload = function() {
				var xml;
				var parseXml;
				if (window.DOMParser) {
					parseXml = function(xmlStr) {
						return ( new window.DOMParser() ).parseFromString(xmlStr, "text/xml");
					};
				} 
				else if (typeof window.ActiveXObject != "undefined" && new window.ActiveXObject("Microsoft.XMLDOM")) {
					parseXml = function(xmlStr) {
						var xmlDoc = new window.ActiveXObject("Microsoft.XMLDOM");
						xmlDoc.async = "false";
						xmlDoc.loadXML(xmlStr);
						return xmlDoc;
					};
				} 
				else {
					parseXml = function() { return null; }
				}
				xml = xhr.responseText;
				var xmlDoc = parseXml(xml);
				if (xmlDoc) {
					var gbXMLNode = xmlDoc.getElementsByTagName("gbXML");
					var CampusNode = gbXMLNode[0].getElementsByTagName("Campus");
					buildingXML = CampusNode[0].getElementsByTagName("Surface");
					renderBuilding();
				}
			}
			xhr.send()
		}
		function renderBuilding() {
			for (var k = 0; k < buildingXML.length; k++) {
				var Points = [];
				var walltype = buildingXML[k].getAttribute('surfaceType');
				var SpaceId = buildingXML[k].getElementsByTagName("AdjacentSpaceId");
				var del3 = SpaceId[0].getAttribute('spaceIdRef');
				var Geometry = buildingXML[k].getElementsByTagName("PlanarGeometry");
				var polyLoop = Geometry[0].getElementsByTagName("PolyLoop");
				var cartesianPoints = polyLoop[0].getElementsByTagName("CartesianPoint");
				for (var j = 0; j < cartesianPoints.length; j++) {
					var Point= new Object();
					Point.coordinateX = cartesianPoints[j].getElementsByTagName("Coordinate")[0].childNodes[0].nodeValue;
					Point.coordinateY = cartesianPoints[j].getElementsByTagName("Coordinate")[1].childNodes[0].nodeValue;
					Point.coordinateZ = cartesianPoints[j].getElementsByTagName("Coordinate")[2].childNodes[0].nodeValue;
					Point.nameId = del3;
					Point.wallType = walltype;
					Points.push(Point);
				}
				buildingCoordinates.push(Points);
			}
			init();
			animate();
			gatherPoints();
		}
		function gatherPoints() {
			pointsArray=[];
			pragmaapi.callRestService(vm.url,"/assignments/"+vm.widget.clients[0].device.token+"/measurements","?page=1&pageSize=2000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&tenantAuthToken="+vm.widget.clients[0].tenant.token,true,vm.user.authentication,"GET",true,false).then(function(res){
				var results = res.data.results;
				for (var i = 0; i < results.length; i++) {
					var metadata = results[i].metadata;
					
					if (typeof metadata.map !== "undefined"){
						var mapData = metadata.map.split(",");
						
						for (var j = 0; j < mapData.length; j+=4) {
							var xy = mapData[j+1] + '|' + mapData[j+2];
							var index = uniqueXY(mapData[j+1], mapData[j+2], pointsArray);
							
							if (index) {
								pointsArray[index][2] += parseInt(mapData[j+3]);
							}
							else {
								if (mapData[j] != ''){
									pointsArray.push([parseInt(mapData[j+1]),parseInt(mapData[j+2]),parseInt(mapData[j+3])]);
								}
							}
						}
					}
				}
				renderPoints();
			});
		}

		function uniqueXY(x, y, myArray){
			for (var i=0; i < myArray.length; i++) {
				if (myArray[i][0] == x && myArray[i][1] == y) {
					return i;
				}
			}
		}
		
		function renderPoints() {
			if (pointsArray.length > 0){
				vm.max = Math.max.apply(Math,pointsArray.map(function(o){return o[2];}));
				vm.min = Math.min.apply(Math,pointsArray.map(function(o){return o[2];}));
				vm.total = pointsArray.length;
				for (var i = 0, len = pointsArray.length; i < len; i += 1) {
					var normalize = (((100-1)*(pointsArray[i][2] - vm.min))/(vm.max - vm.min))+1;
					pointsArray[i][2] = normalize;
				}
				var terrainWidth  = Math.abs(RmaxcartesianY - RmincartesianY);
				var terrainHeight = Math.abs(RmaxcartesianX - RmincartesianX);
				var planeGeometry = new THREE.PlaneGeometry( terrainWidth, terrainHeight, 1 );
				var texture = new THREE.Texture( generateSimpleTextureHeatmap() );
				texture.needsUpdate = true;
				var planeMaterial = new THREE.MeshBasicMaterial({ map: texture, transparent: true, side: THREE.DoubleSide});
				var planeMesh = new THREE.Mesh( planeGeometry, planeMaterial );
				planeMesh.scale.set(0.1,0.1,1);
				planeMesh.position.set(terrainWidth*0.1/2,-(terrainHeight*0.1)/2,0);
				while(scene1.children.length > 0){ 
					scene1.remove(scene1.children[0]); 
				}
				scene1.add( planeMesh );
				var pointsGeometry = new THREE.Geometry();
				for ( var i = 0; i < pointsArray.length; i ++ ) {
					var point = new THREE.Vector3();
					point.x = pointsArray[i][0]/10;
					point.y = -(pointsArray[i][1])/10;
					point.z = pointsArray[i][2];
					
					pointsGeometry.vertices.push( point );
				}
				var pointsMaterial = new THREE.PointsMaterial( { color: 0x000000, size: 1.0, sizeAttenuation: false } );
				var pointsField = new THREE.Points( pointsGeometry, pointsMaterial );
			}	
		}
		
		function generateSimpleTextureHeatmap() {
			var myCanvas = document.createElement( 'canvas' );
			myCanvas.width = Math.abs(RmaxcartesianY - RmincartesianY);
			myCanvas.height = Math.abs(RmaxcartesianX - RmincartesianX);
			var heat = simpleheat(myCanvas);
			heat.data(pointsArray);
			heat.max(100);
			heat.radius(4, 10)
			heat.draw();
			return myCanvas;
		}

		function init() {
			floorsVar = [];
			container = document.getElementById(vm.plotId);
			scene = new THREE.Scene();
			scene1 = new THREE.Scene();
			scene2 = new THREE.Scene();
			var light = new THREE.AmbientLight(0x404040);
			scene.add( light );
			var clockwise;
			var tempName = [];
			var flag = 0;
			var flagNumber;
			var shadowMaterial = [];
			var flag1;
			var nl = [];
			var wallGeometry = new THREE.Geometry();
			var lineGeometry;
			for (var s = 0; s < buildingCoordinates.length; s++) {
				nl[s] = 0;
				if(buildingCoordinates[s][0].wallType == "UndergroundSlab") {
					for (var p = 0; p < buildingCoordinates[s].length; p++) {
						var nl1;
						var nl2;
						nl1 = Number(buildingCoordinates[s][p].coordinateX);
						nl2 = -Number(buildingCoordinates[s][p].coordinateY);
						if(nl1 < 0.001 && nl1 > -0.001) {
							nl1 = 0;
						}
						if(nl2 < 0.001 && nl2 > -0.001) {
							nl2 = 0;
						}
						if(Number(nl1) > maxcartesianX) {
							maxcartesianX = Number(nl1);
						}
						if(Number(nl1) < mincartesianX) {
							mincartesianX = Number(nl1);
						}
						if(Number(nl2) > maxcartesianY) {
							maxcartesianY = Number(nl2);
						}
						if(Number(nl2) < mincartesianY) {
							mincartesianY = Number(nl2);
						}
					}
					nl[s] = Number(buildingCoordinates[s][0].coordinateZ);
					if(nl[s] < 0.001) {
						nl[s] = 0;
					}
					if(floorsVar.length == 0) {
						floorsVar.push(nl[s]);
					}
					else {
						flag1 = 0;
						for (var i = 0; i < floorsVar.length; i++) {
							if(nl[s] == floorsVar[i]) {
								flag1 = 1;
							}
						}
						if (flag1 == 0) {
							floorsVar.push(nl[s]);
						}
					}
				}             
			}
			for (var pass = 1; pass < floorsVar.length; pass++){
				for(var n = 0; n < floorsVar.length-pass; n++) {
					if(floorsVar[n] > floorsVar[n+1]) {
						var temp = floorsVar[n];
						floorsVar[n] = floorsVar[n+1];
						floorsVar[n+1] = temp;
					}
				}
			}
			if(floorToShow == -34) {
				for(var r = 0; r < floorsVar.length; r++) {
					var floorText = "Floor_"+(r+1);
					var floorTextBut = "Floor"+(r+1)+"_but";
					if(floorsVar.length != 1) {
						var node = document.createElement("li");
						node.setAttribute('role', 'presentation');
						node.setAttribute('id', floorTextBut);
						node.setAttribute('onclick', "changeFloorView(id)");
						var createA = document.createElement('a');
						var createAText = document.createTextNode(floorText);
						createA.appendChild(createAText);
						node.appendChild(createA);
						document.getElementById("ul_floors").appendChild(node);
						if(r == 0) {
							node.setAttribute('class', 'active');
						}
					}
				}
				floorToShow = floorsVar[0];
			}
			for (var s = 0; s < buildingCoordinates.length; s++) {
				if(nl[s] == floorToShow) {
					flag = 0;
					flagNumber = null;
					if(s == 0) {
						tempName.push(buildingCoordinates[0][0].nameId);
					}
					for(var k1 = 0; k1 < tempName.length; k1++){
						if(buildingCoordinates[s][0].nameId == tempName[k1]){
							flag = 1;
							flagNumber = k1;
						}
					}
					if(flag == 1) {
						flagNumber = flagNumber;
					}
					else {
						tempName.push(buildingCoordinates[s][0].nameId);
						flagNumber = tempName.length-1;
					}
					shadowMaterial[0] = new THREE.MeshLambertMaterial({
						color: vm.gridLinesColor,
						side: THREE.DoubleSide,
						wireframe: false,
						transparent: false,
						opacity: 0.5,
						vertexColors: THREE.FaceColors, 
						overdraw: true
					});
					shadowMaterial[1] = new THREE.MeshLambertMaterial({
						color: vm.gridLinesColor,
						side: THREE.DoubleSide,
						wireframe: false,
						transparent: false,
						opacity: 1,
						vertexColors: THREE.FaceColors, 
						overdraw: true
					});
					shadowMaterial[2] = new THREE.MeshLambertMaterial({
						color: "rgb(255,244,65)",
						side: THREE.DoubleSide,
						wireframe: false,
						transparent: false,
						opacity: 0.5,
						vertexColors: THREE.FaceColors, 
						overdraw: true
					});
					var datadikamas = [];
					wallGeometry = new THREE.Geometry();
					lineGeometry= new THREE.Geometry();
					clockwise = 0;
					for (var p = 0; p < buildingCoordinates[s].length-1; p++) {
						clockwise += (parseFloat(buildingCoordinates[s][p+1].coordinateX)-parseFloat(buildingCoordinates[s][p].coordinateX))*(-parseFloat(buildingCoordinates[s][p+1].coordinateY)+parseFloat(-buildingCoordinates[s][p].coordinateY));
					}
					clockwise += (parseFloat(buildingCoordinates[s][0].coordinateX)-parseFloat(buildingCoordinates[s][buildingCoordinates[s].length-1].coordinateX))*(-parseFloat(buildingCoordinates[s][0].coordinateY)+parseFloat(-buildingCoordinates[s][buildingCoordinates[s].length-1].coordinateY));
					if(clockwise < 0) {
						for (var p = 0; p < buildingCoordinates[s].length; p++) {
							wallGeometry.vertices.push(new THREE.Vector3(buildingCoordinates[s][p].coordinateX, -buildingCoordinates[s][p].coordinateY, buildingCoordinates[s][p].coordinateZ));
							
							lineGeometry.vertices.push(new THREE.Vector3(buildingCoordinates[s][p].coordinateX, -buildingCoordinates[s][p].coordinateY, buildingCoordinates[s][p].coordinateZ));
							
							datadikamas.push({
								x: buildingCoordinates[s][p].coordinateX,
								y: -buildingCoordinates[s][p].coordinateY
							});
						}
						lineGeometry.vertices.push(new THREE.Vector3(buildingCoordinates[s][0].coordinateX, -buildingCoordinates[s][0].coordinateY, buildingCoordinates[s][0].coordinateZ));
					}
					else if(clockwise > 0) {
						for (var p = buildingCoordinates[s].length-1; p >= 0; p--) {
							wallGeometry.vertices.push(new THREE.Vector3(buildingCoordinates[s][p].coordinateX, -buildingCoordinates[s][p].coordinateY, buildingCoordinates[s][p].coordinateZ));

							lineGeometry.vertices.push(new THREE.Vector3(buildingCoordinates[s][p].coordinateX, -buildingCoordinates[s][p].coordinateY, buildingCoordinates[s][p].coordinateZ));
							
							datadikamas.push({
								x: buildingCoordinates[s][p].coordinateX,
								y: -buildingCoordinates[s][p].coordinateY
							});
						}
						lineGeometry.vertices.push(new THREE.Vector3(buildingCoordinates[s][buildingCoordinates[s].length-1].coordinateX, -buildingCoordinates[s][buildingCoordinates[s].length-1].coordinateY, buildingCoordinates[s][buildingCoordinates[s].length-1].coordinateZ));
					}
					else {
						var tmpX = 0;
						
						for (var p = 0; p < buildingCoordinates[s].length; p++) {
							tmpX = parseFloat(buildingCoordinates[s][0].coordinateX)+parseFloat(buildingCoordinates[s][1].coordinateX)+parseFloat(buildingCoordinates[s][2].coordinateX)+parseFloat(buildingCoordinates[s][3].coordinateX);
							if(tmpX == buildingCoordinates[s].length*parseFloat(buildingCoordinates[s][0].coordinateX)) {
								datadikamas.push({
									x: buildingCoordinates[s][p].coordinateZ,
									y: -buildingCoordinates[s][p].coordinateY
								});
							}
							else {
								datadikamas.push({
									x: buildingCoordinates[s][p].coordinateZ,
									y: buildingCoordinates[s][p].coordinateX
								});
							}
							lineGeometry.vertices.push(new THREE.Vector3(buildingCoordinates[s][p].coordinateX, -buildingCoordinates[s][p].coordinateY, buildingCoordinates[s][p].coordinateZ));
							
							wallGeometry.vertices.push(new THREE.Vector3(buildingCoordinates[s][p].coordinateX, -buildingCoordinates[s][p].coordinateY, buildingCoordinates[s][p].coordinateZ));
						}
					}
					var example_data = [];
					example_data.push(datadikamas);
					var myTriangulator = new PNLTRI.Triangulator();
					var triangList = myTriangulator.triangulate_polygon( example_data );
					
					for(var l = 0;l < triangList.length; l++) {
						wallGeometry.faces.push( new THREE.Face3( triangList[l][0], triangList[l][1], triangList[l][2] ));
					}
					wallGeometry.computeFaceNormals();
					var tmpMaterial = 0;
					if(buildingCoordinates[s][0].wallType == "Roof") {
						tmpMaterial = 0;
					}
					else if(buildingCoordinates[s][0].wallType == "UndergroundSlab") {
						tmpMaterial = 1;
					}
					else {
						tmpMaterial = 2;
					}
					var object = new THREE.Mesh( wallGeometry, shadowMaterial[tmpMaterial]);
					object.name = tempName[flagNumber];
					var line = new THREE.Line( lineGeometry,  new THREE.LineBasicMaterial( { color: 0x000000, linewidth:6 } ));
					scene1.add(line);
					scene.add(object);
				}
			}
			buildingWidth = Math.abs(maxcartesianY - mincartesianY);
			buildingHeight = Math.abs(maxcartesianX - mincartesianX);
			camera = new THREE.OrthographicCamera(mincartesianX, maxcartesianX, mincartesianY, maxcartesianY, -1000, 1000);
			renderer = new THREE.WebGLRenderer({ alpha: true } );
			renderer.setClearColor( 0xffffff, 0);
			renderer.setPixelRatio( window.devicePixelRatio );
			renderer.setSize(document.getElementById(vm.plotId).offsetWidth, document.getElementById(vm.plotId).offsetWidth*(buildingWidth/buildingHeight));
			renderer.sortObjects = false;
			container.appendChild(renderer.domElement);
			window.addEventListener( 'resize', onWindowResize);
			var left   = 0;
			var bottom = 0;
			var width  = Math.floor( document.getElementById(vm.plotId).offsetWidth );
			var height = Math.floor( document.getElementById(vm.plotId).offsetWidth*(buildingWidth/buildingHeight));
			renderer.autoClear = false;
			renderer.clear();
			renderer.render( scene, camera );
			renderer.clearDepth();
			renderer.render( scene1, camera );
			renderer.clearDepth();
			renderer.render( scene2, camera );
		}

		function onWindowResize() {
			renderer.setSize(document.getElementById(vm.plotId).offsetWidth, document.getElementById(vm.plotId).offsetWidth*(buildingWidth/buildingHeight));
		}
		
		function animate() {
			requestAnimationFrame(animate);
			renderer.render( scene, camera );
			renderer.clearDepth();
			renderer.render( scene1, camera );
			renderer.clearDepth();
			renderer.render( scene2, camera );
		}

		function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random()*16)%16 | 0;
                d = Math.floor(d/16);
                return (c=='x' ? r : (r&0x3|0x8)).toString(16);
            });
            return uuid;
        }
	}
})();

(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('entriesExitsPlot', entriesExitsPlot);

    function entriesExitsPlot() {
        var directive = {
            templateUrl:"app/directives/entries-exits-plot/entries-exits-plot.html",
            controller: EntriesExitsPlotController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    /** @ngInject */
    function EntriesExitsPlotController ($scope,$http,session,PRAGMA,$base64,pragmaapi,pragmaTheming) {
        var vm =this;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.gridLinesColor="rgba(255,255,255,";
        }
        else
        {
            vm.gridLinesColor="rgba(0,0,0,";
        }
        vm.metadata=
        {
            min:null,
            max:0,
            avg:0,
            total:0
        }
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.dates=[];
        fillWidget();
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                fillWidget();
            }
        });     
        function fillWidget() {
            vm.dates=[];
            vm.preCounter=0;
            vm.metaCounter=0;
            vm.graphCounter = 0;
            vm.step = false;
            vm.graphType="line";
            vm.showLine=true;
            if(vm.widget.type=== 3) {
                vm.step = true;
            }
            else if(vm.widget.type=== 1)
            {
               vm.graphType="bar";
            }
            else if(vm.widget.type=== 14)
            {
                vm.showLine=false;
            }

            vm.result = {
                unit : "",
                chart: {
                    data: [],
                    labels: [],
                    series: [],
                    colors: [],
                    override: [],
                    options: {
                        legend: {
                            labels: {
                                fontColor: vm.gridLinesColor+"0.6)"
                            },
                            display: true,
                            position: "bottom"
                        },
                         elements: {
                        point: {
                            pointStyle: vm.widget.graph.point
                        }
                    },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [
                                {
                                    gridLines: {
                                        display: true ,
                                        color: vm.gridLinesColor+"0.2)"
                                      },
                                    ticks: {
                                        maxRotation: 0,
                                        fontSize: 10,
                                        autoSkipPadding: 10,
                                        fontColor: vm.gridLinesColor+"0.6)"
                                    }
                                }
                            ],
                            yAxes: [
                                {
                                    gridLines: {
                                        display: true ,
                                        color: vm.gridLinesColor+"0.2)"
                                    },
                                    ticks: {
                                        maxRotation: 0,
                                        fontSize: 10,
                                        autoSkipPadding: 10,
                                        fontColor: vm.gridLinesColor+"0.6)"
                                    },
                                    scaleLabel: { 
                                        display: false,
                                        labelString: '',
                                    }
                                }
                            ]
                        },
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    var unit=vm.result.unit
                                    return parseFloat(tooltipItem.yLabel).toFixed(2) + " " + unit;
                                }
                            }
                        }
                    }
                }
            };
            if (vm.widget.dates.length === 0) {
                vm.dates[0] = $scope.dashboardDate;
            }
            else 
            {
                for(var li=0;li<vm.widget.dates.length;li++)
                {
                    if(vm.widget.dates[li].date==="custom")
                    {
                        vm.dates.push($scope.dashboardDate);
                    }
                    else if(vm.widget.dates[li].date==="thisYear")
                    {
                        vm.dates.push({
                            startDate: moment().startOf('year'),
                            endDate: moment()
                        });
                    }
                    else if(vm.widget.dates[li].date==="last3Months")
                    {
                        vm.dates.push({
                            startDate: moment().subtract(2, 'month').startOf('month'),
                            endDate: moment()
                        });
                    }
                    else if(vm.widget.dates[li].date==="lastMonth")
                    {
                        vm.dates.push({
                            startDate: moment().subtract(1, 'month').startOf('month'),
                            endDate: moment().subtract(1, 'month').endOf('month')
                        });
                    }
                    else if(vm.widget.dates[li].date==="thisMonth")
                    {
                        vm.dates.push({
                            startDate: moment().startOf('month'),
                            endDate: moment()
                        });
                    }
                    else if(vm.widget.dates[li].date==="last30Days")
                    {
                        vm.dates.push({
                            startDate: moment().subtract(29, 'days').startOf('day'),
                            endDate: moment()
                        });
                    }
                    else if(vm.widget.dates[li].date==="lastWeek")
                    {
                        vm.dates.push({
                            startDate: moment().subtract(1, 'week').startOf('week'),
                            endDate: moment().subtract(1, 'week').endOf('week')
                        });
                    }
                    else if(vm.widget.dates[li].date==="thisWeek")
                    {
                        vm.dates.push({
                            startDate: moment().startOf('week'),
                            endDate: moment()
                        });
                    }
                    else if(vm.widget.dates[li].date==="last7Days")
                    {
                        vm.dates.push({
                            startDate: moment().subtract(6, 'days').startOf('day'),
                            endDate: moment()
                        });
                    }
                    else if(vm.widget.dates[li].date==="yesterday")
                    {
                        vm.dates.push({
                            startDate: moment().subtract(1, 'day').startOf('day'),
                            endDate: moment().subtract(1, 'day').endOf('day')
                        }); 
                    }
                    else
                    {
                        if(typeof vm.widget.time!=='undefined')
                        {
                            var time=vm.widget.time;
                            var startTime=time.start.split(":");
                            var endTime=time.end.split(":");

                            var startDate=moment().startOf('day');
                            startDate.set({hour:startTime[0],minute:startTime[1],second:0,millisecond:0});
                            var endDate=moment();
                            if(endDate.hours()>endTime[0] && endDate.minutes()>endTime[1])
                            {
                                endDate.set({hour:endTime[0],minute:endTime[1],second:0,millisecond:0});
                            }
                            vm.dates.push({
                                startDate: startDate,
                                endDate: endDate
                            });
                        }
                        else
                        {
                            vm.dates.push({
                                startDate: moment().startOf('day'),
                                endDate: moment()
                            });
                        }
                    }
                }
            }
            var dF = Date.parse(vm.dates[0].startDate) / 1000;
            var dT = Date.parse(vm.dates[0].endDate) / 1000;
            var def=dT-dF;
            var day = 86400;
            vm.resolution ="m"
            if (def <= day) { // Day raw data
                vm.resolution= "m";
            }
            else if (def <= day * 31) { // 8 weeks
                vm.resolution="d";
            }
            else {
                vm.resolution = "M";
            }
            vm.clients = vm.widget.clients;
            for (var i = 0; i < vm.clients.length; i++) {
                for(var j = 0; j < vm.clients[i].sites.length; j++) {
                    getDevicesCustom(vm.clients[i].token,vm.clients[i].sites[j]);
                }
            }
        }
        function computeMetadata()
        {
            var meta=vm.result.chart.data;
            var counter=0;
            for(var i=0;i<meta.length;i++)
            {
                for(var j=0;j<meta[i].length;j++)
                {
                    if(meta[i][j]>vm.metadata.max)
                    {
                        vm.metadata.max=meta[i][j];
                    }
                    if(vm.metadata.min==null && meta[i][j]>0)
                    {
                        vm.metadata.min=meta[i][j];
                    }
                    if(meta[i][j]<vm.metadata.min && meta[i][j]>0)
                    {
                        vm.metadata.min=meta[i][j];
                    }
                    if(meta[i][j]>0)
                    {
                        counter++;
                        vm.metadata.total+=meta[i][j];
                    }
                }
            }
            vm.metadata.avg=vm.metadata.total/counter;
        }
        function getDevicesCustom(tenant, site) {
            pragmaapi.callRestService(vm.url, "/devices/", "?site=" + site.token + "&page=1&pageSize=2000&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken=" + tenant, true, vm.user.authentication, "GET", true, false).then(function(res) {
                var devices = res.data.results;
                var centralMeter = null;
                for (var i = 0; i < devices.length; i++) {
                    for (var j = 0; j < site.assignments.length; j++) {
                        if (devices[i].assignment.token == site.assignments[j].token) {
                            for (var l = 0; l < site.assignments[j].measurements.length; l++) {
                                var specs = JSON.parse(devices[i].specification.metadata.specs);
                                centralMeter = {
                                    "deviceName":devices[i].metadata.name,
                                    "assignment": devices[i].assignment.token,
                                    "tenant": tenant,
                                    "site": site,
                                    "specs": specs[site.assignments[j].measurements[l]],
                                    "measure": site.assignments[j].measurements[l]
                                };
                                vm.preCounter++;
                                getMeasurementsCustom(centralMeter);
                            }
                        }
                    }
                }
            });
        }
        function calculatePlot(centralMeter,li)
        {
            pragmaapi.callRestService(PRAGMA.api,"/assignments/"+centralMeter.assignment+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates[li].startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates[li].endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+centralMeter.measure+"&tenantAuthToken=" + centralMeter.tenant, true, vm.user.authentication, "GET", true).then(function(res){
                var measurements = res.data[0].entries;
                if(measurements.length>0)
                {
                    vm.result.chart.colors=[];
                    if( vm.widget.graph.entries && vm.widget.graph.exits)
                    {
                        vm.result.chart.series[0]="Entries";
                        vm.result.chart.series[1]="Exits";
                        vm.result.chart.data[0] = [];
                        vm.result.chart.data[1] = [];
                        vm.result.chart.colors[0]={
                            showLine: vm.showLine,
                            steppedLine: vm.step,
                            lineTension : 0,
                            type:vm.graphType,
                            pointHoverRadius:(vm.widget.graph.pointSize)+3,
                            pointRadius:vm.widget.graph.pointSize,
                            borderColor: vm.widget.graph.entriesColor,
                            backgroundColor:  "rgba(0,0,0,0)",
                            pointBorderColor: vm.widget.graph.entriesColor,
                            pointBackgroundColor: vm.widget.graph.entriesColor,
                            pointHoverBorderColor: vm.widget.graph.entriesColor,
                            pointHoverBackgroundColor: vm.widget.graph.entriesColor
                        };
                        vm.result.chart.colors[1]={
                            showLine: vm.showLine,
                            steppedLine: vm.step,
                            lineTension : 0,
                            type:vm.graphType,
                            pointHoverRadius:(vm.widget.graph.pointSize)+3,
                            pointRadius:vm.widget.graph.pointSize,
                            borderColor: vm.widget.graph.exitsColor,
                            backgroundColor: "rgba(0,0,0,0)",
                            pointBorderColor: vm.widget.graph.exitsColor,
                            pointBackgroundColor: vm.widget.graph.exitsColor,
                            pointHoverBorderColor: vm.widget.graph.exitsColor,
                            pointHoverBackgroundColor: vm.widget.graph.exitsColor
                        };
                    }
                    else if(vm.widget.graph.entries)
                    {
                        vm.result.chart.series[0]="Entries";
                        vm.result.chart.data[0] = [];
                        vm.result.chart.colors[0]={
                            showLine: vm.showLine,
                            steppedLine: vm.step,
                            lineTension : 0,
                            type:vm.graphType,
                            pointHoverRadius:(vm.widget.graph.pointSize)+3,
                            pointRadius:vm.widget.graph.pointSize,
                            borderColor: vm.widget.graph.entriesColor,
                            backgroundColor:  "rgba(0,0,0,0)",
                            pointBorderColor: vm.widget.graph.entriesColor,
                            pointBackgroundColor: vm.widget.graph.entriesColor,
                            pointHoverBorderColor: vm.widget.graph.entriesColor,
                            pointHoverBackgroundColor: vm.widget.graph.entriesColor
                        };
                    }
                    else if(vm.widget.graph.exits)
                    {
                        vm.result.chart.series[0]="Exits";
                        vm.result.chart.data[0] = [];
                        vm.result.chart.colors[0]={
                            showLine: vm.showLine,
                            steppedLine: vm.step,
                            lineTension : 0,
                            type:vm.graphType,
                            pointHoverRadius:(vm.widget.graph.pointSize)+3,
                            pointRadius:vm.widget.graph.pointSize,
                            borderColor: vm.widget.graph.exitsColor,
                            backgroundColor: "rgba(0,0,0,0)",
                            pointBorderColor: vm.widget.graph.exitsColor,
                            pointBackgroundColor: vm.widget.graph.exitsColor,
                            pointHoverBorderColor: vm.widget.graph.exitsColor,
                            pointHoverBackgroundColor: vm.widget.graph.exitsColor
                        };
                    }
                    for (var i = 0; i < measurements.length; i++) 
                    {
                        if(vm.resolution==="m")
                        {
                            var timestamp=moment(measurements[i].measurementDate).format('HH:mm');
                            var timestampArray=timestamp.split(":");
                            var minutes="";
                            if(timestampArray[1]<15)
                            {
                                minutes="00";
                            }
                            else if(timestampArray[1]<30)
                            {
                                minutes="15";
                            }
                            else if(timestampArray[1]<45)
                            {
                                minutes="30";
                            }
                            else
                            {
                                minutes="45";
                            }
                            var hour=timestampArray[0]+":"+minutes;
                            if(!vm.result.chart.labels.includes(hour))
                            {
                                vm.result.chart.labels.push(hour);
                                if(measurements[i].value>=0)
                                {
                                    if(vm.widget.graph.entries && vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0].push(measurements[i].value);
                                        vm.result.chart.data[1].push(0);
                                    }
                                    else if(vm.widget.graph.entries)
                                    {
                                        vm.result.chart.data[0].push(measurements[i].value);
                                    } 
                                    else if(vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0].push(0);
                                    }           
                                }
                                else 
                                {
                                    if(vm.widget.graph.entries && vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0].push(0);
                                        vm.result.chart.data[1].push(-measurements[i].value);
                                    }
                                    else if(vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0].push(-measurements[i].value);
                                    } 
                                    else if(vm.widget.graph.entries)
                                    {
                                        vm.result.chart.data[0].push(0);
                                    } 
                                }
                            }
                            else
                            {
                                if(measurements[i].value>=0)
                                {
                                    if(vm.widget.graph.entries)
                                    {
                                        vm.result.chart.data[0][vm.result.chart.data[0].length-1]+=measurements[i].value;
                                    }
                                }
                                else 
                                {
                                    if(vm.widget.graph.entries && vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[1][vm.result.chart.data[1].length-1]+= (-measurements[i].value);
                                    }
                                    else if(vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0][vm.result.chart.data[0].length-1]+= (-measurements[i].value);
                                    }
                                }
                            }
                        }
                        else if(vm.resolution==="d")
                        {
                            var timestamp=moment(measurements[i].measurementDate).format('DD/MM');
                            if(!vm.result.chart.labels.includes(timestamp))
                            {
                                vm.result.chart.labels.push(timestamp);
                                if(measurements[i].value>=0)
                                {
                                    if(vm.widget.graph.entries && vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0].push(measurements[i].value);
                                        vm.result.chart.data[1].push(0);
                                    }
                                    else if(vm.widget.graph.entries)
                                    {
                                        vm.result.chart.data[0].push(measurements[i].value);
                                    } 
                                    else if(vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0].push(0);
                                    }           
                                }
                                else 
                                {
                                    if(vm.widget.graph.entries && vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0].push(0);
                                        vm.result.chart.data[1].push(-measurements[i].value);
                                    }
                                    else if(vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0].push(-measurements[i].value);
                                    } 
                                    else if(vm.widget.graph.entries)
                                    {
                                        vm.result.chart.data[0].push(0);
                                    } 
                                }
                            }
                            else
                            {
                                if(measurements[i].value>=0)
                                {
                                    if(vm.widget.graph.entries)
                                    {
                                        vm.result.chart.data[0][vm.result.chart.data[0].length-1]+=measurements[i].value;
                                    }
                                }
                                else 
                                {
                                    if(vm.widget.graph.entries && vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[1][vm.result.chart.data[1].length-1]+= (-measurements[i].value);
                                    }
                                    else if(vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0][vm.result.chart.data[0].length-1]+= (-measurements[i].value);
                                    }
                                }
                            }
                        }
                        else if(vm.resolution==="M")
                        {
                            var timestamp=moment(measurements[i].measurementDate).format('MM/YYYY');
                            if(!vm.result.chart.labels.includes(timestamp))
                            {
                                vm.result.chart.labels.push(timestamp);
                                if(measurements[i].value>=0)
                                {
                                    if(vm.widget.graph.entries && vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0].push(measurements[i].value);
                                        vm.result.chart.data[1].push(0);
                                    }
                                    else if(vm.widget.graph.entries)
                                    {
                                        vm.result.chart.data[0].push(measurements[i].value);
                                    } 
                                    else if(vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0].push(0);
                                    }           
                                }
                                else 
                                {
                                    if(vm.widget.graph.entries && vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0].push(0);
                                        vm.result.chart.data[1].push(-measurements[i].value);
                                    }
                                    else if(vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0].push(-measurements[i].value);
                                    } 
                                    else if(vm.widget.graph.entries)
                                    {
                                        vm.result.chart.data[0].push(0);
                                    } 
                                }
                            }
                            else
                            {
                                if(measurements[i].value>=0)
                                {
                                    if(vm.widget.graph.entries)
                                    {
                                        vm.result.chart.data[0][vm.result.chart.data[0].length-1]+=measurements[i].value;
                                    }
                                }
                                else 
                                {
                                    if(vm.widget.graph.entries && vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[1][vm.result.chart.data[1].length-1]+= (-measurements[i].value);
                                    }
                                    else if(vm.widget.graph.exits)
                                    {
                                        vm.result.chart.data[0][vm.result.chart.data[0].length-1]+= (-measurements[i].value);
                                    }
                                }
                            }
                        }  
                    }
                    vm.graphCounter++;
                }
                vm.metaCounter++;
                if(vm.preCounter*vm.dates.length==vm.metaCounter)
                {
                    computeMetadata();
                }
            });
        }
        function getMeasurementsCustom(centralMeter) {
            vm.result.unit = centralMeter.specs.unit;
            
            if(vm.resolution!=="m")
            {
                var dates=vm.dates[0];
                vm.dates=[];
                var date=
                {
                    startDate:dates.startDate,
                    endDate: moment(dates.startDate).endOf('day')
                }
                vm.dates.push(date);
                var endDate=dates.endDate;
                var endDateTemp=moment(dates.startDate).endOf('day');
                var i=0;
                while (endDate > endDateTemp) {
                    i++;
                    var date=
                    {
                        startDate:moment(dates.startDate).add(i, 'days').startOf('day'),
                        endDate: moment(dates.startDate).add(i, 'days').endOf('day')
                    }
                    endDateTemp=moment(dates.startDate).add(i, 'days').endOf('day');
                    vm.dates.push(date);
                }
            }
            for(var li=0;li<vm.dates.length;li++)
            {
                calculatePlot(centralMeter,li);
            }
        }   
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
        .directive('entriesExits', entriesExits);

    function entriesExits() {
        var directive = {
            templateUrl:"app/directives/entries-exits/entries-exits.html",
            controller: EntriesExitsController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"=",
                dashboardClients:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }
    //EntriesExitsController.inject = ['$scope','$http','session','PRAGMA','$base64','pragmaapi'];
    /** @ngInject */
    function EntriesExitsController ($rootScope,$scope,$http,session,PRAGMA,$base64,pragmaapi,$timeout,pragmaTheming) {
        var vm =this;
        var fillWidgetIsRunning=false;
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        vm.devices=[];
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
		vm.url=PRAGMA.api;
        vm.tempResult=
        {
            entries:0,
            exits:0
        };
        vm.counter=0;
        vm.widget=$scope.widget;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            vm.datesColor="rgb(255,255,255)";
        }
        else
        {
            vm.datesColor="rgb(0,0,0)";
        }
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.graph.type==='lastValue')
            {
                fillWidgetMqtt(args);
            }
        });
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates.length===0 && vm.widget.graph.type!=="lastValue")
                {
                    fillWidgetDates();
                }
            }
        });
        function checkWidget()
        {
            if(vm.widget.graph.type==='lastValue')
            {
                vm.dates={
                    startDate:moment().startOf('day'),
                    endDate:moment()
                };
                var toSend=
                {
                    widget:vm.widget,
                    dates:vm.dates
                }
                fillWidget();
                pragmaapi.callRestService("https://smarthome.iti.gr:5000/entriesExitsCard","",toSend,false,"","POST",false,false).then(function(res){
                    vm.result=res.data;
                    vm.dateResult=res.data.dates;
                    /*if(vm.result.exits>vm.result.entries)
                    {
                        vm.result.exits=vm.result.entries;
                    }*/
                });
               
            }
            else
            {
                fillWidgetDates();
            }
        }
        checkWidget();
        function fillWidgetMqtt(device)
        {
            $timeout(function() {
                $scope.$apply(function () {
                    for (var i=0;i<vm.devices.length;i++)
                    {
                        if(vm.devices[i].assignment===device.deviceAssignmentToken)
                        {
                            checkWidget();
                            //fillWidget();
                            break;
                        }
                    }
                });
            }, 100); 
        }
        function fillWidgetDates()
        {
            vm.devices=[];
            vm.clients=vm.widget.clients;
            if(vm.widget.dates.length===0)
            {
                vm.dates=$scope.dashboardDate;
            }
            else
            {
                 if(vm.widget.dates[0].date==="custom")
                {
                    vm.dates=$scope.dashboardDate;
                }
                else if(vm.widget.dates[0].date==="thisYear")
                {
                    vm.dates = {
                        startDate: moment().startOf('year'),
                        endDate: moment()
                    };
                }
                else if(vm.widget.dates[0].date==="last3Months")
                {
                    vm.dates = {
                        startDate: moment().subtract(2, 'month').startOf('month'),
                        endDate: moment()
                    };
                }
                else if(vm.widget.dates[0].date==="lastMonth")
                {
                    vm.dates = {
                        startDate: moment().subtract(1, 'month').startOf('month'),
                        endDate: moment().subtract(1, 'month').endOf('month')
                    };
                }
                else if(vm.widget.dates[0].date==="thisMonth")
                {
                    vm.dates = {
                        startDate: moment().startOf('month'),
                        endDate: moment()
                    };
                }
                else if(vm.widget.dates[0].date==="last30Days")
                {
                    vm.dates = {
                        startDate: moment().subtract(29, 'days').startOf('day'),
                        endDate: moment()
                    };
                }
                else if(vm.widget.dates[0].date==="lastWeek")
                {
                    vm.dates = {
                        startDate: moment().subtract(1, 'week').startOf('week'),
                        endDate: moment().subtract(1, 'week').endOf('week')
                    };
                }
                else if(vm.widget.dates[0].date==="thisWeek")
                {
                    vm.dates = {
                        startDate: moment().startOf('week'),
                        endDate: moment()
                    };
                }
                else if(vm.widget.dates[0].date==="last7Days")
                {
                    vm.dates = {
                        startDate: moment().subtract(6, 'days').startOf('day'),
                        endDate: moment()
                    };
                }
                else if(vm.widget.dates[0].date==="yesterday")
                {
                   vm.dates = {
                        startDate: moment().subtract(1, 'day').startOf('day'),
                        endDate: moment().subtract(1, 'day').endOf('day')
                    }; 
                }
                else
                {
                    vm.dates = {
                        startDate: moment().startOf('day'),
                        endDate: moment()
                    };
                }
            }
            for(var i=0;i<vm.clients.length;i++)
            {
                for(var j=0;j<vm.clients[i].sites.length;j++)
                {
                    getDevicesCustom(vm.clients[i].token,vm.clients[i].sites[j])
                }
            }
            
        }
        function fillWidget()
        {
            if(!fillWidgetIsRunning)
            {
                fillWidgetIsRunning=true;
                vm.devices=[];
                vm.clients=vm.widget.clients;
                for(var i=0;i<vm.clients.length;i++)
                {
                    for(var j=0;j<vm.clients[i].sites.length;j++)
                    {
                        getDevicesCustom(vm.clients[i].token,vm.clients[i].sites[j])
                    }
                }
            }
        }
        function getDevicesCustom(tenant,site)
        {
             pragmaapi.callRestService(vm.url,"/devices/","?site="+site.token+"&page=1&pageSize=2000&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken="+tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
                var devices=res.data.results;
                var centralMeter=null;
                for(var i=0;i<devices.length;i++)
                {
                    for(var j=0;j<site.assignments.length;j++)
                    {
                        if(devices[i].assignment.token==site.assignments[j].token)
                        {
                            centralMeter=
                            {
                                "assignment":devices[i].assignment.token,
                                "hardwareId":devices[i].hardwareId,
                                "name":devices[i].metadata.name,
                                "type":devices[i].metadata.type,
                                "tenant":tenant,
                                "specs":JSON.parse(devices[i].specification.metadata.specs),
                                "inverted":site.assignments[j].inverted
                            };
                            vm.devices.push(centralMeter);
                            break;
                        }
                    }
                }
                //reload();
             });
        }
        function reload()
        {
            vm.counter=0;
            vm.tempResult=
            {
                entries:0,
                exits:0
            };
            if(vm.widget.graph.type==='lastValue')
            {
                vm.dates={
                    startDate:moment().startOf('day'),
                    endDate:moment()
                };
            }
            for(var i=0;i<vm.devices.length;i++)
            {
                getMeasurementsCustom(vm.devices[i]);
            }
        }
        function getMeasurementsCustom(centralMeter)
        {
            pragmaapi.callRestService(vm.url,"/assignments/"+centralMeter.assignment+"/measurements/series","?page=1&pageSize=2000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&tenantAuthToken="+centralMeter.tenant,true,vm.user.authentication,"GET",true,false).then(function(res){
                vm.counter++;
                if(res.data.length>0)
                {
                    var flag=0;
                    for(var l=0;l<res.data.length;l++)
                    {
                        if(res.data[l].measurementId==="count" || res.data[l].measurementId==="event")
                        {
                            flag=l;
                        }
                    }
                    var measurements=res.data[flag].entries;
                    if(centralMeter.inverted)
                    {
                        for(var i=0;i<measurements.length;i++)
                        {
                            if(measurements[i].value<0)
                                vm.tempResult.entries-=measurements[i].value;
                            else
                                vm.tempResult.exits+=measurements[i].value;
                        }
                    }
                    else
                    {
                        for(var i=0;i<measurements.length;i++)
                        {
                            if(measurements[i].value>0)
                                vm.tempResult.entries+=measurements[i].value;
                            else
                                vm.tempResult.exits-=measurements[i].value;
                        }
                    }
                }
                if(vm.counter==vm.devices.length)
                {
                     vm.result= vm.tempResult;
                     fillWidgetIsRunning=false;
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.directives')
        .directive('doorsensorCard', doorsensorCard);

    function doorsensorCard() {
        var directive = {
            templateUrl: "app/directives/doorsensor-card/doorsensor-card.html",
            controller: DoorsensorCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate: "="
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }

    /** @ngInject */
    function DoorsensorCardController($rootScope, $scope, $http, $base64, $timeout, session, pragmaapi, pragmaTheming, PRAGMA) {
        var vm = this;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);

        vm.widget = $scope.widget;
        vm.devices = null;
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        vm.url = PRAGMA.api;
        vm.dateColor="#6a6a6a";
        if (isDark) {
            vm.dateColor="rgb(255,255,255)";
        }

        activate();

        function activate() {
            fillWidget();

            $scope.$on('new.measurement.broadcast', function (event, args) {
                if(vm.devices) {
                    var i=0,l=vm.devices.length;
                    for (i;i<l;i++) {
                        if(vm.devices[i].assignment===args.deviceAssignmentToken) {
                            $scope.$apply(function() {
                                if(args.measurements && args.measurements.doorAlarm!=undefined) {
                                    vm.devices[i].measurements = args.measurements;
                                }
                                if(args.eventDate) {
                                    vm.devices[i].measurements.timestamp = args.eventDate;
                                }
                            });
                        }
                    }
                }
            });
        }
        
        
        function fillWidget() {
            vm.clients = vm.widget.clients;
            vm.devices = [];
            for (var i = 0; i < vm.clients.length; i++) {
                for (var j = 0; j < vm.clients[i].sites.length; j++) {
                    getDevicesCustom(vm.clients[i].token, vm.clients[i].sites[j])
                }
            }
        }

        function getDevicesCustom(tenant, site) {
            pragmaapi.callRestService(vm.url, "/devices/", "?site=" + site.token + "&page=1&pageSize=2000&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken=" + tenant, true, vm.user.authentication, "GET", true, false).then(function (res) {
                var devices = res.data.results;
                var centralMeter = null;
                for (var i = 0; i < devices.length; i++) {
                    for (var j = 0; j < site.assignments.length; j++) {
                        if (devices[i].assignment.token == site.assignments[j].token) {
                            centralMeter = {
                                "assignment": devices[i].assignment.token,
                                "name": devices[i].metadata.name,
                                "type": devices[i].metadata.type,
                                "tenant": tenant,
                                "specs": JSON.parse(devices[i].specification.metadata.specs),
                                "binType": devices[i].metadata.binType
                            };
                            vm.devices.push(centralMeter);
                        }
                    }
                }

                if(vm.devices.length) {
                    var i=0, l=vm.devices.length;
                    for(i;i<l;i++) {
                        getMeasurementsCustom(vm.devices[i]);
                    }
                }
            });
        }

        function getMeasurementsCustom(centralMeter) {
            pragmaapi.callRestService(vm.url, "/assignments/" + centralMeter.assignment + "/measurements/lastValue", "?measuredParameter=doorAlarm&tenantAuthToken=" + centralMeter.tenant, true, vm.user.authentication, "GET", true, false).then(function (res) {
                if(res.data) {
                    centralMeter.measurements = res.data;
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.directives')
		.directive('consumptionProduction', consumptionProduction)

    function consumptionProduction() {
        var directive = {
            templateUrl:"app/directives/consumption-production/consumption-production.html",
            controller: ConsumptionProductionController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate:"="
            }
        };
        return directive;
        
        function link(scope, element, attrs) {
        }
    }


    /** @ngInject */
    function ConsumptionProductionController ($scope,session,PRAGMA,pragmaapi,pragmaTheming,$q) {
        var vm =this;
		$scope.plotHasFinished = false;
		
        vm.user = session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.url=PRAGMA.api;
        vm.widget=$scope.widget;
        vm.dates=[];
        vm.result=0;
        vm.triggered=false;
        vm.unit="";
        vm.counter=0;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);
        if(isDark)
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(255,255,255)";
            }
            vm.gridLinesColor="rgba(255,255,255,";
        }
        else
        {
            if(!vm.widget.graph.widgetHasFontColor)
            {
                vm.widget.graph.fontColor="rgb(0,0,0)";
            }
            vm.gridLinesColor="rgba(0,0,0,";
        }
        vm.colors=
        [
            "3,169,244",
            "146,39,143",
            "170,198,6",
            "242,135,6",
            "191, 0, 255",
            "0,191,118",
            "102,45,145",
            "236,0,140",
            "0,148,68",
            "249,237,50",
            "239,65,54",
        ];
        vm.fill="0";
        if(vm.widget.graph.fill)
        {
            vm.fill="0.2";
        }
        var dtZone = new Date().toString().split(" ");
        var timeZoneFormattedArray = dtZone[5].split("GMT");
        vm.timeZone=timeZoneFormattedArray[1];
        fillWidget();
        $scope.$watch(function() {
            return $scope.dashboardDate;
        }, function(newValue, oldValue) {
            if(newValue!=oldValue)
            {
                $scope.dashboardDate=newValue;
                if(vm.widget.dates[0].date=="custom")
                {
                    fillWidget();
                }
				
				if($scope.report)
				{
					$scope.plotHasFinished = false;
					fillWidget();
				}
				
            }
        });
        $scope.$on('new.measurement.broadcast', function(event, args) {
            if(vm.widget.dates[0].date==="today")
            {
                fillWidgetMqtt(args);
            } 
        });

        function fillWidgetMqtt(device)
        {
            var devices=vm.widget.clients;
            for (var i=0;i<devices.length;i++)
            {
                if(devices[i].device.token===device.deviceAssignmentToken)
                {
                    if(vm.triggered)
                    {
                        vm.triggered=false;
                        fillWidget();
                    }
                    break;
                }
            }
        }
        function fillWidget()
        {
            vm.triggered=false;
            vm.tmpResults=[];
            vm.step = false;
            vm.graphType="line";
            vm.showLine=true;
            if(vm.widget.graph.graphType==='step') {
                vm.step = true;
            }
            else if(vm.widget.graph.graphType==='bar')
            {
               vm.graphType="bar";
            }
            else if(vm.widget.graph.graphType==='bubble')
            {
                vm.showLine=false;
            }
            if(vm.widget.dates[0].date==="custom")
            {
				if($scope.report)
				{
					vm.dates = {
						startDate: moment().startOf('day'),
						endDate: moment()
					};
				}
				else {
					vm.dates=$scope.dashboardDate;
				}
            }
            else if(vm.widget.dates[0].date==="thisYear")
            {
                vm.dates = {
                    startDate: moment().startOf('year'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last3Months")
            {
                vm.dates = {
                    startDate: moment().subtract(2, 'month').startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastMonth")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'month').startOf('month'),
                    endDate: moment().subtract(1, 'month').endOf('month')
                };
            }
            else if(vm.widget.dates[0].date==="thisMonth")
            {
                vm.dates = {
                    startDate: moment().startOf('month'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last30Days")
            {
                vm.dates = {
                    startDate: moment().subtract(29, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="lastWeek")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'week').startOf('week'),
                    endDate: moment().subtract(1, 'week').endOf('week')
                };
            }
            else if(vm.widget.dates[0].date==="thisWeek")
            {
                vm.dates = {
                    startDate: moment().startOf('week'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="last7Days")
            {
                vm.dates = {
                    startDate: moment().subtract(6, 'days').startOf('day'),
                    endDate: moment()
                };
            }
            else if(vm.widget.dates[0].date==="yesterday")
            {
                vm.dates = {
                    startDate: moment().subtract(1, 'day').startOf('day'),
                    endDate: moment().subtract(1, 'day').endOf('day')
                }; 
            }
            else
            {
                vm.dates = {
                    startDate: moment().startOf('day'),
                    endDate: moment()
                };
            }
            if(vm.widget.time.type==='minutes')
            {
                angular.copy(vm.dates.endDate,vm.dates.startDate);
                vm.dates.startDate = vm.dates.startDate.subtract(vm.widget.time.minutes, 'minutes');
            }
            else if(vm.widget.time.type==='time')
            {
                var dtime=parseInt(vm.timeZone)/100;
                var startDate=new Date(vm.widget.time.start);
                var startHours=startDate.getHours();
                var startMinutes=startDate.getMinutes();
                var endDate=new Date(vm.widget.time.end);
                var endHours=endDate.getHours();
                var endMinutes=endDate.getMinutes();
                vm.dates.startDate.set({hours:startHours,minutes:startMinutes});
                vm.dates.endDate.set({hours:endHours,minutes:endMinutes});
            }
            vm.resolutionType=vm.widget.time.resolutionType;
            vm.resolutionValue=vm.widget.time.resolutionValue;
            var dF = Date.parse(vm.dates.startDate) / 1000;
            var dT = Date.parse(vm.dates.endDate) / 1000;
            var def=dT-dF;
            var day = 86400;
            vm.resolutionMinutes=0;
            if (def > day && def <= day * 30 && vm.resolutionType==='m' && vm.resolutionValue<60) { 
                vm.resolutionType="d";
                vm.resolutionValue=1;
            }
            else if (def > day * 30 && vm.resolutionType!=='d' && vm.resolutionType!=='M'){
                vm.resolutionType = "M";
                vm.resolutionValue = 1;
            }
            if(vm.resolutionType==='m')
            {
                vm.resolutionMinutes=vm.resolutionValue;
            }
            else if(vm.resolutionType==='h')
            {
                vm.resolutionMinutes=vm.resolutionValue*60;
            }
            else if(vm.resolutionType==='d')
            {
                vm.resolutionMinutes=vm.resolutionValue*60*24;
            }
            else if(vm.resolutionType==='M')
            {
                vm.resolutionMinutes=vm.resolutionValue*60*24*30;
            }
            vm.datesCumulative={};
			angular.copy(vm.dates,vm.datesCumulative);
            vm.datesCumulative.startDate = vm.datesCumulative.startDate.subtract(vm.resolutionMinutes, 'minutes');
            vm.result = {
                chart: {
                    data: [],
                    labels: [],
                    series: [],
                    colors: [],
                    override: [],
                    options: {
                        legend: {
                            labels: {
                                fontColor: vm.gridLinesColor+"0.6)"
                            },
                            display: true,
                            position: "bottom"
                        },
                        elements: {
							point: {
								pointStyle: vm.widget.graph.point
							}
						},
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            xAxes: [
                                {
                                    gridLines: {
                                        display: true ,
                                        color: vm.gridLinesColor+"0.2)"
                                      },
                                    ticks: {
                                        maxRotation: 0,
                                        fontSize: 10,
                                        autoSkipPadding: 10,
                                        fontColor: vm.gridLinesColor+"0.6)"
                                    }
                                }
                            ],
                            yAxes: [
                                {
                                    gridLines: {
                                        display: true ,
                                        color: vm.gridLinesColor+"0.2)"
                                    },
                                    ticks: {
                                        maxRotation: 0,
                                        fontSize: 10,
                                        autoSkipPadding: 10,
                                        fontColor: vm.gridLinesColor+"0.6)"
                                    },
                                    scaleLabel: { 
                                        display: false,
                                        labelString: '',
                                    }
                                }
                            ]
                        },
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    var unit=vm.unit
                                    return parseFloat(tooltipItem.yLabel).toFixed(2) + " " + unit;
                                }
                            }
                        }
                    }
                }
            };
            getMeasurements();
        }
       
        function getMeasurements()
        {
            var devices=vm.widget.clients;
            vm.unit=devices[0].specs.unit;
            var promises = [];
            for (var i=0;i<devices.length;i++)
            {
                if(vm.widget.graph.type==='rawData')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                }
                else if(vm.widget.graph.type==='aggregatedValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType="+vm.resolutionType+"&resolution="+vm.resolutionValue+"&includeTotalSum=false&type=sum&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType="+vm.resolutionType+"&resolution="+vm.resolutionValue+"&includeTotalSum=false&type=mean&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='maxValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType="+vm.resolutionType+"&resolution="+vm.resolutionValue+"&includeTotalMax=true&type=max&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
                else if(vm.widget.graph.type==='minValue')
                {
                    if(devices[i].specs.cumulative==='true')
                    {
                        promises.push(pragmaapi.callRestService(PRAGMA.api,"/assignments/"+devices[i].device.token+"/measurements/series","?page=1&pageSize=3000&startDate="+encodeURIComponent(moment(vm.datesCumulative.startDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') + vm.timeZone)+"&measurementIds="+devices[i].measurement.measure+"&tenantAuthToken=" + devices[i].tenant.token, true, vm.user.authentication, "GET", true));
                    }
                    else
                    {
                        promises.push(pragmaapi.callRestService(vm.url,"/assignments/"+devices[i].device.token+"/measurementsAggregated","?startDate="+encodeURIComponent(moment(vm.dates.startDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&endDate="+encodeURIComponent(moment(vm.dates.endDate).format('YYYY-MM-DDTHH:mm:ss.000') +  vm.timeZone)+"&measuredParameter="+devices[i].measurement.measure+"&resolutionType="+vm.resolutionType+"&resolution="+vm.resolutionValue+"&includeTotalMin=true&type=min&tenantAuthToken="+devices[i].tenant.token,true,vm.user.authentication,"GET",true,false));
                    }
                }
            }
            $q.all(promises).then(function(resArray) {
                var devices=vm.widget.clients;
                for(var i=0;i<resArray.length;i++)
                {
                    var measurements=resArray[i].data;
                    if(vm.widget.graph.type==='rawData')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateRaw(measurements,true,devices[i].device.hardwareId));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateRaw(measurements,false,devices[i].device.hardwareId));
                        }
                    }
                    else if(vm.widget.graph.type==='aggregatedValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,true,devices[i].device.hardwareId));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateAggregated(measurements,false,devices[i].device.hardwareId));
                        }
                    }
                    else if(vm.widget.graph.type==='meanValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMean(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMean(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='maxValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMax(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMax(measurements,false));
                        }
                    }
                    else if(vm.widget.graph.type==='minValue')
                    {
                        if(devices[i].specs.cumulative==='true')
                        {
                            vm.tmpResults.push(calculateMin(measurements,true));
                        }
                        else
                        {
                            vm.tmpResults.push(calculateMin(measurements,false));
                        }
                    }
                }
                vm.triggered=true;
                calculateEnd();
            });
        }
        function calculateMetadata()
        {
            vm.metadata={
                total:0,
                mean:0,
                min:0,
                max:0
            }
            var counter=0;
            vm.metadata.total=0;
            vm.metadata.max=vm.result.chart.data[2][0];
            vm.metadata.min=vm.result.chart.data[2][0];
            for(var j=0;j<vm.result.chart.data[2].length;j++)
            {
                vm.metadata.total+=vm.result.chart.data[2][j];
                counter++;
                if(vm.result.chart.data[2][j]>vm.metadata.max)
                {
                    vm.metadata.max=vm.result.chart.data[2][j];
                }
                if(vm.result.chart.data[2][j]<vm.metadata.min)
                {
                    vm.metadata.min=vm.result.chart.data[2][j];
                }
            }
            vm.metadata.mean=vm.metadata.total/counter;
			$scope.plotHasFinished = true;
        }
        function calculateEnd()
        {
            var devices=vm.widget.clients;
            vm.results=[];
            if(vm.widget.graph.aggregated)
            {
                if(vm.widget.graph.type==='aggregatedValue')
                {
                    vm.result.chart.series=[];
                    vm.result.chart.series.push(vm.widget.title);
                    vm.result.chart.colors=[];
                    var tmp = vm.widget.graph.backgroundColor.split("rgb(");
                    var tmp2=tmp[1].split(")");
                    var lastTmp=tmp2[0].split(",");
                    var clr=lastTmp;
                    if(!vm.widget.graph.fill)
                    {
                        var bgclr="rgba("+clr+",0)";
                    }
                    else
                    {
                        var bgclr="rgba("+clr+",0.2)";
                    }
                    vm.result.chart.colors.push({
                        type:vm.graphType,
                        showLine: vm.showLine,
                        steppedLine: vm.step,
                        lineTension : 0,
                        pointHoverRadius:(vm.widget.graph.pointSize)+3,
                        pointRadius:vm.widget.graph.pointSize,
                        borderColor: vm.widget.graph.backgroundColor,
                        backgroundColor: bgclr,
                        pointBorderColor: vm.widget.graph.backgroundColor,
                        pointBackgroundColor: vm.widget.graph.backgroundColor,
                        pointHoverBorderColor: vm.widget.graph.backgroundColor,
                        pointHoverBackgroundColor: vm.widget.graph.backgroundColor
                    });
                    vm.result.chart.data=[];
                    vm.result.chart.data.push([]);
                    vm.result.chart.labels=[];
                    for(var i=0;i<vm.tmpResults.length;i++)
                    {
                        for(var j=0;j<vm.tmpResults[i].length;j++)
                        {
                            if(i==0)
                            {
                                vm.result.chart.data[0].push(vm.tmpResults[0][j].value)
                                if(vm.resolutionType==='m' || vm.resolutionType==='h')
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[0][j].timestamp).format('HH:mm'))
                                }
                                else
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[0][j].timestamp).format('DD/MM'))
                                }
                            }
                            else
                            {
                                vm.result.chart.data[0][j]=vm.result.chart.data[0][j]+vm.tmpResults[i][j].value;
                            }
                        }
                    }
                }
                else if(vm.widget.graph.type==='meanValue')
                {
                    vm.result.chart.series=[];
                    vm.result.chart.series.push(vm.widget.title);
                    vm.result.chart.colors=[];
                    var tmp = vm.widget.graph.backgroundColor.split("rgb(");
                    var tmp2=tmp[1].split(")");
                    var lastTmp=tmp2[0].split(",");
                    var clr=lastTmp;
                    if(!vm.widget.graph.fill)
                    {
                        var bgclr="rgba("+clr+",0)";
                    }
                    else
                    {
                        var bgclr="rgba("+clr+",0.2)";
                    }
                    vm.result.chart.colors.push({
                        type:vm.graphType,
                        showLine: vm.showLine,
                        steppedLine: vm.step,
                        lineTension : 0,
                        pointHoverRadius:(vm.widget.graph.pointSize)+3,
                        pointRadius:vm.widget.graph.pointSize,
                        borderColor: vm.widget.graph.backgroundColor,
                        backgroundColor: bgclr,
                        pointBorderColor: vm.widget.graph.backgroundColor,
                        pointBackgroundColor: vm.widget.graph.backgroundColor,
                        pointHoverBorderColor: vm.widget.graph.backgroundColor,
                        pointHoverBackgroundColor: vm.widget.graph.backgroundColor
                    });
                    vm.result.chart.data=[];
                    vm.result.chart.data.push([]);
                    vm.result.chart.labels=[];
                    for(var i=0;i<vm.tmpResults.length;i++)
                    {
                        for(var j=0;j<vm.tmpResults[i].length;j++)
                        {
                            if(i==0)
                            {
                                vm.result.chart.data[0].push(vm.tmpResults[0][j].value)
                                if(vm.resolutionType==='m' || vm.resolutionType==='h')
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[0][j].timestamp).format('HH:mm'))
                                }
                                else
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[0][j].timestamp).format('DD/MM'))
                                }
                            }
                            else
                            {
                                vm.result.chart.data[0][j]=vm.result.chart.data[0][j]+vm.tmpResults[i][j].value;
                            }
                        }
                    }
                    for(var i=0;i<vm.result.chart.data[0].length;i++)
                    {
                        vm.result.chart.data[0][i]=vm.result.chart.data[0][i]/vm.tmpResults.length;
                    }
                }
                else
                {
                    vm.result.chart.series=[];
                    vm.result.chart.colors=[];
                    vm.result.chart.data=[];
                    vm.result.chart.labels=[];
                    var maxDates=0
                    if(vm.tmpResults.length>1)
                    {
                        for(var i=1;i<vm.tmpResults.length;i++)
                        {
                            if(vm.tmpResults[i].length>vm.tmpResults[i-1].length)
                            {
                                maxDates=i;
                            }
                        }
                    }
                    for(var i=0;i<vm.tmpResults.length;i++)
                    {
                        vm.result.chart.series.push(devices[i].site.name+" -> "+devices[i].device.name+" ("+devices[i].measurement.name+" )");
                        vm.result.chart.data.push([]);
                        vm.result.chart.colors.push({
                            type:vm.graphType,
                            showLine: vm.showLine,
                            steppedLine: vm.step,
                            lineTension : 0,
                            pointHoverRadius:(vm.widget.graph.pointSize)+3,
                            pointRadius:vm.widget.graph.pointSize,
                            borderColor: "rgba(" + vm.colors[i] + ",1)",
                            backgroundColor: "rgba(" + vm.colors[i] + ","+vm.fill+")",
                            pointBorderColor: "rgba(" + vm.colors[i] + ",1)",
                            pointBackgroundColor: "rgba(" + vm.colors[i] + ",1)",
                            pointHoverBorderColor: "rgba(" + vm.colors[i] + ",1)",
                            pointHoverBackgroundColor: "rgba(" + vm.colors[i] + ",1)"
                        });
                        for(var j=0;j<vm.tmpResults[i].length;j++)
                        {
                            vm.result.chart.data[i].push(vm.tmpResults[i][j].value)
                            if(i==maxDates)
                            {
                                if(vm.resolutionType==='m' || vm.resolutionType==='h')
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[i][j].timestamp).format('HH:mm'))
                                }
                                else
                                {
                                    vm.result.chart.labels.push(moment(vm.tmpResults[i][j].timestamp).format('DD/MM'))
                                }
                            }
                        }
                    }
                }
            }
            else
            {
                vm.result.chart.series=[];
                vm.result.chart.colors=[];
                vm.result.chart.data=[];
                vm.result.chart.labels=[];
                var maxDates=0;
                if(vm.tmpResults.length>1)
                {
                    for(var i=1;i<vm.tmpResults.length;i++)
                    {
                        if(vm.tmpResults[i].data.length>vm.tmpResults[i-1].data.length)
                        {
                            maxDates=i;
                        }
                    }
                }
                for(var i=0;i<vm.tmpResults.length;i++)
                {
                    vm.result.chart.data.push([]);
                    for(var j=0;j<vm.tmpResults[i].data.length;j++)
                    {
                        vm.result.chart.data[i].push(vm.tmpResults[i].data[j].value)
                        if(i==maxDates)
                        {
                            if(vm.resolutionType==='m' || vm.resolutionType==='h')
                            {
                                vm.result.chart.labels.push(moment(vm.tmpResults[i].data[j].timestamp).format('HH:mm'))
                            }
                            else
                            {
                                vm.result.chart.labels.push(moment(vm.tmpResults[i].data[j].timestamp).format('DD/MM'))
                            }
                        }
                    }
                }
            }
            var pvId=0;
            for(var i=0;i<vm.tmpResults.length;i++)
            {
                if(vm.tmpResults[i].device==='2303d93d-0664-4aad-8bad-434ddf65a546')
                {
                    pvId=i;
                    vm.result.chart.series.push("PV Energy Generation");
                    vm.result.chart.colors.push({
                        type:vm.graphType,
                        showLine: vm.showLine,
                        steppedLine: vm.step,
                        lineTension : 0,
                        pointHoverRadius:(vm.widget.graph.pointSize)+3,
                        pointRadius:vm.widget.graph.pointSize,
                        borderColor: "rgba(51, 193, 0,1)",
                        backgroundColor: "rgba(51, 193, 0,0)",
                        pointBorderColor: "rgba(51, 193, 0,1)",
                        pointBackgroundColor: "rgba(51, 193, 0,1)",
                        pointHoverBorderColor: "rgba(51, 193, 0,1)",
                        pointHoverBackgroundColor: "rgba(51, 193, 0,1)"
                    });
                }
                else
                {
                    vm.result.chart.series.push("Energy Consumption");
                    vm.result.chart.colors.push({
                        type:vm.graphType,
                        showLine: vm.showLine,
                        steppedLine: vm.step,
                        lineTension : 0,
                        pointHoverRadius:(vm.widget.graph.pointSize)+3,
                        pointRadius:vm.widget.graph.pointSize,
                        borderColor: "rgba(255, 171, 2,1)",
                        backgroundColor: "rgba(255, 171, 2,0)",
                        pointBorderColor: "rgba(255, 171, 2,1)",
                        pointBackgroundColor: "rgba(255, 171, 2,1)",
                        pointHoverBorderColor: "rgba(255, 171, 2,1)",
                        pointHoverBackgroundColor: "rgba(255, 171, 2,1)"
                    });
                }
            }
            vm.result.chart.data.push([]);
            vm.result.chart.series.push("Net Energy");
            vm.result.chart.colors.push({
                type:'bar',
                showLine: vm.showLine,
                steppedLine: vm.step,
                lineTension : 0,
                pointHoverRadius:(vm.widget.graph.pointSize)+3,
                pointRadius:vm.widget.graph.pointSize,
                borderColor: "rgba(0, 4, 230,1)",
                backgroundColor: "rgba(0, 4, 230,0.3)",
                pointBorderColor: "rgba(0, 4, 230,1)",
                pointBackgroundColor: "rgba(0, 4, 230,1)",
                pointHoverBorderColor: "rgba(0, 4, 230,1)",
                pointHoverBackgroundColor: "rgba(0, 4, 230,1)"
            });
            var max=vm.result.chart.data[0].length;
            if(vm.result.chart.data[1].length<max)
            {
                max=vm.result.chart.data[1].length;
            }
            for(var l=0;l<max;l++)
            {
                if(pvId==0)
                {   
                    var val= Math.abs(vm.result.chart.data[0][l]) - Math.abs(vm.result.chart.data[1][l]);
                }
                else
                {
                    var val= Math.abs(vm.result.chart.data[1][l]) - Math.abs(vm.result.chart.data[0][l]);
                }
                vm.result.chart.data[2].push(val);
            }
            calculateMetadata();
        }

        function calculateRaw(measurements,cumulative,deviceId)
        {
            var response=[];
            if(cumulative)
            {
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    if(deviceId!=='2303d93d-0664-4aad-8bad-434ddf65a546')
                    {
                        val=-val;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements[0].entries;
                for(var i=0;i<foo.length;i++)
                {
                    var val=foo[i].value
                    if(deviceId!=='2303d93d-0664-4aad-8bad-434ddf65a546')
                    {
                        val=-val;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    response.push(tmp);
                }
            }
            var resp={'data':response,'device':deviceId}
            return resp;
        }

        function calculateAggregated(measurements,cumulative,deviceId)
        {
            var response=[];
            if(cumulative)
            {
                var tmpResponse=[];
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    if(deviceId!=='2303d93d-0664-4aad-8bad-434ddf65a546')
                    {
                        val=-val;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    tmpResponse.push(tmp);
                }
                var tmpArray=[];
                var counter=0;
                var current=tmpResponse[0].timestamp;
                var tmpWid=
                {
                    timestamp:current,
                    values:[]
                }
                tmpArray.push(tmpWid);
                for(var i=0;i<tmpResponse.length;i++)
                {
                    if(tmpResponse[i].timestamp-current>=vm.resolutionMinutes*60000)
                    {
                        current=tmpResponse[i].timestamp;
                        var tmpWid=
                        {
                            timestamp:current,
                            values:[]
                        }
                        tmpWid.values.push(tmpResponse[i].value)
                        tmpArray.push(tmpWid);
                        counter++;
                    }
                    else
                    {
                        tmpArray[counter].values.push(tmpResponse[i].value)
                    }
                }
                for(var i=0;i<tmpArray.length;i++)
                {
                    var count=0;
                    for (var j=0;j<tmpArray[i].values.length;j++)
                    {
                        count+=tmpArray[i].values[j];
                    }
                    var tmp=
                    {
                        value:count,
                        timestamp:tmpArray[i].timestamp
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements.data;
                for(var i=0;i<foo.length;i++)
                {
                    var val=foo[i].d;
                    if(deviceId!=='2303d93d-0664-4aad-8bad-434ddf65a546')
                    {
                        val=-val;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:foo[i].t
                    }
                    response.push(tmp);
                }
            }
            var resp={data:response,device:deviceId}
            return resp;
        }

        function calculateMean(measurements,cumulative)
        {
            var response=[];
            if(cumulative)
            {
                var tmpResponse=[];
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    tmpResponse.push(tmp);
                }
                var tmpArray=[];
                var counter=0;
                var current=tmpResponse[0].timestamp;
                var tmpWid=
                {
                    timestamp:current,
                    values:[]
                }
                tmpArray.push(tmpWid);
                for(var i=0;i<tmpResponse.length;i++)
                {
                    if(tmpResponse[i].timestamp-current>=vm.resolutionMinutes*60000)
                    {
                        current=tmpResponse[i].timestamp;
                        var tmpWid=
                        {
                            timestamp:current,
                            values:[]
                        }
                        tmpWid.values.push(tmpResponse[i].value)
                        tmpArray.push(tmpWid);
                        counter++;
                    }
                    else
                    {
                        tmpArray[counter].values.push(tmpResponse[i].value)
                    }
                }
                for(var i=0;i<tmpArray.length;i++)
                {
                    var count=0;
                    for (var j=0;j<tmpArray[i].values.length;j++)
                    {
                        count+=tmpArray[i].values[j];
                    }
                    var tmp=
                    {
                        value:count/tmpArray[i].values.length,
                        timestamp:tmpArray[i].timestamp
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements.data;
                for(var i=0;i<foo.length;i++)
                {
                    var tmp=
                    {
                        value:foo[i].d,
                        timestamp:foo[i].t
                    }
                    response.push(tmp);
                }
            }
            return response;
        }

        function calculateMax(measurements,cumulative)
        {
            var response=[];
            if(cumulative)
            {
                var tmpResponse=[];
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    tmpResponse.push(tmp);
                }
                var tmpArray=[];
                var counter=0;
                var current=tmpResponse[0].timestamp;
                var tmpWid=
                {
                    timestamp:current,
                    values:[]
                }
                tmpArray.push(tmpWid);
                for(var i=0;i<tmpResponse.length;i++)
                {
                    if(tmpResponse[i].timestamp-current>=vm.resolutionMinutes*60000)
                    {
                        current=tmpResponse[i].timestamp;
                        var tmpWid=
                        {
                            timestamp:current,
                            values:[]
                        }
                        tmpWid.values.push(tmpResponse[i].value)
                        tmpArray.push(tmpWid);
                        counter++;
                    }
                    else
                    {
                        tmpArray[counter].values.push(tmpResponse[i].value)
                    }
                }
                for(var i=0;i<tmpArray.length;i++)
                {
                    var max=tmpArray[i].values[0];
                    for (var j=0;j<tmpArray[i].values.length;j++)
                    {
                        if(tmpArray[i].values[j]>max)
                        {
                            max=tmpArray[i].values[j];
                        }
                    }
                    var tmp=
                    {
                        value:max,
                        timestamp:tmpArray[i].timestamp
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements.data;
                for(var i=0;i<foo.length;i++)
                {
                    var tmp=
                    {
                        value:foo[i].d,
                        timestamp:foo[i].t
                    }
                    response.push(tmp);
                }
            }
            return response;
        }

        function calculateMin(measurements,cumulative)
        {
            var response=[];
            if(cumulative)
            {
                var tmpResponse=[];
                var foo=measurements[0].entries;
                for(var i=1;i<foo.length;i++)
                {
                    var val=foo[i].value-foo[i-1].value;
                    if(val<0)
                    {
                        val=foo[i].value;
                    }
                    var tmp=
                    {
                        value:val,
                        timestamp:Date.parse(new Date(foo[i].measurementDate))
                    }
                    tmpResponse.push(tmp);
                }
                var tmpArray=[];
                var counter=0;
                var current=tmpResponse[0].timestamp;
                var tmpWid=
                {
                    timestamp:current,
                    values:[]
                }
                tmpArray.push(tmpWid);
                for(var i=0;i<tmpResponse.length;i++)
                {
                    if(tmpResponse[i].timestamp-current>=vm.resolutionMinutes*60000)
                    {
                        current=tmpResponse[i].timestamp;
                        var tmpWid=
                        {
                            timestamp:current,
                            values:[]
                        }
                        tmpWid.values.push(tmpResponse[i].value)
                        tmpArray.push(tmpWid);
                        counter++;
                    }
                    else
                    {
                        tmpArray[counter].values.push(tmpResponse[i].value)
                    }
                }
                for(var i=0;i<tmpArray.length;i++)
                {
                    var min=tmpArray[i].values[0];
                    for (var j=0;j<tmpArray[i].values.length;j++)
                    {
                        if(tmpArray[i].values[j]<min)
                        {
                            min=tmpArray[i].values[j];
                        }
                    }
                    var tmp=
                    {
                        value:min,
                        timestamp:tmpArray[i].timestamp
                    }
                    response.push(tmp);
                }
            }
            else
            {
                var foo=measurements.data;
                for(var i=0;i<foo.length;i++)
                {
                    var tmp=
                    {
                        value:foo[i].d,
                        timestamp:foo[i].t
                    }
                    response.push(tmp);
                }
            }
            return response;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.directives')
        .directive('bloodpressureCard', bloodpressureCard);

    function bloodpressureCard() {
        var directive = {
            templateUrl: "app/directives/bloodpressure-card/bloodpressure-card.html",
            controller: BloodpressureCardController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                widget: "=",
                dashboardDate: "="
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }

    /** @ngInject */
    function BloodpressureCardController($rootScope, $scope, $http, $base64, $timeout, $q, session, pragmaapi, pragmaTheming, PRAGMA) {
        var vm = this;
        var themes = pragmaTheming.themes;
        var isDark = (themes.active.name.indexOf('Dark') >= 0);

        vm.widget = $scope.widget;
        vm.device = null;
        vm.user = session.getUser();
        vm.user.authentication = vm.user.username + ":" + vm.user.password;
        vm.url = PRAGMA.api;
        vm.labelColor = "#6a6a6a"
        vm.dateColor="#6a6a6a";
        if (isDark) {
            vm.labelColor ="rgb(255,255,255)";
            vm.dateColor="rgb(255,255,255)";
        }

        activate();

        function activate() {
            fillWidget();

            $scope.$on('new.measurement.broadcast', function (event, args) {
                if (vm.device && vm.device.assignment === args.deviceAssignmentToken) {
                    $scope.$apply(function() {
                        if(args.measurements) {
                            for(var key in vm.device.measurements) {
                                if(args.measurements[key]!=undefined) {
                                    vm.device.measurements[key] = args.measurements[key];
                                }
                            }
                        }

                        if(args.eventDate) {
                            vm.device.measurements.timestamp = args.eventDate;
                        }
                    });
                }
            });
        }
        
        
        function fillWidget() {
            vm.clients = vm.widget.clients;
            vm.device = {};
            for (var i = 0; i < vm.clients.length; i++) {
                for (var j = 0; j < vm.clients[i].sites.length; j++) {
                    getDevicesCustom(vm.clients[i].token, vm.clients[i].sites[j])
                }
            }
        }

        function getDevicesCustom(tenant, site) {
            pragmaapi.callRestService(vm.url, "/devices/", "?site=" + site.token + "&page=1&pageSize=2000&includeDeleted=false&excludeAssigned=false&includeSpecification=true&includeAssignment=true&tenantAuthToken=" + tenant, true, vm.user.authentication, "GET", true, false).then(function (res) {
                var devices = res.data.results;
                var centralMeter = null;
                for (var i = 0; i < devices.length; i++) {
                    for (var j = 0; j < site.assignments.length; j++) {
                        if (devices[i].assignment.token == site.assignments[j].token) {
                            centralMeter =
                                {
                                    "assignment": devices[i].assignment.token,
                                    "name": devices[i].metadata.name,
                                    "type": devices[i].metadata.type,
                                    "tenant": tenant,
                                    "specs": JSON.parse(devices[i].specification.metadata.specs),
                                    "binType": devices[i].metadata.binType
                                };
                            vm.device = centralMeter;
                            break;
                        }
                    }
                }
                getMeasurementsCustom(vm.device);
            });
        }

        function getMeasurementsCustom(centralMeter) {
            // pragmaapi.callRestService(vm.url, "/assignments/" + centralMeter.assignment + "/measurements/lastValue", "?tenantAuthToken=" + centralMeter.tenant, true, vm.user.authentication, "GET", true, false).then(function (res) {
            //     if(res.data) {
            //         centralMeter.measurements = res.data;
            //     }
            // });
            var promises = [
                pragmaapi.callRestService(vm.url, "/assignments/" + centralMeter.assignment + "/measurements/lastValue", "?measuredParameter=systolic&tenantAuthToken=" + centralMeter.tenant, true, vm.user.authentication, "GET", true, false),
                pragmaapi.callRestService(vm.url, "/assignments/" + centralMeter.assignment + "/measurements/lastValue", "?measuredParameter=diastolic&tenantAuthToken=" + centralMeter.tenant, true, vm.user.authentication, "GET", true, false),
                pragmaapi.callRestService(vm.url, "/assignments/" + centralMeter.assignment + "/measurements/lastValue", "?measuredParameter=pulse&tenantAuthToken=" + centralMeter.tenant, true, vm.user.authentication, "GET", true, false)
            ];

            $q.all(promises).then(function(resArray) {
                if(resArray && resArray.length){
                    centralMeter.measurements = {};

                    var i=0, l=resArray.length;
                    for(i;i<l;i++) {
                        var res = resArray[i];
                        if(res.data) {
                            for(var key in res.data) {
                                centralMeter.measurements[key] = res.data[key];
                            }
                        }
                    }
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('pragmaTheming', pragmaThemingService);

    /** @ngInject */
    function pragmaThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, pragmaPalettes, pragmaThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            pragmaThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(pragmaPalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(pragmaThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var pragmaThemes = {
        default  : {
            primary   : {
                name: 'pragma-default',
                hues: {
                    'default': '500',
                    'hue-1'  : '900',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'pragma-default',
                hues: {
                    'default': '500'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : 'A100',
                    'hue-2'  : '700',
                    'hue-3'  : '900'
                }
            }
        },
        'Dark-Night'  : {
            primary   : {
                name: 'pragma-dark-night',
                hues: {
                    'default': '500',
                    'hue-1'  : '800',
                    'hue-2'  : '500',
                    'hue-3'  : '900'
                }
            },
            accent    : {
                name: 'pragma-dark-night',
                hues: {
                    'default': 'A700'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'pragma-dark-night',
                hues: {
                    'default': '50',
                    'hue-1'  : '600',
                    'hue-2'  : '100',
                    'hue-3'  : '900'
                }
            }
        },
        'Dark-Purple'  : {
            primary   : {
                name: 'pragma-dark-purple',
                hues: {
                    'default': '500',
                    'hue-1'  : '800',
                    'hue-2'  : '500',
                    'hue-3'  : '900'
                }
            },
            accent    : {
                name: 'pragma-dark-purple',
                hues: {
                    'default': 'A700'
                }
            },
            warn      : {
                name: 'red',
                hues: {
                    'default': '50'
                }
            },
            background: {
                name: 'pragma-dark-purple',
                hues: {
                    'default': '50',
                    'hue-1'  : '600',
                    'hue-2'  : '100',
                    'hue-3'  : '900'
                }
            }
        },
        'Sea-Blue'  : {
            primary   : {
                name: 'sea-blue',
                hues: {
                    'default': '500',
                    'hue-1'  : '900',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'sea-blue',
                hues: {
                    'default': '500'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : 'A100',
                    'hue-2'  : '700',
                    'hue-3'  : '900'
                }
            }
        },
        'Dark-Blue'  : {
            primary   : {
                name: 'dark-blue',
                hues: {
                    'default': '500',
                    'hue-1'  : '800',
                    'hue-2'  : '500',
                    'hue-3'  : '900'
                }
            },
            accent    : {
                name: 'dark-blue',
                hues: {
                    'default': 'A700'
                }
            },
            warn      : {
                name: 'red',
                hues: {
                    'default': '50'
                }
            },
            background: {
                name: 'dark-blue',
                hues: {
                    'default': '50',
                    'hue-1'  : '600',
                    'hue-2'  : '100',
                    'hue-3'  : '900'
                }
            }
        },
        'Smart-Orange'  : {
            primary   : {
                name: 'smart-orange',
                hues: {
                    'default': '500',
                    'hue-1'  : '900',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'smart-orange',
                hues: {
                    'default': '500'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : 'A100',
                    'hue-2'  : '700',
                    'hue-3'  : '900'
                }
            }
        },
		
		
		
        'Teal'  : {
            primary   : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '900',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : 'A100',
                    'hue-2'  : '700',
                    'hue-3'  : '900'
                }
            }
        },
        'Red'  : {
            primary   : {
                name: 'red',
                hues: {
                    'default': '500',
                    'hue-1'  : '900',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'red',
                hues: {
                    'default': '500'
                }
            },
            warn      : {
                name: 'purple'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : 'A100',
                    'hue-2'  : '700',
                    'hue-3'  : '900'
                }
            }
        },
        'Purple'  : {
            primary   : {
                name: 'purple',
                hues: {
                    'default': '500',
                    'hue-1'  : '900',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'purple',
                hues: {
                    'default': '500'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : 'A100',
                    'hue-2'  : '700',
                    'hue-3'  : '900'
                }
            }
        },
        'Indigo'  : {
            primary   : {
                name: 'indigo',
                hues: {
                    'default': '500',
                    'hue-1'  : '900',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'indigo',
                hues: {
                    'default': '500'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : 'A100',
                    'hue-2'  : '700',
                    'hue-3'  : '900'
                }
            }
        },
        'Blue-Grey'  : {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '500',
                    'hue-1'  : '900',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'blue-grey',
                hues: {
                    'default': '500'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : 'A100',
                    'hue-2'  : '700',
                    'hue-3'  : '900'
                }
            }
        },
        'Green'  : {
            primary   : {
                name: 'green',
                hues: {
                    'default': '500',
                    'hue-1'  : '900',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'green',
                hues: {
                    'default': '500'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : 'A100',
                    'hue-2'  : '700',
                    'hue-3'  : '900'
                }
            }
        },
        'Orange'  : {
            primary   : {
                name: 'orange',
                hues: {
                    'default': '500',
                    'hue-1'  : '900',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'orange',
                hues: {
                    'default': '500'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : 'A100',
                    'hue-2'  : '700',
                    'hue-3'  : '900'
                }
            }
        },
        'Brown'  : {
            primary   : {
                name: 'brown',
                hues: {
                    'default': '500',
                    'hue-1'  : '900',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'brown',
                hues: {
                    'default': '500'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : 'A100',
                    'hue-2'  : '700',
                    'hue-3'  : '900'
                }
            }
        },
        'Grey'  : {
            primary   : {
                name: 'grey',
                hues: {
                    'default': '500',
                    'hue-1'  : '900',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'grey',
                hues: {
                    'default': '500'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : 'A100',
                    'hue-2'  : '700',
                    'hue-3'  : '900'
                }
            }
        },
        'Pink'  : {
            primary   : {
                name: 'pink',
                hues: {
                    'default': '500',
                    'hue-1'  : '900',
                    'hue-2'  : '700',
                    'hue-3'  : '50'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '500'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': '50',
                    'hue-1'  : 'A100',
                    'hue-2'  : '700',
                    'hue-3'  : '900'
                }
            }
        }
		/*
		'paleBlueTheme'  : {
			primary:{
				name: 'pragma-paleblue',
				hues:{
					'default':'700',
					'hue-1':'500',
					'hue-2':'600',
					'hue-3':'400'
				}
			},
			accent:{
				name:'blue',
				hues:{
					'default':'600',
					'hue-1':'400',
					'hue-2':'700',
					'hue-3':'A100'
				}
			},
			warn:{
				name:'red',
				hues:{
					'default':'500',
					'hue-1':'300',
					'hue-2':'800',
					'hue-3':'A100'
				}
			},
			background:{
				name:'grey',
				hues:{
					'default':'A100',
					'hue-1':'A100',
					'hue-2':'100',
					'hue-3':'300'
				}
			}
		},
		'pinkTheme': {
            primary   : {
                name: 'pink',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'pragma-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
		*/
    };

    angular
        .module('app.core')
        .constant('pragmaThemes', pragmaThemes);
})();
(function () {
    'use strict';

    var pragmaPalettes = [
		{
			name: 'pragma-default',
			options: {
                '50': '#e0e5ea',
                '100': '#A7DFFA',
                '200': '#7DD1FA',
                '300': '#3AB7F2',
                '400': '#1FAAED',
                '500': '#039BE5',
                '600': '#0389CC',
                '700': '#0374AB',
                '800': '#025C91',
                '900': '#004472',
                'A100': '#5BD5F5',
                'A200': '#11BFF5',
                'A400': '#00A6F5',
                'A700': '#0091EA',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
			}
		},
		{
            name: 'pragma-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'pragma-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'pragma-dark-night',
            options: {
				'50': '#232323',
				'100': '#7A7A7A',
				'200': '#595959',
				'300': '#444444',
				'400': '#353535',
				'500': '#303030',
				'600': '#282828',
				'700': '#232323',
				'800': '#1F1F1F',
				'900': '#161616',
				'A100': '#FFFFFF',
				'A200': '#EFEFEF',
				'A400': '#D8D8D8',
				'A700': '#C8C8C8',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'pragma-dark-purple',
            options: {
				'50': '#c4c4c4',
				'100': '#939598',
				'200': '#7c7c7f',
				'300': '#696970',
				'400': '#585863',
				'500': '#4d4d5b',
				'600': '#3f3f4f',
				'700': '#353542',
				'800': '#30303d',
				'900': '#2b2b36',
				'A100': '#f2f2f2',
				'A200': '#e5e5e5',
				'A400': '#d1d1d1',
				'A700': '#bcbec0',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'sea-blue',
            options: {
				'50':   '#F5F5F5',
				'100':  '#161616',
				'200':  '#9AD4ED',
				'300':  '#81CBEB',
				'400':  '#5CBEE8',
				'500':  '#2CADE4',
				'600':  '#3284BE',
				'700':  '#385B98',
				'800':  '#3B567D',
				'900':  '#3E5264',
				'A100': '#4ED4ED',
				'A200': '#00BFD3',
				'A400': '#46A0B8',
				'A700': '#3E6C83',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
		{
            name: 'dark-blue',
            options: {
				'50':   '#c4c4c4',
				'100':  '#939598',
				'200':  '#67727b',
				'300':  '#415461',
				'400':  '#374b59',
				'500':  '#2c4251',
				'600':  '#233a4a',
				'700':  '#1a313f',
				'800':  '#0b222d',
				'900':  '#011821',
				'A100': '#ffffff',
				'A200': '#efefef',
				'A400': '#d8d8d8',
				'A700': '#c8c8c8',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
		{
            name: 'smart-orange',
            options: {
				'50':   '#f2f2f2',
				'100':  '#f5e2c7',
				'200':  '#f7d8ab',
				'300':  '#fac577',
				'400':  '#fcb752',
				'500':  '#ffa726',
				'600':  '#f8932a',
				'700':  '#f2802d',
				'800':  '#ec6816',
				'900':  '#e65100',
				'A100': '#ffd180',
				'A200': '#ffab40',
				'A400': '#ff9100',
				'A700': '#ff6d00',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('pragmaPalettes', pragmaPalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('pragmaGenerator', pragmaGeneratorService);

    /** @ngInject */
    function pragmaGeneratorService($cookies, $log, pragmaTheming)
    {
		// Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(pragmaTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(pragmaTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            pragmaTheming.setThemesList(themes);
			pragmaTheming.setActiveTheme('default');

			/*
            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
				pragmaTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                pragmaTheming.setActiveTheme('default');
            }
			*/
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';
			
			// PRAGMA Additions
			cssTemplate += '\n\n/* PRAGMA Additions */\n' +
							
							'\n/* Borders */\n' +
							
							'[md-theme="@themeName"] .md-border {\n' +
								'border-color: @primaryDefaultColor !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-border.md-hue-1 {\n' +
								'border-color: @primaryHue1Color !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-border.md-hue-2 {\n' +
								'border-color: @primaryHue2Color !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-border.md-hue-3 {\n' +
								'border-color: @primaryHue3Color !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-primary-border {\n' +
								'border-color: @primaryDefaultColor !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-primary-border.md-hue-1 {\n' +
								'border-color: @primaryHue1Color !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-primary-border.md-hue-2 {\n' +
								'border-color: @primaryHue2Color !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-primary-border.md-hue-3 {\n' +
								'border-color: @primaryHue3Color !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-accent-border {\n' +
								'border-color: @accentDefaultColor !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-accent-border.md-hue-1 {\n' +
								'border-color: @accentHue1Color !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-accent-border.md-hue-2 {\n' +
								'border-color: @accentHue2Color !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-accent-border.md-hue-3 {\n' +
								'border-color: @accentHue3Color !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-warn-border {\n' +
								'border-color: @warnDefaultColor !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-warn-border.md-hue-1 {\n' +
								'border-color: @warnHue1Color !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-warn-border.md-hue-2 {\n' +
								'border-color: @warnHue2Color !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-warn-border.md-hue-3 {\n' +
								'border-color: @warnHue3Color !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-background-border {\n' +
								'border-color: @backgroundDefaultColor !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-background-border.md-hue-1 {\n' +
								'border-color: @backgroundHue1Color !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-background-border.md-hue-2 {\n' +
								'border-color: @backgroundHue2Color;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-background-border.md-hue-3 {\n' +
								'border-color: @backgroundHue3Color !important;\n' +
							'}\n' +
							
							'\n/* Horizontal Navigation Menu */\n' +
							
							'[md-theme="@themeName"] #horizontal-navigation .ms-navigation-horizontal .horizontal .ms-navigation-horizontal-item .ms-navigation-horizontal-button {\n' +
								'color:@backgroundHue2Color;\n' +
							'}\n' +
							
							'md-content.md-@themeName-theme {\n' +
								'color: @backgroundHue1Contrast1;\n' +
							'}\n' +
							
							
							
							'\n/* DateRange */\n' +
							/*
							'[md-theme="@themeName"] .daterange-wrapper .daterange input {\n' +
								'background: @backgroundDefaultColor !important;color:@backgroundHue2Color;\n' +
							'}\n' +
							*/
							
							//'.md-@themeName-theme .md-datepicker-input {\n' +
							//	'color: @backgroundHue1Contrast3 !important;\n' +
							//'}\n' +
							
							
							'[md-theme="@themeName"] .ms-card .ms-card-content-wrapper {\n' +
								'background: @primaryDefaultColor;\n' +
							'}\n' +
							
							
							
							'[md-theme="@themeName"] .custom-icon-button-wrapper {\n' +
								'background: @primaryDefaultColor;\n' +
							'}\n' +
							
							'.custom-icon-button-wrapper .md-icon.md-@themeName-theme, .custom-icon-button-wrapper md-icon.md-@themeName-theme {\n' +
								'color: @primaryHue1Contrast2;\n' +
							'}\n' +
							
							'md-radio-button.md-@themeName-theme .md-off {\n' +
								'border-color: @backgroundHue1Contrast3;\n' +
							'}\n' +
							
							'md-checkbox.md-@themeName-theme:not(.md-checked) .md-icon, md-radio-button.md-@themeName-theme.md-checked .md-off, md-radio-button.md-@themeName-theme:not([disabled]).md-primary.md-checked .md-off, md-radio-group.md-@themeName-theme:not([disabled]) .md-primary.md-checked .md-off {\n' +
								'border-color: @backgroundHue1Contrast1;\n' +
							'}\n' +
							
							'md-radio-button.md-@themeName-theme .md-on, md-radio-button.md-@themeName-theme:not([disabled]).md-primary .md-on, md-radio-group.md-@themeName-theme:not([disabled]) .md-primary .md-on {\n' +
								'background-color: @backgroundHue1Contrast1;\n' +
							'}\n' +
							
							
							
							'\n/* DatePicker */\n' +
							
							'[md-theme="@themeName"] .daterangepicker .ranges li {\n' +
								'color: @primaryDefaultColor;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] .daterangepicker .ranges li.active, [md-theme="@themeName"] .daterangepicker .ranges li:hover {\n' +
								'background:@primaryDefaultColor;\n' +
								'color: @primaryDefaultContrast1;\n' +
								'border-color: @primaryDefaultColor;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] .daterangepicker .input-mini.active {\n' +
								'border-color: @primaryDefaultColor;\n' +
							'}\n' +
							
							
							'[md-theme="@themeName"] .daterangepicker td.active, [md-theme="@themeName"] .daterangepicker td.active:hover {\n' +
								'background:@primaryDefaultColor;\n' +
								'color: @primaryDefaultContrast1;\n' +
								'border-color: @primaryDefaultColor;\n' +
							'}\n' +
							
							
							
							
							
							'\n/* Button Group */\n' +
							
							'[md-theme="@themeName"] .md-button.groupX.md-raised:not([disabled]) {\n' +
								'background:@backgroundHue1Color;\n' +
							'}\n' +
							'[md-theme="@themeName"] .md-button.groupX.md-raised:not([disabled]) md-icon {\n' +
								'color:@backgroundHue2Color;\n' +
							'}\n' +
							
							
							'.md-button.md-@themeName-theme.md-primary:not([disabled]) md-icon {\n' +
								'color:@primaryDefaultColor;\n' +
							'}\n' +
							
							
							
							'\n/* Dialog Form Wizard */\n' +
							'md-dialog.md-@themeName-theme {\n' +
								'color:@backgroundHue2Color;\n' +
							'}\n' +
							
							
							'md-dialog.md-@themeName-theme md-dialog-content .form-content .form-title {\n' +
								'border-color: @backgroundHue2Color;\n' +
							'}\n' +
							
							'md-input-container.md-@themeName-theme .md-placeholder, md-input-container.md-@themeName-theme label {\n' +
								'color:@backgroundHue2Color;\n' +
							'}\n' +
							
							'md-input-container.md-@themeName-theme:not(.md-input-focused):not(.md-input-invalid) label.md-required:after, md-input-container:not(.md-input-focused):not(.md-input-invalid) md-select.md-@themeName-theme .md-select-value span:first-child:after {\n' +
								'color:@backgroundHue1Contrast2;\n' +
							'}\n' +
							
							
							'md-input-container.md-@themeName-theme:not(.md-input-invalid).md-input-has-value label {\n' +
								'color:@backgroundHue2Color;\n' +
							'}\n' +
							
							
							'md-input-container.md-@themeName-theme .md-input, md-input-container.md-@themeName-theme>md-icon {\n' +
								'color:@backgroundHue1Contrast2;\n' +
								'border-bottom-color:@backgroundHue1Contrast4;\n' +
							'}\n' +
							
							'md-select.md-@themeName-theme .md-select-value.md-select-placeholder, md-select.md-@themeName-theme .md-select-icon {\n' +
								'color:@backgroundHue2Color;\n' +
							'}\n' +
							
							'\n/* Select Options */\n' +
							
							'[md-theme="@themeName"] md-content md-option:not([disabled]):hover {\n' +
								'background:rgba(78,77,91,0.2) !important;color:@backgroundHue2Color;\n' +
							'}\n' +
							'[md-theme="@themeName"] md-content md-option[selected] {\n' +
								'background:rgba(78,77,91,0.3) !important;color:@backgroundHue2Color;\n' +
							'}\n' +
							
							
							'\n/* DashboardItems */\n' +
							
							'[md-theme="@themeName"] .dashboardItem {\n' +
								'color:@backgroundHue2Color;\n' +
							'}\n' +
							
							'\n/* Select */\n' +
							
							'[md-theme="@themeName"] .md-select-value, [md-theme="@themeName"] .md-select-value span.md-select-icon, md-select.md-@themeName-theme[disabled] .md-select-value, md-select.md-@themeName-theme .md-select-value, .md-@themeName-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle, .md-@themeName-theme .md-datepicker-input {\n' +
								'color:@backgroundHue1Contrast2 !important;\n' +
								'border-bottom-color:@backgroundHue1Contrast4 !important;\n' +
							'}\n' +
							
							'.md-@themeName-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle {\n' +
								'border-top-color:@backgroundHue1Contrast2 !important;\n' +
							'}\n' +
                            
							'[md-theme="@themeName"] .md-primary-bg.md-hue-2 .md-select-value, [md-theme="@themeName"] .md-primary-bg.md-hue-2 .md-select-value span.md-select-icon, md-select.md-@themeName-theme[disabled] .md-primary-bg.md-hue-2 .md-select-value, md-select.md-@themeName-theme .md-primary-bg.md-hue-2 .md-select-value, .md-@themeName-theme .md-primary-bg.md-hue-2 .md-datepicker-triangle-button .md-datepicker-expand-triangle, .md-@themeName-theme .md-primary-bg.md-hue-2 .md-datepicker-input {\n' +
								'color: @primaryHue1Contrast2 !important;\n' +
								'border-bottom-color:@backgroundHue1Contrast4 !important;\n' +
							'}\n' +
                            
							'\n/* JTree */\n' +
							
							//'[md-theme="@themeName"] .jstree-proton .jstree-wholerow-clicked {\n' +
							//	'background: @primaryHue2Color !important;\n' +
							//'}\n' +
							//'[md-theme="@themeName"] .jstree-proton .jstree-wholerow-hovered  {\n' +
							//	'background: @primaryHue1Color !important;\n' +
							//'}\n' +
							
							'[md-theme="@themeName"] .jstree-proton, [md-theme="@themeName"] .jstree-wholerow  {\n' +
								'color: @backgroundHue1Contrast3;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] .jstree-proton .jstree-clicked, [md-theme="@themeName"] .jstree-wholerow-clicked  {\n' +
								'color: @backgroundHue1Contrast1;\n' +
							'}\n' +
							'[md-theme="@themeName"] .jstree-proton .jstree-hovered,  [md-theme="@themeName"] .jstree-wholerow-hovered {\n' +
								'color: @backgroundHue1Contrast1;\n' +
							'}\n' +
							'[md-theme="@themeName"] .jstree-proton .jstree-clicked.jstree-hovered, [md-theme="@themeName"] .jstree-wholerow-clicked.jstree-wholerow-hovered {\n' +
								'color: @backgroundHue1Contrast1;\n' +
							'}\n' +
							
							
							//'\n/* Grid Stack */\n' +
							/*
							'[md-theme="@themeName"] .grid-stack > .grid-stack-item > .grid-stack-item-content {\n' +
								'color: rgba(0,0,0,0.87);\n' +
							'}\n' +
							*/
							
							'\n/* Sidenav Toggle Buttons */\n' +
							
							'[md-theme="@themeName"] .toggle-left-sidenav {\n' +
								'background: @primaryDefaultColor !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .toggle-left-sidenav md-icon {\n' +
								'color: white !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .toggle-right-sidenav {\n' +
								'background: @primaryDefaultColor !important;\n' +
							'}\n' +
							'[md-theme="@themeName"] .toggle-right-sidenav md-icon {\n' +
								'color: white !important;\n' +
							'}\n' +
							
							
							'\n/* Tables */\n' +
							
							'[md-theme="@themeName"] table.md-table th.md-column, [md-theme="@themeName"] table.md-table td.md-cell {\n' +
								'color: @backgroundHue1Contrast1;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] .md-table-pagination {\n' +
								'color: @backgroundHue1Contrast1;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] table.md-table th.md-column.md-active md-icon {\n' +
								'color: @backgroundHue1Contrast1;\n' +
							'}\n' +
							
							'\n/* Editor */\n' +
							'[md-theme="@themeName"] .ta-root .ta-toolbar {\n' +
								'background: @primaryHue1Color;\n' +
								'color: @primaryHue1Contrast1;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] .ta-root .ta-toolbar .ta-group .md-button {\n' +
								'background: @primaryHue1Color;\n' +
								'color: @primaryHue1Contrast2;\n' +
							'}\n' +
							
							
							
							
							'\n/* Buttons */\n' +
							
							'.md-button.md-@themeName-theme.md-raised {\n' +
								'background: @primaryHue1Color;\n' +
								'color: @primaryHue1Contrast2;\n' +
							'}\n' +
							
							'.md-button.md-@themeName-theme.md-raised:not([disabled]):hover {\n' +
								//'background: @primaryHue2Color;\n' +
								'color: @primaryHue2Contrast2;\n' +
							'}\n' +
							
							'.md-button.md-@themeName-theme[disabled] md-icon {\n' +
								'color: @backgroundHue1Color;\n' +
							'}\n' +
							
							 
							'.md-icon.md-@themeName-theme, md-icon.md-@themeName-theme {\n' +
								'color: @backgroundHue1Contrast2;\n' +
							'}\n' +
							
							
							'.md-@themeName-theme.md-button.groupX {\n' +
								'color: @backgroundHue1Contrast2;\n' +
							'}\n' +
							
							
							
							
							
							'\n/* Tabs */\n' +
							
							'md-tabs.md-@themeName-theme .md-tab {\n' +
								'color: @backgroundHue2Color;\n' +
							'}\n' +
							
							'md-tabs.md-@themeName-theme .md-tab.md-active {\n' +
								'color: @accentDefaultColor;\n' +
							'}\n' +
							
							
							//'\n/* Custom Tabs */\n' +
							/*
							'md-tabs.md-@themeName-theme.header-tabs .md-tab {\n' +
								'color: @primaryHue1Contrast3;\n' +
							'}\n' +
							
							'md-tabs.md-@themeName-theme.header-tabs .md-tab.md-active {\n' +
								'color: @primaryHue1Contrast1;\n' +
							'}\n' +
							*/
							
							'\n/* Graphs */\n' +
							
							'[md-theme="@themeName"] .c3 .c3-axis text, [md-theme="@themeName"] .c3 text {\n' +
								'fill: @backgroundHue1Contrast2;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] .c3 path, [md-theme="@themeName"] .c3 line {\n' +
								'stroke: @backgroundHue1Contrast3;\n' +
							'}\n' +
							
							'\n/* Cards */\n' +
							
							'md-card.md-@themeName-theme md-card-title md-card-title-text:not(:only-child) .md-subhead {\n' +
								'color: @backgroundHue1Contrast2;\n' +
							'}\n' +
							
							'md-card.md-@themeName-theme .md-headline {\n' +
								'color: @backgroundHue1Contrast1;\n' +
							'}\n' +
							
							'md-card.md-@themeName-theme .progress-label {\n' +
								'color: @backgroundHue1Contrast2;\n' +
							'}\n' +
							
							
							'md-card.md-@themeName-theme progress[value]::-webkit-progress-bar {\n' +
								'background: @backgroundHue1Contrast3;\n' +
							'}\n' +
							
							'md-card.md-@themeName-theme progress[value]::-webkit-progress-value {\n' +
								'background: @backgroundHue1Contrast2;\n' +
							'}\n' +
							
						
						
							
							
							'\n/* Calendar */\n' +
							
							'[md-theme="@themeName"] .fc-unthemed th, [md-theme="@themeName"] .fc-unthemed td, [md-theme="@themeName"] .fc-unthemed thead, [md-theme="@themeName"] .fc-unthemed tbody, [md-theme="@themeName"] .fc-unthemed .fc-divider, [md-theme="@themeName"] .fc-unthemed .fc-row, [md-theme="@themeName"] .fc-unthemed .fc-popover {\n' +
								'border-color: @backgroundHue2Color;\n' +
							'}\n' +
							
							
							'[md-theme="@themeName"] .fc-unthemed .fc-today {\n' +
								'background: @primaryHue1Color;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] a.fc-more {\n' +
								'color: @primaryDefaultColor;\n' +
							'}\n' +
							
							
							'\n/* homeappliances etc */\n' +
							
							'[md-theme="@themeName"] #ha-dishwasher div.selectedProg {\n' +
								'background: @primaryHue3Color !important;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-dishwasher div.unselected {\n' +
								'background: white;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-dishwasher div.unselected-dark {\n' +
								'background: #353535;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-dishwasher div.unselected-Dark-Night {\n' +
								'background: #353535;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-dishwasher div.unselected-Dark-Purple {\n' +
								'background: #585863;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-dishwasher div.unselected-Dark-Blue {\n' +
								'background: #374B59;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-dryer div.selectedProg {\n' +
								'background: @primaryHue3Color !important;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-dryer div.unselected {\n' +
								'background: white;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-dryer div.unselected-dark {\n' +
								'background: #353535;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-dryer div.unselected-Dark-Night {\n' +
								'background: #353535;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-dryer div.unselected-Dark-Purple {\n' +
								'background: #585863;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-dryer div.unselected-Dark-Blue {\n' +
								'background: #374B59;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-laundry div.selectedProg {\n' +
								'background: @primaryHue3Color !important;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-laundry div.unselected {\n' +
								'background: white;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-laundry div.unselected-dark {\n' +
								'background: #353535;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-laundry div.unselected-Dark-Night {\n' +
								'background: #353535;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-laundry div.unselected-Dark-Purple {\n' +
								'background: #585863;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-laundry div.unselected-Dark-Blue {\n' +
								'background: #374B59;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-oven div.selectedProg {\n' +
								'background: @primaryHue3Color !important;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-oven div.unselected {\n' +
								'background: white;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-oven div.unselected-dark {\n' +
								'background: #353535;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-oven div.unselected-Dark-Night {\n' +
								'background: #353535;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-oven div.unselected-Dark-Purple {\n' +
								'background: #585863;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] #ha-oven div.unselected-Dark-Blue {\n' +
								'background: #374B59;\n' +
							'}\n' +
							
							'[md-theme="@themeName"] .intl-tel-input .country-list {\n' +
								'color: @primaryHue1Color;\n' +
							'}\n' +
							
							
							
							'\n';
			
            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, pragmaTheming)
    {
        var vm = this;

        // Data
        vm.themes = pragmaTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: 'assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: 'assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: 'assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: 'assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: 'assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: 'assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            pragmaTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return pragmaTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the PRAGMA theme options panel
                        $mdSidenav('pragma-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('websocket', WebsocketService);

    /** @ngInject */
    function WebsocketService($rootScope,PRAGMA,session)
    {
        var ws = null;

        return {
                openSocket: function () {
                    var user=session.getUser();
                    var userId =user.username;
                    if (userId) {
                        ws = new WebSocket(PRAGMA.wsckUrl+userId);
                        
                        ws.onopen = function (event) {
                            $rootScope.$emit("websocket:onopen", event);
                        };

                        ws.onclose = function (event) {
                            $rootScope.$emit("websocket:onclose", event);
                        };

                        ws.onerror = function (event) {
                            $rootScope.$emit("websocket:onerror", event);
                        };
                        
                        ws.onmessage = function (event) {
                            $rootScope.$emit("websocket:onmessage", event);
                        };
                    }

                    return ws;
                },
                closeSocket: function (socket) {
                    socket.close();
                },
                getSocket: function () {
                    return ws;
                },
                send: function(data) {
                   // ws.send(JSON.stringify(data));
                    ws.send(data);
                }
            }
    }
    
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('session', sessionService);

    /** @ngInject */
    function sessionService($log, $cookieStore)
    {

        var service = {
            start: start,
            getUser: getUser,
            setUser: setUser,
            destroy: destroy
        };
		
        return service;
        //////////
		
        function start() {
            this._user = $cookieStore.get('usr');
        }

        function getUser() {
            return this._user;
        };

        function setUser(user) {
            this._user = user;
            $cookieStore.put('usr', user);
            return this;
        };

        /**
         * Destroy session
         */
        function destroy() {
            this.setUser(null);
            $cookieStore.remove("usr");
        };
      }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('pragmaapi', pragmaApiService);

    /** @ngInject */
    function pragmaApiService($q, $http, $base64, session, PRAGMA, $filter)
    {
        var service = {
            costProfiles: {},
            foundCostProfiles: {},
            getTreeConfig: getTreeConfig,
            getTreeData: getTreeData,
            getTreeDataFilter: getTreeDataFilter,
            callRestService: callRestService,
            m3tokWh: m3tokWh,
            kWhtoCO2: kWhtoCO2,
            calculateCost: calculateCost,
            loadCostProfiles: loadCostProfiles,
            findCostProfile: findCostProfile,
            translate: translate,
            translateLabel: translateLabel,
            loadUserData: loadUserData,
            saveUserData: saveUserData
        };
        return service;
        
        
        //////////
        
        function loadUserData(key) {
            return $q(function(resolve, reject) {
                var user = session.getUser();
                user.authentication = user.username + ":" + user.password;
                callRestService(PRAGMA.api, "/userPreferences/userId/" + user.username + "/", "", true, user.authentication, "GET", true, false).then(function(res) {
                    var userPreferences = res.data;
                    if (userPreferences.data != undefined) {
                        var pos = keyInData(key, userPreferences.data);
                        if (pos >= 0) {
                            resolve(userPreferences.data[pos].data);
                        }
                        else {
                            resolve({});
                        }
                    }
                    else {
                        resolve({});
                    }
                });
            });
        }
        
        function saveUserData(key, data) {
            var user = session.getUser();
            user.authentication = user.username + ":" + user.password;
            callRestService(PRAGMA.api, "/userPreferences/userId/" + user.username + "/", "", true, user.authentication, "GET", true, false).then(function(res) {
                var userPreferences = res.data;
                if (userPreferences.data == undefined) userPreferences.data = [];
                var pos = keyInData(key, userPreferences.data);
                if (pos >= 0) {
                    // Update
                    userPreferences.data[pos].data = data;
                    return savePreferences(userPreferences);
                }
                else {
                    // New
                    userPreferences.data.push({key: key, data: data});
                    return savePreferences(userPreferences);
                }
            });
        }
        
        function savePreferences(userPreferences) {
            var user = session.getUser();
            user.authentication = user.username + ":" + user.password;
            callRestService(PRAGMA.api, "/userPreferences/" + userPreferences.token, userPreferences, true, user.authentication, "PUT", true, false).then(function(res) {
                return res;
            });
        }
        
        function keyInData(key, data) {
            for (i = 0; i < data.length; i++) {
                if (data[i].key == key) {
                    return i;
                }
            }
            return -1;
        }
        
        function getTreeData(includeSites,includeGroups,includeDevices,includeMeasurements) {
            return $q(function(resolve, reject) {
                var treeData = [];
                var user = session.getUser();
                user.authentication = user.username + ":" + user.password;
                callRestService(PRAGMA.api, "/trees/defaultTree", "?includeSites="+includeSites+"&includeGroups="+includeGroups+"&includeDevices="+includeDevices+"&includeMeasurements="+includeMeasurements, true, user.authentication, "GET", true, false).then(function(res){
                    resolve(res.data);
                });
            });
        }
        
        function getTreeDataFilter(filter) {
            return $q(function(resolve, reject) {
                var treeData = [];
                var user = session.getUser();
                user.authentication = user.username + ":" + user.password;
                callRestService(PRAGMA.api, "/filter/tree", filter, true, user.authentication, "POST", true, false).then(function(res){
                    resolve(res.data);
                });
            });
        }
        function getTreeConfig(plugins) {
            var treeConfig = {
                core : {
                    multiple : true,
                    animation: true,
                    error : function(error) {
                       console.log('treeCtrl: error from js tree - ' + angular.toJson(error));
                    },
                    check_callback : true,
                    worker : true,
                    themes: {
                        name: 'proton',
                        responsive: true
                    }
                },
                types : {
                    client:{
                        icon : 'icon-account-key'
                    },              
                    portfolio:{
                        icon : 'icon-map-marker-multiple'
                    },
                    site:{
                        icon : 'icon-map-marker'
                    },
                    deviceGroup:{
                        icon : 'icon-folder-outline'
                    },
                    device:{
                        icon : 'icon-speedometer'
                    },
                    measurement:{
                        icon : 'icon-pulse'
                    }
                },
                version : 1,
                plugins : plugins
            };
            return treeConfig;
        }
        
        
        function callRestService(url_in, service, params, useCredentials, auth, method, access_control, cookies)
        {
            var this_url;
            var this_headers = {};
            var this_data = {};
            var this_withCredentials = false;
            
            if (method === "POST" || method === "PUT" || method === "DELETE") {
                this_url = url_in + service;
                this_data = params;
                if (access_control) {
                    this_headers['Access-Control-Allow-Origin'] = "*";
                    this_headers['Content-Type'] = "application/json";
                }
            }
            else {
                this_url = url_in + service + params;
            }
            
            if (useCredentials) {
                var this_auth = $base64.encode(auth);
                this_headers['Authorization'] = "Basic " + this_auth;
            }
            
            if (cookies) {
              this_withCredentials = true;
            }
            
            return $http({
                method: method,
                url: this_url,
                headers: this_headers,
                withCredentials : this_withCredentials,
                data: this_data
            });
        }
        
        
        // Cost Profiles
        function _loadCostProfiles() {
            
            var user = session.getUser();
            user.authentication = user.username + ":" + user.password;
            
            // Get All Tenants
            var tenantAuthTokens = [];
            return callRestService(PRAGMA.api, "/users/" + user.username + "/tenants", "?includeRuntimeInfo=true", true, user.authentication, "GET").then(function(res) {
                var tenants = res.data;
                for (var i = 0; i < tenants.length; i++) {
                    if (!tenants[i].deleted && tenants[i].engineState.lifecycleStatus == "Started") {
                        tenantAuthTokens.push(tenants[i].authenticationToken);
                    }
                }
                
                // Load cost profiles
                var promises = tenantAuthTokens.map(function(tenantAuthToken) {
                    return callRestService(PRAGMA.api, "/costProfiles", "?tenantAuthToken=" + tenantAuthToken, true, user.authentication, "GET", true).then(function(res) {
                        if (!res.data.error && res.data.numResults) {
                            var results = res.data.results;
                            service.costProfiles[tenantAuthToken] = [];
                            for (var i = 0; i < results.length; i++) {
                                service.costProfiles[tenantAuthToken].push(results[i]);
                            }
                        }
                    });
                });
                return $q.all(promises);
            });
        }
        
        // Cost Profiles
        function loadCostProfiles() {
            
            _loadCostProfiles().then(function() {
                
                var user = session.getUser();
                user.authentication = user.username + ":" + user.password;
                
                var tenantAuthTokens = [];
                for (var tenantAuthToken in service.costProfiles) {
                    tenantAuthTokens.push(tenantAuthToken);
                }
                
                // Load costs
                var promises = tenantAuthTokens.map(function(tenantAuthToken) {
                    return callRestService(PRAGMA.api, "/costs", "?tenantAuthToken=" + tenantAuthToken, true, user.authentication, "GET", true).then(function(res) {
                        if (!res.data.error && res.data.numResults) {
                            var costs = res.data.results;
                            /*
                            for (var i = 0; i < costs.length; i++) {
                                var cost = costs[i].tariffs[0];
                                for (var prop in cost) {
                                    costs[i][prop] = cost[prop];
                                }
                            }
                            */
                            var profiles = service.costProfiles[tenantAuthToken];
                            for (var i = 0; i < profiles.length; i++) {
                                var profile = profiles[i];
                                profile.costs = [];
                                for (var j = 0; j < costs.length; j++) {
                                    var cost = costs[j];
                                    if (cost.profileTokens != undefined && jQuery.inArray(profile.token, cost.profileTokens) >= 0) {
                                        profile.costs.push(cost);
                                    }
                                }
                            }
                        }
                    });
                });
                return $q.all(promises);
            });
        }
        
        function findCostProfile(type, siteId) {
            var foundProfile = false;
            if (service.foundCostProfiles[siteId] != undefined && service.foundCostProfiles[siteId][type] != undefined) {
                foundProfile = service.foundCostProfiles[siteId][type];
                return foundProfile;
            }
            else {
                for (var tenantAuthToken in service.costProfiles) {
                    var profiles = service.costProfiles[tenantAuthToken];
                    for (var i = 0; i < profiles.length; i++) {
                        var profile = profiles[i];
                        if (profile.siteIds != undefined && jQuery.inArray(siteId, profile.siteIds) >= 0) {
                            if (foundProfile.startDate != undefined && foundProfile.measure != undefined && profile.startDate != undefined && profile.measure != undefined) {
                                if (profile.measure == foundProfile.measure && profile.startDate > foundProfile.startDate) {
                                    foundProfile = profile;
                                }
                            }
                            else if (profile.measure != undefined && profile.measure == type) {
                                foundProfile = profile;
                            }
                        }
                    }
                    if (foundProfile) {
                        if (service.foundCostProfiles[siteId] == undefined) {
                            service.foundCostProfiles[siteId] = {};
                        }
                        service.foundCostProfiles[siteId][type] = foundProfile;
                        break;
                    }
                }
            }
            return foundProfile;
        }
         

        function calculateCostProfile(value, days, profile, includeFixed) {
            var res = 0;
            var calc = 0;
            
            // For cost profiles which include costs with schedules an array is expected
            // Here the total value is calculated for other costs
            if (value instanceof Array) {
                var values = angular.copy(value);
                value = values.reduce(function(pv, cv) { return pv + cv; }, 0);
            }
            
            var vars = { 'VALUE': value, 'DAYS': days };
            profile.costs.forEach(function(cost) {
                calc = 0;
                cost.calculated = false;
                switch (cost.type) {
                    case 'unit':
                        if (cost.schedule.length) {
                            // Should take schedule into account
                            if (values != undefined) {
                                for (var i = 0; i < values.length; i++) {
                                    calc += values[i] * cost.tariffs[i].cost * (1 + (cost.tariffs[i].vat / 100));
                                }
                            }
                            else {
                                // If the value was not provided as an array the cost is calculated
                                // with the first tarrif of the schedule
                                calc = value * cost.tariffs[0].cost * (1 + (cost.tariffs[0].vat / 100));
                            }
                        }
                        else {
                            calc = value * cost.tariffs[0].cost * (1 + (cost.tariffs[0].vat / 100));
                        }
                    break;
                    case 'fixed':
                        if (includeFixed) {
                            calc = cost.tariffs[0].cost * days / cost.tariffs[0].period * (1 + (cost.tariffs[0].vat / 100));
                        }
                    break;
                    case 'return':
                        if (includeFixed) {
                            calc = 0 - (cost.tariffs[0].cost * days / cost.tariffs[0].period * (1 + (cost.tariffs[0].vat / 100)));
                        }
                    break;
                }
                if (cost.id) vars[cost.id] = calc;
                if (cost.inTotal) res += calc;
            });
            
            var i = 0;
            var pending = false;
            while (i < 10) { // Break if there is a cyclic reference
                profile.costs.forEach(function(cost) {
                    if (cost.type == 'formula' && !cost.calculated) {
                        var formula = " " + cost.tariffs[0].cost + " ";
                        if (formula.match(/^[a-z0-9\.\ \+\-\*\/\(\)]+$/i)) { // Safety check
                            var formula_vars = formula.replace(/[\+\-\*\/\(\)]/, ' ');
                            var parts = formula_vars.split(' ');
                            var found = true;
                            for (var j = 0; j < parts.length; j++) {
                                var part = parts[j];
                                if (part.trim() != "") {
                                    if (vars[part] != undefined || part.match(/^[0-9\.]+$/)) { // formula refers to caclucated value or number
                                        // Do nothing
                                    }
                                    else { // formula probably refers to another formula
                                        found = false; 
                                    }
                                }
                            }
                            if (found) { // we found all parts
                                for (var j = 0; j < parts.length; j++) {
                                    var part = parts[j];
                                    if (part.trim() != "") {
                                        if (vars[part] != undefined) {
                                            var regexp = new RegExp(" " + part + " ");
                                            formula = formula.replace(regexp, " " + vars[part] + " ");
                                        }
                                    }
                                }
                                
                                calc = eval('(' + formula + ') * (1 + (' + (cost.tariffs[0].vat / 100) + '))');
                                if (cost.id) vars[cost.id] = calc;
                                if (cost.inTotal) {
                                    if (cost.tariffs[0].period == 'cost') {
                                        res += calc;
                                    }
                                    else {
                                        res -= calc;
                                    }
                                }
                                cost.calculated = true;
                            }
                            else {
                                pending = true;
                            }
                        }
                    }
                });
                if (!pending) break;
                i++;
            }
            return res;
        }

        
        function calculateCost(value, days, type, siteId, includeFixed, num_sites, measure) {
            if (type == 'electricity_excess') return 0;
            if (includeFixed == undefined) includeFixed = true;
            if (num_sites == undefined) num_sites = 1;
            var profile = {};

            if ((profile = findCostProfile(type, siteId))&& type !== "gas") {
                value = calculateCostProfile(value, days, profile, includeFixed);
            }
            else {
                // Default calculation
                var cost = {};
                switch (type) {
                    case 'recycle_aluminium':
                      value = value * 0.00014;
                    break;
                    case 'recycle_paper':
                      value = value * 0.000034;
                    break;
                    case 'recycle_plastic':
                      value = value * 0.00003;
                    break;
                    case 'water':
                        value = value * 0.00081;
                    break;
                    case 'electricity excess':
                        value = 0;
                    break;
                    case 'electricity':
                      cost['VAT']           = 0.13;
                      cost['high_tariff']   = 0.0946;
                      cost['low_tariff']    = 0.0946;
                      cost['tax']           = 0;
                      cost['SDE']           = 0;
                      cost['delivery']      = 0;
                      cost['network']       = 0;
                      value
                        = (((value * cost['high_tariff'])
                        + (value * cost['tax'])
                        + (value * cost['SDE'])
                        + (cost['delivery'] * num_sites * days / 365))
                        * (1 + cost['VAT']))
                        + (cost['network'] * num_sites * days / 365);
                    break;
                    case 'gas':
                      cost['VAT']           = 0.13;
                      cost['tariff']        = 0.3242;
                      cost['tax']           = 0.015;
                      cost['SDE']           = 0.0186;
                      cost['delivery']      = 0;
                      cost['network']       = 0;
                      value
                        = (((value * cost['tariff'])
                        + (value * cost['tax'])
                        + (value * cost['SDE'])
                        + (cost['delivery'] * num_sites * days / 365))
                        * (1 + cost['VAT']))
                        + (cost['network'] * num_sites * days / 365);
                    break;
                }
            }
            return value;
        }
        
        
        function m3tokWh(m3) {
            var kwh = 0;
            // Volume correction factor
            kwh = m3 / 1.02264;
            // Calorific value
            kwh = kwh * 40;
            // conversion factor
            kwh = kwh / 3.6;
            return kwh;
        }
    
        function kWhtoCO2(kWh, country) {
          var lookup = {
              "AT": [0.209, 0.310], // Austria
              "BE": [0.285, 0.402], // Belgium
              "DE": [0.624, 0.706], // Germany
              "DK": [0.461, 0.760], // Denmark
              "ES": [0.440, 0.639], // Spain
              "FI": [0.216, 0.418], // Finland
              "FR": [0.056, 0.146], // France
              "GB": [0.543, 0.658], // United Kingdom
              "GR": [1.149, 1.167], // Greece
              "IE": [0.732, 0.870], // Ireland
              "IT": [0.483, 0.708], // Italy
              "NL": [0.435, 0.716], // Netherlands
              "PT": [0.369, 0.750], // Portugal
              "SE": [0.023, 0.079], // Sweden
              "BG": [0.819, 0.906], // Bulgaria
              "CY": [0.874, 1.019], // Cyprus
              "CZ": [0.950, 0.802], // Czech Republic
              "EE": [0.908, 1.593], // Estonia
              "HU": [0.566, 0.678], // Hungary
              "LT": [0.153, 0.174], // Lithuania
              "LV": [0.109, 0.563], // Latvia
              "PL": [1.191, 1.185], // Poland
              "RO": [0.701, 1.084], // Romania
              "SI": [0.557, 0.602], // Slovenia
              "SK": [0.252, 0.353] // Slovakia
          };
          var CO2 = kWh * lookup[country][1];
          return CO2;
        }
        
        function translate(label) {
            return $filter('translate')(label);
        }
        
        function translateLabel(section, label) {
            return section + '.' + label.toUpperCase().replace(/\ /, '_');
        }
    }
    
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('convertapi', convertApiService);

    /** @ngInject */
    function convertApiService($filter)
    {
        // DEFINITIONS
        
        var measures = {};

        
        ////////////////////////////////////////////////////////////////////////
        // Apparent Power
        ////////////////////////////////////////////////////////////////////////
        
        var metric;

        metric = {
          "VA": {
            "name": {
              "singular": "Volt-Ampere",
              "plural": "Volt-Amperes"
            },
            "to_anchor": 1
          },
          "mVA": {
            "name": {
              "singular": "Millivolt-Ampere",
              "plural": "Millivolt-Amperes"
            },
            "to_anchor": 1/1000
          },
          "kVA": {
            "name": {
              "singular": "Kilovolt-Ampere",
              "plural": "Kilovolt-Amperes"
            },
            "to_anchor": 1000
          },
          "MVA": {
            "name": {
              "singular": "Megavolt-Ampere",
              "plural": "Megavolt-Amperes"
            },
            "to_anchor": 1000000
          },
          "GVA": {
            "name": {
              "singular": "Gigavolt-Ampere",
              "plural": "Gigavolt-Amperes"
            },
            "to_anchor": 1000000000
          }
        };

        measures.apparentPower = {
          "metric": metric,
          "_anchors": {
            "metric": {
              "unit": "VA",
              "ratio": 1
            }
          }
        };
        
        
        ////////////////////////////////////////////////////////////////////////
        // Area
        ////////////////////////////////////////////////////////////////////////

        var metric, imperial;

        metric = {
          "mm2": {
            "name": {
              "singular": "Square Millimeter",
              "plural": "Square Millimeters"
            },
            "to_anchor": 1/1000000
          },
          "cm2": {
            "name": {
              "singular": "Centimeter",
              "plural": "Centimeters"
            },
            "to_anchor": 1/10000
          },
          "m2": {
            "name": {
              "singular": "Square Meter",
              "plural": "Square Meters"
            },
            "to_anchor": 1
          },
          "ha": {
            "name": {
              "singular": "Hectare",
              "plural": "Hectares"
            },
            "to_anchor": 10000
          },
          "km2": {
            "name": {
              "singular": "Square Kilometer",
              "plural": "Square Kilometers"
            },
            "to_anchor": 1000000
          }
        };

        imperial = {
          "in2": {
            "name": {
              "singular": "Square Inch",
              "plural": "Square Inches"
            },
            "to_anchor": 1/144
          },
          "yd2": {
            "name": {
              "singular": "Square Yard",
              "plural": "Square Yards"
            },
            "to_anchor": 9
          },
          "ft2": {
            "name": {
              "singular": "Square Foot",
              "plural": "Square Feet"
            },
            "to_anchor": 1
          },
          "ac": {
            "name": {
              "singular": "Acre",
              "plural": "Acres"
            },
            "to_anchor": 43560
          },
          "mi2": {
            "name": {
              "singular": "Square Mile",
              "plural": "Square Miles"
            },
            "to_anchor": 27878400
          }
        };

        measures.area = {
          "metric": metric,
          "imperial": imperial,
          "_anchors": {
            "metric": {
              "unit": "m2",
              "ratio": 10.7639
            },
            "imperial": {
              "unit": "ft2",
              "ratio": 1/10.7639
            }
          }
        };
        
        
        ////////////////////////////////////////////////////////////////////////
        // Currency
        ////////////////////////////////////////////////////////////////////////

        var metric;

        metric = {
          "€": {
            "name": {
              "singular": "Euro",
              "plural": "Euro"
            },
            "to_anchor": 1
          },
          "k€": {
            "name": {
              "singular": "Thousand Euro",
              "plural": "Thousand Euro"
            },
            "to_anchor": 1000
          },
          "M€": {
            "name": {
              "singular": "Million Euro",
              "plural": "Million Euro"
            },
            "to_anchor": 1000000
          }
        };

        measures.currency = {
          "metric": metric,
          "_anchors": {
            "metric": {
              "unit": "€",
              "ratio": 1
            }
          }
        };
        
        
        ////////////////////////////////////////////////////////////////////////
        // Current
        ////////////////////////////////////////////////////////////////////////

        var metric;

        metric = {
          "A": {
            "name": {
              "singular": "Ampere",
              "plural": "Amperes"
            },
            "to_anchor": 1
          },
          "mA": {
            "name": {
              "singular": "Milliampere",
              "plural": "Milliamperes"
            },
            "to_anchor": 1/1000
          },
          "kA": {
            "name": {
              "singular": "Kiloampere",
              "plural": "Kiloamperes"
            },
            "to_anchor": 1000
          }
        };

        measures.current = {
          "metric": metric,
          "_anchors": {
            "metric": {
              "unit": "A",
              "ratio": 1
            }
          }
        };
        
        
        ////////////////////////////////////////////////////////////////////////
        // Digital
        ////////////////////////////////////////////////////////////////////////

        var bits, bytes;

        bits = {
          "b": {
            "name": {
              "singular": "Bit",
              "plural": "Bits"
            },
            "to_anchor": 1
          },
          "Kb": {
            "name": {
              "singular": "Kilobit",
              "plural": "Kilobits"
            },
            "to_anchor": 1024
          },
          "Mb": {
            "name": {
              "singular": "Megabit",
              "plural": "Megabits"
            },
            "to_anchor": 1048576
          },
          "Gb": {
            "name": {
              "singular": "Gigabit",
              "plural": "Gigabits"
            },
            "to_anchor": 1073741824
          },
          "Tb": {
            "name": {
              "singular": "Terabit",
              "plural": "Terabits"
            },
            "to_anchor": 1099511627776
          }
        };

        bytes = {
          "B": {
            "name": {
              "singular": "Byte",
              "plural": "Bytes"
            },
            "to_anchor": 1
          },
          "KB": {
            "name": {
              "singular": "Kilobyte",
              "plural": "Kilobytes"
            },
            "to_anchor": 1024
          },
          "MB": {
            "name": {
              "singular": "Megabyte",
              "plural": "Megabytes"
            },
            "to_anchor": 1048576
          },
          "GB": {
            "name": {
              "singular": "Gigabyte",
              "plural": "Gigabytes"
            },
            "to_anchor": 1073741824
          },
          "TB": {
            "name": {
              "singular": "Terabyte",
              "plural": "Terabytes"
            },
            "to_anchor": 1099511627776
          }
        };

        measures.digital = {
          "bits": bits,
          "bytes": bytes,
          "_anchors": {
            "bits": {
              "unit": "b",
              "ratio": 1/8
            },
            "bytes": {
              "unit": "B",
              "ratio": 8
            }
          }
        };


        ////////////////////////////////////////////////////////////////////////
        // Energy
        ////////////////////////////////////////////////////////////////////////
        
        var metric;

        metric = {
          "Wh": {
            "name": {
              "singular": "Watt-hour",
              "plural": "Watt-hours"
            },
            "to_anchor": 3600
          },
          "mWh": {
            "name": {
              "singular": "Milliwatt-hour",
              "plural": "Milliwatt-hours"
            },
            "to_anchor": 3.6
          },
          "kWh": {
            "name": {
              "singular": "Kilowatt-hour",
              "plural": "Kilowatt-hours"
            },
            "to_anchor": 3600000
          },
          "MWh": {
            "name": {
              "singular": "Megawatt-hour",
              "plural": "Megawatt-hours"
            },
            "to_anchor": 3600000000
          },
          "GWh": {
            "name": {
              "singular": "Gigawatt-hour",
              "plural": "Gigawatt-hours"
            },
            "to_anchor": 3600000000000
          },
          "J": {
            "name": {
              "singular": "Joule",
              "plural": "Joules"
            },
            "to_anchor": 1
          },
          "kJ": {
            "name": {
              "singular": "Kilojoule",
              "plural": "Kilojoules"
            },
            "to_anchor": 1000
          }
        };

        measures.metric = {
          "metric": metric,
          "_anchors": {
            "metric": {
              "unit": "J",
              "ratio": 1
            }
          }
        };



        ////////////////////////////////////////////////////////////////////////
        // Frequency
        ////////////////////////////////////////////////////////////////////////
        
        var metric;
        
        metric = {
          "mHz": {
            "name": {
              "singular": "millihertz",
              "plural": "millihertz"
            },
            "to_anchor": 1/1000
          },
          "Hz": {
            "name": {
              "singular": "hertz",
              "plural": "hertz"
            },
            "to_anchor": 1
          },
          "kHz": {
            "name": {
              "singular": "kilohertz",
              "plural": "kilohertz"
            },
            "to_anchor": 1000
          },
          "MHz": {
            "name": {
              "singular": "megahertz",
              "plural": "megahertz"
            },
            "to_anchor": 1000000
          },
          "GHz": {
            "name": {
              "singular": "gigahertz",
              "plural": "gigahertz"
            },
            "to_anchor": 1000000000
          },
          "THz": {
            "name": {
              "singular": "terahertz",
              "plural": "terahertz"
            },
            "to_anchor": 1000000000000
          },
          "rpm": {
            "name": {
              "singular": "rotation per minute",
              "plural": "rotations per minute"
            },
            "to_anchor": 1/60
          },
          "deg/s": {
            "name": {
              "singular": "degree per second",
              "plural": "degrees per second"
            },
            "to_anchor": 1/360
          },
          "rad/s": {
            "name": {
              "singular": "radian per second",
              "plural": "radians per second"
            },
            "to_anchor": 1/(Math.PI * 2)
          }
        };

        measures.frequency = {
          "metric": metric,
          "_anchors": {
            "frequency": {
              "unit": "hz",
              "ratio": 1
            }
          }
        };



        ////////////////////////////////////////////////////////////////////////
        // Luminance
        ////////////////////////////////////////////////////////////////////////
        
        var metric, imperial;

        metric = {
          "lx": {
            "name": {
              "singular": "Lux",
              "plural": "Lux"
            },
            "to_anchor": 1
          }
        };

        imperial = {
          "ft-cd": {
            "name": {
              "singular": "Foot-candle",
              "plural": "Foot-candles"
            },
            "to_anchor": 1
          }
        };

        measures.luminance = {
          "metric": metric,
          "imperial": imperial,
          "_anchors": {
            "metric": {
              "unit": "lx",
              "ratio": 1/10.76391
            },
            "imperial": {
              "unit": "ft-cd",
              "ratio": 10.76391
            }
          }
        };


        ////////////////////////////////////////////////////////////////////////
        // Length
        ////////////////////////////////////////////////////////////////////////
        
        var metric, imperial;

        metric = {
          "mm": {
            "name": {
              "singular": "Millimeter",
              "plural": "Millimeters"
            },
            "to_anchor": 1/1000
          },
          "cm": {
            "name": {
              "singular": "Centimeter",
              "plural": "Centimeters"
            },
            "to_anchor": 1/100
          },
          "m": {
            "name": {
              "singular": "Meter",
              "plural": "Meters"
            },
            "to_anchor": 1
          },
          "km": {
            "name": {
              "singular": "Kilometer",
              "plural": "Kilometers"
            },
            "to_anchor": 1000
          }
        };

        imperial = {
          "in": {
            "name": {
              "singular": "Inch",
              "plural": "Inches"
            },
            "to_anchor": 1/12
          },
          "yd": {
            "name": {
              "singular": "Yard",
              "plural": "Yards"
            },
            "to_anchor": 3
          },
          "ft-us": {
            "name": {
              "singular": "US Survey Foot",
              "plural": "US Survey Feet"
            },
            "to_anchor": 1.000002
          },
          "ft": {
            "name": {
              "singular": "Foot",
              "plural": "Feet"
            },
            "to_anchor": 1
          },
          "mi": {
            "name": {
              "singular": "Mile",
              "plural": "Miles"
            },
            "to_anchor": 5280
          }
        };

        measures.length = {
          "metric": metric,
          "imperial": imperial,
          "_anchors": {
            "metric": {
              "unit": "m",
              "ratio": 3.28084
            },
            "imperial": {
              "unit": "ft",
              "ratio": 1/3.28084
            }
          }
        }
        

        ////////////////////////////////////////////////////////////////////////
        // Mass
        ////////////////////////////////////////////////////////////////////////
        
        var metric, imperial;

        metric = {
          "mcg": {
            "name": {
              "singular": "Microgram",
              "plural": "Micrograms"
            },
            "to_anchor": 1/1000000
          },
          "mg": {
            "name": {
              "singular": "Milligram",
              "plural": "Milligrams"
            },
            "to_anchor": 1/1000
          },
          "g": {
            "name": {
              "singular": "Gram",
              "plural": "Grams"
            },
            "to_anchor": 1
          },
          "kg": {
            "name": {
              "singular": "Kilogram",
              "plural": "Kilograms"
            },
            "to_anchor": 1000
          },
          "mt": {
            "name": {
              "singular": "Metric Tonne",
              "plural": "Metric Tonnes"
            },
            "to_anchor": 1000000
          }
        };

        imperial = {
          "oz": {
            "name": {
              "singular": "Ounce",
              "plural": "Ounces"
            },
            "to_anchor": 1/16
          },
          "lb": {
            "name": {
              "singular": "Pound",
              "plural": "Pounds"
            },
            "to_anchor": 1
          },
          "t": {
            "name": {
              "singular": "Ton",
              "plural": "Tons"
            },
            "to_anchor": 2000
          }
        };
        
        measures.mass = {
          "metric": metric,
          "imperial": imperial,
          "_anchors": {
            "metric": {
              "unit": "g",
              "ratio": 1/453.592
            },
            "imperial": {
              "unit": "lb",
              "ratio": 453.592
            }
          }
        };
        

        ////////////////////////////////////////////////////////////////////////
        // Concentration
        ////////////////////////////////////////////////////////////////////////
        
        var metric;

        metric = {
          "ppm": {
            "name": {
              "singular": "Part-per Million",
              "plural": "Parts-per Million"
            },
            "to_anchor": 1
          },
          "ppb": {
            "name": {
              "singular": "Part-per Billion",
              "plural": "Parts-per Billion"
            },
            "to_anchor": 1/1000
          },
          "ppt": {
            "name": {
              "singular": "Part-per Trillion",
              "plural": "Parts-per Trillion"
            },
            "to_anchor": 1/1000000
          },
          "ppq": {
            "name": {
              "singular": "Part-per Quadrillion",
              "plural": "Parts-per Quadrillion"
            },
            "to_anchor": 1/1000000000
          }
        };

        measures.concentration = {
          "metric": metric,
          "_anchors": {
            "metric": {
              "unit": "ppm",
              "ratio": 1
            }
          }
        };

        ////////////////////////////////////////////////////////////////////////
        // Power
        ////////////////////////////////////////////////////////////////////////
        
        var metric;

        metric = {
          "W": {
            "name": {
              "singular": "Watt",
              "plural": "Watts"
            },
            "to_anchor": 1
          },
          "mW": {
            "name": {
              "singular": "Milliwatt",
              "plural": "Milliwatts"
            },
            "to_anchor": 1/1000
          },
          "kW": {
            "name": {
              "singular": "Kilowatt",
              "plural": "Kilowatts"
            },
            "to_anchor": 1000
          },
          "MW": {
            "name": {
              "singular": "Megawatt",
              "plural": "Megawatts"
            },
            "to_anchor": 1000000
          },
          "GW": {
            "name": {
              "singular": "Gigawatt",
              "plural": "Gigawatts"
            },
            "to_anchor": 1000000000
          }
        };

        measures.power = {
          "metric": metric,
          "_anchors": {
            "metric": {
              "unit": "W",
              "ratio": 1
            }
          }
        };


        ////////////////////////////////////////////////////////////////////////
        // Pressure
        ////////////////////////////////////////////////////////////////////////
        
        var metric, imperial;

        metric = {
          "Pa": {
            "name": {
              "singular": "pascal",
              "plural": "pascals"
            },
            "to_anchor": "1/1000"
          },
          "kPa": {
            "name": {
              "singular": "kilopascal",
              "plural": "kilopascals"
            },
            "to_anchor": 1
          },
          "MPa": {
            "name": {
              "singular": "megapascal",
              "plural": "megapascals"
            },
            "to_anchor": 1000
          },
          "hPa": {
            "name": {
              "singular": "hectopascal",
              "plural": "hectopascals"
            },
            "to_anchor": 1/10
          },
          "bar": {
            "name": {
              "singular": "bar",
              "plural": "bar"
            },
            "to_anchor": 100
          },
          "torr": {
            "name": {
              "singular": "torr",
              "plural": "torr"
            },
            "to_anchor": 101325/760000
          }
        };

        imperial = {
          "psi": {
            "name": {
              "singular": "pound per square inch",
              "plural": "pounds per square inch"
            },
            "to_anchor": 1/1000
          },
          "ksi": {
            "name": {
              "singular": "kilopound per square inch",
              "plural": "kilopound per square inch"
            },
            "to_anchor": 1
          }
        };

        measures.pressure = {
          "metric": metric,
          "imperial": imperial,
          "_anchors": {
            "metric": {
              "unit": "kPa",
              "ratio": 0.00014503768078
            },
            "imperial": {
              "unit": "psi",
              "ratio": 1/0.00014503768078
            }
          }
        };
        

        ////////////////////////////////////////////////////////////////////////
        // Reactive Energy
        ////////////////////////////////////////////////////////////////////////
        
        var metric;

        metric = {
          "VARh": {
            "name": {
              "singular": "Volt-Ampere Reactive Hour",
              "plural": "Volt-Amperes Reactive Hour"
            },
            "to_anchor": 1
          },
          "mVARh": {
            "name": {
              "singular": "Millivolt-Ampere Reactive Hour",
              "plural": "Millivolt-Amperes Reactive Hour"
            },
            "to_anchor": 1/1000
          },
          "kVARh": {
            "name": {
              "singular": "Kilovolt-Ampere Reactive Hour",
              "plural": "Kilovolt-Amperes Reactive Hour"
            },
            "to_anchor": 1000
          },
          "MVARh": {
            "name": {
              "singular": "Megavolt-Ampere Reactive Hour",
              "plural": "Megavolt-Amperes Reactive Hour"
            },
            "to_anchor": 1000000
          },
          "GVARh": {
            "name": {
              "singular": "Gigavolt-Ampere Reactive Hour",
              "plural": "Gigavolt-Amperes Reactive Hour"
            },
            "to_anchor": 1000000000
          }
        };

        measures.reactiveEnergy = {
          "metric": metric,
          "_anchors": {
            "metric": {
              "unit": "VARh",
              "ratio": 1
            }
          }
        };
        

        ////////////////////////////////////////////////////////////////////////
        // Reactive Power
        ////////////////////////////////////////////////////////////////////////
        
        var metric;

        metric = {
          "VAR": {
            "name": {
              "singular": "Volt-Ampere Reactive",
              "plural": "Volt-Amperes Reactive"
            },
            "to_anchor": 1
          },
          "mVAR": {
            "name": {
              "singular": "Millivolt-Ampere Reactive",
              "plural": "Millivolt-Amperes Reactive"
            },
            "to_anchor": 1/1000
          },
          "kVAR": {
            "name": {
              "singular": "Kilovolt-Ampere Reactive",
              "plural": "Kilovolt-Amperes Reactive"
            },
            "to_anchor": 1000
          },
          "MVAR": {
            "name": {
              "singular": "Megavolt-Ampere Reactive",
              "plural": "Megavolt-Amperes Reactive"
            },
            "to_anchor": 1000000
          },
          "GVAR": {
            "name": {
              "singular": "Gigavolt-Ampere Reactive",
              "plural": "Gigavolt-Amperes Reactive"
            },
            "to_anchor": 1000000000
          }
        };

        measures.reactivePower = {
          "metric": metric,
          "_anchors": {
            "metric": {
              "unit": "VAR",
              "ratio": 1
            }
          }
        };


        ////////////////////////////////////////////////////////////////////////
        // Speed
        ////////////////////////////////////////////////////////////////////////
        
        var metric, imperial;

        metric = {
          "m/s": {
            "name": {
              "singular": "Metre per second",
              "plural": "Metres per second"
            },
            "to_anchor": 3.6
          },
          "km/h": {
            "name": {
              "singular": "Kilometre per hour",
              "plural": "Kilometres per hour"
            },
            "to_anchor": 1
          }
        }

        imperial = {
          "m/h": {
            "name": {
              "singular": "Mile per hour",
              "plural": "Miles per hour"
            },
            "to_anchor": 1
          },
          "knot": {
            "name": {
              "singular": "Knot",
              "plural": "Knots"
            },
            "to_anchor": 1.150779
          },
          "ft/s": {
            "name": {
              "singular": "Foot per second",
              "plural": "Feet per second"
            },
            "to_anchor": 0.681818
          }
        };

        measures.speed = {
          "metric": metric,
          "imperial": imperial,
          "_anchors": {
            "metric": {
              "unit": "km/h",
              "ratio": 1/1.609344
            },
            "imperial": {
              "unit": "m/h",
              "ratio": 1.609344
            }
          }
        };


        ////////////////////////////////////////////////////////////////////////
        // Temperature
        ////////////////////////////////////////////////////////////////////////
        
        var metric, imperial;

        metric = {
          "C": {
            "name": {
              "singular": "degree Celsius",
              "plural": "degrees Celsius"
            },
            "to_anchor": 1,
            "anchor_shift": 0
          },
          "°C": {
            "name": {
              "singular": "degree Celsius",
              "plural": "degrees Celsius"
            },
            "to_anchor": 1,
            "anchor_shift": 0
          },
          "K": {
            "name": {
              "singular": "degree Kelvin",
              "plural": "degrees Kelvin"
            },
            "to_anchor": 1,
            "anchor_shift": 273.15
          }
        };

        imperial = {
          "F": {
            "name": {
              "singular": "degree Fahrenheit",
              "plural": "degrees Fahrenheit"
            },
            "to_anchor": 1
          },
          "R": {
            "name": {
              "singular": "degree Rankine",
              "plural": "degrees Rankine"
            },
            "to_anchor": 1,
            "anchor_shift": 459.67
          }
        };

        measures.temperature = {
          "metric": metric,
          "imperial": imperial,
          "_anchors": {
            "metric": {
              "unit": "C",
              "transform": function (C) { return C / (5/9) + 32 }
            },
            "imperial": {
              "unit": "F",
              "transform": function (F) { return (F - 32) * (5/9) }
            }
          }
        };


        ////////////////////////////////////////////////////////////////////////
        // Time
        ////////////////////////////////////////////////////////////////////////

        var metric;
        var daysInYear = 365;

        metric = {
          "ns": {
            "name": {
              "singular": "Nanosecond",
              "plural": "Nanoseconds"
            },
            "to_anchor": 1/1000000000
          },
          "mu": {
            "name": {
              "singular": "Microsecond",
              "plural": "Microseconds"
            },
            "to_anchor": 1/1000000
          },
          "ms": {
            "name": {
              "singular": "Millisecond",
              "plural": "Milliseconds"
            },
            "to_anchor": 1/1000
          },
          "s": {
            "name": {
              "singular": "Second",
              "plural": "Seconds"
            },
            "to_anchor": 1
          },
          "min": {
            "name": {
              "singular": "Minute",
              "plural": "Minutes"
            },
            "to_anchor": 60
          },
          "h": {
            "name": {
              "singular": "Hour",
              "plural": "Hours"
            },
            "to_anchor": 3600
          },
          "d": {
            "name": {
              "singular": "Day",
              "plural": "Days"
            },
            "to_anchor": 86400
          },
          "week": {
            "name": {
              "singular": "Week",
              "plural": "Weeks"
            },
            "to_anchor": 604800
          },
          "month": {
            "name": {
              "singular": "Month",
              "plural": "Months"
            },
            "to_anchor": 86400 * daysInYear / 12
          },
          "year": {
            "name": {
              "singular": "Year",
              "plural": "Years"
            },
            "to_anchor": 86400 * daysInYear
          }
        };
        
        measures.time = {
          "metric": metric
        , "_anchors": {
            "metric": {
              "unit": "s"
            , "ratio": 1
            }
          }
        };
        

        ////////////////////////////////////////////////////////////////////////
        // Voltage
        ////////////////////////////////////////////////////////////////////////

        var metric;

        metric = {
          "V": {
            "name": {
              "singular": "Volt"
            , "plural": "Volts"
            }
          , "to_anchor": 1
          }
        , "mV": {
            "name": {
              "singular": "Millivolt"
              , "plural": "Millivolts"
            }
            , "to_anchor": 1/1000
          }
        , "kV": {
            "name": {
              "singular": "Kilovolt"
            , "plural": "Kilovolts"
            }
          , "to_anchor": 1000
          }
        };

        measures.voltage = {
          "metric": metric,
          "_anchors": {
            "metric": {
              "unit": "V",
              "ratio": 1
            }
          }
        };


        ////////////////////////////////////////////////////////////////////////
        // Volume I (Cubic meters)
        ////////////////////////////////////////////////////////////////////////

        var metric, imperial;

        metric = {
          "mm3": {
            "name": {
              "singular": "Cubic Millimeter",
              "plural": "Cubic Millimeters"
            },
            "to_anchor": 1/1000000000
          },
          "cm3": {
            "name": {
              "singular": "Cubic Centimeter",
              "plural": "Cubic Centimeters"
            },
            "to_anchor": 1/1000000
          },
          "dm3": {
            "name": {
              "singular": "Cubic Centimeter",
              "plural": "Cubic Centimeters"
            },
            "to_anchor": 1/1000
          },
          "m3": {
            "name": {
              "singular": "Cubic meter",
              "plural": "Cubic meters"
            },
            "to_anchor": 1
          },
          "dam3": {
            "name": {
              "singular": "Cubic decameter",
              "plural": "Cubic decameters"
            },
            "to_anchor": 1000
          },
          "hm3": {
            "name": {
              "singular": "Cubic hectometer",
              "plural": "Cubic hectometers"
            },
            "to_anchor": 1000000
          },
          "km3": {
            "name": {
              "singular": "Cubic kilometer",
              "plural": "Cubic kilometers"
            },
            "to_anchor": 1000000000
          }
        };

        measures.volume1 = {
          "metric": metric,
          "_anchors": {
            "metric": {
              "unit": "m3",
              "ratio": 1
            }
          }
        };


        ////////////////////////////////////////////////////////////////////////
        // Volume II (Litres)
        ////////////////////////////////////////////////////////////////////////

        var metric, imperial;

        metric = {
          "ml": {
            "name": {
              "singular": "Millilitre",
              "plural": "Millilitres"
            },
            "to_anchor": 1/1000
          },
          "cl": {
            "name": {
              "singular": "Centilitre",
              "plural": "Centilitres"
            },
            "to_anchor": 1/100
          },
          "dl": {
            "name": {
              "singular": "Decilitre",
              "plural": "Decilitres"
            },
            "to_anchor": 1/10
          },
          "l": {
            "name": {
              "singular": "Litre",
              "plural": "Litres"
            },
            "to_anchor": 1
          },
          "lt": {
            "name": {
              "singular": "Litre",
              "plural": "Litres"
            },
            "to_anchor": 1
          },
          "dal": {
            "name": {
              "singular": "Decalitre",
              "plural": "Decalitres"
            },
            "to_anchor": 10
          },
          "hl": {
            "name": {
              "singular": "Hectolitre",
              "plural": "Hectolitres"
            },
            "to_anchor": 100
          },
          "kl": {
            "name": {
              "singular": "Kilolitre",
              "plural": "Kilolitres"
            },
            "to_anchor": 1000
          }
        };

        imperial = {
          "tsp": {
            "name": {
              "singular": "Teaspoon",
              "plural": "Teaspoons"
            },
            "to_anchor": 1/6
          },
          "Tbs": {
            "name": {
              "singular": "Tablespoon",
              "plural": "Tablespoons"
            },
            "to_anchor": 1/2
          },
          "in3": {
            "name": {
              "singular": "Cubic inch",
              "plural": "Cubic inches"
            },
            "to_anchor": 0.55411
          },
          "fl-oz": {
            "name": {
              "singular": "Fluid Ounce",
              "plural": "Fluid Ounces"
            },
            "to_anchor": 1
          },
          "cup": {
            "name": {
              "singular": "Cup",
              "plural": "Cups"
            },
            "to_anchor": 8
          },
          "pnt": {
            "name": {
              "singular": "Pint",
              "plural": "Pints"
            },
            "to_anchor": 16
          },
          "qt": {
            "name": {
              "singular": "Quart",
              "plural": "Quarts"
            },
            "to_anchor": 32
          },
          "gal": {
            "name": {
              "singular": "Gallon",
              "plural": "Gallons"
            },
            "to_anchor": 128
          },
          "ft3": {
            "name": {
              "singular": "Cubic foot",
              "plural": "Cubic feet"
            },
            "to_anchor": 957.506
          },
          "yd3": {
            "name": {
              "singular": "Cubic yard",
              "plural": "Cubic yards"
            },
            "to_anchor": 25852.7
          }
        };

        measures.volume2 = {
          "metric": metric,
          "imperial": imperial,
          "_anchors": {
            "metric": {
              "unit": "l",
              "ratio": 33.8140226
            },
            "imperial": {
              "unit": "fl-oz",
              "ratio": 1/33.8140226
            }
          }
        };


        ////////////////////////////////////////////////////////////////////////
        // Flow Rate
        ////////////////////////////////////////////////////////////////////////

        var metric, imperial;

        metric = {
          "mm3/s": {
            "name": {
              "singular": "Cubic Millimeter per second",
              "plural": "Cubic Millimeters per second"
            },
            "to_anchor": 1/1000000
          },
          "cm3/s": {
            "name": {
              "singular": "Cubic Centimeter per second",
              "plural": "Cubic Centimeters per second"
            },
            "to_anchor": 1/1000
          },
          "ml/s": {
            "name": {
              "singular": "Millilitre per second",
              "plural": "Millilitres per second"
            },
            "to_anchor": 1/1000
          },
          "cl/s": {
            "name": {
              "singular": "Centilitre per second",
              "plural": "Centilitres per second"
            },
            "to_anchor": 1/100
          },
          "dl/s": {
            "name": {
              "singular": "Decilitre per second",
              "plural": "Decilitres per second"
            },
            "to_anchor": 1/10
          },
          "l/s": {
            "name": {
              "singular": "Litre per second",
              "plural": "Litres per second"
            },
            "to_anchor": 1
          },
          "l/min": {
            "name": {
              "singular": "Litre per minute",
              "plural": "Litres per minute"
            },
            "to_anchor": 1/60
          },
          "l/h": {
            "name": {
              "singular": "Litre per hour",
              "plural": "Litres per hour"
            },
            "to_anchor": 1/3600
          },
          "kl/s": {
            "name": {
              "singular": "Kilolitre per second",
              "plural": "Kilolitres per second"
            },
            "to_anchor": 1000
          },
          "kl/min": {
            "name": {
              "singular": "Kilolitre per minute",
              "plural": "Kilolitres per minute"
            },
            "to_anchor": 50/3
          },
          "kl/h": {
            "name": {
              "singular": "Kilolitre per hour",
              "plural": "Kilolitres per hour"
            },
            "to_anchor": 5/18
          },
          "m3/s": {
            "name": {
              "singular": "Cubic meter per second",
              "plural": "Cubic meters per second"
            },
            "to_anchor": 1000
          },
          "m3/min": {
            "name": {
              "singular": "Cubic meter per minute",
              "plural": "Cubic meters per minute"
            },
            "to_anchor": 50/3
          },
          "m3/h": {
            "name": {
              "singular": "Cubic meter per hour",
              "plural": "Cubic meters per hour"
            },
            "to_anchor": 5/18
          },
          "km3/s": {
            "name": {
              "singular": "Cubic kilometer per second",
              "plural": "Cubic kilometers per second"
            },
            "to_anchor": 1000000000000
          }
        };

        imperial = {
          "tsp/s": {
            "name": {
              "singular": "Teaspoon per second",
              "plural": "Teaspoons per second"
            },
            "to_anchor": 1/6
          },
          "Tbs/s": {
            "name": {
              "singular": "Tablespoon per second",
              "plural": "Tablespoons per second"
            },
            "to_anchor": 1/2
          },
          "in3/s": {
            "name": {
              "singular": "Cubic inch per second",
              "plural": "Cubic inches per second"
            },
            "to_anchor": 0.55411
          },
          "in3/min": {
            "name": {
              "singular": "Cubic inch per minute",
              "plural": "Cubic inches per minute"
            },
            "to_anchor": 0.55411/60
          },
          "in3/h": {
            "name": {
              "singular": "Cubic inch per hour",
              "plural": "Cubic inches per hour"
            },
            "to_anchor": 0.55411/3600
          },
          "fl-oz/s": {
            "name": {
              "singular": "Fluid Ounce per second",
              "plural": "Fluid Ounces per second"
            },
            "to_anchor": 1
          },
          "fl-oz/min": {
            "name": {
              "singular": "Fluid Ounce per minute",
              "plural": "Fluid Ounces per minute"
            },
            "to_anchor": 1/60
          },
          "fl-oz/h": {
            "name": {
              "singular": "Fluid Ounce per hour",
              "plural": "Fluid Ounces per hour"
            },
            "to_anchor": 1/3600
          },
          "cup/s": {
            "name": {
              "singular": "Cup per second",
              "plural": "Cups per second"
            },
            "to_anchor": 8
          },
          "pnt/s": {
            "name": {
              "singular": "Pint per second",
              "plural": "Pints per second"
            },
            "to_anchor": 16
          },
          "pnt/min": {
            "name": {
              "singular": "Pint per minute",
              "plural": "Pints per minute"
            },
            "to_anchor": 4/15
          },
          "pnt/h": {
            "name": {
              "singular": "Pint per hour",
              "plural": "Pints per hour"
            },
            "to_anchor": 1/225
          },
          "qt/s": {
            "name": {
              "singular": "Quart per second",
              "plural": "Quarts per second"
            },
            "to_anchor": 32
          },
          "gal/s": {
            "name": {
              "singular": "Gallon per second",
              "plural": "Gallons per second"
            },
            "to_anchor": 128
          },
          "gal/min": {
            "name": {
              "singular": "Gallon per minute",
              "plural": "Gallons per minute"
            },
            "to_anchor": 32/15
          },
          "gal/h": {
            "name": {
              "singular": "Gallon per hour",
              "plural": "Gallons per hour"
            },
            "to_anchor": 8/225
          },
          "ft3/s": {
            "name": {
              "singular": "Cubic foot per second",
              "plural": "Cubic feet per second"
            },
            "to_anchor": 957.506
          },
          "ft3/min": {
            "name": {
              "singular": "Cubic foot per minute",
              "plural": "Cubic feet per minute"
            },
            "to_anchor": 957.506/60
          },
          "ft3/h": {
            "name": {
              "singular": "Cubic foot per hour",
              "plural": "Cubic feet per hour"
            },
            "to_anchor": 957.506/3600
          },
          "yd3/s": {
            "name": {
              "singular": "Cubic yard per second",
              "plural": "Cubic yards per second"
            },
            "to_anchor": 25852.7
          },
          "yd3/min": {
            "name": {
              "singular": "Cubic yard per minute",
              "plural": "Cubic yards per minute"
            },
            "to_anchor": 25852.7/60
          },
          "yd3/h": {
            "name": {
              "singular": "Cubic yard per hour",
              "plural": "Cubic yards per hour"
            },
            "to_anchor": 25852.7/3600
          }
        };

        measures.flowrate = {
          "metric": metric,
          "imperial": imperial,
          "_anchors": {
            "metric": {
              "unit": "l/s",
              "ratio": 33.8140227
            },
            "imperial": {
              "unit": "fl-oz/s",
              "ratio": 1/33.8140227
            }
          }
        };

        var metric, imperial;

        metric = {
          "%": {
            "name": {
              "singular": "Percent",
              "plural": "Percent"
            },
            "to_anchor": 1
          }
        };
        
        measures.other = {
          "metric": metric,
          "_anchors": {
            "metric": {
              "unit": "%",
              "ratio": 1
            }
          }
        };


        //////////
        

        var service = {
            measures: measures,
            val: 0,
            destination: '',
            origin: '',
            _reset: _reset,
            from: from,
            to: to,
            toBest: toBest,
            getUnit: getUnit,
            _describe: _describe,
            describe: describe,
            list: list,
            throwUnsupportedUnitError: throwUnsupportedUnitError,
            possibilities: possibilities,
            convert: convert
        };
        
        return service;
        
        
        //////////
        
        /**
        * Reset the converter.
        */
        function _reset() {
            this.val = 0;
            this.origin = ''
            this.destination = ''
        }
        
        /**
        * Lets the converter know the source unit abbreviation
        */
        function from(from) {
            if (this.destination) {
                throw new Error('.from must be called before .to');
            }

            this.origin = this.getUnit(from);

            if (!this.origin) {
                this.throwUnsupportedUnitError(from);
            }

            return this;
        }
        
        /**
        * Converts the unit and returns the value
        */
        function to(to) {
            if (!this.origin) {
                throw new Error('.to must be called after .from');
            }
            
            this.destination = this.getUnit(to);
            
            var result, transform;
            
            if (!this.destination) {
                this.throwUnsupportedUnitError(to);
            }

            // Don't change the value if origin and destination are the same
            if (this.origin.abbr === this.destination.abbr) {
                return this.val;
            }
            
            // You can't go from liquid to mass, for example
            if (this.destination.measure != this.origin.measure) {
                throw new Error('Cannot convert incompatible measures of ' + this.destination.measure + ' and ' + this.origin.measure);
            }

            /**
            * Convert from the source value to its anchor inside the system
            */
            result = this.val * this.origin.unit.to_anchor;
            
            /**
            * For some changes it's a simple shift (C to K)
            * So we'll add it when converting into the unit (later)
            * and subtract it when converting from the unit
            */
            if (this.origin.unit.anchor_shift) {
                result -= this.origin.unit.anchor_shift
            }
            
            /**
            * Convert from one system to another through the anchor ratio. Some conversions
            * aren't ratio based or require more than a simple shift. We can provide a custom
            * transform here to provide the direct result
            */
            if (this.origin.system != this.destination.system) {
                transform = measures[this.origin.measure]._anchors[this.origin.system].transform;
                if (typeof transform === 'function') {
                    result = transform(result)
                }
                else {
                    result *= measures[this.origin.measure]._anchors[this.origin.system].ratio;
                }
            }
            
            /**
            * This shift has to be done after the system conversion business
            */
            if (this.destination.unit.anchor_shift) {
                result += this.destination.unit.anchor_shift;
            }
            
            /**
            * Convert to another unit inside the destination system
            */
            return result / this.destination.unit.to_anchor;
        };

        /**
        * Converts the unit to the best available unit.
        */
        function toBest(options) {
            if (!this.origin) {
                throw new Error('.toBest must be called after .from');
            }

            var options = Object.assign({
                exclude: [],
                cutOffNumber: 0.1,
            }, options);

            var best;
            /**
            Looks through every possibility for the 'best' available unit.
            i.e. Where the value has the fewest numbers before the decimal point,
            but is still higher than 1.
            */
            _.each (this.possibilities(), function(possibility) {
                var unit = this.describe(possibility);
                var isIncluded = options.exclude.indexOf(possibility) === -1;

                if (isIncluded && unit.system === this.origin.system) {
                    var result = this.to(possibility);
                    if (!best || (result >= options.cutOffNumber && result < best.val)) {
                        best = {
                            val: result,
                            unit: possibility,
                            singular: unit.singular,
                            plural: unit.plural
                        };
                    }
                }
            }.bind(this));
            
            return best;
        }

        /**
        * Finds the unit
        */
        function getUnit(abbr) {
            var found;

            _.each(measures, function (systems, measure) {
                _.each(systems, function (units, system) {
                    if (system == '_anchors') {
                        return false;
                    }

                    _.each(units, function (unit, testAbbr) {
                        if (testAbbr == abbr) {
                            found = {
                                abbr: abbr,
                                measure: measure,
                                system: system,
                                unit: unit
                            };
                            return false;
                        }
                    });

                    if (found) {
                        return false;
                    }
                });

                if (found) {
                    return false;
                }
            });
            
            return found;
        }
        
        function _describe(resp) {
            return {
                abbr: resp.abbr,
                measure: resp.measure,
                system: resp.system,
                singular: resp.unit.name.singular,
                plural: resp.unit.name.plural
            };
        }
        
        /**
        * An alias for getUnit
        */
        function describe(abbr) {
            var resp = this.getUnit(abbr);
            var desc = null;
            
            try {
                desc = this._describe(resp);
            }
            catch(err) {
                this.throwUnsupportedUnitError(abbr);
            }

            return desc;
        };
        
        /**
        * Detailed list of all supported units
        */
        function list(measure) {
            var list = [];
            
            _.each(measures, function (systems, testMeasure) {
                if (measure && measure !== testMeasure) {
                    return;
                }
                
                _.each(systems, function (units, system) {
                    if (system == '_anchors') {
                        return false;
                    }
                    
                    _.each(units, function (unit, abbr) {
                        list = list.concat(_describe({
                            abbr: abbr,
                            measure: testMeasure,
                            system: system,
                            unit: unit
                        }));
                    });
                });
            });

            return list;
        };

        /**
        * Throws unsupported error.
        */
        function throwUnsupportedUnitError(what) {
            var validUnits = [];

            _.each(measures, function (systems, measure) {
                _.each(systems, function (units, system) {
                    if (system == '_anchors') {
                        return false;
                    }
                    validUnits = validUnits.concat(_.keys(units));
                });
            });

            throw new Error('Unsupported unit ' + what + ', use one of: ' + validUnits.join(', '));
        }

        /**
        * Returns the abbreviated measures that the value can be
        * converted to.
        */
        function possibilities(measure) {
            var possibilities = [];
            if (!this.origin && !measure) {
                _.each(_.keys(measures), function (measure) {
                    _.each(measures[measure], function (units, system) {
                        if (system == '_anchors') {
                            return false;
                        }

                        possibilities = possibilities.concat(_.keys(units));
                    });
                });
            }
            else {
                measure = measure || this.origin.measure;
                _.each(measures[measure], function (units, system) {
                    if (system == '_anchors') {
                        return false;
                    }
                    possibilities = possibilities.concat(_.keys(units));
                });
            }

            return possibilities;
        };

        /**
        * Set value.
        */
        function convert(numerator, denominator) {
            this._reset();
            if (denominator) {
                this.val = numerator / denominator;
            }
            else {
                this.val = numerator;
            }
            return this;
        }
        
    }
        
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('auth', authService);

    /** @ngInject */
    function authService($http, $window, $location, $state, session)
    {
        var service = {
            isLoggedIn: isLoggedIn,
			logIn: logIn,
			logOut: logOut
        };

        return service;
        //////////
		
        /**
         * Check whether the user is logged in
         * @returns boolean
         */
		function isLoggedIn()
		{
			return session.getUser() !== null && session.getUser() !== undefined;
		};

        /**
         * Log in
         * @param credentials
		 * @returns {*|Promise}
         */
		function logIn(credentials)
		{
		  session.destroy();
		  return $http
			.post(
				'https://hydra.iti.gr:8101/oauth2/token',
				{'code': credentials, 'grant_type': 'authorization_code', 'redirect_uri' : 'https://hydra.iti.gr/PRAGMA'},
				{'headers': {'Authorization': 'Basic RUVwb3J0YWw6MzNwb3J0QGw='}}
			)
			.then(function(response) {
				var data = response.data;
				if (data.access_token != undefined) {
					session.setUser(data.access_token);
					$window.location.reload();
				}
				else {
					$location.path('/auth/login?failed=true').replace();
				}
			});
		};

        /**
         * Log out
 		 * @returns {*|Promise}
         */
		function logOut ()
		{
		  return $http
			.get('https://hydra.iti.gr:8101/logout')
			.then(function(response){
			  // Destroy session in the browser
			  session.destroy();
			  $location.path('/auth/login').replace();
			});
		};
	}

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('MqttClient', Paho);

    /** @ngInject */
    function Paho()
    {
         var client = {};

        // initialize attributes
        client._location = "";
        client._port = "";
        client._id = "";
        client._client = null;
        client._isConnected = false;

        // member functions
        client.init = init;
        client.connect = connect;
        client.disconnect = disconnect;
        client.send = send;
        client.startTrace = startTrace;
        client.stopTrace = stopTrace;
        client.subscribe = subscribe;
        client.unsubscribe = unsubscribe;

        return client;

        // onConnectionLost callback

        function _call(cb, args) {
        if (client._client) {
            cb.apply(this, args);
        } else {
            console.log('Angular-Paho: Client must be initialized first.  Call init() function.');
        }
        }

        function onConnectionLost(resp) {
        console.log("Angular-Paho: Connection lost on ", client._id, ", error code: ", resp);
        client._isConnected = false;
        }

        // connects to the MQTT Server
        function connect(options) {
        _call(_connect, [options]);
        }

        function _connect(options) {
        client._client.connect(options);
        client._isConnected = client._client.isConnected();
        }

        function disconnect() {
        _call(_disconnect);
        }

        function _disconnect() {
        client._client.disconnect();
        client._isConnected = false;
        }

        function init(location, port, id) {
        // initialize attributes
        client._location = location;
        client._port = port;
        client._id = id;

        // create the client and callbacks
        client._client = new Paho.MQTT.Client(client._location, Number(client._port), client._id);
        client._client.onConnectionLost = onConnectionLost;
        client._client.onMessageArrived = onMessageArrived;
        }

        function onMessageArrived(message) {
        console.log("onMessageArrived:"+message.payloadString);
        }

        function send(message) {
        _call(_send, [message]);
        }

        function _send(message) {
        client._client.send(message);
        }

        function startTrace() {
        _call(_startTrace);
        }

        function _startTrace() {
        client._client.startTrace();
        }

        function stopTrace() {
        _call(_stopTrace);
        }

        function _stopTrace() {
        client._client.stopTrace();
        }

        function subscribe(filter, options) {
        _call(_subscribe, [filter, options]);
        }

        function _subscribe(filter, options) {
        client._client.subscribe(filter, options);
        }

        function unsubscribe(filter, options) {
        _call(_unsubscribe, [filter, options]);
        }

        function _unsubscribe(filter, options) {
        client._client.unsubscribe(filter, options);
        }
    }
    
})();
// Generated by CoffeeScript 1.8.0
(function() {
  var Framebuffer, Heights, Node, Shader, Texture, WebGLHeatmap, fragmentShaderBlit, nukeVendorPrefix, textureFloatShims, vertexShaderBlit,
    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  nukeVendorPrefix = function() {
    var getExtension, getSupportedExtensions, vendorRe, vendors;
    if (window.WebGLRenderingContext != null) {
      vendors = ['WEBKIT', 'MOZ', 'MS', 'O'];
      vendorRe = /^WEBKIT_(.*)|MOZ_(.*)|MS_(.*)|O_(.*)/;
      getExtension = WebGLRenderingContext.prototype.getExtension;
      WebGLRenderingContext.prototype.getExtension = function(name) {
        var extobj, match, vendor, _i, _len;
        match = name.match(vendorRe);
        if (match !== null) {
          name = match[1];
        }
        extobj = getExtension.call(this, name);
        if (extobj === null) {
          for (_i = 0, _len = vendors.length; _i < _len; _i++) {
            vendor = vendors[_i];
            extobj = getExtension.call(this, vendor + '_' + name);
            if (extobj !== null) {
              return extobj;
            }
          }
          return null;
        } else {
          return extobj;
        }
      };
      getSupportedExtensions = WebGLRenderingContext.prototype.getSupportedExtensions;
      return WebGLRenderingContext.prototype.getSupportedExtensions = function() {
        var extension, match, result, supported, _i, _len;
        supported = getSupportedExtensions.call(this);
        result = [];
        for (_i = 0, _len = supported.length; _i < _len; _i++) {
          extension = supported[_i];
          match = extension.match(vendorRe);
          if (match !== null) {
            extension = match[1];
          }
          if (__indexOf.call(result, extension) < 0) {
            result.push(extension);
          }
        }
        return result;
      };
    }
  };

  textureFloatShims = function() {
    var checkColorBuffer, checkFloatLinear, checkSupport, checkTexture, createSourceCanvas, getExtension, getSupportedExtensions, name, shimExtensions, shimLookup, unshimExtensions, unshimLookup, _i, _len;
    createSourceCanvas = function() {
      var canvas, ctx, imageData;
      canvas = document.createElement('canvas');
      canvas.width = 2;
      canvas.height = 2;
      ctx = canvas.getContext('2d');
      imageData = ctx.getImageData(0, 0, 2, 2);
      imageData.data.set(new Uint8ClampedArray([0, 0, 0, 0, 255, 255, 255, 255, 0, 0, 0, 0, 255, 255, 255, 255]));
      ctx.putImageData(imageData, 0, 0);
      return canvas;
    };
    createSourceCanvas();
    checkFloatLinear = function(gl, sourceType) {
      var buffer, cleanup, fragmentShader, framebuffer, positionLoc, program, readBuffer, result, source, sourceCanvas, sourceLoc, target, vertexShader, vertices;
      program = gl.createProgram();
      vertexShader = gl.createShader(gl.VERTEX_SHADER);
      gl.attachShader(program, vertexShader);
      gl.shaderSource(vertexShader, 'attribute vec2 position;\nvoid main(){\n    gl_Position = vec4(position, 0.0, 1.0);\n}');
      gl.compileShader(vertexShader);
      if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
        throw gl.getShaderInfoLog(vertexShader);
      }
      fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
      gl.attachShader(program, fragmentShader);
      gl.shaderSource(fragmentShader, 'uniform sampler2D source;\nvoid main(){\n    gl_FragColor = texture2D(source, vec2(1.0, 1.0));\n}');
      gl.compileShader(fragmentShader);
      if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
        throw gl.getShaderInfoLog(fragmentShader);
      }
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        throw gl.getProgramInfoLog(program);
      }
      gl.useProgram(program);
      cleanup = function() {
        gl.deleteShader(fragmentShader);
        gl.deleteShader(vertexShader);
        gl.deleteProgram(program);
        gl.deleteBuffer(buffer);
        gl.deleteTexture(source);
        gl.deleteTexture(target);
        gl.deleteFramebuffer(framebuffer);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
        gl.useProgram(null);
        gl.bindTexture(gl.TEXTURE_2D, null);
        return gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      };
      target = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, target);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 2, 2, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      framebuffer = gl.createFramebuffer();
      gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target, 0);
      sourceCanvas = createSourceCanvas();
      source = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, source);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, sourceType, sourceCanvas);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      vertices = new Float32Array([1, 1, -1, 1, -1, -1, 1, 1, -1, -1, 1, -1]);
      buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
      positionLoc = gl.getAttribLocation(program, 'position');
      sourceLoc = gl.getUniformLocation(program, 'source');
      gl.enableVertexAttribArray(positionLoc);
      gl.vertexAttribPointer(positionLoc, 2, gl.FLOAT, false, 0, 0);
      gl.uniform1i(sourceLoc, 0);
      gl.drawArrays(gl.TRIANGLES, 0, 6);
      readBuffer = new Uint8Array(4 * 4);
      gl.readPixels(0, 0, 2, 2, gl.RGBA, gl.UNSIGNED_BYTE, readBuffer);
      result = Math.abs(readBuffer[0] - 127) < 10;
      cleanup();
      return result;
    };
    checkTexture = function(gl, targetType) {
      var target;
      target = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, target);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 2, 2, 0, gl.RGBA, targetType, null);
      if (gl.getError() === 0) {
        gl.deleteTexture(target);
        return true;
      } else {
        gl.deleteTexture(target);
        return false;
      }
    };
    checkColorBuffer = function(gl, targetType) {
      var check, framebuffer, target;
      target = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, target);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 2, 2, 0, gl.RGBA, targetType, null);
      framebuffer = gl.createFramebuffer();
      gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, target, 0);
      check = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
      gl.deleteTexture(target);
      gl.deleteFramebuffer(framebuffer);
      gl.bindTexture(gl.TEXTURE_2D, null);
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      if (check === gl.FRAMEBUFFER_COMPLETE) {
        return true;
      } else {
        return false;
      }
    };
    shimExtensions = [];
    shimLookup = {};
    unshimExtensions = [];
    checkSupport = function() {
      var canvas, extobj, gl, halfFloatExt, halfFloatTexturing, singleFloatExt, singleFloatTexturing;
      canvas = document.createElement('canvas');
      gl = null;
      try {
        gl = canvas.getContext('experimental-webgl');
        if (gl === null) {
          gl = canvas.getContext('webgl');
        }
      } catch (_error) {}
      if (gl != null) {
        singleFloatExt = gl.getExtension('OES_texture_float');
        if (singleFloatExt === null) {
          if (checkTexture(gl, gl.FLOAT)) {
            singleFloatTexturing = true;
            shimExtensions.push('OES_texture_float');
            shimLookup.OES_texture_float = {
              shim: true
            };
          } else {
            singleFloatTexturing = false;
            unshimExtensions.push('OES_texture_float');
          }
        } else {
          if (checkTexture(gl, gl.FLOAT)) {
            singleFloatTexturing = true;
            shimExtensions.push('OES_texture_float');
          } else {
            singleFloatTexturing = false;
            unshimExtensions.push('OES_texture_float');
          }
        }
        if (singleFloatTexturing) {
          extobj = gl.getExtension('WEBGL_color_buffer_float');
          if (extobj === null) {
            if (checkColorBuffer(gl, gl.FLOAT)) {
              shimExtensions.push('WEBGL_color_buffer_float');
              shimLookup.WEBGL_color_buffer_float = {
                shim: true,
                RGBA32F_EXT: 0x8814,
                RGB32F_EXT: 0x8815,
                FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE_EXT: 0x8211,
                UNSIGNED_NORMALIZED_EXT: 0x8C17
              };
            } else {
              unshimExtensions.push('WEBGL_color_buffer_float');
            }
          } else {
            if (checkColorBuffer(gl, gl.FLOAT)) {
              shimExtensions.push('WEBGL_color_buffer_float');
            } else {
              unshimExtensions.push('WEBGL_color_buffer_float');
            }
          }
          extobj = gl.getExtension('OES_texture_float_linear');
          if (extobj === null) {
            if (checkFloatLinear(gl, gl.FLOAT)) {
              shimExtensions.push('OES_texture_float_linear');
              shimLookup.OES_texture_float_linear = {
                shim: true
              };
            } else {
              unshimExtensions.push('OES_texture_float_linear');
            }
          } else {
            if (checkFloatLinear(gl, gl.FLOAT)) {
              shimExtensions.push('OES_texture_float_linear');
            } else {
              unshimExtensions.push('OES_texture_float_linear');
            }
          }
        }
        halfFloatExt = gl.getExtension('OES_texture_half_float');
        if (halfFloatExt === null) {
          if (checkTexture(gl, 0x8D61)) {
            halfFloatTexturing = true;
            shimExtensions.push('OES_texture_half_float');
            halfFloatExt = shimLookup.OES_texture_half_float = {
              HALF_FLOAT_OES: 0x8D61,
              shim: true
            };
          } else {
            halfFloatTexturing = false;
            unshimExtensions.push('OES_texture_half_float');
          }
        } else {
          if (checkTexture(gl, halfFloatExt.HALF_FLOAT_OES)) {
            halfFloatTexturing = true;
            shimExtensions.push('OES_texture_half_float');
          } else {
            halfFloatTexturing = false;
            unshimExtensions.push('OES_texture_half_float');
          }
        }
        if (halfFloatTexturing) {
          extobj = gl.getExtension('EXT_color_buffer_half_float');
          if (extobj === null) {
            if (checkColorBuffer(gl, halfFloatExt.HALF_FLOAT_OES)) {
              shimExtensions.push('EXT_color_buffer_half_float');
              shimLookup.EXT_color_buffer_half_float = {
                shim: true,
                RGBA16F_EXT: 0x881A,
                RGB16F_EXT: 0x881B,
                FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE_EXT: 0x8211,
                UNSIGNED_NORMALIZED_EXT: 0x8C17
              };
            } else {
              unshimExtensions.push('EXT_color_buffer_half_float');
            }
          } else {
            if (checkColorBuffer(gl, halfFloatExt.HALF_FLOAT_OES)) {
              shimExtensions.push('EXT_color_buffer_half_float');
            } else {
              unshimExtensions.push('EXT_color_buffer_half_float');
            }
          }
          extobj = gl.getExtension('OES_texture_half_float_linear');
          if (extobj === null) {
            if (checkFloatLinear(gl, halfFloatExt.HALF_FLOAT_OES)) {
              shimExtensions.push('OES_texture_half_float_linear');
              return shimLookup.OES_texture_half_float_linear = {
                shim: true
              };
            } else {
              return unshimExtensions.push('OES_texture_half_float_linear');
            }
          } else {
            if (checkFloatLinear(gl, halfFloatExt.HALF_FLOAT_OES)) {
              return shimExtensions.push('OES_texture_half_float_linear');
            } else {
              return unshimExtensions.push('OES_texture_half_float_linear');
            }
          }
        }
      }
    };
    if (window.WebGLRenderingContext != null) {
      checkSupport();
      unshimLookup = {};
      for (_i = 0, _len = unshimExtensions.length; _i < _len; _i++) {
        name = unshimExtensions[_i];
        unshimLookup[name] = true;
      }
      getExtension = WebGLRenderingContext.prototype.getExtension;
      WebGLRenderingContext.prototype.getExtension = function(name) {
        var extobj;
        extobj = shimLookup[name];
        if (extobj === void 0) {
          if (unshimLookup[name]) {
            return null;
          } else {
            return getExtension.call(this, name);
          }
        } else {
          return extobj;
        }
      };
      getSupportedExtensions = WebGLRenderingContext.prototype.getSupportedExtensions;
      WebGLRenderingContext.prototype.getSupportedExtensions = function() {
        var extension, result, supported, _j, _k, _len1, _len2;
        supported = getSupportedExtensions.call(this);
        result = [];
        for (_j = 0, _len1 = supported.length; _j < _len1; _j++) {
          extension = supported[_j];
          if (unshimLookup[extension] === void 0) {
            result.push(extension);
          }
        }
        for (_k = 0, _len2 = shimExtensions.length; _k < _len2; _k++) {
          extension = shimExtensions[_k];
          if (__indexOf.call(result, extension) < 0) {
            result.push(extension);
          }
        }
        return result;
      };
      return WebGLRenderingContext.prototype.getFloatExtension = function(spec) {
        var candidate, candidates, half, halfFramebuffer, halfLinear, halfTexture, i, importance, preference, result, single, singleFramebuffer, singleLinear, singleTexture, use, _j, _k, _l, _len1, _len2, _len3, _len4, _m, _ref, _ref1, _ref2;
        if (spec.prefer == null) {
          spec.prefer = ['half'];
        }
        if (spec.require == null) {
          spec.require = [];
        }
        if (spec.throws == null) {
          spec.throws = true;
        }
        singleTexture = this.getExtension('OES_texture_float');
        halfTexture = this.getExtension('OES_texture_half_float');
        singleFramebuffer = this.getExtension('WEBGL_color_buffer_float');
        halfFramebuffer = this.getExtension('EXT_color_buffer_half_float');
        singleLinear = this.getExtension('OES_texture_float_linear');
        halfLinear = this.getExtension('OES_texture_half_float_linear');
        single = {
          texture: singleTexture !== null,
          filterable: singleLinear !== null,
          renderable: singleFramebuffer !== null,
          score: 0,
          precision: 'single',
          half: false,
          single: true,
          type: this.FLOAT
        };
        half = {
          texture: halfTexture !== null,
          filterable: halfLinear !== null,
          renderable: halfFramebuffer !== null,
          score: 0,
          precision: 'half',
          half: true,
          single: false,
          type: (_ref = halfTexture != null ? halfTexture.HALF_FLOAT_OES : void 0) != null ? _ref : null
        };
        candidates = [];
        if (single.texture) {
          candidates.push(single);
        }
        if (half.texture) {
          candidates.push(half);
        }
        result = [];
        for (_j = 0, _len1 = candidates.length; _j < _len1; _j++) {
          candidate = candidates[_j];
          use = true;
          _ref1 = spec.require;
          for (_k = 0, _len2 = _ref1.length; _k < _len2; _k++) {
            name = _ref1[_k];
            if (candidate[name] === false) {
              use = false;
            }
          }
          if (use) {
            result.push(candidate);
          }
        }
        for (_l = 0, _len3 = result.length; _l < _len3; _l++) {
          candidate = result[_l];
          _ref2 = spec.prefer;
          for (i = _m = 0, _len4 = _ref2.length; _m < _len4; i = ++_m) {
            preference = _ref2[i];
            importance = Math.pow(2, spec.prefer.length - i - 1);
            if (candidate[preference]) {
              candidate.score += importance;
            }
          }
        }
        result.sort(function(a, b) {
          if (a.score === b.score) {
            return 0;
          } else if (a.score < b.score) {
            return 1;
          } else if (a.score > b.score) {
            return -1;
          }
        });
        if (result.length === 0) {
          if (spec.throws) {
            throw 'No floating point texture support that is ' + spec.require.join(', ');
          } else {
            return null;
          }
        } else {
          result = result[0];
          return {
            filterable: result.filterable,
            renderable: result.renderable,
            type: result.type,
            precision: result.precision
          };
        }
      };
    }
  };

  nukeVendorPrefix();

  textureFloatShims();

  Shader = (function() {
    function Shader(gl, _arg) {
      var fragment, vertex;
      this.gl = gl;
      vertex = _arg.vertex, fragment = _arg.fragment;
      this.program = this.gl.createProgram();
      this.vs = this.gl.createShader(this.gl.VERTEX_SHADER);
      this.fs = this.gl.createShader(this.gl.FRAGMENT_SHADER);
      this.gl.attachShader(this.program, this.vs);
      this.gl.attachShader(this.program, this.fs);
      this.compileShader(this.vs, vertex);
      this.compileShader(this.fs, fragment);
      this.link();
      this.value_cache = {};
      this.uniform_cache = {};
      this.attribCache = {};
    }

    Shader.prototype.attribLocation = function(name) {
      var location;
      location = this.attribCache[name];
      if (location === void 0) {
        location = this.attribCache[name] = this.gl.getAttribLocation(this.program, name);
      }
      return location;
    };

    Shader.prototype.compileShader = function(shader, source) {
      this.gl.shaderSource(shader, source);
      this.gl.compileShader(shader);
      if (!this.gl.getShaderParameter(shader, this.gl.COMPILE_STATUS)) {
        throw "Shader Compile Error: " + (this.gl.getShaderInfoLog(shader));
      }
    };

    Shader.prototype.link = function() {
      this.gl.linkProgram(this.program);
      if (!this.gl.getProgramParameter(this.program, this.gl.LINK_STATUS)) {
        throw "Shader Link Error: " + (this.gl.getProgramInfoLog(this.program));
      }
    };

    Shader.prototype.use = function() {
      this.gl.useProgram(this.program);
      return this;
    };

    Shader.prototype.uniformLoc = function(name) {
      var location;
      location = this.uniform_cache[name];
      if (location === void 0) {
        location = this.uniform_cache[name] = this.gl.getUniformLocation(this.program, name);
      }
      return location;
    };

    Shader.prototype.int = function(name, value) {
      var cached, loc;
      cached = this.value_cache[name];
      if (cached !== value) {
        this.value_cache[name] = value;
        loc = this.uniformLoc(name);
        if (loc) {
          this.gl.uniform1i(loc, value);
        }
      }
      return this;
    };

    Shader.prototype.vec2 = function(name, a, b) {
      var loc;
      loc = this.uniformLoc(name);
      if (loc) {
        this.gl.uniform2f(loc, a, b);
      }
      return this;
    };

    Shader.prototype.float = function(name, value) {
      var cached, loc;
      cached = this.value_cache[name];
      if (cached !== value) {
        this.value_cache[name] = value;
        loc = this.uniformLoc(name);
        if (loc) {
          this.gl.uniform1f(loc, value);
        }
      }
      return this;
    };

    return Shader;

  })();

  Framebuffer = (function() {
    function Framebuffer(gl) {
      this.gl = gl;
      this.buffer = this.gl.createFramebuffer();
    }

    Framebuffer.prototype.destroy = function() {
      return this.gl.deleteFRamebuffer(this.buffer);
    };

    Framebuffer.prototype.bind = function() {
      this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.buffer);
      return this;
    };

    Framebuffer.prototype.unbind = function() {
      this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, null);
      return this;
    };

    Framebuffer.prototype.check = function() {
      var result;
      result = this.gl.checkFramebufferStatus(this.gl.FRAMEBUFFER);
      switch (result) {
        case this.gl.FRAMEBUFFER_UNSUPPORTED:
          throw 'Framebuffer is unsupported';
          break;
        case this.gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
          throw 'Framebuffer incomplete attachment';
          break;
        case this.gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
          throw 'Framebuffer incomplete dimensions';
          break;
        case this.gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
          throw 'Framebuffer incomplete missing attachment';
      }
      return this;
    };

    Framebuffer.prototype.color = function(texture) {
      this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, texture.target, texture.handle, 0);
      this.check();
      return this;
    };

    Framebuffer.prototype.depth = function(buffer) {
      this.gl.framebufferRenderbuffer(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.RENDERBUFFER, buffer.id);
      this.check();
      return this;
    };

    Framebuffer.prototype.destroy = function() {
      return this.gl.deleteFramebuffer(this.buffer);
    };

    return Framebuffer;

  })();

  Texture = (function() {
    function Texture(gl, params) {
      var _ref, _ref1;
      this.gl = gl;
      if (params == null) {
        params = {};
      }
      this.channels = this.gl[((_ref = params.channels) != null ? _ref : 'rgba').toUpperCase()];
      if (typeof params.type === 'number') {
        this.type = params.type;
      } else {
        this.type = this.gl[((_ref1 = params.type) != null ? _ref1 : 'unsigned_byte').toUpperCase()];
      }
      switch (this.channels) {
        case this.gl.RGBA:
          this.chancount = 4;
          break;
        case this.gl.RGB:
          this.chancount = 3;
          break;
        case this.gl.LUMINANCE_ALPHA:
          this.chancount = 2;
          break;
        default:
          this.chancount = 1;
      }
      this.target = this.gl.TEXTURE_2D;
      this.handle = this.gl.createTexture();
    }

    Texture.prototype.destroy = function() {
      return this.gl.deleteTexture(this.handle);
    };

    Texture.prototype.bind = function(unit) {
      if (unit == null) {
        unit = 0;
      }
      if (unit > 15) {
        throw 'Texture unit too large: ' + unit;
      }
      this.gl.activeTexture(this.gl.TEXTURE0 + unit);
      this.gl.bindTexture(this.target, this.handle);
      return this;
    };

    Texture.prototype.setSize = function(width, height) {
      this.width = width;
      this.height = height;
      this.gl.texImage2D(this.target, 0, this.channels, this.width, this.height, 0, this.channels, this.type, null);
      return this;
    };

    Texture.prototype.upload = function(data) {
      this.width = data.width;
      this.height = data.height;
      this.gl.texImage2D(this.target, 0, this.channels, this.channels, this.type, data);
      return this;
    };

    Texture.prototype.linear = function() {
      this.gl.texParameteri(this.target, this.gl.TEXTURE_MAG_FILTER, this.gl.LINEAR);
      this.gl.texParameteri(this.target, this.gl.TEXTURE_MIN_FILTER, this.gl.LINEAR);
      return this;
    };

    Texture.prototype.nearest = function() {
      this.gl.texParameteri(this.target, this.gl.TEXTURE_MAG_FILTER, this.gl.NEAREST);
      this.gl.texParameteri(this.target, this.gl.TEXTURE_MIN_FILTER, this.gl.NEAREST);
      return this;
    };

    Texture.prototype.clampToEdge = function() {
      this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
      this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
      return this;
    };

    Texture.prototype.repeat = function() {
      this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_S, this.gl.REPEAT);
      this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_T, this.gl.REPEAT);
      return this;
    };

    return Texture;

  })();

  Node = (function() {
    function Node(gl, width, height) {
      var floatExt;
      this.gl = gl;
      this.width = width;
      this.height = height;
      floatExt = this.gl.getFloatExtension({
        require: ['renderable']
      });
      this.texture = new Texture(this.gl, {
        type: floatExt.type
      }).bind(0).setSize(this.width, this.height).nearest().clampToEdge();
      this.fbo = new Framebuffer(this.gl).bind().color(this.texture).unbind();
    }

    Node.prototype.use = function() {
      return this.fbo.bind();
    };

    Node.prototype.bind = function(unit) {
      return this.texture.bind(unit);
    };

    Node.prototype.end = function() {
      return this.fbo.unbind();
    };

    Node.prototype.resize = function(width, height) {
      this.width = width;
      this.height = height;
      return this.texture.bind(0).setSize(this.width, this.height);
    };

    return Node;

  })();

  vertexShaderBlit = 'attribute vec4 position;\nvarying vec2 texcoord;\nvoid main(){\n    texcoord = position.xy*0.5+0.5;\n    gl_Position = position;\n}';

  fragmentShaderBlit = '#ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp int;\n    precision highp float;\n#else\n    precision mediump int;\n    precision mediump float;\n#endif\nuniform sampler2D source;\nvarying vec2 texcoord;';

  Heights = (function() {
    function Heights(heatmap, gl, width, height) {
      var i, _i, _ref;
      this.heatmap = heatmap;
      this.gl = gl;
      this.width = width;
      this.height = height;
      this.shader = new Shader(this.gl, {
        vertex: 'attribute vec4 position, intensity;\nvarying vec2 off, dim;\nvarying float vIntensity;\nuniform vec2 viewport;\n\nvoid main(){\n    dim = abs(position.zw);\n    off = position.zw;\n    vec2 pos = position.xy + position.zw;\n    vIntensity = intensity.x;\n    gl_Position = vec4((pos/viewport)*2.0-1.0, 0.0, 1.0);\n}',
        fragment: '#ifdef GL_FRAGMENT_PRECISION_HIGH\n    precision highp int;\n    precision highp float;\n#else\n    precision mediump int;\n    precision mediump float;\n#endif\nvarying vec2 off, dim;\nvarying float vIntensity;\nvoid main(){\n    float falloff = (1.0 - smoothstep(0.0, 1.0, length(off/dim)));\n    float intensity = falloff*vIntensity;\n    gl_FragColor = vec4(intensity);\n}'
      });
      this.clampShader = new Shader(this.gl, {
        vertex: vertexShaderBlit,
        fragment: fragmentShaderBlit + 'uniform float low, high;\nvoid main(){\n    gl_FragColor = vec4(clamp(texture2D(source, texcoord).rgb, low, high), 1.0);\n}'
      });
      this.multiplyShader = new Shader(this.gl, {
        vertex: vertexShaderBlit,
        fragment: fragmentShaderBlit + 'uniform float value;\nvoid main(){\n    gl_FragColor = vec4(texture2D(source, texcoord).rgb*value, 1.0);\n}'
      });
      this.blurShader = new Shader(this.gl, {
        vertex: vertexShaderBlit,
        fragment: fragmentShaderBlit + 'uniform vec2 viewport;\nvoid main(){\n    vec4 result = vec4(0.0);\n    for(int x=-1; x<=1; x++){\n        for(int y=-1; y<=1; y++){\n            vec2 off = vec2(x,y)/viewport;\n            //float factor = 1.0 - smoothstep(0.0, 1.5, length(off));\n            float factor = 1.0;\n            result += vec4(texture2D(source, texcoord+off).rgb*factor, factor);\n        }\n    }\n    gl_FragColor = vec4(result.rgb/result.w, 1.0);\n}'
      });
      this.nodeBack = new Node(this.gl, this.width, this.height);
      this.nodeFront = new Node(this.gl, this.width, this.height);
      this.vertexBuffer = this.gl.createBuffer();
      this.vertexSize = 8;
      this.maxPointCount = 1024 * 10;
      this.vertexBufferData = new Float32Array(this.maxPointCount * this.vertexSize * 6);
      this.vertexBufferViews = [];
      for (i = _i = 0, _ref = this.maxPointCount; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
        this.vertexBufferViews.push(new Float32Array(this.vertexBufferData.buffer, 0, i * this.vertexSize * 6));
      }
      this.bufferIndex = 0;
      this.pointCount = 0;
    }

    Heights.prototype.resize = function(width, height) {
      this.width = width;
      this.height = height;
      this.nodeBack.resize(this.width, this.height);
      return this.nodeFront.resize(this.width, this.height);
    };

    Heights.prototype.update = function() {
      var intensityLoc, positionLoc;
      if (this.pointCount > 0) {
        this.gl.enable(this.gl.BLEND);
        this.nodeFront.use();
        this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.vertexBuffer);
        this.gl.bufferData(this.gl.ARRAY_BUFFER, this.vertexBufferViews[this.pointCount], this.gl.STREAM_DRAW);
        positionLoc = this.shader.attribLocation('position');
        intensityLoc = this.shader.attribLocation('intensity');
        this.gl.enableVertexAttribArray(1);
        this.gl.vertexAttribPointer(positionLoc, 4, this.gl.FLOAT, false, 8 * 4, 0 * 4);
        this.gl.vertexAttribPointer(intensityLoc, 4, this.gl.FLOAT, false, 8 * 4, 4 * 4);
        this.shader.use().vec2('viewport', this.width, this.height);
        this.gl.drawArrays(this.gl.TRIANGLES, 0, this.pointCount * 6);
        this.gl.disableVertexAttribArray(1);
        this.pointCount = 0;
        this.bufferIndex = 0;
        this.nodeFront.end();
        return this.gl.disable(this.gl.BLEND);
      }
    };

    Heights.prototype.clear = function() {
      this.nodeFront.use();
      this.gl.clearColor(0, 0, 0, 1);
      this.gl.clear(this.gl.COLOR_BUFFER_BIT);
      return this.nodeFront.end();
    };

    Heights.prototype.clamp = function(min, max) {
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.heatmap.quad);
      this.gl.vertexAttribPointer(0, 4, this.gl.FLOAT, false, 0, 0);
      this.nodeFront.bind(0);
      this.nodeBack.use();
      this.clampShader.use().int('source', 0).float('low', min).float('high', max);
      this.gl.drawArrays(this.gl.TRIANGLES, 0, 6);
      this.nodeBack.end();
      return this.swap();
    };

    Heights.prototype.multiply = function(value) {
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.heatmap.quad);
      this.gl.vertexAttribPointer(0, 4, this.gl.FLOAT, false, 0, 0);
      this.nodeFront.bind(0);
      this.nodeBack.use();
      this.multiplyShader.use().int('source', 0).float('value', value);
      this.gl.drawArrays(this.gl.TRIANGLES, 0, 6);
      this.nodeBack.end();
      return this.swap();
    };

    Heights.prototype.blur = function() {
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.heatmap.quad);
      this.gl.vertexAttribPointer(0, 4, this.gl.FLOAT, false, 0, 0);
      this.nodeFront.bind(0);
      this.nodeBack.use();
      this.blurShader.use().int('source', 0).vec2('viewport', this.width, this.height);
      this.gl.drawArrays(this.gl.TRIANGLES, 0, 6);
      this.nodeBack.end();
      return this.swap();
    };

    Heights.prototype.swap = function() {
      var tmp;
      tmp = this.nodeFront;
      this.nodeFront = this.nodeBack;
      return this.nodeBack = tmp;
    };

    Heights.prototype.addVertex = function(x, y, xs, ys, intensity) {
      this.vertexBufferData[this.bufferIndex++] = x;
      this.vertexBufferData[this.bufferIndex++] = y;
      this.vertexBufferData[this.bufferIndex++] = xs;
      this.vertexBufferData[this.bufferIndex++] = ys;
      this.vertexBufferData[this.bufferIndex++] = intensity;
      this.vertexBufferData[this.bufferIndex++] = intensity;
      this.vertexBufferData[this.bufferIndex++] = intensity;
      return this.vertexBufferData[this.bufferIndex++] = intensity;
    };

    Heights.prototype.addPoint = function(x, y, size, intensity) {
      var s;
      if (size == null) {
        size = 50;
      }
      if (intensity == null) {
        intensity = 0.2;
      }
      if (this.pointCount >= this.maxPointCount - 1) {
        this.update();
      }
      y = this.height - y;
      s = size / 2;
      this.addVertex(x, y, -s, -s, intensity);
      this.addVertex(x, y, +s, -s, intensity);
      this.addVertex(x, y, -s, +s, intensity);
      this.addVertex(x, y, -s, +s, intensity);
      this.addVertex(x, y, +s, -s, intensity);
      this.addVertex(x, y, +s, +s, intensity);
      return this.pointCount += 1;
    };

    return Heights;

  })();

  WebGLHeatmap = (function() {
    function WebGLHeatmap(_arg) {
      var alphaEnd, alphaRange, alphaStart, error, getColorFun, gradientTexture, image, intensityToAlpha, output, quad, textureGradient, _ref, _ref1;
      _ref = _arg != null ? _arg : {}, this.canvas = _ref.canvas, this.width = _ref.width, this.height = _ref.height, intensityToAlpha = _ref.intensityToAlpha, gradientTexture = _ref.gradientTexture, alphaRange = _ref.alphaRange;
      if (!this.canvas) {
        this.canvas = document.createElement('canvas');
      }
      try {
        this.gl = this.canvas.getContext('experimental-webgl', {
          depth: false,
          antialias: false
        });
        if (this.gl === null) {
          this.gl = this.canvas.getContext('webgl', {
            depth: false,
            antialias: false
          });
          if (this.gl === null) {
            throw 'WebGL not supported';
          }
        }
      } catch (_error) {
        error = _error;
        throw 'WebGL not supported';
      }
      if (window.WebGLDebugUtils != null) {
        console.log('debugging mode');
        this.gl = WebGLDebugUtils.makeDebugContext(this.gl, function(err, funcName, args) {
          throw WebGLDebugUtils.glEnumToString(err) + " was caused by call to: " + funcName;
        });
      }
      this.gl.enableVertexAttribArray(0);
      this.gl.blendFunc(this.gl.ONE, this.gl.ONE);
      if (gradientTexture) {
        textureGradient = this.gradientTexture = new Texture(this.gl, {
          channels: 'rgba'
        }).bind(0).setSize(2, 2).nearest().clampToEdge();
        if (typeof gradientTexture === 'string') {
          image = new Image();
          image.onload = function() {
            return textureGradient.bind().upload(image);
          };
          image.src = gradientTexture;
        } else {
          if (gradientTexture.width > 0 && gradientTexture.height > 0) {
            textureGradient.upload(gradientTexture);
          } else {
            gradientTexture.onload = function() {
              return textureGradient.upload(gradientTexture);
            };
          }
        }
        getColorFun = 'uniform sampler2D gradientTexture;\nvec3 getColor(float intensity){\n    return texture2D(gradientTexture, vec2(intensity, 0.0)).rgb;\n}';
      } else {
        textureGradient = null;
        getColorFun = 'vec3 getColor(float intensity){\n    vec3 blue = vec3(0.0, 0.0, 1.0);\n    vec3 cyan = vec3(0.0, 1.0, 1.0);\n    vec3 green = vec3(0.0, 1.0, 0.0);\n    vec3 yellow = vec3(1.0, 1.0, 0.0);\n    vec3 red = vec3(1.0, 0.0, 0.0);\n\n    vec3 color = (\n        fade(-0.25, 0.25, intensity)*blue +\n        fade(0.0, 0.5, intensity)*cyan +\n        fade(0.25, 0.75, intensity)*green +\n        fade(0.5, 1.0, intensity)*yellow +\n        smoothstep(0.75, 1.0, intensity)*red\n    );\n    return color;\n}';
      }
      if (intensityToAlpha == null) {
        intensityToAlpha = true;
      }
      if (intensityToAlpha) {
        _ref1 = alphaRange != null ? alphaRange : [0, 1], alphaStart = _ref1[0], alphaEnd = _ref1[1];
        output = "vec4 alphaFun(vec3 color, float intensity){\n    float alpha = smoothstep(" + (alphaStart.toFixed(8)) + ", " + (alphaEnd.toFixed(8)) + ", intensity);\n    return vec4(color*alpha, alpha);\n}";
      } else {
        output = 'vec4 alphaFun(vec3 color, float intensity){\n    return vec4(color, 1.0);\n}';
      }
      this.shader = new Shader(this.gl, {
        vertex: vertexShaderBlit,
        fragment: fragmentShaderBlit + ("float linstep(float low, float high, float value){\n    return clamp((value-low)/(high-low), 0.0, 1.0);\n}\n\nfloat fade(float low, float high, float value){\n    float mid = (low+high)*0.5;\n    float range = (high-low)*0.5;\n    float x = 1.0 - clamp(abs(mid-value)/range, 0.0, 1.0);\n    return smoothstep(0.0, 1.0, x);\n}\n\n" + getColorFun + "\n" + output + "\n\nvoid main(){\n    float intensity = smoothstep(0.0, 1.0, texture2D(source, texcoord).r);\n    vec3 color = getColor(intensity);\n    gl_FragColor = alphaFun(color, intensity);\n}")
      });
      if (this.width == null) {
        this.width = this.canvas.offsetWidth || 2;
      }
      if (this.height == null) {
        this.height = this.canvas.offsetHeight || 2;
      }
      this.canvas.width = this.width;
      this.canvas.height = this.height;
      this.gl.viewport(0, 0, this.width, this.height);
      this.quad = this.gl.createBuffer();
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.quad);
      quad = new Float32Array([-1, -1, 0, 1, 1, -1, 0, 1, -1, 1, 0, 1, -1, 1, 0, 1, 1, -1, 0, 1, 1, 1, 0, 1]);
      this.gl.bufferData(this.gl.ARRAY_BUFFER, quad, this.gl.STATIC_DRAW);
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, null);
      this.heights = new Heights(this, this.gl, this.width, this.height);
    }

    WebGLHeatmap.prototype.adjustSize = function() {
      var canvasHeight, canvasWidth;
      canvasWidth = this.canvas.offsetWidth || 2;
      canvasHeight = this.canvas.offsetHeight || 2;
      if (this.width !== canvasWidth || this.height !== canvasHeight) {
        this.gl.viewport(0, 0, canvasWidth, canvasHeight);
        this.canvas.width = canvasWidth;
        this.canvas.height = canvasHeight;
        this.width = canvasWidth;
        this.height = canvasHeight;
        return this.heights.resize(this.width, this.height);
      }
    };

    WebGLHeatmap.prototype.display = function() {
      this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.quad);
      this.gl.vertexAttribPointer(0, 4, this.gl.FLOAT, false, 0, 0);
      this.heights.nodeFront.bind(0);
      if (this.gradientTexture) {
        this.gradientTexture.bind(1);
      }
      this.shader.use().int('source', 0).int('gradientTexture', 1);
      return this.gl.drawArrays(this.gl.TRIANGLES, 0, 6);
    };

    WebGLHeatmap.prototype.update = function() {
      return this.heights.update();
    };

    WebGLHeatmap.prototype.clear = function() {
      return this.heights.clear();
    };

    WebGLHeatmap.prototype.clamp = function(min, max) {
      if (min == null) {
        min = 0;
      }
      if (max == null) {
        max = 1;
      }
      return this.heights.clamp(min, max);
    };

    WebGLHeatmap.prototype.multiply = function(value) {
      if (value == null) {
        value = 0.95;
      }
      return this.heights.multiply(value);
    };

    WebGLHeatmap.prototype.blur = function() {
      return this.heights.blur();
    };

    WebGLHeatmap.prototype.addPoint = function(x, y, size, intensity) {
      return this.heights.addPoint(x, y, size, intensity);
    };

    WebGLHeatmap.prototype.addPoints = function(items) {
      var item, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = items.length; _i < _len; _i++) {
        item = items[_i];
        _results.push(this.addPoint(item.x, item.y, item.size, item.intensity));
      }
      return _results;
    };

    return WebGLHeatmap;

  })();

  window.createWebGLHeatmap = function(params) {
    return new WebGLHeatmap(params);
  };

}).call(this);

// threejs.org/license
'use strict';var THREE={REVISION:"73"};"function"===typeof define&&define.amd?define("three",THREE):"undefined"!==typeof exports&&"undefined"!==typeof module&&(module.exports=THREE);
void 0!==self.requestAnimationFrame&&void 0!==self.cancelAnimationFrame||function(){for(var a=0,b=["ms","moz","webkit","o"],c=0;c<b.length&&!self.requestAnimationFrame;++c)self.requestAnimationFrame=self[b[c]+"RequestAnimationFrame"],self.cancelAnimationFrame=self[b[c]+"CancelAnimationFrame"]||self[b[c]+"CancelRequestAnimationFrame"];void 0===self.requestAnimationFrame&&void 0!==self.setTimeout&&(self.requestAnimationFrame=function(b){var c=Date.now(),g=Math.max(0,16-(c-a)),f=self.setTimeout(function(){b(c+
g)},g);a=c+g;return f});void 0===self.cancelAnimationFrame&&void 0!==self.clearTimeout&&(self.cancelAnimationFrame=function(a){self.clearTimeout(a)})}();void 0===self.performance&&(self.performance={});void 0===self.performance.now&&function(){var a=Date.now();self.performance.now=function(){return Date.now()-a}}();void 0===Number.EPSILON&&(Number.EPSILON=Math.pow(2,-52));void 0===Math.sign&&(Math.sign=function(a){return 0>a?-1:0<a?1:+a});
void 0===Function.prototype.name&&void 0!==Object.defineProperty&&Object.defineProperty(Function.prototype,"name",{get:function(){return this.toString().match(/^\s*function\s*(\S*)\s*\(/)[1]}});THREE.MOUSE={LEFT:0,MIDDLE:1,RIGHT:2};THREE.CullFaceNone=0;THREE.CullFaceBack=1;THREE.CullFaceFront=2;THREE.CullFaceFrontBack=3;THREE.FrontFaceDirectionCW=0;THREE.FrontFaceDirectionCCW=1;THREE.BasicShadowMap=0;THREE.PCFShadowMap=1;THREE.PCFSoftShadowMap=2;THREE.FrontSide=0;THREE.BackSide=1;
THREE.DoubleSide=2;THREE.FlatShading=1;THREE.SmoothShading=2;THREE.NoColors=0;THREE.FaceColors=1;THREE.VertexColors=2;THREE.NoBlending=0;THREE.NormalBlending=1;THREE.AdditiveBlending=2;THREE.SubtractiveBlending=3;THREE.MultiplyBlending=4;THREE.CustomBlending=5;THREE.AddEquation=100;THREE.SubtractEquation=101;THREE.ReverseSubtractEquation=102;THREE.MinEquation=103;THREE.MaxEquation=104;THREE.ZeroFactor=200;THREE.OneFactor=201;THREE.SrcColorFactor=202;THREE.OneMinusSrcColorFactor=203;
THREE.SrcAlphaFactor=204;THREE.OneMinusSrcAlphaFactor=205;THREE.DstAlphaFactor=206;THREE.OneMinusDstAlphaFactor=207;THREE.DstColorFactor=208;THREE.OneMinusDstColorFactor=209;THREE.SrcAlphaSaturateFactor=210;THREE.NeverDepth=0;THREE.AlwaysDepth=1;THREE.LessDepth=2;THREE.LessEqualDepth=3;THREE.EqualDepth=4;THREE.GreaterEqualDepth=5;THREE.GreaterDepth=6;THREE.NotEqualDepth=7;THREE.MultiplyOperation=0;THREE.MixOperation=1;THREE.AddOperation=2;THREE.UVMapping=300;THREE.CubeReflectionMapping=301;
THREE.CubeRefractionMapping=302;THREE.EquirectangularReflectionMapping=303;THREE.EquirectangularRefractionMapping=304;THREE.SphericalReflectionMapping=305;THREE.RepeatWrapping=1E3;THREE.ClampToEdgeWrapping=1001;THREE.MirroredRepeatWrapping=1002;THREE.NearestFilter=1003;THREE.NearestMipMapNearestFilter=1004;THREE.NearestMipMapLinearFilter=1005;THREE.LinearFilter=1006;THREE.LinearMipMapNearestFilter=1007;THREE.LinearMipMapLinearFilter=1008;THREE.UnsignedByteType=1009;THREE.ByteType=1010;
THREE.ShortType=1011;THREE.UnsignedShortType=1012;THREE.IntType=1013;THREE.UnsignedIntType=1014;THREE.FloatType=1015;THREE.HalfFloatType=1025;THREE.UnsignedShort4444Type=1016;THREE.UnsignedShort5551Type=1017;THREE.UnsignedShort565Type=1018;THREE.AlphaFormat=1019;THREE.RGBFormat=1020;THREE.RGBAFormat=1021;THREE.LuminanceFormat=1022;THREE.LuminanceAlphaFormat=1023;THREE.RGBEFormat=THREE.RGBAFormat;THREE.RGB_S3TC_DXT1_Format=2001;THREE.RGBA_S3TC_DXT1_Format=2002;THREE.RGBA_S3TC_DXT3_Format=2003;
THREE.RGBA_S3TC_DXT5_Format=2004;THREE.RGB_PVRTC_4BPPV1_Format=2100;THREE.RGB_PVRTC_2BPPV1_Format=2101;THREE.RGBA_PVRTC_4BPPV1_Format=2102;THREE.RGBA_PVRTC_2BPPV1_Format=2103;THREE.LoopOnce=2200;THREE.LoopRepeat=2201;THREE.LoopPingPong=2202;
THREE.Projector=function(){console.error("THREE.Projector has been moved to /examples/js/renderers/Projector.js.");this.projectVector=function(a,b){console.warn("THREE.Projector: .projectVector() is now vector.project().");a.project(b)};this.unprojectVector=function(a,b){console.warn("THREE.Projector: .unprojectVector() is now vector.unproject().");a.unproject(b)};this.pickingRay=function(a,b){console.error("THREE.Projector: .pickingRay() is now raycaster.setFromCamera().")}};
THREE.CanvasRenderer=function(){console.error("THREE.CanvasRenderer has been moved to /examples/js/renderers/CanvasRenderer.js");this.domElement=document.createElement("canvas");this.clear=function(){};this.render=function(){};this.setClearColor=function(){};this.setSize=function(){}};THREE.Color=function(a){return 3===arguments.length?this.fromArray(arguments):this.set(a)};
THREE.Color.prototype={constructor:THREE.Color,r:1,g:1,b:1,set:function(a){a instanceof THREE.Color?this.copy(a):"number"===typeof a?this.setHex(a):"string"===typeof a&&this.setStyle(a);return this},setHex:function(a){a=Math.floor(a);this.r=(a>>16&255)/255;this.g=(a>>8&255)/255;this.b=(a&255)/255;return this},setRGB:function(a,b,c){this.r=a;this.g=b;this.b=c;return this},setHSL:function(){function a(a,c,d){0>d&&(d+=1);1<d&&(d-=1);return d<1/6?a+6*(c-a)*d:.5>d?c:d<2/3?a+6*(c-a)*(2/3-d):a}return function(b,
c,d){b=THREE.Math.euclideanModulo(b,1);c=THREE.Math.clamp(c,0,1);d=THREE.Math.clamp(d,0,1);0===c?this.r=this.g=this.b=d:(c=.5>=d?d*(1+c):d+c-d*c,d=2*d-c,this.r=a(d,c,b+1/3),this.g=a(d,c,b),this.b=a(d,c,b-1/3));return this}}(),setStyle:function(a){function b(b){void 0!==b&&1>parseFloat(b)&&console.warn("THREE.Color: Alpha component of "+a+" will be ignored.")}var c;if(c=/^((?:rgb|hsl)a?)\(\s*([^\)]*)\)/.exec(a)){var d=c[2];switch(c[1]){case "rgb":case "rgba":if(c=/^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(d))return this.r=
Math.min(255,parseInt(c[1],10))/255,this.g=Math.min(255,parseInt(c[2],10))/255,this.b=Math.min(255,parseInt(c[3],10))/255,b(c[5]),this;if(c=/^(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(d))return this.r=Math.min(100,parseInt(c[1],10))/100,this.g=Math.min(100,parseInt(c[2],10))/100,this.b=Math.min(100,parseInt(c[3],10))/100,b(c[5]),this;break;case "hsl":case "hsla":if(c=/^([0-9]*\.?[0-9]+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(d)){var d=parseFloat(c[1])/
360,e=parseInt(c[2],10)/100,g=parseInt(c[3],10)/100;b(c[5]);return this.setHSL(d,e,g)}}}else if(c=/^\#([A-Fa-f0-9]+)$/.exec(a)){c=c[1];d=c.length;if(3===d)return this.r=parseInt(c.charAt(0)+c.charAt(0),16)/255,this.g=parseInt(c.charAt(1)+c.charAt(1),16)/255,this.b=parseInt(c.charAt(2)+c.charAt(2),16)/255,this;if(6===d)return this.r=parseInt(c.charAt(0)+c.charAt(1),16)/255,this.g=parseInt(c.charAt(2)+c.charAt(3),16)/255,this.b=parseInt(c.charAt(4)+c.charAt(5),16)/255,this}a&&0<a.length&&(c=THREE.ColorKeywords[a],
void 0!==c?this.setHex(c):console.warn("THREE.Color: Unknown color "+a));return this},clone:function(){return new this.constructor(this.r,this.g,this.b)},copy:function(a){this.r=a.r;this.g=a.g;this.b=a.b;return this},copyGammaToLinear:function(a,b){void 0===b&&(b=2);this.r=Math.pow(a.r,b);this.g=Math.pow(a.g,b);this.b=Math.pow(a.b,b);return this},copyLinearToGamma:function(a,b){void 0===b&&(b=2);var c=0<b?1/b:1;this.r=Math.pow(a.r,c);this.g=Math.pow(a.g,c);this.b=Math.pow(a.b,c);return this},convertGammaToLinear:function(){var a=
this.r,b=this.g,c=this.b;this.r=a*a;this.g=b*b;this.b=c*c;return this},convertLinearToGamma:function(){this.r=Math.sqrt(this.r);this.g=Math.sqrt(this.g);this.b=Math.sqrt(this.b);return this},getHex:function(){return 255*this.r<<16^255*this.g<<8^255*this.b<<0},getHexString:function(){return("000000"+this.getHex().toString(16)).slice(-6)},getHSL:function(a){a=a||{h:0,s:0,l:0};var b=this.r,c=this.g,d=this.b,e=Math.max(b,c,d),g=Math.min(b,c,d),f,h=(g+e)/2;if(g===e)g=f=0;else{var l=e-g,g=.5>=h?l/(e+g):
l/(2-e-g);switch(e){case b:f=(c-d)/l+(c<d?6:0);break;case c:f=(d-b)/l+2;break;case d:f=(b-c)/l+4}f/=6}a.h=f;a.s=g;a.l=h;return a},getStyle:function(){return"rgb("+(255*this.r|0)+","+(255*this.g|0)+","+(255*this.b|0)+")"},offsetHSL:function(a,b,c){var d=this.getHSL();d.h+=a;d.s+=b;d.l+=c;this.setHSL(d.h,d.s,d.l);return this},add:function(a){this.r+=a.r;this.g+=a.g;this.b+=a.b;return this},addColors:function(a,b){this.r=a.r+b.r;this.g=a.g+b.g;this.b=a.b+b.b;return this},addScalar:function(a){this.r+=
a;this.g+=a;this.b+=a;return this},multiply:function(a){this.r*=a.r;this.g*=a.g;this.b*=a.b;return this},multiplyScalar:function(a){this.r*=a;this.g*=a;this.b*=a;return this},lerp:function(a,b){this.r+=(a.r-this.r)*b;this.g+=(a.g-this.g)*b;this.b+=(a.b-this.b)*b;return this},equals:function(a){return a.r===this.r&&a.g===this.g&&a.b===this.b},fromArray:function(a,b){void 0===b&&(b=0);this.r=a[b];this.g=a[b+1];this.b=a[b+2];return this},toArray:function(a,b){void 0===a&&(a=[]);void 0===b&&(b=0);a[b]=
this.r;a[b+1]=this.g;a[b+2]=this.b;return a}};
THREE.ColorKeywords={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,
darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,
grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,
lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,
palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,
tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074};THREE.Quaternion=function(a,b,c,d){this._x=a||0;this._y=b||0;this._z=c||0;this._w=void 0!==d?d:1};
THREE.Quaternion.prototype={constructor:THREE.Quaternion,get x(){return this._x},set x(a){this._x=a;this.onChangeCallback()},get y(){return this._y},set y(a){this._y=a;this.onChangeCallback()},get z(){return this._z},set z(a){this._z=a;this.onChangeCallback()},get w(){return this._w},set w(a){this._w=a;this.onChangeCallback()},set:function(a,b,c,d){this._x=a;this._y=b;this._z=c;this._w=d;this.onChangeCallback();return this},clone:function(){return new this.constructor(this._x,this._y,this._z,this._w)},
copy:function(a){this._x=a.x;this._y=a.y;this._z=a.z;this._w=a.w;this.onChangeCallback();return this},setFromEuler:function(a,b){if(!1===a instanceof THREE.Euler)throw Error("THREE.Quaternion: .setFromEuler() now expects a Euler rotation rather than a Vector3 and order.");var c=Math.cos(a._x/2),d=Math.cos(a._y/2),e=Math.cos(a._z/2),g=Math.sin(a._x/2),f=Math.sin(a._y/2),h=Math.sin(a._z/2),l=a.order;"XYZ"===l?(this._x=g*d*e+c*f*h,this._y=c*f*e-g*d*h,this._z=c*d*h+g*f*e,this._w=c*d*e-g*f*h):"YXZ"===
l?(this._x=g*d*e+c*f*h,this._y=c*f*e-g*d*h,this._z=c*d*h-g*f*e,this._w=c*d*e+g*f*h):"ZXY"===l?(this._x=g*d*e-c*f*h,this._y=c*f*e+g*d*h,this._z=c*d*h+g*f*e,this._w=c*d*e-g*f*h):"ZYX"===l?(this._x=g*d*e-c*f*h,this._y=c*f*e+g*d*h,this._z=c*d*h-g*f*e,this._w=c*d*e+g*f*h):"YZX"===l?(this._x=g*d*e+c*f*h,this._y=c*f*e+g*d*h,this._z=c*d*h-g*f*e,this._w=c*d*e-g*f*h):"XZY"===l&&(this._x=g*d*e-c*f*h,this._y=c*f*e-g*d*h,this._z=c*d*h+g*f*e,this._w=c*d*e+g*f*h);if(!1!==b)this.onChangeCallback();return this},setFromAxisAngle:function(a,
b){var c=b/2,d=Math.sin(c);this._x=a.x*d;this._y=a.y*d;this._z=a.z*d;this._w=Math.cos(c);this.onChangeCallback();return this},setFromRotationMatrix:function(a){var b=a.elements,c=b[0];a=b[4];var d=b[8],e=b[1],g=b[5],f=b[9],h=b[2],l=b[6],b=b[10],k=c+g+b;0<k?(c=.5/Math.sqrt(k+1),this._w=.25/c,this._x=(l-f)*c,this._y=(d-h)*c,this._z=(e-a)*c):c>g&&c>b?(c=2*Math.sqrt(1+c-g-b),this._w=(l-f)/c,this._x=.25*c,this._y=(a+e)/c,this._z=(d+h)/c):g>b?(c=2*Math.sqrt(1+g-c-b),this._w=(d-h)/c,this._x=(a+e)/c,this._y=
.25*c,this._z=(f+l)/c):(c=2*Math.sqrt(1+b-c-g),this._w=(e-a)/c,this._x=(d+h)/c,this._y=(f+l)/c,this._z=.25*c);this.onChangeCallback();return this},setFromUnitVectors:function(){var a,b;return function(c,d){void 0===a&&(a=new THREE.Vector3);b=c.dot(d)+1;1E-6>b?(b=0,Math.abs(c.x)>Math.abs(c.z)?a.set(-c.y,c.x,0):a.set(0,-c.z,c.y)):a.crossVectors(c,d);this._x=a.x;this._y=a.y;this._z=a.z;this._w=b;this.normalize();return this}}(),inverse:function(){this.conjugate().normalize();return this},conjugate:function(){this._x*=
-1;this._y*=-1;this._z*=-1;this.onChangeCallback();return this},dot:function(a){return this._x*a._x+this._y*a._y+this._z*a._z+this._w*a._w},lengthSq:function(){return this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w},length:function(){return Math.sqrt(this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w)},normalize:function(){var a=this.length();0===a?(this._z=this._y=this._x=0,this._w=1):(a=1/a,this._x*=a,this._y*=a,this._z*=a,this._w*=a);this.onChangeCallback();return this},
multiply:function(a,b){return void 0!==b?(console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead."),this.multiplyQuaternions(a,b)):this.multiplyQuaternions(this,a)},multiplyQuaternions:function(a,b){var c=a._x,d=a._y,e=a._z,g=a._w,f=b._x,h=b._y,l=b._z,k=b._w;this._x=c*k+g*f+d*l-e*h;this._y=d*k+g*h+e*f-c*l;this._z=e*k+g*l+c*h-d*f;this._w=g*k-c*f-d*h-e*l;this.onChangeCallback();return this},multiplyVector3:function(a){console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.");
return a.applyQuaternion(this)},slerp:function(a,b){if(0===b)return this;if(1===b)return this.copy(a);var c=this._x,d=this._y,e=this._z,g=this._w,f=g*a._w+c*a._x+d*a._y+e*a._z;0>f?(this._w=-a._w,this._x=-a._x,this._y=-a._y,this._z=-a._z,f=-f):this.copy(a);if(1<=f)return this._w=g,this._x=c,this._y=d,this._z=e,this;var h=Math.acos(f),l=Math.sqrt(1-f*f);if(.001>Math.abs(l))return this._w=.5*(g+this._w),this._x=.5*(c+this._x),this._y=.5*(d+this._y),this._z=.5*(e+this._z),this;f=Math.sin((1-b)*h)/l;h=
Math.sin(b*h)/l;this._w=g*f+this._w*h;this._x=c*f+this._x*h;this._y=d*f+this._y*h;this._z=e*f+this._z*h;this.onChangeCallback();return this},equals:function(a){return a._x===this._x&&a._y===this._y&&a._z===this._z&&a._w===this._w},fromArray:function(a,b){void 0===b&&(b=0);this._x=a[b];this._y=a[b+1];this._z=a[b+2];this._w=a[b+3];this.onChangeCallback();return this},toArray:function(a,b){void 0===a&&(a=[]);void 0===b&&(b=0);a[b]=this._x;a[b+1]=this._y;a[b+2]=this._z;a[b+3]=this._w;return a},onChange:function(a){this.onChangeCallback=
a;return this},onChangeCallback:function(){}};THREE.Quaternion.slerp=function(a,b,c,d){return c.copy(a).slerp(b,d)};THREE.Vector2=function(a,b){this.x=a||0;this.y=b||0};
THREE.Vector2.prototype={constructor:THREE.Vector2,get width(){return this.x},set width(a){this.x=a},get height(){return this.y},set height(a){this.y=a},set:function(a,b){this.x=a;this.y=b;return this},setX:function(a){this.x=a;return this},setY:function(a){this.y=a;return this},setComponent:function(a,b){switch(a){case 0:this.x=b;break;case 1:this.y=b;break;default:throw Error("index is out of range: "+a);}},getComponent:function(a){switch(a){case 0:return this.x;case 1:return this.y;default:throw Error("index is out of range: "+
a);}},clone:function(){return new this.constructor(this.x,this.y)},copy:function(a){this.x=a.x;this.y=a.y;return this},add:function(a,b){if(void 0!==b)return console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead."),this.addVectors(a,b);this.x+=a.x;this.y+=a.y;return this},addScalar:function(a){this.x+=a;this.y+=a;return this},addVectors:function(a,b){this.x=a.x+b.x;this.y=a.y+b.y;return this},addScaledVector:function(a,b){this.x+=a.x*b;this.y+=a.y*b;return this},
sub:function(a,b){if(void 0!==b)return console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."),this.subVectors(a,b);this.x-=a.x;this.y-=a.y;return this},subScalar:function(a){this.x-=a;this.y-=a;return this},subVectors:function(a,b){this.x=a.x-b.x;this.y=a.y-b.y;return this},multiply:function(a){this.x*=a.x;this.y*=a.y;return this},multiplyScalar:function(a){isFinite(a)?(this.x*=a,this.y*=a):this.y=this.x=0;return this},divide:function(a){this.x/=a.x;
this.y/=a.y;return this},divideScalar:function(a){return this.multiplyScalar(1/a)},min:function(a){this.x=Math.min(this.x,a.x);this.y=Math.min(this.y,a.y);return this},max:function(a){this.x=Math.max(this.x,a.x);this.y=Math.max(this.y,a.y);return this},clamp:function(a,b){this.x=Math.max(a.x,Math.min(b.x,this.x));this.y=Math.max(a.y,Math.min(b.y,this.y));return this},clampScalar:function(){var a,b;return function(c,d){void 0===a&&(a=new THREE.Vector2,b=new THREE.Vector2);a.set(c,c);b.set(d,d);return this.clamp(a,
b)}}(),clampLength:function(a,b){var c=this.length();this.multiplyScalar(Math.max(a,Math.min(b,c))/c);return this},floor:function(){this.x=Math.floor(this.x);this.y=Math.floor(this.y);return this},ceil:function(){this.x=Math.ceil(this.x);this.y=Math.ceil(this.y);return this},round:function(){this.x=Math.round(this.x);this.y=Math.round(this.y);return this},roundToZero:function(){this.x=0>this.x?Math.ceil(this.x):Math.floor(this.x);this.y=0>this.y?Math.ceil(this.y):Math.floor(this.y);return this},negate:function(){this.x=
-this.x;this.y=-this.y;return this},dot:function(a){return this.x*a.x+this.y*a.y},lengthSq:function(){return this.x*this.x+this.y*this.y},length:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},lengthManhattan:function(){return Math.abs(this.x)+Math.abs(this.y)},normalize:function(){return this.divideScalar(this.length())},distanceTo:function(a){return Math.sqrt(this.distanceToSquared(a))},distanceToSquared:function(a){var b=this.x-a.x;a=this.y-a.y;return b*b+a*a},setLength:function(a){return this.multiplyScalar(a/
this.length())},lerp:function(a,b){this.x+=(a.x-this.x)*b;this.y+=(a.y-this.y)*b;return this},lerpVectors:function(a,b,c){this.subVectors(b,a).multiplyScalar(c).add(a);return this},equals:function(a){return a.x===this.x&&a.y===this.y},fromArray:function(a,b){void 0===b&&(b=0);this.x=a[b];this.y=a[b+1];return this},toArray:function(a,b){void 0===a&&(a=[]);void 0===b&&(b=0);a[b]=this.x;a[b+1]=this.y;return a},fromAttribute:function(a,b,c){void 0===c&&(c=0);b=b*a.itemSize+c;this.x=a.array[b];this.y=
a.array[b+1];return this},rotateAround:function(a,b){var c=Math.cos(b),d=Math.sin(b),e=this.x-a.x,g=this.y-a.y;this.x=e*c-g*d+a.x;this.y=e*d+g*c+a.y;return this}};THREE.Vector3=function(a,b,c){this.x=a||0;this.y=b||0;this.z=c||0};
THREE.Vector3.prototype={constructor:THREE.Vector3,set:function(a,b,c){this.x=a;this.y=b;this.z=c;return this},setX:function(a){this.x=a;return this},setY:function(a){this.y=a;return this},setZ:function(a){this.z=a;return this},setComponent:function(a,b){switch(a){case 0:this.x=b;break;case 1:this.y=b;break;case 2:this.z=b;break;default:throw Error("index is out of range: "+a);}},getComponent:function(a){switch(a){case 0:return this.x;case 1:return this.y;case 2:return this.z;default:throw Error("index is out of range: "+
a);}},clone:function(){return new this.constructor(this.x,this.y,this.z)},copy:function(a){this.x=a.x;this.y=a.y;this.z=a.z;return this},add:function(a,b){if(void 0!==b)return console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead."),this.addVectors(a,b);this.x+=a.x;this.y+=a.y;this.z+=a.z;return this},addScalar:function(a){this.x+=a;this.y+=a;this.z+=a;return this},addVectors:function(a,b){this.x=a.x+b.x;this.y=a.y+b.y;this.z=a.z+b.z;return this},addScaledVector:function(a,
b){this.x+=a.x*b;this.y+=a.y*b;this.z+=a.z*b;return this},sub:function(a,b){if(void 0!==b)return console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."),this.subVectors(a,b);this.x-=a.x;this.y-=a.y;this.z-=a.z;return this},subScalar:function(a){this.x-=a;this.y-=a;this.z-=a;return this},subVectors:function(a,b){this.x=a.x-b.x;this.y=a.y-b.y;this.z=a.z-b.z;return this},multiply:function(a,b){if(void 0!==b)return console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead."),
this.multiplyVectors(a,b);this.x*=a.x;this.y*=a.y;this.z*=a.z;return this},multiplyScalar:function(a){isFinite(a)?(this.x*=a,this.y*=a,this.z*=a):this.z=this.y=this.x=0;return this},multiplyVectors:function(a,b){this.x=a.x*b.x;this.y=a.y*b.y;this.z=a.z*b.z;return this},applyEuler:function(){var a;return function(b){!1===b instanceof THREE.Euler&&console.error("THREE.Vector3: .applyEuler() now expects a Euler rotation rather than a Vector3 and order.");void 0===a&&(a=new THREE.Quaternion);this.applyQuaternion(a.setFromEuler(b));
return this}}(),applyAxisAngle:function(){var a;return function(b,c){void 0===a&&(a=new THREE.Quaternion);this.applyQuaternion(a.setFromAxisAngle(b,c));return this}}(),applyMatrix3:function(a){var b=this.x,c=this.y,d=this.z;a=a.elements;this.x=a[0]*b+a[3]*c+a[6]*d;this.y=a[1]*b+a[4]*c+a[7]*d;this.z=a[2]*b+a[5]*c+a[8]*d;return this},applyMatrix4:function(a){var b=this.x,c=this.y,d=this.z;a=a.elements;this.x=a[0]*b+a[4]*c+a[8]*d+a[12];this.y=a[1]*b+a[5]*c+a[9]*d+a[13];this.z=a[2]*b+a[6]*c+a[10]*d+a[14];
return this},applyProjection:function(a){var b=this.x,c=this.y,d=this.z;a=a.elements;var e=1/(a[3]*b+a[7]*c+a[11]*d+a[15]);this.x=(a[0]*b+a[4]*c+a[8]*d+a[12])*e;this.y=(a[1]*b+a[5]*c+a[9]*d+a[13])*e;this.z=(a[2]*b+a[6]*c+a[10]*d+a[14])*e;return this},applyQuaternion:function(a){var b=this.x,c=this.y,d=this.z,e=a.x,g=a.y,f=a.z;a=a.w;var h=a*b+g*d-f*c,l=a*c+f*b-e*d,k=a*d+e*c-g*b,b=-e*b-g*c-f*d;this.x=h*a+b*-e+l*-f-k*-g;this.y=l*a+b*-g+k*-e-h*-f;this.z=k*a+b*-f+h*-g-l*-e;return this},project:function(){var a;
return function(b){void 0===a&&(a=new THREE.Matrix4);a.multiplyMatrices(b.projectionMatrix,a.getInverse(b.matrixWorld));return this.applyProjection(a)}}(),unproject:function(){var a;return function(b){void 0===a&&(a=new THREE.Matrix4);a.multiplyMatrices(b.matrixWorld,a.getInverse(b.projectionMatrix));return this.applyProjection(a)}}(),transformDirection:function(a){var b=this.x,c=this.y,d=this.z;a=a.elements;this.x=a[0]*b+a[4]*c+a[8]*d;this.y=a[1]*b+a[5]*c+a[9]*d;this.z=a[2]*b+a[6]*c+a[10]*d;this.normalize();
return this},divide:function(a){this.x/=a.x;this.y/=a.y;this.z/=a.z;return this},divideScalar:function(a){return this.multiplyScalar(1/a)},min:function(a){this.x=Math.min(this.x,a.x);this.y=Math.min(this.y,a.y);this.z=Math.min(this.z,a.z);return this},max:function(a){this.x=Math.max(this.x,a.x);this.y=Math.max(this.y,a.y);this.z=Math.max(this.z,a.z);return this},clamp:function(a,b){this.x=Math.max(a.x,Math.min(b.x,this.x));this.y=Math.max(a.y,Math.min(b.y,this.y));this.z=Math.max(a.z,Math.min(b.z,
this.z));return this},clampScalar:function(){var a,b;return function(c,d){void 0===a&&(a=new THREE.Vector3,b=new THREE.Vector3);a.set(c,c,c);b.set(d,d,d);return this.clamp(a,b)}}(),clampLength:function(a,b){var c=this.length();this.multiplyScalar(Math.max(a,Math.min(b,c))/c);return this},floor:function(){this.x=Math.floor(this.x);this.y=Math.floor(this.y);this.z=Math.floor(this.z);return this},ceil:function(){this.x=Math.ceil(this.x);this.y=Math.ceil(this.y);this.z=Math.ceil(this.z);return this},
round:function(){this.x=Math.round(this.x);this.y=Math.round(this.y);this.z=Math.round(this.z);return this},roundToZero:function(){this.x=0>this.x?Math.ceil(this.x):Math.floor(this.x);this.y=0>this.y?Math.ceil(this.y):Math.floor(this.y);this.z=0>this.z?Math.ceil(this.z):Math.floor(this.z);return this},negate:function(){this.x=-this.x;this.y=-this.y;this.z=-this.z;return this},dot:function(a){return this.x*a.x+this.y*a.y+this.z*a.z},lengthSq:function(){return this.x*this.x+this.y*this.y+this.z*this.z},
length:function(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z)},lengthManhattan:function(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)},normalize:function(){return this.divideScalar(this.length())},setLength:function(a){return this.multiplyScalar(a/this.length())},lerp:function(a,b){this.x+=(a.x-this.x)*b;this.y+=(a.y-this.y)*b;this.z+=(a.z-this.z)*b;return this},lerpVectors:function(a,b,c){this.subVectors(b,a).multiplyScalar(c).add(a);return this},cross:function(a,b){if(void 0!==
b)return console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead."),this.crossVectors(a,b);var c=this.x,d=this.y,e=this.z;this.x=d*a.z-e*a.y;this.y=e*a.x-c*a.z;this.z=c*a.y-d*a.x;return this},crossVectors:function(a,b){var c=a.x,d=a.y,e=a.z,g=b.x,f=b.y,h=b.z;this.x=d*h-e*f;this.y=e*g-c*h;this.z=c*f-d*g;return this},projectOnVector:function(){var a,b;return function(c){void 0===a&&(a=new THREE.Vector3);a.copy(c).normalize();b=this.dot(a);return this.copy(a).multiplyScalar(b)}}(),
projectOnPlane:function(){var a;return function(b){void 0===a&&(a=new THREE.Vector3);a.copy(this).projectOnVector(b);return this.sub(a)}}(),reflect:function(){var a;return function(b){void 0===a&&(a=new THREE.Vector3);return this.sub(a.copy(b).multiplyScalar(2*this.dot(b)))}}(),angleTo:function(a){a=this.dot(a)/(this.length()*a.length());return Math.acos(THREE.Math.clamp(a,-1,1))},distanceTo:function(a){return Math.sqrt(this.distanceToSquared(a))},distanceToSquared:function(a){var b=this.x-a.x,c=
this.y-a.y;a=this.z-a.z;return b*b+c*c+a*a},setEulerFromRotationMatrix:function(a,b){console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.")},setEulerFromQuaternion:function(a,b){console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.")},getPositionFromMatrix:function(a){console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().");return this.setFromMatrixPosition(a)},
getScaleFromMatrix:function(a){console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().");return this.setFromMatrixScale(a)},getColumnFromMatrix:function(a,b){console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().");return this.setFromMatrixColumn(a,b)},setFromMatrixPosition:function(a){this.x=a.elements[12];this.y=a.elements[13];this.z=a.elements[14];return this},setFromMatrixScale:function(a){var b=this.set(a.elements[0],
a.elements[1],a.elements[2]).length(),c=this.set(a.elements[4],a.elements[5],a.elements[6]).length();a=this.set(a.elements[8],a.elements[9],a.elements[10]).length();this.x=b;this.y=c;this.z=a;return this},setFromMatrixColumn:function(a,b){var c=4*a,d=b.elements;this.x=d[c];this.y=d[c+1];this.z=d[c+2];return this},equals:function(a){return a.x===this.x&&a.y===this.y&&a.z===this.z},fromArray:function(a,b){void 0===b&&(b=0);this.x=a[b];this.y=a[b+1];this.z=a[b+2];return this},toArray:function(a,b){void 0===
a&&(a=[]);void 0===b&&(b=0);a[b]=this.x;a[b+1]=this.y;a[b+2]=this.z;return a},fromAttribute:function(a,b,c){void 0===c&&(c=0);b=b*a.itemSize+c;this.x=a.array[b];this.y=a.array[b+1];this.z=a.array[b+2];return this}};THREE.Vector4=function(a,b,c,d){this.x=a||0;this.y=b||0;this.z=c||0;this.w=void 0!==d?d:1};
THREE.Vector4.prototype={constructor:THREE.Vector4,set:function(a,b,c,d){this.x=a;this.y=b;this.z=c;this.w=d;return this},setX:function(a){this.x=a;return this},setY:function(a){this.y=a;return this},setZ:function(a){this.z=a;return this},setW:function(a){this.w=a;return this},setComponent:function(a,b){switch(a){case 0:this.x=b;break;case 1:this.y=b;break;case 2:this.z=b;break;case 3:this.w=b;break;default:throw Error("index is out of range: "+a);}},getComponent:function(a){switch(a){case 0:return this.x;
case 1:return this.y;case 2:return this.z;case 3:return this.w;default:throw Error("index is out of range: "+a);}},clone:function(){return new this.constructor(this.x,this.y,this.z,this.w)},copy:function(a){this.x=a.x;this.y=a.y;this.z=a.z;this.w=void 0!==a.w?a.w:1;return this},add:function(a,b){if(void 0!==b)return console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead."),this.addVectors(a,b);this.x+=a.x;this.y+=a.y;this.z+=a.z;this.w+=a.w;return this},
addScalar:function(a){this.x+=a;this.y+=a;this.z+=a;this.w+=a;return this},addVectors:function(a,b){this.x=a.x+b.x;this.y=a.y+b.y;this.z=a.z+b.z;this.w=a.w+b.w;return this},addScaledVector:function(a,b){this.x+=a.x*b;this.y+=a.y*b;this.z+=a.z*b;this.w+=a.w*b;return this},sub:function(a,b){if(void 0!==b)return console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."),this.subVectors(a,b);this.x-=a.x;this.y-=a.y;this.z-=a.z;this.w-=a.w;return this},subScalar:function(a){this.x-=
a;this.y-=a;this.z-=a;this.w-=a;return this},subVectors:function(a,b){this.x=a.x-b.x;this.y=a.y-b.y;this.z=a.z-b.z;this.w=a.w-b.w;return this},multiplyScalar:function(a){isFinite(a)?(this.x*=a,this.y*=a,this.z*=a,this.w*=a):this.w=this.z=this.y=this.x=0;return this},applyMatrix4:function(a){var b=this.x,c=this.y,d=this.z,e=this.w;a=a.elements;this.x=a[0]*b+a[4]*c+a[8]*d+a[12]*e;this.y=a[1]*b+a[5]*c+a[9]*d+a[13]*e;this.z=a[2]*b+a[6]*c+a[10]*d+a[14]*e;this.w=a[3]*b+a[7]*c+a[11]*d+a[15]*e;return this},
divideScalar:function(a){return this.multiplyScalar(1/a)},setAxisAngleFromQuaternion:function(a){this.w=2*Math.acos(a.w);var b=Math.sqrt(1-a.w*a.w);1E-4>b?(this.x=1,this.z=this.y=0):(this.x=a.x/b,this.y=a.y/b,this.z=a.z/b);return this},setAxisAngleFromRotationMatrix:function(a){var b,c,d;a=a.elements;var e=a[0];d=a[4];var g=a[8],f=a[1],h=a[5],l=a[9];c=a[2];b=a[6];var k=a[10];if(.01>Math.abs(d-f)&&.01>Math.abs(g-c)&&.01>Math.abs(l-b)){if(.1>Math.abs(d+f)&&.1>Math.abs(g+c)&&.1>Math.abs(l+b)&&.1>Math.abs(e+
h+k-3))return this.set(1,0,0,0),this;a=Math.PI;e=(e+1)/2;h=(h+1)/2;k=(k+1)/2;d=(d+f)/4;g=(g+c)/4;l=(l+b)/4;e>h&&e>k?.01>e?(b=0,d=c=.707106781):(b=Math.sqrt(e),c=d/b,d=g/b):h>k?.01>h?(b=.707106781,c=0,d=.707106781):(c=Math.sqrt(h),b=d/c,d=l/c):.01>k?(c=b=.707106781,d=0):(d=Math.sqrt(k),b=g/d,c=l/d);this.set(b,c,d,a);return this}a=Math.sqrt((b-l)*(b-l)+(g-c)*(g-c)+(f-d)*(f-d));.001>Math.abs(a)&&(a=1);this.x=(b-l)/a;this.y=(g-c)/a;this.z=(f-d)/a;this.w=Math.acos((e+h+k-1)/2);return this},min:function(a){this.x=
Math.min(this.x,a.x);this.y=Math.min(this.y,a.y);this.z=Math.min(this.z,a.z);this.w=Math.min(this.w,a.w);return this},max:function(a){this.x=Math.max(this.x,a.x);this.y=Math.max(this.y,a.y);this.z=Math.max(this.z,a.z);this.w=Math.max(this.w,a.w);return this},clamp:function(a,b){this.x=Math.max(a.x,Math.min(b.x,this.x));this.y=Math.max(a.y,Math.min(b.y,this.y));this.z=Math.max(a.z,Math.min(b.z,this.z));this.w=Math.max(a.w,Math.min(b.w,this.w));return this},clampScalar:function(){var a,b;return function(c,
d){void 0===a&&(a=new THREE.Vector4,b=new THREE.Vector4);a.set(c,c,c,c);b.set(d,d,d,d);return this.clamp(a,b)}}(),floor:function(){this.x=Math.floor(this.x);this.y=Math.floor(this.y);this.z=Math.floor(this.z);this.w=Math.floor(this.w);return this},ceil:function(){this.x=Math.ceil(this.x);this.y=Math.ceil(this.y);this.z=Math.ceil(this.z);this.w=Math.ceil(this.w);return this},round:function(){this.x=Math.round(this.x);this.y=Math.round(this.y);this.z=Math.round(this.z);this.w=Math.round(this.w);return this},
roundToZero:function(){this.x=0>this.x?Math.ceil(this.x):Math.floor(this.x);this.y=0>this.y?Math.ceil(this.y):Math.floor(this.y);this.z=0>this.z?Math.ceil(this.z):Math.floor(this.z);this.w=0>this.w?Math.ceil(this.w):Math.floor(this.w);return this},negate:function(){this.x=-this.x;this.y=-this.y;this.z=-this.z;this.w=-this.w;return this},dot:function(a){return this.x*a.x+this.y*a.y+this.z*a.z+this.w*a.w},lengthSq:function(){return this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w},length:function(){return Math.sqrt(this.x*
this.x+this.y*this.y+this.z*this.z+this.w*this.w)},lengthManhattan:function(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)+Math.abs(this.w)},normalize:function(){return this.divideScalar(this.length())},setLength:function(a){return this.multiplyScalar(a/this.length())},lerp:function(a,b){this.x+=(a.x-this.x)*b;this.y+=(a.y-this.y)*b;this.z+=(a.z-this.z)*b;this.w+=(a.w-this.w)*b;return this},lerpVectors:function(a,b,c){this.subVectors(b,a).multiplyScalar(c).add(a);return this},equals:function(a){return a.x===
this.x&&a.y===this.y&&a.z===this.z&&a.w===this.w},fromArray:function(a,b){void 0===b&&(b=0);this.x=a[b];this.y=a[b+1];this.z=a[b+2];this.w=a[b+3];return this},toArray:function(a,b){void 0===a&&(a=[]);void 0===b&&(b=0);a[b]=this.x;a[b+1]=this.y;a[b+2]=this.z;a[b+3]=this.w;return a},fromAttribute:function(a,b,c){void 0===c&&(c=0);b=b*a.itemSize+c;this.x=a.array[b];this.y=a.array[b+1];this.z=a.array[b+2];this.w=a.array[b+3];return this}};
THREE.Euler=function(a,b,c,d){this._x=a||0;this._y=b||0;this._z=c||0;this._order=d||THREE.Euler.DefaultOrder};THREE.Euler.RotationOrders="XYZ YZX ZXY XZY YXZ ZYX".split(" ");THREE.Euler.DefaultOrder="XYZ";
THREE.Euler.prototype={constructor:THREE.Euler,get x(){return this._x},set x(a){this._x=a;this.onChangeCallback()},get y(){return this._y},set y(a){this._y=a;this.onChangeCallback()},get z(){return this._z},set z(a){this._z=a;this.onChangeCallback()},get order(){return this._order},set order(a){this._order=a;this.onChangeCallback()},set:function(a,b,c,d){this._x=a;this._y=b;this._z=c;this._order=d||this._order;this.onChangeCallback();return this},clone:function(){return new this.constructor(this._x,
this._y,this._z,this._order)},copy:function(a){this._x=a._x;this._y=a._y;this._z=a._z;this._order=a._order;this.onChangeCallback();return this},setFromRotationMatrix:function(a,b,c){var d=THREE.Math.clamp,e=a.elements;a=e[0];var g=e[4],f=e[8],h=e[1],l=e[5],k=e[9],m=e[2],p=e[6],e=e[10];b=b||this._order;"XYZ"===b?(this._y=Math.asin(d(f,-1,1)),.99999>Math.abs(f)?(this._x=Math.atan2(-k,e),this._z=Math.atan2(-g,a)):(this._x=Math.atan2(p,l),this._z=0)):"YXZ"===b?(this._x=Math.asin(-d(k,-1,1)),.99999>Math.abs(k)?
(this._y=Math.atan2(f,e),this._z=Math.atan2(h,l)):(this._y=Math.atan2(-m,a),this._z=0)):"ZXY"===b?(this._x=Math.asin(d(p,-1,1)),.99999>Math.abs(p)?(this._y=Math.atan2(-m,e),this._z=Math.atan2(-g,l)):(this._y=0,this._z=Math.atan2(h,a))):"ZYX"===b?(this._y=Math.asin(-d(m,-1,1)),.99999>Math.abs(m)?(this._x=Math.atan2(p,e),this._z=Math.atan2(h,a)):(this._x=0,this._z=Math.atan2(-g,l))):"YZX"===b?(this._z=Math.asin(d(h,-1,1)),.99999>Math.abs(h)?(this._x=Math.atan2(-k,l),this._y=Math.atan2(-m,a)):(this._x=
0,this._y=Math.atan2(f,e))):"XZY"===b?(this._z=Math.asin(-d(g,-1,1)),.99999>Math.abs(g)?(this._x=Math.atan2(p,l),this._y=Math.atan2(f,a)):(this._x=Math.atan2(-k,e),this._y=0)):console.warn("THREE.Euler: .setFromRotationMatrix() given unsupported order: "+b);this._order=b;if(!1!==c)this.onChangeCallback();return this},setFromQuaternion:function(){var a;return function(b,c,d){void 0===a&&(a=new THREE.Matrix4);a.makeRotationFromQuaternion(b);this.setFromRotationMatrix(a,c,d);return this}}(),setFromVector3:function(a,
b){return this.set(a.x,a.y,a.z,b||this._order)},reorder:function(){var a=new THREE.Quaternion;return function(b){a.setFromEuler(this);this.setFromQuaternion(a,b)}}(),equals:function(a){return a._x===this._x&&a._y===this._y&&a._z===this._z&&a._order===this._order},fromArray:function(a){this._x=a[0];this._y=a[1];this._z=a[2];void 0!==a[3]&&(this._order=a[3]);this.onChangeCallback();return this},toArray:function(a,b){void 0===a&&(a=[]);void 0===b&&(b=0);a[b]=this._x;a[b+1]=this._y;a[b+2]=this._z;a[b+
3]=this._order;return a},toVector3:function(a){return a?a.set(this._x,this._y,this._z):new THREE.Vector3(this._x,this._y,this._z)},onChange:function(a){this.onChangeCallback=a;return this},onChangeCallback:function(){}};THREE.Line3=function(a,b){this.start=void 0!==a?a:new THREE.Vector3;this.end=void 0!==b?b:new THREE.Vector3};
THREE.Line3.prototype={constructor:THREE.Line3,set:function(a,b){this.start.copy(a);this.end.copy(b);return this},clone:function(){return(new this.constructor).copy(this)},copy:function(a){this.start.copy(a.start);this.end.copy(a.end);return this},center:function(a){return(a||new THREE.Vector3).addVectors(this.start,this.end).multiplyScalar(.5)},delta:function(a){return(a||new THREE.Vector3).subVectors(this.end,this.start)},distanceSq:function(){return this.start.distanceToSquared(this.end)},distance:function(){return this.start.distanceTo(this.end)},
at:function(a,b){var c=b||new THREE.Vector3;return this.delta(c).multiplyScalar(a).add(this.start)},closestPointToPointParameter:function(){var a=new THREE.Vector3,b=new THREE.Vector3;return function(c,d){a.subVectors(c,this.start);b.subVectors(this.end,this.start);var e=b.dot(b),e=b.dot(a)/e;d&&(e=THREE.Math.clamp(e,0,1));return e}}(),closestPointToPoint:function(a,b,c){a=this.closestPointToPointParameter(a,b);c=c||new THREE.Vector3;return this.delta(c).multiplyScalar(a).add(this.start)},applyMatrix4:function(a){this.start.applyMatrix4(a);
this.end.applyMatrix4(a);return this},equals:function(a){return a.start.equals(this.start)&&a.end.equals(this.end)}};THREE.Box2=function(a,b){this.min=void 0!==a?a:new THREE.Vector2(Infinity,Infinity);this.max=void 0!==b?b:new THREE.Vector2(-Infinity,-Infinity)};
THREE.Box2.prototype={constructor:THREE.Box2,set:function(a,b){this.min.copy(a);this.max.copy(b);return this},setFromPoints:function(a){this.makeEmpty();for(var b=0,c=a.length;b<c;b++)this.expandByPoint(a[b]);return this},setFromCenterAndSize:function(){var a=new THREE.Vector2;return function(b,c){var d=a.copy(c).multiplyScalar(.5);this.min.copy(b).sub(d);this.max.copy(b).add(d);return this}}(),clone:function(){return(new this.constructor).copy(this)},copy:function(a){this.min.copy(a.min);this.max.copy(a.max);
return this},makeEmpty:function(){this.min.x=this.min.y=Infinity;this.max.x=this.max.y=-Infinity;return this},empty:function(){return this.max.x<this.min.x||this.max.y<this.min.y},center:function(a){return(a||new THREE.Vector2).addVectors(this.min,this.max).multiplyScalar(.5)},size:function(a){return(a||new THREE.Vector2).subVectors(this.max,this.min)},expandByPoint:function(a){this.min.min(a);this.max.max(a);return this},expandByVector:function(a){this.min.sub(a);this.max.add(a);return this},expandByScalar:function(a){this.min.addScalar(-a);
this.max.addScalar(a);return this},containsPoint:function(a){return a.x<this.min.x||a.x>this.max.x||a.y<this.min.y||a.y>this.max.y?!1:!0},containsBox:function(a){return this.min.x<=a.min.x&&a.max.x<=this.max.x&&this.min.y<=a.min.y&&a.max.y<=this.max.y?!0:!1},getParameter:function(a,b){return(b||new THREE.Vector2).set((a.x-this.min.x)/(this.max.x-this.min.x),(a.y-this.min.y)/(this.max.y-this.min.y))},isIntersectionBox:function(a){return a.max.x<this.min.x||a.min.x>this.max.x||a.max.y<this.min.y||a.min.y>
this.max.y?!1:!0},clampPoint:function(a,b){return(b||new THREE.Vector2).copy(a).clamp(this.min,this.max)},distanceToPoint:function(){var a=new THREE.Vector2;return function(b){return a.copy(b).clamp(this.min,this.max).sub(b).length()}}(),intersect:function(a){this.min.max(a.min);this.max.min(a.max);return this},union:function(a){this.min.min(a.min);this.max.max(a.max);return this},translate:function(a){this.min.add(a);this.max.add(a);return this},equals:function(a){return a.min.equals(this.min)&&
a.max.equals(this.max)}};THREE.Box3=function(a,b){this.min=void 0!==a?a:new THREE.Vector3(Infinity,Infinity,Infinity);this.max=void 0!==b?b:new THREE.Vector3(-Infinity,-Infinity,-Infinity)};
THREE.Box3.prototype={constructor:THREE.Box3,set:function(a,b){this.min.copy(a);this.max.copy(b);return this},setFromPoints:function(a){this.makeEmpty();for(var b=0,c=a.length;b<c;b++)this.expandByPoint(a[b]);return this},setFromCenterAndSize:function(){var a=new THREE.Vector3;return function(b,c){var d=a.copy(c).multiplyScalar(.5);this.min.copy(b).sub(d);this.max.copy(b).add(d);return this}}(),setFromObject:function(){var a=new THREE.Vector3;return function(b){var c=this;b.updateMatrixWorld(!0);
this.makeEmpty();b.traverse(function(b){var e=b.geometry;if(void 0!==e)if(e instanceof THREE.Geometry)for(var g=e.vertices,e=0,f=g.length;e<f;e++)a.copy(g[e]),a.applyMatrix4(b.matrixWorld),c.expandByPoint(a);else if(e instanceof THREE.BufferGeometry&&void 0!==e.attributes.position)for(g=e.attributes.position.array,e=0,f=g.length;e<f;e+=3)a.set(g[e],g[e+1],g[e+2]),a.applyMatrix4(b.matrixWorld),c.expandByPoint(a)});return this}}(),clone:function(){return(new this.constructor).copy(this)},copy:function(a){this.min.copy(a.min);
this.max.copy(a.max);return this},makeEmpty:function(){this.min.x=this.min.y=this.min.z=Infinity;this.max.x=this.max.y=this.max.z=-Infinity;return this},empty:function(){return this.max.x<this.min.x||this.max.y<this.min.y||this.max.z<this.min.z},center:function(a){return(a||new THREE.Vector3).addVectors(this.min,this.max).multiplyScalar(.5)},size:function(a){return(a||new THREE.Vector3).subVectors(this.max,this.min)},expandByPoint:function(a){this.min.min(a);this.max.max(a);return this},expandByVector:function(a){this.min.sub(a);
this.max.add(a);return this},expandByScalar:function(a){this.min.addScalar(-a);this.max.addScalar(a);return this},containsPoint:function(a){return a.x<this.min.x||a.x>this.max.x||a.y<this.min.y||a.y>this.max.y||a.z<this.min.z||a.z>this.max.z?!1:!0},containsBox:function(a){return this.min.x<=a.min.x&&a.max.x<=this.max.x&&this.min.y<=a.min.y&&a.max.y<=this.max.y&&this.min.z<=a.min.z&&a.max.z<=this.max.z?!0:!1},getParameter:function(a,b){return(b||new THREE.Vector3).set((a.x-this.min.x)/(this.max.x-
this.min.x),(a.y-this.min.y)/(this.max.y-this.min.y),(a.z-this.min.z)/(this.max.z-this.min.z))},isIntersectionBox:function(a){return a.max.x<this.min.x||a.min.x>this.max.x||a.max.y<this.min.y||a.min.y>this.max.y||a.max.z<this.min.z||a.min.z>this.max.z?!1:!0},clampPoint:function(a,b){return(b||new THREE.Vector3).copy(a).clamp(this.min,this.max)},distanceToPoint:function(){var a=new THREE.Vector3;return function(b){return a.copy(b).clamp(this.min,this.max).sub(b).length()}}(),getBoundingSphere:function(){var a=
new THREE.Vector3;return function(b){b=b||new THREE.Sphere;b.center=this.center();b.radius=.5*this.size(a).length();return b}}(),intersect:function(a){this.min.max(a.min);this.max.min(a.max);return this},union:function(a){this.min.min(a.min);this.max.max(a.max);return this},applyMatrix4:function(){var a=[new THREE.Vector3,new THREE.Vector3,new THREE.Vector3,new THREE.Vector3,new THREE.Vector3,new THREE.Vector3,new THREE.Vector3,new THREE.Vector3];return function(b){a[0].set(this.min.x,this.min.y,
this.min.z).applyMatrix4(b);a[1].set(this.min.x,this.min.y,this.max.z).applyMatrix4(b);a[2].set(this.min.x,this.max.y,this.min.z).applyMatrix4(b);a[3].set(this.min.x,this.max.y,this.max.z).applyMatrix4(b);a[4].set(this.max.x,this.min.y,this.min.z).applyMatrix4(b);a[5].set(this.max.x,this.min.y,this.max.z).applyMatrix4(b);a[6].set(this.max.x,this.max.y,this.min.z).applyMatrix4(b);a[7].set(this.max.x,this.max.y,this.max.z).applyMatrix4(b);this.makeEmpty();this.setFromPoints(a);return this}}(),translate:function(a){this.min.add(a);
this.max.add(a);return this},equals:function(a){return a.min.equals(this.min)&&a.max.equals(this.max)}};THREE.Matrix3=function(){this.elements=new Float32Array([1,0,0,0,1,0,0,0,1]);0<arguments.length&&console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.")};
THREE.Matrix3.prototype={constructor:THREE.Matrix3,set:function(a,b,c,d,e,g,f,h,l){var k=this.elements;k[0]=a;k[3]=b;k[6]=c;k[1]=d;k[4]=e;k[7]=g;k[2]=f;k[5]=h;k[8]=l;return this},identity:function(){this.set(1,0,0,0,1,0,0,0,1);return this},clone:function(){return(new this.constructor).fromArray(this.elements)},copy:function(a){a=a.elements;this.set(a[0],a[3],a[6],a[1],a[4],a[7],a[2],a[5],a[8]);return this},multiplyVector3:function(a){console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.");
return a.applyMatrix3(this)},multiplyVector3Array:function(a){console.warn("THREE.Matrix3: .multiplyVector3Array() has been renamed. Use matrix.applyToVector3Array( array ) instead.");return this.applyToVector3Array(a)},applyToVector3Array:function(){var a;return function(b,c,d){void 0===a&&(a=new THREE.Vector3);void 0===c&&(c=0);void 0===d&&(d=b.length);for(var e=0;e<d;e+=3,c+=3)a.fromArray(b,c),a.applyMatrix3(this),a.toArray(b,c);return b}}(),applyToBuffer:function(){var a;return function(b,c,d){void 0===
a&&(a=new THREE.Vector3);void 0===c&&(c=0);void 0===d&&(d=b.length/b.itemSize);for(var e=0;e<d;e++,c++)a.x=b.getX(c),a.y=b.getY(c),a.z=b.getZ(c),a.applyMatrix3(this),b.setXYZ(a.x,a.y,a.z);return b}}(),multiplyScalar:function(a){var b=this.elements;b[0]*=a;b[3]*=a;b[6]*=a;b[1]*=a;b[4]*=a;b[7]*=a;b[2]*=a;b[5]*=a;b[8]*=a;return this},determinant:function(){var a=this.elements,b=a[0],c=a[1],d=a[2],e=a[3],g=a[4],f=a[5],h=a[6],l=a[7],a=a[8];return b*g*a-b*f*l-c*e*a+c*f*h+d*e*l-d*g*h},getInverse:function(a,
b){var c=a.elements,d=this.elements;d[0]=c[10]*c[5]-c[6]*c[9];d[1]=-c[10]*c[1]+c[2]*c[9];d[2]=c[6]*c[1]-c[2]*c[5];d[3]=-c[10]*c[4]+c[6]*c[8];d[4]=c[10]*c[0]-c[2]*c[8];d[5]=-c[6]*c[0]+c[2]*c[4];d[6]=c[9]*c[4]-c[5]*c[8];d[7]=-c[9]*c[0]+c[1]*c[8];d[8]=c[5]*c[0]-c[1]*c[4];c=c[0]*d[0]+c[1]*d[3]+c[2]*d[6];if(0===c){if(b)throw Error("Matrix3.getInverse(): can't invert matrix, determinant is 0");console.warn("Matrix3.getInverse(): can't invert matrix, determinant is 0");this.identity();return this}this.multiplyScalar(1/
c);return this},transpose:function(){var a,b=this.elements;a=b[1];b[1]=b[3];b[3]=a;a=b[2];b[2]=b[6];b[6]=a;a=b[5];b[5]=b[7];b[7]=a;return this},flattenToArrayOffset:function(a,b){var c=this.elements;a[b]=c[0];a[b+1]=c[1];a[b+2]=c[2];a[b+3]=c[3];a[b+4]=c[4];a[b+5]=c[5];a[b+6]=c[6];a[b+7]=c[7];a[b+8]=c[8];return a},getNormalMatrix:function(a){this.getInverse(a).transpose();return this},transposeIntoArray:function(a){var b=this.elements;a[0]=b[0];a[1]=b[3];a[2]=b[6];a[3]=b[1];a[4]=b[4];a[5]=b[7];a[6]=
b[2];a[7]=b[5];a[8]=b[8];return this},fromArray:function(a){this.elements.set(a);return this},toArray:function(){var a=this.elements;return[a[0],a[1],a[2],a[3],a[4],a[5],a[6],a[7],a[8]]}};THREE.Matrix4=function(){this.elements=new Float32Array([1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]);0<arguments.length&&console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.")};
THREE.Matrix4.prototype={constructor:THREE.Matrix4,set:function(a,b,c,d,e,g,f,h,l,k,m,p,n,q,s,t){var v=this.elements;v[0]=a;v[4]=b;v[8]=c;v[12]=d;v[1]=e;v[5]=g;v[9]=f;v[13]=h;v[2]=l;v[6]=k;v[10]=m;v[14]=p;v[3]=n;v[7]=q;v[11]=s;v[15]=t;return this},identity:function(){this.set(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1);return this},clone:function(){return(new THREE.Matrix4).fromArray(this.elements)},copy:function(a){this.elements.set(a.elements);return this},extractPosition:function(a){console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().");
return this.copyPosition(a)},copyPosition:function(a){var b=this.elements;a=a.elements;b[12]=a[12];b[13]=a[13];b[14]=a[14];return this},extractBasis:function(a,b,c){var d=this.elements;a.set(d[0],d[1],d[2]);b.set(d[4],d[5],d[6]);c.set(d[8],d[9],d[10]);return this},makeBasis:function(a,b,c){this.set(a.x,b.x,c.x,0,a.y,b.y,c.y,0,a.z,b.z,c.z,0,0,0,0,1);return this},extractRotation:function(){var a;return function(b){void 0===a&&(a=new THREE.Vector3);var c=this.elements;b=b.elements;var d=1/a.set(b[0],
b[1],b[2]).length(),e=1/a.set(b[4],b[5],b[6]).length(),g=1/a.set(b[8],b[9],b[10]).length();c[0]=b[0]*d;c[1]=b[1]*d;c[2]=b[2]*d;c[4]=b[4]*e;c[5]=b[5]*e;c[6]=b[6]*e;c[8]=b[8]*g;c[9]=b[9]*g;c[10]=b[10]*g;return this}}(),makeRotationFromEuler:function(a){!1===a instanceof THREE.Euler&&console.error("THREE.Matrix: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");var b=this.elements,c=a.x,d=a.y,e=a.z,g=Math.cos(c),c=Math.sin(c),f=Math.cos(d),d=Math.sin(d),h=Math.cos(e),
e=Math.sin(e);if("XYZ"===a.order){a=g*h;var l=g*e,k=c*h,m=c*e;b[0]=f*h;b[4]=-f*e;b[8]=d;b[1]=l+k*d;b[5]=a-m*d;b[9]=-c*f;b[2]=m-a*d;b[6]=k+l*d;b[10]=g*f}else"YXZ"===a.order?(a=f*h,l=f*e,k=d*h,m=d*e,b[0]=a+m*c,b[4]=k*c-l,b[8]=g*d,b[1]=g*e,b[5]=g*h,b[9]=-c,b[2]=l*c-k,b[6]=m+a*c,b[10]=g*f):"ZXY"===a.order?(a=f*h,l=f*e,k=d*h,m=d*e,b[0]=a-m*c,b[4]=-g*e,b[8]=k+l*c,b[1]=l+k*c,b[5]=g*h,b[9]=m-a*c,b[2]=-g*d,b[6]=c,b[10]=g*f):"ZYX"===a.order?(a=g*h,l=g*e,k=c*h,m=c*e,b[0]=f*h,b[4]=k*d-l,b[8]=a*d+m,b[1]=f*e,b[5]=
m*d+a,b[9]=l*d-k,b[2]=-d,b[6]=c*f,b[10]=g*f):"YZX"===a.order?(a=g*f,l=g*d,k=c*f,m=c*d,b[0]=f*h,b[4]=m-a*e,b[8]=k*e+l,b[1]=e,b[5]=g*h,b[9]=-c*h,b[2]=-d*h,b[6]=l*e+k,b[10]=a-m*e):"XZY"===a.order&&(a=g*f,l=g*d,k=c*f,m=c*d,b[0]=f*h,b[4]=-e,b[8]=d*h,b[1]=a*e+m,b[5]=g*h,b[9]=l*e-k,b[2]=k*e-l,b[6]=c*h,b[10]=m*e+a);b[3]=0;b[7]=0;b[11]=0;b[12]=0;b[13]=0;b[14]=0;b[15]=1;return this},setRotationFromQuaternion:function(a){console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().");
return this.makeRotationFromQuaternion(a)},makeRotationFromQuaternion:function(a){var b=this.elements,c=a.x,d=a.y,e=a.z,g=a.w,f=c+c,h=d+d,l=e+e;a=c*f;var k=c*h,c=c*l,m=d*h,d=d*l,e=e*l,f=g*f,h=g*h,g=g*l;b[0]=1-(m+e);b[4]=k-g;b[8]=c+h;b[1]=k+g;b[5]=1-(a+e);b[9]=d-f;b[2]=c-h;b[6]=d+f;b[10]=1-(a+m);b[3]=0;b[7]=0;b[11]=0;b[12]=0;b[13]=0;b[14]=0;b[15]=1;return this},lookAt:function(){var a,b,c;return function(d,e,g){void 0===a&&(a=new THREE.Vector3);void 0===b&&(b=new THREE.Vector3);void 0===c&&(c=new THREE.Vector3);
var f=this.elements;c.subVectors(d,e).normalize();0===c.lengthSq()&&(c.z=1);a.crossVectors(g,c).normalize();0===a.lengthSq()&&(c.x+=1E-4,a.crossVectors(g,c).normalize());b.crossVectors(c,a);f[0]=a.x;f[4]=b.x;f[8]=c.x;f[1]=a.y;f[5]=b.y;f[9]=c.y;f[2]=a.z;f[6]=b.z;f[10]=c.z;return this}}(),multiply:function(a,b){return void 0!==b?(console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead."),this.multiplyMatrices(a,b)):this.multiplyMatrices(this,a)},
multiplyMatrices:function(a,b){var c=a.elements,d=b.elements,e=this.elements,g=c[0],f=c[4],h=c[8],l=c[12],k=c[1],m=c[5],p=c[9],n=c[13],q=c[2],s=c[6],t=c[10],v=c[14],u=c[3],w=c[7],D=c[11],c=c[15],x=d[0],B=d[4],y=d[8],z=d[12],A=d[1],J=d[5],F=d[9],C=d[13],N=d[2],L=d[6],Q=d[10],M=d[14],K=d[3],E=d[7],O=d[11],d=d[15];e[0]=g*x+f*A+h*N+l*K;e[4]=g*B+f*J+h*L+l*E;e[8]=g*y+f*F+h*Q+l*O;e[12]=g*z+f*C+h*M+l*d;e[1]=k*x+m*A+p*N+n*K;e[5]=k*B+m*J+p*L+n*E;e[9]=k*y+m*F+p*Q+n*O;e[13]=k*z+m*C+p*M+n*d;e[2]=q*x+s*A+t*N+v*
K;e[6]=q*B+s*J+t*L+v*E;e[10]=q*y+s*F+t*Q+v*O;e[14]=q*z+s*C+t*M+v*d;e[3]=u*x+w*A+D*N+c*K;e[7]=u*B+w*J+D*L+c*E;e[11]=u*y+w*F+D*Q+c*O;e[15]=u*z+w*C+D*M+c*d;return this},multiplyToArray:function(a,b,c){var d=this.elements;this.multiplyMatrices(a,b);c[0]=d[0];c[1]=d[1];c[2]=d[2];c[3]=d[3];c[4]=d[4];c[5]=d[5];c[6]=d[6];c[7]=d[7];c[8]=d[8];c[9]=d[9];c[10]=d[10];c[11]=d[11];c[12]=d[12];c[13]=d[13];c[14]=d[14];c[15]=d[15];return this},multiplyScalar:function(a){var b=this.elements;b[0]*=a;b[4]*=a;b[8]*=a;
b[12]*=a;b[1]*=a;b[5]*=a;b[9]*=a;b[13]*=a;b[2]*=a;b[6]*=a;b[10]*=a;b[14]*=a;b[3]*=a;b[7]*=a;b[11]*=a;b[15]*=a;return this},multiplyVector3:function(a){console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) or vector.applyProjection( matrix ) instead.");return a.applyProjection(this)},multiplyVector4:function(a){console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.");return a.applyMatrix4(this)},multiplyVector3Array:function(a){console.warn("THREE.Matrix4: .multiplyVector3Array() has been renamed. Use matrix.applyToVector3Array( array ) instead.");
return this.applyToVector3Array(a)},applyToVector3Array:function(){var a;return function(b,c,d){void 0===a&&(a=new THREE.Vector3);void 0===c&&(c=0);void 0===d&&(d=b.length);for(var e=0;e<d;e+=3,c+=3)a.fromArray(b,c),a.applyMatrix4(this),a.toArray(b,c);return b}}(),applyToBuffer:function(){var a;return function(b,c,d){void 0===a&&(a=new THREE.Vector3);void 0===c&&(c=0);void 0===d&&(d=b.length/b.itemSize);for(var e=0;e<d;e++,c++)a.x=b.getX(c),a.y=b.getY(c),a.z=b.getZ(c),a.applyMatrix4(this),b.setXYZ(a.x,
a.y,a.z);return b}}(),rotateAxis:function(a){console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.");a.transformDirection(this)},crossVector:function(a){console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.");return a.applyMatrix4(this)},determinant:function(){var a=this.elements,b=a[0],c=a[4],d=a[8],e=a[12],g=a[1],f=a[5],h=a[9],l=a[13],k=a[2],m=a[6],p=a[10],n=a[14];return a[3]*(+e*h*m-d*l*
m-e*f*p+c*l*p+d*f*n-c*h*n)+a[7]*(+b*h*n-b*l*p+e*g*p-d*g*n+d*l*k-e*h*k)+a[11]*(+b*l*m-b*f*n-e*g*m+c*g*n+e*f*k-c*l*k)+a[15]*(-d*f*k-b*h*m+b*f*p+d*g*m-c*g*p+c*h*k)},transpose:function(){var a=this.elements,b;b=a[1];a[1]=a[4];a[4]=b;b=a[2];a[2]=a[8];a[8]=b;b=a[6];a[6]=a[9];a[9]=b;b=a[3];a[3]=a[12];a[12]=b;b=a[7];a[7]=a[13];a[13]=b;b=a[11];a[11]=a[14];a[14]=b;return this},flattenToArrayOffset:function(a,b){var c=this.elements;a[b]=c[0];a[b+1]=c[1];a[b+2]=c[2];a[b+3]=c[3];a[b+4]=c[4];a[b+5]=c[5];a[b+6]=
c[6];a[b+7]=c[7];a[b+8]=c[8];a[b+9]=c[9];a[b+10]=c[10];a[b+11]=c[11];a[b+12]=c[12];a[b+13]=c[13];a[b+14]=c[14];a[b+15]=c[15];return a},getPosition:function(){var a;return function(){void 0===a&&(a=new THREE.Vector3);console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.");var b=this.elements;return a.set(b[12],b[13],b[14])}}(),setPosition:function(a){var b=this.elements;b[12]=a.x;b[13]=a.y;b[14]=a.z;return this},getInverse:function(a,b){var c=
this.elements,d=a.elements,e=d[0],g=d[4],f=d[8],h=d[12],l=d[1],k=d[5],m=d[9],p=d[13],n=d[2],q=d[6],s=d[10],t=d[14],v=d[3],u=d[7],w=d[11],d=d[15];c[0]=m*t*u-p*s*u+p*q*w-k*t*w-m*q*d+k*s*d;c[4]=h*s*u-f*t*u-h*q*w+g*t*w+f*q*d-g*s*d;c[8]=f*p*u-h*m*u+h*k*w-g*p*w-f*k*d+g*m*d;c[12]=h*m*q-f*p*q-h*k*s+g*p*s+f*k*t-g*m*t;c[1]=p*s*v-m*t*v-p*n*w+l*t*w+m*n*d-l*s*d;c[5]=f*t*v-h*s*v+h*n*w-e*t*w-f*n*d+e*s*d;c[9]=h*m*v-f*p*v-h*l*w+e*p*w+f*l*d-e*m*d;c[13]=f*p*n-h*m*n+h*l*s-e*p*s-f*l*t+e*m*t;c[2]=k*t*v-p*q*v+p*n*u-l*t*
u-k*n*d+l*q*d;c[6]=h*q*v-g*t*v-h*n*u+e*t*u+g*n*d-e*q*d;c[10]=g*p*v-h*k*v+h*l*u-e*p*u-g*l*d+e*k*d;c[14]=h*k*n-g*p*n-h*l*q+e*p*q+g*l*t-e*k*t;c[3]=m*q*v-k*s*v-m*n*u+l*s*u+k*n*w-l*q*w;c[7]=g*s*v-f*q*v+f*n*u-e*s*u-g*n*w+e*q*w;c[11]=f*k*v-g*m*v-f*l*u+e*m*u+g*l*w-e*k*w;c[15]=g*m*n-f*k*n+f*l*q-e*m*q-g*l*s+e*k*s;c=e*c[0]+l*c[4]+n*c[8]+v*c[12];if(0===c){if(b)throw Error("THREE.Matrix4.getInverse(): can't invert matrix, determinant is 0");console.warn("THREE.Matrix4.getInverse(): can't invert matrix, determinant is 0");
this.identity();return this}this.multiplyScalar(1/c);return this},translate:function(a){console.error("THREE.Matrix4: .translate() has been removed.")},rotateX:function(a){console.error("THREE.Matrix4: .rotateX() has been removed.")},rotateY:function(a){console.error("THREE.Matrix4: .rotateY() has been removed.")},rotateZ:function(a){console.error("THREE.Matrix4: .rotateZ() has been removed.")},rotateByAxis:function(a,b){console.error("THREE.Matrix4: .rotateByAxis() has been removed.")},scale:function(a){var b=
this.elements,c=a.x,d=a.y;a=a.z;b[0]*=c;b[4]*=d;b[8]*=a;b[1]*=c;b[5]*=d;b[9]*=a;b[2]*=c;b[6]*=d;b[10]*=a;b[3]*=c;b[7]*=d;b[11]*=a;return this},getMaxScaleOnAxis:function(){var a=this.elements;return Math.sqrt(Math.max(a[0]*a[0]+a[1]*a[1]+a[2]*a[2],a[4]*a[4]+a[5]*a[5]+a[6]*a[6],a[8]*a[8]+a[9]*a[9]+a[10]*a[10]))},makeTranslation:function(a,b,c){this.set(1,0,0,a,0,1,0,b,0,0,1,c,0,0,0,1);return this},makeRotationX:function(a){var b=Math.cos(a);a=Math.sin(a);this.set(1,0,0,0,0,b,-a,0,0,a,b,0,0,0,0,1);
return this},makeRotationY:function(a){var b=Math.cos(a);a=Math.sin(a);this.set(b,0,a,0,0,1,0,0,-a,0,b,0,0,0,0,1);return this},makeRotationZ:function(a){var b=Math.cos(a);a=Math.sin(a);this.set(b,-a,0,0,a,b,0,0,0,0,1,0,0,0,0,1);return this},makeRotationAxis:function(a,b){var c=Math.cos(b),d=Math.sin(b),e=1-c,g=a.x,f=a.y,h=a.z,l=e*g,k=e*f;this.set(l*g+c,l*f-d*h,l*h+d*f,0,l*f+d*h,k*f+c,k*h-d*g,0,l*h-d*f,k*h+d*g,e*h*h+c,0,0,0,0,1);return this},makeScale:function(a,b,c){this.set(a,0,0,0,0,b,0,0,0,0,c,
0,0,0,0,1);return this},compose:function(a,b,c){this.makeRotationFromQuaternion(b);this.scale(c);this.setPosition(a);return this},decompose:function(){var a,b;return function(c,d,e){void 0===a&&(a=new THREE.Vector3);void 0===b&&(b=new THREE.Matrix4);var g=this.elements,f=a.set(g[0],g[1],g[2]).length(),h=a.set(g[4],g[5],g[6]).length(),l=a.set(g[8],g[9],g[10]).length();0>this.determinant()&&(f=-f);c.x=g[12];c.y=g[13];c.z=g[14];b.elements.set(this.elements);c=1/f;var g=1/h,k=1/l;b.elements[0]*=c;b.elements[1]*=
c;b.elements[2]*=c;b.elements[4]*=g;b.elements[5]*=g;b.elements[6]*=g;b.elements[8]*=k;b.elements[9]*=k;b.elements[10]*=k;d.setFromRotationMatrix(b);e.x=f;e.y=h;e.z=l;return this}}(),makeFrustum:function(a,b,c,d,e,g){var f=this.elements;f[0]=2*e/(b-a);f[4]=0;f[8]=(b+a)/(b-a);f[12]=0;f[1]=0;f[5]=2*e/(d-c);f[9]=(d+c)/(d-c);f[13]=0;f[2]=0;f[6]=0;f[10]=-(g+e)/(g-e);f[14]=-2*g*e/(g-e);f[3]=0;f[7]=0;f[11]=-1;f[15]=0;return this},makePerspective:function(a,b,c,d){a=c*Math.tan(THREE.Math.degToRad(.5*a));
var e=-a;return this.makeFrustum(e*b,a*b,e,a,c,d)},makeOrthographic:function(a,b,c,d,e,g){var f=this.elements,h=b-a,l=c-d,k=g-e;f[0]=2/h;f[4]=0;f[8]=0;f[12]=-((b+a)/h);f[1]=0;f[5]=2/l;f[9]=0;f[13]=-((c+d)/l);f[2]=0;f[6]=0;f[10]=-2/k;f[14]=-((g+e)/k);f[3]=0;f[7]=0;f[11]=0;f[15]=1;return this},equals:function(a){var b=this.elements;a=a.elements;for(var c=0;16>c;c++)if(b[c]!==a[c])return!1;return!0},fromArray:function(a){this.elements.set(a);return this},toArray:function(){var a=this.elements;return[a[0],
a[1],a[2],a[3],a[4],a[5],a[6],a[7],a[8],a[9],a[10],a[11],a[12],a[13],a[14],a[15]]}};THREE.Ray=function(a,b){this.origin=void 0!==a?a:new THREE.Vector3;this.direction=void 0!==b?b:new THREE.Vector3};
THREE.Ray.prototype={constructor:THREE.Ray,set:function(a,b){this.origin.copy(a);this.direction.copy(b);return this},clone:function(){return(new this.constructor).copy(this)},copy:function(a){this.origin.copy(a.origin);this.direction.copy(a.direction);return this},at:function(a,b){return(b||new THREE.Vector3).copy(this.direction).multiplyScalar(a).add(this.origin)},recast:function(){var a=new THREE.Vector3;return function(b){this.origin.copy(this.at(b,a));return this}}(),closestPointToPoint:function(a,
b){var c=b||new THREE.Vector3;c.subVectors(a,this.origin);var d=c.dot(this.direction);return 0>d?c.copy(this.origin):c.copy(this.direction).multiplyScalar(d).add(this.origin)},distanceToPoint:function(a){return Math.sqrt(this.distanceSqToPoint(a))},distanceSqToPoint:function(){var a=new THREE.Vector3;return function(b){var c=a.subVectors(b,this.origin).dot(this.direction);if(0>c)return this.origin.distanceToSquared(b);a.copy(this.direction).multiplyScalar(c).add(this.origin);return a.distanceToSquared(b)}}(),
distanceSqToSegment:function(){var a=new THREE.Vector3,b=new THREE.Vector3,c=new THREE.Vector3;return function(d,e,g,f){a.copy(d).add(e).multiplyScalar(.5);b.copy(e).sub(d).normalize();c.copy(this.origin).sub(a);var h=.5*d.distanceTo(e),l=-this.direction.dot(b),k=c.dot(this.direction),m=-c.dot(b),p=c.lengthSq(),n=Math.abs(1-l*l),q;0<n?(d=l*m-k,e=l*k-m,q=h*n,0<=d?e>=-q?e<=q?(h=1/n,d*=h,e*=h,l=d*(d+l*e+2*k)+e*(l*d+e+2*m)+p):(e=h,d=Math.max(0,-(l*e+k)),l=-d*d+e*(e+2*m)+p):(e=-h,d=Math.max(0,-(l*e+k)),
l=-d*d+e*(e+2*m)+p):e<=-q?(d=Math.max(0,-(-l*h+k)),e=0<d?-h:Math.min(Math.max(-h,-m),h),l=-d*d+e*(e+2*m)+p):e<=q?(d=0,e=Math.min(Math.max(-h,-m),h),l=e*(e+2*m)+p):(d=Math.max(0,-(l*h+k)),e=0<d?h:Math.min(Math.max(-h,-m),h),l=-d*d+e*(e+2*m)+p)):(e=0<l?-h:h,d=Math.max(0,-(l*e+k)),l=-d*d+e*(e+2*m)+p);g&&g.copy(this.direction).multiplyScalar(d).add(this.origin);f&&f.copy(b).multiplyScalar(e).add(a);return l}}(),isIntersectionSphere:function(a){return this.distanceToPoint(a.center)<=a.radius},intersectSphere:function(){var a=
new THREE.Vector3;return function(b,c){a.subVectors(b.center,this.origin);var d=a.dot(this.direction),e=a.dot(a)-d*d,g=b.radius*b.radius;if(e>g)return null;g=Math.sqrt(g-e);e=d-g;d+=g;return 0>e&&0>d?null:0>e?this.at(d,c):this.at(e,c)}}(),isIntersectionPlane:function(a){var b=a.distanceToPoint(this.origin);return 0===b||0>a.normal.dot(this.direction)*b?!0:!1},distanceToPlane:function(a){var b=a.normal.dot(this.direction);if(0===b)return 0===a.distanceToPoint(this.origin)?0:null;a=-(this.origin.dot(a.normal)+
a.constant)/b;return 0<=a?a:null},intersectPlane:function(a,b){var c=this.distanceToPlane(a);return null===c?null:this.at(c,b)},isIntersectionBox:function(){var a=new THREE.Vector3;return function(b){return null!==this.intersectBox(b,a)}}(),intersectBox:function(a,b){var c,d,e,g,f;d=1/this.direction.x;g=1/this.direction.y;f=1/this.direction.z;var h=this.origin;0<=d?(c=(a.min.x-h.x)*d,d*=a.max.x-h.x):(c=(a.max.x-h.x)*d,d*=a.min.x-h.x);0<=g?(e=(a.min.y-h.y)*g,g*=a.max.y-h.y):(e=(a.max.y-h.y)*g,g*=a.min.y-
h.y);if(c>g||e>d)return null;if(e>c||c!==c)c=e;if(g<d||d!==d)d=g;0<=f?(e=(a.min.z-h.z)*f,f*=a.max.z-h.z):(e=(a.max.z-h.z)*f,f*=a.min.z-h.z);if(c>f||e>d)return null;if(e>c||c!==c)c=e;if(f<d||d!==d)d=f;return 0>d?null:this.at(0<=c?c:d,b)},intersectTriangle:function(){var a=new THREE.Vector3,b=new THREE.Vector3,c=new THREE.Vector3,d=new THREE.Vector3;return function(e,g,f,h,l){b.subVectors(g,e);c.subVectors(f,e);d.crossVectors(b,c);g=this.direction.dot(d);if(0<g){if(h)return null;h=1}else if(0>g)h=-1,
g=-g;else return null;a.subVectors(this.origin,e);e=h*this.direction.dot(c.crossVectors(a,c));if(0>e)return null;f=h*this.direction.dot(b.cross(a));if(0>f||e+f>g)return null;e=-h*a.dot(d);return 0>e?null:this.at(e/g,l)}}(),applyMatrix4:function(a){this.direction.add(this.origin).applyMatrix4(a);this.origin.applyMatrix4(a);this.direction.sub(this.origin);this.direction.normalize();return this},equals:function(a){return a.origin.equals(this.origin)&&a.direction.equals(this.direction)}};
THREE.Sphere=function(a,b){this.center=void 0!==a?a:new THREE.Vector3;this.radius=void 0!==b?b:0};
THREE.Sphere.prototype={constructor:THREE.Sphere,set:function(a,b){this.center.copy(a);this.radius=b;return this},setFromPoints:function(){var a=new THREE.Box3;return function(b,c){var d=this.center;void 0!==c?d.copy(c):a.setFromPoints(b).center(d);for(var e=0,g=0,f=b.length;g<f;g++)e=Math.max(e,d.distanceToSquared(b[g]));this.radius=Math.sqrt(e);return this}}(),clone:function(){return(new this.constructor).copy(this)},copy:function(a){this.center.copy(a.center);this.radius=a.radius;return this},
empty:function(){return 0>=this.radius},containsPoint:function(a){return a.distanceToSquared(this.center)<=this.radius*this.radius},distanceToPoint:function(a){return a.distanceTo(this.center)-this.radius},intersectsSphere:function(a){var b=this.radius+a.radius;return a.center.distanceToSquared(this.center)<=b*b},clampPoint:function(a,b){var c=this.center.distanceToSquared(a),d=b||new THREE.Vector3;d.copy(a);c>this.radius*this.radius&&(d.sub(this.center).normalize(),d.multiplyScalar(this.radius).add(this.center));
return d},getBoundingBox:function(a){a=a||new THREE.Box3;a.set(this.center,this.center);a.expandByScalar(this.radius);return a},applyMatrix4:function(a){this.center.applyMatrix4(a);this.radius*=a.getMaxScaleOnAxis();return this},translate:function(a){this.center.add(a);return this},equals:function(a){return a.center.equals(this.center)&&a.radius===this.radius}};
THREE.Frustum=function(a,b,c,d,e,g){this.planes=[void 0!==a?a:new THREE.Plane,void 0!==b?b:new THREE.Plane,void 0!==c?c:new THREE.Plane,void 0!==d?d:new THREE.Plane,void 0!==e?e:new THREE.Plane,void 0!==g?g:new THREE.Plane]};
THREE.Frustum.prototype={constructor:THREE.Frustum,set:function(a,b,c,d,e,g){var f=this.planes;f[0].copy(a);f[1].copy(b);f[2].copy(c);f[3].copy(d);f[4].copy(e);f[5].copy(g);return this},clone:function(){return(new this.constructor).copy(this)},copy:function(a){for(var b=this.planes,c=0;6>c;c++)b[c].copy(a.planes[c]);return this},setFromMatrix:function(a){var b=this.planes,c=a.elements;a=c[0];var d=c[1],e=c[2],g=c[3],f=c[4],h=c[5],l=c[6],k=c[7],m=c[8],p=c[9],n=c[10],q=c[11],s=c[12],t=c[13],v=c[14],
c=c[15];b[0].setComponents(g-a,k-f,q-m,c-s).normalize();b[1].setComponents(g+a,k+f,q+m,c+s).normalize();b[2].setComponents(g+d,k+h,q+p,c+t).normalize();b[3].setComponents(g-d,k-h,q-p,c-t).normalize();b[4].setComponents(g-e,k-l,q-n,c-v).normalize();b[5].setComponents(g+e,k+l,q+n,c+v).normalize();return this},intersectsObject:function(){var a=new THREE.Sphere;return function(b){var c=b.geometry;null===c.boundingSphere&&c.computeBoundingSphere();a.copy(c.boundingSphere);a.applyMatrix4(b.matrixWorld);
return this.intersectsSphere(a)}}(),intersectsSphere:function(a){var b=this.planes,c=a.center;a=-a.radius;for(var d=0;6>d;d++)if(b[d].distanceToPoint(c)<a)return!1;return!0},intersectsBox:function(){var a=new THREE.Vector3,b=new THREE.Vector3;return function(c){for(var d=this.planes,e=0;6>e;e++){var g=d[e];a.x=0<g.normal.x?c.min.x:c.max.x;b.x=0<g.normal.x?c.max.x:c.min.x;a.y=0<g.normal.y?c.min.y:c.max.y;b.y=0<g.normal.y?c.max.y:c.min.y;a.z=0<g.normal.z?c.min.z:c.max.z;b.z=0<g.normal.z?c.max.z:c.min.z;
var f=g.distanceToPoint(a),g=g.distanceToPoint(b);if(0>f&&0>g)return!1}return!0}}(),containsPoint:function(a){for(var b=this.planes,c=0;6>c;c++)if(0>b[c].distanceToPoint(a))return!1;return!0}};THREE.Plane=function(a,b){this.normal=void 0!==a?a:new THREE.Vector3(1,0,0);this.constant=void 0!==b?b:0};
THREE.Plane.prototype={constructor:THREE.Plane,set:function(a,b){this.normal.copy(a);this.constant=b;return this},setComponents:function(a,b,c,d){this.normal.set(a,b,c);this.constant=d;return this},setFromNormalAndCoplanarPoint:function(a,b){this.normal.copy(a);this.constant=-b.dot(this.normal);return this},setFromCoplanarPoints:function(){var a=new THREE.Vector3,b=new THREE.Vector3;return function(c,d,e){d=a.subVectors(e,d).cross(b.subVectors(c,d)).normalize();this.setFromNormalAndCoplanarPoint(d,
c);return this}}(),clone:function(){return(new this.constructor).copy(this)},copy:function(a){this.normal.copy(a.normal);this.constant=a.constant;return this},normalize:function(){var a=1/this.normal.length();this.normal.multiplyScalar(a);this.constant*=a;return this},negate:function(){this.constant*=-1;this.normal.negate();return this},distanceToPoint:function(a){return this.normal.dot(a)+this.constant},distanceToSphere:function(a){return this.distanceToPoint(a.center)-a.radius},projectPoint:function(a,
b){return this.orthoPoint(a,b).sub(a).negate()},orthoPoint:function(a,b){var c=this.distanceToPoint(a);return(b||new THREE.Vector3).copy(this.normal).multiplyScalar(c)},isIntersectionLine:function(a){var b=this.distanceToPoint(a.start);a=this.distanceToPoint(a.end);return 0>b&&0<a||0>a&&0<b},intersectLine:function(){var a=new THREE.Vector3;return function(b,c){var d=c||new THREE.Vector3,e=b.delta(a),g=this.normal.dot(e);if(0===g){if(0===this.distanceToPoint(b.start))return d.copy(b.start)}else return g=
-(b.start.dot(this.normal)+this.constant)/g,0>g||1<g?void 0:d.copy(e).multiplyScalar(g).add(b.start)}}(),coplanarPoint:function(a){return(a||new THREE.Vector3).copy(this.normal).multiplyScalar(-this.constant)},applyMatrix4:function(){var a=new THREE.Vector3,b=new THREE.Vector3,c=new THREE.Matrix3;return function(d,e){var g=e||c.getNormalMatrix(d),g=a.copy(this.normal).applyMatrix3(g),f=this.coplanarPoint(b);f.applyMatrix4(d);this.setFromNormalAndCoplanarPoint(g,f);return this}}(),translate:function(a){this.constant-=
a.dot(this.normal);return this},equals:function(a){return a.normal.equals(this.normal)&&a.constant===this.constant}};
THREE.Math={generateUUID:function(){var a="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(""),b=Array(36),c=0,d;return function(){for(var e=0;36>e;e++)8===e||13===e||18===e||23===e?b[e]="-":14===e?b[e]="4":(2>=c&&(c=33554432+16777216*Math.random()|0),d=c&15,c>>=4,b[e]=a[19===e?d&3|8:d]);return b.join("")}}(),clamp:function(a,b,c){return Math.max(b,Math.min(c,a))},euclideanModulo:function(a,b){return(a%b+b)%b},mapLinear:function(a,b,c,d,e){return d+(a-b)*(e-d)/(c-b)},smoothstep:function(a,
b,c){if(a<=b)return 0;if(a>=c)return 1;a=(a-b)/(c-b);return a*a*(3-2*a)},smootherstep:function(a,b,c){if(a<=b)return 0;if(a>=c)return 1;a=(a-b)/(c-b);return a*a*a*(a*(6*a-15)+10)},random16:function(){return(65280*Math.random()+255*Math.random())/65535},randInt:function(a,b){return a+Math.floor(Math.random()*(b-a+1))},randFloat:function(a,b){return a+Math.random()*(b-a)},randFloatSpread:function(a){return a*(.5-Math.random())},degToRad:function(){var a=Math.PI/180;return function(b){return b*a}}(),
radToDeg:function(){var a=180/Math.PI;return function(b){return b*a}}(),isPowerOfTwo:function(a){return 0===(a&a-1)&&0!==a},nearestPowerOfTwo:function(a){return Math.pow(2,Math.round(Math.log(a)/Math.LN2))},nextPowerOfTwo:function(a){a--;a|=a>>1;a|=a>>2;a|=a>>4;a|=a>>8;a|=a>>16;a++;return a}};
THREE.Spline=function(a){function b(a,b,c,d,e,g,f){a=.5*(c-a);d=.5*(d-b);return(2*(b-c)+a+d)*f+(-3*(b-c)-2*a-d)*g+a*e+b}this.points=a;var c=[],d={x:0,y:0,z:0},e,g,f,h,l,k,m,p,n;this.initFromArray=function(a){this.points=[];for(var b=0;b<a.length;b++)this.points[b]={x:a[b][0],y:a[b][1],z:a[b][2]}};this.getPoint=function(a){e=(this.points.length-1)*a;g=Math.floor(e);f=e-g;c[0]=0===g?g:g-1;c[1]=g;c[2]=g>this.points.length-2?this.points.length-1:g+1;c[3]=g>this.points.length-3?this.points.length-1:g+
2;k=this.points[c[0]];m=this.points[c[1]];p=this.points[c[2]];n=this.points[c[3]];h=f*f;l=f*h;d.x=b(k.x,m.x,p.x,n.x,f,h,l);d.y=b(k.y,m.y,p.y,n.y,f,h,l);d.z=b(k.z,m.z,p.z,n.z,f,h,l);return d};this.getControlPointsArray=function(){var a,b,c=this.points.length,d=[];for(a=0;a<c;a++)b=this.points[a],d[a]=[b.x,b.y,b.z];return d};this.getLength=function(a){var b,c,d,e=b=b=0,g=new THREE.Vector3,f=new THREE.Vector3,h=[],l=0;h[0]=0;a||(a=100);c=this.points.length*a;g.copy(this.points[0]);for(a=1;a<c;a++)b=
a/c,d=this.getPoint(b),f.copy(d),l+=f.distanceTo(g),g.copy(d),b*=this.points.length-1,b=Math.floor(b),b!==e&&(h[b]=l,e=b);h[h.length]=l;return{chunks:h,total:l}};this.reparametrizeByArcLength=function(a){var b,c,d,e,g,f,h=[],l=new THREE.Vector3,k=this.getLength();h.push(l.copy(this.points[0]).clone());for(b=1;b<this.points.length;b++){c=k.chunks[b]-k.chunks[b-1];f=Math.ceil(a*c/k.total);e=(b-1)/(this.points.length-1);g=b/(this.points.length-1);for(c=1;c<f-1;c++)d=e+1/f*c*(g-e),d=this.getPoint(d),
h.push(l.copy(d).clone());h.push(l.copy(this.points[b]).clone())}this.points=h}};THREE.Triangle=function(a,b,c){this.a=void 0!==a?a:new THREE.Vector3;this.b=void 0!==b?b:new THREE.Vector3;this.c=void 0!==c?c:new THREE.Vector3};THREE.Triangle.normal=function(){var a=new THREE.Vector3;return function(b,c,d,e){e=e||new THREE.Vector3;e.subVectors(d,c);a.subVectors(b,c);e.cross(a);b=e.lengthSq();return 0<b?e.multiplyScalar(1/Math.sqrt(b)):e.set(0,0,0)}}();
THREE.Triangle.barycoordFromPoint=function(){var a=new THREE.Vector3,b=new THREE.Vector3,c=new THREE.Vector3;return function(d,e,g,f,h){a.subVectors(f,e);b.subVectors(g,e);c.subVectors(d,e);d=a.dot(a);e=a.dot(b);g=a.dot(c);var l=b.dot(b);f=b.dot(c);var k=d*l-e*e;h=h||new THREE.Vector3;if(0===k)return h.set(-2,-1,-1);k=1/k;l=(l*g-e*f)*k;d=(d*f-e*g)*k;return h.set(1-l-d,d,l)}}();
THREE.Triangle.containsPoint=function(){var a=new THREE.Vector3;return function(b,c,d,e){b=THREE.Triangle.barycoordFromPoint(b,c,d,e,a);return 0<=b.x&&0<=b.y&&1>=b.x+b.y}}();
THREE.Triangle.prototype={constructor:THREE.Triangle,set:function(a,b,c){this.a.copy(a);this.b.copy(b);this.c.copy(c);return this},setFromPointsAndIndices:function(a,b,c,d){this.a.copy(a[b]);this.b.copy(a[c]);this.c.copy(a[d]);return this},clone:function(){return(new this.constructor).copy(this)},copy:function(a){this.a.copy(a.a);this.b.copy(a.b);this.c.copy(a.c);return this},area:function(){var a=new THREE.Vector3,b=new THREE.Vector3;return function(){a.subVectors(this.c,this.b);b.subVectors(this.a,
this.b);return.5*a.cross(b).length()}}(),midpoint:function(a){return(a||new THREE.Vector3).addVectors(this.a,this.b).add(this.c).multiplyScalar(1/3)},normal:function(a){return THREE.Triangle.normal(this.a,this.b,this.c,a)},plane:function(a){return(a||new THREE.Plane).setFromCoplanarPoints(this.a,this.b,this.c)},barycoordFromPoint:function(a,b){return THREE.Triangle.barycoordFromPoint(a,this.a,this.b,this.c,b)},containsPoint:function(a){return THREE.Triangle.containsPoint(a,this.a,this.b,this.c)},
equals:function(a){return a.a.equals(this.a)&&a.b.equals(this.b)&&a.c.equals(this.c)}};THREE.Channels=function(){this.mask=1};THREE.Channels.prototype={constructor:THREE.Channels,set:function(a){this.mask=1<<a},enable:function(a){this.mask|=1<<a},toggle:function(a){this.mask^=1<<a},disable:function(a){this.mask&=~(1<<a)}};THREE.Clock=function(a){this.autoStart=void 0!==a?a:!0;this.elapsedTime=this.oldTime=this.startTime=0;this.running=!1};
THREE.Clock.prototype={constructor:THREE.Clock,start:function(){this.oldTime=this.startTime=self.performance.now();this.running=!0},stop:function(){this.getElapsedTime();this.running=!1},getElapsedTime:function(){this.getDelta();return this.elapsedTime},getDelta:function(){var a=0;this.autoStart&&!this.running&&this.start();if(this.running){var b=self.performance.now(),a=.001*(b-this.oldTime);this.oldTime=b;this.elapsedTime+=a}return a}};THREE.EventDispatcher=function(){};
THREE.EventDispatcher.prototype={constructor:THREE.EventDispatcher,apply:function(a){a.addEventListener=THREE.EventDispatcher.prototype.addEventListener;a.hasEventListener=THREE.EventDispatcher.prototype.hasEventListener;a.removeEventListener=THREE.EventDispatcher.prototype.removeEventListener;a.dispatchEvent=THREE.EventDispatcher.prototype.dispatchEvent},addEventListener:function(a,b){void 0===this._listeners&&(this._listeners={});var c=this._listeners;void 0===c[a]&&(c[a]=[]);-1===c[a].indexOf(b)&&
c[a].push(b)},hasEventListener:function(a,b){if(void 0===this._listeners)return!1;var c=this._listeners;return void 0!==c[a]&&-1!==c[a].indexOf(b)?!0:!1},removeEventListener:function(a,b){if(void 0!==this._listeners){var c=this._listeners[a];if(void 0!==c){var d=c.indexOf(b);-1!==d&&c.splice(d,1)}}},dispatchEvent:function(a){if(void 0!==this._listeners){var b=this._listeners[a.type];if(void 0!==b){a.target=this;for(var c=[],d=b.length,e=0;e<d;e++)c[e]=b[e];for(e=0;e<d;e++)c[e].call(this,a)}}}};
(function(a){function b(a,b){return a.distance-b.distance}function c(a,b,g,f){if(!1!==a.visible&&(a.raycast(b,g),!0===f)){a=a.children;f=0;for(var h=a.length;f<h;f++)c(a[f],b,g,!0)}}a.Raycaster=function(b,c,g,f){this.ray=new a.Ray(b,c);this.near=g||0;this.far=f||Infinity;this.params={Mesh:{},Line:{},LOD:{},Points:{threshold:1},Sprite:{}};Object.defineProperties(this.params,{PointCloud:{get:function(){console.warn("THREE.Raycaster: params.PointCloud has been renamed to params.Points.");return this.Points}}})};
a.Raycaster.prototype={constructor:a.Raycaster,linePrecision:1,set:function(a,b){this.ray.set(a,b)},setFromCamera:function(b,c){c instanceof a.PerspectiveCamera?(this.ray.origin.setFromMatrixPosition(c.matrixWorld),this.ray.direction.set(b.x,b.y,.5).unproject(c).sub(this.ray.origin).normalize()):c instanceof a.OrthographicCamera?(this.ray.origin.set(b.x,b.y,-1).unproject(c),this.ray.direction.set(0,0,-1).transformDirection(c.matrixWorld)):console.error("THREE.Raycaster: Unsupported camera type.")},
intersectObject:function(a,e){var g=[];c(a,this,g,e);g.sort(b);return g},intersectObjects:function(a,e){var g=[];if(!1===Array.isArray(a))return console.warn("THREE.Raycaster.intersectObjects: objects is not an Array."),g;for(var f=0,h=a.length;f<h;f++)c(a[f],this,g,e);g.sort(b);return g}}})(THREE);
THREE.Object3D=function(){Object.defineProperty(this,"id",{value:THREE.Object3DIdCount++});this.uuid=THREE.Math.generateUUID();this.name="";this.type="Object3D";this.parent=null;this.channels=new THREE.Channels;this.children=[];this.up=THREE.Object3D.DefaultUp.clone();var a=new THREE.Vector3,b=new THREE.Euler,c=new THREE.Quaternion,d=new THREE.Vector3(1,1,1);b.onChange(function(){c.setFromEuler(b,!1)});c.onChange(function(){b.setFromQuaternion(c,void 0,!1)});Object.defineProperties(this,{position:{enumerable:!0,
value:a},rotation:{enumerable:!0,value:b},quaternion:{enumerable:!0,value:c},scale:{enumerable:!0,value:d},modelViewMatrix:{value:new THREE.Matrix4},normalMatrix:{value:new THREE.Matrix3}});this.rotationAutoUpdate=!0;this.matrix=new THREE.Matrix4;this.matrixWorld=new THREE.Matrix4;this.matrixAutoUpdate=THREE.Object3D.DefaultMatrixAutoUpdate;this.matrixWorldNeedsUpdate=!1;this.visible=!0;this.receiveShadow=this.castShadow=!1;this.frustumCulled=!0;this.renderOrder=0;this.userData={}};
THREE.Object3D.DefaultUp=new THREE.Vector3(0,1,0);THREE.Object3D.DefaultMatrixAutoUpdate=!0;
THREE.Object3D.prototype={constructor:THREE.Object3D,get eulerOrder(){console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");return this.rotation.order},set eulerOrder(a){console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");this.rotation.order=a},get useQuaternion(){console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.")},set useQuaternion(a){console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.")},set renderDepth(a){console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.")},
applyMatrix:function(a){this.matrix.multiplyMatrices(a,this.matrix);this.matrix.decompose(this.position,this.quaternion,this.scale)},setRotationFromAxisAngle:function(a,b){this.quaternion.setFromAxisAngle(a,b)},setRotationFromEuler:function(a){this.quaternion.setFromEuler(a,!0)},setRotationFromMatrix:function(a){this.quaternion.setFromRotationMatrix(a)},setRotationFromQuaternion:function(a){this.quaternion.copy(a)},rotateOnAxis:function(){var a=new THREE.Quaternion;return function(b,c){a.setFromAxisAngle(b,
c);this.quaternion.multiply(a);return this}}(),rotateX:function(){var a=new THREE.Vector3(1,0,0);return function(b){return this.rotateOnAxis(a,b)}}(),rotateY:function(){var a=new THREE.Vector3(0,1,0);return function(b){return this.rotateOnAxis(a,b)}}(),rotateZ:function(){var a=new THREE.Vector3(0,0,1);return function(b){return this.rotateOnAxis(a,b)}}(),translateOnAxis:function(){var a=new THREE.Vector3;return function(b,c){a.copy(b).applyQuaternion(this.quaternion);this.position.add(a.multiplyScalar(c));
return this}}(),translate:function(a,b){console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.");return this.translateOnAxis(b,a)},translateX:function(){var a=new THREE.Vector3(1,0,0);return function(b){return this.translateOnAxis(a,b)}}(),translateY:function(){var a=new THREE.Vector3(0,1,0);return function(b){return this.translateOnAxis(a,b)}}(),translateZ:function(){var a=new THREE.Vector3(0,0,1);return function(b){return this.translateOnAxis(a,
b)}}(),localToWorld:function(a){return a.applyMatrix4(this.matrixWorld)},worldToLocal:function(){var a=new THREE.Matrix4;return function(b){return b.applyMatrix4(a.getInverse(this.matrixWorld))}}(),lookAt:function(){var a=new THREE.Matrix4;return function(b){a.lookAt(b,this.position,this.up);this.quaternion.setFromRotationMatrix(a)}}(),add:function(a){if(1<arguments.length){for(var b=0;b<arguments.length;b++)this.add(arguments[b]);return this}if(a===this)return console.error("THREE.Object3D.add: object can't be added as a child of itself.",
a),this;a instanceof THREE.Object3D?(null!==a.parent&&a.parent.remove(a),a.parent=this,a.dispatchEvent({type:"added"}),this.children.push(a)):console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.",a);return this},remove:function(a){if(1<arguments.length)for(var b=0;b<arguments.length;b++)this.remove(arguments[b]);b=this.children.indexOf(a);-1!==b&&(a.parent=null,a.dispatchEvent({type:"removed"}),this.children.splice(b,1))},getChildByName:function(a){console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().");
return this.getObjectByName(a)},getObjectById:function(a){return this.getObjectByProperty("id",a)},getObjectByName:function(a){return this.getObjectByProperty("name",a)},getObjectByProperty:function(a,b){if(this[a]===b)return this;for(var c=0,d=this.children.length;c<d;c++){var e=this.children[c].getObjectByProperty(a,b);if(void 0!==e)return e}},getWorldPosition:function(a){a=a||new THREE.Vector3;this.updateMatrixWorld(!0);return a.setFromMatrixPosition(this.matrixWorld)},getWorldQuaternion:function(){var a=
new THREE.Vector3,b=new THREE.Vector3;return function(c){c=c||new THREE.Quaternion;this.updateMatrixWorld(!0);this.matrixWorld.decompose(a,c,b);return c}}(),getWorldRotation:function(){var a=new THREE.Quaternion;return function(b){b=b||new THREE.Euler;this.getWorldQuaternion(a);return b.setFromQuaternion(a,this.rotation.order,!1)}}(),getWorldScale:function(){var a=new THREE.Vector3,b=new THREE.Quaternion;return function(c){c=c||new THREE.Vector3;this.updateMatrixWorld(!0);this.matrixWorld.decompose(a,
b,c);return c}}(),getWorldDirection:function(){var a=new THREE.Quaternion;return function(b){b=b||new THREE.Vector3;this.getWorldQuaternion(a);return b.set(0,0,1).applyQuaternion(a)}}(),raycast:function(){},traverse:function(a){a(this);for(var b=this.children,c=0,d=b.length;c<d;c++)b[c].traverse(a)},traverseVisible:function(a){if(!1!==this.visible){a(this);for(var b=this.children,c=0,d=b.length;c<d;c++)b[c].traverseVisible(a)}},traverseAncestors:function(a){var b=this.parent;null!==b&&(a(b),b.traverseAncestors(a))},
updateMatrix:function(){this.matrix.compose(this.position,this.quaternion,this.scale);this.matrixWorldNeedsUpdate=!0},updateMatrixWorld:function(a){!0===this.matrixAutoUpdate&&this.updateMatrix();if(!0===this.matrixWorldNeedsUpdate||!0===a)null===this.parent?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix),this.matrixWorldNeedsUpdate=!1,a=!0;for(var b=0,c=this.children.length;b<c;b++)this.children[b].updateMatrixWorld(a)},toJSON:function(a){function b(a){var b=
[],c;for(c in a){var d=a[c];delete d.metadata;b.push(d)}return b}var c=void 0===a,d={};c&&(a={geometries:{},materials:{},textures:{},images:{}},d.metadata={version:4.4,type:"Object",generator:"Object3D.toJSON"});var e={};e.uuid=this.uuid;e.type=this.type;""!==this.name&&(e.name=this.name);"{}"!==JSON.stringify(this.userData)&&(e.userData=this.userData);!0===this.castShadow&&(e.castShadow=!0);!0===this.receiveShadow&&(e.receiveShadow=!0);!1===this.visible&&(e.visible=!1);e.matrix=this.matrix.toArray();
void 0!==this.geometry&&(void 0===a.geometries[this.geometry.uuid]&&(a.geometries[this.geometry.uuid]=this.geometry.toJSON(a)),e.geometry=this.geometry.uuid);void 0!==this.material&&(void 0===a.materials[this.material.uuid]&&(a.materials[this.material.uuid]=this.material.toJSON(a)),e.material=this.material.uuid);if(0<this.children.length){e.children=[];for(var g=0;g<this.children.length;g++)e.children.push(this.children[g].toJSON(a).object)}if(c){var c=b(a.geometries),g=b(a.materials),f=b(a.textures);
a=b(a.images);0<c.length&&(d.geometries=c);0<g.length&&(d.materials=g);0<f.length&&(d.textures=f);0<a.length&&(d.images=a)}d.object=e;return d},clone:function(a){return(new this.constructor).copy(this,a)},copy:function(a,b){void 0===b&&(b=!0);this.name=a.name;this.up.copy(a.up);this.position.copy(a.position);this.quaternion.copy(a.quaternion);this.scale.copy(a.scale);this.rotationAutoUpdate=a.rotationAutoUpdate;this.matrix.copy(a.matrix);this.matrixWorld.copy(a.matrixWorld);this.matrixAutoUpdate=
a.matrixAutoUpdate;this.matrixWorldNeedsUpdate=a.matrixWorldNeedsUpdate;this.visible=a.visible;this.castShadow=a.castShadow;this.receiveShadow=a.receiveShadow;this.frustumCulled=a.frustumCulled;this.renderOrder=a.renderOrder;this.userData=JSON.parse(JSON.stringify(a.userData));if(!0===b)for(var c=0;c<a.children.length;c++)this.add(a.children[c].clone());return this}};THREE.EventDispatcher.prototype.apply(THREE.Object3D.prototype);THREE.Object3DIdCount=0;
THREE.Face3=function(a,b,c,d,e,g){this.a=a;this.b=b;this.c=c;this.normal=d instanceof THREE.Vector3?d:new THREE.Vector3;this.vertexNormals=Array.isArray(d)?d:[];this.color=e instanceof THREE.Color?e:new THREE.Color;this.vertexColors=Array.isArray(e)?e:[];this.materialIndex=void 0!==g?g:0};
THREE.Face3.prototype={constructor:THREE.Face3,clone:function(){return(new this.constructor).copy(this)},copy:function(a){this.a=a.a;this.b=a.b;this.c=a.c;this.normal.copy(a.normal);this.color.copy(a.color);this.materialIndex=a.materialIndex;for(var b=0,c=a.vertexNormals.length;b<c;b++)this.vertexNormals[b]=a.vertexNormals[b].clone();b=0;for(c=a.vertexColors.length;b<c;b++)this.vertexColors[b]=a.vertexColors[b].clone();return this}};
THREE.Face4=function(a,b,c,d,e,g,f){console.warn("THREE.Face4 has been removed. A THREE.Face3 will be created instead.");return new THREE.Face3(a,b,c,e,g,f)};THREE.BufferAttribute=function(a,b){this.uuid=THREE.Math.generateUUID();this.array=a;this.itemSize=b;this.dynamic=!1;this.updateRange={offset:0,count:-1};this.version=0};
THREE.BufferAttribute.prototype={constructor:THREE.BufferAttribute,get length(){console.warn("THREE.BufferAttribute: .length has been deprecated. Please use .count.");return this.array.length},get count(){return this.array.length/this.itemSize},set needsUpdate(a){!0===a&&this.version++},setDynamic:function(a){this.dynamic=a;return this},copy:function(a){this.array=new a.array.constructor(a.array);this.itemSize=a.itemSize;this.dynamic=a.dynamic;return this},copyAt:function(a,b,c){a*=this.itemSize;
c*=b.itemSize;for(var d=0,e=this.itemSize;d<e;d++)this.array[a+d]=b.array[c+d];return this},copyArray:function(a){this.array.set(a);return this},copyColorsArray:function(a){for(var b=this.array,c=0,d=0,e=a.length;d<e;d++){var g=a[d];void 0===g&&(console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined",d),g=new THREE.Color);b[c++]=g.r;b[c++]=g.g;b[c++]=g.b}return this},copyIndicesArray:function(a){for(var b=this.array,c=0,d=0,e=a.length;d<e;d++){var g=a[d];b[c++]=g.a;b[c++]=g.b;b[c++]=
g.c}return this},copyVector2sArray:function(a){for(var b=this.array,c=0,d=0,e=a.length;d<e;d++){var g=a[d];void 0===g&&(console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined",d),g=new THREE.Vector2);b[c++]=g.x;b[c++]=g.y}return this},copyVector3sArray:function(a){for(var b=this.array,c=0,d=0,e=a.length;d<e;d++){var g=a[d];void 0===g&&(console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined",d),g=new THREE.Vector3);b[c++]=g.x;b[c++]=g.y;b[c++]=g.z}return this},
copyVector4sArray:function(a){for(var b=this.array,c=0,d=0,e=a.length;d<e;d++){var g=a[d];void 0===g&&(console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined",d),g=new THREE.Vector4);b[c++]=g.x;b[c++]=g.y;b[c++]=g.z;b[c++]=g.w}return this},set:function(a,b){void 0===b&&(b=0);this.array.set(a,b);return this},getX:function(a){return this.array[a*this.itemSize]},setX:function(a,b){this.array[a*this.itemSize]=b;return this},getY:function(a){return this.array[a*this.itemSize+1]},
setY:function(a,b){this.array[a*this.itemSize+1]=b;return this},getZ:function(a){return this.array[a*this.itemSize+2]},setZ:function(a,b){this.array[a*this.itemSize+2]=b;return this},getW:function(a){return this.array[a*this.itemSize+3]},setW:function(a,b){this.array[a*this.itemSize+3]=b;return this},setXY:function(a,b,c){a*=this.itemSize;this.array[a+0]=b;this.array[a+1]=c;return this},setXYZ:function(a,b,c,d){a*=this.itemSize;this.array[a+0]=b;this.array[a+1]=c;this.array[a+2]=d;return this},setXYZW:function(a,
b,c,d,e){a*=this.itemSize;this.array[a+0]=b;this.array[a+1]=c;this.array[a+2]=d;this.array[a+3]=e;return this},clone:function(){return(new this.constructor).copy(this)}};THREE.Int8Attribute=function(a,b){return new THREE.BufferAttribute(new Int8Array(a),b)};THREE.Uint8Attribute=function(a,b){return new THREE.BufferAttribute(new Uint8Array(a),b)};THREE.Uint8ClampedAttribute=function(a,b){return new THREE.BufferAttribute(new Uint8ClampedArray(a),b)};
THREE.Int16Attribute=function(a,b){return new THREE.BufferAttribute(new Int16Array(a),b)};THREE.Uint16Attribute=function(a,b){return new THREE.BufferAttribute(new Uint16Array(a),b)};THREE.Int32Attribute=function(a,b){return new THREE.BufferAttribute(new Int32Array(a),b)};THREE.Uint32Attribute=function(a,b){return new THREE.BufferAttribute(new Uint32Array(a),b)};THREE.Float32Attribute=function(a,b){return new THREE.BufferAttribute(new Float32Array(a),b)};
THREE.Float64Attribute=function(a,b){return new THREE.BufferAttribute(new Float64Array(a),b)};THREE.DynamicBufferAttribute=function(a,b){console.warn("THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setDynamic( true ) instead.");return(new THREE.BufferAttribute(a,b)).setDynamic(!0)};THREE.InstancedBufferAttribute=function(a,b,c){THREE.BufferAttribute.call(this,a,b);this.meshPerAttribute=c||1};THREE.InstancedBufferAttribute.prototype=Object.create(THREE.BufferAttribute.prototype);
THREE.InstancedBufferAttribute.prototype.constructor=THREE.InstancedBufferAttribute;THREE.InstancedBufferAttribute.prototype.copy=function(a){THREE.BufferAttribute.prototype.copy.call(this,a);this.meshPerAttribute=a.meshPerAttribute;return this};THREE.InterleavedBuffer=function(a,b){this.uuid=THREE.Math.generateUUID();this.array=a;this.stride=b;this.dynamic=!1;this.updateRange={offset:0,count:-1};this.version=0};
THREE.InterleavedBuffer.prototype={constructor:THREE.InterleavedBuffer,get length(){return this.array.length},get count(){return this.array.length/this.stride},set needsUpdate(a){!0===a&&this.version++},setDynamic:function(a){this.dynamic=a;return this},copy:function(a){this.array=new a.array.constructor(a.array);this.stride=a.stride;this.dynamic=a.dynamic},copyAt:function(a,b,c){a*=this.stride;c*=b.stride;for(var d=0,e=this.stride;d<e;d++)this.array[a+d]=b.array[c+d];return this},set:function(a,
b){void 0===b&&(b=0);this.array.set(a,b);return this},clone:function(){return(new this.constructor).copy(this)}};THREE.InstancedInterleavedBuffer=function(a,b,c){THREE.InterleavedBuffer.call(this,a,b);this.meshPerAttribute=c||1};THREE.InstancedInterleavedBuffer.prototype=Object.create(THREE.InterleavedBuffer.prototype);THREE.InstancedInterleavedBuffer.prototype.constructor=THREE.InstancedInterleavedBuffer;
THREE.InstancedInterleavedBuffer.prototype.copy=function(a){THREE.InterleavedBuffer.prototype.copy.call(this,a);this.meshPerAttribute=a.meshPerAttribute;return this};THREE.InterleavedBufferAttribute=function(a,b,c){this.uuid=THREE.Math.generateUUID();this.data=a;this.itemSize=b;this.offset=c};
THREE.InterleavedBufferAttribute.prototype={constructor:THREE.InterleavedBufferAttribute,get length(){console.warn("THREE.BufferAttribute: .length has been deprecated. Please use .count.");return this.array.length},get count(){return this.data.array.length/this.data.stride},setX:function(a,b){this.data.array[a*this.data.stride+this.offset]=b;return this},setY:function(a,b){this.data.array[a*this.data.stride+this.offset+1]=b;return this},setZ:function(a,b){this.data.array[a*this.data.stride+this.offset+
2]=b;return this},setW:function(a,b){this.data.array[a*this.data.stride+this.offset+3]=b;return this},getX:function(a){return this.data.array[a*this.data.stride+this.offset]},getY:function(a){return this.data.array[a*this.data.stride+this.offset+1]},getZ:function(a){return this.data.array[a*this.data.stride+this.offset+2]},getW:function(a){return this.data.array[a*this.data.stride+this.offset+3]},setXY:function(a,b,c){a=a*this.data.stride+this.offset;this.data.array[a+0]=b;this.data.array[a+1]=c;
return this},setXYZ:function(a,b,c,d){a=a*this.data.stride+this.offset;this.data.array[a+0]=b;this.data.array[a+1]=c;this.data.array[a+2]=d;return this},setXYZW:function(a,b,c,d,e){a=a*this.data.stride+this.offset;this.data.array[a+0]=b;this.data.array[a+1]=c;this.data.array[a+2]=d;this.data.array[a+3]=e;return this}};
THREE.Geometry=function(){Object.defineProperty(this,"id",{value:THREE.GeometryIdCount++});this.uuid=THREE.Math.generateUUID();this.name="";this.type="Geometry";this.vertices=[];this.colors=[];this.faces=[];this.faceVertexUvs=[[]];this.morphTargets=[];this.morphNormals=[];this.skinWeights=[];this.skinIndices=[];this.lineDistances=[];this.boundingSphere=this.boundingBox=null;this.groupsNeedUpdate=this.lineDistancesNeedUpdate=this.colorsNeedUpdate=this.normalsNeedUpdate=this.uvsNeedUpdate=this.elementsNeedUpdate=
this.verticesNeedUpdate=!1};
THREE.Geometry.prototype={constructor:THREE.Geometry,applyMatrix:function(a){for(var b=(new THREE.Matrix3).getNormalMatrix(a),c=0,d=this.vertices.length;c<d;c++)this.vertices[c].applyMatrix4(a);c=0;for(d=this.faces.length;c<d;c++){a=this.faces[c];a.normal.applyMatrix3(b).normalize();for(var e=0,g=a.vertexNormals.length;e<g;e++)a.vertexNormals[e].applyMatrix3(b).normalize()}null!==this.boundingBox&&this.computeBoundingBox();null!==this.boundingSphere&&this.computeBoundingSphere();this.normalsNeedUpdate=
this.verticesNeedUpdate=!0},rotateX:function(){var a;return function(b){void 0===a&&(a=new THREE.Matrix4);a.makeRotationX(b);this.applyMatrix(a);return this}}(),rotateY:function(){var a;return function(b){void 0===a&&(a=new THREE.Matrix4);a.makeRotationY(b);this.applyMatrix(a);return this}}(),rotateZ:function(){var a;return function(b){void 0===a&&(a=new THREE.Matrix4);a.makeRotationZ(b);this.applyMatrix(a);return this}}(),translate:function(){var a;return function(b,c,d){void 0===a&&(a=new THREE.Matrix4);
a.makeTranslation(b,c,d);this.applyMatrix(a);return this}}(),scale:function(){var a;return function(b,c,d){void 0===a&&(a=new THREE.Matrix4);a.makeScale(b,c,d);this.applyMatrix(a);return this}}(),lookAt:function(){var a;return function(b){void 0===a&&(a=new THREE.Object3D);a.lookAt(b);a.updateMatrix();this.applyMatrix(a.matrix)}}(),fromBufferGeometry:function(a){function b(a,b,d){var e=void 0!==f?[m[a].clone(),m[b].clone(),m[d].clone()]:[],g=void 0!==h?[c.colors[a].clone(),c.colors[b].clone(),c.colors[d].clone()]:
[],e=new THREE.Face3(a,b,d,e,g);c.faces.push(e);void 0!==l&&c.faceVertexUvs[0].push([p[a].clone(),p[b].clone(),p[d].clone()]);void 0!==k&&c.faceVertexUvs[1].push([n[a].clone(),n[b].clone(),n[d].clone()])}var c=this,d=null!==a.index?a.index.array:void 0,e=a.attributes,g=e.position.array,f=void 0!==e.normal?e.normal.array:void 0,h=void 0!==e.color?e.color.array:void 0,l=void 0!==e.uv?e.uv.array:void 0,k=void 0!==e.uv2?e.uv2.array:void 0;void 0!==k&&(this.faceVertexUvs[1]=[]);for(var m=[],p=[],n=[],
q=e=0;e<g.length;e+=3,q+=2)c.vertices.push(new THREE.Vector3(g[e],g[e+1],g[e+2])),void 0!==f&&m.push(new THREE.Vector3(f[e],f[e+1],f[e+2])),void 0!==h&&c.colors.push(new THREE.Color(h[e],h[e+1],h[e+2])),void 0!==l&&p.push(new THREE.Vector2(l[q],l[q+1])),void 0!==k&&n.push(new THREE.Vector2(k[q],k[q+1]));if(void 0!==d)if(g=a.groups,0<g.length)for(e=0;e<g.length;e++)for(var q=g[e],s=q.start,t=q.count,q=s,s=s+t;q<s;q+=3)b(d[q],d[q+1],d[q+2]);else for(e=0;e<d.length;e+=3)b(d[e],d[e+1],d[e+2]);else for(e=
0;e<g.length/3;e+=3)b(e,e+1,e+2);this.computeFaceNormals();null!==a.boundingBox&&(this.boundingBox=a.boundingBox.clone());null!==a.boundingSphere&&(this.boundingSphere=a.boundingSphere.clone());return this},center:function(){this.computeBoundingBox();var a=this.boundingBox.center().negate();this.translate(a.x,a.y,a.z);return a},normalize:function(){this.computeBoundingSphere();var a=this.boundingSphere.center,b=this.boundingSphere.radius,b=0===b?1:1/b,c=new THREE.Matrix4;c.set(b,0,0,-b*a.x,0,b,0,
-b*a.y,0,0,b,-b*a.z,0,0,0,1);this.applyMatrix(c);return this},computeFaceNormals:function(){for(var a=new THREE.Vector3,b=new THREE.Vector3,c=0,d=this.faces.length;c<d;c++){var e=this.faces[c],g=this.vertices[e.a],f=this.vertices[e.b];a.subVectors(this.vertices[e.c],f);b.subVectors(g,f);a.cross(b);a.normalize();e.normal.copy(a)}},computeVertexNormals:function(a){var b,c,d;d=Array(this.vertices.length);b=0;for(c=this.vertices.length;b<c;b++)d[b]=new THREE.Vector3;if(a){var e,g,f,h=new THREE.Vector3,
l=new THREE.Vector3;a=0;for(b=this.faces.length;a<b;a++)c=this.faces[a],e=this.vertices[c.a],g=this.vertices[c.b],f=this.vertices[c.c],h.subVectors(f,g),l.subVectors(e,g),h.cross(l),d[c.a].add(h),d[c.b].add(h),d[c.c].add(h)}else for(a=0,b=this.faces.length;a<b;a++)c=this.faces[a],d[c.a].add(c.normal),d[c.b].add(c.normal),d[c.c].add(c.normal);b=0;for(c=this.vertices.length;b<c;b++)d[b].normalize();a=0;for(b=this.faces.length;a<b;a++)c=this.faces[a],e=c.vertexNormals,3===e.length?(e[0].copy(d[c.a]),
e[1].copy(d[c.b]),e[2].copy(d[c.c])):(e[0]=d[c.a].clone(),e[1]=d[c.b].clone(),e[2]=d[c.c].clone())},computeMorphNormals:function(){var a,b,c,d,e;c=0;for(d=this.faces.length;c<d;c++)for(e=this.faces[c],e.__originalFaceNormal?e.__originalFaceNormal.copy(e.normal):e.__originalFaceNormal=e.normal.clone(),e.__originalVertexNormals||(e.__originalVertexNormals=[]),a=0,b=e.vertexNormals.length;a<b;a++)e.__originalVertexNormals[a]?e.__originalVertexNormals[a].copy(e.vertexNormals[a]):e.__originalVertexNormals[a]=
e.vertexNormals[a].clone();var g=new THREE.Geometry;g.faces=this.faces;a=0;for(b=this.morphTargets.length;a<b;a++){if(!this.morphNormals[a]){this.morphNormals[a]={};this.morphNormals[a].faceNormals=[];this.morphNormals[a].vertexNormals=[];e=this.morphNormals[a].faceNormals;var f=this.morphNormals[a].vertexNormals,h,l;c=0;for(d=this.faces.length;c<d;c++)h=new THREE.Vector3,l={a:new THREE.Vector3,b:new THREE.Vector3,c:new THREE.Vector3},e.push(h),f.push(l)}f=this.morphNormals[a];g.vertices=this.morphTargets[a].vertices;
g.computeFaceNormals();g.computeVertexNormals();c=0;for(d=this.faces.length;c<d;c++)e=this.faces[c],h=f.faceNormals[c],l=f.vertexNormals[c],h.copy(e.normal),l.a.copy(e.vertexNormals[0]),l.b.copy(e.vertexNormals[1]),l.c.copy(e.vertexNormals[2])}c=0;for(d=this.faces.length;c<d;c++)e=this.faces[c],e.normal=e.__originalFaceNormal,e.vertexNormals=e.__originalVertexNormals},computeTangents:function(){console.warn("THREE.Geometry: .computeTangents() has been removed.")},computeLineDistances:function(){for(var a=
0,b=this.vertices,c=0,d=b.length;c<d;c++)0<c&&(a+=b[c].distanceTo(b[c-1])),this.lineDistances[c]=a},computeBoundingBox:function(){null===this.boundingBox&&(this.boundingBox=new THREE.Box3);this.boundingBox.setFromPoints(this.vertices)},computeBoundingSphere:function(){null===this.boundingSphere&&(this.boundingSphere=new THREE.Sphere);this.boundingSphere.setFromPoints(this.vertices)},merge:function(a,b,c){if(!1===a instanceof THREE.Geometry)console.error("THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.",
a);else{var d,e=this.vertices.length,g=this.vertices,f=a.vertices,h=this.faces,l=a.faces,k=this.faceVertexUvs[0];a=a.faceVertexUvs[0];void 0===c&&(c=0);void 0!==b&&(d=(new THREE.Matrix3).getNormalMatrix(b));for(var m=0,p=f.length;m<p;m++){var n=f[m].clone();void 0!==b&&n.applyMatrix4(b);g.push(n)}m=0;for(p=l.length;m<p;m++){var f=l[m],q,s=f.vertexNormals,t=f.vertexColors,n=new THREE.Face3(f.a+e,f.b+e,f.c+e);n.normal.copy(f.normal);void 0!==d&&n.normal.applyMatrix3(d).normalize();b=0;for(g=s.length;b<
g;b++)q=s[b].clone(),void 0!==d&&q.applyMatrix3(d).normalize(),n.vertexNormals.push(q);n.color.copy(f.color);b=0;for(g=t.length;b<g;b++)q=t[b],n.vertexColors.push(q.clone());n.materialIndex=f.materialIndex+c;h.push(n)}m=0;for(p=a.length;m<p;m++)if(c=a[m],d=[],void 0!==c){b=0;for(g=c.length;b<g;b++)d.push(c[b].clone());k.push(d)}}},mergeMesh:function(a){!1===a instanceof THREE.Mesh?console.error("THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.",a):(a.matrixAutoUpdate&&a.updateMatrix(),
this.merge(a.geometry,a.matrix))},mergeVertices:function(){var a={},b=[],c=[],d,e=Math.pow(10,4),g,f;g=0;for(f=this.vertices.length;g<f;g++)d=this.vertices[g],d=Math.round(d.x*e)+"_"+Math.round(d.y*e)+"_"+Math.round(d.z*e),void 0===a[d]?(a[d]=g,b.push(this.vertices[g]),c[g]=b.length-1):c[g]=c[a[d]];a=[];g=0;for(f=this.faces.length;g<f;g++)for(e=this.faces[g],e.a=c[e.a],e.b=c[e.b],e.c=c[e.c],e=[e.a,e.b,e.c],d=0;3>d;d++)if(e[d]===e[(d+1)%3]){a.push(g);break}for(g=a.length-1;0<=g;g--)for(e=a[g],this.faces.splice(e,
1),c=0,f=this.faceVertexUvs.length;c<f;c++)this.faceVertexUvs[c].splice(e,1);g=this.vertices.length-b.length;this.vertices=b;return g},sortFacesByMaterialIndex:function(){for(var a=this.faces,b=a.length,c=0;c<b;c++)a[c]._id=c;a.sort(function(a,b){return a.materialIndex-b.materialIndex});var d=this.faceVertexUvs[0],e=this.faceVertexUvs[1],g,f;d&&d.length===b&&(g=[]);e&&e.length===b&&(f=[]);for(c=0;c<b;c++){var h=a[c]._id;g&&g.push(d[h]);f&&f.push(e[h])}g&&(this.faceVertexUvs[0]=g);f&&(this.faceVertexUvs[1]=
f)},toJSON:function(){function a(a,b,c){return c?a|1<<b:a&~(1<<b)}function b(a){var b=a.x.toString()+a.y.toString()+a.z.toString();if(void 0!==k[b])return k[b];k[b]=l.length/3;l.push(a.x,a.y,a.z);return k[b]}function c(a){var b=a.r.toString()+a.g.toString()+a.b.toString();if(void 0!==p[b])return p[b];p[b]=m.length;m.push(a.getHex());return p[b]}function d(a){var b=a.x.toString()+a.y.toString();if(void 0!==q[b])return q[b];q[b]=n.length/2;n.push(a.x,a.y);return q[b]}var e={metadata:{version:4.4,type:"Geometry",
generator:"Geometry.toJSON"}};e.uuid=this.uuid;e.type=this.type;""!==this.name&&(e.name=this.name);if(void 0!==this.parameters){var g=this.parameters,f;for(f in g)void 0!==g[f]&&(e[f]=g[f]);return e}g=[];for(f=0;f<this.vertices.length;f++){var h=this.vertices[f];g.push(h.x,h.y,h.z)}var h=[],l=[],k={},m=[],p={},n=[],q={};for(f=0;f<this.faces.length;f++){var s=this.faces[f],t=void 0!==this.faceVertexUvs[0][f],v=0<s.normal.length(),u=0<s.vertexNormals.length,w=1!==s.color.r||1!==s.color.g||1!==s.color.b,
D=0<s.vertexColors.length,x=0,x=a(x,0,0),x=a(x,1,!1),x=a(x,2,!1),x=a(x,3,t),x=a(x,4,v),x=a(x,5,u),x=a(x,6,w),x=a(x,7,D);h.push(x);h.push(s.a,s.b,s.c);t&&(t=this.faceVertexUvs[0][f],h.push(d(t[0]),d(t[1]),d(t[2])));v&&h.push(b(s.normal));u&&(v=s.vertexNormals,h.push(b(v[0]),b(v[1]),b(v[2])));w&&h.push(c(s.color));D&&(s=s.vertexColors,h.push(c(s[0]),c(s[1]),c(s[2])))}e.data={};e.data.vertices=g;e.data.normals=l;0<m.length&&(e.data.colors=m);0<n.length&&(e.data.uvs=[n]);e.data.faces=h;return e},clone:function(){return(new this.constructor).copy(this)},
copy:function(a){this.vertices=[];this.faces=[];this.faceVertexUvs=[[]];for(var b=a.vertices,c=0,d=b.length;c<d;c++)this.vertices.push(b[c].clone());b=a.faces;c=0;for(d=b.length;c<d;c++)this.faces.push(b[c].clone());c=0;for(d=a.faceVertexUvs.length;c<d;c++){b=a.faceVertexUvs[c];void 0===this.faceVertexUvs[c]&&(this.faceVertexUvs[c]=[]);for(var e=0,g=b.length;e<g;e++){for(var f=b[e],h=[],l=0,k=f.length;l<k;l++)h.push(f[l].clone());this.faceVertexUvs[c].push(h)}}return this},dispose:function(){this.dispatchEvent({type:"dispose"})}};
THREE.EventDispatcher.prototype.apply(THREE.Geometry.prototype);THREE.GeometryIdCount=0;
THREE.DirectGeometry=function(){Object.defineProperty(this,"id",{value:THREE.GeometryIdCount++});this.uuid=THREE.Math.generateUUID();this.name="";this.type="DirectGeometry";this.indices=[];this.vertices=[];this.normals=[];this.colors=[];this.uvs=[];this.uvs2=[];this.groups=[];this.morphTargets={};this.skinWeights=[];this.skinIndices=[];this.boundingSphere=this.boundingBox=null;this.groupsNeedUpdate=this.uvsNeedUpdate=this.colorsNeedUpdate=this.normalsNeedUpdate=this.verticesNeedUpdate=!1};
THREE.DirectGeometry.prototype={constructor:THREE.DirectGeometry,computeBoundingBox:THREE.Geometry.prototype.computeBoundingBox,computeBoundingSphere:THREE.Geometry.prototype.computeBoundingSphere,computeFaceNormals:function(){console.warn("THREE.DirectGeometry: computeFaceNormals() is not a method of this type of geometry.")},computeVertexNormals:function(){console.warn("THREE.DirectGeometry: computeVertexNormals() is not a method of this type of geometry.")},computeGroups:function(a){var b,c=[],
d;a=a.faces;for(var e=0;e<a.length;e++){var g=a[e];g.materialIndex!==d&&(d=g.materialIndex,void 0!==b&&(b.count=3*e-b.start,c.push(b)),b={start:3*e,materialIndex:d})}void 0!==b&&(b.count=3*e-b.start,c.push(b));this.groups=c},fromGeometry:function(a){var b=a.faces,c=a.vertices,d=a.faceVertexUvs,e=d[0]&&0<d[0].length,g=d[1]&&0<d[1].length,f=a.morphTargets,h=f.length;if(0<h){for(var l=[],k=0;k<h;k++)l[k]=[];this.morphTargets.position=l}var m=a.morphNormals,p=m.length;if(0<p){for(var n=[],k=0;k<p;k++)n[k]=
[];this.morphTargets.normal=n}for(var q=a.skinIndices,s=a.skinWeights,t=q.length===c.length,v=s.length===c.length,k=0;k<b.length;k++){var u=b[k];this.vertices.push(c[u.a],c[u.b],c[u.c]);var w=u.vertexNormals;3===w.length?this.normals.push(w[0],w[1],w[2]):(w=u.normal,this.normals.push(w,w,w));w=u.vertexColors;3===w.length?this.colors.push(w[0],w[1],w[2]):(w=u.color,this.colors.push(w,w,w));!0===e&&(w=d[0][k],void 0!==w?this.uvs.push(w[0],w[1],w[2]):(console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ",
k),this.uvs.push(new THREE.Vector2,new THREE.Vector2,new THREE.Vector2)));!0===g&&(w=d[1][k],void 0!==w?this.uvs2.push(w[0],w[1],w[2]):(console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ",k),this.uvs2.push(new THREE.Vector2,new THREE.Vector2,new THREE.Vector2)));for(w=0;w<h;w++){var D=f[w].vertices;l[w].push(D[u.a],D[u.b],D[u.c])}for(w=0;w<p;w++)D=m[w].vertexNormals[k],n[w].push(D.a,D.b,D.c);t&&this.skinIndices.push(q[u.a],q[u.b],q[u.c]);v&&this.skinWeights.push(s[u.a],s[u.b],
s[u.c])}this.computeGroups(a);this.verticesNeedUpdate=a.verticesNeedUpdate;this.normalsNeedUpdate=a.normalsNeedUpdate;this.colorsNeedUpdate=a.colorsNeedUpdate;this.uvsNeedUpdate=a.uvsNeedUpdate;this.groupsNeedUpdate=a.groupsNeedUpdate;return this},dispose:function(){this.dispatchEvent({type:"dispose"})}};THREE.EventDispatcher.prototype.apply(THREE.DirectGeometry.prototype);
THREE.BufferGeometry=function(){Object.defineProperty(this,"id",{value:THREE.GeometryIdCount++});this.uuid=THREE.Math.generateUUID();this.name="";this.type="BufferGeometry";this.index=null;this.attributes={};this.morphAttributes={};this.groups=[];this.boundingSphere=this.boundingBox=null;this.drawRange={start:0,count:Infinity}};
THREE.BufferGeometry.prototype={constructor:THREE.BufferGeometry,addIndex:function(a){console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().");this.setIndex(a)},getIndex:function(){return this.index},setIndex:function(a){this.index=a},addAttribute:function(a,b,c){!1===b instanceof THREE.BufferAttribute&&!1===b instanceof THREE.InterleavedBufferAttribute?(console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute )."),this.addAttribute(a,new THREE.BufferAttribute(b,
c))):"index"===a?(console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute."),this.setIndex(b)):this.attributes[a]=b},getAttribute:function(a){return this.attributes[a]},removeAttribute:function(a){delete this.attributes[a]},get drawcalls(){console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups.");return this.groups},get offsets(){console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups.");return this.groups},addDrawCall:function(a,
b,c){void 0!==c&&console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.");console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup().");this.addGroup(a,b)},clearDrawCalls:function(){console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().");this.clearGroups()},addGroup:function(a,b,c){this.groups.push({start:a,count:b,materialIndex:void 0!==c?c:0})},clearGroups:function(){this.groups=[]},setDrawRange:function(a,b){this.drawRange.start=a;this.drawRange.count=
b},applyMatrix:function(a){var b=this.attributes.position;void 0!==b&&(a.applyToVector3Array(b.array),b.needsUpdate=!0);b=this.attributes.normal;void 0!==b&&((new THREE.Matrix3).getNormalMatrix(a).applyToVector3Array(b.array),b.needsUpdate=!0);null!==this.boundingBox&&this.computeBoundingBox();null!==this.boundingSphere&&this.computeBoundingSphere()},rotateX:function(){var a;return function(b){void 0===a&&(a=new THREE.Matrix4);a.makeRotationX(b);this.applyMatrix(a);return this}}(),rotateY:function(){var a;
return function(b){void 0===a&&(a=new THREE.Matrix4);a.makeRotationY(b);this.applyMatrix(a);return this}}(),rotateZ:function(){var a;return function(b){void 0===a&&(a=new THREE.Matrix4);a.makeRotationZ(b);this.applyMatrix(a);return this}}(),translate:function(){var a;return function(b,c,d){void 0===a&&(a=new THREE.Matrix4);a.makeTranslation(b,c,d);this.applyMatrix(a);return this}}(),scale:function(){var a;return function(b,c,d){void 0===a&&(a=new THREE.Matrix4);a.makeScale(b,c,d);this.applyMatrix(a);
return this}}(),lookAt:function(){var a;return function(b){void 0===a&&(a=new THREE.Object3D);a.lookAt(b);a.updateMatrix();this.applyMatrix(a.matrix)}}(),center:function(){this.computeBoundingBox();var a=this.boundingBox.center().negate();this.translate(a.x,a.y,a.z);return a},setFromObject:function(a){var b=a.geometry;if(a instanceof THREE.Points||a instanceof THREE.Line){a=new THREE.Float32Attribute(3*b.vertices.length,3);var c=new THREE.Float32Attribute(3*b.colors.length,3);this.addAttribute("position",
a.copyVector3sArray(b.vertices));this.addAttribute("color",c.copyColorsArray(b.colors));b.lineDistances&&b.lineDistances.length===b.vertices.length&&(a=new THREE.Float32Attribute(b.lineDistances.length,1),this.addAttribute("lineDistance",a.copyArray(b.lineDistances)));null!==b.boundingSphere&&(this.boundingSphere=b.boundingSphere.clone());null!==b.boundingBox&&(this.boundingBox=b.boundingBox.clone())}else a instanceof THREE.Mesh&&b instanceof THREE.Geometry&&this.fromGeometry(b);return this},updateFromObject:function(a){var b=
a.geometry;if(a instanceof THREE.Mesh){var c=b.__directGeometry;if(void 0===c)return this.fromGeometry(b);c.verticesNeedUpdate=b.verticesNeedUpdate;c.normalsNeedUpdate=b.normalsNeedUpdate;c.colorsNeedUpdate=b.colorsNeedUpdate;c.uvsNeedUpdate=b.uvsNeedUpdate;c.groupsNeedUpdate=b.groupsNeedUpdate;b.verticesNeedUpdate=!1;b.normalsNeedUpdate=!1;b.colorsNeedUpdate=!1;b.uvsNeedUpdate=!1;b.groupsNeedUpdate=!1;b=c}!0===b.verticesNeedUpdate&&(c=this.attributes.position,void 0!==c&&(c.copyVector3sArray(b.vertices),
c.needsUpdate=!0),b.verticesNeedUpdate=!1);!0===b.normalsNeedUpdate&&(c=this.attributes.normal,void 0!==c&&(c.copyVector3sArray(b.normals),c.needsUpdate=!0),b.normalsNeedUpdate=!1);!0===b.colorsNeedUpdate&&(c=this.attributes.color,void 0!==c&&(c.copyColorsArray(b.colors),c.needsUpdate=!0),b.colorsNeedUpdate=!1);b.uvsNeedUpdate&&(c=this.attributes.uv,void 0!==c&&(c.copyVector2sArray(b.uvs),c.needsUpdate=!0),b.uvsNeedUpdate=!1);b.lineDistancesNeedUpdate&&(c=this.attributes.lineDistance,void 0!==c&&
(c.copyArray(b.lineDistances),c.needsUpdate=!0),b.lineDistancesNeedUpdate=!1);b.groupsNeedUpdate&&(b.computeGroups(a.geometry),this.groups=b.groups,b.groupsNeedUpdate=!1);return this},fromGeometry:function(a){a.__directGeometry=(new THREE.DirectGeometry).fromGeometry(a);return this.fromDirectGeometry(a.__directGeometry)},fromDirectGeometry:function(a){var b=new Float32Array(3*a.vertices.length);this.addAttribute("position",(new THREE.BufferAttribute(b,3)).copyVector3sArray(a.vertices));0<a.normals.length&&
(b=new Float32Array(3*a.normals.length),this.addAttribute("normal",(new THREE.BufferAttribute(b,3)).copyVector3sArray(a.normals)));0<a.colors.length&&(b=new Float32Array(3*a.colors.length),this.addAttribute("color",(new THREE.BufferAttribute(b,3)).copyColorsArray(a.colors)));0<a.uvs.length&&(b=new Float32Array(2*a.uvs.length),this.addAttribute("uv",(new THREE.BufferAttribute(b,2)).copyVector2sArray(a.uvs)));0<a.uvs2.length&&(b=new Float32Array(2*a.uvs2.length),this.addAttribute("uv2",(new THREE.BufferAttribute(b,
2)).copyVector2sArray(a.uvs2)));0<a.indices.length&&(b=new (65535<a.vertices.length?Uint32Array:Uint16Array)(3*a.indices.length),this.setIndex((new THREE.BufferAttribute(b,1)).copyIndicesArray(a.indices)));this.groups=a.groups;for(var c in a.morphTargets){for(var b=[],d=a.morphTargets[c],e=0,g=d.length;e<g;e++){var f=d[e],h=new THREE.Float32Attribute(3*f.length,3);b.push(h.copyVector3sArray(f))}this.morphAttributes[c]=b}0<a.skinIndices.length&&(c=new THREE.Float32Attribute(4*a.skinIndices.length,
4),this.addAttribute("skinIndex",c.copyVector4sArray(a.skinIndices)));0<a.skinWeights.length&&(c=new THREE.Float32Attribute(4*a.skinWeights.length,4),this.addAttribute("skinWeight",c.copyVector4sArray(a.skinWeights)));null!==a.boundingSphere&&(this.boundingSphere=a.boundingSphere.clone());null!==a.boundingBox&&(this.boundingBox=a.boundingBox.clone());return this},computeBoundingBox:function(){var a=new THREE.Vector3;return function(){null===this.boundingBox&&(this.boundingBox=new THREE.Box3);var b=
this.attributes.position.array;if(b){var c=this.boundingBox;c.makeEmpty();for(var d=0,e=b.length;d<e;d+=3)a.fromArray(b,d),c.expandByPoint(a)}if(void 0===b||0===b.length)this.boundingBox.min.set(0,0,0),this.boundingBox.max.set(0,0,0);(isNaN(this.boundingBox.min.x)||isNaN(this.boundingBox.min.y)||isNaN(this.boundingBox.min.z))&&console.error('THREE.BufferGeometry.computeBoundingBox: Computed min/max have NaN values. The "position" attribute is likely to have NaN values.',this)}}(),computeBoundingSphere:function(){var a=
new THREE.Box3,b=new THREE.Vector3;return function(){null===this.boundingSphere&&(this.boundingSphere=new THREE.Sphere);var c=this.attributes.position.array;if(c){a.makeEmpty();for(var d=this.boundingSphere.center,e=0,g=c.length;e<g;e+=3)b.fromArray(c,e),a.expandByPoint(b);a.center(d);for(var f=0,e=0,g=c.length;e<g;e+=3)b.fromArray(c,e),f=Math.max(f,d.distanceToSquared(b));this.boundingSphere.radius=Math.sqrt(f);isNaN(this.boundingSphere.radius)&&console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.',
this)}}}(),computeFaceNormals:function(){},computeVertexNormals:function(){var a=this.index,b=this.attributes,c=this.groups;if(b.position){var d=b.position.array;if(void 0===b.normal)this.addAttribute("normal",new THREE.BufferAttribute(new Float32Array(d.length),3));else for(var e=b.normal.array,g=0,f=e.length;g<f;g++)e[g]=0;var e=b.normal.array,h,l,k,m=new THREE.Vector3,p=new THREE.Vector3,n=new THREE.Vector3,q=new THREE.Vector3,s=new THREE.Vector3;if(a){a=a.array;0===c.length&&this.addGroup(0,a.length);
for(var t=0,v=c.length;t<v;++t)for(g=c[t],f=g.start,h=g.count,g=f,f+=h;g<f;g+=3)h=3*a[g+0],l=3*a[g+1],k=3*a[g+2],m.fromArray(d,h),p.fromArray(d,l),n.fromArray(d,k),q.subVectors(n,p),s.subVectors(m,p),q.cross(s),e[h]+=q.x,e[h+1]+=q.y,e[h+2]+=q.z,e[l]+=q.x,e[l+1]+=q.y,e[l+2]+=q.z,e[k]+=q.x,e[k+1]+=q.y,e[k+2]+=q.z}else for(g=0,f=d.length;g<f;g+=9)m.fromArray(d,g),p.fromArray(d,g+3),n.fromArray(d,g+6),q.subVectors(n,p),s.subVectors(m,p),q.cross(s),e[g]=q.x,e[g+1]=q.y,e[g+2]=q.z,e[g+3]=q.x,e[g+4]=q.y,
e[g+5]=q.z,e[g+6]=q.x,e[g+7]=q.y,e[g+8]=q.z;this.normalizeNormals();b.normal.needsUpdate=!0}},computeTangents:function(){console.warn("THREE.BufferGeometry: .computeTangents() has been removed.")},computeOffsets:function(a){console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.")},merge:function(a,b){if(!1===a instanceof THREE.BufferGeometry)console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.",a);else{void 0===b&&(b=0);var c=this.attributes,
d;for(d in c)if(void 0!==a.attributes[d])for(var e=c[d].array,g=a.attributes[d],f=g.array,h=0,g=g.itemSize*b;h<f.length;h++,g++)e[g]=f[h];return this}},normalizeNormals:function(){for(var a=this.attributes.normal.array,b,c,d,e=0,g=a.length;e<g;e+=3)b=a[e],c=a[e+1],d=a[e+2],b=1/Math.sqrt(b*b+c*c+d*d),a[e]*=b,a[e+1]*=b,a[e+2]*=b},toJSON:function(){var a={metadata:{version:4.4,type:"BufferGeometry",generator:"BufferGeometry.toJSON"}};a.uuid=this.uuid;a.type=this.type;""!==this.name&&(a.name=this.name);
if(void 0!==this.parameters){var b=this.parameters,c;for(c in b)void 0!==b[c]&&(a[c]=b[c]);return a}a.data={attributes:{}};var d=this.index;null!==d&&(b=Array.prototype.slice.call(d.array),a.data.index={type:d.array.constructor.name,array:b});d=this.attributes;for(c in d){var e=d[c],b=Array.prototype.slice.call(e.array);a.data.attributes[c]={itemSize:e.itemSize,type:e.array.constructor.name,array:b}}c=this.groups;0<c.length&&(a.data.groups=JSON.parse(JSON.stringify(c)));c=this.boundingSphere;null!==
c&&(a.data.boundingSphere={center:c.center.toArray(),radius:c.radius});return a},clone:function(){return(new this.constructor).copy(this)},copy:function(a){var b=a.index;null!==b&&this.setIndex(b.clone());var b=a.attributes,c;for(c in b)this.addAttribute(c,b[c].clone());a=a.groups;c=0;for(b=a.length;c<b;c++){var d=a[c];this.addGroup(d.start,d.count)}return this},dispose:function(){this.dispatchEvent({type:"dispose"})}};THREE.EventDispatcher.prototype.apply(THREE.BufferGeometry.prototype);
THREE.BufferGeometry.MaxIndex=65535;THREE.InstancedBufferGeometry=function(){THREE.BufferGeometry.call(this);this.type="InstancedBufferGeometry";this.maxInstancedCount=void 0};THREE.InstancedBufferGeometry.prototype=Object.create(THREE.BufferGeometry.prototype);THREE.InstancedBufferGeometry.prototype.constructor=THREE.InstancedBufferGeometry;THREE.InstancedBufferGeometry.prototype.addGroup=function(a,b,c){this.groups.push({start:a,count:b,instances:c})};
THREE.InstancedBufferGeometry.prototype.copy=function(a){var b=a.index;null!==b&&this.setIndex(b.clone());var b=a.attributes,c;for(c in b)this.addAttribute(c,b[c].clone());a=a.groups;c=0;for(b=a.length;c<b;c++){var d=a[c];this.addGroup(d.start,d.count,d.instances)}return this};THREE.EventDispatcher.prototype.apply(THREE.InstancedBufferGeometry.prototype);
THREE.AnimationAction=function(a,b,c,d,e){if(void 0===a)throw Error("clip is null");this.clip=a;this.localRoot=null;this.startTime=b||0;this.timeScale=c||1;this.weight=d||1;this.loop=e||THREE.LoopRepeat;this.loopCount=0;this.enabled=!0;this.actionTime=-this.startTime;this.clipTime=0;this.propertyBindings=[]};
THREE.AnimationAction.prototype={constructor:THREE.AnimationAction,setLocalRoot:function(a){this.localRoot=a;return this},updateTime:function(a){var b=this.clipTime,c=this.loopCount,d=this.clip.duration;this.actionTime+=a;if(this.loop===THREE.LoopOnce)return this.loopCount=0,this.clipTime=Math.min(Math.max(this.actionTime,0),d),this.clipTime!==b&&(this.clipTime===d?this.mixer.dispatchEvent({type:"finished",action:this,direction:1}):0===this.clipTime&&this.mixer.dispatchEvent({type:"finished",action:this,
direction:-1})),this.clipTime;this.loopCount=Math.floor(this.actionTime/d);a=this.actionTime-this.loopCount*d;a%=d;this.loop==THREE.LoopPingPong&&1===Math.abs(this.loopCount%2)&&(a=d-a);this.clipTime=a;this.loopCount!==c&&this.mixer.dispatchEvent({type:"loop",action:this,loopDelta:this.loopCount-this.loopCount});return this.clipTime},syncWith:function(a){this.actionTime=a.actionTime;this.timeScale=a.timeScale;return this},warpToDuration:function(a){this.timeScale=this.clip.duration/a;return this},
init:function(a){this.clipTime=a-this.startTime;return this},update:function(a){this.updateTime(a);return this.clip.getAt(this.clipTime)},getTimeScaleAt:function(a){return this.timeScale.getAt?this.timeScale.getAt(a):this.timeScale},getWeightAt:function(a){return this.weight.getAt?this.weight.getAt(a):this.weight}};
THREE.AnimationClip=function(a,b,c){this.name=a;this.tracks=c;this.duration=void 0!==b?b:-1;if(0>this.duration)for(a=0;a<this.tracks.length;a++)b=this.tracks[a],this.duration=Math.max(b.keys[b.keys.length-1].time);this.trim();this.optimize();this.results=[]};
THREE.AnimationClip.prototype={constructor:THREE.AnimationClip,getAt:function(a){a=Math.max(0,Math.min(a,this.duration));for(var b=0;b<this.tracks.length;b++)this.results[b]=this.tracks[b].getAt(a);return this.results},trim:function(){for(var a=0;a<this.tracks.length;a++)this.tracks[a].trim(0,this.duration);return this},optimize:function(){for(var a=0;a<this.tracks.length;a++)this.tracks[a].optimize();return this}};
THREE.AnimationClip.CreateFromMorphTargetSequence=function(a,b,c){for(var d=b.length,e=[],g=0;g<d;g++){var f=[];f.push({time:(g+d-1)%d,value:0});f.push({time:g,value:1});f.push({time:(g+1)%d,value:0});f.sort(THREE.KeyframeTrack.keyComparer);0===f[0].time&&f.push({time:d,value:f[0].value});e.push((new THREE.NumberKeyframeTrack(".morphTargetInfluences["+b[g].name+"]",f)).scale(1/c))}return new THREE.AnimationClip(a,-1,e)};
THREE.AnimationClip.findByName=function(a,b){for(var c=0;c<a.length;c++)if(a[c].name===b)return a[c];return null};THREE.AnimationClip.CreateClipsFromMorphTargetSequences=function(a,b){for(var c={},d=/^([\w-]*?)([\d]+)$/,e=0,g=a.length;e<g;e++){var f=a[e],h=f.name.match(d);if(h&&1<h.length){var l=h[1];(h=c[l])||(c[l]=h=[]);h.push(f)}}d=[];for(l in c)d.push(THREE.AnimationClip.CreateFromMorphTargetSequence(l,c[l],b));return d};
THREE.AnimationClip.parse=function(a){for(var b=[],c=0;c<a.tracks.length;c++)b.push(THREE.KeyframeTrack.parse(a.tracks[c]).scale(1/a.fps));return new THREE.AnimationClip(a.name,a.duration,b)};
THREE.AnimationClip.parseAnimation=function(a,b,c){if(!a)return console.error("  no animation in JSONLoader data"),null;var d=function(a,b,c,d,e){for(var g=[],f=0;f<b.length;f++){var h=b[f];void 0!==h[c]&&g.push({time:h.time,value:e(h)})}return 0<g.length?new d(a,g):null},e=[],g=a.name||"default",f=a.length||-1,h=a.fps||30;a=a.hierarchy||[];for(var l=0;l<a.length;l++){var k=a[l].keys;if(k&&0!=k.length)if(k[0].morphTargets){for(var f={},m=0;m<k.length;m++)if(k[m].morphTargets)for(var p=0;p<k[m].morphTargets.length;p++)f[k[m].morphTargets[p]]=
-1;for(var n in f){for(var q=[],p=0;p<k[m].morphTargets.length;p++){var s=k[m];q.push({time:s.time,value:s.morphTarget===n?1:0})}e.push(new THREE.NumberKeyframeTrack(c+".morphTargetInfluence["+n+"]",q))}f=f.length*(h||1)}else m=c+".bones["+b[l].name+"]",(p=d(m+".position",k,"pos",THREE.VectorKeyframeTrack,function(a){return(new THREE.Vector3).fromArray(a.pos)}))&&e.push(p),(p=d(m+".quaternion",k,"rot",THREE.QuaternionKeyframeTrack,function(a){return a.rot.slerp?a.rot.clone():(new THREE.Quaternion).fromArray(a.rot)}))&&
e.push(p),(k=d(m+".scale",k,"scl",THREE.VectorKeyframeTrack,function(a){return(new THREE.Vector3).fromArray(a.scl)}))&&e.push(k)}return 0===e.length?null:new THREE.AnimationClip(g,f,e)};THREE.AnimationMixer=function(a){this.root=a;this.time=0;this.timeScale=1;this.actions=[];this.propertyBindingMap={}};
THREE.AnimationMixer.prototype={constructor:THREE.AnimationMixer,addAction:function(a){this.actions.push(a);a.init(this.time);a.mixer=this;for(var b=a.clip.tracks,c=a.localRoot||this.root,d=0;d<b.length;d++){var e=b[d],g=c.uuid+"-"+e.name,f=this.propertyBindingMap[g];void 0===f&&(f=new THREE.PropertyBinding(c,e.name),this.propertyBindingMap[g]=f);a.propertyBindings.push(f);f.referenceCount+=1}},removeAllActions:function(){for(var a=0;a<this.actions.length;a++)this.actions[a].mixer=null;for(var b in this.propertyBindingMap)this.propertyBindingMap[b].unbind();
this.actions=[];this.propertyBindingMap={};return this},removeAction:function(a){var b=this.actions.indexOf(a);-1!==b&&(this.actions.splice(b,1),a.mixer=null);b=a.localRoot||this.root;a=a.clip.tracks;for(var c=0;c<a.length;c++){var d=b.uuid+"-"+a[c].name,e=this.propertyBindingMap[d];e.referenceCount-=1;0>=e.referenceCount&&(e.unbind(),delete this.propertyBindingMap[d])}return this},findActionByName:function(a){for(var b=0;b<this.actions.length;b++)if(this.actions[b].name===a)return this.actions[b];
return null},play:function(a,b){a.startTime=this.time;this.addAction(a);return this},fadeOut:function(a,b){var c=[];c.push({time:this.time,value:1});c.push({time:this.time+b,value:0});a.weight=new THREE.NumberKeyframeTrack("weight",c);return this},fadeIn:function(a,b){var c=[];c.push({time:this.time,value:0});c.push({time:this.time+b,value:1});a.weight=new THREE.NumberKeyframeTrack("weight",c);return this},warp:function(a,b,c,d){var e=[];e.push({time:this.time,value:b});e.push({time:this.time+d,value:c});
a.timeScale=new THREE.NumberKeyframeTrack("timeScale",e);return this},crossFade:function(a,b,c,d){this.fadeOut(a,c);this.fadeIn(b,c);if(d){d=a.clip.duration/b.clip.duration;var e=1/d;this.warp(a,1,d,c);this.warp(b,e,1,c)}return this},update:function(a){a*=this.timeScale;this.time+=a;for(var b=0;b<this.actions.length;b++){var c=this.actions[b],d=c.getWeightAt(this.time),e=c.getTimeScaleAt(this.time),e=c.update(a*e);if(!(0>=c.weight)&&c.enabled)for(var g=0;g<e.length;g++)c.propertyBindings[g].accumulate(e[g],
d)}for(var f in this.propertyBindingMap)this.propertyBindingMap[f].apply();return this}};THREE.EventDispatcher.prototype.apply(THREE.AnimationMixer.prototype);
THREE.AnimationUtils={getEqualsFunc:function(a){return a.equals?function(a,c){return a.equals(c)}:function(a,c){return a===c}},clone:function(a){if("object"===typeof a){if(a.clone)return a.clone();console.error("can not figure out how to copy exemplarValue",a)}return a},lerp:function(a,b,c,d){return THREE.AnimationUtils.getLerpFunc(a,d)(a,b,c)},lerp_object:function(a,b,c){return a.lerp(b,c)},slerp_object:function(a,b,c){return a.slerp(b,c)},lerp_number:function(a,b,c){return a*(1-c)+b*c},lerp_boolean:function(a,
b,c){return.5>c?a:b},lerp_boolean_immediate:function(a,b,c){return a},lerp_string:function(a,b,c){return.5>c?a:b},lerp_string_immediate:function(a,b,c){return a},getLerpFunc:function(a,b){if(void 0===a||null===a)throw Error("examplarValue is null");switch(typeof a){case "object":if(a.lerp)return THREE.AnimationUtils.lerp_object;if(a.slerp)return THREE.AnimationUtils.slerp_object;break;case "number":return THREE.AnimationUtils.lerp_number;case "boolean":return b?THREE.AnimationUtils.lerp_boolean:THREE.AnimationUtils.lerp_boolean_immediate;
case "string":return b?THREE.AnimationUtils.lerp_string:THREE.AnimationUtils.lerp_string_immediate}}};THREE.KeyframeTrack=function(a,b){if(void 0===a)throw Error("track name is undefined");if(void 0===b||0===b.length)throw Error("no keys in track named "+a);this.name=a;this.keys=b;this.lastIndex=0;this.validate();this.optimize()};
THREE.KeyframeTrack.prototype={constructor:THREE.KeyframeTrack,getAt:function(a){for(;this.lastIndex<this.keys.length&&a>=this.keys[this.lastIndex].time;)this.lastIndex++;for(;0<this.lastIndex&&a<this.keys[this.lastIndex-1].time;)this.lastIndex--;if(this.lastIndex>=this.keys.length)return this.setResult(this.keys[this.keys.length-1].value),this.result;if(0===this.lastIndex)return this.setResult(this.keys[0].value),this.result;var b=this.keys[this.lastIndex-1];this.setResult(b.value);if(b.constantToNext)return this.result;
var c=this.keys[this.lastIndex];return this.result=this.lerpValues(this.result,c.value,(a-b.time)/(c.time-b.time))},shift:function(a){if(0!==a)for(var b=0;b<this.keys.length;b++)this.keys[b].time+=a;return this},scale:function(a){if(1!==a)for(var b=0;b<this.keys.length;b++)this.keys[b].time*=a;return this},trim:function(a,b){for(var c=0,d=1;d<this.keys.length;d++)this.keys[d]<=a&&c++;for(var e=0,d=this.keys.length-2;0<d;d++)if(this.keys[d]>=b)e++;else break;0<c+e&&(this.keys=this.keys.splice(c,this.keys.length-
e-c));return this},validate:function(){var a=null;if(0===this.keys.length)console.error("  track is empty, no keys",this);else{for(var b=0;b<this.keys.length;b++){var c=this.keys[b];if(!c){console.error("  key is null in track",this,b);return}if("number"!==typeof c.time||isNaN(c.time)){console.error("  key.time is not a valid number",this,b,c);return}if(void 0===c.value||null===c.value){console.error("  key.value is null in track",this,b,c);return}if(a&&a.time>c.time){console.error("  key.time is less than previous key time, out of order keys",
this,b,c,a);return}a=c}return this}},optimize:function(){var a=[],b=this.keys[0];a.push(b);THREE.AnimationUtils.getEqualsFunc(b.value);for(var c=1;c<this.keys.length-1;c++){var d=this.keys[c],e=this.keys[c+1];b.time===d.time||this.compareValues(b.value,d.value)&&this.compareValues(d.value,e.value)||(b.constantToNext=this.compareValues(b.value,d.value),a.push(d),b=d)}a.push(this.keys[this.keys.length-1]);this.keys=a;return this}};THREE.KeyframeTrack.keyComparer=function(a,b){return a.time-b.time};
THREE.KeyframeTrack.parse=function(a){if(void 0===a.type)throw Error("track type undefined, can not parse");return THREE.KeyframeTrack.GetTrackTypeForTypeName(a.type).parse(a)};
THREE.KeyframeTrack.GetTrackTypeForTypeName=function(a){switch(a.toLowerCase()){case "vector":case "vector2":case "vector3":case "vector4":return THREE.VectorKeyframeTrack;case "quaternion":return THREE.QuaternionKeyframeTrack;case "integer":case "scalar":case "double":case "float":case "number":return THREE.NumberKeyframeTrack;case "bool":case "boolean":return THREE.BooleanKeyframeTrack;case "string":return THREE.StringKeyframeTrack}throw Error("Unsupported typeName: "+a);};
THREE.PropertyBinding=function(a,b){this.rootNode=a;this.trackName=b;this.referenceCount=0;this.originalValue=null;var c=THREE.PropertyBinding.parseTrackName(b);this.directoryName=c.directoryName;this.nodeName=c.nodeName;this.objectName=c.objectName;this.objectIndex=c.objectIndex;this.propertyName=c.propertyName;this.propertyIndex=c.propertyIndex;this.node=THREE.PropertyBinding.findNode(a,this.nodeName)||a;this.cumulativeValue=null;this.cumulativeWeight=0};
THREE.PropertyBinding.prototype={constructor:THREE.PropertyBinding,reset:function(){this.cumulativeValue=null;this.cumulativeWeight=0},accumulate:function(a,b){this.isBound||this.bind();0===this.cumulativeWeight?0<b&&(null===this.cumulativeValue&&(this.cumulativeValue=THREE.AnimationUtils.clone(a)),this.cumulativeWeight=b):(this.cumulativeValue=this.lerpValue(this.cumulativeValue,a,b/(this.cumulativeWeight+b)),this.cumulativeWeight+=b)},unbind:function(){this.isBound&&(this.setValue(this.originalValue),
this.triggerDirty=this.equalsValue=this.lerpValue=this.getValue=this.setValue=null,this.isBound=!1)},bind:function(){if(!this.isBound){var a=this.node;if(a){if(this.objectName){if("materials"===this.objectName){if(!a.material){console.error("  can not bind to material as node does not have a material",this);return}if(!a.material.materials){console.error("  can not bind to material.materials as node.material does not have a materials array",this);return}a=a.material.materials}else if("bones"===this.objectName){if(!a.skeleton){console.error("  can not bind to bones as node does not have a skeleton",
this);return}for(var a=a.skeleton.bones,b=0;b<a.length;b++)if(a[b].name===this.objectIndex){this.objectIndex=b;break}}else{if(void 0===a[this.objectName]){console.error("  can not bind to objectName of node, undefined",this);return}a=a[this.objectName]}if(void 0!==this.objectIndex){if(void 0===a[this.objectIndex]){console.error("  trying to bind to objectIndex of objectName, but is undefined:",this,a);return}a=a[this.objectIndex]}}var c=a[this.propertyName];if(c){if(void 0!==this.propertyIndex){if("morphTargetInfluences"===
this.propertyName)for(a.geometry||console.error("  can not bind to morphTargetInfluences becasuse node does not have a geometry",this),a.geometry.morphTargets||console.error("  can not bind to morphTargetInfluences becasuse node does not have a geometry.morphTargets",this),b=0;b<this.node.geometry.morphTargets.length;b++)if(a.geometry.morphTargets[b].name===this.propertyIndex){this.propertyIndex=b;break}this.setValue=function(a){return this.equalsValue(c[this.propertyIndex],a)?!1:(c[this.propertyIndex]=
a,!0)};this.getValue=function(){return c[this.propertyIndex]}}else c.copy?(this.setValue=function(a){return this.equalsValue(c,a)?!1:(c.copy(a),!0)},this.getValue=function(){return c}):(this.setValue=function(b){return this.equalsValue(a[this.propertyName],b)?!1:(a[this.propertyName]=b,!0)},this.getValue=function(){return a[this.propertyName]});void 0!==a.needsUpdate?this.triggerDirty=function(){this.node.needsUpdate=!0}:void 0!==a.matrixWorldNeedsUpdate&&(this.triggerDirty=function(){a.matrixWorldNeedsUpdate=
!0});this.originalValue=this.getValue();this.equalsValue=THREE.AnimationUtils.getEqualsFunc(this.originalValue);this.lerpValue=THREE.AnimationUtils.getLerpFunc(this.originalValue,!0);this.isBound=!0}else console.error("  trying to update property for track: "+this.nodeName+"."+this.propertyName+" but it wasn't found.",a)}else console.error("  trying to update node for track: "+this.trackName+" but it wasn't found.")}},apply:function(){this.isBound||this.bind();if(0<this.cumulativeWeight){if(1>this.cumulativeWeight){var a=
1-this.cumulativeWeight;this.cumulativeValue=this.lerpValue(this.cumulativeValue,this.originalValue,a/(this.cumulativeWeight+a))}this.setValue(this.cumulativeValue)&&this.triggerDirty&&this.triggerDirty();this.cumulativeValue=null;this.cumulativeWeight=0}}};
THREE.PropertyBinding.parseTrackName=function(a){var b=/^(([\w]+\/)*)([\w-\d]+)?(\.([\w]+)(\[([\w\d\[\]\_. ]+)\])?)?(\.([\w.]+)(\[([\w\d\[\]\_. ]+)\])?)$/,c=b.exec(a);if(!c)throw Error("cannot parse trackName at all: "+a);c.index===b.lastIndex&&b.lastIndex++;b={directoryName:c[1],nodeName:c[3],objectName:c[5],objectIndex:c[7],propertyName:c[9],propertyIndex:c[11]};if(null===b.propertyName||0===b.propertyName.length)throw Error("can not parse propertyName from trackName: "+a);return b};
THREE.PropertyBinding.findNode=function(a,b){function c(a){for(var c=0;c<a.bones.length;c++){var d=a.bones[c];if(d.name===b)return d}return null}function d(a){for(var c=0;c<a.length;c++){var e=a[c];if(e.name===b||e.uuid===b||(e=d(e.children)))return e}return null}if(!b||""===b||"root"===b||"."===b||-1===b||b===a.name||b===a.uuid)return a;if(a.skeleton){var e=c(a.skeleton);if(e)return e}return a.children&&(e=d(a.children))?e:null};
THREE.VectorKeyframeTrack=function(a,b){THREE.KeyframeTrack.call(this,a,b);this.result=this.keys[0].value.clone()};THREE.VectorKeyframeTrack.prototype=Object.create(THREE.KeyframeTrack.prototype);THREE.VectorKeyframeTrack.prototype.constructor=THREE.VectorKeyframeTrack;THREE.VectorKeyframeTrack.prototype.setResult=function(a){this.result.copy(a)};THREE.VectorKeyframeTrack.prototype.lerpValues=function(a,b,c){return a.lerp(b,c)};THREE.VectorKeyframeTrack.prototype.compareValues=function(a,b){return a.equals(b)};
THREE.VectorKeyframeTrack.prototype.clone=function(){for(var a=[],b=0;b<this.keys.length;b++){var c=this.keys[b];a.push({time:c.time,value:c.value.clone()})}return new THREE.VectorKeyframeTrack(this.name,a)};THREE.VectorKeyframeTrack.parse=function(a){for(var b=THREE["Vector"+a.keys[0].value.length],c=[],d=0;d<a.keys.length;d++){var e=a.keys[d];c.push({value:(new b).fromArray(e.value),time:e.time})}return new THREE.VectorKeyframeTrack(a.name,c)};
THREE.QuaternionKeyframeTrack=function(a,b){THREE.KeyframeTrack.call(this,a,b);this.result=this.keys[0].value.clone()};THREE.QuaternionKeyframeTrack.prototype=Object.create(THREE.KeyframeTrack.prototype);THREE.QuaternionKeyframeTrack.prototype.constructor=THREE.QuaternionKeyframeTrack;THREE.QuaternionKeyframeTrack.prototype.setResult=function(a){this.result.copy(a)};THREE.QuaternionKeyframeTrack.prototype.lerpValues=function(a,b,c){return a.slerp(b,c)};
THREE.QuaternionKeyframeTrack.prototype.compareValues=function(a,b){return a.equals(b)};THREE.QuaternionKeyframeTrack.prototype.multiply=function(a){for(var b=0;b<this.keys.length;b++)this.keys[b].value.multiply(a);return this};THREE.QuaternionKeyframeTrack.prototype.clone=function(){for(var a=[],b=0;b<this.keys.length;b++){var c=this.keys[b];a.push({time:c.time,value:c.value.clone()})}return new THREE.QuaternionKeyframeTrack(this.name,a)};
THREE.QuaternionKeyframeTrack.parse=function(a){for(var b=[],c=0;c<a.keys.length;c++){var d=a.keys[c];b.push({value:(new THREE.Quaternion).fromArray(d.value),time:d.time})}return new THREE.QuaternionKeyframeTrack(a.name,b)};THREE.StringKeyframeTrack=function(a,b){THREE.KeyframeTrack.call(this,a,b);this.result=this.keys[0].value};THREE.StringKeyframeTrack.prototype=Object.create(THREE.KeyframeTrack.prototype);THREE.StringKeyframeTrack.prototype.constructor=THREE.StringKeyframeTrack;
THREE.StringKeyframeTrack.prototype.setResult=function(a){this.result=a};THREE.StringKeyframeTrack.prototype.lerpValues=function(a,b,c){return 1>c?a:b};THREE.StringKeyframeTrack.prototype.compareValues=function(a,b){return a===b};THREE.StringKeyframeTrack.prototype.clone=function(){for(var a=[],b=0;b<this.keys.length;b++){var c=this.keys[b];a.push({time:c.time,value:c.value})}return new THREE.StringKeyframeTrack(this.name,a)};
THREE.StringKeyframeTrack.parse=function(a){return new THREE.StringKeyframeTrack(a.name,a.keys)};THREE.BooleanKeyframeTrack=function(a,b){THREE.KeyframeTrack.call(this,a,b);this.result=this.keys[0].value};THREE.BooleanKeyframeTrack.prototype=Object.create(THREE.KeyframeTrack.prototype);THREE.BooleanKeyframeTrack.prototype.constructor=THREE.BooleanKeyframeTrack;THREE.BooleanKeyframeTrack.prototype.setResult=function(a){this.result=a};
THREE.BooleanKeyframeTrack.prototype.lerpValues=function(a,b,c){return 1>c?a:b};THREE.BooleanKeyframeTrack.prototype.compareValues=function(a,b){return a===b};THREE.BooleanKeyframeTrack.prototype.clone=function(){for(var a=[],b=0;b<this.keys.length;b++){var c=this.keys[b];a.push({time:c.time,value:c.value})}return new THREE.BooleanKeyframeTrack(this.name,a)};THREE.BooleanKeyframeTrack.parse=function(a){return new THREE.BooleanKeyframeTrack(a.name,a.keys)};
THREE.NumberKeyframeTrack=function(a,b){THREE.KeyframeTrack.call(this,a,b);this.result=this.keys[0].value};THREE.NumberKeyframeTrack.prototype=Object.create(THREE.KeyframeTrack.prototype);THREE.NumberKeyframeTrack.prototype.constructor=THREE.NumberKeyframeTrack;THREE.NumberKeyframeTrack.prototype.setResult=function(a){this.result=a};THREE.NumberKeyframeTrack.prototype.lerpValues=function(a,b,c){return a*(1-c)+b*c};THREE.NumberKeyframeTrack.prototype.compareValues=function(a,b){return a===b};
THREE.NumberKeyframeTrack.prototype.clone=function(){for(var a=[],b=0;b<this.keys.length;b++){var c=this.keys[b];a.push({time:c.time,value:c.value})}return new THREE.NumberKeyframeTrack(this.name,a)};THREE.NumberKeyframeTrack.parse=function(a){return new THREE.NumberKeyframeTrack(a.name,a.keys)};THREE.Camera=function(){THREE.Object3D.call(this);this.type="Camera";this.matrixWorldInverse=new THREE.Matrix4;this.projectionMatrix=new THREE.Matrix4};THREE.Camera.prototype=Object.create(THREE.Object3D.prototype);
THREE.Camera.prototype.constructor=THREE.Camera;THREE.Camera.prototype.getWorldDirection=function(){var a=new THREE.Quaternion;return function(b){b=b||new THREE.Vector3;this.getWorldQuaternion(a);return b.set(0,0,-1).applyQuaternion(a)}}();THREE.Camera.prototype.lookAt=function(){var a=new THREE.Matrix4;return function(b){a.lookAt(this.position,b,this.up);this.quaternion.setFromRotationMatrix(a)}}();THREE.Camera.prototype.clone=function(){return(new this.constructor).copy(this)};
THREE.Camera.prototype.copy=function(a){THREE.Object3D.prototype.copy.call(this,a);this.matrixWorldInverse.copy(a.matrixWorldInverse);this.projectionMatrix.copy(a.projectionMatrix);return this};
THREE.CubeCamera=function(a,b,c){THREE.Object3D.call(this);this.type="CubeCamera";var d=new THREE.PerspectiveCamera(90,1,a,b);d.up.set(0,-1,0);d.lookAt(new THREE.Vector3(1,0,0));this.add(d);var e=new THREE.PerspectiveCamera(90,1,a,b);e.up.set(0,-1,0);e.lookAt(new THREE.Vector3(-1,0,0));this.add(e);var g=new THREE.PerspectiveCamera(90,1,a,b);g.up.set(0,0,1);g.lookAt(new THREE.Vector3(0,1,0));this.add(g);var f=new THREE.PerspectiveCamera(90,1,a,b);f.up.set(0,0,-1);f.lookAt(new THREE.Vector3(0,-1,0));
this.add(f);var h=new THREE.PerspectiveCamera(90,1,a,b);h.up.set(0,-1,0);h.lookAt(new THREE.Vector3(0,0,1));this.add(h);var l=new THREE.PerspectiveCamera(90,1,a,b);l.up.set(0,-1,0);l.lookAt(new THREE.Vector3(0,0,-1));this.add(l);this.renderTarget=new THREE.WebGLRenderTargetCube(c,c,{format:THREE.RGBFormat,magFilter:THREE.LinearFilter,minFilter:THREE.LinearFilter});this.updateCubeMap=function(a,b){null===this.parent&&this.updateMatrixWorld();var c=this.renderTarget,n=c.texture.generateMipmaps;c.texture.generateMipmaps=
!1;c.activeCubeFace=0;a.render(b,d,c);c.activeCubeFace=1;a.render(b,e,c);c.activeCubeFace=2;a.render(b,g,c);c.activeCubeFace=3;a.render(b,f,c);c.activeCubeFace=4;a.render(b,h,c);c.texture.generateMipmaps=n;c.activeCubeFace=5;a.render(b,l,c);a.setRenderTarget(null)}};THREE.CubeCamera.prototype=Object.create(THREE.Object3D.prototype);THREE.CubeCamera.prototype.constructor=THREE.CubeCamera;
THREE.OrthographicCamera=function(a,b,c,d,e,g){THREE.Camera.call(this);this.type="OrthographicCamera";this.zoom=1;this.left=a;this.right=b;this.top=c;this.bottom=d;this.near=void 0!==e?e:.1;this.far=void 0!==g?g:2E3;this.updateProjectionMatrix()};THREE.OrthographicCamera.prototype=Object.create(THREE.Camera.prototype);THREE.OrthographicCamera.prototype.constructor=THREE.OrthographicCamera;
THREE.OrthographicCamera.prototype.updateProjectionMatrix=function(){var a=(this.right-this.left)/(2*this.zoom),b=(this.top-this.bottom)/(2*this.zoom),c=(this.right+this.left)/2,d=(this.top+this.bottom)/2;this.projectionMatrix.makeOrthographic(c-a,c+a,d+b,d-b,this.near,this.far)};THREE.OrthographicCamera.prototype.copy=function(a){THREE.Camera.prototype.copy.call(this,a);this.left=a.left;this.right=a.right;this.top=a.top;this.bottom=a.bottom;this.near=a.near;this.far=a.far;this.zoom=a.zoom;return this};
THREE.OrthographicCamera.prototype.toJSON=function(a){a=THREE.Object3D.prototype.toJSON.call(this,a);a.object.zoom=this.zoom;a.object.left=this.left;a.object.right=this.right;a.object.top=this.top;a.object.bottom=this.bottom;a.object.near=this.near;a.object.far=this.far;return a};THREE.PerspectiveCamera=function(a,b,c,d){THREE.Camera.call(this);this.type="PerspectiveCamera";this.zoom=1;this.fov=void 0!==a?a:50;this.aspect=void 0!==b?b:1;this.near=void 0!==c?c:.1;this.far=void 0!==d?d:2E3;this.updateProjectionMatrix()};
THREE.PerspectiveCamera.prototype=Object.create(THREE.Camera.prototype);THREE.PerspectiveCamera.prototype.constructor=THREE.PerspectiveCamera;THREE.PerspectiveCamera.prototype.setLens=function(a,b){void 0===b&&(b=24);this.fov=2*THREE.Math.radToDeg(Math.atan(b/(2*a)));this.updateProjectionMatrix()};THREE.PerspectiveCamera.prototype.setViewOffset=function(a,b,c,d,e,g){this.fullWidth=a;this.fullHeight=b;this.x=c;this.y=d;this.width=e;this.height=g;this.updateProjectionMatrix()};
THREE.PerspectiveCamera.prototype.updateProjectionMatrix=function(){var a=THREE.Math.radToDeg(2*Math.atan(Math.tan(.5*THREE.Math.degToRad(this.fov))/this.zoom));if(this.fullWidth){var b=this.fullWidth/this.fullHeight,a=Math.tan(THREE.Math.degToRad(.5*a))*this.near,c=-a,d=b*c,b=Math.abs(b*a-d),c=Math.abs(a-c);this.projectionMatrix.makeFrustum(d+this.x*b/this.fullWidth,d+(this.x+this.width)*b/this.fullWidth,a-(this.y+this.height)*c/this.fullHeight,a-this.y*c/this.fullHeight,this.near,this.far)}else this.projectionMatrix.makePerspective(a,
this.aspect,this.near,this.far)};THREE.PerspectiveCamera.prototype.copy=function(a){THREE.Camera.prototype.copy.call(this,a);this.fov=a.fov;this.aspect=a.aspect;this.near=a.near;this.far=a.far;this.zoom=a.zoom;return this};THREE.PerspectiveCamera.prototype.toJSON=function(a){a=THREE.Object3D.prototype.toJSON.call(this,a);a.object.zoom=this.zoom;a.object.fov=this.fov;a.object.aspect=this.aspect;a.object.near=this.near;a.object.far=this.far;return a};
THREE.Light=function(a){THREE.Object3D.call(this);this.type="Light";this.color=new THREE.Color(a);this.receiveShadow=void 0};THREE.Light.prototype=Object.create(THREE.Object3D.prototype);THREE.Light.prototype.constructor=THREE.Light;
Object.defineProperties(THREE.Light.prototype,{onlyShadow:{set:function(a){console.warn("THREE.Light: .onlyShadow has been removed.")}},shadowCameraFov:{set:function(a){this.shadow.camera.fov=a}},shadowCameraLeft:{set:function(a){this.shadow.camera.left=a}},shadowCameraRight:{set:function(a){this.shadow.camera.right=a}},shadowCameraTop:{set:function(a){this.shadow.camera.top=a}},shadowCameraBottom:{set:function(a){this.shadow.camera.bottom=a}},shadowCameraNear:{set:function(a){this.shadow.camera.near=
a}},shadowCameraFar:{set:function(a){this.shadow.camera.far=a}},shadowCameraVisible:{set:function(a){console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow ) instead.")}},shadowBias:{set:function(a){this.shadow.bias=a}},shadowDarkness:{set:function(a){this.shadow.darkness=a}},shadowMapWidth:{set:function(a){this.shadow.mapSize.width=a}},shadowMapHeight:{set:function(a){this.shadow.mapSize.height=a}}});
THREE.Light.prototype.copy=function(a){THREE.Object3D.prototype.copy.call(this,a);this.color.copy(a.color);return this};
THREE.Light.prototype.toJSON=function(a){a=THREE.Object3D.prototype.toJSON.call(this,a);a.object.color=this.color.getHex();void 0!==this.groundColor&&(a.object.groundColor=this.groundColor.getHex());void 0!==this.intensity&&(a.object.intensity=this.intensity);void 0!==this.distance&&(a.object.distance=this.distance);void 0!==this.angle&&(a.object.angle=this.angle);void 0!==this.decay&&(a.object.decay=this.decay);void 0!==this.exponent&&(a.object.exponent=this.exponent);return a};
THREE.LightShadow=function(a){this.camera=a;this.bias=0;this.darkness=1;this.mapSize=new THREE.Vector2(512,512);this.matrix=this.map=null};THREE.LightShadow.prototype={constructor:THREE.LightShadow,copy:function(a){this.camera=a.camera.clone();this.bias=a.bias;this.darkness=a.darkness;this.mapSize.copy(a.mapSize)},clone:function(){return(new this.constructor).copy(this)}};THREE.AmbientLight=function(a){THREE.Light.call(this,a);this.type="AmbientLight";this.castShadow=void 0};
THREE.AmbientLight.prototype=Object.create(THREE.Light.prototype);THREE.AmbientLight.prototype.constructor=THREE.AmbientLight;THREE.DirectionalLight=function(a,b){THREE.Light.call(this,a);this.type="DirectionalLight";this.position.set(0,1,0);this.updateMatrix();this.target=new THREE.Object3D;this.intensity=void 0!==b?b:1;this.shadow=new THREE.LightShadow(new THREE.OrthographicCamera(-500,500,500,-500,50,5E3))};THREE.DirectionalLight.prototype=Object.create(THREE.Light.prototype);
THREE.DirectionalLight.prototype.constructor=THREE.DirectionalLight;THREE.DirectionalLight.prototype.copy=function(a){THREE.Light.prototype.copy.call(this,a);this.intensity=a.intensity;this.target=a.target.clone();this.shadow=a.shadow.clone();return this};THREE.HemisphereLight=function(a,b,c){THREE.Light.call(this,a);this.type="HemisphereLight";this.castShadow=void 0;this.position.set(0,1,0);this.updateMatrix();this.groundColor=new THREE.Color(b);this.intensity=void 0!==c?c:1};
THREE.HemisphereLight.prototype=Object.create(THREE.Light.prototype);THREE.HemisphereLight.prototype.constructor=THREE.HemisphereLight;THREE.HemisphereLight.prototype.copy=function(a){THREE.Light.prototype.copy.call(this,a);this.groundColor.copy(a.groundColor);this.intensity=a.intensity;return this};
THREE.PointLight=function(a,b,c,d){THREE.Light.call(this,a);this.type="PointLight";this.intensity=void 0!==b?b:1;this.distance=void 0!==c?c:0;this.decay=void 0!==d?d:1;this.shadow=new THREE.LightShadow(new THREE.PerspectiveCamera(90,1,1,500))};THREE.PointLight.prototype=Object.create(THREE.Light.prototype);THREE.PointLight.prototype.constructor=THREE.PointLight;
THREE.PointLight.prototype.copy=function(a){THREE.Light.prototype.copy.call(this,a);this.intensity=a.intensity;this.distance=a.distance;this.decay=a.decay;this.shadow=a.shadow.clone();return this};
THREE.SpotLight=function(a,b,c,d,e,g){THREE.Light.call(this,a);this.type="SpotLight";this.position.set(0,1,0);this.updateMatrix();this.target=new THREE.Object3D;this.intensity=void 0!==b?b:1;this.distance=void 0!==c?c:0;this.angle=void 0!==d?d:Math.PI/3;this.exponent=void 0!==e?e:10;this.decay=void 0!==g?g:1;this.shadow=new THREE.LightShadow(new THREE.PerspectiveCamera(50,1,50,5E3))};THREE.SpotLight.prototype=Object.create(THREE.Light.prototype);THREE.SpotLight.prototype.constructor=THREE.SpotLight;
THREE.SpotLight.prototype.copy=function(a){THREE.Light.prototype.copy.call(this,a);this.intensity=a.intensity;this.distance=a.distance;this.angle=a.angle;this.exponent=a.exponent;this.decay=a.decay;this.target=a.target.clone();this.shadow=a.shadow.clone();return this};THREE.Cache={enabled:!1,files:{},add:function(a,b){!1!==this.enabled&&(this.files[a]=b)},get:function(a){if(!1!==this.enabled)return this.files[a]},remove:function(a){delete this.files[a]},clear:function(){this.files={}}};
THREE.Loader=function(){this.onLoadStart=function(){};this.onLoadProgress=function(){};this.onLoadComplete=function(){}};
THREE.Loader.prototype={constructor:THREE.Loader,crossOrigin:void 0,extractUrlBase:function(a){a=a.split("/");if(1===a.length)return"./";a.pop();return a.join("/")+"/"},initMaterials:function(a,b,c){for(var d=[],e=0;e<a.length;++e)d[e]=this.createMaterial(a[e],b,c);return d},createMaterial:function(){var a,b,c;return function(d,e,g){function f(a,c,d,f,l){a=e+a;var k=THREE.Loader.Handlers.get(a);null!==k?a=k.load(a):(b.setCrossOrigin(g),a=b.load(a));void 0!==c&&(a.repeat.fromArray(c),1!==c[0]&&(a.wrapS=
THREE.RepeatWrapping),1!==c[1]&&(a.wrapT=THREE.RepeatWrapping));void 0!==d&&a.offset.fromArray(d);void 0!==f&&("repeat"===f[0]&&(a.wrapS=THREE.RepeatWrapping),"mirror"===f[0]&&(a.wrapS=THREE.MirroredRepeatWrapping),"repeat"===f[1]&&(a.wrapT=THREE.RepeatWrapping),"mirror"===f[1]&&(a.wrapT=THREE.MirroredRepeatWrapping));void 0!==l&&(a.anisotropy=l);c=THREE.Math.generateUUID();h[c]=a;return c}void 0===a&&(a=new THREE.Color);void 0===b&&(b=new THREE.TextureLoader);void 0===c&&(c=new THREE.MaterialLoader);
var h={},l={uuid:THREE.Math.generateUUID(),type:"MeshLambertMaterial"},k;for(k in d){var m=d[k];switch(k){case "DbgColor":l.color=m;break;case "DbgIndex":case "opticalDensity":case "illumination":break;case "DbgName":l.name=m;break;case "blending":l.blending=THREE[m];break;case "colorDiffuse":l.color=a.fromArray(m).getHex();break;case "colorSpecular":l.specular=a.fromArray(m).getHex();break;case "colorEmissive":l.emissive=a.fromArray(m).getHex();break;case "specularCoef":l.shininess=m;break;case "shading":"basic"===
m.toLowerCase()&&(l.type="MeshBasicMaterial");"phong"===m.toLowerCase()&&(l.type="MeshPhongMaterial");break;case "mapDiffuse":l.map=f(m,d.mapDiffuseRepeat,d.mapDiffuseOffset,d.mapDiffuseWrap,d.mapDiffuseAnisotropy);break;case "mapDiffuseRepeat":case "mapDiffuseOffset":case "mapDiffuseWrap":case "mapDiffuseAnisotropy":break;case "mapLight":l.lightMap=f(m,d.mapLightRepeat,d.mapLightOffset,d.mapLightWrap,d.mapLightAnisotropy);break;case "mapLightRepeat":case "mapLightOffset":case "mapLightWrap":case "mapLightAnisotropy":break;
case "mapAO":l.aoMap=f(m,d.mapAORepeat,d.mapAOOffset,d.mapAOWrap,d.mapAOAnisotropy);break;case "mapAORepeat":case "mapAOOffset":case "mapAOWrap":case "mapAOAnisotropy":break;case "mapBump":l.bumpMap=f(m,d.mapBumpRepeat,d.mapBumpOffset,d.mapBumpWrap,d.mapBumpAnisotropy);break;case "mapBumpScale":l.bumpScale=m;break;case "mapBumpRepeat":case "mapBumpOffset":case "mapBumpWrap":case "mapBumpAnisotropy":break;case "mapNormal":l.normalMap=f(m,d.mapNormalRepeat,d.mapNormalOffset,d.mapNormalWrap,d.mapNormalAnisotropy);
break;case "mapNormalFactor":l.normalScale=[m,m];break;case "mapNormalRepeat":case "mapNormalOffset":case "mapNormalWrap":case "mapNormalAnisotropy":break;case "mapSpecular":l.specularMap=f(m,d.mapSpecularRepeat,d.mapSpecularOffset,d.mapSpecularWrap,d.mapSpecularAnisotropy);break;case "mapSpecularRepeat":case "mapSpecularOffset":case "mapSpecularWrap":case "mapSpecularAnisotropy":break;case "mapAlpha":l.alphaMap=f(m,d.mapAlphaRepeat,d.mapAlphaOffset,d.mapAlphaWrap,d.mapAlphaAnisotropy);break;case "mapAlphaRepeat":case "mapAlphaOffset":case "mapAlphaWrap":case "mapAlphaAnisotropy":break;
case "flipSided":l.side=THREE.BackSide;break;case "doubleSided":l.side=THREE.DoubleSide;break;case "transparency":console.warn("THREE.Loader: transparency has been renamed to opacity");l.opacity=m;break;case "opacity":case "transparent":case "depthTest":case "depthWrite":case "transparent":case "visible":case "wireframe":l[k]=m;break;case "vertexColors":!0===m&&(l.vertexColors=THREE.VertexColors);"face"===m&&(l.vertexColors=THREE.FaceColors);break;default:console.error("Loader.createMaterial: Unsupported",
k,m)}}"MeshPhongMaterial"!==l.type&&delete l.specular;1>l.opacity&&(l.transparent=!0);c.setTextures(h);return c.parse(l)}}()};THREE.Loader.Handlers={handlers:[],add:function(a,b){this.handlers.push(a,b)},get:function(a){for(var b=this.handlers,c=0,d=b.length;c<d;c+=2){var e=b[c+1];if(b[c].test(a))return e}return null}};THREE.XHRLoader=function(a){this.manager=void 0!==a?a:THREE.DefaultLoadingManager};
THREE.XHRLoader.prototype={constructor:THREE.XHRLoader,load:function(a,b,c,d){var e=this,g=THREE.Cache.get(a);if(void 0!==g)return b&&setTimeout(function(){b(g)},0),g;var f=new XMLHttpRequest;f.open("GET",a,!0);f.addEventListener("load",function(c){c=c.target.response;THREE.Cache.add(a,c);b&&b(c);e.manager.itemEnd(a)},!1);void 0!==c&&f.addEventListener("progress",function(a){c(a)},!1);f.addEventListener("error",function(b){d&&d(b);e.manager.itemError(a)},!1);void 0!==this.crossOrigin&&(f.crossOrigin=
this.crossOrigin);void 0!==this.responseType&&(f.responseType=this.responseType);void 0!==this.withCredentials&&(f.withCredentials=this.withCredentials);f.send(null);e.manager.itemStart(a);return f},setResponseType:function(a){this.responseType=a},setCrossOrigin:function(a){this.crossOrigin=a},setWithCredentials:function(a){this.withCredentials=a}};THREE.ImageLoader=function(a){this.manager=void 0!==a?a:THREE.DefaultLoadingManager};
THREE.ImageLoader.prototype={constructor:THREE.ImageLoader,load:function(a,b,c,d){var e=this,g=THREE.Cache.get(a);if(void 0!==g)return e.manager.itemStart(a),b?setTimeout(function(){b(g);e.manager.itemEnd(a)},0):e.manager.itemEnd(a),g;var f=document.createElement("img");f.addEventListener("load",function(c){THREE.Cache.add(a,this);b&&b(this);e.manager.itemEnd(a)},!1);void 0!==c&&f.addEventListener("progress",function(a){c(a)},!1);f.addEventListener("error",function(b){d&&d(b);e.manager.itemError(a)},
!1);void 0!==this.crossOrigin&&(f.crossOrigin=this.crossOrigin);e.manager.itemStart(a);f.src=a;return f},setCrossOrigin:function(a){this.crossOrigin=a}};THREE.JSONLoader=function(a){"boolean"===typeof a&&(console.warn("THREE.JSONLoader: showStatus parameter has been removed from constructor."),a=void 0);this.manager=void 0!==a?a:THREE.DefaultLoadingManager;this.withCredentials=!1};
THREE.JSONLoader.prototype={constructor:THREE.JSONLoader,get statusDomElement(){void 0===this._statusDomElement&&(this._statusDomElement=document.createElement("div"));console.warn("THREE.JSONLoader: .statusDomElement has been removed.");return this._statusDomElement},load:function(a,b,c,d){var e=this,g=this.texturePath&&"string"===typeof this.texturePath?this.texturePath:THREE.Loader.prototype.extractUrlBase(a);c=new THREE.XHRLoader(this.manager);c.setCrossOrigin(this.crossOrigin);c.setWithCredentials(this.withCredentials);
c.load(a,function(c){c=JSON.parse(c);var d=c.metadata;if(void 0!==d){if("object"===d.type){console.error("THREE.JSONLoader: "+a+" should be loaded with THREE.ObjectLoader instead.");return}if("scene"===d.type){console.error("THREE.JSONLoader: "+a+" should be loaded with THREE.SceneLoader instead.");return}}c=e.parse(c,g);b(c.geometry,c.materials)})},setCrossOrigin:function(a){this.crossOrigin=a},setTexturePath:function(a){this.texturePath=a},parse:function(a,b){var c=new THREE.Geometry,d=void 0!==
a.scale?1/a.scale:1;(function(b){var d,f,h,l,k,m,p,n,q,s,t,v,u,w=a.faces;m=a.vertices;var D=a.normals,x=a.colors,B=0;if(void 0!==a.uvs){for(d=0;d<a.uvs.length;d++)a.uvs[d].length&&B++;for(d=0;d<B;d++)c.faceVertexUvs[d]=[]}l=0;for(k=m.length;l<k;)d=new THREE.Vector3,d.x=m[l++]*b,d.y=m[l++]*b,d.z=m[l++]*b,c.vertices.push(d);l=0;for(k=w.length;l<k;)if(b=w[l++],q=b&1,h=b&2,d=b&8,p=b&16,s=b&32,m=b&64,b&=128,q){q=new THREE.Face3;q.a=w[l];q.b=w[l+1];q.c=w[l+3];t=new THREE.Face3;t.a=w[l+1];t.b=w[l+2];t.c=
w[l+3];l+=4;h&&(h=w[l++],q.materialIndex=h,t.materialIndex=h);h=c.faces.length;if(d)for(d=0;d<B;d++)for(v=a.uvs[d],c.faceVertexUvs[d][h]=[],c.faceVertexUvs[d][h+1]=[],f=0;4>f;f++)n=w[l++],u=v[2*n],n=v[2*n+1],u=new THREE.Vector2(u,n),2!==f&&c.faceVertexUvs[d][h].push(u),0!==f&&c.faceVertexUvs[d][h+1].push(u);p&&(p=3*w[l++],q.normal.set(D[p++],D[p++],D[p]),t.normal.copy(q.normal));if(s)for(d=0;4>d;d++)p=3*w[l++],s=new THREE.Vector3(D[p++],D[p++],D[p]),2!==d&&q.vertexNormals.push(s),0!==d&&t.vertexNormals.push(s);
m&&(m=w[l++],m=x[m],q.color.setHex(m),t.color.setHex(m));if(b)for(d=0;4>d;d++)m=w[l++],m=x[m],2!==d&&q.vertexColors.push(new THREE.Color(m)),0!==d&&t.vertexColors.push(new THREE.Color(m));c.faces.push(q);c.faces.push(t)}else{q=new THREE.Face3;q.a=w[l++];q.b=w[l++];q.c=w[l++];h&&(h=w[l++],q.materialIndex=h);h=c.faces.length;if(d)for(d=0;d<B;d++)for(v=a.uvs[d],c.faceVertexUvs[d][h]=[],f=0;3>f;f++)n=w[l++],u=v[2*n],n=v[2*n+1],u=new THREE.Vector2(u,n),c.faceVertexUvs[d][h].push(u);p&&(p=3*w[l++],q.normal.set(D[p++],
D[p++],D[p]));if(s)for(d=0;3>d;d++)p=3*w[l++],s=new THREE.Vector3(D[p++],D[p++],D[p]),q.vertexNormals.push(s);m&&(m=w[l++],q.color.setHex(x[m]));if(b)for(d=0;3>d;d++)m=w[l++],q.vertexColors.push(new THREE.Color(x[m]));c.faces.push(q)}})(d);(function(){var b=void 0!==a.influencesPerVertex?a.influencesPerVertex:2;if(a.skinWeights)for(var d=0,f=a.skinWeights.length;d<f;d+=b)c.skinWeights.push(new THREE.Vector4(a.skinWeights[d],1<b?a.skinWeights[d+1]:0,2<b?a.skinWeights[d+2]:0,3<b?a.skinWeights[d+3]:
0));if(a.skinIndices)for(d=0,f=a.skinIndices.length;d<f;d+=b)c.skinIndices.push(new THREE.Vector4(a.skinIndices[d],1<b?a.skinIndices[d+1]:0,2<b?a.skinIndices[d+2]:0,3<b?a.skinIndices[d+3]:0));c.bones=a.bones;c.bones&&0<c.bones.length&&(c.skinWeights.length!==c.skinIndices.length||c.skinIndices.length!==c.vertices.length)&&console.warn("When skinning, number of vertices ("+c.vertices.length+"), skinIndices ("+c.skinIndices.length+"), and skinWeights ("+c.skinWeights.length+") should match.")})();(function(b){if(void 0!==
a.morphTargets)for(var d=0,f=a.morphTargets.length;d<f;d++){c.morphTargets[d]={};c.morphTargets[d].name=a.morphTargets[d].name;c.morphTargets[d].vertices=[];for(var h=c.morphTargets[d].vertices,l=a.morphTargets[d].vertices,k=0,m=l.length;k<m;k+=3){var p=new THREE.Vector3;p.x=l[k]*b;p.y=l[k+1]*b;p.z=l[k+2]*b;h.push(p)}}if(void 0!==a.morphColors&&0<a.morphColors.length)for(console.warn('THREE.JSONLoader: "morphColors" no longer supported. Using them as face colors.'),b=c.faces,h=a.morphColors[0].colors,
d=0,f=b.length;d<f;d++)b[d].color.fromArray(h,3*d)})(d);(function(){var b=[],d=[];void 0!==a.animation&&d.push(a.animation);void 0!==a.animations&&(a.animations.length?d=d.concat(a.animations):d.push(a.animations));for(var f=0;f<d.length;f++){var h=THREE.AnimationClip.parseAnimation(d[f],c.bones);h&&b.push(h)}c.morphTargets&&(d=THREE.AnimationClip.CreateClipsFromMorphTargetSequences(c.morphTargets,10),b=b.concat(d));0<b.length&&(c.animations=b)})();c.computeFaceNormals();c.computeBoundingSphere();
if(void 0===a.materials||0===a.materials.length)return{geometry:c};d=THREE.Loader.prototype.initMaterials(a.materials,b,this.crossOrigin);return{geometry:c,materials:d}}};
THREE.LoadingManager=function(a,b,c){var d=this,e=!1,g=0,f=0;this.onStart=void 0;this.onLoad=a;this.onProgress=b;this.onError=c;this.itemStart=function(a){f++;if(!1===e&&void 0!==d.onStart)d.onStart(a,g,f);e=!0};this.itemEnd=function(a){g++;if(void 0!==d.onProgress)d.onProgress(a,g,f);if(g===f&&(e=!1,void 0!==d.onLoad))d.onLoad()};this.itemError=function(a){if(void 0!==d.onError)d.onError(a)}};THREE.DefaultLoadingManager=new THREE.LoadingManager;
THREE.BufferGeometryLoader=function(a){this.manager=void 0!==a?a:THREE.DefaultLoadingManager};
THREE.BufferGeometryLoader.prototype={constructor:THREE.BufferGeometryLoader,load:function(a,b,c,d){var e=this,g=new THREE.XHRLoader(e.manager);g.setCrossOrigin(this.crossOrigin);g.load(a,function(a){b(e.parse(JSON.parse(a)))},c,d)},setCrossOrigin:function(a){this.crossOrigin=a},parse:function(a){var b=new THREE.BufferGeometry,c=a.data.index;void 0!==c&&(c=new self[c.type](c.array),b.setIndex(new THREE.BufferAttribute(c,1)));var d=a.data.attributes,e;for(e in d){var g=d[e],c=new self[g.type](g.array);
b.addAttribute(e,new THREE.BufferAttribute(c,g.itemSize))}e=a.data.groups||a.data.drawcalls||a.data.offsets;if(void 0!==e)for(c=0,d=e.length;c!==d;++c)g=e[c],b.addGroup(g.start,g.count);a=a.data.boundingSphere;void 0!==a&&(e=new THREE.Vector3,void 0!==a.center&&e.fromArray(a.center),b.boundingSphere=new THREE.Sphere(e,a.radius));return b}};THREE.MaterialLoader=function(a){this.manager=void 0!==a?a:THREE.DefaultLoadingManager;this.textures={}};
THREE.MaterialLoader.prototype={constructor:THREE.MaterialLoader,load:function(a,b,c,d){var e=this,g=new THREE.XHRLoader(e.manager);g.setCrossOrigin(this.crossOrigin);g.load(a,function(a){b(e.parse(JSON.parse(a)))},c,d)},setCrossOrigin:function(a){this.crossOrigin=a},setTextures:function(a){this.textures=a},getTexture:function(a){var b=this.textures;void 0===b[a]&&console.warn("THREE.MaterialLoader: Undefined texture",a);return b[a]},parse:function(a){var b=new THREE[a.type];b.uuid=a.uuid;void 0!==
a.name&&(b.name=a.name);void 0!==a.color&&b.color.setHex(a.color);void 0!==a.emissive&&b.emissive.setHex(a.emissive);void 0!==a.specular&&b.specular.setHex(a.specular);void 0!==a.shininess&&(b.shininess=a.shininess);void 0!==a.uniforms&&(b.uniforms=a.uniforms);void 0!==a.vertexShader&&(b.vertexShader=a.vertexShader);void 0!==a.fragmentShader&&(b.fragmentShader=a.fragmentShader);void 0!==a.vertexColors&&(b.vertexColors=a.vertexColors);void 0!==a.shading&&(b.shading=a.shading);void 0!==a.blending&&
(b.blending=a.blending);void 0!==a.side&&(b.side=a.side);void 0!==a.opacity&&(b.opacity=a.opacity);void 0!==a.transparent&&(b.transparent=a.transparent);void 0!==a.alphaTest&&(b.alphaTest=a.alphaTest);void 0!==a.depthTest&&(b.depthTest=a.depthTest);void 0!==a.depthWrite&&(b.depthWrite=a.depthWrite);void 0!==a.wireframe&&(b.wireframe=a.wireframe);void 0!==a.wireframeLinewidth&&(b.wireframeLinewidth=a.wireframeLinewidth);void 0!==a.size&&(b.size=a.size);void 0!==a.sizeAttenuation&&(b.sizeAttenuation=
a.sizeAttenuation);void 0!==a.map&&(b.map=this.getTexture(a.map));void 0!==a.alphaMap&&(b.alphaMap=this.getTexture(a.alphaMap),b.transparent=!0);void 0!==a.bumpMap&&(b.bumpMap=this.getTexture(a.bumpMap));void 0!==a.bumpScale&&(b.bumpScale=a.bumpScale);void 0!==a.normalMap&&(b.normalMap=this.getTexture(a.normalMap));a.normalScale&&(b.normalScale=new THREE.Vector2(a.normalScale,a.normalScale));void 0!==a.displacementMap&&(b.displacementMap=this.getTexture(a.displacementMap));void 0!==a.displacementScale&&
(b.displacementScale=a.displacementScale);void 0!==a.displacementBias&&(b.displacementBias=a.displacementBias);void 0!==a.specularMap&&(b.specularMap=this.getTexture(a.specularMap));void 0!==a.envMap&&(b.envMap=this.getTexture(a.envMap),b.combine=THREE.MultiplyOperation);a.reflectivity&&(b.reflectivity=a.reflectivity);void 0!==a.lightMap&&(b.lightMap=this.getTexture(a.lightMap));void 0!==a.lightMapIntensity&&(b.lightMapIntensity=a.lightMapIntensity);void 0!==a.aoMap&&(b.aoMap=this.getTexture(a.aoMap));
void 0!==a.aoMapIntensity&&(b.aoMapIntensity=a.aoMapIntensity);if(void 0!==a.materials)for(var c=0,d=a.materials.length;c<d;c++)b.materials.push(this.parse(a.materials[c]));return b}};THREE.ObjectLoader=function(a){this.manager=void 0!==a?a:THREE.DefaultLoadingManager;this.texturePath=""};
THREE.ObjectLoader.prototype={constructor:THREE.ObjectLoader,load:function(a,b,c,d){""===this.texturePath&&(this.texturePath=a.substring(0,a.lastIndexOf("/")+1));var e=this,g=new THREE.XHRLoader(e.manager);g.setCrossOrigin(this.crossOrigin);g.load(a,function(a){e.parse(JSON.parse(a),b)},c,d)},setTexturePath:function(a){this.texturePath=a},setCrossOrigin:function(a){this.crossOrigin=a},parse:function(a,b){var c=this.parseGeometries(a.geometries),d=this.parseImages(a.images,function(){void 0!==b&&b(e)}),
d=this.parseTextures(a.textures,d),d=this.parseMaterials(a.materials,d),e=this.parseObject(a.object,c,d);a.animations&&(e.animations=this.parseAnimations(a.animations));void 0!==a.images&&0!==a.images.length||void 0===b||b(e);return e},parseGeometries:function(a){var b={};if(void 0!==a)for(var c=new THREE.JSONLoader,d=new THREE.BufferGeometryLoader,e=0,g=a.length;e<g;e++){var f,h=a[e];switch(h.type){case "PlaneGeometry":case "PlaneBufferGeometry":f=new THREE[h.type](h.width,h.height,h.widthSegments,
h.heightSegments);break;case "BoxGeometry":case "CubeGeometry":f=new THREE.BoxGeometry(h.width,h.height,h.depth,h.widthSegments,h.heightSegments,h.depthSegments);break;case "CircleBufferGeometry":f=new THREE.CircleBufferGeometry(h.radius,h.segments,h.thetaStart,h.thetaLength);break;case "CircleGeometry":f=new THREE.CircleGeometry(h.radius,h.segments,h.thetaStart,h.thetaLength);break;case "CylinderGeometry":f=new THREE.CylinderGeometry(h.radiusTop,h.radiusBottom,h.height,h.radialSegments,h.heightSegments,
h.openEnded,h.thetaStart,h.thetaLength);break;case "SphereGeometry":f=new THREE.SphereGeometry(h.radius,h.widthSegments,h.heightSegments,h.phiStart,h.phiLength,h.thetaStart,h.thetaLength);break;case "SphereBufferGeometry":f=new THREE.SphereBufferGeometry(h.radius,h.widthSegments,h.heightSegments,h.phiStart,h.phiLength,h.thetaStart,h.thetaLength);break;case "DodecahedronGeometry":f=new THREE.DodecahedronGeometry(h.radius,h.detail);break;case "IcosahedronGeometry":f=new THREE.IcosahedronGeometry(h.radius,
h.detail);break;case "OctahedronGeometry":f=new THREE.OctahedronGeometry(h.radius,h.detail);break;case "TetrahedronGeometry":f=new THREE.TetrahedronGeometry(h.radius,h.detail);break;case "RingGeometry":f=new THREE.RingGeometry(h.innerRadius,h.outerRadius,h.thetaSegments,h.phiSegments,h.thetaStart,h.thetaLength);break;case "TorusGeometry":f=new THREE.TorusGeometry(h.radius,h.tube,h.radialSegments,h.tubularSegments,h.arc);break;case "TorusKnotGeometry":f=new THREE.TorusKnotGeometry(h.radius,h.tube,
h.radialSegments,h.tubularSegments,h.p,h.q,h.heightScale);break;case "BufferGeometry":f=d.parse(h);break;case "Geometry":f=c.parse(h.data,this.texturePath).geometry;break;default:console.warn('THREE.ObjectLoader: Unsupported geometry type "'+h.type+'"');continue}f.uuid=h.uuid;void 0!==h.name&&(f.name=h.name);b[h.uuid]=f}return b},parseMaterials:function(a,b){var c={};if(void 0!==a){var d=new THREE.MaterialLoader;d.setTextures(b);for(var e=0,g=a.length;e<g;e++){var f=d.parse(a[e]);c[f.uuid]=f}}return c},
parseAnimations:function(a){for(var b=[],c=0;c<a.length;c++){var d=THREE.AnimationClip.parse(a[c]);b.push(d)}return b},parseImages:function(a,b){function c(a){d.manager.itemStart(a);return f.load(a,function(){d.manager.itemEnd(a)})}var d=this,e={};if(void 0!==a&&0<a.length){var g=new THREE.LoadingManager(b),f=new THREE.ImageLoader(g);f.setCrossOrigin(this.crossOrigin);for(var g=0,h=a.length;g<h;g++){var l=a[g],k=/^(\/\/)|([a-z]+:(\/\/)?)/i.test(l.url)?l.url:d.texturePath+l.url;e[l.uuid]=c(k)}}return e},
parseTextures:function(a,b){function c(a){if("number"===typeof a)return a;console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.",a);return THREE[a]}var d={};if(void 0!==a)for(var e=0,g=a.length;e<g;e++){var f=a[e];void 0===f.image&&console.warn('THREE.ObjectLoader: No "image" specified for',f.uuid);void 0===b[f.image]&&console.warn("THREE.ObjectLoader: Undefined image",f.image);var h=new THREE.Texture(b[f.image]);h.needsUpdate=!0;h.uuid=f.uuid;void 0!==f.name&&(h.name=
f.name);void 0!==f.mapping&&(h.mapping=c(f.mapping));void 0!==f.offset&&(h.offset=new THREE.Vector2(f.offset[0],f.offset[1]));void 0!==f.repeat&&(h.repeat=new THREE.Vector2(f.repeat[0],f.repeat[1]));void 0!==f.minFilter&&(h.minFilter=c(f.minFilter));void 0!==f.magFilter&&(h.magFilter=c(f.magFilter));void 0!==f.anisotropy&&(h.anisotropy=f.anisotropy);Array.isArray(f.wrap)&&(h.wrapS=c(f.wrap[0]),h.wrapT=c(f.wrap[1]));d[f.uuid]=h}return d},parseObject:function(){var a=new THREE.Matrix4;return function(b,
c,d){function e(a){void 0===c[a]&&console.warn("THREE.ObjectLoader: Undefined geometry",a);return c[a]}function g(a){if(void 0!==a)return void 0===d[a]&&console.warn("THREE.ObjectLoader: Undefined material",a),d[a]}var f;switch(b.type){case "Scene":f=new THREE.Scene;break;case "PerspectiveCamera":f=new THREE.PerspectiveCamera(b.fov,b.aspect,b.near,b.far);break;case "OrthographicCamera":f=new THREE.OrthographicCamera(b.left,b.right,b.top,b.bottom,b.near,b.far);break;case "AmbientLight":f=new THREE.AmbientLight(b.color);
break;case "DirectionalLight":f=new THREE.DirectionalLight(b.color,b.intensity);break;case "PointLight":f=new THREE.PointLight(b.color,b.intensity,b.distance,b.decay);break;case "SpotLight":f=new THREE.SpotLight(b.color,b.intensity,b.distance,b.angle,b.exponent,b.decay);break;case "HemisphereLight":f=new THREE.HemisphereLight(b.color,b.groundColor,b.intensity);break;case "Mesh":f=new THREE.Mesh(e(b.geometry),g(b.material));break;case "LOD":f=new THREE.LOD;break;case "Line":f=new THREE.Line(e(b.geometry),
g(b.material),b.mode);break;case "PointCloud":case "Points":f=new THREE.Points(e(b.geometry),g(b.material));break;case "Sprite":f=new THREE.Sprite(g(b.material));break;case "Group":f=new THREE.Group;break;default:f=new THREE.Object3D}f.uuid=b.uuid;void 0!==b.name&&(f.name=b.name);void 0!==b.matrix?(a.fromArray(b.matrix),a.decompose(f.position,f.quaternion,f.scale)):(void 0!==b.position&&f.position.fromArray(b.position),void 0!==b.rotation&&f.rotation.fromArray(b.rotation),void 0!==b.scale&&f.scale.fromArray(b.scale));
void 0!==b.castShadow&&(f.castShadow=b.castShadow);void 0!==b.receiveShadow&&(f.receiveShadow=b.receiveShadow);void 0!==b.visible&&(f.visible=b.visible);void 0!==b.userData&&(f.userData=b.userData);if(void 0!==b.children)for(var h in b.children)f.add(this.parseObject(b.children[h],c,d));if("LOD"===b.type){b=b.levels;for(var l=0;l<b.length;l++){var k=b[l];h=f.getObjectByProperty("uuid",k.object);void 0!==h&&f.addLevel(h,k.distance)}}return f}}()};
THREE.TextureLoader=function(a){this.manager=void 0!==a?a:THREE.DefaultLoadingManager};THREE.TextureLoader.prototype={constructor:THREE.TextureLoader,load:function(a,b,c,d){var e=new THREE.Texture,g=new THREE.ImageLoader(this.manager);g.setCrossOrigin(this.crossOrigin);g.load(a,function(a){e.image=a;e.needsUpdate=!0;void 0!==b&&b(e)},c,d);return e},setCrossOrigin:function(a){this.crossOrigin=a}};THREE.CubeTextureLoader=function(a){this.manager=void 0!==a?a:THREE.DefaultLoadingManager};
THREE.CubeTextureLoader.prototype={constructor:THREE.CubeTextureLoader,load:function(a,b,c,d){function e(c){f.load(a[c],function(a){g.images[c]=a;h++;6===h&&(g.needsUpdate=!0,b&&b(g))},void 0,d)}var g=new THREE.CubeTexture([]),f=new THREE.ImageLoader;f.setCrossOrigin(this.crossOrigin);var h=0;for(c=0;c<a.length;++c)e(c);return g},setCrossOrigin:function(a){this.crossOrigin=a}};
THREE.DataTextureLoader=THREE.BinaryTextureLoader=function(a){this.manager=void 0!==a?a:THREE.DefaultLoadingManager;this._parser=null};
THREE.BinaryTextureLoader.prototype={constructor:THREE.BinaryTextureLoader,load:function(a,b,c,d){var e=this,g=new THREE.DataTexture,f=new THREE.XHRLoader(this.manager);f.setCrossOrigin(this.crossOrigin);f.setResponseType("arraybuffer");f.load(a,function(a){if(a=e._parser(a))void 0!==a.image?g.image=a.image:void 0!==a.data&&(g.image.width=a.width,g.image.height=a.height,g.image.data=a.data),g.wrapS=void 0!==a.wrapS?a.wrapS:THREE.ClampToEdgeWrapping,g.wrapT=void 0!==a.wrapT?a.wrapT:THREE.ClampToEdgeWrapping,
g.magFilter=void 0!==a.magFilter?a.magFilter:THREE.LinearFilter,g.minFilter=void 0!==a.minFilter?a.minFilter:THREE.LinearMipMapLinearFilter,g.anisotropy=void 0!==a.anisotropy?a.anisotropy:1,void 0!==a.format&&(g.format=a.format),void 0!==a.type&&(g.type=a.type),void 0!==a.mipmaps&&(g.mipmaps=a.mipmaps),1===a.mipmapCount&&(g.minFilter=THREE.LinearFilter),g.needsUpdate=!0,b&&b(g,a)},c,d);return g},setCrossOrigin:function(a){this.crossOrigin=a}};
THREE.CompressedTextureLoader=function(a){this.manager=void 0!==a?a:THREE.DefaultLoadingManager;this._parser=null};
THREE.CompressedTextureLoader.prototype={constructor:THREE.CompressedTextureLoader,load:function(a,b,c,d){var e=this,g=[],f=new THREE.CompressedTexture;f.image=g;var h=new THREE.XHRLoader(this.manager);h.setCrossOrigin(this.crossOrigin);h.setResponseType("arraybuffer");if(Array.isArray(a))for(var l=0,k=function(k){h.load(a[k],function(a){a=e._parser(a,!0);g[k]={width:a.width,height:a.height,format:a.format,mipmaps:a.mipmaps};l+=1;6===l&&(1===a.mipmapCount&&(f.minFilter=THREE.LinearFilter),f.format=
a.format,f.needsUpdate=!0,b&&b(f))},c,d)},m=0,p=a.length;m<p;++m)k(m);else h.load(a,function(a){a=e._parser(a,!0);if(a.isCubemap)for(var c=a.mipmaps.length/a.mipmapCount,d=0;d<c;d++){g[d]={mipmaps:[]};for(var h=0;h<a.mipmapCount;h++)g[d].mipmaps.push(a.mipmaps[d*a.mipmapCount+h]),g[d].format=a.format,g[d].width=a.width,g[d].height=a.height}else f.image.width=a.width,f.image.height=a.height,f.mipmaps=a.mipmaps;1===a.mipmapCount&&(f.minFilter=THREE.LinearFilter);f.format=a.format;f.needsUpdate=!0;b&&
b(f)},c,d);return f},setCrossOrigin:function(a){this.crossOrigin=a}};
THREE.Material=function(){Object.defineProperty(this,"id",{value:THREE.MaterialIdCount++});this.uuid=THREE.Math.generateUUID();this.name="";this.type="Material";this.side=THREE.FrontSide;this.opacity=1;this.transparent=!1;this.blending=THREE.NormalBlending;this.blendSrc=THREE.SrcAlphaFactor;this.blendDst=THREE.OneMinusSrcAlphaFactor;this.blendEquation=THREE.AddEquation;this.blendEquationAlpha=this.blendDstAlpha=this.blendSrcAlpha=null;this.depthFunc=THREE.LessEqualDepth;this.colorWrite=this.depthWrite=
this.depthTest=!0;this.precision=null;this.polygonOffset=!1;this.overdraw=this.alphaTest=this.polygonOffsetUnits=this.polygonOffsetFactor=0;this._needsUpdate=this.visible=!0};
THREE.Material.prototype={constructor:THREE.Material,get needsUpdate(){return this._needsUpdate},set needsUpdate(a){!0===a&&this.update();this._needsUpdate=a},setValues:function(a){if(void 0!==a)for(var b in a){var c=a[b];if(void 0===c)console.warn("THREE.Material: '"+b+"' parameter is undefined.");else{var d=this[b];void 0===d?console.warn("THREE."+this.type+": '"+b+"' is not a property of this material."):d instanceof THREE.Color?d.set(c):d instanceof THREE.Vector3&&c instanceof THREE.Vector3?d.copy(c):
this[b]="overdraw"===b?Number(c):c}}},toJSON:function(a){var b={metadata:{version:4.4,type:"Material",generator:"Material.toJSON"}};b.uuid=this.uuid;b.type=this.type;""!==this.name&&(b.name=this.name);this.color instanceof THREE.Color&&(b.color=this.color.getHex());this.emissive instanceof THREE.Color&&(b.emissive=this.emissive.getHex());this.specular instanceof THREE.Color&&(b.specular=this.specular.getHex());void 0!==this.shininess&&(b.shininess=this.shininess);this.map instanceof THREE.Texture&&
(b.map=this.map.toJSON(a).uuid);this.alphaMap instanceof THREE.Texture&&(b.alphaMap=this.alphaMap.toJSON(a).uuid);this.lightMap instanceof THREE.Texture&&(b.lightMap=this.lightMap.toJSON(a).uuid);this.bumpMap instanceof THREE.Texture&&(b.bumpMap=this.bumpMap.toJSON(a).uuid,b.bumpScale=this.bumpScale);this.normalMap instanceof THREE.Texture&&(b.normalMap=this.normalMap.toJSON(a).uuid,b.normalScale=this.normalScale);this.displacementMap instanceof THREE.Texture&&(b.displacementMap=this.displacementMap.toJSON(a).uuid,
b.displacementScale=this.displacementScale,b.displacementBias=this.displacementBias);this.specularMap instanceof THREE.Texture&&(b.specularMap=this.specularMap.toJSON(a).uuid);this.envMap instanceof THREE.Texture&&(b.envMap=this.envMap.toJSON(a).uuid,b.reflectivity=this.reflectivity);void 0!==this.size&&(b.size=this.size);void 0!==this.sizeAttenuation&&(b.sizeAttenuation=this.sizeAttenuation);void 0!==this.vertexColors&&this.vertexColors!==THREE.NoColors&&(b.vertexColors=this.vertexColors);void 0!==
this.shading&&this.shading!==THREE.SmoothShading&&(b.shading=this.shading);void 0!==this.blending&&this.blending!==THREE.NormalBlending&&(b.blending=this.blending);void 0!==this.side&&this.side!==THREE.FrontSide&&(b.side=this.side);1>this.opacity&&(b.opacity=this.opacity);!0===this.transparent&&(b.transparent=this.transparent);0<this.alphaTest&&(b.alphaTest=this.alphaTest);!0===this.wireframe&&(b.wireframe=this.wireframe);1<this.wireframeLinewidth&&(b.wireframeLinewidth=this.wireframeLinewidth);return b},
clone:function(){return(new this.constructor).copy(this)},copy:function(a){this.name=a.name;this.side=a.side;this.opacity=a.opacity;this.transparent=a.transparent;this.blending=a.blending;this.blendSrc=a.blendSrc;this.blendDst=a.blendDst;this.blendEquation=a.blendEquation;this.blendSrcAlpha=a.blendSrcAlpha;this.blendDstAlpha=a.blendDstAlpha;this.blendEquationAlpha=a.blendEquationAlpha;this.depthFunc=a.depthFunc;this.depthTest=a.depthTest;this.depthWrite=a.depthWrite;this.precision=a.precision;this.polygonOffset=
a.polygonOffset;this.polygonOffsetFactor=a.polygonOffsetFactor;this.polygonOffsetUnits=a.polygonOffsetUnits;this.alphaTest=a.alphaTest;this.overdraw=a.overdraw;this.visible=a.visible;return this},update:function(){this.dispatchEvent({type:"update"})},dispose:function(){this.dispatchEvent({type:"dispose"})},get wrapAround(){console.warn("THREE."+this.type+": .wrapAround has been removed.")},set wrapAround(a){console.warn("THREE."+this.type+": .wrapAround has been removed.")},get wrapRGB(){console.warn("THREE."+
this.type+": .wrapRGB has been removed.");return new THREE.Color}};THREE.EventDispatcher.prototype.apply(THREE.Material.prototype);THREE.MaterialIdCount=0;THREE.LineBasicMaterial=function(a){THREE.Material.call(this);this.type="LineBasicMaterial";this.color=new THREE.Color(16777215);this.linewidth=1;this.linejoin=this.linecap="round";this.vertexColors=THREE.NoColors;this.fog=!0;this.setValues(a)};THREE.LineBasicMaterial.prototype=Object.create(THREE.Material.prototype);
THREE.LineBasicMaterial.prototype.constructor=THREE.LineBasicMaterial;THREE.LineBasicMaterial.prototype.copy=function(a){THREE.Material.prototype.copy.call(this,a);this.color.copy(a.color);this.linewidth=a.linewidth;this.linecap=a.linecap;this.linejoin=a.linejoin;this.vertexColors=a.vertexColors;this.fog=a.fog;return this};
THREE.LineDashedMaterial=function(a){THREE.Material.call(this);this.type="LineDashedMaterial";this.color=new THREE.Color(16777215);this.scale=this.linewidth=1;this.dashSize=3;this.gapSize=1;this.vertexColors=!1;this.fog=!0;this.setValues(a)};THREE.LineDashedMaterial.prototype=Object.create(THREE.Material.prototype);THREE.LineDashedMaterial.prototype.constructor=THREE.LineDashedMaterial;
THREE.LineDashedMaterial.prototype.copy=function(a){THREE.Material.prototype.copy.call(this,a);this.color.copy(a.color);this.linewidth=a.linewidth;this.scale=a.scale;this.dashSize=a.dashSize;this.gapSize=a.gapSize;this.vertexColors=a.vertexColors;this.fog=a.fog;return this};
THREE.MeshBasicMaterial=function(a){THREE.Material.call(this);this.type="MeshBasicMaterial";this.color=new THREE.Color(16777215);this.aoMap=this.map=null;this.aoMapIntensity=1;this.envMap=this.alphaMap=this.specularMap=null;this.combine=THREE.MultiplyOperation;this.reflectivity=1;this.refractionRatio=.98;this.fog=!0;this.shading=THREE.SmoothShading;this.wireframe=!1;this.wireframeLinewidth=1;this.wireframeLinejoin=this.wireframeLinecap="round";this.vertexColors=THREE.NoColors;this.morphTargets=this.skinning=
!1;this.setValues(a)};THREE.MeshBasicMaterial.prototype=Object.create(THREE.Material.prototype);THREE.MeshBasicMaterial.prototype.constructor=THREE.MeshBasicMaterial;
THREE.MeshBasicMaterial.prototype.copy=function(a){THREE.Material.prototype.copy.call(this,a);this.color.copy(a.color);this.map=a.map;this.aoMap=a.aoMap;this.aoMapIntensity=a.aoMapIntensity;this.specularMap=a.specularMap;this.alphaMap=a.alphaMap;this.envMap=a.envMap;this.combine=a.combine;this.reflectivity=a.reflectivity;this.refractionRatio=a.refractionRatio;this.fog=a.fog;this.shading=a.shading;this.wireframe=a.wireframe;this.wireframeLinewidth=a.wireframeLinewidth;this.wireframeLinecap=a.wireframeLinecap;
this.wireframeLinejoin=a.wireframeLinejoin;this.vertexColors=a.vertexColors;this.skinning=a.skinning;this.morphTargets=a.morphTargets;return this};
THREE.MeshLambertMaterial=function(a){THREE.Material.call(this);this.type="MeshLambertMaterial";this.color=new THREE.Color(16777215);this.emissive=new THREE.Color(0);this.envMap=this.alphaMap=this.specularMap=this.map=null;this.combine=THREE.MultiplyOperation;this.reflectivity=1;this.refractionRatio=.98;this.fog=!0;this.wireframe=!1;this.wireframeLinewidth=1;this.wireframeLinejoin=this.wireframeLinecap="round";this.vertexColors=THREE.NoColors;this.morphNormals=this.morphTargets=this.skinning=!1;this.setValues(a)};
THREE.MeshLambertMaterial.prototype=Object.create(THREE.Material.prototype);THREE.MeshLambertMaterial.prototype.constructor=THREE.MeshLambertMaterial;
THREE.MeshLambertMaterial.prototype.copy=function(a){THREE.Material.prototype.copy.call(this,a);this.color.copy(a.color);this.emissive.copy(a.emissive);this.map=a.map;this.specularMap=a.specularMap;this.alphaMap=a.alphaMap;this.envMap=a.envMap;this.combine=a.combine;this.reflectivity=a.reflectivity;this.refractionRatio=a.refractionRatio;this.fog=a.fog;this.wireframe=a.wireframe;this.wireframeLinewidth=a.wireframeLinewidth;this.wireframeLinecap=a.wireframeLinecap;this.wireframeLinejoin=a.wireframeLinejoin;
this.vertexColors=a.vertexColors;this.skinning=a.skinning;this.morphTargets=a.morphTargets;this.morphNormals=a.morphNormals;return this};
THREE.MeshPhongMaterial=function(a){THREE.Material.call(this);this.type="MeshPhongMaterial";this.color=new THREE.Color(16777215);this.emissive=new THREE.Color(0);this.specular=new THREE.Color(1118481);this.shininess=30;this.metal=!1;this.lightMap=this.map=null;this.lightMapIntensity=1;this.aoMap=null;this.aoMapIntensity=1;this.bumpMap=this.emissiveMap=null;this.bumpScale=1;this.normalMap=null;this.normalScale=new THREE.Vector2(1,1);this.displacementMap=null;this.displacementScale=1;this.displacementBias=
0;this.envMap=this.alphaMap=this.specularMap=null;this.combine=THREE.MultiplyOperation;this.reflectivity=1;this.refractionRatio=.98;this.fog=!0;this.shading=THREE.SmoothShading;this.wireframe=!1;this.wireframeLinewidth=1;this.wireframeLinejoin=this.wireframeLinecap="round";this.vertexColors=THREE.NoColors;this.morphNormals=this.morphTargets=this.skinning=!1;this.setValues(a)};THREE.MeshPhongMaterial.prototype=Object.create(THREE.Material.prototype);THREE.MeshPhongMaterial.prototype.constructor=THREE.MeshPhongMaterial;
THREE.MeshPhongMaterial.prototype.copy=function(a){THREE.Material.prototype.copy.call(this,a);this.color.copy(a.color);this.emissive.copy(a.emissive);this.specular.copy(a.specular);this.shininess=a.shininess;this.metal=a.metal;this.map=a.map;this.lightMap=a.lightMap;this.lightMapIntensity=a.lightMapIntensity;this.aoMap=a.aoMap;this.aoMapIntensity=a.aoMapIntensity;this.emissiveMap=a.emissiveMap;this.bumpMap=a.bumpMap;this.bumpScale=a.bumpScale;this.normalMap=a.normalMap;this.normalScale.copy(a.normalScale);
this.displacementMap=a.displacementMap;this.displacementScale=a.displacementScale;this.displacementBias=a.displacementBias;this.specularMap=a.specularMap;this.alphaMap=a.alphaMap;this.envMap=a.envMap;this.combine=a.combine;this.reflectivity=a.reflectivity;this.refractionRatio=a.refractionRatio;this.fog=a.fog;this.shading=a.shading;this.wireframe=a.wireframe;this.wireframeLinewidth=a.wireframeLinewidth;this.wireframeLinecap=a.wireframeLinecap;this.wireframeLinejoin=a.wireframeLinejoin;this.vertexColors=
a.vertexColors;this.skinning=a.skinning;this.morphTargets=a.morphTargets;this.morphNormals=a.morphNormals;return this};THREE.MeshDepthMaterial=function(a){THREE.Material.call(this);this.type="MeshDepthMaterial";this.wireframe=this.morphTargets=!1;this.wireframeLinewidth=1;this.setValues(a)};THREE.MeshDepthMaterial.prototype=Object.create(THREE.Material.prototype);THREE.MeshDepthMaterial.prototype.constructor=THREE.MeshDepthMaterial;
THREE.MeshDepthMaterial.prototype.copy=function(a){THREE.Material.prototype.copy.call(this,a);this.wireframe=a.wireframe;this.wireframeLinewidth=a.wireframeLinewidth;return this};THREE.MeshNormalMaterial=function(a){THREE.Material.call(this,a);this.type="MeshNormalMaterial";this.wireframe=!1;this.wireframeLinewidth=1;this.morphTargets=!1;this.setValues(a)};THREE.MeshNormalMaterial.prototype=Object.create(THREE.Material.prototype);THREE.MeshNormalMaterial.prototype.constructor=THREE.MeshNormalMaterial;
THREE.MeshNormalMaterial.prototype.copy=function(a){THREE.Material.prototype.copy.call(this,a);this.wireframe=a.wireframe;this.wireframeLinewidth=a.wireframeLinewidth;return this};THREE.MultiMaterial=function(a){this.uuid=THREE.Math.generateUUID();this.type="MultiMaterial";this.materials=a instanceof Array?a:[];this.visible=!0};
THREE.MultiMaterial.prototype={constructor:THREE.MultiMaterial,toJSON:function(){for(var a={metadata:{version:4.2,type:"material",generator:"MaterialExporter"},uuid:this.uuid,type:this.type,materials:[]},b=0,c=this.materials.length;b<c;b++)a.materials.push(this.materials[b].toJSON());a.visible=this.visible;return a},clone:function(){for(var a=new this.constructor,b=0;b<this.materials.length;b++)a.materials.push(this.materials[b].clone());a.visible=this.visible;return a}};THREE.MeshFaceMaterial=THREE.MultiMaterial;
THREE.PointsMaterial=function(a){THREE.Material.call(this);this.type="PointsMaterial";this.color=new THREE.Color(16777215);this.map=null;this.size=1;this.sizeAttenuation=!0;this.vertexColors=THREE.NoColors;this.fog=!0;this.setValues(a)};THREE.PointsMaterial.prototype=Object.create(THREE.Material.prototype);THREE.PointsMaterial.prototype.constructor=THREE.PointsMaterial;
THREE.PointsMaterial.prototype.copy=function(a){THREE.Material.prototype.copy.call(this,a);this.color.copy(a.color);this.map=a.map;this.size=a.size;this.sizeAttenuation=a.sizeAttenuation;this.vertexColors=a.vertexColors;this.fog=a.fog;return this};THREE.PointCloudMaterial=function(a){console.warn("THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.");return new THREE.PointsMaterial(a)};
THREE.ParticleBasicMaterial=function(a){console.warn("THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.");return new THREE.PointsMaterial(a)};THREE.ParticleSystemMaterial=function(a){console.warn("THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.");return new THREE.PointsMaterial(a)};
THREE.ShaderMaterial=function(a){THREE.Material.call(this);this.type="ShaderMaterial";this.defines={};this.uniforms={};this.vertexShader="void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";this.fragmentShader="void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";this.shading=THREE.SmoothShading;this.linewidth=1;this.wireframe=!1;this.wireframeLinewidth=1;this.lights=this.fog=!1;this.vertexColors=THREE.NoColors;this.derivatives=this.morphNormals=
this.morphTargets=this.skinning=!1;this.defaultAttributeValues={color:[1,1,1],uv:[0,0],uv2:[0,0]};this.index0AttributeName=void 0;void 0!==a&&(void 0!==a.attributes&&console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead."),this.setValues(a))};THREE.ShaderMaterial.prototype=Object.create(THREE.Material.prototype);THREE.ShaderMaterial.prototype.constructor=THREE.ShaderMaterial;
THREE.ShaderMaterial.prototype.copy=function(a){THREE.Material.prototype.copy.call(this,a);this.fragmentShader=a.fragmentShader;this.vertexShader=a.vertexShader;this.uniforms=THREE.UniformsUtils.clone(a.uniforms);this.attributes=a.attributes;this.defines=a.defines;this.shading=a.shading;this.wireframe=a.wireframe;this.wireframeLinewidth=a.wireframeLinewidth;this.fog=a.fog;this.lights=a.lights;this.vertexColors=a.vertexColors;this.skinning=a.skinning;this.morphTargets=a.morphTargets;this.morphNormals=
a.morphNormals;this.derivatives=a.derivatives;return this};THREE.ShaderMaterial.prototype.toJSON=function(a){a=THREE.Material.prototype.toJSON.call(this,a);a.uniforms=this.uniforms;a.attributes=this.attributes;a.vertexShader=this.vertexShader;a.fragmentShader=this.fragmentShader;return a};THREE.RawShaderMaterial=function(a){THREE.ShaderMaterial.call(this,a);this.type="RawShaderMaterial"};THREE.RawShaderMaterial.prototype=Object.create(THREE.ShaderMaterial.prototype);
THREE.RawShaderMaterial.prototype.constructor=THREE.RawShaderMaterial;THREE.SpriteMaterial=function(a){THREE.Material.call(this);this.type="SpriteMaterial";this.color=new THREE.Color(16777215);this.map=null;this.rotation=0;this.fog=!1;this.setValues(a)};THREE.SpriteMaterial.prototype=Object.create(THREE.Material.prototype);THREE.SpriteMaterial.prototype.constructor=THREE.SpriteMaterial;
THREE.SpriteMaterial.prototype.copy=function(a){THREE.Material.prototype.copy.call(this,a);this.color.copy(a.color);this.map=a.map;this.rotation=a.rotation;this.fog=a.fog;return this};
THREE.Texture=function(a,b,c,d,e,g,f,h,l){Object.defineProperty(this,"id",{value:THREE.TextureIdCount++});this.uuid=THREE.Math.generateUUID();this.sourceFile=this.name="";this.image=void 0!==a?a:THREE.Texture.DEFAULT_IMAGE;this.mipmaps=[];this.mapping=void 0!==b?b:THREE.Texture.DEFAULT_MAPPING;this.wrapS=void 0!==c?c:THREE.ClampToEdgeWrapping;this.wrapT=void 0!==d?d:THREE.ClampToEdgeWrapping;this.magFilter=void 0!==e?e:THREE.LinearFilter;this.minFilter=void 0!==g?g:THREE.LinearMipMapLinearFilter;
this.anisotropy=void 0!==l?l:1;this.format=void 0!==f?f:THREE.RGBAFormat;this.type=void 0!==h?h:THREE.UnsignedByteType;this.offset=new THREE.Vector2(0,0);this.repeat=new THREE.Vector2(1,1);this.generateMipmaps=!0;this.premultiplyAlpha=!1;this.flipY=!0;this.unpackAlignment=4;this.version=0;this.onUpdate=null};THREE.Texture.DEFAULT_IMAGE=void 0;THREE.Texture.DEFAULT_MAPPING=THREE.UVMapping;
THREE.Texture.prototype={constructor:THREE.Texture,set needsUpdate(a){!0===a&&this.version++},clone:function(){return(new this.constructor).copy(this)},copy:function(a){this.image=a.image;this.mipmaps=a.mipmaps.slice(0);this.mapping=a.mapping;this.wrapS=a.wrapS;this.wrapT=a.wrapT;this.magFilter=a.magFilter;this.minFilter=a.minFilter;this.anisotropy=a.anisotropy;this.format=a.format;this.type=a.type;this.offset.copy(a.offset);this.repeat.copy(a.repeat);this.generateMipmaps=a.generateMipmaps;this.premultiplyAlpha=
a.premultiplyAlpha;this.flipY=a.flipY;this.unpackAlignment=a.unpackAlignment;return this},toJSON:function(a){if(void 0!==a.textures[this.uuid])return a.textures[this.uuid];var b={metadata:{version:4.4,type:"Texture",generator:"Texture.toJSON"},uuid:this.uuid,name:this.name,mapping:this.mapping,repeat:[this.repeat.x,this.repeat.y],offset:[this.offset.x,this.offset.y],wrap:[this.wrapS,this.wrapT],minFilter:this.minFilter,magFilter:this.magFilter,anisotropy:this.anisotropy};if(void 0!==this.image){var c=
this.image;void 0===c.uuid&&(c.uuid=THREE.Math.generateUUID());if(void 0===a.images[c.uuid]){var d=a.images,e=c.uuid,g=c.uuid,f;void 0!==c.toDataURL?f=c:(f=document.createElement("canvas"),f.width=c.width,f.height=c.height,f.getContext("2d").drawImage(c,0,0,c.width,c.height));f=2048<f.width||2048<f.height?f.toDataURL("image/jpeg",.6):f.toDataURL("image/png");d[e]={uuid:g,url:f}}b.image=c.uuid}return a.textures[this.uuid]=b},dispose:function(){this.dispatchEvent({type:"dispose"})},transformUv:function(a){if(this.mapping===
THREE.UVMapping){a.multiply(this.repeat);a.add(this.offset);if(0>a.x||1<a.x)switch(this.wrapS){case THREE.RepeatWrapping:a.x-=Math.floor(a.x);break;case THREE.ClampToEdgeWrapping:a.x=0>a.x?0:1;break;case THREE.MirroredRepeatWrapping:1===Math.abs(Math.floor(a.x)%2)?a.x=Math.ceil(a.x)-a.x:a.x-=Math.floor(a.x)}if(0>a.y||1<a.y)switch(this.wrapT){case THREE.RepeatWrapping:a.y-=Math.floor(a.y);break;case THREE.ClampToEdgeWrapping:a.y=0>a.y?0:1;break;case THREE.MirroredRepeatWrapping:1===Math.abs(Math.floor(a.y)%
2)?a.y=Math.ceil(a.y)-a.y:a.y-=Math.floor(a.y)}this.flipY&&(a.y=1-a.y)}}};THREE.EventDispatcher.prototype.apply(THREE.Texture.prototype);THREE.TextureIdCount=0;THREE.CanvasTexture=function(a,b,c,d,e,g,f,h,l){THREE.Texture.call(this,a,b,c,d,e,g,f,h,l);this.needsUpdate=!0};THREE.CanvasTexture.prototype=Object.create(THREE.Texture.prototype);THREE.CanvasTexture.prototype.constructor=THREE.CanvasTexture;
THREE.CubeTexture=function(a,b,c,d,e,g,f,h,l){b=void 0!==b?b:THREE.CubeReflectionMapping;THREE.Texture.call(this,a,b,c,d,e,g,f,h,l);this.images=a;this.flipY=!1};THREE.CubeTexture.prototype=Object.create(THREE.Texture.prototype);THREE.CubeTexture.prototype.constructor=THREE.CubeTexture;THREE.CubeTexture.prototype.copy=function(a){THREE.Texture.prototype.copy.call(this,a);this.images=a.images;return this};
THREE.CompressedTexture=function(a,b,c,d,e,g,f,h,l,k,m){THREE.Texture.call(this,null,g,f,h,l,k,d,e,m);this.image={width:b,height:c};this.mipmaps=a;this.generateMipmaps=this.flipY=!1};THREE.CompressedTexture.prototype=Object.create(THREE.Texture.prototype);THREE.CompressedTexture.prototype.constructor=THREE.CompressedTexture;
THREE.DataTexture=function(a,b,c,d,e,g,f,h,l,k,m){THREE.Texture.call(this,null,g,f,h,l,k,d,e,m);this.image={data:a,width:b,height:c};this.magFilter=void 0!==l?l:THREE.NearestFilter;this.minFilter=void 0!==k?k:THREE.NearestFilter;this.generateMipmaps=this.flipY=!1};THREE.DataTexture.prototype=Object.create(THREE.Texture.prototype);THREE.DataTexture.prototype.constructor=THREE.DataTexture;
THREE.VideoTexture=function(a,b,c,d,e,g,f,h,l){function k(){requestAnimationFrame(k);a.readyState===a.HAVE_ENOUGH_DATA&&(m.needsUpdate=!0)}THREE.Texture.call(this,a,b,c,d,e,g,f,h,l);this.generateMipmaps=!1;var m=this;k()};THREE.VideoTexture.prototype=Object.create(THREE.Texture.prototype);THREE.VideoTexture.prototype.constructor=THREE.VideoTexture;THREE.Group=function(){THREE.Object3D.call(this);this.type="Group"};THREE.Group.prototype=Object.create(THREE.Object3D.prototype);
THREE.Group.prototype.constructor=THREE.Group;THREE.Points=function(a,b){THREE.Object3D.call(this);this.type="Points";this.geometry=void 0!==a?a:new THREE.Geometry;this.material=void 0!==b?b:new THREE.PointsMaterial({color:16777215*Math.random()})};THREE.Points.prototype=Object.create(THREE.Object3D.prototype);THREE.Points.prototype.constructor=THREE.Points;
THREE.Points.prototype.raycast=function(){var a=new THREE.Matrix4,b=new THREE.Ray;return function(c,d){function e(a,e){var f=b.distanceSqToPoint(a);if(f<l){var h=b.closestPointToPoint(a);h.applyMatrix4(g.matrixWorld);var k=c.ray.origin.distanceTo(h);k<c.near||k>c.far||d.push({distance:k,distanceToRay:Math.sqrt(f),point:h.clone(),index:e,face:null,object:g})}}var g=this,f=g.geometry,h=c.params.Points.threshold;a.getInverse(this.matrixWorld);b.copy(c.ray).applyMatrix4(a);if(null===f.boundingBox||!1!==
b.isIntersectionBox(f.boundingBox)){var h=h/((this.scale.x+this.scale.y+this.scale.z)/3),l=h*h,h=new THREE.Vector3;if(f instanceof THREE.BufferGeometry){var k=f.index,f=f.attributes.position.array;if(null!==k)for(var m=k.array,k=0,p=m.length;k<p;k++){var n=m[k];h.fromArray(f,3*n);e(h,n)}else for(k=0,m=f.length/3;k<m;k++)h.fromArray(f,3*k),e(h,k)}else for(h=f.vertices,k=0,m=h.length;k<m;k++)e(h[k],k)}}}();THREE.Points.prototype.clone=function(){return(new this.constructor(this.geometry,this.material)).copy(this)};
THREE.PointCloud=function(a,b){console.warn("THREE.PointCloud has been renamed to THREE.Points.");return new THREE.Points(a,b)};THREE.ParticleSystem=function(a,b){console.warn("THREE.ParticleSystem has been renamed to THREE.Points.");return new THREE.Points(a,b)};
THREE.Line=function(a,b,c){if(1===c)return console.warn("THREE.Line: parameter THREE.LinePieces no longer supported. Created THREE.LineSegments instead."),new THREE.LineSegments(a,b);THREE.Object3D.call(this);this.type="Line";this.geometry=void 0!==a?a:new THREE.Geometry;this.material=void 0!==b?b:new THREE.LineBasicMaterial({color:16777215*Math.random()})};THREE.Line.prototype=Object.create(THREE.Object3D.prototype);THREE.Line.prototype.constructor=THREE.Line;
THREE.Line.prototype.raycast=function(){var a=new THREE.Matrix4,b=new THREE.Ray,c=new THREE.Sphere;return function(d,e){var g=d.linePrecision,g=g*g,f=this.geometry;null===f.boundingSphere&&f.computeBoundingSphere();c.copy(f.boundingSphere);c.applyMatrix4(this.matrixWorld);if(!1!==d.ray.isIntersectionSphere(c)){a.getInverse(this.matrixWorld);b.copy(d.ray).applyMatrix4(a);var h=new THREE.Vector3,l=new THREE.Vector3,k=new THREE.Vector3,m=new THREE.Vector3,p=this instanceof THREE.LineSegments?2:1;if(f instanceof
THREE.BufferGeometry){var n=f.index,q=f.attributes;if(null!==n)for(var f=n.array,q=q.position.array,n=0,s=f.length-1;n<s;n+=p){var t=f[n+1];h.fromArray(q,3*f[n]);l.fromArray(q,3*t);t=b.distanceSqToSegment(h,l,m,k);t>g||(m.applyMatrix4(this.matrixWorld),t=d.ray.origin.distanceTo(m),t<d.near||t>d.far||e.push({distance:t,point:k.clone().applyMatrix4(this.matrixWorld),index:n,face:null,faceIndex:null,object:this}))}else for(q=q.position.array,n=0,s=q.length/3-1;n<s;n+=p)h.fromArray(q,3*n),l.fromArray(q,
3*n+3),t=b.distanceSqToSegment(h,l,m,k),t>g||(m.applyMatrix4(this.matrixWorld),t=d.ray.origin.distanceTo(m),t<d.near||t>d.far||e.push({distance:t,point:k.clone().applyMatrix4(this.matrixWorld),index:n,face:null,faceIndex:null,object:this}))}else if(f instanceof THREE.Geometry)for(h=f.vertices,l=h.length,n=0;n<l-1;n+=p)t=b.distanceSqToSegment(h[n],h[n+1],m,k),t>g||(m.applyMatrix4(this.matrixWorld),t=d.ray.origin.distanceTo(m),t<d.near||t>d.far||e.push({distance:t,point:k.clone().applyMatrix4(this.matrixWorld),
index:n,face:null,faceIndex:null,object:this}))}}}();THREE.Line.prototype.clone=function(){return(new this.constructor(this.geometry,this.material)).copy(this)};THREE.LineStrip=0;THREE.LinePieces=1;THREE.LineSegments=function(a,b){THREE.Line.call(this,a,b);this.type="LineSegments"};THREE.LineSegments.prototype=Object.create(THREE.Line.prototype);THREE.LineSegments.prototype.constructor=THREE.LineSegments;
THREE.Mesh=function(a,b){THREE.Object3D.call(this);this.type="Mesh";this.geometry=void 0!==a?a:new THREE.Geometry;this.material=void 0!==b?b:new THREE.MeshBasicMaterial({color:16777215*Math.random()});this.updateMorphTargets()};THREE.Mesh.prototype=Object.create(THREE.Object3D.prototype);THREE.Mesh.prototype.constructor=THREE.Mesh;
THREE.Mesh.prototype.updateMorphTargets=function(){if(void 0!==this.geometry.morphTargets&&0<this.geometry.morphTargets.length){this.morphTargetBase=-1;this.morphTargetInfluences=[];this.morphTargetDictionary={};for(var a=0,b=this.geometry.morphTargets.length;a<b;a++)this.morphTargetInfluences.push(0),this.morphTargetDictionary[this.geometry.morphTargets[a].name]=a}};
THREE.Mesh.prototype.getMorphTargetIndexByName=function(a){if(void 0!==this.morphTargetDictionary[a])return this.morphTargetDictionary[a];console.warn("THREE.Mesh.getMorphTargetIndexByName: morph target "+a+" does not exist. Returning 0.");return 0};
THREE.Mesh.prototype.raycast=function(){function a(a,b,c,d,e,f,g){THREE.Triangle.barycoordFromPoint(a,b,c,d,t);e.multiplyScalar(t.x);f.multiplyScalar(t.y);g.multiplyScalar(t.z);e.add(f).add(g);return e.clone()}function b(a,b,c,d,e,f,g){var h=a.material;if(null===(h.side===THREE.BackSide?c.intersectTriangle(f,e,d,!0,g):c.intersectTriangle(d,e,f,h.side!==THREE.DoubleSide,g)))return null;u.copy(g);u.applyMatrix4(a.matrixWorld);c=b.ray.origin.distanceTo(u);return c<b.near||c>b.far?null:{distance:c,point:u.clone(),
object:a}}function c(c,d,e,g,k,m,p,u){f.fromArray(g,3*m);h.fromArray(g,3*p);l.fromArray(g,3*u);if(c=b(c,d,e,f,h,l,v))k&&(n.fromArray(k,2*m),q.fromArray(k,2*p),s.fromArray(k,2*u),c.uv=a(v,f,h,l,n,q,s)),c.face=new THREE.Face3(m,p,u,THREE.Triangle.normal(f,h,l)),c.faceIndex=m;return c}var d=new THREE.Matrix4,e=new THREE.Ray,g=new THREE.Sphere,f=new THREE.Vector3,h=new THREE.Vector3,l=new THREE.Vector3,k=new THREE.Vector3,m=new THREE.Vector3,p=new THREE.Vector3,n=new THREE.Vector2,q=new THREE.Vector2,
s=new THREE.Vector2,t=new THREE.Vector3,v=new THREE.Vector3,u=new THREE.Vector3;return function(u,t){var x=this.geometry,B=this.material;if(void 0!==B){null===x.boundingSphere&&x.computeBoundingSphere();var y=this.matrixWorld;g.copy(x.boundingSphere);g.applyMatrix4(y);if(!1!==u.ray.isIntersectionSphere(g)&&(d.getInverse(y),e.copy(u.ray).applyMatrix4(d),null===x.boundingBox||!1!==e.isIntersectionBox(x.boundingBox))){var z,A;if(x instanceof THREE.BufferGeometry){var J,F,B=x.index,y=x.attributes,x=y.position.array;
void 0!==y.uv&&(z=y.uv.array);if(null!==B)for(var y=B.array,C=0,N=y.length;C<N;C+=3){if(B=y[C],J=y[C+1],F=y[C+2],A=c(this,u,e,x,z,B,J,F))A.faceIndex=Math.floor(C/3),t.push(A)}else for(C=0,N=x.length;C<N;C+=9)if(B=C/3,J=B+1,F=B+2,A=c(this,u,e,x,z,B,J,F))A.index=B,t.push(A)}else if(x instanceof THREE.Geometry){var L,Q,y=B instanceof THREE.MeshFaceMaterial,C=!0===y?B.materials:null,N=x.vertices;J=x.faces;F=x.faceVertexUvs[0];0<F.length&&(z=F);for(var M=0,K=J.length;M<K;M++){var E=J[M];A=!0===y?C[E.materialIndex]:
B;if(void 0!==A){F=N[E.a];L=N[E.b];Q=N[E.c];if(!0===A.morphTargets){A=x.morphTargets;var O=this.morphTargetInfluences;f.set(0,0,0);h.set(0,0,0);l.set(0,0,0);for(var T=0,H=A.length;T<H;T++){var R=O[T];if(0!==R){var G=A[T].vertices;f.addScaledVector(k.subVectors(G[E.a],F),R);h.addScaledVector(m.subVectors(G[E.b],L),R);l.addScaledVector(p.subVectors(G[E.c],Q),R)}}f.add(F);h.add(L);l.add(Q);F=f;L=h;Q=l}if(A=b(this,u,e,F,L,Q,v))z&&(O=z[M],n.copy(O[0]),q.copy(O[1]),s.copy(O[2]),A.uv=a(v,F,L,Q,n,q,s)),A.face=
E,A.faceIndex=M,t.push(A)}}}}}}}();THREE.Mesh.prototype.clone=function(){return(new this.constructor(this.geometry,this.material)).copy(this)};THREE.Bone=function(a){THREE.Object3D.call(this);this.type="Bone";this.skin=a};THREE.Bone.prototype=Object.create(THREE.Object3D.prototype);THREE.Bone.prototype.constructor=THREE.Bone;THREE.Bone.prototype.copy=function(a){THREE.Object3D.prototype.copy.call(this,a);this.skin=a.skin;return this};
THREE.Skeleton=function(a,b,c){this.useVertexTexture=void 0!==c?c:!0;this.identityMatrix=new THREE.Matrix4;a=a||[];this.bones=a.slice(0);this.useVertexTexture?(a=Math.sqrt(4*this.bones.length),a=THREE.Math.nextPowerOfTwo(Math.ceil(a)),this.boneTextureHeight=this.boneTextureWidth=a=Math.max(a,4),this.boneMatrices=new Float32Array(this.boneTextureWidth*this.boneTextureHeight*4),this.boneTexture=new THREE.DataTexture(this.boneMatrices,this.boneTextureWidth,this.boneTextureHeight,THREE.RGBAFormat,THREE.FloatType)):
this.boneMatrices=new Float32Array(16*this.bones.length);if(void 0===b)this.calculateInverses();else if(this.bones.length===b.length)this.boneInverses=b.slice(0);else for(console.warn("THREE.Skeleton bonInverses is the wrong length."),this.boneInverses=[],b=0,a=this.bones.length;b<a;b++)this.boneInverses.push(new THREE.Matrix4)};
THREE.Skeleton.prototype.calculateInverses=function(){this.boneInverses=[];for(var a=0,b=this.bones.length;a<b;a++){var c=new THREE.Matrix4;this.bones[a]&&c.getInverse(this.bones[a].matrixWorld);this.boneInverses.push(c)}};
THREE.Skeleton.prototype.pose=function(){for(var a,b=0,c=this.bones.length;b<c;b++)(a=this.bones[b])&&a.matrixWorld.getInverse(this.boneInverses[b]);b=0;for(c=this.bones.length;b<c;b++)if(a=this.bones[b])a.parent?(a.matrix.getInverse(a.parent.matrixWorld),a.matrix.multiply(a.matrixWorld)):a.matrix.copy(a.matrixWorld),a.matrix.decompose(a.position,a.quaternion,a.scale)};
THREE.Skeleton.prototype.update=function(){var a=new THREE.Matrix4;return function(){for(var b=0,c=this.bones.length;b<c;b++)a.multiplyMatrices(this.bones[b]?this.bones[b].matrixWorld:this.identityMatrix,this.boneInverses[b]),a.flattenToArrayOffset(this.boneMatrices,16*b);this.useVertexTexture&&(this.boneTexture.needsUpdate=!0)}}();THREE.Skeleton.prototype.clone=function(){return new THREE.Skeleton(this.bones,this.boneInverses,this.useVertexTexture)};
THREE.SkinnedMesh=function(a,b,c){THREE.Mesh.call(this,a,b);this.type="SkinnedMesh";this.bindMode="attached";this.bindMatrix=new THREE.Matrix4;this.bindMatrixInverse=new THREE.Matrix4;a=[];if(this.geometry&&void 0!==this.geometry.bones){for(var d,e=0,g=this.geometry.bones.length;e<g;++e)d=this.geometry.bones[e],b=new THREE.Bone(this),a.push(b),b.name=d.name,b.position.fromArray(d.pos),b.quaternion.fromArray(d.rotq),void 0!==d.scl&&b.scale.fromArray(d.scl);e=0;for(g=this.geometry.bones.length;e<g;++e)d=
this.geometry.bones[e],-1!==d.parent&&null!==d.parent?a[d.parent].add(a[e]):this.add(a[e])}this.normalizeSkinWeights();this.updateMatrixWorld(!0);this.bind(new THREE.Skeleton(a,void 0,c),this.matrixWorld)};THREE.SkinnedMesh.prototype=Object.create(THREE.Mesh.prototype);THREE.SkinnedMesh.prototype.constructor=THREE.SkinnedMesh;
THREE.SkinnedMesh.prototype.bind=function(a,b){this.skeleton=a;void 0===b&&(this.updateMatrixWorld(!0),this.skeleton.calculateInverses(),b=this.matrixWorld);this.bindMatrix.copy(b);this.bindMatrixInverse.getInverse(b)};THREE.SkinnedMesh.prototype.pose=function(){this.skeleton.pose()};
THREE.SkinnedMesh.prototype.normalizeSkinWeights=function(){if(this.geometry instanceof THREE.Geometry)for(var a=0;a<this.geometry.skinIndices.length;a++){var b=this.geometry.skinWeights[a],c=1/b.lengthManhattan();Infinity!==c?b.multiplyScalar(c):b.set(1)}};
THREE.SkinnedMesh.prototype.updateMatrixWorld=function(a){THREE.Mesh.prototype.updateMatrixWorld.call(this,!0);"attached"===this.bindMode?this.bindMatrixInverse.getInverse(this.matrixWorld):"detached"===this.bindMode?this.bindMatrixInverse.getInverse(this.bindMatrix):console.warn("THREE.SkinnedMesh unrecognized bindMode: "+this.bindMode)};THREE.SkinnedMesh.prototype.clone=function(){return(new this.constructor(this.geometry,this.material,this.useVertexTexture)).copy(this)};
THREE.LOD=function(){THREE.Object3D.call(this);this.type="LOD";Object.defineProperties(this,{levels:{enumerable:!0,value:[]},objects:{get:function(){console.warn("THREE.LOD: .objects has been renamed to .levels.");return this.levels}}})};THREE.LOD.prototype=Object.create(THREE.Object3D.prototype);THREE.LOD.prototype.constructor=THREE.LOD;
THREE.LOD.prototype.addLevel=function(a,b){void 0===b&&(b=0);b=Math.abs(b);for(var c=this.levels,d=0;d<c.length&&!(b<c[d].distance);d++);c.splice(d,0,{distance:b,object:a});this.add(a)};THREE.LOD.prototype.getObjectForDistance=function(a){for(var b=this.levels,c=1,d=b.length;c<d&&!(a<b[c].distance);c++);return b[c-1].object};
THREE.LOD.prototype.raycast=function(){var a=new THREE.Vector3;return function(b,c){a.setFromMatrixPosition(this.matrixWorld);var d=b.ray.origin.distanceTo(a);this.getObjectForDistance(d).raycast(b,c)}}();
THREE.LOD.prototype.update=function(){var a=new THREE.Vector3,b=new THREE.Vector3;return function(c){var d=this.levels;if(1<d.length){a.setFromMatrixPosition(c.matrixWorld);b.setFromMatrixPosition(this.matrixWorld);c=a.distanceTo(b);d[0].object.visible=!0;for(var e=1,g=d.length;e<g;e++)if(c>=d[e].distance)d[e-1].object.visible=!1,d[e].object.visible=!0;else break;for(;e<g;e++)d[e].object.visible=!1}}}();
THREE.LOD.prototype.copy=function(a){THREE.Object3D.prototype.copy.call(this,a,!1);a=a.levels;for(var b=0,c=a.length;b<c;b++){var d=a[b];this.addLevel(d.object.clone(),d.distance)}return this};THREE.LOD.prototype.toJSON=function(a){a=THREE.Object3D.prototype.toJSON.call(this,a);a.object.levels=[];for(var b=this.levels,c=0,d=b.length;c<d;c++){var e=b[c];a.object.levels.push({object:e.object.uuid,distance:e.distance})}return a};
THREE.Sprite=function(){var a=new Uint16Array([0,1,2,0,2,3]),b=new Float32Array([-.5,-.5,0,.5,-.5,0,.5,.5,0,-.5,.5,0]),c=new Float32Array([0,0,1,0,1,1,0,1]),d=new THREE.BufferGeometry;d.setIndex(new THREE.BufferAttribute(a,1));d.addAttribute("position",new THREE.BufferAttribute(b,3));d.addAttribute("uv",new THREE.BufferAttribute(c,2));return function(a){THREE.Object3D.call(this);this.type="Sprite";this.geometry=d;this.material=void 0!==a?a:new THREE.SpriteMaterial}}();THREE.Sprite.prototype=Object.create(THREE.Object3D.prototype);
THREE.Sprite.prototype.constructor=THREE.Sprite;THREE.Sprite.prototype.raycast=function(){var a=new THREE.Vector3;return function(b,c){a.setFromMatrixPosition(this.matrixWorld);var d=b.ray.distanceSqToPoint(a);d>this.scale.x*this.scale.y||c.push({distance:Math.sqrt(d),point:this.position,face:null,object:this})}}();THREE.Sprite.prototype.clone=function(){return(new this.constructor(this.material)).copy(this)};THREE.Particle=THREE.Sprite;
THREE.LensFlare=function(a,b,c,d,e){THREE.Object3D.call(this);this.lensFlares=[];this.positionScreen=new THREE.Vector3;this.customUpdateCallback=void 0;void 0!==a&&this.add(a,b,c,d,e)};THREE.LensFlare.prototype=Object.create(THREE.Object3D.prototype);THREE.LensFlare.prototype.constructor=THREE.LensFlare;
THREE.LensFlare.prototype.add=function(a,b,c,d,e,g){void 0===b&&(b=-1);void 0===c&&(c=0);void 0===g&&(g=1);void 0===e&&(e=new THREE.Color(16777215));void 0===d&&(d=THREE.NormalBlending);c=Math.min(c,Math.max(0,c));this.lensFlares.push({texture:a,size:b,distance:c,x:0,y:0,z:0,scale:1,rotation:0,opacity:g,color:e,blending:d})};
THREE.LensFlare.prototype.updateLensFlares=function(){var a,b=this.lensFlares.length,c,d=2*-this.positionScreen.x,e=2*-this.positionScreen.y;for(a=0;a<b;a++)c=this.lensFlares[a],c.x=this.positionScreen.x+d*c.distance,c.y=this.positionScreen.y+e*c.distance,c.wantedRotation=c.x*Math.PI*.25,c.rotation+=.25*(c.wantedRotation-c.rotation)};
THREE.LensFlare.prototype.copy=function(a){THREE.Object3D.prototype.copy.call(this,a);this.positionScreen.copy(a.positionScreen);this.customUpdateCallback=a.customUpdateCallback;for(var b=0,c=a.lensFlares.length;b<c;b++)this.lensFlares.push(a.lensFlares[b]);return this};THREE.Scene=function(){THREE.Object3D.call(this);this.type="Scene";this.overrideMaterial=this.fog=null;this.autoUpdate=!0};THREE.Scene.prototype=Object.create(THREE.Object3D.prototype);THREE.Scene.prototype.constructor=THREE.Scene;
THREE.Scene.prototype.copy=function(a){THREE.Object3D.prototype.copy.call(this,a);null!==a.fog&&(this.fog=a.fog.clone());null!==a.overrideMaterial&&(this.overrideMaterial=a.overrideMaterial.clone());this.autoUpdate=a.autoUpdate;this.matrixAutoUpdate=a.matrixAutoUpdate;return this};THREE.Fog=function(a,b,c){this.name="";this.color=new THREE.Color(a);this.near=void 0!==b?b:1;this.far=void 0!==c?c:1E3};THREE.Fog.prototype.clone=function(){return new THREE.Fog(this.color.getHex(),this.near,this.far)};
THREE.FogExp2=function(a,b){this.name="";this.color=new THREE.Color(a);this.density=void 0!==b?b:2.5E-4};THREE.FogExp2.prototype.clone=function(){return new THREE.FogExp2(this.color.getHex(),this.density)};THREE.ShaderChunk={};THREE.ShaderChunk.alphamap_fragment="#ifdef USE_ALPHAMAP\n\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n\n#endif\n";THREE.ShaderChunk.alphamap_pars_fragment="#ifdef USE_ALPHAMAP\n\n\tuniform sampler2D alphaMap;\n\n#endif\n";THREE.ShaderChunk.alphatest_fragment="#ifdef ALPHATEST\n\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n\n#endif\n";
THREE.ShaderChunk.aomap_fragment="#ifdef USE_AOMAP\n\n\ttotalAmbientLight *= ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\n#endif\n";THREE.ShaderChunk.aomap_pars_fragment="#ifdef USE_AOMAP\n\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n\n#endif";THREE.ShaderChunk.begin_vertex="\nvec3 transformed = vec3( position );\n";THREE.ShaderChunk.beginnormal_vertex="\nvec3 objectNormal = vec3( normal );\n";THREE.ShaderChunk.bumpmap_pars_fragment="#ifdef USE_BUMPMAP\n\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\n\n\n\tvec2 dHdxy_fwd() {\n\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\n\t\treturn vec2( dBx, dBy );\n\n\t}\n\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\n\t\tvec3 vSigmaX = dFdx( surf_pos );\n\t\tvec3 vSigmaY = dFdy( surf_pos );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\n\t}\n\n#endif\n";
THREE.ShaderChunk.color_fragment="#ifdef USE_COLOR\n\n\tdiffuseColor.rgb *= vColor;\n\n#endif";THREE.ShaderChunk.color_pars_fragment="#ifdef USE_COLOR\n\n\tvarying vec3 vColor;\n\n#endif\n";THREE.ShaderChunk.color_pars_vertex="#ifdef USE_COLOR\n\n\tvarying vec3 vColor;\n\n#endif";THREE.ShaderChunk.color_vertex="#ifdef USE_COLOR\n\n\tvColor.xyz = color.xyz;\n\n#endif";THREE.ShaderChunk.common="#define PI 3.14159\n#define PI2 6.28318\n#define RECIPROCAL_PI2 0.15915494\n#define LOG2 1.442695\n#define EPSILON 1e-6\n\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#define whiteCompliment(a) ( 1.0 - saturate( a ) )\n\nvec3 transformDirection( in vec3 normal, in mat4 matrix ) {\n\n\treturn normalize( ( matrix * vec4( normal, 0.0 ) ).xyz );\n\n}\n\nvec3 inverseTransformDirection( in vec3 normal, in mat4 matrix ) {\n\n\treturn normalize( ( vec4( normal, 0.0 ) * matrix ).xyz );\n\n}\n\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\n\treturn - distance * planeNormal + point;\n\n}\n\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n\n}\n\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n\n}\n\nfloat calcLightAttenuation( float lightDistance, float cutoffDistance, float decayExponent ) {\n\n\tif ( decayExponent > 0.0 ) {\n\n\t  return pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\n\t}\n\n\treturn 1.0;\n\n}\n\nvec3 F_Schlick( in vec3 specularColor, in float dotLH ) {\n\n\n\tfloat fresnel = exp2( ( -5.55437 * dotLH - 6.98316 ) * dotLH );\n\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n\n}\n\nfloat G_BlinnPhong_Implicit( /* in float dotNL, in float dotNV */ ) {\n\n\n\treturn 0.25;\n\n}\n\nfloat D_BlinnPhong( in float shininess, in float dotNH ) {\n\n\n\treturn ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n\n}\n\nvec3 BRDF_BlinnPhong( in vec3 specularColor, in float shininess, in vec3 normal, in vec3 lightDir, in vec3 viewDir ) {\n\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotLH = saturate( dot( lightDir, halfDir ) );\n\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\n\tfloat G = G_BlinnPhong_Implicit( /* dotNL, dotNV */ );\n\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\n\treturn F * G * D;\n\n}\n\nvec3 inputToLinear( in vec3 a ) {\n\n\t#ifdef GAMMA_INPUT\n\n\t\treturn pow( a, vec3( float( GAMMA_FACTOR ) ) );\n\n\t#else\n\n\t\treturn a;\n\n\t#endif\n\n}\n\nvec3 linearToOutput( in vec3 a ) {\n\n\t#ifdef GAMMA_OUTPUT\n\n\t\treturn pow( a, vec3( 1.0 / float( GAMMA_FACTOR ) ) );\n\n\t#else\n\n\t\treturn a;\n\n\t#endif\n\n}\n";
THREE.ShaderChunk.defaultnormal_vertex="#ifdef FLIP_SIDED\n\n\tobjectNormal = -objectNormal;\n\n#endif\n\nvec3 transformedNormal = normalMatrix * objectNormal;\n";THREE.ShaderChunk.displacementmap_vertex="#ifdef USE_DISPLACEMENTMAP\n\n\ttransformed += normal * ( texture2D( displacementMap, uv ).x * displacementScale + displacementBias );\n\n#endif\n";THREE.ShaderChunk.displacementmap_pars_vertex="#ifdef USE_DISPLACEMENTMAP\n\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n\n#endif\n";
THREE.ShaderChunk.emissivemap_fragment="#ifdef USE_EMISSIVEMAP\n\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\n\temissiveColor.rgb = inputToLinear( emissiveColor.rgb );\n\n\ttotalEmissiveLight *= emissiveColor.rgb;\n\n#endif\n";THREE.ShaderChunk.emissivemap_pars_fragment="#ifdef USE_EMISSIVEMAP\n\n\tuniform sampler2D emissiveMap;\n\n#endif\n";THREE.ShaderChunk.envmap_fragment="#ifdef USE_ENVMAP\n\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\n\t\tvec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\n\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\n\t\t\tvec3 reflectVec = reflect( cameraToVertex, worldNormal );\n\n\t\t#else\n\n\t\t\tvec3 reflectVec = refract( cameraToVertex, worldNormal, refractionRatio );\n\n\t\t#endif\n\n\t#else\n\n\t\tvec3 reflectVec = vReflect;\n\n\t#endif\n\n\t#ifdef DOUBLE_SIDED\n\t\tfloat flipNormal = ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t#else\n\t\tfloat flipNormal = 1.0;\n\t#endif\n\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, flipNormal * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\n\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\tvec2 sampleUV;\n\t\tsampleUV.y = saturate( flipNormal * reflectVec.y * 0.5 + 0.5 );\n\t\tsampleUV.x = atan( flipNormal * reflectVec.z, flipNormal * reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\tvec4 envColor = texture2D( envMap, sampleUV );\n\n\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\tvec3 reflectView = flipNormal * normalize((viewMatrix * vec4( reflectVec, 0.0 )).xyz + vec3(0.0,0.0,1.0));\n\t\tvec4 envColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5 );\n\t#endif\n\n\tenvColor.xyz = inputToLinear( envColor.xyz );\n\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\n\t#endif\n\n#endif\n";
THREE.ShaderChunk.envmap_pars_fragment="#ifdef USE_ENVMAP\n\n\tuniform float reflectivity;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\tuniform float flipEnvMap;\n\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\n\t\tuniform float refractionRatio;\n\n\t#else\n\n\t\tvarying vec3 vReflect;\n\n\t#endif\n\n#endif\n";THREE.ShaderChunk.envmap_pars_vertex="#if defined( USE_ENVMAP ) && ! defined( USE_BUMPMAP ) && ! defined( USE_NORMALMAP ) && ! defined( PHONG )\n\n\tvarying vec3 vReflect;\n\n\tuniform float refractionRatio;\n\n#endif\n";
THREE.ShaderChunk.envmap_vertex="#if defined( USE_ENVMAP ) && ! defined( USE_BUMPMAP ) && ! defined( USE_NORMALMAP ) && ! defined( PHONG )\n\n\tvec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\n\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\n\t#ifdef ENVMAP_MODE_REFLECTION\n\n\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\n\t#else\n\n\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\n\t#endif\n\n#endif\n";
THREE.ShaderChunk.fog_fragment="#ifdef USE_FOG\n\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\n\t\tfloat depth = gl_FragDepthEXT / gl_FragCoord.w;\n\n\t#else\n\n\t\tfloat depth = gl_FragCoord.z / gl_FragCoord.w;\n\n\t#endif\n\n\t#ifdef FOG_EXP2\n\n\t\tfloat fogFactor = whiteCompliment( exp2( - fogDensity * fogDensity * depth * depth * LOG2 ) );\n\n\t#else\n\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, depth );\n\n\t#endif\n\t\n\toutgoingLight = mix( outgoingLight, fogColor, fogFactor );\n\n#endif";
THREE.ShaderChunk.fog_pars_fragment="#ifdef USE_FOG\n\n\tuniform vec3 fogColor;\n\n\t#ifdef FOG_EXP2\n\n\t\tuniform float fogDensity;\n\n\t#else\n\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n\n#endif";THREE.ShaderChunk.hemilight_fragment="#if MAX_HEMI_LIGHTS > 0\n\n\tfor ( int i = 0; i < MAX_HEMI_LIGHTS; i ++ ) {\n\n\t\tvec3 lightDir = hemisphereLightDirection[ i ];\n\n\t\tfloat dotProduct = dot( normal, lightDir );\n\n\t\tfloat hemiDiffuseWeight = 0.5 * dotProduct + 0.5;\n\n\t\tvec3 lightColor = mix( hemisphereLightGroundColor[ i ], hemisphereLightSkyColor[ i ], hemiDiffuseWeight );\n\n\t\ttotalAmbientLight += lightColor;\n\n\t}\n\n#endif\n\n";
THREE.ShaderChunk.lightmap_fragment="#ifdef USE_LIGHTMAP\n\n\ttotalAmbientLight += texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\n#endif\n";THREE.ShaderChunk.lightmap_pars_fragment="#ifdef USE_LIGHTMAP\n\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n\n#endif";THREE.ShaderChunk.lights_lambert_pars_vertex="#if MAX_DIR_LIGHTS > 0\n\n\tuniform vec3 directionalLightColor[ MAX_DIR_LIGHTS ];\n\tuniform vec3 directionalLightDirection[ MAX_DIR_LIGHTS ];\n\n#endif\n\n#if MAX_HEMI_LIGHTS > 0\n\n\tuniform vec3 hemisphereLightSkyColor[ MAX_HEMI_LIGHTS ];\n\tuniform vec3 hemisphereLightGroundColor[ MAX_HEMI_LIGHTS ];\n\tuniform vec3 hemisphereLightDirection[ MAX_HEMI_LIGHTS ];\n\n#endif\n\n#if MAX_POINT_LIGHTS > 0\n\n\tuniform vec3 pointLightColor[ MAX_POINT_LIGHTS ];\n\tuniform vec3 pointLightPosition[ MAX_POINT_LIGHTS ];\n\tuniform float pointLightDistance[ MAX_POINT_LIGHTS ];\n\tuniform float pointLightDecay[ MAX_POINT_LIGHTS ];\n\n#endif\n\n#if MAX_SPOT_LIGHTS > 0\n\n\tuniform vec3 spotLightColor[ MAX_SPOT_LIGHTS ];\n\tuniform vec3 spotLightPosition[ MAX_SPOT_LIGHTS ];\n\tuniform vec3 spotLightDirection[ MAX_SPOT_LIGHTS ];\n\tuniform float spotLightDistance[ MAX_SPOT_LIGHTS ];\n\tuniform float spotLightAngleCos[ MAX_SPOT_LIGHTS ];\n\tuniform float spotLightExponent[ MAX_SPOT_LIGHTS ];\n\tuniform float spotLightDecay[ MAX_SPOT_LIGHTS ];\n\n#endif\n";
THREE.ShaderChunk.lights_lambert_vertex="vLightFront = vec3( 0.0 );\n\n#ifdef DOUBLE_SIDED\n\n\tvLightBack = vec3( 0.0 );\n\n#endif\n\nvec3 normal = normalize( transformedNormal );\n\n#if MAX_POINT_LIGHTS > 0\n\n\tfor ( int i = 0; i < MAX_POINT_LIGHTS; i ++ ) {\n\n\t\tvec3 lightColor = pointLightColor[ i ];\n\n\t\tvec3 lVector = pointLightPosition[ i ] - mvPosition.xyz;\n\t\tvec3 lightDir = normalize( lVector );\n\n\n\t\tfloat attenuation = calcLightAttenuation( length( lVector ), pointLightDistance[ i ], pointLightDecay[ i ] );\n\n\n\t\tfloat dotProduct = dot( normal, lightDir );\n\n\t\tvLightFront += lightColor * attenuation * saturate( dotProduct );\n\n\t\t#ifdef DOUBLE_SIDED\n\n\t\t\tvLightBack += lightColor * attenuation * saturate( - dotProduct );\n\n\t\t#endif\n\n\t}\n\n#endif\n\n#if MAX_SPOT_LIGHTS > 0\n\n\tfor ( int i = 0; i < MAX_SPOT_LIGHTS; i ++ ) {\n\n\t\tvec3 lightColor = spotLightColor[ i ];\n\n\t\tvec3 lightPosition = spotLightPosition[ i ];\n\t\tvec3 lVector = lightPosition - mvPosition.xyz;\n\t\tvec3 lightDir = normalize( lVector );\n\n\t\tfloat spotEffect = dot( spotLightDirection[ i ], lightDir );\n\n\t\tif ( spotEffect > spotLightAngleCos[ i ] ) {\n\n\t\t\tspotEffect = saturate( pow( saturate( spotEffect ), spotLightExponent[ i ] ) );\n\n\n\t\t\tfloat attenuation = calcLightAttenuation( length( lVector ), spotLightDistance[ i ], spotLightDecay[ i ] );\n\n\t\t\tattenuation *= spotEffect;\n\n\n\t\t\tfloat dotProduct = dot( normal, lightDir );\n\n\t\t\tvLightFront += lightColor * attenuation * saturate( dotProduct );\n\n\t\t\t#ifdef DOUBLE_SIDED\n\n\t\t\t\tvLightBack += lightColor * attenuation * saturate( - dotProduct );\n\n\t\t\t#endif\n\n\t\t}\n\n\t}\n\n#endif\n\n#if MAX_DIR_LIGHTS > 0\n\n\tfor ( int i = 0; i < MAX_DIR_LIGHTS; i ++ ) {\n\n\t\tvec3 lightColor = directionalLightColor[ i ];\n\n\t\tvec3 lightDir = directionalLightDirection[ i ];\n\n\n\t\tfloat dotProduct = dot( normal, lightDir );\n\n\t\tvLightFront += lightColor * saturate( dotProduct );\n\n\t\t#ifdef DOUBLE_SIDED\n\n\t\t\tvLightBack += lightColor * saturate( - dotProduct );\n\n\t\t#endif\n\n\t}\n\n#endif\n\n#if MAX_HEMI_LIGHTS > 0\n\n\tfor ( int i = 0; i < MAX_HEMI_LIGHTS; i ++ ) {\n\n\t\tvec3 lightDir = hemisphereLightDirection[ i ];\n\n\n\t\tfloat dotProduct = dot( normal, lightDir );\n\n\t\tfloat hemiDiffuseWeight = 0.5 * dotProduct + 0.5;\n\n\t\tvLightFront += mix( hemisphereLightGroundColor[ i ], hemisphereLightSkyColor[ i ], hemiDiffuseWeight );\n\n\t\t#ifdef DOUBLE_SIDED\n\n\t\t\tfloat hemiDiffuseWeightBack = - 0.5 * dotProduct + 0.5;\n\n\t\t\tvLightBack += mix( hemisphereLightGroundColor[ i ], hemisphereLightSkyColor[ i ], hemiDiffuseWeightBack );\n\n\t\t#endif\n\n\t}\n\n#endif\n";
THREE.ShaderChunk.lights_phong_fragment="vec3 viewDir = normalize( vViewPosition );\n\nvec3 totalDiffuseLight = vec3( 0.0 );\nvec3 totalSpecularLight = vec3( 0.0 );\n\n#if MAX_POINT_LIGHTS > 0\n\n\tfor ( int i = 0; i < MAX_POINT_LIGHTS; i ++ ) {\n\n\t\tvec3 lightColor = pointLightColor[ i ];\n\n\t\tvec3 lightPosition = pointLightPosition[ i ];\n\t\tvec3 lVector = lightPosition + vViewPosition.xyz;\n\t\tvec3 lightDir = normalize( lVector );\n\n\n\t\tfloat attenuation = calcLightAttenuation( length( lVector ), pointLightDistance[ i ], pointLightDecay[ i ] );\n\n\n\t\tfloat cosineTerm = saturate( dot( normal, lightDir ) );\n\n\t\ttotalDiffuseLight += lightColor * attenuation * cosineTerm;\n\n\n\t\tvec3 brdf = BRDF_BlinnPhong( specular, shininess, normal, lightDir, viewDir );\n\n\t\ttotalSpecularLight += brdf * specularStrength * lightColor * attenuation * cosineTerm;\n\n\n\t}\n\n#endif\n\n#if MAX_SPOT_LIGHTS > 0\n\n\tfor ( int i = 0; i < MAX_SPOT_LIGHTS; i ++ ) {\n\n\t\tvec3 lightColor = spotLightColor[ i ];\n\n\t\tvec3 lightPosition = spotLightPosition[ i ];\n\t\tvec3 lVector = lightPosition + vViewPosition.xyz;\n\t\tvec3 lightDir = normalize( lVector );\n\n\t\tfloat spotEffect = dot( spotLightDirection[ i ], lightDir );\n\n\t\tif ( spotEffect > spotLightAngleCos[ i ] ) {\n\n\t\t\tspotEffect = saturate( pow( saturate( spotEffect ), spotLightExponent[ i ] ) );\n\n\n\t\t\tfloat attenuation = calcLightAttenuation( length( lVector ), spotLightDistance[ i ], spotLightDecay[ i ] );\n\n\t\t\tattenuation *= spotEffect;\n\n\n\t\t\tfloat cosineTerm = saturate( dot( normal, lightDir ) );\n\n\t\t\ttotalDiffuseLight += lightColor * attenuation * cosineTerm;\n\n\n\t\t\tvec3 brdf = BRDF_BlinnPhong( specular, shininess, normal, lightDir, viewDir );\n\n\t\t\ttotalSpecularLight += brdf * specularStrength * lightColor * attenuation * cosineTerm;\n\n\t\t}\n\n\t}\n\n#endif\n\n#if MAX_DIR_LIGHTS > 0\n\n\tfor ( int i = 0; i < MAX_DIR_LIGHTS; i ++ ) {\n\n\t\tvec3 lightColor = directionalLightColor[ i ];\n\n\t\tvec3 lightDir = directionalLightDirection[ i ];\n\n\n\t\tfloat cosineTerm = saturate( dot( normal, lightDir ) );\n\n\t\ttotalDiffuseLight += lightColor * cosineTerm;\n\n\n\t\tvec3 brdf = BRDF_BlinnPhong( specular, shininess, normal, lightDir, viewDir );\n\n\t\ttotalSpecularLight += brdf * specularStrength * lightColor * cosineTerm;\n\n\t}\n\n#endif\n";
THREE.ShaderChunk.lights_phong_pars_fragment="uniform vec3 ambientLightColor;\n\n#if MAX_DIR_LIGHTS > 0\n\n\tuniform vec3 directionalLightColor[ MAX_DIR_LIGHTS ];\n\tuniform vec3 directionalLightDirection[ MAX_DIR_LIGHTS ];\n\n#endif\n\n#if MAX_HEMI_LIGHTS > 0\n\n\tuniform vec3 hemisphereLightSkyColor[ MAX_HEMI_LIGHTS ];\n\tuniform vec3 hemisphereLightGroundColor[ MAX_HEMI_LIGHTS ];\n\tuniform vec3 hemisphereLightDirection[ MAX_HEMI_LIGHTS ];\n\n#endif\n\n#if MAX_POINT_LIGHTS > 0\n\n\tuniform vec3 pointLightColor[ MAX_POINT_LIGHTS ];\n\n\tuniform vec3 pointLightPosition[ MAX_POINT_LIGHTS ];\n\tuniform float pointLightDistance[ MAX_POINT_LIGHTS ];\n\tuniform float pointLightDecay[ MAX_POINT_LIGHTS ];\n\n#endif\n\n#if MAX_SPOT_LIGHTS > 0\n\n\tuniform vec3 spotLightColor[ MAX_SPOT_LIGHTS ];\n\tuniform vec3 spotLightPosition[ MAX_SPOT_LIGHTS ];\n\tuniform vec3 spotLightDirection[ MAX_SPOT_LIGHTS ];\n\tuniform float spotLightAngleCos[ MAX_SPOT_LIGHTS ];\n\tuniform float spotLightExponent[ MAX_SPOT_LIGHTS ];\n\tuniform float spotLightDistance[ MAX_SPOT_LIGHTS ];\n\tuniform float spotLightDecay[ MAX_SPOT_LIGHTS ];\n\n#endif\n\n#if MAX_SPOT_LIGHTS > 0 || defined( USE_ENVMAP )\n\n\tvarying vec3 vWorldPosition;\n\n#endif\n\nvarying vec3 vViewPosition;\n\n#ifndef FLAT_SHADED\n\n\tvarying vec3 vNormal;\n\n#endif\n";
THREE.ShaderChunk.lights_phong_pars_vertex="#if MAX_SPOT_LIGHTS > 0 || defined( USE_ENVMAP )\n\n\tvarying vec3 vWorldPosition;\n\n#endif\n\n#if MAX_POINT_LIGHTS > 0\n\n\tuniform vec3 pointLightPosition[ MAX_POINT_LIGHTS ];\n\n#endif\n";THREE.ShaderChunk.lights_phong_vertex="#if MAX_SPOT_LIGHTS > 0 || defined( USE_ENVMAP )\n\n\tvWorldPosition = worldPosition.xyz;\n\n#endif\n";THREE.ShaderChunk.linear_to_gamma_fragment="\n\toutgoingLight = linearToOutput( outgoingLight );\n";
THREE.ShaderChunk.logdepthbuf_fragment="#if defined(USE_LOGDEPTHBUF) && defined(USE_LOGDEPTHBUF_EXT)\n\n\tgl_FragDepthEXT = log2(vFragDepth) * logDepthBufFC * 0.5;\n\n#endif";THREE.ShaderChunk.logdepthbuf_pars_fragment="#ifdef USE_LOGDEPTHBUF\n\n\tuniform float logDepthBufFC;\n\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\n\t\tvarying float vFragDepth;\n\n\t#endif\n\n#endif\n";THREE.ShaderChunk.logdepthbuf_pars_vertex="#ifdef USE_LOGDEPTHBUF\n\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\n\t\tvarying float vFragDepth;\n\n\t#endif\n\n\tuniform float logDepthBufFC;\n\n#endif";
THREE.ShaderChunk.logdepthbuf_vertex="#ifdef USE_LOGDEPTHBUF\n\n\tgl_Position.z = log2(max( EPSILON, gl_Position.w + 1.0 )) * logDepthBufFC;\n\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\n#else\n\n\t\tgl_Position.z = (gl_Position.z - 1.0) * gl_Position.w;\n\n\t#endif\n\n#endif";THREE.ShaderChunk.map_fragment="#ifdef USE_MAP\n\n\tvec4 texelColor = texture2D( map, vUv );\n\n\ttexelColor.xyz = inputToLinear( texelColor.xyz );\n\n\tdiffuseColor *= texelColor;\n\n#endif\n";
THREE.ShaderChunk.map_pars_fragment="#ifdef USE_MAP\n\n\tuniform sampler2D map;\n\n#endif";THREE.ShaderChunk.map_particle_fragment="#ifdef USE_MAP\n\n\tdiffuseColor *= texture2D( map, vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y ) * offsetRepeat.zw + offsetRepeat.xy );\n\n#endif\n";THREE.ShaderChunk.map_particle_pars_fragment="#ifdef USE_MAP\n\n\tuniform vec4 offsetRepeat;\n\tuniform sampler2D map;\n\n#endif\n";THREE.ShaderChunk.morphnormal_vertex="#ifdef USE_MORPHNORMALS\n\n\tobjectNormal += ( morphNormal0 - normal ) * morphTargetInfluences[ 0 ];\n\tobjectNormal += ( morphNormal1 - normal ) * morphTargetInfluences[ 1 ];\n\tobjectNormal += ( morphNormal2 - normal ) * morphTargetInfluences[ 2 ];\n\tobjectNormal += ( morphNormal3 - normal ) * morphTargetInfluences[ 3 ];\n\n#endif\n";
THREE.ShaderChunk.morphtarget_pars_vertex="#ifdef USE_MORPHTARGETS\n\n\t#ifndef USE_MORPHNORMALS\n\n\tuniform float morphTargetInfluences[ 8 ];\n\n\t#else\n\n\tuniform float morphTargetInfluences[ 4 ];\n\n\t#endif\n\n#endif";THREE.ShaderChunk.morphtarget_vertex="#ifdef USE_MORPHTARGETS\n\n\ttransformed += ( morphTarget0 - position ) * morphTargetInfluences[ 0 ];\n\ttransformed += ( morphTarget1 - position ) * morphTargetInfluences[ 1 ];\n\ttransformed += ( morphTarget2 - position ) * morphTargetInfluences[ 2 ];\n\ttransformed += ( morphTarget3 - position ) * morphTargetInfluences[ 3 ];\n\n\t#ifndef USE_MORPHNORMALS\n\n\ttransformed += ( morphTarget4 - position ) * morphTargetInfluences[ 4 ];\n\ttransformed += ( morphTarget5 - position ) * morphTargetInfluences[ 5 ];\n\ttransformed += ( morphTarget6 - position ) * morphTargetInfluences[ 6 ];\n\ttransformed += ( morphTarget7 - position ) * morphTargetInfluences[ 7 ];\n\n\t#endif\n\n#endif\n";
THREE.ShaderChunk.normal_phong_fragment="#ifndef FLAT_SHADED\n\n\tvec3 normal = normalize( vNormal );\n\n\t#ifdef DOUBLE_SIDED\n\n\t\tnormal = normal * ( -1.0 + 2.0 * float( gl_FrontFacing ) );\n\n\t#endif\n\n#else\n\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n\n#endif\n\n#ifdef USE_NORMALMAP\n\n\tnormal = perturbNormal2Arb( -vViewPosition, normal );\n\n#elif defined( USE_BUMPMAP )\n\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n\n#endif\n\n";
THREE.ShaderChunk.normalmap_pars_fragment="#ifdef USE_NORMALMAP\n\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n\n\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm ) {\n\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\n\t\tvec3 S = normalize( q0 * st1.t - q1 * st0.t );\n\t\tvec3 T = normalize( -q0 * st1.s + q1 * st0.s );\n\t\tvec3 N = normalize( surf_norm );\n\n\t\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t\tmapN.xy = normalScale * mapN.xy;\n\t\tmat3 tsn = mat3( S, T, N );\n\t\treturn normalize( tsn * mapN );\n\n\t}\n\n#endif\n";
THREE.ShaderChunk.project_vertex="#ifdef USE_SKINNING\n\n\tvec4 mvPosition = modelViewMatrix * skinned;\n\n#else\n\n\tvec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\n\n#endif\n\ngl_Position = projectionMatrix * mvPosition;\n";THREE.ShaderChunk.shadowmap_fragment="#ifdef USE_SHADOWMAP\n\n\tfor ( int i = 0; i < MAX_SHADOWS; i ++ ) {\n\n\t\tfloat texelSizeY =  1.0 / shadowMapSize[ i ].y;\n\n\t\tfloat shadow = 0.0;\n\n#if defined( POINT_LIGHT_SHADOWS )\n\n\t\tbool isPointLight = shadowDarkness[ i ] < 0.0;\n\n\t\tif ( isPointLight ) {\n\n\t\t\tfloat realShadowDarkness = abs( shadowDarkness[ i ] );\n\n\t\t\tvec3 lightToPosition = vShadowCoord[ i ].xyz;\n\n\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT )\n\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tfloat dp = length( lightToPosition );\n\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D, texelSizeY ) ), shadowBias[ i ], shadow );\n\n\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tconst float Dr = 1.25;\n\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tconst float Dr = 2.25;\n\t#endif\n\n\t\t\tfloat os = Dr *  2.0 * texelSizeY;\n\n\t\t\tconst vec3 Gsd = vec3( - 1, 0, 1 );\n\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.zzz * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.zxz * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.xxz * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.xzz * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.zzx * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.zxx * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.xxx * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.xzx * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.zzy * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.zxy * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.xxy * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.xzy * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.zyz * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.xyz * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.zyx * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.xyx * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.yzz * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.yxz * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.yxx * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D + Gsd.yzx * os, texelSizeY ) ), shadowBias[ i ], shadow );\n\n\t\t\tshadow *= realShadowDarkness * ( 1.0 / 21.0 );\n\n\t#else \n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tfloat dp = length( lightToPosition );\n\n\t\t\tadjustShadowValue1K( dp, texture2D( shadowMap[ i ], cubeToUV( bd3D, texelSizeY ) ), shadowBias[ i ], shadow );\n\n\t\t\tshadow *= realShadowDarkness;\n\n\t#endif\n\n\t\t} else {\n\n#endif \n\t\t\tfloat texelSizeX =  1.0 / shadowMapSize[ i ].x;\n\n\t\t\tvec3 shadowCoord = vShadowCoord[ i ].xyz / vShadowCoord[ i ].w;\n\n\n\t\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\t\tbool inFrustum = all( inFrustumVec );\n\n\t\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\n\t\t\tbool frustumTest = all( frustumTestVec );\n\n\t\t\tif ( frustumTest ) {\n\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\n\n\t\t\t\t/*\n\t\t\t\t\tfor ( float y = -1.25; y <= 1.25; y += 1.25 )\n\t\t\t\t\t\tfor ( float x = -1.25; x <= 1.25; x += 1.25 ) {\n\t\t\t\t\t\t\tvec4 rgbaDepth = texture2D( shadowMap[ i ], vec2( x * xPixelOffset, y * yPixelOffset ) + shadowCoord.xy );\n\t\t\t\t\t\t\tfloat fDepth = unpackDepth( rgbaDepth );\n\t\t\t\t\t\t\tif ( fDepth < shadowCoord.z )\n\t\t\t\t\t\t\t\tshadow += 1.0;\n\t\t\t\t\t}\n\t\t\t\t\tshadow /= 9.0;\n\t\t\t\t*/\n\n\t\t\t\tshadowCoord.z += shadowBias[ i ];\n\n\t\t\t\tconst float ShadowDelta = 1.0 / 9.0;\n\n\t\t\t\tfloat xPixelOffset = texelSizeX;\n\t\t\t\tfloat yPixelOffset = texelSizeY;\n\n\t\t\t\tfloat dx0 = - 1.25 * xPixelOffset;\n\t\t\t\tfloat dy0 = - 1.25 * yPixelOffset;\n\t\t\t\tfloat dx1 = 1.25 * xPixelOffset;\n\t\t\t\tfloat dy1 = 1.25 * yPixelOffset;\n\n\t\t\t\tfloat fDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx0, dy0 ) ) );\n\t\t\t\tif ( fDepth < shadowCoord.z ) shadow += ShadowDelta;\n\n\t\t\t\tfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( 0.0, dy0 ) ) );\n\t\t\t\tif ( fDepth < shadowCoord.z ) shadow += ShadowDelta;\n\n\t\t\t\tfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx1, dy0 ) ) );\n\t\t\t\tif ( fDepth < shadowCoord.z ) shadow += ShadowDelta;\n\n\t\t\t\tfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx0, 0.0 ) ) );\n\t\t\t\tif ( fDepth < shadowCoord.z ) shadow += ShadowDelta;\n\n\t\t\t\tfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy ) );\n\t\t\t\tif ( fDepth < shadowCoord.z ) shadow += ShadowDelta;\n\n\t\t\t\tfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx1, 0.0 ) ) );\n\t\t\t\tif ( fDepth < shadowCoord.z ) shadow += ShadowDelta;\n\n\t\t\t\tfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx0, dy1 ) ) );\n\t\t\t\tif ( fDepth < shadowCoord.z ) shadow += ShadowDelta;\n\n\t\t\t\tfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( 0.0, dy1 ) ) );\n\t\t\t\tif ( fDepth < shadowCoord.z ) shadow += ShadowDelta;\n\n\t\t\t\tfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx1, dy1 ) ) );\n\t\t\t\tif ( fDepth < shadowCoord.z ) shadow += ShadowDelta;\n\n\t\t\t\tshadow *= shadowDarkness[ i ];\n\n\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\n\n\t\t\t\tshadowCoord.z += shadowBias[ i ];\n\n\t\t\t\tfloat xPixelOffset = texelSizeX;\n\t\t\t\tfloat yPixelOffset = texelSizeY;\n\n\t\t\t\tfloat dx0 = - 1.0 * xPixelOffset;\n\t\t\t\tfloat dy0 = - 1.0 * yPixelOffset;\n\t\t\t\tfloat dx1 = 1.0 * xPixelOffset;\n\t\t\t\tfloat dy1 = 1.0 * yPixelOffset;\n\n\t\t\t\tmat3 shadowKernel;\n\t\t\t\tmat3 depthKernel;\n\n\t\t\t\tdepthKernel[ 0 ][ 0 ] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx0, dy0 ) ) );\n\t\t\t\tdepthKernel[ 0 ][ 1 ] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx0, 0.0 ) ) );\n\t\t\t\tdepthKernel[ 0 ][ 2 ] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx0, dy1 ) ) );\n\t\t\t\tdepthKernel[ 1 ][ 0 ] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( 0.0, dy0 ) ) );\n\t\t\t\tdepthKernel[ 1 ][ 1 ] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy ) );\n\t\t\t\tdepthKernel[ 1 ][ 2 ] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( 0.0, dy1 ) ) );\n\t\t\t\tdepthKernel[ 2 ][ 0 ] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx1, dy0 ) ) );\n\t\t\t\tdepthKernel[ 2 ][ 1 ] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx1, 0.0 ) ) );\n\t\t\t\tdepthKernel[ 2 ][ 2 ] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx1, dy1 ) ) );\n\n\t\t\t\tvec3 shadowZ = vec3( shadowCoord.z );\n\t\t\t\tshadowKernel[ 0 ] = vec3( lessThan( depthKernel[ 0 ], shadowZ ) );\n\t\t\t\tshadowKernel[ 0 ] *= vec3( 0.25 );\n\n\t\t\t\tshadowKernel[ 1 ] = vec3( lessThan( depthKernel[ 1 ], shadowZ ) );\n\t\t\t\tshadowKernel[ 1 ] *= vec3( 0.25 );\n\n\t\t\t\tshadowKernel[ 2 ] = vec3( lessThan( depthKernel[ 2 ], shadowZ ) );\n\t\t\t\tshadowKernel[ 2 ] *= vec3( 0.25 );\n\n\t\t\t\tvec2 fractionalCoord = 1.0 - fract( shadowCoord.xy * shadowMapSize[ i ].xy );\n\n\t\t\t\tshadowKernel[ 0 ] = mix( shadowKernel[ 1 ], shadowKernel[ 0 ], fractionalCoord.x );\n\t\t\t\tshadowKernel[ 1 ] = mix( shadowKernel[ 2 ], shadowKernel[ 1 ], fractionalCoord.x );\n\n\t\t\t\tvec4 shadowValues;\n\t\t\t\tshadowValues.x = mix( shadowKernel[ 0 ][ 1 ], shadowKernel[ 0 ][ 0 ], fractionalCoord.y );\n\t\t\t\tshadowValues.y = mix( shadowKernel[ 0 ][ 2 ], shadowKernel[ 0 ][ 1 ], fractionalCoord.y );\n\t\t\t\tshadowValues.z = mix( shadowKernel[ 1 ][ 1 ], shadowKernel[ 1 ][ 0 ], fractionalCoord.y );\n\t\t\t\tshadowValues.w = mix( shadowKernel[ 1 ][ 2 ], shadowKernel[ 1 ][ 1 ], fractionalCoord.y );\n\n\t\t\t\tshadow = dot( shadowValues, vec4( 1.0 ) ) * shadowDarkness[ i ];\n\n\t#else \n\t\t\t\tshadowCoord.z += shadowBias[ i ];\n\n\t\t\t\tvec4 rgbaDepth = texture2D( shadowMap[ i ], shadowCoord.xy );\n\t\t\t\tfloat fDepth = unpackDepth( rgbaDepth );\n\n\t\t\t\tif ( fDepth < shadowCoord.z )\n\t\t\t\t\tshadow = shadowDarkness[ i ];\n\n\t#endif\n\n\t\t\t}\n\n#ifdef SHADOWMAP_DEBUG\n\n\t\t\tif ( inFrustum ) {\n\n\t\t\t\tif ( i == 0 ) {\n\n\t\t\t\t\toutgoingLight *= vec3( 1.0, 0.5, 0.0 );\n\n\t\t\t\t} else if ( i == 1 ) {\n\n\t\t\t\t\toutgoingLight *= vec3( 0.0, 1.0, 0.8 );\n\n\t\t\t\t} else {\n\n\t\t\t\t\toutgoingLight *= vec3( 0.0, 0.5, 1.0 );\n\n\t\t\t\t}\n\n\t\t\t}\n\n#endif\n\n#if defined( POINT_LIGHT_SHADOWS )\n\n\t\t}\n\n#endif\n\n\t\tshadowMask = shadowMask * vec3( 1.0 - shadow );\n\n\t}\n\n#endif\n";
THREE.ShaderChunk.shadowmap_pars_fragment="#ifdef USE_SHADOWMAP\n\n\tuniform sampler2D shadowMap[ MAX_SHADOWS ];\n\tuniform vec2 shadowMapSize[ MAX_SHADOWS ];\n\n\tuniform float shadowDarkness[ MAX_SHADOWS ];\n\tuniform float shadowBias[ MAX_SHADOWS ];\n\n\tvarying vec4 vShadowCoord[ MAX_SHADOWS ];\n\n\tfloat unpackDepth( const in vec4 rgba_depth ) {\n\n\t\tconst vec4 bit_shift = vec4( 1.0 / ( 256.0 * 256.0 * 256.0 ), 1.0 / ( 256.0 * 256.0 ), 1.0 / 256.0, 1.0 );\n\t\tfloat depth = dot( rgba_depth, bit_shift );\n\t\treturn depth;\n\n\t}\n\n\t#if defined(POINT_LIGHT_SHADOWS)\n\n\n\t\tvoid adjustShadowValue1K( const float testDepth, const vec4 textureData, const float bias, inout float shadowValue ) {\n\n\t\t\tconst vec4 bitSh = vec4( 1.0 / ( 256.0 * 256.0 * 256.0 ), 1.0 / ( 256.0 * 256.0 ), 1.0 / 256.0, 1.0 );\n\t\t\tif ( testDepth >= dot( textureData, bitSh ) * 1000.0 + bias )\n\t\t\t\tshadowValue += 1.0;\n\n\t\t}\n\n\n\t\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\n\n\t\t\tvec3 absV = abs( v );\n\n\n\t\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\t\tabsV *= scaleToCube;\n\n\n\t\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\n\n\n\t\t\tvec2 planar = v.xy;\n\n\t\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\t\tfloat almostOne = 1.0 - almostATexel;\n\n\t\t\tif ( absV.z >= almostOne ) {\n\n\t\t\t\tif ( v.z > 0.0 )\n\t\t\t\t\tplanar.x = 4.0 - v.x;\n\n\t\t\t} else if ( absV.x >= almostOne ) {\n\n\t\t\t\tfloat signX = sign( v.x );\n\t\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\n\t\t\t} else if ( absV.y >= almostOne ) {\n\n\t\t\t\tfloat signY = sign( v.y );\n\t\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\t\tplanar.y = v.z * signY - 2.0;\n\n\t\t\t}\n\n\n\t\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\n\t\t}\n\n\t#endif\n\n#endif\n";
THREE.ShaderChunk.shadowmap_pars_vertex="#ifdef USE_SHADOWMAP\n\n\tuniform float shadowDarkness[ MAX_SHADOWS ];\n\tuniform mat4 shadowMatrix[ MAX_SHADOWS ];\n\tvarying vec4 vShadowCoord[ MAX_SHADOWS ];\n\n#endif";THREE.ShaderChunk.shadowmap_vertex="#ifdef USE_SHADOWMAP\n\n\tfor ( int i = 0; i < MAX_SHADOWS; i ++ ) {\n\n\t\t\tvShadowCoord[ i ] = shadowMatrix[ i ] * worldPosition;\n\n\t}\n\n#endif";THREE.ShaderChunk.skinbase_vertex="#ifdef USE_SKINNING\n\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n\n#endif";
THREE.ShaderChunk.skinning_pars_vertex="#ifdef USE_SKINNING\n\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\n\t#ifdef BONE_TEXTURE\n\n\t\tuniform sampler2D boneTexture;\n\t\tuniform int boneTextureWidth;\n\t\tuniform int boneTextureHeight;\n\n\t\tmat4 getBoneMatrix( const in float i ) {\n\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureWidth ) );\n\t\t\tfloat y = floor( j / float( boneTextureWidth ) );\n\n\t\t\tfloat dx = 1.0 / float( boneTextureWidth );\n\t\t\tfloat dy = 1.0 / float( boneTextureHeight );\n\n\t\t\ty = dy * ( y + 0.5 );\n\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\n\t\t\treturn bone;\n\n\t\t}\n\n\t#else\n\n\t\tuniform mat4 boneGlobalMatrices[ MAX_BONES ];\n\n\t\tmat4 getBoneMatrix( const in float i ) {\n\n\t\t\tmat4 bone = boneGlobalMatrices[ int(i) ];\n\t\t\treturn bone;\n\n\t\t}\n\n\t#endif\n\n#endif\n";
THREE.ShaderChunk.skinning_vertex="#ifdef USE_SKINNING\n\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\tskinned  = bindMatrixInverse * skinned;\n\n#endif\n";THREE.ShaderChunk.skinnormal_vertex="#ifdef USE_SKINNING\n\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix  = bindMatrixInverse * skinMatrix * bindMatrix;\n\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\n#endif\n";
THREE.ShaderChunk.specularmap_fragment="float specularStrength;\n\n#ifdef USE_SPECULARMAP\n\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n\n#else\n\n\tspecularStrength = 1.0;\n\n#endif";THREE.ShaderChunk.specularmap_pars_fragment="#ifdef USE_SPECULARMAP\n\n\tuniform sampler2D specularMap;\n\n#endif";THREE.ShaderChunk.uv2_pars_fragment="#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\n\tvarying vec2 vUv2;\n\n#endif";
THREE.ShaderChunk.uv2_pars_vertex="#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\n#endif";THREE.ShaderChunk.uv2_vertex="#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\n\tvUv2 = uv2;\n\n#endif";THREE.ShaderChunk.uv_pars_fragment="#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP )\n\n\tvarying vec2 vUv;\n\n#endif";
THREE.ShaderChunk.uv_pars_vertex="#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP )\n\n\tvarying vec2 vUv;\n\tuniform vec4 offsetRepeat;\n\n#endif\n";THREE.ShaderChunk.uv_vertex="#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP )\n\n\tvUv = uv * offsetRepeat.zw + offsetRepeat.xy;\n\n#endif";
THREE.ShaderChunk.worldpos_vertex="#if defined( USE_ENVMAP ) || defined( PHONG ) || defined( LAMBERT ) || defined ( USE_SHADOWMAP )\n\n\t#ifdef USE_SKINNING\n\n\t\tvec4 worldPosition = modelMatrix * skinned;\n\n\t#else\n\n\t\tvec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );\n\n\t#endif\n\n#endif\n";
THREE.UniformsUtils={merge:function(a){for(var b={},c=0;c<a.length;c++){var d=this.clone(a[c]),e;for(e in d)b[e]=d[e]}return b},clone:function(a){var b={},c;for(c in a){b[c]={};for(var d in a[c]){var e=a[c][d];e instanceof THREE.Color||e instanceof THREE.Vector2||e instanceof THREE.Vector3||e instanceof THREE.Vector4||e instanceof THREE.Matrix3||e instanceof THREE.Matrix4||e instanceof THREE.Texture?b[c][d]=e.clone():Array.isArray(e)?b[c][d]=e.slice():b[c][d]=e}}return b}};
THREE.UniformsLib={common:{diffuse:{type:"c",value:new THREE.Color(15658734)},opacity:{type:"f",value:1},map:{type:"t",value:null},offsetRepeat:{type:"v4",value:new THREE.Vector4(0,0,1,1)},specularMap:{type:"t",value:null},alphaMap:{type:"t",value:null},envMap:{type:"t",value:null},flipEnvMap:{type:"f",value:-1},reflectivity:{type:"f",value:1},refractionRatio:{type:"f",value:.98}},aomap:{aoMap:{type:"t",value:null},aoMapIntensity:{type:"f",value:1}},lightmap:{lightMap:{type:"t",value:null},lightMapIntensity:{type:"f",
value:1}},emissivemap:{emissiveMap:{type:"t",value:null}},bumpmap:{bumpMap:{type:"t",value:null},bumpScale:{type:"f",value:1}},normalmap:{normalMap:{type:"t",value:null},normalScale:{type:"v2",value:new THREE.Vector2(1,1)}},displacementmap:{displacementMap:{type:"t",value:null},displacementScale:{type:"f",value:1},displacementBias:{type:"f",value:0}},fog:{fogDensity:{type:"f",value:2.5E-4},fogNear:{type:"f",value:1},fogFar:{type:"f",value:2E3},fogColor:{type:"c",value:new THREE.Color(16777215)}},
lights:{ambientLightColor:{type:"fv",value:[]},directionalLightDirection:{type:"fv",value:[]},directionalLightColor:{type:"fv",value:[]},hemisphereLightDirection:{type:"fv",value:[]},hemisphereLightSkyColor:{type:"fv",value:[]},hemisphereLightGroundColor:{type:"fv",value:[]},pointLightColor:{type:"fv",value:[]},pointLightPosition:{type:"fv",value:[]},pointLightDistance:{type:"fv1",value:[]},pointLightDecay:{type:"fv1",value:[]},spotLightColor:{type:"fv",value:[]},spotLightPosition:{type:"fv",value:[]},
spotLightDirection:{type:"fv",value:[]},spotLightDistance:{type:"fv1",value:[]},spotLightAngleCos:{type:"fv1",value:[]},spotLightExponent:{type:"fv1",value:[]},spotLightDecay:{type:"fv1",value:[]}},points:{psColor:{type:"c",value:new THREE.Color(15658734)},opacity:{type:"f",value:1},size:{type:"f",value:1},scale:{type:"f",value:1},map:{type:"t",value:null},offsetRepeat:{type:"v4",value:new THREE.Vector4(0,0,1,1)},fogDensity:{type:"f",value:2.5E-4},fogNear:{type:"f",value:1},fogFar:{type:"f",value:2E3},
fogColor:{type:"c",value:new THREE.Color(16777215)}},shadowmap:{shadowMap:{type:"tv",value:[]},shadowMapSize:{type:"v2v",value:[]},shadowBias:{type:"fv1",value:[]},shadowDarkness:{type:"fv1",value:[]},shadowMatrix:{type:"m4v",value:[]}}};
THREE.ShaderLib={basic:{uniforms:THREE.UniformsUtils.merge([THREE.UniformsLib.common,THREE.UniformsLib.aomap,THREE.UniformsLib.fog,THREE.UniformsLib.shadowmap]),vertexShader:[THREE.ShaderChunk.common,THREE.ShaderChunk.uv_pars_vertex,THREE.ShaderChunk.uv2_pars_vertex,THREE.ShaderChunk.envmap_pars_vertex,THREE.ShaderChunk.color_pars_vertex,THREE.ShaderChunk.morphtarget_pars_vertex,THREE.ShaderChunk.skinning_pars_vertex,THREE.ShaderChunk.shadowmap_pars_vertex,THREE.ShaderChunk.logdepthbuf_pars_vertex,
"void main() {",THREE.ShaderChunk.uv_vertex,THREE.ShaderChunk.uv2_vertex,THREE.ShaderChunk.color_vertex,THREE.ShaderChunk.skinbase_vertex,"\t#ifdef USE_ENVMAP",THREE.ShaderChunk.beginnormal_vertex,THREE.ShaderChunk.morphnormal_vertex,THREE.ShaderChunk.skinnormal_vertex,THREE.ShaderChunk.defaultnormal_vertex,"\t#endif",THREE.ShaderChunk.begin_vertex,THREE.ShaderChunk.morphtarget_vertex,THREE.ShaderChunk.skinning_vertex,THREE.ShaderChunk.project_vertex,THREE.ShaderChunk.logdepthbuf_vertex,THREE.ShaderChunk.worldpos_vertex,
THREE.ShaderChunk.envmap_vertex,THREE.ShaderChunk.shadowmap_vertex,"}"].join("\n"),fragmentShader:["uniform vec3 diffuse;\nuniform float opacity;",THREE.ShaderChunk.common,THREE.ShaderChunk.color_pars_fragment,THREE.ShaderChunk.uv_pars_fragment,THREE.ShaderChunk.uv2_pars_fragment,THREE.ShaderChunk.map_pars_fragment,THREE.ShaderChunk.alphamap_pars_fragment,THREE.ShaderChunk.aomap_pars_fragment,THREE.ShaderChunk.envmap_pars_fragment,THREE.ShaderChunk.fog_pars_fragment,THREE.ShaderChunk.shadowmap_pars_fragment,
THREE.ShaderChunk.specularmap_pars_fragment,THREE.ShaderChunk.logdepthbuf_pars_fragment,"void main() {\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tvec3 totalAmbientLight = vec3( 1.0 );\n\tvec3 shadowMask = vec3( 1.0 );",THREE.ShaderChunk.logdepthbuf_fragment,THREE.ShaderChunk.map_fragment,THREE.ShaderChunk.color_fragment,THREE.ShaderChunk.alphamap_fragment,THREE.ShaderChunk.alphatest_fragment,THREE.ShaderChunk.specularmap_fragment,THREE.ShaderChunk.aomap_fragment,
THREE.ShaderChunk.shadowmap_fragment,"\toutgoingLight = diffuseColor.rgb * totalAmbientLight * shadowMask;",THREE.ShaderChunk.envmap_fragment,THREE.ShaderChunk.linear_to_gamma_fragment,THREE.ShaderChunk.fog_fragment,"\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n}"].join("\n")},lambert:{uniforms:THREE.UniformsUtils.merge([THREE.UniformsLib.common,THREE.UniformsLib.fog,THREE.UniformsLib.lights,THREE.UniformsLib.shadowmap,{emissive:{type:"c",value:new THREE.Color(0)}}]),vertexShader:["#define LAMBERT\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif",
THREE.ShaderChunk.common,THREE.ShaderChunk.uv_pars_vertex,THREE.ShaderChunk.uv2_pars_vertex,THREE.ShaderChunk.envmap_pars_vertex,THREE.ShaderChunk.lights_lambert_pars_vertex,THREE.ShaderChunk.color_pars_vertex,THREE.ShaderChunk.morphtarget_pars_vertex,THREE.ShaderChunk.skinning_pars_vertex,THREE.ShaderChunk.shadowmap_pars_vertex,THREE.ShaderChunk.logdepthbuf_pars_vertex,"void main() {",THREE.ShaderChunk.uv_vertex,THREE.ShaderChunk.uv2_vertex,THREE.ShaderChunk.color_vertex,THREE.ShaderChunk.beginnormal_vertex,
THREE.ShaderChunk.morphnormal_vertex,THREE.ShaderChunk.skinbase_vertex,THREE.ShaderChunk.skinnormal_vertex,THREE.ShaderChunk.defaultnormal_vertex,THREE.ShaderChunk.begin_vertex,THREE.ShaderChunk.morphtarget_vertex,THREE.ShaderChunk.skinning_vertex,THREE.ShaderChunk.project_vertex,THREE.ShaderChunk.logdepthbuf_vertex,THREE.ShaderChunk.worldpos_vertex,THREE.ShaderChunk.envmap_vertex,THREE.ShaderChunk.lights_lambert_vertex,THREE.ShaderChunk.shadowmap_vertex,"}"].join("\n"),fragmentShader:["uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nuniform vec3 ambientLightColor;\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif",
THREE.ShaderChunk.common,THREE.ShaderChunk.color_pars_fragment,THREE.ShaderChunk.uv_pars_fragment,THREE.ShaderChunk.uv2_pars_fragment,THREE.ShaderChunk.map_pars_fragment,THREE.ShaderChunk.alphamap_pars_fragment,THREE.ShaderChunk.envmap_pars_fragment,THREE.ShaderChunk.fog_pars_fragment,THREE.ShaderChunk.shadowmap_pars_fragment,THREE.ShaderChunk.specularmap_pars_fragment,THREE.ShaderChunk.logdepthbuf_pars_fragment,"void main() {\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tvec3 totalAmbientLight = ambientLightColor;\n\tvec3 shadowMask = vec3( 1.0 );",
THREE.ShaderChunk.logdepthbuf_fragment,THREE.ShaderChunk.map_fragment,THREE.ShaderChunk.color_fragment,THREE.ShaderChunk.alphamap_fragment,THREE.ShaderChunk.alphatest_fragment,THREE.ShaderChunk.specularmap_fragment,THREE.ShaderChunk.shadowmap_fragment,"\t#ifdef DOUBLE_SIDED\n\t\tif ( gl_FrontFacing )\n\t\t\toutgoingLight += diffuseColor.rgb * ( vLightFront * shadowMask + totalAmbientLight ) + emissive;\n\t\telse\n\t\t\toutgoingLight += diffuseColor.rgb * ( vLightBack * shadowMask + totalAmbientLight ) + emissive;\n\t#else\n\t\toutgoingLight += diffuseColor.rgb * ( vLightFront * shadowMask + totalAmbientLight ) + emissive;\n\t#endif",
THREE.ShaderChunk.envmap_fragment,THREE.ShaderChunk.linear_to_gamma_fragment,THREE.ShaderChunk.fog_fragment,"\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n}"].join("\n")},phong:{uniforms:THREE.UniformsUtils.merge([THREE.UniformsLib.common,THREE.UniformsLib.aomap,THREE.UniformsLib.lightmap,THREE.UniformsLib.emissivemap,THREE.UniformsLib.bumpmap,THREE.UniformsLib.normalmap,THREE.UniformsLib.displacementmap,THREE.UniformsLib.fog,THREE.UniformsLib.lights,THREE.UniformsLib.shadowmap,{emissive:{type:"c",
value:new THREE.Color(0)},specular:{type:"c",value:new THREE.Color(1118481)},shininess:{type:"f",value:30}}]),vertexShader:["#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif",THREE.ShaderChunk.common,THREE.ShaderChunk.uv_pars_vertex,THREE.ShaderChunk.uv2_pars_vertex,THREE.ShaderChunk.displacementmap_pars_vertex,THREE.ShaderChunk.envmap_pars_vertex,THREE.ShaderChunk.lights_phong_pars_vertex,THREE.ShaderChunk.color_pars_vertex,THREE.ShaderChunk.morphtarget_pars_vertex,
THREE.ShaderChunk.skinning_pars_vertex,THREE.ShaderChunk.shadowmap_pars_vertex,THREE.ShaderChunk.logdepthbuf_pars_vertex,"void main() {",THREE.ShaderChunk.uv_vertex,THREE.ShaderChunk.uv2_vertex,THREE.ShaderChunk.color_vertex,THREE.ShaderChunk.beginnormal_vertex,THREE.ShaderChunk.morphnormal_vertex,THREE.ShaderChunk.skinbase_vertex,THREE.ShaderChunk.skinnormal_vertex,THREE.ShaderChunk.defaultnormal_vertex,"#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif",THREE.ShaderChunk.begin_vertex,
THREE.ShaderChunk.displacementmap_vertex,THREE.ShaderChunk.morphtarget_vertex,THREE.ShaderChunk.skinning_vertex,THREE.ShaderChunk.project_vertex,THREE.ShaderChunk.logdepthbuf_vertex,"\tvViewPosition = - mvPosition.xyz;",THREE.ShaderChunk.worldpos_vertex,THREE.ShaderChunk.envmap_vertex,THREE.ShaderChunk.lights_phong_vertex,THREE.ShaderChunk.shadowmap_vertex,"}"].join("\n"),fragmentShader:["#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;",
THREE.ShaderChunk.common,THREE.ShaderChunk.color_pars_fragment,THREE.ShaderChunk.uv_pars_fragment,THREE.ShaderChunk.uv2_pars_fragment,THREE.ShaderChunk.map_pars_fragment,THREE.ShaderChunk.alphamap_pars_fragment,THREE.ShaderChunk.aomap_pars_fragment,THREE.ShaderChunk.lightmap_pars_fragment,THREE.ShaderChunk.emissivemap_pars_fragment,THREE.ShaderChunk.envmap_pars_fragment,THREE.ShaderChunk.fog_pars_fragment,THREE.ShaderChunk.lights_phong_pars_fragment,THREE.ShaderChunk.shadowmap_pars_fragment,THREE.ShaderChunk.bumpmap_pars_fragment,
THREE.ShaderChunk.normalmap_pars_fragment,THREE.ShaderChunk.specularmap_pars_fragment,THREE.ShaderChunk.logdepthbuf_pars_fragment,"void main() {\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tvec3 totalAmbientLight = ambientLightColor;\n\tvec3 totalEmissiveLight = emissive;\n\tvec3 shadowMask = vec3( 1.0 );",THREE.ShaderChunk.logdepthbuf_fragment,THREE.ShaderChunk.map_fragment,THREE.ShaderChunk.color_fragment,THREE.ShaderChunk.alphamap_fragment,THREE.ShaderChunk.alphatest_fragment,
THREE.ShaderChunk.specularmap_fragment,THREE.ShaderChunk.normal_phong_fragment,THREE.ShaderChunk.lightmap_fragment,THREE.ShaderChunk.hemilight_fragment,THREE.ShaderChunk.aomap_fragment,THREE.ShaderChunk.emissivemap_fragment,THREE.ShaderChunk.lights_phong_fragment,THREE.ShaderChunk.shadowmap_fragment,"totalDiffuseLight *= shadowMask;\ntotalSpecularLight *= shadowMask;\n#ifdef METAL\n\toutgoingLight += diffuseColor.rgb * ( totalDiffuseLight + totalAmbientLight ) * specular + totalSpecularLight + totalEmissiveLight;\n#else\n\toutgoingLight += diffuseColor.rgb * ( totalDiffuseLight + totalAmbientLight ) + totalSpecularLight + totalEmissiveLight;\n#endif",
THREE.ShaderChunk.envmap_fragment,THREE.ShaderChunk.linear_to_gamma_fragment,THREE.ShaderChunk.fog_fragment,"\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n}"].join("\n")},points:{uniforms:THREE.UniformsUtils.merge([THREE.UniformsLib.points,THREE.UniformsLib.shadowmap]),vertexShader:["uniform float size;\nuniform float scale;",THREE.ShaderChunk.common,THREE.ShaderChunk.color_pars_vertex,THREE.ShaderChunk.shadowmap_pars_vertex,THREE.ShaderChunk.logdepthbuf_pars_vertex,"void main() {",THREE.ShaderChunk.color_vertex,
"\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\t#ifdef USE_SIZEATTENUATION\n\t\tgl_PointSize = size * ( scale / length( mvPosition.xyz ) );\n\t#else\n\t\tgl_PointSize = size;\n\t#endif\n\tgl_Position = projectionMatrix * mvPosition;",THREE.ShaderChunk.logdepthbuf_vertex,THREE.ShaderChunk.worldpos_vertex,THREE.ShaderChunk.shadowmap_vertex,"}"].join("\n"),fragmentShader:["uniform vec3 psColor;\nuniform float opacity;",THREE.ShaderChunk.common,THREE.ShaderChunk.color_pars_fragment,THREE.ShaderChunk.map_particle_pars_fragment,
THREE.ShaderChunk.fog_pars_fragment,THREE.ShaderChunk.shadowmap_pars_fragment,THREE.ShaderChunk.logdepthbuf_pars_fragment,"void main() {\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( psColor, opacity );\n\tvec3 shadowMask = vec3( 1.0 );",THREE.ShaderChunk.logdepthbuf_fragment,THREE.ShaderChunk.map_particle_fragment,THREE.ShaderChunk.color_fragment,THREE.ShaderChunk.alphatest_fragment,THREE.ShaderChunk.shadowmap_fragment,"\toutgoingLight = diffuseColor.rgb * shadowMask;",THREE.ShaderChunk.fog_fragment,
"\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n}"].join("\n")},dashed:{uniforms:THREE.UniformsUtils.merge([THREE.UniformsLib.common,THREE.UniformsLib.fog,{scale:{type:"f",value:1},dashSize:{type:"f",value:1},totalSize:{type:"f",value:2}}]),vertexShader:["uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;",THREE.ShaderChunk.common,THREE.ShaderChunk.color_pars_vertex,THREE.ShaderChunk.logdepthbuf_pars_vertex,"void main() {",THREE.ShaderChunk.color_vertex,"\tvLineDistance = scale * lineDistance;\n\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\tgl_Position = projectionMatrix * mvPosition;",
THREE.ShaderChunk.logdepthbuf_vertex,"}"].join("\n"),fragmentShader:["uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;",THREE.ShaderChunk.common,THREE.ShaderChunk.color_pars_fragment,THREE.ShaderChunk.fog_pars_fragment,THREE.ShaderChunk.logdepthbuf_pars_fragment,"void main() {\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );",
THREE.ShaderChunk.logdepthbuf_fragment,THREE.ShaderChunk.color_fragment,"\toutgoingLight = diffuseColor.rgb;",THREE.ShaderChunk.fog_fragment,"\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n}"].join("\n")},depth:{uniforms:{mNear:{type:"f",value:1},mFar:{type:"f",value:2E3},opacity:{type:"f",value:1}},vertexShader:[THREE.ShaderChunk.common,THREE.ShaderChunk.morphtarget_pars_vertex,THREE.ShaderChunk.logdepthbuf_pars_vertex,"void main() {",THREE.ShaderChunk.begin_vertex,THREE.ShaderChunk.morphtarget_vertex,
THREE.ShaderChunk.project_vertex,THREE.ShaderChunk.logdepthbuf_vertex,"}"].join("\n"),fragmentShader:["uniform float mNear;\nuniform float mFar;\nuniform float opacity;",THREE.ShaderChunk.common,THREE.ShaderChunk.logdepthbuf_pars_fragment,"void main() {",THREE.ShaderChunk.logdepthbuf_fragment,"\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tfloat depth = gl_FragDepthEXT / gl_FragCoord.w;\n\t#else\n\t\tfloat depth = gl_FragCoord.z / gl_FragCoord.w;\n\t#endif\n\tfloat color = 1.0 - smoothstep( mNear, mFar, depth );\n\tgl_FragColor = vec4( vec3( color ), opacity );\n}"].join("\n")},
normal:{uniforms:{opacity:{type:"f",value:1}},vertexShader:["varying vec3 vNormal;",THREE.ShaderChunk.common,THREE.ShaderChunk.morphtarget_pars_vertex,THREE.ShaderChunk.logdepthbuf_pars_vertex,"void main() {\n\tvNormal = normalize( normalMatrix * normal );",THREE.ShaderChunk.begin_vertex,THREE.ShaderChunk.morphtarget_vertex,THREE.ShaderChunk.project_vertex,THREE.ShaderChunk.logdepthbuf_vertex,"}"].join("\n"),fragmentShader:["uniform float opacity;\nvarying vec3 vNormal;",THREE.ShaderChunk.common,
THREE.ShaderChunk.logdepthbuf_pars_fragment,"void main() {\n\tgl_FragColor = vec4( 0.5 * normalize( vNormal ) + 0.5, opacity );",THREE.ShaderChunk.logdepthbuf_fragment,"}"].join("\n")},cube:{uniforms:{tCube:{type:"t",value:null},tFlip:{type:"f",value:-1}},vertexShader:["varying vec3 vWorldPosition;",THREE.ShaderChunk.common,THREE.ShaderChunk.logdepthbuf_pars_vertex,"void main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",
THREE.ShaderChunk.logdepthbuf_vertex,"}"].join("\n"),fragmentShader:["uniform samplerCube tCube;\nuniform float tFlip;\nvarying vec3 vWorldPosition;",THREE.ShaderChunk.common,THREE.ShaderChunk.logdepthbuf_pars_fragment,"void main() {\n\tgl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );",THREE.ShaderChunk.logdepthbuf_fragment,"}"].join("\n")},equirect:{uniforms:{tEquirect:{type:"t",value:null},tFlip:{type:"f",value:-1}},vertexShader:["varying vec3 vWorldPosition;",
THREE.ShaderChunk.common,THREE.ShaderChunk.logdepthbuf_pars_vertex,"void main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",THREE.ShaderChunk.logdepthbuf_vertex,"}"].join("\n"),fragmentShader:["uniform sampler2D tEquirect;\nuniform float tFlip;\nvarying vec3 vWorldPosition;",THREE.ShaderChunk.common,THREE.ShaderChunk.logdepthbuf_pars_fragment,"void main() {\nvec3 direction = normalize( vWorldPosition );\nvec2 sampleUV;\nsampleUV.y = saturate( tFlip * direction.y * -0.5 + 0.5 );\nsampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;\ngl_FragColor = texture2D( tEquirect, sampleUV );",
THREE.ShaderChunk.logdepthbuf_fragment,"}"].join("\n")},depthRGBA:{uniforms:{},vertexShader:[THREE.ShaderChunk.common,THREE.ShaderChunk.morphtarget_pars_vertex,THREE.ShaderChunk.skinning_pars_vertex,THREE.ShaderChunk.logdepthbuf_pars_vertex,"void main() {",THREE.ShaderChunk.skinbase_vertex,THREE.ShaderChunk.begin_vertex,THREE.ShaderChunk.morphtarget_vertex,THREE.ShaderChunk.skinning_vertex,THREE.ShaderChunk.project_vertex,THREE.ShaderChunk.logdepthbuf_vertex,"}"].join("\n"),fragmentShader:[THREE.ShaderChunk.common,
THREE.ShaderChunk.logdepthbuf_pars_fragment,"vec4 pack_depth( const in float depth ) {\n\tconst vec4 bit_shift = vec4( 256.0 * 256.0 * 256.0, 256.0 * 256.0, 256.0, 1.0 );\n\tconst vec4 bit_mask = vec4( 0.0, 1.0 / 256.0, 1.0 / 256.0, 1.0 / 256.0 );\n\tvec4 res = mod( depth * bit_shift * vec4( 255 ), vec4( 256 ) ) / vec4( 255 );\n\tres -= res.xxyz * bit_mask;\n\treturn res;\n}\nvoid main() {",THREE.ShaderChunk.logdepthbuf_fragment,"\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tgl_FragData[ 0 ] = pack_depth( gl_FragDepthEXT );\n\t#else\n\t\tgl_FragData[ 0 ] = pack_depth( gl_FragCoord.z );\n\t#endif\n}"].join("\n")},
distanceRGBA:{uniforms:{lightPos:{type:"v3",value:new THREE.Vector3(0,0,0)}},vertexShader:["varying vec4 vWorldPosition;",THREE.ShaderChunk.common,THREE.ShaderChunk.morphtarget_pars_vertex,THREE.ShaderChunk.skinning_pars_vertex,"void main() {",THREE.ShaderChunk.skinbase_vertex,THREE.ShaderChunk.begin_vertex,THREE.ShaderChunk.morphtarget_vertex,THREE.ShaderChunk.skinning_vertex,THREE.ShaderChunk.project_vertex,THREE.ShaderChunk.worldpos_vertex,"vWorldPosition = worldPosition;\n}"].join("\n"),fragmentShader:["uniform vec3 lightPos;\nvarying vec4 vWorldPosition;",
THREE.ShaderChunk.common,"vec4 pack1K ( float depth ) {\n   depth /= 1000.0;\n   const vec4 bitSh = vec4( 256.0 * 256.0 * 256.0, 256.0 * 256.0, 256.0, 1.0 );\n\tconst vec4 bitMsk = vec4( 0.0, 1.0 / 256.0, 1.0 / 256.0, 1.0 / 256.0 );\n\tvec4 res = fract( depth * bitSh );\n\tres -= res.xxyz * bitMsk;\n\treturn res; \n}\nfloat unpack1K ( vec4 color ) {\n\tconst vec4 bitSh = vec4( 1.0 / ( 256.0 * 256.0 * 256.0 ), 1.0 / ( 256.0 * 256.0 ), 1.0 / 256.0, 1.0 );\n\treturn dot( color, bitSh ) * 1000.0;\n}\nvoid main () {\n\tgl_FragColor = pack1K( length( vWorldPosition.xyz - lightPos.xyz ) );\n}"].join("\n")}};
THREE.WebGLRenderer=function(a){function b(a,b,c,d){!0===G&&(a*=d,b*=d,c*=d);r.clearColor(a,b,c,d)}function c(){I.init();r.viewport(na,oa,pa,qa);b(U.r,U.g,U.b,X)}function d(){ra=Aa=null;sa="";ta=-1;wa=!0;I.reset()}function e(a){a.preventDefault();d();c();W.clear()}function g(a){a=a.target;a.removeEventListener("dispose",g);a:{var b=W.get(a);if(a.image&&b.__image__webglTextureCube)r.deleteTexture(b.__image__webglTextureCube);else{if(void 0===b.__webglInit)break a;r.deleteTexture(b.__webglTexture)}W.delete(a)}la.textures--}
function f(a){a=a.target;a.removeEventListener("dispose",f);var b=W.get(a),c=W.get(a.texture);if(a&&void 0!==c.__webglTexture){r.deleteTexture(c.__webglTexture);if(a instanceof THREE.WebGLRenderTargetCube)for(c=0;6>c;c++)r.deleteFramebuffer(b.__webglFramebuffer[c]),r.deleteRenderbuffer(b.__webglRenderbuffer[c]);else r.deleteFramebuffer(b.__webglFramebuffer),r.deleteRenderbuffer(b.__webglRenderbuffer);W.delete(a.texture);W.delete(a)}la.textures--}function h(a){a=a.target;a.removeEventListener("dispose",
h);l(a);W.delete(a)}function l(a){var b=W.get(a).program;a.program=void 0;void 0!==b&&ua.releaseProgram(b)}function k(a,b){return b[0]-a[0]}function m(a,b){return a.object.renderOrder!==b.object.renderOrder?a.object.renderOrder-b.object.renderOrder:a.material.id!==b.material.id?a.material.id-b.material.id:a.z!==b.z?a.z-b.z:a.id-b.id}function p(a,b){return a.object.renderOrder!==b.object.renderOrder?a.object.renderOrder-b.object.renderOrder:a.z!==b.z?b.z-a.z:a.id-b.id}function n(a,b,c,d,e){var f;c.transparent?
(d=Z,f=++fa):(d=ca,f=++ga);f=d[f];void 0!==f?(f.id=a.id,f.object=a,f.geometry=b,f.material=c,f.z=V.z,f.group=e):(f={id:a.id,object:a,geometry:b,material:c,z:V.z,group:e},d.push(f))}function q(a,b){if(!1!==a.visible){if(0!==(a.channels.mask&b.channels.mask))if(a instanceof THREE.Light)da.push(a);else if(a instanceof THREE.Sprite)ea.push(a);else if(a instanceof THREE.LensFlare)ja.push(a);else if(a instanceof THREE.ImmediateRenderObject)!0===aa.sortObjects&&(V.setFromMatrixPosition(a.matrixWorld),V.applyProjection(xa)),
n(a,null,a.material,V.z,null);else if(a instanceof THREE.Mesh||a instanceof THREE.Line||a instanceof THREE.Points)if(a instanceof THREE.SkinnedMesh&&a.skeleton.update(),!1===a.frustumCulled||!0===Ba.intersectsObject(a)){var c=a.material;if(!0===c.visible){!0===aa.sortObjects&&(V.setFromMatrixPosition(a.matrixWorld),V.applyProjection(xa));var d=va.update(a);if(c instanceof THREE.MeshFaceMaterial)for(var e=d.groups,f=c.materials,c=0,g=e.length;c<g;c++){var h=e[c],l=f[h.materialIndex];!0===l.visible&&
n(a,d,l,V.z,h)}else n(a,d,c,V.z,null)}}d=a.children;c=0;for(g=d.length;c<g;c++)q(d[c],b)}}function s(a,b,c,d,e){for(var f=0,g=a.length;f<g;f++){var h=a[f],l=h.object,k=h.geometry,n=void 0===e?h.material:e,h=h.group;l.modelViewMatrix.multiplyMatrices(b.matrixWorldInverse,l.matrixWorld);l.normalMatrix.getNormalMatrix(l.modelViewMatrix);if(l instanceof THREE.ImmediateRenderObject){t(n);var m=v(b,c,d,n,l);sa="";l.render(function(a){aa.renderBufferImmediate(a,m,n)})}else aa.renderBufferDirect(b,c,d,k,
n,l,h)}}function t(a){a.side!==THREE.DoubleSide?I.enable(r.CULL_FACE):I.disable(r.CULL_FACE);I.setFlipSided(a.side===THREE.BackSide);!0===a.transparent?I.setBlending(a.blending,a.blendEquation,a.blendSrc,a.blendDst,a.blendEquationAlpha,a.blendSrcAlpha,a.blendDstAlpha):I.setBlending(THREE.NoBlending);I.setDepthFunc(a.depthFunc);I.setDepthTest(a.depthTest);I.setDepthWrite(a.depthWrite);I.setColorWrite(a.colorWrite);I.setPolygonOffset(a.polygonOffset,a.polygonOffsetFactor,a.polygonOffsetUnits)}function v(a,
b,c,d,e){ya=0;var f=W.get(d);if(d.needsUpdate||!f.program){a:{var g=W.get(d),k=ua.getParameters(d,b,c,e),n=ua.getProgramCode(d,k),m=g.program,q=!0;if(void 0===m)d.addEventListener("dispose",h);else if(m.code!==n)l(d);else if(void 0!==k.shaderID)break a;else q=!1;q&&(k.shaderID?(m=THREE.ShaderLib[k.shaderID],g.__webglShader={name:d.type,uniforms:THREE.UniformsUtils.clone(m.uniforms),vertexShader:m.vertexShader,fragmentShader:m.fragmentShader}):g.__webglShader={name:d.type,uniforms:d.uniforms,vertexShader:d.vertexShader,
fragmentShader:d.fragmentShader},d.__webglShader=g.__webglShader,m=ua.acquireProgram(d,k,n),g.program=m,d.program=m);k=m.getAttributes();if(d.morphTargets)for(n=d.numSupportedMorphTargets=0;n<aa.maxMorphTargets;n++)0<=k["morphTarget"+n]&&d.numSupportedMorphTargets++;if(d.morphNormals)for(n=d.numSupportedMorphNormals=0;n<aa.maxMorphNormals;n++)0<=k["morphNormal"+n]&&d.numSupportedMorphNormals++;g.uniformsList=[];var k=g.program.getUniforms(),p;for(p in g.__webglShader.uniforms)(n=k[p])&&g.uniformsList.push([g.__webglShader.uniforms[p],
n])}d.needsUpdate=!1}n=m=q=!1;g=f.program;p=g.getUniforms();k=f.__webglShader.uniforms;g.id!==Aa&&(r.useProgram(g.program),Aa=g.id,n=m=q=!0);d.id!==ta&&(-1===ta&&(n=!0),ta=d.id,m=!0);if(q||a!==ra)r.uniformMatrix4fv(p.projectionMatrix,!1,a.projectionMatrix.elements),ha.logarithmicDepthBuffer&&r.uniform1f(p.logDepthBufFC,2/(Math.log(a.far+1)/Math.LN2)),a!==ra&&(ra=a),(d instanceof THREE.ShaderMaterial||d instanceof THREE.MeshPhongMaterial||d.envMap)&&void 0!==p.cameraPosition&&(V.setFromMatrixPosition(a.matrixWorld),
r.uniform3f(p.cameraPosition,V.x,V.y,V.z)),(d instanceof THREE.MeshPhongMaterial||d instanceof THREE.MeshLambertMaterial||d instanceof THREE.MeshBasicMaterial||d instanceof THREE.ShaderMaterial||d.skinning)&&void 0!==p.viewMatrix&&r.uniformMatrix4fv(p.viewMatrix,!1,a.matrixWorldInverse.elements);d.skinning&&(e.bindMatrix&&void 0!==p.bindMatrix&&r.uniformMatrix4fv(p.bindMatrix,!1,e.bindMatrix.elements),e.bindMatrixInverse&&void 0!==p.bindMatrixInverse&&r.uniformMatrix4fv(p.bindMatrixInverse,!1,e.bindMatrixInverse.elements),
ha.floatVertexTextures&&e.skeleton&&e.skeleton.useVertexTexture?(void 0!==p.boneTexture&&(q=w(),r.uniform1i(p.boneTexture,q),aa.setTexture(e.skeleton.boneTexture,q)),void 0!==p.boneTextureWidth&&r.uniform1i(p.boneTextureWidth,e.skeleton.boneTextureWidth),void 0!==p.boneTextureHeight&&r.uniform1i(p.boneTextureHeight,e.skeleton.boneTextureHeight)):e.skeleton&&e.skeleton.boneMatrices&&void 0!==p.boneGlobalMatrices&&r.uniformMatrix4fv(p.boneGlobalMatrices,!1,e.skeleton.boneMatrices));if(m){c&&d.fog&&
(k.fogColor.value=c.color,c instanceof THREE.Fog?(k.fogNear.value=c.near,k.fogFar.value=c.far):c instanceof THREE.FogExp2&&(k.fogDensity.value=c.density));if(d instanceof THREE.MeshPhongMaterial||d instanceof THREE.MeshLambertMaterial||d.lights){if(wa){var n=!0,s,t=q=0,x=0,v,F,C,y=Ca,E=a.matrixWorldInverse,B=y.directional.colors,K=y.directional.positions,O=y.point.colors,N=y.point.positions,M=y.point.distances,G=y.point.decays,J=y.spot.colors,H=y.spot.positions,Q=y.spot.distances,I=y.spot.directions,
da=y.spot.anglesCos,T=y.spot.exponents,R=y.spot.decays,Z=y.hemi.skyColors,ga=y.hemi.groundColors,S=y.hemi.positions,ca=0,U=0,ea=0,fa=0,ja=0,ma=0,X=0,$=0,ba=s=0;c=C=ba=0;for(m=b.length;c<m;c++)s=b[c],v=s.color,F=s.intensity,C=s.distance,s instanceof THREE.AmbientLight?s.visible&&(q+=v.r,t+=v.g,x+=v.b):s instanceof THREE.DirectionalLight?(ja+=1,s.visible&&(Y.setFromMatrixPosition(s.matrixWorld),V.setFromMatrixPosition(s.target.matrixWorld),Y.sub(V),Y.transformDirection(E),s=3*ca,K[s+0]=Y.x,K[s+1]=Y.y,
K[s+2]=Y.z,D(B,s,v,F),ca+=1)):s instanceof THREE.PointLight?(ma+=1,s.visible&&(ba=3*U,D(O,ba,v,F),V.setFromMatrixPosition(s.matrixWorld),V.applyMatrix4(E),N[ba+0]=V.x,N[ba+1]=V.y,N[ba+2]=V.z,M[U]=C,G[U]=0===s.distance?0:s.decay,U+=1)):s instanceof THREE.SpotLight?(X+=1,s.visible&&(ba=3*ea,D(J,ba,v,F),Y.setFromMatrixPosition(s.matrixWorld),V.copy(Y).applyMatrix4(E),H[ba+0]=V.x,H[ba+1]=V.y,H[ba+2]=V.z,Q[ea]=C,V.setFromMatrixPosition(s.target.matrixWorld),Y.sub(V),Y.transformDirection(E),I[ba+0]=Y.x,
I[ba+1]=Y.y,I[ba+2]=Y.z,da[ea]=Math.cos(s.angle),T[ea]=s.exponent,R[ea]=0===s.distance?0:s.decay,ea+=1)):s instanceof THREE.HemisphereLight&&($+=1,s.visible&&(Y.setFromMatrixPosition(s.matrixWorld),Y.transformDirection(E),C=3*fa,S[C+0]=Y.x,S[C+1]=Y.y,S[C+2]=Y.z,v=s.color,s=s.groundColor,D(Z,C,v,F),D(ga,C,s,F),fa+=1));c=3*ca;for(m=Math.max(B.length,3*ja);c<m;c++)B[c]=0;c=3*U;for(m=Math.max(O.length,3*ma);c<m;c++)O[c]=0;c=3*ea;for(m=Math.max(J.length,3*X);c<m;c++)J[c]=0;c=3*fa;for(m=Math.max(Z.length,
3*$);c<m;c++)Z[c]=0;c=3*fa;for(m=Math.max(ga.length,3*$);c<m;c++)ga[c]=0;y.directional.length=ca;y.point.length=U;y.spot.length=ea;y.hemi.length=fa;y.ambient[0]=q;y.ambient[1]=t;y.ambient[2]=x;wa=!1}n?(n=Ca,k.ambientLightColor.value=n.ambient,k.directionalLightColor.value=n.directional.colors,k.directionalLightDirection.value=n.directional.positions,k.pointLightColor.value=n.point.colors,k.pointLightPosition.value=n.point.positions,k.pointLightDistance.value=n.point.distances,k.pointLightDecay.value=
n.point.decays,k.spotLightColor.value=n.spot.colors,k.spotLightPosition.value=n.spot.positions,k.spotLightDistance.value=n.spot.distances,k.spotLightDirection.value=n.spot.directions,k.spotLightAngleCos.value=n.spot.anglesCos,k.spotLightExponent.value=n.spot.exponents,k.spotLightDecay.value=n.spot.decays,k.hemisphereLightSkyColor.value=n.hemi.skyColors,k.hemisphereLightGroundColor.value=n.hemi.groundColors,k.hemisphereLightDirection.value=n.hemi.positions,u(k,!0)):u(k,!1)}if(d instanceof THREE.MeshBasicMaterial||
d instanceof THREE.MeshLambertMaterial||d instanceof THREE.MeshPhongMaterial){k.opacity.value=d.opacity;k.diffuse.value=d.color;d.emissive&&(k.emissive.value=d.emissive);k.map.value=d.map;k.specularMap.value=d.specularMap;k.alphaMap.value=d.alphaMap;d.aoMap&&(k.aoMap.value=d.aoMap,k.aoMapIntensity.value=d.aoMapIntensity);var P;d.map?P=d.map:d.specularMap?P=d.specularMap:d.displacementMap?P=d.displacementMap:d.normalMap?P=d.normalMap:d.bumpMap?P=d.bumpMap:d.alphaMap?P=d.alphaMap:d.emissiveMap&&(P=
d.emissiveMap);void 0!==P&&(P instanceof THREE.WebGLRenderTarget&&(P=P.texture),n=P.offset,P=P.repeat,k.offsetRepeat.value.set(n.x,n.y,P.x,P.y));k.envMap.value=d.envMap;k.flipEnvMap.value=d.envMap instanceof THREE.WebGLRenderTargetCube?1:-1;k.reflectivity.value=d.reflectivity;k.refractionRatio.value=d.refractionRatio}d instanceof THREE.LineBasicMaterial?(k.diffuse.value=d.color,k.opacity.value=d.opacity):d instanceof THREE.LineDashedMaterial?(k.diffuse.value=d.color,k.opacity.value=d.opacity,k.dashSize.value=
d.dashSize,k.totalSize.value=d.dashSize+d.gapSize,k.scale.value=d.scale):d instanceof THREE.PointsMaterial?(k.psColor.value=d.color,k.opacity.value=d.opacity,k.size.value=d.size,k.scale.value=L.height/2,k.map.value=d.map,null!==d.map&&(a=d.map.offset,P=d.map.repeat,k.offsetRepeat.value.set(a.x,a.y,P.x,P.y))):d instanceof THREE.MeshPhongMaterial?(k.specular.value=d.specular,k.shininess.value=Math.max(d.shininess,1E-4),d.lightMap&&(k.lightMap.value=d.lightMap,k.lightMapIntensity.value=d.lightMapIntensity),
d.emissiveMap&&(k.emissiveMap.value=d.emissiveMap),d.bumpMap&&(k.bumpMap.value=d.bumpMap,k.bumpScale.value=d.bumpScale),d.normalMap&&(k.normalMap.value=d.normalMap,k.normalScale.value.copy(d.normalScale)),d.displacementMap&&(k.displacementMap.value=d.displacementMap,k.displacementScale.value=d.displacementScale,k.displacementBias.value=d.displacementBias)):d instanceof THREE.MeshDepthMaterial?(k.mNear.value=a.near,k.mFar.value=a.far,k.opacity.value=d.opacity):d instanceof THREE.MeshNormalMaterial&&
(k.opacity.value=d.opacity);if(e.receiveShadow&&!d._shadowPass&&k.shadowMatrix)for(a=d=0,P=b.length;a<P;a++)n=b[a],!0===n.castShadow&&(n instanceof THREE.PointLight||n instanceof THREE.SpotLight||n instanceof THREE.DirectionalLight)&&(c=n.shadow,n instanceof THREE.PointLight?(V.setFromMatrixPosition(n.matrixWorld).negate(),c.matrix.identity().setPosition(V),k.shadowDarkness.value[d]=-c.darkness):k.shadowDarkness.value[d]=c.darkness,k.shadowMatrix.value[d]=c.matrix,k.shadowMap.value[d]=c.map,k.shadowMapSize.value[d]=
c.mapSize,k.shadowBias.value[d]=c.bias,d++);b=f.uniformsList;f=0;for(d=b.length;f<d;f++)if(a=b[f][0],!1!==a.needsUpdate)switch(k=a.type,c=a.value,P=b[f][1],k){case "1i":r.uniform1i(P,c);break;case "1f":r.uniform1f(P,c);break;case "2f":r.uniform2f(P,c[0],c[1]);break;case "3f":r.uniform3f(P,c[0],c[1],c[2]);break;case "4f":r.uniform4f(P,c[0],c[1],c[2],c[3]);break;case "1iv":r.uniform1iv(P,c);break;case "3iv":r.uniform3iv(P,c);break;case "1fv":r.uniform1fv(P,c);break;case "2fv":r.uniform2fv(P,c);break;
case "3fv":r.uniform3fv(P,c);break;case "4fv":r.uniform4fv(P,c);break;case "Matrix3fv":r.uniformMatrix3fv(P,!1,c);break;case "Matrix4fv":r.uniformMatrix4fv(P,!1,c);break;case "i":r.uniform1i(P,c);break;case "f":r.uniform1f(P,c);break;case "v2":r.uniform2f(P,c.x,c.y);break;case "v3":r.uniform3f(P,c.x,c.y,c.z);break;case "v4":r.uniform4f(P,c.x,c.y,c.z,c.w);break;case "c":r.uniform3f(P,c.r,c.g,c.b);break;case "iv1":r.uniform1iv(P,c);break;case "iv":r.uniform3iv(P,c);break;case "fv1":r.uniform1fv(P,c);
break;case "fv":r.uniform3fv(P,c);break;case "v2v":void 0===a._array&&(a._array=new Float32Array(2*c.length));m=k=0;for(n=c.length;k<n;k++,m+=2)a._array[m+0]=c[k].x,a._array[m+1]=c[k].y;r.uniform2fv(P,a._array);break;case "v3v":void 0===a._array&&(a._array=new Float32Array(3*c.length));m=k=0;for(n=c.length;k<n;k++,m+=3)a._array[m+0]=c[k].x,a._array[m+1]=c[k].y,a._array[m+2]=c[k].z;r.uniform3fv(P,a._array);break;case "v4v":void 0===a._array&&(a._array=new Float32Array(4*c.length));m=k=0;for(n=c.length;k<
n;k++,m+=4)a._array[m+0]=c[k].x,a._array[m+1]=c[k].y,a._array[m+2]=c[k].z,a._array[m+3]=c[k].w;r.uniform4fv(P,a._array);break;case "m3":r.uniformMatrix3fv(P,!1,c.elements);break;case "m3v":void 0===a._array&&(a._array=new Float32Array(9*c.length));k=0;for(n=c.length;k<n;k++)c[k].flattenToArrayOffset(a._array,9*k);r.uniformMatrix3fv(P,!1,a._array);break;case "m4":r.uniformMatrix4fv(P,!1,c.elements);break;case "m4v":void 0===a._array&&(a._array=new Float32Array(16*c.length));k=0;for(n=c.length;k<n;k++)c[k].flattenToArrayOffset(a._array,
16*k);r.uniformMatrix4fv(P,!1,a._array);break;case "t":m=w();r.uniform1i(P,m);if(!c)continue;c instanceof THREE.CubeTexture||Array.isArray(c.image)&&6===c.image.length?z(c,m):c instanceof THREE.WebGLRenderTargetCube?A(c.texture,m):c instanceof THREE.WebGLRenderTarget?aa.setTexture(c.texture,m):aa.setTexture(c,m);break;case "tv":void 0===a._array&&(a._array=[]);k=0;for(n=a.value.length;k<n;k++)a._array[k]=w();r.uniform1iv(P,a._array);k=0;for(n=a.value.length;k<n;k++)c=a.value[k],m=a._array[k],c&&(c instanceof
THREE.CubeTexture||c.image instanceof Array&&6===c.image.length?z(c,m):c instanceof THREE.WebGLRenderTarget?aa.setTexture(c.texture,m):c instanceof THREE.WebGLRenderTargetCube?A(c.texture,m):aa.setTexture(c,m));break;default:console.warn("THREE.WebGLRenderer: Unknown uniform type: "+k)}}r.uniformMatrix4fv(p.modelViewMatrix,!1,e.modelViewMatrix.elements);p.normalMatrix&&r.uniformMatrix3fv(p.normalMatrix,!1,e.normalMatrix.elements);void 0!==p.modelMatrix&&r.uniformMatrix4fv(p.modelMatrix,!1,e.matrixWorld.elements);
return g}function u(a,b){a.ambientLightColor.needsUpdate=b;a.directionalLightColor.needsUpdate=b;a.directionalLightDirection.needsUpdate=b;a.pointLightColor.needsUpdate=b;a.pointLightPosition.needsUpdate=b;a.pointLightDistance.needsUpdate=b;a.pointLightDecay.needsUpdate=b;a.spotLightColor.needsUpdate=b;a.spotLightPosition.needsUpdate=b;a.spotLightDistance.needsUpdate=b;a.spotLightDirection.needsUpdate=b;a.spotLightAngleCos.needsUpdate=b;a.spotLightExponent.needsUpdate=b;a.spotLightDecay.needsUpdate=
b;a.hemisphereLightSkyColor.needsUpdate=b;a.hemisphereLightGroundColor.needsUpdate=b;a.hemisphereLightDirection.needsUpdate=b}function w(){var a=ya;a>=ha.maxTextures&&console.warn("WebGLRenderer: trying to use "+a+" texture units while this GPU supports only "+ha.maxTextures);ya+=1;return a}function D(a,b,c,d){a[b+0]=c.r*d;a[b+1]=c.g*d;a[b+2]=c.b*d}function x(a,b,c){c?(r.texParameteri(a,r.TEXTURE_WRAP_S,N(b.wrapS)),r.texParameteri(a,r.TEXTURE_WRAP_T,N(b.wrapT)),r.texParameteri(a,r.TEXTURE_MAG_FILTER,
N(b.magFilter)),r.texParameteri(a,r.TEXTURE_MIN_FILTER,N(b.minFilter))):(r.texParameteri(a,r.TEXTURE_WRAP_S,r.CLAMP_TO_EDGE),r.texParameteri(a,r.TEXTURE_WRAP_T,r.CLAMP_TO_EDGE),b.wrapS===THREE.ClampToEdgeWrapping&&b.wrapT===THREE.ClampToEdgeWrapping||console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.",b),r.texParameteri(a,r.TEXTURE_MAG_FILTER,C(b.magFilter)),r.texParameteri(a,r.TEXTURE_MIN_FILTER,C(b.minFilter)),
b.minFilter!==THREE.NearestFilter&&b.minFilter!==THREE.LinearFilter&&console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.",b));!(c=S.get("EXT_texture_filter_anisotropic"))||b.type===THREE.FloatType&&null===S.get("OES_texture_float_linear")||b.type===THREE.HalfFloatType&&null===S.get("OES_texture_half_float_linear")||!(1<b.anisotropy||W.get(b).__currentAnisotropy)||(r.texParameterf(a,c.TEXTURE_MAX_ANISOTROPY_EXT,
Math.min(b.anisotropy,aa.getMaxAnisotropy())),W.get(b).__currentAnisotropy=b.anisotropy)}function B(a,b){if(a.width>b||a.height>b){var c=b/Math.max(a.width,a.height),d=document.createElement("canvas");d.width=Math.floor(a.width*c);d.height=Math.floor(a.height*c);d.getContext("2d").drawImage(a,0,0,a.width,a.height,0,0,d.width,d.height);console.warn("THREE.WebGLRenderer: image is too big ("+a.width+"x"+a.height+"). Resized to "+d.width+"x"+d.height,a);return d}return a}function y(a){return THREE.Math.isPowerOfTwo(a.width)&&
THREE.Math.isPowerOfTwo(a.height)}function z(a,b){var c=W.get(a);if(6===a.image.length)if(0<a.version&&c.__version!==a.version){c.__image__webglTextureCube||(a.addEventListener("dispose",g),c.__image__webglTextureCube=r.createTexture(),la.textures++);I.activeTexture(r.TEXTURE0+b);I.bindTexture(r.TEXTURE_CUBE_MAP,c.__image__webglTextureCube);r.pixelStorei(r.UNPACK_FLIP_Y_WEBGL,a.flipY);for(var d=a instanceof THREE.CompressedTexture,e=a.image[0]instanceof THREE.DataTexture,f=[],h=0;6>h;h++)f[h]=!aa.autoScaleCubemaps||
d||e?e?a.image[h].image:a.image[h]:B(a.image[h],ha.maxCubemapSize);var k=y(f[0]),l=N(a.format),n=N(a.type);x(r.TEXTURE_CUBE_MAP,a,k);for(h=0;6>h;h++)if(d)for(var m,q=f[h].mipmaps,p=0,s=q.length;p<s;p++)m=q[p],a.format!==THREE.RGBAFormat&&a.format!==THREE.RGBFormat?-1<I.getCompressedTextureFormats().indexOf(l)?I.compressedTexImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X+h,p,l,m.width,m.height,0,m.data):console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setCubeTexture()"):
I.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X+h,p,l,m.width,m.height,0,l,n,m.data);else e?I.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X+h,0,l,f[h].width,f[h].height,0,l,n,f[h].data):I.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X+h,0,l,l,n,f[h]);a.generateMipmaps&&k&&r.generateMipmap(r.TEXTURE_CUBE_MAP);c.__version=a.version;if(a.onUpdate)a.onUpdate(a)}else I.activeTexture(r.TEXTURE0+b),I.bindTexture(r.TEXTURE_CUBE_MAP,c.__image__webglTextureCube)}function A(a,b){I.activeTexture(r.TEXTURE0+b);I.bindTexture(r.TEXTURE_CUBE_MAP,
W.get(a).__webglTexture)}function J(a,b,c){r.bindFramebuffer(r.FRAMEBUFFER,a);r.framebufferTexture2D(r.FRAMEBUFFER,r.COLOR_ATTACHMENT0,c,W.get(b.texture).__webglTexture,0)}function F(a,b){r.bindRenderbuffer(r.RENDERBUFFER,a);b.depthBuffer&&!b.stencilBuffer?(r.renderbufferStorage(r.RENDERBUFFER,r.DEPTH_COMPONENT16,b.width,b.height),r.framebufferRenderbuffer(r.FRAMEBUFFER,r.DEPTH_ATTACHMENT,r.RENDERBUFFER,a)):b.depthBuffer&&b.stencilBuffer?(r.renderbufferStorage(r.RENDERBUFFER,r.DEPTH_STENCIL,b.width,
b.height),r.framebufferRenderbuffer(r.FRAMEBUFFER,r.DEPTH_STENCIL_ATTACHMENT,r.RENDERBUFFER,a)):r.renderbufferStorage(r.RENDERBUFFER,r.RGBA4,b.width,b.height)}function C(a){return a===THREE.NearestFilter||a===THREE.NearestMipMapNearestFilter||a===THREE.NearestMipMapLinearFilter?r.NEAREST:r.LINEAR}function N(a){var b;if(a===THREE.RepeatWrapping)return r.REPEAT;if(a===THREE.ClampToEdgeWrapping)return r.CLAMP_TO_EDGE;if(a===THREE.MirroredRepeatWrapping)return r.MIRRORED_REPEAT;if(a===THREE.NearestFilter)return r.NEAREST;
if(a===THREE.NearestMipMapNearestFilter)return r.NEAREST_MIPMAP_NEAREST;if(a===THREE.NearestMipMapLinearFilter)return r.NEAREST_MIPMAP_LINEAR;if(a===THREE.LinearFilter)return r.LINEAR;if(a===THREE.LinearMipMapNearestFilter)return r.LINEAR_MIPMAP_NEAREST;if(a===THREE.LinearMipMapLinearFilter)return r.LINEAR_MIPMAP_LINEAR;if(a===THREE.UnsignedByteType)return r.UNSIGNED_BYTE;if(a===THREE.UnsignedShort4444Type)return r.UNSIGNED_SHORT_4_4_4_4;if(a===THREE.UnsignedShort5551Type)return r.UNSIGNED_SHORT_5_5_5_1;
if(a===THREE.UnsignedShort565Type)return r.UNSIGNED_SHORT_5_6_5;if(a===THREE.ByteType)return r.BYTE;if(a===THREE.ShortType)return r.SHORT;if(a===THREE.UnsignedShortType)return r.UNSIGNED_SHORT;if(a===THREE.IntType)return r.INT;if(a===THREE.UnsignedIntType)return r.UNSIGNED_INT;if(a===THREE.FloatType)return r.FLOAT;b=S.get("OES_texture_half_float");if(null!==b&&a===THREE.HalfFloatType)return b.HALF_FLOAT_OES;if(a===THREE.AlphaFormat)return r.ALPHA;if(a===THREE.RGBFormat)return r.RGB;if(a===THREE.RGBAFormat)return r.RGBA;
if(a===THREE.LuminanceFormat)return r.LUMINANCE;if(a===THREE.LuminanceAlphaFormat)return r.LUMINANCE_ALPHA;if(a===THREE.AddEquation)return r.FUNC_ADD;if(a===THREE.SubtractEquation)return r.FUNC_SUBTRACT;if(a===THREE.ReverseSubtractEquation)return r.FUNC_REVERSE_SUBTRACT;if(a===THREE.ZeroFactor)return r.ZERO;if(a===THREE.OneFactor)return r.ONE;if(a===THREE.SrcColorFactor)return r.SRC_COLOR;if(a===THREE.OneMinusSrcColorFactor)return r.ONE_MINUS_SRC_COLOR;if(a===THREE.SrcAlphaFactor)return r.SRC_ALPHA;
if(a===THREE.OneMinusSrcAlphaFactor)return r.ONE_MINUS_SRC_ALPHA;if(a===THREE.DstAlphaFactor)return r.DST_ALPHA;if(a===THREE.OneMinusDstAlphaFactor)return r.ONE_MINUS_DST_ALPHA;if(a===THREE.DstColorFactor)return r.DST_COLOR;if(a===THREE.OneMinusDstColorFactor)return r.ONE_MINUS_DST_COLOR;if(a===THREE.SrcAlphaSaturateFactor)return r.SRC_ALPHA_SATURATE;b=S.get("WEBGL_compressed_texture_s3tc");if(null!==b){if(a===THREE.RGB_S3TC_DXT1_Format)return b.COMPRESSED_RGB_S3TC_DXT1_EXT;if(a===THREE.RGBA_S3TC_DXT1_Format)return b.COMPRESSED_RGBA_S3TC_DXT1_EXT;
if(a===THREE.RGBA_S3TC_DXT3_Format)return b.COMPRESSED_RGBA_S3TC_DXT3_EXT;if(a===THREE.RGBA_S3TC_DXT5_Format)return b.COMPRESSED_RGBA_S3TC_DXT5_EXT}b=S.get("WEBGL_compressed_texture_pvrtc");if(null!==b){if(a===THREE.RGB_PVRTC_4BPPV1_Format)return b.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;if(a===THREE.RGB_PVRTC_2BPPV1_Format)return b.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;if(a===THREE.RGBA_PVRTC_4BPPV1_Format)return b.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;if(a===THREE.RGBA_PVRTC_2BPPV1_Format)return b.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG}b=
S.get("EXT_blend_minmax");if(null!==b){if(a===THREE.MinEquation)return b.MIN_EXT;if(a===THREE.MaxEquation)return b.MAX_EXT}return 0}a=a||{};var L=void 0!==a.canvas?a.canvas:document.createElement("canvas"),Q=void 0!==a.context?a.context:null,M=L.width,K=L.height,E=1,O=void 0!==a.alpha?a.alpha:!1,T=void 0!==a.depth?a.depth:!0,H=void 0!==a.stencil?a.stencil:!0,R=void 0!==a.antialias?a.antialias:!1,G=void 0!==a.premultipliedAlpha?a.premultipliedAlpha:
!0,ia=void 0!==a.preserveDrawingBuffer?a.preserveDrawingBuffer:!1,U=new THREE.Color(0),X=0,da=[],ca=[],ga=-1,Z=[],fa=-1,ma=new Float32Array(8),ea=[],ja=[];this.domElement=L;this.context=null;this.sortObjects=this.autoClearStencil=this.autoClearDepth=this.autoClearColor=this.autoClear=!0;this.gammaFactor=2;this.gammaOutput=this.gammaInput=!1;this.maxMorphTargets=8;this.maxMorphNormals=4;this.autoScaleCubemaps=!0;var aa=this,Aa=null,za=null,ta=-1,sa="",ra=null,ya=0,na=0,oa=0,pa=L.width,qa=L.height,
Da=0,Ea=0,Ba=new THREE.Frustum,xa=new THREE.Matrix4,V=new THREE.Vector3,Y=new THREE.Vector3,wa=!0,Ca={ambient:[0,0,0],directional:{length:0,colors:[],positions:[]},point:{length:0,colors:[],positions:[],distances:[],decays:[]},spot:{length:0,colors:[],positions:[],distances:[],directions:[],anglesCos:[],exponents:[],decays:[]},hemi:{length:0,skyColors:[],groundColors:[],positions:[]}},la={geometries:0,textures:0},ka={calls:0,vertices:0,faces:0,points:0};this.info={render:ka,memory:la,programs:null};
var r;try{O={alpha:O,depth:T,stencil:H,antialias:R,premultipliedAlpha:G,preserveDrawingBuffer:ia};r=Q||L.getContext("webgl",O)||L.getContext("experimental-webgl",O);if(null===r){if(null!==L.getContext("webgl"))throw"Error creating WebGL context with your selected attributes.";throw"Error creating WebGL context.";}L.addEventListener("webglcontextlost",e,!1)}catch(Fa){console.error("THREE.WebGLRenderer: "+Fa)}var S=new THREE.WebGLExtensions(r);S.get("OES_texture_float");S.get("OES_texture_float_linear");
S.get("OES_texture_half_float");S.get("OES_texture_half_float_linear");S.get("OES_standard_derivatives");S.get("ANGLE_instanced_arrays");S.get("OES_element_index_uint")&&(THREE.BufferGeometry.MaxIndex=4294967296);var ha=new THREE.WebGLCapabilities(r,S,a),I=new THREE.WebGLState(r,S,N),W=new THREE.WebGLProperties,va=new THREE.WebGLObjects(r,W,this.info),ua=new THREE.WebGLPrograms(this,ha);this.info.programs=ua.programs;var Ga=new THREE.WebGLBufferRenderer(r,S,ka),Ha=new THREE.WebGLIndexedBufferRenderer(r,
S,ka);c();this.context=r;this.capabilities=ha;this.extensions=S;this.state=I;var $=new THREE.WebGLShadowMap(this,da,va);this.shadowMap=$;var Ia=new THREE.SpritePlugin(this,ea),Ja=new THREE.LensFlarePlugin(this,ja);this.getContext=function(){return r};this.getContextAttributes=function(){return r.getContextAttributes()};this.forceContextLoss=function(){S.get("WEBGL_lose_context").loseContext()};this.getMaxAnisotropy=function(){var a;return function(){if(void 0!==a)return a;var b=S.get("EXT_texture_filter_anisotropic");
return a=null!==b?r.getParameter(b.MAX_TEXTURE_MAX_ANISOTROPY_EXT):0}}();this.getPrecision=function(){return ha.precision};this.getPixelRatio=function(){return E};this.setPixelRatio=function(a){void 0!==a&&(E=a)};this.getSize=function(){return{width:M,height:K}};this.setSize=function(a,b,c){M=a;K=b;L.width=a*E;L.height=b*E;!1!==c&&(L.style.width=a+"px",L.style.height=b+"px");this.setViewport(0,0,a,b)};this.setViewport=function(a,b,c,d){na=a*E;oa=b*E;pa=c*E;qa=d*E;r.viewport(na,oa,pa,qa)};this.getViewport=
function(a){a.x=na/E;a.y=oa/E;a.z=pa/E;a.w=qa/E};this.setScissor=function(a,b,c,d){r.scissor(a*E,b*E,c*E,d*E)};this.enableScissorTest=function(a){I.setScissorTest(a)};this.getClearColor=function(){return U};this.setClearColor=function(a,c){U.set(a);X=void 0!==c?c:1;b(U.r,U.g,U.b,X)};this.getClearAlpha=function(){return X};this.setClearAlpha=function(a){X=a;b(U.r,U.g,U.b,X)};this.clear=function(a,b,c){var d=0;if(void 0===a||a)d|=r.COLOR_BUFFER_BIT;if(void 0===b||b)d|=r.DEPTH_BUFFER_BIT;if(void 0===
c||c)d|=r.STENCIL_BUFFER_BIT;r.clear(d)};this.clearColor=function(){r.clear(r.COLOR_BUFFER_BIT)};this.clearDepth=function(){r.clear(r.DEPTH_BUFFER_BIT)};this.clearStencil=function(){r.clear(r.STENCIL_BUFFER_BIT)};this.clearTarget=function(a,b,c,d){this.setRenderTarget(a);this.clear(b,c,d)};this.resetGLState=d;this.dispose=function(){L.removeEventListener("webglcontextlost",e,!1)};this.renderBufferImmediate=function(a,b,c){I.initAttributes();var d=W.get(a);a.hasPositions&&!d.position&&(d.position=
r.createBuffer());a.hasNormals&&!d.normal&&(d.normal=r.createBuffer());a.hasUvs&&!d.uv&&(d.uv=r.createBuffer());a.hasColors&&!d.color&&(d.color=r.createBuffer());b=b.getAttributes();a.hasPositions&&(r.bindBuffer(r.ARRAY_BUFFER,d.position),r.bufferData(r.ARRAY_BUFFER,a.positionArray,r.DYNAMIC_DRAW),I.enableAttribute(b.position),r.vertexAttribPointer(b.position,3,r.FLOAT,!1,0,0));if(a.hasNormals){r.bindBuffer(r.ARRAY_BUFFER,d.normal);if("MeshPhongMaterial"!==c.type&&c.shading===THREE.FlatShading)for(var e=
0,f=3*a.count;e<f;e+=9){var g=a.normalArray,h=(g[e+0]+g[e+3]+g[e+6])/3,k=(g[e+1]+g[e+4]+g[e+7])/3,l=(g[e+2]+g[e+5]+g[e+8])/3;g[e+0]=h;g[e+1]=k;g[e+2]=l;g[e+3]=h;g[e+4]=k;g[e+5]=l;g[e+6]=h;g[e+7]=k;g[e+8]=l}r.bufferData(r.ARRAY_BUFFER,a.normalArray,r.DYNAMIC_DRAW);I.enableAttribute(b.normal);r.vertexAttribPointer(b.normal,3,r.FLOAT,!1,0,0)}a.hasUvs&&c.map&&(r.bindBuffer(r.ARRAY_BUFFER,d.uv),r.bufferData(r.ARRAY_BUFFER,a.uvArray,r.DYNAMIC_DRAW),I.enableAttribute(b.uv),r.vertexAttribPointer(b.uv,2,r.FLOAT,
!1,0,0));a.hasColors&&c.vertexColors!==THREE.NoColors&&(r.bindBuffer(r.ARRAY_BUFFER,d.color),r.bufferData(r.ARRAY_BUFFER,a.colorArray,r.DYNAMIC_DRAW),I.enableAttribute(b.color),r.vertexAttribPointer(b.color,3,r.FLOAT,!1,0,0));I.disableUnusedAttributes();r.drawArrays(r.TRIANGLES,0,a.count);a.count=0};this.renderBufferDirect=function(a,b,c,d,e,f,g){t(e);var h=v(a,b,c,e,f),l=!1;a=d.id+"_"+h.id+"_"+e.wireframe;a!==sa&&(sa=a,l=!0);b=f.morphTargetInfluences;if(void 0!==b){a=[];c=0;for(l=b.length;c<l;c++){var n=
b[c];a.push([n,c])}a.sort(k);8<a.length&&(a.length=8);var m=d.morphAttributes;c=0;for(l=a.length;c<l;c++)n=a[c],ma[c]=n[0],0!==n[0]?(b=n[1],!0===e.morphTargets&&m.position&&d.addAttribute("morphTarget"+c,m.position[b]),!0===e.morphNormals&&m.normal&&d.addAttribute("morphNormal"+c,m.normal[b])):(!0===e.morphTargets&&d.removeAttribute("morphTarget"+c),!0===e.morphNormals&&d.removeAttribute("morphNormal"+c));a=h.getUniforms();null!==a.morphTargetInfluences&&r.uniform1fv(a.morphTargetInfluences,ma);l=
!0}b=d.index;c=d.attributes.position;!0===e.wireframe&&(b=va.getWireframeAttribute(d));null!==b?(a=Ha,a.setIndex(b)):a=Ga;if(l){a:{var l=void 0,q;if(d instanceof THREE.InstancedBufferGeometry&&(q=S.get("ANGLE_instanced_arrays"),null===q)){console.error("THREE.WebGLRenderer.setupVertexAttributes: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");break a}void 0===l&&(l=0);I.initAttributes();var n=d.attributes,h=h.getAttributes(),m=e.defaultAttributeValues,
p;for(p in h){var s=h[p];if(0<=s){var u=n[p];if(void 0!==u){var w=u.itemSize,x=va.getAttributeBuffer(u);if(u instanceof THREE.InterleavedBufferAttribute){var F=u.data,D=F.stride,u=u.offset;F instanceof THREE.InstancedInterleavedBuffer?(I.enableAttributeAndDivisor(s,F.meshPerAttribute,q),void 0===d.maxInstancedCount&&(d.maxInstancedCount=F.meshPerAttribute*F.count)):I.enableAttribute(s);r.bindBuffer(r.ARRAY_BUFFER,x);r.vertexAttribPointer(s,w,r.FLOAT,!1,D*F.array.BYTES_PER_ELEMENT,(l*D+u)*F.array.BYTES_PER_ELEMENT)}else u instanceof
THREE.InstancedBufferAttribute?(I.enableAttributeAndDivisor(s,u.meshPerAttribute,q),void 0===d.maxInstancedCount&&(d.maxInstancedCount=u.meshPerAttribute*u.count)):I.enableAttribute(s),r.bindBuffer(r.ARRAY_BUFFER,x),r.vertexAttribPointer(s,w,r.FLOAT,!1,0,l*w*4)}else if(void 0!==m&&(w=m[p],void 0!==w))switch(w.length){case 2:r.vertexAttrib2fv(s,w);break;case 3:r.vertexAttrib3fv(s,w);break;case 4:r.vertexAttrib4fv(s,w);break;default:r.vertexAttrib1fv(s,w)}}}I.disableUnusedAttributes()}null!==b&&r.bindBuffer(r.ELEMENT_ARRAY_BUFFER,
va.getAttributeBuffer(b))}q=Infinity;null!==b?q=b.count:void 0!==c&&(q=c.count);p=d.drawRange.start;b=d.drawRange.count;c=null!==g?g.start:0;l=null!==g?g.count:Infinity;g=Math.max(0,p,c);q=Math.min(0+q,p+b,c+l)-1;q=Math.max(0,q-g+1);f instanceof THREE.Mesh?(!0===e.wireframe?(I.setLineWidth(e.wireframeLinewidth*E),a.setMode(r.LINES)):a.setMode(r.TRIANGLES),d instanceof THREE.InstancedBufferGeometry&&0<d.maxInstancedCount?a.renderInstances(d):a.render(g,q)):f instanceof THREE.Line?(d=e.linewidth,void 0===
d&&(d=1),I.setLineWidth(d*E),f instanceof THREE.LineSegments?a.setMode(r.LINES):a.setMode(r.LINE_STRIP),a.render(g,q)):f instanceof THREE.Points&&(a.setMode(r.POINTS),a.render(g,q))};this.render=function(a,b,c,d){if(!1===b instanceof THREE.Camera)console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");else{var e=a.fog;sa="";ta=-1;ra=null;wa=!0;!0===a.autoUpdate&&a.updateMatrixWorld();null===b.parent&&b.updateMatrixWorld();b.matrixWorldInverse.getInverse(b.matrixWorld);
xa.multiplyMatrices(b.projectionMatrix,b.matrixWorldInverse);Ba.setFromMatrix(xa);da.length=0;fa=ga=-1;ea.length=0;ja.length=0;q(a,b);ca.length=ga+1;Z.length=fa+1;!0===aa.sortObjects&&(ca.sort(m),Z.sort(p));$.render(a);ka.calls=0;ka.vertices=0;ka.faces=0;ka.points=0;this.setRenderTarget(c);(this.autoClear||d)&&this.clear(this.autoClearColor,this.autoClearDepth,this.autoClearStencil);a.overrideMaterial?(d=a.overrideMaterial,s(ca,b,da,e,d),s(Z,b,da,e,d)):(I.setBlending(THREE.NoBlending),s(ca,b,da,e),
s(Z,b,da,e));Ia.render(a,b);Ja.render(a,b,Da,Ea);c&&(a=c.texture,b=y(c),a.generateMipmaps&&b&&a.minFilter!==THREE.NearestFilter&&a.minFilter!==THREE.LinearFilter&&(a=c instanceof THREE.WebGLRenderTargetCube?r.TEXTURE_CUBE_MAP:r.TEXTURE_2D,c=W.get(c.texture).__webglTexture,I.bindTexture(a,c),r.generateMipmap(a),I.bindTexture(a,null)));I.setDepthTest(!0);I.setDepthWrite(!0);I.setColorWrite(!0)}};this.setFaceCulling=function(a,b){a===THREE.CullFaceNone?I.disable(r.CULL_FACE):(b===THREE.FrontFaceDirectionCW?
r.frontFace(r.CW):r.frontFace(r.CCW),a===THREE.CullFaceBack?r.cullFace(r.BACK):a===THREE.CullFaceFront?r.cullFace(r.FRONT):r.cullFace(r.FRONT_AND_BACK),I.enable(r.CULL_FACE))};this.setTexture=function(a,b){var c=W.get(a);if(0<a.version&&c.__version!==a.version){var d=a.image;if(void 0===d)console.warn("THREE.WebGLRenderer: Texture marked for update but image is undefined",a);else if(!1===d.complete)console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete",a);else{void 0===
c.__webglInit&&(c.__webglInit=!0,a.addEventListener("dispose",g),c.__webglTexture=r.createTexture(),la.textures++);I.activeTexture(r.TEXTURE0+b);I.bindTexture(r.TEXTURE_2D,c.__webglTexture);r.pixelStorei(r.UNPACK_FLIP_Y_WEBGL,a.flipY);r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL,a.premultiplyAlpha);r.pixelStorei(r.UNPACK_ALIGNMENT,a.unpackAlignment);a.image=B(a.image,ha.maxTextureSize);if((a.wrapS!==THREE.ClampToEdgeWrapping||a.wrapT!==THREE.ClampToEdgeWrapping||a.minFilter!==THREE.NearestFilter&&
a.minFilter!==THREE.LinearFilter)&&!1===y(a.image)){d=a.image;if(d instanceof HTMLImageElement||d instanceof HTMLCanvasElement){var e=document.createElement("canvas");e.width=THREE.Math.nearestPowerOfTwo(d.width);e.height=THREE.Math.nearestPowerOfTwo(d.height);e.getContext("2d").drawImage(d,0,0,e.width,e.height);console.warn("THREE.WebGLRenderer: image is not power of two ("+d.width+"x"+d.height+"). Resized to "+e.width+"x"+e.height,d);d=e}a.image=d}var f=a.image,d=y(f),e=N(a.format),h=N(a.type);
x(r.TEXTURE_2D,a,d);var k=a.mipmaps;if(a instanceof THREE.DataTexture)if(0<k.length&&d){for(var l=0,n=k.length;l<n;l++)f=k[l],I.texImage2D(r.TEXTURE_2D,l,e,f.width,f.height,0,e,h,f.data);a.generateMipmaps=!1}else I.texImage2D(r.TEXTURE_2D,0,e,f.width,f.height,0,e,h,f.data);else if(a instanceof THREE.CompressedTexture)for(l=0,n=k.length;l<n;l++)f=k[l],a.format!==THREE.RGBAFormat&&a.format!==THREE.RGBFormat?-1<I.getCompressedTextureFormats().indexOf(e)?I.compressedTexImage2D(r.TEXTURE_2D,l,e,f.width,
f.height,0,f.data):console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()"):I.texImage2D(r.TEXTURE_2D,l,e,f.width,f.height,0,e,h,f.data);else if(0<k.length&&d){l=0;for(n=k.length;l<n;l++)f=k[l],I.texImage2D(r.TEXTURE_2D,l,e,e,h,f);a.generateMipmaps=!1}else I.texImage2D(r.TEXTURE_2D,0,e,e,h,a.image);a.generateMipmaps&&d&&r.generateMipmap(r.TEXTURE_2D);c.__version=a.version;if(a.onUpdate)a.onUpdate(a)}}else I.activeTexture(r.TEXTURE0+b),I.bindTexture(r.TEXTURE_2D,
c.__webglTexture)};this.setRenderTarget=function(a){var b=a instanceof THREE.WebGLRenderTargetCube;if(a&&void 0===W.get(a).__webglFramebuffer){var c=W.get(a),d=W.get(a.texture);void 0===a.depthBuffer&&(a.depthBuffer=!0);void 0===a.stencilBuffer&&(a.stencilBuffer=!0);a.addEventListener("dispose",f);d.__webglTexture=r.createTexture();la.textures++;var e=y(a),g=N(a.texture.format),h=N(a.texture.type);if(b){c.__webglFramebuffer=[];c.__webglRenderbuffer=[];I.bindTexture(r.TEXTURE_CUBE_MAP,d.__webglTexture);
x(r.TEXTURE_CUBE_MAP,a.texture,e);for(d=0;6>d;d++)c.__webglFramebuffer[d]=r.createFramebuffer(),c.__webglRenderbuffer[d]=r.createRenderbuffer(),I.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X+d,0,g,a.width,a.height,0,g,h,null),J(c.__webglFramebuffer[d],a,r.TEXTURE_CUBE_MAP_POSITIVE_X+d),F(c.__webglRenderbuffer[d],a);a.texture.generateMipmaps&&e&&r.generateMipmap(r.TEXTURE_CUBE_MAP)}else c.__webglFramebuffer=r.createFramebuffer(),c.__webglRenderbuffer=a.shareDepthFrom?a.shareDepthFrom.__webglRenderbuffer:
r.createRenderbuffer(),I.bindTexture(r.TEXTURE_2D,d.__webglTexture),x(r.TEXTURE_2D,a.texture,e),I.texImage2D(r.TEXTURE_2D,0,g,a.width,a.height,0,g,h,null),J(c.__webglFramebuffer,a,r.TEXTURE_2D),a.shareDepthFrom?a.depthBuffer&&!a.stencilBuffer?r.framebufferRenderbuffer(r.FRAMEBUFFER,r.DEPTH_ATTACHMENT,r.RENDERBUFFER,c.__webglRenderbuffer):a.depthBuffer&&a.stencilBuffer&&r.framebufferRenderbuffer(r.FRAMEBUFFER,r.DEPTH_STENCIL_ATTACHMENT,r.RENDERBUFFER,c.__webglRenderbuffer):F(c.__webglRenderbuffer,
a),a.texture.generateMipmaps&&e&&r.generateMipmap(r.TEXTURE_2D);b?I.bindTexture(r.TEXTURE_CUBE_MAP,null):I.bindTexture(r.TEXTURE_2D,null);r.bindRenderbuffer(r.RENDERBUFFER,null);r.bindFramebuffer(r.FRAMEBUFFER,null)}a?(c=W.get(a),d=b?c.__webglFramebuffer[a.activeCubeFace]:c.__webglFramebuffer,c=a.width,e=a.height,h=g=0):(d=null,c=pa,e=qa,g=na,h=oa);d!==za&&(r.bindFramebuffer(r.FRAMEBUFFER,d),r.viewport(g,h,c,e),za=d);b&&(d=W.get(a.texture),r.framebufferTexture2D(r.FRAMEBUFFER,r.COLOR_ATTACHMENT0,
r.TEXTURE_CUBE_MAP_POSITIVE_X+a.activeCubeFace,d.__webglTexture,0));Da=c;Ea=e};this.readRenderTargetPixels=function(a,b,c,d,e,f){if(!1===a instanceof THREE.WebGLRenderTarget)console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");else{var g=W.get(a).__webglFramebuffer;if(g){var h=!1;g!==za&&(r.bindFramebuffer(r.FRAMEBUFFER,g),h=!0);try{var k=a.texture;k.format!==THREE.RGBAFormat&&N(k.format)!==r.getParameter(r.IMPLEMENTATION_COLOR_READ_FORMAT)?console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format."):
k.type===THREE.UnsignedByteType||N(k.type)===r.getParameter(r.IMPLEMENTATION_COLOR_READ_TYPE)||k.type===THREE.FloatType&&S.get("WEBGL_color_buffer_float")||k.type===THREE.HalfFloatType&&S.get("EXT_color_buffer_half_float")?r.checkFramebufferStatus(r.FRAMEBUFFER)===r.FRAMEBUFFER_COMPLETE?r.readPixels(b,c,d,e,N(k.format),N(k.type),f):console.error("THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete."):console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.")}finally{h&&
r.bindFramebuffer(r.FRAMEBUFFER,za)}}}};this.supportsFloatTextures=function(){console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' ).");return S.get("OES_texture_float")};this.supportsHalfFloatTextures=function(){console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' ).");return S.get("OES_texture_half_float")};this.supportsStandardDerivatives=function(){console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' ).");
return S.get("OES_standard_derivatives")};this.supportsCompressedTextureS3TC=function(){console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' ).");return S.get("WEBGL_compressed_texture_s3tc")};this.supportsCompressedTexturePVRTC=function(){console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' ).");return S.get("WEBGL_compressed_texture_pvrtc")};this.supportsBlendMinMax=
function(){console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' ).");return S.get("EXT_blend_minmax")};this.supportsVertexTextures=function(){return ha.vertexTextures};this.supportsInstancedArrays=function(){console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' ).");return S.get("ANGLE_instanced_arrays")};this.initMaterial=function(){console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.")};
this.addPrePlugin=function(){console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.")};this.addPostPlugin=function(){console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.")};this.updateShadowMap=function(){console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.")};Object.defineProperties(this,{shadowMapEnabled:{get:function(){return $.enabled},set:function(a){console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.");$.enabled=a}},
shadowMapType:{get:function(){return $.type},set:function(a){console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.");$.type=a}},shadowMapCullFace:{get:function(){return $.cullFace},set:function(a){console.warn("THREE.WebGLRenderer: .shadowMapCullFace is now .shadowMap.cullFace.");$.cullFace=a}},shadowMapDebug:{get:function(){return $.debug},set:function(a){console.warn("THREE.WebGLRenderer: .shadowMapDebug is now .shadowMap.debug.");$.debug=a}}})};
THREE.WebGLRenderTarget=function(a,b,c){this.uuid=THREE.Math.generateUUID();this.width=a;this.height=b;c=c||{};void 0===c.minFilter&&(c.minFilter=THREE.LinearFilter);this.texture=new THREE.Texture(void 0,void 0,c.wrapS,c.wrapT,c.magFilter,c.minFilter,c.format,c.type,c.anisotropy);this.depthBuffer=void 0!==c.depthBuffer?c.depthBuffer:!0;this.stencilBuffer=void 0!==c.stencilBuffer?c.stencilBuffer:!0;this.shareDepthFrom=void 0!==c.shareDepthFrom?c.shareDepthFrom:null};
THREE.WebGLRenderTarget.prototype={constructor:THREE.WebGLRenderTarget,get wrapS(){console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");return this.texture.wrapS},set wrapS(a){console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");this.texture.wrapS=a},get wrapT(){console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");return this.texture.wrapT},set wrapT(a){console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");this.texture.wrapT=a},
get magFilter(){console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");return this.texture.magFilter},set magFilter(a){console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");this.texture.magFilter=a},get minFilter(){console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");return this.texture.minFilter},set minFilter(a){console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");this.texture.minFilter=a},get anisotropy(){console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
return this.texture.anisotropy},set anisotropy(a){console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");this.texture.anisotropy=a},get offset(){console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");return this.texture.offset},set offset(a){console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");this.texture.offset=a},get repeat(){console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");return this.texture.repeat},set repeat(a){console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
this.texture.repeat=a},get format(){console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");return this.texture.format},set format(a){console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");this.texture.format=a},get type(){console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");return this.texture.type},set type(a){console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");this.texture.type=a},get generateMipmaps(){console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
return this.texture.generateMipmaps},set generateMipmaps(a){console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");this.texture.generateMipmaps=a},setSize:function(a,b){if(this.width!==a||this.height!==b)this.width=a,this.height=b,this.dispose()},clone:function(){return(new this.constructor).copy(this)},copy:function(a){this.width=a.width;this.height=a.height;this.texture=a.texture.clone();this.depthBuffer=a.depthBuffer;this.stencilBuffer=a.stencilBuffer;this.shareDepthFrom=
a.shareDepthFrom;return this},dispose:function(){this.dispatchEvent({type:"dispose"})}};THREE.EventDispatcher.prototype.apply(THREE.WebGLRenderTarget.prototype);THREE.WebGLRenderTargetCube=function(a,b,c){THREE.WebGLRenderTarget.call(this,a,b,c);this.activeCubeFace=0};THREE.WebGLRenderTargetCube.prototype=Object.create(THREE.WebGLRenderTarget.prototype);THREE.WebGLRenderTargetCube.prototype.constructor=THREE.WebGLRenderTargetCube;
THREE.WebGLBufferRenderer=function(a,b,c){var d;this.setMode=function(a){d=a};this.render=function(b,g){a.drawArrays(d,b,g);c.calls++;c.vertices+=g;d===a.TRIANGLES&&(c.faces+=g/3)};this.renderInstances=function(a){var c=b.get("ANGLE_instanced_arrays");if(null===c)console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");else{var f=a.attributes.position;f instanceof THREE.InterleavedBufferAttribute?c.drawArraysInstancedANGLE(d,
0,f.data.count,a.maxInstancedCount):c.drawArraysInstancedANGLE(d,0,f.count,a.maxInstancedCount)}}};
THREE.WebGLIndexedBufferRenderer=function(a,b,c){var d,e,g;this.setMode=function(a){d=a};this.setIndex=function(c){c.array instanceof Uint32Array&&b.get("OES_element_index_uint")?(e=a.UNSIGNED_INT,g=4):(e=a.UNSIGNED_SHORT,g=2)};this.render=function(b,h){a.drawElements(d,h,e,b*g);c.calls++;c.vertices+=h;d===a.TRIANGLES&&(c.faces+=h/3)};this.renderInstances=function(a){var c=b.get("ANGLE_instanced_arrays");null===c?console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays."):
c.drawElementsInstancedANGLE(d,a.index.array.length,e,0,a.maxInstancedCount)}};
THREE.WebGLExtensions=function(a){var b={};this.get=function(c){if(void 0!==b[c])return b[c];var d;switch(c){case "EXT_texture_filter_anisotropic":d=a.getExtension("EXT_texture_filter_anisotropic")||a.getExtension("MOZ_EXT_texture_filter_anisotropic")||a.getExtension("WEBKIT_EXT_texture_filter_anisotropic");break;case "WEBGL_compressed_texture_s3tc":d=a.getExtension("WEBGL_compressed_texture_s3tc")||a.getExtension("MOZ_WEBGL_compressed_texture_s3tc")||a.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
break;case "WEBGL_compressed_texture_pvrtc":d=a.getExtension("WEBGL_compressed_texture_pvrtc")||a.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");break;default:d=a.getExtension(c)}null===d&&console.warn("THREE.WebGLRenderer: "+c+" extension not supported.");return b[c]=d}};
THREE.WebGLCapabilities=function(a,b,c){function d(b){if("highp"===b){if(0<a.getShaderPrecisionFormat(a.VERTEX_SHADER,a.HIGH_FLOAT).precision&&0<a.getShaderPrecisionFormat(a.FRAGMENT_SHADER,a.HIGH_FLOAT).precision)return"highp";b="mediump"}return"mediump"===b&&0<a.getShaderPrecisionFormat(a.VERTEX_SHADER,a.MEDIUM_FLOAT).precision&&0<a.getShaderPrecisionFormat(a.FRAGMENT_SHADER,a.MEDIUM_FLOAT).precision?"mediump":"lowp"}this.getMaxPrecision=d;this.precision=void 0!==c.precision?c.precision:"highp";
this.logarithmicDepthBuffer=void 0!==c.logarithmicDepthBuffer?c.logarithmicDepthBuffer:!1;this.maxTextures=a.getParameter(a.MAX_TEXTURE_IMAGE_UNITS);this.maxVertexTextures=a.getParameter(a.MAX_VERTEX_TEXTURE_IMAGE_UNITS);this.maxTextureSize=a.getParameter(a.MAX_TEXTURE_SIZE);this.maxCubemapSize=a.getParameter(a.MAX_CUBE_MAP_TEXTURE_SIZE);this.maxAttributes=a.getParameter(a.MAX_VERTEX_ATTRIBS);this.maxVertexUniforms=a.getParameter(a.MAX_VERTEX_UNIFORM_VECTORS);this.maxVaryings=a.getParameter(a.MAX_VARYING_VECTORS);
this.maxFragmentUniforms=a.getParameter(a.MAX_FRAGMENT_UNIFORM_VECTORS);this.vertexTextures=0<this.maxVertexTextures;this.floatFragmentTextures=!!b.get("OES_texture_float");this.floatVertexTextures=this.vertexTextures&&this.floatFragmentTextures;c=d(this.precision);c!==this.precision&&(console.warn("THREE.WebGLRenderer:",this.precision,"not supported, using",c,"instead."),this.precision=c);this.logarithmicDepthBuffer&&(this.logarithmicDepthBuffer=!!b.get("EXT_frag_depth"))};
THREE.WebGLGeometries=function(a,b,c){function d(a){a=a.target;var h=g[a.id].attributes,l;for(l in h)e(h[l]);a.removeEventListener("dispose",d);delete g[a.id];l=b.get(a);l.wireframe&&e(l.wireframe);c.memory.geometries--}function e(c){var d;d=c instanceof THREE.InterleavedBufferAttribute?b.get(c.data).__webglBuffer:b.get(c).__webglBuffer;void 0!==d&&(a.deleteBuffer(d),c instanceof THREE.InterleavedBufferAttribute?b.delete(c.data):b.delete(c))}var g={};this.get=function(a){var b=a.geometry;if(void 0!==
g[b.id])return g[b.id];b.addEventListener("dispose",d);var e;b instanceof THREE.BufferGeometry?e=b:b instanceof THREE.Geometry&&(void 0===b._bufferGeometry&&(b._bufferGeometry=(new THREE.BufferGeometry).setFromObject(a)),e=b._bufferGeometry);g[b.id]=e;c.memory.geometries++;return e}};
THREE.WebGLObjects=function(a,b,c){function d(c,d){var e=c instanceof THREE.InterleavedBufferAttribute?c.data:c,g=b.get(e);void 0===g.__webglBuffer?(g.__webglBuffer=a.createBuffer(),a.bindBuffer(d,g.__webglBuffer),a.bufferData(d,e.array,e.dynamic?a.DYNAMIC_DRAW:a.STATIC_DRAW),g.version=e.version):g.version!==e.version&&(a.bindBuffer(d,g.__webglBuffer),!1===e.dynamic||-1===e.updateRange.count?a.bufferSubData(d,0,e.array):0===e.updateRange.count?console.error("THREE.WebGLObjects.updateBuffer: dynamic THREE.BufferAttribute marked as needsUpdate but updateRange.count is 0, ensure you are using set methods or updating manually."):
(a.bufferSubData(d,e.updateRange.offset*e.array.BYTES_PER_ELEMENT,e.array.subarray(e.updateRange.offset,e.updateRange.offset+e.updateRange.count)),e.updateRange.count=0),g.version=e.version)}function e(a,b,c){if(b>c){var d=b;b=c;c=d}d=a[b];return void 0===d?(a[b]=[c],!0):-1===d.indexOf(c)?(d.push(c),!0):!1}var g=new THREE.WebGLGeometries(a,b,c);this.getAttributeBuffer=function(a){return a instanceof THREE.InterleavedBufferAttribute?b.get(a.data).__webglBuffer:b.get(a).__webglBuffer};this.getWireframeAttribute=
function(c){var g=b.get(c);if(void 0!==g.wireframe)return g.wireframe;var l=[],k=c.index,m=c.attributes;c=m.position;if(null!==k)for(var m={},k=k.array,p=0,n=k.length;p<n;p+=3){var q=k[p+0],s=k[p+1],t=k[p+2];e(m,q,s)&&l.push(q,s);e(m,s,t)&&l.push(s,t);e(m,t,q)&&l.push(t,q)}else for(k=m.position.array,p=0,n=k.length/3-1;p<n;p+=3)q=p+0,s=p+1,t=p+2,l.push(q,s,s,t,t,q);l=new THREE.BufferAttribute(new (65535<c.count?Uint32Array:Uint16Array)(l),1);d(l,a.ELEMENT_ARRAY_BUFFER);return g.wireframe=l};this.update=
function(b){var c=g.get(b);b.geometry instanceof THREE.Geometry&&c.updateFromObject(b);b=c.index;var e=c.attributes;null!==b&&d(b,a.ELEMENT_ARRAY_BUFFER);for(var k in e)d(e[k],a.ARRAY_BUFFER);b=c.morphAttributes;for(k in b)for(var e=b[k],m=0,p=e.length;m<p;m++)d(e[m],a.ARRAY_BUFFER);return c}};
THREE.WebGLProgram=function(){function a(a){var b=[],c;for(c in a){var f=a[c];!1!==f&&b.push("#define "+c+" "+f)}return b.join("\n")}function b(a){return""!==a}var c=0;return function(d,e,g,f){var h=d.context,l=g.defines,k=g.__webglShader.vertexShader,m=g.__webglShader.fragmentShader,p="SHADOWMAP_TYPE_BASIC";f.shadowMapType===THREE.PCFShadowMap?p="SHADOWMAP_TYPE_PCF":f.shadowMapType===THREE.PCFSoftShadowMap&&(p="SHADOWMAP_TYPE_PCF_SOFT");var n="ENVMAP_TYPE_CUBE",q="ENVMAP_MODE_REFLECTION",s="ENVMAP_BLENDING_MULTIPLY";
if(f.envMap){switch(g.envMap.mapping){case THREE.CubeReflectionMapping:case THREE.CubeRefractionMapping:n="ENVMAP_TYPE_CUBE";break;case THREE.EquirectangularReflectionMapping:case THREE.EquirectangularRefractionMapping:n="ENVMAP_TYPE_EQUIREC";break;case THREE.SphericalReflectionMapping:n="ENVMAP_TYPE_SPHERE"}switch(g.envMap.mapping){case THREE.CubeRefractionMapping:case THREE.EquirectangularRefractionMapping:q="ENVMAP_MODE_REFRACTION"}switch(g.combine){case THREE.MultiplyOperation:s="ENVMAP_BLENDING_MULTIPLY";
break;case THREE.MixOperation:s="ENVMAP_BLENDING_MIX";break;case THREE.AddOperation:s="ENVMAP_BLENDING_ADD"}}var t=0<d.gammaFactor?d.gammaFactor:1,v=a(l),u=h.createProgram();g instanceof THREE.RawShaderMaterial?d=l="":(l=["precision "+f.precision+" float;","precision "+f.precision+" int;","#define SHADER_NAME "+g.__webglShader.name,v,f.supportsVertexTextures?"#define VERTEX_TEXTURES":"",d.gammaInput?"#define GAMMA_INPUT":"",d.gammaOutput?"#define GAMMA_OUTPUT":"","#define GAMMA_FACTOR "+t,"#define MAX_DIR_LIGHTS "+
f.maxDirLights,"#define MAX_POINT_LIGHTS "+f.maxPointLights,"#define MAX_SPOT_LIGHTS "+f.maxSpotLights,"#define MAX_HEMI_LIGHTS "+f.maxHemiLights,"#define MAX_SHADOWS "+f.maxShadows,"#define MAX_BONES "+f.maxBones,f.map?"#define USE_MAP":"",f.envMap?"#define USE_ENVMAP":"",f.envMap?"#define "+q:"",f.lightMap?"#define USE_LIGHTMAP":"",f.aoMap?"#define USE_AOMAP":"",f.emissiveMap?"#define USE_EMISSIVEMAP":"",f.bumpMap?"#define USE_BUMPMAP":"",f.normalMap?"#define USE_NORMALMAP":"",f.displacementMap&&
f.supportsVertexTextures?"#define USE_DISPLACEMENTMAP":"",f.specularMap?"#define USE_SPECULARMAP":"",f.alphaMap?"#define USE_ALPHAMAP":"",f.vertexColors?"#define USE_COLOR":"",f.flatShading?"#define FLAT_SHADED":"",f.skinning?"#define USE_SKINNING":"",f.useVertexTexture?"#define BONE_TEXTURE":"",f.morphTargets?"#define USE_MORPHTARGETS":"",f.morphNormals&&!1===f.flatShading?"#define USE_MORPHNORMALS":"",f.doubleSided?"#define DOUBLE_SIDED":"",f.flipSided?"#define FLIP_SIDED":"",f.shadowMapEnabled?
"#define USE_SHADOWMAP":"",f.shadowMapEnabled?"#define "+p:"",f.shadowMapDebug?"#define SHADOWMAP_DEBUG":"",0<f.pointLightShadows?"#define POINT_LIGHT_SHADOWS":"",f.sizeAttenuation?"#define USE_SIZEATTENUATION":"",f.logarithmicDepthBuffer?"#define USE_LOGDEPTHBUF":"",f.logarithmicDepthBuffer&&d.extensions.get("EXT_frag_depth")?"#define USE_LOGDEPTHBUF_EXT":"","uniform mat4 modelMatrix;","uniform mat4 modelViewMatrix;","uniform mat4 projectionMatrix;","uniform mat4 viewMatrix;","uniform mat3 normalMatrix;",
"uniform vec3 cameraPosition;","attribute vec3 position;","attribute vec3 normal;","attribute vec2 uv;","#ifdef USE_COLOR","\tattribute vec3 color;","#endif","#ifdef USE_MORPHTARGETS","\tattribute vec3 morphTarget0;","\tattribute vec3 morphTarget1;","\tattribute vec3 morphTarget2;","\tattribute vec3 morphTarget3;","\t#ifdef USE_MORPHNORMALS","\t\tattribute vec3 morphNormal0;","\t\tattribute vec3 morphNormal1;","\t\tattribute vec3 morphNormal2;","\t\tattribute vec3 morphNormal3;","\t#else","\t\tattribute vec3 morphTarget4;",
"\t\tattribute vec3 morphTarget5;","\t\tattribute vec3 morphTarget6;","\t\tattribute vec3 morphTarget7;","\t#endif","#endif","#ifdef USE_SKINNING","\tattribute vec4 skinIndex;","\tattribute vec4 skinWeight;","#endif","\n"].filter(b).join("\n"),d=[f.bumpMap||f.normalMap||f.flatShading||g.derivatives?"#extension GL_OES_standard_derivatives : enable":"",f.logarithmicDepthBuffer&&d.extensions.get("EXT_frag_depth")?"#extension GL_EXT_frag_depth : enable":"","precision "+f.precision+" float;","precision "+
f.precision+" int;","#define SHADER_NAME "+g.__webglShader.name,v,"#define MAX_DIR_LIGHTS "+f.maxDirLights,"#define MAX_POINT_LIGHTS "+f.maxPointLights,"#define MAX_SPOT_LIGHTS "+f.maxSpotLights,"#define MAX_HEMI_LIGHTS "+f.maxHemiLights,"#define MAX_SHADOWS "+f.maxShadows,f.alphaTest?"#define ALPHATEST "+f.alphaTest:"",d.gammaInput?"#define GAMMA_INPUT":"",d.gammaOutput?"#define GAMMA_OUTPUT":"","#define GAMMA_FACTOR "+t,f.useFog&&f.fog?"#define USE_FOG":"",f.useFog&&f.fogExp?"#define FOG_EXP2":
"",f.map?"#define USE_MAP":"",f.envMap?"#define USE_ENVMAP":"",f.envMap?"#define "+n:"",f.envMap?"#define "+q:"",f.envMap?"#define "+s:"",f.lightMap?"#define USE_LIGHTMAP":"",f.aoMap?"#define USE_AOMAP":"",f.emissiveMap?"#define USE_EMISSIVEMAP":"",f.bumpMap?"#define USE_BUMPMAP":"",f.normalMap?"#define USE_NORMALMAP":"",f.specularMap?"#define USE_SPECULARMAP":"",f.alphaMap?"#define USE_ALPHAMAP":"",f.vertexColors?"#define USE_COLOR":"",f.flatShading?"#define FLAT_SHADED":"",f.metal?"#define METAL":
"",f.doubleSided?"#define DOUBLE_SIDED":"",f.flipSided?"#define FLIP_SIDED":"",f.shadowMapEnabled?"#define USE_SHADOWMAP":"",f.shadowMapEnabled?"#define "+p:"",f.shadowMapDebug?"#define SHADOWMAP_DEBUG":"",0<f.pointLightShadows?"#define POINT_LIGHT_SHADOWS":"",f.logarithmicDepthBuffer?"#define USE_LOGDEPTHBUF":"",f.logarithmicDepthBuffer&&d.extensions.get("EXT_frag_depth")?"#define USE_LOGDEPTHBUF_EXT":"","uniform mat4 viewMatrix;","uniform vec3 cameraPosition;","\n"].filter(b).join("\n"));m=d+m;
k=THREE.WebGLShader(h,h.VERTEX_SHADER,l+k);m=THREE.WebGLShader(h,h.FRAGMENT_SHADER,m);h.attachShader(u,k);h.attachShader(u,m);void 0!==g.index0AttributeName?h.bindAttribLocation(u,0,g.index0AttributeName):!0===f.morphTargets&&h.bindAttribLocation(u,0,"position");h.linkProgram(u);f=h.getProgramInfoLog(u);p=h.getShaderInfoLog(k);n=h.getShaderInfoLog(m);s=q=!0;if(!1===h.getProgramParameter(u,h.LINK_STATUS))q=!1,console.error("THREE.WebGLProgram: shader error: ",h.getError(),"gl.VALIDATE_STATUS",h.getProgramParameter(u,
h.VALIDATE_STATUS),"gl.getProgramInfoLog",f,p,n);else if(""!==f)console.warn("THREE.WebGLProgram: gl.getProgramInfoLog()",f);else if(""===p||""===n)s=!1;s&&(this.diagnostics={runnable:q,material:g,programLog:f,vertexShader:{log:p,prefix:l},fragmentShader:{log:n,prefix:d}});h.deleteShader(k);h.deleteShader(m);var w;this.getUniforms=function(){if(void 0===w){for(var a={},b=h.getProgramParameter(u,h.ACTIVE_UNIFORMS),c=0;c<b;c++){var d=h.getActiveUniform(u,c).name,e=h.getUniformLocation(u,d),f=d.lastIndexOf("[0]");
-1!==f&&f===d.length-3&&(a[d.substr(0,f)]=e);a[d]=e}w=a}return w};var D;this.getAttributes=function(){if(void 0===D){for(var a={},b=h.getProgramParameter(u,h.ACTIVE_ATTRIBUTES),c=0;c<b;c++){var d=h.getActiveAttrib(u,c).name;a[d]=h.getAttribLocation(u,d)}D=a}return D};this.destroy=function(){h.deleteProgram(u);this.program=void 0};Object.defineProperties(this,{uniforms:{get:function(){console.warn("THREE.WebGLProgram: .uniforms is now .getUniforms().");return this.getUniforms()}},attributes:{get:function(){console.warn("THREE.WebGLProgram: .attributes is now .getAttributes().");
return this.getAttributes()}}});this.id=c++;this.code=e;this.usedTimes=1;this.program=u;this.vertexShader=k;this.fragmentShader=m;return this}}();
THREE.WebGLPrograms=function(a,b){var c=[],d={MeshDepthMaterial:"depth",MeshNormalMaterial:"normal",MeshBasicMaterial:"basic",MeshLambertMaterial:"lambert",MeshPhongMaterial:"phong",LineBasicMaterial:"basic",LineDashedMaterial:"dashed",PointsMaterial:"points"},e="precision supportsVertexTextures map envMap envMapMode lightMap aoMap emissiveMap bumpMap normalMap displacementMap specularMap alphaMap combine vertexColors fog useFog fogExp flatShading sizeAttenuation logarithmicDepthBuffer skinning maxBones useVertexTexture morphTargets morphNormals maxMorphTargets maxMorphNormals maxDirLights maxPointLights maxSpotLights maxHemiLights maxShadows shadowMapEnabled pointLightShadows shadowMapType shadowMapDebug alphaTest metal doubleSided flipSided".split(" ");this.getParameters=
function(c,e,h,l){var k,m,p,n,q,s=d[c.type];k=q=n=p=m=0;for(var t=e.length;k<t;k++){var v=e[k];!1!==v.visible&&(v instanceof THREE.DirectionalLight&&m++,v instanceof THREE.PointLight&&p++,v instanceof THREE.SpotLight&&n++,v instanceof THREE.HemisphereLight&&q++)}for(var v=k=t=0,u=e.length;v<u;v++){var w=e[v];w.castShadow&&((w instanceof THREE.SpotLight||w instanceof THREE.DirectionalLight)&&t++,w instanceof THREE.PointLight&&(t++,k++))}e=t;b.floatVertexTextures&&l&&l.skeleton&&l.skeleton.useVertexTexture?
t=1024:(t=Math.floor((b.maxVertexUniforms-20)/4),void 0!==l&&l instanceof THREE.SkinnedMesh&&(t=Math.min(l.skeleton.bones.length,t),t<l.skeleton.bones.length&&console.warn("WebGLRenderer: too many bones - "+l.skeleton.bones.length+", this GPU supports just "+t+" (try OpenGL instead of ANGLE)")));v=a.getPrecision();null!==c.precision&&(v=b.getMaxPrecision(c.precision),v!==c.precision&&console.warn("THREE.WebGLRenderer.initMaterial:",c.precision,"not supported, using",v,"instead."));return{shaderID:s,
precision:v,supportsVertexTextures:b.vertexTextures,map:!!c.map,envMap:!!c.envMap,envMapMode:c.envMap&&c.envMap.mapping,lightMap:!!c.lightMap,aoMap:!!c.aoMap,emissiveMap:!!c.emissiveMap,bumpMap:!!c.bumpMap,normalMap:!!c.normalMap,displacementMap:!!c.displacementMap,specularMap:!!c.specularMap,alphaMap:!!c.alphaMap,combine:c.combine,vertexColors:c.vertexColors,fog:h,useFog:c.fog,fogExp:h instanceof THREE.FogExp2,flatShading:c.shading===THREE.FlatShading,sizeAttenuation:c.sizeAttenuation,logarithmicDepthBuffer:b.logarithmicDepthBuffer,
skinning:c.skinning,maxBones:t,useVertexTexture:b.floatVertexTextures&&l&&l.skeleton&&l.skeleton.useVertexTexture,morphTargets:c.morphTargets,morphNormals:c.morphNormals,maxMorphTargets:a.maxMorphTargets,maxMorphNormals:a.maxMorphNormals,maxDirLights:m,maxPointLights:p,maxSpotLights:n,maxHemiLights:q,maxShadows:e,pointLightShadows:k,shadowMapEnabled:a.shadowMap.enabled&&l.receiveShadow&&0<e,shadowMapType:a.shadowMap.type,shadowMapDebug:a.shadowMap.debug,alphaTest:c.alphaTest,metal:c.metal,doubleSided:c.side===
THREE.DoubleSide,flipSided:c.side===THREE.BackSide}};this.getProgramCode=function(a,b){var c=[];b.shaderID?c.push(b.shaderID):(c.push(a.fragmentShader),c.push(a.vertexShader));if(void 0!==a.defines)for(var d in a.defines)c.push(d),c.push(a.defines[d]);for(d=0;d<e.length;d++){var k=e[d];c.push(k);c.push(b[k])}return c.join()};this.acquireProgram=function(b,d,e){for(var l,k=0,m=c.length;k<m;k++){var p=c[k];if(p.code===e){l=p;++l.usedTimes;break}}void 0===l&&(l=new THREE.WebGLProgram(a,e,b,d),c.push(l));
return l};this.releaseProgram=function(a){if(0===--a.usedTimes){var b=c.indexOf(a);c[b]=c[c.length-1];c.pop();a.destroy()}};this.programs=c};THREE.WebGLProperties=function(){var a={};this.get=function(b){b=b.uuid;var c=a[b];void 0===c&&(c={},a[b]=c);return c};this.delete=function(b){delete a[b.uuid]};this.clear=function(){a={}}};
THREE.WebGLShader=function(){function a(a){a=a.split("\n");for(var c=0;c<a.length;c++)a[c]=c+1+": "+a[c];return a.join("\n")}return function(b,c,d){var e=b.createShader(c);b.shaderSource(e,d);b.compileShader(e);!1===b.getShaderParameter(e,b.COMPILE_STATUS)&&console.error("THREE.WebGLShader: Shader couldn't compile.");""!==b.getShaderInfoLog(e)&&console.warn("THREE.WebGLShader: gl.getShaderInfoLog()",c===b.VERTEX_SHADER?"vertex":"fragment",b.getShaderInfoLog(e),a(d));return e}}();
THREE.WebGLShadowMap=function(a,b,c){function d(a,b,c,d){var e=a.geometry,f=null,f=n,g=a.customDepthMaterial;c&&(f=q,g=a.customDistanceMaterial);g?f=g:(a=a instanceof THREE.SkinnedMesh&&b.skinning,g=0,void 0!==e.morphTargets&&0<e.morphTargets.length&&b.morphTargets&&(g|=1),a&&(g|=2),f=f[g]);f.visible=b.visible;f.wireframe=b.wireframe;f.wireframeLinewidth=b.wireframeLinewidth;c&&void 0!==f.uniforms.lightPos&&f.uniforms.lightPos.value.copy(d);return f}function e(a,b){if(!1!==a.visible){(a instanceof
THREE.Mesh||a instanceof THREE.Line||a instanceof THREE.Points)&&a.castShadow&&(!1===a.frustumCulled||!0===h.intersectsObject(a))&&!0===a.material.visible&&(a.modelViewMatrix.multiplyMatrices(b.matrixWorldInverse,a.matrixWorld),p.push(a));for(var c=a.children,d=0,f=c.length;d<f;d++)e(c[d],b)}}var g=a.context,f=a.state,h=new THREE.Frustum,l=new THREE.Matrix4;new THREE.Vector3;new THREE.Vector3;for(var k=new THREE.Vector3,m=new THREE.Vector3,p=[],n=Array(4),q=Array(4),s=[new THREE.Vector3(1,0,0),new THREE.Vector3(-1,
0,0),new THREE.Vector3(0,0,1),new THREE.Vector3(0,0,-1),new THREE.Vector3(0,1,0),new THREE.Vector3(0,-1,0)],t=[new THREE.Vector3(0,1,0),new THREE.Vector3(0,1,0),new THREE.Vector3(0,1,0),new THREE.Vector3(0,1,0),new THREE.Vector3(0,0,1),new THREE.Vector3(0,0,-1)],v=[new THREE.Vector4,new THREE.Vector4,new THREE.Vector4,new THREE.Vector4,new THREE.Vector4,new THREE.Vector4],u=new THREE.Vector4,w=THREE.ShaderLib.depthRGBA,D=THREE.UniformsUtils.clone(w.uniforms),x=THREE.ShaderLib.distanceRGBA,B=THREE.UniformsUtils.clone(x.uniforms),
y=0;4!==y;++y){var z=0!==(y&1),A=0!==(y&2),J=new THREE.ShaderMaterial({uniforms:D,vertexShader:w.vertexShader,fragmentShader:w.fragmentShader,morphTargets:z,skinning:A});J._shadowPass=!0;n[y]=J;z=new THREE.ShaderMaterial({uniforms:B,vertexShader:x.vertexShader,fragmentShader:x.fragmentShader,morphTargets:z,skinning:A});z._shadowPass=!0;q[y]=z}var F=this;this.enabled=!1;this.autoUpdate=!0;this.needsUpdate=!1;this.type=THREE.PCFShadowMap;this.cullFace=THREE.CullFaceFront;this.render=function(n){var q,
w;if(!1!==F.enabled&&(!1!==F.autoUpdate||!1!==F.needsUpdate)){g.clearColor(1,1,1,1);f.disable(g.BLEND);f.enable(g.CULL_FACE);g.frontFace(g.CCW);g.cullFace(F.cullFace===THREE.CullFaceFront?g.FRONT:g.BACK);f.setDepthTest(!0);a.getViewport(u);for(var x=0,D=b.length;x<D;x++){var y=b[x];if(!0===y.castShadow){var z=y.shadow,B=z.camera,A=z.mapSize;if(y instanceof THREE.PointLight){q=6;w=!0;var H=A.x/4,J=A.y/2;v[0].set(2*H,J,H,J);v[1].set(0,J,H,J);v[2].set(3*H,J,H,J);v[3].set(H,J,H,J);v[4].set(3*H,0,H,J);
v[5].set(H,0,H,J)}else q=1,w=!1;null===z.map&&(H=THREE.LinearFilter,F.type===THREE.PCFSoftShadowMap&&(H=THREE.NearestFilter),z.map=new THREE.WebGLRenderTarget(A.x,A.y,{minFilter:H,magFilter:H,format:THREE.RGBAFormat}),z.matrix=new THREE.Matrix4,y instanceof THREE.SpotLight&&(B.aspect=A.x/A.y),B.updateProjectionMatrix());A=z.map;z=z.matrix;m.setFromMatrixPosition(y.matrixWorld);B.position.copy(m);a.setRenderTarget(A);a.clear();for(A=0;A<q;A++)for(w?(k.copy(B.position),k.add(s[A]),B.up.copy(t[A]),B.lookAt(k),
H=v[A],a.setViewport(H.x,H.y,H.z,H.w)):(k.setFromMatrixPosition(y.target.matrixWorld),B.lookAt(k)),B.updateMatrixWorld(),B.matrixWorldInverse.getInverse(B.matrixWorld),z.set(.5,0,0,.5,0,.5,0,.5,0,0,.5,.5,0,0,0,1),z.multiply(B.projectionMatrix),z.multiply(B.matrixWorldInverse),l.multiplyMatrices(B.projectionMatrix,B.matrixWorldInverse),h.setFromMatrix(l),p.length=0,e(n,B),H=0,J=p.length;H<J;H++){var G=p[H],ia=c.update(G),U=G.material;if(U instanceof THREE.MeshFaceMaterial)for(var X=ia.groups,U=U.materials,
da=0,ca=X.length;da<ca;da++){var ga=X[da],Z=U[ga.materialIndex];!0===Z.visible&&(Z=d(G,Z,w,m),a.renderBufferDirect(B,b,null,ia,Z,G,ga))}else Z=d(G,U,w,m),a.renderBufferDirect(B,b,null,ia,Z,G,null)}a.resetGLState()}}a.setViewport(u.x,u.y,u.z,u.w);n=a.getClearColor();q=a.getClearAlpha();a.setClearColor(n,q);f.enable(g.BLEND);F.cullFace===THREE.CullFaceFront&&g.cullFace(g.BACK);a.resetGLState();F.needsUpdate=!1}}};
THREE.WebGLState=function(a,b,c){var d=this,e=new Uint8Array(16),g=new Uint8Array(16),f=new Uint8Array(16),h={},l=null,k=null,m=null,p=null,n=null,q=null,s=null,t=null,v=null,u=null,w=null,D=null,x=null,B=null,y=null,z=a.getParameter(a.MAX_TEXTURE_IMAGE_UNITS),A=void 0,J={};this.init=function(){a.clearColor(0,0,0,1);a.clearDepth(1);a.clearStencil(0);this.enable(a.DEPTH_TEST);a.depthFunc(a.LEQUAL);a.frontFace(a.CCW);a.cullFace(a.BACK);this.enable(a.CULL_FACE);this.enable(a.BLEND);a.blendEquation(a.FUNC_ADD);
a.blendFunc(a.SRC_ALPHA,a.ONE_MINUS_SRC_ALPHA)};this.initAttributes=function(){for(var a=0,b=e.length;a<b;a++)e[a]=0};this.enableAttribute=function(c){e[c]=1;0===g[c]&&(a.enableVertexAttribArray(c),g[c]=1);0!==f[c]&&(b.get("ANGLE_instanced_arrays").vertexAttribDivisorANGLE(c,0),f[c]=0)};this.enableAttributeAndDivisor=function(b,c,d){e[b]=1;0===g[b]&&(a.enableVertexAttribArray(b),g[b]=1);f[b]!==c&&(d.vertexAttribDivisorANGLE(b,c),f[b]=c)};this.disableUnusedAttributes=function(){for(var b=0,c=g.length;b<
c;b++)g[b]!==e[b]&&(a.disableVertexAttribArray(b),g[b]=0)};this.enable=function(b){!0!==h[b]&&(a.enable(b),h[b]=!0)};this.disable=function(b){!1!==h[b]&&(a.disable(b),h[b]=!1)};this.getCompressedTextureFormats=function(){if(null===l&&(l=[],b.get("WEBGL_compressed_texture_pvrtc")||b.get("WEBGL_compressed_texture_s3tc")))for(var c=a.getParameter(a.COMPRESSED_TEXTURE_FORMATS),d=0;d<c.length;d++)l.push(c[d]);return l};this.setBlending=function(b,d,e,f,g,h,l){b!==k&&(b===THREE.NoBlending?this.disable(a.BLEND):
b===THREE.AdditiveBlending?(this.enable(a.BLEND),a.blendEquation(a.FUNC_ADD),a.blendFunc(a.SRC_ALPHA,a.ONE)):b===THREE.SubtractiveBlending?(this.enable(a.BLEND),a.blendEquation(a.FUNC_ADD),a.blendFunc(a.ZERO,a.ONE_MINUS_SRC_COLOR)):b===THREE.MultiplyBlending?(this.enable(a.BLEND),a.blendEquation(a.FUNC_ADD),a.blendFunc(a.ZERO,a.SRC_COLOR)):b===THREE.CustomBlending?this.enable(a.BLEND):(this.enable(a.BLEND),a.blendEquationSeparate(a.FUNC_ADD,a.FUNC_ADD),a.blendFuncSeparate(a.SRC_ALPHA,a.ONE_MINUS_SRC_ALPHA,
a.ONE,a.ONE_MINUS_SRC_ALPHA)),k=b);if(b===THREE.CustomBlending){g=g||d;h=h||e;l=l||f;if(d!==m||g!==q)a.blendEquationSeparate(c(d),c(g)),m=d,q=g;if(e!==p||f!==n||h!==s||l!==t)a.blendFuncSeparate(c(e),c(f),c(h),c(l)),p=e,n=f,s=h,t=l}else t=s=q=n=p=m=null};this.setDepthFunc=function(b){if(v!==b){if(b)switch(b){case THREE.NeverDepth:a.depthFunc(a.NEVER);break;case THREE.AlwaysDepth:a.depthFunc(a.ALWAYS);break;case THREE.LessDepth:a.depthFunc(a.LESS);break;case THREE.LessEqualDepth:a.depthFunc(a.LEQUAL);
break;case THREE.EqualDepth:a.depthFunc(a.EQUAL);break;case THREE.GreaterEqualDepth:a.depthFunc(a.GEQUAL);break;case THREE.GreaterDepth:a.depthFunc(a.GREATER);break;case THREE.NotEqualDepth:a.depthFunc(a.NOTEQUAL);break;default:a.depthFunc(a.LEQUAL)}else a.depthFunc(a.LEQUAL);v=b}};this.setDepthTest=function(b){b?this.enable(a.DEPTH_TEST):this.disable(a.DEPTH_TEST)};this.setDepthWrite=function(b){u!==b&&(a.depthMask(b),u=b)};this.setColorWrite=function(b){w!==b&&(a.colorMask(b,b,b,b),w=b)};this.setFlipSided=
function(b){D!==b&&(b?a.frontFace(a.CW):a.frontFace(a.CCW),D=b)};this.setLineWidth=function(b){b!==x&&(a.lineWidth(b),x=b)};this.setPolygonOffset=function(b,c,d){b?this.enable(a.POLYGON_OFFSET_FILL):this.disable(a.POLYGON_OFFSET_FILL);!b||B===c&&y===d||(a.polygonOffset(c,d),B=c,y=d)};this.setScissorTest=function(b){b?this.enable(a.SCISSOR_TEST):this.disable(a.SCISSOR_TEST)};this.activeTexture=function(b){void 0===b&&(b=a.TEXTURE0+z-1);A!==b&&(a.activeTexture(b),A=b)};this.bindTexture=function(b,c){void 0===
A&&d.activeTexture();var e=J[A];void 0===e&&(e={type:void 0,texture:void 0},J[A]=e);if(e.type!==b||e.texture!==c)a.bindTexture(b,c),e.type=b,e.texture=c};this.compressedTexImage2D=function(){try{a.compressedTexImage2D.apply(a,arguments)}catch(b){console.error(b)}};this.texImage2D=function(){try{a.texImage2D.apply(a,arguments)}catch(b){console.error(b)}};this.reset=function(){for(var b=0;b<g.length;b++)1===g[b]&&(a.disableVertexAttribArray(b),g[b]=0);h={};D=w=u=k=l=null}};
THREE.LensFlarePlugin=function(a,b){var c,d,e,g,f,h,l,k,m,p,n=a.context,q=a.state,s,t,v,u,w,D;this.render=function(x,B,y,z){if(0!==b.length){x=new THREE.Vector3;var A=z/y,J=.5*y,F=.5*z,C=16/z,N=new THREE.Vector2(C*A,C),L=new THREE.Vector3(1,1,0),Q=new THREE.Vector2(1,1);if(void 0===v){var C=new Float32Array([-1,-1,0,0,1,-1,1,0,1,1,1,1,-1,1,0,1]),M=new Uint16Array([0,1,2,0,2,3]);s=n.createBuffer();t=n.createBuffer();n.bindBuffer(n.ARRAY_BUFFER,s);n.bufferData(n.ARRAY_BUFFER,C,n.STATIC_DRAW);n.bindBuffer(n.ELEMENT_ARRAY_BUFFER,
t);n.bufferData(n.ELEMENT_ARRAY_BUFFER,M,n.STATIC_DRAW);w=n.createTexture();D=n.createTexture();q.bindTexture(n.TEXTURE_2D,w);n.texImage2D(n.TEXTURE_2D,0,n.RGB,16,16,0,n.RGB,n.UNSIGNED_BYTE,null);n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_S,n.CLAMP_TO_EDGE);n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_T,n.CLAMP_TO_EDGE);n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MAG_FILTER,n.NEAREST);n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MIN_FILTER,n.NEAREST);q.bindTexture(n.TEXTURE_2D,D);n.texImage2D(n.TEXTURE_2D,0,
n.RGBA,16,16,0,n.RGBA,n.UNSIGNED_BYTE,null);n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_S,n.CLAMP_TO_EDGE);n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_T,n.CLAMP_TO_EDGE);n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MAG_FILTER,n.NEAREST);n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MIN_FILTER,n.NEAREST);var C=(u=0<n.getParameter(n.MAX_VERTEX_TEXTURE_IMAGE_UNITS))?{vertexShader:"uniform lowp int renderType;\nuniform vec3 screenPosition;\nuniform vec2 scale;\nuniform float rotation;\nuniform sampler2D occlusionMap;\nattribute vec2 position;\nattribute vec2 uv;\nvarying vec2 vUV;\nvarying float vVisibility;\nvoid main() {\nvUV = uv;\nvec2 pos = position;\nif ( renderType == 2 ) {\nvec4 visibility = texture2D( occlusionMap, vec2( 0.1, 0.1 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.5, 0.1 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.9, 0.1 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.9, 0.5 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.9, 0.9 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.5, 0.9 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.1, 0.9 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.1, 0.5 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.5, 0.5 ) );\nvVisibility =        visibility.r / 9.0;\nvVisibility *= 1.0 - visibility.g / 9.0;\nvVisibility *=       visibility.b / 9.0;\nvVisibility *= 1.0 - visibility.a / 9.0;\npos.x = cos( rotation ) * position.x - sin( rotation ) * position.y;\npos.y = sin( rotation ) * position.x + cos( rotation ) * position.y;\n}\ngl_Position = vec4( ( pos * scale + screenPosition.xy ).xy, screenPosition.z, 1.0 );\n}",
fragmentShader:"uniform lowp int renderType;\nuniform sampler2D map;\nuniform float opacity;\nuniform vec3 color;\nvarying vec2 vUV;\nvarying float vVisibility;\nvoid main() {\nif ( renderType == 0 ) {\ngl_FragColor = vec4( 1.0, 0.0, 1.0, 0.0 );\n} else if ( renderType == 1 ) {\ngl_FragColor = texture2D( map, vUV );\n} else {\nvec4 texture = texture2D( map, vUV );\ntexture.a *= opacity * vVisibility;\ngl_FragColor = texture;\ngl_FragColor.rgb *= color;\n}\n}"}:{vertexShader:"uniform lowp int renderType;\nuniform vec3 screenPosition;\nuniform vec2 scale;\nuniform float rotation;\nattribute vec2 position;\nattribute vec2 uv;\nvarying vec2 vUV;\nvoid main() {\nvUV = uv;\nvec2 pos = position;\nif ( renderType == 2 ) {\npos.x = cos( rotation ) * position.x - sin( rotation ) * position.y;\npos.y = sin( rotation ) * position.x + cos( rotation ) * position.y;\n}\ngl_Position = vec4( ( pos * scale + screenPosition.xy ).xy, screenPosition.z, 1.0 );\n}",
fragmentShader:"precision mediump float;\nuniform lowp int renderType;\nuniform sampler2D map;\nuniform sampler2D occlusionMap;\nuniform float opacity;\nuniform vec3 color;\nvarying vec2 vUV;\nvoid main() {\nif ( renderType == 0 ) {\ngl_FragColor = vec4( texture2D( map, vUV ).rgb, 0.0 );\n} else if ( renderType == 1 ) {\ngl_FragColor = texture2D( map, vUV );\n} else {\nfloat visibility = texture2D( occlusionMap, vec2( 0.5, 0.1 ) ).a;\nvisibility += texture2D( occlusionMap, vec2( 0.9, 0.5 ) ).a;\nvisibility += texture2D( occlusionMap, vec2( 0.5, 0.9 ) ).a;\nvisibility += texture2D( occlusionMap, vec2( 0.1, 0.5 ) ).a;\nvisibility = ( 1.0 - visibility / 4.0 );\nvec4 texture = texture2D( map, vUV );\ntexture.a *= opacity * visibility;\ngl_FragColor = texture;\ngl_FragColor.rgb *= color;\n}\n}"},
M=n.createProgram(),K=n.createShader(n.FRAGMENT_SHADER),E=n.createShader(n.VERTEX_SHADER),O="precision "+a.getPrecision()+" float;\n";n.shaderSource(K,O+C.fragmentShader);n.shaderSource(E,O+C.vertexShader);n.compileShader(K);n.compileShader(E);n.attachShader(M,K);n.attachShader(M,E);n.linkProgram(M);v=M;m=n.getAttribLocation(v,"position");p=n.getAttribLocation(v,"uv");c=n.getUniformLocation(v,"renderType");d=n.getUniformLocation(v,"map");e=n.getUniformLocation(v,"occlusionMap");g=n.getUniformLocation(v,
"opacity");f=n.getUniformLocation(v,"color");h=n.getUniformLocation(v,"scale");l=n.getUniformLocation(v,"rotation");k=n.getUniformLocation(v,"screenPosition")}n.useProgram(v);q.initAttributes();q.enableAttribute(m);q.enableAttribute(p);q.disableUnusedAttributes();n.uniform1i(e,0);n.uniform1i(d,1);n.bindBuffer(n.ARRAY_BUFFER,s);n.vertexAttribPointer(m,2,n.FLOAT,!1,16,0);n.vertexAttribPointer(p,2,n.FLOAT,!1,16,8);n.bindBuffer(n.ELEMENT_ARRAY_BUFFER,t);q.disable(n.CULL_FACE);n.depthMask(!1);M=0;for(K=
b.length;M<K;M++)if(C=16/z,N.set(C*A,C),E=b[M],x.set(E.matrixWorld.elements[12],E.matrixWorld.elements[13],E.matrixWorld.elements[14]),x.applyMatrix4(B.matrixWorldInverse),x.applyProjection(B.projectionMatrix),L.copy(x),Q.x=L.x*J+J,Q.y=L.y*F+F,u||0<Q.x&&Q.x<y&&0<Q.y&&Q.y<z){q.activeTexture(n.TEXTURE0);q.bindTexture(n.TEXTURE_2D,null);q.activeTexture(n.TEXTURE1);q.bindTexture(n.TEXTURE_2D,w);n.copyTexImage2D(n.TEXTURE_2D,0,n.RGB,Q.x-8,Q.y-8,16,16,0);n.uniform1i(c,0);n.uniform2f(h,N.x,N.y);n.uniform3f(k,
L.x,L.y,L.z);q.disable(n.BLEND);q.enable(n.DEPTH_TEST);n.drawElements(n.TRIANGLES,6,n.UNSIGNED_SHORT,0);q.activeTexture(n.TEXTURE0);q.bindTexture(n.TEXTURE_2D,D);n.copyTexImage2D(n.TEXTURE_2D,0,n.RGBA,Q.x-8,Q.y-8,16,16,0);n.uniform1i(c,1);q.disable(n.DEPTH_TEST);q.activeTexture(n.TEXTURE1);q.bindTexture(n.TEXTURE_2D,w);n.drawElements(n.TRIANGLES,6,n.UNSIGNED_SHORT,0);E.positionScreen.copy(L);E.customUpdateCallback?E.customUpdateCallback(E):E.updateLensFlares();n.uniform1i(c,2);q.enable(n.BLEND);for(var O=
0,T=E.lensFlares.length;O<T;O++){var H=E.lensFlares[O];.001<H.opacity&&.001<H.scale&&(L.x=H.x,L.y=H.y,L.z=H.z,C=H.size*H.scale/z,N.x=C*A,N.y=C,n.uniform3f(k,L.x,L.y,L.z),n.uniform2f(h,N.x,N.y),n.uniform1f(l,H.rotation),n.uniform1f(g,H.opacity),n.uniform3f(f,H.color.r,H.color.g,H.color.b),q.setBlending(H.blending,H.blendEquation,H.blendSrc,H.blendDst),a.setTexture(H.texture,1),n.drawElements(n.TRIANGLES,6,n.UNSIGNED_SHORT,0))}}q.enable(n.CULL_FACE);q.enable(n.DEPTH_TEST);n.depthMask(!0);a.resetGLState()}}};
THREE.SpritePlugin=function(a,b){var c,d,e,g,f,h,l,k,m,p,n,q,s,t,v,u,w;function D(a,b){return a.z!==b.z?b.z-a.z:b.id-a.id}var x=a.context,B=a.state,y,z,A,J,F=new THREE.Vector3,C=new THREE.Quaternion,N=new THREE.Vector3;this.render=function(L,Q){if(0!==b.length){if(void 0===A){var M=new Float32Array([-.5,-.5,0,0,.5,-.5,1,0,.5,.5,1,1,-.5,.5,0,1]),K=new Uint16Array([0,1,2,0,2,3]);y=x.createBuffer();z=x.createBuffer();x.bindBuffer(x.ARRAY_BUFFER,y);x.bufferData(x.ARRAY_BUFFER,M,x.STATIC_DRAW);x.bindBuffer(x.ELEMENT_ARRAY_BUFFER,
z);x.bufferData(x.ELEMENT_ARRAY_BUFFER,K,x.STATIC_DRAW);var M=x.createProgram(),K=x.createShader(x.VERTEX_SHADER),E=x.createShader(x.FRAGMENT_SHADER);x.shaderSource(K,["precision "+a.getPrecision()+" float;","uniform mat4 modelViewMatrix;\nuniform mat4 projectionMatrix;\nuniform float rotation;\nuniform vec2 scale;\nuniform vec2 uvOffset;\nuniform vec2 uvScale;\nattribute vec2 position;\nattribute vec2 uv;\nvarying vec2 vUV;\nvoid main() {\nvUV = uvOffset + uv * uvScale;\nvec2 alignedPosition = position * scale;\nvec2 rotatedPosition;\nrotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\nrotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\nvec4 finalPosition;\nfinalPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\nfinalPosition.xy += rotatedPosition;\nfinalPosition = projectionMatrix * finalPosition;\ngl_Position = finalPosition;\n}"].join("\n"));
x.shaderSource(E,["precision "+a.getPrecision()+" float;","uniform vec3 color;\nuniform sampler2D map;\nuniform float opacity;\nuniform int fogType;\nuniform vec3 fogColor;\nuniform float fogDensity;\nuniform float fogNear;\nuniform float fogFar;\nuniform float alphaTest;\nvarying vec2 vUV;\nvoid main() {\nvec4 texture = texture2D( map, vUV );\nif ( texture.a < alphaTest ) discard;\ngl_FragColor = vec4( color * texture.xyz, texture.a * opacity );\nif ( fogType > 0 ) {\nfloat depth = gl_FragCoord.z / gl_FragCoord.w;\nfloat fogFactor = 0.0;\nif ( fogType == 1 ) {\nfogFactor = smoothstep( fogNear, fogFar, depth );\n} else {\nconst float LOG2 = 1.442695;\nfogFactor = exp2( - fogDensity * fogDensity * depth * depth * LOG2 );\nfogFactor = 1.0 - clamp( fogFactor, 0.0, 1.0 );\n}\ngl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );\n}\n}"].join("\n"));
x.compileShader(K);x.compileShader(E);x.attachShader(M,K);x.attachShader(M,E);x.linkProgram(M);A=M;u=x.getAttribLocation(A,"position");w=x.getAttribLocation(A,"uv");c=x.getUniformLocation(A,"uvOffset");d=x.getUniformLocation(A,"uvScale");e=x.getUniformLocation(A,"rotation");g=x.getUniformLocation(A,"scale");f=x.getUniformLocation(A,"color");h=x.getUniformLocation(A,"map");l=x.getUniformLocation(A,"opacity");k=x.getUniformLocation(A,"modelViewMatrix");m=x.getUniformLocation(A,"projectionMatrix");p=
x.getUniformLocation(A,"fogType");n=x.getUniformLocation(A,"fogDensity");q=x.getUniformLocation(A,"fogNear");s=x.getUniformLocation(A,"fogFar");t=x.getUniformLocation(A,"fogColor");v=x.getUniformLocation(A,"alphaTest");M=document.createElement("canvas");M.width=8;M.height=8;K=M.getContext("2d");K.fillStyle="white";K.fillRect(0,0,8,8);J=new THREE.Texture(M);J.needsUpdate=!0}x.useProgram(A);B.initAttributes();B.enableAttribute(u);B.enableAttribute(w);B.disableUnusedAttributes();B.disable(x.CULL_FACE);
B.enable(x.BLEND);x.bindBuffer(x.ARRAY_BUFFER,y);x.vertexAttribPointer(u,2,x.FLOAT,!1,16,0);x.vertexAttribPointer(w,2,x.FLOAT,!1,16,8);x.bindBuffer(x.ELEMENT_ARRAY_BUFFER,z);x.uniformMatrix4fv(m,!1,Q.projectionMatrix.elements);B.activeTexture(x.TEXTURE0);x.uniform1i(h,0);K=M=0;(E=L.fog)?(x.uniform3f(t,E.color.r,E.color.g,E.color.b),E instanceof THREE.Fog?(x.uniform1f(q,E.near),x.uniform1f(s,E.far),x.uniform1i(p,1),K=M=1):E instanceof THREE.FogExp2&&(x.uniform1f(n,E.density),x.uniform1i(p,2),K=M=2)):
(x.uniform1i(p,0),K=M=0);for(var E=0,O=b.length;E<O;E++){var T=b[E];T.modelViewMatrix.multiplyMatrices(Q.matrixWorldInverse,T.matrixWorld);T.z=-T.modelViewMatrix.elements[14]}b.sort(D);for(var H=[],E=0,O=b.length;E<O;E++){var T=b[E],R=T.material;x.uniform1f(v,R.alphaTest);x.uniformMatrix4fv(k,!1,T.modelViewMatrix.elements);T.matrixWorld.decompose(F,C,N);H[0]=N.x;H[1]=N.y;T=0;L.fog&&R.fog&&(T=K);M!==T&&(x.uniform1i(p,T),M=T);null!==R.map?(x.uniform2f(c,R.map.offset.x,R.map.offset.y),x.uniform2f(d,
R.map.repeat.x,R.map.repeat.y)):(x.uniform2f(c,0,0),x.uniform2f(d,1,1));x.uniform1f(l,R.opacity);x.uniform3f(f,R.color.r,R.color.g,R.color.b);x.uniform1f(e,R.rotation);x.uniform2fv(g,H);B.setBlending(R.blending,R.blendEquation,R.blendSrc,R.blendDst);B.setDepthTest(R.depthTest);B.setDepthWrite(R.depthWrite);R.map&&R.map.image&&R.map.image.width?a.setTexture(R.map,0):a.setTexture(J,0);x.drawElements(x.TRIANGLES,6,x.UNSIGNED_SHORT,0)}B.enable(x.CULL_FACE);a.resetGLState()}}};
THREE.CurveUtils={tangentQuadraticBezier:function(a,b,c,d){return 2*(1-a)*(c-b)+2*a*(d-c)},tangentCubicBezier:function(a,b,c,d,e){return-3*b*(1-a)*(1-a)+3*c*(1-a)*(1-a)-6*a*c*(1-a)+6*a*d*(1-a)-3*a*a*d+3*a*a*e},tangentSpline:function(a,b,c,d,e){return 6*a*a-6*a+(3*a*a-4*a+1)+(-6*a*a+6*a)+(3*a*a-2*a)},interpolate:function(a,b,c,d,e){a=.5*(c-a);d=.5*(d-b);var g=e*e;return(2*b-2*c+a+d)*e*g+(-3*b+3*c-2*a-d)*g+a*e+b}};
THREE.GeometryUtils={merge:function(a,b,c){console.warn("THREE.GeometryUtils: .merge() has been moved to Geometry. Use geometry.merge( geometry2, matrix, materialIndexOffset ) instead.");var d;b instanceof THREE.Mesh&&(b.matrixAutoUpdate&&b.updateMatrix(),d=b.matrix,b=b.geometry);a.merge(b,d,c)},center:function(a){console.warn("THREE.GeometryUtils: .center() has been moved to Geometry. Use geometry.center() instead.");return a.center()}};
THREE.ImageUtils={crossOrigin:void 0,loadTexture:function(a,b,c,d){console.warn("THREE.ImageUtils.loadTexture is being deprecated. Use THREE.TextureLoader() instead.");var e=new THREE.TextureLoader;e.setCrossOrigin(this.crossOrigin);a=e.load(a,c,void 0,d);b&&(a.mapping=b);return a},loadTextureCube:function(a,b,c,d){console.warn("THREE.ImageUtils.loadTextureCube is being deprecated. Use THREE.CubeTextureLoader() instead.");var e=new THREE.CubeTextureLoader;e.setCrossOrigin(this.crossOrigin);a=e.load(a,
c,void 0,d);b&&(a.mapping=b);return a},loadCompressedTexture:function(){console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.")},loadCompressedTextureCube:function(){console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.")}};
THREE.SceneUtils={createMultiMaterialObject:function(a,b){for(var c=new THREE.Group,d=0,e=b.length;d<e;d++)c.add(new THREE.Mesh(a,b[d]));return c},detach:function(a,b,c){a.applyMatrix(b.matrixWorld);b.remove(a);c.add(a)},attach:function(a,b,c){var d=new THREE.Matrix4;d.getInverse(c.matrixWorld);a.applyMatrix(d);b.remove(a);c.add(a)}};
THREE.ShapeUtils={area:function(a){for(var b=a.length,c=0,d=b-1,e=0;e<b;d=e++)c+=a[d].x*a[e].y-a[e].x*a[d].y;return.5*c},triangulate:function(){return function(a,b){var c=a.length;if(3>c)return null;var d=[],e=[],g=[],f,h,l;if(0<THREE.ShapeUtils.area(a))for(h=0;h<c;h++)e[h]=h;else for(h=0;h<c;h++)e[h]=c-1-h;var k=2*c;for(h=c-1;2<c;){if(0>=k--){console.warn("THREE.ShapeUtils: Unable to triangulate polygon! in triangulate()");break}f=h;c<=f&&(f=0);h=f+1;c<=h&&(h=0);l=h+1;c<=l&&(l=0);var m;a:{var p=
m=void 0,n=void 0,q=void 0,s=void 0,t=void 0,v=void 0,u=void 0,w=void 0,p=a[e[f]].x,n=a[e[f]].y,q=a[e[h]].x,s=a[e[h]].y,t=a[e[l]].x,v=a[e[l]].y;if(Number.EPSILON>(q-p)*(v-n)-(s-n)*(t-p))m=!1;else{var D=void 0,x=void 0,B=void 0,y=void 0,z=void 0,A=void 0,J=void 0,F=void 0,C=void 0,N=void 0,C=F=J=w=u=void 0,D=t-q,x=v-s,B=p-t,y=n-v,z=q-p,A=s-n;for(m=0;m<c;m++)if(u=a[e[m]].x,w=a[e[m]].y,!(u===p&&w===n||u===q&&w===s||u===t&&w===v)&&(J=u-p,F=w-n,C=u-q,N=w-s,u-=t,w-=v,C=D*N-x*C,J=z*F-A*J,F=B*w-y*u,C>=-Number.EPSILON&&
F>=-Number.EPSILON&&J>=-Number.EPSILON)){m=!1;break a}m=!0}}if(m){d.push([a[e[f]],a[e[h]],a[e[l]]]);g.push([e[f],e[h],e[l]]);f=h;for(l=h+1;l<c;f++,l++)e[f]=e[l];c--;k=2*c}}return b?g:d}}(),triangulateShape:function(a,b){function c(a,b,c){return a.x!==b.x?a.x<b.x?a.x<=c.x&&c.x<=b.x:b.x<=c.x&&c.x<=a.x:a.y<b.y?a.y<=c.y&&c.y<=b.y:b.y<=c.y&&c.y<=a.y}function d(a,b,d,e,f){var g=b.x-a.x,h=b.y-a.y,k=e.x-d.x,l=e.y-d.y,m=a.x-d.x,p=a.y-d.y,z=h*k-g*l,A=h*m-g*p;if(Math.abs(z)>Number.EPSILON){if(0<z){if(0>A||A>
z)return[];k=l*m-k*p;if(0>k||k>z)return[]}else{if(0<A||A<z)return[];k=l*m-k*p;if(0<k||k<z)return[]}if(0===k)return!f||0!==A&&A!==z?[a]:[];if(k===z)return!f||0!==A&&A!==z?[b]:[];if(0===A)return[d];if(A===z)return[e];f=k/z;return[{x:a.x+f*g,y:a.y+f*h}]}if(0!==A||l*m!==k*p)return[];h=0===g&&0===h;k=0===k&&0===l;if(h&&k)return a.x!==d.x||a.y!==d.y?[]:[a];if(h)return c(d,e,a)?[a]:[];if(k)return c(a,b,d)?[d]:[];0!==g?(a.x<b.x?(g=a,k=a.x,h=b,a=b.x):(g=b,k=b.x,h=a,a=a.x),d.x<e.x?(b=d,z=d.x,l=e,d=e.x):(b=
e,z=e.x,l=d,d=d.x)):(a.y<b.y?(g=a,k=a.y,h=b,a=b.y):(g=b,k=b.y,h=a,a=a.y),d.y<e.y?(b=d,z=d.y,l=e,d=e.y):(b=e,z=e.y,l=d,d=d.y));return k<=z?a<z?[]:a===z?f?[]:[b]:a<=d?[b,h]:[b,l]:k>d?[]:k===d?f?[]:[g]:a<=d?[g,h]:[g,l]}function e(a,b,c,d){var e=b.x-a.x,f=b.y-a.y;b=c.x-a.x;c=c.y-a.y;var g=d.x-a.x;d=d.y-a.y;a=e*c-f*b;e=e*d-f*g;return Math.abs(a)>Number.EPSILON?(b=g*c-d*b,0<a?0<=e&&0<=b:0<=e||0<=b):0<e}var g,f,h,l,k,m={};h=a.concat();g=0;for(f=b.length;g<f;g++)Array.prototype.push.apply(h,b[g]);g=0;for(f=
h.length;g<f;g++)k=h[g].x+":"+h[g].y,void 0!==m[k]&&console.warn("THREE.Shape: Duplicate point",k),m[k]=g;g=function(a,b){function c(a,b){var d=h.length-1,f=a-1;0>f&&(f=d);var g=a+1;g>d&&(g=0);d=e(h[a],h[f],h[g],k[b]);if(!d)return!1;d=k.length-1;f=b-1;0>f&&(f=d);g=b+1;g>d&&(g=0);return(d=e(k[b],k[f],k[g],h[a]))?!0:!1}function f(a,b){var c,e;for(c=0;c<h.length;c++)if(e=c+1,e%=h.length,e=d(a,b,h[c],h[e],!0),0<e.length)return!0;return!1}function g(a,c){var e,f,h,k;for(e=0;e<l.length;e++)for(f=b[l[e]],
h=0;h<f.length;h++)if(k=h+1,k%=f.length,k=d(a,c,f[h],f[k],!0),0<k.length)return!0;return!1}var h=a.concat(),k,l=[],m,p,y,z,A,J=[],F,C,N,L=0;for(m=b.length;L<m;L++)l.push(L);F=0;for(var Q=2*l.length;0<l.length;){Q--;if(0>Q){console.log("Infinite Loop! Holes left:"+l.length+", Probably Hole outside Shape!");break}for(p=F;p<h.length;p++){y=h[p];m=-1;for(L=0;L<l.length;L++)if(z=l[L],A=y.x+":"+y.y+":"+z,void 0===J[A]){k=b[z];for(C=0;C<k.length;C++)if(z=k[C],c(p,C)&&!f(y,z)&&!g(y,z)){m=C;l.splice(L,1);
F=h.slice(0,p+1);z=h.slice(p);C=k.slice(m);N=k.slice(0,m+1);h=F.concat(C).concat(N).concat(z);F=p;break}if(0<=m)break;J[A]=!0}if(0<=m)break}}return h}(a,b);var p=THREE.ShapeUtils.triangulate(g,!1);g=0;for(f=p.length;g<f;g++)for(l=p[g],h=0;3>h;h++)k=l[h].x+":"+l[h].y,k=m[k],void 0!==k&&(l[h]=k);return p.concat()},isClockWise:function(a){return 0>THREE.ShapeUtils.area(a)},b2:function(){return function(a,b,c,d){var e=1-a;return e*e*b+2*(1-a)*a*c+a*a*d}}(),b3:function(){return function(a,b,c,d,e){var g=
1-a,f=1-a;return g*g*g*b+3*f*f*a*c+3*(1-a)*a*a*d+a*a*a*e}}()};THREE.Audio=function(a){THREE.Object3D.call(this);this.type="Audio";this.context=a.context;this.source=this.context.createBufferSource();this.source.onended=this.onEnded.bind(this);this.gain=this.context.createGain();this.gain.connect(this.context.destination);this.panner=this.context.createPanner();this.panner.connect(this.gain);this.autoplay=!1;this.startTime=0;this.playbackRate=1;this.isPlaying=!1};THREE.Audio.prototype=Object.create(THREE.Object3D.prototype);
THREE.Audio.prototype.constructor=THREE.Audio;THREE.Audio.prototype.load=function(a){var b=this,c=new XMLHttpRequest;c.open("GET",a,!0);c.responseType="arraybuffer";c.onload=function(a){b.context.decodeAudioData(this.response,function(a){b.source.buffer=a;b.autoplay&&b.play()})};c.send();return this};
THREE.Audio.prototype.play=function(){if(!0===this.isPlaying)console.warn("THREE.Audio: Audio is already playing.");else{var a=this.context.createBufferSource();a.buffer=this.source.buffer;a.loop=this.source.loop;a.onended=this.source.onended;a.start(0,this.startTime);a.playbackRate.value=this.playbackRate;this.isPlaying=!0;this.source=a;this.connect()}};THREE.Audio.prototype.pause=function(){this.source.stop();this.startTime=this.context.currentTime};
THREE.Audio.prototype.stop=function(){this.source.stop();this.startTime=0};THREE.Audio.prototype.connect=function(){void 0!==this.filter?(this.source.connect(this.filter),this.filter.connect(this.panner)):this.source.connect(this.panner)};THREE.Audio.prototype.disconnect=function(){void 0!==this.filter?(this.source.disconnect(this.filter),this.filter.disconnect(this.panner)):this.source.disconnect(this.panner)};
THREE.Audio.prototype.setFilter=function(a){!0===this.isPlaying?(this.disconnect(),this.filter=a,this.connect()):this.filter=a};THREE.Audio.prototype.getFilter=function(){return this.filter};THREE.Audio.prototype.setPlaybackRate=function(a){this.playbackRate=a;!0===this.isPlaying&&(this.source.playbackRate.value=this.playbackRate)};THREE.Audio.prototype.getPlaybackRate=function(){return this.playbackRate};THREE.Audio.prototype.onEnded=function(){this.isPlaying=!1};
THREE.Audio.prototype.setLoop=function(a){this.source.loop=a};THREE.Audio.prototype.getLoop=function(){return this.source.loop};THREE.Audio.prototype.setRefDistance=function(a){this.panner.refDistance=a};THREE.Audio.prototype.getRefDistance=function(){return this.panner.refDistance};THREE.Audio.prototype.setRolloffFactor=function(a){this.panner.rolloffFactor=a};THREE.Audio.prototype.getRolloffFactor=function(){return this.panner.rolloffFactor};
THREE.Audio.prototype.setVolume=function(a){this.gain.gain.value=a};THREE.Audio.prototype.getVolume=function(){return this.gain.gain.value};THREE.Audio.prototype.updateMatrixWorld=function(){var a=new THREE.Vector3;return function(b){THREE.Object3D.prototype.updateMatrixWorld.call(this,b);a.setFromMatrixPosition(this.matrixWorld);this.panner.setPosition(a.x,a.y,a.z)}}();THREE.AudioListener=function(){THREE.Object3D.call(this);this.type="AudioListener";this.context=new (window.AudioContext||window.webkitAudioContext)};
THREE.AudioListener.prototype=Object.create(THREE.Object3D.prototype);THREE.AudioListener.prototype.constructor=THREE.AudioListener;
THREE.AudioListener.prototype.updateMatrixWorld=function(){var a=new THREE.Vector3,b=new THREE.Quaternion,c=new THREE.Vector3,d=new THREE.Vector3;return function(e){THREE.Object3D.prototype.updateMatrixWorld.call(this,e);e=this.context.listener;var g=this.up;this.matrixWorld.decompose(a,b,c);d.set(0,0,-1).applyQuaternion(b);e.setPosition(a.x,a.y,a.z);e.setOrientation(d.x,d.y,d.z,g.x,g.y,g.z)}}();THREE.Curve=function(){};
THREE.Curve.prototype={constructor:THREE.Curve,getPoint:function(a){console.warn("THREE.Curve: Warning, getPoint() not implemented!");return null},getPointAt:function(a){a=this.getUtoTmapping(a);return this.getPoint(a)},getPoints:function(a){a||(a=5);var b,c=[];for(b=0;b<=a;b++)c.push(this.getPoint(b/a));return c},getSpacedPoints:function(a){a||(a=5);var b,c=[];for(b=0;b<=a;b++)c.push(this.getPointAt(b/a));return c},getLength:function(){var a=this.getLengths();return a[a.length-1]},getLengths:function(a){a||
(a=this.__arcLengthDivisions?this.__arcLengthDivisions:200);if(this.cacheArcLengths&&this.cacheArcLengths.length===a+1&&!this.needsUpdate)return this.cacheArcLengths;this.needsUpdate=!1;var b=[],c,d=this.getPoint(0),e,g=0;b.push(0);for(e=1;e<=a;e++)c=this.getPoint(e/a),g+=c.distanceTo(d),b.push(g),d=c;return this.cacheArcLengths=b},updateArcLengths:function(){this.needsUpdate=!0;this.getLengths()},getUtoTmapping:function(a,b){var c=this.getLengths(),d=0,e=c.length,g;g=b?b:a*c[e-1];for(var f=0,h=e-
1,l;f<=h;)if(d=Math.floor(f+(h-f)/2),l=c[d]-g,0>l)f=d+1;else if(0<l)h=d-1;else{h=d;break}d=h;if(c[d]===g)return d/(e-1);f=c[d];return c=(d+(g-f)/(c[d+1]-f))/(e-1)},getTangent:function(a){var b=a-1E-4;a+=1E-4;0>b&&(b=0);1<a&&(a=1);b=this.getPoint(b);return this.getPoint(a).clone().sub(b).normalize()},getTangentAt:function(a){a=this.getUtoTmapping(a);return this.getTangent(a)}};THREE.Curve.Utils=THREE.CurveUtils;
THREE.Curve.create=function(a,b){a.prototype=Object.create(THREE.Curve.prototype);a.prototype.constructor=a;a.prototype.getPoint=b;return a};THREE.CurvePath=function(){this.curves=[];this.autoClose=!1};THREE.CurvePath.prototype=Object.create(THREE.Curve.prototype);THREE.CurvePath.prototype.constructor=THREE.CurvePath;THREE.CurvePath.prototype.add=function(a){this.curves.push(a)};
THREE.CurvePath.prototype.closePath=function(){var a=this.curves[0].getPoint(0),b=this.curves[this.curves.length-1].getPoint(1);a.equals(b)||this.curves.push(new THREE.LineCurve(b,a))};THREE.CurvePath.prototype.getPoint=function(a){for(var b=a*this.getLength(),c=this.getCurveLengths(),d=0;d<c.length;){if(c[d]>=b)return a=this.curves[d],b=1-(c[d]-b)/a.getLength(),a.getPointAt(b);d++}return null};THREE.CurvePath.prototype.getLength=function(){var a=this.getCurveLengths();return a[a.length-1]};
THREE.CurvePath.prototype.getCurveLengths=function(){if(this.cacheLengths&&this.cacheLengths.length===this.curves.length)return this.cacheLengths;for(var a=[],b=0,c=0,d=this.curves.length;c<d;c++)b+=this.curves[c].getLength(),a.push(b);return this.cacheLengths=a};THREE.CurvePath.prototype.createPointsGeometry=function(a){a=this.getPoints(a,!0);return this.createGeometry(a)};THREE.CurvePath.prototype.createSpacedPointsGeometry=function(a){a=this.getSpacedPoints(a,!0);return this.createGeometry(a)};
THREE.CurvePath.prototype.createGeometry=function(a){for(var b=new THREE.Geometry,c=0,d=a.length;c<d;c++){var e=a[c];b.vertices.push(new THREE.Vector3(e.x,e.y,e.z||0))}return b};THREE.Path=function(a){THREE.CurvePath.call(this);this.actions=[];a&&this.fromPoints(a)};THREE.Path.prototype=Object.create(THREE.CurvePath.prototype);THREE.Path.prototype.constructor=THREE.Path;THREE.Path.prototype.fromPoints=function(a){this.moveTo(a[0].x,a[0].y);for(var b=1,c=a.length;b<c;b++)this.lineTo(a[b].x,a[b].y)};
THREE.Path.prototype.moveTo=function(a,b){this.actions.push({action:"moveTo",args:[a,b]})};THREE.Path.prototype.lineTo=function(a,b){var c=this.actions[this.actions.length-1].args,c=new THREE.LineCurve(new THREE.Vector2(c[c.length-2],c[c.length-1]),new THREE.Vector2(a,b));this.curves.push(c);this.actions.push({action:"lineTo",args:[a,b]})};
THREE.Path.prototype.quadraticCurveTo=function(a,b,c,d){var e=this.actions[this.actions.length-1].args,e=new THREE.QuadraticBezierCurve(new THREE.Vector2(e[e.length-2],e[e.length-1]),new THREE.Vector2(a,b),new THREE.Vector2(c,d));this.curves.push(e);this.actions.push({action:"quadraticCurveTo",args:[a,b,c,d]})};
THREE.Path.prototype.bezierCurveTo=function(a,b,c,d,e,g){var f=this.actions[this.actions.length-1].args,f=new THREE.CubicBezierCurve(new THREE.Vector2(f[f.length-2],f[f.length-1]),new THREE.Vector2(a,b),new THREE.Vector2(c,d),new THREE.Vector2(e,g));this.curves.push(f);this.actions.push({action:"bezierCurveTo",args:[a,b,c,d,e,g]})};
THREE.Path.prototype.splineThru=function(a){var b=Array.prototype.slice.call(arguments),c=this.actions[this.actions.length-1].args,c=[new THREE.Vector2(c[c.length-2],c[c.length-1])];Array.prototype.push.apply(c,a);c=new THREE.SplineCurve(c);this.curves.push(c);this.actions.push({action:"splineThru",args:b})};THREE.Path.prototype.arc=function(a,b,c,d,e,g){var f=this.actions[this.actions.length-1].args;this.absarc(a+f[f.length-2],b+f[f.length-1],c,d,e,g)};
THREE.Path.prototype.absarc=function(a,b,c,d,e,g){this.absellipse(a,b,c,c,d,e,g)};THREE.Path.prototype.ellipse=function(a,b,c,d,e,g,f,h){var l=this.actions[this.actions.length-1].args;this.absellipse(a+l[l.length-2],b+l[l.length-1],c,d,e,g,f,h)};THREE.Path.prototype.absellipse=function(a,b,c,d,e,g,f,h){var l=[a,b,c,d,e,g,f,h||0];a=new THREE.EllipseCurve(a,b,c,d,e,g,f,h);this.curves.push(a);a=a.getPoint(1);l.push(a.x);l.push(a.y);this.actions.push({action:"ellipse",args:l})};
THREE.Path.prototype.getSpacedPoints=function(a,b){a||(a=40);for(var c=[],d=0;d<a;d++)c.push(this.getPoint(d/a));return c};
THREE.Path.prototype.getPoints=function(a,b){a=a||12;for(var c=THREE.ShapeUtils.b2,d=THREE.ShapeUtils.b3,e=[],g,f,h,l,k,m,p,n,q,s,t=0,v=this.actions.length;t<v;t++){q=this.actions[t];var u=q.args;switch(q.action){case "moveTo":e.push(new THREE.Vector2(u[0],u[1]));break;case "lineTo":e.push(new THREE.Vector2(u[0],u[1]));break;case "quadraticCurveTo":g=u[2];f=u[3];k=u[0];m=u[1];0<e.length?(q=e[e.length-1],p=q.x,n=q.y):(q=this.actions[t-1].args,p=q[q.length-2],n=q[q.length-1]);for(u=1;u<=a;u++)s=u/a,
q=c(s,p,k,g),s=c(s,n,m,f),e.push(new THREE.Vector2(q,s));break;case "bezierCurveTo":g=u[4];f=u[5];k=u[0];m=u[1];h=u[2];l=u[3];0<e.length?(q=e[e.length-1],p=q.x,n=q.y):(q=this.actions[t-1].args,p=q[q.length-2],n=q[q.length-1]);for(u=1;u<=a;u++)s=u/a,q=d(s,p,k,h,g),s=d(s,n,m,l,f),e.push(new THREE.Vector2(q,s));break;case "splineThru":q=this.actions[t-1].args;s=[new THREE.Vector2(q[q.length-2],q[q.length-1])];q=a*u[0].length;s=s.concat(u[0]);s=new THREE.SplineCurve(s);for(u=1;u<=q;u++)e.push(s.getPointAt(u/
q));break;case "arc":g=u[0];f=u[1];m=u[2];h=u[3];q=u[4];k=!!u[5];p=q-h;n=2*a;for(u=1;u<=n;u++)s=u/n,k||(s=1-s),s=h+s*p,q=g+m*Math.cos(s),s=f+m*Math.sin(s),e.push(new THREE.Vector2(q,s));break;case "ellipse":g=u[0];f=u[1];m=u[2];l=u[3];h=u[4];q=u[5];k=!!u[6];var w=u[7];p=q-h;n=2*a;var D,x;0!==w&&(D=Math.cos(w),x=Math.sin(w));for(u=1;u<=n;u++){s=u/n;k||(s=1-s);s=h+s*p;q=g+m*Math.cos(s);s=f+l*Math.sin(s);if(0!==w){var B=q;q=(B-g)*D-(s-f)*x+g;s=(B-g)*x+(s-f)*D+f}e.push(new THREE.Vector2(q,s))}}}c=e[e.length-
1];Math.abs(c.x-e[0].x)<Number.EPSILON&&Math.abs(c.y-e[0].y)<Number.EPSILON&&e.splice(e.length-1,1);b&&e.push(e[0]);return e};
THREE.Path.prototype.toShapes=function(a,b){function c(a){for(var b=[],c=0,d=a.length;c<d;c++){var e=a[c],f=new THREE.Shape;f.actions=e.actions;f.curves=e.curves;b.push(f)}return b}function d(a,b){for(var c=b.length,d=!1,e=c-1,f=0;f<c;e=f++){var g=b[e],h=b[f],k=h.x-g.x,l=h.y-g.y;if(Math.abs(l)>Number.EPSILON){if(0>l&&(g=b[f],k=-k,h=b[e],l=-l),!(a.y<g.y||a.y>h.y))if(a.y===g.y){if(a.x===g.x)return!0}else{e=l*(a.x-g.x)-k*(a.y-g.y);if(0===e)return!0;0>e||(d=!d)}}else if(a.y===g.y&&(h.x<=a.x&&a.x<=g.x||
g.x<=a.x&&a.x<=h.x))return!0}return d}var e=THREE.ShapeUtils.isClockWise,g=function(a){for(var b=[],c=new THREE.Path,d=0,e=a.length;d<e;d++){var f=a[d],g=f.args,f=f.action;"moveTo"===f&&0!==c.actions.length&&(b.push(c),c=new THREE.Path);c[f].apply(c,g)}0!==c.actions.length&&b.push(c);return b}(this.actions);if(0===g.length)return[];if(!0===b)return c(g);var f,h,l,k=[];if(1===g.length)return h=g[0],l=new THREE.Shape,l.actions=h.actions,l.curves=h.curves,k.push(l),k;var m=!e(g[0].getPoints()),m=a?!m:
m;l=[];var p=[],n=[],q=0,s;p[q]=void 0;n[q]=[];for(var t=0,v=g.length;t<v;t++)h=g[t],s=h.getPoints(),f=e(s),(f=a?!f:f)?(!m&&p[q]&&q++,p[q]={s:new THREE.Shape,p:s},p[q].s.actions=h.actions,p[q].s.curves=h.curves,m&&q++,n[q]=[]):n[q].push({h:h,p:s[0]});if(!p[0])return c(g);if(1<p.length){t=!1;h=[];e=0;for(g=p.length;e<g;e++)l[e]=[];e=0;for(g=p.length;e<g;e++)for(f=n[e],m=0;m<f.length;m++){q=f[m];s=!0;for(v=0;v<p.length;v++)d(q.p,p[v].p)&&(e!==v&&h.push({froms:e,tos:v,hole:m}),s?(s=!1,l[v].push(q)):
t=!0);s&&l[e].push(q)}0<h.length&&(t||(n=l))}t=0;for(e=p.length;t<e;t++)for(l=p[t].s,k.push(l),h=n[t],g=0,f=h.length;g<f;g++)l.holes.push(h[g].h);return k};THREE.Shape=function(){THREE.Path.apply(this,arguments);this.holes=[]};THREE.Shape.prototype=Object.create(THREE.Path.prototype);THREE.Shape.prototype.constructor=THREE.Shape;THREE.Shape.prototype.extrude=function(a){return new THREE.ExtrudeGeometry(this,a)};THREE.Shape.prototype.makeGeometry=function(a){return new THREE.ShapeGeometry(this,a)};
THREE.Shape.prototype.getPointsHoles=function(a){for(var b=[],c=0,d=this.holes.length;c<d;c++)b[c]=this.holes[c].getPoints(a);return b};THREE.Shape.prototype.extractAllPoints=function(a){return{shape:this.getPoints(a),holes:this.getPointsHoles(a)}};THREE.Shape.prototype.extractPoints=function(a){return this.extractAllPoints(a)};THREE.Shape.Utils=THREE.ShapeUtils;THREE.LineCurve=function(a,b){this.v1=a;this.v2=b};THREE.LineCurve.prototype=Object.create(THREE.Curve.prototype);
THREE.LineCurve.prototype.constructor=THREE.LineCurve;THREE.LineCurve.prototype.getPoint=function(a){var b=this.v2.clone().sub(this.v1);b.multiplyScalar(a).add(this.v1);return b};THREE.LineCurve.prototype.getPointAt=function(a){return this.getPoint(a)};THREE.LineCurve.prototype.getTangent=function(a){return this.v2.clone().sub(this.v1).normalize()};THREE.QuadraticBezierCurve=function(a,b,c){this.v0=a;this.v1=b;this.v2=c};THREE.QuadraticBezierCurve.prototype=Object.create(THREE.Curve.prototype);
THREE.QuadraticBezierCurve.prototype.constructor=THREE.QuadraticBezierCurve;THREE.QuadraticBezierCurve.prototype.getPoint=function(a){var b=THREE.ShapeUtils.b2;return new THREE.Vector2(b(a,this.v0.x,this.v1.x,this.v2.x),b(a,this.v0.y,this.v1.y,this.v2.y))};THREE.QuadraticBezierCurve.prototype.getTangent=function(a){var b=THREE.CurveUtils.tangentQuadraticBezier;return(new THREE.Vector2(b(a,this.v0.x,this.v1.x,this.v2.x),b(a,this.v0.y,this.v1.y,this.v2.y))).normalize()};
THREE.CubicBezierCurve=function(a,b,c,d){this.v0=a;this.v1=b;this.v2=c;this.v3=d};THREE.CubicBezierCurve.prototype=Object.create(THREE.Curve.prototype);THREE.CubicBezierCurve.prototype.constructor=THREE.CubicBezierCurve;THREE.CubicBezierCurve.prototype.getPoint=function(a){var b=THREE.ShapeUtils.b3;return new THREE.Vector2(b(a,this.v0.x,this.v1.x,this.v2.x,this.v3.x),b(a,this.v0.y,this.v1.y,this.v2.y,this.v3.y))};
THREE.CubicBezierCurve.prototype.getTangent=function(a){var b=THREE.CurveUtils.tangentCubicBezier;return(new THREE.Vector2(b(a,this.v0.x,this.v1.x,this.v2.x,this.v3.x),b(a,this.v0.y,this.v1.y,this.v2.y,this.v3.y))).normalize()};THREE.SplineCurve=function(a){this.points=void 0==a?[]:a};THREE.SplineCurve.prototype=Object.create(THREE.Curve.prototype);THREE.SplineCurve.prototype.constructor=THREE.SplineCurve;
THREE.SplineCurve.prototype.getPoint=function(a){var b=this.points;a*=b.length-1;var c=Math.floor(a);a-=c;var d=b[0===c?c:c-1],e=b[c],g=b[c>b.length-2?b.length-1:c+1],b=b[c>b.length-3?b.length-1:c+2],c=THREE.CurveUtils.interpolate;return new THREE.Vector2(c(d.x,e.x,g.x,b.x,a),c(d.y,e.y,g.y,b.y,a))};THREE.EllipseCurve=function(a,b,c,d,e,g,f,h){this.aX=a;this.aY=b;this.xRadius=c;this.yRadius=d;this.aStartAngle=e;this.aEndAngle=g;this.aClockwise=f;this.aRotation=h||0};THREE.EllipseCurve.prototype=Object.create(THREE.Curve.prototype);
THREE.EllipseCurve.prototype.constructor=THREE.EllipseCurve;
THREE.EllipseCurve.prototype.getPoint=function(a){var b=this.aEndAngle-this.aStartAngle;0>b&&(b+=2*Math.PI);b>2*Math.PI&&(b-=2*Math.PI);b=!0===this.aClockwise?this.aEndAngle+(1-a)*(2*Math.PI-b):this.aStartAngle+a*b;a=this.aX+this.xRadius*Math.cos(b);var c=this.aY+this.yRadius*Math.sin(b);if(0!==this.aRotation){var b=Math.cos(this.aRotation),d=Math.sin(this.aRotation),e=a;a=(e-this.aX)*b-(c-this.aY)*d+this.aX;c=(e-this.aX)*d+(c-this.aY)*b+this.aY}return new THREE.Vector2(a,c)};
THREE.ArcCurve=function(a,b,c,d,e,g){THREE.EllipseCurve.call(this,a,b,c,c,d,e,g)};THREE.ArcCurve.prototype=Object.create(THREE.EllipseCurve.prototype);THREE.ArcCurve.prototype.constructor=THREE.ArcCurve;THREE.LineCurve3=THREE.Curve.create(function(a,b){this.v1=a;this.v2=b},function(a){var b=new THREE.Vector3;b.subVectors(this.v2,this.v1);b.multiplyScalar(a);b.add(this.v1);return b});
THREE.QuadraticBezierCurve3=THREE.Curve.create(function(a,b,c){this.v0=a;this.v1=b;this.v2=c},function(a){var b=THREE.ShapeUtils.b2;return new THREE.Vector3(b(a,this.v0.x,this.v1.x,this.v2.x),b(a,this.v0.y,this.v1.y,this.v2.y),b(a,this.v0.z,this.v1.z,this.v2.z))});
THREE.CubicBezierCurve3=THREE.Curve.create(function(a,b,c,d){this.v0=a;this.v1=b;this.v2=c;this.v3=d},function(a){var b=THREE.ShapeUtils.b3;return new THREE.Vector3(b(a,this.v0.x,this.v1.x,this.v2.x,this.v3.x),b(a,this.v0.y,this.v1.y,this.v2.y,this.v3.y),b(a,this.v0.z,this.v1.z,this.v2.z,this.v3.z))});
THREE.SplineCurve3=THREE.Curve.create(function(a){console.warn("THREE.SplineCurve3 will be deprecated. Please use THREE.CatmullRomCurve3");this.points=void 0==a?[]:a},function(a){var b=this.points;a*=b.length-1;var c=Math.floor(a);a-=c;var d=b[0==c?c:c-1],e=b[c],g=b[c>b.length-2?b.length-1:c+1],b=b[c>b.length-3?b.length-1:c+2],c=THREE.CurveUtils.interpolate;return new THREE.Vector3(c(d.x,e.x,g.x,b.x,a),c(d.y,e.y,g.y,b.y,a),c(d.z,e.z,g.z,b.z,a))});
THREE.CatmullRomCurve3=function(){function a(){}var b=new THREE.Vector3,c=new a,d=new a,e=new a;a.prototype.init=function(a,b,c,d){this.c0=a;this.c1=c;this.c2=-3*a+3*b-2*c-d;this.c3=2*a-2*b+c+d};a.prototype.initNonuniformCatmullRom=function(a,b,c,d,e,m,p){a=((b-a)/e-(c-a)/(e+m)+(c-b)/m)*m;d=((c-b)/m-(d-b)/(m+p)+(d-c)/p)*m;this.init(b,c,a,d)};a.prototype.initCatmullRom=function(a,b,c,d,e){this.init(b,c,e*(c-a),e*(d-b))};a.prototype.calc=function(a){var b=a*a;return this.c0+this.c1*a+this.c2*b+this.c3*
b*a};return THREE.Curve.create(function(a){this.points=a||[]},function(a){var f=this.points,h,l;l=f.length;2>l&&console.log("duh, you need at least 2 points");a*=l-1;h=Math.floor(a);a-=h;0===a&&h===l-1&&(h=l-2,a=1);var k,m,p;0===h?(b.subVectors(f[0],f[1]).add(f[0]),k=b):k=f[h-1];m=f[h];p=f[h+1];h+2<l?f=f[h+2]:(b.subVectors(f[l-1],f[l-2]).add(f[l-2]),f=b);if(void 0===this.type||"centripetal"===this.type||"chordal"===this.type){var n="chordal"===this.type?.5:.25;l=Math.pow(k.distanceToSquared(m),n);
h=Math.pow(m.distanceToSquared(p),n);n=Math.pow(p.distanceToSquared(f),n);1E-4>h&&(h=1);1E-4>l&&(l=h);1E-4>n&&(n=h);c.initNonuniformCatmullRom(k.x,m.x,p.x,f.x,l,h,n);d.initNonuniformCatmullRom(k.y,m.y,p.y,f.y,l,h,n);e.initNonuniformCatmullRom(k.z,m.z,p.z,f.z,l,h,n)}else"catmullrom"===this.type&&(l=void 0!==this.tension?this.tension:.5,c.initCatmullRom(k.x,m.x,p.x,f.x,l),d.initCatmullRom(k.y,m.y,p.y,f.y,l),e.initCatmullRom(k.z,m.z,p.z,f.z,l));return new THREE.Vector3(c.calc(a),d.calc(a),e.calc(a))})}();
THREE.ClosedSplineCurve3=THREE.Curve.create(function(a){this.points=void 0==a?[]:a},function(a){var b=this.points;a*=b.length-0;var c=Math.floor(a);a-=c;var c=c+(0<c?0:(Math.floor(Math.abs(c)/b.length)+1)*b.length),d=b[(c-1)%b.length],e=b[c%b.length],g=b[(c+1)%b.length],b=b[(c+2)%b.length],c=THREE.CurveUtils.interpolate;return new THREE.Vector3(c(d.x,e.x,g.x,b.x,a),c(d.y,e.y,g.y,b.y,a),c(d.z,e.z,g.z,b.z,a))});
THREE.BoxGeometry=function(a,b,c,d,e,g){function f(a,b,c,d,e,f,g,t){var v,u=h.widthSegments,w=h.heightSegments,D=e/2,x=f/2,B=h.vertices.length;if("x"===a&&"y"===b||"y"===a&&"x"===b)v="z";else if("x"===a&&"z"===b||"z"===a&&"x"===b)v="y",w=h.depthSegments;else if("z"===a&&"y"===b||"y"===a&&"z"===b)v="x",u=h.depthSegments;var y=u+1,z=w+1,A=e/u,J=f/w,F=new THREE.Vector3;F[v]=0<g?1:-1;for(e=0;e<z;e++)for(f=0;f<y;f++){var C=new THREE.Vector3;C[a]=(f*A-D)*c;C[b]=(e*J-x)*d;C[v]=g;h.vertices.push(C)}for(e=
0;e<w;e++)for(f=0;f<u;f++)x=f+y*e,a=f+y*(e+1),b=f+1+y*(e+1),c=f+1+y*e,d=new THREE.Vector2(f/u,1-e/w),g=new THREE.Vector2(f/u,1-(e+1)/w),v=new THREE.Vector2((f+1)/u,1-(e+1)/w),D=new THREE.Vector2((f+1)/u,1-e/w),x=new THREE.Face3(x+B,a+B,c+B),x.normal.copy(F),x.vertexNormals.push(F.clone(),F.clone(),F.clone()),x.materialIndex=t,h.faces.push(x),h.faceVertexUvs[0].push([d,g,D]),x=new THREE.Face3(a+B,b+B,c+B),x.normal.copy(F),x.vertexNormals.push(F.clone(),F.clone(),F.clone()),x.materialIndex=t,h.faces.push(x),
h.faceVertexUvs[0].push([g.clone(),v,D.clone()])}THREE.Geometry.call(this);this.type="BoxGeometry";this.parameters={width:a,height:b,depth:c,widthSegments:d,heightSegments:e,depthSegments:g};this.widthSegments=d||1;this.heightSegments=e||1;this.depthSegments=g||1;var h=this;d=a/2;e=b/2;g=c/2;f("z","y",-1,-1,c,b,d,0);f("z","y",1,-1,c,b,-d,1);f("x","z",1,1,a,c,e,2);f("x","z",1,-1,a,c,-e,3);f("x","y",1,-1,a,b,g,4);f("x","y",-1,-1,a,b,-g,5);this.mergeVertices()};THREE.BoxGeometry.prototype=Object.create(THREE.Geometry.prototype);
THREE.BoxGeometry.prototype.constructor=THREE.BoxGeometry;THREE.BoxGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.BoxGeometry(a.width,a.height,a.depth,a.widthSegments,a.heightSegments,a.depthSegments)};THREE.CubeGeometry=THREE.BoxGeometry;THREE.CircleGeometry=function(a,b,c,d){THREE.Geometry.call(this);this.type="CircleGeometry";this.parameters={radius:a,segments:b,thetaStart:c,thetaLength:d};this.fromBufferGeometry(new THREE.CircleBufferGeometry(a,b,c,d))};
THREE.CircleGeometry.prototype=Object.create(THREE.Geometry.prototype);THREE.CircleGeometry.prototype.constructor=THREE.CircleGeometry;THREE.CircleGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.CircleGeometry(a.radius,a.segments,a.thetaStart,a.thetaLength)};
THREE.CircleBufferGeometry=function(a,b,c,d){THREE.BufferGeometry.call(this);this.type="CircleBufferGeometry";this.parameters={radius:a,segments:b,thetaStart:c,thetaLength:d};a=a||50;b=void 0!==b?Math.max(3,b):8;c=void 0!==c?c:0;d=void 0!==d?d:2*Math.PI;var e=b+2,g=new Float32Array(3*e),f=new Float32Array(3*e),e=new Float32Array(2*e);f[2]=1;e[0]=.5;e[1]=.5;for(var h=0,l=3,k=2;h<=b;h++,l+=3,k+=2){var m=c+h/b*d;g[l]=a*Math.cos(m);g[l+1]=a*Math.sin(m);f[l+2]=1;e[k]=(g[l]/a+1)/2;e[k+1]=(g[l+1]/a+1)/2}c=
[];for(l=1;l<=b;l++)c.push(l,l+1,0);this.setIndex(new THREE.BufferAttribute(new Uint16Array(c),1));this.addAttribute("position",new THREE.BufferAttribute(g,3));this.addAttribute("normal",new THREE.BufferAttribute(f,3));this.addAttribute("uv",new THREE.BufferAttribute(e,2));this.boundingSphere=new THREE.Sphere(new THREE.Vector3,a)};THREE.CircleBufferGeometry.prototype=Object.create(THREE.BufferGeometry.prototype);THREE.CircleBufferGeometry.prototype.constructor=THREE.CircleBufferGeometry;
THREE.CircleBufferGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.CircleBufferGeometry(a.radius,a.segments,a.thetaStart,a.thetaLength)};
THREE.CylinderGeometry=function(a,b,c,d,e,g,f,h){THREE.Geometry.call(this);this.type="CylinderGeometry";this.parameters={radiusTop:a,radiusBottom:b,height:c,radialSegments:d,heightSegments:e,openEnded:g,thetaStart:f,thetaLength:h};a=void 0!==a?a:20;b=void 0!==b?b:20;c=void 0!==c?c:100;d=d||8;e=e||1;g=void 0!==g?g:!1;f=void 0!==f?f:0;h=void 0!==h?h:2*Math.PI;var l=c/2,k,m,p=[],n=[];for(m=0;m<=e;m++){var q=[],s=[],t=m/e,v=t*(b-a)+a;for(k=0;k<=d;k++){var u=k/d,w=new THREE.Vector3;w.x=v*Math.sin(u*h+
f);w.y=-t*c+l;w.z=v*Math.cos(u*h+f);this.vertices.push(w);q.push(this.vertices.length-1);s.push(new THREE.Vector2(u,1-t))}p.push(q);n.push(s)}c=(b-a)/c;for(k=0;k<d;k++)for(0!==a?(f=this.vertices[p[0][k]].clone(),h=this.vertices[p[0][k+1]].clone()):(f=this.vertices[p[1][k]].clone(),h=this.vertices[p[1][k+1]].clone()),f.setY(Math.sqrt(f.x*f.x+f.z*f.z)*c).normalize(),h.setY(Math.sqrt(h.x*h.x+h.z*h.z)*c).normalize(),m=0;m<e;m++){var q=p[m][k],s=p[m+1][k],t=p[m+1][k+1],v=p[m][k+1],u=f.clone(),w=f.clone(),
D=h.clone(),x=h.clone(),B=n[m][k].clone(),y=n[m+1][k].clone(),z=n[m+1][k+1].clone(),A=n[m][k+1].clone();this.faces.push(new THREE.Face3(q,s,v,[u,w,x]));this.faceVertexUvs[0].push([B,y,A]);this.faces.push(new THREE.Face3(s,t,v,[w.clone(),D,x.clone()]));this.faceVertexUvs[0].push([y.clone(),z,A.clone()])}if(!1===g&&0<a)for(this.vertices.push(new THREE.Vector3(0,l,0)),k=0;k<d;k++)q=p[0][k],s=p[0][k+1],t=this.vertices.length-1,u=new THREE.Vector3(0,1,0),w=new THREE.Vector3(0,1,0),D=new THREE.Vector3(0,
1,0),B=n[0][k].clone(),y=n[0][k+1].clone(),z=new THREE.Vector2(y.x,0),this.faces.push(new THREE.Face3(q,s,t,[u,w,D],void 0,1)),this.faceVertexUvs[0].push([B,y,z]);if(!1===g&&0<b)for(this.vertices.push(new THREE.Vector3(0,-l,0)),k=0;k<d;k++)q=p[e][k+1],s=p[e][k],t=this.vertices.length-1,u=new THREE.Vector3(0,-1,0),w=new THREE.Vector3(0,-1,0),D=new THREE.Vector3(0,-1,0),B=n[e][k+1].clone(),y=n[e][k].clone(),z=new THREE.Vector2(y.x,1),this.faces.push(new THREE.Face3(q,s,t,[u,w,D],void 0,2)),this.faceVertexUvs[0].push([B,
y,z]);this.computeFaceNormals()};THREE.CylinderGeometry.prototype=Object.create(THREE.Geometry.prototype);THREE.CylinderGeometry.prototype.constructor=THREE.CylinderGeometry;THREE.CylinderGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.CylinderGeometry(a.radiusTop,a.radiusBottom,a.height,a.radialSegments,a.heightSegments,a.openEnded,a.thetaStart,a.thetaLength)};
THREE.EdgesGeometry=function(a,b){function c(a,b){return a-b}THREE.BufferGeometry.call(this);var d=Math.cos(THREE.Math.degToRad(void 0!==b?b:1)),e=[0,0],g={},f=["a","b","c"],h;a instanceof THREE.BufferGeometry?(h=new THREE.Geometry,h.fromBufferGeometry(a)):h=a.clone();h.mergeVertices();h.computeFaceNormals();var l=h.vertices;h=h.faces;for(var k=0,m=h.length;k<m;k++)for(var p=h[k],n=0;3>n;n++){e[0]=p[f[n]];e[1]=p[f[(n+1)%3]];e.sort(c);var q=e.toString();void 0===g[q]?g[q]={vert1:e[0],vert2:e[1],face1:k,
face2:void 0}:g[q].face2=k}e=[];for(q in g)if(f=g[q],void 0===f.face2||h[f.face1].normal.dot(h[f.face2].normal)<=d)k=l[f.vert1],e.push(k.x),e.push(k.y),e.push(k.z),k=l[f.vert2],e.push(k.x),e.push(k.y),e.push(k.z);this.addAttribute("position",new THREE.BufferAttribute(new Float32Array(e),3))};THREE.EdgesGeometry.prototype=Object.create(THREE.BufferGeometry.prototype);THREE.EdgesGeometry.prototype.constructor=THREE.EdgesGeometry;
THREE.ExtrudeGeometry=function(a,b){"undefined"!==typeof a&&(THREE.Geometry.call(this),this.type="ExtrudeGeometry",a=Array.isArray(a)?a:[a],this.addShapeList(a,b),this.computeFaceNormals())};THREE.ExtrudeGeometry.prototype=Object.create(THREE.Geometry.prototype);THREE.ExtrudeGeometry.prototype.constructor=THREE.ExtrudeGeometry;THREE.ExtrudeGeometry.prototype.addShapeList=function(a,b){for(var c=a.length,d=0;d<c;d++)this.addShape(a[d],b)};
THREE.ExtrudeGeometry.prototype.addShape=function(a,b){function c(a,b,c){b||console.error("THREE.ExtrudeGeometry: vec does not exist");return b.clone().multiplyScalar(c).add(a)}function d(a,b,c){var d=1,d=a.x-b.x,e=a.y-b.y,f=c.x-a.x,g=c.y-a.y,h=d*d+e*e;if(Math.abs(d*g-e*f)>Number.EPSILON){var k=Math.sqrt(h),l=Math.sqrt(f*f+g*g),h=b.x-e/k;b=b.y+d/k;f=((c.x-g/l-h)*g-(c.y+f/l-b)*f)/(d*g-e*f);c=h+d*f-a.x;a=b+e*f-a.y;d=c*c+a*a;if(2>=d)return new THREE.Vector2(c,a);d=Math.sqrt(d/2)}else a=!1,d>Number.EPSILON?
f>Number.EPSILON&&(a=!0):d<-Number.EPSILON?f<-Number.EPSILON&&(a=!0):Math.sign(e)===Math.sign(g)&&(a=!0),a?(c=-e,a=d,d=Math.sqrt(h)):(c=d,a=e,d=Math.sqrt(h/2));return new THREE.Vector2(c/d,a/d)}function e(a,b){var c,d;for(G=a.length;0<=--G;){c=G;d=G-1;0>d&&(d=a.length-1);for(var e=0,f=q+2*m,e=0;e<f;e++){var g=T*e,h=T*(e+1),k=b+c+g,g=b+d+g,l=b+d+h,h=b+c+h,k=k+F,g=g+F,l=l+F,h=h+F;J.faces.push(new THREE.Face3(k,g,h,null,null,1));J.faces.push(new THREE.Face3(g,l,h,null,null,1));k=u.generateSideWallUV(J,
k,g,l,h);J.faceVertexUvs[0].push([k[0],k[1],k[3]]);J.faceVertexUvs[0].push([k[1],k[2],k[3]])}}}function g(a,b,c){J.vertices.push(new THREE.Vector3(a,b,c))}function f(a,b,c){a+=F;b+=F;c+=F;J.faces.push(new THREE.Face3(a,b,c,null,null,0));a=u.generateTopUV(J,a,b,c);J.faceVertexUvs[0].push(a)}var h=void 0!==b.amount?b.amount:100,l=void 0!==b.bevelThickness?b.bevelThickness:6,k=void 0!==b.bevelSize?b.bevelSize:l-2,m=void 0!==b.bevelSegments?b.bevelSegments:3,p=void 0!==b.bevelEnabled?b.bevelEnabled:!0,
n=void 0!==b.curveSegments?b.curveSegments:12,q=void 0!==b.steps?b.steps:1,s=b.extrudePath,t,v=!1,u=void 0!==b.UVGenerator?b.UVGenerator:THREE.ExtrudeGeometry.WorldUVGenerator,w,D,x,B;s&&(t=s.getSpacedPoints(q),v=!0,p=!1,w=void 0!==b.frames?b.frames:new THREE.TubeGeometry.FrenetFrames(s,q,!1),D=new THREE.Vector3,x=new THREE.Vector3,B=new THREE.Vector3);p||(k=l=m=0);var y,z,A,J=this,F=this.vertices.length,s=a.extractPoints(n),n=s.shape,C=s.holes;if(s=!THREE.ShapeUtils.isClockWise(n)){n=n.reverse();
z=0;for(A=C.length;z<A;z++)y=C[z],THREE.ShapeUtils.isClockWise(y)&&(C[z]=y.reverse());s=!1}var N=THREE.ShapeUtils.triangulateShape(n,C),L=n;z=0;for(A=C.length;z<A;z++)y=C[z],n=n.concat(y);var Q,M,K,E,O,T=n.length,H,R=N.length,s=[],G=0;K=L.length;Q=K-1;for(M=G+1;G<K;G++,Q++,M++)Q===K&&(Q=0),M===K&&(M=0),s[G]=d(L[G],L[Q],L[M]);var ia=[],U,X=s.concat();z=0;for(A=C.length;z<A;z++){y=C[z];U=[];G=0;K=y.length;Q=K-1;for(M=G+1;G<K;G++,Q++,M++)Q===K&&(Q=0),M===K&&(M=0),U[G]=d(y[G],y[Q],y[M]);ia.push(U);X=
X.concat(U)}for(Q=0;Q<m;Q++){K=Q/m;E=l*(1-K);M=k*Math.sin(K*Math.PI/2);G=0;for(K=L.length;G<K;G++)O=c(L[G],s[G],M),g(O.x,O.y,-E);z=0;for(A=C.length;z<A;z++)for(y=C[z],U=ia[z],G=0,K=y.length;G<K;G++)O=c(y[G],U[G],M),g(O.x,O.y,-E)}M=k;for(G=0;G<T;G++)O=p?c(n[G],X[G],M):n[G],v?(x.copy(w.normals[0]).multiplyScalar(O.x),D.copy(w.binormals[0]).multiplyScalar(O.y),B.copy(t[0]).add(x).add(D),g(B.x,B.y,B.z)):g(O.x,O.y,0);for(K=1;K<=q;K++)for(G=0;G<T;G++)O=p?c(n[G],X[G],M):n[G],v?(x.copy(w.normals[K]).multiplyScalar(O.x),
D.copy(w.binormals[K]).multiplyScalar(O.y),B.copy(t[K]).add(x).add(D),g(B.x,B.y,B.z)):g(O.x,O.y,h/q*K);for(Q=m-1;0<=Q;Q--){K=Q/m;E=l*(1-K);M=k*Math.sin(K*Math.PI/2);G=0;for(K=L.length;G<K;G++)O=c(L[G],s[G],M),g(O.x,O.y,h+E);z=0;for(A=C.length;z<A;z++)for(y=C[z],U=ia[z],G=0,K=y.length;G<K;G++)O=c(y[G],U[G],M),v?g(O.x,O.y+t[q-1].y,t[q-1].x+E):g(O.x,O.y,h+E)}(function(){if(p){var a;a=0*T;for(G=0;G<R;G++)H=N[G],f(H[2]+a,H[1]+a,H[0]+a);a=q+2*m;a*=T;for(G=0;G<R;G++)H=N[G],f(H[0]+a,H[1]+a,H[2]+a)}else{for(G=
0;G<R;G++)H=N[G],f(H[2],H[1],H[0]);for(G=0;G<R;G++)H=N[G],f(H[0]+T*q,H[1]+T*q,H[2]+T*q)}})();(function(){var a=0;e(L,a);a+=L.length;z=0;for(A=C.length;z<A;z++)y=C[z],e(y,a),a+=y.length})()};
THREE.ExtrudeGeometry.WorldUVGenerator={generateTopUV:function(a,b,c,d){a=a.vertices;b=a[b];c=a[c];d=a[d];return[new THREE.Vector2(b.x,b.y),new THREE.Vector2(c.x,c.y),new THREE.Vector2(d.x,d.y)]},generateSideWallUV:function(a,b,c,d,e){a=a.vertices;b=a[b];c=a[c];d=a[d];e=a[e];return.01>Math.abs(b.y-c.y)?[new THREE.Vector2(b.x,1-b.z),new THREE.Vector2(c.x,1-c.z),new THREE.Vector2(d.x,1-d.z),new THREE.Vector2(e.x,1-e.z)]:[new THREE.Vector2(b.y,1-b.z),new THREE.Vector2(c.y,1-c.z),new THREE.Vector2(d.y,
1-d.z),new THREE.Vector2(e.y,1-e.z)]}};THREE.ShapeGeometry=function(a,b){THREE.Geometry.call(this);this.type="ShapeGeometry";!1===Array.isArray(a)&&(a=[a]);this.addShapeList(a,b);this.computeFaceNormals()};THREE.ShapeGeometry.prototype=Object.create(THREE.Geometry.prototype);THREE.ShapeGeometry.prototype.constructor=THREE.ShapeGeometry;THREE.ShapeGeometry.prototype.addShapeList=function(a,b){for(var c=0,d=a.length;c<d;c++)this.addShape(a[c],b);return this};
THREE.ShapeGeometry.prototype.addShape=function(a,b){void 0===b&&(b={});var c=b.material,d=void 0===b.UVGenerator?THREE.ExtrudeGeometry.WorldUVGenerator:b.UVGenerator,e,g,f,h=this.vertices.length;e=a.extractPoints(void 0!==b.curveSegments?b.curveSegments:12);var l=e.shape,k=e.holes;if(!THREE.ShapeUtils.isClockWise(l))for(l=l.reverse(),e=0,g=k.length;e<g;e++)f=k[e],THREE.ShapeUtils.isClockWise(f)&&(k[e]=f.reverse());var m=THREE.ShapeUtils.triangulateShape(l,k);e=0;for(g=k.length;e<g;e++)f=k[e],l=l.concat(f);
k=l.length;g=m.length;for(e=0;e<k;e++)f=l[e],this.vertices.push(new THREE.Vector3(f.x,f.y,0));for(e=0;e<g;e++)k=m[e],l=k[0]+h,f=k[1]+h,k=k[2]+h,this.faces.push(new THREE.Face3(l,f,k,null,null,c)),this.faceVertexUvs[0].push(d.generateTopUV(this,l,f,k))};
THREE.LatheGeometry=function(a,b,c,d){THREE.Geometry.call(this);this.type="LatheGeometry";this.parameters={points:a,segments:b,phiStart:c,phiLength:d};b=b||12;c=c||0;d=d||2*Math.PI;for(var e=1/(a.length-1),g=1/b,f=0,h=b;f<=h;f++)for(var l=c+f*g*d,k=Math.cos(l),m=Math.sin(l),l=0,p=a.length;l<p;l++){var n=a[l],q=new THREE.Vector3;q.x=k*n.x-m*n.y;q.y=m*n.x+k*n.y;q.z=n.z;this.vertices.push(q)}c=a.length;f=0;for(h=b;f<h;f++)for(l=0,p=a.length-1;l<p;l++){b=m=l+c*f;d=m+c;var k=m+1+c,m=m+1,n=f*g,q=l*e,s=
n+g,t=q+e;this.faces.push(new THREE.Face3(b,d,m));this.faceVertexUvs[0].push([new THREE.Vector2(n,q),new THREE.Vector2(s,q),new THREE.Vector2(n,t)]);this.faces.push(new THREE.Face3(d,k,m));this.faceVertexUvs[0].push([new THREE.Vector2(s,q),new THREE.Vector2(s,t),new THREE.Vector2(n,t)])}this.mergeVertices();this.computeFaceNormals();this.computeVertexNormals()};THREE.LatheGeometry.prototype=Object.create(THREE.Geometry.prototype);THREE.LatheGeometry.prototype.constructor=THREE.LatheGeometry;
THREE.PlaneGeometry=function(a,b,c,d){THREE.Geometry.call(this);this.type="PlaneGeometry";this.parameters={width:a,height:b,widthSegments:c,heightSegments:d};this.fromBufferGeometry(new THREE.PlaneBufferGeometry(a,b,c,d))};THREE.PlaneGeometry.prototype=Object.create(THREE.Geometry.prototype);THREE.PlaneGeometry.prototype.constructor=THREE.PlaneGeometry;THREE.PlaneGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.PlaneGeometry(a.width,a.height,a.widthSegments,a.heightSegments)};
THREE.PlaneBufferGeometry=function(a,b,c,d){THREE.BufferGeometry.call(this);this.type="PlaneBufferGeometry";this.parameters={width:a,height:b,widthSegments:c,heightSegments:d};var e=a/2,g=b/2;c=Math.floor(c)||1;d=Math.floor(d)||1;var f=c+1,h=d+1,l=a/c,k=b/d;b=new Float32Array(f*h*3);a=new Float32Array(f*h*3);for(var m=new Float32Array(f*h*2),p=0,n=0,q=0;q<h;q++)for(var s=q*k-g,t=0;t<f;t++)b[p]=t*l-e,b[p+1]=-s,a[p+2]=1,m[n]=t/c,m[n+1]=1-q/d,p+=3,n+=2;p=0;e=new (65535<b.length/3?Uint32Array:Uint16Array)(c*
d*6);for(q=0;q<d;q++)for(t=0;t<c;t++)g=t+f*(q+1),h=t+1+f*(q+1),l=t+1+f*q,e[p]=t+f*q,e[p+1]=g,e[p+2]=l,e[p+3]=g,e[p+4]=h,e[p+5]=l,p+=6;this.setIndex(new THREE.BufferAttribute(e,1));this.addAttribute("position",new THREE.BufferAttribute(b,3));this.addAttribute("normal",new THREE.BufferAttribute(a,3));this.addAttribute("uv",new THREE.BufferAttribute(m,2))};THREE.PlaneBufferGeometry.prototype=Object.create(THREE.BufferGeometry.prototype);THREE.PlaneBufferGeometry.prototype.constructor=THREE.PlaneBufferGeometry;
THREE.PlaneBufferGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.PlaneBufferGeometry(a.width,a.height,a.widthSegments,a.heightSegments)};
THREE.RingGeometry=function(a,b,c,d,e,g){THREE.Geometry.call(this);this.type="RingGeometry";this.parameters={innerRadius:a,outerRadius:b,thetaSegments:c,phiSegments:d,thetaStart:e,thetaLength:g};a=a||0;b=b||50;e=void 0!==e?e:0;g=void 0!==g?g:2*Math.PI;c=void 0!==c?Math.max(3,c):8;d=void 0!==d?Math.max(1,d):8;var f,h=[],l=a,k=(b-a)/d;for(a=0;a<d+1;a++){for(f=0;f<c+1;f++){var m=new THREE.Vector3,p=e+f/c*g;m.x=l*Math.cos(p);m.y=l*Math.sin(p);this.vertices.push(m);h.push(new THREE.Vector2((m.x/b+1)/2,
(m.y/b+1)/2))}l+=k}b=new THREE.Vector3(0,0,1);for(a=0;a<d;a++)for(e=a*(c+1),f=0;f<c;f++)g=p=f+e,k=p+c+1,m=p+c+2,this.faces.push(new THREE.Face3(g,k,m,[b.clone(),b.clone(),b.clone()])),this.faceVertexUvs[0].push([h[g].clone(),h[k].clone(),h[m].clone()]),g=p,k=p+c+2,m=p+1,this.faces.push(new THREE.Face3(g,k,m,[b.clone(),b.clone(),b.clone()])),this.faceVertexUvs[0].push([h[g].clone(),h[k].clone(),h[m].clone()]);this.computeFaceNormals();this.boundingSphere=new THREE.Sphere(new THREE.Vector3,l)};
THREE.RingGeometry.prototype=Object.create(THREE.Geometry.prototype);THREE.RingGeometry.prototype.constructor=THREE.RingGeometry;THREE.RingGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.RingGeometry(a.innerRadius,a.outerRadius,a.thetaSegments,a.phiSegments,a.thetaStart,a.thetaLength)};
THREE.SphereGeometry=function(a,b,c,d,e,g,f){THREE.Geometry.call(this);this.type="SphereGeometry";this.parameters={radius:a,widthSegments:b,heightSegments:c,phiStart:d,phiLength:e,thetaStart:g,thetaLength:f};this.fromBufferGeometry(new THREE.SphereBufferGeometry(a,b,c,d,e,g,f))};THREE.SphereGeometry.prototype=Object.create(THREE.Geometry.prototype);THREE.SphereGeometry.prototype.constructor=THREE.SphereGeometry;
THREE.SphereGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.SphereGeometry(a.radius,a.widthSegments,a.heightSegments,a.phiStart,a.phiLength,a.thetaStart,a.thetaLength)};
THREE.SphereBufferGeometry=function(a,b,c,d,e,g,f){THREE.BufferGeometry.call(this);this.type="SphereBufferGeometry";this.parameters={radius:a,widthSegments:b,heightSegments:c,phiStart:d,phiLength:e,thetaStart:g,thetaLength:f};a=a||50;b=Math.max(3,Math.floor(b)||8);c=Math.max(2,Math.floor(c)||6);d=void 0!==d?d:0;e=void 0!==e?e:2*Math.PI;g=void 0!==g?g:0;f=void 0!==f?f:Math.PI;for(var h=g+f,l=(b+1)*(c+1),k=new THREE.BufferAttribute(new Float32Array(3*l),3),m=new THREE.BufferAttribute(new Float32Array(3*
l),3),l=new THREE.BufferAttribute(new Float32Array(2*l),2),p=0,n=[],q=new THREE.Vector3,s=0;s<=c;s++){for(var t=[],v=s/c,u=0;u<=b;u++){var w=u/b,D=-a*Math.cos(d+w*e)*Math.sin(g+v*f),x=a*Math.cos(g+v*f),B=a*Math.sin(d+w*e)*Math.sin(g+v*f);q.set(D,x,B).normalize();k.setXYZ(p,D,x,B);m.setXYZ(p,q.x,q.y,q.z);l.setXY(p,w,1-v);t.push(p);p++}n.push(t)}d=[];for(s=0;s<c;s++)for(u=0;u<b;u++)e=n[s][u+1],f=n[s][u],p=n[s+1][u],q=n[s+1][u+1],(0!==s||0<g)&&d.push(e,f,q),(s!==c-1||h<Math.PI)&&d.push(f,p,q);this.setIndex(new (65535<
k.count?THREE.Uint32Attribute:THREE.Uint16Attribute)(d,1));this.addAttribute("position",k);this.addAttribute("normal",m);this.addAttribute("uv",l);this.boundingSphere=new THREE.Sphere(new THREE.Vector3,a)};THREE.SphereBufferGeometry.prototype=Object.create(THREE.BufferGeometry.prototype);THREE.SphereBufferGeometry.prototype.constructor=THREE.SphereBufferGeometry;
THREE.SphereBufferGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.SphereBufferGeometry(a.radius,a.widthSegments,a.heightSegments,a.phiStart,a.phiLength,a.thetaStart,a.thetaLength)};
THREE.TorusGeometry=function(a,b,c,d,e){THREE.Geometry.call(this);this.type="TorusGeometry";this.parameters={radius:a,tube:b,radialSegments:c,tubularSegments:d,arc:e};a=a||100;b=b||40;c=c||8;d=d||6;e=e||2*Math.PI;for(var g=new THREE.Vector3,f=[],h=[],l=0;l<=c;l++)for(var k=0;k<=d;k++){var m=k/d*e,p=l/c*Math.PI*2;g.x=a*Math.cos(m);g.y=a*Math.sin(m);var n=new THREE.Vector3;n.x=(a+b*Math.cos(p))*Math.cos(m);n.y=(a+b*Math.cos(p))*Math.sin(m);n.z=b*Math.sin(p);this.vertices.push(n);f.push(new THREE.Vector2(k/
d,l/c));h.push(n.clone().sub(g).normalize())}for(l=1;l<=c;l++)for(k=1;k<=d;k++)a=(d+1)*l+k-1,b=(d+1)*(l-1)+k-1,e=(d+1)*(l-1)+k,g=(d+1)*l+k,m=new THREE.Face3(a,b,g,[h[a].clone(),h[b].clone(),h[g].clone()]),this.faces.push(m),this.faceVertexUvs[0].push([f[a].clone(),f[b].clone(),f[g].clone()]),m=new THREE.Face3(b,e,g,[h[b].clone(),h[e].clone(),h[g].clone()]),this.faces.push(m),this.faceVertexUvs[0].push([f[b].clone(),f[e].clone(),f[g].clone()]);this.computeFaceNormals()};
THREE.TorusGeometry.prototype=Object.create(THREE.Geometry.prototype);THREE.TorusGeometry.prototype.constructor=THREE.TorusGeometry;THREE.TorusGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.TorusGeometry(a.radius,a.tube,a.radialSegments,a.tubularSegments,a.arc)};
THREE.TorusKnotGeometry=function(a,b,c,d,e,g,f){function h(a,b,c,d,e){var f=Math.cos(a),g=Math.sin(a);a*=b/c;b=Math.cos(a);f*=d*(2+b)*.5;g=d*(2+b)*g*.5;d=e*d*Math.sin(a)*.5;return new THREE.Vector3(f,g,d)}THREE.Geometry.call(this);this.type="TorusKnotGeometry";this.parameters={radius:a,tube:b,radialSegments:c,tubularSegments:d,p:e,q:g,heightScale:f};a=a||100;b=b||40;c=c||64;d=d||8;e=e||2;g=g||3;f=f||1;for(var l=Array(c),k=new THREE.Vector3,m=new THREE.Vector3,p=new THREE.Vector3,n=0;n<c;++n){l[n]=
Array(d);var q=n/c*2*e*Math.PI,s=h(q,g,e,a,f),q=h(q+.01,g,e,a,f);k.subVectors(q,s);m.addVectors(q,s);p.crossVectors(k,m);m.crossVectors(p,k);p.normalize();m.normalize();for(q=0;q<d;++q){var t=q/d*2*Math.PI,v=-b*Math.cos(t),t=b*Math.sin(t),u=new THREE.Vector3;u.x=s.x+v*m.x+t*p.x;u.y=s.y+v*m.y+t*p.y;u.z=s.z+v*m.z+t*p.z;l[n][q]=this.vertices.push(u)-1}}for(n=0;n<c;++n)for(q=0;q<d;++q)e=(n+1)%c,g=(q+1)%d,a=l[n][q],b=l[e][q],e=l[e][g],g=l[n][g],f=new THREE.Vector2(n/c,q/d),k=new THREE.Vector2((n+1)/c,
q/d),m=new THREE.Vector2((n+1)/c,(q+1)/d),p=new THREE.Vector2(n/c,(q+1)/d),this.faces.push(new THREE.Face3(a,b,g)),this.faceVertexUvs[0].push([f,k,p]),this.faces.push(new THREE.Face3(b,e,g)),this.faceVertexUvs[0].push([k.clone(),m,p.clone()]);this.computeFaceNormals();this.computeVertexNormals()};THREE.TorusKnotGeometry.prototype=Object.create(THREE.Geometry.prototype);THREE.TorusKnotGeometry.prototype.constructor=THREE.TorusKnotGeometry;
THREE.TorusKnotGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.TorusKnotGeometry(a.radius,a.tube,a.radialSegments,a.tubularSegments,a.p,a.q,a.heightScale)};
THREE.TubeGeometry=function(a,b,c,d,e,g){THREE.Geometry.call(this);this.type="TubeGeometry";this.parameters={path:a,segments:b,radius:c,radialSegments:d,closed:e,taper:g};b=b||64;c=c||1;d=d||8;e=e||!1;g=g||THREE.TubeGeometry.NoTaper;var f=[],h,l,k=b+1,m,p,n,q,s,t=new THREE.Vector3,v,u,w;v=new THREE.TubeGeometry.FrenetFrames(a,b,e);u=v.normals;w=v.binormals;this.tangents=v.tangents;this.normals=u;this.binormals=w;for(v=0;v<k;v++)for(f[v]=[],m=v/(k-1),s=a.getPointAt(m),h=u[v],l=w[v],n=c*g(m),m=0;m<
d;m++)p=m/d*2*Math.PI,q=-n*Math.cos(p),p=n*Math.sin(p),t.copy(s),t.x+=q*h.x+p*l.x,t.y+=q*h.y+p*l.y,t.z+=q*h.z+p*l.z,f[v][m]=this.vertices.push(new THREE.Vector3(t.x,t.y,t.z))-1;for(v=0;v<b;v++)for(m=0;m<d;m++)g=e?(v+1)%b:v+1,k=(m+1)%d,a=f[v][m],c=f[g][m],g=f[g][k],k=f[v][k],t=new THREE.Vector2(v/b,m/d),u=new THREE.Vector2((v+1)/b,m/d),w=new THREE.Vector2((v+1)/b,(m+1)/d),h=new THREE.Vector2(v/b,(m+1)/d),this.faces.push(new THREE.Face3(a,c,k)),this.faceVertexUvs[0].push([t,u,h]),this.faces.push(new THREE.Face3(c,
g,k)),this.faceVertexUvs[0].push([u.clone(),w,h.clone()]);this.computeFaceNormals();this.computeVertexNormals()};THREE.TubeGeometry.prototype=Object.create(THREE.Geometry.prototype);THREE.TubeGeometry.prototype.constructor=THREE.TubeGeometry;THREE.TubeGeometry.prototype.clone=function(){return new this.constructor(this.parameters.path,this.parameters.segments,this.parameters.radius,this.parameters.radialSegments,this.parameters.closed,this.parameters.taper)};THREE.TubeGeometry.NoTaper=function(a){return 1};
THREE.TubeGeometry.SinusoidalTaper=function(a){return Math.sin(Math.PI*a)};
THREE.TubeGeometry.FrenetFrames=function(a,b,c){var d=new THREE.Vector3,e=[],g=[],f=[],h=new THREE.Vector3,l=new THREE.Matrix4;b+=1;var k,m,p;this.tangents=e;this.normals=g;this.binormals=f;for(k=0;k<b;k++)m=k/(b-1),e[k]=a.getTangentAt(m),e[k].normalize();g[0]=new THREE.Vector3;f[0]=new THREE.Vector3;a=Number.MAX_VALUE;k=Math.abs(e[0].x);m=Math.abs(e[0].y);p=Math.abs(e[0].z);k<=a&&(a=k,d.set(1,0,0));m<=a&&(a=m,d.set(0,1,0));p<=a&&d.set(0,0,1);h.crossVectors(e[0],d).normalize();g[0].crossVectors(e[0],
h);f[0].crossVectors(e[0],g[0]);for(k=1;k<b;k++)g[k]=g[k-1].clone(),f[k]=f[k-1].clone(),h.crossVectors(e[k-1],e[k]),h.length()>Number.EPSILON&&(h.normalize(),d=Math.acos(THREE.Math.clamp(e[k-1].dot(e[k]),-1,1)),g[k].applyMatrix4(l.makeRotationAxis(h,d))),f[k].crossVectors(e[k],g[k]);if(c)for(d=Math.acos(THREE.Math.clamp(g[0].dot(g[b-1]),-1,1)),d/=b-1,0<e[0].dot(h.crossVectors(g[0],g[b-1]))&&(d=-d),k=1;k<b;k++)g[k].applyMatrix4(l.makeRotationAxis(e[k],d*k)),f[k].crossVectors(e[k],g[k])};
THREE.PolyhedronGeometry=function(a,b,c,d){function e(a){var b=a.normalize().clone();b.index=l.vertices.push(b)-1;var c=Math.atan2(a.z,-a.x)/2/Math.PI+.5;a=Math.atan2(-a.y,Math.sqrt(a.x*a.x+a.z*a.z))/Math.PI+.5;b.uv=new THREE.Vector2(c,1-a);return b}function g(a,b,c,d){d=new THREE.Face3(a.index,b.index,c.index,[a.clone(),b.clone(),c.clone()],void 0,d);l.faces.push(d);v.copy(a).add(b).add(c).divideScalar(3);d=Math.atan2(v.z,-v.x);l.faceVertexUvs[0].push([h(a.uv,a,d),h(b.uv,b,d),h(c.uv,c,d)])}function f(a,
b){for(var c=Math.pow(2,b),d=e(l.vertices[a.a]),f=e(l.vertices[a.b]),h=e(l.vertices[a.c]),k=[],n=a.materialIndex,m=0;m<=c;m++){k[m]=[];for(var p=e(d.clone().lerp(h,m/c)),q=e(f.clone().lerp(h,m/c)),s=c-m,t=0;t<=s;t++)k[m][t]=0===t&&m===c?p:e(p.clone().lerp(q,t/s))}for(m=0;m<c;m++)for(t=0;t<2*(c-m)-1;t++)d=Math.floor(t/2),0===t%2?g(k[m][d+1],k[m+1][d],k[m][d],n):g(k[m][d+1],k[m+1][d+1],k[m+1][d],n)}function h(a,b,c){0>c&&1===a.x&&(a=new THREE.Vector2(a.x-1,a.y));0===b.x&&0===b.z&&(a=new THREE.Vector2(c/
2/Math.PI+.5,a.y));return a.clone()}THREE.Geometry.call(this);this.type="PolyhedronGeometry";this.parameters={vertices:a,indices:b,radius:c,detail:d};c=c||1;d=d||0;for(var l=this,k=0,m=a.length;k<m;k+=3)e(new THREE.Vector3(a[k],a[k+1],a[k+2]));a=this.vertices;for(var p=[],n=k=0,m=b.length;k<m;k+=3,n++){var q=a[b[k]],s=a[b[k+1]],t=a[b[k+2]];p[n]=new THREE.Face3(q.index,s.index,t.index,[q.clone(),s.clone(),t.clone()],void 0,n)}for(var v=new THREE.Vector3,k=0,m=p.length;k<m;k++)f(p[k],d);k=0;for(m=this.faceVertexUvs[0].length;k<
m;k++)b=this.faceVertexUvs[0][k],d=b[0].x,a=b[1].x,p=b[2].x,n=Math.max(d,a,p),q=Math.min(d,a,p),.9<n&&.1>q&&(.2>d&&(b[0].x+=1),.2>a&&(b[1].x+=1),.2>p&&(b[2].x+=1));k=0;for(m=this.vertices.length;k<m;k++)this.vertices[k].multiplyScalar(c);this.mergeVertices();this.computeFaceNormals();this.boundingSphere=new THREE.Sphere(new THREE.Vector3,c)};THREE.PolyhedronGeometry.prototype=Object.create(THREE.Geometry.prototype);THREE.PolyhedronGeometry.prototype.constructor=THREE.PolyhedronGeometry;
THREE.PolyhedronGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.PolyhedronGeometry(a.vertices,a.indices,a.radius,a.detail)};
THREE.DodecahedronGeometry=function(a,b){var c=(1+Math.sqrt(5))/2,d=1/c;THREE.PolyhedronGeometry.call(this,[-1,-1,-1,-1,-1,1,-1,1,-1,-1,1,1,1,-1,-1,1,-1,1,1,1,-1,1,1,1,0,-d,-c,0,-d,c,0,d,-c,0,d,c,-d,-c,0,-d,c,0,d,-c,0,d,c,0,-c,0,-d,c,0,-d,-c,0,d,c,0,d],[3,11,7,3,7,15,3,15,13,7,19,17,7,17,6,7,6,15,17,4,8,17,8,10,17,10,6,8,0,16,8,16,2,8,2,10,0,12,1,0,1,18,0,18,16,6,10,2,6,2,13,6,13,15,2,16,18,2,18,3,2,3,13,18,1,9,18,9,11,18,11,3,4,14,12,4,12,0,4,0,8,11,9,5,11,5,19,11,19,7,19,5,14,19,14,4,19,4,17,1,
12,14,1,14,5,1,5,9],a,b);this.type="DodecahedronGeometry";this.parameters={radius:a,detail:b}};THREE.DodecahedronGeometry.prototype=Object.create(THREE.PolyhedronGeometry.prototype);THREE.DodecahedronGeometry.prototype.constructor=THREE.DodecahedronGeometry;THREE.DodecahedronGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.DodecahedronGeometry(a.radius,a.detail)};
THREE.IcosahedronGeometry=function(a,b){var c=(1+Math.sqrt(5))/2;THREE.PolyhedronGeometry.call(this,[-1,c,0,1,c,0,-1,-c,0,1,-c,0,0,-1,c,0,1,c,0,-1,-c,0,1,-c,c,0,-1,c,0,1,-c,0,-1,-c,0,1],[0,11,5,0,5,1,0,1,7,0,7,10,0,10,11,1,5,9,5,11,4,11,10,2,10,7,6,7,1,8,3,9,4,3,4,2,3,2,6,3,6,8,3,8,9,4,9,5,2,4,11,6,2,10,8,6,7,9,8,1],a,b);this.type="IcosahedronGeometry";this.parameters={radius:a,detail:b}};THREE.IcosahedronGeometry.prototype=Object.create(THREE.PolyhedronGeometry.prototype);
THREE.IcosahedronGeometry.prototype.constructor=THREE.IcosahedronGeometry;THREE.IcosahedronGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.IcosahedronGeometry(a.radius,a.detail)};THREE.OctahedronGeometry=function(a,b){THREE.PolyhedronGeometry.call(this,[1,0,0,-1,0,0,0,1,0,0,-1,0,0,0,1,0,0,-1],[0,2,4,0,4,3,0,3,5,0,5,2,1,2,5,1,5,3,1,3,4,1,4,2],a,b);this.type="OctahedronGeometry";this.parameters={radius:a,detail:b}};THREE.OctahedronGeometry.prototype=Object.create(THREE.PolyhedronGeometry.prototype);
THREE.OctahedronGeometry.prototype.constructor=THREE.OctahedronGeometry;THREE.OctahedronGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.OctahedronGeometry(a.radius,a.detail)};THREE.TetrahedronGeometry=function(a,b){THREE.PolyhedronGeometry.call(this,[1,1,1,-1,-1,1,-1,1,-1,1,-1,-1],[2,1,0,0,3,2,1,3,0,2,3,1],a,b);this.type="TetrahedronGeometry";this.parameters={radius:a,detail:b}};THREE.TetrahedronGeometry.prototype=Object.create(THREE.PolyhedronGeometry.prototype);
THREE.TetrahedronGeometry.prototype.constructor=THREE.TetrahedronGeometry;THREE.TetrahedronGeometry.prototype.clone=function(){var a=this.parameters;return new THREE.TetrahedronGeometry(a.radius,a.detail)};
THREE.ParametricGeometry=function(a,b,c){THREE.Geometry.call(this);this.type="ParametricGeometry";this.parameters={func:a,slices:b,stacks:c};var d=this.vertices,e=this.faces,g=this.faceVertexUvs[0],f,h,l,k,m=b+1;for(f=0;f<=c;f++)for(k=f/c,h=0;h<=b;h++)l=h/b,l=a(l,k),d.push(l);var p,n,q,s;for(f=0;f<c;f++)for(h=0;h<b;h++)a=f*m+h,d=f*m+h+1,k=(f+1)*m+h+1,l=(f+1)*m+h,p=new THREE.Vector2(h/b,f/c),n=new THREE.Vector2((h+1)/b,f/c),q=new THREE.Vector2((h+1)/b,(f+1)/c),s=new THREE.Vector2(h/b,(f+1)/c),e.push(new THREE.Face3(a,
d,l)),g.push([p,n,s]),e.push(new THREE.Face3(d,k,l)),g.push([n.clone(),q,s.clone()]);this.computeFaceNormals();this.computeVertexNormals()};THREE.ParametricGeometry.prototype=Object.create(THREE.Geometry.prototype);THREE.ParametricGeometry.prototype.constructor=THREE.ParametricGeometry;
THREE.WireframeGeometry=function(a){function b(a,b){return a-b}THREE.BufferGeometry.call(this);var c=[0,0],d={},e=["a","b","c"];if(a instanceof THREE.Geometry){var g=a.vertices,f=a.faces,h=0,l=new Uint32Array(6*f.length);a=0;for(var k=f.length;a<k;a++)for(var m=f[a],p=0;3>p;p++){c[0]=m[e[p]];c[1]=m[e[(p+1)%3]];c.sort(b);var n=c.toString();void 0===d[n]&&(l[2*h]=c[0],l[2*h+1]=c[1],d[n]=!0,h++)}c=new Float32Array(6*h);a=0;for(k=h;a<k;a++)for(p=0;2>p;p++)d=g[l[2*a+p]],h=6*a+3*p,c[h+0]=d.x,c[h+1]=d.y,
c[h+2]=d.z;this.addAttribute("position",new THREE.BufferAttribute(c,3))}else if(a instanceof THREE.BufferGeometry){if(null!==a.index){k=a.index.array;g=a.attributes.position;e=a.drawcalls;h=0;0===e.length&&a.addGroup(0,k.length);l=new Uint32Array(2*k.length);f=0;for(m=e.length;f<m;++f){a=e[f];p=a.start;n=a.count;a=p;for(var q=p+n;a<q;a+=3)for(p=0;3>p;p++)c[0]=k[a+p],c[1]=k[a+(p+1)%3],c.sort(b),n=c.toString(),void 0===d[n]&&(l[2*h]=c[0],l[2*h+1]=c[1],d[n]=!0,h++)}c=new Float32Array(6*h);a=0;for(k=
h;a<k;a++)for(p=0;2>p;p++)h=6*a+3*p,d=l[2*a+p],c[h+0]=g.getX(d),c[h+1]=g.getY(d),c[h+2]=g.getZ(d)}else for(g=a.attributes.position.array,h=g.length/3,l=h/3,c=new Float32Array(6*h),a=0,k=l;a<k;a++)for(p=0;3>p;p++)h=18*a+6*p,l=9*a+3*p,c[h+0]=g[l],c[h+1]=g[l+1],c[h+2]=g[l+2],d=9*a+(p+1)%3*3,c[h+3]=g[d],c[h+4]=g[d+1],c[h+5]=g[d+2];this.addAttribute("position",new THREE.BufferAttribute(c,3))}};THREE.WireframeGeometry.prototype=Object.create(THREE.BufferGeometry.prototype);
THREE.WireframeGeometry.prototype.constructor=THREE.WireframeGeometry;THREE.AxisHelper=function(a){a=a||1;var b=new Float32Array([0,0,0,a,0,0,0,0,0,0,a,0,0,0,0,0,0,a]),c=new Float32Array([1,0,0,1,.6,0,0,1,0,.6,1,0,0,0,1,0,.6,1]);a=new THREE.BufferGeometry;a.addAttribute("position",new THREE.BufferAttribute(b,3));a.addAttribute("color",new THREE.BufferAttribute(c,3));b=new THREE.LineBasicMaterial({vertexColors:THREE.VertexColors});THREE.LineSegments.call(this,a,b)};THREE.AxisHelper.prototype=Object.create(THREE.LineSegments.prototype);
THREE.AxisHelper.prototype.constructor=THREE.AxisHelper;
THREE.ArrowHelper=function(){var a=new THREE.Geometry;a.vertices.push(new THREE.Vector3(0,0,0),new THREE.Vector3(0,1,0));var b=new THREE.CylinderGeometry(0,.5,1,5,1);b.translate(0,-.5,0);return function(c,d,e,g,f,h){THREE.Object3D.call(this);void 0===g&&(g=16776960);void 0===e&&(e=1);void 0===f&&(f=.2*e);void 0===h&&(h=.2*f);this.position.copy(d);f<e&&(this.line=new THREE.Line(a,new THREE.LineBasicMaterial({color:g})),this.line.matrixAutoUpdate=!1,this.add(this.line));this.cone=new THREE.Mesh(b,new THREE.MeshBasicMaterial({color:g}));
this.cone.matrixAutoUpdate=!1;this.add(this.cone);this.setDirection(c);this.setLength(e,f,h)}}();THREE.ArrowHelper.prototype=Object.create(THREE.Object3D.prototype);THREE.ArrowHelper.prototype.constructor=THREE.ArrowHelper;THREE.ArrowHelper.prototype.setDirection=function(){var a=new THREE.Vector3,b;return function(c){.99999<c.y?this.quaternion.set(0,0,0,1):-.99999>c.y?this.quaternion.set(1,0,0,0):(a.set(c.z,0,-c.x).normalize(),b=Math.acos(c.y),this.quaternion.setFromAxisAngle(a,b))}}();
THREE.ArrowHelper.prototype.setLength=function(a,b,c){void 0===b&&(b=.2*a);void 0===c&&(c=.2*b);b<a&&(this.line.scale.set(1,a-b,1),this.line.updateMatrix());this.cone.scale.set(c,b,c);this.cone.position.y=a;this.cone.updateMatrix()};THREE.ArrowHelper.prototype.setColor=function(a){void 0!==this.line&&this.line.material.color.set(a);this.cone.material.color.set(a)};
THREE.BoxHelper=function(a){var b=new Uint16Array([0,1,1,2,2,3,3,0,4,5,5,6,6,7,7,4,0,4,1,5,2,6,3,7]),c=new Float32Array(24),d=new THREE.BufferGeometry;d.setIndex(new THREE.BufferAttribute(b,1));d.addAttribute("position",new THREE.BufferAttribute(c,3));THREE.LineSegments.call(this,d,new THREE.LineBasicMaterial({color:16776960}));void 0!==a&&this.update(a)};THREE.BoxHelper.prototype=Object.create(THREE.LineSegments.prototype);THREE.BoxHelper.prototype.constructor=THREE.BoxHelper;
THREE.BoxHelper.prototype.update=function(){var a=new THREE.Box3;return function(b){a.setFromObject(b);if(!a.empty()){b=a.min;var c=a.max,d=this.geometry.attributes.position,e=d.array;e[0]=c.x;e[1]=c.y;e[2]=c.z;e[3]=b.x;e[4]=c.y;e[5]=c.z;e[6]=b.x;e[7]=b.y;e[8]=c.z;e[9]=c.x;e[10]=b.y;e[11]=c.z;e[12]=c.x;e[13]=c.y;e[14]=b.z;e[15]=b.x;e[16]=c.y;e[17]=b.z;e[18]=b.x;e[19]=b.y;e[20]=b.z;e[21]=c.x;e[22]=b.y;e[23]=b.z;d.needsUpdate=!0;this.geometry.computeBoundingSphere()}}}();
THREE.BoundingBoxHelper=function(a,b){var c=void 0!==b?b:8947848;this.object=a;this.box=new THREE.Box3;THREE.Mesh.call(this,new THREE.BoxGeometry(1,1,1),new THREE.MeshBasicMaterial({color:c,wireframe:!0}))};THREE.BoundingBoxHelper.prototype=Object.create(THREE.Mesh.prototype);THREE.BoundingBoxHelper.prototype.constructor=THREE.BoundingBoxHelper;THREE.BoundingBoxHelper.prototype.update=function(){this.box.setFromObject(this.object);this.box.size(this.scale);this.box.center(this.position)};
THREE.CameraHelper=function(a){function b(a,b,d){c(a,d);c(b,d)}function c(a,b){d.vertices.push(new THREE.Vector3);d.colors.push(new THREE.Color(b));void 0===g[a]&&(g[a]=[]);g[a].push(d.vertices.length-1)}var d=new THREE.Geometry,e=new THREE.LineBasicMaterial({color:16777215,vertexColors:THREE.FaceColors}),g={};b("n1","n2",16755200);b("n2","n4",16755200);b("n4","n3",16755200);b("n3","n1",16755200);b("f1","f2",16755200);b("f2","f4",16755200);b("f4","f3",16755200);b("f3","f1",16755200);b("n1","f1",16755200);
b("n2","f2",16755200);b("n3","f3",16755200);b("n4","f4",16755200);b("p","n1",16711680);b("p","n2",16711680);b("p","n3",16711680);b("p","n4",16711680);b("u1","u2",43775);b("u2","u3",43775);b("u3","u1",43775);b("c","t",16777215);b("p","c",3355443);b("cn1","cn2",3355443);b("cn3","cn4",3355443);b("cf1","cf2",3355443);b("cf3","cf4",3355443);THREE.LineSegments.call(this,d,e);this.camera=a;this.camera.updateProjectionMatrix();this.matrix=a.matrixWorld;this.matrixAutoUpdate=!1;this.pointMap=g;this.update()};
THREE.CameraHelper.prototype=Object.create(THREE.LineSegments.prototype);THREE.CameraHelper.prototype.constructor=THREE.CameraHelper;
THREE.CameraHelper.prototype.update=function(){function a(a,f,h,l){d.set(f,h,l).unproject(e);a=c[a];if(void 0!==a)for(f=0,h=a.length;f<h;f++)b.vertices[a[f]].copy(d)}var b,c,d=new THREE.Vector3,e=new THREE.Camera;return function(){b=this.geometry;c=this.pointMap;e.projectionMatrix.copy(this.camera.projectionMatrix);a("c",0,0,-1);a("t",0,0,1);a("n1",-1,-1,-1);a("n2",1,-1,-1);a("n3",-1,1,-1);a("n4",1,1,-1);a("f1",-1,-1,1);a("f2",1,-1,1);a("f3",-1,1,1);a("f4",1,1,1);a("u1",.7,1.1,-1);a("u2",-.7,1.1,
-1);a("u3",0,2,-1);a("cf1",-1,0,1);a("cf2",1,0,1);a("cf3",0,-1,1);a("cf4",0,1,1);a("cn1",-1,0,-1);a("cn2",1,0,-1);a("cn3",0,-1,-1);a("cn4",0,1,-1);b.verticesNeedUpdate=!0}}();
THREE.DirectionalLightHelper=function(a,b){THREE.Object3D.call(this);this.light=a;this.light.updateMatrixWorld();this.matrix=a.matrixWorld;this.matrixAutoUpdate=!1;b=b||1;var c=new THREE.Geometry;c.vertices.push(new THREE.Vector3(-b,b,0),new THREE.Vector3(b,b,0),new THREE.Vector3(b,-b,0),new THREE.Vector3(-b,-b,0),new THREE.Vector3(-b,b,0));var d=new THREE.LineBasicMaterial({fog:!1});d.color.copy(this.light.color).multiplyScalar(this.light.intensity);this.lightPlane=new THREE.Line(c,d);this.add(this.lightPlane);
c=new THREE.Geometry;c.vertices.push(new THREE.Vector3,new THREE.Vector3);d=new THREE.LineBasicMaterial({fog:!1});d.color.copy(this.light.color).multiplyScalar(this.light.intensity);this.targetLine=new THREE.Line(c,d);this.add(this.targetLine);this.update()};THREE.DirectionalLightHelper.prototype=Object.create(THREE.Object3D.prototype);THREE.DirectionalLightHelper.prototype.constructor=THREE.DirectionalLightHelper;
THREE.DirectionalLightHelper.prototype.dispose=function(){this.lightPlane.geometry.dispose();this.lightPlane.material.dispose();this.targetLine.geometry.dispose();this.targetLine.material.dispose()};
THREE.DirectionalLightHelper.prototype.update=function(){var a=new THREE.Vector3,b=new THREE.Vector3,c=new THREE.Vector3;return function(){a.setFromMatrixPosition(this.light.matrixWorld);b.setFromMatrixPosition(this.light.target.matrixWorld);c.subVectors(b,a);this.lightPlane.lookAt(c);this.lightPlane.material.color.copy(this.light.color).multiplyScalar(this.light.intensity);this.targetLine.geometry.vertices[1].copy(c);this.targetLine.geometry.verticesNeedUpdate=!0;this.targetLine.material.color.copy(this.lightPlane.material.color)}}();
THREE.EdgesHelper=function(a,b,c){b=void 0!==b?b:16777215;THREE.LineSegments.call(this,new THREE.EdgesGeometry(a.geometry,c),new THREE.LineBasicMaterial({color:b}));this.matrix=a.matrixWorld;this.matrixAutoUpdate=!1};THREE.EdgesHelper.prototype=Object.create(THREE.LineSegments.prototype);THREE.EdgesHelper.prototype.constructor=THREE.EdgesHelper;
THREE.FaceNormalsHelper=function(a,b,c,d){this.object=a;this.size=void 0!==b?b:1;a=void 0!==c?c:16776960;d=void 0!==d?d:1;b=0;c=this.object.geometry;c instanceof THREE.Geometry?b=c.faces.length:console.warn("THREE.FaceNormalsHelper: only THREE.Geometry is supported. Use THREE.VertexNormalsHelper, instead.");c=new THREE.BufferGeometry;b=new THREE.Float32Attribute(6*b,3);c.addAttribute("position",b);THREE.LineSegments.call(this,c,new THREE.LineBasicMaterial({color:a,linewidth:d}));this.matrixAutoUpdate=
!1;this.update()};THREE.FaceNormalsHelper.prototype=Object.create(THREE.LineSegments.prototype);THREE.FaceNormalsHelper.prototype.constructor=THREE.FaceNormalsHelper;
THREE.FaceNormalsHelper.prototype.update=function(){var a=new THREE.Vector3,b=new THREE.Vector3,c=new THREE.Matrix3;return function(){this.object.updateMatrixWorld(!0);c.getNormalMatrix(this.object.matrixWorld);for(var d=this.object.matrixWorld,e=this.geometry.attributes.position,g=this.object.geometry,f=g.vertices,g=g.faces,h=0,l=0,k=g.length;l<k;l++){var m=g[l],p=m.normal;a.copy(f[m.a]).add(f[m.b]).add(f[m.c]).divideScalar(3).applyMatrix4(d);b.copy(p).applyMatrix3(c).normalize().multiplyScalar(this.size).add(a);
e.setXYZ(h,a.x,a.y,a.z);h+=1;e.setXYZ(h,b.x,b.y,b.z);h+=1}e.needsUpdate=!0;return this}}();
THREE.GridHelper=function(a,b){var c=new THREE.Geometry,d=new THREE.LineBasicMaterial({vertexColors:THREE.VertexColors});this.color1=new THREE.Color(4473924);this.color2=new THREE.Color(8947848);for(var e=-a;e<=a;e+=b){c.vertices.push(new THREE.Vector3(-a,0,e),new THREE.Vector3(a,0,e),new THREE.Vector3(e,0,-a),new THREE.Vector3(e,0,a));var g=0===e?this.color1:this.color2;c.colors.push(g,g,g,g)}THREE.LineSegments.call(this,c,d)};THREE.GridHelper.prototype=Object.create(THREE.LineSegments.prototype);
THREE.GridHelper.prototype.constructor=THREE.GridHelper;THREE.GridHelper.prototype.setColors=function(a,b){this.color1.set(a);this.color2.set(b);this.geometry.colorsNeedUpdate=!0};
THREE.HemisphereLightHelper=function(a,b){THREE.Object3D.call(this);this.light=a;this.light.updateMatrixWorld();this.matrix=a.matrixWorld;this.matrixAutoUpdate=!1;this.colors=[new THREE.Color,new THREE.Color];var c=new THREE.SphereGeometry(b,4,2);c.rotateX(-Math.PI/2);for(var d=0;8>d;d++)c.faces[d].color=this.colors[4>d?0:1];d=new THREE.MeshBasicMaterial({vertexColors:THREE.FaceColors,wireframe:!0});this.lightSphere=new THREE.Mesh(c,d);this.add(this.lightSphere);this.update()};
THREE.HemisphereLightHelper.prototype=Object.create(THREE.Object3D.prototype);THREE.HemisphereLightHelper.prototype.constructor=THREE.HemisphereLightHelper;THREE.HemisphereLightHelper.prototype.dispose=function(){this.lightSphere.geometry.dispose();this.lightSphere.material.dispose()};
THREE.HemisphereLightHelper.prototype.update=function(){var a=new THREE.Vector3;return function(){this.colors[0].copy(this.light.color).multiplyScalar(this.light.intensity);this.colors[1].copy(this.light.groundColor).multiplyScalar(this.light.intensity);this.lightSphere.lookAt(a.setFromMatrixPosition(this.light.matrixWorld).negate());this.lightSphere.geometry.colorsNeedUpdate=!0}}();
THREE.PointLightHelper=function(a,b){this.light=a;this.light.updateMatrixWorld();var c=new THREE.SphereGeometry(b,4,2),d=new THREE.MeshBasicMaterial({wireframe:!0,fog:!1});d.color.copy(this.light.color).multiplyScalar(this.light.intensity);THREE.Mesh.call(this,c,d);this.matrix=this.light.matrixWorld;this.matrixAutoUpdate=!1};THREE.PointLightHelper.prototype=Object.create(THREE.Mesh.prototype);THREE.PointLightHelper.prototype.constructor=THREE.PointLightHelper;
THREE.PointLightHelper.prototype.dispose=function(){this.geometry.dispose();this.material.dispose()};THREE.PointLightHelper.prototype.update=function(){this.material.color.copy(this.light.color).multiplyScalar(this.light.intensity)};
THREE.SkeletonHelper=function(a){this.bones=this.getBoneList(a);for(var b=new THREE.Geometry,c=0;c<this.bones.length;c++)this.bones[c].parent instanceof THREE.Bone&&(b.vertices.push(new THREE.Vector3),b.vertices.push(new THREE.Vector3),b.colors.push(new THREE.Color(0,0,1)),b.colors.push(new THREE.Color(0,1,0)));b.dynamic=!0;c=new THREE.LineBasicMaterial({vertexColors:THREE.VertexColors,depthTest:!1,depthWrite:!1,transparent:!0});THREE.LineSegments.call(this,b,c);this.root=a;this.matrix=a.matrixWorld;
this.matrixAutoUpdate=!1;this.update()};THREE.SkeletonHelper.prototype=Object.create(THREE.LineSegments.prototype);THREE.SkeletonHelper.prototype.constructor=THREE.SkeletonHelper;THREE.SkeletonHelper.prototype.getBoneList=function(a){var b=[];a instanceof THREE.Bone&&b.push(a);for(var c=0;c<a.children.length;c++)b.push.apply(b,this.getBoneList(a.children[c]));return b};
THREE.SkeletonHelper.prototype.update=function(){for(var a=this.geometry,b=(new THREE.Matrix4).getInverse(this.root.matrixWorld),c=new THREE.Matrix4,d=0,e=0;e<this.bones.length;e++){var g=this.bones[e];g.parent instanceof THREE.Bone&&(c.multiplyMatrices(b,g.matrixWorld),a.vertices[d].setFromMatrixPosition(c),c.multiplyMatrices(b,g.parent.matrixWorld),a.vertices[d+1].setFromMatrixPosition(c),d+=2)}a.verticesNeedUpdate=!0;a.computeBoundingSphere()};
THREE.SpotLightHelper=function(a){THREE.Object3D.call(this);this.light=a;this.light.updateMatrixWorld();this.matrix=a.matrixWorld;this.matrixAutoUpdate=!1;a=new THREE.CylinderGeometry(0,1,1,8,1,!0);a.translate(0,-.5,0);a.rotateX(-Math.PI/2);var b=new THREE.MeshBasicMaterial({wireframe:!0,fog:!1});this.cone=new THREE.Mesh(a,b);this.add(this.cone);this.update()};THREE.SpotLightHelper.prototype=Object.create(THREE.Object3D.prototype);THREE.SpotLightHelper.prototype.constructor=THREE.SpotLightHelper;
THREE.SpotLightHelper.prototype.dispose=function(){this.cone.geometry.dispose();this.cone.material.dispose()};THREE.SpotLightHelper.prototype.update=function(){var a=new THREE.Vector3,b=new THREE.Vector3;return function(){var c=this.light.distance?this.light.distance:1E4,d=c*Math.tan(this.light.angle);this.cone.scale.set(d,d,c);a.setFromMatrixPosition(this.light.matrixWorld);b.setFromMatrixPosition(this.light.target.matrixWorld);this.cone.lookAt(b.sub(a));this.cone.material.color.copy(this.light.color).multiplyScalar(this.light.intensity)}}();
THREE.VertexNormalsHelper=function(a,b,c,d){this.object=a;this.size=void 0!==b?b:1;a=void 0!==c?c:16711680;d=void 0!==d?d:1;b=0;c=this.object.geometry;c instanceof THREE.Geometry?b=3*c.faces.length:c instanceof THREE.BufferGeometry&&(b=c.attributes.normal.count);c=new THREE.BufferGeometry;b=new THREE.Float32Attribute(6*b,3);c.addAttribute("position",b);THREE.LineSegments.call(this,c,new THREE.LineBasicMaterial({color:a,linewidth:d}));this.matrixAutoUpdate=!1;this.update()};
THREE.VertexNormalsHelper.prototype=Object.create(THREE.LineSegments.prototype);THREE.VertexNormalsHelper.prototype.constructor=THREE.VertexNormalsHelper;
THREE.VertexNormalsHelper.prototype.update=function(){var a=new THREE.Vector3,b=new THREE.Vector3,c=new THREE.Matrix3;return function(){var d=["a","b","c"];this.object.updateMatrixWorld(!0);c.getNormalMatrix(this.object.matrixWorld);var e=this.object.matrixWorld,g=this.geometry.attributes.position,f=this.object.geometry;if(f instanceof THREE.Geometry)for(var h=f.vertices,l=f.faces,k=f=0,m=l.length;k<m;k++)for(var p=l[k],n=0,q=p.vertexNormals.length;n<q;n++){var s=p.vertexNormals[n];a.copy(h[p[d[n]]]).applyMatrix4(e);
b.copy(s).applyMatrix3(c).normalize().multiplyScalar(this.size).add(a);g.setXYZ(f,a.x,a.y,a.z);f+=1;g.setXYZ(f,b.x,b.y,b.z);f+=1}else if(f instanceof THREE.BufferGeometry)for(d=f.attributes.position,h=f.attributes.normal,n=f=0,q=d.count;n<q;n++)a.set(d.getX(n),d.getY(n),d.getZ(n)).applyMatrix4(e),b.set(h.getX(n),h.getY(n),h.getZ(n)),b.applyMatrix3(c).normalize().multiplyScalar(this.size).add(a),g.setXYZ(f,a.x,a.y,a.z),f+=1,g.setXYZ(f,b.x,b.y,b.z),f+=1;g.needsUpdate=!0;return this}}();
THREE.WireframeHelper=function(a,b){var c=void 0!==b?b:16777215;THREE.LineSegments.call(this,new THREE.WireframeGeometry(a.geometry),new THREE.LineBasicMaterial({color:c}));this.matrix=a.matrixWorld;this.matrixAutoUpdate=!1};THREE.WireframeHelper.prototype=Object.create(THREE.LineSegments.prototype);THREE.WireframeHelper.prototype.constructor=THREE.WireframeHelper;THREE.ImmediateRenderObject=function(a){THREE.Object3D.call(this);this.material=a;this.render=function(a){}};
THREE.ImmediateRenderObject.prototype=Object.create(THREE.Object3D.prototype);THREE.ImmediateRenderObject.prototype.constructor=THREE.ImmediateRenderObject;THREE.MorphBlendMesh=function(a,b){THREE.Mesh.call(this,a,b);this.animationsMap={};this.animationsList=[];var c=this.geometry.morphTargets.length;this.createAnimation("__default",0,c-1,c/1);this.setAnimationWeight("__default",1)};THREE.MorphBlendMesh.prototype=Object.create(THREE.Mesh.prototype);THREE.MorphBlendMesh.prototype.constructor=THREE.MorphBlendMesh;
THREE.MorphBlendMesh.prototype.createAnimation=function(a,b,c,d){b={start:b,end:c,length:c-b+1,fps:d,duration:(c-b)/d,lastFrame:0,currentFrame:0,active:!1,time:0,direction:1,weight:1,directionBackwards:!1,mirroredLoop:!1};this.animationsMap[a]=b;this.animationsList.push(b)};
THREE.MorphBlendMesh.prototype.autoCreateAnimations=function(a){for(var b=/([a-z]+)_?(\d+)/,c,d={},e=this.geometry,g=0,f=e.morphTargets.length;g<f;g++){var h=e.morphTargets[g].name.match(b);if(h&&1<h.length){var l=h[1];d[l]||(d[l]={start:Infinity,end:-Infinity});h=d[l];g<h.start&&(h.start=g);g>h.end&&(h.end=g);c||(c=l)}}for(l in d)h=d[l],this.createAnimation(l,h.start,h.end,a);this.firstAnimation=c};
THREE.MorphBlendMesh.prototype.setAnimationDirectionForward=function(a){if(a=this.animationsMap[a])a.direction=1,a.directionBackwards=!1};THREE.MorphBlendMesh.prototype.setAnimationDirectionBackward=function(a){if(a=this.animationsMap[a])a.direction=-1,a.directionBackwards=!0};THREE.MorphBlendMesh.prototype.setAnimationFPS=function(a,b){var c=this.animationsMap[a];c&&(c.fps=b,c.duration=(c.end-c.start)/c.fps)};
THREE.MorphBlendMesh.prototype.setAnimationDuration=function(a,b){var c=this.animationsMap[a];c&&(c.duration=b,c.fps=(c.end-c.start)/c.duration)};THREE.MorphBlendMesh.prototype.setAnimationWeight=function(a,b){var c=this.animationsMap[a];c&&(c.weight=b)};THREE.MorphBlendMesh.prototype.setAnimationTime=function(a,b){var c=this.animationsMap[a];c&&(c.time=b)};THREE.MorphBlendMesh.prototype.getAnimationTime=function(a){var b=0;if(a=this.animationsMap[a])b=a.time;return b};
THREE.MorphBlendMesh.prototype.getAnimationDuration=function(a){var b=-1;if(a=this.animationsMap[a])b=a.duration;return b};THREE.MorphBlendMesh.prototype.playAnimation=function(a){var b=this.animationsMap[a];b?(b.time=0,b.active=!0):console.warn("THREE.MorphBlendMesh: animation["+a+"] undefined in .playAnimation()")};THREE.MorphBlendMesh.prototype.stopAnimation=function(a){if(a=this.animationsMap[a])a.active=!1};
THREE.MorphBlendMesh.prototype.update=function(a){for(var b=0,c=this.animationsList.length;b<c;b++){var d=this.animationsList[b];if(d.active){var e=d.duration/d.length;d.time+=d.direction*a;if(d.mirroredLoop){if(d.time>d.duration||0>d.time)d.direction*=-1,d.time>d.duration&&(d.time=d.duration,d.directionBackwards=!0),0>d.time&&(d.time=0,d.directionBackwards=!1)}else d.time%=d.duration,0>d.time&&(d.time+=d.duration);var g=d.start+THREE.Math.clamp(Math.floor(d.time/e),0,d.length-1),f=d.weight;g!==d.currentFrame&&
(this.morphTargetInfluences[d.lastFrame]=0,this.morphTargetInfluences[d.currentFrame]=1*f,this.morphTargetInfluences[g]=0,d.lastFrame=d.currentFrame,d.currentFrame=g);e=d.time%e/e;d.directionBackwards&&(e=1-e);d.currentFrame!==d.lastFrame?(this.morphTargetInfluences[d.currentFrame]=e*f,this.morphTargetInfluences[d.lastFrame]=(1-e)*f):this.morphTargetInfluences[d.currentFrame]=f}}};
'use strict';

if (typeof module !== 'undefined') module.exports = simpleheat;

function simpleheat(canvas) {
    if (!(this instanceof simpleheat)) return new simpleheat(canvas);

    this._canvas = canvas = typeof canvas === 'string' ? document.getElementById(canvas) : canvas;

    this._ctx = canvas.getContext('2d');
    this._width = canvas.width;
    this._height = canvas.height;

    this._max = 1;
    this._data = [];
}

simpleheat.prototype = {

    defaultRadius: 25,

    defaultGradient: {
        0.4: 'blue',
        0.6: 'cyan',
        0.7: 'lime',
        0.8: 'yellow',
        1.0: 'red'
    },

    data: function (data) {
        this._data = data;
        return this;
    },

    max: function (max) {
        this._max = max;
        return this;
    },

    add: function (point) {
        this._data.push(point);
        return this;
    },

    clear: function () {
        this._data = [];
        return this;
    },

    radius: function (r, blur) {
        blur = blur === undefined ? 15 : blur;

        // create a grayscale blurred circle image that we'll use for drawing points
        var circle = this._circle = this._createCanvas(),
            ctx = circle.getContext('2d'),
            r2 = this._r = r + blur;

        circle.width = circle.height = r2 * 2;

        ctx.shadowOffsetX = ctx.shadowOffsetY = r2 * 2;
        ctx.shadowBlur = blur;
        ctx.shadowColor = 'black';

        ctx.beginPath();
        ctx.arc(-r2, -r2, r, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();

        return this;
    },

    resize: function () {
        this._width = this._canvas.width;
        this._height = this._canvas.height;
    },

    gradient: function (grad) {
        // create a 256x1 gradient that we'll use to turn a grayscale heatmap into a colored one
        var canvas = this._createCanvas(),
            ctx = canvas.getContext('2d'),
            gradient = ctx.createLinearGradient(0, 0, 0, 256);

        canvas.width = 1;
        canvas.height = 256;

        for (var i in grad) {
            gradient.addColorStop(+i, grad[i]);
        }

        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 1, 256);

        this._grad = ctx.getImageData(0, 0, 1, 256).data;

        return this;
    },

    draw: function (minOpacity) {
        if (!this._circle) this.radius(this.defaultRadius);
        if (!this._grad) this.gradient(this.defaultGradient);

        var ctx = this._ctx;

        ctx.clearRect(0, 0, this._width, this._height);

        // draw a grayscale heatmap by putting a blurred circle at each data point
        for (var i = 0, len = this._data.length, p; i < len; i++) {
            p = this._data[i];
            ctx.globalAlpha = Math.min(Math.max(p[2] / this._max, minOpacity === undefined ? 0.05 : minOpacity), 1);
            ctx.drawImage(this._circle, p[0] - this._r, p[1] - this._r);
        }

        // colorize the heatmap, using opacity value of each pixel to get the right color from our gradient
        var colored = ctx.getImageData(0, 0, this._width, this._height);
        this._colorize(colored.data, this._grad);
        ctx.putImageData(colored, 0, 0);

        return this;
    },

    _colorize: function (pixels, gradient) {
        for (var i = 0, len = pixels.length, j; i < len; i += 4) {
            j = pixels[i + 3] * 4; // get gradient color from opacity value

            if (j) {
                pixels[i] = gradient[j];
                pixels[i + 1] = gradient[j + 1];
                pixels[i + 2] = gradient[j + 2];
            }
        }
    },

    _createCanvas: function () {
        if (typeof document !== 'undefined') {
            return document.createElement('canvas');
        } else {
            // create a new canvas instance in node.js
            // the canvas class needs to have a default constructor without any parameter
            return new this._canvas.constructor();
        }
    }
};

// pnltri.js / raw.github.com/jahting/pnltri.js/master/LICENSE
/**
 * @author jahting / http://www.ameco.tv/
 *
 *	(Simple) Polygon Near-Linear Triangulation
 *	  with fast ear-clipping for polygons without holes
 *
 */
 
var PNLTRI = { REVISION: '2.1.1' };

//	#####  Global Constants  #####


//	#####  Global Variables  #####


/**
 * @author jahting / http://www.ameco.tv/
 */

PNLTRI.Math = {

	random: Math.random,		// function to use for random number generation

	// generate random ordering in place:
	//	Fisher-Yates shuffle
	array_shuffle: function( inoutArray ) {
		for (var i = inoutArray.length - 1; i > 0; i-- ) {
			var j = Math.floor( PNLTRI.Math.random() * (i+1) );
			var tmp = inoutArray[i];
			inoutArray[i] = inoutArray[j];
			inoutArray[j] = tmp;
		}
		return	inoutArray;
	},


	//	like compare (<=>)
	//		yA > yB resp. xA > xB: 1, equal: 0, otherwise: -1
	compare_pts_yx: function ( inPtA, inPtB ) {
		var deltaY = inPtA.y - inPtB.y;
		if ( deltaY < PNLTRI.Math.EPSILON_N ) {
			return -1;
		} else if ( deltaY > PNLTRI.Math.EPSILON_P ) {
			return 1;
		} else {
			var deltaX = inPtA.x - inPtB.x;
			if ( deltaX < PNLTRI.Math.EPSILON_N ) {
				return -1;
			} else if ( deltaX > PNLTRI.Math.EPSILON_P ) {
				return  1;
			} else {
				return  0;
			}
		}
	},


	ptsCrossProd: function ( inPtVertex, inPtFrom, inPtTo ) {
		// two vectors: ( v0: inPtVertex -> inPtFrom ), ( v1: inPtVertex -> inPtTo )
		// CROSS_SINE: sin(theta) * len(v0) * len(v1)
		return	( inPtFrom.x - inPtVertex.x ) * ( inPtTo.y - inPtVertex.y ) -
				( inPtFrom.y - inPtVertex.y ) * ( inPtTo.x - inPtVertex.x );
		// <=> crossProd( inPtFrom-inPtVertex, inPtTo-inPtVertex )
		// == 0: colinear (angle == 0 or 180 deg == PI rad)
		// > 0:  v1 lies left of v0, CCW angle from v0 to v1 is convex ( < 180 deg )
		// < 0:  v1 lies right of v0, CW angle from v0 to v1 is convex ( < 180 deg )
	},

};

// precision of floating point arithmetic
//	PNLTRI.Math.EPSILON_P = Math.pow(2,-32);	// ~ 0.0000000001
	PNLTRI.Math.EPSILON_P = Math.pow(2,-43);	// ~ 0.0000000000001
	PNLTRI.Math.EPSILON_N = -PNLTRI.Math.EPSILON_P;

//	Problem with EPSILON-compares:
//	- especially when there is a x-coordinate ordering on equal y-coordinates
//		=> either NO EPSILON-compares on y-coordinates, since almost equal y
//			can have very different x - so they are not nearly close
//		or EPSILON must be bigger: Solution so far.
/**
 * @author jahting / http://www.ameco.tv/
 */

/** @constructor */
PNLTRI.PolygonData = function ( inPolygonChainList ) {

	// list of polygon vertices
	//	.x, .y: coordinates
	this.vertices = [];

	// list of polygon segments, original polygons ane holes
	//	and additional ones added during the subdivision into
	//	uni-y-monotone polygons (s. this.monoSubPolyChains)
	//	doubly linked by: snext, sprev
	this.segments = [];
	this.diagonals = [];

	// for the ORIGINAL polygon chains
	this.idNextPolyChain = 0;
	//	for each original chain: lies the polygon inside to the left?
	//	"true": winding order is CCW for a contour or CW for a hole
	//	"false": winding order is CW for a contour or CCW for a hole
	this.PolyLeftArr = [];

	// indices into this.segments: at least one for each monoton chain for the polygon
	//  these subdivide the polygon into uni-y-monotone polygons, that is
	//  polygons that have only one segment between ymax and ymin on one side
	//  and the other side has monotone increasing y from ymin to ymax
	// the monoSubPolyChains are doubly linked by: mnext, mprev
	this.monoSubPolyChains = [];

	// list of triangles: each 3 indices into this.vertices
	this.triangles = [];

	// initialize optional polygon chains
	if ( inPolygonChainList ) {
		for (var i=0, j=inPolygonChainList.length; i<j; i++) {
			this.addPolygonChain( inPolygonChainList[i] );
		}
	}

};


PNLTRI.PolygonData.prototype = {

	constructor: PNLTRI.PolygonData,


	/*	Accessors  */

	nbVertices: function () {
		return	this.vertices.length;
	},
	getSegments: function () {
		return	this.segments;
	},
	getFirstSegment: function () {
		return	this.segments[0];
	},
	getMonoSubPolys: function () {
		return	this.monoSubPolyChains;
	},
	getTriangles: function () {
		return	this.triangles.concat();
	},

	nbPolyChains: function () {
		return	this.idNextPolyChain;
	},

	// for the polygon data AFTER triangulation
	//	returns an Array of flags, one flag for each polygon chain:
	//		lies the inside of the polygon to the left?
	//		"true" implies CCW for contours and CW for holes
	get_PolyLeftArr: function () {
		return	this.PolyLeftArr.concat();
	},
	set_PolyLeft_wrong: function ( inChainId ) {
		this.PolyLeftArr[inChainId] = false;
	},


	/*	Helper  */

	// checks winding order by calculating the area of the polygon
	isClockWise: function ( inStartSeg ) {
		var cursor = inStartSeg, doubleArea = 0;
		do {
			doubleArea += ( cursor.vFrom.x - cursor.vTo.x ) * ( cursor.vFrom.y + cursor.vTo.y );
			cursor = cursor.snext;
		} while ( cursor != inStartSeg );
		return	( doubleArea < 0 );
	},


	/*	Operations  */

	appendVertexEntry: function ( inVertexX, inVertexY ) {			// private
		var vertex = {
				id: this.vertices.length,	// vertex id, representing input sequence
				x: inVertexX,				// coordinates
				y: inVertexY,
			};
		this.vertices.push( vertex );
		return	vertex;
	},


	createSegmentEntry: function ( inVertexFrom, inVertexTo ) {			// private
		return	{
			chainId: this.idNextPolyChain,
			// end points of segment
			vFrom: inVertexFrom,	// -> start point entry in vertices
			vTo: inVertexTo,		// -> end point entry in vertices
			// upward segment? (i.e. vTo > vFrom) !!! only valid for sprev,snext NOT for mprev,mnext !!!
			upward: ( PNLTRI.Math.compare_pts_yx(inVertexTo, inVertexFrom) == 1 ),
			// doubly linked list of original polygon chains (not the monoChains !)
			sprev: null,			// previous segment
			snext: null,			// next segment
			//
			//	for performance reasons:
			//	 initialization of all fields added later
			//
			// for trapezoids
			rootFrom: null,			// root of partial tree where vFrom is located
			rootTo: null,			// root of partial tree where vTo is located
			is_inserted: false,		// already inserted into QueryStructure ?
			// for assigning depth: trapezoids
			trLeft: null,			// one trapezoid bordering on the left of this segment
			trRight: null,			// one trapezoid bordering on the right of this segment
			// for monochains
			mprev: null,			// doubly linked list for monotone chains (sub-polygons)
			mnext: null,
			marked: false,			// already visited during unique monoChain identification ?
		};
	},

	appendSegmentEntry: function ( inSegment ) {				// private
		this.segments.push( inSegment );
		return	inSegment;
	},


	appendDiagonalsEntry: function ( inDiagonal ) {				// <<<<<	public
		this.diagonals.push( inDiagonal );
		return	inDiagonal;
	},


	addVertexChain: function ( inRawPointList ) {			// private

		function verts_equal( inVert1, inVert2 ) {
			return ( ( Math.abs(inVert1.x - inVert2.x) < PNLTRI.Math.EPSILON_P ) &&
					 ( Math.abs(inVert1.y - inVert2.y) < PNLTRI.Math.EPSILON_P ) );
		}

		function verts_colinear_chain( inVert1, inVert2, inVert3 ) {
			if ( Math.abs( PNLTRI.Math.ptsCrossProd( inVert2, inVert1, inVert3 ) ) > PNLTRI.Math.EPSILON_P )	return false;
			// only real sequences, not direction reversals
			var low, middle, high;
			if ( Math.abs( inVert1.y - inVert2.y ) < PNLTRI.Math.EPSILON_P ) {
				// horizontal line
				middle = inVert2.x;
				if ( inVert1.x < inVert3.x ) {
					low = inVert1.x;
					high = inVert3.x;
				} else {
					low = inVert3.x;
					high = inVert1.x;
				}
			} else {
				middle = inVert2.y;
				if ( inVert1.y < inVert3.y ) {
					low = inVert1.y;
					high = inVert3.y;
				} else {
					low = inVert3.y;
					high = inVert1.y;
				}
			}
			return	( ( ( low - middle ) < PNLTRI.Math.EPSILON_P ) && ( ( middle - high ) < PNLTRI.Math.EPSILON_P ) );
		}

		var newVertices = [];
		var newVertex, acceptVertex, lastIdx;
		for ( var i=0; i < inRawPointList.length; i++ ) {
			newVertex = this.appendVertexEntry( inRawPointList[i].x, inRawPointList[i].y );
			// suppresses zero-length segments
			acceptVertex = true;
			lastIdx = newVertices.length-1;
			if ( lastIdx >= 0 ) {
				if ( verts_equal( newVertex, newVertices[lastIdx] ) ) {
					acceptVertex = false;
				} else if ( lastIdx > 0 ) {
					if ( verts_colinear_chain( newVertices[lastIdx-1], newVertices[lastIdx], newVertex ) ) {
						newVertices.pop();
					}
				}
			}
			if ( acceptVertex )	newVertices.push( newVertex );
		}
		// compare last vertices to first: suppresses zero-length and co-linear segments
		lastIdx = newVertices.length - 1;
		if ( ( lastIdx > 0 ) &&
			 verts_equal( newVertices[lastIdx], newVertices[0] ) ) {
			newVertices.pop();
			lastIdx--;
		}
		if ( lastIdx > 1 ) {
			if ( verts_colinear_chain( newVertices[lastIdx-1], newVertices[lastIdx], newVertices[0] ) ) {
				newVertices.pop();
				lastIdx--;
			}
			if ( ( lastIdx > 1 ) &&
				 verts_colinear_chain( newVertices[lastIdx], newVertices[0], newVertices[1] ) ) {
				newVertices.shift();
			}
		}

		return	newVertices;
	},


	addPolygonChain: function ( inRawPointList ) {			// <<<<<< public

		// vertices
		var newVertices = this.addVertexChain( inRawPointList );
		if ( newVertices.length < 3 ) {
			console.log( "Polygon has < 3 vertices!", newVertices );
			return	0;
		}

		// segments
		var	saveSegListLength = this.segments.length;
		//
		var	segment, firstSeg, prevSeg;
		for ( var i=0; i < newVertices.length-1; i++ ) {
			segment = this.createSegmentEntry( newVertices[i], newVertices[i+1] );
			if (prevSeg) {
				segment.sprev = prevSeg;
				prevSeg.snext = segment;
			} else {
				firstSeg = segment;
			}
			prevSeg = segment;
			this.appendSegmentEntry( segment );
		}
		// close polygon
		segment = this.createSegmentEntry( newVertices[newVertices.length-1], newVertices[0] );
		segment.sprev = prevSeg;
		prevSeg.snext = segment;
		this.appendSegmentEntry( segment );
		firstSeg.sprev = segment;
		segment.snext = firstSeg;

		this.PolyLeftArr[this.idNextPolyChain++] = true;
		return	this.segments.length - saveSegListLength;
	},


	/* Monotone Polygon Chains */

	// Generate the uni-y-monotone sub-polygons from
	//	the trapezoidation of the polygon.

	create_mono_chains: function () {						// <<<<<< public
		var newMono, newMonoTo, toFirstOutSeg, fromRevSeg;
		for ( var i = 0, j = this.segments.length; i < j; i++) {
			newMono = this.segments[i];
			if ( this.PolyLeftArr[newMono.chainId] ) {
				// preserve winding order
				newMonoTo = newMono.vTo;			// target of segment
				newMono.mprev = newMono.sprev;		// doubly linked list for monotone chains (sub-polygons)
				newMono.mnext = newMono.snext;
			} else {
				// reverse winding order
				newMonoTo = newMono.vFrom;
				newMono = newMono.snext;
				newMono.mprev = newMono.snext;
				newMono.mnext = newMono.sprev;
			}
			if ( fromRevSeg = newMono.vFrom.lastInDiag ) {		// assignment !
				fromRevSeg.mnext = newMono;
				newMono.mprev = fromRevSeg;
				newMono.vFrom.lastInDiag = null;		// cleanup
			}
			if ( toFirstOutSeg = newMonoTo.firstOutDiag ) {		// assignment !
				toFirstOutSeg.mprev = newMono;
				newMono.mnext = toFirstOutSeg;
				newMonoTo.firstOutDiag = null;			// cleanup
			}
		}
	},

	// For each monotone polygon, find the ymax (to determine the two
	// y-monotone chains) and skip duplicate monotone polygons

	unique_monotone_chains_max: function () {			// <<<<<< public

		function find_monotone_chain_max( frontMono ) {
			var frontPt, firstPt, ymaxPt;

			var monoPosmax = frontMono;
			firstPt = ymaxPt = frontMono.vFrom;

			frontMono.marked = true;
			frontMono = frontMono.mnext;
			while ( frontPt = frontMono.vFrom ) {				// assignment !
				if (frontMono.marked) {
					if ( frontPt == firstPt )	break;	// mono chain completed
					console.log("ERR unique_monotone: segment in two chains", firstPt, frontMono );
					return	null;
				} else {
/*					if ( frontPt == firstPt ) {			// check for robustness
						console.log("ERR unique_monotone: point double", firstPt, frontMono );
					}		*/
					frontMono.marked = true;
				}
				if ( PNLTRI.Math.compare_pts_yx( frontPt, ymaxPt ) == 1 ) {
					ymaxPt = frontPt;
					monoPosmax = frontMono;
				}
				frontMono = frontMono.mnext;
			}
			return	monoPosmax;
		}

		var frontMono, monoPosmax;

		// assumes attribute "marked" is NOT yet "true" for any mono chain segment
		this.monoSubPolyChains = [];
		// loop through all original segments
		for ( var i = 0, j = this.segments.length; i < j; i++ ) {
			frontMono = this.segments[i];
			if ( frontMono.marked )		continue;		// already in a processed mono chain
			monoPosmax = find_monotone_chain_max( frontMono );
			if ( monoPosmax )	this.monoSubPolyChains.push( monoPosmax );
		}
		// loop through all additional segments (diagonals)			// TODO: Testcase for mono chain without original segments !!!
/*		for ( var i = 0, j = this.diagonals.length; i < j; i++ ) {
			frontMono = this.diagonals[i];
			if ( frontMono.marked )		continue;		// already in a processed mono chain
			monoPosmax = find_monotone_chain_max( frontMono );
			if ( monoPosmax )	this.monoSubPolyChains.push( monoPosmax );
		}	*/
		return	this.monoSubPolyChains;
	},


	/* Triangles */

	clearTriangles: function () {
		this.triangles = [];
	},

	addTriangle: function ( inVert1, inVert2, inVert3 ) {
		this.triangles.push( [ inVert1.id, inVert2.id, inVert3.id ] );
	},

};

/**
 * Simple Polygon Triangulation by Ear Clipping
 *
 * description of technique employed:
 *	http://www.siggraph.org/education/materials/HyperGraph/scanline/outprims/polygon1.htm
 *
 * This code is a quick port of code written in C++ which was submitted to
 *	flipcode.com by John W. Ratcliff  // July 22, 2000
 * See original code and more information here:
 *	http://www.flipcode.com/archives/Efficient_Polygon_Triangulation.shtml
 *
 * ported to actionscript by Zevan Rosser
 *	http://actionsnippet.com/?p=1462
 *
 * ported to javascript by Joshua Koo
 *	http://www.lab4games.net/zz85/blog
 *
 * adapted to doubly linked list by Juergen Ahting
 *	http://www.ameco.tv
 *
 */

/** @constructor */
PNLTRI.EarClipTriangulator = function ( inPolygonData ) {

	this.polyData	= inPolygonData;

};


PNLTRI.EarClipTriangulator.prototype = {

	constructor: PNLTRI.EarClipTriangulator,


	// triangulates first doubly linked segment list in this.polyData
	//	algorithm uses ear-clipping and runs in O(n^2) time

	triangulate_polygon_no_holes: function () {

		function isEarAt( vertex ) {

			var prevX = vertex.mprev.vFrom.x;
			var prevY = vertex.mprev.vFrom.y;

			var vertX = vertex.vFrom.x;
			var vertY = vertex.vFrom.y;

			var nextX = vertex.mnext.vFrom.x;
			var nextY = vertex.mnext.vFrom.y;

			var vnX = nextX - vertX,  vnY = nextY - vertY;
			var npX = prevX - nextX,  npY = prevY - nextY;
			var pvX = vertX - prevX,  pvY = vertY - prevY;

			// concave angle at vertex -> not an ear to cut off
			if ( PNLTRI.Math.EPSILON_P > ( ( pvX * vnY ) - ( vnX * pvY ) ) ) return false;

			// check whether any other point lieas within the triangle abc
			var vStop	= vertex.mprev.mprev;
			var vOther	= vertex.mnext;
			while ( vOther != vStop ) {
				vOther = vOther.mnext;
				var otherX = vOther.vFrom.x;
				var otherY = vOther.vFrom.y;

				var poX = otherX - prevX,  poY = otherY - prevY;
					// just in case there are several vertices with the same coordinate
					if ( ( poX === 0 ) && ( poY === 0 ) )		continue;	// vOther == vertex.mprev
				var voX = otherX - vertX,  voY = otherY - vertY;
					if ( ( voX === 0 ) && ( voY === 0 ) )		continue;	// vOther == vertex
				var noX = otherX - nextX,  noY = otherY - nextY;
					if ( ( noX === 0 ) && ( noY === 0 ) )		continue;	// vOther == vertex.mnext

				// if vOther is inside triangle abc -> not an ear to cut off
				if ( ( ( vnX * voY - vnY * voX ) >= PNLTRI.Math.EPSILON_N ) &&
					 ( ( pvX * poY - pvY * poX ) >= PNLTRI.Math.EPSILON_N ) &&
					 ( ( npX * noY - npY * noX ) >= PNLTRI.Math.EPSILON_N ) ) return false;
			}
			return true;

		}

		var myPolyData = this.polyData;
		var startSeg = myPolyData.getFirstSegment();

		// create a counter-clockwise ordered doubly linked list (monoChain links)

		var cursor = startSeg;
		if ( myPolyData.isClockWise( startSeg ) ) {
			do {	// reverses chain order
				cursor.mprev = cursor.snext;
				cursor.mnext = cursor.sprev;
				cursor = cursor.sprev;
			} while ( cursor != startSeg );
			myPolyData.set_PolyLeft_wrong(0);
		} else {
			do {
				cursor.mprev = cursor.sprev;
				cursor.mnext = cursor.snext;
				cursor = cursor.snext;
			} while ( cursor != startSeg );
		}

		//  remove all vertices except 2, creating 1 triangle every time

		var vertex = startSeg;
		var fullLoop = vertex;   // prevent infinite loop on "defective" polygons

		while ( vertex.mnext != vertex.mprev ) {
			if ( isEarAt( vertex ) ) {
				// found a triangle ear to cut off
				this.polyData.addTriangle( vertex.mprev.vFrom, vertex.vFrom, vertex.mnext.vFrom );
				// remove vertex from the remaining chain
				vertex.mprev.mnext = vertex.mnext;
				vertex.mnext.mprev = vertex.mprev;
				vertex = vertex.mnext;
				fullLoop = vertex;			// reset error detection
			} else {
				vertex = vertex.mnext;
				// loop?: probably non-simple polygon -> stop with error
				if ( vertex == fullLoop )	return false;
			}
		}

		return true;

	},

/*	// takes one element of a double linked segment list
	//	works on array of vertices

	triangulate_polygon_no_holes: function () {
		var startSeg = this.polyData.getFirstSegment();

		function vertList( inStartSeg ) {
			var verts = [];
			// we want a counter-clockwise polygon in verts
			var doubleArea = 0.0;
			var cursor = inStartSeg;
			var p,q;
			var idx = 0;
			do {
				p = cursor.sprev.vFrom;
				q = cursor.vFrom;
				doubleArea += p.x * q.y - q.x * p.y;
				verts[idx++] = q;
				cursor = cursor.snext;
			} while ( cursor != inStartSeg );
			if ( doubleArea < 0.0 ) {
				verts = verts.reverse();
				var tmp = verts.pop();
				verts.unshift( tmp );
			}
			return	verts;
		}

		function snip( verts, u, v, w, n ) {

			var ax = verts[ u ].x;
			var ay = verts[ u ].y;

			var bx = verts[ v ].x;
			var by = verts[ v ].y;

			var cx = verts[ w ].x;
			var cy = verts[ w ].y;

			if ( PNLTRI.Math.EPSILON_P > ( ( bx - ax ) * ( cy - ay ) - ( by - ay ) * ( cx - ax ) ) ) return false;

			var aX, aY, bX, bY, cX, cY;

			aX = cx - bx;  aY = cy - by;
			bX = ax - cx;  bY = ay - cy;
			cX = bx - ax;  cY = by - ay;

			var p, px, py;

			var apx, apy, bpx, bpy, cpx, cpy;
			var cCROSSap, bCROSScp, aCROSSbp;

			for ( p = 0; p < n; p ++ ) {

				px = verts[ p ].x
				py = verts[ p ].y

				apx = px - ax;  apy = py - ay;
					if ( ( apx == 0 ) && ( apy == 0 ) )		continue;
				bpx = px - bx;  bpy = py - by;
					if ( ( bpx == 0 ) && ( bpy == 0 ) )		continue;
				cpx = px - cx;  cpy = py - cy;
					if ( ( cpx == 0 ) && ( cpy == 0 ) )		continue;

				// see if p is inside triangle abc

				aCROSSbp = aX * bpy - aY * bpx;
				cCROSSap = cX * apy - cY * apx;
				bCROSScp = bX * cpy - bY * cpx;

				if ( ( aCROSSbp >= PNLTRI.Math.EPSILON_N ) &&
					 ( bCROSScp >= PNLTRI.Math.EPSILON_N ) &&
					 ( cCROSSap >= PNLTRI.Math.EPSILON_N ) ) return false;

			}

			return true;

		};

		var result = [];

		var	verts = vertList( startSeg );

		var n = verts.length;
		var nv = n;

		var u, v, w;

		//  remove nv - 2 vertices, creating 1 triangle every time

		var count = 2 * nv;   // error detection

		for ( v = nv - 1; nv > 2; ) {

			// if we loop, it is probably a non-simple polygon

			if ( ( count -- ) <= 0 )	return false;

			// three consecutive vertices in current polygon, <u,v,w>

			u = v; 	 	if ( nv <= u ) u = 0;     // previous
			v = u + 1;  if ( nv <= v ) v = 0;     // new v
			w = v + 1;  if ( nv <= w ) w = 0;     // next

			if ( snip( verts, u, v, w, nv ) ) {

				// output Triangle

				this.polyData.addTriangle( verts[ u ], verts[ v ], verts[ w ] );

				// remove v from the remaining polygon

				var s, t;

				for ( s = v, t = v + 1; t < nv; s++, t++ ) {

					verts[ s ] = verts[ t ];

				}

				nv --;

				v --;
				if ( v < 0 )	v = nv-1;

				// reset error detection counter

				count = 2 * nv;

			}

		}

		return true;

	},		*/

};

/**
 * @author jahting / http://www.ameco.tv/
 *
 *	Algorithm to create the trapezoidation of a polygon with holes
 *	 according to Seidel's algorithm [Sei91]
 */

/** @constructor */
PNLTRI.Trapezoid = function ( inHigh, inLow, inLeft, inRight ) {

	this.vHigh = inHigh ? inHigh : { x: Number.POSITIVE_INFINITY, y: Number.POSITIVE_INFINITY };
	this.vLow  = inLow  ? inLow  : { x: Number.NEGATIVE_INFINITY, y: Number.NEGATIVE_INFINITY };

	this.lseg = inLeft;
	this.rseg = inRight;

//	this.uL = null;				// -> Trapezoid: upper left neighbor
//	this.uR = null;				// -> Trapezoid: upper right neighbor
//	this.dL = null;				// -> Trapezoid: lower left neighbor
//	this.dR = null;				// -> Trapezoid: lower right neighbor

//	this.sink = null;			// link to corresponding SINK-Node in QueryStructure

//	this.usave = null;			// temp: uL/uR, preserved for next step
//	this.uleft = null;			// temp: from uL? (true) or uR (false)

	this.depth = -1;			// no depth assigned yet

	this.monoDone = false;		// monotonization: done with trying to split this trapezoid ?

};

PNLTRI.Trapezoid.prototype = {

	constructor: PNLTRI.Trapezoid,

	clone: function () {
		var newTrap = new PNLTRI.Trapezoid( this.vHigh, this.vLow, this.lseg, this.rseg );

		newTrap.uL = this.uL;
		newTrap.uR = this.uR;

		newTrap.dL = this.dL;
		newTrap.dR = this.dR;

		newTrap.sink = this.sink;

		return	newTrap;
	},


	splitOffLower: function ( inSplitPt ) {
		var trLower = this.clone();				// new lower trapezoid

		this.vLow = trLower.vHigh = inSplitPt;

		// L/R unknown, anyway changed later
		this.dL = trLower;		// setBelow
		trLower.uL = this;		// setAbove
		this.dR = trLower.uR = null;

		// setAbove
		if ( trLower.dL )	trLower.dL.uL = trLower;	// dL always connects to uL
		if ( trLower.dR )	trLower.dR.uR = trLower;	// dR always connects to uR

		return	trLower;
	},

};


/*==============================================================================
 *
 *============================================================================*/

// PNLTRI.qsCounter = 0;

/** @constructor */
PNLTRI.QsNode = function ( inTrapezoid ) {
//	this.qsId = PNLTRI.qsCounter++;				// Debug only
	// Only SINK-nodes are created directly.
	// The others originate from splitting trapezoids
	// - by a horizontal line: SINK-Node -> Y-Node
	// - by a segment: SINK-Node -> X-Node
	this.trap = inTrapezoid;
	inTrapezoid.sink = this;
};

PNLTRI.QsNode.prototype = {

	constructor: PNLTRI.QsNode,

};

/*==============================================================================
 *
 *============================================================================*/

/** @constructor */
PNLTRI.QueryStructure = function ( inPolygonData ) {
	// initialise the query structure and trapezoid list
	var initialTrap = new PNLTRI.Trapezoid( null, null, null, null );
	this.trapArray = [];
	this.appendTrapEntry( initialTrap );

//	PNLTRI.qsCounter = 0;
	this.root = new PNLTRI.QsNode( initialTrap );

	if ( inPolygonData ) {
		/*
		 * adds and initializes specific attributes for all segments
		 *	// -> QueryStructure: roots of partial tree where vertex is located
		 *	rootFrom, rootTo:	for vFrom, vTo
		 *	// marker
		 *	is_inserted:	already inserted into QueryStructure ?
		 */
		var segListArray = inPolygonData.getSegments();
		for ( var i = 0; i < segListArray.length; i++ ) {
			segListArray[i].rootFrom = segListArray[i].rootTo = this.root;
			segListArray[i].is_inserted = false;
		}
	}
};

PNLTRI.QueryStructure.prototype = {

	constructor: PNLTRI.QueryStructure,

	getRoot: function () {
		return this.root;
	},


	appendTrapEntry: function ( inTrapezoid ) {
		inTrapezoid.trapID = this.trapArray.length;			// for Debug
		this.trapArray.push( inTrapezoid );
	},
	cloneTrap: function ( inTrapezoid ) {
		var trap = inTrapezoid.clone();
		this.appendTrapEntry( trap );
		return	trap;
	},


	splitNodeAtPoint: function ( inNode, inPoint, inReturnUpper ) {
		// inNode: SINK-Node with trapezoid containing inPoint
		var trUpper = inNode.trap;							// trUpper: trapezoid includes the point
		if (trUpper.vHigh == inPoint)	return	inNode;				// (ERROR) inPoint is already inserted
		if (trUpper.vLow == inPoint)	return	inNode;				// (ERROR) inPoint is already inserted
		var trLower = trUpper.splitOffLower( inPoint );		// trLower: new lower trapezoid
		this.appendTrapEntry( trLower );

		// SINK-Node -> Y-Node
		inNode.yval = inPoint;
		inNode.trap = null;

		inNode.right = new PNLTRI.QsNode( trUpper );		// Upper trapezoid sink
		inNode.left = new PNLTRI.QsNode( trLower );			// Lower trapezoid sink

		return	inReturnUpper ? trUpper.sink : trLower.sink;
	},


	/*
	 * Mathematics & Geometry helper methods
	 */

	fpEqual: function ( inNum0, inNum1 ) {
		 return		Math.abs( inNum0 - inNum1 ) < PNLTRI.Math.EPSILON_P;
	},


	// Checks, whether the vertex inPt is to the left of line segment inSeg.
	//	Returns:
	//		>0: inPt is left of inSeg,
	//		<0: inPt is right of inSeg,
	//		=0: inPt is co-linear with inSeg
	//
	//	ATTENTION: always viewed from -y, not as if moving along the segment chain !!

	is_left_of: function ( inSeg, inPt, inBetweenY ) {
		var retVal;
		var dXfrom = inSeg.vFrom.x - inPt.x;
		var dXto = inSeg.vTo.x - inPt.x;
		var dYfromZero = this.fpEqual( inSeg.vFrom.y, inPt.y );
		if ( this.fpEqual( inSeg.vTo.y, inPt.y ) ) {
			if ( dYfromZero )	return 0;		// all points on a horizontal line
			retVal = dXto;
		} else if ( dYfromZero ) {
			retVal = dXfrom;
/*		} else if ( inBetweenY && ( dXfrom * dXto > 0 ) ) {
			// both x-coordinates of inSeg are on the same side of inPt
			if ( Math.abs( dXto ) >= PNLTRI.Math.EPSILON_P )	return	dXto;
			retVal = dXfrom;	*/
		} else {
			if ( inSeg.upward ) {
				return	PNLTRI.Math.ptsCrossProd( inSeg.vFrom, inSeg.vTo, inPt );
			} else {
				return	PNLTRI.Math.ptsCrossProd( inSeg.vTo, inSeg.vFrom, inPt );
			}
		}
		if ( Math.abs( retVal ) < PNLTRI.Math.EPSILON_P )		return	0;
		return	retVal;
	},


	/*
	 * Query structure main methods
	 */

	//	This method finds the Nodes in the QueryStructure corresponding
	//   to the trapezoids that contain the endpoints of inSegment,
	//	 starting from Nodes rootFrom/rootTo and replacing them with the results.

	segNodes: function ( inSegment ) {
		this.ptNode( inSegment, true );
		this.ptNode( inSegment, false );
	},

	// TODO: may need to prevent infinite loop in case of messed up
	//	trapezoid structure (s. test_add_segment_special_6)

	ptNode: function ( inSegment, inUseFrom ) {
		var ptMain, ptOther, qsNode;
		if ( inUseFrom ) {
			ptMain = inSegment.vFrom;
			ptOther = inSegment.vTo;		// used if ptMain is not sufficient
			qsNode = inSegment.rootFrom;
		} else {
			ptMain = inSegment.vTo;
			ptOther = inSegment.vFrom;
			qsNode = inSegment.rootTo;
		}
		var compPt, compRes;
		var isInSegmentShorter;

		while ( qsNode ) {
			if ( qsNode.yval ) {			// Y-Node: horizontal line
											// 4 times as often as X-Node
				qsNode = ( PNLTRI.Math.compare_pts_yx( ( ( ptMain == qsNode.yval ) ?	// is the point already inserted ?
									ptOther : ptMain ), qsNode.yval ) == -1 ) ?
									qsNode.left : qsNode.right;						// below : above
			} else if ( qsNode.seg ) {		// X-Node: segment (~vertical line)
											// 0.8 to 1.5 times as often as SINK-Node
				if ( ( ptMain == qsNode.seg.vFrom ) ||
					 ( ptMain == qsNode.seg.vTo ) ) {
					// the point is already inserted
					if ( this.fpEqual( ptMain.y, ptOther.y ) ) {
						// horizontal segment
						if ( !this.fpEqual( qsNode.seg.vFrom.y, qsNode.seg.vTo.y ) ) {
							qsNode = ( ptOther.x < ptMain.x ) ? qsNode.left : qsNode.right;		// left : right
						} else {	// co-linear horizontal reversal: test_add_segment_special_7
							if ( ptMain == qsNode.seg.vFrom ) {
								// connected at qsNode.seg.vFrom
//								console.log("ptNode: co-linear horizontal reversal, connected at qsNode.seg.vFrom", inUseFrom, inSegment, qsNode )
								isInSegmentShorter = inSegment.upward ?
										( ptOther.x >= qsNode.seg.vTo.x ) :
										( ptOther.x <  qsNode.seg.vTo.x );
								qsNode = ( isInSegmentShorter ?
												inSegment.sprev.upward :
												qsNode.seg.snext.upward ) ? qsNode.right : qsNode.left;		// above : below
							} else {
								// connected at qsNode.seg.vTo
//								console.log("ptNode: co-linear horizontal reversal, connected at qsNode.seg.vTo", inUseFrom, inSegment, qsNode );
								isInSegmentShorter = inSegment.upward ?
										( ptOther.x <  qsNode.seg.vFrom.x ) :
										( ptOther.x >= qsNode.seg.vFrom.x );
								qsNode = ( isInSegmentShorter ?
												inSegment.snext.upward :
												qsNode.seg.sprev.upward ) ? qsNode.left : qsNode.right;		// below : above
							}
						}
						continue;
					} else {
						compRes = this.is_left_of( qsNode.seg, ptOther, false );
						if ( compRes === 0 ) {
							// co-linear reversal (not horizontal)
							//	a co-linear continuation would not reach this point
							//  since the previous Y-node comparison would have led to a sink instead
//							console.log("ptNode: co-linear, going back on previous segment", ptMain, ptOther, qsNode );
							// now as we have two consecutive co-linear segments we have to avoid a cross-over
							//	for this we need the far point on the "next" segment to the SHORTER of our two
							//	segments to avoid that "next" segment to cross the longer of our two segments
							if ( ptMain == qsNode.seg.vFrom ) {
								// connected at qsNode.seg.vFrom
//								console.log("ptNode: co-linear, going back on previous segment, connected at qsNode.seg.vFrom", ptMain, ptOther, qsNode );
								isInSegmentShorter = inSegment.upward ?
										( ptOther.y >= qsNode.seg.vTo.y ) :
										( ptOther.y <  qsNode.seg.vTo.y );
								compRes = isInSegmentShorter ?
										this.is_left_of( qsNode.seg, inSegment.sprev.vFrom, false ) :
										-this.is_left_of( qsNode.seg, qsNode.seg.snext.vTo, false );
							} else {
								// connected at qsNode.seg.vTo
//								console.log("ptNode: co-linear, going back on previous segment, connected at qsNode.seg.vTo", ptMain, ptOther, qsNode );
								isInSegmentShorter = inSegment.upward ?
										( ptOther.y <  qsNode.seg.vFrom.y ) :
										( ptOther.y >= qsNode.seg.vFrom.y );
								compRes = isInSegmentShorter ?
										this.is_left_of( qsNode.seg, inSegment.snext.vTo, false ) :
										-this.is_left_of( qsNode.seg, qsNode.seg.sprev.vFrom, false );
							}
						}
					}
				} else {
/*					if ( ( PNLTRI.Math.compare_pts_yx( ptMain, qsNode.seg.vFrom ) *			// TODO: Testcase
							PNLTRI.Math.compare_pts_yx( ptMain, qsNode.seg.vTo )
						   ) == 0 ) {
						console.log("ptNode: Pts too close together#2: ", ptMain, qsNode.seg );
					}		*/
					compRes = this.is_left_of( qsNode.seg, ptMain, true );
					if ( compRes === 0 ) {
						// touching: ptMain lies on qsNode.seg but is none of its endpoints
						//	should happen quite seldom
						compRes = this.is_left_of( qsNode.seg, ptOther, false );
						if ( compRes === 0 ) {
							// co-linear: inSegment and qsNode.seg
							//	includes case with ptOther connected to qsNode.seg
							var tmpPtOther = inUseFrom ? inSegment.sprev.vFrom : inSegment.snext.vTo;
							compRes = this.is_left_of( qsNode.seg, tmpPtOther, false );
						}
					}
				}
				if ( compRes > 0 ) {
					qsNode = qsNode.left;
				} else if ( compRes < 0 ) {
					qsNode = qsNode.right;
				} else {
					// ???	TODO - not reached with current tests
					//				possible at all ?
					return qsNode;
					// qsNode = qsNode.left;		// left
					// qsNode = qsNode.right;		// right
				}
			} else {		// SINK-Node: trapezoid area
							// least often
				if ( !qsNode.trap )	{ console.log("ptNode: unknown type", qsNode); }
				if ( inUseFrom )	{ inSegment.rootFrom = qsNode; }
				else				{ inSegment.rootTo = qsNode; }
				return qsNode;
			}
		}	// end while - should not exit here
	},


 	// Add a new segment into the trapezoidation and update QueryStructure and Trapezoids
	// 1) locates the two endpoints of the segment in the QueryStructure and inserts them
	// 2) goes from the high-end trapezoid down to the low-end trapezoid
	//		changing all the trapezoids in between.
	// Except for the high-end and low-end no new trapezoids are created.
	// For all in between either:
	// - the existing trapezoid is restricted to the left of the new segment
	//		and on the right side the trapezoid from above is extended downwards
	// - or the other way round:
	//	 the existing trapezoid is restricted to the right of the new segment
	//		and on the left side the trapezoid from above is extended downwards

	add_segment: function ( inSegment ) {
		var scope = this;

		// functions handling the relationship to the upper neighbors (uL, uR)
		//	of trNewLeft and trNewRight

		function fresh_seg_or_upward_cusp() {
			// trCurrent has at most 1 upper neighbor
			//	and should also have at least 1, since the high-point trapezoid
			//	has been split off another one, which is now above
			var trUpper = trCurrent.uL || trCurrent.uR;

			// trNewLeft and trNewRight CANNOT have been extended from above
			if ( trUpper.dL && trUpper.dR ) {
				// upward cusp: top forms a triangle

				// ATTENTION: the decision whether trNewLeft or trNewRight is the
				//	triangle trapezoid formed by the two segments has already been taken
				//	when selecting trCurrent as the left or right lower neighbor to trUpper !!

				if ( trCurrent == trUpper.dL ) {
					//	*** Case: FUC_UC_LEFT; prev: ----
					// console.log( "fresh_seg_or_upward_cusp: upward cusp, new seg to the left!" );
					//		  upper
					//   -------*-------
					//		   + \
					//	  NL  +   \
					//		 +	NR \
					//		+		\
					trNewRight.uL	= null;			// setAbove; trNewRight.uR, trNewLeft unchanged
					trUpper.dL		= trNewLeft;	// setBelow; dR: unchanged, NEVER null
				} else {
					//	*** Case: FUC_UC_RIGHT; prev: ----
					// console.log( "fresh_seg_or_upward_cusp: upward cusp, new seg from the right!" );
					//		  upper
					//   -------*-------
					//		   / +
					//		  /   +	 NR
					//		 /	NL +
					//		/		+
					trNewLeft.uR	= null;			// setAbove; trNewLeft.uL, trNewRight unchanged
					trUpper.dR		= trNewRight;	// setBelow; dL: unchanged, NEVER null
				}
			} else {
				//	*** Case: FUC_FS; prev: "splitOffLower"
				// console.log( "fresh_seg_or_upward_cusp: fresh segment, high adjacent segment still missing" );
				//		  upper
				//   -------*-------
				//		   +
				//	  NL  +
				//		 +	NR
				//		+
				trNewRight.uL = null;			// setAbove; trNewLeft unchanged, set by "splitOffLower"
				trNewRight.uR = trUpper;
				trUpper.dR = trNewRight;		// setBelow; trUpper.dL unchanged, set by "splitOffLower"
			}
 		}

		function continue_chain_from_above() {
			// trCurrent has at least 2 upper neighbors
			if ( trCurrent.usave ) {
				// 3 upper neighbors (part II)
				if ( trCurrent.uleft ) {
					//	*** Case: CC_3UN_LEFT; prev: 1B_3UN_LEFT
					// console.log( "continue_chain_from_above: 3 upper neighbors (part II): u0a, u0b, uR(usave)" );
					// => left gets one, right gets two of the upper neighbors
					// !! trNewRight cannot have been extended from above
					//		and trNewLeft must have been !!
					//		   +		/
					//	  C.uL  + C.uR / C.usave
					//    - - - -+----*----------
					//		NL	  +		NR
					trNewRight.uL = trCurrent.uR;		// setAbove
					trNewRight.uR = trCurrent.usave;
					trNewRight.uL.dL = trNewRight;		// setBelow; trNewRight.uL.dR == null, unchanged
					trNewRight.uR.dR = trNewRight;		// setBelow; trNewRight.uR.dL == null, unchanged
				} else {
					//	*** Case: CC_3UN_RIGHT; prev: 1B_3UN_RIGHT
					// console.log( "continue_chain_from_above: 3 upper neighbors (part II): uL(usave), u1a, u1b" );
					// => left gets two, right gets one of the upper neighbors
					// !! trNewLeft cannot have been extended from above
					//		and trNewRight must have been !!
					//			\		 +
					//	 C.usave \ C.uL + C.uR
					//   ---------*----+- - - -
					//			NL    +   NR
					trNewLeft.uR = trCurrent.uL;		// setAbove; first uR !!!
					trNewLeft.uL = trCurrent.usave;
					trNewLeft.uL.dL = trNewLeft;		// setBelow; dR == null, unchanged
					trNewLeft.uR.dR = trNewLeft;		// setBelow; dL == null, unchanged
				}
				trNewLeft.usave = trNewRight.usave = null;
			} else if ( trCurrent.vHigh == trFirst.vHigh ) {		// && meetsHighAdjSeg ??? TODO
				//	*** Case: CC_2UN_CONN; prev: ----
				// console.log( "continue_chain_from_above: 2 upper neighbors, fresh seg, continues high adjacent seg" );
				// !! trNewLeft and trNewRight cannot have been extended from above !!
				//	  C.uL	 /  C.uR
				//   -------*---------
				//	   NL  +	NR
				trNewRight.uR.dR = trNewRight;			// setBelow; dL == null, unchanged
				trNewLeft.uR = trNewRight.uL = null;	// setAbove; trNewLeft.uL, trNewRight.uR unchanged
			} else {
				//	*** Case: CC_2UN; prev: 1B_1UN_CONT, 2B_NOCON_RIGHT/LEFT, 2B_TOUCH_RIGHT/LEFT, 2B_COLIN_RIGHT/LEFT
				// console.log( "continue_chain_from_above: simple case, 2 upper neighbors (no usave, not fresh seg)" );
				// !! trNewLeft XOR trNewRight will have been extended from above !!
				//	  C.uL	 +  C.uR
				//   -------+---------
				//	   NL  +	NR
				if ( trNewRight == trCurrent ) {		// trNewLeft has been extended from above
					// setAbove
					trNewRight.uL = trNewRight.uR;
					trNewRight.uR = null;
					// setBelow; dR: unchanged, is NOT always null (prev: 2B_NOCON_LEFT, 2B_TOUCH_LEFT, 2B_COLIN_LEFT)
					trNewRight.uL.dL = trNewRight;
				} else {								// trNewRight has been extended from above
					trNewLeft.uR = trNewLeft.uL;	// setAbove; first uR !!!
					trNewLeft.uL = null;
				}
			}
		}

		// functions handling the relationship to the lower neighbors (dL, dR)
		//	of trNewLeft and trNewRight
		// trNewLeft or trNewRight MIGHT have been extended from above
		//  !! in that case dL and dR are different from trCurrent and MUST be set here !!

		function only_one_trap_below( inTrNext ) {

			if ( trCurrent.vLow == trLast.vLow ) {
				// final part of segment

				if ( meetsLowAdjSeg ) {
					// downward cusp: bottom forms a triangle

					// ATTENTION: the decision whether trNewLeft and trNewRight are to the
					//	left or right of the already inserted segment the new one meets here
					//	has already been taken when selecting trLast to the left or right
					//	of that already inserted segment !!

					if ( trCurrent.dL ) {
						//	*** Case: 1B_DC_LEFT; next: ----
						// console.log( "only_one_trap_below: downward cusp, new seg from the left!" );
						//		+		/
						//		 +  NR /
						//	  NL  +	  /
						//		   + /
						//   -------*-------
						//	   C.dL = next

						// setAbove
						inTrNext.uL = trNewLeft;	// uR: unchanged, NEVER null
						// setBelow part 1
						trNewLeft.dL = inTrNext;
						trNewRight.dR = null;
					} else {
						//	*** Case: 1B_DC_RIGHT; next: ----
						// console.log( "only_one_trap_below: downward cusp, new seg to the right!" );
						//		\		+
						//		 \  NL +
						//		  \	  +  NR
						//		   \ +
						//   -------*-------
						//	   C.dR = next

						// setAbove
						inTrNext.uR = trNewRight;	// uL: unchanged, NEVER null
						// setBelow part 1
						trNewLeft.dL = null;
						trNewRight.dR = inTrNext;
					}
				} else {
					//	*** Case: 1B_1UN_END; next: ----
					// console.log( "only_one_trap_below: simple case, new seg ends here, low adjacent seg still missing" );
					//			  +
					//		NL	 +  NR
					//			+
					//   ------*-------
					//		  next

					// setAbove
					inTrNext.uL = trNewLeft;									// trNewLeft must
					inTrNext.uR = trNewRight;		// must
					// setBelow part 1
					trNewLeft.dL = trNewRight.dR = inTrNext;					// Error
//					trNewRight.dR = inTrNext;
				}
				// setBelow part 2
				trNewLeft.dR = trNewRight.dL = null;
			} else {
				// NOT final part of segment

				if ( inTrNext.uL && inTrNext.uR ) {
					// inTrNext has two upper neighbors
					// => a segment ends on the upper Y-line of inTrNext
					// => inTrNext has temporarily 3 upper neighbors
					// => marks whether the new segment cuts through
					//		uL or uR of inTrNext and saves the other in .usave
					if ( inTrNext.uL == trCurrent ) {
						//	*** Case: 1B_3UN_LEFT; next: CC_3UN_LEFT
						// console.log( "only_one_trap_below: inTrNext has 3 upper neighbors (part I): u0a, u0b, uR(usave)" );
						//		 +		  /
						//	  NL  +	 NR	 /
						//		   +	/
						//   - - - -+--*----
						//			 +
						//		  next
//						if ( inTrNext.uR != trNewRight ) {		// for robustness	TODO: prevent
							inTrNext.usave = inTrNext.uR;
							inTrNext.uleft = true;
							// trNewLeft: L/R undefined, will be extended down and changed anyway
						// } else {
							// ERROR: should not happen
							// console.log( "ERR add_segment: Trapezoid Loop right", inTrNext, trCurrent, trNewLeft, trNewRight, inSegment, this );
//						}
					} else {
						//	*** Case: 1B_3UN_RIGHT; next: CC_3UN_RIGHT
						// console.log( "only_one_trap_below: inTrNext has 3 upper neighbors (part I): uL(usave), u1a, u1b" );
						//	 \		   +
						//	  \	  NL  +  NR
						//	   \	 +
						//   ---*---+- - - -
						//		   +
						//		  next
//						if ( inTrNext.uL != trNewLeft ) {		// for robustness	TODO: prevent
							inTrNext.usave = inTrNext.uL;
							inTrNext.uleft = false;
							// trNewRight: L/R undefined, will be extended down and changed anyway
						// } else {
							// ERROR: should not happen
							// console.log( "ERR add_segment: Trapezoid Loop left", inTrNext, trCurrent, trNewLeft, trNewRight, inSegment, this );
//						}
					}
				//} else {
					//	*** Case: 1B_1UN_CONT; next: CC_2UN
					// console.log( "only_one_trap_below: simple case, new seg continues down" );
					//			  +
					//		NL	 +  NR
					//			+
					//   ------+-------
					//	 	  +
					//		next

					// L/R for one side undefined, which one is not fixed
					//	but that one will be extended down and changed anyway
					// for the other side, vLow must lie at the opposite end
					//	thus both are set accordingly
				}
				// setAbove
				inTrNext.uL = trNewLeft;
				inTrNext.uR = trNewRight;
				// setBelow
				trNewLeft.dR = trNewRight.dL = inTrNext;
				trNewLeft.dL = trNewRight.dR = null;
			}
		}

		function two_trap_below() {
			// Find out which one (dL,dR) is intersected by this segment and
			//	continue down that one
			var trNext;
			if ( ( trCurrent.vLow == trLast.vLow ) && meetsLowAdjSeg ) {	// meetsLowAdjSeg necessary? TODO
				//	*** Case: 2B_CON_END; next: ----
				// console.log( "two_trap_below: finished, meets low adjacent segment" );
				//			  +
				//		NL	 +  NR
				//			+
				//   ------*-------
				//	 		\  C.dR
				//	  C.dL	 \

				// setAbove
				trCurrent.dL.uL = trNewLeft;
				trCurrent.dR.uR = trNewRight;
				// setBelow; sequence of assignments essential, just in case: trCurrent == trNewLeft
				trNewLeft.dL = trCurrent.dL;
				trNewRight.dR = trCurrent.dR;
				trNewLeft.dR = trNewRight.dL = null;

				trNext = null;	      	// segment finished
			} else {
				// setAbove part 1
				trCurrent.dL.uL = trNewLeft;
				trCurrent.dR.uR = trNewRight;

				var goDownRight;
				// passes left or right of an already inserted NOT connected segment
				//	trCurrent.vLow: high-end of existing segment
				var compRes = scope.is_left_of( inSegment, trCurrent.vLow, true );
				if ( compRes > 0 ) {				// trCurrent.vLow is left of inSegment
					//	*** Case: 2B_NOCON_RIGHT; next: CC_2UN
					// console.log( "two_trap_below: (intersecting dR)" );
					//		 +
					//	  NL  +  NR
					//		   +
					//   ---*---+- - - -
					//		 \	 +
					//	 C.dL \	C.dR
					goDownRight = true;
				} else if ( compRes < 0 ) {			// trCurrent.vLow is right of inSegment
					//	*** Case: 2B_NOCON_LEFT; next: CC_2UN
					// console.log( "two_trap_below: (intersecting dL)" );
					//			  +
					//		NL	 +  NR
					//			+
					//    - - -+---*-------
					//	 	  +		\  C.dR
					//	 	 C.dL	 \
					goDownRight = false;
				} else {							// trCurrent.vLow lies ON inSegment
					var vLowSeg = trCurrent.dL.rseg;
					var directionIsUp = vLowSeg.upward;
					var otherPt = directionIsUp ? vLowSeg.vFrom : vLowSeg.vTo;
					compRes = scope.is_left_of( inSegment, otherPt, false );
					if ( compRes > 0 ) {				// otherPt is left of inSegment
						//	*** Case: 2B_TOUCH_RIGHT; next: CC_2UN
						// console.log( "two_trap_below: vLow ON new segment, touching from right" );
						//		 +
						//	  NL  +  NR
						//		   +
						//   -------*- - - -
						//		   / +
						//	 C.dL /	C.dR
						goDownRight = true;		// like intersecting dR
					} else if ( compRes < 0 ) {			// otherPt is right of inSegment
						//	*** Case: 2B_TOUCH_LEFT; next: CC_2UN
						// console.log( "two_trap_below: vLow ON new segment, touching from left" );
						//			  +
						//		NL	 +  NR
						//			+
						//    - - -*-------
						//	 	  +	\  C.dR
						//	  C.dL	 \
						goDownRight = false;	// like intersecting dL
					} else {							// otherPt lies ON inSegment
						vLowSeg = directionIsUp ? vLowSeg.snext : vLowSeg.sprev;		// other segment with trCurrent.vLow
						otherPt = directionIsUp ? vLowSeg.vTo : vLowSeg.vFrom;
						compRes = scope.is_left_of( inSegment, otherPt, false );
						if ( compRes > 0 ) {				// otherPt is left of inSegment
							//	*** Case: 2B_COLIN_RIGHT; next: CC_2UN
							// console.log( "two_trap_below: vLow ON new segment, touching from right" );
							//		  +
							//	  NL   +  NR
							//   -------*- - - -
							//	  C.dL 	\+  C.dR
							//			 \+
							goDownRight = true;		// like intersecting dR
					//	} else if ( compRes == 0 ) {		//	NOT POSSIBLE, since 3 points on a line is prevented during input of polychains
					//		goDownRight = true;		// like intersecting dR
						} else {							// otherPt is right of inSegment
							//	*** Case: 2B_COLIN_LEFT; next: CC_2UN
							// console.log( "two_trap_below: vLow ON new segment, touching from left" );
							//			   +
							//		NL	  +  NR
							//    - - - -*-------
							//	  C.dL	+/  C.dR
							//		   +/
							goDownRight = false;		// TODO: for test_add_segment_special_4 -> like intersecting dL
						}
					}
				}
				if ( goDownRight ) {
					trNext = trCurrent.dR;
					// setAbove part 2
					trCurrent.dR.uL = trNewLeft;
					// setBelow part 1
					trNewLeft.dL = trCurrent.dL;
					trNewRight.dR = null;	// L/R undefined, will be extended down and changed anyway
				} else {
					trNext = trCurrent.dL;
					// setAbove part 2
					trCurrent.dL.uR = trNewRight;
					// setBelow part 1
					trNewRight.dR = trCurrent.dR;
					trNewLeft.dL = null;	// L/R undefined, will be extended down and changed anyway
				}
				// setBelow part 2
				trNewLeft.dR = trNewRight.dL = trNext;
			}

 			return	trNext;
		}

		//
		//	main function body
		//

/*		if ( ( inSegment.sprev.vTo != inSegment.vFrom ) || ( inSegment.vTo != inSegment.snext.vFrom ) ) {
			console.log( "add_segment: inconsistent point order of adjacent segments: ",
						 inSegment.sprev.vTo, inSegment.vFrom, inSegment.vTo, inSegment.snext.vFrom );
			return;
		}		*/

		//	Find the top-most and bottom-most intersecting trapezoids -> rootXXX
		this.segNodes( inSegment );

		var segLowVert , segLowNode, meetsLowAdjSeg;		// y-min vertex
		var segHighVert, segHighNode, meetsHighAdjSeg;		// y-max vertex

		if ( inSegment.upward ) {
			segLowVert	= inSegment.vFrom;
			segHighVert	= inSegment.vTo;
			segLowNode		= inSegment.rootFrom;
			segHighNode		= inSegment.rootTo;
			// was lower point already inserted earlier? => segments meet at their ends
			meetsLowAdjSeg	= inSegment.sprev.is_inserted;
			// was higher point already inserted earlier? => segments meet at their ends
			meetsHighAdjSeg	= inSegment.snext.is_inserted;
		} else {
			segLowVert	= inSegment.vTo;
			segHighVert	= inSegment.vFrom;
			segLowNode		= inSegment.rootTo;
			segHighNode		= inSegment.rootFrom;
			meetsLowAdjSeg	= inSegment.snext.is_inserted;
			meetsHighAdjSeg	= inSegment.sprev.is_inserted;
		}

		//	insert higher vertex into QueryStructure
		if ( !meetsHighAdjSeg ) {
			// higher vertex not yet inserted => split trapezoid horizontally
			var tmpNode = this.splitNodeAtPoint( segHighNode, segHighVert, false );
			// move segLowNode to new (lower) trapezoid, if it was the one which was just split
			if ( segHighNode == segLowNode )	segLowNode = tmpNode;
			segHighNode = tmpNode;
		}
		var trFirst = segHighNode.trap;		// top-most trapezoid for this segment

		// check for robustness		// TODO: prevent
		if ( !trFirst.uL && !trFirst.uR ) {
			console.log("ERR add_segment: missing trFirst.uX: ", trFirst );
			return;
		}
		if ( trFirst.vHigh != segHighVert ) {
			console.log("ERR add_segment: trFirstHigh != segHigh: ", trFirst );
			return;
		}

		//	insert lower vertex into QueryStructure
		if ( !meetsLowAdjSeg ) {
			// lower vertex not yet inserted => split trapezoid horizontally
			segLowNode = this.splitNodeAtPoint( segLowNode, segLowVert, true );
		}
		var trLast = segLowNode.trap;			// bottom-most trapezoid for this segment

		//
		// Thread the segment into the query "tree" from top to bottom.
		// All the trapezoids which are intersected by inSegment are "split" into two.
		// For each the SINK-QsNode is converted into an X-Node and
		//  new sinks for the new partial trapezoids are added.
		// In fact a real split only happens at the top and/or bottom end of the segment
		//	since at every y-line seperating two trapezoids is traverses it
		//	cuts off the "beam" from the y-vertex on one side, so that at that side
		//	the trapezoid from above can be extended down.
		//

		var trCurrent = trFirst;

		var trNewLeft, trNewRight, trPrevLeft, trPrevRight;

		var counter = this.trapArray.length + 2;		// just to prevent infinite loop
		var trNext;
		while ( trCurrent ) {
			if ( --counter < 0 ) {
				console.log( "ERR add_segment: infinite loop", trCurrent, inSegment, this );
				return;
			}
			if ( !trCurrent.dL && !trCurrent.dR ) {
				// ERROR: no successors, cannot arise if data is correct
				console.log( "ERR add_segment: missing successors", trCurrent, inSegment, this );
				return;
			}

			var qs_trCurrent = trCurrent.sink;
			// SINK-Node -> X-Node
			qs_trCurrent.seg = inSegment;
			qs_trCurrent.trap = null;
			//
			// successive trapezoids bordered by the same segments are merged
			//  by extending the trPrevRight or trPrevLeft down
			//  and redirecting the parent X-Node to the extended sink
			// !!! destroys tree structure since several nodes now point to the same SINK-Node !!!
			// TODO: maybe it's not a problem;
			//  merging of X-Nodes is no option, since they are used as "rootFrom/rootTo" !
			//
			if ( trPrevRight && ( trPrevRight.rseg == trCurrent.rseg ) ) {
				// console.log( "add_segment: extending right predecessor down!", trPrevRight );
				trNewLeft = trCurrent;
				trNewRight = trPrevRight;
				trNewRight.vLow = trCurrent.vLow;
				// redirect parent X-Node to extended sink
				qs_trCurrent.left = new PNLTRI.QsNode( trNewLeft );			// trCurrent -> left SINK-Node
				qs_trCurrent.right = trPrevRight.sink;						// deforms tree by multiple links to trPrevRight.sink
			} else if ( trPrevLeft && ( trPrevLeft.lseg == trCurrent.lseg ) ) {
				// console.log( "add_segment: extending left predecessor down!", trPrevLeft );
				trNewRight = trCurrent;
				trNewLeft = trPrevLeft;
				trNewLeft.vLow = trCurrent.vLow;
				// redirect parent X-Node to extended sink
				qs_trCurrent.left = trPrevLeft.sink;						// deforms tree by multiple links to trPrevLeft.sink
				qs_trCurrent.right = new PNLTRI.QsNode( trNewRight );		// trCurrent -> right SINK-Node
			} else {
				trNewLeft = trCurrent;
				trNewRight = this.cloneTrap(trCurrent);
				qs_trCurrent.left = new PNLTRI.QsNode( trNewLeft );			// trCurrent -> left SINK-Node
				qs_trCurrent.right = new PNLTRI.QsNode( trNewRight );		// new clone -> right SINK-Node
			}

			// handle neighbors above
			if ( trCurrent.uL && trCurrent.uR )	{
				continue_chain_from_above();
			} else {
				fresh_seg_or_upward_cusp();
			}

			// handle neighbors below
			if ( trCurrent.dL && trCurrent.dR ) {
				trNext = two_trap_below();
			} else {
				if ( trCurrent.dL ) {
					// console.log( "add_segment: only_one_trap_below! (dL)" );
					trNext = trCurrent.dL;
				} else {
					// console.log( "add_segment: only_one_trap_below! (dR)" );
					trNext = trCurrent.dR;
				}
				only_one_trap_below( trNext );
			}

			if ( trNewLeft.rseg )	trNewLeft.rseg.trLeft = trNewRight;
			if ( trNewRight.lseg )	trNewRight.lseg.trRight = trNewLeft;
			trNewLeft.rseg = trNewRight.lseg  = inSegment;
			inSegment.trLeft = trNewLeft;
			inSegment.trRight = trNewRight;

			// further loop-step down ?
			if ( trCurrent.vLow != trLast.vLow ) {
				trPrevLeft = trNewLeft;
				trPrevRight = trNewRight;

				trCurrent = trNext;
			} else {
				trCurrent = null;
			}
		}	// end while

		inSegment.is_inserted = true;
		// console.log( "add_segment: ###### DONE ######" );
	},

	// Assigns a depth to all trapezoids;
	//	0: outside, 1: main polygon, 2: holes, 3:polygons in holes, ...
	// Checks segment orientation and marks those polygon chains for reversal
	//	where the polygon inside lies to their right (contour in CW, holes in CCW)
	assignDepths: function ( inPolyData ) {
		var thisDepth = [ this.trapArray[0] ];
		var nextDepth = [];

		var thisTrap, borderSeg, curDepth = 0;
		do {
			// rseg should exactely go upward on trapezoids inside the polygon (odd depth)
			var expectedRsegUpward = ( ( curDepth % 2 ) == 1 );
			while ( thisTrap = thisDepth.pop() ) {			// assignment !
				if ( thisTrap.depth != -1 )	continue;
				thisTrap.depth = curDepth;
				//
				if ( thisTrap.uL )	thisDepth.push( thisTrap.uL );
				if ( thisTrap.uR )	thisDepth.push( thisTrap.uR );
				if ( thisTrap.dL )	thisDepth.push( thisTrap.dL );
				if ( thisTrap.dR )	thisDepth.push( thisTrap.dR );
				//
				if ( ( borderSeg = thisTrap.lseg ) && ( borderSeg.trLeft.depth == -1 ) )	// assignment !
					nextDepth.push( borderSeg.trLeft );
				if ( borderSeg = thisTrap.rseg ) {											// assignment !
					if ( borderSeg.trRight.depth == -1 )
						nextDepth.push( borderSeg.trRight );
					if ( borderSeg.upward != expectedRsegUpward )
						inPolyData.set_PolyLeft_wrong( borderSeg.chainId );
				}
			}
			thisDepth = nextDepth; nextDepth = [];
			curDepth++;
		} while ( thisDepth.length > 0 );
	},

	// creates the visibility map:
	//	for each vertex the list of all vertices in CW order which are directly
	//	visible through neighboring trapezoids and thus can be connected by a diagonal

	create_visibility_map: function ( inPolygonData ) {
		// positional slots for neighboring trapezoid-diagonals
		var DIAG_UL = 0, DIAG_UM = 1, DIAG_ULR = 2, DIAG_UR = 3;
		var DIAG_DR = 4, DIAG_DM = 5, DIAG_DLR = 6, DIAG_DL = 7;

		var i, j;
		var nbVertices = inPolygonData.nbVertices();

		// initialize arrays for neighboring trapezoid-diagonals and vertices
		var myVisibleDiagonals	= new Array(nbVertices);
		for ( i = 0; i < nbVertices; i++ ) {
			myVisibleDiagonals[i] = new Array(DIAG_DL+1);
		}
		// create the list of neighboring trapezoid-diagonals
		//	put into their positional slots
		var myExternalNeighbors = new Array(nbVertices);
		for ( i = 0, j = this.trapArray.length; i < j; i++ ) {
			var curTrap = this.trapArray[i];
			var highPos = curTrap.uL ?
						( curTrap.uR ? DIAG_DM : DIAG_DL ) :
						( curTrap.uR ? DIAG_DR : DIAG_DLR );
			var lowPos = curTrap.dL ?
						( curTrap.dR ? DIAG_UM : DIAG_UL ) :
						( curTrap.dR ? DIAG_UR : DIAG_ULR );

			if ( ( curTrap.depth % 2 ) == 1 ) {		// inside ?
				if ( ( highPos == DIAG_DM ) || ( lowPos == DIAG_UM ) ||
					 ( ( highPos == DIAG_DL ) && ( lowPos == DIAG_UR ) ) ||
					 ( ( highPos == DIAG_DR ) && ( lowPos == DIAG_UL ) ) ) {
					var lhDiag = inPolygonData.appendDiagonalsEntry( {
									vFrom: curTrap.vLow, vTo: curTrap.vHigh,
									mprev: null, mnext: null, marked: false } );
					var hlDiag = inPolygonData.appendDiagonalsEntry( {
									vFrom: curTrap.vHigh, vTo: curTrap.vLow, revDiag: lhDiag,
									mprev: null, mnext: null, marked: false } );
					lhDiag.revDiag = hlDiag;
					myVisibleDiagonals[ curTrap.vLow.id][ lowPos] = lhDiag;
					myVisibleDiagonals[curTrap.vHigh.id][highPos] = hlDiag;
				}
			} else {		// outside, hole
				if ( curTrap.vHigh.id !== null )	myExternalNeighbors[curTrap.vHigh.id] = highPos;
				if ( curTrap.vLow.id  !== null )	myExternalNeighbors[ curTrap.vLow.id] = lowPos;
			}
		}
		// create the list of outgoing diagonals in the right order (CW)
		//	from the ordered list of neighboring trapezoid-diagonals
		//	- starting from an external one
		// and connect those incoming to
		var curDiag, curDiags, firstElem, fromVertex, lastIncoming;
		for ( i = 0; i < nbVertices; i++ ) {
			curDiags  = myVisibleDiagonals[i];
			firstElem = myExternalNeighbors[i];
			if ( firstElem == null )	continue;		// eg. skipped vertices (zero length, co-linear		// NOT: === !
			j = firstElem;
			lastIncoming = null;
			do {
				if ( j++ > DIAG_DL )			j = DIAG_UL;	// circular positional list
				if ( curDiag = curDiags[j] ) {
					if ( lastIncoming ) {
						curDiag.mprev = lastIncoming;
						lastIncoming.mnext = curDiag;
					} else {
						fromVertex = curDiag.vFrom;
						fromVertex.firstOutDiag = curDiag;
					}
					lastIncoming = curDiag.revDiag;
				}
			} while ( j != firstElem );
			if ( lastIncoming )		fromVertex.lastInDiag = lastIncoming;
		}
	},


};


/*==============================================================================
 *
 *============================================================================*/

/** @constructor */
PNLTRI.Trapezoider = function ( inPolygonData ) {

	this.polyData		= inPolygonData;
	this.queryStructure	= new PNLTRI.QueryStructure( this.polyData );

};

PNLTRI.Trapezoider.prototype = {

	constructor: PNLTRI.Trapezoider,


	/*
	 * Mathematics helper methods
	 */

	optimise_randomlist: function ( inOutSegListArray ) {
		// makes sure that the first N segments are one from each of the N polygon chains
		var mainIdx = 0;
		var helpIdx = this.polyData.nbPolyChains();
		if ( helpIdx == 1 )		return;
		var chainMarker = new Array(helpIdx);
		var oldSegListArray = inOutSegListArray.concat();
		for (var i=0; i<oldSegListArray.length; i++) {
			var chainId = oldSegListArray[i].chainId;
			if ( chainMarker[chainId] ) {
				inOutSegListArray[helpIdx++] = oldSegListArray[i];
			} else {
				inOutSegListArray[mainIdx++] = oldSegListArray[i];
				chainMarker[chainId] = true;
			}
		}
	},


	/*
	 * main methods
	 */

	// Creates the trapezoidation of the polygon
	//  and assigns a depth to all trapezoids (odd: inside, even: outside).

	trapezoide_polygon: function () {							// <<<< public
		var randSegListArray = this.polyData.getSegments().concat();
//		console.log( "Polygon Chains: ", dumpSegmentList( randSegListArray ) );
		PNLTRI.Math.array_shuffle( randSegListArray );
		this.optimise_randomlist( randSegListArray );
//		console.log( "Random Segment Sequence: ", dumpRandomSequence( randSegListArray ) );

		var nbSegs = randSegListArray.length;
		var myQs = this.queryStructure;

		var i, current = 0, logstar = nbSegs;
		while ( current < nbSegs ) {
			// The CENTRAL mechanism for the near-linear performance:
			//	stratefies the loop through all segments into log* parts
			//	and computes new root-Nodes for the remaining segments in each
			//	partition.
			logstar = Math.log(logstar)/Math.LN2;		// == log2(logstar)
			var partEnd = ( logstar > 1 ) ? Math.floor( nbSegs / logstar ) : nbSegs;

			// Core: adds next partition of the segments
			for (; current < partEnd; current++ ) { myQs.add_segment( randSegListArray[current] ); }
//			console.log( nbSegs, current );

			// To speed up the segment insertion into the trapezoidation
			//	the endponts of those segments not yet inserted
			//	are repeatedly pre-located,
			// thus their final location-query can start at the top of the
			//	appropriate sub-tree instead of the root of the whole
			//	query structure.
			//
			for (i = current; i < nbSegs; i++) { this.queryStructure.segNodes( randSegListArray[i] ); }
		}

		myQs.assignDepths( this.polyData );
		// cleanup to support garbage collection
		for (i = 0; i < nbSegs; i++) { randSegListArray[i].trLeft = randSegListArray[i].trRight = null; }
	},

	// Creates a visibility map:
	//	for each vertex the list of all vertices in CW order which are directly
	//	visible through neighboring trapezoids and thus can be connected by a diagonal

	create_visibility_map: function () {
		return	this.queryStructure.create_visibility_map( this.polyData );
	},

};

/**
 * @author jahting / http://www.ameco.tv/
 *
 *	Algorithm to split a polygon into uni-y-monotone sub-polygons
 *
 *	1) creates a trapezoidation of the main polygon according to Seidel's
 *	   algorithm [Sei91]
 *	2) uses diagonals of the trapezoids as additional segments
 *		to split the main polygon into uni-y-monotone sub-polygons
 */

/** @constructor */
PNLTRI.MonoSplitter = function ( inPolygonData ) {

	this.polyData = inPolygonData;

	this.trapezoider = null;

};


PNLTRI.MonoSplitter.prototype = {

	constructor: PNLTRI.MonoSplitter,


	monotonate_trapezoids: function () {					// <<<<<<<<<< public
		// Trapezoidation
		this.trapezoider = new PNLTRI.Trapezoider( this.polyData );
		//	=> one triangular trapezoid which lies inside the polygon
		this.trapezoider.trapezoide_polygon();

		// create segments for diagonals
		this.trapezoider.create_visibility_map();
		// create mono chains by inserting diagonals
		this.polyData.create_mono_chains();

		// create UNIQUE monotone sub-polygons
		this.polyData.unique_monotone_chains_max();
	},

};

/**
 * @author jahting / http://www.ameco.tv/
 *
 *	Algorithm to triangulate uni-y-monotone polygons [FoM84]
 *
 *	expects list of doubly linked monoChains, with Y-max as first vertex
 */


/** @constructor */
PNLTRI.MonoTriangulator = function ( inPolygonData ) {

	this.polyData	= inPolygonData;

};


PNLTRI.MonoTriangulator.prototype = {

	constructor: PNLTRI.MonoTriangulator,


	// Pass each uni-y-monotone polygon with start at Y-max for greedy triangulation.

	triangulate_all_polygons: function () {					// <<<<<<<<<< public
		var	normedMonoChains = this.polyData.getMonoSubPolys();
		this.polyData.clearTriangles();
		for ( var i=0; i<normedMonoChains.length; i++ ) {
			// loop through uni-y-monotone chains
			// => monoPosmin is next to monoPosmax (left or right)
			var monoPosmax = normedMonoChains[i];
			var prevMono = monoPosmax.mprev;
			var nextMono = monoPosmax.mnext;

			if ( nextMono.mnext == prevMono ) {		// already a triangle
				this.polyData.addTriangle( monoPosmax.vFrom, nextMono.vFrom, prevMono.vFrom );
			} else {								// triangulate the polygon
				this.triangulate_monotone_polygon( monoPosmax );
			}
		}
	},

	//	algorithm to triangulate an uni-y-monotone polygon in O(n) time.[FoM84]

	triangulate_monotone_polygon: function ( monoPosmax ) {			// private
		var scope = this;

		function error_cleanup() {
			// Error in algorithm OR polygon is not uni-y-monotone
			console.log( "ERR uni-y-monotone: only concave angles left", vertBackLog );
			// push all "wrong" triangles => loop ends
			while (vertBackLogIdx > 1) {
				vertBackLogIdx--;
				scope.polyData.addTriangle(	vertBackLog[vertBackLogIdx-1],
											vertBackLog[vertBackLogIdx],
											vertBackLog[vertBackLogIdx+1] );
			}
		}

		//
		// Decisive for this algorithm to work correctly is to make sure
		//  the polygon stays uni-y-monotone when cutting off ears, i.e.
		//  to make sure the top-most and bottom-most vertices are removed last
		// Usually this is done by handling the LHS-case ("LeftHandSide is a single segment")
		//	and the RHS-case ("RightHandSide segment is a single segment")
		//	differently by starting at the bottom for LHS and at the top for RHS.
		// This is not necessary. It can be seen easily, that starting
		//	from the vertex next to top handles both cases correctly.
		//

		var frontMono = monoPosmax.mnext;		// == LHS: YminPoint; RHS: YmaxPoint.mnext
		var endVert = monoPosmax.vFrom;

		var vertBackLog = [ frontMono.vFrom ];
		var vertBackLogIdx = 0;

		frontMono = frontMono.mnext;
		var frontVert = frontMono.vFrom;

		// check for robustness		// TODO
		if (frontVert == endVert)	return;		// Error: only 2 vertices

		while ( (frontVert != endVert) || (vertBackLogIdx > 1) ) {
			if ( vertBackLogIdx > 0 ) {
				// vertBackLog is not empty
				var insideAngleCCW = PNLTRI.Math.ptsCrossProd( vertBackLog[vertBackLogIdx], frontVert, vertBackLog[vertBackLogIdx-1] );
				if ( Math.abs(insideAngleCCW) <= PNLTRI.Math.EPSILON_P ) {
					// co-linear
					if ( (frontVert == endVert) ||		// all remaining triangles are co-linear (180 degree)
						 ( PNLTRI.Math.compare_pts_yx( vertBackLog[vertBackLogIdx], frontVert ) ==				// co-linear-reversal
						   PNLTRI.Math.compare_pts_yx( vertBackLog[vertBackLogIdx], vertBackLog[vertBackLogIdx-1] ) ) ) {
						insideAngleCCW = 1;		// => create triangle
					}
				}
				if ( insideAngleCCW > 0 ) {
					// convex corner: cut if off
					this.polyData.addTriangle( vertBackLog[vertBackLogIdx-1], vertBackLog[vertBackLogIdx], frontVert );
					vertBackLogIdx--;
				} else {
					// non-convex: add frontVert to the vertBackLog
					vertBackLog[++vertBackLogIdx] = frontVert;
					if (frontVert == endVert)	error_cleanup();	// should never happen !!
					else {
						frontMono = frontMono.mnext;
						frontVert = frontMono.vFrom;
					}
				}
			} else {
				// vertBackLog contains only start vertex:
				//	add frontVert to the vertBackLog and advance frontVert
				vertBackLog[++vertBackLogIdx] = frontVert;
				frontMono = frontMono.mnext;
				frontVert = frontMono.vFrom;
			}
		}
		// reached the last vertex. Add in the triangle formed
		this.polyData.addTriangle( vertBackLog[vertBackLogIdx - 1], vertBackLog[vertBackLogIdx], frontVert );
	},

};

/**
 * @author jahting / http://www.ameco.tv/
 */

/*******************************************************************************
 *
 *	Triangulator for Simple Polygons with Holes
 *
 *  polygon with holes:
 *	- one closed contour polygon chain
 *  - zero or more closed hole polygon chains
 *
 *	polygon chain (closed):
 *	- Array of vertex Objects with attributes "x" and "y"
 *		- representing the sequence of line segments
 *		- closing line segment (last->first vertex) is implied
 *		- line segments are non-zero length and non-crossing
 *
 *	"global vertex index":
 *	- vertex number resulting from concatenation all polygon chains (starts with 0)
 *
 *
 *	Parameters (will not be changed):
 *		inPolygonChains:
 *		- Array of polygon chains
 *
 *	Results (are a fresh copy):
 *		triangulate_polygon:
 *		- Array of Triangles ( Array of 3 "global vertex index" values )
 *
 ******************************************************************************/

/** @constructor */
PNLTRI.Triangulator = function () {

	this.lastPolyData = null;		// for Debug purposes only

};


PNLTRI.Triangulator.prototype = {

	constructor: PNLTRI.Triangulator,


	clear_lastData: function () {	// save memory after Debug
		this.lastPolyData = null;
	},

	// for the polygon data AFTER triangulation
	//	returns an Array of flags, one flag for each polygon chain:
	//		lies the inside of the polygon to the left?
	//		"true" implies CCW for contours and CW for holes
	get_PolyLeftArr: function () {
		if ( this.lastPolyData )	return this.lastPolyData.get_PolyLeftArr();
		return	null;
	},


	triangulate_polygon: function ( inPolygonChains, inForceTrapezoidation ) {

		// collected conditions for selecting EarClipTriangulator over Seidel's algorithm
		function is_basic_polygon() {
			if (inForceTrapezoidation)	return	false;
			return	( myPolygonData.nbPolyChains() == 1 );
		}


		this.clear_lastData();
		if ( ( !inPolygonChains ) || ( inPolygonChains.length === 0 ) )		return	[];
		//
		// initializes general polygon data structure
		//
		var myPolygonData = new PNLTRI.PolygonData( inPolygonChains );
		//
		var basicPolygon = is_basic_polygon();
		var	myTriangulator;
		if ( basicPolygon ) {
			//
			// triangulates single polygon without holes
			//
			myTriangulator = new PNLTRI.EarClipTriangulator( myPolygonData );
			basicPolygon = myTriangulator.triangulate_polygon_no_holes();
		}
		if ( !basicPolygon ) {
			//
			// splits polygon into uni-y-monotone sub-polygons
			//
			var	myMonoSplitter = new PNLTRI.MonoSplitter( myPolygonData );
			myMonoSplitter.monotonate_trapezoids();
			//
			// triangulates all uni-y-monotone sub-polygons
			//
			myTriangulator = new PNLTRI.MonoTriangulator( myPolygonData );
			myTriangulator.triangulate_all_polygons();
		}
		//
		this.lastPolyData = myPolygonData;
		return	myPolygonData.getTriangles();	// copy of triangle list
	}


};


!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.mqtt=t()}}(function(){var t;return function e(t,r,n){function i(s,a){if(!r[s]){if(!t[s]){var u="function"==typeof require&&require;if(!a&&u)return u(s,!0);if(o)return o(s,!0);var c=new Error("Cannot find module '"+s+"'");throw c.code="MODULE_NOT_FOUND",c}var h=r[s]={exports:{}};t[s][0].call(h.exports,function(e){var r=t[s][1][e];return i(r?r:e)},h,h.exports,e,t,r,n)}return r[s].exports}for(var o="function"==typeof require&&require,s=0;s<n.length;s++)i(n[s]);return i}({1:[function(t,e,r){"use strict";function n(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");return"="===t[e-2]?2:"="===t[e-1]?1:0}function i(t){return 3*t.length/4-n(t)}function o(t){var e,r,i,o,s,a=t.length;o=n(t),s=new f(3*a/4-o),r=o>0?a-4:a;var u=0;for(e=0;r>e;e+=4)i=h[t.charCodeAt(e)]<<18|h[t.charCodeAt(e+1)]<<12|h[t.charCodeAt(e+2)]<<6|h[t.charCodeAt(e+3)],s[u++]=i>>16&255,s[u++]=i>>8&255,s[u++]=255&i;return 2===o?(i=h[t.charCodeAt(e)]<<2|h[t.charCodeAt(e+1)]>>4,s[u++]=255&i):1===o&&(i=h[t.charCodeAt(e)]<<10|h[t.charCodeAt(e+1)]<<4|h[t.charCodeAt(e+2)]>>2,s[u++]=i>>8&255,s[u++]=255&i),s}function s(t){return c[t>>18&63]+c[t>>12&63]+c[t>>6&63]+c[63&t]}function a(t,e,r){for(var n,i=[],o=e;r>o;o+=3)n=(t[o]<<16)+(t[o+1]<<8)+t[o+2],i.push(s(n));return i.join("")}function u(t){for(var e,r=t.length,n=r%3,i="",o=[],s=16383,u=0,h=r-n;h>u;u+=s)o.push(a(t,u,u+s>h?h:u+s));return 1===n?(e=t[r-1],i+=c[e>>2],i+=c[e<<4&63],i+="=="):2===n&&(e=(t[r-2]<<8)+t[r-1],i+=c[e>>10],i+=c[e>>4&63],i+=c[e<<2&63],i+="="),o.push(i),o.join("")}r.byteLength=i,r.toByteArray=o,r.fromByteArray=u;for(var c=[],h=[],f="undefined"!=typeof Uint8Array?Uint8Array:Array,l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",p=0,d=l.length;d>p;++p)c[p]=l[p],h[l.charCodeAt(p)]=p;h["-".charCodeAt(0)]=62,h["_".charCodeAt(0)]=63},{}],2:[function(t,e,r){},{}],3:[function(t,e,r){"use strict";function n(){try{var t=new Uint8Array(1);return t.__proto__={__proto__:Uint8Array.prototype,foo:function(){return 42}},42===t.foo()}catch(e){return!1}}function i(t){if(t>Y)throw new RangeError("Invalid typed array length");var e=new Uint8Array(t);return e.__proto__=o.prototype,e}function o(t,e,r){if("number"==typeof t){if("string"==typeof e)throw new Error("If encoding is specified then the first argument must be a string");return c(t)}return s(t,e,r)}function s(t,e,r){if("number"==typeof t)throw new TypeError('"value" argument must not be a number');return Q(t)?l(t,e,r):"string"==typeof t?h(t,e):p(t)}function a(t){if("number"!=typeof t)throw new TypeError('"size" argument must be a number');if(0>t)throw new RangeError('"size" argument must not be negative')}function u(t,e,r){return a(t),0>=t?i(t):void 0!==e?"string"==typeof r?i(t).fill(e,r):i(t).fill(e):i(t)}function c(t){return a(t),i(0>t?0:0|d(t))}function h(t,e){if(("string"!=typeof e||""===e)&&(e="utf8"),!o.isEncoding(e))throw new TypeError('"encoding" must be a valid string encoding');var r=0|b(t,e),n=i(r),s=n.write(t,e);return s!==r&&(n=n.slice(0,s)),n}function f(t){for(var e=t.length<0?0:0|d(t.length),r=i(e),n=0;e>n;n+=1)r[n]=255&t[n];return r}function l(t,e,r){if(0>e||t.byteLength<e)throw new RangeError("'offset' is out of bounds");if(t.byteLength<e+(r||0))throw new RangeError("'length' is out of bounds");var n;return n=void 0===e&&void 0===r?new Uint8Array(t):void 0===r?new Uint8Array(t,e):new Uint8Array(t,e,r),n.__proto__=o.prototype,n}function p(t){if(o.isBuffer(t)){var e=0|d(t.length),r=i(e);return 0===r.length?r:(t.copy(r,0,0,e),r)}if(t){if(V(t)||"length"in t)return"number"!=typeof t.length||G(t.length)?i(0):f(t);if("Buffer"===t.type&&Array.isArray(t.data))return f(t.data)}throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}function d(t){if(t>=Y)throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+Y.toString(16)+" bytes");return 0|t}function g(t){return+t!=t&&(t=0),o.alloc(+t)}function b(t,e){if(o.isBuffer(t))return t.length;if(V(t)||Q(t))return t.byteLength;"string"!=typeof t&&(t=""+t);var r=t.length;if(0===r)return 0;for(var n=!1;;)switch(e){case"ascii":case"latin1":case"binary":return r;case"utf8":case"utf-8":case void 0:return W(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*r;case"hex":return r>>>1;case"base64":return z(t).length;default:if(n)return W(t).length;e=(""+e).toLowerCase(),n=!0}}function m(t,e,r){var n=!1;if((void 0===e||0>e)&&(e=0),e>this.length)return"";if((void 0===r||r>this.length)&&(r=this.length),0>=r)return"";if(r>>>=0,e>>>=0,e>=r)return"";for(t||(t="utf8");;)switch(t){case"hex":return L(this,e,r);case"utf8":case"utf-8":return T(this,e,r);case"ascii":return C(this,e,r);case"latin1":case"binary":return j(this,e,r);case"base64":return A(this,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return O(this,e,r);default:if(n)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),n=!0}}function y(t,e,r){var n=t[e];t[e]=t[r],t[r]=n}function v(t,e,r,n,i){if(0===t.length)return-1;if("string"==typeof r?(n=r,r=0):r>2147483647?r=2147483647:-2147483648>r&&(r=-2147483648),r=+r,G(r)&&(r=i?0:t.length-1),0>r&&(r=t.length+r),r>=t.length){if(i)return-1;r=t.length-1}else if(0>r){if(!i)return-1;r=0}if("string"==typeof e&&(e=o.from(e,n)),o.isBuffer(e))return 0===e.length?-1:_(t,e,r,n,i);if("number"==typeof e)return e=255&e,"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(t,e,r):Uint8Array.prototype.lastIndexOf.call(t,e,r):_(t,[e],r,n,i);throw new TypeError("val must be string, number or Buffer")}function _(t,e,r,n,i){function o(t,e){return 1===s?t[e]:t.readUInt16BE(e*s)}var s=1,a=t.length,u=e.length;if(void 0!==n&&(n=String(n).toLowerCase(),"ucs2"===n||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(t.length<2||e.length<2)return-1;s=2,a/=2,u/=2,r/=2}var c;if(i){var h=-1;for(c=r;a>c;c++)if(o(t,c)===o(e,-1===h?0:c-h)){if(-1===h&&(h=c),c-h+1===u)return h*s}else-1!==h&&(c-=c-h),h=-1}else for(r+u>a&&(r=a-u),c=r;c>=0;c--){for(var f=!0,l=0;u>l;l++)if(o(t,c+l)!==o(e,l)){f=!1;break}if(f)return c}return-1}function w(t,e,r,n){r=Number(r)||0;var i=t.length-r;n?(n=Number(n),n>i&&(n=i)):n=i;var o=e.length;if(o%2!==0)throw new TypeError("Invalid hex string");n>o/2&&(n=o/2);for(var s=0;n>s;++s){var a=parseInt(e.substr(2*s,2),16);if(G(a))return s;t[r+s]=a}return s}function S(t,e,r,n){return K(W(e,t.length-r),t,r,n)}function E(t,e,r,n){return K(F(e),t,r,n)}function k(t,e,r,n){return E(t,e,r,n)}function I(t,e,r,n){return K(z(e),t,r,n)}function x(t,e,r,n){return K(H(e,t.length-r),t,r,n)}function A(t,e,r){return 0===e&&r===t.length?$.fromByteArray(t):$.fromByteArray(t.slice(e,r))}function T(t,e,r){r=Math.min(t.length,r);for(var n=[],i=e;r>i;){var o=t[i],s=null,a=o>239?4:o>223?3:o>191?2:1;if(r>=i+a){var u,c,h,f;switch(a){case 1:128>o&&(s=o);break;case 2:u=t[i+1],128===(192&u)&&(f=(31&o)<<6|63&u,f>127&&(s=f));break;case 3:u=t[i+1],c=t[i+2],128===(192&u)&&128===(192&c)&&(f=(15&o)<<12|(63&u)<<6|63&c,f>2047&&(55296>f||f>57343)&&(s=f));break;case 4:u=t[i+1],c=t[i+2],h=t[i+3],128===(192&u)&&128===(192&c)&&128===(192&h)&&(f=(15&o)<<18|(63&u)<<12|(63&c)<<6|63&h,f>65535&&1114112>f&&(s=f))}}null===s?(s=65533,a=1):s>65535&&(s-=65536,n.push(s>>>10&1023|55296),s=56320|1023&s),n.push(s),i+=a}return M(n)}function M(t){var e=t.length;if(J>=e)return String.fromCharCode.apply(String,t);for(var r="",n=0;e>n;)r+=String.fromCharCode.apply(String,t.slice(n,n+=J));return r}function C(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;r>i;++i)n+=String.fromCharCode(127&t[i]);return n}function j(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;r>i;++i)n+=String.fromCharCode(t[i]);return n}function L(t,e,r){var n=t.length;(!e||0>e)&&(e=0),(!r||0>r||r>n)&&(r=n);for(var i="",o=e;r>o;++o)i+=D(t[o]);return i}function O(t,e,r){for(var n=t.slice(e,r),i="",o=0;o<n.length;o+=2)i+=String.fromCharCode(n[o]+256*n[o+1]);return i}function R(t,e,r){if(t%1!==0||0>t)throw new RangeError("offset is not uint");if(t+e>r)throw new RangeError("Trying to access beyond buffer length")}function U(t,e,r,n,i,s){if(!o.isBuffer(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(e>i||s>e)throw new RangeError('"value" argument is out of bounds');if(r+n>t.length)throw new RangeError("Index out of range")}function B(t,e,r,n,i,o){if(r+n>t.length)throw new RangeError("Index out of range");if(0>r)throw new RangeError("Index out of range")}function N(t,e,r,n,i){return e=+e,r>>>=0,i||B(t,e,r,4,3.4028234663852886e38,-3.4028234663852886e38),Z.write(t,e,r,n,23,4),r+4}function q(t,e,r,n,i){return e=+e,r>>>=0,i||B(t,e,r,8,1.7976931348623157e308,-1.7976931348623157e308),Z.write(t,e,r,n,52,8),r+8}function P(t){if(t=t.trim().replace(X,""),t.length<2)return"";for(;t.length%4!==0;)t+="=";return t}function D(t){return 16>t?"0"+t.toString(16):t.toString(16)}function W(t,e){e=e||1/0;for(var r,n=t.length,i=null,o=[],s=0;n>s;++s){if(r=t.charCodeAt(s),r>55295&&57344>r){if(!i){if(r>56319){(e-=3)>-1&&o.push(239,191,189);continue}if(s+1===n){(e-=3)>-1&&o.push(239,191,189);continue}i=r;continue}if(56320>r){(e-=3)>-1&&o.push(239,191,189),i=r;continue}r=(i-55296<<10|r-56320)+65536}else i&&(e-=3)>-1&&o.push(239,191,189);if(i=null,128>r){if((e-=1)<0)break;o.push(r)}else if(2048>r){if((e-=2)<0)break;o.push(r>>6|192,63&r|128)}else if(65536>r){if((e-=3)<0)break;o.push(r>>12|224,r>>6&63|128,63&r|128)}else{if(!(1114112>r))throw new Error("Invalid code point");if((e-=4)<0)break;o.push(r>>18|240,r>>12&63|128,r>>6&63|128,63&r|128)}}return o}function F(t){for(var e=[],r=0;r<t.length;++r)e.push(255&t.charCodeAt(r));return e}function H(t,e){for(var r,n,i,o=[],s=0;s<t.length&&!((e-=2)<0);++s)r=t.charCodeAt(s),n=r>>8,i=r%256,o.push(i),o.push(n);return o}function z(t){return $.toByteArray(P(t))}function K(t,e,r,n){for(var i=0;n>i&&!(i+r>=e.length||i>=t.length);++i)e[i+r]=t[i];return i}function Q(t){return t instanceof ArrayBuffer||null!=t&&null!=t.constructor&&"ArrayBuffer"===t.constructor.name&&"number"==typeof t.byteLength}function V(t){return"function"==typeof ArrayBuffer.isView&&ArrayBuffer.isView(t)}function G(t){return t!==t}var $=t("base64-js"),Z=t("ieee754");r.Buffer=o,r.SlowBuffer=g,r.INSPECT_MAX_BYTES=50;var Y=2147483647;r.kMaxLength=Y,o.TYPED_ARRAY_SUPPORT=n(),o.TYPED_ARRAY_SUPPORT||"undefined"==typeof console||"function"!=typeof console.error||console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."),"undefined"!=typeof Symbol&&Symbol.species&&o[Symbol.species]===o&&Object.defineProperty(o,Symbol.species,{value:null,configurable:!0,enumerable:!1,writable:!1}),o.poolSize=8192,o.from=function(t,e,r){return s(t,e,r)},o.prototype.__proto__=Uint8Array.prototype,o.__proto__=Uint8Array,o.alloc=function(t,e,r){return u(t,e,r)},o.allocUnsafe=function(t){return c(t)},o.allocUnsafeSlow=function(t){return c(t)},o.isBuffer=function(t){return null!=t&&t._isBuffer===!0},o.compare=function(t,e){if(!o.isBuffer(t)||!o.isBuffer(e))throw new TypeError("Arguments must be Buffers");if(t===e)return 0;for(var r=t.length,n=e.length,i=0,s=Math.min(r,n);s>i;++i)if(t[i]!==e[i]){r=t[i],n=e[i];break}return n>r?-1:r>n?1:0},o.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},o.concat=function(t,e){if(!Array.isArray(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return o.alloc(0);var r;if(void 0===e)for(e=0,r=0;r<t.length;++r)e+=t[r].length;var n=o.allocUnsafe(e),i=0;for(r=0;r<t.length;++r){var s=t[r];if(!o.isBuffer(s))throw new TypeError('"list" argument must be an Array of Buffers');s.copy(n,i),i+=s.length}return n},o.byteLength=b,o.prototype._isBuffer=!0,o.prototype.swap16=function(){var t=this.length;if(t%2!==0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var e=0;t>e;e+=2)y(this,e,e+1);return this},o.prototype.swap32=function(){var t=this.length;if(t%4!==0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var e=0;t>e;e+=4)y(this,e,e+3),y(this,e+1,e+2);return this},o.prototype.swap64=function(){var t=this.length;if(t%8!==0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var e=0;t>e;e+=8)y(this,e,e+7),y(this,e+1,e+6),y(this,e+2,e+5),y(this,e+3,e+4);return this},o.prototype.toString=function(){var t=this.length;return 0===t?"":0===arguments.length?T(this,0,t):m.apply(this,arguments)},o.prototype.equals=function(t){if(!o.isBuffer(t))throw new TypeError("Argument must be a Buffer");return this===t?!0:0===o.compare(this,t)},o.prototype.inspect=function(){var t="",e=r.INSPECT_MAX_BYTES;return this.length>0&&(t=this.toString("hex",0,e).match(/.{2}/g).join(" "),this.length>e&&(t+=" ... ")),"<Buffer "+t+">"},o.prototype.compare=function(t,e,r,n,i){if(!o.isBuffer(t))throw new TypeError("Argument must be a Buffer");if(void 0===e&&(e=0),void 0===r&&(r=t?t.length:0),void 0===n&&(n=0),void 0===i&&(i=this.length),0>e||r>t.length||0>n||i>this.length)throw new RangeError("out of range index");if(n>=i&&e>=r)return 0;if(n>=i)return-1;if(e>=r)return 1;if(e>>>=0,r>>>=0,n>>>=0,i>>>=0,this===t)return 0;for(var s=i-n,a=r-e,u=Math.min(s,a),c=this.slice(n,i),h=t.slice(e,r),f=0;u>f;++f)if(c[f]!==h[f]){s=c[f],a=h[f];break}return a>s?-1:s>a?1:0},o.prototype.includes=function(t,e,r){return-1!==this.indexOf(t,e,r)},o.prototype.indexOf=function(t,e,r){return v(this,t,e,r,!0)},o.prototype.lastIndexOf=function(t,e,r){return v(this,t,e,r,!1)},o.prototype.write=function(t,e,r,n){if(void 0===e)n="utf8",r=this.length,e=0;else if(void 0===r&&"string"==typeof e)n=e,r=this.length,e=0;else{if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e>>>=0,isFinite(r)?(r>>>=0,void 0===n&&(n="utf8")):(n=r,r=void 0)}var i=this.length-e;if((void 0===r||r>i)&&(r=i),t.length>0&&(0>r||0>e)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");n||(n="utf8");for(var o=!1;;)switch(n){case"hex":return w(this,t,e,r);case"utf8":case"utf-8":return S(this,t,e,r);case"ascii":return E(this,t,e,r);case"latin1":case"binary":return k(this,t,e,r);case"base64":return I(this,t,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return x(this,t,e,r);default:if(o)throw new TypeError("Unknown encoding: "+n);n=(""+n).toLowerCase(),o=!0}},o.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var J=4096;o.prototype.slice=function(t,e){var r=this.length;t=~~t,e=void 0===e?r:~~e,0>t?(t+=r,0>t&&(t=0)):t>r&&(t=r),0>e?(e+=r,0>e&&(e=0)):e>r&&(e=r),t>e&&(e=t);var n=this.subarray(t,e);return n.__proto__=o.prototype,n},o.prototype.readUIntLE=function(t,e,r){t>>>=0,e>>>=0,r||R(t,e,this.length);for(var n=this[t],i=1,o=0;++o<e&&(i*=256);)n+=this[t+o]*i;return n},o.prototype.readUIntBE=function(t,e,r){t>>>=0,e>>>=0,r||R(t,e,this.length);for(var n=this[t+--e],i=1;e>0&&(i*=256);)n+=this[t+--e]*i;return n},o.prototype.readUInt8=function(t,e){return t>>>=0,e||R(t,1,this.length),this[t]},o.prototype.readUInt16LE=function(t,e){return t>>>=0,e||R(t,2,this.length),this[t]|this[t+1]<<8},o.prototype.readUInt16BE=function(t,e){return t>>>=0,e||R(t,2,this.length),this[t]<<8|this[t+1]},o.prototype.readUInt32LE=function(t,e){return t>>>=0,e||R(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},o.prototype.readUInt32BE=function(t,e){return t>>>=0,e||R(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},o.prototype.readIntLE=function(t,e,r){t>>>=0,e>>>=0,r||R(t,e,this.length);for(var n=this[t],i=1,o=0;++o<e&&(i*=256);)n+=this[t+o]*i;return i*=128,n>=i&&(n-=Math.pow(2,8*e)),n},o.prototype.readIntBE=function(t,e,r){t>>>=0,e>>>=0,r||R(t,e,this.length);for(var n=e,i=1,o=this[t+--n];n>0&&(i*=256);)o+=this[t+--n]*i;return i*=128,o>=i&&(o-=Math.pow(2,8*e)),o},o.prototype.readInt8=function(t,e){return t>>>=0,e||R(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},o.prototype.readInt16LE=function(t,e){t>>>=0,e||R(t,2,this.length);var r=this[t]|this[t+1]<<8;return 32768&r?4294901760|r:r},o.prototype.readInt16BE=function(t,e){t>>>=0,e||R(t,2,this.length);var r=this[t+1]|this[t]<<8;return 32768&r?4294901760|r:r},o.prototype.readInt32LE=function(t,e){return t>>>=0,e||R(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},o.prototype.readInt32BE=function(t,e){return t>>>=0,e||R(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},o.prototype.readFloatLE=function(t,e){return t>>>=0,e||R(t,4,this.length),Z.read(this,t,!0,23,4)},o.prototype.readFloatBE=function(t,e){return t>>>=0,e||R(t,4,this.length),Z.read(this,t,!1,23,4)},o.prototype.readDoubleLE=function(t,e){return t>>>=0,e||R(t,8,this.length),Z.read(this,t,!0,52,8)},o.prototype.readDoubleBE=function(t,e){return t>>>=0,e||R(t,8,this.length),Z.read(this,t,!1,52,8)},o.prototype.writeUIntLE=function(t,e,r,n){if(t=+t,e>>>=0,r>>>=0,!n){var i=Math.pow(2,8*r)-1;U(this,t,e,r,i,0)}var o=1,s=0;for(this[e]=255&t;++s<r&&(o*=256);)this[e+s]=t/o&255;return e+r},o.prototype.writeUIntBE=function(t,e,r,n){if(t=+t,e>>>=0,r>>>=0,!n){var i=Math.pow(2,8*r)-1;U(this,t,e,r,i,0)}var o=r-1,s=1;for(this[e+o]=255&t;--o>=0&&(s*=256);)this[e+o]=t/s&255;return e+r},o.prototype.writeUInt8=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,1,255,0),this[e]=255&t,e+1},o.prototype.writeUInt16LE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,2,65535,0),this[e]=255&t,this[e+1]=t>>>8,e+2},o.prototype.writeUInt16BE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,2,65535,0),this[e]=t>>>8,this[e+1]=255&t,e+2},o.prototype.writeUInt32LE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,4,4294967295,0),this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t,e+4},o.prototype.writeUInt32BE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,4,4294967295,0),this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t,e+4},o.prototype.writeIntLE=function(t,e,r,n){if(t=+t,e>>>=0,!n){var i=Math.pow(2,8*r-1);U(this,t,e,r,i-1,-i)}var o=0,s=1,a=0;for(this[e]=255&t;++o<r&&(s*=256);)0>t&&0===a&&0!==this[e+o-1]&&(a=1),this[e+o]=(t/s>>0)-a&255;return e+r},o.prototype.writeIntBE=function(t,e,r,n){if(t=+t,e>>>=0,!n){var i=Math.pow(2,8*r-1);U(this,t,e,r,i-1,-i)}var o=r-1,s=1,a=0;for(this[e+o]=255&t;--o>=0&&(s*=256);)0>t&&0===a&&0!==this[e+o+1]&&(a=1),this[e+o]=(t/s>>0)-a&255;return e+r},o.prototype.writeInt8=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,1,127,-128),0>t&&(t=255+t+1),this[e]=255&t,e+1},o.prototype.writeInt16LE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,2,32767,-32768),this[e]=255&t,this[e+1]=t>>>8,e+2},o.prototype.writeInt16BE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,2,32767,-32768),this[e]=t>>>8,this[e+1]=255&t,e+2},o.prototype.writeInt32LE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,4,2147483647,-2147483648),this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24,e+4},o.prototype.writeInt32BE=function(t,e,r){return t=+t,e>>>=0,r||U(this,t,e,4,2147483647,-2147483648),0>t&&(t=4294967295+t+1),this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t,e+4},o.prototype.writeFloatLE=function(t,e,r){return N(this,t,e,!0,r)},o.prototype.writeFloatBE=function(t,e,r){return N(this,t,e,!1,r)},o.prototype.writeDoubleLE=function(t,e,r){return q(this,t,e,!0,r)},o.prototype.writeDoubleBE=function(t,e,r){return q(this,t,e,!1,r)},o.prototype.copy=function(t,e,r,n){if(r||(r=0),n||0===n||(n=this.length),e>=t.length&&(e=t.length),e||(e=0),n>0&&r>n&&(n=r),n===r)return 0;if(0===t.length||0===this.length)return 0;if(0>e)throw new RangeError("targetStart out of bounds");if(0>r||r>=this.length)throw new RangeError("sourceStart out of bounds");if(0>n)throw new RangeError("sourceEnd out of bounds");n>this.length&&(n=this.length),t.length-e<n-r&&(n=t.length-e+r);var i,o=n-r;if(this===t&&e>r&&n>e)for(i=o-1;i>=0;--i)t[i+e]=this[i+r];else if(1e3>o)for(i=0;o>i;++i)t[i+e]=this[i+r];else Uint8Array.prototype.set.call(t,this.subarray(r,r+o),e);return o},o.prototype.fill=function(t,e,r,n){if("string"==typeof t){if("string"==typeof e?(n=e,e=0,r=this.length):"string"==typeof r&&(n=r,r=this.length),1===t.length){var i=t.charCodeAt(0);256>i&&(t=i)}if(void 0!==n&&"string"!=typeof n)throw new TypeError("encoding must be a string");if("string"==typeof n&&!o.isEncoding(n))throw new TypeError("Unknown encoding: "+n)}else"number"==typeof t&&(t=255&t);if(0>e||this.length<e||this.length<r)throw new RangeError("Out of range index");if(e>=r)return this;e>>>=0,r=void 0===r?this.length:r>>>0,t||(t=0);var s;if("number"==typeof t)for(s=e;r>s;++s)this[s]=t;else{var a=o.isBuffer(t)?t:new o(t,n),u=a.length;for(s=0;r-e>s;++s)this[s+e]=a[s%u]}return this};var X=/[^+\/0-9A-Za-z-_]/g},{"base64-js":1,ieee754:5}],4:[function(t,e,r){function n(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function i(t){return"function"==typeof t}function o(t){return"number"==typeof t}function s(t){return"object"==typeof t&&null!==t}function a(t){return void 0===t}e.exports=n,n.EventEmitter=n,n.prototype._events=void 0,n.prototype._maxListeners=void 0,n.defaultMaxListeners=10,n.prototype.setMaxListeners=function(t){if(!o(t)||0>t||isNaN(t))throw TypeError("n must be a positive number");return this._maxListeners=t,this},n.prototype.emit=function(t){var e,r,n,o,u,c;if(this._events||(this._events={}),"error"===t&&(!this._events.error||s(this._events.error)&&!this._events.error.length)){if(e=arguments[1],e instanceof Error)throw e;var h=new Error('Uncaught, unspecified "error" event. ('+e+")");throw h.context=e,h}if(r=this._events[t],a(r))return!1;if(i(r))switch(arguments.length){case 1:r.call(this);break;case 2:r.call(this,arguments[1]);break;case 3:r.call(this,arguments[1],arguments[2]);break;default:o=Array.prototype.slice.call(arguments,1),r.apply(this,o)}else if(s(r))for(o=Array.prototype.slice.call(arguments,1),c=r.slice(),n=c.length,u=0;n>u;u++)c[u].apply(this,o);return!0},n.prototype.addListener=function(t,e){var r;if(!i(e))throw TypeError("listener must be a function");return this._events||(this._events={}),this._events.newListener&&this.emit("newListener",t,i(e.listener)?e.listener:e),this._events[t]?s(this._events[t])?this._events[t].push(e):this._events[t]=[this._events[t],e]:this._events[t]=e,s(this._events[t])&&!this._events[t].warned&&(r=a(this._maxListeners)?n.defaultMaxListeners:this._maxListeners,r&&r>0&&this._events[t].length>r&&(this._events[t].warned=!0,console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[t].length),"function"==typeof console.trace&&console.trace())),this},n.prototype.on=n.prototype.addListener,n.prototype.once=function(t,e){function r(){this.removeListener(t,r),n||(n=!0,e.apply(this,arguments))}if(!i(e))throw TypeError("listener must be a function");var n=!1;return r.listener=e,this.on(t,r),this},n.prototype.removeListener=function(t,e){var r,n,o,a;if(!i(e))throw TypeError("listener must be a function");if(!this._events||!this._events[t])return this;if(r=this._events[t],o=r.length,n=-1,r===e||i(r.listener)&&r.listener===e)delete this._events[t],this._events.removeListener&&this.emit("removeListener",t,e);else if(s(r)){for(a=o;a-->0;)if(r[a]===e||r[a].listener&&r[a].listener===e){n=a;break}if(0>n)return this;1===r.length?(r.length=0,delete this._events[t]):r.splice(n,1),this._events.removeListener&&this.emit("removeListener",t,e)}return this},n.prototype.removeAllListeners=function(t){var e,r;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[t]&&delete this._events[t],this;if(0===arguments.length){for(e in this._events)"removeListener"!==e&&this.removeAllListeners(e);return this.removeAllListeners("removeListener"),this._events={},this}if(r=this._events[t],i(r))this.removeListener(t,r);else if(r)for(;r.length;)this.removeListener(t,r[r.length-1]);return delete this._events[t],this},n.prototype.listeners=function(t){var e;return e=this._events&&this._events[t]?i(this._events[t])?[this._events[t]]:this._events[t].slice():[]},n.prototype.listenerCount=function(t){if(this._events){var e=this._events[t];if(i(e))return 1;if(e)return e.length}return 0},n.listenerCount=function(t,e){return t.listenerCount(e)}},{}],5:[function(t,e,r){r.read=function(t,e,r,n,i){var o,s,a=8*i-n-1,u=(1<<a)-1,c=u>>1,h=-7,f=r?i-1:0,l=r?-1:1,p=t[e+f];for(f+=l,o=p&(1<<-h)-1,p>>=-h,h+=a;h>0;o=256*o+t[e+f],f+=l,h-=8);for(s=o&(1<<-h)-1,o>>=-h,h+=n;h>0;s=256*s+t[e+f],f+=l,h-=8);if(0===o)o=1-c;else{if(o===u)return s?NaN:(p?-1:1)*(1/0);s+=Math.pow(2,n),o-=c}return(p?-1:1)*s*Math.pow(2,o-n)},r.write=function(t,e,r,n,i,o){var s,a,u,c=8*o-i-1,h=(1<<c)-1,f=h>>1,l=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,p=n?0:o-1,d=n?1:-1,g=0>e||0===e&&0>1/e?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(a=isNaN(e)?1:0,s=h):(s=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-s))<1&&(s--,u*=2),e+=s+f>=1?l/u:l*Math.pow(2,1-f),e*u>=2&&(s++,u/=2),s+f>=h?(a=0,s=h):s+f>=1?(a=(e*u-1)*Math.pow(2,i),s+=f):(a=e*Math.pow(2,f-1)*Math.pow(2,i),s=0));i>=8;t[r+p]=255&a,p+=d,a/=256,i-=8);for(s=s<<i|a,c+=i;c>0;t[r+p]=255&s,p+=d,s/=256,c-=8);t[r+p-d]|=128*g}},{}],6:[function(t,e,r){function n(t){return!!t.constructor&&"function"==typeof t.constructor.isBuffer&&t.constructor.isBuffer(t)}function i(t){return"function"==typeof t.readFloatLE&&"function"==typeof t.slice&&n(t.slice(0,0))}e.exports=function(t){return null!=t&&(n(t)||i(t)||!!t._isBuffer)}},{}],7:[function(t,e,r){function n(){throw new Error("setTimeout has not been defined")}function i(){throw new Error("clearTimeout has not been defined")}function o(t){if(f===setTimeout)return setTimeout(t,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(t,0);try{return f(t,0)}catch(e){try{return f.call(null,t,0)}catch(e){return f.call(this,t,0)}}}function s(t){if(l===clearTimeout)return clearTimeout(t);if((l===i||!l)&&clearTimeout)return l=clearTimeout,clearTimeout(t);try{return l(t)}catch(e){try{return l.call(null,t)}catch(e){return l.call(this,t)}}}function a(){b&&d&&(b=!1,d.length?g=d.concat(g):m=-1,g.length&&u())}function u(){if(!b){var t=o(a);b=!0;for(var e=g.length;e;){for(d=g,g=[];++m<e;)d&&d[m].run();m=-1,e=g.length}d=null,b=!1,s(t)}}function c(t,e){this.fun=t,this.array=e}function h(){}var f,l,p=e.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:n}catch(t){f=n}try{l="function"==typeof clearTimeout?clearTimeout:i}catch(t){l=i}}();var d,g=[],b=!1,m=-1;p.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var r=1;r<arguments.length;r++)e[r-1]=arguments[r];g.push(new c(t,e)),1!==g.length||b||o(u)},c.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=h,p.addListener=h,p.once=h,p.off=h,p.removeListener=h,p.removeAllListeners=h,p.emit=h,p.prependListener=h,p.prependOnceListener=h,p.listeners=function(t){return[]},p.binding=function(t){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(t){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},{}],8:[function(e,r,n){(function(e){!function(i){function o(t){throw new RangeError(R[t])}function s(t,e){for(var r=t.length,n=[];r--;)n[r]=e(t[r]);return n}function a(t,e){var r=t.split("@"),n="";r.length>1&&(n=r[0]+"@",t=r[1]),t=t.replace(O,".");var i=t.split("."),o=s(i,e).join(".");return n+o}function u(t){for(var e,r,n=[],i=0,o=t.length;o>i;)e=t.charCodeAt(i++),e>=55296&&56319>=e&&o>i?(r=t.charCodeAt(i++),56320==(64512&r)?n.push(((1023&e)<<10)+(1023&r)+65536):(n.push(e),i--)):n.push(e);return n}function c(t){return s(t,function(t){var e="";return t>65535&&(t-=65536,e+=N(t>>>10&1023|55296),t=56320|1023&t),e+=N(t)}).join("")}function h(t){return 10>t-48?t-22:26>t-65?t-65:26>t-97?t-97:E}function f(t,e){return t+22+75*(26>t)-((0!=e)<<5)}function l(t,e,r){var n=0;for(t=r?B(t/A):t>>1,t+=B(t/e);t>U*I>>1;n+=E)t=B(t/U);return B(n+(U+1)*t/(t+x))}function p(t){var e,r,n,i,s,a,u,f,p,d,g=[],b=t.length,m=0,y=M,v=T;for(r=t.lastIndexOf(C),0>r&&(r=0),n=0;r>n;++n)t.charCodeAt(n)>=128&&o("not-basic"),g.push(t.charCodeAt(n));for(i=r>0?r+1:0;b>i;){for(s=m,a=1,u=E;i>=b&&o("invalid-input"),f=h(t.charCodeAt(i++)),(f>=E||f>B((S-m)/a))&&o("overflow"),m+=f*a,p=v>=u?k:u>=v+I?I:u-v,!(p>f);u+=E)d=E-p,a>B(S/d)&&o("overflow"),a*=d;e=g.length+1,v=l(m-s,e,0==s),B(m/e)>S-y&&o("overflow"),y+=B(m/e),m%=e,g.splice(m++,0,y)}return c(g)}function d(t){var e,r,n,i,s,a,c,h,p,d,g,b,m,y,v,_=[];for(t=u(t),b=t.length,e=M,r=0,s=T,a=0;b>a;++a)g=t[a],128>g&&_.push(N(g));for(n=i=_.length,i&&_.push(C);b>n;){for(c=S,a=0;b>a;++a)g=t[a],g>=e&&c>g&&(c=g);for(m=n+1,c-e>B((S-r)/m)&&o("overflow"),r+=(c-e)*m,e=c,a=0;b>a;++a)if(g=t[a],e>g&&++r>S&&o("overflow"),g==e){for(h=r,p=E;d=s>=p?k:p>=s+I?I:p-s,!(d>h);p+=E)v=h-d,y=E-d,_.push(N(f(d+v%y,0))),h=B(v/y);_.push(N(f(h,0))),s=l(r,m,n==i),r=0,++n}++r,++e}return _.join("")}function g(t){return a(t,function(t){return j.test(t)?p(t.slice(4).toLowerCase()):t})}function b(t){return a(t,function(t){return L.test(t)?"xn--"+d(t):t})}var m="object"==typeof n&&n&&!n.nodeType&&n,y="object"==typeof r&&r&&!r.nodeType&&r,v="object"==typeof e&&e;(v.global===v||v.window===v||v.self===v)&&(i=v);var _,w,S=2147483647,E=36,k=1,I=26,x=38,A=700,T=72,M=128,C="-",j=/^xn--/,L=/[^\x20-\x7E]/,O=/[\x2E\u3002\uFF0E\uFF61]/g,R={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},U=E-k,B=Math.floor,N=String.fromCharCode;if(_={version:"1.4.1",ucs2:{decode:u,encode:c},decode:p,encode:d,toASCII:b,toUnicode:g},"function"==typeof t&&"object"==typeof t.amd&&t.amd)t("punycode",function(){return _});else if(m&&y)if(r.exports==m)y.exports=_;else for(w in _)_.hasOwnProperty(w)&&(m[w]=_[w]);else i.punycode=_}(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],9:[function(t,e,r){"use strict";function n(t,e){return Object.prototype.hasOwnProperty.call(t,e)}e.exports=function(t,e,r,o){e=e||"&",r=r||"=";var s={};if("string"!=typeof t||0===t.length)return s;var a=/\+/g;t=t.split(e);var u=1e3;o&&"number"==typeof o.maxKeys&&(u=o.maxKeys);var c=t.length;u>0&&c>u&&(c=u);for(var h=0;c>h;++h){var f,l,p,d,g=t[h].replace(a,"%20"),b=g.indexOf(r);b>=0?(f=g.substr(0,b),l=g.substr(b+1)):(f=g,l=""),p=decodeURIComponent(f),d=decodeURIComponent(l),n(s,p)?i(s[p])?s[p].push(d):s[p]=[s[p],d]:s[p]=d}return s};var i=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)}},{}],10:[function(t,e,r){"use strict";function n(t,e){if(t.map)return t.map(e);for(var r=[],n=0;n<t.length;n++)r.push(e(t[n],n));return r}var i=function(t){switch(typeof t){case"string":return t;case"boolean":return t?"true":"false";case"number":return isFinite(t)?t:"";default:return""}};e.exports=function(t,e,r,a){return e=e||"&",r=r||"=",null===t&&(t=void 0),"object"==typeof t?n(s(t),function(s){var a=encodeURIComponent(i(s))+r;return o(t[s])?n(t[s],function(t){return a+encodeURIComponent(i(t))}).join(e):a+encodeURIComponent(i(t[s]))}).join(e):a?encodeURIComponent(i(a))+r+encodeURIComponent(i(t)):""};var o=Array.isArray||function(t){return"[object Array]"===Object.prototype.toString.call(t)},s=Object.keys||function(t){var e=[];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&e.push(r);return e}},{}],11:[function(t,e,r){"use strict";r.decode=r.parse=t("./decode"),r.encode=r.stringify=t("./encode")},{"./decode":9,"./encode":10}],12:[function(t,e,r){"use strict";function n(){
this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}function i(t,e,r){if(t&&c.isObject(t)&&t instanceof n)return t;var i=new n;return i.parse(t,e,r),i}function o(t){return c.isString(t)&&(t=i(t)),t instanceof n?t.format():n.prototype.format.call(t)}function s(t,e){return i(t,!1,!0).resolve(e)}function a(t,e){return t?i(t,!1,!0).resolveObject(e):e}var u=t("punycode"),c=t("./util");r.parse=i,r.resolve=s,r.resolveObject=a,r.format=o,r.Url=n;var h=/^([a-z0-9.+-]+:)/i,f=/:[0-9]*$/,l=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,p=["<",">",'"',"`"," ","\r","\n","	"],d=["{","}","|","\\","^","`"].concat(p),g=["'"].concat(d),b=["%","/","?",";","#"].concat(g),m=["/","?","#"],y=255,v=/^[+a-z0-9A-Z_-]{0,63}$/,_=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,w={javascript:!0,"javascript:":!0},S={javascript:!0,"javascript:":!0},E={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},k=t("querystring");n.prototype.parse=function(t,e,r){if(!c.isString(t))throw new TypeError("Parameter 'url' must be a string, not "+typeof t);var n=t.indexOf("?"),i=-1!==n&&n<t.indexOf("#")?"?":"#",o=t.split(i),s=/\\/g;o[0]=o[0].replace(s,"/"),t=o.join(i);var a=t;if(a=a.trim(),!r&&1===t.split("#").length){var f=l.exec(a);if(f)return this.path=a,this.href=a,this.pathname=f[1],f[2]?(this.search=f[2],e?this.query=k.parse(this.search.substr(1)):this.query=this.search.substr(1)):e&&(this.search="",this.query={}),this}var p=h.exec(a);if(p){p=p[0];var d=p.toLowerCase();this.protocol=d,a=a.substr(p.length)}if(r||p||a.match(/^\/\/[^@\/]+@[^@\/]+/)){var I="//"===a.substr(0,2);!I||p&&S[p]||(a=a.substr(2),this.slashes=!0)}if(!S[p]&&(I||p&&!E[p])){for(var x=-1,A=0;A<m.length;A++){var T=a.indexOf(m[A]);-1!==T&&(-1===x||x>T)&&(x=T)}var M,C;C=-1===x?a.lastIndexOf("@"):a.lastIndexOf("@",x),-1!==C&&(M=a.slice(0,C),a=a.slice(C+1),this.auth=decodeURIComponent(M)),x=-1;for(var A=0;A<b.length;A++){var T=a.indexOf(b[A]);-1!==T&&(-1===x||x>T)&&(x=T)}-1===x&&(x=a.length),this.host=a.slice(0,x),a=a.slice(x),this.parseHost(),this.hostname=this.hostname||"";var j="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!j)for(var L=this.hostname.split(/\./),A=0,O=L.length;O>A;A++){var R=L[A];if(R&&!R.match(v)){for(var U="",B=0,N=R.length;N>B;B++)U+=R.charCodeAt(B)>127?"x":R[B];if(!U.match(v)){var q=L.slice(0,A),P=L.slice(A+1),D=R.match(_);D&&(q.push(D[1]),P.unshift(D[2])),P.length&&(a="/"+P.join(".")+a),this.hostname=q.join(".");break}}}this.hostname.length>y?this.hostname="":this.hostname=this.hostname.toLowerCase(),j||(this.hostname=u.toASCII(this.hostname));var W=this.port?":"+this.port:"",F=this.hostname||"";this.host=F+W,this.href+=this.host,j&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==a[0]&&(a="/"+a))}if(!w[d])for(var A=0,O=g.length;O>A;A++){var H=g[A];if(-1!==a.indexOf(H)){var z=encodeURIComponent(H);z===H&&(z=escape(H)),a=a.split(H).join(z)}}var K=a.indexOf("#");-1!==K&&(this.hash=a.substr(K),a=a.slice(0,K));var Q=a.indexOf("?");if(-1!==Q?(this.search=a.substr(Q),this.query=a.substr(Q+1),e&&(this.query=k.parse(this.query)),a=a.slice(0,Q)):e&&(this.search="",this.query={}),a&&(this.pathname=a),E[d]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){var W=this.pathname||"",V=this.search||"";this.path=W+V}return this.href=this.format(),this},n.prototype.format=function(){var t=this.auth||"";t&&(t=encodeURIComponent(t),t=t.replace(/%3A/i,":"),t+="@");var e=this.protocol||"",r=this.pathname||"",n=this.hash||"",i=!1,o="";this.host?i=t+this.host:this.hostname&&(i=t+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(i+=":"+this.port)),this.query&&c.isObject(this.query)&&Object.keys(this.query).length&&(o=k.stringify(this.query));var s=this.search||o&&"?"+o||"";return e&&":"!==e.substr(-1)&&(e+=":"),this.slashes||(!e||E[e])&&i!==!1?(i="//"+(i||""),r&&"/"!==r.charAt(0)&&(r="/"+r)):i||(i=""),n&&"#"!==n.charAt(0)&&(n="#"+n),s&&"?"!==s.charAt(0)&&(s="?"+s),r=r.replace(/[?#]/g,function(t){return encodeURIComponent(t)}),s=s.replace("#","%23"),e+i+r+s+n},n.prototype.resolve=function(t){return this.resolveObject(i(t,!1,!0)).format()},n.prototype.resolveObject=function(t){if(c.isString(t)){var e=new n;e.parse(t,!1,!0),t=e}for(var r=new n,i=Object.keys(this),o=0;o<i.length;o++){var s=i[o];r[s]=this[s]}if(r.hash=t.hash,""===t.href)return r.href=r.format(),r;if(t.slashes&&!t.protocol){for(var a=Object.keys(t),u=0;u<a.length;u++){var h=a[u];"protocol"!==h&&(r[h]=t[h])}return E[r.protocol]&&r.hostname&&!r.pathname&&(r.path=r.pathname="/"),r.href=r.format(),r}if(t.protocol&&t.protocol!==r.protocol){if(!E[t.protocol]){for(var f=Object.keys(t),l=0;l<f.length;l++){var p=f[l];r[p]=t[p]}return r.href=r.format(),r}if(r.protocol=t.protocol,t.host||S[t.protocol])r.pathname=t.pathname;else{for(var d=(t.pathname||"").split("/");d.length&&!(t.host=d.shift()););t.host||(t.host=""),t.hostname||(t.hostname=""),""!==d[0]&&d.unshift(""),d.length<2&&d.unshift(""),r.pathname=d.join("/")}if(r.search=t.search,r.query=t.query,r.host=t.host||"",r.auth=t.auth,r.hostname=t.hostname||t.host,r.port=t.port,r.pathname||r.search){var g=r.pathname||"",b=r.search||"";r.path=g+b}return r.slashes=r.slashes||t.slashes,r.href=r.format(),r}var m=r.pathname&&"/"===r.pathname.charAt(0),y=t.host||t.pathname&&"/"===t.pathname.charAt(0),v=y||m||r.host&&t.pathname,_=v,w=r.pathname&&r.pathname.split("/")||[],d=t.pathname&&t.pathname.split("/")||[],k=r.protocol&&!E[r.protocol];if(k&&(r.hostname="",r.port=null,r.host&&(""===w[0]?w[0]=r.host:w.unshift(r.host)),r.host="",t.protocol&&(t.hostname=null,t.port=null,t.host&&(""===d[0]?d[0]=t.host:d.unshift(t.host)),t.host=null),v=v&&(""===d[0]||""===w[0])),y)r.host=t.host||""===t.host?t.host:r.host,r.hostname=t.hostname||""===t.hostname?t.hostname:r.hostname,r.search=t.search,r.query=t.query,w=d;else if(d.length)w||(w=[]),w.pop(),w=w.concat(d),r.search=t.search,r.query=t.query;else if(!c.isNullOrUndefined(t.search)){if(k){r.hostname=r.host=w.shift();var I=r.host&&r.host.indexOf("@")>0?r.host.split("@"):!1;I&&(r.auth=I.shift(),r.host=r.hostname=I.shift())}return r.search=t.search,r.query=t.query,c.isNull(r.pathname)&&c.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.href=r.format(),r}if(!w.length)return r.pathname=null,r.search?r.path="/"+r.search:r.path=null,r.href=r.format(),r;for(var x=w.slice(-1)[0],A=(r.host||t.host||w.length>1)&&("."===x||".."===x)||""===x,T=0,M=w.length;M>=0;M--)x=w[M],"."===x?w.splice(M,1):".."===x?(w.splice(M,1),T++):T&&(w.splice(M,1),T--);if(!v&&!_)for(;T--;T)w.unshift("..");!v||""===w[0]||w[0]&&"/"===w[0].charAt(0)||w.unshift(""),A&&"/"!==w.join("/").substr(-1)&&w.push("");var C=""===w[0]||w[0]&&"/"===w[0].charAt(0);if(k){r.hostname=r.host=C?"":w.length?w.shift():"";var I=r.host&&r.host.indexOf("@")>0?r.host.split("@"):!1;I&&(r.auth=I.shift(),r.host=r.hostname=I.shift())}return v=v||r.host&&w.length,v&&!C&&w.unshift(""),w.length?r.pathname=w.join("/"):(r.pathname=null,r.path=null),c.isNull(r.pathname)&&c.isNull(r.search)||(r.path=(r.pathname?r.pathname:"")+(r.search?r.search:"")),r.auth=t.auth||r.auth,r.slashes=r.slashes||t.slashes,r.href=r.format(),r},n.prototype.parseHost=function(){var t=this.host,e=f.exec(t);e&&(e=e[0],":"!==e&&(this.port=e.substr(1)),t=t.substr(0,t.length-e.length)),t&&(this.hostname=t)}},{"./util":13,punycode:8,querystring:11}],13:[function(t,e,r){"use strict";e.exports={isString:function(t){return"string"==typeof t},isObject:function(t){return"object"==typeof t&&null!==t},isNull:function(t){return null===t},isNullOrUndefined:function(t){return null==t}}},{}],14:[function(t,e,r){"function"==typeof Object.create?e.exports=function(t,e){t.super_=e,t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}})}:e.exports=function(t,e){t.super_=e;var r=function(){};r.prototype=e.prototype,t.prototype=new r,t.prototype.constructor=t}},{}],15:[function(t,e,r){e.exports=function(t){return t&&"object"==typeof t&&"function"==typeof t.copy&&"function"==typeof t.fill&&"function"==typeof t.readUInt8}},{}],16:[function(t,e,r){(function(e,n){function i(t,e){var n={seen:[],stylize:s};return arguments.length>=3&&(n.depth=arguments[2]),arguments.length>=4&&(n.colors=arguments[3]),g(e)?n.showHidden=e:e&&r._extend(n,e),w(n.showHidden)&&(n.showHidden=!1),w(n.depth)&&(n.depth=2),w(n.colors)&&(n.colors=!1),w(n.customInspect)&&(n.customInspect=!0),n.colors&&(n.stylize=o),u(n,t,n.depth)}function o(t,e){var r=i.styles[e];return r?"["+i.colors[r][0]+"m"+t+"["+i.colors[r][1]+"m":t}function s(t,e){return t}function a(t){var e={};return t.forEach(function(t,r){e[t]=!0}),e}function u(t,e,n){if(t.customInspect&&e&&x(e.inspect)&&e.inspect!==r.inspect&&(!e.constructor||e.constructor.prototype!==e)){var i=e.inspect(n,t);return v(i)||(i=u(t,i,n)),i}var o=c(t,e);if(o)return o;var s=Object.keys(e),g=a(s);if(t.showHidden&&(s=Object.getOwnPropertyNames(e)),I(e)&&(s.indexOf("message")>=0||s.indexOf("description")>=0))return h(e);if(0===s.length){if(x(e)){var b=e.name?": "+e.name:"";return t.stylize("[Function"+b+"]","special")}if(S(e))return t.stylize(RegExp.prototype.toString.call(e),"regexp");if(k(e))return t.stylize(Date.prototype.toString.call(e),"date");if(I(e))return h(e)}var m="",y=!1,_=["{","}"];if(d(e)&&(y=!0,_=["[","]"]),x(e)){var w=e.name?": "+e.name:"";m=" [Function"+w+"]"}if(S(e)&&(m=" "+RegExp.prototype.toString.call(e)),k(e)&&(m=" "+Date.prototype.toUTCString.call(e)),I(e)&&(m=" "+h(e)),0===s.length&&(!y||0==e.length))return _[0]+m+_[1];if(0>n)return S(e)?t.stylize(RegExp.prototype.toString.call(e),"regexp"):t.stylize("[Object]","special");t.seen.push(e);var E;return E=y?f(t,e,n,g,s):s.map(function(r){return l(t,e,n,g,r,y)}),t.seen.pop(),p(E,m,_)}function c(t,e){if(w(e))return t.stylize("undefined","undefined");if(v(e)){var r="'"+JSON.stringify(e).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return t.stylize(r,"string")}return y(e)?t.stylize(""+e,"number"):g(e)?t.stylize(""+e,"boolean"):b(e)?t.stylize("null","null"):void 0}function h(t){return"["+Error.prototype.toString.call(t)+"]"}function f(t,e,r,n,i){for(var o=[],s=0,a=e.length;a>s;++s)j(e,String(s))?o.push(l(t,e,r,n,String(s),!0)):o.push("");return i.forEach(function(i){i.match(/^\d+$/)||o.push(l(t,e,r,n,i,!0))}),o}function l(t,e,r,n,i,o){var s,a,c;if(c=Object.getOwnPropertyDescriptor(e,i)||{value:e[i]},c.get?a=c.set?t.stylize("[Getter/Setter]","special"):t.stylize("[Getter]","special"):c.set&&(a=t.stylize("[Setter]","special")),j(n,i)||(s="["+i+"]"),a||(t.seen.indexOf(c.value)<0?(a=b(r)?u(t,c.value,null):u(t,c.value,r-1),a.indexOf("\n")>-1&&(a=o?a.split("\n").map(function(t){return"  "+t}).join("\n").substr(2):"\n"+a.split("\n").map(function(t){return"   "+t}).join("\n"))):a=t.stylize("[Circular]","special")),w(s)){if(o&&i.match(/^\d+$/))return a;s=JSON.stringify(""+i),s.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)?(s=s.substr(1,s.length-2),s=t.stylize(s,"name")):(s=s.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'"),s=t.stylize(s,"string"))}return s+": "+a}function p(t,e,r){var n=0,i=t.reduce(function(t,e){return n++,e.indexOf("\n")>=0&&n++,t+e.replace(/\u001b\[\d\d?m/g,"").length+1},0);return i>60?r[0]+(""===e?"":e+"\n ")+" "+t.join(",\n  ")+" "+r[1]:r[0]+e+" "+t.join(", ")+" "+r[1]}function d(t){return Array.isArray(t)}function g(t){return"boolean"==typeof t}function b(t){return null===t}function m(t){return null==t}function y(t){return"number"==typeof t}function v(t){return"string"==typeof t}function _(t){return"symbol"==typeof t}function w(t){return void 0===t}function S(t){return E(t)&&"[object RegExp]"===T(t)}function E(t){return"object"==typeof t&&null!==t}function k(t){return E(t)&&"[object Date]"===T(t)}function I(t){return E(t)&&("[object Error]"===T(t)||t instanceof Error)}function x(t){return"function"==typeof t}function A(t){return null===t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||"symbol"==typeof t||"undefined"==typeof t}function T(t){return Object.prototype.toString.call(t)}function M(t){return 10>t?"0"+t.toString(10):t.toString(10)}function C(){var t=new Date,e=[M(t.getHours()),M(t.getMinutes()),M(t.getSeconds())].join(":");return[t.getDate(),U[t.getMonth()],e].join(" ")}function j(t,e){return Object.prototype.hasOwnProperty.call(t,e)}var L=/%[sdj%]/g;r.format=function(t){if(!v(t)){for(var e=[],r=0;r<arguments.length;r++)e.push(i(arguments[r]));return e.join(" ")}for(var r=1,n=arguments,o=n.length,s=String(t).replace(L,function(t){if("%%"===t)return"%";if(r>=o)return t;switch(t){case"%s":return String(n[r++]);case"%d":return Number(n[r++]);case"%j":try{return JSON.stringify(n[r++])}catch(e){return"[Circular]"}default:return t}}),a=n[r];o>r;a=n[++r])s+=b(a)||!E(a)?" "+a:" "+i(a);return s},r.deprecate=function(t,i){function o(){if(!s){if(e.throwDeprecation)throw new Error(i);e.traceDeprecation?console.trace(i):console.error(i),s=!0}return t.apply(this,arguments)}if(w(n.process))return function(){return r.deprecate(t,i).apply(this,arguments)};if(e.noDeprecation===!0)return t;var s=!1;return o};var O,R={};r.debuglog=function(t){if(w(O)&&(O=e.env.NODE_DEBUG||""),t=t.toUpperCase(),!R[t])if(new RegExp("\\b"+t+"\\b","i").test(O)){var n=e.pid;R[t]=function(){var e=r.format.apply(r,arguments);console.error("%s %d: %s",t,n,e)}}else R[t]=function(){};return R[t]},r.inspect=i,i.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},i.styles={special:"cyan",number:"yellow","boolean":"yellow",undefined:"grey","null":"bold",string:"green",date:"magenta",regexp:"red"},r.isArray=d,r.isBoolean=g,r.isNull=b,r.isNullOrUndefined=m,r.isNumber=y,r.isString=v,r.isSymbol=_,r.isUndefined=w,r.isRegExp=S,r.isObject=E,r.isDate=k,r.isError=I,r.isFunction=x,r.isPrimitive=A,r.isBuffer=t("./support/isBuffer");var U=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];r.log=function(){console.log("%s - %s",C(),r.format.apply(r,arguments))},r.inherits=t("inherits"),r._extend=function(t,e){if(!e||!E(e))return t;for(var r=Object.keys(e),n=r.length;n--;)t[r[n]]=e[r[n]];return t}}).call(this,t("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./support/isBuffer":15,_process:7,inherits:14}],17:[function(t,e,r){(function(r,n){"use strict";function i(){return"mqttjs_"+Math.random().toString(16).substr(2,8)}function o(t,e,r){t.emit("packetsend",e);var n=l.writeToStream(e,t.stream);!n&&r?t.stream.once("drain",r):r&&r()}function s(t,e,r){t.outgoingStore.put(e,function(n){return n?r&&r(n):void o(t,e,r)})}function a(){}function u(t,e){var r,n=this;if(!(this instanceof u))return new u(t,e);this.options=e||{};for(r in v)"undefined"==typeof this.options[r]?this.options[r]=v[r]:this.options[r]=e[r];this.options.clientId=this.options.clientId||i(),this.streamBuilder=t,this.outgoingStore=this.options.outgoingStore||new h,this.incomingStore=this.options.incomingStore||new h,this.queueQoSZero=void 0===this.options.queueQoSZero?!0:this.options.queueQoSZero,this._resubscribeTopics={},this.messageIdToTopic={},this.pingTimer=null,this.connected=!1,this.disconnecting=!1,this.queue=[],this.connackTimer=null,this.reconnectTimer=null,this.nextId=Math.floor(65535*Math.random()),this.outgoing={},this.on("connect",function(){if(!this.disconnected){this.connected=!0;var t=null;t=this.outgoingStore.createStream(),t.once("readable",function(){function e(){var r,i=t.read(1);i&&(!n.disconnecting&&!n.reconnectTimer&&n.options.reconnectPeriod>0?(t.read(0),r=n.outgoing[i.messageId],n.outgoing[i.messageId]=function(t,n){r&&r(t,n),e()},n._sendPacket(i)):t.destroy&&t.destroy())}e()}).on("error",this.emit.bind(this,"error"))}}),this.on("close",function(){this.connected=!1,clearTimeout(this.connackTimer)}),this.on("connect",this._setupPingTimer),this.on("connect",function(){function t(){var r=e.shift(),i=null;r&&(i=r.packet,n._sendPacket(i,function(e){r.cb&&r.cb(e),t()}))}var e=this.queue;t()});var o=!0;this.on("connect",function(){!o&&this.options.clean&&Object.keys(this._resubscribeTopics).length>0&&(this.options.resubscribe?(this._resubscribeTopics.resubscribe=!0,this.subscribe(this._resubscribeTopics)):this._resubscribeTopics={}),o=!1}),this.on("close",function(){null!==n.pingTimer&&(n.pingTimer.clear(),n.pingTimer=null)}),this.on("close",this._setupReconnect),c.EventEmitter.call(this),this._setupStream()}var c=t("events"),h=t("./store"),f=t("end-of-stream"),l=t("mqtt-packet"),p=t("readable-stream").Writable,d=t("inherits"),g=t("reinterval"),b=t("./validations"),m=t("xtend"),y=n.setImmediate||function(t){r.nextTick(t)},v={keepalive:60,reschedulePings:!0,protocolId:"MQTT",protocolVersion:4,reconnectPeriod:1e3,connectTimeout:3e4,clean:!0,resubscribe:!0};d(u,c.EventEmitter),u.prototype._setupStream=function(){function t(){var e=u.shift(),n=s;e?r._handlePacket(e,t):(s=null,n())}var e,r=this,n=new p,i=l.parser(this.options),s=null,u=[];this._clearReconnect(),this.stream=this.streamBuilder(this),i.on("packet",function(t){u.push(t)}),n._write=function(e,r,n){s=n,i.parse(e),t()},this.stream.pipe(n),this.stream.on("error",a),f(this.stream,this.emit.bind(this,"close")),e=Object.create(this.options),e.cmd="connect",o(this,e),i.on("error",this.emit.bind(this,"error")),this.stream.setMaxListeners(1e3),clearTimeout(this.connackTimer),this.connackTimer=setTimeout(function(){r._cleanUp(!0)},this.options.connectTimeout)},u.prototype._handlePacket=function(t,e){switch(this.emit("packetreceive",t),t.cmd){case"publish":this._handlePublish(t,e);break;case"puback":case"pubrec":case"pubcomp":case"suback":case"unsuback":this._handleAck(t),e();break;case"pubrel":this._handlePubrel(t,e);break;case"connack":this._handleConnack(t),e();break;case"pingresp":this._handlePingresp(t),e()}},u.prototype._checkDisconnecting=function(t){return this.disconnecting&&(t?t(new Error("client disconnecting")):this.emit("error",new Error("client disconnecting"))),this.disconnecting},u.prototype.publish=function(t,e,r,n){var i;"function"==typeof r&&(n=r,r=null);var o={qos:0,retain:!1,dup:!1};if(r=m(o,r),this._checkDisconnecting(n))return this;switch(i={cmd:"publish",topic:t,payload:e,qos:r.qos,retain:r.retain,messageId:this._nextId(),dup:r.dup},r.qos){case 1:case 2:this.outgoing[i.messageId]=n||a,this._sendPacket(i);break;default:this._sendPacket(i,n)}return this},u.prototype.subscribe=function(){var t,e,r=Array.prototype.slice.call(arguments),n=[],i=r.shift(),o=i.resubscribe,s=r.pop()||a,u=r.pop(),c=this;if(delete i.resubscribe,"string"==typeof i&&(i=[i]),"function"!=typeof s&&(u=s,s=a),e=b.validateTopics(i),null!==e)return y(s,new Error("Invalid topic "+e)),this;if(this._checkDisconnecting(s))return this;var h={qos:0};if(u=m(h,u),Array.isArray(i)?i.forEach(function(t){(c._resubscribeTopics[t]<u.qos||!c._resubscribeTopics.hasOwnProperty(t)||o)&&n.push({topic:t,qos:u.qos})}):Object.keys(i).forEach(function(t){(c._resubscribeTopics[t]<i[t]||!c._resubscribeTopics.hasOwnProperty(t)||o)&&n.push({topic:t,qos:i[t]})}),t={cmd:"subscribe",subscriptions:n,qos:1,retain:!1,dup:!1,messageId:this._nextId()},!n.length)return void s(null,[]);if(this.options.resubscribe){var f=[];n.forEach(function(t){c.options.reconnectPeriod>0&&(c._resubscribeTopics[t.topic]=t.qos,f.push(t.topic))}),c.messageIdToTopic[t.messageId]=f}return this.outgoing[t.messageId]=function(t,e){if(!t)for(var r=e.granted,i=0;i<r.length;i+=1)n[i].qos=r[i];s(t,n)},this._sendPacket(t),this},u.prototype.unsubscribe=function(t,e){var r={cmd:"unsubscribe",qos:1,messageId:this._nextId()},n=this;return e=e||a,this._checkDisconnecting(e)?this:("string"==typeof t?r.unsubscriptions=[t]:"object"==typeof t&&t.length&&(r.unsubscriptions=t),this.options.resubscribe&&r.unsubscriptions.forEach(function(t){delete n._resubscribeTopics[t]}),this.outgoing[r.messageId]=e,this._sendPacket(r),this)},u.prototype.end=function(t,e){function r(){i.disconnected=!0,i.incomingStore.close(function(){i.outgoingStore.close(e)})}function n(){i._cleanUp(t,y.bind(null,r))}var i=this;return"function"==typeof t&&(e=t,t=!1),this.disconnecting?this:(this._clearReconnect(),this.disconnecting=!0,!t&&Object.keys(this.outgoing).length>0?this.once("outgoingEmpty",setTimeout.bind(null,n,10)):n(),this)},u.prototype.removeOutgoingMessage=function(t){var e=this.outgoing[t];return delete this.outgoing[t],this.outgoingStore.del({messageId:t},function(){e(new Error("Message removed"))}),this},u.prototype.reconnect=function(){return this.disconnecting=!1,this.disconnected=!1,this._reconnect(),this},u.prototype._reconnect=function(){this.emit("reconnect"),this._setupStream()},u.prototype._setupReconnect=function(){var t=this;!t.disconnecting&&!t.reconnectTimer&&t.options.reconnectPeriod>0&&(this.reconnecting||(this.emit("offline"),this.reconnecting=!0),t.reconnectTimer=setInterval(function(){t._reconnect()},t.options.reconnectPeriod))},u.prototype._clearReconnect=function(){this.reconnectTimer&&(clearInterval(this.reconnectTimer),this.reconnectTimer=null)},u.prototype._cleanUp=function(t,e){e&&this.stream.on("close",e),t?this.stream.destroy():this._sendPacket({cmd:"disconnect"},y.bind(null,this.stream.end.bind(this.stream))),this.disconnecting||(this._clearReconnect(),this._setupReconnect()),null!==this.pingTimer&&(this.pingTimer.clear(),this.pingTimer=null)},u.prototype._sendPacket=function(t,e){if(!this.connected)return void(0===(t.qos||0)&&this.queueQoSZero||"publish"!==t.cmd?this.queue.push({packet:t,cb:e}):t.qos>0?this.outgoingStore.put(t,function(t){return t?e&&e(t):void 0}):e&&e(new Error("No connection to broker")));if(this._shiftPingInterval(),"publish"!==t.cmd)return void o(this,t,e);switch(t.qos){case 2:case 1:s(this,t,e);break;case 0:default:o(this,t,e)}},u.prototype._setupPingTimer=function(){var t=this;!this.pingTimer&&this.options.keepalive&&(this.pingResp=!0,this.pingTimer=g(function(){t._checkPing()},1e3*this.options.keepalive))},u.prototype._shiftPingInterval=function(){this.pingTimer&&this.options.keepalive&&this.options.reschedulePings&&this.pingTimer.reschedule(1e3*this.options.keepalive)},u.prototype._checkPing=function(){this.pingResp?(this.pingResp=!1,this._sendPacket({cmd:"pingreq"})):this._cleanUp(!0)},u.prototype._handlePingresp=function(){this.pingResp=!0},u.prototype._handleConnack=function(t){var e=t.returnCode,r=["","Unacceptable protocol version","Identifier rejected","Server unavailable","Bad username or password","Not authorized"];if(clearTimeout(this.connackTimer),0===e)this.reconnecting=!1,this.emit("connect",t);else if(e>0){var n=new Error("Connection refused: "+r[e]);n.code=e,this.emit("error",n)}},u.prototype._handlePublish=function(t,e){var r=t.topic.toString(),n=t.payload,i=t.qos,o=t.messageId,s=this;switch(i){case 2:this.incomingStore.put(t,function(){s._sendPacket({cmd:"pubrec",messageId:o},e)});break;case 1:this.emit("message",r,n,t),this.handleMessage(t,function(t){return t?void e(t):void s._sendPacket({cmd:"puback",messageId:o},e)});break;case 0:this.emit("message",r,n,t),this.handleMessage(t,e)}},u.prototype.handleMessage=function(t,e){e()},u.prototype._handleAck=function(t){var e=t.messageId,r=t.cmd,n=null,i=this.outgoing[e],o=this;if(i){switch(r){case"pubcomp":case"puback":delete this.outgoing[e],this.outgoingStore.del(t,i);break;case"pubrec":n={cmd:"pubrel",qos:2,messageId:e},this._sendPacket(n);break;case"suback":if(delete this.outgoing[e],1===t.granted.length&&0!==(128&t.granted[0])){var s=this.messageIdToTopic[e];s&&s.forEach(function(t){delete o._resubscribeTopics[t]})}i(null,t);break;case"unsuback":delete this.outgoing[e],i(null);break;default:o.emit("error",new Error("unrecognized packet type"))}this.disconnecting&&0===Object.keys(this.outgoing).length&&this.emit("outgoingEmpty")}},u.prototype._handlePubrel=function(t,e){var r=t.messageId,n=this,i={cmd:"pubcomp",messageId:r};n.incomingStore.get(t,function(r,o){r||"pubrel"===o.cmd?n._sendPacket(i,e):(n.emit("message",o.topic,o.payload,o),n.incomingStore.put(t),n.handleMessage(o,function(t){return t?void e(t):void n._sendPacket(i,e)}))})},u.prototype._nextId=function(){var t=this.nextId++;return 65535===t&&(this.nextId=1),t},u.prototype.getLastMessageId=function(){return 1===this.nextId?65535:this.nextId-1},e.exports=u}).call(this,t("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./store":22,"./validations":23,_process:7,"end-of-stream":28,events:4,inherits:29,"mqtt-packet":33,"readable-stream":49,reinterval:50,xtend:58}],18:[function(t,e,r){"use strict";function n(t,e){var r,n;return e.port=e.port||1883,e.hostname=e.hostname||e.host||"localhost",r=e.port,n=e.hostname,i.createConnection(r,n)}var i=t("net");e.exports=n},{net:2}],19:[function(t,e,r){"use strict";function n(t,e){function r(r){e.rejectUnauthorized&&t.emit("error",r),n.end()}var n;return e.port=e.port||8883,e.host=e.hostname||e.host||"localhost",e.rejectUnauthorized=e.rejectUnauthorized!==!1,delete e.path,n=i.connect(e),n.on("secureConnect",function(){e.rejectUnauthorized&&!n.authorized?n.emit("error",new Error("TLS not authorized")):n.removeListener("error",r)}),n.on("error",r),n}var i=t("tls");e.exports=n},{tls:2}],20:[function(t,e,r){(function(r){"use strict";function n(t,e){var r=t.protocol+"://"+t.hostname+":"+t.port+t.path;return"function"==typeof t.transformWsUrl&&(r=t.transformWsUrl(r,t,e)),r}function i(t){t.hostname||(t.hostname="localhost"),t.port||("wss"===t.protocol?t.port=443:t.port=80),t.path||(t.path="/"),t.wsOptions||(t.wsOptions={}),f||"wss"!==t.protocol||h.forEach(function(e){t.hasOwnProperty(e)&&!t.wsOptions.hasOwnProperty(e)&&(t.wsOptions[e]=t[e])})}function o(t,e){var r="MQIsdp"===e.protocolId&&3===e.protocolVersion?"mqttv3.1":"mqtt";i(e);var o=n(e,t);return u(o,[r],e.wsOptions)}function s(t,e){return o(t,e)}function a(t,e){if(e.hostname||(e.hostname=e.host),!e.hostname){if("undefined"==typeof document)throw new Error("Could not determine host. Specify host manually.");var r=c.parse(document.URL);e.hostname=r.hostname,e.port||(e.port=r.port)}return o(t,e)}var u=t("websocket-stream"),c=t("url"),h=["rejectUnauthorized","ca","cert","key","pfx","passphrase"],f="browser"===r.title;f?e.exports=a:e.exports=s}).call(this,t("_process"))},{_process:7,url:12,"websocket-stream":55}],21:[function(t,e,r){"use strict";function n(t){c?wx.sendSocketMessage({data:t}):h.push(t)}function i(t,e){console.log("creating WebSocket...",arguments);var r={OPEN:1,CLOSING:2,CLOSED:3,readyState:c?1:0,send:n,close:wx.closeSocket,onopen:null,onmessage:null,onclose:null,onerror:null};return wx.connectSocket({url:t,protocols:e}),wx.onSocketOpen(function(t){r.readyState=r.OPEN,c=!0;for(var e=0;e<h.length;e++)n(h[e]);h=[],r.onopen&&r.onopen.apply(r,arguments)}),wx.onSocketMessage(function(t){r.onmessage&&r.onmessage.apply(r,arguments)}),wx.onSocketClose(function(){r.readyState=r.CLOSED,r.onclose&&r.onclose.apply(r,arguments)}),wx.onSocketError(function(){r.onerror&&r.onerror.apply(r,arguments)}),r}function o(t,e){var r="wxs"===t.protocol?"wss":"ws",n=r+"://"+t.hostname+":"+t.port+t.path;return"function"==typeof t.transformWsUrl&&(n=t.transformWsUrl(n,t,e)),n}function s(t){t.hostname||(t.hostname="localhost"),t.port||("wss"===t.protocol?t.port=443:t.port=80),t.path||(t.path="/"),t.wsOptions||(t.wsOptions={})}function a(t,e){var r="MQIsdp"===e.protocolId&&3===e.protocolVersion?"mqttv3.1":"mqtt";s(e);var n=o(e,t);return f(i(n,[r]))}function u(t,e){if(e.hostname||(e.hostname=e.host),!e.hostname){if("undefined"==typeof document)throw new Error("Could not determine host. Specify host manually.");var r=l.parse(document.URL);e.hostname=r.hostname,e.port||(e.port=r.port)}return a(t,e)}var c=!1,h=[],f=t("websocket-stream"),l=t("url");e.exports=u},{url:12,"websocket-stream":55}],22:[function(t,e,r){(function(r){"use strict";function n(t){return this instanceof n?(this.options=t||{},this.options=i(a,t),void(this._inflights={})):new n(t)}var i=t("xtend"),o=t("readable-stream").Readable,s={objectMode:!0},a={clean:!0};n.prototype.put=function(t,e){return this._inflights[t.messageId]=t,e&&e(),this},n.prototype.createStream=function(){var t=new o(s),e=this._inflights,n=Object.keys(this._inflights),i=!1,a=0;return t._read=function(){!i&&a<n.length?this.push(e[n[a++]]):this.push(null)},t.destroy=function(){if(!i){var t=this;i=!0,r.nextTick(function(){t.emit("close")})}},t},n.prototype.del=function(t,e){return t=this._inflights[t.messageId],t?(delete this._inflights[t.messageId],e(null,t)):e&&e(new Error("missing packet")),this},n.prototype.get=function(t,e){return t=this._inflights[t.messageId],t?e(null,t):e&&e(new Error("missing packet")),this},n.prototype.close=function(t){this.options.clean&&(this._inflights=null),t&&t()},e.exports=n}).call(this,t("_process"))},{_process:7,"readable-stream":49,xtend:58}],23:[function(t,e,r){"use strict";function n(t){for(var e=t.split("/"),r=0;r<e.length;r++)if("+"!==e[r]){if("#"===e[r])return r===e.length-1;if(-1!==e[r].indexOf("+")||-1!==e[r].indexOf("#"))return!1}return!0}function i(t){if(0===t.length)return"empty_topic_list";for(var e=0;e<t.length;e++)if(!n(t[e]))return t[e];return null}e.exports={validateTopics:i}},{}],24:[function(t,e,r){(function(r){"use strict";function n(t){var e;t.auth&&(e=t.auth.match(/^(.+):(.+)$/),e?(t.username=e[1],t.password=e[2]):t.username=t.auth)}function i(t,e){function r(t){return e.servers&&(t._reconnectCount&&t._reconnectCount!==e.servers.length||(t._reconnectCount=0),e.host=e.servers[t._reconnectCount].host,e.port=e.servers[t._reconnectCount].port,e.hostname=e.host,t._reconnectCount++),u[e.protocol](t,e)}if("object"!=typeof t||e||(e=t,t=null),e=e||{},t){var i=s.parse(t,!0);if(null!=i.port&&(i.port=Number(i.port)),e=a(i,e),null===e.protocol)throw new Error("Missing protocol");e.protocol=e.protocol.replace(/:$/,"")}if(n(e),e.query&&"string"==typeof e.query.clientId&&(e.clientId=e.query.clientId),e.cert&&e.key){if(!e.protocol)throw new Error("Missing secure protocol key");if(-1===["mqtts","wss","wxs"].indexOf(e.protocol))switch(e.protocol){case"mqtt":e.protocol="mqtts";break;case"ws":e.protocol="wss";break;case"wx":e.protocol="wxs";break;default:throw new Error('Unknown protocol for secure connection: "'+e.protocol+'"!')}}if(!u[e.protocol]){var c=-1!==["mqtts","wss"].indexOf(e.protocol);e.protocol=["mqtt","mqtts","ws","wss","wx","wxs"].filter(function(t,e){return c&&e%2===0?!1:"function"==typeof u[t]})[0]}if(e.clean===!1&&!e.clientId)throw new Error("Missing clientId for unclean clients");return new o(r,e)}var o=t("../client"),s=t("url"),a=t("xtend"),u={};"browser"!==r.title?(u.mqtt=t("./tcp"),u.tcp=t("./tcp"),u.ssl=t("./tls"),u.tls=t("./tls"),u.mqtts=t("./tls")):(u.wx=t("./wx"),u.wxs=t("./wx")),u.ws=t("./ws"),u.wss=t("./ws"),e.exports=i,e.exports.connect=i,e.exports.MqttClient=o}).call(this,t("_process"))},{"../client":17,"./tcp":18,"./tls":19,"./ws":20,"./wx":21,_process:7,url:12,xtend:58}],25:[function(t,e,r){(function(r){function n(t){if(!(this instanceof n))return new n(t);if(this._bufs=[],this.length=0,"function"==typeof t){this._callback=t;var e=function(t){this._callback&&(this._callback(t),this._callback=null)}.bind(this);this.on("pipe",function(t){t.on("error",e)}),this.on("unpipe",function(t){t.removeListener("error",e)})}else this.append(t);i.call(this)}var i=t("readable-stream/duplex"),o=t("util");o.inherits(n,i),n.prototype._offset=function(t){var e,r=0,n=0;if(0===t)return[0,0];for(;n<this._bufs.length;n++){if(e=r+this._bufs[n].length,e>t||n==this._bufs.length-1)return[n,t-r];r=e}},n.prototype.append=function(t){var e=0;if(r.isBuffer(t))this._appendBuffer(t);else if(Array.isArray(t))for(;e<t.length;e++)this.append(t[e]);else if(t instanceof n)for(;e<t._bufs.length;e++)this.append(t._bufs[e]);else null!=t&&("number"==typeof t&&(t=t.toString()),
this._appendBuffer(new r(t)));return this},n.prototype._appendBuffer=function(t){this._bufs.push(t),this.length+=t.length},n.prototype._write=function(t,e,r){this._appendBuffer(t),"function"==typeof r&&r()},n.prototype._read=function(t){return this.length?(t=Math.min(t,this.length),this.push(this.slice(0,t)),void this.consume(t)):this.push(null)},n.prototype.end=function(t){i.prototype.end.call(this,t),this._callback&&(this._callback(null,this.slice()),this._callback=null)},n.prototype.get=function(t){return this.slice(t,t+1)[0]},n.prototype.slice=function(t,e){return"number"==typeof t&&0>t&&(t+=this.length),"number"==typeof e&&0>e&&(e+=this.length),this.copy(null,0,t,e)},n.prototype.copy=function s(t,e,n,i){if(("number"!=typeof n||0>n)&&(n=0),("number"!=typeof i||i>this.length)&&(i=this.length),n>=this.length)return t||new r(0);if(0>=i)return t||new r(0);var o,a,s=!!t,u=this._offset(n),c=i-n,h=c,f=s&&e||0,l=u[1];if(0===n&&i==this.length){if(!s)return 1===this._bufs.length?this._bufs[0]:r.concat(this._bufs,this.length);for(a=0;a<this._bufs.length;a++)this._bufs[a].copy(t,f),f+=this._bufs[a].length;return t}if(h<=this._bufs[u[0]].length-l)return s?this._bufs[u[0]].copy(t,e,l,l+h):this._bufs[u[0]].slice(l,l+h);for(s||(t=new r(c)),a=u[0];a<this._bufs.length;a++){if(o=this._bufs[a].length-l,!(h>o)){this._bufs[a].copy(t,f,l,l+h);break}this._bufs[a].copy(t,f,l),f+=o,h-=o,l&&(l=0)}return t},n.prototype.shallowSlice=function(t,e){t=t||0,e=e||this.length,0>t&&(t+=this.length),0>e&&(e+=this.length);var r=this._offset(t),i=this._offset(e),o=this._bufs.slice(r[0],i[0]+1);return 0==i[1]?o.pop():o[o.length-1]=o[o.length-1].slice(0,i[1]),0!=r[1]&&(o[0]=o[0].slice(r[1])),new n(o)},n.prototype.toString=function(t,e,r){return this.slice(e,r).toString(t)},n.prototype.consume=function(t){for(;this._bufs.length;){if(!(t>=this._bufs[0].length)){this._bufs[0]=this._bufs[0].slice(t),this.length-=t;break}t-=this._bufs[0].length,this.length-=this._bufs[0].length,this._bufs.shift()}return this},n.prototype.duplicate=function(){for(var t=0,e=new n;t<this._bufs.length;t++)e.append(this._bufs[t]);return e},n.prototype.destroy=function(){this._bufs.length=0,this.length=0,this.push(null)},function(){var t={readDoubleBE:8,readDoubleLE:8,readFloatBE:4,readFloatLE:4,readInt32BE:4,readInt32LE:4,readUInt32BE:4,readUInt32LE:4,readInt16BE:2,readInt16LE:2,readUInt16BE:2,readUInt16LE:2,readInt8:1,readUInt8:1};for(var e in t)!function(e){n.prototype[e]=function(r){return this.slice(r,r+t[e])[e](0)}}(e)}(),e.exports=n}).call(this,t("buffer").Buffer)},{buffer:3,"readable-stream/duplex":40,util:16}],26:[function(t,e,r){(function(t){function e(t){return Array.isArray?Array.isArray(t):"[object Array]"===b(t)}function n(t){return"boolean"==typeof t}function i(t){return null===t}function o(t){return null==t}function s(t){return"number"==typeof t}function a(t){return"string"==typeof t}function u(t){return"symbol"==typeof t}function c(t){return void 0===t}function h(t){return"[object RegExp]"===b(t)}function f(t){return"object"==typeof t&&null!==t}function l(t){return"[object Date]"===b(t)}function p(t){return"[object Error]"===b(t)||t instanceof Error}function d(t){return"function"==typeof t}function g(t){return null===t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||"symbol"==typeof t||"undefined"==typeof t}function b(t){return Object.prototype.toString.call(t)}r.isArray=e,r.isBoolean=n,r.isNull=i,r.isNullOrUndefined=o,r.isNumber=s,r.isString=a,r.isSymbol=u,r.isUndefined=c,r.isRegExp=h,r.isObject=f,r.isDate=l,r.isError=p,r.isFunction=d,r.isPrimitive=g,r.isBuffer=t.isBuffer}).call(this,{isBuffer:t("C:/Users/lmak/AppData/Roaming/npm/node_modules/browserify/node_modules/is-buffer/index.js")})},{"C:/Users/lmak/AppData/Roaming/npm/node_modules/browserify/node_modules/is-buffer/index.js":6}],27:[function(t,e,r){(function(r,n){var i=t("readable-stream"),o=t("end-of-stream"),s=t("inherits"),a=t("stream-shift"),u=new n([0]),c=function(t,e){t._corked?t.once("uncork",e):e()},h=function(t,e){return function(r){r?t.destroy("premature close"===r.message?null:r):e&&!t._ended&&t.end()}},f=function(t,e){return t?t._writableState&&t._writableState.finished?e():t._writableState?t.end(e):(t.end(),void e()):e()},l=function(t){return new i.Readable({objectMode:!0,highWaterMark:16}).wrap(t)},p=function(t,e,r){return this instanceof p?(i.Duplex.call(this,r),this._writable=null,this._readable=null,this._readable2=null,this._forwardDestroy=!r||r.destroy!==!1,this._forwardEnd=!r||r.end!==!1,this._corked=1,this._ondrain=null,this._drained=!1,this._forwarding=!1,this._unwrite=null,this._unread=null,this._ended=!1,this.destroyed=!1,t&&this.setWritable(t),void(e&&this.setReadable(e))):new p(t,e,r)};s(p,i.Duplex),p.obj=function(t,e,r){return r||(r={}),r.objectMode=!0,r.highWaterMark=16,new p(t,e,r)},p.prototype.cork=function(){1===++this._corked&&this.emit("cork")},p.prototype.uncork=function(){this._corked&&0===--this._corked&&this.emit("uncork")},p.prototype.setWritable=function(t){if(this._unwrite&&this._unwrite(),this.destroyed)return void(t&&t.destroy&&t.destroy());if(null===t||t===!1)return void this.end();var e=this,n=o(t,{writable:!0,readable:!1},h(this,this._forwardEnd)),i=function(){var t=e._ondrain;e._ondrain=null,t&&t()},s=function(){e._writable.removeListener("drain",i),n()};this._unwrite&&r.nextTick(i),this._writable=t,this._writable.on("drain",i),this._unwrite=s,this.uncork()},p.prototype.setReadable=function(t){if(this._unread&&this._unread(),this.destroyed)return void(t&&t.destroy&&t.destroy());if(null===t||t===!1)return this.push(null),void this.resume();var e=this,r=o(t,{writable:!1,readable:!0},h(this)),n=function(){e._forward()},i=function(){e.push(null)},s=function(){e._readable2.removeListener("readable",n),e._readable2.removeListener("end",i),r()};this._drained=!0,this._readable=t,this._readable2=t._readableState?t:l(t),this._readable2.on("readable",n),this._readable2.on("end",i),this._unread=s,this._forward()},p.prototype._read=function(){this._drained=!0,this._forward()},p.prototype._forward=function(){if(!this._forwarding&&this._readable2&&this._drained){this._forwarding=!0;for(var t;this._drained&&null!==(t=a(this._readable2));)this.destroyed||(this._drained=this.push(t));this._forwarding=!1}},p.prototype.destroy=function(t){if(!this.destroyed){this.destroyed=!0;var e=this;r.nextTick(function(){e._destroy(t)})}},p.prototype._destroy=function(t){if(t){var e=this._ondrain;this._ondrain=null,e?e(t):this.emit("error",t)}this._forwardDestroy&&(this._readable&&this._readable.destroy&&this._readable.destroy(),this._writable&&this._writable.destroy&&this._writable.destroy()),this.emit("close")},p.prototype._write=function(t,e,r){return this.destroyed?r():this._corked?c(this,this._write.bind(this,t,e,r)):t===u?this._finish(r):this._writable?void(this._writable.write(t)===!1?this._ondrain=r:r()):r()},p.prototype._finish=function(t){var e=this;this.emit("preend"),c(this,function(){f(e._forwardEnd&&e._writable,function(){e._writableState.prefinished===!1&&(e._writableState.prefinished=!0),e.emit("prefinish"),c(e,t)})})},p.prototype.end=function(t,e,r){return"function"==typeof t?this.end(null,null,t):"function"==typeof e?this.end(t,null,e):(this._ended=!0,t&&this.write(t),this._writableState.ending||this.write(u),i.Writable.prototype.end.call(this,r))},e.exports=p}).call(this,t("_process"),t("buffer").Buffer)},{_process:7,buffer:3,"end-of-stream":28,inherits:29,"readable-stream":49,"stream-shift":52}],28:[function(t,e,r){var n=t("once"),i=function(){},o=function(t){return t.setHeader&&"function"==typeof t.abort},s=function(t){return t.stdio&&Array.isArray(t.stdio)&&3===t.stdio.length},a=function(t,e,r){if("function"==typeof e)return a(t,null,e);e||(e={}),r=n(r||i);var u=t._writableState,c=t._readableState,h=e.readable||e.readable!==!1&&t.readable,f=e.writable||e.writable!==!1&&t.writable,l=function(){t.writable||p()},p=function(){f=!1,h||r.call(t)},d=function(){h=!1,f||r.call(t)},g=function(e){r.call(t,e?new Error("exited with error code: "+e):null)},b=function(){return(!h||c&&c.ended)&&(!f||u&&u.ended)?void 0:r.call(t,new Error("premature close"))},m=function(){t.req.on("finish",p)};return o(t)?(t.on("complete",p),t.on("abort",b),t.req?m():t.on("request",m)):f&&!u&&(t.on("end",l),t.on("close",l)),s(t)&&t.on("exit",g),t.on("end",d),t.on("finish",p),e.error!==!1&&t.on("error",r),t.on("close",b),function(){t.removeListener("complete",p),t.removeListener("abort",b),t.removeListener("request",m),t.req&&t.req.removeListener("finish",p),t.removeListener("end",l),t.removeListener("close",l),t.removeListener("finish",p),t.removeListener("exit",g),t.removeListener("end",d),t.removeListener("error",r),t.removeListener("close",b)}};e.exports=a},{once:38}],29:[function(t,e,r){arguments[4][14][0].apply(r,arguments)},{dup:14}],30:[function(t,e,r){var n={}.toString;e.exports=Array.isArray||function(t){return"[object Array]"==n.call(t)}},{}],31:[function(t,e,r){"use strict";function n(t){return[0,1,2].map(function(e){return[0,1].map(function(r){return[0,1].map(function(n){var s=new i(1);return s.writeUInt8(o.codes[t]<<o.CMD_SHIFT|(r?o.DUP_MASK:0)|e<<o.QOS_SHIFT|n,0,!0),s})})})}var i=t("safe-buffer").Buffer,o=e.exports;o.types={0:"reserved",1:"connect",2:"connack",3:"publish",4:"puback",5:"pubrec",6:"pubrel",7:"pubcomp",8:"subscribe",9:"suback",10:"unsubscribe",11:"unsuback",12:"pingreq",13:"pingresp",14:"disconnect",15:"reserved"},o.codes={};for(var s in o.types){var a=o.types[s];o.codes[a]=s}o.CMD_SHIFT=4,o.CMD_MASK=240,o.DUP_MASK=8,o.QOS_MASK=3,o.QOS_SHIFT=1,o.RETAIN_MASK=1,o.LENGTH_MASK=127,o.LENGTH_FIN_MASK=128,o.SESSIONPRESENT_MASK=1,o.SESSIONPRESENT_HEADER=i.from([o.SESSIONPRESENT_MASK]),o.CONNACK_HEADER=i.from([o.codes.connack<<o.CMD_SHIFT]),o.USERNAME_MASK=128,o.PASSWORD_MASK=64,o.WILL_RETAIN_MASK=32,o.WILL_QOS_MASK=24,o.WILL_QOS_SHIFT=3,o.WILL_FLAG_MASK=4,o.CLEAN_SESSION_MASK=2,o.CONNECT_HEADER=i.from([o.codes.connect<<o.CMD_SHIFT]),o.PUBLISH_HEADER=n("publish"),o.SUBSCRIBE_HEADER=n("subscribe"),o.UNSUBSCRIBE_HEADER=n("unsubscribe"),o.ACKS={unsuback:n("unsuback"),puback:n("puback"),pubcomp:n("pubcomp"),pubrel:n("pubrel"),pubrec:n("pubrec")},o.SUBACK_HEADER=i.from([o.codes.suback<<o.CMD_SHIFT]),o.VERSION3=i.from([3]),o.VERSION4=i.from([4]),o.QOS=[0,1,2].map(function(t){return i.from([t])}),o.EMPTY={pingreq:i.from([o.codes.pingreq<<4,0]),pingresp:i.from([o.codes.pingresp<<4,0]),disconnect:i.from([o.codes.disconnect<<4,0])}},{"safe-buffer":51}],32:[function(t,e,r){"use strict";function n(t){var e=new i;return s(t,e),e.concat()}function i(){this._array=new Array(20),this._i=0}var o=t("safe-buffer").Buffer,s=t("./writeToStream"),a=t("events").EventEmitter,u=t("inherits");u(i,a),i.prototype.write=function(t){return this._array[this._i++]=t,!0},i.prototype.concat=function(){var t,e,r=0,n=new Array(this._array.length),i=this._array,s=0;for(t=0;t<i.length&&i[t];t++)"string"!=typeof i[t]?n[t]=i[t].length:n[t]=o.byteLength(i[t]),r+=n[t];for(e=o.allocUnsafe(r),t=0;t<i.length&&i[t];t++)"string"!=typeof i[t]?(i[t].copy(e,s),s+=n[t]):(e.write(i[t],s),s+=n[t]);return e},e.exports=n},{"./writeToStream":37,events:4,inherits:29,"safe-buffer":51}],33:[function(t,e,r){"use strict";r.parser=t("./parser"),r.generate=t("./generate"),r.writeToStream=t("./writeToStream")},{"./generate":32,"./parser":36,"./writeToStream":37}],34:[function(t,e,r){"use strict";function n(t){var e=o.allocUnsafe(2);return e.writeUInt8(t>>8,0,!0),e.writeUInt8(255&t,1,!0),e}function i(){for(var t=0;s>t;t++)a[t]=n(t)}var o=t("safe-buffer").Buffer,s=65536,a={};e.exports={cache:a,generateCache:i,generateNumber:n}},{"safe-buffer":51}],35:[function(t,e,r){function n(){this.cmd=null,this.retain=!1,this.qos=0,this.dup=!1,this.length=-1,this.topic=null,this.payload=null}e.exports=n},{}],36:[function(t,e,r){"use strict";function n(){return this instanceof n?(this._states=["_parseHeader","_parseLength","_parsePayload","_newPacket"],void this._resetState()):new n}var i=t("bl"),o=t("inherits"),s=t("events").EventEmitter,a=t("./packet"),u=t("./constants");o(n,s),n.prototype._resetState=function(){this.packet=new a,this.error=null,this._list=i(),this._stateCounter=0},n.prototype.parse=function(t){for(this.error&&this._resetState(),this._list.append(t);(-1!==this.packet.length||this._list.length>0)&&this[this._states[this._stateCounter]]()&&!this.error;)this._stateCounter++,this._stateCounter>=this._states.length&&(this._stateCounter=0);return this._list.length},n.prototype._parseHeader=function(){var t=this._list.readUInt8(0);return this.packet.cmd=u.types[t>>u.CMD_SHIFT],this.packet.retain=0!==(t&u.RETAIN_MASK),this.packet.qos=t>>u.QOS_SHIFT&u.QOS_MASK,this.packet.dup=0!==(t&u.DUP_MASK),this._list.consume(1),!0},n.prototype._parseLength=function(){for(var t,e=0,r=1,n=0,i=!0;5>e&&(t=this._list.readUInt8(e++),n+=r*(t&u.LENGTH_MASK),r*=128,0!==(t&u.LENGTH_FIN_MASK));)if(this._list.length<=e){i=!1;break}return i&&(this.packet.length=n,this._list.consume(e)),i},n.prototype._parsePayload=function(){var t=!1;if(0===this.packet.length||this._list.length>=this.packet.length){switch(this._pos=0,this.packet.cmd){case"connect":this._parseConnect();break;case"connack":this._parseConnack();break;case"publish":this._parsePublish();break;case"puback":case"pubrec":case"pubrel":case"pubcomp":this._parseMessageId();break;case"subscribe":this._parseSubscribe();break;case"suback":this._parseSuback();break;case"unsubscribe":this._parseUnsubscribe();break;case"unsuback":this._parseUnsuback();break;case"pingreq":case"pingresp":case"disconnect":break;default:this._emitError(new Error("Not supported"))}t=!0}return t},n.prototype._parseConnect=function(){var t,e,r,n,i,o,s={},a=this.packet;if(t=this._parseString(),null===t)return this._emitError(new Error("Cannot parse protocolId"));if("MQTT"!==t&&"MQIsdp"!==t)return this._emitError(new Error("Invalid protocolId"));if(a.protocolId=t,this._pos>=this._list.length)return this._emitError(new Error("Packet too short"));if(a.protocolVersion=this._list.readUInt8(this._pos),3!==a.protocolVersion&&4!==a.protocolVersion)return this._emitError(new Error("Invalid protocol version"));if(this._pos++,this._pos>=this._list.length)return this._emitError(new Error("Packet too short"));if(s.username=this._list.readUInt8(this._pos)&u.USERNAME_MASK,s.password=this._list.readUInt8(this._pos)&u.PASSWORD_MASK,s.will=this._list.readUInt8(this._pos)&u.WILL_FLAG_MASK,s.will&&(a.will={},a.will.retain=0!==(this._list.readUInt8(this._pos)&u.WILL_RETAIN_MASK),a.will.qos=(this._list.readUInt8(this._pos)&u.WILL_QOS_MASK)>>u.WILL_QOS_SHIFT),a.clean=0!==(this._list.readUInt8(this._pos)&u.CLEAN_SESSION_MASK),this._pos++,a.keepalive=this._parseNum(),-1===a.keepalive)return this._emitError(new Error("Packet too short"));if(e=this._parseString(),null===e)return this._emitError(new Error("Packet too short"));if(a.clientId=e,s.will){if(r=this._parseString(),null===r)return this._emitError(new Error("Cannot parse will topic"));if(a.will.topic=r,n=this._parseBuffer(),null===n)return this._emitError(new Error("Cannot parse will payload"));a.will.payload=n}if(s.username){if(o=this._parseString(),null===o)return this._emitError(new Error("Cannot parse username"));a.username=o}if(s.password){if(i=this._parseBuffer(),null===i)return this._emitError(new Error("Cannot parse password"));a.password=i}return a},n.prototype._parseConnack=function(){var t=this.packet;return this._list.length<2?null:(t.sessionPresent=!!(this._list.readUInt8(this._pos++)&u.SESSIONPRESENT_MASK),t.returnCode=this._list.readUInt8(this._pos),-1===t.returnCode?this._emitError(new Error("Cannot parse return code")):void 0)},n.prototype._parsePublish=function(){var t=this.packet;return t.topic=this._parseString(),null===t.topic?this._emitError(new Error("Cannot parse topic")):void(t.qos>0&&!this._parseMessageId()||(t.payload=this._list.slice(this._pos,t.length)))},n.prototype._parseSubscribe=function(){var t,e,r=this.packet;if(1!==r.qos)return this._emitError(new Error("Wrong subscribe header"));if(r.subscriptions=[],this._parseMessageId())for(;this._pos<r.length;){if(t=this._parseString(),null===t)return this._emitError(new Error("Cannot parse topic"));e=this._list.readUInt8(this._pos++),r.subscriptions.push({topic:t,qos:e})}},n.prototype._parseSuback=function(){if(this.packet.granted=[],this._parseMessageId())for(;this._pos<this.packet.length;)this.packet.granted.push(this._list.readUInt8(this._pos++))},n.prototype._parseUnsubscribe=function(){var t=this.packet;if(t.unsubscriptions=[],this._parseMessageId())for(;this._pos<t.length;){var e;if(e=this._parseString(),null===e)return this._emitError(new Error("Cannot parse topic"));t.unsubscriptions.push(e)}},n.prototype._parseUnsuback=function(){return this._parseMessageId()?void 0:this._emitError(new Error("Cannot parse messageId"))},n.prototype._parseMessageId=function(){var t=this.packet;return t.messageId=this._parseNum(),null===t.messageId?(this._emitError(new Error("Cannot parse messageId")),!1):!0},n.prototype._parseString=function(t){var e,r=this._parseNum(),n=r+this._pos;return-1===r||n>this._list.length||n>this.packet.length?null:(e=this._list.toString("utf8",this._pos,n),this._pos+=r,e)},n.prototype._parseBuffer=function(){var t,e=this._parseNum(),r=e+this._pos;return-1===e||r>this._list.length||r>this.packet.length?null:(t=this._list.slice(this._pos,r),this._pos+=e,t)},n.prototype._parseNum=function(){if(this._list.length-this._pos<2)return-1;var t=this._list.readUInt16BE(this._pos);return this._pos+=2,t},n.prototype._newPacket=function(){return this.packet&&(this._list.consume(this.packet.length),this.emit("packet",this.packet)),this.packet=new a,!0},n.prototype._emitError=function(t){this.error=t,this.emit("error",t)},e.exports=n},{"./constants":31,"./packet":35,bl:25,events:4,inherits:29}],37:[function(t,e,r){"use strict";function n(t,e){switch(e.cork&&(e.cork(),x(i,e)),j&&(j=!1,M()),t.cmd){case"connect":return o(t,e);case"connack":return s(t,e);case"publish":return a(t,e);case"puback":case"pubrec":case"pubrel":case"pubcomp":case"unsuback":return u(t,e);case"subscribe":return c(t,e);case"suback":return h(t,e);case"unsubscribe":return f(t,e);case"pingreq":case"pingresp":case"disconnect":return l(t,e);default:return e.emit("error",new Error("Unknown command")),!1}}function i(t){t.uncork()}function o(t,e){var r=t||{},n=r.protocolId||"MQTT",i=r.protocolVersion||4,o=r.will,s=r.clean,a=r.keepalive||0,u=r.clientId||"",c=r.username,h=r.password;void 0===s&&(s=!0);var f=0;if(!n||"string"!=typeof n&&!S.isBuffer(n))return e.emit("error",new Error("Invalid protocolId")),!1;if(f+=n.length+2,3!==i&&4!==i)return e.emit("error",new Error("Invalid protocol version")),!1;if(f+=1,"string"!=typeof u&&!S.isBuffer(u)||!u&&4!==i||!u&&!s){if(4>i)return e.emit("error",new Error("clientId must be supplied before 3.1.1")),!1;if(1*s===0)return e.emit("error",new Error("clientId must be given if cleanSession set to 0")),!1}else f+=u.length+2;if("number"!=typeof a||0>a||a>65535||a%1!==0)return e.emit("error",new Error("Invalid keepalive")),!1;if(f+=2,f+=1,o){if("object"!=typeof o)return e.emit("error",new Error("Invalid will")),!1;if(!o.topic||"string"!=typeof o.topic)return e.emit("error",new Error("Invalid will topic")),!1;if(f+=S.byteLength(o.topic)+2,o.payload&&o.payload){if(!(o.payload.length>=0))return e.emit("error",new Error("Invalid will payload")),!1;f+="string"==typeof o.payload?S.byteLength(o.payload)+2:o.payload.length+2}else f+=2}if(c){if(!c.length)return e.emit("error",new Error("Invalid username")),!1;f+=S.byteLength(c)+2}if(h){if(!h.length)return e.emit("error",new Error("Invalid password")),!1;f+=_(h)+2}e.write(w.CONNECT_HEADER),g(e,f),v(e,n),e.write(4===i?w.VERSION4:w.VERSION3);var l=0;return l|=c?w.USERNAME_MASK:0,l|=h?w.PASSWORD_MASK:0,l|=o&&o.retain?w.WILL_RETAIN_MASK:0,l|=o&&o.qos?o.qos<<w.WILL_QOS_SHIFT:0,l|=o?w.WILL_FLAG_MASK:0,l|=s?w.CLEAN_SESSION_MASK:0,e.write(S.from([l])),C(e,a),v(e,u),o&&(b(e,o.topic),v(e,o.payload)),c&&v(e,c),h&&v(e,h),!0}function s(t,e){var r=t||{},n=r.returnCode;return"number"!=typeof n?(e.emit("error",new Error("Invalid return code")),!1):(e.write(w.CONNACK_HEADER),g(e,2),e.write(t.sessionPresent?w.SESSIONPRESENT_HEADER:k),e.write(S.from([n])))}function a(t,e){var r=t||{},n=r.qos||0,i=r.retain?w.RETAIN_MASK:0,o=r.topic,s=r.payload||E,a=r.messageId,u=0;if("string"==typeof o)u+=S.byteLength(o)+2;else{if(!S.isBuffer(o))return e.emit("error",new Error("Invalid topic")),!1;u+=o.length+2}return u+=S.isBuffer(s)?s.length:S.byteLength(s),n&&"number"!=typeof a?(e.emit("error",new Error("Invalid messageId")),!1):(n&&(u+=2),e.write(w.PUBLISH_HEADER[n][t.dup?1:0][i?1:0]),g(e,u),C(e,_(o)),e.write(o),n>0&&C(e,a),e.write(s))}function u(t,e){var r=t||{},n=r.cmd||"puback",i=r.messageId,o=r.dup&&"pubrel"===n?w.DUP_MASK:0,s=0;return"pubrel"===n&&(s=1),"number"!=typeof i?(e.emit("error",new Error("Invalid messageId")),!1):(e.write(w.ACKS[n][s][o][0]),g(e,2),C(e,i))}function c(t,e){var r=t||{},n=r.dup?w.DUP_MASK:0,i=r.messageId,o=r.subscriptions,s=0;if("number"!=typeof i)return e.emit("error",new Error("Invalid messageId")),!1;if(s+=2,"object"!=typeof o||!o.length)return e.emit("error",new Error("Invalid subscriptions")),!1;for(var a=0;a<o.length;a+=1){var u=o[a].topic,c=o[a].qos;if("string"!=typeof u)return e.emit("error",new Error("Invalid subscriptions - invalid topic")),!1;if("number"!=typeof c)return e.emit("error",new Error("Invalid subscriptions - invalid qos")),!1;s+=S.byteLength(u)+2+1}e.write(w.SUBSCRIBE_HEADER[1][n?1:0][0]),g(e,s),C(e,i);for(var h=!0,f=0;f<o.length;f++){var l=o[f],p=l.topic,d=l.qos;b(e,p),h=e.write(w.QOS[d])}return h}function h(t,e){var r=t||{},n=r.messageId,i=r.granted,o=0;if("number"!=typeof n)return e.emit("error",new Error("Invalid messageId")),!1;if(o+=2,"object"!=typeof i||!i.length)return e.emit("error",new Error("Invalid qos vector")),!1;for(var s=0;s<i.length;s+=1){if("number"!=typeof i[s])return e.emit("error",new Error("Invalid qos vector")),!1;o+=1}return e.write(w.SUBACK_HEADER),g(e,o),C(e,n),e.write(S.from(i))}function f(t,e){var r=t||{},n=r.messageId,i=r.dup?w.DUP_MASK:0,o=r.unsubscriptions,s=0;if("number"!=typeof n)return e.emit("error",new Error("Invalid messageId")),!1;if(s+=2,"object"!=typeof o||!o.length)return e.emit("error",new Error("Invalid unsubscriptions")),!1;for(var a=0;a<o.length;a+=1){if("string"!=typeof o[a])return e.emit("error",new Error("Invalid unsubscriptions")),!1;s+=S.byteLength(o[a])+2}e.write(w.UNSUBSCRIBE_HEADER[1][i?1:0][0]),g(e,s),C(e,n);for(var u=!0,c=0;c<o.length;c++)u=b(e,o[c]);return u}function l(t,e){return e.write(w.EMPTY[t.cmd])}function p(t){return t>=0&&128>t?1:t>=128&&16384>t?2:t>=16384&&2097152>t?3:t>=2097152&&268435456>t?4:0}function d(t){var e=0,r=0,n=S.allocUnsafe(p(t));do e=t%128|0,t=t/128|0,t>0&&(e=128|e),n.writeUInt8(e,r++,!0);while(t>0);return n}function g(t,e){var r=L[e];r||(r=d(e),16384>e&&(L[e]=r)),t.write(r)}function b(t,e){var r=S.byteLength(e);C(t,r),t.write(e,"utf8")}function m(t,e){return t.write(A[e])}function y(t,e){return t.write(T(e))}function v(t,e){e&&"string"==typeof e?b(t,e):e?(C(t,e.length),t.write(e)):C(t,0)}function _(t){return t?S.isBuffer(t)?t.length:S.byteLength(t):0}var w=t("./constants"),S=t("safe-buffer").Buffer,E=S.allocUnsafe(0),k=S.from([0]),I=t("./numbers"),x=t("process-nextick-args"),A=I.cache,T=I.generateNumber,M=I.generateCache,C=m,j=!0;Object.defineProperty(n,"cacheNumbers",{get:function(){return C===m},set:function(t){t?(A&&0!==Object.keys(A).length||(j=!0),C=m):(j=!1,C=y)}});var L={};e.exports=n},{"./constants":31,"./numbers":34,"process-nextick-args":39,"safe-buffer":51}],38:[function(t,e,r){function n(t){var e=function(){return e.called?e.value:(e.called=!0,e.value=t.apply(this,arguments))};return e.called=!1,e}function i(t){var e=function(){if(e.called)throw new Error(e.onceError);return e.called=!0,e.value=t.apply(this,arguments)},r=t.name||"Function wrapped with `once`";return e.onceError=r+" shouldn't be called more than once",e.called=!1,e}var o=t("wrappy");e.exports=o(n),e.exports.strict=o(i),n.proto=n(function(){Object.defineProperty(Function.prototype,"once",{value:function(){return n(this)},configurable:!0}),Object.defineProperty(Function.prototype,"onceStrict",{value:function(){return i(this)},configurable:!0})})},{wrappy:57}],39:[function(t,e,r){(function(t){"use strict";function r(e,r,n,i){if("function"!=typeof e)throw new TypeError('"callback" argument must be a function');var o,s,a=arguments.length;switch(a){case 0:case 1:return t.nextTick(e);case 2:return t.nextTick(function(){e.call(null,r)});case 3:return t.nextTick(function(){e.call(null,r,n)});case 4:return t.nextTick(function(){e.call(null,r,n,i)});default:for(o=new Array(a-1),s=0;s<o.length;)o[s++]=arguments[s];return t.nextTick(function(){e.apply(null,o)})}}!t.version||0===t.version.indexOf("v0.")||0===t.version.indexOf("v1.")&&0!==t.version.indexOf("v1.8.")?e.exports=r:e.exports=t.nextTick}).call(this,t("_process"))},{_process:7}],40:[function(t,e,r){e.exports=t("./lib/_stream_duplex.js")},{"./lib/_stream_duplex.js":41}],41:[function(t,e,r){"use strict";function n(t){return this instanceof n?(c.call(this,t),h.call(this,t),t&&t.readable===!1&&(this.readable=!1),t&&t.writable===!1&&(this.writable=!1),this.allowHalfOpen=!0,t&&t.allowHalfOpen===!1&&(this.allowHalfOpen=!1),void this.once("end",i)):new n(t)}function i(){this.allowHalfOpen||this._writableState.ended||s(o,this)}function o(t){t.end()}var s=t("process-nextick-args"),a=Object.keys||function(t){var e=[];for(var r in t)e.push(r);return e};e.exports=n;var u=t("core-util-is");u.inherits=t("inherits");var c=t("./_stream_readable"),h=t("./_stream_writable");u.inherits(n,c);for(var f=a(h.prototype),l=0;l<f.length;l++){var p=f[l];n.prototype[p]||(n.prototype[p]=h.prototype[p])}Object.defineProperty(n.prototype,"destroyed",{get:function(){return void 0===this._readableState||void 0===this._writableState?!1:this._readableState.destroyed&&this._writableState.destroyed},set:function(t){void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed=t,this._writableState.destroyed=t)}}),n.prototype._destroy=function(t,e){this.push(null),this.end(),s(e,t)}},{"./_stream_readable":43,"./_stream_writable":45,"core-util-is":26,inherits:29,"process-nextick-args":39}],42:[function(t,e,r){"use strict";function n(t){return this instanceof n?void i.call(this,t):new n(t)}e.exports=n;var i=t("./_stream_transform"),o=t("core-util-is");o.inherits=t("inherits"),o.inherits(n,i),n.prototype._transform=function(t,e,r){r(null,t)}},{"./_stream_transform":44,"core-util-is":26,inherits:29}],43:[function(t,e,r){(function(r,n){"use strict";function i(t){return N.from(t)}function o(t){return N.isBuffer(t)||t instanceof q}function s(t,e,r){return"function"==typeof t.prependListener?t.prependListener(e,r):void(t._events&&t._events[e]?R(t._events[e])?t._events[e].unshift(r):t._events[e]=[r,t._events[e]]:t.on(e,r))}function a(e,r){O=O||t("./_stream_duplex"),e=e||{},this.objectMode=!!e.objectMode,r instanceof O&&(this.objectMode=this.objectMode||!!e.readableObjectMode);var n=e.highWaterMark,i=this.objectMode?16:16384;this.highWaterMark=n||0===n?n:i,this.highWaterMark=Math.floor(this.highWaterMark),this.buffer=new H,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=!1,this.endEmitted=!1,this.reading=!1,this.sync=!0,this.needReadable=!1,this.emittedReadable=!1,this.readableListening=!1,this.resumeScheduled=!1,this.destroyed=!1,this.defaultEncoding=e.defaultEncoding||"utf8",this.awaitDrain=0,this.readingMore=!1,this.decoder=null,this.encoding=null,e.encoding&&(F||(F=t("string_decoder/").StringDecoder),this.decoder=new F(e.encoding),this.encoding=e.encoding)}function u(e){return O=O||t("./_stream_duplex"),this instanceof u?(this._readableState=new a(e,this),this.readable=!0,e&&("function"==typeof e.read&&(this._read=e.read),"function"==typeof e.destroy&&(this._destroy=e.destroy)),void B.call(this)):new u(e)}function c(t,e,r,n,o){var s=t._readableState;if(null===e)s.reading=!1,g(t,s);else{var a;o||(a=f(s,e)),a?t.emit("error",a):s.objectMode||e&&e.length>0?("string"==typeof e||s.objectMode||Object.getPrototypeOf(e)===N.prototype||(e=i(e)),n?s.endEmitted?t.emit("error",new Error("stream.unshift() after end event")):h(t,s,e,!0):s.ended?t.emit("error",new Error("stream.push() after EOF")):(s.reading=!1,s.decoder&&!r?(e=s.decoder.write(e),s.objectMode||0!==e.length?h(t,s,e,!1):y(t,s)):h(t,s,e,!1))):n||(s.reading=!1)}return l(s)}function h(t,e,r,n){e.flowing&&0===e.length&&!e.sync?(t.emit("data",r),t.read(0)):(e.length+=e.objectMode?1:r.length,n?e.buffer.unshift(r):e.buffer.push(r),e.needReadable&&b(t)),y(t,e)}function f(t,e){var r;return o(e)||"string"==typeof e||void 0===e||t.objectMode||(r=new TypeError("Invalid non-string/buffer chunk")),r}function l(t){return!t.ended&&(t.needReadable||t.length<t.highWaterMark||0===t.length)}function p(t){return t>=Q?t=Q:(t--,t|=t>>>1,t|=t>>>2,t|=t>>>4,t|=t>>>8,t|=t>>>16,t++),t}function d(t,e){return 0>=t||0===e.length&&e.ended?0:e.objectMode?1:t!==t?e.flowing&&e.length?e.buffer.head.data.length:e.length:(t>e.highWaterMark&&(e.highWaterMark=p(t)),t<=e.length?t:e.ended?e.length:(e.needReadable=!0,0))}function g(t,e){if(!e.ended){if(e.decoder){var r=e.decoder.end();r&&r.length&&(e.buffer.push(r),e.length+=e.objectMode?1:r.length)}e.ended=!0,b(t)}}function b(t){var e=t._readableState;e.needReadable=!1,e.emittedReadable||(W("emitReadable",e.flowing),e.emittedReadable=!0,e.sync?L(m,t):m(t))}function m(t){W("emit readable"),t.emit("readable"),k(t)}function y(t,e){e.readingMore||(e.readingMore=!0,L(v,t,e))}function v(t,e){for(var r=e.length;!e.reading&&!e.flowing&&!e.ended&&e.length<e.highWaterMark&&(W("maybeReadMore read 0"),t.read(0),r!==e.length);)r=e.length;e.readingMore=!1}function _(t){return function(){var e=t._readableState;W("pipeOnDrain",e.awaitDrain),e.awaitDrain&&e.awaitDrain--,0===e.awaitDrain&&U(t,"data")&&(e.flowing=!0,k(t))}}function w(t){W("readable nexttick read 0"),t.read(0)}function S(t,e){e.resumeScheduled||(e.resumeScheduled=!0,L(E,t,e))}function E(t,e){e.reading||(W("resume read 0"),t.read(0)),e.resumeScheduled=!1,e.awaitDrain=0,t.emit("resume"),k(t),e.flowing&&!e.reading&&t.read(0)}function k(t){var e=t._readableState;for(W("flow",e.flowing);e.flowing&&null!==t.read(););}function I(t,e){if(0===e.length)return null;var r;return e.objectMode?r=e.buffer.shift():!t||t>=e.length?(r=e.decoder?e.buffer.join(""):1===e.buffer.length?e.buffer.head.data:e.buffer.concat(e.length),e.buffer.clear()):r=x(t,e.buffer,e.decoder),r}function x(t,e,r){var n;return t<e.head.data.length?(n=e.head.data.slice(0,t),e.head.data=e.head.data.slice(t)):n=t===e.head.data.length?e.shift():r?A(t,e):T(t,e),n}function A(t,e){var r=e.head,n=1,i=r.data;for(t-=i.length;r=r.next;){var o=r.data,s=t>o.length?o.length:t;if(i+=s===o.length?o:o.slice(0,t),t-=s,0===t){s===o.length?(++n,r.next?e.head=r.next:e.head=e.tail=null):(e.head=r,r.data=o.slice(s));break}++n}return e.length-=n,i}function T(t,e){var r=N.allocUnsafe(t),n=e.head,i=1;for(n.data.copy(r),t-=n.data.length;n=n.next;){var o=n.data,s=t>o.length?o.length:t;if(o.copy(r,r.length-t,0,s),t-=s,0===t){s===o.length?(++i,n.next?e.head=n.next:e.head=e.tail=null):(e.head=n,n.data=o.slice(s));break}++i}return e.length-=i,r}function M(t){var e=t._readableState;if(e.length>0)throw new Error('"endReadable()" called on non-empty stream');e.endEmitted||(e.ended=!0,L(C,e,t))}function C(t,e){t.endEmitted||0!==t.length||(t.endEmitted=!0,e.readable=!1,e.emit("end"))}function j(t,e){for(var r=0,n=t.length;n>r;r++)if(t[r]===e)return r;return-1}var L=t("process-nextick-args");e.exports=u;var O,R=t("isarray");u.ReadableState=a;var U=(t("events").EventEmitter,function(t,e){return t.listeners(e).length}),B=t("./internal/streams/stream"),N=t("safe-buffer").Buffer,q=n.Uint8Array||function(){},P=t("core-util-is");P.inherits=t("inherits");var D=t("util"),W=void 0;W=D&&D.debuglog?D.debuglog("stream"):function(){};
var F,H=t("./internal/streams/BufferList"),z=t("./internal/streams/destroy");P.inherits(u,B);var K=["error","close","destroy","pause","resume"];Object.defineProperty(u.prototype,"destroyed",{get:function(){return void 0===this._readableState?!1:this._readableState.destroyed},set:function(t){this._readableState&&(this._readableState.destroyed=t)}}),u.prototype.destroy=z.destroy,u.prototype._undestroy=z.undestroy,u.prototype._destroy=function(t,e){this.push(null),e(t)},u.prototype.push=function(t,e){var r,n=this._readableState;return n.objectMode?r=!0:"string"==typeof t&&(e=e||n.defaultEncoding,e!==n.encoding&&(t=N.from(t,e),e=""),r=!0),c(this,t,e,!1,r)},u.prototype.unshift=function(t){return c(this,t,null,!0,!1)},u.prototype.isPaused=function(){return this._readableState.flowing===!1},u.prototype.setEncoding=function(e){return F||(F=t("string_decoder/").StringDecoder),this._readableState.decoder=new F(e),this._readableState.encoding=e,this};var Q=8388608;u.prototype.read=function(t){W("read",t),t=parseInt(t,10);var e=this._readableState,r=t;if(0!==t&&(e.emittedReadable=!1),0===t&&e.needReadable&&(e.length>=e.highWaterMark||e.ended))return W("read: emitReadable",e.length,e.ended),0===e.length&&e.ended?M(this):b(this),null;if(t=d(t,e),0===t&&e.ended)return 0===e.length&&M(this),null;var n=e.needReadable;W("need readable",n),(0===e.length||e.length-t<e.highWaterMark)&&(n=!0,W("length less than watermark",n)),e.ended||e.reading?(n=!1,W("reading or ended",n)):n&&(W("do read"),e.reading=!0,e.sync=!0,0===e.length&&(e.needReadable=!0),this._read(e.highWaterMark),e.sync=!1,e.reading||(t=d(r,e)));var i;return i=t>0?I(t,e):null,null===i?(e.needReadable=!0,t=0):e.length-=t,0===e.length&&(e.ended||(e.needReadable=!0),r!==t&&e.ended&&M(this)),null!==i&&this.emit("data",i),i},u.prototype._read=function(t){this.emit("error",new Error("_read() is not implemented"))},u.prototype.pipe=function(t,e){function n(t,e){W("onunpipe"),t===l&&e&&e.hasUnpiped===!1&&(e.hasUnpiped=!0,o())}function i(){W("onend"),t.end()}function o(){W("cleanup"),t.removeListener("close",c),t.removeListener("finish",h),t.removeListener("drain",b),t.removeListener("error",u),t.removeListener("unpipe",n),l.removeListener("end",i),l.removeListener("end",f),l.removeListener("data",a),m=!0,!p.awaitDrain||t._writableState&&!t._writableState.needDrain||b()}function a(e){W("ondata"),y=!1;var r=t.write(e);!1!==r||y||((1===p.pipesCount&&p.pipes===t||p.pipesCount>1&&-1!==j(p.pipes,t))&&!m&&(W("false write response, pause",l._readableState.awaitDrain),l._readableState.awaitDrain++,y=!0),l.pause())}function u(e){W("onerror",e),f(),t.removeListener("error",u),0===U(t,"error")&&t.emit("error",e)}function c(){t.removeListener("finish",h),f()}function h(){W("onfinish"),t.removeListener("close",c),f()}function f(){W("unpipe"),l.unpipe(t)}var l=this,p=this._readableState;switch(p.pipesCount){case 0:p.pipes=t;break;case 1:p.pipes=[p.pipes,t];break;default:p.pipes.push(t)}p.pipesCount+=1,W("pipe count=%d opts=%j",p.pipesCount,e);var d=(!e||e.end!==!1)&&t!==r.stdout&&t!==r.stderr,g=d?i:f;p.endEmitted?L(g):l.once("end",g),t.on("unpipe",n);var b=_(l);t.on("drain",b);var m=!1,y=!1;return l.on("data",a),s(t,"error",u),t.once("close",c),t.once("finish",h),t.emit("pipe",l),p.flowing||(W("pipe resume"),l.resume()),t},u.prototype.unpipe=function(t){var e=this._readableState,r={hasUnpiped:!1};if(0===e.pipesCount)return this;if(1===e.pipesCount)return t&&t!==e.pipes?this:(t||(t=e.pipes),e.pipes=null,e.pipesCount=0,e.flowing=!1,t&&t.emit("unpipe",this,r),this);if(!t){var n=e.pipes,i=e.pipesCount;e.pipes=null,e.pipesCount=0,e.flowing=!1;for(var o=0;i>o;o++)n[o].emit("unpipe",this,r);return this}var s=j(e.pipes,t);return-1===s?this:(e.pipes.splice(s,1),e.pipesCount-=1,1===e.pipesCount&&(e.pipes=e.pipes[0]),t.emit("unpipe",this,r),this)},u.prototype.on=function(t,e){var r=B.prototype.on.call(this,t,e);if("data"===t)this._readableState.flowing!==!1&&this.resume();else if("readable"===t){var n=this._readableState;n.endEmitted||n.readableListening||(n.readableListening=n.needReadable=!0,n.emittedReadable=!1,n.reading?n.length&&b(this):L(w,this))}return r},u.prototype.addListener=u.prototype.on,u.prototype.resume=function(){var t=this._readableState;return t.flowing||(W("resume"),t.flowing=!0,S(this,t)),this},u.prototype.pause=function(){return W("call pause flowing=%j",this._readableState.flowing),!1!==this._readableState.flowing&&(W("pause"),this._readableState.flowing=!1,this.emit("pause")),this},u.prototype.wrap=function(t){var e=this._readableState,r=!1,n=this;t.on("end",function(){if(W("wrapped end"),e.decoder&&!e.ended){var t=e.decoder.end();t&&t.length&&n.push(t)}n.push(null)}),t.on("data",function(i){if(W("wrapped data"),e.decoder&&(i=e.decoder.write(i)),(!e.objectMode||null!==i&&void 0!==i)&&(e.objectMode||i&&i.length)){var o=n.push(i);o||(r=!0,t.pause())}});for(var i in t)void 0===this[i]&&"function"==typeof t[i]&&(this[i]=function(e){return function(){return t[e].apply(t,arguments)}}(i));for(var o=0;o<K.length;o++)t.on(K[o],n.emit.bind(n,K[o]));return n._read=function(e){W("wrapped _read",e),r&&(r=!1,t.resume())},n},u._fromList=I}).call(this,t("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./_stream_duplex":41,"./internal/streams/BufferList":46,"./internal/streams/destroy":47,"./internal/streams/stream":48,_process:7,"core-util-is":26,events:4,inherits:29,isarray:30,"process-nextick-args":39,"safe-buffer":51,"string_decoder/":53,util:2}],44:[function(t,e,r){"use strict";function n(t){this.afterTransform=function(e,r){return i(t,e,r)},this.needTransform=!1,this.transforming=!1,this.writecb=null,this.writechunk=null,this.writeencoding=null}function i(t,e,r){var n=t._transformState;n.transforming=!1;var i=n.writecb;if(!i)return t.emit("error",new Error("write callback called multiple times"));n.writechunk=null,n.writecb=null,null!==r&&void 0!==r&&t.push(r),i(e);var o=t._readableState;o.reading=!1,(o.needReadable||o.length<o.highWaterMark)&&t._read(o.highWaterMark)}function o(t){if(!(this instanceof o))return new o(t);a.call(this,t),this._transformState=new n(this);var e=this;this._readableState.needReadable=!0,this._readableState.sync=!1,t&&("function"==typeof t.transform&&(this._transform=t.transform),"function"==typeof t.flush&&(this._flush=t.flush)),this.once("prefinish",function(){"function"==typeof this._flush?this._flush(function(t,r){s(e,t,r)}):s(e)})}function s(t,e,r){if(e)return t.emit("error",e);null!==r&&void 0!==r&&t.push(r);var n=t._writableState,i=t._transformState;if(n.length)throw new Error("Calling transform done when ws.length != 0");if(i.transforming)throw new Error("Calling transform done when still transforming");return t.push(null)}e.exports=o;var a=t("./_stream_duplex"),u=t("core-util-is");u.inherits=t("inherits"),u.inherits(o,a),o.prototype.push=function(t,e){return this._transformState.needTransform=!1,a.prototype.push.call(this,t,e)},o.prototype._transform=function(t,e,r){throw new Error("_transform() is not implemented")},o.prototype._write=function(t,e,r){var n=this._transformState;if(n.writecb=r,n.writechunk=t,n.writeencoding=e,!n.transforming){var i=this._readableState;(n.needTransform||i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark)}},o.prototype._read=function(t){var e=this._transformState;null!==e.writechunk&&e.writecb&&!e.transforming?(e.transforming=!0,this._transform(e.writechunk,e.writeencoding,e.afterTransform)):e.needTransform=!0},o.prototype._destroy=function(t,e){var r=this;a.prototype._destroy.call(this,t,function(t){e(t),r.emit("close")})}},{"./_stream_duplex":41,"core-util-is":26,inherits:29}],45:[function(t,e,r){(function(r,n){"use strict";function i(t){var e=this;this.next=null,this.entry=null,this.finish=function(){x(e,t)}}function o(t){return O.from(t)}function s(t){return O.isBuffer(t)||t instanceof R}function a(){}function u(e,r){T=T||t("./_stream_duplex"),e=e||{},this.objectMode=!!e.objectMode,r instanceof T&&(this.objectMode=this.objectMode||!!e.writableObjectMode);var n=e.highWaterMark,o=this.objectMode?16:16384;this.highWaterMark=n||0===n?n:o,this.highWaterMark=Math.floor(this.highWaterMark),this.finalCalled=!1,this.needDrain=!1,this.ending=!1,this.ended=!1,this.finished=!1,this.destroyed=!1;var s=e.decodeStrings===!1;this.decodeStrings=!s,this.defaultEncoding=e.defaultEncoding||"utf8",this.length=0,this.writing=!1,this.corked=0,this.sync=!0,this.bufferProcessing=!1,this.onwrite=function(t){m(r,t)},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=!1,this.errorEmitted=!1,this.bufferedRequestCount=0,this.corkedRequestsFree=new i(this)}function c(e){return T=T||t("./_stream_duplex"),B.call(c,this)||this instanceof T?(this._writableState=new u(e,this),this.writable=!0,e&&("function"==typeof e.write&&(this._write=e.write),"function"==typeof e.writev&&(this._writev=e.writev),"function"==typeof e.destroy&&(this._destroy=e.destroy),"function"==typeof e["final"]&&(this._final=e["final"])),void L.call(this)):new c(e)}function h(t,e){var r=new Error("write after end");t.emit("error",r),A(e,r)}function f(t,e,r,n){var i=!0,o=!1;return null===r?o=new TypeError("May not write null values to stream"):"string"==typeof r||void 0===r||e.objectMode||(o=new TypeError("Invalid non-string/buffer chunk")),o&&(t.emit("error",o),A(n,o),i=!1),i}function l(t,e,r){return t.objectMode||t.decodeStrings===!1||"string"!=typeof e||(e=O.from(e,r)),e}function p(t,e,r,n,i,o){if(!r){var s=l(e,n,i);n!==s&&(r=!0,i="buffer",n=s)}var a=e.objectMode?1:n.length;e.length+=a;var u=e.length<e.highWaterMark;if(u||(e.needDrain=!0),e.writing||e.corked){var c=e.lastBufferedRequest;e.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:o,next:null},c?c.next=e.lastBufferedRequest:e.bufferedRequest=e.lastBufferedRequest,e.bufferedRequestCount+=1}else d(t,e,!1,a,n,i,o);return u}function d(t,e,r,n,i,o,s){e.writelen=n,e.writecb=s,e.writing=!0,e.sync=!0,r?t._writev(i,e.onwrite):t._write(i,o,e.onwrite),e.sync=!1}function g(t,e,r,n,i){--e.pendingcb,r?(A(i,n),A(k,t,e),t._writableState.errorEmitted=!0,t.emit("error",n)):(i(n),t._writableState.errorEmitted=!0,t.emit("error",n),k(t,e))}function b(t){t.writing=!1,t.writecb=null,t.length-=t.writelen,t.writelen=0}function m(t,e){var r=t._writableState,n=r.sync,i=r.writecb;if(b(r),e)g(t,r,n,e,i);else{var o=w(r);o||r.corked||r.bufferProcessing||!r.bufferedRequest||_(t,r),n?M(y,t,r,o,i):y(t,r,o,i)}}function y(t,e,r,n){r||v(t,e),e.pendingcb--,n(),k(t,e)}function v(t,e){0===e.length&&e.needDrain&&(e.needDrain=!1,t.emit("drain"))}function _(t,e){e.bufferProcessing=!0;var r=e.bufferedRequest;if(t._writev&&r&&r.next){var n=e.bufferedRequestCount,o=new Array(n),s=e.corkedRequestsFree;s.entry=r;for(var a=0,u=!0;r;)o[a]=r,r.isBuf||(u=!1),r=r.next,a+=1;o.allBuffers=u,d(t,e,!0,e.length,o,"",s.finish),e.pendingcb++,e.lastBufferedRequest=null,s.next?(e.corkedRequestsFree=s.next,s.next=null):e.corkedRequestsFree=new i(e)}else{for(;r;){var c=r.chunk,h=r.encoding,f=r.callback,l=e.objectMode?1:c.length;if(d(t,e,!1,l,c,h,f),r=r.next,e.writing)break}null===r&&(e.lastBufferedRequest=null)}e.bufferedRequestCount=0,e.bufferedRequest=r,e.bufferProcessing=!1}function w(t){return t.ending&&0===t.length&&null===t.bufferedRequest&&!t.finished&&!t.writing}function S(t,e){t._final(function(r){e.pendingcb--,r&&t.emit("error",r),e.prefinished=!0,t.emit("prefinish"),k(t,e)})}function E(t,e){e.prefinished||e.finalCalled||("function"==typeof t._final?(e.pendingcb++,e.finalCalled=!0,A(S,t,e)):(e.prefinished=!0,t.emit("prefinish")))}function k(t,e){var r=w(e);return r&&(E(t,e),0===e.pendingcb&&(e.finished=!0,t.emit("finish"))),r}function I(t,e,r){e.ending=!0,k(t,e),r&&(e.finished?A(r):t.once("finish",r)),e.ended=!0,t.writable=!1}function x(t,e,r){var n=t.entry;for(t.entry=null;n;){var i=n.callback;e.pendingcb--,i(r),n=n.next}e.corkedRequestsFree?e.corkedRequestsFree.next=t:e.corkedRequestsFree=t}var A=t("process-nextick-args");e.exports=c;var T,M=!r.browser&&["v0.10","v0.9."].indexOf(r.version.slice(0,5))>-1?setImmediate:A;c.WritableState=u;var C=t("core-util-is");C.inherits=t("inherits");var j={deprecate:t("util-deprecate")},L=t("./internal/streams/stream"),O=t("safe-buffer").Buffer,R=n.Uint8Array||function(){},U=t("./internal/streams/destroy");C.inherits(c,L),u.prototype.getBuffer=function(){for(var t=this.bufferedRequest,e=[];t;)e.push(t),t=t.next;return e},function(){try{Object.defineProperty(u.prototype,"buffer",{get:j.deprecate(function(){return this.getBuffer()},"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.","DEP0003")})}catch(t){}}();var B;"function"==typeof Symbol&&Symbol.hasInstance&&"function"==typeof Function.prototype[Symbol.hasInstance]?(B=Function.prototype[Symbol.hasInstance],Object.defineProperty(c,Symbol.hasInstance,{value:function(t){return B.call(this,t)?!0:t&&t._writableState instanceof u}})):B=function(t){return t instanceof this},c.prototype.pipe=function(){this.emit("error",new Error("Cannot pipe, not readable"))},c.prototype.write=function(t,e,r){var n=this._writableState,i=!1,u=s(t)&&!n.objectMode;return u&&!O.isBuffer(t)&&(t=o(t)),"function"==typeof e&&(r=e,e=null),u?e="buffer":e||(e=n.defaultEncoding),"function"!=typeof r&&(r=a),n.ended?h(this,r):(u||f(this,n,t,r))&&(n.pendingcb++,i=p(this,n,u,t,e,r)),i},c.prototype.cork=function(){var t=this._writableState;t.corked++},c.prototype.uncork=function(){var t=this._writableState;t.corked&&(t.corked--,t.writing||t.corked||t.finished||t.bufferProcessing||!t.bufferedRequest||_(this,t))},c.prototype.setDefaultEncoding=function(t){if("string"==typeof t&&(t=t.toLowerCase()),!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((t+"").toLowerCase())>-1))throw new TypeError("Unknown encoding: "+t);return this._writableState.defaultEncoding=t,this},c.prototype._write=function(t,e,r){r(new Error("_write() is not implemented"))},c.prototype._writev=null,c.prototype.end=function(t,e,r){var n=this._writableState;"function"==typeof t?(r=t,t=null,e=null):"function"==typeof e&&(r=e,e=null),null!==t&&void 0!==t&&this.write(t,e),n.corked&&(n.corked=1,this.uncork()),n.ending||n.finished||I(this,n,r)},Object.defineProperty(c.prototype,"destroyed",{get:function(){return void 0===this._writableState?!1:this._writableState.destroyed},set:function(t){this._writableState&&(this._writableState.destroyed=t)}}),c.prototype.destroy=U.destroy,c.prototype._undestroy=U.undestroy,c.prototype._destroy=function(t,e){this.end(),e(t)}}).call(this,t("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./_stream_duplex":41,"./internal/streams/destroy":47,"./internal/streams/stream":48,_process:7,"core-util-is":26,inherits:29,"process-nextick-args":39,"safe-buffer":51,"util-deprecate":54}],46:[function(t,e,r){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e,r){t.copy(e,r)}var o=t("safe-buffer").Buffer;e.exports=function(){function t(){n(this,t),this.head=null,this.tail=null,this.length=0}return t.prototype.push=function(t){var e={data:t,next:null};this.length>0?this.tail.next=e:this.head=e,this.tail=e,++this.length},t.prototype.unshift=function(t){var e={data:t,next:this.head};0===this.length&&(this.tail=e),this.head=e,++this.length},t.prototype.shift=function(){if(0!==this.length){var t=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,t}},t.prototype.clear=function(){this.head=this.tail=null,this.length=0},t.prototype.join=function(t){if(0===this.length)return"";for(var e=this.head,r=""+e.data;e=e.next;)r+=t+e.data;return r},t.prototype.concat=function(t){if(0===this.length)return o.alloc(0);if(1===this.length)return this.head.data;for(var e=o.allocUnsafe(t>>>0),r=this.head,n=0;r;)i(r.data,e,n),n+=r.data.length,r=r.next;return e},t}()},{"safe-buffer":51}],47:[function(t,e,r){"use strict";function n(t,e){var r=this,n=this._readableState&&this._readableState.destroyed,i=this._writableState&&this._writableState.destroyed;return n||i?void(e?e(t):!t||this._writableState&&this._writableState.errorEmitted||s(o,this,t)):(this._readableState&&(this._readableState.destroyed=!0),this._writableState&&(this._writableState.destroyed=!0),void this._destroy(t||null,function(t){!e&&t?(s(o,r,t),r._writableState&&(r._writableState.errorEmitted=!0)):e&&e(t)}))}function i(){this._readableState&&(this._readableState.destroyed=!1,this._readableState.reading=!1,this._readableState.ended=!1,this._readableState.endEmitted=!1),this._writableState&&(this._writableState.destroyed=!1,this._writableState.ended=!1,this._writableState.ending=!1,this._writableState.finished=!1,this._writableState.errorEmitted=!1)}function o(t,e){t.emit("error",e)}var s=t("process-nextick-args");e.exports={destroy:n,undestroy:i}},{"process-nextick-args":39}],48:[function(t,e,r){e.exports=t("events").EventEmitter},{events:4}],49:[function(t,e,r){r=e.exports=t("./lib/_stream_readable.js"),r.Stream=r,r.Readable=r,r.Writable=t("./lib/_stream_writable.js"),r.Duplex=t("./lib/_stream_duplex.js"),r.Transform=t("./lib/_stream_transform.js"),r.PassThrough=t("./lib/_stream_passthrough.js")},{"./lib/_stream_duplex.js":41,"./lib/_stream_passthrough.js":42,"./lib/_stream_readable.js":43,"./lib/_stream_transform.js":44,"./lib/_stream_writable.js":45}],50:[function(t,e,r){"use strict";function n(t,e,r){var n=this;this._callback=t,this._args=r,this._interval=setInterval(t,e,this._args),this.reschedule=function(t){t||(t=n._interval),n._interval&&clearInterval(n._interval),n._interval=setInterval(n._callback,t,n._args)},this.clear=function(){n._interval&&(clearInterval(n._interval),n._interval=void 0)},this.destroy=function(){n._interval&&clearInterval(n._interval),n._callback=void 0,n._interval=void 0,n._args=void 0}}function i(){if("function"!=typeof arguments[0])throw new Error("callback needed");if("number"!=typeof arguments[1])throw new Error("interval needed");var t;if(arguments.length>0){t=new Array(arguments.length-2);for(var e=0;e<t.length;e++)t[e]=arguments[e+2]}return new n(arguments[0],arguments[1],t)}e.exports=i},{}],51:[function(t,e,r){function n(t,e){for(var r in t)e[r]=t[r]}function i(t,e,r){return s(t,e,r)}var o=t("buffer"),s=o.Buffer;s.from&&s.alloc&&s.allocUnsafe&&s.allocUnsafeSlow?e.exports=o:(n(o,r),r.Buffer=i),n(s,i),i.from=function(t,e,r){if("number"==typeof t)throw new TypeError("Argument must not be a number");return s(t,e,r)},i.alloc=function(t,e,r){if("number"!=typeof t)throw new TypeError("Argument must be a number");var n=s(t);return void 0!==e?"string"==typeof r?n.fill(e,r):n.fill(e):n.fill(0),n},i.allocUnsafe=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return s(t)},i.allocUnsafeSlow=function(t){if("number"!=typeof t)throw new TypeError("Argument must be a number");return o.SlowBuffer(t)}},{buffer:3}],52:[function(t,e,r){function n(t){var e=t._readableState;return e?e.objectMode?t.read():t.read(i(e)):null}function i(t){return t.buffer.length?t.buffer.head?t.buffer.head.data.length:t.buffer[0].length:t.length}e.exports=n},{}],53:[function(t,e,r){"use strict";function n(t){if(!t)return"utf8";for(var e;;)switch(t){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return t;default:if(e)return;t=(""+t).toLowerCase(),e=!0}}function i(t){var e=n(t);if("string"!=typeof e&&(y.isEncoding===v||!v(t)))throw new Error("Unknown encoding: "+t);return e||t}function o(t){this.encoding=i(t);var e;switch(this.encoding){case"utf16le":this.text=l,this.end=p,e=4;break;case"utf8":this.fillLast=c,e=4;break;case"base64":this.text=d,this.end=g,e=3;break;default:return this.write=b,void(this.end=m)}this.lastNeed=0,this.lastTotal=0,this.lastChar=y.allocUnsafe(e)}function s(t){return 127>=t?0:t>>5===6?2:t>>4===14?3:t>>3===30?4:-1}function a(t,e,r){var n=e.length-1;if(r>n)return 0;var i=s(e[n]);return i>=0?(i>0&&(t.lastNeed=i-1),i):--n<r?0:(i=s(e[n]),i>=0?(i>0&&(t.lastNeed=i-2),i):--n<r?0:(i=s(e[n]),i>=0?(i>0&&(2===i?i=0:t.lastNeed=i-3),i):0))}function u(t,e,r){if(128!==(192&e[0]))return t.lastNeed=0,"�".repeat(r);if(t.lastNeed>1&&e.length>1){if(128!==(192&e[1]))return t.lastNeed=1,"�".repeat(r+1);if(t.lastNeed>2&&e.length>2&&128!==(192&e[2]))return t.lastNeed=2,"�".repeat(r+2)}}function c(t){var e=this.lastTotal-this.lastNeed,r=u(this,t,e);return void 0!==r?r:this.lastNeed<=t.length?(t.copy(this.lastChar,e,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(t.copy(this.lastChar,e,0,t.length),void(this.lastNeed-=t.length))}function h(t,e){var r=a(this,t,e);if(!this.lastNeed)return t.toString("utf8",e);this.lastTotal=r;var n=t.length-(r-this.lastNeed);return t.copy(this.lastChar,0,n),t.toString("utf8",e,n)}function f(t){var e=t&&t.length?this.write(t):"";return this.lastNeed?e+"�".repeat(this.lastTotal-this.lastNeed):e}function l(t,e){if((t.length-e)%2===0){var r=t.toString("utf16le",e);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&56319>=n)return this.lastNeed=2,this.lastTotal=4,this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1],r.slice(0,-1)}return r}return this.lastNeed=1,this.lastTotal=2,this.lastChar[0]=t[t.length-1],t.toString("utf16le",e,t.length-1)}function p(t){var e=t&&t.length?this.write(t):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return e+this.lastChar.toString("utf16le",0,r)}return e}function d(t,e){var r=(t.length-e)%3;return 0===r?t.toString("base64",e):(this.lastNeed=3-r,this.lastTotal=3,1===r?this.lastChar[0]=t[t.length-1]:(this.lastChar[0]=t[t.length-2],this.lastChar[1]=t[t.length-1]),t.toString("base64",e,t.length-r))}function g(t){var e=t&&t.length?this.write(t):"";return this.lastNeed?e+this.lastChar.toString("base64",0,3-this.lastNeed):e}function b(t){return t.toString(this.encoding)}function m(t){return t&&t.length?this.write(t):""}var y=t("safe-buffer").Buffer,v=y.isEncoding||function(t){switch(t=""+t,t&&t.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return!0;default:return!1}};r.StringDecoder=o,o.prototype.write=function(t){if(0===t.length)return"";var e,r;if(this.lastNeed){if(e=this.fillLast(t),void 0===e)return"";r=this.lastNeed,this.lastNeed=0}else r=0;return r<t.length?e?e+this.text(t,r):this.text(t,r):e||""},o.prototype.end=f,o.prototype.text=h,o.prototype.fillLast=function(t){return this.lastNeed<=t.length?(t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(t.copy(this.lastChar,this.lastTotal-this.lastNeed,0,t.length),void(this.lastNeed-=t.length))}},{"safe-buffer":51}],54:[function(t,e,r){(function(t){function r(t,e){function r(){if(!i){if(n("throwDeprecation"))throw new Error(e);n("traceDeprecation")?console.trace(e):console.warn(e),i=!0}return t.apply(this,arguments)}if(n("noDeprecation"))return t;var i=!1;return r}function n(e){try{if(!t.localStorage)return!1}catch(r){return!1}var n=t.localStorage[e];return null==n?!1:"true"===String(n).toLowerCase()}e.exports=r}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],55:[function(t,e,r){(function(r,n){"use strict";function i(t,e,n){var i=new s({objectMode:t.objectMode});return i._write=e,i._flush=n,i._destroy=function(t,e){var n=this;this.push(null),this.end(),r.nextTick(function(){e(t),n.emit("close")})},i}function o(t,e,o){function s(t,e,r){return v.readyState!==v.OPEN?void r():(x&&"string"==typeof t&&(t=new c(t,"utf8")),void v.send(t,r))}function h(t,e,r){if(v.bufferedAmount>k)return void setTimeout(h,I,t,e,r);x&&"string"==typeof t&&(t=new c(t,"utf8"));try{v.send(t)}catch(n){return r(n)}r()}function f(t){v.close(),t()}function l(){y.setReadable(E),y.setWritable(E),y.emit("connect")}function p(){y.end(),y.destroy()}function d(t){y.destroy(t)}function g(t){var e=t.data;e=e instanceof ArrayBuffer?c.from(e):c.from(e,"utf8"),E.push(e)}function b(){v.close()}function m(t,e){for(var r=new Array(t.length),n=0;n<t.length;n++)"string"==typeof t[n].chunk?r[n]=c.from(t[n],"utf8"):r[n]=t[n].chunk;this._write(c.concat(r),"binary",e)}var y,v,_="browser"===r.title,w=!!n.WebSocket,S=_?h:s;e&&!Array.isArray(e)&&"object"==typeof e&&(o=e,e=null,("string"==typeof o.protocol||Array.isArray(o.protocol))&&(e=o.protocol)),o||(o={}),void 0===o.objectMode&&(o.objectMode=!(o.binary===!0||void 0===o.binary));var E=i(o,S,f);o.objectMode||(E._writev=m);var k=o.browserBufferSize||524288,I=o.browserBufferTimeout||1e3;"object"==typeof t?v=t:(v=w&&_?new u(t,e):new u(t,e,o),v.binaryType="arraybuffer"),v.readyState===v.OPEN?y=E:(y=a.obj(),v.onopen=l),y.socket=v,v.onclose=p,v.onerror=d,v.onmessage=g,E.on("close",b);var x=!o.objectMode;return y}var s=t("readable-stream").Transform,a=t("duplexify"),u=t("ws"),c=t("safe-buffer").Buffer;e.exports=o}).call(this,t("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{_process:7,duplexify:27,"readable-stream":49,"safe-buffer":51,ws:56}],56:[function(t,e,r){var n=null;"undefined"!=typeof WebSocket?n=WebSocket:"undefined"!=typeof MozWebSocket?n=MozWebSocket:"undefined"!=typeof window&&(n=window.WebSocket||window.MozWebSocket),e.exports=n},{}],57:[function(t,e,r){function n(t,e){function r(){for(var e=new Array(arguments.length),r=0;r<e.length;r++)e[r]=arguments[r];var n=t.apply(this,e),i=e[e.length-1];return"function"==typeof n&&n!==i&&Object.keys(i).forEach(function(t){n[t]=i[t]}),n}if(t&&e)return n(t)(e);if("function"!=typeof t)throw new TypeError("need wrapper function");return Object.keys(t).forEach(function(e){r[e]=t[e]}),r}e.exports=n},{}],58:[function(t,e,r){function n(){for(var t={},e=0;e<arguments.length;e++){var r=arguments[e];for(var n in r)i.call(r,n)&&(t[n]=r[n])}return t}e.exports=n;var i=Object.prototype.hasOwnProperty},{}]},{},[24])(24)});
/*!
 * html2canvas 1.0.0-alpha.12 <https://html2canvas.hertzen.com>
 * Copyright (c) 2018 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["html2canvas"] = factory();
	else
		root["html2canvas"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 27);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://dev.w3.org/csswg/css-color/

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HEX3 = /^#([a-f0-9]{3})$/i;
var hex3 = function hex3(value) {
    var match = value.match(HEX3);
    if (match) {
        return [parseInt(match[1][0] + match[1][0], 16), parseInt(match[1][1] + match[1][1], 16), parseInt(match[1][2] + match[1][2], 16), null];
    }
    return false;
};

var HEX6 = /^#([a-f0-9]{6})$/i;
var hex6 = function hex6(value) {
    var match = value.match(HEX6);
    if (match) {
        return [parseInt(match[1].substring(0, 2), 16), parseInt(match[1].substring(2, 4), 16), parseInt(match[1].substring(4, 6), 16), null];
    }
    return false;
};

var RGB = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var rgb = function rgb(value) {
    var match = value.match(RGB);
    if (match) {
        return [Number(match[1]), Number(match[2]), Number(match[3]), null];
    }
    return false;
};

var RGBA = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;
var rgba = function rgba(value) {
    var match = value.match(RGBA);
    if (match && match.length > 4) {
        return [Number(match[1]), Number(match[2]), Number(match[3]), Number(match[4])];
    }
    return false;
};

var fromArray = function fromArray(array) {
    return [Math.min(array[0], 255), Math.min(array[1], 255), Math.min(array[2], 255), array.length > 3 ? array[3] : null];
};

var namedColor = function namedColor(name) {
    var color = NAMED_COLORS[name.toLowerCase()];
    return color ? color : false;
};

var Color = function () {
    function Color(value) {
        _classCallCheck(this, Color);

        var _ref = Array.isArray(value) ? fromArray(value) : hex3(value) || rgb(value) || rgba(value) || namedColor(value) || hex6(value) || [0, 0, 0, null],
            _ref2 = _slicedToArray(_ref, 4),
            r = _ref2[0],
            g = _ref2[1],
            b = _ref2[2],
            a = _ref2[3];

        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }

    _createClass(Color, [{
        key: 'isTransparent',
        value: function isTransparent() {
            return this.a === 0;
        }
    }, {
        key: 'toString',
        value: function toString() {
            return this.a !== null && this.a !== 1 ? 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',' + this.a + ')' : 'rgb(' + this.r + ',' + this.g + ',' + this.b + ')';
        }
    }]);

    return Color;
}();

exports.default = Color;


var NAMED_COLORS = {
    transparent: [0, 0, 0, 0],
    aliceblue: [240, 248, 255, null],
    antiquewhite: [250, 235, 215, null],
    aqua: [0, 255, 255, null],
    aquamarine: [127, 255, 212, null],
    azure: [240, 255, 255, null],
    beige: [245, 245, 220, null],
    bisque: [255, 228, 196, null],
    black: [0, 0, 0, null],
    blanchedalmond: [255, 235, 205, null],
    blue: [0, 0, 255, null],
    blueviolet: [138, 43, 226, null],
    brown: [165, 42, 42, null],
    burlywood: [222, 184, 135, null],
    cadetblue: [95, 158, 160, null],
    chartreuse: [127, 255, 0, null],
    chocolate: [210, 105, 30, null],
    coral: [255, 127, 80, null],
    cornflowerblue: [100, 149, 237, null],
    cornsilk: [255, 248, 220, null],
    crimson: [220, 20, 60, null],
    cyan: [0, 255, 255, null],
    darkblue: [0, 0, 139, null],
    darkcyan: [0, 139, 139, null],
    darkgoldenrod: [184, 134, 11, null],
    darkgray: [169, 169, 169, null],
    darkgreen: [0, 100, 0, null],
    darkgrey: [169, 169, 169, null],
    darkkhaki: [189, 183, 107, null],
    darkmagenta: [139, 0, 139, null],
    darkolivegreen: [85, 107, 47, null],
    darkorange: [255, 140, 0, null],
    darkorchid: [153, 50, 204, null],
    darkred: [139, 0, 0, null],
    darksalmon: [233, 150, 122, null],
    darkseagreen: [143, 188, 143, null],
    darkslateblue: [72, 61, 139, null],
    darkslategray: [47, 79, 79, null],
    darkslategrey: [47, 79, 79, null],
    darkturquoise: [0, 206, 209, null],
    darkviolet: [148, 0, 211, null],
    deeppink: [255, 20, 147, null],
    deepskyblue: [0, 191, 255, null],
    dimgray: [105, 105, 105, null],
    dimgrey: [105, 105, 105, null],
    dodgerblue: [30, 144, 255, null],
    firebrick: [178, 34, 34, null],
    floralwhite: [255, 250, 240, null],
    forestgreen: [34, 139, 34, null],
    fuchsia: [255, 0, 255, null],
    gainsboro: [220, 220, 220, null],
    ghostwhite: [248, 248, 255, null],
    gold: [255, 215, 0, null],
    goldenrod: [218, 165, 32, null],
    gray: [128, 128, 128, null],
    green: [0, 128, 0, null],
    greenyellow: [173, 255, 47, null],
    grey: [128, 128, 128, null],
    honeydew: [240, 255, 240, null],
    hotpink: [255, 105, 180, null],
    indianred: [205, 92, 92, null],
    indigo: [75, 0, 130, null],
    ivory: [255, 255, 240, null],
    khaki: [240, 230, 140, null],
    lavender: [230, 230, 250, null],
    lavenderblush: [255, 240, 245, null],
    lawngreen: [124, 252, 0, null],
    lemonchiffon: [255, 250, 205, null],
    lightblue: [173, 216, 230, null],
    lightcoral: [240, 128, 128, null],
    lightcyan: [224, 255, 255, null],
    lightgoldenrodyellow: [250, 250, 210, null],
    lightgray: [211, 211, 211, null],
    lightgreen: [144, 238, 144, null],
    lightgrey: [211, 211, 211, null],
    lightpink: [255, 182, 193, null],
    lightsalmon: [255, 160, 122, null],
    lightseagreen: [32, 178, 170, null],
    lightskyblue: [135, 206, 250, null],
    lightslategray: [119, 136, 153, null],
    lightslategrey: [119, 136, 153, null],
    lightsteelblue: [176, 196, 222, null],
    lightyellow: [255, 255, 224, null],
    lime: [0, 255, 0, null],
    limegreen: [50, 205, 50, null],
    linen: [250, 240, 230, null],
    magenta: [255, 0, 255, null],
    maroon: [128, 0, 0, null],
    mediumaquamarine: [102, 205, 170, null],
    mediumblue: [0, 0, 205, null],
    mediumorchid: [186, 85, 211, null],
    mediumpurple: [147, 112, 219, null],
    mediumseagreen: [60, 179, 113, null],
    mediumslateblue: [123, 104, 238, null],
    mediumspringgreen: [0, 250, 154, null],
    mediumturquoise: [72, 209, 204, null],
    mediumvioletred: [199, 21, 133, null],
    midnightblue: [25, 25, 112, null],
    mintcream: [245, 255, 250, null],
    mistyrose: [255, 228, 225, null],
    moccasin: [255, 228, 181, null],
    navajowhite: [255, 222, 173, null],
    navy: [0, 0, 128, null],
    oldlace: [253, 245, 230, null],
    olive: [128, 128, 0, null],
    olivedrab: [107, 142, 35, null],
    orange: [255, 165, 0, null],
    orangered: [255, 69, 0, null],
    orchid: [218, 112, 214, null],
    palegoldenrod: [238, 232, 170, null],
    palegreen: [152, 251, 152, null],
    paleturquoise: [175, 238, 238, null],
    palevioletred: [219, 112, 147, null],
    papayawhip: [255, 239, 213, null],
    peachpuff: [255, 218, 185, null],
    peru: [205, 133, 63, null],
    pink: [255, 192, 203, null],
    plum: [221, 160, 221, null],
    powderblue: [176, 224, 230, null],
    purple: [128, 0, 128, null],
    rebeccapurple: [102, 51, 153, null],
    red: [255, 0, 0, null],
    rosybrown: [188, 143, 143, null],
    royalblue: [65, 105, 225, null],
    saddlebrown: [139, 69, 19, null],
    salmon: [250, 128, 114, null],
    sandybrown: [244, 164, 96, null],
    seagreen: [46, 139, 87, null],
    seashell: [255, 245, 238, null],
    sienna: [160, 82, 45, null],
    silver: [192, 192, 192, null],
    skyblue: [135, 206, 235, null],
    slateblue: [106, 90, 205, null],
    slategray: [112, 128, 144, null],
    slategrey: [112, 128, 144, null],
    snow: [255, 250, 250, null],
    springgreen: [0, 255, 127, null],
    steelblue: [70, 130, 180, null],
    tan: [210, 180, 140, null],
    teal: [0, 128, 128, null],
    thistle: [216, 191, 216, null],
    tomato: [255, 99, 71, null],
    turquoise: [64, 224, 208, null],
    violet: [238, 130, 238, null],
    wheat: [245, 222, 179, null],
    white: [255, 255, 255, null],
    whitesmoke: [245, 245, 245, null],
    yellow: [255, 255, 0, null],
    yellowgreen: [154, 205, 50, null]
};

var TRANSPARENT = exports.TRANSPARENT = new Color([0, 0, 0, 0]);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calculateLengthFromValueWithUnit = exports.LENGTH_TYPE = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NodeContainer = __webpack_require__(3);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LENGTH_WITH_UNIT = /([\d.]+)(px|r?em|%)/i;

var LENGTH_TYPE = exports.LENGTH_TYPE = {
    PX: 0,
    PERCENTAGE: 1
};

var Length = function () {
    function Length(value) {
        _classCallCheck(this, Length);

        this.type = value.substr(value.length - 1) === '%' ? LENGTH_TYPE.PERCENTAGE : LENGTH_TYPE.PX;
        var parsedValue = parseFloat(value);
        if (true && isNaN(parsedValue)) {
            console.error('Invalid value given for Length: "' + value + '"');
        }
        this.value = isNaN(parsedValue) ? 0 : parsedValue;
    }

    _createClass(Length, [{
        key: 'isPercentage',
        value: function isPercentage() {
            return this.type === LENGTH_TYPE.PERCENTAGE;
        }
    }, {
        key: 'getAbsoluteValue',
        value: function getAbsoluteValue(parentLength) {
            return this.isPercentage() ? parentLength * (this.value / 100) : this.value;
        }
    }], [{
        key: 'create',
        value: function create(v) {
            return new Length(v);
        }
    }]);

    return Length;
}();

exports.default = Length;


var getRootFontSize = function getRootFontSize(container) {
    var parent = container.parent;
    return parent ? getRootFontSize(parent) : parseFloat(container.style.font.fontSize);
};

var calculateLengthFromValueWithUnit = exports.calculateLengthFromValueWithUnit = function calculateLengthFromValueWithUnit(container, value, unit) {
    switch (unit) {
        case 'px':
        case '%':
            return new Length(value + unit);
        case 'em':
        case 'rem':
            var length = new Length(value);
            length.value *= unit === 'em' ? parseFloat(container.style.font.fontSize) : getRootFontSize(container);
            return length;
        default:
            // TODO: handle correctly if unknown unit is used
            return new Length('0');
    }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBoundCurves = exports.calculatePaddingBoxPath = exports.calculateBorderBoxPath = exports.parsePathForBorder = exports.parseDocumentSize = exports.calculateContentBox = exports.calculatePaddingBox = exports.parseBounds = exports.Bounds = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Vector = __webpack_require__(7);

var _Vector2 = _interopRequireDefault(_Vector);

var _BezierCurve = __webpack_require__(32);

var _BezierCurve2 = _interopRequireDefault(_BezierCurve);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TOP = 0;
var RIGHT = 1;
var BOTTOM = 2;
var LEFT = 3;

var H = 0;
var V = 1;

var Bounds = exports.Bounds = function () {
    function Bounds(x, y, w, h) {
        _classCallCheck(this, Bounds);

        this.left = x;
        this.top = y;
        this.width = w;
        this.height = h;
    }

    _createClass(Bounds, null, [{
        key: 'fromClientRect',
        value: function fromClientRect(clientRect, scrollX, scrollY) {
            return new Bounds(clientRect.left + scrollX, clientRect.top + scrollY, clientRect.width, clientRect.height);
        }
    }]);

    return Bounds;
}();

var parseBounds = exports.parseBounds = function parseBounds(node, scrollX, scrollY) {
    return Bounds.fromClientRect(node.getBoundingClientRect(), scrollX, scrollY);
};

var calculatePaddingBox = exports.calculatePaddingBox = function calculatePaddingBox(bounds, borders) {
    return new Bounds(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth));
};

var calculateContentBox = exports.calculateContentBox = function calculateContentBox(bounds, padding, borders) {
    // TODO support percentage paddings
    var paddingTop = padding[TOP].value;
    var paddingRight = padding[RIGHT].value;
    var paddingBottom = padding[BOTTOM].value;
    var paddingLeft = padding[LEFT].value;

    return new Bounds(bounds.left + paddingLeft + borders[LEFT].borderWidth, bounds.top + paddingTop + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth + paddingLeft + paddingRight), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth + paddingTop + paddingBottom));
};

var parseDocumentSize = exports.parseDocumentSize = function parseDocumentSize(document) {
    var body = document.body;
    var documentElement = document.documentElement;

    if (!body || !documentElement) {
        throw new Error( true ? 'Unable to get document size' : '');
    }
    var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));

    var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));

    return new Bounds(0, 0, width, height);
};

var parsePathForBorder = exports.parsePathForBorder = function parsePathForBorder(curves, borderSide) {
    switch (borderSide) {
        case TOP:
            return createPathFromCurves(curves.topLeftOuter, curves.topLeftInner, curves.topRightOuter, curves.topRightInner);
        case RIGHT:
            return createPathFromCurves(curves.topRightOuter, curves.topRightInner, curves.bottomRightOuter, curves.bottomRightInner);
        case BOTTOM:
            return createPathFromCurves(curves.bottomRightOuter, curves.bottomRightInner, curves.bottomLeftOuter, curves.bottomLeftInner);
        case LEFT:
        default:
            return createPathFromCurves(curves.bottomLeftOuter, curves.bottomLeftInner, curves.topLeftOuter, curves.topLeftInner);
    }
};

var createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {
    var path = [];
    if (outer1 instanceof _BezierCurve2.default) {
        path.push(outer1.subdivide(0.5, false));
    } else {
        path.push(outer1);
    }

    if (outer2 instanceof _BezierCurve2.default) {
        path.push(outer2.subdivide(0.5, true));
    } else {
        path.push(outer2);
    }

    if (inner2 instanceof _BezierCurve2.default) {
        path.push(inner2.subdivide(0.5, true).reverse());
    } else {
        path.push(inner2);
    }

    if (inner1 instanceof _BezierCurve2.default) {
        path.push(inner1.subdivide(0.5, false).reverse());
    } else {
        path.push(inner1);
    }

    return path;
};

var calculateBorderBoxPath = exports.calculateBorderBoxPath = function calculateBorderBoxPath(curves) {
    return [curves.topLeftOuter, curves.topRightOuter, curves.bottomRightOuter, curves.bottomLeftOuter];
};

var calculatePaddingBoxPath = exports.calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {
    return [curves.topLeftInner, curves.topRightInner, curves.bottomRightInner, curves.bottomLeftInner];
};

var parseBoundCurves = exports.parseBoundCurves = function parseBoundCurves(bounds, borders, borderRadius) {
    var tlh = borderRadius[CORNER.TOP_LEFT][H].getAbsoluteValue(bounds.width);
    var tlv = borderRadius[CORNER.TOP_LEFT][V].getAbsoluteValue(bounds.height);
    var trh = borderRadius[CORNER.TOP_RIGHT][H].getAbsoluteValue(bounds.width);
    var trv = borderRadius[CORNER.TOP_RIGHT][V].getAbsoluteValue(bounds.height);
    var brh = borderRadius[CORNER.BOTTOM_RIGHT][H].getAbsoluteValue(bounds.width);
    var brv = borderRadius[CORNER.BOTTOM_RIGHT][V].getAbsoluteValue(bounds.height);
    var blh = borderRadius[CORNER.BOTTOM_LEFT][H].getAbsoluteValue(bounds.width);
    var blv = borderRadius[CORNER.BOTTOM_LEFT][V].getAbsoluteValue(bounds.height);

    var factors = [];
    factors.push((tlh + trh) / bounds.width);
    factors.push((blh + brh) / bounds.width);
    factors.push((tlv + blv) / bounds.height);
    factors.push((trv + brv) / bounds.height);
    var maxFactor = Math.max.apply(Math, factors);

    if (maxFactor > 1) {
        tlh /= maxFactor;
        tlv /= maxFactor;
        trh /= maxFactor;
        trv /= maxFactor;
        brh /= maxFactor;
        brv /= maxFactor;
        blh /= maxFactor;
        blv /= maxFactor;
    }

    var topWidth = bounds.width - trh;
    var rightHeight = bounds.height - brv;
    var bottomWidth = bounds.width - brh;
    var leftHeight = bounds.height - blv;

    return {
        topLeftOuter: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new _Vector2.default(bounds.left, bounds.top),
        topLeftInner: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, Math.max(0, tlh - borders[LEFT].borderWidth), Math.max(0, tlv - borders[TOP].borderWidth), CORNER.TOP_LEFT) : new _Vector2.default(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth),
        topRightOuter: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new _Vector2.default(bounds.left + bounds.width, bounds.top),
        topRightInner: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borders[LEFT].borderWidth), bounds.top + borders[TOP].borderWidth, topWidth > bounds.width + borders[LEFT].borderWidth ? 0 : trh - borders[LEFT].borderWidth, trv - borders[TOP].borderWidth, CORNER.TOP_RIGHT) : new _Vector2.default(bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + borders[TOP].borderWidth),
        bottomRightOuter: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new _Vector2.default(bounds.left + bounds.width, bounds.top + bounds.height),
        bottomRightInner: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borders[LEFT].borderWidth), bounds.top + Math.min(rightHeight, bounds.height + borders[TOP].borderWidth), Math.max(0, brh - borders[RIGHT].borderWidth), brv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_RIGHT) : new _Vector2.default(bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth),
        bottomLeftOuter: blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new _Vector2.default(bounds.left, bounds.top + bounds.height),
        bottomLeftInner: blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + leftHeight, Math.max(0, blh - borders[LEFT].borderWidth), blv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_LEFT) : new _Vector2.default(bounds.left + borders[LEFT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth)
    };
};

var CORNER = {
    TOP_LEFT: 0,
    TOP_RIGHT: 1,
    BOTTOM_RIGHT: 2,
    BOTTOM_LEFT: 3
};

var getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {
    var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
    var ox = r1 * kappa; // control point offset horizontal
    var oy = r2 * kappa; // control point offset vertical
    var xm = x + r1; // x-middle
    var ym = y + r2; // y-middle

    switch (position) {
        case CORNER.TOP_LEFT:
            return new _BezierCurve2.default(new _Vector2.default(x, ym), new _Vector2.default(x, ym - oy), new _Vector2.default(xm - ox, y), new _Vector2.default(xm, y));
        case CORNER.TOP_RIGHT:
            return new _BezierCurve2.default(new _Vector2.default(x, y), new _Vector2.default(x + ox, y), new _Vector2.default(xm, ym - oy), new _Vector2.default(xm, ym));
        case CORNER.BOTTOM_RIGHT:
            return new _BezierCurve2.default(new _Vector2.default(xm, y), new _Vector2.default(xm, y + oy), new _Vector2.default(x + ox, ym), new _Vector2.default(x, ym));
        case CORNER.BOTTOM_LEFT:
        default:
            return new _BezierCurve2.default(new _Vector2.default(xm, ym), new _Vector2.default(xm - ox, ym), new _Vector2.default(x, y + oy), new _Vector2.default(x, y));
    }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Color = __webpack_require__(0);

var _Color2 = _interopRequireDefault(_Color);

var _Util = __webpack_require__(4);

var _background = __webpack_require__(5);

var _border = __webpack_require__(12);

var _borderRadius = __webpack_require__(33);

var _display = __webpack_require__(34);

var _float = __webpack_require__(35);

var _font = __webpack_require__(36);

var _letterSpacing = __webpack_require__(37);

var _lineBreak = __webpack_require__(38);

var _listStyle = __webpack_require__(8);

var _margin = __webpack_require__(39);

var _overflow = __webpack_require__(40);

var _overflowWrap = __webpack_require__(18);

var _padding = __webpack_require__(17);

var _position = __webpack_require__(19);

var _textDecoration = __webpack_require__(11);

var _textShadow = __webpack_require__(41);

var _textTransform = __webpack_require__(20);

var _transform = __webpack_require__(42);

var _visibility = __webpack_require__(43);

var _wordBreak = __webpack_require__(44);

var _zIndex = __webpack_require__(45);

var _Bounds = __webpack_require__(2);

var _Input = __webpack_require__(21);

var _ListItem = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];

var NodeContainer = function () {
    function NodeContainer(node, parent, resourceLoader, index) {
        var _this = this;

        _classCallCheck(this, NodeContainer);

        this.parent = parent;
        this.tagName = node.tagName;
        this.index = index;
        this.childNodes = [];
        this.listItems = [];
        if (typeof node.start === 'number') {
            this.listStart = node.start;
        }
        var defaultView = node.ownerDocument.defaultView;
        var scrollX = defaultView.pageXOffset;
        var scrollY = defaultView.pageYOffset;
        var style = defaultView.getComputedStyle(node, null);
        var display = (0, _display.parseDisplay)(style.display);

        var IS_INPUT = node.type === 'radio' || node.type === 'checkbox';

        var position = (0, _position.parsePosition)(style.position);

        this.style = {
            background: IS_INPUT ? _Input.INPUT_BACKGROUND : (0, _background.parseBackground)(style, resourceLoader),
            border: IS_INPUT ? _Input.INPUT_BORDERS : (0, _border.parseBorder)(style),
            borderRadius: (node instanceof defaultView.HTMLInputElement || node instanceof HTMLInputElement) && IS_INPUT ? (0, _Input.getInputBorderRadius)(node) : (0, _borderRadius.parseBorderRadius)(style),
            color: IS_INPUT ? _Input.INPUT_COLOR : new _Color2.default(style.color),
            display: display,
            float: (0, _float.parseCSSFloat)(style.float),
            font: (0, _font.parseFont)(style),
            letterSpacing: (0, _letterSpacing.parseLetterSpacing)(style.letterSpacing),
            listStyle: display === _display.DISPLAY.LIST_ITEM ? (0, _listStyle.parseListStyle)(style) : null,
            lineBreak: (0, _lineBreak.parseLineBreak)(style.lineBreak),
            margin: (0, _margin.parseMargin)(style),
            opacity: parseFloat(style.opacity),
            overflow: INPUT_TAGS.indexOf(node.tagName) === -1 ? (0, _overflow.parseOverflow)(style.overflow) : _overflow.OVERFLOW.HIDDEN,
            overflowWrap: (0, _overflowWrap.parseOverflowWrap)(style.overflowWrap ? style.overflowWrap : style.wordWrap),
            padding: (0, _padding.parsePadding)(style),
            position: position,
            textDecoration: (0, _textDecoration.parseTextDecoration)(style),
            textShadow: (0, _textShadow.parseTextShadow)(style.textShadow),
            textTransform: (0, _textTransform.parseTextTransform)(style.textTransform),
            transform: (0, _transform.parseTransform)(style),
            visibility: (0, _visibility.parseVisibility)(style.visibility),
            wordBreak: (0, _wordBreak.parseWordBreak)(style.wordBreak),
            zIndex: (0, _zIndex.parseZIndex)(position !== _position.POSITION.STATIC ? style.zIndex : 'auto')
        };

        if (this.isTransformed()) {
            // getBoundingClientRect provides values post-transform, we want them without the transformation
            node.style.transform = 'matrix(1,0,0,1,0,0)';
        }

        if (display === _display.DISPLAY.LIST_ITEM) {
            var listOwner = (0, _ListItem.getListOwner)(this);
            if (listOwner) {
                var listIndex = listOwner.listItems.length;
                listOwner.listItems.push(this);
                this.listIndex = node.hasAttribute('value') && typeof node.value === 'number' ? node.value : listIndex === 0 ? typeof listOwner.listStart === 'number' ? listOwner.listStart : 1 : listOwner.listItems[listIndex - 1].listIndex + 1;
            }
        }

        // TODO move bound retrieval for all nodes to a later stage?
        if (node.tagName === 'IMG') {
            node.addEventListener('load', function () {
                _this.bounds = (0, _Bounds.parseBounds)(node, scrollX, scrollY);
                _this.curvedBounds = (0, _Bounds.parseBoundCurves)(_this.bounds, _this.style.border, _this.style.borderRadius);
            });
        }
        this.image = getImage(node, resourceLoader);
        this.bounds = IS_INPUT ? (0, _Input.reformatInputBounds)((0, _Bounds.parseBounds)(node, scrollX, scrollY)) : (0, _Bounds.parseBounds)(node, scrollX, scrollY);
        this.curvedBounds = (0, _Bounds.parseBoundCurves)(this.bounds, this.style.border, this.style.borderRadius);

        if (true) {
            this.name = '' + node.tagName.toLowerCase() + (node.id ? '#' + node.id : '') + node.className.toString().split(' ').map(function (s) {
                return s.length ? '.' + s : '';
            }).join('');
        }
    }

    _createClass(NodeContainer, [{
        key: 'getClipPaths',
        value: function getClipPaths() {
            var parentClips = this.parent ? this.parent.getClipPaths() : [];
            var isClipped = this.style.overflow !== _overflow.OVERFLOW.VISIBLE;

            return isClipped ? parentClips.concat([(0, _Bounds.calculatePaddingBoxPath)(this.curvedBounds)]) : parentClips;
        }
    }, {
        key: 'isInFlow',
        value: function isInFlow() {
            return this.isRootElement() && !this.isFloating() && !this.isAbsolutelyPositioned();
        }
    }, {
        key: 'isVisible',
        value: function isVisible() {
            return !(0, _Util.contains)(this.style.display, _display.DISPLAY.NONE) && this.style.opacity > 0 && this.style.visibility === _visibility.VISIBILITY.VISIBLE;
        }
    }, {
        key: 'isAbsolutelyPositioned',
        value: function isAbsolutelyPositioned() {
            return this.style.position !== _position.POSITION.STATIC && this.style.position !== _position.POSITION.RELATIVE;
        }
    }, {
        key: 'isPositioned',
        value: function isPositioned() {
            return this.style.position !== _position.POSITION.STATIC;
        }
    }, {
        key: 'isFloating',
        value: function isFloating() {
            return this.style.float !== _float.FLOAT.NONE;
        }
    }, {
        key: 'isRootElement',
        value: function isRootElement() {
            return this.parent === null;
        }
    }, {
        key: 'isTransformed',
        value: function isTransformed() {
            return this.style.transform !== null;
        }
    }, {
        key: 'isPositionedWithZIndex',
        value: function isPositionedWithZIndex() {
            return this.isPositioned() && !this.style.zIndex.auto;
        }
    }, {
        key: 'isInlineLevel',
        value: function isInlineLevel() {
            return (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_BLOCK) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_FLEX) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_GRID) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_LIST_ITEM) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_TABLE);
        }
    }, {
        key: 'isInlineBlockOrInlineTable',
        value: function isInlineBlockOrInlineTable() {
            return (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_BLOCK) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_TABLE);
        }
    }]);

    return NodeContainer;
}();

exports.default = NodeContainer;


var getImage = function getImage(node, resourceLoader) {
    if (node instanceof node.ownerDocument.defaultView.SVGSVGElement || node instanceof SVGSVGElement) {
        var s = new XMLSerializer();
        return resourceLoader.loadImage('data:image/svg+xml,' + encodeURIComponent(s.serializeToString(node)));
    }
    switch (node.tagName) {
        case 'IMG':
            // $FlowFixMe
            var img = node;
            return resourceLoader.loadImage(img.currentSrc || img.src);
        case 'CANVAS':
            // $FlowFixMe
            var canvas = node;
            return resourceLoader.loadCanvas(canvas);
        case 'IFRAME':
            var iframeKey = node.getAttribute('data-html2canvas-internal-iframe-key');
            if (iframeKey) {
                return iframeKey;
            }
            break;
    }

    return null;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var contains = exports.contains = function contains(bit, value) {
    return (bit & value) !== 0;
};

var distance = exports.distance = function distance(a, b) {
    return Math.sqrt(a * a + b * b);
};

var copyCSSStyles = exports.copyCSSStyles = function copyCSSStyles(style, target) {
    // Edge does not provide value for cssText
    for (var i = style.length - 1; i >= 0; i--) {
        var property = style.item(i);
        // Safari shows pseudoelements if content is set
        if (property !== 'content') {
            target.style.setProperty(property, style.getPropertyValue(property));
        }
    }
    return target;
};

var SMALL_IMAGE = exports.SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBackgroundImage = exports.parseBackground = exports.calculateBackgroundRepeatPath = exports.calculateBackgroundPosition = exports.calculateBackgroungPositioningArea = exports.calculateBackgroungPaintingArea = exports.calculateGradientBackgroundSize = exports.calculateBackgroundSize = exports.BACKGROUND_ORIGIN = exports.BACKGROUND_CLIP = exports.BACKGROUND_SIZE = exports.BACKGROUND_REPEAT = undefined;

var _Color = __webpack_require__(0);

var _Color2 = _interopRequireDefault(_Color);

var _Length = __webpack_require__(1);

var _Length2 = _interopRequireDefault(_Length);

var _Size = __webpack_require__(31);

var _Size2 = _interopRequireDefault(_Size);

var _Vector = __webpack_require__(7);

var _Vector2 = _interopRequireDefault(_Vector);

var _Bounds = __webpack_require__(2);

var _padding = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BACKGROUND_REPEAT = exports.BACKGROUND_REPEAT = {
    REPEAT: 0,
    NO_REPEAT: 1,
    REPEAT_X: 2,
    REPEAT_Y: 3
};

var BACKGROUND_SIZE = exports.BACKGROUND_SIZE = {
    AUTO: 0,
    CONTAIN: 1,
    COVER: 2,
    LENGTH: 3
};

var BACKGROUND_CLIP = exports.BACKGROUND_CLIP = {
    BORDER_BOX: 0,
    PADDING_BOX: 1,
    CONTENT_BOX: 2
};

var BACKGROUND_ORIGIN = exports.BACKGROUND_ORIGIN = BACKGROUND_CLIP;

var AUTO = 'auto';

var BackgroundSize = function BackgroundSize(size) {
    _classCallCheck(this, BackgroundSize);

    switch (size) {
        case 'contain':
            this.size = BACKGROUND_SIZE.CONTAIN;
            break;
        case 'cover':
            this.size = BACKGROUND_SIZE.COVER;
            break;
        case 'auto':
            this.size = BACKGROUND_SIZE.AUTO;
            break;
        default:
            this.value = new _Length2.default(size);
    }
};

var calculateBackgroundSize = exports.calculateBackgroundSize = function calculateBackgroundSize(backgroundImage, image, bounds) {
    var width = 0;
    var height = 0;
    var size = backgroundImage.size;
    if (size[0].size === BACKGROUND_SIZE.CONTAIN || size[0].size === BACKGROUND_SIZE.COVER) {
        var targetRatio = bounds.width / bounds.height;
        var currentRatio = image.width / image.height;
        return targetRatio < currentRatio !== (size[0].size === BACKGROUND_SIZE.COVER) ? new _Size2.default(bounds.width, bounds.width / currentRatio) : new _Size2.default(bounds.height * currentRatio, bounds.height);
    }

    if (size[0].value) {
        width = size[0].value.getAbsoluteValue(bounds.width);
    }

    if (size[0].size === BACKGROUND_SIZE.AUTO && size[1].size === BACKGROUND_SIZE.AUTO) {
        height = image.height;
    } else if (size[1].size === BACKGROUND_SIZE.AUTO) {
        height = width / image.width * image.height;
    } else if (size[1].value) {
        height = size[1].value.getAbsoluteValue(bounds.height);
    }

    if (size[0].size === BACKGROUND_SIZE.AUTO) {
        width = height / image.height * image.width;
    }

    return new _Size2.default(width, height);
};

var calculateGradientBackgroundSize = exports.calculateGradientBackgroundSize = function calculateGradientBackgroundSize(backgroundImage, bounds) {
    var size = backgroundImage.size;
    var width = size[0].value ? size[0].value.getAbsoluteValue(bounds.width) : bounds.width;
    var height = size[1].value ? size[1].value.getAbsoluteValue(bounds.height) : size[0].value ? width : bounds.height;

    return new _Size2.default(width, height);
};

var AUTO_SIZE = new BackgroundSize(AUTO);

var calculateBackgroungPaintingArea = exports.calculateBackgroungPaintingArea = function calculateBackgroungPaintingArea(curves, clip) {
    switch (clip) {
        case BACKGROUND_CLIP.BORDER_BOX:
            return (0, _Bounds.calculateBorderBoxPath)(curves);
        case BACKGROUND_CLIP.PADDING_BOX:
        default:
            return (0, _Bounds.calculatePaddingBoxPath)(curves);
    }
};

var calculateBackgroungPositioningArea = exports.calculateBackgroungPositioningArea = function calculateBackgroungPositioningArea(backgroundOrigin, bounds, padding, border) {
    var paddingBox = (0, _Bounds.calculatePaddingBox)(bounds, border);

    switch (backgroundOrigin) {
        case BACKGROUND_ORIGIN.BORDER_BOX:
            return bounds;
        case BACKGROUND_ORIGIN.CONTENT_BOX:
            var paddingLeft = padding[_padding.PADDING_SIDES.LEFT].getAbsoluteValue(bounds.width);
            var paddingRight = padding[_padding.PADDING_SIDES.RIGHT].getAbsoluteValue(bounds.width);
            var paddingTop = padding[_padding.PADDING_SIDES.TOP].getAbsoluteValue(bounds.width);
            var paddingBottom = padding[_padding.PADDING_SIDES.BOTTOM].getAbsoluteValue(bounds.width);
            return new _Bounds.Bounds(paddingBox.left + paddingLeft, paddingBox.top + paddingTop, paddingBox.width - paddingLeft - paddingRight, paddingBox.height - paddingTop - paddingBottom);
        case BACKGROUND_ORIGIN.PADDING_BOX:
        default:
            return paddingBox;
    }
};

var calculateBackgroundPosition = exports.calculateBackgroundPosition = function calculateBackgroundPosition(position, size, bounds) {
    return new _Vector2.default(position[0].getAbsoluteValue(bounds.width - size.width), position[1].getAbsoluteValue(bounds.height - size.height));
};

var calculateBackgroundRepeatPath = exports.calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(background, position, size, backgroundPositioningArea, bounds) {
    var repeat = background.repeat;
    switch (repeat) {
        case BACKGROUND_REPEAT.REPEAT_X:
            return [new _Vector2.default(Math.round(bounds.left), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(size.height + backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left), Math.round(size.height + backgroundPositioningArea.top + position.y))];
        case BACKGROUND_REPEAT.REPEAT_Y:
            return [new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.height + bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.height + bounds.top))];
        case BACKGROUND_REPEAT.NO_REPEAT:
            return [new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y + size.height)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y + size.height))];
        default:
            return [new _Vector2.default(Math.round(bounds.left), Math.round(bounds.top)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.top)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.height + bounds.top)), new _Vector2.default(Math.round(bounds.left), Math.round(bounds.height + bounds.top))];
    }
};

var parseBackground = exports.parseBackground = function parseBackground(style, resourceLoader) {
    return {
        backgroundColor: new _Color2.default(style.backgroundColor),
        backgroundImage: parseBackgroundImages(style, resourceLoader),
        backgroundClip: parseBackgroundClip(style.backgroundClip),
        backgroundOrigin: parseBackgroundOrigin(style.backgroundOrigin)
    };
};

var parseBackgroundClip = function parseBackgroundClip(backgroundClip) {
    switch (backgroundClip) {
        case 'padding-box':
            return BACKGROUND_CLIP.PADDING_BOX;
        case 'content-box':
            return BACKGROUND_CLIP.CONTENT_BOX;
    }
    return BACKGROUND_CLIP.BORDER_BOX;
};

var parseBackgroundOrigin = function parseBackgroundOrigin(backgroundOrigin) {
    switch (backgroundOrigin) {
        case 'padding-box':
            return BACKGROUND_ORIGIN.PADDING_BOX;
        case 'content-box':
            return BACKGROUND_ORIGIN.CONTENT_BOX;
    }
    return BACKGROUND_ORIGIN.BORDER_BOX;
};

var parseBackgroundRepeat = function parseBackgroundRepeat(backgroundRepeat) {
    switch (backgroundRepeat.trim()) {
        case 'no-repeat':
            return BACKGROUND_REPEAT.NO_REPEAT;
        case 'repeat-x':
        case 'repeat no-repeat':
            return BACKGROUND_REPEAT.REPEAT_X;
        case 'repeat-y':
        case 'no-repeat repeat':
            return BACKGROUND_REPEAT.REPEAT_Y;
        case 'repeat':
            return BACKGROUND_REPEAT.REPEAT;
    }

    if (true) {
        console.error('Invalid background-repeat value "' + backgroundRepeat + '"');
    }

    return BACKGROUND_REPEAT.REPEAT;
};

var parseBackgroundImages = function parseBackgroundImages(style, resourceLoader) {
    var sources = parseBackgroundImage(style.backgroundImage).map(function (backgroundImage) {
        if (backgroundImage.method === 'url') {
            var key = resourceLoader.loadImage(backgroundImage.args[0]);
            backgroundImage.args = key ? [key] : [];
        }
        return backgroundImage;
    });
    var positions = style.backgroundPosition.split(',');
    var repeats = style.backgroundRepeat.split(',');
    var sizes = style.backgroundSize.split(',');

    return sources.map(function (source, index) {
        var size = (sizes[index] || AUTO).trim().split(' ').map(parseBackgroundSize);
        var position = (positions[index] || AUTO).trim().split(' ').map(parseBackgoundPosition);

        return {
            source: source,
            repeat: parseBackgroundRepeat(typeof repeats[index] === 'string' ? repeats[index] : repeats[0]),
            size: size.length < 2 ? [size[0], AUTO_SIZE] : [size[0], size[1]],
            position: position.length < 2 ? [position[0], position[0]] : [position[0], position[1]]
        };
    });
};

var parseBackgroundSize = function parseBackgroundSize(size) {
    return size === 'auto' ? AUTO_SIZE : new BackgroundSize(size);
};

var parseBackgoundPosition = function parseBackgoundPosition(position) {
    switch (position) {
        case 'bottom':
        case 'right':
            return new _Length2.default('100%');
        case 'left':
        case 'top':
            return new _Length2.default('0%');
        case 'auto':
            return new _Length2.default('0');
    }
    return new _Length2.default(position);
};

var parseBackgroundImage = exports.parseBackgroundImage = function parseBackgroundImage(image) {
    var whitespace = /^\s$/;
    var results = [];

    var args = [];
    var method = '';
    var quote = null;
    var definition = '';
    var mode = 0;
    var numParen = 0;

    var appendResult = function appendResult() {
        var prefix = '';
        if (method) {
            if (definition.substr(0, 1) === '"') {
                definition = definition.substr(1, definition.length - 2);
            }

            if (definition) {
                args.push(definition.trim());
            }

            var prefix_i = method.indexOf('-', 1) + 1;
            if (method.substr(0, 1) === '-' && prefix_i > 0) {
                prefix = method.substr(0, prefix_i).toLowerCase();
                method = method.substr(prefix_i);
            }
            method = method.toLowerCase();
            if (method !== 'none') {
                results.push({
                    prefix: prefix,
                    method: method,
                    args: args
                });
            }
        }
        args = [];
        method = definition = '';
    };

    image.split('').forEach(function (c) {
        if (mode === 0 && whitespace.test(c)) {
            return;
        }
        switch (c) {
            case '"':
                if (!quote) {
                    quote = c;
                } else if (quote === c) {
                    quote = null;
                }
                break;
            case '(':
                if (quote) {
                    break;
                } else if (mode === 0) {
                    mode = 1;
                    return;
                } else {
                    numParen++;
                }
                break;
            case ')':
                if (quote) {
                    break;
                } else if (mode === 1) {
                    if (numParen === 0) {
                        mode = 0;
                        appendResult();
                        return;
                    } else {
                        numParen--;
                    }
                }
                break;

            case ',':
                if (quote) {
                    break;
                } else if (mode === 0) {
                    appendResult();
                    return;
                } else if (mode === 1) {
                    if (numParen === 0 && !method.match(/^url$/i)) {
                        args.push(definition.trim());
                        definition = '';
                        return;
                    }
                }
                break;
        }

        if (mode === 0) {
            method += c;
        } else {
            definition += c;
        }
    });

    appendResult();
    return results;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var PATH = exports.PATH = {
    VECTOR: 0,
    BEZIER_CURVE: 1,
    CIRCLE: 2
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Path = __webpack_require__(6);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Vector = function Vector(x, y) {
    _classCallCheck(this, Vector);

    this.type = _Path.PATH.VECTOR;
    this.x = x;
    this.y = y;
    if (true) {
        if (isNaN(x)) {
            console.error('Invalid x value given for Vector');
        }
        if (isNaN(y)) {
            console.error('Invalid y value given for Vector');
        }
    }
};

exports.default = Vector;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseListStyle = exports.parseListStyleType = exports.LIST_STYLE_TYPE = exports.LIST_STYLE_POSITION = undefined;

var _background = __webpack_require__(5);

var LIST_STYLE_POSITION = exports.LIST_STYLE_POSITION = {
    INSIDE: 0,
    OUTSIDE: 1
};

var LIST_STYLE_TYPE = exports.LIST_STYLE_TYPE = {
    NONE: -1,
    DISC: 0,
    CIRCLE: 1,
    SQUARE: 2,
    DECIMAL: 3,
    CJK_DECIMAL: 4,
    DECIMAL_LEADING_ZERO: 5,
    LOWER_ROMAN: 6,
    UPPER_ROMAN: 7,
    LOWER_GREEK: 8,
    LOWER_ALPHA: 9,
    UPPER_ALPHA: 10,
    ARABIC_INDIC: 11,
    ARMENIAN: 12,
    BENGALI: 13,
    CAMBODIAN: 14,
    CJK_EARTHLY_BRANCH: 15,
    CJK_HEAVENLY_STEM: 16,
    CJK_IDEOGRAPHIC: 17,
    DEVANAGARI: 18,
    ETHIOPIC_NUMERIC: 19,
    GEORGIAN: 20,
    GUJARATI: 21,
    GURMUKHI: 22,
    HEBREW: 22,
    HIRAGANA: 23,
    HIRAGANA_IROHA: 24,
    JAPANESE_FORMAL: 25,
    JAPANESE_INFORMAL: 26,
    KANNADA: 27,
    KATAKANA: 28,
    KATAKANA_IROHA: 29,
    KHMER: 30,
    KOREAN_HANGUL_FORMAL: 31,
    KOREAN_HANJA_FORMAL: 32,
    KOREAN_HANJA_INFORMAL: 33,
    LAO: 34,
    LOWER_ARMENIAN: 35,
    MALAYALAM: 36,
    MONGOLIAN: 37,
    MYANMAR: 38,
    ORIYA: 39,
    PERSIAN: 40,
    SIMP_CHINESE_FORMAL: 41,
    SIMP_CHINESE_INFORMAL: 42,
    TAMIL: 43,
    TELUGU: 44,
    THAI: 45,
    TIBETAN: 46,
    TRAD_CHINESE_FORMAL: 47,
    TRAD_CHINESE_INFORMAL: 48,
    UPPER_ARMENIAN: 49,
    DISCLOSURE_OPEN: 50,
    DISCLOSURE_CLOSED: 51
};

var parseListStyleType = exports.parseListStyleType = function parseListStyleType(type) {
    switch (type) {
        case 'disc':
            return LIST_STYLE_TYPE.DISC;
        case 'circle':
            return LIST_STYLE_TYPE.CIRCLE;
        case 'square':
            return LIST_STYLE_TYPE.SQUARE;
        case 'decimal':
            return LIST_STYLE_TYPE.DECIMAL;
        case 'cjk-decimal':
            return LIST_STYLE_TYPE.CJK_DECIMAL;
        case 'decimal-leading-zero':
            return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
        case 'lower-roman':
            return LIST_STYLE_TYPE.LOWER_ROMAN;
        case 'upper-roman':
            return LIST_STYLE_TYPE.UPPER_ROMAN;
        case 'lower-greek':
            return LIST_STYLE_TYPE.LOWER_GREEK;
        case 'lower-alpha':
            return LIST_STYLE_TYPE.LOWER_ALPHA;
        case 'upper-alpha':
            return LIST_STYLE_TYPE.UPPER_ALPHA;
        case 'arabic-indic':
            return LIST_STYLE_TYPE.ARABIC_INDIC;
        case 'armenian':
            return LIST_STYLE_TYPE.ARMENIAN;
        case 'bengali':
            return LIST_STYLE_TYPE.BENGALI;
        case 'cambodian':
            return LIST_STYLE_TYPE.CAMBODIAN;
        case 'cjk-earthly-branch':
            return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
        case 'cjk-heavenly-stem':
            return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
        case 'cjk-ideographic':
            return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
        case 'devanagari':
            return LIST_STYLE_TYPE.DEVANAGARI;
        case 'ethiopic-numeric':
            return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
        case 'georgian':
            return LIST_STYLE_TYPE.GEORGIAN;
        case 'gujarati':
            return LIST_STYLE_TYPE.GUJARATI;
        case 'gurmukhi':
            return LIST_STYLE_TYPE.GURMUKHI;
        case 'hebrew':
            return LIST_STYLE_TYPE.HEBREW;
        case 'hiragana':
            return LIST_STYLE_TYPE.HIRAGANA;
        case 'hiragana-iroha':
            return LIST_STYLE_TYPE.HIRAGANA_IROHA;
        case 'japanese-formal':
            return LIST_STYLE_TYPE.JAPANESE_FORMAL;
        case 'japanese-informal':
            return LIST_STYLE_TYPE.JAPANESE_INFORMAL;
        case 'kannada':
            return LIST_STYLE_TYPE.KANNADA;
        case 'katakana':
            return LIST_STYLE_TYPE.KATAKANA;
        case 'katakana-iroha':
            return LIST_STYLE_TYPE.KATAKANA_IROHA;
        case 'khmer':
            return LIST_STYLE_TYPE.KHMER;
        case 'korean-hangul-formal':
            return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
        case 'korean-hanja-formal':
            return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
        case 'korean-hanja-informal':
            return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
        case 'lao':
            return LIST_STYLE_TYPE.LAO;
        case 'lower-armenian':
            return LIST_STYLE_TYPE.LOWER_ARMENIAN;
        case 'malayalam':
            return LIST_STYLE_TYPE.MALAYALAM;
        case 'mongolian':
            return LIST_STYLE_TYPE.MONGOLIAN;
        case 'myanmar':
            return LIST_STYLE_TYPE.MYANMAR;
        case 'oriya':
            return LIST_STYLE_TYPE.ORIYA;
        case 'persian':
            return LIST_STYLE_TYPE.PERSIAN;
        case 'simp-chinese-formal':
            return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
        case 'simp-chinese-informal':
            return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
        case 'tamil':
            return LIST_STYLE_TYPE.TAMIL;
        case 'telugu':
            return LIST_STYLE_TYPE.TELUGU;
        case 'thai':
            return LIST_STYLE_TYPE.THAI;
        case 'tibetan':
            return LIST_STYLE_TYPE.TIBETAN;
        case 'trad-chinese-formal':
            return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
        case 'trad-chinese-informal':
            return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
        case 'upper-armenian':
            return LIST_STYLE_TYPE.UPPER_ARMENIAN;
        case 'disclosure-open':
            return LIST_STYLE_TYPE.DISCLOSURE_OPEN;
        case 'disclosure-closed':
            return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
        case 'none':
        default:
            return LIST_STYLE_TYPE.NONE;
    }
};

var parseListStyle = exports.parseListStyle = function parseListStyle(style) {
    var listStyleImage = (0, _background.parseBackgroundImage)(style.getPropertyValue('list-style-image'));
    return {
        listStyleType: parseListStyleType(style.getPropertyValue('list-style-type')),
        listStyleImage: listStyleImage.length ? listStyleImage[0] : null,
        listStylePosition: parseListStylePosition(style.getPropertyValue('list-style-position'))
    };
};

var parseListStylePosition = function parseListStylePosition(position) {
    switch (position) {
        case 'inside':
            return LIST_STYLE_POSITION.INSIDE;
        case 'outside':
        default:
            return LIST_STYLE_POSITION.OUTSIDE;
    }
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _textTransform = __webpack_require__(20);

var _TextBounds = __webpack_require__(22);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TextContainer = function () {
    function TextContainer(text, parent, bounds) {
        _classCallCheck(this, TextContainer);

        this.text = text;
        this.parent = parent;
        this.bounds = bounds;
    }

    _createClass(TextContainer, null, [{
        key: 'fromTextNode',
        value: function fromTextNode(node, parent) {
            var text = transform(node.data, parent.style.textTransform);
            return new TextContainer(text, parent, (0, _TextBounds.parseTextBounds)(text, parent, node));
        }
    }]);

    return TextContainer;
}();

exports.default = TextContainer;


var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;

var transform = function transform(text, _transform) {
    switch (_transform) {
        case _textTransform.TEXT_TRANSFORM.LOWERCASE:
            return text.toLowerCase();
        case _textTransform.TEXT_TRANSFORM.CAPITALIZE:
            return text.replace(CAPITALIZE, capitalize);
        case _textTransform.TEXT_TRANSFORM.UPPERCASE:
            return text.toUpperCase();
        default:
            return text;
    }
};

function capitalize(m, p1, p2) {
    if (m.length > 0) {
        return p1 + p2.toUpperCase();
    }

    return m;
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ForeignObjectRenderer = __webpack_require__(23);

var testRangeBounds = function testRangeBounds(document) {
    var TEST_HEIGHT = 123;

    if (document.createRange) {
        var range = document.createRange();
        if (range.getBoundingClientRect) {
            var testElement = document.createElement('boundtest');
            testElement.style.height = TEST_HEIGHT + 'px';
            testElement.style.display = 'block';
            document.body.appendChild(testElement);

            range.selectNode(testElement);
            var rangeBounds = range.getBoundingClientRect();
            var rangeHeight = Math.round(rangeBounds.height);
            document.body.removeChild(testElement);
            if (rangeHeight === TEST_HEIGHT) {
                return true;
            }
        }
    }

    return false;
};

// iOS 10.3 taints canvas with base64 images unless crossOrigin = 'anonymous'
var testBase64 = function testBase64(document, src) {
    var img = new Image();
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    return new Promise(function (resolve) {
        // Single pixel base64 image renders fine on iOS 10.3???
        img.src = src;

        var onload = function onload() {
            try {
                ctx.drawImage(img, 0, 0);
                canvas.toDataURL();
            } catch (e) {
                return resolve(false);
            }

            return resolve(true);
        };

        img.onload = onload;
        img.onerror = function () {
            return resolve(false);
        };

        if (img.complete === true) {
            setTimeout(function () {
                onload();
            }, 500);
        }
    });
};

var testCORS = function testCORS() {
    return typeof new Image().crossOrigin !== 'undefined';
};

var testResponseType = function testResponseType() {
    return typeof new XMLHttpRequest().responseType === 'string';
};

var testSVG = function testSVG(document) {
    var img = new Image();
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    img.src = 'data:image/svg+xml,<svg xmlns=\'http://www.w3.org/2000/svg\'></svg>';

    try {
        ctx.drawImage(img, 0, 0);
        canvas.toDataURL();
    } catch (e) {
        return false;
    }
    return true;
};

var isGreenPixel = function isGreenPixel(data) {
    return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
};

var testForeignObject = function testForeignObject(document) {
    var canvas = document.createElement('canvas');
    var size = 100;
    canvas.width = size;
    canvas.height = size;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = 'rgb(0, 255, 0)';
    ctx.fillRect(0, 0, size, size);

    var img = new Image();
    var greenImageSrc = canvas.toDataURL();
    img.src = greenImageSrc;
    var svg = (0, _ForeignObjectRenderer.createForeignObjectSVG)(size, size, 0, 0, img);
    ctx.fillStyle = 'red';
    ctx.fillRect(0, 0, size, size);

    return (0, _ForeignObjectRenderer.loadSerializedSVG)(svg).then(function (img) {
        ctx.drawImage(img, 0, 0);
        var data = ctx.getImageData(0, 0, size, size).data;
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);

        var node = document.createElement('div');
        node.style.backgroundImage = 'url(' + greenImageSrc + ')';
        node.style.height = size + 'px';
        // Firefox 55 does not render inline <img /> tags
        return isGreenPixel(data) ? (0, _ForeignObjectRenderer.loadSerializedSVG)((0, _ForeignObjectRenderer.createForeignObjectSVG)(size, size, 0, 0, node)) : Promise.reject(false);
    }).then(function (img) {
        ctx.drawImage(img, 0, 0);
        // Edge does not render background-images
        return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
    }).catch(function (e) {
        return false;
    });
};

var FEATURES = {
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_RANGE_BOUNDS() {
        'use strict';

        var value = testRangeBounds(document);
        Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_SVG_DRAWING() {
        'use strict';

        var value = testSVG(document);
        Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_BASE64_DRAWING() {
        'use strict';

        return function (src) {
            var _value = testBase64(document, src);
            Object.defineProperty(FEATURES, 'SUPPORT_BASE64_DRAWING', { value: function value() {
                    return _value;
                } });
            return _value;
        };
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_FOREIGNOBJECT_DRAWING() {
        'use strict';

        var value = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
        Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_CORS_IMAGES() {
        'use strict';

        var value = testCORS();
        Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_RESPONSE_TYPE() {
        'use strict';

        var value = testResponseType();
        Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_CORS_XHR() {
        'use strict';

        var value = 'withCredentials' in new XMLHttpRequest();
        Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
        return value;
    }
};

exports.default = FEATURES;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseTextDecoration = exports.TEXT_DECORATION_LINE = exports.TEXT_DECORATION = exports.TEXT_DECORATION_STYLE = undefined;

var _Color = __webpack_require__(0);

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TEXT_DECORATION_STYLE = exports.TEXT_DECORATION_STYLE = {
    SOLID: 0,
    DOUBLE: 1,
    DOTTED: 2,
    DASHED: 3,
    WAVY: 4
};

var TEXT_DECORATION = exports.TEXT_DECORATION = {
    NONE: null
};

var TEXT_DECORATION_LINE = exports.TEXT_DECORATION_LINE = {
    UNDERLINE: 1,
    OVERLINE: 2,
    LINE_THROUGH: 3,
    BLINK: 4
};

var parseLine = function parseLine(line) {
    switch (line) {
        case 'underline':
            return TEXT_DECORATION_LINE.UNDERLINE;
        case 'overline':
            return TEXT_DECORATION_LINE.OVERLINE;
        case 'line-through':
            return TEXT_DECORATION_LINE.LINE_THROUGH;
    }
    return TEXT_DECORATION_LINE.BLINK;
};

var parseTextDecorationLine = function parseTextDecorationLine(line) {
    if (line === 'none') {
        return null;
    }

    return line.split(' ').map(parseLine);
};

var parseTextDecorationStyle = function parseTextDecorationStyle(style) {
    switch (style) {
        case 'double':
            return TEXT_DECORATION_STYLE.DOUBLE;
        case 'dotted':
            return TEXT_DECORATION_STYLE.DOTTED;
        case 'dashed':
            return TEXT_DECORATION_STYLE.DASHED;
        case 'wavy':
            return TEXT_DECORATION_STYLE.WAVY;
    }
    return TEXT_DECORATION_STYLE.SOLID;
};

var parseTextDecoration = exports.parseTextDecoration = function parseTextDecoration(style) {
    var textDecorationLine = parseTextDecorationLine(style.textDecorationLine ? style.textDecorationLine : style.textDecoration);
    if (textDecorationLine === null) {
        return TEXT_DECORATION.NONE;
    }

    var textDecorationColor = style.textDecorationColor ? new _Color2.default(style.textDecorationColor) : null;
    var textDecorationStyle = parseTextDecorationStyle(style.textDecorationStyle);

    return {
        textDecorationLine: textDecorationLine,
        textDecorationColor: textDecorationColor,
        textDecorationStyle: textDecorationStyle
    };
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBorder = exports.BORDER_SIDES = exports.BORDER_STYLE = undefined;

var _Color = __webpack_require__(0);

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BORDER_STYLE = exports.BORDER_STYLE = {
    NONE: 0,
    SOLID: 1
};

var BORDER_SIDES = exports.BORDER_SIDES = {
    TOP: 0,
    RIGHT: 1,
    BOTTOM: 2,
    LEFT: 3
};

var SIDES = Object.keys(BORDER_SIDES).map(function (s) {
    return s.toLowerCase();
});

var parseBorderStyle = function parseBorderStyle(style) {
    switch (style) {
        case 'none':
            return BORDER_STYLE.NONE;
    }
    return BORDER_STYLE.SOLID;
};

var parseBorder = exports.parseBorder = function parseBorder(style) {
    return SIDES.map(function (side) {
        var borderColor = new _Color2.default(style.getPropertyValue('border-' + side + '-color'));
        var borderStyle = parseBorderStyle(style.getPropertyValue('border-' + side + '-style'));
        var borderWidth = parseFloat(style.getPropertyValue('border-' + side + '-width'));
        return {
            borderColor: borderColor,
            borderStyle: borderStyle,
            borderWidth: isNaN(borderWidth) ? 0 : borderWidth
        };
    });
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var toCodePoints = exports.toCodePoints = function toCodePoints(str) {
    var codePoints = [];
    var i = 0;
    var length = str.length;
    while (i < length) {
        var value = str.charCodeAt(i++);
        if (value >= 0xd800 && value <= 0xdbff && i < length) {
            var extra = str.charCodeAt(i++);
            if ((extra & 0xfc00) === 0xdc00) {
                codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
            } else {
                codePoints.push(value);
                i--;
            }
        } else {
            codePoints.push(value);
        }
    }
    return codePoints;
};

var fromCodePoint = exports.fromCodePoint = function fromCodePoint() {
    if (String.fromCodePoint) {
        return String.fromCodePoint.apply(String, arguments);
    }

    var length = arguments.length;
    if (!length) {
        return '';
    }

    var codeUnits = [];

    var index = -1;
    var result = '';
    while (++index < length) {
        var codePoint = arguments.length <= index ? undefined : arguments[index];
        if (codePoint <= 0xffff) {
            codeUnits.push(codePoint);
        } else {
            codePoint -= 0x10000;
            codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
        }
        if (index + 1 === length || codeUnits.length > 0x4000) {
            result += String.fromCharCode.apply(String, codeUnits);
            codeUnits.length = 0;
        }
    }
    return result;
};

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

// Use a lookup table to find the index.
var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
}

var decode = exports.decode = function decode(base64) {
    var bufferLength = base64.length * 0.75,
        len = base64.length,
        i = void 0,
        p = 0,
        encoded1 = void 0,
        encoded2 = void 0,
        encoded3 = void 0,
        encoded4 = void 0;

    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
    var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = lookup[base64.charCodeAt(i)];
        encoded2 = lookup[base64.charCodeAt(i + 1)];
        encoded3 = lookup[base64.charCodeAt(i + 2)];
        encoded4 = lookup[base64.charCodeAt(i + 3)];

        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }

    return buffer;
};

var polyUint16Array = exports.polyUint16Array = function polyUint16Array(buffer) {
    var length = buffer.length;
    var bytes = [];
    for (var _i = 0; _i < length; _i += 2) {
        bytes.push(buffer[_i + 1] << 8 | buffer[_i]);
    }
    return bytes;
};

var polyUint32Array = exports.polyUint32Array = function polyUint32Array(buffer) {
    var length = buffer.length;
    var bytes = [];
    for (var _i2 = 0; _i2 < length; _i2 += 4) {
        bytes.push(buffer[_i2 + 3] << 24 | buffer[_i2 + 2] << 16 | buffer[_i2 + 1] << 8 | buffer[_i2]);
    }
    return bytes;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createCounterText = exports.inlineListItemElement = exports.getListOwner = undefined;

var _Util = __webpack_require__(4);

var _NodeContainer = __webpack_require__(3);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _TextContainer = __webpack_require__(9);

var _TextContainer2 = _interopRequireDefault(_TextContainer);

var _listStyle = __webpack_require__(8);

var _Unicode = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Margin between the enumeration and the list item content
var MARGIN_RIGHT = 7;

var ancestorTypes = ['OL', 'UL', 'MENU'];

var getListOwner = exports.getListOwner = function getListOwner(container) {
    var parent = container.parent;
    if (!parent) {
        return null;
    }

    do {
        var isAncestor = ancestorTypes.indexOf(parent.tagName) !== -1;
        if (isAncestor) {
            return parent;
        }
        parent = parent.parent;
    } while (parent);

    return container.parent;
};

var inlineListItemElement = exports.inlineListItemElement = function inlineListItemElement(node, container, resourceLoader) {
    var listStyle = container.style.listStyle;

    if (!listStyle) {
        return;
    }

    var style = node.ownerDocument.defaultView.getComputedStyle(node, null);
    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
    (0, _Util.copyCSSStyles)(style, wrapper);

    wrapper.style.position = 'absolute';
    wrapper.style.bottom = 'auto';
    wrapper.style.display = 'block';
    wrapper.style.letterSpacing = 'normal';

    switch (listStyle.listStylePosition) {
        case _listStyle.LIST_STYLE_POSITION.OUTSIDE:
            wrapper.style.left = 'auto';
            wrapper.style.right = node.ownerDocument.defaultView.innerWidth - container.bounds.left - container.style.margin[1].getAbsoluteValue(container.bounds.width) + MARGIN_RIGHT + 'px';
            wrapper.style.textAlign = 'right';
            break;
        case _listStyle.LIST_STYLE_POSITION.INSIDE:
            wrapper.style.left = container.bounds.left - container.style.margin[3].getAbsoluteValue(container.bounds.width) + 'px';
            wrapper.style.right = 'auto';
            wrapper.style.textAlign = 'left';
            break;
    }

    var text = void 0;
    var MARGIN_TOP = container.style.margin[0].getAbsoluteValue(container.bounds.width);
    var styleImage = listStyle.listStyleImage;
    if (styleImage) {
        if (styleImage.method === 'url') {
            var image = node.ownerDocument.createElement('img');
            image.src = styleImage.args[0];
            wrapper.style.top = container.bounds.top - MARGIN_TOP + 'px';
            wrapper.style.width = 'auto';
            wrapper.style.height = 'auto';
            wrapper.appendChild(image);
        } else {
            var size = parseFloat(container.style.font.fontSize) * 0.5;
            wrapper.style.top = container.bounds.top - MARGIN_TOP + container.bounds.height - 1.5 * size + 'px';
            wrapper.style.width = size + 'px';
            wrapper.style.height = size + 'px';
            wrapper.style.backgroundImage = style.listStyleImage;
        }
    } else if (typeof container.listIndex === 'number') {
        text = node.ownerDocument.createTextNode(createCounterText(container.listIndex, listStyle.listStyleType, true));
        wrapper.appendChild(text);
        wrapper.style.top = container.bounds.top - MARGIN_TOP + 'px';
    }

    // $FlowFixMe
    var body = node.ownerDocument.body;
    body.appendChild(wrapper);

    if (text) {
        container.childNodes.push(_TextContainer2.default.fromTextNode(text, container));
        body.removeChild(wrapper);
    } else {
        // $FlowFixMe
        container.childNodes.push(new _NodeContainer2.default(wrapper, container, resourceLoader, 0));
    }
};

var ROMAN_UPPER = {
    integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
    values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
};

var ARMENIAN = {
    integers: [9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
    values: ['Ք', 'Փ', 'Ւ', 'Ց', 'Ր', 'Տ', 'Վ', 'Ս', 'Ռ', 'Ջ', 'Պ', 'Չ', 'Ո', 'Շ', 'Ն', 'Յ', 'Մ', 'Ճ', 'Ղ', 'Ձ', 'Հ', 'Կ', 'Ծ', 'Խ', 'Լ', 'Ի', 'Ժ', 'Թ', 'Ը', 'Է', 'Զ', 'Ե', 'Դ', 'Գ', 'Բ', 'Ա']
};

var HEBREW = {
    integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
    values: ['י׳', 'ט׳', 'ח׳', 'ז׳', 'ו׳', 'ה׳', 'ד׳', 'ג׳', 'ב׳', 'א׳', 'ת', 'ש', 'ר', 'ק', 'צ', 'פ', 'ע', 'ס', 'נ', 'מ', 'ל', 'כ', 'יט', 'יח', 'יז', 'טז', 'טו', 'י', 'ט', 'ח', 'ז', 'ו', 'ה', 'ד', 'ג', 'ב', 'א']
};

var GEORGIAN = {
    integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
    values: ['ჵ', 'ჰ', 'ჯ', 'ჴ', 'ხ', 'ჭ', 'წ', 'ძ', 'ც', 'ჩ', 'შ', 'ყ', 'ღ', 'ქ', 'ფ', 'ჳ', 'ტ', 'ს', 'რ', 'ჟ', 'პ', 'ო', 'ჲ', 'ნ', 'მ', 'ლ', 'კ', 'ი', 'თ', 'ჱ', 'ზ', 'ვ', 'ე', 'დ', 'გ', 'ბ', 'ა']
};

var createAdditiveCounter = function createAdditiveCounter(value, min, max, symbols, fallback, suffix) {
    if (value < min || value > max) {
        return createCounterText(value, fallback, suffix.length > 0);
    }

    return symbols.integers.reduce(function (string, integer, index) {
        while (value >= integer) {
            value -= integer;
            string += symbols.values[index];
        }
        return string;
    }, '') + suffix;
};

var createCounterStyleWithSymbolResolver = function createCounterStyleWithSymbolResolver(value, codePointRangeLength, isNumeric, resolver) {
    var string = '';

    do {
        if (!isNumeric) {
            value--;
        }
        string = resolver(value) + string;
        value /= codePointRangeLength;
    } while (value * codePointRangeLength >= codePointRangeLength);

    return string;
};

var createCounterStyleFromRange = function createCounterStyleFromRange(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
    var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;

    return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
        return (0, _Unicode.fromCodePoint)(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
    }) + suffix);
};

var createCounterStyleFromSymbols = function createCounterStyleFromSymbols(value, symbols) {
    var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '. ';

    var codePointRangeLength = symbols.length;
    return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) {
        return symbols[Math.floor(codePoint % codePointRangeLength)];
    }) + suffix;
};

var CJK_ZEROS = 1 << 0;
var CJK_TEN_COEFFICIENTS = 1 << 1;
var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
var CJK_HUNDRED_COEFFICIENTS = 1 << 3;

var createCJKCounter = function createCJKCounter(value, numbers, multipliers, negativeSign, suffix, flags) {
    if (value < -9999 || value > 9999) {
        return createCounterText(value, _listStyle.LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
    }
    var tmp = Math.abs(value);
    var string = suffix;

    if (tmp === 0) {
        return numbers[0] + string;
    }

    for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
        var coefficient = tmp % 10;

        if (coefficient === 0 && (0, _Util.contains)(flags, CJK_ZEROS) && string !== '') {
            string = numbers[coefficient] + string;
        } else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && (0, _Util.contains)(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && (0, _Util.contains)(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && (0, _Util.contains)(flags, CJK_HUNDRED_COEFFICIENTS)) {
            string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
        } else if (coefficient === 1 && digit > 0) {
            string = multipliers[digit - 1] + string;
        }
        tmp = Math.floor(tmp / 10);
    }

    return (value < 0 ? negativeSign : '') + string;
};

var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
var JAPANESE_NEGATIVE = 'マイナス';
var KOREAN_NEGATIVE = '마이너스 ';

var createCounterText = exports.createCounterText = function createCounterText(value, type, appendSuffix) {
    var defaultSuffix = appendSuffix ? '. ' : '';
    var cjkSuffix = appendSuffix ? '、' : '';
    var koreanSuffix = appendSuffix ? ', ' : '';
    switch (type) {
        case _listStyle.LIST_STYLE_TYPE.DISC:
            return '•';
        case _listStyle.LIST_STYLE_TYPE.CIRCLE:
            return '◦';
        case _listStyle.LIST_STYLE_TYPE.SQUARE:
            return '◾';
        case _listStyle.LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
            var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
            return string.length < 4 ? '0' + string : string;
        case _listStyle.LIST_STYLE_TYPE.CJK_DECIMAL:
            return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
        case _listStyle.LIST_STYLE_TYPE.LOWER_ROMAN:
            return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
        case _listStyle.LIST_STYLE_TYPE.UPPER_ROMAN:
            return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.LOWER_GREEK:
            return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.LOWER_ALPHA:
            return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.UPPER_ALPHA:
            return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.ARABIC_INDIC:
            return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.ARMENIAN:
        case _listStyle.LIST_STYLE_TYPE.UPPER_ARMENIAN:
            return createAdditiveCounter(value, 1, 9999, ARMENIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.LOWER_ARMENIAN:
            return createAdditiveCounter(value, 1, 9999, ARMENIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
        case _listStyle.LIST_STYLE_TYPE.BENGALI:
            return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.CAMBODIAN:
        case _listStyle.LIST_STYLE_TYPE.KHMER:
            return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
            return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
        case _listStyle.LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
            return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
        case _listStyle.LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
        case _listStyle.LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
            return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
            return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
            return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
            return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.JAPANESE_INFORMAL:
            return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
        case _listStyle.LIST_STYLE_TYPE.JAPANESE_FORMAL:
            return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
            return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
            return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
            return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.DEVANAGARI:
            return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.GEORGIAN:
            return createAdditiveCounter(value, 1, 19999, GEORGIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.GUJARATI:
            return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.GURMUKHI:
            return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.HEBREW:
            return createAdditiveCounter(value, 1, 10999, HEBREW, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.HIRAGANA:
            return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
        case _listStyle.LIST_STYLE_TYPE.HIRAGANA_IROHA:
            return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
        case _listStyle.LIST_STYLE_TYPE.KANNADA:
            return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.KATAKANA:
            return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
        case _listStyle.LIST_STYLE_TYPE.KATAKANA_IROHA:
            return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
        case _listStyle.LIST_STYLE_TYPE.LAO:
            return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.MONGOLIAN:
            return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.MYANMAR:
            return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.ORIYA:
            return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.PERSIAN:
            return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.TAMIL:
            return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.TELUGU:
            return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.THAI:
            return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.TIBETAN:
            return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.DECIMAL:
        default:
            return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
    }
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Path = __webpack_require__(6);

var _textDecoration = __webpack_require__(11);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var addColorStops = function addColorStops(gradient, canvasGradient) {
    var maxStop = Math.max.apply(null, gradient.colorStops.map(function (colorStop) {
        return colorStop.stop;
    }));
    var f = 1 / Math.max(1, maxStop);
    gradient.colorStops.forEach(function (colorStop) {
        canvasGradient.addColorStop(f * colorStop.stop, colorStop.color.toString());
    });
};

var CanvasRenderer = function () {
    function CanvasRenderer(canvas) {
        _classCallCheck(this, CanvasRenderer);

        this.canvas = canvas ? canvas : document.createElement('canvas');
    }

    _createClass(CanvasRenderer, [{
        key: 'render',
        value: function render(options) {
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            this.canvas.width = Math.floor(options.width * options.scale);
            this.canvas.height = Math.floor(options.height * options.scale);
            this.canvas.style.width = options.width + 'px';
            this.canvas.style.height = options.height + 'px';

            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x, -options.y);
            this.ctx.textBaseline = 'bottom';
            options.logger.log('Canvas renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + this.options.scale);
        }
    }, {
        key: 'clip',
        value: function clip(clipPaths, callback) {
            var _this = this;

            if (clipPaths.length) {
                this.ctx.save();
                clipPaths.forEach(function (path) {
                    _this.path(path);
                    _this.ctx.clip();
                });
            }

            callback();

            if (clipPaths.length) {
                this.ctx.restore();
            }
        }
    }, {
        key: 'drawImage',
        value: function drawImage(image, source, destination) {
            this.ctx.drawImage(image, source.left, source.top, source.width, source.height, destination.left, destination.top, destination.width, destination.height);
        }
    }, {
        key: 'drawShape',
        value: function drawShape(path, color) {
            this.path(path);
            this.ctx.fillStyle = color.toString();
            this.ctx.fill();
        }
    }, {
        key: 'fill',
        value: function fill(color) {
            this.ctx.fillStyle = color.toString();
            this.ctx.fill();
        }
    }, {
        key: 'getTarget',
        value: function getTarget() {
            this.canvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
            return Promise.resolve(this.canvas);
        }
    }, {
        key: 'path',
        value: function path(_path) {
            var _this2 = this;

            this.ctx.beginPath();
            if (Array.isArray(_path)) {
                _path.forEach(function (point, index) {
                    var start = point.type === _Path.PATH.VECTOR ? point : point.start;
                    if (index === 0) {
                        _this2.ctx.moveTo(start.x, start.y);
                    } else {
                        _this2.ctx.lineTo(start.x, start.y);
                    }

                    if (point.type === _Path.PATH.BEZIER_CURVE) {
                        _this2.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                    }
                });
            } else {
                this.ctx.arc(_path.x + _path.radius, _path.y + _path.radius, _path.radius, 0, Math.PI * 2, true);
            }

            this.ctx.closePath();
        }
    }, {
        key: 'rectangle',
        value: function rectangle(x, y, width, height, color) {
            this.ctx.fillStyle = color.toString();
            this.ctx.fillRect(x, y, width, height);
        }
    }, {
        key: 'renderLinearGradient',
        value: function renderLinearGradient(bounds, gradient) {
            var linearGradient = this.ctx.createLinearGradient(bounds.left + gradient.direction.x1, bounds.top + gradient.direction.y1, bounds.left + gradient.direction.x0, bounds.top + gradient.direction.y0);

            addColorStops(gradient, linearGradient);
            this.ctx.fillStyle = linearGradient;
            this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
        }
    }, {
        key: 'renderRadialGradient',
        value: function renderRadialGradient(bounds, gradient) {
            var _this3 = this;

            var x = bounds.left + gradient.center.x;
            var y = bounds.top + gradient.center.y;

            var radialGradient = this.ctx.createRadialGradient(x, y, 0, x, y, gradient.radius.x);
            if (!radialGradient) {
                return;
            }

            addColorStops(gradient, radialGradient);
            this.ctx.fillStyle = radialGradient;

            if (gradient.radius.x !== gradient.radius.y) {
                // transforms for elliptical radial gradient
                var midX = bounds.left + 0.5 * bounds.width;
                var midY = bounds.top + 0.5 * bounds.height;
                var f = gradient.radius.y / gradient.radius.x;
                var invF = 1 / f;

                this.transform(midX, midY, [1, 0, 0, f, 0, 0], function () {
                    return _this3.ctx.fillRect(bounds.left, invF * (bounds.top - midY) + midY, bounds.width, bounds.height * invF);
                });
            } else {
                this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
            }
        }
    }, {
        key: 'renderRepeat',
        value: function renderRepeat(path, image, imageSize, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = this.ctx.createPattern(this.resizeImage(image, imageSize), 'repeat');
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        }
    }, {
        key: 'renderTextNode',
        value: function renderTextNode(textBounds, color, font, textDecoration, textShadows) {
            var _this4 = this;

            this.ctx.font = [font.fontStyle, font.fontVariant, font.fontWeight, font.fontSize, font.fontFamily].join(' ');

            textBounds.forEach(function (text) {
                _this4.ctx.fillStyle = color.toString();
                if (textShadows && text.text.trim().length) {
                    textShadows.slice(0).reverse().forEach(function (textShadow) {
                        _this4.ctx.shadowColor = textShadow.color.toString();
                        _this4.ctx.shadowOffsetX = textShadow.offsetX * _this4.options.scale;
                        _this4.ctx.shadowOffsetY = textShadow.offsetY * _this4.options.scale;
                        _this4.ctx.shadowBlur = textShadow.blur;

                        _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
                    });
                } else {
                    _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
                }

                if (textDecoration !== null) {
                    var textDecorationColor = textDecoration.textDecorationColor || color;
                    textDecoration.textDecorationLine.forEach(function (textDecorationLine) {
                        switch (textDecorationLine) {
                            case _textDecoration.TEXT_DECORATION_LINE.UNDERLINE:
                                // Draws a line at the baseline of the font
                                // TODO As some browsers display the line as more than 1px if the font-size is big,
                                // need to take that into account both in position and size
                                var _options$fontMetrics$ = _this4.options.fontMetrics.getMetrics(font),
                                    baseline = _options$fontMetrics$.baseline;

                                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1, textDecorationColor);
                                break;
                            case _textDecoration.TEXT_DECORATION_LINE.OVERLINE:
                                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1, textDecorationColor);
                                break;
                            case _textDecoration.TEXT_DECORATION_LINE.LINE_THROUGH:
                                // TODO try and find exact position for line-through
                                var _options$fontMetrics$2 = _this4.options.fontMetrics.getMetrics(font),
                                    middle = _options$fontMetrics$2.middle;

                                _this4.rectangle(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1, textDecorationColor);
                                break;
                        }
                    });
                }
            });
        }
    }, {
        key: 'resizeImage',
        value: function resizeImage(image, size) {
            if (image.width === size.width && image.height === size.height) {
                return image;
            }

            var canvas = this.canvas.ownerDocument.createElement('canvas');
            canvas.width = size.width;
            canvas.height = size.height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, size.width, size.height);
            return canvas;
        }
    }, {
        key: 'setOpacity',
        value: function setOpacity(opacity) {
            this.ctx.globalAlpha = opacity;
        }
    }, {
        key: 'transform',
        value: function transform(offsetX, offsetY, matrix, callback) {
            this.ctx.save();
            this.ctx.translate(offsetX, offsetY);
            this.ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
            this.ctx.translate(-offsetX, -offsetY);

            callback();

            this.ctx.restore();
        }
    }]);

    return CanvasRenderer;
}();

exports.default = CanvasRenderer;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Logger = function () {
    function Logger(enabled, id, start) {
        _classCallCheck(this, Logger);

        this.enabled = typeof window !== 'undefined' && enabled;
        this.start = start ? start : Date.now();
        this.id = id;
    }

    _createClass(Logger, [{
        key: 'child',
        value: function child(id) {
            return new Logger(this.enabled, id, this.start);
        }

        // eslint-disable-next-line flowtype/no-weak-types

    }, {
        key: 'log',
        value: function log() {
            if (this.enabled && window.console && window.console.log) {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                Function.prototype.bind.call(window.console.log, window.console).apply(window.console, [Date.now() - this.start + 'ms', this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'].concat([].slice.call(args, 0)));
            }
        }

        // eslint-disable-next-line flowtype/no-weak-types

    }, {
        key: 'error',
        value: function error() {
            if (this.enabled && window.console && window.console.error) {
                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                }

                Function.prototype.bind.call(window.console.error, window.console).apply(window.console, [Date.now() - this.start + 'ms', this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'].concat([].slice.call(args, 0)));
            }
        }
    }]);

    return Logger;
}();

exports.default = Logger;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parsePadding = exports.PADDING_SIDES = undefined;

var _Length = __webpack_require__(1);

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PADDING_SIDES = exports.PADDING_SIDES = {
    TOP: 0,
    RIGHT: 1,
    BOTTOM: 2,
    LEFT: 3
};

var SIDES = ['top', 'right', 'bottom', 'left'];

var parsePadding = exports.parsePadding = function parsePadding(style) {
    return SIDES.map(function (side) {
        return new _Length2.default(style.getPropertyValue('padding-' + side));
    });
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var OVERFLOW_WRAP = exports.OVERFLOW_WRAP = {
    NORMAL: 0,
    BREAK_WORD: 1
};

var parseOverflowWrap = exports.parseOverflowWrap = function parseOverflowWrap(overflow) {
    switch (overflow) {
        case 'break-word':
            return OVERFLOW_WRAP.BREAK_WORD;
        case 'normal':
        default:
            return OVERFLOW_WRAP.NORMAL;
    }
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var POSITION = exports.POSITION = {
    STATIC: 0,
    RELATIVE: 1,
    ABSOLUTE: 2,
    FIXED: 3,
    STICKY: 4
};

var parsePosition = exports.parsePosition = function parsePosition(position) {
    switch (position) {
        case 'relative':
            return POSITION.RELATIVE;
        case 'absolute':
            return POSITION.ABSOLUTE;
        case 'fixed':
            return POSITION.FIXED;
        case 'sticky':
            return POSITION.STICKY;
    }

    return POSITION.STATIC;
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var TEXT_TRANSFORM = exports.TEXT_TRANSFORM = {
    NONE: 0,
    LOWERCASE: 1,
    UPPERCASE: 2,
    CAPITALIZE: 3
};

var parseTextTransform = exports.parseTextTransform = function parseTextTransform(textTransform) {
    switch (textTransform) {
        case 'uppercase':
            return TEXT_TRANSFORM.UPPERCASE;
        case 'lowercase':
            return TEXT_TRANSFORM.LOWERCASE;
        case 'capitalize':
            return TEXT_TRANSFORM.CAPITALIZE;
    }

    return TEXT_TRANSFORM.NONE;
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reformatInputBounds = exports.inlineSelectElement = exports.inlineTextAreaElement = exports.inlineInputElement = exports.getInputBorderRadius = exports.INPUT_BACKGROUND = exports.INPUT_BORDERS = exports.INPUT_COLOR = undefined;

var _TextContainer = __webpack_require__(9);

var _TextContainer2 = _interopRequireDefault(_TextContainer);

var _background = __webpack_require__(5);

var _border = __webpack_require__(12);

var _Circle = __webpack_require__(50);

var _Circle2 = _interopRequireDefault(_Circle);

var _Vector = __webpack_require__(7);

var _Vector2 = _interopRequireDefault(_Vector);

var _Color = __webpack_require__(0);

var _Color2 = _interopRequireDefault(_Color);

var _Length = __webpack_require__(1);

var _Length2 = _interopRequireDefault(_Length);

var _Bounds = __webpack_require__(2);

var _TextBounds = __webpack_require__(22);

var _Util = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INPUT_COLOR = exports.INPUT_COLOR = new _Color2.default([42, 42, 42]);
var INPUT_BORDER_COLOR = new _Color2.default([165, 165, 165]);
var INPUT_BACKGROUND_COLOR = new _Color2.default([222, 222, 222]);
var INPUT_BORDER = {
    borderWidth: 1,
    borderColor: INPUT_BORDER_COLOR,
    borderStyle: _border.BORDER_STYLE.SOLID
};
var INPUT_BORDERS = exports.INPUT_BORDERS = [INPUT_BORDER, INPUT_BORDER, INPUT_BORDER, INPUT_BORDER];
var INPUT_BACKGROUND = exports.INPUT_BACKGROUND = {
    backgroundColor: INPUT_BACKGROUND_COLOR,
    backgroundImage: [],
    backgroundClip: _background.BACKGROUND_CLIP.PADDING_BOX,
    backgroundOrigin: _background.BACKGROUND_ORIGIN.PADDING_BOX
};

var RADIO_BORDER_RADIUS = new _Length2.default('50%');
var RADIO_BORDER_RADIUS_TUPLE = [RADIO_BORDER_RADIUS, RADIO_BORDER_RADIUS];
var INPUT_RADIO_BORDER_RADIUS = [RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE];

var CHECKBOX_BORDER_RADIUS = new _Length2.default('3px');
var CHECKBOX_BORDER_RADIUS_TUPLE = [CHECKBOX_BORDER_RADIUS, CHECKBOX_BORDER_RADIUS];
var INPUT_CHECKBOX_BORDER_RADIUS = [CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE];

var getInputBorderRadius = exports.getInputBorderRadius = function getInputBorderRadius(node) {
    return node.type === 'radio' ? INPUT_RADIO_BORDER_RADIUS : INPUT_CHECKBOX_BORDER_RADIUS;
};

var inlineInputElement = exports.inlineInputElement = function inlineInputElement(node, container) {
    if (node.type === 'radio' || node.type === 'checkbox') {
        if (node.checked) {
            var size = Math.min(container.bounds.width, container.bounds.height);
            container.childNodes.push(node.type === 'checkbox' ? [new _Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79), new _Vector2.default(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549), new _Vector2.default(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071), new _Vector2.default(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649), new _Vector2.default(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23), new _Vector2.default(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085), new _Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)] : new _Circle2.default(container.bounds.left + size / 4, container.bounds.top + size / 4, size / 4));
        }
    } else {
        inlineFormElement(getInputValue(node), node, container, false);
    }
};

var inlineTextAreaElement = exports.inlineTextAreaElement = function inlineTextAreaElement(node, container) {
    inlineFormElement(node.value, node, container, true);
};

var inlineSelectElement = exports.inlineSelectElement = function inlineSelectElement(node, container) {
    var option = node.options[node.selectedIndex || 0];
    inlineFormElement(option ? option.text || '' : '', node, container, false);
};

var reformatInputBounds = exports.reformatInputBounds = function reformatInputBounds(bounds) {
    if (bounds.width > bounds.height) {
        bounds.left += (bounds.width - bounds.height) / 2;
        bounds.width = bounds.height;
    } else if (bounds.width < bounds.height) {
        bounds.top += (bounds.height - bounds.width) / 2;
        bounds.height = bounds.width;
    }
    return bounds;
};

var inlineFormElement = function inlineFormElement(value, node, container, allowLinebreak) {
    var body = node.ownerDocument.body;
    if (value.length > 0 && body) {
        var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
        (0, _Util.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node, null), wrapper);
        wrapper.style.position = 'absolute';
        wrapper.style.left = container.bounds.left + 'px';
        wrapper.style.top = container.bounds.top + 'px';
        if (!allowLinebreak) {
            wrapper.style.whiteSpace = 'nowrap';
        }
        var text = node.ownerDocument.createTextNode(value);
        wrapper.appendChild(text);
        body.appendChild(wrapper);
        container.childNodes.push(_TextContainer2.default.fromTextNode(text, container));
        body.removeChild(wrapper);
    }
};

var getInputValue = function getInputValue(node) {
    var value = node.type === 'password' ? new Array(node.value.length + 1).join('\u2022') : node.value;

    return value.length === 0 ? node.placeholder || '' : value;
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseTextBounds = exports.TextBounds = undefined;

var _Bounds = __webpack_require__(2);

var _textDecoration = __webpack_require__(11);

var _Feature = __webpack_require__(10);

var _Feature2 = _interopRequireDefault(_Feature);

var _Unicode = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TextBounds = exports.TextBounds = function TextBounds(text, bounds) {
    _classCallCheck(this, TextBounds);

    this.text = text;
    this.bounds = bounds;
};

var parseTextBounds = exports.parseTextBounds = function parseTextBounds(value, parent, node) {
    var letterRendering = parent.style.letterSpacing !== 0;
    var textList = letterRendering ? (0, _Unicode.toCodePoints)(value).map(function (i) {
        return (0, _Unicode.fromCodePoint)(i);
    }) : (0, _Unicode.breakWords)(value, parent);
    var length = textList.length;
    var defaultView = node.parentNode ? node.parentNode.ownerDocument.defaultView : null;
    var scrollX = defaultView ? defaultView.pageXOffset : 0;
    var scrollY = defaultView ? defaultView.pageYOffset : 0;
    var textBounds = [];
    var offset = 0;
    for (var i = 0; i < length; i++) {
        var text = textList[i];
        if (parent.style.textDecoration !== _textDecoration.TEXT_DECORATION.NONE || text.trim().length > 0) {
            if (_Feature2.default.SUPPORT_RANGE_BOUNDS) {
                textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length, scrollX, scrollY)));
            } else {
                var replacementNode = node.splitText(text.length);
                textBounds.push(new TextBounds(text, getWrapperBounds(node, scrollX, scrollY)));
                node = replacementNode;
            }
        } else if (!_Feature2.default.SUPPORT_RANGE_BOUNDS) {
            node = node.splitText(text.length);
        }
        offset += text.length;
    }
    return textBounds;
};

var getWrapperBounds = function getWrapperBounds(node, scrollX, scrollY) {
    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
    wrapper.appendChild(node.cloneNode(true));
    var parentNode = node.parentNode;
    if (parentNode) {
        parentNode.replaceChild(wrapper, node);
        var bounds = (0, _Bounds.parseBounds)(wrapper, scrollX, scrollY);
        if (wrapper.firstChild) {
            parentNode.replaceChild(wrapper.firstChild, wrapper);
        }
        return bounds;
    }
    return new _Bounds.Bounds(0, 0, 0, 0);
};

var getRangeBounds = function getRangeBounds(node, offset, length, scrollX, scrollY) {
    var range = node.ownerDocument.createRange();
    range.setStart(node, offset);
    range.setEnd(node, offset + length);
    return _Bounds.Bounds.fromClientRect(range.getBoundingClientRect(), scrollX, scrollY);
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ForeignObjectRenderer = function () {
    function ForeignObjectRenderer(element) {
        _classCallCheck(this, ForeignObjectRenderer);

        this.element = element;
    }

    _createClass(ForeignObjectRenderer, [{
        key: 'render',
        value: function render(options) {
            var _this = this;

            this.options = options;
            this.canvas = document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.canvas.width = Math.floor(options.width) * options.scale;
            this.canvas.height = Math.floor(options.height) * options.scale;
            this.canvas.style.width = options.width + 'px';
            this.canvas.style.height = options.height + 'px';

            options.logger.log('ForeignObject renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + options.scale);
            var svg = createForeignObjectSVG(Math.max(options.windowWidth, options.width) * options.scale, Math.max(options.windowHeight, options.height) * options.scale, options.scrollX * options.scale, options.scrollY * options.scale, this.element);

            return loadSerializedSVG(svg).then(function (img) {
                if (options.backgroundColor) {
                    _this.ctx.fillStyle = options.backgroundColor.toString();
                    _this.ctx.fillRect(0, 0, options.width * options.scale, options.height * options.scale);
                }

                _this.ctx.drawImage(img, -options.x * options.scale, -options.y * options.scale);
                return _this.canvas;
            });
        }
    }]);

    return ForeignObjectRenderer;
}();

exports.default = ForeignObjectRenderer;
var createForeignObjectSVG = exports.createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {
    var xmlns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(xmlns, 'svg');
    var foreignObject = document.createElementNS(xmlns, 'foreignObject');
    svg.setAttributeNS(null, 'width', width);
    svg.setAttributeNS(null, 'height', height);

    foreignObject.setAttributeNS(null, 'width', '100%');
    foreignObject.setAttributeNS(null, 'height', '100%');
    foreignObject.setAttributeNS(null, 'x', x);
    foreignObject.setAttributeNS(null, 'y', y);
    foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
    svg.appendChild(foreignObject);

    foreignObject.appendChild(node);

    return svg;
};

var loadSerializedSVG = exports.loadSerializedSVG = function loadSerializedSVG(svg) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
            return resolve(img);
        };
        img.onerror = reject;

        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(svg));
    });
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.breakWords = exports.fromCodePoint = exports.toCodePoints = undefined;

var _cssLineBreak = __webpack_require__(46);

Object.defineProperty(exports, 'toCodePoints', {
    enumerable: true,
    get: function get() {
        return _cssLineBreak.toCodePoints;
    }
});
Object.defineProperty(exports, 'fromCodePoint', {
    enumerable: true,
    get: function get() {
        return _cssLineBreak.fromCodePoint;
    }
});

var _NodeContainer = __webpack_require__(3);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _overflowWrap = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var breakWords = exports.breakWords = function breakWords(str, parent) {
    var breaker = (0, _cssLineBreak.LineBreaker)(str, {
        lineBreak: parent.style.lineBreak,
        wordBreak: parent.style.overflowWrap === _overflowWrap.OVERFLOW_WRAP.BREAK_WORD ? 'break-word' : parent.style.wordBreak
    });

    var words = [];
    var bk = void 0;

    while (!(bk = breaker.next()).done) {
        words.push(bk.value.slice());
    }

    return words;
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FontMetrics = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Util = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SAMPLE_TEXT = 'Hidden Text';

var FontMetrics = exports.FontMetrics = function () {
    function FontMetrics(document) {
        _classCallCheck(this, FontMetrics);

        this._data = {};
        this._document = document;
    }

    _createClass(FontMetrics, [{
        key: '_parseMetrics',
        value: function _parseMetrics(font) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');

            var body = this._document.body;
            if (!body) {
                throw new Error( true ? 'No document found for font metrics' : '');
            }

            container.style.visibility = 'hidden';
            container.style.fontFamily = font.fontFamily;
            container.style.fontSize = font.fontSize;
            container.style.margin = '0';
            container.style.padding = '0';

            body.appendChild(container);

            img.src = _Util.SMALL_IMAGE;
            img.width = 1;
            img.height = 1;

            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';

            span.style.fontFamily = font.fontFamily;
            span.style.fontSize = font.fontSize;
            span.style.margin = '0';
            span.style.padding = '0';

            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;

            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));

            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';

            var middle = img.offsetTop - container.offsetTop + 2;

            body.removeChild(container);

            return { baseline: baseline, middle: middle };
        }
    }, {
        key: 'getMetrics',
        value: function getMetrics(font) {
            var key = font.fontFamily + ' ' + font.fontSize;
            if (this._data[key] === undefined) {
                this._data[key] = this._parseMetrics(font);
            }

            return this._data[key];
        }
    }]);

    return FontMetrics;
}();

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Proxy = undefined;

var _Feature = __webpack_require__(10);

var _Feature2 = _interopRequireDefault(_Feature);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Proxy = exports.Proxy = function Proxy(src, options) {
    if (!options.proxy) {
        return Promise.reject( true ? 'No proxy defined' : null);
    }
    var proxy = options.proxy;

    return new Promise(function (resolve, reject) {
        var responseType = _Feature2.default.SUPPORT_CORS_XHR && _Feature2.default.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
        var xhr = _Feature2.default.SUPPORT_CORS_XHR ? new XMLHttpRequest() : new XDomainRequest();
        xhr.onload = function () {
            if (xhr instanceof XMLHttpRequest) {
                if (xhr.status === 200) {
                    if (responseType === 'text') {
                        resolve(xhr.response);
                    } else {
                        var reader = new FileReader();
                        // $FlowFixMe
                        reader.addEventListener('load', function () {
                            return resolve(reader.result);
                        }, false);
                        // $FlowFixMe
                        reader.addEventListener('error', function (e) {
                            return reject(e);
                        }, false);
                        reader.readAsDataURL(xhr.response);
                    }
                } else {
                    reject( true ? 'Failed to proxy resource ' + src.substring(0, 256) + ' with status code ' + xhr.status : '');
                }
            } else {
                resolve(xhr.responseText);
            }
        };

        xhr.onerror = reject;
        xhr.open('GET', proxy + '?url=' + encodeURIComponent(src) + '&responseType=' + responseType);

        if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
            xhr.responseType = responseType;
        }

        if (options.imageTimeout) {
            var timeout = options.imageTimeout;
            xhr.timeout = timeout;
            xhr.ontimeout = function () {
                return reject( true ? 'Timed out (' + timeout + 'ms) proxying ' + src.substring(0, 256) : '');
            };
        }

        xhr.send();
    });
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _CanvasRenderer = __webpack_require__(15);

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

var _Logger = __webpack_require__(16);

var _Logger2 = _interopRequireDefault(_Logger);

var _Window = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var html2canvas = function html2canvas(element, conf) {
    var config = conf || {};
    var logger = new _Logger2.default(typeof config.logging === 'boolean' ? config.logging : true);
    logger.log('html2canvas ' + "1.0.0-alpha.12");

    if (true && typeof config.onrendered === 'function') {
        logger.error('onrendered option is deprecated, html2canvas returns a Promise with the canvas as the value');
    }

    var ownerDocument = element.ownerDocument;
    if (!ownerDocument) {
        return Promise.reject('Provided element is not within a Document');
    }
    var defaultView = ownerDocument.defaultView;

    var defaultOptions = {
        async: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        imageTimeout: 15000,
        logging: true,
        proxy: null,
        removeContainer: true,
        foreignObjectRendering: false,
        scale: defaultView.devicePixelRatio || 1,
        target: new _CanvasRenderer2.default(config.canvas),
        useCORS: false,
        windowWidth: defaultView.innerWidth,
        windowHeight: defaultView.innerHeight,
        scrollX: defaultView.pageXOffset,
        scrollY: defaultView.pageYOffset
    };

    var result = (0, _Window.renderElement)(element, _extends({}, defaultOptions, config), logger);

    if (true) {
        return result.catch(function (e) {
            logger.error(e);
            throw e;
        });
    }
    return result;
};

html2canvas.CanvasRenderer = _CanvasRenderer2.default;

module.exports = html2canvas;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderElement = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Logger = __webpack_require__(16);

var _Logger2 = _interopRequireDefault(_Logger);

var _NodeParser = __webpack_require__(29);

var _Renderer = __webpack_require__(51);

var _Renderer2 = _interopRequireDefault(_Renderer);

var _ForeignObjectRenderer = __webpack_require__(23);

var _ForeignObjectRenderer2 = _interopRequireDefault(_ForeignObjectRenderer);

var _Feature = __webpack_require__(10);

var _Feature2 = _interopRequireDefault(_Feature);

var _Bounds = __webpack_require__(2);

var _Clone = __webpack_require__(54);

var _Font = __webpack_require__(25);

var _Color = __webpack_require__(0);

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderElement = exports.renderElement = function renderElement(element, options, logger) {
    var ownerDocument = element.ownerDocument;

    var windowBounds = new _Bounds.Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);

    // http://www.w3.org/TR/css3-background/#special-backgrounds
    var documentBackgroundColor = ownerDocument.documentElement ? new _Color2.default(getComputedStyle(ownerDocument.documentElement).backgroundColor) : _Color.TRANSPARENT;
    var bodyBackgroundColor = ownerDocument.body ? new _Color2.default(getComputedStyle(ownerDocument.body).backgroundColor) : _Color.TRANSPARENT;

    var backgroundColor = element === ownerDocument.documentElement ? documentBackgroundColor.isTransparent() ? bodyBackgroundColor.isTransparent() ? options.backgroundColor ? new _Color2.default(options.backgroundColor) : null : bodyBackgroundColor : documentBackgroundColor : options.backgroundColor ? new _Color2.default(options.backgroundColor) : null;

    return (options.foreignObjectRendering ? // $FlowFixMe
    _Feature2.default.SUPPORT_FOREIGNOBJECT_DRAWING : Promise.resolve(false)).then(function (supportForeignObject) {
        return supportForeignObject ? function (cloner) {
            if (true) {
                logger.log('Document cloned, using foreignObject rendering');
            }

            return cloner.inlineFonts(ownerDocument).then(function () {
                return cloner.resourceLoader.ready();
            }).then(function () {
                var renderer = new _ForeignObjectRenderer2.default(cloner.documentElement);

                var defaultView = ownerDocument.defaultView;
                var scrollX = defaultView.pageXOffset;
                var scrollY = defaultView.pageYOffset;

                var isDocument = element.tagName === 'HTML' || element.tagName === 'BODY';

                var _ref = isDocument ? (0, _Bounds.parseDocumentSize)(ownerDocument) : (0, _Bounds.parseBounds)(element, scrollX, scrollY),
                    width = _ref.width,
                    height = _ref.height,
                    left = _ref.left,
                    top = _ref.top;

                return renderer.render({
                    backgroundColor: backgroundColor,
                    logger: logger,
                    scale: options.scale,
                    x: typeof options.x === 'number' ? options.x : left,
                    y: typeof options.y === 'number' ? options.y : top,
                    width: typeof options.width === 'number' ? options.width : Math.ceil(width),
                    height: typeof options.height === 'number' ? options.height : Math.ceil(height),
                    windowWidth: options.windowWidth,
                    windowHeight: options.windowHeight,
                    scrollX: options.scrollX,
                    scrollY: options.scrollY
                });
            });
        }(new _Clone.DocumentCloner(element, options, logger, true, renderElement)) : (0, _Clone.cloneWindow)(ownerDocument, windowBounds, element, options, logger, renderElement).then(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 3),
                container = _ref3[0],
                clonedElement = _ref3[1],
                resourceLoader = _ref3[2];

            if (true) {
                logger.log('Document cloned, using computed rendering');
            }

            var stack = (0, _NodeParser.NodeParser)(clonedElement, resourceLoader, logger);
            var clonedDocument = clonedElement.ownerDocument;

            if (backgroundColor === stack.container.style.background.backgroundColor) {
                stack.container.style.background.backgroundColor = _Color.TRANSPARENT;
            }

            return resourceLoader.ready().then(function (imageStore) {
                var fontMetrics = new _Font.FontMetrics(clonedDocument);
                if (true) {
                    logger.log('Starting renderer');
                }

                var defaultView = clonedDocument.defaultView;
                var scrollX = defaultView.pageXOffset;
                var scrollY = defaultView.pageYOffset;

                var isDocument = clonedElement.tagName === 'HTML' || clonedElement.tagName === 'BODY';

                var _ref4 = isDocument ? (0, _Bounds.parseDocumentSize)(ownerDocument) : (0, _Bounds.parseBounds)(clonedElement, scrollX, scrollY),
                    width = _ref4.width,
                    height = _ref4.height,
                    left = _ref4.left,
                    top = _ref4.top;

                var renderOptions = {
                    backgroundColor: backgroundColor,
                    fontMetrics: fontMetrics,
                    imageStore: imageStore,
                    logger: logger,
                    scale: options.scale,
                    x: typeof options.x === 'number' ? options.x : left,
                    y: typeof options.y === 'number' ? options.y : top,
                    width: typeof options.width === 'number' ? options.width : Math.ceil(width),
                    height: typeof options.height === 'number' ? options.height : Math.ceil(height)
                };

                if (Array.isArray(options.target)) {
                    return Promise.all(options.target.map(function (target) {
                        var renderer = new _Renderer2.default(target, renderOptions);
                        return renderer.render(stack);
                    }));
                } else {
                    var renderer = new _Renderer2.default(options.target, renderOptions);
                    var canvas = renderer.render(stack);
                    if (options.removeContainer === true) {
                        if (container.parentNode) {
                            container.parentNode.removeChild(container);
                        } else if (true) {
                            logger.log('Cannot detach cloned iframe as it is not in the DOM anymore');
                        }
                    }

                    return canvas;
                }
            });
        });
    });
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NodeParser = undefined;

var _StackingContext = __webpack_require__(30);

var _StackingContext2 = _interopRequireDefault(_StackingContext);

var _NodeContainer = __webpack_require__(3);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _TextContainer = __webpack_require__(9);

var _TextContainer2 = _interopRequireDefault(_TextContainer);

var _Input = __webpack_require__(21);

var _ListItem = __webpack_require__(14);

var _listStyle = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NodeParser = exports.NodeParser = function NodeParser(node, resourceLoader, logger) {
    if (true) {
        logger.log('Starting node parsing');
    }

    var index = 0;

    var container = new _NodeContainer2.default(node, null, resourceLoader, index++);
    var stack = new _StackingContext2.default(container, null, true);

    parseNodeTree(node, container, stack, resourceLoader, index);

    if (true) {
        logger.log('Finished parsing node tree');
    }

    return stack;
};

var IGNORED_NODE_NAMES = ['SCRIPT', 'HEAD', 'TITLE', 'OBJECT', 'BR', 'OPTION'];

var parseNodeTree = function parseNodeTree(node, parent, stack, resourceLoader, index) {
    if (true && index > 50000) {
        throw new Error('Recursion error while parsing node tree');
    }

    for (var childNode = node.firstChild, nextNode; childNode; childNode = nextNode) {
        nextNode = childNode.nextSibling;
        var defaultView = childNode.ownerDocument.defaultView;
        if (childNode instanceof defaultView.Text || childNode instanceof Text || defaultView.parent && childNode instanceof defaultView.parent.Text) {
            if (childNode.data.trim().length > 0) {
                parent.childNodes.push(_TextContainer2.default.fromTextNode(childNode, parent));
            }
        } else if (childNode instanceof defaultView.HTMLElement || childNode instanceof HTMLElement || defaultView.parent && childNode instanceof defaultView.parent.HTMLElement) {
            if (IGNORED_NODE_NAMES.indexOf(childNode.nodeName) === -1) {
                var container = new _NodeContainer2.default(childNode, parent, resourceLoader, index++);
                if (container.isVisible()) {
                    if (childNode.tagName === 'INPUT') {
                        // $FlowFixMe
                        (0, _Input.inlineInputElement)(childNode, container);
                    } else if (childNode.tagName === 'TEXTAREA') {
                        // $FlowFixMe
                        (0, _Input.inlineTextAreaElement)(childNode, container);
                    } else if (childNode.tagName === 'SELECT') {
                        // $FlowFixMe
                        (0, _Input.inlineSelectElement)(childNode, container);
                    } else if (container.style.listStyle && container.style.listStyle.listStyleType !== _listStyle.LIST_STYLE_TYPE.NONE) {
                        (0, _ListItem.inlineListItemElement)(childNode, container, resourceLoader);
                    }

                    var SHOULD_TRAVERSE_CHILDREN = childNode.tagName !== 'TEXTAREA';
                    var treatAsRealStackingContext = createsRealStackingContext(container, childNode);
                    if (treatAsRealStackingContext || createsStackingContext(container)) {
                        // for treatAsRealStackingContext:false, any positioned descendants and descendants
                        // which actually create a new stacking context should be considered part of the parent stacking context
                        var parentStack = treatAsRealStackingContext || container.isPositioned() ? stack.getRealParentStackingContext() : stack;
                        var childStack = new _StackingContext2.default(container, parentStack, treatAsRealStackingContext);
                        parentStack.contexts.push(childStack);
                        if (SHOULD_TRAVERSE_CHILDREN) {
                            parseNodeTree(childNode, container, childStack, resourceLoader, index);
                        }
                    } else {
                        stack.children.push(container);
                        if (SHOULD_TRAVERSE_CHILDREN) {
                            parseNodeTree(childNode, container, stack, resourceLoader, index);
                        }
                    }
                }
            }
        } else if (childNode instanceof defaultView.SVGSVGElement || childNode instanceof SVGSVGElement || defaultView.parent && childNode instanceof defaultView.parent.SVGSVGElement) {
            var _container = new _NodeContainer2.default(childNode, parent, resourceLoader, index++);
            var _treatAsRealStackingContext = createsRealStackingContext(_container, childNode);
            if (_treatAsRealStackingContext || createsStackingContext(_container)) {
                // for treatAsRealStackingContext:false, any positioned descendants and descendants
                // which actually create a new stacking context should be considered part of the parent stacking context
                var _parentStack = _treatAsRealStackingContext || _container.isPositioned() ? stack.getRealParentStackingContext() : stack;
                var _childStack = new _StackingContext2.default(_container, _parentStack, _treatAsRealStackingContext);
                _parentStack.contexts.push(_childStack);
            } else {
                stack.children.push(_container);
            }
        }
    }
};

var createsRealStackingContext = function createsRealStackingContext(container, node) {
    return container.isRootElement() || container.isPositionedWithZIndex() || container.style.opacity < 1 || container.isTransformed() || isBodyWithTransparentRoot(container, node);
};

var createsStackingContext = function createsStackingContext(container) {
    return container.isPositioned() || container.isFloating();
};

var isBodyWithTransparentRoot = function isBodyWithTransparentRoot(container, node) {
    return node.nodeName === 'BODY' && container.parent instanceof _NodeContainer2.default && container.parent.style.background.backgroundColor.isTransparent();
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NodeContainer = __webpack_require__(3);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _position = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StackingContext = function () {
    function StackingContext(container, parent, treatAsRealStackingContext) {
        _classCallCheck(this, StackingContext);

        this.container = container;
        this.parent = parent;
        this.contexts = [];
        this.children = [];
        this.treatAsRealStackingContext = treatAsRealStackingContext;
    }

    _createClass(StackingContext, [{
        key: 'getOpacity',
        value: function getOpacity() {
            return this.parent ? this.container.style.opacity * this.parent.getOpacity() : this.container.style.opacity;
        }
    }, {
        key: 'getRealParentStackingContext',
        value: function getRealParentStackingContext() {
            return !this.parent || this.treatAsRealStackingContext ? this : this.parent.getRealParentStackingContext();
        }
    }]);

    return StackingContext;
}();

exports.default = StackingContext;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Size = function Size(width, height) {
    _classCallCheck(this, Size);

    this.width = width;
    this.height = height;
};

exports.default = Size;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Path = __webpack_require__(6);

var _Vector = __webpack_require__(7);

var _Vector2 = _interopRequireDefault(_Vector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var lerp = function lerp(a, b, t) {
    return new _Vector2.default(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
};

var BezierCurve = function () {
    function BezierCurve(start, startControl, endControl, end) {
        _classCallCheck(this, BezierCurve);

        this.type = _Path.PATH.BEZIER_CURVE;
        this.start = start;
        this.startControl = startControl;
        this.endControl = endControl;
        this.end = end;
    }

    _createClass(BezierCurve, [{
        key: 'subdivide',
        value: function subdivide(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        }
    }, {
        key: 'reverse',
        value: function reverse() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        }
    }]);

    return BezierCurve;
}();

exports.default = BezierCurve;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBorderRadius = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Length = __webpack_require__(1);

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIDES = ['top-left', 'top-right', 'bottom-right', 'bottom-left'];

var parseBorderRadius = exports.parseBorderRadius = function parseBorderRadius(style) {
    return SIDES.map(function (side) {
        var value = style.getPropertyValue('border-' + side + '-radius');

        var _value$split$map = value.split(' ').map(_Length2.default.create),
            _value$split$map2 = _slicedToArray(_value$split$map, 2),
            horizontal = _value$split$map2[0],
            vertical = _value$split$map2[1];

        return typeof vertical === 'undefined' ? [horizontal, horizontal] : [horizontal, vertical];
    });
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DISPLAY = exports.DISPLAY = {
    NONE: 1 << 0,
    BLOCK: 1 << 1,
    INLINE: 1 << 2,
    RUN_IN: 1 << 3,
    FLOW: 1 << 4,
    FLOW_ROOT: 1 << 5,
    TABLE: 1 << 6,
    FLEX: 1 << 7,
    GRID: 1 << 8,
    RUBY: 1 << 9,
    SUBGRID: 1 << 10,
    LIST_ITEM: 1 << 11,
    TABLE_ROW_GROUP: 1 << 12,
    TABLE_HEADER_GROUP: 1 << 13,
    TABLE_FOOTER_GROUP: 1 << 14,
    TABLE_ROW: 1 << 15,
    TABLE_CELL: 1 << 16,
    TABLE_COLUMN_GROUP: 1 << 17,
    TABLE_COLUMN: 1 << 18,
    TABLE_CAPTION: 1 << 19,
    RUBY_BASE: 1 << 20,
    RUBY_TEXT: 1 << 21,
    RUBY_BASE_CONTAINER: 1 << 22,
    RUBY_TEXT_CONTAINER: 1 << 23,
    CONTENTS: 1 << 24,
    INLINE_BLOCK: 1 << 25,
    INLINE_LIST_ITEM: 1 << 26,
    INLINE_TABLE: 1 << 27,
    INLINE_FLEX: 1 << 28,
    INLINE_GRID: 1 << 29
};

var parseDisplayValue = function parseDisplayValue(display) {
    switch (display) {
        case 'block':
            return DISPLAY.BLOCK;
        case 'inline':
            return DISPLAY.INLINE;
        case 'run-in':
            return DISPLAY.RUN_IN;
        case 'flow':
            return DISPLAY.FLOW;
        case 'flow-root':
            return DISPLAY.FLOW_ROOT;
        case 'table':
            return DISPLAY.TABLE;
        case 'flex':
            return DISPLAY.FLEX;
        case 'grid':
            return DISPLAY.GRID;
        case 'ruby':
            return DISPLAY.RUBY;
        case 'subgrid':
            return DISPLAY.SUBGRID;
        case 'list-item':
            return DISPLAY.LIST_ITEM;
        case 'table-row-group':
            return DISPLAY.TABLE_ROW_GROUP;
        case 'table-header-group':
            return DISPLAY.TABLE_HEADER_GROUP;
        case 'table-footer-group':
            return DISPLAY.TABLE_FOOTER_GROUP;
        case 'table-row':
            return DISPLAY.TABLE_ROW;
        case 'table-cell':
            return DISPLAY.TABLE_CELL;
        case 'table-column-group':
            return DISPLAY.TABLE_COLUMN_GROUP;
        case 'table-column':
            return DISPLAY.TABLE_COLUMN;
        case 'table-caption':
            return DISPLAY.TABLE_CAPTION;
        case 'ruby-base':
            return DISPLAY.RUBY_BASE;
        case 'ruby-text':
            return DISPLAY.RUBY_TEXT;
        case 'ruby-base-container':
            return DISPLAY.RUBY_BASE_CONTAINER;
        case 'ruby-text-container':
            return DISPLAY.RUBY_TEXT_CONTAINER;
        case 'contents':
            return DISPLAY.CONTENTS;
        case 'inline-block':
            return DISPLAY.INLINE_BLOCK;
        case 'inline-list-item':
            return DISPLAY.INLINE_LIST_ITEM;
        case 'inline-table':
            return DISPLAY.INLINE_TABLE;
        case 'inline-flex':
            return DISPLAY.INLINE_FLEX;
        case 'inline-grid':
            return DISPLAY.INLINE_GRID;
    }

    return DISPLAY.NONE;
};

var setDisplayBit = function setDisplayBit(bit, display) {
    return bit | parseDisplayValue(display);
};

var parseDisplay = exports.parseDisplay = function parseDisplay(display) {
    return display.split(' ').reduce(setDisplayBit, 0);
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var FLOAT = exports.FLOAT = {
    NONE: 0,
    LEFT: 1,
    RIGHT: 2,
    INLINE_START: 3,
    INLINE_END: 4
};

var parseCSSFloat = exports.parseCSSFloat = function parseCSSFloat(float) {
    switch (float) {
        case 'left':
            return FLOAT.LEFT;
        case 'right':
            return FLOAT.RIGHT;
        case 'inline-start':
            return FLOAT.INLINE_START;
        case 'inline-end':
            return FLOAT.INLINE_END;
    }
    return FLOAT.NONE;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var parseFontWeight = function parseFontWeight(weight) {
    switch (weight) {
        case 'normal':
            return 400;
        case 'bold':
            return 700;
    }

    var value = parseInt(weight, 10);
    return isNaN(value) ? 400 : value;
};

var parseFont = exports.parseFont = function parseFont(style) {
    var fontFamily = style.fontFamily;
    var fontSize = style.fontSize;
    var fontStyle = style.fontStyle;
    var fontVariant = style.fontVariant;
    var fontWeight = parseFontWeight(style.fontWeight);

    return {
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontStyle: fontStyle,
        fontVariant: fontVariant,
        fontWeight: fontWeight
    };
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parseLetterSpacing = exports.parseLetterSpacing = function parseLetterSpacing(letterSpacing) {
    if (letterSpacing === 'normal') {
        return 0;
    }
    var value = parseFloat(letterSpacing);
    return isNaN(value) ? 0 : value;
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LINE_BREAK = exports.LINE_BREAK = {
    NORMAL: 'normal',
    STRICT: 'strict'
};

var parseLineBreak = exports.parseLineBreak = function parseLineBreak(wordBreak) {
    switch (wordBreak) {
        case 'strict':
            return LINE_BREAK.STRICT;
        case 'normal':
        default:
            return LINE_BREAK.NORMAL;
    }
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseMargin = undefined;

var _Length = __webpack_require__(1);

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIDES = ['top', 'right', 'bottom', 'left'];

var parseMargin = exports.parseMargin = function parseMargin(style) {
    return SIDES.map(function (side) {
        return new _Length2.default(style.getPropertyValue('margin-' + side));
    });
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var OVERFLOW = exports.OVERFLOW = {
    VISIBLE: 0,
    HIDDEN: 1,
    SCROLL: 2,
    AUTO: 3
};

var parseOverflow = exports.parseOverflow = function parseOverflow(overflow) {
    switch (overflow) {
        case 'hidden':
            return OVERFLOW.HIDDEN;
        case 'scroll':
            return OVERFLOW.SCROLL;
        case 'auto':
            return OVERFLOW.AUTO;
        case 'visible':
        default:
            return OVERFLOW.VISIBLE;
    }
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseTextShadow = undefined;

var _Color = __webpack_require__(0);

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NUMBER = /^([+-]|\d|\.)$/i;

var parseTextShadow = exports.parseTextShadow = function parseTextShadow(textShadow) {
    if (textShadow === 'none' || typeof textShadow !== 'string') {
        return null;
    }

    var currentValue = '';
    var isLength = false;
    var values = [];
    var shadows = [];
    var numParens = 0;
    var color = null;

    var appendValue = function appendValue() {
        if (currentValue.length) {
            if (isLength) {
                values.push(parseFloat(currentValue));
            } else {
                color = new _Color2.default(currentValue);
            }
        }
        isLength = false;
        currentValue = '';
    };

    var appendShadow = function appendShadow() {
        if (values.length && color !== null) {
            shadows.push({
                color: color,
                offsetX: values[0] || 0,
                offsetY: values[1] || 0,
                blur: values[2] || 0
            });
        }
        values.splice(0, values.length);
        color = null;
    };

    for (var i = 0; i < textShadow.length; i++) {
        var c = textShadow[i];
        switch (c) {
            case '(':
                currentValue += c;
                numParens++;
                break;
            case ')':
                currentValue += c;
                numParens--;
                break;
            case ',':
                if (numParens === 0) {
                    appendValue();
                    appendShadow();
                } else {
                    currentValue += c;
                }
                break;
            case ' ':
                if (numParens === 0) {
                    appendValue();
                } else {
                    currentValue += c;
                }
                break;
            default:
                if (currentValue.length === 0 && NUMBER.test(c)) {
                    isLength = true;
                }
                currentValue += c;
        }
    }

    appendValue();
    appendShadow();

    if (shadows.length === 0) {
        return null;
    }

    return shadows;
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseTransform = undefined;

var _Length = __webpack_require__(1);

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toFloat = function toFloat(s) {
    return parseFloat(s.trim());
};

var MATRIX = /(matrix|matrix3d)\((.+)\)/;

var parseTransform = exports.parseTransform = function parseTransform(style) {
    var transform = parseTransformMatrix(style.transform || style.webkitTransform || style.mozTransform ||
    // $FlowFixMe
    style.msTransform ||
    // $FlowFixMe
    style.oTransform);
    if (transform === null) {
        return null;
    }

    return {
        transform: transform,
        transformOrigin: parseTransformOrigin(style.transformOrigin || style.webkitTransformOrigin || style.mozTransformOrigin ||
        // $FlowFixMe
        style.msTransformOrigin ||
        // $FlowFixMe
        style.oTransformOrigin)
    };
};

// $FlowFixMe
var parseTransformOrigin = function parseTransformOrigin(origin) {
    if (typeof origin !== 'string') {
        var v = new _Length2.default('0');
        return [v, v];
    }
    var values = origin.split(' ').map(_Length2.default.create);
    return [values[0], values[1]];
};

// $FlowFixMe
var parseTransformMatrix = function parseTransformMatrix(transform) {
    if (transform === 'none' || typeof transform !== 'string') {
        return null;
    }

    var match = transform.match(MATRIX);
    if (match) {
        if (match[1] === 'matrix') {
            var matrix = match[2].split(',').map(toFloat);
            return [matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]];
        } else {
            var matrix3d = match[2].split(',').map(toFloat);
            return [matrix3d[0], matrix3d[1], matrix3d[4], matrix3d[5], matrix3d[12], matrix3d[13]];
        }
    }
    return null;
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var VISIBILITY = exports.VISIBILITY = {
    VISIBLE: 0,
    HIDDEN: 1,
    COLLAPSE: 2
};

var parseVisibility = exports.parseVisibility = function parseVisibility(visibility) {
    switch (visibility) {
        case 'hidden':
            return VISIBILITY.HIDDEN;
        case 'collapse':
            return VISIBILITY.COLLAPSE;
        case 'visible':
        default:
            return VISIBILITY.VISIBLE;
    }
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var WORD_BREAK = exports.WORD_BREAK = {
    NORMAL: 'normal',
    BREAK_ALL: 'break-all',
    KEEP_ALL: 'keep-all'
};

var parseWordBreak = exports.parseWordBreak = function parseWordBreak(wordBreak) {
    switch (wordBreak) {
        case 'break-all':
            return WORD_BREAK.BREAK_ALL;
        case 'keep-all':
            return WORD_BREAK.KEEP_ALL;
        case 'normal':
        default:
            return WORD_BREAK.NORMAL;
    }
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parseZIndex = exports.parseZIndex = function parseZIndex(zIndex) {
    var auto = zIndex === 'auto';
    return {
        auto: auto,
        order: auto ? 0 : parseInt(zIndex, 10)
    };
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Util = __webpack_require__(13);

Object.defineProperty(exports, 'toCodePoints', {
  enumerable: true,
  get: function get() {
    return _Util.toCodePoints;
  }
});
Object.defineProperty(exports, 'fromCodePoint', {
  enumerable: true,
  get: function get() {
    return _Util.fromCodePoint;
  }
});

var _LineBreak = __webpack_require__(47);

Object.defineProperty(exports, 'LineBreaker', {
  enumerable: true,
  get: function get() {
    return _LineBreak.LineBreaker;
  }
});

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LineBreaker = exports.inlineBreakOpportunities = exports.lineBreakAtIndex = exports.codePointsToCharacterClasses = exports.UnicodeTrie = exports.BREAK_ALLOWED = exports.BREAK_NOT_ALLOWED = exports.BREAK_MANDATORY = exports.classes = exports.LETTER_NUMBER_MODIFIER = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Trie = __webpack_require__(48);

var _linebreakTrie = __webpack_require__(49);

var _linebreakTrie2 = _interopRequireDefault(_linebreakTrie);

var _Util = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LETTER_NUMBER_MODIFIER = exports.LETTER_NUMBER_MODIFIER = 50;

// Non-tailorable Line Breaking Classes
var BK = 1; //  Cause a line break (after)
var CR = 2; //  Cause a line break (after), except between CR and LF
var LF = 3; //  Cause a line break (after)
var CM = 4; //  Prohibit a line break between the character and the preceding character
var NL = 5; //  Cause a line break (after)
var SG = 6; //  Do not occur in well-formed text
var WJ = 7; //  Prohibit line breaks before and after
var ZW = 8; //  Provide a break opportunity
var GL = 9; //  Prohibit line breaks before and after
var SP = 10; // Enable indirect line breaks
var ZWJ = 11; // Prohibit line breaks within joiner sequences
// Break Opportunities
var B2 = 12; //  Provide a line break opportunity before and after the character
var BA = 13; //  Generally provide a line break opportunity after the character
var BB = 14; //  Generally provide a line break opportunity before the character
var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
var CB = 16; //   Provide a line break opportunity contingent on additional information
// Characters Prohibiting Certain Breaks
var CL = 17; //  Prohibit line breaks before
var CP = 18; //  Prohibit line breaks before
var EX = 19; //  Prohibit line breaks before
var IN = 20; //  Allow only indirect line breaks between pairs
var NS = 21; //  Allow only indirect line breaks before
var OP = 22; //  Prohibit line breaks after
var QU = 23; //  Act like they are both opening and closing
// Numeric Context
var IS = 24; //  Prevent breaks after any and before numeric
var NU = 25; //  Form numeric expressions for line breaking purposes
var PO = 26; //  Do not break following a numeric expression
var PR = 27; //  Do not break in front of a numeric expression
var SY = 28; //  Prevent a break before; and allow a break after
// Other Characters
var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
var EB = 32; //  Do not break from following Emoji Modifier
var EM = 33; //  Do not break from preceding Emoji Base
var H2 = 34; //  Form Korean syllable blocks
var H3 = 35; //  Form Korean syllable blocks
var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
var ID = 37; //  Break before or after; except in some numeric context
var JL = 38; //  Form Korean syllable blocks
var JV = 39; //  Form Korean syllable blocks
var JT = 40; //  Form Korean syllable blocks
var RI = 41; //  Keep pairs together. For pairs; break before and after other classes
var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions

var classes = exports.classes = {
    BK: BK,
    CR: CR,
    LF: LF,
    CM: CM,
    NL: NL,
    SG: SG,
    WJ: WJ,
    ZW: ZW,
    GL: GL,
    SP: SP,
    ZWJ: ZWJ,
    B2: B2,
    BA: BA,
    BB: BB,
    HY: HY,
    CB: CB,
    CL: CL,
    CP: CP,
    EX: EX,
    IN: IN,
    NS: NS,
    OP: OP,
    QU: QU,
    IS: IS,
    NU: NU,
    PO: PO,
    PR: PR,
    SY: SY,
    AI: AI,
    AL: AL,
    CJ: CJ,
    EB: EB,
    EM: EM,
    H2: H2,
    H3: H3,
    HL: HL,
    ID: ID,
    JL: JL,
    JV: JV,
    JT: JT,
    RI: RI,
    SA: SA,
    XX: XX
};

var BREAK_MANDATORY = exports.BREAK_MANDATORY = '!';
var BREAK_NOT_ALLOWED = exports.BREAK_NOT_ALLOWED = '×';
var BREAK_ALLOWED = exports.BREAK_ALLOWED = '÷';
var UnicodeTrie = exports.UnicodeTrie = (0, _Trie.createTrieFromBase64)(_linebreakTrie2.default);

var ALPHABETICS = [AL, HL];
var HARD_LINE_BREAKS = [BK, CR, LF, NL];
var SPACE = [SP, ZW];
var PREFIX_POSTFIX = [PR, PO];
var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE);
var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
var HYPHEN = [HY, BA];

var codePointsToCharacterClasses = exports.codePointsToCharacterClasses = function codePointsToCharacterClasses(codePoints) {
    var lineBreak = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'strict';

    var types = [];
    var indicies = [];
    var categories = [];
    codePoints.forEach(function (codePoint, index) {
        var classType = UnicodeTrie.get(codePoint);
        if (classType > LETTER_NUMBER_MODIFIER) {
            categories.push(true);
            classType -= LETTER_NUMBER_MODIFIER;
        } else {
            categories.push(false);
        }

        if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
            // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                indicies.push(index);
                return types.push(CB);
            }
        }

        if (classType === CM || classType === ZWJ) {
            // LB10 Treat any remaining combining mark or ZWJ as AL.
            if (index === 0) {
                indicies.push(index);
                return types.push(AL);
            }

            // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
            // the base character in all of the following rules. Treat ZWJ as if it were CM.
            var prev = types[index - 1];
            if (LINE_BREAKS.indexOf(prev) === -1) {
                indicies.push(indicies[index - 1]);
                return types.push(prev);
            }
            indicies.push(index);
            return types.push(AL);
        }

        indicies.push(index);

        if (classType === CJ) {
            return types.push(lineBreak === 'strict' ? NS : ID);
        }

        if (classType === SA) {
            return types.push(AL);
        }

        if (classType === AI) {
            return types.push(AL);
        }

        // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
        // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
        // to take into account the actual line breaking properties for these characters.
        if (classType === XX) {
            if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) {
                return types.push(ID);
            } else {
                return types.push(AL);
            }
        }

        types.push(classType);
    });

    return [indicies, types, categories];
};

var isAdjacentWithSpaceIgnored = function isAdjacentWithSpaceIgnored(a, b, currentIndex, classTypes) {
    var current = classTypes[currentIndex];
    if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
        var i = currentIndex;
        while (i <= classTypes.length) {
            i++;
            var next = classTypes[i];

            if (next === b) {
                return true;
            }

            if (next !== SP) {
                break;
            }
        }
    }

    if (current === SP) {
        var _i = currentIndex;

        while (_i > 0) {
            _i--;
            var prev = classTypes[_i];

            if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                var n = currentIndex;
                while (n <= classTypes.length) {
                    n++;
                    var _next = classTypes[n];

                    if (_next === b) {
                        return true;
                    }

                    if (_next !== SP) {
                        break;
                    }
                }
            }

            if (prev !== SP) {
                break;
            }
        }
    }
    return false;
};

var previousNonSpaceClassType = function previousNonSpaceClassType(currentIndex, classTypes) {
    var i = currentIndex;
    while (i >= 0) {
        var type = classTypes[i];
        if (type === SP) {
            i--;
        } else {
            return type;
        }
    }
    return 0;
};

var _lineBreakAtIndex = function _lineBreakAtIndex(codePoints, classTypes, indicies, index, forbiddenBreaks) {
    if (indicies[index] === 0) {
        return BREAK_NOT_ALLOWED;
    }

    var currentIndex = index - 1;
    if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
        return BREAK_NOT_ALLOWED;
    }

    var beforeIndex = currentIndex - 1;
    var afterIndex = currentIndex + 1;
    var current = classTypes[currentIndex];

    // LB4 Always break after hard line breaks.
    // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
    var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
    var next = classTypes[afterIndex];

    if (current === CR && next === LF) {
        return BREAK_NOT_ALLOWED;
    }

    if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
        return BREAK_MANDATORY;
    }

    // LB6 Do not break before hard line breaks.
    if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB7 Do not break before spaces or zero width space.
    if (SPACE.indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
    if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
        return BREAK_ALLOWED;
    }

    // LB8a Do not break between a zero width joiner and an ideograph, emoji base or emoji modifier.
    if (UnicodeTrie.get(codePoints[currentIndex]) === ZWJ && (next === ID || next === EB || next === EM)) {
        return BREAK_NOT_ALLOWED;
    }

    // LB11 Do not break before or after Word joiner and related characters.
    if (current === WJ || next === WJ) {
        return BREAK_NOT_ALLOWED;
    }

    // LB12 Do not break after NBSP and related characters.
    if (current === GL) {
        return BREAK_NOT_ALLOWED;
    }

    // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
    if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
        return BREAK_NOT_ALLOWED;
    }

    // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
    if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB14 Do not break after ‘[’, even after spaces.
    if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
        return BREAK_NOT_ALLOWED;
    }

    // LB15 Do not break within ‘”[’, even with intervening spaces.
    if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
        return BREAK_NOT_ALLOWED;
    }

    // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
    if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
        return BREAK_NOT_ALLOWED;
    }

    // LB17 Do not break within ‘——’, even with intervening spaces.
    if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
        return BREAK_NOT_ALLOWED;
    }

    // LB18 Break after spaces.
    if (current === SP) {
        return BREAK_ALLOWED;
    }

    // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
    if (current === QU || next === QU) {
        return BREAK_NOT_ALLOWED;
    }

    // LB20 Break before and after unresolved CB.
    if (next === CB || current === CB) {
        return BREAK_ALLOWED;
    }

    // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
    if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
        return BREAK_NOT_ALLOWED;
    }

    // LB21a Don't break after Hebrew + Hyphen.
    if (before === HL && HYPHEN.indexOf(current) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB21b Don’t break between Solidus and Hebrew letters.
    if (current === SY && next === HL) {
        return BREAK_NOT_ALLOWED;
    }

    // LB22 Do not break between two ellipses, or between letters, numbers or exclamations and ellipsis.
    if (next === IN && ALPHABETICS.concat(IN, EX, NU, ID, EB, EM).indexOf(current) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB23 Do not break between digits and letters.
    if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) {
        return BREAK_NOT_ALLOWED;
    }

    // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
    if (current === PR && [ID, EB, EM].indexOf(next) !== -1 || [ID, EB, EM].indexOf(current) !== -1 && next === PO) {
        return BREAK_NOT_ALLOWED;
    }

    // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
    if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB25 Do not break between the following pairs of classes relevant to numbers:
    if (
    // (PR | PO) × ( OP | HY )? NU
    [PR, PO].indexOf(current) !== -1 && (next === NU || [OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) ||
    // ( OP | HY ) × NU
    [OP, HY].indexOf(current) !== -1 && next === NU ||
    // NU ×	(NU | SY | IS)
    current === NU && [NU, SY, IS].indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
    if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
        var prevIndex = currentIndex;
        while (prevIndex >= 0) {
            var type = classTypes[prevIndex];
            if (type === NU) {
                return BREAK_NOT_ALLOWED;
            } else if ([SY, IS].indexOf(type) !== -1) {
                prevIndex--;
            } else {
                break;
            }
        }
    }

    // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
    if ([PR, PO].indexOf(next) !== -1) {
        var _prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
        while (_prevIndex >= 0) {
            var _type = classTypes[_prevIndex];
            if (_type === NU) {
                return BREAK_NOT_ALLOWED;
            } else if ([SY, IS].indexOf(_type) !== -1) {
                _prevIndex--;
            } else {
                break;
            }
        }
    }

    // LB26 Do not break a Korean syllable.
    if (JL === current && [JL, JV, H2, H3].indexOf(next) !== -1 || [JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1 || [JT, H3].indexOf(current) !== -1 && next === JT) {
        return BREAK_NOT_ALLOWED;
    }

    // LB27 Treat a Korean Syllable Block the same as ID.
    if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) {
        return BREAK_NOT_ALLOWED;
    }

    // LB28 Do not break between alphabetics (“at”).
    if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
    if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
    if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) {
        return BREAK_NOT_ALLOWED;
    }

    // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
    // indicators preceding the position of the break.
    if (current === RI && next === RI) {
        var i = indicies[currentIndex];
        var count = 1;
        while (i > 0) {
            i--;
            if (classTypes[i] === RI) {
                count++;
            } else {
                break;
            }
        }
        if (count % 2 !== 0) {
            return BREAK_NOT_ALLOWED;
        }
    }

    // LB30b Do not break between an emoji base and an emoji modifier.
    if (current === EB && next === EM) {
        return BREAK_NOT_ALLOWED;
    }

    return BREAK_ALLOWED;
};

var lineBreakAtIndex = exports.lineBreakAtIndex = function lineBreakAtIndex(codePoints, index) {
    // LB2 Never break at the start of text.
    if (index === 0) {
        return BREAK_NOT_ALLOWED;
    }

    // LB3 Always break at the end of text.
    if (index >= codePoints.length) {
        return BREAK_MANDATORY;
    }

    var _codePointsToCharacte = codePointsToCharacterClasses(codePoints),
        _codePointsToCharacte2 = _slicedToArray(_codePointsToCharacte, 2),
        indicies = _codePointsToCharacte2[0],
        classTypes = _codePointsToCharacte2[1];

    return _lineBreakAtIndex(codePoints, classTypes, indicies, index);
};

var cssFormattedClasses = function cssFormattedClasses(codePoints, options) {
    if (!options) {
        options = { lineBreak: 'normal', wordBreak: 'normal' };
    }

    var _codePointsToCharacte3 = codePointsToCharacterClasses(codePoints, options.lineBreak),
        _codePointsToCharacte4 = _slicedToArray(_codePointsToCharacte3, 3),
        indicies = _codePointsToCharacte4[0],
        classTypes = _codePointsToCharacte4[1],
        isLetterNumber = _codePointsToCharacte4[2];

    if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
        classTypes = classTypes.map(function (type) {
            return [NU, AL, SA].indexOf(type) !== -1 ? ID : type;
        });
    }

    var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function (isLetterNumber, i) {
        return isLetterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
    }) : null;

    return [indicies, classTypes, forbiddenBreakpoints];
};

var inlineBreakOpportunities = exports.inlineBreakOpportunities = function inlineBreakOpportunities(str, options) {
    var codePoints = (0, _Util.toCodePoints)(str);
    var output = BREAK_NOT_ALLOWED;

    var _cssFormattedClasses = cssFormattedClasses(codePoints, options),
        _cssFormattedClasses2 = _slicedToArray(_cssFormattedClasses, 3),
        indicies = _cssFormattedClasses2[0],
        classTypes = _cssFormattedClasses2[1],
        forbiddenBreakpoints = _cssFormattedClasses2[2];

    codePoints.forEach(function (codePoint, i) {
        output += (0, _Util.fromCodePoint)(codePoint) + (i >= codePoints.length - 1 ? BREAK_MANDATORY : _lineBreakAtIndex(codePoints, classTypes, indicies, i + 1, forbiddenBreakpoints));
    });

    return output;
};

var Break = function () {
    function Break(codePoints, lineBreak, start, end) {
        _classCallCheck(this, Break);

        this._codePoints = codePoints;
        this.required = lineBreak === BREAK_MANDATORY;
        this.start = start;
        this.end = end;
    }

    _createClass(Break, [{
        key: 'slice',
        value: function slice() {
            return _Util.fromCodePoint.apply(undefined, _toConsumableArray(this._codePoints.slice(this.start, this.end)));
        }
    }]);

    return Break;
}();

var LineBreaker = exports.LineBreaker = function LineBreaker(str, options) {
    var codePoints = (0, _Util.toCodePoints)(str);

    var _cssFormattedClasses3 = cssFormattedClasses(codePoints, options),
        _cssFormattedClasses4 = _slicedToArray(_cssFormattedClasses3, 3),
        indicies = _cssFormattedClasses4[0],
        classTypes = _cssFormattedClasses4[1],
        forbiddenBreakpoints = _cssFormattedClasses4[2];

    var length = codePoints.length;
    var lastEnd = 0;
    var nextIndex = 0;

    return {
        next: function next() {
            if (nextIndex >= length) {
                return { done: true };
            }
            var lineBreak = BREAK_NOT_ALLOWED;
            while (nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED) {}

            if (lineBreak !== BREAK_NOT_ALLOWED || nextIndex === length) {
                var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                lastEnd = nextIndex;
                return { value: value, done: false };
            }

            return { done: true };
        }
    };
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Trie = exports.createTrieFromBase64 = exports.UTRIE2_INDEX_2_MASK = exports.UTRIE2_INDEX_2_BLOCK_LENGTH = exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = exports.UTRIE2_INDEX_1_OFFSET = exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = exports.UTRIE2_INDEX_2_BMP_LENGTH = exports.UTRIE2_LSCP_INDEX_2_LENGTH = exports.UTRIE2_DATA_MASK = exports.UTRIE2_DATA_BLOCK_LENGTH = exports.UTRIE2_LSCP_INDEX_2_OFFSET = exports.UTRIE2_SHIFT_1_2 = exports.UTRIE2_INDEX_SHIFT = exports.UTRIE2_SHIFT_1 = exports.UTRIE2_SHIFT_2 = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Util = __webpack_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** Shift size for getting the index-2 table offset. */
var UTRIE2_SHIFT_2 = exports.UTRIE2_SHIFT_2 = 5;

/** Shift size for getting the index-1 table offset. */
var UTRIE2_SHIFT_1 = exports.UTRIE2_SHIFT_1 = 6 + 5;

/**
 * Shift size for shifting left the index array values.
 * Increases possible data size with 16-bit index values at the cost
 * of compactability.
 * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
 */
var UTRIE2_INDEX_SHIFT = exports.UTRIE2_INDEX_SHIFT = 2;

/**
 * Difference between the two shift sizes,
 * for getting an index-1 offset from an index-2 offset. 6=11-5
 */
var UTRIE2_SHIFT_1_2 = exports.UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;

/**
 * The part of the index-2 table for U+D800..U+DBFF stores values for
 * lead surrogate code _units_ not code _points_.
 * Values for lead surrogate code _points_ are indexed with this portion of the table.
 * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
 */
var UTRIE2_LSCP_INDEX_2_OFFSET = exports.UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;

/** Number of entries in a data block. 32=0x20 */
var UTRIE2_DATA_BLOCK_LENGTH = exports.UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
/** Mask for getting the lower bits for the in-data-block offset. */
var UTRIE2_DATA_MASK = exports.UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;

var UTRIE2_LSCP_INDEX_2_LENGTH = exports.UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
/** Count the lengths of both BMP pieces. 2080=0x820 */
var UTRIE2_INDEX_2_BMP_LENGTH = exports.UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
/**
 * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
 * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
 */
var UTRIE2_UTF8_2B_INDEX_2_OFFSET = exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
var UTRIE2_UTF8_2B_INDEX_2_LENGTH = exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
/**
 * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
 * Variable length, for code points up to highStart, where the last single-value range starts.
 * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
 * (For 0x100000 supplementary code points U+10000..U+10ffff.)
 *
 * The part of the index-2 table for supplementary code points starts
 * after this index-1 table.
 *
 * Both the index-1 table and the following part of the index-2 table
 * are omitted completely if there is only BMP data.
 */
var UTRIE2_INDEX_1_OFFSET = exports.UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;

/**
 * Number of index-1 entries for the BMP. 32=0x20
 * This part of the index-1 table is omitted from the serialized form.
 */
var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;

/** Number of entries in an index-2 block. 64=0x40 */
var UTRIE2_INDEX_2_BLOCK_LENGTH = exports.UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
/** Mask for getting the lower bits for the in-index-2-block offset. */
var UTRIE2_INDEX_2_MASK = exports.UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;

var createTrieFromBase64 = exports.createTrieFromBase64 = function createTrieFromBase64(base64) {
    var buffer = (0, _Util.decode)(base64);
    var view32 = Array.isArray(buffer) ? (0, _Util.polyUint32Array)(buffer) : new Uint32Array(buffer);
    var view16 = Array.isArray(buffer) ? (0, _Util.polyUint16Array)(buffer) : new Uint16Array(buffer);
    var headerLength = 24;

    var index = view16.slice(headerLength / 2, view32[4] / 2);
    var data = view32[5] === 2 ? view16.slice((headerLength + view32[4]) / 2) : view32.slice(Math.ceil((headerLength + view32[4]) / 4));

    return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
};

var Trie = exports.Trie = function () {
    function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
        _classCallCheck(this, Trie);

        this.initialValue = initialValue;
        this.errorValue = errorValue;
        this.highStart = highStart;
        this.highValueIndex = highValueIndex;
        this.index = index;
        this.data = data;
    }

    /**
     * Get the value for a code point as stored in the Trie.
     *
     * @param codePoint the code point
     * @return the value
     */


    _createClass(Trie, [{
        key: 'get',
        value: function get(codePoint) {
            var ix = void 0;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }

                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }

                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }

            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        }
    }]);

    return Trie;
}();

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = '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';

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Path = __webpack_require__(6);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Circle = function Circle(x, y, radius) {
    _classCallCheck(this, Circle);

    this.type = _Path.PATH.CIRCLE;
    this.x = x;
    this.y = y;
    this.radius = radius;
    if (true) {
        if (isNaN(x)) {
            console.error('Invalid x value given for Circle');
        }
        if (isNaN(y)) {
            console.error('Invalid y value given for Circle');
        }
        if (isNaN(radius)) {
            console.error('Invalid radius value given for Circle');
        }
    }
};

exports.default = Circle;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Bounds = __webpack_require__(2);

var _Font = __webpack_require__(25);

var _Gradient = __webpack_require__(52);

var _TextContainer = __webpack_require__(9);

var _TextContainer2 = _interopRequireDefault(_TextContainer);

var _background = __webpack_require__(5);

var _border = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Renderer = function () {
    function Renderer(target, options) {
        _classCallCheck(this, Renderer);

        this.target = target;
        this.options = options;
        target.render(options);
    }

    _createClass(Renderer, [{
        key: 'renderNode',
        value: function renderNode(container) {
            if (container.isVisible()) {
                this.renderNodeBackgroundAndBorders(container);
                this.renderNodeContent(container);
            }
        }
    }, {
        key: 'renderNodeContent',
        value: function renderNodeContent(container) {
            var _this = this;

            var callback = function callback() {
                if (container.childNodes.length) {
                    container.childNodes.forEach(function (child) {
                        if (child instanceof _TextContainer2.default) {
                            var style = child.parent.style;
                            _this.target.renderTextNode(child.bounds, style.color, style.font, style.textDecoration, style.textShadow);
                        } else {
                            _this.target.drawShape(child, container.style.color);
                        }
                    });
                }

                if (container.image) {
                    var _image = _this.options.imageStore.get(container.image);
                    if (_image) {
                        var contentBox = (0, _Bounds.calculateContentBox)(container.bounds, container.style.padding, container.style.border);
                        var _width = typeof _image.width === 'number' && _image.width > 0 ? _image.width : contentBox.width;
                        var _height = typeof _image.height === 'number' && _image.height > 0 ? _image.height : contentBox.height;
                        if (_width > 0 && _height > 0) {
                            _this.target.clip([(0, _Bounds.calculatePaddingBoxPath)(container.curvedBounds)], function () {
                                _this.target.drawImage(_image, new _Bounds.Bounds(0, 0, _width, _height), contentBox);
                            });
                        }
                    }
                }
            };
            var paths = container.getClipPaths();
            if (paths.length) {
                this.target.clip(paths, callback);
            } else {
                callback();
            }
        }
    }, {
        key: 'renderNodeBackgroundAndBorders',
        value: function renderNodeBackgroundAndBorders(container) {
            var _this2 = this;

            var HAS_BACKGROUND = !container.style.background.backgroundColor.isTransparent() || container.style.background.backgroundImage.length;

            var hasRenderableBorders = container.style.border.some(function (border) {
                return border.borderStyle !== _border.BORDER_STYLE.NONE && !border.borderColor.isTransparent();
            });

            var callback = function callback() {
                var backgroundPaintingArea = (0, _background.calculateBackgroungPaintingArea)(container.curvedBounds, container.style.background.backgroundClip);

                if (HAS_BACKGROUND) {
                    _this2.target.clip([backgroundPaintingArea], function () {
                        if (!container.style.background.backgroundColor.isTransparent()) {
                            _this2.target.fill(container.style.background.backgroundColor);
                        }

                        _this2.renderBackgroundImage(container);
                    });
                }

                container.style.border.forEach(function (border, side) {
                    if (border.borderStyle !== _border.BORDER_STYLE.NONE && !border.borderColor.isTransparent()) {
                        _this2.renderBorder(border, side, container.curvedBounds);
                    }
                });
            };

            if (HAS_BACKGROUND || hasRenderableBorders) {
                var paths = container.parent ? container.parent.getClipPaths() : [];
                if (paths.length) {
                    this.target.clip(paths, callback);
                } else {
                    callback();
                }
            }
        }
    }, {
        key: 'renderBackgroundImage',
        value: function renderBackgroundImage(container) {
            var _this3 = this;

            container.style.background.backgroundImage.slice(0).reverse().forEach(function (backgroundImage) {
                if (backgroundImage.source.method === 'url' && backgroundImage.source.args.length) {
                    _this3.renderBackgroundRepeat(container, backgroundImage);
                } else if (/gradient/i.test(backgroundImage.source.method)) {
                    _this3.renderBackgroundGradient(container, backgroundImage);
                }
            });
        }
    }, {
        key: 'renderBackgroundRepeat',
        value: function renderBackgroundRepeat(container, background) {
            var image = this.options.imageStore.get(background.source.args[0]);
            if (image) {
                var backgroundPositioningArea = (0, _background.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
                var backgroundImageSize = (0, _background.calculateBackgroundSize)(background, image, backgroundPositioningArea);
                var position = (0, _background.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
                var _path = (0, _background.calculateBackgroundRepeatPath)(background, position, backgroundImageSize, backgroundPositioningArea, container.bounds);

                var _offsetX = Math.round(backgroundPositioningArea.left + position.x);
                var _offsetY = Math.round(backgroundPositioningArea.top + position.y);
                this.target.renderRepeat(_path, image, backgroundImageSize, _offsetX, _offsetY);
            }
        }
    }, {
        key: 'renderBackgroundGradient',
        value: function renderBackgroundGradient(container, background) {
            var backgroundPositioningArea = (0, _background.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
            var backgroundImageSize = (0, _background.calculateGradientBackgroundSize)(background, backgroundPositioningArea);
            var position = (0, _background.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
            var gradientBounds = new _Bounds.Bounds(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y), backgroundImageSize.width, backgroundImageSize.height);

            var gradient = (0, _Gradient.parseGradient)(container, background.source, gradientBounds);
            if (gradient) {
                switch (gradient.type) {
                    case _Gradient.GRADIENT_TYPE.LINEAR_GRADIENT:
                        // $FlowFixMe
                        this.target.renderLinearGradient(gradientBounds, gradient);
                        break;
                    case _Gradient.GRADIENT_TYPE.RADIAL_GRADIENT:
                        // $FlowFixMe
                        this.target.renderRadialGradient(gradientBounds, gradient);
                        break;
                }
            }
        }
    }, {
        key: 'renderBorder',
        value: function renderBorder(border, side, curvePoints) {
            this.target.drawShape((0, _Bounds.parsePathForBorder)(curvePoints, side), border.borderColor);
        }
    }, {
        key: 'renderStack',
        value: function renderStack(stack) {
            var _this4 = this;

            if (stack.container.isVisible()) {
                var _opacity = stack.getOpacity();
                if (_opacity !== this._opacity) {
                    this.target.setOpacity(stack.getOpacity());
                    this._opacity = _opacity;
                }

                var _transform = stack.container.style.transform;
                if (_transform !== null) {
                    this.target.transform(stack.container.bounds.left + _transform.transformOrigin[0].value, stack.container.bounds.top + _transform.transformOrigin[1].value, _transform.transform, function () {
                        return _this4.renderStackContent(stack);
                    });
                } else {
                    this.renderStackContent(stack);
                }
            }
        }
    }, {
        key: 'renderStackContent',
        value: function renderStackContent(stack) {
            var _splitStackingContext = splitStackingContexts(stack),
                _splitStackingContext2 = _slicedToArray(_splitStackingContext, 5),
                negativeZIndex = _splitStackingContext2[0],
                zeroOrAutoZIndexOrTransformedOrOpacity = _splitStackingContext2[1],
                positiveZIndex = _splitStackingContext2[2],
                nonPositionedFloats = _splitStackingContext2[3],
                nonPositionedInlineLevel = _splitStackingContext2[4];

            var _splitDescendants = splitDescendants(stack),
                _splitDescendants2 = _slicedToArray(_splitDescendants, 2),
                inlineLevel = _splitDescendants2[0],
                nonInlineLevel = _splitDescendants2[1];

            // https://www.w3.org/TR/css-position-3/#painting-order
            // 1. the background and borders of the element forming the stacking context.


            this.renderNodeBackgroundAndBorders(stack.container);
            // 2. the child stacking contexts with negative stack levels (most negative first).
            negativeZIndex.sort(sortByZIndex).forEach(this.renderStack, this);
            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
            this.renderNodeContent(stack.container);
            nonInlineLevel.forEach(this.renderNode, this);
            // 4. All non-positioned floating descendants, in tree order. For each one of these,
            // treat the element as if it created a new stacking context, but any positioned descendants and descendants
            // which actually create a new stacking context should be considered part of the parent stacking context,
            // not this new one.
            nonPositionedFloats.forEach(this.renderStack, this);
            // 5. the in-flow, inline-level, non-positioned descendants, including inline tables and inline blocks.
            nonPositionedInlineLevel.forEach(this.renderStack, this);
            inlineLevel.forEach(this.renderNode, this);
            // 6. All positioned, opacity or transform descendants, in tree order that fall into the following categories:
            //  All positioned descendants with 'z-index: auto' or 'z-index: 0', in tree order.
            //  For those with 'z-index: auto', treat the element as if it created a new stacking context,
            //  but any positioned descendants and descendants which actually create a new stacking context should be
            //  considered part of the parent stacking context, not this new one. For those with 'z-index: 0',
            //  treat the stacking context generated atomically.
            //
            //  All opacity descendants with opacity less than 1
            //
            //  All transform descendants with transform other than none
            zeroOrAutoZIndexOrTransformedOrOpacity.forEach(this.renderStack, this);
            // 7. Stacking contexts formed by positioned descendants with z-indices greater than or equal to 1 in z-index
            // order (smallest first) then tree order.
            positiveZIndex.sort(sortByZIndex).forEach(this.renderStack, this);
        }
    }, {
        key: 'render',
        value: function render(stack) {
            var _this5 = this;

            if (this.options.backgroundColor) {
                this.target.rectangle(this.options.x, this.options.y, this.options.width, this.options.height, this.options.backgroundColor);
            }
            this.renderStack(stack);
            var target = this.target.getTarget();
            if (true) {
                return target.then(function (output) {
                    _this5.options.logger.log('Render completed');
                    return output;
                });
            }
            return target;
        }
    }]);

    return Renderer;
}();

exports.default = Renderer;


var splitDescendants = function splitDescendants(stack) {
    var inlineLevel = [];
    var nonInlineLevel = [];

    var length = stack.children.length;
    for (var i = 0; i < length; i++) {
        var child = stack.children[i];
        if (child.isInlineLevel()) {
            inlineLevel.push(child);
        } else {
            nonInlineLevel.push(child);
        }
    }
    return [inlineLevel, nonInlineLevel];
};

var splitStackingContexts = function splitStackingContexts(stack) {
    var negativeZIndex = [];
    var zeroOrAutoZIndexOrTransformedOrOpacity = [];
    var positiveZIndex = [];
    var nonPositionedFloats = [];
    var nonPositionedInlineLevel = [];
    var length = stack.contexts.length;
    for (var i = 0; i < length; i++) {
        var child = stack.contexts[i];
        if (child.container.isPositioned() || child.container.style.opacity < 1 || child.container.isTransformed()) {
            if (child.container.style.zIndex.order < 0) {
                negativeZIndex.push(child);
            } else if (child.container.style.zIndex.order > 0) {
                positiveZIndex.push(child);
            } else {
                zeroOrAutoZIndexOrTransformedOrOpacity.push(child);
            }
        } else {
            if (child.container.isFloating()) {
                nonPositionedFloats.push(child);
            } else {
                nonPositionedInlineLevel.push(child);
            }
        }
    }
    return [negativeZIndex, zeroOrAutoZIndexOrTransformedOrOpacity, positiveZIndex, nonPositionedFloats, nonPositionedInlineLevel];
};

var sortByZIndex = function sortByZIndex(a, b) {
    if (a.container.style.zIndex.order > b.container.style.zIndex.order) {
        return 1;
    } else if (a.container.style.zIndex.order < b.container.style.zIndex.order) {
        return -1;
    }

    return a.container.index > b.container.index ? 1 : -1;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.transformWebkitRadialGradientArgs = exports.parseGradient = exports.RadialGradient = exports.LinearGradient = exports.RADIAL_GRADIENT_SHAPE = exports.GRADIENT_TYPE = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _NodeContainer = __webpack_require__(3);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _Angle = __webpack_require__(53);

var _Color = __webpack_require__(0);

var _Color2 = _interopRequireDefault(_Color);

var _Length = __webpack_require__(1);

var _Length2 = _interopRequireDefault(_Length);

var _Util = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SIDE_OR_CORNER = /^(to )?(left|top|right|bottom)( (left|top|right|bottom))?$/i;
var PERCENTAGE_ANGLES = /^([+-]?\d*\.?\d+)% ([+-]?\d*\.?\d+)%$/i;
var ENDS_WITH_LENGTH = /(px)|%|( 0)$/i;
var FROM_TO_COLORSTOP = /^(from|to|color-stop)\((?:([\d.]+)(%)?,\s*)?(.+?)\)$/i;
var RADIAL_SHAPE_DEFINITION = /^\s*(circle|ellipse)?\s*((?:([\d.]+)(px|r?em|%)\s*(?:([\d.]+)(px|r?em|%))?)|closest-side|closest-corner|farthest-side|farthest-corner)?\s*(?:at\s*(?:(left|center|right)|([\d.]+)(px|r?em|%))\s+(?:(top|center|bottom)|([\d.]+)(px|r?em|%)))?(?:\s|$)/i;

var GRADIENT_TYPE = exports.GRADIENT_TYPE = {
    LINEAR_GRADIENT: 0,
    RADIAL_GRADIENT: 1
};

var RADIAL_GRADIENT_SHAPE = exports.RADIAL_GRADIENT_SHAPE = {
    CIRCLE: 0,
    ELLIPSE: 1
};

var LENGTH_FOR_POSITION = {
    left: new _Length2.default('0%'),
    top: new _Length2.default('0%'),
    center: new _Length2.default('50%'),
    right: new _Length2.default('100%'),
    bottom: new _Length2.default('100%')
};

var LinearGradient = exports.LinearGradient = function LinearGradient(colorStops, direction) {
    _classCallCheck(this, LinearGradient);

    this.type = GRADIENT_TYPE.LINEAR_GRADIENT;
    this.colorStops = colorStops;
    this.direction = direction;
};

var RadialGradient = exports.RadialGradient = function RadialGradient(colorStops, shape, center, radius) {
    _classCallCheck(this, RadialGradient);

    this.type = GRADIENT_TYPE.RADIAL_GRADIENT;
    this.colorStops = colorStops;
    this.shape = shape;
    this.center = center;
    this.radius = radius;
};

var parseGradient = exports.parseGradient = function parseGradient(container, _ref, bounds) {
    var args = _ref.args,
        method = _ref.method,
        prefix = _ref.prefix;

    if (method === 'linear-gradient') {
        return parseLinearGradient(args, bounds, !!prefix);
    } else if (method === 'gradient' && args[0] === 'linear') {
        // TODO handle correct angle
        return parseLinearGradient(['to bottom'].concat(transformObsoleteColorStops(args.slice(3))), bounds, !!prefix);
    } else if (method === 'radial-gradient') {
        return parseRadialGradient(container, prefix === '-webkit-' ? transformWebkitRadialGradientArgs(args) : args, bounds);
    } else if (method === 'gradient' && args[0] === 'radial') {
        return parseRadialGradient(container, transformObsoleteColorStops(transformWebkitRadialGradientArgs(args.slice(1))), bounds);
    }
};

var parseColorStops = function parseColorStops(args, firstColorStopIndex, lineLength) {
    var colorStops = [];

    for (var i = firstColorStopIndex; i < args.length; i++) {
        var value = args[i];
        var HAS_LENGTH = ENDS_WITH_LENGTH.test(value);
        var lastSpaceIndex = value.lastIndexOf(' ');
        var _color = new _Color2.default(HAS_LENGTH ? value.substring(0, lastSpaceIndex) : value);
        var _stop = HAS_LENGTH ? new _Length2.default(value.substring(lastSpaceIndex + 1)) : i === firstColorStopIndex ? new _Length2.default('0%') : i === args.length - 1 ? new _Length2.default('100%') : null;
        colorStops.push({ color: _color, stop: _stop });
    }

    var absoluteValuedColorStops = colorStops.map(function (_ref2) {
        var color = _ref2.color,
            stop = _ref2.stop;

        var absoluteStop = lineLength === 0 ? 0 : stop ? stop.getAbsoluteValue(lineLength) / lineLength : null;

        return {
            color: color,
            // $FlowFixMe
            stop: absoluteStop
        };
    });

    var previousColorStop = absoluteValuedColorStops[0].stop;
    for (var _i = 0; _i < absoluteValuedColorStops.length; _i++) {
        if (previousColorStop !== null) {
            var _stop2 = absoluteValuedColorStops[_i].stop;
            if (_stop2 === null) {
                var n = _i;
                while (absoluteValuedColorStops[n].stop === null) {
                    n++;
                }
                var steps = n - _i + 1;
                var nextColorStep = absoluteValuedColorStops[n].stop;
                var stepSize = (nextColorStep - previousColorStop) / steps;
                for (; _i < n; _i++) {
                    previousColorStop = absoluteValuedColorStops[_i].stop = previousColorStop + stepSize;
                }
            } else {
                previousColorStop = _stop2;
            }
        }
    }

    return absoluteValuedColorStops;
};

var parseLinearGradient = function parseLinearGradient(args, bounds, hasPrefix) {
    var angle = (0, _Angle.parseAngle)(args[0]);
    var HAS_SIDE_OR_CORNER = SIDE_OR_CORNER.test(args[0]);
    var HAS_DIRECTION = HAS_SIDE_OR_CORNER || angle !== null || PERCENTAGE_ANGLES.test(args[0]);
    var direction = HAS_DIRECTION ? angle !== null ? calculateGradientDirection(
    // if there is a prefix, the 0° angle points due East (instead of North per W3C)
    hasPrefix ? angle - Math.PI * 0.5 : angle, bounds) : HAS_SIDE_OR_CORNER ? parseSideOrCorner(args[0], bounds) : parsePercentageAngle(args[0], bounds) : calculateGradientDirection(Math.PI, bounds);
    var firstColorStopIndex = HAS_DIRECTION ? 1 : 0;

    // TODO: Fix some inaccuracy with color stops with px values
    var lineLength = Math.min((0, _Util.distance)(Math.abs(direction.x0) + Math.abs(direction.x1), Math.abs(direction.y0) + Math.abs(direction.y1)), bounds.width * 2, bounds.height * 2);

    return new LinearGradient(parseColorStops(args, firstColorStopIndex, lineLength), direction);
};

var parseRadialGradient = function parseRadialGradient(container, args, bounds) {
    var m = args[0].match(RADIAL_SHAPE_DEFINITION);
    var shape = m && (m[1] === 'circle' || // explicit shape specification
    m[3] !== undefined && m[5] === undefined) // only one radius coordinate
    ? RADIAL_GRADIENT_SHAPE.CIRCLE : RADIAL_GRADIENT_SHAPE.ELLIPSE;
    var radius = {};
    var center = {};

    if (m) {
        // Radius
        if (m[3] !== undefined) {
            radius.x = (0, _Length.calculateLengthFromValueWithUnit)(container, m[3], m[4]).getAbsoluteValue(bounds.width);
        }

        if (m[5] !== undefined) {
            radius.y = (0, _Length.calculateLengthFromValueWithUnit)(container, m[5], m[6]).getAbsoluteValue(bounds.height);
        }

        // Position
        if (m[7]) {
            center.x = LENGTH_FOR_POSITION[m[7].toLowerCase()];
        } else if (m[8] !== undefined) {
            center.x = (0, _Length.calculateLengthFromValueWithUnit)(container, m[8], m[9]);
        }

        if (m[10]) {
            center.y = LENGTH_FOR_POSITION[m[10].toLowerCase()];
        } else if (m[11] !== undefined) {
            center.y = (0, _Length.calculateLengthFromValueWithUnit)(container, m[11], m[12]);
        }
    }

    var gradientCenter = {
        x: center.x === undefined ? bounds.width / 2 : center.x.getAbsoluteValue(bounds.width),
        y: center.y === undefined ? bounds.height / 2 : center.y.getAbsoluteValue(bounds.height)
    };
    var gradientRadius = calculateRadius(m && m[2] || 'farthest-corner', shape, gradientCenter, radius, bounds);

    return new RadialGradient(parseColorStops(args, m ? 1 : 0, Math.min(gradientRadius.x, gradientRadius.y)), shape, gradientCenter, gradientRadius);
};

var calculateGradientDirection = function calculateGradientDirection(radian, bounds) {
    var width = bounds.width;
    var height = bounds.height;
    var HALF_WIDTH = width * 0.5;
    var HALF_HEIGHT = height * 0.5;
    var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
    var HALF_LINE_LENGTH = lineLength / 2;

    var x0 = HALF_WIDTH + Math.sin(radian) * HALF_LINE_LENGTH;
    var y0 = HALF_HEIGHT - Math.cos(radian) * HALF_LINE_LENGTH;
    var x1 = width - x0;
    var y1 = height - y0;

    return { x0: x0, x1: x1, y0: y0, y1: y1 };
};

var parseTopRight = function parseTopRight(bounds) {
    return Math.acos(bounds.width / 2 / ((0, _Util.distance)(bounds.width, bounds.height) / 2));
};

var parseSideOrCorner = function parseSideOrCorner(side, bounds) {
    switch (side) {
        case 'bottom':
        case 'to top':
            return calculateGradientDirection(0, bounds);
        case 'left':
        case 'to right':
            return calculateGradientDirection(Math.PI / 2, bounds);
        case 'right':
        case 'to left':
            return calculateGradientDirection(3 * Math.PI / 2, bounds);
        case 'top right':
        case 'right top':
        case 'to bottom left':
        case 'to left bottom':
            return calculateGradientDirection(Math.PI + parseTopRight(bounds), bounds);
        case 'top left':
        case 'left top':
        case 'to bottom right':
        case 'to right bottom':
            return calculateGradientDirection(Math.PI - parseTopRight(bounds), bounds);
        case 'bottom left':
        case 'left bottom':
        case 'to top right':
        case 'to right top':
            return calculateGradientDirection(parseTopRight(bounds), bounds);
        case 'bottom right':
        case 'right bottom':
        case 'to top left':
        case 'to left top':
            return calculateGradientDirection(2 * Math.PI - parseTopRight(bounds), bounds);
        case 'top':
        case 'to bottom':
        default:
            return calculateGradientDirection(Math.PI, bounds);
    }
};

var parsePercentageAngle = function parsePercentageAngle(angle, bounds) {
    var _angle$split$map = angle.split(' ').map(parseFloat),
        _angle$split$map2 = _slicedToArray(_angle$split$map, 2),
        left = _angle$split$map2[0],
        top = _angle$split$map2[1];

    var ratio = left / 100 * bounds.width / (top / 100 * bounds.height);

    return calculateGradientDirection(Math.atan(isNaN(ratio) ? 1 : ratio) + Math.PI / 2, bounds);
};

var findCorner = function findCorner(bounds, x, y, closest) {
    var corners = [{ x: 0, y: 0 }, { x: 0, y: bounds.height }, { x: bounds.width, y: 0 }, { x: bounds.width, y: bounds.height }];

    // $FlowFixMe
    return corners.reduce(function (stat, corner) {
        var d = (0, _Util.distance)(x - corner.x, y - corner.y);
        if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
            return {
                optimumCorner: corner,
                optimumDistance: d
            };
        }

        return stat;
    }, {
        optimumDistance: closest ? Infinity : -Infinity,
        optimumCorner: null
    }).optimumCorner;
};

var calculateRadius = function calculateRadius(extent, shape, center, radius, bounds) {
    var x = center.x;
    var y = center.y;
    var rx = 0;
    var ry = 0;

    switch (extent) {
        case 'closest-side':
            // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
            // If the shape is an ellipse, it exactly meets the closest side in each dimension.
            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
                rx = ry = Math.min(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                rx = Math.min(Math.abs(x), Math.abs(x - bounds.width));
                ry = Math.min(Math.abs(y), Math.abs(y - bounds.height));
            }
            break;

        case 'closest-corner':
            // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
            // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
                rx = ry = Math.min((0, _Util.distance)(x, y), (0, _Util.distance)(x, y - bounds.height), (0, _Util.distance)(x - bounds.width, y), (0, _Util.distance)(x - bounds.width, y - bounds.height));
            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                var c = Math.min(Math.abs(y), Math.abs(y - bounds.height)) / Math.min(Math.abs(x), Math.abs(x - bounds.width));
                var corner = findCorner(bounds, x, y, true);
                rx = (0, _Util.distance)(corner.x - x, (corner.y - y) / c);
                ry = c * rx;
            }
            break;

        case 'farthest-side':
            // Same as closest-side, except the ending shape is sized based on the farthest side(s)
            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
                rx = ry = Math.max(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                rx = Math.max(Math.abs(x), Math.abs(x - bounds.width));
                ry = Math.max(Math.abs(y), Math.abs(y - bounds.height));
            }
            break;

        case 'farthest-corner':
            // Same as closest-corner, except the ending shape is sized based on the farthest corner.
            // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
                rx = ry = Math.max((0, _Util.distance)(x, y), (0, _Util.distance)(x, y - bounds.height), (0, _Util.distance)(x - bounds.width, y), (0, _Util.distance)(x - bounds.width, y - bounds.height));
            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                var _c = Math.max(Math.abs(y), Math.abs(y - bounds.height)) / Math.max(Math.abs(x), Math.abs(x - bounds.width));
                var _corner = findCorner(bounds, x, y, false);
                rx = (0, _Util.distance)(_corner.x - x, (_corner.y - y) / _c);
                ry = _c * rx;
            }
            break;

        default:
            // pixel or percentage values
            rx = radius.x || 0;
            ry = radius.y !== undefined ? radius.y : rx;
            break;
    }

    return {
        x: rx,
        y: ry
    };
};

var transformWebkitRadialGradientArgs = exports.transformWebkitRadialGradientArgs = function transformWebkitRadialGradientArgs(args) {
    var shape = '';
    var radius = '';
    var extent = '';
    var position = '';
    var idx = 0;

    var POSITION = /^(left|center|right|\d+(?:px|r?em|%)?)(?:\s+(top|center|bottom|\d+(?:px|r?em|%)?))?$/i;
    var SHAPE_AND_EXTENT = /^(circle|ellipse)?\s*(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)?$/i;
    var RADIUS = /^\d+(px|r?em|%)?(?:\s+\d+(px|r?em|%)?)?$/i;

    var matchStartPosition = args[idx].match(POSITION);
    if (matchStartPosition) {
        idx++;
    }

    var matchShapeExtent = args[idx].match(SHAPE_AND_EXTENT);
    if (matchShapeExtent) {
        shape = matchShapeExtent[1] || '';
        extent = matchShapeExtent[2] || '';
        if (extent === 'contain') {
            extent = 'closest-side';
        } else if (extent === 'cover') {
            extent = 'farthest-corner';
        }
        idx++;
    }

    var matchStartRadius = args[idx].match(RADIUS);
    if (matchStartRadius) {
        idx++;
    }

    var matchEndPosition = args[idx].match(POSITION);
    if (matchEndPosition) {
        idx++;
    }

    var matchEndRadius = args[idx].match(RADIUS);
    if (matchEndRadius) {
        idx++;
    }

    var matchPosition = matchEndPosition || matchStartPosition;
    if (matchPosition && matchPosition[1]) {
        position = matchPosition[1] + (/^\d+$/.test(matchPosition[1]) ? 'px' : '');
        if (matchPosition[2]) {
            position += ' ' + matchPosition[2] + (/^\d+$/.test(matchPosition[2]) ? 'px' : '');
        }
    }

    var matchRadius = matchEndRadius || matchStartRadius;
    if (matchRadius) {
        radius = matchRadius[0];
        if (!matchRadius[1]) {
            radius += 'px';
        }
    }

    if (position && !shape && !radius && !extent) {
        radius = position;
        position = '';
    }

    if (position) {
        position = 'at ' + position;
    }

    return [[shape, extent, radius, position].filter(function (s) {
        return !!s;
    }).join(' ')].concat(args.slice(idx));
};

var transformObsoleteColorStops = function transformObsoleteColorStops(args) {
    return args.map(function (color) {
        return color.match(FROM_TO_COLORSTOP);
    })
    // $FlowFixMe
    .map(function (v, index) {
        if (!v) {
            return args[index];
        }

        switch (v[1]) {
            case 'from':
                return v[4] + ' 0%';
            case 'to':
                return v[4] + ' 100%';
            case 'color-stop':
                if (v[3] === '%') {
                    return v[4] + ' ' + v[2];
                }
                return v[4] + ' ' + parseFloat(v[2]) * 100 + '%';
        }
    });
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ANGLE = /([+-]?\d*\.?\d+)(deg|grad|rad|turn)/i;

var parseAngle = exports.parseAngle = function parseAngle(angle) {
    var match = angle.match(ANGLE);

    if (match) {
        var value = parseFloat(match[1]);
        switch (match[2].toLowerCase()) {
            case 'deg':
                return Math.PI * value / 180;
            case 'grad':
                return Math.PI / 200 * value;
            case 'rad':
                return value;
            case 'turn':
                return Math.PI * 2 * value;
        }
    }

    return null;
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cloneWindow = exports.DocumentCloner = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Bounds = __webpack_require__(2);

var _Proxy = __webpack_require__(26);

var _ResourceLoader = __webpack_require__(55);

var _ResourceLoader2 = _interopRequireDefault(_ResourceLoader);

var _Util = __webpack_require__(4);

var _background = __webpack_require__(5);

var _CanvasRenderer = __webpack_require__(15);

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

var _PseudoNodeContent = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';

var DocumentCloner = exports.DocumentCloner = function () {
    function DocumentCloner(element, options, logger, copyInline, renderer) {
        _classCallCheck(this, DocumentCloner);

        this.referenceElement = element;
        this.scrolledElements = [];
        this.copyStyles = copyInline;
        this.inlineImages = copyInline;
        this.logger = logger;
        this.options = options;
        this.renderer = renderer;
        this.resourceLoader = new _ResourceLoader2.default(options, logger, window);
        this.pseudoContentData = {
            counters: {},
            quoteDepth: 0
        };
        // $FlowFixMe
        this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
    }

    _createClass(DocumentCloner, [{
        key: 'inlineAllImages',
        value: function inlineAllImages(node) {
            var _this = this;

            if (this.inlineImages && node) {
                var style = node.style;
                Promise.all((0, _background.parseBackgroundImage)(style.backgroundImage).map(function (backgroundImage) {
                    if (backgroundImage.method === 'url') {
                        return _this.resourceLoader.inlineImage(backgroundImage.args[0]).then(function (img) {
                            return img && typeof img.src === 'string' ? 'url("' + img.src + '")' : 'none';
                        }).catch(function (e) {
                            if (true) {
                                _this.logger.log('Unable to load image', e);
                            }
                        });
                    }
                    return Promise.resolve('' + backgroundImage.prefix + backgroundImage.method + '(' + backgroundImage.args.join(',') + ')');
                })).then(function (backgroundImages) {
                    if (backgroundImages.length > 1) {
                        // TODO Multiple backgrounds somehow broken in Chrome
                        style.backgroundColor = '';
                    }
                    style.backgroundImage = backgroundImages.join(',');
                });

                if (node instanceof HTMLImageElement) {
                    this.resourceLoader.inlineImage(node.src).then(function (img) {
                        if (img && node instanceof HTMLImageElement && node.parentNode) {
                            var parentNode = node.parentNode;
                            var clonedChild = (0, _Util.copyCSSStyles)(node.style, img.cloneNode(false));
                            parentNode.replaceChild(clonedChild, node);
                        }
                    }).catch(function (e) {
                        if (true) {
                            _this.logger.log('Unable to load image', e);
                        }
                    });
                }
            }
        }
    }, {
        key: 'inlineFonts',
        value: function inlineFonts(document) {
            var _this2 = this;

            return Promise.all(Array.from(document.styleSheets).map(function (sheet) {
                if (sheet.href) {
                    return fetch(sheet.href).then(function (res) {
                        return res.text();
                    }).then(function (text) {
                        return createStyleSheetFontsFromText(text, sheet.href);
                    }).catch(function (e) {
                        if (true) {
                            _this2.logger.log('Unable to load stylesheet', e);
                        }
                        return [];
                    });
                }
                return getSheetFonts(sheet, document);
            })).then(function (fonts) {
                return fonts.reduce(function (acc, font) {
                    return acc.concat(font);
                }, []);
            }).then(function (fonts) {
                return Promise.all(fonts.map(function (font) {
                    return fetch(font.formats[0].src).then(function (response) {
                        return response.blob();
                    }).then(function (blob) {
                        return new Promise(function (resolve, reject) {
                            var reader = new FileReader();
                            reader.onerror = reject;
                            reader.onload = function () {
                                // $FlowFixMe
                                var result = reader.result;
                                resolve(result);
                            };
                            reader.readAsDataURL(blob);
                        });
                    }).then(function (dataUri) {
                        font.fontFace.setProperty('src', 'url("' + dataUri + '")');
                        return '@font-face {' + font.fontFace.cssText + ' ';
                    });
                }));
            }).then(function (fontCss) {
                var style = document.createElement('style');
                style.textContent = fontCss.join('\n');
                _this2.documentElement.appendChild(style);
            });
        }
    }, {
        key: 'createElementClone',
        value: function createElementClone(node) {
            var _this3 = this;

            if (this.copyStyles && node instanceof HTMLCanvasElement) {
                var img = node.ownerDocument.createElement('img');
                try {
                    img.src = node.toDataURL();
                    return img;
                } catch (e) {
                    if (true) {
                        this.logger.log('Unable to clone canvas contents, canvas is tainted');
                    }
                }
            }

            if (node instanceof HTMLIFrameElement) {
                var tempIframe = node.cloneNode(false);
                var iframeKey = generateIframeKey();
                tempIframe.setAttribute('data-html2canvas-internal-iframe-key', iframeKey);

                var _parseBounds = (0, _Bounds.parseBounds)(node, 0, 0),
                    width = _parseBounds.width,
                    height = _parseBounds.height;

                this.resourceLoader.cache[iframeKey] = getIframeDocumentElement(node, this.options).then(function (documentElement) {
                    return _this3.renderer(documentElement, {
                        async: _this3.options.async,
                        allowTaint: _this3.options.allowTaint,
                        backgroundColor: '#ffffff',
                        canvas: null,
                        imageTimeout: _this3.options.imageTimeout,
                        logging: _this3.options.logging,
                        proxy: _this3.options.proxy,
                        removeContainer: _this3.options.removeContainer,
                        scale: _this3.options.scale,
                        foreignObjectRendering: _this3.options.foreignObjectRendering,
                        useCORS: _this3.options.useCORS,
                        target: new _CanvasRenderer2.default(),
                        width: width,
                        height: height,
                        x: 0,
                        y: 0,
                        windowWidth: documentElement.ownerDocument.defaultView.innerWidth,
                        windowHeight: documentElement.ownerDocument.defaultView.innerHeight,
                        scrollX: documentElement.ownerDocument.defaultView.pageXOffset,
                        scrollY: documentElement.ownerDocument.defaultView.pageYOffset
                    }, _this3.logger.child(iframeKey));
                }).then(function (canvas) {
                    return new Promise(function (resolve, reject) {
                        var iframeCanvas = document.createElement('img');
                        iframeCanvas.onload = function () {
                            return resolve(canvas);
                        };
                        iframeCanvas.onerror = reject;
                        iframeCanvas.src = canvas.toDataURL();
                        if (tempIframe.parentNode) {
                            tempIframe.parentNode.replaceChild((0, _Util.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node), iframeCanvas), tempIframe);
                        }
                    });
                });
                return tempIframe;
            }

            if (node instanceof HTMLStyleElement && node.sheet && node.sheet.cssRules) {
                var css = [].slice.call(node.sheet.cssRules, 0).reduce(function (css, rule) {
                    try {
                        if (rule && rule.cssText) {
                            return css + rule.cssText;
                        }
                        return css;
                    } catch (err) {
                        _this3.logger.log('Unable to access cssText property', rule.name);
                        return css;
                    }
                }, '');
                var style = node.cloneNode(false);
                style.textContent = css;
                return style;
            }

            return node.cloneNode(false);
        }
    }, {
        key: 'cloneNode',
        value: function cloneNode(node) {
            var clone = node.nodeType === Node.TEXT_NODE ? document.createTextNode(node.nodeValue) : this.createElementClone(node);

            var window = node.ownerDocument.defaultView;
            var style = node instanceof window.HTMLElement ? window.getComputedStyle(node) : null;
            var styleBefore = node instanceof window.HTMLElement ? window.getComputedStyle(node, ':before') : null;
            var styleAfter = node instanceof window.HTMLElement ? window.getComputedStyle(node, ':after') : null;

            if (this.referenceElement === node && clone instanceof window.HTMLElement) {
                this.clonedReferenceElement = clone;
            }

            if (clone instanceof window.HTMLBodyElement) {
                createPseudoHideStyles(clone);
            }

            var counters = (0, _PseudoNodeContent.parseCounterReset)(style, this.pseudoContentData);
            var contentBefore = (0, _PseudoNodeContent.resolvePseudoContent)(node, styleBefore, this.pseudoContentData);

            for (var child = node.firstChild; child; child = child.nextSibling) {
                if (child.nodeType !== Node.ELEMENT_NODE || child.nodeName !== 'SCRIPT' &&
                // $FlowFixMe
                !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' ||
                // $FlowFixMe
                !this.options.ignoreElements(child))) {
                    if (!this.copyStyles || child.nodeName !== 'STYLE') {
                        clone.appendChild(this.cloneNode(child));
                    }
                }
            }

            var contentAfter = (0, _PseudoNodeContent.resolvePseudoContent)(node, styleAfter, this.pseudoContentData);
            (0, _PseudoNodeContent.popCounters)(counters, this.pseudoContentData);

            if (node instanceof window.HTMLElement && clone instanceof window.HTMLElement) {
                if (styleBefore) {
                    this.inlineAllImages(inlinePseudoElement(node, clone, styleBefore, contentBefore, PSEUDO_BEFORE));
                }
                if (styleAfter) {
                    this.inlineAllImages(inlinePseudoElement(node, clone, styleAfter, contentAfter, PSEUDO_AFTER));
                }
                if (style && this.copyStyles && !(node instanceof HTMLIFrameElement)) {
                    (0, _Util.copyCSSStyles)(style, clone);
                }
                this.inlineAllImages(clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                switch (node.nodeName) {
                    case 'CANVAS':
                        if (!this.copyStyles) {
                            cloneCanvasContents(node, clone);
                        }
                        break;
                    case 'TEXTAREA':
                    case 'SELECT':
                        clone.value = node.value;
                        break;
                }
            }
            return clone;
        }
    }]);

    return DocumentCloner;
}();

var getSheetFonts = function getSheetFonts(sheet, document) {
    // $FlowFixMe
    return (sheet.cssRules ? Array.from(sheet.cssRules) : []).filter(function (rule) {
        return rule.type === CSSRule.FONT_FACE_RULE;
    }).map(function (rule) {
        var src = (0, _background.parseBackgroundImage)(rule.style.getPropertyValue('src'));
        var formats = [];
        for (var i = 0; i < src.length; i++) {
            if (src[i].method === 'url' && src[i + 1] && src[i + 1].method === 'format') {
                var a = document.createElement('a');
                a.href = src[i].args[0];
                if (document.body) {
                    document.body.appendChild(a);
                }

                var font = {
                    src: a.href,
                    format: src[i + 1].args[0]
                };
                formats.push(font);
            }
        }

        return {
            // TODO select correct format for browser),

            formats: formats.filter(function (font) {
                return (/^woff/i.test(font.format)
                );
            }),
            fontFace: rule.style
        };
    }).filter(function (font) {
        return font.formats.length;
    });
};

var createStyleSheetFontsFromText = function createStyleSheetFontsFromText(text, baseHref) {
    var doc = document.implementation.createHTMLDocument('');
    var base = document.createElement('base');
    // $FlowFixMe
    base.href = baseHref;
    var style = document.createElement('style');

    style.textContent = text;
    if (doc.head) {
        doc.head.appendChild(base);
    }
    if (doc.body) {
        doc.body.appendChild(style);
    }

    return style.sheet ? getSheetFonts(style.sheet, doc) : [];
};

var restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {
    if (ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
        ownerDocument.defaultView.scrollTo(x, y);
    }
};

var cloneCanvasContents = function cloneCanvasContents(canvas, clonedCanvas) {
    try {
        if (clonedCanvas) {
            clonedCanvas.width = canvas.width;
            clonedCanvas.height = canvas.height;
            var ctx = canvas.getContext('2d');
            var clonedCtx = clonedCanvas.getContext('2d');
            if (ctx) {
                clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
            } else {
                clonedCtx.drawImage(canvas, 0, 0);
            }
        }
    } catch (e) {}
};

var inlinePseudoElement = function inlinePseudoElement(node, clone, style, contentItems, pseudoElt) {
    if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') {
        return;
    }

    var anonymousReplacedElement = clone.ownerDocument.createElement('html2canvaspseudoelement');
    (0, _Util.copyCSSStyles)(style, anonymousReplacedElement);

    if (contentItems) {
        var len = contentItems.length;
        for (var i = 0; i < len; i++) {
            var item = contentItems[i];
            switch (item.type) {
                case _PseudoNodeContent.PSEUDO_CONTENT_ITEM_TYPE.IMAGE:
                    var img = clone.ownerDocument.createElement('img');
                    img.src = (0, _background.parseBackgroundImage)('url(' + item.value + ')')[0].args[0];
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                    break;
                case _PseudoNodeContent.PSEUDO_CONTENT_ITEM_TYPE.TEXT:
                    anonymousReplacedElement.appendChild(clone.ownerDocument.createTextNode(item.value));
                    break;
            }
        }
    }

    anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
    clone.className += pseudoElt === PSEUDO_BEFORE ? ' ' + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
    if (pseudoElt === PSEUDO_BEFORE) {
        clone.insertBefore(anonymousReplacedElement, clone.firstChild);
    } else {
        clone.appendChild(anonymousReplacedElement);
    }

    return anonymousReplacedElement;
};

var URL_REGEXP = /^url\((.+)\)$/i;
var PSEUDO_BEFORE = ':before';
var PSEUDO_AFTER = ':after';
var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';

var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';

var createPseudoHideStyles = function createPseudoHideStyles(body) {
    createStyles(body, '.' + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + '\n         .' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
};

var createStyles = function createStyles(body, styles) {
    var style = body.ownerDocument.createElement('style');
    style.innerHTML = styles;
    body.appendChild(style);
};

var initNode = function initNode(_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        element = _ref2[0],
        x = _ref2[1],
        y = _ref2[2];

    element.scrollLeft = x;
    element.scrollTop = y;
};

var generateIframeKey = function generateIframeKey() {
    return Math.ceil(Date.now() + Math.random() * 10000000).toString(16);
};

var DATA_URI_REGEXP = /^data:text\/(.+);(base64)?,(.*)$/i;

var getIframeDocumentElement = function getIframeDocumentElement(node, options) {
    try {
        return Promise.resolve(node.contentWindow.document.documentElement);
    } catch (e) {
        return options.proxy ? (0, _Proxy.Proxy)(node.src, options).then(function (html) {
            var match = html.match(DATA_URI_REGEXP);
            if (!match) {
                return Promise.reject();
            }

            return match[2] === 'base64' ? window.atob(decodeURIComponent(match[3])) : decodeURIComponent(match[3]);
        }).then(function (html) {
            return createIframeContainer(node.ownerDocument, (0, _Bounds.parseBounds)(node, 0, 0)).then(function (cloneIframeContainer) {
                var cloneWindow = cloneIframeContainer.contentWindow;
                var documentClone = cloneWindow.document;

                documentClone.open();
                documentClone.write(html);
                var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {
                    return documentClone.documentElement;
                });

                documentClone.close();
                return iframeLoad;
            });
        }) : Promise.reject();
    }
};

var createIframeContainer = function createIframeContainer(ownerDocument, bounds) {
    var cloneIframeContainer = ownerDocument.createElement('iframe');

    cloneIframeContainer.className = 'html2canvas-container';
    cloneIframeContainer.style.visibility = 'hidden';
    cloneIframeContainer.style.position = 'fixed';
    cloneIframeContainer.style.left = '-10000px';
    cloneIframeContainer.style.top = '0px';
    cloneIframeContainer.style.border = '0';
    cloneIframeContainer.width = bounds.width.toString();
    cloneIframeContainer.height = bounds.height.toString();
    cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
    cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
    if (!ownerDocument.body) {
        return Promise.reject( true ? 'Body element not found in Document that is getting rendered' : '');
    }

    ownerDocument.body.appendChild(cloneIframeContainer);

    return Promise.resolve(cloneIframeContainer);
};

var iframeLoader = function iframeLoader(cloneIframeContainer) {
    var cloneWindow = cloneIframeContainer.contentWindow;
    var documentClone = cloneWindow.document;

    return new Promise(function (resolve, reject) {
        cloneWindow.onload = cloneIframeContainer.onload = documentClone.onreadystatechange = function () {
            var interval = setInterval(function () {
                if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                    clearInterval(interval);
                    resolve(cloneIframeContainer);
                }
            }, 50);
        };
    });
};

var cloneWindow = exports.cloneWindow = function cloneWindow(ownerDocument, bounds, referenceElement, options, logger, renderer) {
    var cloner = new DocumentCloner(referenceElement, options, logger, false, renderer);
    var scrollX = ownerDocument.defaultView.pageXOffset;
    var scrollY = ownerDocument.defaultView.pageYOffset;

    return createIframeContainer(ownerDocument, bounds).then(function (cloneIframeContainer) {
        var cloneWindow = cloneIframeContainer.contentWindow;
        var documentClone = cloneWindow.document;

        /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */

        var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {
            cloner.scrolledElements.forEach(initNode);
            cloneWindow.scrollTo(bounds.left, bounds.top);
            if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== bounds.top || cloneWindow.scrollX !== bounds.left)) {
                documentClone.documentElement.style.top = -bounds.top + 'px';
                documentClone.documentElement.style.left = -bounds.left + 'px';
                documentClone.documentElement.style.position = 'absolute';
            }

            var result = Promise.resolve([cloneIframeContainer, cloner.clonedReferenceElement, cloner.resourceLoader]);

            var onclone = options.onclone;

            return cloner.clonedReferenceElement instanceof cloneWindow.HTMLElement || cloner.clonedReferenceElement instanceof ownerDocument.defaultView.HTMLElement || cloner.clonedReferenceElement instanceof HTMLElement ? typeof onclone === 'function' ? Promise.resolve().then(function () {
                return onclone(documentClone);
            }).then(function () {
                return result;
            }) : result : Promise.reject( true ? 'Error finding the ' + referenceElement.nodeName + ' in the cloned document' : '');
        });

        documentClone.open();
        documentClone.write(serializeDoctype(document.doctype) + '<html></html>');
        // Chrome scrolls the parent document for some reason after the write to the cloned window???
        restoreOwnerScroll(referenceElement.ownerDocument, scrollX, scrollY);
        documentClone.replaceChild(documentClone.adoptNode(cloner.documentElement), documentClone.documentElement);
        documentClone.close();

        return iframeLoad;
    });
};

var serializeDoctype = function serializeDoctype(doctype) {
    var str = '';
    if (doctype) {
        str += '<!DOCTYPE ';
        if (doctype.name) {
            str += doctype.name;
        }

        if (doctype.internalSubset) {
            str += doctype.internalSubset;
        }

        if (doctype.publicId) {
            str += '"' + doctype.publicId + '"';
        }

        if (doctype.systemId) {
            str += '"' + doctype.systemId + '"';
        }

        str += '>';
    }

    return str;
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResourceStore = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Feature = __webpack_require__(10);

var _Feature2 = _interopRequireDefault(_Feature);

var _Proxy = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResourceLoader = function () {
    function ResourceLoader(options, logger, window) {
        _classCallCheck(this, ResourceLoader);

        this.options = options;
        this._window = window;
        this.origin = this.getOrigin(window.location.href);
        this.cache = {};
        this.logger = logger;
        this._index = 0;
    }

    _createClass(ResourceLoader, [{
        key: 'loadImage',
        value: function loadImage(src) {
            var _this = this;

            if (this.hasResourceInCache(src)) {
                return src;
            }
            if (isBlobImage(src)) {
                this.cache[src] = _loadImage(src, this.options.imageTimeout || 0);
                return src;
            }

            if (!isSVG(src) || _Feature2.default.SUPPORT_SVG_DRAWING) {
                if (this.options.allowTaint === true || isInlineImage(src) || this.isSameOrigin(src)) {
                    return this.addImage(src, src, false);
                } else if (!this.isSameOrigin(src)) {
                    if (typeof this.options.proxy === 'string') {
                        this.cache[src] = (0, _Proxy.Proxy)(src, this.options).then(function (src) {
                            return _loadImage(src, _this.options.imageTimeout || 0);
                        });
                        return src;
                    } else if (this.options.useCORS === true && _Feature2.default.SUPPORT_CORS_IMAGES) {
                        return this.addImage(src, src, true);
                    }
                }
            }
        }
    }, {
        key: 'inlineImage',
        value: function inlineImage(src) {
            var _this2 = this;

            if (isInlineImage(src)) {
                return _loadImage(src, this.options.imageTimeout || 0);
            }
            if (this.hasResourceInCache(src)) {
                return this.cache[src];
            }
            if (!this.isSameOrigin(src) && typeof this.options.proxy === 'string') {
                return this.cache[src] = (0, _Proxy.Proxy)(src, this.options).then(function (src) {
                    return _loadImage(src, _this2.options.imageTimeout || 0);
                });
            }

            return this.xhrImage(src);
        }
    }, {
        key: 'xhrImage',
        value: function xhrImage(src) {
            var _this3 = this;

            this.cache[src] = new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        if (xhr.status !== 200) {
                            reject('Failed to fetch image ' + src.substring(0, 256) + ' with status code ' + xhr.status);
                        } else {
                            var reader = new FileReader();
                            reader.addEventListener('load', function () {
                                // $FlowFixMe
                                var result = reader.result;
                                resolve(result);
                            }, false);
                            reader.addEventListener('error', function (e) {
                                return reject(e);
                            }, false);
                            reader.readAsDataURL(xhr.response);
                        }
                    }
                };
                xhr.responseType = 'blob';
                if (_this3.options.imageTimeout) {
                    var timeout = _this3.options.imageTimeout;
                    xhr.timeout = timeout;
                    xhr.ontimeout = function () {
                        return reject( true ? 'Timed out (' + timeout + 'ms) fetching ' + src.substring(0, 256) : '');
                    };
                }
                xhr.open('GET', src, true);
                xhr.send();
            }).then(function (src) {
                return _loadImage(src, _this3.options.imageTimeout || 0);
            });

            return this.cache[src];
        }
    }, {
        key: 'loadCanvas',
        value: function loadCanvas(node) {
            var key = String(this._index++);
            this.cache[key] = Promise.resolve(node);
            return key;
        }
    }, {
        key: 'hasResourceInCache',
        value: function hasResourceInCache(key) {
            return typeof this.cache[key] !== 'undefined';
        }
    }, {
        key: 'addImage',
        value: function addImage(key, src, useCORS) {
            var _this4 = this;

            if (true) {
                this.logger.log('Added image ' + key.substring(0, 256));
            }

            var imageLoadHandler = function imageLoadHandler(supportsDataImages) {
                return new Promise(function (resolve, reject) {
                    var img = new Image();
                    img.onload = function () {
                        return resolve(img);
                    };
                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                    if (!supportsDataImages || useCORS) {
                        img.crossOrigin = 'anonymous';
                    }

                    img.onerror = reject;
                    img.src = src;
                    if (img.complete === true) {
                        // Inline XML images may fail to parse, throwing an Error later on
                        setTimeout(function () {
                            resolve(img);
                        }, 500);
                    }
                    if (_this4.options.imageTimeout) {
                        var timeout = _this4.options.imageTimeout;
                        setTimeout(function () {
                            return reject( true ? 'Timed out (' + timeout + 'ms) fetching ' + src.substring(0, 256) : '');
                        }, timeout);
                    }
                });
            };

            this.cache[key] = isInlineBase64Image(src) && !isSVG(src) ? // $FlowFixMe
            _Feature2.default.SUPPORT_BASE64_DRAWING(src).then(imageLoadHandler) : imageLoadHandler(true);
            return key;
        }
    }, {
        key: 'isSameOrigin',
        value: function isSameOrigin(url) {
            return this.getOrigin(url) === this.origin;
        }
    }, {
        key: 'getOrigin',
        value: function getOrigin(url) {
            var link = this._link || (this._link = this._window.document.createElement('a'));
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        }
    }, {
        key: 'ready',
        value: function ready() {
            var _this5 = this;

            var keys = Object.keys(this.cache);
            var values = keys.map(function (str) {
                return _this5.cache[str].catch(function (e) {
                    if (true) {
                        _this5.logger.log('Unable to load image', e);
                    }
                    return null;
                });
            });
            return Promise.all(values).then(function (images) {
                if (true) {
                    _this5.logger.log('Finished loading ' + images.length + ' images', images);
                }
                return new ResourceStore(keys, images);
            });
        }
    }]);

    return ResourceLoader;
}();

exports.default = ResourceLoader;

var ResourceStore = exports.ResourceStore = function () {
    function ResourceStore(keys, resources) {
        _classCallCheck(this, ResourceStore);

        this._keys = keys;
        this._resources = resources;
    }

    _createClass(ResourceStore, [{
        key: 'get',
        value: function get(key) {
            var index = this._keys.indexOf(key);
            return index === -1 ? null : this._resources[index];
        }
    }]);

    return ResourceStore;
}();

var INLINE_SVG = /^data:image\/svg\+xml/i;
var INLINE_BASE64 = /^data:image\/.*;base64,/i;
var INLINE_IMG = /^data:image\/.*/i;

var isInlineImage = function isInlineImage(src) {
    return INLINE_IMG.test(src);
};
var isInlineBase64Image = function isInlineBase64Image(src) {
    return INLINE_BASE64.test(src);
};
var isBlobImage = function isBlobImage(src) {
    return src.substr(0, 4) === 'blob';
};

var isSVG = function isSVG(src) {
    return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
};

var _loadImage = function _loadImage(src, timeout) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
            return resolve(img);
        };
        img.onerror = reject;
        img.src = src;
        if (img.complete === true) {
            // Inline XML images may fail to parse, throwing an Error later on
            setTimeout(function () {
                resolve(img);
            }, 500);
        }
        if (timeout) {
            setTimeout(function () {
                return reject( true ? 'Timed out (' + timeout + 'ms) loading image' : '');
            }, timeout);
        }
    });
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseContent = exports.resolvePseudoContent = exports.popCounters = exports.parseCounterReset = exports.TOKEN_TYPE = exports.PSEUDO_CONTENT_ITEM_TYPE = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ListItem = __webpack_require__(14);

var _listStyle = __webpack_require__(8);

var PSEUDO_CONTENT_ITEM_TYPE = exports.PSEUDO_CONTENT_ITEM_TYPE = {
    TEXT: 0,
    IMAGE: 1
};

var TOKEN_TYPE = exports.TOKEN_TYPE = {
    STRING: 0,
    ATTRIBUTE: 1,
    URL: 2,
    COUNTER: 3,
    COUNTERS: 4,
    OPENQUOTE: 5,
    CLOSEQUOTE: 6
};

var parseCounterReset = exports.parseCounterReset = function parseCounterReset(style, data) {
    if (!style || !style.counterReset || style.counterReset === 'none') {
        return [];
    }

    var counterNames = [];
    var counterResets = style.counterReset.split(/\s*,\s*/);
    var lenCounterResets = counterResets.length;

    for (var i = 0; i < lenCounterResets; i++) {
        var _counterResets$i$spli = counterResets[i].split(/\s+/),
            _counterResets$i$spli2 = _slicedToArray(_counterResets$i$spli, 2),
            counterName = _counterResets$i$spli2[0],
            initialValue = _counterResets$i$spli2[1];

        counterNames.push(counterName);
        var counter = data.counters[counterName];
        if (!counter) {
            counter = data.counters[counterName] = [];
        }
        counter.push(parseInt(initialValue || 0, 10));
    }

    return counterNames;
};

var popCounters = exports.popCounters = function popCounters(counterNames, data) {
    var lenCounters = counterNames.length;
    for (var i = 0; i < lenCounters; i++) {
        data.counters[counterNames[i]].pop();
    }
};

var resolvePseudoContent = exports.resolvePseudoContent = function resolvePseudoContent(node, style, data) {
    if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') {
        return null;
    }

    var tokens = parseContent(style.content);

    var len = tokens.length;
    var contentItems = [];
    var s = '';

    // increment the counter (if there is a "counter-increment" declaration)
    var counterIncrement = style.counterIncrement;
    if (counterIncrement && counterIncrement !== 'none') {
        var _counterIncrement$spl = counterIncrement.split(/\s+/),
            _counterIncrement$spl2 = _slicedToArray(_counterIncrement$spl, 2),
            counterName = _counterIncrement$spl2[0],
            incrementValue = _counterIncrement$spl2[1];

        var counter = data.counters[counterName];
        if (counter) {
            counter[counter.length - 1] += incrementValue === undefined ? 1 : parseInt(incrementValue, 10);
        }
    }

    // build the content string
    for (var i = 0; i < len; i++) {
        var token = tokens[i];
        switch (token.type) {
            case TOKEN_TYPE.STRING:
                s += token.value || '';
                break;

            case TOKEN_TYPE.ATTRIBUTE:
                if (node instanceof HTMLElement && token.value) {
                    s += node.getAttribute(token.value) || '';
                }
                break;

            case TOKEN_TYPE.COUNTER:
                var _counter = data.counters[token.name || ''];
                if (_counter) {
                    s += formatCounterValue([_counter[_counter.length - 1]], '', token.format);
                }
                break;

            case TOKEN_TYPE.COUNTERS:
                var _counters = data.counters[token.name || ''];
                if (_counters) {
                    s += formatCounterValue(_counters, token.glue, token.format);
                }
                break;

            case TOKEN_TYPE.OPENQUOTE:
                s += getQuote(style, true, data.quoteDepth);
                data.quoteDepth++;
                break;

            case TOKEN_TYPE.CLOSEQUOTE:
                data.quoteDepth--;
                s += getQuote(style, false, data.quoteDepth);
                break;

            case TOKEN_TYPE.URL:
                if (s) {
                    contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.TEXT, value: s });
                    s = '';
                }
                contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.IMAGE, value: token.value || '' });
                break;
        }
    }

    if (s) {
        contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.TEXT, value: s });
    }

    return contentItems;
};

var parseContent = exports.parseContent = function parseContent(content, cache) {
    if (cache && cache[content]) {
        return cache[content];
    }

    var tokens = [];
    var len = content.length;

    var isString = false;
    var isEscaped = false;
    var isFunction = false;
    var str = '';
    var functionName = '';
    var args = [];

    for (var i = 0; i < len; i++) {
        var c = content.charAt(i);

        switch (c) {
            case "'":
            case '"':
                if (isEscaped) {
                    str += c;
                } else {
                    isString = !isString;
                    if (!isFunction && !isString) {
                        tokens.push({ type: TOKEN_TYPE.STRING, value: str });
                        str = '';
                    }
                }
                break;

            case '\\':
                if (isEscaped) {
                    str += c;
                    isEscaped = false;
                } else {
                    isEscaped = true;
                }
                break;

            case '(':
                if (isString) {
                    str += c;
                } else {
                    isFunction = true;
                    functionName = str;
                    str = '';
                    args = [];
                }
                break;

            case ')':
                if (isString) {
                    str += c;
                } else if (isFunction) {
                    if (str) {
                        args.push(str);
                    }

                    switch (functionName) {
                        case 'attr':
                            if (args.length > 0) {
                                tokens.push({ type: TOKEN_TYPE.ATTRIBUTE, value: args[0] });
                            }
                            break;

                        case 'counter':
                            if (args.length > 0) {
                                var counter = {
                                    type: TOKEN_TYPE.COUNTER,
                                    name: args[0]
                                };
                                if (args.length > 1) {
                                    counter.format = args[1];
                                }
                                tokens.push(counter);
                            }
                            break;

                        case 'counters':
                            if (args.length > 0) {
                                var _counters2 = {
                                    type: TOKEN_TYPE.COUNTERS,
                                    name: args[0]
                                };
                                if (args.length > 1) {
                                    _counters2.glue = args[1];
                                }
                                if (args.length > 2) {
                                    _counters2.format = args[2];
                                }
                                tokens.push(_counters2);
                            }
                            break;

                        case 'url':
                            if (args.length > 0) {
                                tokens.push({ type: TOKEN_TYPE.URL, value: args[0] });
                            }
                            break;
                    }

                    isFunction = false;
                    str = '';
                }
                break;

            case ',':
                if (isString) {
                    str += c;
                } else if (isFunction) {
                    args.push(str);
                    str = '';
                }
                break;

            case ' ':
            case '\t':
                if (isString) {
                    str += c;
                } else if (str) {
                    addOtherToken(tokens, str);
                    str = '';
                }
                break;

            default:
                str += c;
        }

        if (c !== '\\') {
            isEscaped = false;
        }
    }

    if (str) {
        addOtherToken(tokens, str);
    }

    if (cache) {
        cache[content] = tokens;
    }

    return tokens;
};

var addOtherToken = function addOtherToken(tokens, identifier) {
    switch (identifier) {
        case 'open-quote':
            tokens.push({ type: TOKEN_TYPE.OPENQUOTE });
            break;
        case 'close-quote':
            tokens.push({ type: TOKEN_TYPE.CLOSEQUOTE });
            break;
    }
};

var getQuote = function getQuote(style, isOpening, quoteDepth) {
    var quotes = style.quotes ? style.quotes.split(/\s+/) : ["'\"'", "'\"'"];
    var idx = quoteDepth * 2;
    if (idx >= quotes.length) {
        idx = quotes.length - 2;
    }
    if (!isOpening) {
        ++idx;
    }
    return quotes[idx].replace(/^["']|["']$/g, '');
};

var formatCounterValue = function formatCounterValue(counter, glue, format) {
    var len = counter.length;
    var result = '';

    for (var i = 0; i < len; i++) {
        if (i > 0) {
            result += glue || '';
        }
        result += (0, _ListItem.createCounterText)(counter[i], (0, _listStyle.parseListStyleType)(format || 'decimal'), false);
    }

    return result;
};

/***/ })
/******/ ]);
});
(function(){var a="\n//# sourceURL=",k="' of type ",n='<script type="text/javascript" src="',p="SCRIPT",r="array",t="complete",u="function",v="google.charts.load",w="hasOwnProperty",x="number",y="object",z="pre-45",A="propertyIsEnumerable",B="string",C="text/javascript",D="toLocaleString";function E(){return function(b){return b}}function F(){return function(){}}function G(b){return function(){return this[b]}}var I,J=J||{};J.scope={};
J.Up=function(b,c,d){if(null==b)throw new TypeError("The 'this' value for String.prototype."+d+" must not be null or undefined");if(c instanceof RegExp)throw new TypeError("First argument to String.prototype."+d+" must not be a regular expression");return b+""};J.Gh=!1;J.fm=!1;J.gm=!1;J.defineProperty=J.Gh||typeof Object.defineProperties==u?Object.defineProperty:function(b,c,d){b!=Array.prototype&&b!=Object.prototype&&(b[c]=d.value)};
J.Ij=function(b){return"undefined"!=typeof window&&window===b?b:"undefined"!=typeof global&&null!=global?global:b};J.global=J.Ij(this);J.Sk=function(b){if(b){for(var c=J.global,d=["Promise"],e=0;e<d.length-1;e++){var f=d[e];f in c||(c[f]={});c=c[f]}d=d[d.length-1];e=c[d];b=b(e);b!=e&&null!=b&&J.defineProperty(c,d,{configurable:!0,writable:!0,value:b})}};
J.Fq=function(b,c,d){b instanceof String&&(b=String(b));for(var e=b.length,f=0;f<e;f++){var g=b[f];if(c.call(d,g,f,b))return{Zj:f,Ll:g}}return{Zj:-1,Ll:void 0}};J.yi="jscomp_symbol_";J.rg=function(){J.rg=F();J.global.Symbol||(J.global.Symbol=J.Symbol)};J.Symbol=function(){var b=0;return function(c){return J.yi+(c||"")+b++}}();
J.Fd=function(){J.rg();var b=J.global.Symbol.iterator;b||(b=J.global.Symbol.iterator=J.global.Symbol("iterator"));typeof Array.prototype[b]!=u&&J.defineProperty(Array.prototype,b,{configurable:!0,writable:!0,value:function(){return J.df(this)}});J.Fd=F()};J.df=function(b){var c=0;return J.uk(function(){return c<b.length?{done:!1,value:b[c++]}:{done:!0}})};J.uk=function(b){J.Fd();b={next:b};b[J.global.Symbol.iterator]=function(){return this};return b};
J.Qg=function(b){J.Fd();var c=b[Symbol.iterator];return c?c.call(b):J.df(b)};J.Yh=!1;
J.Sk(function(b){function c(b){this.$=g.wa;this.ia=void 0;this.Ub=[];var c=this.gd();try{b(c.resolve,c.reject)}catch(q){c.reject(q)}}function d(){this.Ma=null}function e(b){return b instanceof c?b:new c(function(c){c(b)})}if(b&&!J.Yh)return b;d.prototype.ef=function(b){null==this.Ma&&(this.Ma=[],this.Ni());this.Ma.push(b)};d.prototype.Ni=function(){var b=this;this.ff(function(){b.uj()})};var f=J.global.setTimeout;d.prototype.ff=function(b){f(b,0)};d.prototype.uj=function(){for(;this.Ma&&this.Ma.length;){var b=
this.Ma;this.Ma=[];for(var c=0;c<b.length;++c){var d=b[c];delete b[c];try{d()}catch(H){this.Oi(H)}}}this.Ma=null};d.prototype.Oi=function(b){this.ff(function(){throw b;})};var g={wa:0,Ja:1,ka:2};c.prototype.gd=function(){function b(b){return function(e){d||(d=!0,b.call(c,e))}}var c=this,d=!1;return{resolve:b(this.Xk),reject:b(this.Yd)}};c.prototype.Xk=function(b){if(b===this)this.Yd(new TypeError("A Promise cannot resolve to itself"));else if(b instanceof c)this.pl(b);else{a:switch(typeof b){case y:var d=
null!=b;break a;case u:d=!0;break a;default:d=!1}d?this.Wk(b):this.If(b)}};c.prototype.Wk=function(b){var c=void 0;try{c=b.then}catch(q){this.Yd(q);return}typeof c==u?this.ql(c,b):this.If(b)};c.prototype.Yd=function(b){this.mh(g.ka,b)};c.prototype.If=function(b){this.mh(g.Ja,b)};c.prototype.mh=function(b,c){if(this.$!=g.wa)throw Error("Cannot settle("+b+", "+c|"): Promise already settled in state"+this.$);this.$=b;this.ia=c;this.wj()};c.prototype.wj=function(){if(null!=this.Ub){for(var b=this.Ub,
c=0;c<b.length;++c)b[c].call(),b[c]=null;this.Ub=null}};var h=new d;c.prototype.pl=function(b){var c=this.gd();b.fc(c.resolve,c.reject)};c.prototype.ql=function(b,c){var d=this.gd();try{b.call(c,d.resolve,d.reject)}catch(H){d.reject(H)}};c.prototype.then=function(b,d){function e(b,c){return typeof b==u?function(c){try{f(b(c))}catch(ca){g(ca)}}:c}var f,g,h=new c(function(b,c){f=b;g=c});this.fc(e(b,f),e(d,g));return h};c.prototype["catch"]=function(b){return this.then(void 0,b)};c.prototype.fc=function(b,
c){function d(){switch(e.$){case g.Ja:b(e.ia);break;case g.ka:c(e.ia);break;default:throw Error("Unexpected state: "+e.$);}}var e=this;null==this.Ub?h.ef(d):this.Ub.push(function(){h.ef(d)})};c.resolve=e;c.reject=function(b){return new c(function(c,d){d(b)})};c.race=function(b){return new c(function(c,d){for(var f=J.Qg(b),g=f.next();!g.done;g=f.next())e(g.value).fc(c,d)})};c.all=function(b){var d=J.Qg(b),f=d.next();return f.done?e([]):new c(function(b,c){function g(c){return function(d){h[c]=d;l--;
0==l&&b(h)}}var h=[],l=0;do h.push(void 0),l++,e(f.value).fc(g(h.length-1),c),f=d.next();while(!f.done)})};return c});var K=K||{};K.global=this;K.R=function(b){return void 0!==b};K.L=function(b){return typeof b==B};K.ck=function(b){return"boolean"==typeof b};K.Rb=function(b){return typeof b==x};
K.md=function(b,c,d){b=b.split(".");d=d||K.global;b[0]in d||!d.execScript||d.execScript("var "+b[0]);for(var e;b.length&&(e=b.shift());)!b.length&&K.R(c)?d[e]=c:d=d[e]&&d[e]!==Object.prototype[e]?d[e]:d[e]={}};K.define=function(b,c){K.md(b,c)};K.ea=!0;K.ba="en";K.$c=!0;K.wi=!1;K.Uh=!K.ea;K.De=!1;K.Es=function(b){if(K.Kd())throw Error("goog.provide can not be used within a goog.module.");K.qf(b)};K.qf=function(b,c){K.md(b,c)};K.Di=/^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
K.Td=function(b){if(!K.L(b)||!b||-1==b.search(K.Di))throw Error("Invalid module identifier");if(!K.Kd())throw Error("Module "+b+" has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
if(K.na.Ud)throw Error("goog.module may only be called once per module.");K.na.Ud=b};K.Td.get=function(){return null};K.Td.$q=function(){return null};K.na=null;K.Kd=function(){return null!=K.na};K.Td.jd=function(){K.na.jd=!0};K.rt=function(b){if(K.Uh)throw b=b||"",Error("Importing test-only code into non-debug environment"+(b?": "+b:"."));};K.Lq=F();K.rb=function(b){b=b.split(".");for(var c=K.global,d=0;d<b.length;d++)if(c=c[b[d]],!K.cb(c))return null;return c};
K.kr=function(b,c){c=c||K.global;for(var d in b)c[d]=b[d]};K.hp=function(b,c,d,e){if(K.Ae){var f;b=b.replace(/\\/g,"/");var g=K.la;e&&"boolean"!==typeof e||(e=e?{module:"goog"}:{});for(var h=0;f=c[h];h++)g.Sb[f]=b,g.Od[b]=e;for(e=0;c=d[e];e++)b in g.gb||(g.gb[b]={}),g.gb[b][c]=!0}};K.Ut=!1;K.Xm=!0;K.Ek=function(b){K.global.console&&K.global.console.error(b)};K.Qs=F();K.La="";K.eb=F();K.gp=function(){throw Error("unimplemented abstract method");};
K.ip=function(b){b.Gd=void 0;b.Zq=function(){if(b.Gd)return b.Gd;K.ea&&(K.wg[K.wg.length]=b);return b.Gd=new b}};K.wg=[];K.fi=!0;K.ti=K.ea;K.Ck={};K.Ae=!1;K.Ve="detect";K.zi="transpile.js";
K.Ae&&(K.la={Od:{},Sb:{},gb:{},zh:{},je:{},pb:{}},K.qg=function(){var b=K.global.document;return null!=b&&"write"in b},K.xj=function(){if(K.R(K.global.ye)&&K.L(K.global.ye))K.La=K.global.ye;else if(K.qg()){var b=K.global.document,c=b.currentScript;b=c?[c]:b.getElementsByTagName(p);for(c=b.length-1;0<=c;--c){var d=b[c].src,e=d.lastIndexOf("?");e=-1==e?d.length:e;if("base.js"==d.substr(e-7,7)){K.La=d.substr(0,e-7);break}}}},K.Ed=function(b,c){(K.global.zm||K.Tl)(b,c)&&(K.la.je[b]=!0)},K.di=!(K.global.atob||
!K.global.document||!K.global.document.all),K.$g=!1,K.ak=function(b,c,d){K.Ed("",'goog.retrieveAndExec_("'+b+'", '+c+", "+d+");")},K.Wd=[],K.Yt=function(b,c){return K.fi&&K.R(K.global.JSON)?"goog.loadModule("+K.global.JSON.stringify(c+a+b+"\n")+");":'goog.loadModule(function(exports) {"use strict";'+c+"\n;return exports});\n//# sourceURL="+b+"\n"},K.Ak=function(){var b=K.Wd.length;if(0<b){var c=K.Wd;K.Wd=[];for(var d=0;d<b;d++)K.Tg(c[d])}K.$g=!1},K.ks=function(b){K.Bg(b)&&K.Ji(b)&&K.Tg(K.La+K.zd(b))},
K.Bg=function(b){var c=(b=K.zd(b))&&K.la.Od[b]||{},d=c.lang||"es3";return b&&("goog"==c.module||K.Xg(d))?K.La+b in K.la.pb:!1},K.Ji=function(b){if((b=K.zd(b))&&b in K.la.gb)for(var c in K.la.gb[b])if(!K.mk(c)&&!K.Bg(c))return!1;return!0},K.Tg=function(b){if(b in K.la.pb){var c=K.la.pb[b];delete K.la.pb[b];K.Tj(c)}},K.es=F(),K.Sl=function(b){K.global.document.write(n+b+'">\x3c/script>')},K.Ki=function(b){var c=K.global.document,d=c.createElement("script");d.type=C;d.src=b;d.defer=!1;d.async=!1;c.head.appendChild(d)},
K.Tl=function(b,c){if(K.qg()){var d=K.global.document;if(!K.De&&d.readyState==t){if(/\bdeps.js$/.test(b))return!1;throw Error('Cannot write "'+b+'" after document load');}void 0===c?K.di?(K.$g=!0,c=" onreadystatechange='goog.onScriptLoad_(this, "+ ++K.Pg+")' ",d.write(n+b+'"'+c+">\x3c/script>")):K.De?K.Ki(b):K.Sl(b):d.write('<script type="text/javascript">'+K.Tk(c)+"\x3c/script>");return!0}return!1},K.Tk=function(b){return b.replace(/<\/(SCRIPT)/ig,"\\x3c/$1")},K.Xg=function(b){if("always"==K.Ve)return!0;
if("never"==K.Ve)return!1;K.Dc||(K.Dc=K.ej());if(b in K.Dc)return K.Dc[b];throw Error("Unknown language mode: "+b);},K.Dc=null,K.Pg=0,K.ys=function(b,c){b.readyState==t&&K.Pg==c&&K.Ak();return!0},K.Zt=function(b){function c(b){if(!(b in f.je||b in f.zh)){f.zh[b]=!0;if(b in f.gb)for(var g in f.gb[b])if(!K.mk(g))if(g in f.Sb)c(f.Sb[g]);else throw Error("Undefined nameToPath for "+g);b in e||(e[b]=!0,d.push(b))}}var d=[],e={},f=K.la;c(b);for(b=0;b<d.length;b++){var g=d[b];K.la.je[g]=!0}var h=K.na;K.na=
null;for(b=0;b<d.length;b++)if(g=d[b]){var l=f.Od[g]||{},m=K.Xg(l.lang||"es3");"goog"==l.module||m?K.ak(K.La+g,"goog"==l.module,m):K.Ed(K.La+g)}else throw K.na=h,Error("Undefined script input");K.na=h},K.zd=function(b){return b in K.la.Sb?K.la.Sb[b]:null},K.xj(),K.global.Am||K.Ed(K.La+"deps.js"));K.Cd=null;K.Jl=function(){if(null==K.Cd){try{var b=!eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";')}catch(c){b=!1}K.Cd=b}return K.Cd};
K.Ql=function(b){return"(function(){"+b+"\n;})();\n"};K.ds=function(b){var c=K.na;try{K.na={Ud:void 0,jd:!1};if(K.ya(b))var d=b.call(void 0,{});else if(K.L(b))K.Jl()&&(b=K.Ql(b)),d=K.zk.call(void 0,b);else throw Error("Invalid module definition");var e=K.na.Ud;if(!K.L(e)||!e)throw Error('Invalid module name "'+e+'"');K.na.jd?K.qf(e,d):K.ti&&Object.seal&&typeof d==y&&null!=d&&Object.seal(d);K.Ck[e]=d}finally{K.na=c}};K.zk=function(b){eval(b);return{}};
K.rs=function(b){b=b.split("/");for(var c=0;c<b.length;)"."==b[c]?b.splice(c,1):c&&".."==b[c]&&b[c-1]&&".."!=b[c-1]?b.splice(--c,2):c++;return b.join("/")};K.xk=function(b){if(K.global.Ph)return K.global.Ph(b);try{var c=new K.global.XMLHttpRequest;c.open("get",b,!1);c.send();return 0==c.status||200==c.status?c.responseText:null}catch(d){return null}};K.Ss=F();
K.Lt=function(b,c){var d=K.global.$jscomp;d||(K.global.$jscomp=d={});var e=d.he;if(!e){var f=K.La+K.zi,g=K.xk(f);if(g){eval(g+a+f);if(K.global.$gwtExport&&K.global.$gwtExport.$jscomp&&!K.global.$gwtExport.$jscomp.transpile)throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: '+JSON.stringify(K.global.$gwtExport));K.global.$jscomp.he=K.global.$gwtExport.$jscomp.transpile;d=K.global.$jscomp;e=d.he}}if(!e){var h=" requires transpilation but no transpiler was found.";
h+=' Please add "//javascript/closure:transpiler" as a data dependency to ensure it is included.';e=d.he=function(b,c){K.Ek(c+h);return b}}return e(b,c)};
K.aa=function(b){var c=typeof b;if(c==y)if(b){if(b instanceof Array)return r;if(b instanceof Object)return c;var d=Object.prototype.toString.call(b);if("[object Window]"==d)return y;if("[object Array]"==d||typeof b.length==x&&"undefined"!=typeof b.splice&&"undefined"!=typeof b.propertyIsEnumerable&&!b.propertyIsEnumerable("splice"))return r;if("[object Function]"==d||"undefined"!=typeof b.call&&"undefined"!=typeof b.propertyIsEnumerable&&!b.propertyIsEnumerable("call"))return u}else return"null";
else if(c==u&&"undefined"==typeof b.call)return y;return c};K.Pr=function(b){return null===b};K.cb=function(b){return null!=b};K.isArray=function(b){return K.aa(b)==r};K.Nb=function(b){var c=K.aa(b);return c==r||c==y&&typeof b.length==x};K.Br=function(b){return K.ha(b)&&typeof b.getFullYear==u};K.ya=function(b){return K.aa(b)==u};K.ha=function(b){var c=typeof b;return c==y&&null!=b||c==u};K.kg=function(b){return b[K.Va]||(b[K.Va]=++K.Cl)};K.nr=function(b){return!!b[K.Va]};
K.Uk=function(b){null!==b&&"removeAttribute"in b&&b.removeAttribute(K.Va);try{delete b[K.Va]}catch(c){}};K.Va="closure_uid_"+(1E9*Math.random()>>>0);K.Cl=0;K.Yq=K.kg;K.Ms=K.Uk;K.aj=function(b){var c=K.aa(b);if(c==y||c==r){if(b.clone)return b.clone();c=c==r?[]:{};for(var d in b)c[d]=K.aj(b[d]);return c}return b};K.Si=function(b,c,d){return b.call.apply(b.bind,arguments)};
K.Ri=function(b,c,d){if(!b)throw Error();if(2<arguments.length){var e=Array.prototype.slice.call(arguments,2);return function(){var d=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(d,e);return b.apply(c,d)}}return function(){return b.apply(c,arguments)}};K.bind=function(b,c,d){K.bind=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?K.Si:K.Ri;return K.bind.apply(null,arguments)};
K.fb=function(b,c){var d=Array.prototype.slice.call(arguments,1);return function(){var c=d.slice();c.push.apply(c,arguments);return b.apply(this,c)}};K.ms=function(b,c){for(var d in c)b[d]=c[d]};K.now=K.$c&&Date.now||function(){return+new Date};
K.Tj=function(b){if(K.global.execScript)K.global.execScript(b,"JavaScript");else if(K.global.eval){if(null==K.lc)if(K.global.eval("var _evalTest_ = 1;"),"undefined"!=typeof K.global._evalTest_){try{delete K.global._evalTest_}catch(e){}K.lc=!0}else K.lc=!1;if(K.lc)K.global.eval(b);else{var c=K.global.document,d=c.createElement(p);d.type=C;d.defer=!1;d.appendChild(c.createTextNode(b));c.body.appendChild(d);c.body.removeChild(d)}}else throw Error("goog.globalEval not available");};K.lc=null;
K.Wq=function(b,c){function d(b){b=b.split("-");for(var c=[],d=0;d<b.length;d++)c.push(e(b[d]));return c.join("-")}function e(b){return K.uf[b]||b}if("."==String(b).charAt(0))throw Error('className passed in goog.getCssName must not start with ".". You passed: '+b);var f=K.uf?"BY_WHOLE"==K.kj?e:d:E();b=c?b+"-"+f(c):f(b);return K.global.Oh?K.global.Oh(b):b};K.bt=function(b,c){K.uf=b;K.kj=c};K.ar=function(b,c){c&&(b=b.replace(/\{\$([^}]+)}/g,function(b,e){return null!=c&&e in c?c[e]:b}));return b};
K.cr=E();K.zf=function(b,c){K.md(b,c,void 0)};K.Eq=function(b,c,d){b[c]=d};K.ab=function(b,c){function d(){}d.prototype=c.prototype;b.Lc=c.prototype;b.prototype=new d;b.prototype.constructor=b;b.Qi=function(b,d,g){for(var e=Array(arguments.length-2),f=2;f<arguments.length;f++)e[f-2]=arguments[f];return c.prototype[d].apply(b,e)}};
K.Qi=function(b,c,d){var e=arguments.callee.caller;if(K.wi||K.ea&&!e)throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");if(e.Lc){for(var f=Array(arguments.length-1),g=1;g<arguments.length;g++)f[g-1]=arguments[g];return e.Lc.constructor.apply(b,f)}f=Array(arguments.length-2);for(g=2;g<arguments.length;g++)f[g-2]=arguments[g];g=!1;for(var h=b.constructor;h;h=h.Lc&&h.Lc.constructor)if(h.prototype[c]===
e)g=!0;else if(g)return h.prototype[c].apply(b,f);if(b[c]===e)return b.constructor.prototype[c].apply(b,f);throw Error("goog.base called from a method of one name to a method of a different name");};K.scope=function(b){if(K.Kd())throw Error("goog.scope is not supported within a goog.module.");b.call(K.global)};
K.oa=function(b,c){var d=c.constructor,e=c.ul;d&&d!=Object.prototype.constructor||(d=function(){throw Error("cannot instantiate an interface (no constructor defined).");});d=K.oa.fj(d,b);b&&K.ab(d,b);delete c.constructor;delete c.ul;K.oa.cf(d.prototype,c);null!=e&&(e instanceof Function?e(d):K.oa.cf(d,e));return d};K.oa.si=K.ea;
K.oa.fj=function(b,c){function d(){var c=b.apply(this,arguments)||this;c[K.Va]=c[K.Va];this.constructor===d&&e&&Object.seal instanceof Function&&Object.seal(c);return c}if(!K.oa.si)return b;var e=!K.oa.qk(c);return d};K.oa.qk=function(b){return b&&b.prototype&&b.prototype[K.Bi]};K.oa.Me=["constructor",w,"isPrototypeOf",A,D,"toString","valueOf"];
K.oa.cf=function(b,c){for(var d in c)Object.prototype.hasOwnProperty.call(c,d)&&(b[d]=c[d]);for(var e=0;e<K.oa.Me.length;e++)d=K.oa.Me[e],Object.prototype.hasOwnProperty.call(c,d)&&(b[d]=c[d])};K.Et=F();K.Bi="goog_defineClass_legacy_unsealable";
K.ej=function(){function b(b,c){e?d[b]=!0:c()?d[b]=!1:e=d[b]=!0}function c(b){try{return!!eval(b)}catch(h){return!1}}var d={es3:!1},e=!1,f=K.global.navigator&&K.global.navigator.userAgent?K.global.navigator.userAgent:"";b("es5",function(){return c("[1,].length==1")});b("es6",function(){var b=f.match(/Edge\/(\d+)(\.\d)*/i);return b&&15>Number(b[1])?!1:c('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()')});
b("es6-impl",function(){return!0});b("es7",function(){return c("2 ** 2 == 4")});b("es8",function(){return c("async () => 1, true")});return d};K.debug={};K.debug.Error=function(b){if(Error.captureStackTrace)Error.captureStackTrace(this,K.debug.Error);else{var c=Error().stack;c&&(this.stack=c)}b&&(this.message=String(b))};K.ab(K.debug.Error,Error);K.debug.Error.prototype.name="CustomError";K.a={};K.a.fa={Ia:1,hm:2,cc:3,wm:4,Zm:5,Ym:6,oo:7,Fm:8,Xc:9,Rm:10,Vh:11,bo:12};K.f={};K.f.Wc=!1;K.f.Xh=!1;K.f.Ye={Ke:"\u00a0"};K.f.startsWith=function(b,c){return 0==b.lastIndexOf(c,0)};K.f.endsWith=function(b,c){var d=b.length-c.length;return 0<=d&&b.indexOf(c,d)==d};K.f.Zi=function(b){return 0==K.f.jf("tel:",b.substr(0,4))};K.f.Sp=function(b,c){return 0==K.f.jf(c,b.substr(b.length-c.length,c.length))};K.f.Tp=function(b,c){return b.toLowerCase()==c.toLowerCase()};
K.f.wl=function(b,c){for(var d=b.split("%s"),e="",f=Array.prototype.slice.call(arguments,1);f.length&&1<d.length;)e+=d.shift()+f.shift();return e+d.join("%s")};K.f.Zp=function(b){return b.replace(/[\s\xa0]+/g," ").replace(/^\s+|\s+$/g,"")};K.f.Id=function(b){return/^[\s\xa0]*$/.test(b)};K.f.Er=function(b){return 0==b.length};K.f.Qb=K.f.Id;K.f.ek=function(b){return K.f.Id(K.f.Jk(b))};K.f.Dr=K.f.ek;K.f.zr=function(b){return!/[^\t\n\r ]/.test(b)};K.f.wr=function(b){return!/[^a-zA-Z]/.test(b)};
K.f.Qr=function(b){return!/[^0-9]/.test(b)};K.f.xr=function(b){return!/[^a-zA-Z0-9]/.test(b)};K.f.Wr=function(b){return" "==b};K.f.Xr=function(b){return 1==b.length&&" "<=b&&"~">=b||"\u0080"<=b&&"\ufffd">=b};K.f.Ct=function(b){return b.replace(/(\r\n|\r|\n)+/g," ")};K.f.Yi=function(b){return b.replace(/(\r\n|\r|\n)/g,"\n")};K.f.ts=function(b){return b.replace(/\xa0|\s/g," ")};K.f.ss=function(b){return b.replace(/\xa0|[ \t]+/g," ")};
K.f.Yp=function(b){return b.replace(/[\t\r\n ]+/g," ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g,"")};K.f.trim=K.$c&&String.prototype.trim?function(b){return b.trim()}:function(b){return b.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")};K.f.trimLeft=function(b){return b.replace(/^[\s\xa0]+/,"")};K.f.trimRight=function(b){return b.replace(/[\s\xa0]+$/,"")};K.f.jf=function(b,c){b=String(b).toLowerCase();c=String(c).toLowerCase();return b<c?-1:b==c?0:1};
K.f.Zg=function(b,c,d){if(b==c)return 0;if(!b)return-1;if(!c)return 1;for(var e=b.toLowerCase().match(d),f=c.toLowerCase().match(d),g=Math.min(e.length,f.length),h=0;h<g;h++){d=e[h];var l=f[h];if(d!=l)return b=parseInt(d,10),!isNaN(b)&&(c=parseInt(l,10),!isNaN(c)&&b-c)?b-c:d<l?-1:1}return e.length!=f.length?e.length-f.length:b<c?-1:1};K.f.ur=function(b,c){return K.f.Zg(b,c,/\d+|\D+/g)};K.f.Aj=function(b,c){return K.f.Zg(b,c,/\d+|\.\d+|\D+/g)};K.f.ws=K.f.Aj;K.f.Tt=function(b){return encodeURIComponent(String(b))};
K.f.St=function(b){return decodeURIComponent(b.replace(/\+/g," "))};K.f.Yg=function(b,c){return b.replace(/(\r\n|\r|\n)/g,c?"<br />":"<br>")};
K.f.ta=function(b,c){if(c)b=b.replace(K.f.ke,"&amp;").replace(K.f.Je,"&lt;").replace(K.f.Ge,"&gt;").replace(K.f.Qe,"&quot;").replace(K.f.Te,"&#39;").replace(K.f.Le,"&#0;"),K.f.Wc&&(b=b.replace(K.f.Ee,"&#101;"));else{if(!K.f.Eh.test(b))return b;-1!=b.indexOf("&")&&(b=b.replace(K.f.ke,"&amp;"));-1!=b.indexOf("<")&&(b=b.replace(K.f.Je,"&lt;"));-1!=b.indexOf(">")&&(b=b.replace(K.f.Ge,"&gt;"));-1!=b.indexOf('"')&&(b=b.replace(K.f.Qe,"&quot;"));-1!=b.indexOf("'")&&(b=b.replace(K.f.Te,"&#39;"));-1!=b.indexOf("\x00")&&
(b=b.replace(K.f.Le,"&#0;"));K.f.Wc&&-1!=b.indexOf("e")&&(b=b.replace(K.f.Ee,"&#101;"))}return b};K.f.ke=/&/g;K.f.Je=/</g;K.f.Ge=/>/g;K.f.Qe=/"/g;K.f.Te=/'/g;K.f.Le=/\x00/g;K.f.Ee=/e/g;K.f.Eh=K.f.Wc?/[\x00&<>"'e]/:/[\x00&<>"']/;K.f.vh=function(b){return K.f.contains(b,"&")?!K.f.Xh&&"document"in K.global?K.f.wh(b):K.f.Fl(b):b};K.f.Pt=function(b,c){return K.f.contains(b,"&")?K.f.wh(b,c):b};
K.f.wh=function(b,c){var d={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"'};var e=c?c.createElement("div"):K.global.document.createElement("div");return b.replace(K.f.bi,function(b,c){var f=d[b];if(f)return f;"#"==c.charAt(0)&&(c=Number("0"+c.substr(1)),isNaN(c)||(f=String.fromCharCode(c)));f||(e.innerHTML=b+" ",f=e.firstChild.nodeValue.slice(0,-1));return d[b]=f})};
K.f.Fl=function(b){return b.replace(/&([^;]+);/g,function(b,d){switch(d){case "amp":return"&";case "lt":return"<";case "gt":return">";case "quot":return'"';default:return"#"!=d.charAt(0)||(d=Number("0"+d.substr(1)),isNaN(d))?b:String.fromCharCode(d)}})};K.f.bi=/&([^;\s<&]+);?/g;K.f.Ol=function(b){return K.f.Yg(b.replace(/  /g," &#160;"),void 0)};K.f.Ds=function(b){return b.replace(/(^|[\n ]) /g,"$1"+K.f.Ye.Ke)};
K.f.Dt=function(b,c){for(var d=c.length,e=0;e<d;e++){var f=1==d?c:c.charAt(e);if(b.charAt(0)==f&&b.charAt(b.length-1)==f)return b.substring(1,b.length-1)}return b};K.f.truncate=function(b,c,d){d&&(b=K.f.vh(b));b.length>c&&(b=b.substring(0,c-3)+"...");d&&(b=K.f.ta(b));return b};K.f.Nt=function(b,c,d,e){d&&(b=K.f.vh(b));e&&b.length>c?(e>c&&(e=c),b=b.substring(0,c-e)+"..."+b.substring(b.length-e)):b.length>c&&(e=Math.floor(c/2),b=b.substring(0,e+c%2)+"..."+b.substring(b.length-e));d&&(b=K.f.ta(b));return b};
K.f.de={"\x00":"\\0","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\x0B",'"':'\\"',"\\":"\\\\","<":"<"};K.f.vc={"'":"\\'"};K.f.quote=function(b){b=String(b);for(var c=['"'],d=0;d<b.length;d++){var e=b.charAt(d),f=e.charCodeAt(0);c[d+1]=K.f.de[e]||(31<f&&127>f?e:K.f.xf(e))}c.push('"');return c.join("")};K.f.Dq=function(b){for(var c=[],d=0;d<b.length;d++)c[d]=K.f.xf(b.charAt(d));return c.join("")};
K.f.xf=function(b){if(b in K.f.vc)return K.f.vc[b];if(b in K.f.de)return K.f.vc[b]=K.f.de[b];var c=b.charCodeAt(0);if(31<c&&127>c)var d=b;else{if(256>c){if(d="\\x",16>c||256<c)d+="0"}else d="\\u",4096>c&&(d+="0");d+=c.toString(16).toUpperCase()}return K.f.vc[b]=d};K.f.contains=function(b,c){return-1!=b.indexOf(c)};K.f.kf=function(b,c){return K.f.contains(b.toLowerCase(),c.toLowerCase())};K.f.gq=function(b,c){return b&&c?b.split(c).length-1:0};
K.f.yb=function(b,c,d){var e=b;0<=c&&c<b.length&&0<d&&(e=b.substr(0,c)+b.substr(c+d,b.length-c-d));return e};K.f.remove=function(b,c){return b.replace(c,"")};K.f.Js=function(b,c){c=new RegExp(K.f.Xd(c),"g");return b.replace(c,"")};K.f.Ps=function(b,c,d){c=new RegExp(K.f.Xd(c),"g");return b.replace(c,d.replace(/\$/g,"$$$$"))};K.f.Xd=function(b){return String(b).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g,"\\$1").replace(/\x08/g,"\\x08")};
K.f.repeat=String.prototype.repeat?function(b,c){return b.repeat(c)}:function(b,c){return Array(c+1).join(b)};K.f.Bs=function(b,c,d){b=K.R(d)?b.toFixed(d):String(b);d=b.indexOf(".");-1==d&&(d=b.length);return K.f.repeat("0",Math.max(0,c-d))+b};K.f.Jk=function(b){return null==b?"":String(b)};K.f.Np=function(b){return Array.prototype.join.call(arguments,"")};K.f.fr=function(){return Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^K.now()).toString(36)};
K.f.Eb=function(b,c){var d=0;b=K.f.trim(String(b)).split(".");c=K.f.trim(String(c)).split(".");for(var e=Math.max(b.length,c.length),f=0;0==d&&f<e;f++){var g=b[f]||"",h=c[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];if(0==g[0].length&&0==h[0].length)break;d=K.f.dd(0==g[1].length?0:parseInt(g[1],10),0==h[1].length?0:parseInt(h[1],10))||K.f.dd(0==g[2].length,0==h[2].length)||K.f.dd(g[2],h[2]);g=g[3];h=h[3]}while(0==d)}return d};
K.f.dd=function(b,c){return b<c?-1:b>c?1:0};K.f.or=function(b){for(var c=0,d=0;d<b.length;++d)c=31*c+b.charCodeAt(d)>>>0;return c};K.f.Gl=2147483648*Math.random()|0;K.f.pq=function(){return"goog_"+K.f.Gl++};K.f.Ht=function(b){var c=Number(b);return 0==c&&K.f.Id(b)?NaN:c};K.f.Jr=function(b){return/^[a-z]+([A-Z][a-z]*)*$/.test(b)};K.f.Yr=function(b){return/^([A-Z][a-z]*)+$/.test(b)};K.f.Gt=function(b){return String(b).replace(/\-([a-z])/g,function(b,d){return d.toUpperCase()})};
K.f.Jt=function(b){return String(b).replace(/([A-Z])/g,"-$1").toLowerCase()};K.f.Kt=function(b,c){c=K.L(c)?K.f.Xd(c):"\\s";return b.replace(new RegExp("(^"+(c?"|["+c+"]+":"")+")([a-z])","g"),function(b,c,f){return c+f.toUpperCase()})};K.f.Rp=function(b){return String(b.charAt(0)).toUpperCase()+String(b.substr(1)).toLowerCase()};K.f.parseInt=function(b){isFinite(b)&&(b=String(b));return K.L(b)?/^\s*-?0x/i.test(b)?parseInt(b,16):parseInt(b,10):NaN};
K.f.xt=function(b,c,d){b=b.split(c);for(var e=[];0<d&&b.length;)e.push(b.shift()),d--;b.length&&e.push(b.join(c));return e};K.f.as=function(b,c){if(c)typeof c==B&&(c=[c]);else return b;for(var d=-1,e=0;e<c.length;e++)if(""!=c[e]){var f=b.lastIndexOf(c[e]);f>d&&(d=f)}return-1==d?b:b.slice(d+1)};
K.f.xq=function(b,c){var d=[],e=[];if(b==c)return 0;if(!b.length||!c.length)return Math.max(b.length,c.length);for(var f=0;f<c.length+1;f++)d[f]=f;for(f=0;f<b.length;f++){e[0]=f+1;for(var g=0;g<c.length;g++)e[g+1]=Math.min(e[g]+1,d[g+1]+1,d[g]+Number(b[f]!=c[g]));for(g=0;g<d.length;g++)d[g]=e[g]}return e[c.length]};K.m={};K.m.ja=K.ea;K.m.Xb=function(b,c){c.unshift(b);K.debug.Error.call(this,K.f.wl.apply(null,c));c.shift()};K.ab(K.m.Xb,K.debug.Error);K.m.Xb.prototype.name="AssertionError";K.m.Sh=function(b){throw b;};K.m.kd=K.m.Sh;K.m.xa=function(b,c,d,e){var f="Assertion failed";if(d){f+=": "+d;var g=e}else b&&(f+=": "+b,g=c);b=new K.m.Xb(""+f,g||[]);K.m.kd(b)};K.m.ft=function(b){K.m.ja&&(K.m.kd=b)};K.m.assert=function(b,c,d){K.m.ja&&!b&&K.m.xa("",null,c,Array.prototype.slice.call(arguments,2));return b};
K.m.ma=function(b,c){K.m.ja&&K.m.kd(new K.m.Xb("Failure"+(b?": "+b:""),Array.prototype.slice.call(arguments,1)))};K.m.Ep=function(b,c,d){K.m.ja&&!K.Rb(b)&&K.m.xa("Expected number but got %s: %s.",[K.aa(b),b],c,Array.prototype.slice.call(arguments,2));return b};K.m.Hp=function(b,c,d){K.m.ja&&!K.L(b)&&K.m.xa("Expected string but got %s: %s.",[K.aa(b),b],c,Array.prototype.slice.call(arguments,2));return b};
K.m.sp=function(b,c,d){K.m.ja&&!K.ya(b)&&K.m.xa("Expected function but got %s: %s.",[K.aa(b),b],c,Array.prototype.slice.call(arguments,2));return b};K.m.Fp=function(b,c,d){K.m.ja&&!K.ha(b)&&K.m.xa("Expected object but got %s: %s.",[K.aa(b),b],c,Array.prototype.slice.call(arguments,2));return b};K.m.op=function(b,c,d){K.m.ja&&!K.isArray(b)&&K.m.xa("Expected array but got %s: %s.",[K.aa(b),b],c,Array.prototype.slice.call(arguments,2));return b};
K.m.pp=function(b,c,d){K.m.ja&&!K.ck(b)&&K.m.xa("Expected boolean but got %s: %s.",[K.aa(b),b],c,Array.prototype.slice.call(arguments,2));return b};K.m.qp=function(b,c,d){!K.m.ja||K.ha(b)&&b.nodeType==K.a.fa.Ia||K.m.xa("Expected Element but got %s: %s.",[K.aa(b),b],c,Array.prototype.slice.call(arguments,2));return b};K.m.tp=function(b,c,d,e){!K.m.ja||b instanceof c||K.m.xa("Expected instanceof %s but got %s.",[K.m.jg(c),K.m.jg(b)],d,Array.prototype.slice.call(arguments,3));return b};
K.m.rp=function(b,c,d){!K.m.ja||typeof b==x&&isFinite(b)||K.m.xa("Expected %s to be a finite number but it is not.",[b],c,Array.prototype.slice.call(arguments,2));return b};K.m.Gp=function(){for(var b in Object.prototype)K.m.ma(b+" should not be enumerable in Object.prototype.")};K.m.jg=function(b){return b instanceof Function?b.displayName||b.name||"unknown type name":b instanceof Object?b.constructor.displayName||b.constructor.name||Object.prototype.toString.call(b):null===b?"null":typeof b};K.f.Yo=F();K.f.I=function(){this.Kc="";this.xi=K.f.I.We};K.f.I.prototype.ua=!0;K.f.I.prototype.ga=G("Kc");K.f.I.prototype.toString=function(){return"Const{"+this.Kc+"}"};K.f.I.u=function(b){if(b instanceof K.f.I&&b.constructor===K.f.I&&b.xi===K.f.I.We)return b.Kc;K.m.ma("expected object of type Const, got '"+b+"'");return"type_error:Const"};K.f.I.from=function(b){return K.f.I.jj(b)};K.f.I.We={};K.f.I.jj=function(b){var c=new K.f.I;c.Kc=b;return c};K.f.I.EMPTY=K.f.I.from("");K.j={};K.Ca=K.$c;K.j.za=!1;K.j.Rk=function(b){return b[b.length-1]};K.j.$r=K.j.Rk;K.j.indexOf=K.Ca&&(K.j.za||Array.prototype.indexOf)?function(b,c,d){return Array.prototype.indexOf.call(b,c,d)}:function(b,c,d){d=null==d?0:0>d?Math.max(0,b.length+d):d;if(K.L(b))return K.L(c)&&1==c.length?b.indexOf(c,d):-1;for(;d<b.length;d++)if(d in b&&b[d]===c)return d;return-1};
K.j.lastIndexOf=K.Ca&&(K.j.za||Array.prototype.lastIndexOf)?function(b,c,d){return Array.prototype.lastIndexOf.call(b,c,null==d?b.length-1:d)}:function(b,c,d){d=null==d?b.length-1:d;0>d&&(d=Math.max(0,b.length+d));if(K.L(b))return K.L(c)&&1==c.length?b.lastIndexOf(c,d):-1;for(;0<=d;d--)if(d in b&&b[d]===c)return d;return-1};
K.j.forEach=K.Ca&&(K.j.za||Array.prototype.forEach)?function(b,c,d){Array.prototype.forEach.call(b,c,d)}:function(b,c,d){for(var e=b.length,f=K.L(b)?b.split(""):b,g=0;g<e;g++)g in f&&c.call(d,f[g],g,b)};K.j.Gf=function(b,c){for(var d=K.L(b)?b.split(""):b,e=b.length-1;0<=e;--e)e in d&&c.call(void 0,d[e],e,b)};
K.j.filter=K.Ca&&(K.j.za||Array.prototype.filter)?function(b,c,d){return Array.prototype.filter.call(b,c,d)}:function(b,c,d){for(var e=b.length,f=[],g=0,h=K.L(b)?b.split(""):b,l=0;l<e;l++)if(l in h){var m=h[l];c.call(d,m,l,b)&&(f[g++]=m)}return f};K.j.map=K.Ca&&(K.j.za||Array.prototype.map)?function(b,c,d){return Array.prototype.map.call(b,c,d)}:function(b,c,d){for(var e=b.length,f=Array(e),g=K.L(b)?b.split(""):b,h=0;h<e;h++)h in g&&(f[h]=c.call(d,g[h],h,b));return f};
K.j.reduce=K.Ca&&(K.j.za||Array.prototype.reduce)?function(b,c,d,e){e&&(c=K.bind(c,e));return Array.prototype.reduce.call(b,c,d)}:function(b,c,d,e){var f=d;K.j.forEach(b,function(d,h){f=c.call(e,f,d,h,b)});return f};K.j.reduceRight=K.Ca&&(K.j.za||Array.prototype.reduceRight)?function(b,c,d,e){e&&(c=K.bind(c,e));return Array.prototype.reduceRight.call(b,c,d)}:function(b,c,d,e){var f=d;K.j.Gf(b,function(d,h){f=c.call(e,f,d,h,b)});return f};
K.j.some=K.Ca&&(K.j.za||Array.prototype.some)?function(b,c,d){return Array.prototype.some.call(b,c,d)}:function(b,c,d){for(var e=b.length,f=K.L(b)?b.split(""):b,g=0;g<e;g++)if(g in f&&c.call(d,f[g],g,b))return!0;return!1};K.j.every=K.Ca&&(K.j.za||Array.prototype.every)?function(b,c,d){return Array.prototype.every.call(b,c,d)}:function(b,c,d){for(var e=b.length,f=K.L(b)?b.split(""):b,g=0;g<e;g++)if(g in f&&!c.call(d,f[g],g,b))return!1;return!0};
K.j.count=function(b,c,d){var e=0;K.j.forEach(b,function(b,g,h){c.call(d,b,g,h)&&++e},d);return e};K.j.find=function(b,c,d){c=K.j.findIndex(b,c,d);return 0>c?null:K.L(b)?b.charAt(c):b[c]};K.j.findIndex=function(b,c,d){for(var e=b.length,f=K.L(b)?b.split(""):b,g=0;g<e;g++)if(g in f&&c.call(d,f[g],g,b))return g;return-1};K.j.Gq=function(b,c,d){c=K.j.yj(b,c,d);return 0>c?null:K.L(b)?b.charAt(c):b[c]};
K.j.yj=function(b,c,d){for(var e=K.L(b)?b.split(""):b,f=b.length-1;0<=f;f--)if(f in e&&c.call(d,e[f],f,b))return f;return-1};K.j.contains=function(b,c){return 0<=K.j.indexOf(b,c)};K.j.Qb=function(b){return 0==b.length};K.j.clear=function(b){if(!K.isArray(b))for(var c=b.length-1;0<=c;c--)delete b[c];b.length=0};K.j.rr=function(b,c){K.j.contains(b,c)||b.push(c)};K.j.sg=function(b,c,d){K.j.splice(b,d,0,c)};K.j.tr=function(b,c,d){K.fb(K.j.splice,b,d,0).apply(null,c)};
K.j.insertBefore=function(b,c,d){var e;2==arguments.length||0>(e=K.j.indexOf(b,d))?b.push(c):K.j.sg(b,c,e)};K.j.remove=function(b,c){c=K.j.indexOf(b,c);var d;(d=0<=c)&&K.j.yb(b,c);return d};K.j.Os=function(b,c){c=K.j.lastIndexOf(b,c);return 0<=c?(K.j.yb(b,c),!0):!1};K.j.yb=function(b,c){return 1==Array.prototype.splice.call(b,c,1).length};K.j.Ns=function(b,c,d){c=K.j.findIndex(b,c,d);return 0<=c?(K.j.yb(b,c),!0):!1};
K.j.Ks=function(b,c,d){var e=0;K.j.Gf(b,function(f,g){c.call(d,f,g,b)&&K.j.yb(b,g)&&e++});return e};K.j.concat=function(b){return Array.prototype.concat.apply([],arguments)};K.j.join=function(b){return Array.prototype.concat.apply([],arguments)};K.j.th=function(b){var c=b.length;if(0<c){for(var d=Array(c),e=0;e<c;e++)d[e]=b[e];return d}return[]};K.j.clone=K.j.th;
K.j.extend=function(b,c){for(var d=1;d<arguments.length;d++){var e=arguments[d];if(K.Nb(e)){var f=b.length||0,g=e.length||0;b.length=f+g;for(var h=0;h<g;h++)b[f+h]=e[h]}else b.push(e)}};K.j.splice=function(b,c,d,e){return Array.prototype.splice.apply(b,K.j.slice(arguments,1))};K.j.slice=function(b,c,d){return 2>=arguments.length?Array.prototype.slice.call(b,c):Array.prototype.slice.call(b,c,d)};
K.j.Ls=function(b,c,d){function e(b){return K.ha(b)?"o"+K.kg(b):(typeof b).charAt(0)+b}c=c||b;d=d||e;for(var f={},g=0,h=0;h<b.length;){var l=b[h++],m=d(l);Object.prototype.hasOwnProperty.call(f,m)||(f[m]=!0,c[g++]=l)}c.length=g};K.j.gf=function(b,c,d){return K.j.hf(b,d||K.j.Pa,!1,c)};K.j.Kp=function(b,c,d){return K.j.hf(b,c,!0,void 0,d)};K.j.hf=function(b,c,d,e,f){for(var g=0,h=b.length,l;g<h;){var m=g+h>>1;var q=d?c.call(f,b[m],m,b):c(e,b[m]);0<q?g=m+1:(h=m,l=!q)}return l?g:~g};
K.j.sort=function(b,c){b.sort(c||K.j.Pa)};K.j.zt=function(b,c){for(var d=Array(b.length),e=0;e<b.length;e++)d[e]={index:e,value:b[e]};var f=c||K.j.Pa;K.j.sort(d,function(b,c){return f(b.value,c.value)||b.index-c.index});for(e=0;e<b.length;e++)b[e]=d[e].value};K.j.sl=function(b,c,d){var e=d||K.j.Pa;K.j.sort(b,function(b,d){return e(c(b),c(d))})};K.j.wt=function(b,c,d){K.j.sl(b,function(b){return b[c]},d)};
K.j.Vr=function(b,c,d){c=c||K.j.Pa;for(var e=1;e<b.length;e++){var f=c(b[e-1],b[e]);if(0<f||0==f&&d)return!1}return!0};K.j.Ib=function(b,c,d){if(!K.Nb(b)||!K.Nb(c)||b.length!=c.length)return!1;var e=b.length;d=d||K.j.lj;for(var f=0;f<e;f++)if(!d(b[f],c[f]))return!1;return!0};K.j.$p=function(b,c,d){d=d||K.j.Pa;for(var e=Math.min(b.length,c.length),f=0;f<e;f++){var g=d(b[f],c[f]);if(0!=g)return g}return K.j.Pa(b.length,c.length)};K.j.Pa=function(b,c){return b>c?1:b<c?-1:0};
K.j.vr=function(b,c){return-K.j.Pa(b,c)};K.j.lj=function(b,c){return b===c};K.j.Ip=function(b,c,d){d=K.j.gf(b,c,d);return 0>d?(K.j.sg(b,c,-(d+1)),!0):!1};K.j.Jp=function(b,c,d){c=K.j.gf(b,c,d);return 0<=c?K.j.yb(b,c):!1};K.j.Mp=function(b,c,d){for(var e={},f=0;f<b.length;f++){var g=b[f],h=c.call(d,g,f,b);K.R(h)&&(e[h]||(e[h]=[])).push(g)}return e};K.j.It=function(b,c,d){var e={};K.j.forEach(b,function(f,g){e[c.call(d,f,g,b)]=f});return e};
K.j.Gs=function(b,c,d){var e=[],f=0,g=b;d=d||1;void 0!==c&&(f=b,g=c);if(0>d*(g-f))return[];if(0<d)for(b=f;b<g;b+=d)e.push(b);else for(b=f;b>g;b+=d)e.push(b);return e};K.j.repeat=function(b,c){for(var d=[],e=0;e<c;e++)d[e]=b;return d};K.j.flatten=function(b){for(var c=[],d=0;d<arguments.length;d++){var e=arguments[d];if(K.isArray(e))for(var f=0;f<e.length;f+=8192)for(var g=K.j.flatten.apply(null,K.j.slice(e,f,f+8192)),h=0;h<g.length;h++)c.push(g[h]);else c.push(e)}return c};
K.j.rotate=function(b,c){b.length&&(c%=b.length,0<c?Array.prototype.unshift.apply(b,b.splice(-c,c)):0>c&&Array.prototype.push.apply(b,b.splice(0,-c)));return b};K.j.os=function(b,c,d){c=Array.prototype.splice.call(b,c,1);Array.prototype.splice.call(b,d,0,c[0])};
K.j.$t=function(b){if(!arguments.length)return[];for(var c=[],d=arguments[0].length,e=1;e<arguments.length;e++)arguments[e].length<d&&(d=arguments[e].length);for(e=0;e<d;e++){for(var f=[],g=0;g<arguments.length;g++)f.push(arguments[g][e]);c.push(f)}return c};K.j.vt=function(b,c){c=c||Math.random;for(var d=b.length-1;0<d;d--){var e=Math.floor(c()*(d+1)),f=b[d];b[d]=b[e];b[e]=f}};K.j.fq=function(b,c){var d=[];K.j.forEach(c,function(c){d.push(b[c])});return d};
K.j.bq=function(b,c,d){return K.j.concat.apply([],K.j.map(b,c,d))};K.h={};K.h.i={};K.h.i.Zh=!1;
K.h.i.Ie=K.h.i.Zh||("ar"==K.ba.substring(0,2).toLowerCase()||"fa"==K.ba.substring(0,2).toLowerCase()||"he"==K.ba.substring(0,2).toLowerCase()||"iw"==K.ba.substring(0,2).toLowerCase()||"ps"==K.ba.substring(0,2).toLowerCase()||"sd"==K.ba.substring(0,2).toLowerCase()||"ug"==K.ba.substring(0,2).toLowerCase()||"ur"==K.ba.substring(0,2).toLowerCase()||"yi"==K.ba.substring(0,2).toLowerCase())&&(2==K.ba.length||"-"==K.ba.substring(2,3)||"_"==K.ba.substring(2,3))||3<=K.ba.length&&"ckb"==K.ba.substring(0,3).toLowerCase()&&
(3==K.ba.length||"-"==K.ba.substring(3,4)||"_"==K.ba.substring(3,4));K.h.i.mb={gi:"\u202a",ji:"\u202b",Oe:"\u202c",hi:"\u200e",ki:"\u200f"};K.h.i.O={Ta:1,Ua:-1,qa:0};K.h.i.bc="right";K.h.i.$b="left";K.h.i.yn=K.h.i.Ie?K.h.i.$b:K.h.i.bc;K.h.i.xn=K.h.i.Ie?K.h.i.bc:K.h.i.$b;K.h.i.Al=function(b){return typeof b==x?0<b?K.h.i.O.Ta:0>b?K.h.i.O.Ua:K.h.i.O.qa:null==b?null:b?K.h.i.O.Ua:K.h.i.O.Ta};K.h.i.vb="A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff";
K.h.i.zb="\u0591-\u06ef\u06fa-\u07ff\u200f\ufb1d-\ufdff\ufe70-\ufefc";K.h.i.Yj=/<[^>]*>|&[^;]+;/g;K.h.i.Sa=function(b,c){return c?b.replace(K.h.i.Yj,""):b};K.h.i.$k=new RegExp("["+K.h.i.zb+"]");K.h.i.Fk=new RegExp("["+K.h.i.vb+"]");K.h.i.Bd=function(b,c){return K.h.i.$k.test(K.h.i.Sa(b,c))};K.h.i.mr=K.h.i.Bd;K.h.i.og=function(b){return K.h.i.Fk.test(K.h.i.Sa(b,void 0))};K.h.i.Ik=new RegExp("^["+K.h.i.vb+"]");K.h.i.el=new RegExp("^["+K.h.i.zb+"]");K.h.i.nk=function(b){return K.h.i.el.test(b)};
K.h.i.jk=function(b){return K.h.i.Ik.test(b)};K.h.i.Nr=function(b){return!K.h.i.jk(b)&&!K.h.i.nk(b)};K.h.i.Gk=new RegExp("^[^"+K.h.i.zb+"]*["+K.h.i.vb+"]");K.h.i.bl=new RegExp("^[^"+K.h.i.vb+"]*["+K.h.i.zb+"]");K.h.i.nh=function(b,c){return K.h.i.bl.test(K.h.i.Sa(b,c))};K.h.i.Tr=K.h.i.nh;K.h.i.tl=function(b,c){return K.h.i.Gk.test(K.h.i.Sa(b,c))};K.h.i.Lr=K.h.i.tl;K.h.i.Jg=/^http:\/\/.*/;K.h.i.Or=function(b,c){b=K.h.i.Sa(b,c);return K.h.i.Jg.test(b)||!K.h.i.og(b)&&!K.h.i.Bd(b)};
K.h.i.Hk=new RegExp("["+K.h.i.vb+"][^"+K.h.i.zb+"]*$");K.h.i.cl=new RegExp("["+K.h.i.zb+"][^"+K.h.i.vb+"]*$");K.h.i.rj=function(b,c){return K.h.i.Hk.test(K.h.i.Sa(b,c))};K.h.i.Kr=K.h.i.rj;K.h.i.sj=function(b,c){return K.h.i.cl.test(K.h.i.Sa(b,c))};K.h.i.Rr=K.h.i.sj;K.h.i.dl=/^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Arab|Hebr|Thaa|Nkoo|Tfng))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;K.h.i.Sr=function(b){return K.h.i.dl.test(b)};K.h.i.Ui=/(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;
K.h.i.lr=function(b,c){c=(void 0===c?K.h.i.Bd(b):c)?K.h.i.mb.ki:K.h.i.mb.hi;return b.replace(K.h.i.Ui,c+"$&"+c)};K.h.i.Aq=function(b){return"<"==b.charAt(0)?b.replace(/<\w+/,"$& dir=rtl"):"\n<span dir=rtl>"+b+"</span>"};K.h.i.Bq=function(b){return K.h.i.mb.ji+b+K.h.i.mb.Oe};K.h.i.yq=function(b){return"<"==b.charAt(0)?b.replace(/<\w+/,"$& dir=ltr"):"\n<span dir=ltr>"+b+"</span>"};K.h.i.zq=function(b){return K.h.i.mb.gi+b+K.h.i.mb.Oe};K.h.i.pj=/:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;
K.h.i.vk=/left/gi;K.h.i.Zk=/right/gi;K.h.i.yl=/%%%%/g;K.h.i.ls=function(b){return b.replace(K.h.i.pj,":$1 $4 $3 $2").replace(K.h.i.vk,"%%%%").replace(K.h.i.Zk,K.h.i.$b).replace(K.h.i.yl,K.h.i.bc)};K.h.i.qj=/([\u0591-\u05f2])"/g;K.h.i.rl=/([\u0591-\u05f2])'/g;K.h.i.qs=function(b){return b.replace(K.h.i.qj,"$1\u05f4").replace(K.h.i.rl,"$1\u05f3")};K.h.i.Pl=/\s+/;K.h.i.Xj=/[\d\u06f0-\u06f9]/;K.h.i.al=.4;
K.h.i.yf=function(b,c){var d=0,e=0,f=!1;b=K.h.i.Sa(b,c).split(K.h.i.Pl);for(c=0;c<b.length;c++){var g=b[c];K.h.i.nh(g)?(d++,e++):K.h.i.Jg.test(g)?f=!0:K.h.i.og(g)?e++:K.h.i.Xj.test(g)&&(f=!0)}return 0==e?f?K.h.i.O.Ta:K.h.i.O.qa:d/e>K.h.i.al?K.h.i.O.Ua:K.h.i.O.Ta};K.h.i.tq=function(b,c){return K.h.i.yf(b,c)==K.h.i.O.Ua};K.h.i.ct=function(b,c){b&&(c=K.h.i.Al(c))&&(b.style.textAlign=c==K.h.i.O.Ua?K.h.i.bc:K.h.i.$b,b.dir=c==K.h.i.O.Ua?"rtl":"ltr")};
K.h.i.dt=function(b,c){switch(K.h.i.yf(c)){case K.h.i.O.Ta:b.dir="ltr";break;case K.h.i.O.Ua:b.dir="rtl";break;default:b.removeAttribute("dir")}};K.h.i.Tm=F();K.b={};K.b.C=function(){this.Bc="";this.Ai=K.b.C.ca};K.b.C.prototype.ua=!0;K.b.C.prototype.ga=G("Bc");K.b.C.prototype.Dd=!0;K.b.C.prototype.$a=function(){return K.h.i.O.Ta};K.ea&&(K.b.C.prototype.toString=function(){return"TrustedResourceUrl{"+this.Bc+"}"});K.b.C.u=function(b){if(b instanceof K.b.C&&b.constructor===K.b.C&&b.Ai===K.b.C.ca)return b.Bc;K.m.ma("expected object of type TrustedResourceUrl, got '"+b+k+K.aa(b));return"type_error:TrustedResourceUrl"};
K.b.C.format=function(b,c){b=K.b.C.Hf(b,c);return K.b.C.Hb(b)};K.b.C.Hf=function(b,c){var d=K.f.I.u(b);if(!K.b.C.Ih.test(d))throw Error("Invalid TrustedResourceUrl format: "+d);return d.replace(K.b.C.$h,function(b,f){if(!Object.prototype.hasOwnProperty.call(c,f))throw Error('Found marker, "'+f+'", in format string, "'+d+'", but no valid label mapping found in args: '+JSON.stringify(c));b=c[f];return b instanceof K.f.I?K.f.I.u(b):encodeURIComponent(String(b))})};K.b.C.$h=/%{(\w+)}/g;K.b.C.Ih=/^(?:https:)?\/\/[0-9a-z.:[\]-]+\/|^\/[^\/\\]|^about:blank(#|$)/i;
K.b.C.Kq=function(b,c,d){b=K.b.C.Hf(b,c);c=/\?/.test(b)?"&":"?";for(var e in d)for(var f=K.isArray(d[e])?d[e]:[d[e]],g=0;g<f.length;g++)null!=f[g]&&(b+=c+encodeURIComponent(e)+"="+encodeURIComponent(String(f[g])),c="&");return K.b.C.Hb(b)};K.b.C.mc=function(b){return K.b.C.Hb(K.f.I.u(b))};K.b.C.Nq=function(b){for(var c="",d=0;d<b.length;d++)c+=K.f.I.u(b[d]);return K.b.C.Hb(c)};K.b.C.ca={};K.b.C.Hb=function(b){var c=new K.b.C;c.Bc=b;return c};K.async={};K.async.Zb=function(b,c,d){this.wk=d;this.ij=b;this.Vk=c;this.xc=0;this.tc=null};K.async.Zb.prototype.get=function(){if(0<this.xc){this.xc--;var b=this.tc;this.tc=b.next;b.next=null}else b=this.ij();return b};K.async.Zb.prototype.put=function(b){this.Vk(b);this.xc<this.wk&&(this.xc++,b.next=this.tc,this.tc=b)};K.debug.Z={};K.debug.$m=F();K.debug.Z.xb=[];K.debug.Z.Vd=[];K.debug.Z.Wg=!1;K.debug.Z.register=function(b){K.debug.Z.xb[K.debug.Z.xb.length]=b;if(K.debug.Z.Wg)for(var c=K.debug.Z.Vd,d=0;d<c.length;d++)b(K.bind(c[d].Rl,c[d]))};K.debug.Z.ns=function(b){K.debug.Z.Wg=!0;for(var c=K.bind(b.Rl,b),d=0;d<K.debug.Z.xb.length;d++)K.debug.Z.xb[d](c);K.debug.Z.Vd.push(b)};K.debug.Z.Rt=function(b){var c=K.debug.Z.Vd;b=K.bind(b.u,b);for(var d=0;d<K.debug.Z.xb.length;d++)K.debug.Z.xb[d](b);c.length--};K.a.vn=F();K.a.c=function(b){this.xl=b};K.a.c.prototype.toString=G("xl");K.a.c.Ul=new K.a.c("A");K.a.c.Vl=new K.a.c("ABBR");K.a.c.Xl=new K.a.c("ACRONYM");K.a.c.Yl=new K.a.c("ADDRESS");K.a.c.bm=new K.a.c("APPLET");K.a.c.cm=new K.a.c("AREA");K.a.c.dm=new K.a.c("ARTICLE");K.a.c.em=new K.a.c("ASIDE");K.a.c.im=new K.a.c("AUDIO");K.a.c.jm=new K.a.c("B");K.a.c.km=new K.a.c("BASE");K.a.c.lm=new K.a.c("BASEFONT");K.a.c.mm=new K.a.c("BDI");K.a.c.nm=new K.a.c("BDO");K.a.c.qm=new K.a.c("BIG");K.a.c.rm=new K.a.c("BLOCKQUOTE");
K.a.c.sm=new K.a.c("BODY");K.a.c.we=new K.a.c("BR");K.a.c.tm=new K.a.c("BUTTON");K.a.c.um=new K.a.c("CANVAS");K.a.c.vm=new K.a.c("CAPTION");K.a.c.xm=new K.a.c("CENTER");K.a.c.ym=new K.a.c("CITE");K.a.c.Bm=new K.a.c("CODE");K.a.c.Cm=new K.a.c("COL");K.a.c.Dm=new K.a.c("COLGROUP");K.a.c.Em=new K.a.c("COMMAND");K.a.c.Gm=new K.a.c("DATA");K.a.c.Hm=new K.a.c("DATALIST");K.a.c.Im=new K.a.c("DD");K.a.c.Jm=new K.a.c("DEL");K.a.c.Km=new K.a.c("DETAILS");K.a.c.Lm=new K.a.c("DFN");K.a.c.Mm=new K.a.c("DIALOG");
K.a.c.Nm=new K.a.c("DIR");K.a.c.Om=new K.a.c("DIV");K.a.c.Pm=new K.a.c("DL");K.a.c.Sm=new K.a.c("DT");K.a.c.Vm=new K.a.c("EM");K.a.c.Wm=new K.a.c("EMBED");K.a.c.bn=new K.a.c("FIELDSET");K.a.c.cn=new K.a.c("FIGCAPTION");K.a.c.dn=new K.a.c("FIGURE");K.a.c.en=new K.a.c("FONT");K.a.c.fn=new K.a.c("FOOTER");K.a.c.gn=new K.a.c("FORM");K.a.c.hn=new K.a.c("FRAME");K.a.c.jn=new K.a.c("FRAMESET");K.a.c.kn=new K.a.c("H1");K.a.c.ln=new K.a.c("H2");K.a.c.mn=new K.a.c("H3");K.a.c.nn=new K.a.c("H4");K.a.c.on=new K.a.c("H5");
K.a.c.pn=new K.a.c("H6");K.a.c.qn=new K.a.c("HEAD");K.a.c.rn=new K.a.c("HEADER");K.a.c.sn=new K.a.c("HGROUP");K.a.c.tn=new K.a.c("HR");K.a.c.un=new K.a.c("HTML");K.a.c.wn=new K.a.c("I");K.a.c.zn=new K.a.c("IFRAME");K.a.c.An=new K.a.c("IMG");K.a.c.Bn=new K.a.c("INPUT");K.a.c.Cn=new K.a.c("INS");K.a.c.Hn=new K.a.c("ISINDEX");K.a.c.Jn=new K.a.c("KBD");K.a.c.Kn=new K.a.c("KEYGEN");K.a.c.Ln=new K.a.c("LABEL");K.a.c.Nn=new K.a.c("LEGEND");K.a.c.On=new K.a.c("LI");K.a.c.Pn=new K.a.c("LINK");K.a.c.Sn=new K.a.c("MAP");
K.a.c.Tn=new K.a.c("MARK");K.a.c.Un=new K.a.c("MATH");K.a.c.Vn=new K.a.c("MENU");K.a.c.Wn=new K.a.c("META");K.a.c.Xn=new K.a.c("METER");K.a.c.Zn=new K.a.c("NAV");K.a.c.$n=new K.a.c("NOFRAMES");K.a.c.ao=new K.a.c("NOSCRIPT");K.a.c.eo=new K.a.c("OBJECT");K.a.c.fo=new K.a.c("OL");K.a.c.ho=new K.a.c("OPTGROUP");K.a.c.io=new K.a.c("OPTION");K.a.c.jo=new K.a.c("OUTPUT");K.a.c.ko=new K.a.c("P");K.a.c.lo=new K.a.c("PARAM");K.a.c.no=new K.a.c("PRE");K.a.c.po=new K.a.c("PROGRESS");K.a.c.Q=new K.a.c("Q");
K.a.c.qo=new K.a.c("RP");K.a.c.ro=new K.a.c("RT");K.a.c.so=new K.a.c("RUBY");K.a.c.uo=new K.a.c("S");K.a.c.wo=new K.a.c("SAMP");K.a.c.xo=new K.a.c(p);K.a.c.yo=new K.a.c("SECTION");K.a.c.zo=new K.a.c("SELECT");K.a.c.Ao=new K.a.c("SMALL");K.a.c.Bo=new K.a.c("SOURCE");K.a.c.Co=new K.a.c("SPAN");K.a.c.Do=new K.a.c("STRIKE");K.a.c.Eo=new K.a.c("STRONG");K.a.c.Fo=new K.a.c("STYLE");K.a.c.Go=new K.a.c("SUB");K.a.c.Ho=new K.a.c("SUMMARY");K.a.c.Io=new K.a.c("SUP");K.a.c.Jo=new K.a.c("SVG");K.a.c.Ko=new K.a.c("TABLE");
K.a.c.Lo=new K.a.c("TBODY");K.a.c.Mo=new K.a.c("TD");K.a.c.No=new K.a.c("TEMPLATE");K.a.c.Oo=new K.a.c("TEXTAREA");K.a.c.Po=new K.a.c("TFOOT");K.a.c.Qo=new K.a.c("TH");K.a.c.Ro=new K.a.c("THEAD");K.a.c.So=new K.a.c("TIME");K.a.c.To=new K.a.c("TITLE");K.a.c.Uo=new K.a.c("TR");K.a.c.Vo=new K.a.c("TRACK");K.a.c.Xo=new K.a.c("TT");K.a.c.Zo=new K.a.c("U");K.a.c.$o=new K.a.c("UL");K.a.c.ap=new K.a.c("VAR");K.a.c.bp=new K.a.c("VIDEO");K.a.c.cp=new K.a.c("WBR");K.J={};K.J.ic=function(b){return function(){return b}};K.J.an=K.J.ic(!1);K.J.Wo=K.J.ic(!0);K.J.co=K.J.ic(null);K.J.$j=E();K.J.error=function(b){return function(){throw Error(b);}};K.J.ma=function(b){return function(){throw b;}};K.J.lock=function(b,c){c=c||0;return function(){return b.apply(this,Array.prototype.slice.call(arguments,0,c))}};K.J.vs=function(b){return function(){return arguments[b]}};
K.J.Cs=function(b,c){var d=Array.prototype.slice.call(arguments,1);return function(){var c=Array.prototype.slice.call(arguments);c.push.apply(c,d);return b.apply(this,c)}};K.J.Xt=function(b,c){return K.J.ll(b,K.J.ic(c))};K.J.Cq=function(b,c){return function(d){return c?b==d:b===d}};K.J.aq=function(b,c){var d=arguments,e=d.length;return function(){var b;e&&(b=d[e-1].apply(this,arguments));for(var c=e-2;0<=c;c--)b=d[c].call(this,b);return b}};
K.J.ll=function(b){var c=arguments,d=c.length;return function(){for(var b,f=0;f<d;f++)b=c[f].apply(this,arguments);return b}};K.J.kp=function(b){var c=arguments,d=c.length;return function(){for(var b=0;b<d;b++)if(!c[b].apply(this,arguments))return!1;return!0}};K.J.As=function(b){var c=arguments,d=c.length;return function(){for(var b=0;b<d;b++)if(c[b].apply(this,arguments))return!0;return!1}};K.J.us=function(b){return function(){return!b.apply(this,arguments)}};
K.J.create=function(b,c){function d(){}d.prototype=b.prototype;var e=new d;b.apply(e,Array.prototype.slice.call(arguments,1));return e};K.J.Kh=!0;K.J.Op=function(b){var c=!1,d;return function(){if(!K.J.Kh)return b();c||(d=b(),c=!0);return d}};K.J.once=function(b){var c=b;return function(){if(c){var b=c;c=null;b()}}};K.J.rq=function(b,c,d){var e=0;return function(f){K.global.clearTimeout(e);var g=arguments;e=K.global.setTimeout(function(){b.apply(d,g)},c)}};
K.J.Ft=function(b,c,d){function e(){g=K.global.setTimeout(f,c);b.apply(d,l)}function f(){g=0;h&&(h=!1,e())}var g=0,h=!1,l=[];return function(b){l=arguments;g?h=!0:e()}};K.J.Hs=function(b,c,d){function e(){f=0}var f=0;return function(g){f||(f=K.global.setTimeout(e,c),b.apply(d,arguments))}};K.g={};K.g.userAgent={};K.g.userAgent.A={};K.g.userAgent.A.Xf=function(){var b=K.g.userAgent.A.Kj();return b&&(b=b.userAgent)?b:""};K.g.userAgent.A.Kj=function(){return K.global.navigator};K.g.userAgent.A.xh=K.g.userAgent.A.Xf();K.g.userAgent.A.tt=function(b){K.g.userAgent.A.xh=b||K.g.userAgent.A.Xf()};K.g.userAgent.A.sb=function(){return K.g.userAgent.A.xh};K.g.userAgent.A.K=function(b){return K.f.contains(K.g.userAgent.A.sb(),b)};
K.g.userAgent.A.Pk=function(){return K.f.kf(K.g.userAgent.A.sb(),"WebKit")};K.g.userAgent.A.Af=function(b){for(var c=/(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g,d=[],e;e=c.exec(b);)d.push([e[1],e[2],e[3]||void 0]);return d};K.object={};K.object.is=function(b,c){return b===c?0!==b||1/b===1/c:b!==b&&c!==c};K.object.forEach=function(b,c,d){for(var e in b)c.call(d,b[e],e,b)};K.object.filter=function(b,c,d){var e={},f;for(f in b)c.call(d,b[f],f,b)&&(e[f]=b[f]);return e};K.object.map=function(b,c,d){var e={},f;for(f in b)e[f]=c.call(d,b[f],f,b);return e};K.object.some=function(b,c,d){for(var e in b)if(c.call(d,b[e],e,b))return!0;return!1};K.object.every=function(b,c,d){for(var e in b)if(!c.call(d,b[e],e,b))return!1;return!0};
K.object.Vq=function(b){var c=0,d;for(d in b)c++;return c};K.object.Tq=function(b){for(var c in b)return c};K.object.Uq=function(b){for(var c in b)return b[c]};K.object.contains=function(b,c){return K.object.cj(b,c)};K.object.jr=function(b){var c=[],d=0,e;for(e in b)c[d++]=b[e];return c};K.object.Vf=function(b){var c=[],d=0,e;for(e in b)c[d++]=e;return c};K.object.ir=function(b,c){var d=K.Nb(c),e=d?c:arguments;for(d=d?0:1;d<e.length;d++){if(null==b)return;b=b[e[d]]}return b};
K.object.bj=function(b,c){return null!==b&&c in b};K.object.cj=function(b,c){for(var d in b)if(b[d]==c)return!0;return!1};K.object.zj=function(b,c,d){for(var e in b)if(c.call(d,b[e],e,b))return e};K.object.Hq=function(b,c,d){return(c=K.object.zj(b,c,d))&&b[c]};K.object.Qb=function(b){for(var c in b)return!1;return!0};K.object.clear=function(b){for(var c in b)delete b[c]};K.object.remove=function(b,c){var d;(d=c in b)&&delete b[c];return d};
K.object.add=function(b,c,d){if(null!==b&&c in b)throw Error('The object already contains the key "'+c+'"');K.object.set(b,c,d)};K.object.get=function(b,c,d){return null!==b&&c in b?b[c]:d};K.object.set=function(b,c,d){b[c]=d};K.object.ht=function(b,c,d){return c in b?b[c]:b[c]=d};K.object.ut=function(b,c,d){if(c in b)return b[c];d=d();return b[c]=d};K.object.Ib=function(b,c){for(var d in b)if(!(d in c)||b[d]!==c[d])return!1;for(d in c)if(!(d in b))return!1;return!0};
K.object.clone=function(b){var c={},d;for(d in b)c[d]=b[d];return c};K.object.Hl=function(b){var c=K.aa(b);if(c==y||c==r){if(K.ya(b.clone))return b.clone();c=c==r?[]:{};for(var d in b)c[d]=K.object.Hl(b[d]);return c}return b};K.object.Mt=function(b){var c={},d;for(d in b)c[b[d]]=d;return c};K.object.Pe=["constructor",w,"isPrototypeOf",A,D,"toString","valueOf"];
K.object.extend=function(b,c){for(var d,e,f=1;f<arguments.length;f++){e=arguments[f];for(d in e)b[d]=e[d];for(var g=0;g<K.object.Pe.length;g++)d=K.object.Pe[g],Object.prototype.hasOwnProperty.call(e,d)&&(b[d]=e[d])}};K.object.create=function(b){var c=arguments.length;if(1==c&&K.isArray(arguments[0]))return K.object.create.apply(null,arguments[0]);if(c%2)throw Error("Uneven number of arguments");for(var d={},e=0;e<c;e+=2)d[arguments[e]]=arguments[e+1];return d};
K.object.gj=function(b){var c=arguments.length;if(1==c&&K.isArray(arguments[0]))return K.object.gj.apply(null,arguments[0]);for(var d={},e=0;e<c;e++)d[arguments[e]]=!0;return d};K.object.iq=function(b){var c=b;Object.isFrozen&&!Object.isFrozen(b)&&(c=Object.create(b),Object.freeze(c));return c};K.object.Gr=function(b){return!!Object.isFrozen&&Object.isFrozen(b)};
K.object.Sq=function(b,c,d){if(!b)return[];if(!Object.getOwnPropertyNames||!Object.getPrototypeOf)return K.object.Vf(b);for(var e={};b&&(b!==Object.prototype||c)&&(b!==Function.prototype||d);){for(var f=Object.getOwnPropertyNames(b),g=0;g<f.length;g++)e[f[g]]=!0;b=Object.getPrototypeOf(b)}return K.object.Vf(e)};K.g.userAgent.v={};K.g.userAgent.v.Rg=function(){return K.g.userAgent.A.K("Opera")};K.g.userAgent.v.Nk=function(){return K.g.userAgent.A.K("Trident")||K.g.userAgent.A.K("MSIE")};K.g.userAgent.v.Sd=function(){return K.g.userAgent.A.K("Edge")};K.g.userAgent.v.Mk=function(){return K.g.userAgent.A.K("Firefox")};K.g.userAgent.v.Sg=function(){return K.g.userAgent.A.K("Safari")&&!(K.g.userAgent.v.Qd()||K.g.userAgent.v.Rd()||K.g.userAgent.v.Rg()||K.g.userAgent.v.Sd()||K.g.userAgent.v.Kg()||K.g.userAgent.A.K("Android"))};
K.g.userAgent.v.Rd=function(){return K.g.userAgent.A.K("Coast")};K.g.userAgent.v.Ok=function(){return(K.g.userAgent.A.K("iPad")||K.g.userAgent.A.K("iPhone"))&&!K.g.userAgent.v.Sg()&&!K.g.userAgent.v.Qd()&&!K.g.userAgent.v.Rd()&&K.g.userAgent.A.K("AppleWebKit")};K.g.userAgent.v.Qd=function(){return(K.g.userAgent.A.K("Chrome")||K.g.userAgent.A.K("CriOS"))&&!K.g.userAgent.v.Sd()};
K.g.userAgent.v.Lk=function(){return K.g.userAgent.A.K("Android")&&!(K.g.userAgent.v.zg()||K.g.userAgent.v.fk()||K.g.userAgent.v.Nd()||K.g.userAgent.v.Kg())};K.g.userAgent.v.Nd=K.g.userAgent.v.Rg;K.g.userAgent.v.uc=K.g.userAgent.v.Nk;K.g.userAgent.v.Ra=K.g.userAgent.v.Sd;K.g.userAgent.v.fk=K.g.userAgent.v.Mk;K.g.userAgent.v.Ur=K.g.userAgent.v.Sg;K.g.userAgent.v.Ar=K.g.userAgent.v.Rd;K.g.userAgent.v.Ir=K.g.userAgent.v.Ok;K.g.userAgent.v.zg=K.g.userAgent.v.Qd;K.g.userAgent.v.yr=K.g.userAgent.v.Lk;
K.g.userAgent.v.Kg=function(){return K.g.userAgent.A.K("Silk")};K.g.userAgent.v.Lb=function(){function b(b){b=K.j.find(b,e);return d[b]||""}var c=K.g.userAgent.A.sb();if(K.g.userAgent.v.uc())return K.g.userAgent.v.Jj(c);c=K.g.userAgent.A.Af(c);var d={};K.j.forEach(c,function(b){d[b[0]]=b[1]});var e=K.fb(K.object.bj,d);return K.g.userAgent.v.Nd()?b(["Version","Opera"]):K.g.userAgent.v.Ra()?b(["Edge"]):K.g.userAgent.v.zg()?b(["Chrome","CriOS"]):(c=c[2])&&c[1]||""};
K.g.userAgent.v.va=function(b){return 0<=K.f.Eb(K.g.userAgent.v.Lb(),b)};K.g.userAgent.v.Jj=function(b){var c=/rv: *([\d\.]*)/.exec(b);if(c&&c[1])return c[1];c="";var d=/MSIE +([\d\.]+)/.exec(b);if(d&&d[1])if(b=/Trident\/(\d.\d)/.exec(b),"7.0"==d[1])if(b&&b[1])switch(b[1]){case "4.0":c="8.0";break;case "5.0":c="9.0";break;case "6.0":c="10.0";break;case "7.0":c="11.0"}else c="7.0";else c=d[1];return c};K.g.userAgent.U={};K.g.userAgent.U.lk=function(){return K.g.userAgent.A.K("Presto")};K.g.userAgent.U.pk=function(){return K.g.userAgent.A.K("Trident")||K.g.userAgent.A.K("MSIE")};K.g.userAgent.U.Ra=function(){return K.g.userAgent.A.K("Edge")};K.g.userAgent.U.Mg=function(){return K.g.userAgent.A.Pk()&&!K.g.userAgent.U.Ra()};K.g.userAgent.U.gk=function(){return K.g.userAgent.A.K("Gecko")&&!K.g.userAgent.U.Mg()&&!K.g.userAgent.U.pk()&&!K.g.userAgent.U.Ra()};
K.g.userAgent.U.Lb=function(){var b=K.g.userAgent.A.sb();if(b){b=K.g.userAgent.A.Af(b);var c=K.g.userAgent.U.Hj(b);if(c)return"Gecko"==c[0]?K.g.userAgent.U.Rj(b):c[1];b=b[0];var d;if(b&&(d=b[2])&&(d=/Trident\/([^\s;]+)/.exec(d)))return d[1]}return""};K.g.userAgent.U.Hj=function(b){if(!K.g.userAgent.U.Ra())return b[1];for(var c=0;c<b.length;c++){var d=b[c];if("Edge"==d[0])return d}};K.g.userAgent.U.va=function(b){return 0<=K.f.Eb(K.g.userAgent.U.Lb(),b)};
K.g.userAgent.U.Rj=function(b){return(b=K.j.find(b,function(b){return"Firefox"==b[0]}))&&b[1]||""};K.async.qh=function(b){K.global.setTimeout(function(){throw b;},0)};K.async.pa=function(b,c,d){var e=b;c&&(e=K.bind(b,c));e=K.async.pa.Ah(e);K.ya(K.global.setImmediate)&&(d||K.async.pa.Kl())?K.global.setImmediate(e):(K.async.pa.kh||(K.async.pa.kh=K.async.pa.Nj()),K.async.pa.kh(e))};K.async.pa.Kl=function(){return K.global.Window&&K.global.Window.prototype&&!K.g.userAgent.v.Ra()&&K.global.Window.prototype.setImmediate==K.global.setImmediate?!1:!0};
K.async.pa.Nj=function(){var b=K.global.MessageChannel;"undefined"===typeof b&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!K.g.userAgent.U.lk()&&(b=function(){var b=document.createElement("IFRAME");b.style.display="none";b.src="";document.documentElement.appendChild(b);var c=b.contentWindow;b=c.document;b.open();b.write("");b.close();var d="callImmediate"+Math.random(),e="file:"==c.location.protocol?"*":c.location.protocol+"//"+c.location.host;b=K.bind(function(b){if(("*"==
e||b.origin==e)&&b.data==d)this.port1.onmessage()},this);c.addEventListener("message",b,!1);this.port1={};this.port2={postMessage:function(){c.postMessage(d,e)}}});if("undefined"!==typeof b&&!K.g.userAgent.v.uc()){var c=new b,d={},e=d;c.port1.onmessage=function(){if(K.R(d.next)){d=d.next;var b=d.lf;d.lf=null;b()}};return function(b){e.next={lf:b};e=e.next;c.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement(p)?function(b){var c=document.createElement(p);
c.onreadystatechange=function(){c.onreadystatechange=null;c.parentNode.removeChild(c);c=null;b();b=null};document.documentElement.appendChild(c)}:function(b){K.global.setTimeout(b,0)}};K.async.pa.Ah=K.J.$j;K.debug.Z.register(function(b){K.async.pa.Ah=b});K.async.Ea=function(){this.Qc=this.Ab=null};K.async.Ea.Vc=100;K.async.Ea.Kb=new K.async.Zb(function(){return new K.async.ad},function(b){b.reset()},K.async.Ea.Vc);K.async.Ea.prototype.add=function(b,c){var d=K.async.Ea.Kb.get();d.set(b,c);this.Qc?this.Qc.next=d:this.Ab=d;this.Qc=d};K.async.Ea.prototype.remove=function(){var b=null;this.Ab&&(b=this.Ab,this.Ab=this.Ab.next,this.Ab||(this.Qc=null),b.next=null);return b};K.async.ad=function(){this.next=this.scope=this.od=null};
K.async.ad.prototype.set=function(b,c){this.od=b;this.scope=c;this.next=null};K.async.ad.prototype.reset=function(){this.next=this.scope=this.od=null};K.async.M=function(b,c){K.async.M.Hc||K.async.M.bk();K.async.M.Pc||(K.async.M.Hc(),K.async.M.Pc=!0);K.async.M.ie.add(b,c)};K.async.M.bk=function(){if(-1!=String(K.global.Promise).indexOf("[native code]")){var b=K.global.Promise.resolve(void 0);K.async.M.Hc=function(){b.then(K.async.M.Cc)}}else K.async.M.Hc=function(){K.async.pa(K.async.M.Cc)}};K.async.M.Jq=function(b){K.async.M.Hc=function(){K.async.pa(K.async.M.Cc);b&&b(K.async.M.Cc)}};K.async.M.Pc=!1;K.async.M.ie=new K.async.Ea;
K.ea&&(K.async.M.Rs=function(){K.async.M.Pc=!1;K.async.M.ie=new K.async.Ea});K.async.M.Cc=function(){for(var b;b=K.async.M.ie.remove();){try{b.od.call(b.scope)}catch(c){K.async.qh(c)}K.async.Ea.Kb.put(b)}K.async.M.Pc=!1};K.a.m={};K.a.m.Cp=F();K.a.m.up=F();K.a.m.zp=F();K.a.m.yp=F();K.a.m.vp=F();K.a.m.wp=F();K.a.m.xp=F();K.a.m.Ap=F();K.a.m.Bp=F();K.a.m.sq=function(b){return K.ha(b)?b.constructor.displayName||b.constructor.name||Object.prototype.toString.call(b):void 0===b?"undefined":null===b?"null":typeof b};K.a.m.qc=function(b){return(b=b&&b.ownerDocument)&&(b.defaultView||b.parentWindow)||K.global};K.g.userAgent.platform={};K.g.userAgent.platform.yg=function(){return K.g.userAgent.A.K("Android")};K.g.userAgent.platform.Hg=function(){return K.g.userAgent.A.K("iPod")};K.g.userAgent.platform.Gg=function(){return K.g.userAgent.A.K("iPhone")&&!K.g.userAgent.A.K("iPod")&&!K.g.userAgent.A.K("iPad")};K.g.userAgent.platform.Fg=function(){return K.g.userAgent.A.K("iPad")};K.g.userAgent.platform.Eg=function(){return K.g.userAgent.platform.Gg()||K.g.userAgent.platform.Fg()||K.g.userAgent.platform.Hg()};
K.g.userAgent.platform.Ig=function(){return K.g.userAgent.A.K("Macintosh")};K.g.userAgent.platform.ik=function(){return K.g.userAgent.A.K("Linux")};K.g.userAgent.platform.Og=function(){return K.g.userAgent.A.K("Windows")};K.g.userAgent.platform.Ag=function(){return K.g.userAgent.A.K("CrOS")};
K.g.userAgent.platform.Lb=function(){var b=K.g.userAgent.A.sb(),c="";K.g.userAgent.platform.Og()?(c=/Windows (?:NT|Phone) ([0-9.]+)/,c=(b=c.exec(b))?b[1]:"0.0"):K.g.userAgent.platform.Eg()?(c=/(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/,c=(b=c.exec(b))&&b[1].replace(/_/g,".")):K.g.userAgent.platform.Ig()?(c=/Mac OS X ([0-9_.]+)/,c=(b=c.exec(b))?b[1].replace(/_/g,"."):"10"):K.g.userAgent.platform.yg()?(c=/Android\s+([^\);]+)(\)|;)/,c=(b=c.exec(b))&&b[1]):K.g.userAgent.platform.Ag()&&(c=/(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/,
c=(b=c.exec(b))&&b[1]);return c||""};K.g.userAgent.platform.va=function(b){return 0<=K.f.Eb(K.g.userAgent.platform.Lb(),b)};K.Ha={};K.Ha.object=function(b,c){return c};K.Ha.ce=function(b){K.Ha.ce[" "](b);return b};K.Ha.ce[" "]=K.eb;K.Ha.Pp=function(b,c){try{return K.Ha.ce(b[c]),!0}catch(d){}return!1};K.Ha.cache=function(b,c,d,e){e=e?e(c):c;return Object.prototype.hasOwnProperty.call(b,e)?b[e]:b[e]=d(c)};K.userAgent={};K.userAgent.oe=!1;K.userAgent.me=!1;K.userAgent.ne=!1;K.userAgent.te=!1;K.userAgent.Uc=!1;K.userAgent.re=!1;K.userAgent.Fh=!1;K.userAgent.Bb=K.userAgent.oe||K.userAgent.me||K.userAgent.ne||K.userAgent.Uc||K.userAgent.te||K.userAgent.re;K.userAgent.Qj=function(){return K.g.userAgent.A.sb()};K.userAgent.Yf=function(){return K.global.navigator||null};K.userAgent.Ne=K.userAgent.Bb?K.userAgent.re:K.g.userAgent.v.Nd();K.userAgent.Y=K.userAgent.Bb?K.userAgent.oe:K.g.userAgent.v.uc();
K.userAgent.Ce=K.userAgent.Bb?K.userAgent.me:K.g.userAgent.U.Ra();K.userAgent.Um=K.userAgent.Ce||K.userAgent.Y;K.userAgent.Yc=K.userAgent.Bb?K.userAgent.ne:K.g.userAgent.U.gk();K.userAgent.Cb=K.userAgent.Bb?K.userAgent.te||K.userAgent.Uc:K.g.userAgent.U.Mg();K.userAgent.kk=function(){return K.userAgent.Cb&&K.g.userAgent.A.K("Mobile")};K.userAgent.Yn=K.userAgent.Uc||K.userAgent.kk();K.userAgent.vo=K.userAgent.Cb;K.userAgent.nj=function(){var b=K.userAgent.Yf();return b&&b.platform||""};
K.userAgent.mo=K.userAgent.nj();K.userAgent.qe=!1;K.userAgent.ue=!1;K.userAgent.pe=!1;K.userAgent.ve=!1;K.userAgent.le=!1;K.userAgent.Sc=!1;K.userAgent.Rc=!1;K.userAgent.Tc=!1;K.userAgent.Da=K.userAgent.qe||K.userAgent.ue||K.userAgent.pe||K.userAgent.ve||K.userAgent.le||K.userAgent.Sc||K.userAgent.Rc||K.userAgent.Tc;K.userAgent.Rn=K.userAgent.Da?K.userAgent.qe:K.g.userAgent.platform.Ig();K.userAgent.ep=K.userAgent.Da?K.userAgent.ue:K.g.userAgent.platform.Og();
K.userAgent.hk=function(){return K.g.userAgent.platform.ik()||K.g.userAgent.platform.Ag()};K.userAgent.Qn=K.userAgent.Da?K.userAgent.pe:K.userAgent.hk();K.userAgent.tk=function(){var b=K.userAgent.Yf();return!!b&&K.f.contains(b.appVersion||"","X11")};K.userAgent.fp=K.userAgent.Da?K.userAgent.ve:K.userAgent.tk();K.userAgent.am=K.userAgent.Da?K.userAgent.le:K.g.userAgent.platform.yg();K.userAgent.Fn=K.userAgent.Da?K.userAgent.Sc:K.g.userAgent.platform.Gg();
K.userAgent.En=K.userAgent.Da?K.userAgent.Rc:K.g.userAgent.platform.Fg();K.userAgent.Gn=K.userAgent.Da?K.userAgent.Tc:K.g.userAgent.platform.Hg();K.userAgent.Dn=K.userAgent.Da?K.userAgent.Sc||K.userAgent.Rc||K.userAgent.Tc:K.g.userAgent.platform.Eg();K.userAgent.oj=function(){var b="",c=K.userAgent.Sj();c&&(b=c?c[1]:"");return K.userAgent.Y&&(c=K.userAgent.Of(),null!=c&&c>parseFloat(b))?String(c):b};
K.userAgent.Sj=function(){var b=K.userAgent.Qj();if(K.userAgent.Yc)return/rv\:([^\);]+)(\)|;)/.exec(b);if(K.userAgent.Ce)return/Edge\/([\d\.]+)/.exec(b);if(K.userAgent.Y)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(b);if(K.userAgent.Cb)return/WebKit\/(\S+)/.exec(b);if(K.userAgent.Ne)return/(?:Version)[ \/]?(\S+)/.exec(b)};K.userAgent.Of=function(){var b=K.global.document;return b?b.documentMode:void 0};K.userAgent.VERSION=K.userAgent.oj();K.userAgent.compare=function(b,c){return K.f.Eb(b,c)};
K.userAgent.rk={};K.userAgent.va=function(b){return K.userAgent.Fh||K.Ha.cache(K.userAgent.rk,b,function(){return 0<=K.f.Eb(K.userAgent.VERSION,b)})};K.userAgent.Zr=K.userAgent.va;K.userAgent.Pb=function(b){return Number(K.userAgent.Wh)>=b};K.userAgent.Cr=K.userAgent.Pb;var L;var M=K.global.document,aa=K.userAgent.Of();L=M&&K.userAgent.Y?aa||("CSS1Compat"==M.compatMode?parseInt(K.userAgent.VERSION,10):5):void 0;K.userAgent.Wh=L;K.a.ib={Lh:!K.userAgent.Y||K.userAgent.Pb(9),Mh:!K.userAgent.Yc&&!K.userAgent.Y||K.userAgent.Y&&K.userAgent.Pb(9)||K.userAgent.Yc&&K.userAgent.va("1.9.1"),xe:K.userAgent.Y&&!K.userAgent.va("9"),Nh:K.userAgent.Y||K.userAgent.Ne||K.userAgent.Cb,ci:K.userAgent.Y,Mn:K.userAgent.Y&&!K.userAgent.Pb(9)};K.a.Mc={};K.a.Mc.Hi={area:!0,base:!0,br:!0,col:!0,command:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0};K.a.Mc.sk=function(b){return!0===K.a.Mc.Hi[b]};K.b.V=function(){this.yc="";this.ni=K.b.V.ca};K.b.V.prototype.ua=!0;K.b.V.ca={};K.b.V.mc=function(b){b=K.f.I.u(b);return 0===b.length?K.b.V.EMPTY:K.b.V.hd(b)};K.b.V.prototype.ga=G("yc");K.ea&&(K.b.V.prototype.toString=function(){return"SafeScript{"+this.yc+"}"});K.b.V.u=function(b){if(b instanceof K.b.V&&b.constructor===K.b.V&&b.ni===K.b.V.ca)return b.yc;K.m.ma("expected object of type SafeScript, got '"+b+k+K.aa(b));return"type_error:SafeScript"};K.b.V.hd=function(b){return(new K.b.V).bb(b)};
K.b.V.prototype.bb=function(b){this.yc=b;return this};K.b.V.EMPTY=K.b.V.hd("");K.sa={};K.sa.url={};K.sa.url.dj=function(b){return K.sa.url.lg().createObjectURL(b)};K.sa.url.Ts=function(b){K.sa.url.lg().revokeObjectURL(b)};K.sa.url.lg=function(){var b=K.sa.url.Ef();if(null!=b)return b;throw Error("This browser doesn't seem to support blob URLs");};K.sa.url.Ef=function(){return K.R(K.global.URL)&&K.R(K.global.URL.createObjectURL)?K.global.URL:K.R(K.global.webkitURL)&&K.R(K.global.webkitURL.createObjectURL)?K.global.webkitURL:K.R(K.global.createObjectURL)?K.global:null};
K.sa.url.Lp=function(){return null!=K.sa.url.Ef()};K.b.o=function(){this.Ga="";this.ri=K.b.o.ca};K.b.o.Ka="about:invalid#zClosurez";K.b.o.prototype.ua=!0;K.b.o.prototype.ga=G("Ga");K.b.o.prototype.Dd=!0;K.b.o.prototype.$a=function(){return K.h.i.O.Ta};K.ea&&(K.b.o.prototype.toString=function(){return"SafeUrl{"+this.Ga+"}"});K.b.o.u=function(b){if(b instanceof K.b.o&&b.constructor===K.b.o&&b.ri===K.b.o.ca)return b.Ga;K.m.ma("expected object of type SafeUrl, got '"+b+k+K.aa(b));return"type_error:SafeUrl"};K.b.o.mc=function(b){return K.b.o.Fa(K.f.I.u(b))};
K.b.Re=/^(?:audio\/(?:3gpp|3gpp2|aac|midi|mp4|mpeg|ogg|x-m4a|x-wav|webm)|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|text\/csv|video\/(?:mpeg|mp4|ogg|webm))$/i;K.b.o.Mq=function(b){b=K.b.Re.test(b.type)?K.sa.url.dj(b):K.b.o.Ka;return K.b.o.Fa(b)};K.b.Rh=/^data:([^;,]*);base64,[a-z0-9+\/]+=*$/i;K.b.o.Oq=function(b){var c=b.match(K.b.Rh);c=c&&K.b.Re.test(c[1]);return K.b.o.Fa(c?b:K.b.o.Ka)};K.b.o.Qq=function(b){K.f.Zi(b)||(b=K.b.o.Ka);return K.b.o.Fa(b)};K.b.o.Rq=function(b){return K.b.o.Fa(K.b.C.u(b))};
K.b.Se=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;K.b.o.Gc=function(b){if(b instanceof K.b.o)return b;b=b.ua?b.ga():String(b);K.b.Se.test(b)||(b=K.b.o.Ka);return K.b.o.Fa(b)};K.b.o.Vb=function(b){if(b instanceof K.b.o)return b;b=b.ua?b.ga():String(b);K.b.Se.test(b)||(b=K.b.o.Ka);return K.b.o.Fa(b)};K.b.o.ca={};K.b.o.Fa=function(b){var c=new K.b.o;c.Ga=b;return c};K.b.o.Wl=K.b.o.Fa("about:blank");K.b.B=function(){this.Ac="";this.pi=K.b.B.ca};K.b.B.prototype.ua=!0;K.b.B.ca={};K.b.B.mc=function(b){b=K.f.I.u(b);return 0===b.length?K.b.B.EMPTY:K.b.B.Fb(b)};K.b.B.Vp=F();K.b.B.prototype.ga=G("Ac");K.ea&&(K.b.B.prototype.toString=function(){return"SafeStyle{"+this.Ac+"}"});K.b.B.u=function(b){if(b instanceof K.b.B&&b.constructor===K.b.B&&b.pi===K.b.B.ca)return b.Ac;K.m.ma("expected object of type SafeStyle, got '"+b+k+K.aa(b));return"type_error:SafeStyle"};K.b.B.Fb=function(b){return(new K.b.B).bb(b)};
K.b.B.prototype.bb=function(b){this.Ac=b;return this};K.b.B.EMPTY=K.b.B.Fb("");K.b.B.Ka="zClosurez";K.b.B.create=function(b){var c="",d;for(d in b){if(!/^[-_a-zA-Z0-9]+$/.test(d))throw Error("Name allows only [-_a-zA-Z0-9], got: "+d);var e=b[d];null!=e&&(e=K.isArray(e)?K.j.map(e,K.b.B.gh).join(" "):K.b.B.gh(e),c+=d+":"+e+";")}return c?K.b.B.Fb(c):K.b.B.EMPTY};
K.b.B.gh=function(b){return b instanceof K.b.o?'url("'+K.b.o.u(b).replace(/</g,"%3c").replace(/[\\"]/g,"\\$&")+'")':b instanceof K.f.I?K.f.I.u(b):K.b.B.il(String(b))};K.b.B.il=function(b){var c=b.replace(K.b.o.ai,"$1").replace(K.b.o.Xe,"url");return K.b.B.Ei.test(c)?K.b.B.Vj(b)?K.b.B.jl(b):(K.m.ma("String value requires balanced quotes, got: "+b),K.b.B.Ka):(K.m.ma("String value allows only "+K.b.B.$e+" and simple functions, got: "+b),K.b.B.Ka)};
K.b.B.Vj=function(b){for(var c=!0,d=!0,e=0;e<b.length;e++){var f=b.charAt(e);"'"==f&&d?c=!c:'"'==f&&c&&(d=!d)}return c&&d};K.b.B.$e="[-,.\"'%_!# a-zA-Z0-9]";K.b.B.Ei=new RegExp("^"+K.b.B.$e+"+$");K.b.o.Xe=/\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g;K.b.o.ai=/\b(hsl|hsla|rgb|rgba|(rotate|scale|translate)(X|Y|Z|3d)?)\([-0-9a-z.%, ]+\)/g;
K.b.B.jl=function(b){return b.replace(K.b.o.Xe,function(b,d,e,f){var c="";e=e.replace(/^(['"])(.*)\1$/,function(b,d,e){c=d;return e});b=K.b.o.Gc(e).ga();return d+c+b+c+f})};K.b.B.concat=function(b){function c(b){K.isArray(b)?K.j.forEach(b,c):d+=K.b.B.u(b)}var d="";K.j.forEach(arguments,c);return d?K.b.B.Fb(d):K.b.B.EMPTY};K.b.N=function(){this.zc="";this.oi=K.b.N.ca};K.b.N.prototype.ua=!0;K.b.N.ca={};
K.b.N.kq=function(b,c){if(K.f.contains(b,"<"))throw Error("Selector does not allow '<', got: "+b);var d=b.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g,"");if(!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(d))throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: "+b);if(!K.b.N.Uj(d))throw Error("() and [] in selector must be balanced, got: "+b);c instanceof K.b.B||(c=K.b.B.create(c));b=b+"{"+K.b.B.u(c)+"}";return K.b.N.Gb(b)};
K.b.N.Uj=function(b){for(var c={"(":")","[":"]"},d=[],e=0;e<b.length;e++){var f=b[e];if(c[f])d.push(c[f]);else if(K.object.contains(c,f)&&d.pop()!=f)return!1}return 0==d.length};K.b.N.concat=function(b){function c(b){K.isArray(b)?K.j.forEach(b,c):d+=K.b.N.u(b)}var d="";K.j.forEach(arguments,c);return K.b.N.Gb(d)};K.b.N.mc=function(b){b=K.f.I.u(b);return 0===b.length?K.b.N.EMPTY:K.b.N.Gb(b)};K.b.N.prototype.ga=G("zc");K.ea&&(K.b.N.prototype.toString=function(){return"SafeStyleSheet{"+this.zc+"}"});
K.b.N.u=function(b){if(b instanceof K.b.N&&b.constructor===K.b.N&&b.oi===K.b.N.ca)return b.zc;K.m.ma("expected object of type SafeStyleSheet, got '"+b+k+K.aa(b));return"type_error:SafeStyleSheet"};K.b.N.Gb=function(b){return(new K.b.N).bb(b)};K.b.N.prototype.bb=function(b){this.zc=b;return this};K.b.N.EMPTY=K.b.N.Gb("");K.b.l=function(){this.Ga="";this.mi=K.b.l.ca;this.kc=null};K.b.l.prototype.Dd=!0;K.b.l.prototype.$a=G("kc");K.b.l.prototype.ua=!0;K.b.l.prototype.ga=G("Ga");K.ea&&(K.b.l.prototype.toString=function(){return"SafeHtml{"+this.Ga+"}"});K.b.l.u=function(b){if(b instanceof K.b.l&&b.constructor===K.b.l&&b.mi===K.b.l.ca)return b.Ga;K.m.ma("expected object of type SafeHtml, got '"+b+k+K.aa(b));return"type_error:SafeHtml"};
K.b.l.ta=function(b){if(b instanceof K.b.l)return b;var c=null;b.Dd&&(c=b.$a());return K.b.l.ra(K.f.ta(b.ua?b.ga():String(b)),c)};K.b.l.pr=function(b){if(b instanceof K.b.l)return b;b=K.b.l.ta(b);return K.b.l.ra(K.f.Yg(K.b.l.u(b)),b.$a())};K.b.l.qr=function(b){if(b instanceof K.b.l)return b;b=K.b.l.ta(b);return K.b.l.ra(K.f.Ol(K.b.l.u(b)),b.$a())};K.b.l.from=K.b.l.ta;K.b.l.Ze=/^[a-zA-Z0-9-]+$/;K.b.l.Ci={action:!0,cite:!0,data:!0,formaction:!0,href:!0,manifest:!0,poster:!0,src:!0};
K.b.l.ii={APPLET:!0,BASE:!0,EMBED:!0,IFRAME:!0,LINK:!0,MATH:!0,META:!0,OBJECT:!0,SCRIPT:!0,STYLE:!0,SVG:!0,TEMPLATE:!0};K.b.l.create=function(b,c,d){K.b.l.Ml(String(b));return K.b.l.Ya(String(b),c,d)};K.b.l.Ml=function(b){if(!K.b.l.Ze.test(b))throw Error("Invalid tag name <"+b+">.");if(b.toUpperCase()in K.b.l.ii)throw Error("Tag name <"+b+"> is not allowed for SafeHtml.");};
K.b.l.hq=function(b,c,d,e){b&&K.b.C.u(b);var f={};f.src=b||null;f.srcdoc=c&&K.b.l.u(c);b=K.b.l.hc(f,{sandbox:""},d);return K.b.l.Ya("iframe",b,e)};K.b.l.lq=function(b,c,d,e){if(!K.b.l.Wi())throw Error("The browser does not support sandboxed iframes.");var f={};f.src=b?K.b.o.u(K.b.o.Gc(b)):null;f.srcdoc=c||null;f.sandbox="";b=K.b.l.hc(f,{},d);return K.b.l.Ya("iframe",b,e)};K.b.l.Wi=function(){return K.global.HTMLIFrameElement&&"sandbox"in K.global.HTMLIFrameElement.prototype};
K.b.l.nq=function(b,c){K.b.C.u(b);b=K.b.l.hc({src:b},{},c);return K.b.l.Ya("script",b)};K.b.l.mq=function(b,c){for(var d in c){var e=d.toLowerCase();if("language"==e||"src"==e||"text"==e||"type"==e)throw Error('Cannot set "'+e+'" attribute');}d="";b=K.j.concat(b);for(e=0;e<b.length;e++)d+=K.b.V.u(b[e]);b=K.b.l.ra(d,K.h.i.O.qa);return K.b.l.Ya("script",c,b)};
K.b.l.oq=function(b,c){c=K.b.l.hc({type:"text/css"},{},c);var d="";b=K.j.concat(b);for(var e=0;e<b.length;e++)d+=K.b.N.u(b[e]);b=K.b.l.ra(d,K.h.i.O.qa);return K.b.l.Ya("style",c,b)};K.b.l.jq=function(b,c){b=K.b.o.u(K.b.o.Gc(b));(K.g.userAgent.v.uc()||K.g.userAgent.v.Ra())&&K.f.contains(b,";")&&(b="'"+b.replace(/'/g,"%27")+"'");return K.b.l.Ya("meta",{"http-equiv":"refresh",content:(c||0)+"; url="+b})};
K.b.l.Cj=function(b,c,d){if(d instanceof K.f.I)d=K.f.I.u(d);else if("style"==c.toLowerCase())d=K.b.l.Oj(d);else{if(/^on/i.test(c))throw Error('Attribute "'+c+'" requires goog.string.Const value, "'+d+'" given.');if(c.toLowerCase()in K.b.l.Ci)if(d instanceof K.b.C)d=K.b.C.u(d);else if(d instanceof K.b.o)d=K.b.o.u(d);else if(K.L(d))d=K.b.o.Gc(d).ga();else throw Error('Attribute "'+c+'" on tag "'+b+'" requires goog.html.SafeUrl, goog.string.Const, or string, value "'+d+'" given.');}d.ua&&(d=d.ga());
return c+'="'+K.f.ta(String(d))+'"'};K.b.l.Oj=function(b){if(!K.ha(b))throw Error('The "style" attribute requires goog.html.SafeStyle or map of style properties, '+typeof b+" given: "+b);b instanceof K.b.B||(b=K.b.B.create(b));return K.b.B.u(b)};K.b.l.qq=function(b,c,d,e){c=K.b.l.create(c,d,e);c.kc=b;return c};
K.b.l.concat=function(b){function c(b){K.isArray(b)?K.j.forEach(b,c):(b=K.b.l.ta(b),e+=K.b.l.u(b),b=b.$a(),d==K.h.i.O.qa?d=b:b!=K.h.i.O.qa&&d!=b&&(d=null))}var d=K.h.i.O.qa,e="";K.j.forEach(arguments,c);return K.b.l.ra(e,d)};K.b.l.cq=function(b,c){var d=K.b.l.concat(K.j.slice(arguments,1));d.kc=b;return d};K.b.l.ca={};K.b.l.ra=function(b,c){return(new K.b.l).bb(b,c)};K.b.l.prototype.bb=function(b,c){this.Ga=b;this.kc=c;return this};
K.b.l.Ya=function(b,c,d){var e=null;var f="<"+b+K.b.l.vl(b,c);K.cb(d)?K.isArray(d)||(d=[d]):d=[];K.a.Mc.sk(b.toLowerCase())?f+=">":(e=K.b.l.concat(d),f+=">"+K.b.l.u(e)+"</"+b+">",e=e.$a());(b=c&&c.dir)&&(e=/^(ltr|rtl|auto)$/i.test(b)?K.h.i.O.qa:null);return K.b.l.ra(f,e)};K.b.l.vl=function(b,c){var d="";if(c)for(var e in c){if(!K.b.l.Ze.test(e))throw Error('Invalid attribute name "'+e+'".');var f=c[e];K.cb(f)&&(d+=" "+K.b.l.Cj(b,e,f))}return d};
K.b.l.hc=function(b,c,d){var e={},f;for(f in b)e[f]=b[f];for(f in c)e[f]=c[f];for(f in d){var g=f.toLowerCase();if(g in b)throw Error('Cannot override "'+g+'" attribute, got "'+f+'" with value "'+d[f]+'"');g in c&&delete e[g];e[f]=d[f]}return e};K.b.l.Qm=K.b.l.ra("<!DOCTYPE html>",K.h.i.O.qa);K.b.l.EMPTY=K.b.l.ra("",K.h.i.O.qa);K.b.l.we=K.b.l.ra("<br>",K.h.i.O.qa);K.a.S={};K.a.S.In={Zl:"afterbegin",$l:"afterend",om:"beforebegin",pm:"beforeend"};K.a.S.sr=function(b,c,d){b.insertAdjacentHTML(c,K.b.l.u(d))};K.a.S.ui={MATH:!0,SCRIPT:!0,STYLE:!0,SVG:!0,TEMPLATE:!0};K.a.S.lh=function(b,c){if(K.m.ja&&K.a.S.ui[b.tagName.toUpperCase()])throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of "+b.tagName+".");b.innerHTML=K.b.l.u(c)};K.a.S.ot=function(b,c){b.outerHTML=K.b.l.u(c)};K.a.S.qt=function(b,c){b.style.cssText=K.b.B.u(c)};K.a.S.wq=function(b,c){b.write(K.b.l.u(c))};
K.a.S.at=function(b,c){c=c instanceof K.b.o?c:K.b.o.Vb(c);b.href=K.b.o.u(c)};K.a.S.kt=function(b,c){c=c instanceof K.b.o?c:K.b.o.Vb(c);b.src=K.b.o.u(c)};K.a.S.et=function(b,c){b.src=K.b.C.u(c)};K.a.S.gt=function(b,c){b.src=K.b.C.u(c)};K.a.S.it=function(b,c){b.src=K.b.C.u(c)};K.a.S.jt=function(b,c){b.srcdoc=K.b.l.u(c)};K.a.S.lt=function(b,c,d){b.rel=d;K.f.kf(d,"stylesheet")?b.href=K.b.C.u(c):b.href=c instanceof K.b.C?K.b.C.u(c):c instanceof K.b.o?K.b.o.u(c):K.b.o.Vb(c).ga()};
K.a.S.nt=function(b,c){b.data=K.b.C.u(c)};K.a.S.ol=function(b,c){b.src=K.b.C.u(c)};K.a.S.pt=function(b,c){b.text=K.b.V.u(c)};K.a.S.mt=function(b,c){c=c instanceof K.b.o?c:K.b.o.Vb(c);b.href=K.b.o.u(c)};K.a.S.zs=function(b,c,d,e,f){b=b instanceof K.b.o?b:K.b.o.Vb(b);return(c||window).open(K.b.o.u(b),d?K.f.I.u(d):"",e,f)};K.b.hb={};K.b.hb.fl=function(b,c){return K.b.l.ra(c,null)};K.b.hb.Xs=function(b,c){return K.b.V.hd(c)};K.b.hb.Ys=function(b,c){return K.b.B.Fb(c)};K.b.hb.Zs=function(b,c){return K.b.N.Gb(c)};K.b.hb.$s=function(b,c){return K.b.o.Fa(c)};K.b.hb.Ot=function(b,c){return K.b.C.Hb(c)};K.s={};K.s.Fs=function(b){return Math.floor(Math.random()*b)};K.s.Qt=function(b,c){return b+Math.random()*(c-b)};K.s.Wp=function(b,c,d){return Math.min(Math.max(b,c),d)};K.s.Vg=function(b,c){b%=c;return 0>b*c?b+c:b};K.s.bs=function(b,c,d){return b+d*(c-b)};K.s.ps=function(b,c,d){return Math.abs(b-c)<=(d||1E-6)};K.s.fe=function(b){return K.s.Vg(b,360)};K.s.At=function(b){return K.s.Vg(b,2*Math.PI)};K.s.uh=function(b){return b*Math.PI/180};K.s.zl=function(b){return 180*b/Math.PI};
K.s.mp=function(b,c){return c*Math.cos(K.s.uh(b))};K.s.np=function(b,c){return c*Math.sin(K.s.uh(b))};K.s.angle=function(b,c,d,e){return K.s.fe(K.s.zl(Math.atan2(e-c,d-b)))};K.s.lp=function(b,c){b=K.s.fe(c)-K.s.fe(b);180<b?b-=360:-180>=b&&(b=360+b);return b};K.s.sign=function(b){return 0<b?1:0>b?-1:b};
K.s.gs=function(b,c,d,e){d=d||function(b,c){return b==c};e=e||function(c){return b[c]};for(var f=b.length,g=c.length,h=[],l=0;l<f+1;l++)h[l]=[],h[l][0]=0;for(var m=0;m<g+1;m++)h[0][m]=0;for(l=1;l<=f;l++)for(m=1;m<=g;m++)d(b[l-1],c[m-1])?h[l][m]=h[l-1][m-1]+1:h[l][m]=Math.max(h[l-1][m],h[l][m-1]);var q=[];l=f;for(m=g;0<l&&0<m;)d(b[l-1],c[m-1])?(q.unshift(e(l-1,m-1)),l--,m--):h[l-1][m]>h[l][m-1]?l--:m--;return q};K.s.ge=function(b){return K.j.reduce(arguments,function(b,d){return b+d},0)};
K.s.Pi=function(b){return K.s.ge.apply(null,arguments)/arguments.length};K.s.hl=function(b){var c=arguments.length;if(2>c)return 0;var d=K.s.Pi.apply(null,arguments);return K.s.ge.apply(null,K.j.map(arguments,function(b){return Math.pow(b-d,2)}))/(c-1)};K.s.Bt=function(b){return Math.sqrt(K.s.hl.apply(null,arguments))};K.s.Hr=function(b){return isFinite(b)&&0==b%1};K.s.Fr=function(b){return isFinite(b)};K.s.Mr=function(b){return 0==b&&0>1/b};
K.s.fs=function(b){if(0<b){var c=Math.round(Math.log(b)*Math.LOG10E);return c-(parseFloat("1e"+c)>b?1:0)}return 0==b?-Infinity:NaN};K.s.Vs=function(b,c){return Math.floor(b+(c||2E-15))};K.s.Us=function(b,c){return Math.ceil(b-(c||2E-15))};K.s.W=function(b,c){this.x=K.R(b)?b:0;this.y=K.R(c)?c:0};K.s.W.prototype.clone=function(){return new K.s.W(this.x,this.y)};K.ea&&(K.s.W.prototype.toString=function(){return"("+this.x+", "+this.y+")"});K.s.W.prototype.Ib=function(b){return b instanceof K.s.W&&K.s.W.Ib(this,b)};K.s.W.Ib=function(b,c){return b==c?!0:b&&c?b.x==c.x&&b.y==c.y:!1};K.s.W.vq=function(b,c){var d=b.x-c.x;b=b.y-c.y;return Math.sqrt(d*d+b*b)};K.s.W.hs=function(b){return Math.sqrt(b.x*b.x+b.y*b.y)};
K.s.W.azimuth=function(b){return K.s.angle(0,0,b.x,b.y)};K.s.W.yt=function(b,c){var d=b.x-c.x;b=b.y-c.y;return d*d+b*b};K.s.W.uq=function(b,c){return new K.s.W(b.x-c.x,b.y-c.y)};K.s.W.ge=function(b,c){return new K.s.W(b.x+c.x,b.y+c.y)};I=K.s.W.prototype;I.ceil=function(){this.x=Math.ceil(this.x);this.y=Math.ceil(this.y);return this};I.floor=function(){this.x=Math.floor(this.x);this.y=Math.floor(this.y);return this};I.round=function(){this.x=Math.round(this.x);this.y=Math.round(this.y);return this};
I.translate=function(b,c){b instanceof K.s.W?(this.x+=b.x,this.y+=b.y):(this.x+=Number(b),K.Rb(c)&&(this.y+=c));return this};I.scale=function(b,c){c=K.Rb(c)?c:b;this.x*=b;this.y*=c;return this};K.s.nb=function(b,c){this.width=b;this.height=c};K.s.nb.Ib=function(b,c){return b==c?!0:b&&c?b.width==c.width&&b.height==c.height:!1};K.s.nb.prototype.clone=function(){return new K.s.nb(this.width,this.height)};K.ea&&(K.s.nb.prototype.toString=function(){return"("+this.width+" x "+this.height+")"});I=K.s.nb.prototype;I.Li=function(){return this.width*this.height};I.aspectRatio=function(){return this.width/this.height};I.Qb=function(){return!this.Li()};
I.ceil=function(){this.width=Math.ceil(this.width);this.height=Math.ceil(this.height);return this};I.floor=function(){this.width=Math.floor(this.width);this.height=Math.floor(this.height);return this};I.round=function(){this.width=Math.round(this.width);this.height=Math.round(this.height);return this};I.scale=function(b,c){c=K.Rb(c)?c:b;this.width*=b;this.height*=c;return this};K.a.Hh=!1;K.a.se=!1;K.a.Qh=K.a.Hh||K.a.se;K.a.td=function(b){return b?new K.a.lb(K.a.Qa(b)):K.a.mj||(K.a.mj=new K.a.lb)};K.a.Dj=function(){return document};K.a.ud=function(b){return K.a.xd(document,b)};K.a.xd=function(b,c){return K.L(c)?b.getElementById(c):c};K.a.Lj=function(b){return K.a.ig(document,b)};K.a.ig=function(b,c){return K.a.xd(b,c)};K.a.Bh=K.a.ud;K.a.getElementsByTagName=function(b,c){return(c||document).getElementsByTagName(String(b))};
K.a.yd=function(b,c,d){return K.a.nc(document,b,c,d)};K.a.Gj=function(b,c,d){return K.a.wd(document,b,c,d)};K.a.Rf=function(b,c){var d=c||document;return K.a.cd(d)?d.querySelectorAll("."+b):K.a.nc(document,"*",b,c)};K.a.vd=function(b,c){var d=c||document;return(d.getElementsByClassName?d.getElementsByClassName(b)[0]:K.a.wd(document,"*",b,c))||null};K.a.hg=function(b,c){return K.a.vd(b,c)};K.a.cd=function(b){return!(!b.querySelectorAll||!b.querySelector)};
K.a.nc=function(b,c,d,e){b=e||b;c=c&&"*"!=c?String(c).toUpperCase():"";if(K.a.cd(b)&&(c||d))return b.querySelectorAll(c+(d?"."+d:""));if(d&&b.getElementsByClassName){b=b.getElementsByClassName(d);if(c){e={};for(var f=0,g=0,h;h=b[g];g++)c==h.nodeName&&(e[f++]=h);e.length=f;return e}return b}b=b.getElementsByTagName(c||"*");if(d){e={};for(g=f=0;h=b[g];g++)c=h.className,typeof c.split==u&&K.j.contains(c.split(/\s+/),d)&&(e[f++]=h);e.length=f;return e}return b};
K.a.wd=function(b,c,d,e){var f=e||b,g=c&&"*"!=c?String(c).toUpperCase():"";return K.a.cd(f)&&(g||d)?f.querySelector(g+(d?"."+d:"")):K.a.nc(b,c,d,e)[0]||null};K.a.Ch=K.a.yd;K.a.Jc=function(b,c){K.object.forEach(c,function(c,e){c&&c.ua&&(c=c.ga());"style"==e?b.style.cssText=c:"class"==e?b.className=c:"for"==e?b.htmlFor=c:K.a.Be.hasOwnProperty(e)?b.setAttribute(K.a.Be[e],c):K.f.startsWith(e,"aria-")||K.f.startsWith(e,"data-")?b.setAttribute(e,c):b[e]=c})};
K.a.Be={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};K.a.mg=function(b){return K.a.ng(b||window)};K.a.ng=function(b){b=b.document;b=K.a.Ob(b)?b.documentElement:b.body;return new K.s.nb(b.clientWidth,b.clientHeight)};K.a.Ej=function(){return K.a.rd(window)};K.a.Xq=function(b){return K.a.rd(b)};
K.a.rd=function(b){var c=b.document,d=0;if(c){d=c.body;var e=c.documentElement;if(!e||!d)return 0;b=K.a.ng(b).height;if(K.a.Ob(c)&&e.scrollHeight)d=e.scrollHeight!=b?e.scrollHeight:e.offsetHeight;else{c=e.scrollHeight;var f=e.offsetHeight;e.clientHeight!=f&&(c=d.scrollHeight,f=d.offsetHeight);d=c>b?c>f?c:f:c<f?c:f}}return d};K.a.dr=function(b){return K.a.td((b||K.global||window).document).Pf()};K.a.Pf=function(){return K.a.Qf(document)};
K.a.Qf=function(b){var c=K.a.sd(b);b=K.a.qc(b);return K.userAgent.Y&&K.userAgent.va("10")&&b.pageYOffset!=c.scrollTop?new K.s.W(c.scrollLeft,c.scrollTop):new K.s.W(b.pageXOffset||c.scrollLeft,b.pageYOffset||c.scrollTop)};K.a.Fj=function(){return K.a.sd(document)};K.a.sd=function(b){return b.scrollingElement?b.scrollingElement:!K.userAgent.Cb&&K.a.Ob(b)?b.documentElement:b.body||b.documentElement};K.a.tb=function(b){return b?K.a.qc(b):window};K.a.qc=function(b){return b.parentWindow||b.defaultView};
K.a.fd=function(b,c,d){return K.a.sf(document,arguments)};K.a.sf=function(b,c){var d=String(c[0]),e=c[1];if(!K.a.ib.Lh&&e&&(e.name||e.type)){d=["<",d];e.name&&d.push(' name="',K.f.ta(e.name),'"');if(e.type){d.push(' type="',K.f.ta(e.type),'"');var f={};K.object.extend(f,e);delete f.type;e=f}d.push(">");d=d.join("")}d=b.createElement(d);e&&(K.L(e)?d.className=e:K.isArray(e)?d.className=e.join(" "):K.a.Jc(d,e));2<c.length&&K.a.bf(b,d,c,2);return d};
K.a.bf=function(b,c,d,e){function f(d){d&&c.appendChild(K.L(d)?b.createTextNode(d):d)}for(;e<d.length;e++){var g=d[e];K.Nb(g)&&!K.a.Ld(g)?K.j.forEach(K.a.Md(g)?K.j.th(g):g,f):f(g)}};K.a.Dh=K.a.fd;K.a.createElement=function(b){return K.a.Oa(document,b)};K.a.Oa=function(b,c){return b.createElement(String(c))};K.a.createTextNode=function(b){return document.createTextNode(String(b))};K.a.hj=function(b,c,d){return K.a.tf(document,b,c,!!d)};
K.a.tf=function(b,c,d,e){for(var f=K.a.Oa(b,"TABLE"),g=f.appendChild(K.a.Oa(b,"TBODY")),h=0;h<c;h++){for(var l=K.a.Oa(b,"TR"),m=0;m<d;m++){var q=K.a.Oa(b,"TD");e&&K.a.ae(q,K.f.Ye.Ke);l.appendChild(q)}g.appendChild(l)}return f};K.a.eq=function(b){var c=K.j.map(arguments,K.f.I.u);c=K.b.hb.fl(K.f.I.from("Constant HTML string, that gets turned into a Node later, so it will be automatically balanced."),c.join(""));return K.a.eh(c)};K.a.eh=function(b){return K.a.fh(document,b)};
K.a.fh=function(b,c){var d=K.a.Oa(b,"DIV");K.a.ib.ci?(K.a.S.lh(d,K.b.l.concat(K.b.l.we,c)),d.removeChild(d.firstChild)):K.a.S.lh(d,c);return K.a.$i(b,d)};K.a.$i=function(b,c){if(1==c.childNodes.length)return c.removeChild(c.firstChild);for(b=b.createDocumentFragment();c.firstChild;)b.appendChild(c.firstChild);return b};K.a.dk=function(){return K.a.Ob(document)};K.a.Ob=function(b){return K.a.Qh?K.a.se:"CSS1Compat"==b.compatMode};K.a.canHaveChildren=function(b){if(b.nodeType!=K.a.fa.Ia)return!1;switch(b.tagName){case "APPLET":case "AREA":case "BASE":case "BR":case "COL":case "COMMAND":case "EMBED":case "FRAME":case "HR":case "IMG":case "INPUT":case "IFRAME":case "ISINDEX":case "KEYGEN":case "LINK":case "NOFRAMES":case "NOSCRIPT":case "META":case "OBJECT":case "PARAM":case p:case "SOURCE":case "STYLE":case "TRACK":case "WBR":return!1}return!0};
K.a.appendChild=function(b,c){b.appendChild(c)};K.a.append=function(b,c){K.a.bf(K.a.Qa(b),b,arguments,1)};K.a.Zd=function(b){for(var c;c=b.firstChild;)b.removeChild(c)};K.a.vg=function(b,c){c.parentNode&&c.parentNode.insertBefore(b,c)};K.a.ug=function(b,c){c.parentNode&&c.parentNode.insertBefore(b,c.nextSibling)};K.a.tg=function(b,c,d){b.insertBefore(c,b.childNodes[d]||null)};K.a.removeNode=function(b){return b&&b.parentNode?b.parentNode.removeChild(b):null};
K.a.dh=function(b,c){var d=c.parentNode;d&&d.replaceChild(b,c)};K.a.Ff=function(b){var c,d=b.parentNode;if(d&&d.nodeType!=K.a.fa.Vh){if(b.removeNode)return b.removeNode(!1);for(;c=b.firstChild;)d.insertBefore(c,b);return K.a.removeNode(b)}};K.a.Nf=function(b){return K.a.ib.Mh&&void 0!=b.children?b.children:K.j.filter(b.childNodes,function(b){return b.nodeType==K.a.fa.Ia})};K.a.Sf=function(b){return K.R(b.firstElementChild)?b.firstElementChild:K.a.oc(b.firstChild,!0)};
K.a.Wf=function(b){return K.R(b.lastElementChild)?b.lastElementChild:K.a.oc(b.lastChild,!1)};K.a.Zf=function(b){return K.R(b.nextElementSibling)?b.nextElementSibling:K.a.oc(b.nextSibling,!0)};K.a.fg=function(b){return K.R(b.previousElementSibling)?b.previousElementSibling:K.a.oc(b.previousSibling,!1)};K.a.oc=function(b,c){for(;b&&b.nodeType!=K.a.fa.Ia;)b=c?b.nextSibling:b.previousSibling;return b};
K.a.$f=function(b){if(!b)return null;if(b.firstChild)return b.firstChild;for(;b&&!b.nextSibling;)b=b.parentNode;return b?b.nextSibling:null};K.a.gg=function(b){if(!b)return null;if(!b.previousSibling)return b.parentNode;for(b=b.previousSibling;b&&b.lastChild;)b=b.lastChild;return b};K.a.Ld=function(b){return K.ha(b)&&0<b.nodeType};K.a.Hd=function(b){return K.ha(b)&&b.nodeType==K.a.fa.Ia};K.a.Ng=function(b){return K.ha(b)&&b.window==b};
K.a.eg=function(b){var c;if(K.a.ib.Nh&&!(K.userAgent.Y&&K.userAgent.va("9")&&!K.userAgent.va("10")&&K.global.SVGElement&&b instanceof K.global.SVGElement)&&(c=b.parentElement))return c;c=b.parentNode;return K.a.Hd(c)?c:null};K.a.contains=function(b,c){if(!b||!c)return!1;if(b.contains&&c.nodeType==K.a.fa.Ia)return b==c||b.contains(c);if("undefined"!=typeof b.compareDocumentPosition)return b==c||!!(b.compareDocumentPosition(c)&16);for(;c&&b!=c;)c=c.parentNode;return c==b};
K.a.mf=function(b,c){if(b==c)return 0;if(b.compareDocumentPosition)return b.compareDocumentPosition(c)&2?1:-1;if(K.userAgent.Y&&!K.userAgent.Pb(9)){if(b.nodeType==K.a.fa.Xc)return-1;if(c.nodeType==K.a.fa.Xc)return 1}if("sourceIndex"in b||b.parentNode&&"sourceIndex"in b.parentNode){var d=b.nodeType==K.a.fa.Ia,e=c.nodeType==K.a.fa.Ia;if(d&&e)return b.sourceIndex-c.sourceIndex;var f=b.parentNode,g=c.parentNode;return f==g?K.a.pf(b,c):!d&&K.a.contains(f,c)?-1*K.a.nf(b,c):!e&&K.a.contains(g,b)?K.a.nf(c,
b):(d?b.sourceIndex:f.sourceIndex)-(e?c.sourceIndex:g.sourceIndex)}e=K.a.Qa(b);d=e.createRange();d.selectNode(b);d.collapse(!0);b=e.createRange();b.selectNode(c);b.collapse(!0);return d.compareBoundaryPoints(K.global.Range.START_TO_END,b)};K.a.nf=function(b,c){var d=b.parentNode;if(d==c)return-1;for(;c.parentNode!=d;)c=c.parentNode;return K.a.pf(c,b)};K.a.pf=function(b,c){for(;c=c.previousSibling;)if(c==b)return-1;return 1};
K.a.Bf=function(b){var c,d=arguments.length;if(!d)return null;if(1==d)return arguments[0];var e=[],f=Infinity;for(c=0;c<d;c++){for(var g=[],h=arguments[c];h;)g.unshift(h),h=h.parentNode;e.push(g);f=Math.min(f,g.length)}g=null;for(c=0;c<f;c++){h=e[0][c];for(var l=1;l<d;l++)if(h!=e[l][c])return g;g=h}return g};K.a.Qa=function(b){return b.nodeType==K.a.fa.Xc?b:b.ownerDocument||b.document};K.a.Tf=function(b){return b.contentDocument||b.contentWindow.document};
K.a.Uf=function(b){try{return b.contentWindow||(b.contentDocument?K.a.tb(b.contentDocument):null)}catch(c){}return null};K.a.ae=function(b,c){if("textContent"in b)b.textContent=c;else if(b.nodeType==K.a.fa.cc)b.data=String(c);else if(b.firstChild&&b.firstChild.nodeType==K.a.fa.cc){for(;b.lastChild!=b.firstChild;)b.removeChild(b.lastChild);b.firstChild.data=String(c)}else{K.a.Zd(b);var d=K.a.Qa(b);b.appendChild(d.createTextNode(String(c)))}};
K.a.dg=function(b){if("outerHTML"in b)return b.outerHTML;var c=K.a.Qa(b);c=K.a.Oa(c,"DIV");c.appendChild(b.cloneNode(!0));return c.innerHTML};K.a.Cf=function(b,c){var d=[];return K.a.nd(b,c,d,!0)?d[0]:void 0};K.a.Df=function(b,c){var d=[];K.a.nd(b,c,d,!1);return d};K.a.nd=function(b,c,d,e){if(null!=b)for(b=b.firstChild;b;){if(c(b)&&(d.push(b),e)||K.a.nd(b,c,d,e))return!0;b=b.nextSibling}return!1};K.a.Ue={SCRIPT:1,STYLE:1,HEAD:1,IFRAME:1,OBJECT:1};K.a.ac={IMG:" ",BR:"\n"};
K.a.Jd=function(b){return K.a.pg(b)&&K.a.Lg(b)};K.a.jh=function(b,c){c?b.tabIndex=0:(b.tabIndex=-1,b.removeAttribute("tabIndex"))};K.a.Cg=function(b){var c;return(c=K.a.Qk(b)?!b.disabled&&(!K.a.pg(b)||K.a.Lg(b)):K.a.Jd(b))&&K.userAgent.Y?K.a.Wj(b):c};K.a.pg=function(b){return K.userAgent.Y&&!K.userAgent.va("9")?(b=b.getAttributeNode("tabindex"),K.cb(b)&&b.specified):b.hasAttribute("tabindex")};K.a.Lg=function(b){b=b.tabIndex;return K.Rb(b)&&0<=b&&32768>b};
K.a.Qk=function(b){return"A"==b.tagName||"INPUT"==b.tagName||"TEXTAREA"==b.tagName||"SELECT"==b.tagName||"BUTTON"==b.tagName};K.a.Wj=function(b){b=!K.ya(b.getBoundingClientRect)||K.userAgent.Y&&null==b.parentElement?{height:b.offsetHeight,width:b.offsetWidth}:b.getBoundingClientRect();return K.cb(b)&&0<b.height&&0<b.width};
K.a.pc=function(b){if(K.a.ib.xe&&null!==b&&"innerText"in b)b=K.f.Yi(b.innerText);else{var c=[];K.a.Ad(b,c,!0);b=c.join("")}b=b.replace(/ \xAD /g," ").replace(/\xAD/g,"");b=b.replace(/\u200B/g,"");K.a.ib.xe||(b=b.replace(/ +/g," "));" "!=b&&(b=b.replace(/^\s*/,""));return b};K.a.gr=function(b){var c=[];K.a.Ad(b,c,!1);return c.join("")};
K.a.Ad=function(b,c,d){if(!(b.nodeName in K.a.Ue))if(b.nodeType==K.a.fa.cc)d?c.push(String(b.nodeValue).replace(/(\r\n|\r|\n)/g,"")):c.push(b.nodeValue);else if(b.nodeName in K.a.ac)c.push(K.a.ac[b.nodeName]);else for(b=b.firstChild;b;)K.a.Ad(b,c,d),b=b.nextSibling};K.a.bg=function(b){return K.a.pc(b).length};K.a.cg=function(b,c){c=c||K.a.Qa(b).body;for(var d=[];b&&b!=c;){for(var e=b;e=e.previousSibling;)d.unshift(K.a.pc(e));b=b.parentNode}return K.f.trimLeft(d.join("")).replace(/ +/g," ").length};
K.a.ag=function(b,c,d){b=[b];for(var e=0,f=null;0<b.length&&e<c;)if(f=b.pop(),!(f.nodeName in K.a.Ue))if(f.nodeType==K.a.fa.cc){var g=f.nodeValue.replace(/(\r\n|\r|\n)/g,"").replace(/ +/g," ");e+=g.length}else if(f.nodeName in K.a.ac)e+=K.a.ac[f.nodeName].length;else for(g=f.childNodes.length-1;0<=g;g--)b.push(f.childNodes[g]);K.ha(d)&&(d.Is=f?f.nodeValue.length+c-e-1:0,d.node=f);return f};
K.a.Md=function(b){if(b&&typeof b.length==x){if(K.ha(b))return typeof b.item==u||typeof b.item==B;if(K.ya(b))return typeof b.item==u}return!1};K.a.qd=function(b,c,d,e){if(!c&&!d)return null;var f=c?String(c).toUpperCase():null;return K.a.pd(b,function(b){return(!f||b.nodeName==f)&&(!d||K.L(b.className)&&K.j.contains(b.className.split(/\s+/),d))},!0,e)};K.a.Kf=function(b,c,d){return K.a.qd(b,null,c,d)};
K.a.pd=function(b,c,d,e){b&&!d&&(b=b.parentNode);for(d=0;b&&(null==e||d<=e);){if(c(b))return b;b=b.parentNode;d++}return null};K.a.Jf=function(b){try{return b&&b.activeElement}catch(c){}return null};K.a.er=function(){var b=K.a.tb();return K.R(b.devicePixelRatio)?b.devicePixelRatio:b.matchMedia?K.a.wc(3)||K.a.wc(2)||K.a.wc(1.5)||K.a.wc(1)||.75:1};
K.a.wc=function(b){return K.a.tb().matchMedia("(min-resolution: "+b+"dppx),(min--moz-device-pixel-ratio: "+b+"),(min-resolution: "+96*b+"dpi)").matches?b:0};K.a.Mf=function(b){return b.getContext("2d")};K.a.lb=function(b){this.X=b||K.global.document||document};I=K.a.lb.prototype;I.td=K.a.td;I.Dj=G("X");I.ud=function(b){return K.a.xd(this.X,b)};I.Lj=function(b){return K.a.ig(this.X,b)};I.Bh=K.a.lb.prototype.ud;I.getElementsByTagName=function(b,c){return(c||this.X).getElementsByTagName(String(b))};
I.yd=function(b,c,d){return K.a.nc(this.X,b,c,d)};I.Gj=function(b,c,d){return K.a.wd(this.X,b,c,d)};I.Rf=function(b,c){return K.a.Rf(b,c||this.X)};I.vd=function(b,c){return K.a.vd(b,c||this.X)};I.hg=function(b,c){return K.a.hg(b,c||this.X)};I.Ch=K.a.lb.prototype.yd;I.Jc=K.a.Jc;I.mg=function(b){return K.a.mg(b||this.tb())};I.Ej=function(){return K.a.rd(this.tb())};I.fd=function(b,c,d){return K.a.sf(this.X,arguments)};I.Dh=K.a.lb.prototype.fd;I.createElement=function(b){return K.a.Oa(this.X,b)};
I.createTextNode=function(b){return this.X.createTextNode(String(b))};I.hj=function(b,c,d){return K.a.tf(this.X,b,c,!!d)};I.eh=function(b){return K.a.fh(this.X,b)};I.dk=function(){return K.a.Ob(this.X)};I.tb=function(){return K.a.qc(this.X)};I.Fj=function(){return K.a.sd(this.X)};I.Pf=function(){return K.a.Qf(this.X)};I.Jf=function(b){return K.a.Jf(b||this.X)};I.appendChild=K.a.appendChild;I.append=K.a.append;I.canHaveChildren=K.a.canHaveChildren;I.Zd=K.a.Zd;I.vg=K.a.vg;I.ug=K.a.ug;I.tg=K.a.tg;
I.removeNode=K.a.removeNode;I.dh=K.a.dh;I.Ff=K.a.Ff;I.Nf=K.a.Nf;I.Sf=K.a.Sf;I.Wf=K.a.Wf;I.Zf=K.a.Zf;I.fg=K.a.fg;I.$f=K.a.$f;I.gg=K.a.gg;I.Ld=K.a.Ld;I.Hd=K.a.Hd;I.Ng=K.a.Ng;I.eg=K.a.eg;I.contains=K.a.contains;I.mf=K.a.mf;I.Bf=K.a.Bf;I.Qa=K.a.Qa;I.Tf=K.a.Tf;I.Uf=K.a.Uf;I.ae=K.a.ae;I.dg=K.a.dg;I.Cf=K.a.Cf;I.Df=K.a.Df;I.Jd=K.a.Jd;I.jh=K.a.jh;I.Cg=K.a.Cg;I.pc=K.a.pc;I.bg=K.a.bg;I.cg=K.a.cg;I.ag=K.a.ag;I.Md=K.a.Md;I.qd=K.a.qd;I.Kf=K.a.Kf;I.pd=K.a.pd;I.Mf=K.a.Mf;K.bh={};K.bh.to=F();K.Thenable=F();K.Thenable.prototype.then=F();K.Thenable.He="$goog_Thenable";K.Thenable.af=function(b){b.prototype.then=b.prototype.then;b.prototype[K.Thenable.He]=!0};K.Thenable.Dg=function(b){if(!b)return!1;try{return!!b[K.Thenable.He]}catch(c){return!1}};K.Promise=function(b,c){this.$=K.Promise.P.wa;this.ia=void 0;this.ob=this.Na=this.da=null;this.ld=!1;0<K.Promise.Wa?this.Oc=0:0==K.Promise.Wa&&(this.rc=!1);K.Promise.Aa&&(this.ee=[],N(this,Error("created")),this.vf=0);if(b!=K.eb)try{var d=this;b.call(c,function(b){O(d,K.Promise.P.Ja,b)},function(b){if(K.ea&&!(b instanceof K.Promise.kb))try{if(b instanceof Error)throw b;throw Error("Promise rejected.");}catch(f){}O(d,K.Promise.P.ka,b)})}catch(e){O(this,K.Promise.P.ka,e)}};K.Promise.Aa=!1;
K.Promise.Wa=0;K.Promise.P={wa:0,Jh:1,Ja:2,ka:3};K.Promise.ze=function(){this.next=this.context=this.wb=this.Tb=this.Xa=null;this.dc=!1};K.Promise.ze.prototype.reset=function(){this.context=this.wb=this.Tb=this.Xa=null;this.dc=!1};K.Promise.Vc=100;K.Promise.Kb=new K.async.Zb(function(){return new K.Promise.ze},function(b){b.reset()},K.Promise.Vc);K.Promise.Lf=function(b,c,d){var e=K.Promise.Kb.get();e.Tb=b;e.wb=c;e.context=d;return e};K.Promise.Yk=function(b){K.Promise.Kb.put(b)};
K.Promise.resolve=function(b){if(b instanceof K.Promise)return b;var c=new K.Promise(K.eb);O(c,K.Promise.P.Ja,b);return c};K.Promise.reject=function(b){return new K.Promise(function(c,d){d(b)})};K.Promise.Ec=function(b,c,d){K.Promise.Ug(b,c,d,null)||K.async.M(K.fb(c,b))};K.Promise.race=function(b){return new K.Promise(function(c,d){b.length||c(void 0);for(var e=0,f;e<b.length;e++)f=b[e],K.Promise.Ec(f,c,d)})};
K.Promise.all=function(b){return new K.Promise(function(c,d){var e=b.length,f=[];if(e)for(var g=function(b,d){e--;f[b]=d;0==e&&c(f)},h=function(b){d(b)},l=0,m;l<b.length;l++)m=b[l],K.Promise.Ec(m,K.fb(g,l),h);else c(f)})};K.Promise.jp=function(b){return new K.Promise(function(c){var d=b.length,e=[];if(d)for(var f=function(b,f,g){d--;e[b]=f?{Bj:!0,value:g}:{Bj:!1,reason:g};0==d&&c(e)},g=0,h;g<b.length;g++)h=b[g],K.Promise.Ec(h,K.fb(f,g,!0),K.fb(f,g,!1));else c(e)})};
K.Promise.Iq=function(b){return new K.Promise(function(c,d){var e=b.length,f=[];if(e)for(var g=function(b){c(b)},h=function(b,c){e--;f[b]=c;0==e&&d(f)},l=0,m;l<b.length;l++)m=b[l],K.Promise.Ec(m,g,K.fb(h,l));else c(void 0)})};K.Promise.Wt=function(){var b,c,d=new K.Promise(function(d,f){b=d;c=f});return new K.Promise.li(d,b,c)};K.Promise.prototype.then=function(b,c,d){K.Promise.Aa&&N(this,Error("then"));return ba(this,K.ya(b)?b:null,K.ya(c)?c:null,d)};K.Thenable.af(K.Promise);
K.Promise.prototype.cancel=function(b){this.$==K.Promise.P.wa&&K.async.M(function(){var c=new K.Promise.kb(b);P(this,c)},this)};function P(b,c){if(b.$==K.Promise.P.wa)if(b.da){var d=b.da;if(d.Na){for(var e=0,f=null,g=null,h=d.Na;h&&(h.dc||(e++,h.Xa==b&&(f=h),!(f&&1<e)));h=h.next)f||(g=h);f&&(d.$==K.Promise.P.wa&&1==e?P(d,c):(g?(e=g,e.next==d.ob&&(d.ob=e),e.next=e.next.next):Q(d),R(d,f,K.Promise.P.ka,c)))}b.da=null}else O(b,K.Promise.P.ka,c)}
function S(b,c){b.Na||b.$!=K.Promise.P.Ja&&b.$!=K.Promise.P.ka||T(b);b.ob?b.ob.next=c:b.Na=c;b.ob=c}function ba(b,c,d,e){var f=K.Promise.Lf(null,null,null);f.Xa=new K.Promise(function(b,h){f.Tb=c?function(d){try{var f=c.call(e,d);b(f)}catch(q){h(q)}}:b;f.wb=d?function(c){try{var f=d.call(e,c);!K.R(f)&&c instanceof K.Promise.kb?h(c):b(f)}catch(q){h(q)}}:h});f.Xa.da=b;S(b,f);return f.Xa}K.Promise.prototype.Dl=function(b){this.$=K.Promise.P.wa;O(this,K.Promise.P.Ja,b)};
K.Promise.prototype.El=function(b){this.$=K.Promise.P.wa;O(this,K.Promise.P.ka,b)};function O(b,c,d){b.$==K.Promise.P.wa&&(b===d&&(c=K.Promise.P.ka,d=new TypeError("Promise cannot resolve to itself")),b.$=K.Promise.P.Jh,K.Promise.Ug(d,b.Dl,b.El,b)||(b.ia=d,b.$=c,b.da=null,T(b),c!=K.Promise.P.ka||d instanceof K.Promise.kb||K.Promise.Ii(b,d)))}
K.Promise.Ug=function(b,c,d,e){if(b instanceof K.Promise)return K.Promise.Aa&&N(b,Error("then")),S(b,K.Promise.Lf(c||K.eb,d||null,e)),!0;if(K.Thenable.Dg(b))return b.then(c,d,e),!0;if(K.ha(b))try{var f=b.then;if(K.ya(f))return K.Promise.Bl(b,f,c,d,e),!0}catch(g){return d.call(e,g),!0}return!1};K.Promise.Bl=function(b,c,d,e,f){function g(b){l||(l=!0,e.call(f,b))}function h(b){l||(l=!0,d.call(f,b))}var l=!1;try{c.call(b,h,g)}catch(m){g(m)}};function T(b){b.ld||(b.ld=!0,K.async.M(b.vj,b))}
function Q(b){var c=null;b.Na&&(c=b.Na,b.Na=c.next,c.next=null);b.Na||(b.ob=null);return c}K.Promise.prototype.vj=function(){for(var b;b=Q(this);)K.Promise.Aa&&this.vf++,R(this,b,this.$,this.ia);this.ld=!1};
function R(b,c,d,e){if(d==K.Promise.P.ka&&c.wb&&!c.dc)if(0<K.Promise.Wa)for(;b&&b.Oc;b=b.da)K.global.clearTimeout(b.Oc),b.Oc=0;else if(0==K.Promise.Wa)for(;b&&b.rc;b=b.da)b.rc=!1;if(c.Xa)c.Xa.da=null,K.Promise.xg(c,d,e);else try{c.dc?c.Tb.call(c.context):K.Promise.xg(c,d,e)}catch(f){K.Promise.sc.call(null,f)}K.Promise.Yk(c)}K.Promise.xg=function(b,c,d){c==K.Promise.P.Ja?b.Tb.call(b.context,d):b.wb&&b.wb.call(b.context,d)};
function N(b,c){if(K.Promise.Aa&&K.L(c.stack)){var d=c.stack.split("\n",4)[3];c=c.message;c+=Array(11-c.length).join(" ");b.ee.push(c+d)}}function U(b,c){if(K.Promise.Aa&&c&&K.L(c.stack)&&b.ee.length){for(var d=["Promise trace:"],e=b;e;e=e.da){for(var f=b.vf;0<=f;f--)d.push(e.ee[f]);d.push("Value: ["+(e.$==K.Promise.P.ka?"REJECTED":"FULFILLED")+"] <"+String(e.ia)+">")}c.stack+="\n\n"+d.join("\n")}}
K.Promise.Ii=function(b,c){0<K.Promise.Wa?b.Oc=K.global.setTimeout(function(){U(b,c);K.Promise.sc.call(null,c)},K.Promise.Wa):0==K.Promise.Wa&&(b.rc=!0,K.async.M(function(){b.rc&&(U(b,c),K.Promise.sc.call(null,c))}))};K.Promise.sc=K.async.qh;K.Promise.st=function(b){K.Promise.sc=b};K.Promise.kb=function(b){K.debug.Error.call(this,b)};K.ab(K.Promise.kb,K.debug.Error);K.Promise.kb.prototype.name="cancel";K.Promise.li=function(b,c,d){this.bh=b;this.resolve=c;this.reject=d};/*
 Portions of this code are from MochiKit, received by
 The Closure Authors under the MIT license. All other code is Copyright
 2005-2009 The Closure Authors. All Rights Reserved.
*/
K.async.w=function(b,c){this.Ic=[];this.ah=b;this.wf=c||null;this.ub=this.qb=!1;this.ia=void 0;this.be=this.Ti=this.bd=!1;this.Nc=0;this.da=null;this.ec=0;K.async.w.Aa&&(this.ed=null,Error.captureStackTrace&&(b={stack:""},Error.captureStackTrace(b,K.async.w),typeof b.stack==B&&(this.ed=b.stack.replace(/^[^\n]*\n/,""))))};K.async.w.vi=!1;K.async.w.Aa=!1;I=K.async.w.prototype;
I.cancel=function(b){if(this.qb)this.ia instanceof K.async.w&&this.ia.cancel();else{if(this.da){var c=this.da;delete this.da;b?c.cancel(b):(c.ec--,0>=c.ec&&c.cancel())}this.ah?this.ah.call(this.wf,this):this.be=!0;this.qb||this.Za(new K.async.w.jb(this))}};I.rf=function(b,c){this.bd=!1;V(this,b,c)};function V(b,c,d){b.qb=!0;b.ia=d;b.ub=!c;W(b)}function X(b){if(b.qb){if(!b.be)throw new K.async.w.Wb(b);b.be=!1}}I.Db=function(b){X(this);V(this,!0,b)};I.Za=function(b){X(this);da(this,b);V(this,!1,b)};
function da(b,c){K.async.w.Aa&&b.ed&&K.ha(c)&&c.stack&&/^[^\n]+(\n   [^\n]+)+/.test(c.stack)&&(c.stack=c.stack+"\nDEFERRED OPERATION:\n"+b.ed)}function Y(b,c,d){return Z(b,c,null,d)}function ea(b,c){Z(b,null,c,void 0)}function Z(b,c,d,e){b.Ic.push([c,d,e]);b.qb&&W(b);return b}I.then=function(b,c,d){var e,f,g=new K.Promise(function(b,c){e=b;f=c});Z(this,e,function(b){b instanceof K.async.w.jb?g.cancel():f(b)});return g.then(b,c,d)};K.Thenable.af(K.async.w);
K.async.w.prototype.Vi=function(){var b=new K.async.w;Z(this,b.Db,b.Za,b);b.da=this;this.ec++;return b};function fa(b){return K.j.some(b.Ic,function(b){return K.ya(b[1])})}
function W(b){b.Nc&&b.qb&&fa(b)&&(K.async.w.Il(b.Nc),b.Nc=0);b.da&&(b.da.ec--,delete b.da);for(var c=b.ia,d=!1,e=!1;b.Ic.length&&!b.bd;){var f=b.Ic.shift(),g=f[0],h=f[1];f=f[2];if(g=b.ub?h:g)try{var l=g.call(f||b.wf,c);K.R(l)&&(b.ub=b.ub&&(l==c||l instanceof Error),b.ia=c=l);if(K.Thenable.Dg(c)||typeof K.global.Promise===u&&c instanceof K.global.Promise)e=!0,b.bd=!0}catch(m){c=m,b.ub=!0,da(b,c),fa(b)||(d=!0)}}b.ia=c;e?(e=K.bind(b.rf,b,!0),l=K.bind(b.rf,b,!1),c instanceof K.async.w?(Z(c,e,l),c.Ti=
!0):c.then(e,l)):K.async.w.vi&&c instanceof Error&&!(c instanceof K.async.w.jb)&&(d=b.ub=!0);d&&(b.Nc=K.async.w.kl(c))}K.async.w.oh=function(b){var c=new K.async.w;c.Db(b);return c};K.async.w.Pq=function(b){var c=new K.async.w;c.Db();Y(c,function(){return b});return c};K.async.w.ma=function(b){var c=new K.async.w;c.Za(b);return c};K.async.w.Qp=function(){var b=new K.async.w;b.cancel();return b};K.async.w.Vt=function(b,c,d){return b instanceof K.async.w?Y(b.Vi(),c,d):Y(K.async.w.oh(b),c,d)};
K.async.w.Wb=function(b){K.debug.Error.call(this);this.pb=b};K.ab(K.async.w.Wb,K.debug.Error);K.async.w.Wb.prototype.message="Deferred has already fired";K.async.w.Wb.prototype.name="AlreadyCalledError";K.async.w.jb=function(b){K.debug.Error.call(this);this.pb=b};K.ab(K.async.w.jb,K.debug.Error);K.async.w.jb.prototype.message="Deferred was canceled";K.async.w.jb.prototype.name="CanceledError";K.async.w.Fe=function(b){this.Mb=K.global.setTimeout(K.bind(this.ph,this),0);this.tj=b};
K.async.w.Fe.prototype.ph=function(){delete K.async.w.Jb[this.Mb];throw this.tj;};K.async.w.Jb={};K.async.w.kl=function(b){b=new K.async.w.Fe(b);K.async.w.Jb[b.Mb]=b;return b.Mb};K.async.w.Il=function(b){var c=K.async.w.Jb[b];c&&(K.global.clearTimeout(c.Mb),delete K.async.w.Jb[b])};K.async.w.Dp=function(){var b=K.async.w.Jb,c;for(c in b){var d=b[c];K.global.clearTimeout(d.Mb);d.ph()}};K.D={};K.D.F={};K.D.F.Zc="closure_verification";K.D.F.Th=5E3;K.D.F.$d=[];K.D.F.gl=function(b,c){function d(){var e=b.shift();e=K.D.F.Fc(e,c);b.length&&Z(e,d,d,void 0);return e}if(!b.length)return K.async.w.oh(null);var e=K.D.F.$d.length;K.j.extend(K.D.F.$d,b);if(e)return K.D.F.hh;b=K.D.F.$d;K.D.F.hh=d();return K.D.F.hh};
K.D.F.Fc=function(b,c){var d=c||{};c=d.document||document;var e=K.b.C.u(b),f=K.a.createElement(p),g={ih:f,sh:void 0},h=new K.async.w(K.D.F.Xi,g),l=null,m=K.cb(d.timeout)?d.timeout:K.D.F.Th;0<m&&(l=window.setTimeout(function(){K.D.F.gc(f,!0);h.Za(new K.D.F.Error(K.D.F.Yb.TIMEOUT,"Timeout reached for loading script "+e))},m),g.sh=l);f.onload=f.onreadystatechange=function(){f.readyState&&"loaded"!=f.readyState&&f.readyState!=t||(K.D.F.gc(f,d.Xp||!1,l),h.Db(null))};f.onerror=function(){K.D.F.gc(f,!0,
l);h.Za(new K.D.F.Error(K.D.F.Yb.ei,"Error while loading script "+e))};g=d.attributes||{};K.object.extend(g,{type:C,charset:"UTF-8"});K.a.Jc(f,g);K.a.S.ol(f,b);K.D.F.Mj(c).appendChild(f);return h};
K.D.F.Ws=function(b,c,d){K.global[K.D.F.Zc]||(K.global[K.D.F.Zc]={});var e=K.global[K.D.F.Zc],f=K.b.C.u(b);if(K.R(e[c]))return K.async.w.ma(new K.D.F.Error(K.D.F.Yb.Gi,"Verification object "+c+" already defined."));b=K.D.F.Fc(b,d);var g=new K.async.w(K.bind(b.cancel,b));Y(b,function(){var b=e[c];K.R(b)?(g.Db(b),delete e[c]):g.Za(new K.D.F.Error(K.D.F.Yb.Fi,"Script "+f+" loaded, but verification object "+c+" was not defined."))});ea(b,function(b){K.R(e[c])&&delete e[c];g.Za(b)});return g};
K.D.F.Mj=function(b){var c=K.a.getElementsByTagName("HEAD",b);return!c||K.j.Qb(c)?b.documentElement:c[0]};K.D.F.Xi=function(){if(this&&this.ih){var b=this.ih;b&&b.tagName==p&&K.D.F.gc(b,!0,this.sh)}};K.D.F.gc=function(b,c,d){K.cb(d)&&K.global.clearTimeout(d);b.onload=K.eb;b.onerror=K.eb;b.onreadystatechange=K.eb;c&&window.setTimeout(function(){K.a.removeNode(b)},0)};K.D.F.Yb={ei:0,TIMEOUT:1,Fi:2,Gi:3};
K.D.F.Error=function(b,c){var d="Jsloader error (code #"+b+")";c&&(d+=": "+c);K.debug.Error.call(this,d);this.code=b};K.ab(K.D.F.Error,K.debug.Error);var google={G:{}};google.G.H={};google.G.H.Ba={};google.G.H.Ba.rh=3E4;google.G.H.Ba.js=function(b,c){return{format:b,Mi:c}};google.G.H.Ba.Pj=function(b){return K.b.C.format(b.format,b.Mi)};google.G.H.Ba.load=function(b,c){b=K.b.C.format(b,c);var d=K.D.F.Fc(b,{timeout:google.G.H.Ba.rh,attributes:{async:!1,defer:!1}});return new Promise(function(b){Y(d,b)})};
google.G.H.Ba.cs=function(b){b=K.j.map(b,google.G.H.Ba.Pj);if(K.j.Qb(b))return Promise.resolve();var c={timeout:google.G.H.Ba.rh,attributes:{async:!1,defer:!1}},d=[];!K.userAgent.Y||K.userAgent.va(11)?K.j.forEach(b,function(b){d.push(K.D.F.Fc(b,c))}):d.push(K.D.F.gl(b,c));return Promise.all(K.j.map(d,function(b){return new Promise(function(c){return Y(b,c)})}))};google.G.H.T={};if(K.rb(v))throw Error("Google Charts loader.js can only be loaded once.");google.G.H.T.Nl={41:z,42:z,43:z,44:z,1:"1.0","1.0":"current","1.1":"upcoming",current:"45.2",upcoming:"46"};google.G.H.T.Kk=function(b){var c=b,d=b.match(/^testing-/);d&&(c=c.replace(/^testing-/,""));b=c;do{var e=google.G.H.T.Nl[c];e&&(c=e)}while(e);d=(d?"testing-":"")+c;return{version:c==z?b:d,Dk:d}};google.G.H.T.yh=null;
google.G.H.T.Bk=function(b){var c=google.G.H.T.Kk(b),d=K.f.I.from("https://www.gstatic.com/charts/%{version}/loader.js");return google.G.H.Ba.load(d,{version:c.Dk}).then(function(){var d=K.rb("google.charts.loader.VersionSpecific.load")||K.rb("google.charts.loader.publicLoad")||K.rb("google.charts.versionSpecific.load");if(!d)throw Error("Bad version: "+b);google.G.H.T.yh=function(b){b=d(c.version,b);if(null==b||null==b.then){var e=K.rb("google.charts.loader.publicSetOnLoadCallback")||K.rb("google.charts.versionSpecific.setOnLoadCallback");
b=new Promise(function(b){e(b)});b.then=e}return b}})};google.G.H.T.Pd=null;google.G.H.T.jc=null;google.G.H.T.yk=function(b,c){google.G.H.T.Pd||(google.G.H.T.Pd=google.G.H.T.Bk(b));return google.G.H.T.jc=google.G.H.T.Pd.then(function(){return google.G.H.T.yh(c)})};google.G.H.T.nl=function(b){if(!google.G.H.T.jc)throw Error("Must call google.charts.load before google.charts.setOnLoadCallback");return b?google.G.H.T.jc.then(b):google.G.H.T.jc};
google.G.load=function(b){for(var c=[],d=0;d<arguments.length;++d)c[d-0]=arguments[d];d=0;"visualization"===c[d]&&d++;var e="current";K.L(c[d])&&(e=c[d],d++);var f={};K.ha(c[d])&&(f=c[d]);return google.G.H.T.yk(e,f)};K.zf(v,google.G.load);google.G.ml=google.G.H.T.nl;K.zf("google.charts.setOnLoadCallback",google.G.ml);}).call(this);
/**
 * @author Eberhard Graether / http://egraether.com/
 * @author Mark Lundin 	/ http://mark-lundin.com
 * @author Simone Manini / http://daron1337.github.io
 * @author Luca Antiga 	/ http://lantiga.github.io
 */

THREE.TrackballControls = function ( object, domElement ) {
    
        var _this = this;
        var STATE = { NONE: - 1, ROTATE: 0, ZOOM: 1, PAN: 2, TOUCH_ROTATE: 3, TOUCH_ZOOM_PAN: 4 };
    
        this.object = object;
        this.domElement = ( domElement !== undefined ) ? domElement : document;
    
        // API
    
        this.enabled = true;
    
        this.screen = { left: 0, top: 0, width: 0, height: 0 };
    
        this.rotateSpeed = 1.0;
        this.zoomSpeed = 1.2;
        this.panSpeed = 0.3;
    
        this.noRotate = false;
        this.noZoom = false;
        this.noPan = false;
    
        this.staticMoving = false;
        this.dynamicDampingFactor = 0.2;
    
        this.minDistance = 0;
        this.maxDistance = Infinity;
    
        this.keys = [ 65 /*A*/, 83 /*S*/, 68 /*D*/ ];
    
        // internals
    
        this.target = new THREE.Vector3();
    
        var EPS = 0.000001;
    
        var lastPosition = new THREE.Vector3();
    
        var _state = STATE.NONE,
        _prevState = STATE.NONE,
    
        _eye = new THREE.Vector3(),
    
        _movePrev = new THREE.Vector2(),
        _moveCurr = new THREE.Vector2(),
    
        _lastAxis = new THREE.Vector3(),
        _lastAngle = 0,
    
        _zoomStart = new THREE.Vector2(),
        _zoomEnd = new THREE.Vector2(),
    
        _touchZoomDistanceStart = 0,
        _touchZoomDistanceEnd = 0,
    
        _panStart = new THREE.Vector2(),
        _panEnd = new THREE.Vector2();
    
        // for reset
    
        this.target0 = this.target.clone();
        this.position0 = this.object.position.clone();
        this.up0 = this.object.up.clone();
    
        // events
    
        var changeEvent = { type: 'change' };
        var startEvent = { type: 'start' };
        var endEvent = { type: 'end' };
    
    
        // methods
    
        this.handleResize = function () {
    
            if ( this.domElement === document ) {
    
                this.screen.left = 0;
                this.screen.top = 0;
                this.screen.width = window.innerWidth;
                this.screen.height = window.innerHeight;
    
            } else {
    
                var box = this.domElement.getBoundingClientRect();
                // adjustments come from similar code in the jquery offset() function
                var d = this.domElement.ownerDocument.documentElement;
                this.screen.left = box.left + window.pageXOffset - d.clientLeft;
                this.screen.top = box.top + window.pageYOffset - d.clientTop;
                this.screen.width = box.width;
                this.screen.height = box.height;
    
            }
    
        };
    
        this.handleEvent = function ( event ) {
    
            if ( typeof this[ event.type ] == 'function' ) {
    
                this[ event.type ]( event );
    
            }
    
        };
    
        var getMouseOnScreen = ( function () {
    
            var vector = new THREE.Vector2();
    
            return function getMouseOnScreen( pageX, pageY ) {
    
                vector.set(
                    ( pageX - _this.screen.left ) / _this.screen.width,
                    ( pageY - _this.screen.top ) / _this.screen.height
                );
    
                return vector;
    
            };
    
        }() );
    
        var getMouseOnCircle = ( function () {
    
            var vector = new THREE.Vector2();
    
            return function getMouseOnCircle( pageX, pageY ) {
    
                vector.set(
                    ( ( pageX - _this.screen.width * 0.5 - _this.screen.left ) / ( _this.screen.width * 0.5 ) ),
                    ( ( _this.screen.height + 2 * ( _this.screen.top - pageY ) ) / _this.screen.width ) // screen.width intentional
                );
    
                return vector;
    
            };
    
        }() );
    
        this.rotateCamera = ( function() {
    
            var axis = new THREE.Vector3(),
                quaternion = new THREE.Quaternion(),
                eyeDirection = new THREE.Vector3(),
                objectUpDirection = new THREE.Vector3(),
                objectSidewaysDirection = new THREE.Vector3(),
                moveDirection = new THREE.Vector3(),
                angle;
    
            return function rotateCamera() {
    
                moveDirection.set( _moveCurr.x - _movePrev.x, _moveCurr.y - _movePrev.y, 0 );
                angle = moveDirection.length();
    
                if ( angle ) {
    
                    _eye.copy( _this.object.position ).sub( _this.target );
    
                    eyeDirection.copy( _eye ).normalize();
                    objectUpDirection.copy( _this.object.up ).normalize();
                    objectSidewaysDirection.crossVectors( objectUpDirection, eyeDirection ).normalize();
    
                    objectUpDirection.setLength( _moveCurr.y - _movePrev.y );
                    objectSidewaysDirection.setLength( _moveCurr.x - _movePrev.x );
    
                    moveDirection.copy( objectUpDirection.add( objectSidewaysDirection ) );
    
                    axis.crossVectors( moveDirection, _eye ).normalize();
    
                    angle *= _this.rotateSpeed;
                    quaternion.setFromAxisAngle( axis, angle );
    
                    _eye.applyQuaternion( quaternion );
                    _this.object.up.applyQuaternion( quaternion );
    
                    _lastAxis.copy( axis );
                    _lastAngle = angle;
    
                } else if ( ! _this.staticMoving && _lastAngle ) {
    
                    _lastAngle *= Math.sqrt( 1.0 - _this.dynamicDampingFactor );
                    _eye.copy( _this.object.position ).sub( _this.target );
                    quaternion.setFromAxisAngle( _lastAxis, _lastAngle );
                    _eye.applyQuaternion( quaternion );
                    _this.object.up.applyQuaternion( quaternion );
    
                }
    
                _movePrev.copy( _moveCurr );
    
            };
    
        }() );
    
    
        this.zoomCamera = function () {
    
            var factor;
    
            if ( _state === STATE.TOUCH_ZOOM_PAN ) {
    
                factor = _touchZoomDistanceStart / _touchZoomDistanceEnd;
                _touchZoomDistanceStart = _touchZoomDistanceEnd;
                _eye.multiplyScalar( factor );
    
            } else {
    
                factor = 1.0 + ( _zoomEnd.y - _zoomStart.y ) * _this.zoomSpeed;
    
                if ( factor !== 1.0 && factor > 0.0 ) {
    
                    _eye.multiplyScalar( factor );
    
                    if ( _this.staticMoving ) {
    
                        _zoomStart.copy( _zoomEnd );
    
                    } else {
    
                        _zoomStart.y += ( _zoomEnd.y - _zoomStart.y ) * this.dynamicDampingFactor;
    
                    }
    
                }
    
            }
    
        };
    
        this.panCamera = ( function() {
    
            var mouseChange = new THREE.Vector2(),
                objectUp = new THREE.Vector3(),
                pan = new THREE.Vector3();
    
            return function panCamera() {
    
                mouseChange.copy( _panEnd ).sub( _panStart );
    
                if ( mouseChange.lengthSq() ) {
    
                    mouseChange.multiplyScalar( _eye.length() * _this.panSpeed );
    
                    pan.copy( _eye ).cross( _this.object.up ).setLength( mouseChange.x );
                    pan.add( objectUp.copy( _this.object.up ).setLength( mouseChange.y ) );
    
                    _this.object.position.add( pan );
                    _this.target.add( pan );
    
                    if ( _this.staticMoving ) {
    
                        _panStart.copy( _panEnd );
    
                    } else {
    
                        _panStart.add( mouseChange.subVectors( _panEnd, _panStart ).multiplyScalar( _this.dynamicDampingFactor ) );
    
                    }
    
                }
    
            };
    
        }() );
    
        this.checkDistances = function () {
    
            if ( ! _this.noZoom || ! _this.noPan ) {
    
                if ( _eye.lengthSq() > _this.maxDistance * _this.maxDistance ) {
    
                    _this.object.position.addVectors( _this.target, _eye.setLength( _this.maxDistance ) );
                    _zoomStart.copy( _zoomEnd );
    
                }
    
                if ( _eye.lengthSq() < _this.minDistance * _this.minDistance ) {
    
                    _this.object.position.addVectors( _this.target, _eye.setLength( _this.minDistance ) );
                    _zoomStart.copy( _zoomEnd );
    
                }
    
            }
    
        };
    
        this.update = function () {
    
            _eye.subVectors( _this.object.position, _this.target );
    
            if ( ! _this.noRotate ) {
    
                _this.rotateCamera();
    
            }
    
            if ( ! _this.noZoom ) {
    
                _this.zoomCamera();
    
            }
    
            if ( ! _this.noPan ) {
    
                _this.panCamera();
    
            }
    
            _this.object.position.addVectors( _this.target, _eye );
    
            _this.checkDistances();
    
            _this.object.lookAt( _this.target );
    
            if ( lastPosition.distanceToSquared( _this.object.position ) > EPS ) {
    
                _this.dispatchEvent( changeEvent );
    
                lastPosition.copy( _this.object.position );
    
            }
    
        };
    
        this.reset = function () {
    
            _state = STATE.NONE;
            _prevState = STATE.NONE;
    
            _this.target.copy( _this.target0 );
            _this.object.position.copy( _this.position0 );
            _this.object.up.copy( _this.up0 );
    
            _eye.subVectors( _this.object.position, _this.target );
    
            _this.object.lookAt( _this.target );
    
            _this.dispatchEvent( changeEvent );
    
            lastPosition.copy( _this.object.position );
    
        };
    
        // listeners
    
        function keydown( event ) {
    
            if ( _this.enabled === false ) return;
    
            window.removeEventListener( 'keydown', keydown );
    
            _prevState = _state;
    
            if ( _state !== STATE.NONE ) {
    
                return;
    
            } else if ( event.keyCode === _this.keys[ STATE.ROTATE ] && ! _this.noRotate ) {
    
                _state = STATE.ROTATE;
    
            } else if ( event.keyCode === _this.keys[ STATE.ZOOM ] && ! _this.noZoom ) {
    
                _state = STATE.ZOOM;
    
            } else if ( event.keyCode === _this.keys[ STATE.PAN ] && ! _this.noPan ) {
    
                _state = STATE.PAN;
    
            }
    
        }
    
        function keyup( event ) {
    
            if ( _this.enabled === false ) return;
    
            _state = _prevState;
    
            window.addEventListener( 'keydown', keydown, false );
    
        }
    
        function mousedown( event ) {
    
            if ( _this.enabled === false ) return;
    
            event.preventDefault();
            event.stopPropagation();
    
            if ( _state === STATE.NONE ) {
    
                _state = event.button;
    
            }
    
            if ( _state === STATE.ROTATE && ! _this.noRotate ) {
    
                _moveCurr.copy( getMouseOnCircle( event.pageX, event.pageY ) );
                _movePrev.copy( _moveCurr );
    
            } else if ( _state === STATE.ZOOM && ! _this.noZoom ) {
    
                _zoomStart.copy( getMouseOnScreen( event.pageX, event.pageY ) );
                _zoomEnd.copy( _zoomStart );
    
            } else if ( _state === STATE.PAN && ! _this.noPan ) {
    
                _panStart.copy( getMouseOnScreen( event.pageX, event.pageY ) );
                _panEnd.copy( _panStart );
    
            }
    
            document.addEventListener( 'mousemove', mousemove, false );
            document.addEventListener( 'mouseup', mouseup, false );
    
            _this.dispatchEvent( startEvent );
    
        }
    
        function mousemove( event ) {
    
            if ( _this.enabled === false ) return;
    
            event.preventDefault();
            event.stopPropagation();
    
            if ( _state === STATE.ROTATE && ! _this.noRotate ) {
    
                _movePrev.copy( _moveCurr );
                _moveCurr.copy( getMouseOnCircle( event.pageX, event.pageY ) );
    
            } else if ( _state === STATE.ZOOM && ! _this.noZoom ) {
    
                _zoomEnd.copy( getMouseOnScreen( event.pageX, event.pageY ) );
    
            } else if ( _state === STATE.PAN && ! _this.noPan ) {
    
                _panEnd.copy( getMouseOnScreen( event.pageX, event.pageY ) );
    
            }
    
        }
    
        function mouseup( event ) {
    
            if ( _this.enabled === false ) return;
    
            event.preventDefault();
            event.stopPropagation();
    
            _state = STATE.NONE;
    
            document.removeEventListener( 'mousemove', mousemove );
            document.removeEventListener( 'mouseup', mouseup );
            _this.dispatchEvent( endEvent );
    
        }
    
        function mousewheel( event ) {
    
            if ( _this.enabled === false ) return;
    
            event.preventDefault();
            event.stopPropagation();
    
            var delta = 0;
    
            if ( event.wheelDelta ) {
    
                // WebKit / Opera / Explorer 9
    
                delta = event.wheelDelta / 40;
    
            } else if ( event.detail ) {
    
                // Firefox
    
                delta = - event.detail / 3;
    
            }
    
            _zoomStart.y += delta * 0.01;
            _this.dispatchEvent( startEvent );
            _this.dispatchEvent( endEvent );
    
        }
    
        function touchstart( event ) {
    
            if ( _this.enabled === false ) return;
    
            switch ( event.touches.length ) {
    
                case 1:
                    _state = STATE.TOUCH_ROTATE;
                    _moveCurr.copy( getMouseOnCircle( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY ) );
                    _movePrev.copy( _moveCurr );
                    break;
    
                case 2:
                    _state = STATE.TOUCH_ZOOM_PAN;
                    var dx = event.touches[ 0 ].pageX - event.touches[ 1 ].pageX;
                    var dy = event.touches[ 0 ].pageY - event.touches[ 1 ].pageY;
                    _touchZoomDistanceEnd = _touchZoomDistanceStart = Math.sqrt( dx * dx + dy * dy );
    
                    var x = ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX ) / 2;
                    var y = ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY ) / 2;
                    _panStart.copy( getMouseOnScreen( x, y ) );
                    _panEnd.copy( _panStart );
                    break;
    
                default:
                    _state = STATE.NONE;
    
            }
            _this.dispatchEvent( startEvent );
    
    
        }
    
        function touchmove( event ) {
    
            if ( _this.enabled === false ) return;
    
            event.preventDefault();
            event.stopPropagation();
    
            switch ( event.touches.length ) {
    
                case 1:
                    _movePrev.copy( _moveCurr );
                    _moveCurr.copy( getMouseOnCircle(  event.touches[ 0 ].pageX, event.touches[ 0 ].pageY ) );
                    break;
    
                case 2:
                    var dx = event.touches[ 0 ].pageX - event.touches[ 1 ].pageX;
                    var dy = event.touches[ 0 ].pageY - event.touches[ 1 ].pageY;
                    _touchZoomDistanceEnd = Math.sqrt( dx * dx + dy * dy );
    
                    var x = ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX ) / 2;
                    var y = ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY ) / 2;
                    _panEnd.copy( getMouseOnScreen( x, y ) );
                    break;
    
                default:
                    _state = STATE.NONE;
    
            }
    
        }
    
        function touchend( event ) {
    
            if ( _this.enabled === false ) return;
    
            switch ( event.touches.length ) {
    
                case 1:
                    _movePrev.copy( _moveCurr );
                    _moveCurr.copy( getMouseOnCircle(  event.touches[ 0 ].pageX, event.touches[ 0 ].pageY ) );
                    break;
    
                case 2:
                    _touchZoomDistanceStart = _touchZoomDistanceEnd = 0;
    
                    var x = ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX ) / 2;
                    var y = ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY ) / 2;
                    _panEnd.copy( getMouseOnScreen( x, y ) );
                    _panStart.copy( _panEnd );
                    break;
    
            }
    
            _state = STATE.NONE;
            _this.dispatchEvent( endEvent );
    
        }
    
        function contextmenu( event ) {
    
            event.preventDefault();
    
        }
    
        this.dispose = function() {
    
            this.domElement.removeEventListener( 'contextmenu', contextmenu, false );
            this.domElement.removeEventListener( 'mousedown', mousedown, false );
           // this.domElement.removeEventListener( 'mousewheel', mousewheel, false );
            //this.domElement.removeEventListener( 'DOMMouseScroll', mousewheel, false ); // firefox
    
            this.domElement.removeEventListener( 'touchstart', touchstart, false );
            this.domElement.removeEventListener( 'touchend', touchend, false );
            this.domElement.removeEventListener( 'touchmove', touchmove, false );
    
            document.removeEventListener( 'mousemove', mousemove, false );
            document.removeEventListener( 'mouseup', mouseup, false );
    
            window.removeEventListener( 'keydown', keydown, false );
            window.removeEventListener( 'keyup', keyup, false );
    
        }
    
        this.domElement.addEventListener( 'contextmenu', contextmenu, false );
        this.domElement.addEventListener( 'mousedown', mousedown, false );
        //this.domElement.addEventListener( 'mousewheel', mousewheel, false );
        //this.domElement.addEventListener( 'DOMMouseScroll', mousewheel, false ); // firefox
    
        this.domElement.addEventListener( 'touchstart', touchstart, false );
        this.domElement.addEventListener( 'touchend', touchend, false );
        this.domElement.addEventListener( 'touchmove', touchmove, false );
    
        window.addEventListener( 'keydown', keydown, false );
        window.addEventListener( 'keyup', keyup, false );
    
        this.handleResize();
    
        // force an update at start
        this.update();
    
    };
    
    THREE.TrackballControls.prototype = Object.create( THREE.EventDispatcher.prototype );
    THREE.TrackballControls.prototype.constructor = THREE.TrackballControls;
/**
 * @author qiao / https://github.com/qiao
 * @author mrdoob / http://mrdoob.com
 * @author alteredq / http://alteredqualia.com/
 * @author WestLangley / http://github.com/WestLangley
 * @author erich666 / http://erichaines.com
 * @author mrflix / http://felixniklas.de
 * 
 * released under MIT License (MIT)
 */
/*global THREE, console */

// This set of controls performs orbiting, dollying (zooming), and panning. It maintains
// the "up" direction as +Y, unlike the TrackballControls. Touch on tablet and phones is
// supported.
//
//    Orbit - left mouse / touch: one finger move
//    Zoom - middle mouse, or mousewheel / touch: two finger spread or squish
//    Pan - right mouse, or arrow keys / touch: three finter swipe
//
// This is a drop-in replacement for (most) TrackballControls used in examples.
// That is, include this js file and wherever you see:
//    	controls = new THREE.TrackballControls( camera );
//      controls.target.z = 150;
// Simple substitute "OrbitControls" and the control should work as-is.

THREE.OrbitControls = function ( object, domElement, localElement ) {

	this.object = object;
	this.domElement = ( domElement !== undefined ) ? domElement : document;
	this.localElement = ( localElement !== undefined ) ? localElement : document;

	// API

	// Set to false to disable this control
	this.enabled = true;

	// "target" sets the location of focus, where the control orbits around
	// and where it pans with respect to.
	this.target = new THREE.Vector3();
	// center is old, deprecated; use "target" instead
	this.center = this.target;

	// This option actually enables dollying in and out; left as "zoom" for
	// backwards compatibility
	this.noZoom = false;
	this.zoomSpeed = 1.0;
	// Limits to how far you can dolly in and out
	this.minDistance = 0;
	this.maxDistance = Infinity;

	// Set to true to disable this control
	this.noRotate = false;
	this.rotateSpeed = 0.3;

	// Set to true to disable this control
	this.noPan = false;
	this.keyPanSpeed = 0.05;	// pixels moved per arrow key push

	// Set to true to automatically rotate around the target
	this.autoRotate = false;
	this.autoRotateSpeed = 2.0; // 30 seconds per round when fps is 60

	// How far you can orbit vertically, upper and lower limits.
	// Range is 0 to Math.PI radians.
	this.minPolarAngle = 0; // radians
	this.maxPolarAngle = Math.PI; // radians

	// Set to true to disable use of the keys
	this.noKeys = false;
	// The four arrow keys
	this.keys = { LEFT: 37, UP: 38, RIGHT: 39, BOTTOM: 40 };

	////////////
	// internals

	var scope = this;

	var EPS = 0.000001;

	var rotateStart = new THREE.Vector2();
	var rotateEnd = new THREE.Vector2();
	var rotateDelta = new THREE.Vector2();

	var panStart = new THREE.Vector2();
	var panEnd = new THREE.Vector2();
	var panDelta = new THREE.Vector2();

	var dollyStart = new THREE.Vector2();
	var dollyEnd = new THREE.Vector2();
	var dollyDelta = new THREE.Vector2();

	var phiDelta = 0;
	var thetaDelta = 0;
	var scale = 1;
	var pan = new THREE.Vector3();

	var lastPosition = new THREE.Vector3();

	var STATE = { NONE : -1, ROTATE : 0, DOLLY : 1, PAN : 2, TOUCH_ROTATE : 3, TOUCH_DOLLY : 4, TOUCH_PAN : 5 };
	var state = STATE.NONE;
	var triggerMouse=false;

	// events

	var changeEvent = { type: 'change' };


	this.rotateLeft = function ( angle ) {

		if ( angle === undefined ) {

			angle = getAutoRotationAngle();

		}

		thetaDelta -= angle;

	};

	this.rotateUp = function ( angle ) {

		if ( angle === undefined ) {

			angle = getAutoRotationAngle();

		}

		phiDelta -= angle;

	};

	// pass in distance in world space to move left
	this.panLeft = function ( distance ) {

		var panOffset = new THREE.Vector3();
		var te = this.object.matrix.elements;
		// get X column of matrix
		panOffset.set( te[0], te[1], te[2] );
		panOffset.multiplyScalar(-distance);
		
		pan.add( panOffset );

	};

	// pass in distance in world space to move up
	this.panUp = function ( distance ) {

		var panOffset = new THREE.Vector3();
		var te = this.object.matrix.elements;
		// get Y column of matrix
		panOffset.set( te[4], te[5], te[6] );
		panOffset.multiplyScalar(distance);
		
		pan.add( panOffset );
	};
	
	// main entry point; pass in Vector2 of change desired in pixel space,
	// right and down are positive
	this.pan = function ( delta ) {

		var element = scope.domElement === document ? scope.domElement.body : scope.domElement;

		if ( scope.object.fov !== undefined ) {

			// perspective
			var position = scope.object.position;
			var offset = position.clone().sub( scope.target );
			var targetDistance = offset.length();

			// half of the fov is center to top of screen
			targetDistance *= Math.tan( (scope.object.fov/2) * Math.PI / 180.0 );
			// we actually don't use screenWidth, since perspective camera is fixed to screen height
			scope.panLeft( 6 * delta.x * targetDistance / element.clientHeight );
			scope.panUp( -6 * delta.y * targetDistance / element.clientHeight );

		} else if ( scope.object.top !== undefined ) {

			// orthographic
			scope.panLeft( delta.x * (scope.object.right - scope.object.left) / element.clientWidth );
			scope.panUp( delta.y * (scope.object.top - scope.object.bottom) / element.clientHeight );

		} else {

			// camera neither orthographic or perspective - warn user
			console.warn( 'WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.' );

		}

	};

	this.dollyIn = function ( dollyScale ) {

		if ( dollyScale === undefined ) {

			dollyScale = getZoomScale();

		}

		scale /= dollyScale;

	};

	this.dollyOut = function ( dollyScale ) {

		if ( dollyScale === undefined ) {

			dollyScale = getZoomScale();

		}

		scale *= dollyScale;

	};

	this.update = function () {

		var position = this.object.position;
		var offset = position.clone().sub( this.target );

		// angle from z-axis around y-axis

		var theta = Math.atan2( offset.x, offset.z );

		// angle from y-axis

		var phi = Math.atan2( Math.sqrt( offset.x * offset.x + offset.z * offset.z ), offset.y );

		if ( this.autoRotate ) {

			this.rotateLeft( getAutoRotationAngle() );

		}

		theta += thetaDelta;
		phi += phiDelta;

		// restrict phi to be between desired limits
		phi = Math.max( this.minPolarAngle, Math.min( this.maxPolarAngle, phi ) );

		// restrict phi to be betwee EPS and PI-EPS
		phi = Math.max( EPS, Math.min( Math.PI - EPS, phi ) );

		var radius = offset.length() * scale;

		// restrict radius to be between desired limits
		radius = Math.max( this.minDistance, Math.min( this.maxDistance, radius ) );
		
		// move target to panned location
		this.target.add( pan );

		offset.x = radius * Math.sin( phi ) * Math.sin( theta );
		offset.y = radius * Math.cos( phi );
		offset.z = radius * Math.sin( phi ) * Math.cos( theta );

		position.copy( this.target ).add( offset );

		this.object.lookAt( this.target );

		thetaDelta = 0;
		phiDelta = 0;
		scale = 1;
		pan.set(0,0,0);

		if ( lastPosition.distanceTo( this.object.position ) > 0 ) {

			this.dispatchEvent( changeEvent );

			lastPosition.copy( this.object.position );

		}

	};


	function getAutoRotationAngle() {

		return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;

	}

	function getZoomScale() {

		return Math.pow( 0.95, scope.zoomSpeed );

	}

	function onMouseDown( event ) {
		
		if ( scope.enabled === false ) { return; }
		//event.preventDefault();
		if (event.ctrlKey) {
			triggerMouse=true;
			if ( event.button === 0 ) {
				if ( scope.noRotate === true ) { return; }
	
				state = STATE.ROTATE;
	
				rotateStart.set( event.clientX, event.clientY );
	
			} else if ( event.button === 1 ) {
				if ( scope.noZoom === true ) { return; }
	
				state = STATE.DOLLY;
	
				dollyStart.set( event.clientX, event.clientY );
	
			} else if ( event.button === 2 ) {
				if ( scope.noPan === true ) { return; }
	
				state = STATE.PAN;
	
				panStart.set( event.clientX, event.clientY );
	
			}
		}
	/*	if ( event.button === 0 ) {
			if ( scope.noRotate === true ) { return; }

			state = STATE.ROTATE;

			rotateStart.set( event.clientX, event.clientY );

		} else if ( event.button === 1 ) {
			if ( scope.noZoom === true ) { return; }

			state = STATE.DOLLY;

			dollyStart.set( event.clientX, event.clientY );

		} else if ( event.button === 2 ) {
			if ( scope.noPan === true ) { return; }

			state = STATE.PAN;

			panStart.set( event.clientX, event.clientY );

		}*/
		/*if ( event.button === 2 ) {
			event.preventDefault();
			if ( scope.noRotate === true ) { return; }
			triggerMouse=true;
			state = STATE.ROTATE;


			rotateStart.set( event.clientX, event.clientY );

		}*/

		// Greggman fix: https://github.com/greggman/three.js/commit/fde9f9917d6d8381f06bf22cdff766029d1761be
		scope.domElement.addEventListener( 'mousemove', onMouseMove, false );
		scope.domElement.addEventListener( 'mouseup', onMouseUp, false );

	}

	function onMouseMove( event ) {
		if(triggerMouse)
		{
			if ( scope.enabled === false ) return;
			
			event.preventDefault();
	
			var element = scope.domElement === document ? scope.domElement.body : scope.domElement;
	
			if ( state === STATE.ROTATE ) {
	
				if ( scope.noRotate === true ) return;
	
				rotateEnd.set( event.clientX, event.clientY );
				rotateDelta.subVectors( rotateEnd, rotateStart );
	
				// rotating across whole screen goes 360 degrees around
				scope.rotateLeft( 2 * Math.PI * rotateDelta.x / element.clientWidth * scope.rotateSpeed );
				// rotating up and down along whole screen attempts to go 360, but limited to 180
				scope.rotateUp( 2 * Math.PI * rotateDelta.y / element.clientHeight * scope.rotateSpeed );
	
				rotateStart.copy( rotateEnd );
	
			} else if ( state === STATE.DOLLY ) {
	
				if ( scope.noZoom === true ) return;
	
				dollyEnd.set( event.clientX, event.clientY );
				dollyDelta.subVectors( dollyEnd, dollyStart );
	
				if ( dollyDelta.y > 0 ) {
	
					scope.dollyIn();
	
				} else {
	
					scope.dollyOut();
	
				}
	
				dollyStart.copy( dollyEnd );
	
			} else if ( state === STATE.PAN ) {
	
				if ( scope.noPan === true ) return;
	
				panEnd.set( event.clientX, event.clientY );
				panDelta.subVectors( panEnd, panStart );
				
				scope.pan( panDelta );
	
				panStart.copy( panEnd );
	
			}
	
			// Greggman fix: https://github.com/greggman/three.js/commit/fde9f9917d6d8381f06bf22cdff766029d1761be
			scope.update();
		}

	}

	function onMouseUp( /* event */ ) {

		if ( scope.enabled === false ) return;

		// Greggman fix: https://github.com/greggman/three.js/commit/fde9f9917d6d8381f06bf22cdff766029d1761be
		scope.domElement.removeEventListener( 'mousemove', onMouseMove, false );
		scope.domElement.removeEventListener( 'mouseup', onMouseUp, false );
		triggerMouse=false;
		state = STATE.NONE;

	}

	function onMouseWheel( event ) {

		if ( scope.enabled === false || scope.noZoom === true ) return;

		var delta = 0;

		if ( event.wheelDelta ) { // WebKit / Opera / Explorer 9

			delta = event.wheelDelta;

		} else if ( event.detail ) { // Firefox

			delta = - event.detail;

		}

		if ( delta > 0 ) {

			scope.dollyOut();

		} else {

			scope.dollyIn();

		}

	}

	function onKeyDown( event ) {

		if ( scope.enabled === false ) { return; }
		if ( scope.noKeys === true ) { return; }
		if ( scope.noPan === true ) { return; }

		// pan a pixel - I guess for precise positioning?
		// Greggman fix: https://github.com/greggman/three.js/commit/fde9f9917d6d8381f06bf22cdff766029d1761be
		var needUpdate = false;
		
		switch ( event.keyCode ) {

			case scope.keys.UP:
				scope.pan( new THREE.Vector2( 0, scope.keyPanSpeed ) );
				needUpdate = true;
				break;
			case scope.keys.BOTTOM:
				scope.pan( new THREE.Vector2( 0, -scope.keyPanSpeed ) );
				needUpdate = true;
				break;
			case scope.keys.LEFT:
				scope.pan( new THREE.Vector2( scope.keyPanSpeed, 0 ) );
				needUpdate = true;
				break;
			case scope.keys.RIGHT:
				scope.pan( new THREE.Vector2( -scope.keyPanSpeed, 0 ) );
				needUpdate = true;
				break;
		}

		// Greggman fix: https://github.com/greggman/three.js/commit/fde9f9917d6d8381f06bf22cdff766029d1761be
		if ( needUpdate ) {

			scope.update();

		}

	}
	
	function touchstart( event ) {

		if ( scope.enabled === false ) { return; }

		switch ( event.touches.length ) {

			case 1:	// one-fingered touch: rotate
				if ( scope.noRotate === true ) { return; }

				state = STATE.TOUCH_ROTATE;

				rotateStart.set( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY );
				break;

			case 2:	// two-fingered touch: dolly
				if ( scope.noZoom === true ) { return; }

				state = STATE.TOUCH_DOLLY;

				var dx = event.touches[ 0 ].pageX - event.touches[ 1 ].pageX;
				var dy = event.touches[ 0 ].pageY - event.touches[ 1 ].pageY;
				var distance = Math.sqrt( dx * dx + dy * dy );
				dollyStart.set( 0, distance );
				break;

			case 3: // three-fingered touch: pan
				if ( scope.noPan === true ) { return; }

				state = STATE.TOUCH_PAN;

				panStart.set( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY );
				break;

			default:
				state = STATE.NONE;

		}
	}

	function touchmove( event ) {

		if ( scope.enabled === false ) { return; }

		event.preventDefault();
		event.stopPropagation();

		var element = scope.domElement === document ? scope.domElement.body : scope.domElement;

		switch ( event.touches.length ) {

			case 1: // one-fingered touch: rotate
				if ( scope.noRotate === true ) { return; }
				if ( state !== STATE.TOUCH_ROTATE ) { return; }

				rotateEnd.set( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY );
				rotateDelta.subVectors( rotateEnd, rotateStart );

				// rotating across whole screen goes 360 degrees around
				scope.rotateLeft( 2 * Math.PI * rotateDelta.x / element.clientWidth * scope.rotateSpeed );
				// rotating up and down along whole screen attempts to go 360, but limited to 180
				scope.rotateUp( 2 * Math.PI * rotateDelta.y / element.clientHeight * scope.rotateSpeed );

				rotateStart.copy( rotateEnd );
				break;

			case 2: // two-fingered touch: dolly
				if ( scope.noZoom === true ) { return; }
				if ( state !== STATE.TOUCH_DOLLY ) { return; }

				var dx = event.touches[ 0 ].pageX - event.touches[ 1 ].pageX;
				var dy = event.touches[ 0 ].pageY - event.touches[ 1 ].pageY;
				var distance = Math.sqrt( dx * dx + dy * dy );

				dollyEnd.set( 0, distance );
				dollyDelta.subVectors( dollyEnd, dollyStart );

				if ( dollyDelta.y > 0 ) {

					scope.dollyOut();

				} else {

					scope.dollyIn();

				}

				dollyStart.copy( dollyEnd );
				break;

			case 3: // three-fingered touch: pan
				if ( scope.noPan === true ) { return; }
				if ( state !== STATE.TOUCH_PAN ) { return; }

				panEnd.set( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY );
				panDelta.subVectors( panEnd, panStart );
				
				scope.pan( panDelta );

				panStart.copy( panEnd );
				break;

			default:
				state = STATE.NONE;

		}

	}

	function touchend( /* event */ ) {

		if ( scope.enabled === false ) { return; }

		state = STATE.NONE;
	}

	this.domElement.addEventListener( 'contextmenu', function ( event ) { event.preventDefault(); }, false );
	this.localElement.addEventListener( 'mousedown', onMouseDown, false );
	//this.domElement.addEventListener( 'mousewheel', onMouseWheel, false );
	//this.domElement.addEventListener( 'DOMMouseScroll', onMouseWheel, false ); // firefox

	//this.domElement.addEventListener( 'keydown', onKeyDown, false );

	this.localElement.addEventListener( 'touchstart', touchstart, false );
	this.domElement.addEventListener( 'touchend', touchend, false );
	this.domElement.addEventListener( 'touchmove', touchmove, false );

};

THREE.OrbitControls.prototype = Object.create( THREE.EventDispatcher.prototype );
/**
 *	@author zz85 / http://twitter.com/blurspline / http://www.lab4games.net/zz85/blog
 *
 *	A general perpose camera, for setting FOV, Lens Focal Length,
 *		and switching between perspective and orthographic views easily.
 *		Use this only if you do not wish to manage
 *		both a Orthographic and Perspective Camera
 *
 */


THREE.CombinedCamera = function ( left, right, top, bottom, fov, near, far, orthoNear, orthoFar ) {
    
        THREE.Camera.call( this );
      
        this.fov = fov;
    
        this.far = far;
        this.near = near;
    
        this.left = left;
        this.right =right;
        this.top = top;
        this.bottom = bottom;
        var width=left+right;
        var height=top+bottom;
        //this.aspect =  width / height;
        this.zoom = 70;
        this.view = null;
        // We could also handle the projectionMatrix internally, but just wanted to test nested camera objects
    
        this.cameraO = new THREE.OrthographicCamera( left, right, top, bottom, 	orthoNear, orthoFar );
        this.cameraP = new THREE.PerspectiveCamera( fov, width / height, near, far );
    
        this.toOrthographic();
    
    };
    
    THREE.CombinedCamera.prototype = Object.create( THREE.Camera.prototype );
    THREE.CombinedCamera.prototype.constructor = THREE.CombinedCamera;
    
    THREE.CombinedCamera.prototype.toPerspective = function () {
    
        // Switches to the Perspective Camera
    
        this.near = this.cameraP.near;
        this.far = this.cameraP.far;
    
        this.cameraP.aspect = this.aspect;
        this.cameraP.fov =  this.fov / this.zoom ;
        this.cameraP.view = this.view;
    
        this.cameraP.updateProjectionMatrix();
    
        this.projectionMatrix = this.cameraP.projectionMatrix;
    
        this.inPerspectiveMode = true;
        this.inOrthographicMode = false;
    
    };
    var start=true;
    THREE.CombinedCamera.prototype.toOrthographic = function () {
    
        // Switches to the Orthographic camera estimating viewport from Perspective
    
        var fov = this.fov;
        var aspect = this.cameraP.aspect;
        var near = this.cameraP.near;
        var far = this.cameraP.far;
    
        // The size that we set is the mid plane of the viewing frustum
    
        var hyperfocus = ( near + far ) / 2;
    
        var halfHeight = Math.tan( fov * Math.PI / 180 / 2 ) * hyperfocus;
        var halfWidth = halfHeight * aspect;
    
        halfHeight /= this.zoom;
        halfWidth /= this.zoom;
       
        if(start)
        {
            this.cameraO.position.set(0, 0,0.3);
            start=false;
        }
        else
        {
            this.cameraO.left =  halfWidth;
            this.cameraO.right = -halfWidth;
            this.cameraO.top = -halfHeight;
            this.cameraO.bottom =  halfHeight;
            this.cameraO.view = this.view;
        }
        
        this.cameraO.updateProjectionMatrix();
    
        this.near = this.cameraO.near;
        this.far = this.cameraO.far;
        this.projectionMatrix = this.cameraO.projectionMatrix;
    
        this.inPerspectiveMode = false;
        this.inOrthographicMode = true;
    
    };
    
    THREE.CombinedCamera.prototype.copy = function ( source ) {
    
        THREE.Camera.prototype.copy.call( this, source );
    
        this.fov = source.fov;
        this.far = source.far;
        this.near = source.near;
    
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
    
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign( {}, source.view );
        this.aspect = source.aspect;
    
        this.cameraO.copy( source.cameraO );
        this.cameraP.copy( source.cameraP );
    
        this.inOrthographicMode = source.inOrthographicMode;
        this.inPerspectiveMode = source.inPerspectiveMode;
    
        return this;
    
    };
    
    THREE.CombinedCamera.prototype.setViewOffset = function( fullWidth, fullHeight, x, y, width, height ) {
    
        this.view = {
            fullWidth: fullWidth,
            fullHeight: fullHeight,
            offsetX: x,
            offsetY: y,
            width: width,
            height: height
        };
    
        if ( this.inPerspectiveMode ) {
    
            this.aspect = fullWidth / fullHeight;
    
            this.toPerspective();
    
        } else {
    
            this.toOrthographic();
    
        }
    
    };
    
    THREE.CombinedCamera.prototype.clearViewOffset = function() {
    
        this.view = null;
        this.updateProjectionMatrix();
    
    };
    
    THREE.CombinedCamera.prototype.setSize = function( width, height ) {
    
        this.cameraP.aspect = width / height;
        this.left = - width / 2;
        this.right = width / 2;
        this.top = height / 2;
        this.bottom = - height / 2;
    
    };
    
    
    THREE.CombinedCamera.prototype.setFov = function( fov ) {
    
        this.fov = fov;
    
        if ( this.inPerspectiveMode ) {
    
            this.toPerspective();
    
        } else {
    
            this.toOrthographic();
    
        }
    
    };
    
    // For maintaining similar API with PerspectiveCamera
    
    THREE.CombinedCamera.prototype.updateProjectionMatrix = function() {
    
        if ( this.inPerspectiveMode ) {
    
            this.toPerspective();
    
        } else {
    
            this.toPerspective();
            this.toOrthographic();
    
        }
    
    };
    
    /*
    * Uses Focal Length (in mm) to estimate and set FOV
    * 35mm (full frame) camera is used if frame size is not specified;
    * Formula based on http://www.bobatkins.com/photography/technical/field_of_view.html
    */
    THREE.CombinedCamera.prototype.setLens = function ( focalLength, filmGauge ) {
    
        if ( filmGauge === undefined ) filmGauge = 35;
    
        var vExtentSlope = 0.5 * filmGauge /
                ( focalLength * Math.max( this.cameraP.aspect, 1 ) );
    
        var fov = THREE.Math.RAD2DEG * 2 * Math.atan( vExtentSlope );
    
        this.setFov( fov );
    
        return fov;
    
    };
    
    
    THREE.CombinedCamera.prototype.setZoom = function( zoom ) {
    
        this.zoom = zoom;
    
        if ( this.inPerspectiveMode ) {
    
            this.toPerspective();
    
        } else {
    
            this.toOrthographic();
    
        }
    
    };
    
    THREE.CombinedCamera.prototype.toFrontView = function() {
    
        this.rotation.x = 0;
        this.rotation.y = 0;
        this.rotation.z = 0;
    
        // should we be modifing the matrix instead?
    
    };
    
    THREE.CombinedCamera.prototype.toBackView = function() {
    
        this.rotation.x = 0;
        this.rotation.y = Math.PI;
        this.rotation.z = 0;
    
    };
    
    THREE.CombinedCamera.prototype.toLeftView = function() {
    
        this.rotation.x = 0;
        this.rotation.y = - Math.PI / 2;
        this.rotation.z = 0;
    
    };
    
    THREE.CombinedCamera.prototype.toRightView = function() {
    
        this.rotation.x = 0;
        this.rotation.y = Math.PI / 2;
        this.rotation.z = 0;
    
    };
    
    THREE.CombinedCamera.prototype.toTopView = function() {
    
        this.rotation.x = - Math.PI / 2;
        this.rotation.y = 0;
        this.rotation.z = 0;
    
    };
    
    THREE.CombinedCamera.prototype.toBottomView = function() {
    
        this.rotation.x = Math.PI / 2;
        this.rotation.y = 0;
        this.rotation.z = 0;
    
    };
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('VerticalSolutionsController', VerticalSolutionsController);

    // DashboardController.inject = ['$q','msApi', '$mdSidenav', '$mdDialog', '$document', '$scope', 'session', 'pragmaapi','PRAGMA'];
    function VerticalSolutionsController($rootScope, $q, $filter, $translate, $cookies, $timeout, msApi, $mdSidenav, $mdDialog, $document, $scope, session, pragmaapi, PRAGMA, $location) {
        var vm = this;
        vm.user=session.getUser();
        vm.user.authentication=vm.user.username+":"+vm.user.password;
        vm.url=PRAGMA.api;
        vm.changeVerticalSolution=changeVerticalSolution;
        vm.showModules=false;
		vm.selectedIndex = 0;
		
        function checkUserModules()
        {
            var fl=false;
            if(vm.user.modules.length>1)
            {
                vm.showModules=true;
            }
            for(var i=0;i<vm.solutions.length;i++)
            {
                fl=false;
                for(var j=0;j<vm.user.modules.length;j++)
                {
                    if(vm.solutions[i].token===vm.user.modules[j])
                    {
                        fl=true;
                    }
                }
				if(!fl)
				{
					vm.solutions.splice(i, 1);
				}
            }
			for(var i=0;i<vm.solutions.length;i++) {
				if (vm.solutions[i].token === vm.user.currentModule){
					vm.selectedIndex = i;
				}
				
			}
			
        }
        ifSolutions()
        function ifSolutions()
        {
            if(vm.user.hasVerticals)
            {
                pragmaapi.callRestService(vm.url, "/verticalSolutions/tenant/",  vm.user.currentTenant, true, vm.user.authentication, "GET", true, false).then(function(res) {
                    var solutions=res.data.results;
                    var tmpSolutions=[];
                    for(var i=0;i<solutions.length;i++)
                    {
                        if(solutions[i].parent==="#")
                        {
                            tmpSolutions.push(solutions[i])
                        }
                    }
                    for(var i=0;i<solutions.length;i++)
                    {
                        if(solutions[i].parent!=="#")
                        {
                            tmpSolutions.push(solutions[i])
                        }
                    }
                    for(var i=0;i<tmpSolutions.length;i++)
                    {
                        tmpSolutions[i].color = tmpSolutions[i].secondary;
                        tmpSolutions[i].notsmart = tmpSolutions[i].name.split(" ").pop();
                    }
                    vm.solutions=tmpSolutions;
                    checkUserModules();
                });
            }
        }
        function changeVerticalSolution(thisModule)
        {
            var expireDate = new Date();
            $rootScope.$broadcast('change.module',thisModule);
            vm.user.currentModule=thisModule.token;
            vm.user.parentModule=thisModule.parent;
            session.setUser(vm.user);
            vm.currentModule=thisModule.token;
        }
       
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('pragmaConfig', pragmaConfigProvider);

    /** @ngInject */
    function pragmaConfigProvider()
    {
        // Default configuration
        var pragmaConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            pragmaConfiguration = angular.extend({}, pragmaConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(pragmaConfiguration[configName]) )
                {
                    return false;
                }

                return pragmaConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                pragmaConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($cookies,pragmaapi,$rootScope,$scope, $q, $state, $location, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, session, PRAGMA, $base64,$http, $window)
    {
        var vm = this;
		
        if(typeof session.getUser() !== "undefined") {
            vm.user = session.getUser();
            vm.user.authentication = vm.user.username + ":" + vm.user.password;
            vm.url = PRAGMA.api;
            vm.portalUrl=PRAGMA.url;
            vm.seenNotification=seenNotification;
            vm.checkAllSeen=checkAllSeen;
            if(vm.user.hasVerticals)
            {
                pragmaapi.callRestService(PRAGMA.api, "/verticalSolutions", "", true, vm.user.authentication, "GET", true, false).then(function(res) {
                    var solutions=res.data.results;
                    for(var i=0;i<solutions.length;i++)
                    {
                        if(solutions[i].token===$cookies.get("currentModule"))
                        {
                            vm.logo=solutions[i].logo;
                        }
                    }
                });
            }
            else
            {
                if (vm.user.role === "level01") {
                    vm.logo = PRAGMA.url + "/assets/logos/pragma-logo.png";
                 }
                 else {
                     callRestService(vm.url, "/users/" + vm.user.username + "/tenants", "", true, vm.user.authentication, "GET").then(function(res) {
                         if (res.data[0].logoUrl !== "") {
                            vm.logo = res.data[0].logoUrl;
                         }
                         else {
                            vm.logo = PRAGMA.url + "/assets/logos/pragma-logo.png";
                         }
                     });
                 }
            }
            $scope.$on('change.module', function(event, args) {
                vm.logo=args.logo;
            });
			
            $scope.$on('change.module.login', function(event, args) {
                vm.logo=args.logo;
            });
			
            // Data
            $rootScope.global = {
                search: ''
            };
            $rootScope.$on('removeNotification', function(event, args) {
                vm.notifications--;
                if(vm.notifications==0)
                {
                    $('.notificationCircle').hide();
                }
            });
            vm.notifications=0;
            $scope.$on('notifications.broadcast', function(event, args) {
                $timeout(function() {
                    $scope.$apply(function () {
                            getNotifications();
                    });
                },1000); 
            });

            function seenNotification(notification)
            {
                if(!notification.seen)
                {
                    var message=
                    {
                        token:notification.token,
                        read:false,
                        seen:true,
                        site:notification.site,
                        tenant:notification.tenant,
                        eventDate:notification.eventDate,
                        user:notification.user,
                        title:notification.title,
                        message:notification.message,
                        type:notification.type
                    };
                    pragmaapi.callRestService(PRAGMA.api, "/notifications/"+message.token, message, true, vm.user.authentication, "PUT", true, false).then(function(res){
                        var fl=0;
                        for(var i=0;i<vm.allNotifications.length;i++)
                        {
                            if(vm.allNotifications[i].token==notification.token)
                            {
                                fl=i;
                                vm.allNotifications[i].seen=true;
                            }
                        }
                        vm.unseenNotifications.splice(fl, 1);

                    });
                }
            }

            function seenNotificationAll(notification)
            {
                if(!notification.seen)
                {
                    var message=
                    {
                        token:notification.token,
                        read:false,
                        seen:true,
                        site:notification.site,
                        tenant:notification.tenant,
                        eventDate:notification.eventDate,
                        user:notification.user,
                        title:notification.title,
                        message:notification.message,
                        type:notification.type
                    };
                    pragmaapi.callRestService(PRAGMA.api, "/notifications/"+message.token, message, true, vm.user.authentication, "PUT", true, false).then(function(res){
                        var fl=0;
                        for(var i=0;i<vm.allNotifications.length;i++)
                        {
                            if(vm.allNotifications[i].token==notification.token)
                            {
                                fl=i;
                                vm.allNotifications[i].seen=true;
                            }
                        }
                    });
                }
            }

            function checkAllSeen()
            {
                vm.unseenNotifications=[];
                for(var i=0;i<vm.unseenNotifications.length;i++)
                {
                    seenNotificationAll(vm.unseenNotifications[i]);
                }
            }
            getNotifications();
            function getNotifications()
            {
                pragmaapi.callRestService(PRAGMA.api, "/notifications/userId/" + vm.user.username, "", true, vm.user.authentication, "GET", true, false).then(function(res){
                    vm.notifications=res.data.results;  
                    var unseenNotifications=[];
                    var seenNotifications=[];
                    var allNotifications=[];
                    for(var i=0;i<vm.notifications.length;i++)
                    {
                        if(!vm.notifications[i].seen)
                        {
                            unseenNotifications.push(vm.notifications[i]);
                            allNotifications.push(vm.notifications[i]);
                        }
                        else
                        {
                            seenNotifications.push(vm.notifications[i]);
                        }
                    }
                    if(allNotifications.length<5)
                    {
                        var x=5-allNotifications.length;
                        for(var i=0;i<=x;i++)
                        {
                            if(typeof seenNotifications[i]!=='undefined')
                                allNotifications.push(seenNotifications[i]);
                        }
                    }
                    $timeout(function() {
                        $scope.$apply(function () {
                            vm.unseenNotifications=unseenNotifications;
                            vm.allNotifications=allNotifications;
                            vm.seenNotifications=seenNotifications;
                        });
                    },500);   
               });
            }
            
            vm.bodyEl = angular.element('body');
            $rootScope.$on('userLogo', function(event, args) {
                vm.user.logo=$rootScope.logo;
            });

            vm.userStatusOptions = [
                {
                    'title': 'Online',
                    'icon' : 'icon-checkbox-marked-circle',
                    'color': '#4CAF50'
                },
                {
                    'title': 'Away',
                    'icon' : 'icon-clock',
                    'color': '#FFC107'
                },
                {
                    'title': 'Do not Disturb',
                    'icon' : 'icon-minus-circle',
                    'color': '#F44336'
                },
                {
                    'title': 'Invisible',
                    'icon' : 'icon-checkbox-blank-circle-outline',
                    'color': '#BDBDBD'
                },
                {
                    'title': 'Offline',
                    'icon' : 'icon-checkbox-blank-circle-outline',
                    'color': '#616161'
                }
            ];
            vm.languages = {
                en: {
                    'title'      : 'English',
                    'translation': 'TOOLBAR.ENGLISH',
                    'code'       : 'en',
                    'flag'       : 'us'
                },
                /*es: {
                    'title'      : 'Spanish',
                    'translation': 'TOOLBAR.SPANISH',
                    'code'       : 'es',
                    'flag'       : 'es'
                },
                tr: {
                    'title'      : 'Turkish',
                    'translation': 'TOOLBAR.TURKISH',
                    'code'       : 'tr',
                    'flag'       : 'tr'
                },*/
                el: {
                    'title'      : 'Greek',
                    'translation': 'TOOLBAR.GREEK',
                    'code'       : 'el',
                    'flag'       : 'el'
                }
            };

            // Methods
            vm.toggleSidenav = toggleSidenav;
            vm.logout = logout;
            vm.changeLanguage = changeLanguage;
            vm.setUserStatus = setUserStatus;
            vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
            vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
            vm.search = search;
            vm.searchResultClick = searchResultClick;

            //////////

            init();

            /**
             * Initialize
             */
            function init()
            {
                // Select the first status as a default
                vm.userStatus = vm.userStatusOptions[0];

                // Get the selected language directly from angular-translate module setting
                vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
            }


            /**
             * Toggle sidenav
             *
             * @param sidenavId
             */
            function toggleSidenav(sidenavId)
            {
                $mdSidenav(sidenavId).toggle();
            }

            /**
             * Sets User Status
             * @param status
             */
            function setUserStatus(status)
            {
                vm.userStatus = status;
            }

            function callRestService(url_in,service,params,useCredentials,auth,method,PRAGMA)
            {
                var this_url;
                var this_headers={};
                var this_data={};
                if(method==="POST" || method==="PUT")
                {
                    this_url=url_in+service;
                    this_data=params;
                    this_headers['Access-Control-Allow-Origin']="*";
                    this_headers['Content-Type']="application/json";
                }
                else 
                {
                    this_url=url_in+service+params;
                }
                if(useCredentials)
                {
                    var this_auth = $base64.encode(auth);
                    this_headers['Authorization']="Basic "+ this_auth;
                }
                return $http({
                    method: method,
                    url: this_url,
                    headers: this_headers,
                    data:this_data
                });
            }
            /**
             * Logout Function
             */
            function logout()
            {
                session.destroy();
                //$window.location.href = vm.portalUrl+'/auth/login';
                $window.location.href = vm.portalUrl + PRAGMA.loginPage;
            }

            /**
             * Change Language
             */
            function changeLanguage(lang)
            {
                vm.selectedLanguage = lang;

                /**
                 * Show temporary message if user selects a language other than English
                 *
                 * angular-translate module will try to load language specific json files
                 * as soon as you change the language. And because we don't have them, there
                 * will be a lot of errors in the page potentially breaking couple functions
                 * of the template.
                 *
                 * To prevent that from happening, we added a simple "return;" statement at the
                 * end of this if block. If you have all the translation files, remove this if
                 * block and the translations should work without any problems.
                 */
                /*
                if ( lang.code !== 'en' )
                {
                    
                    var message = 'PRAGMA supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message.';
                    
                    $mdToast.show({
                        template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                        hideDelay: 7000,
                        position : 'top right',
                        parent   : '#content'
                    });

                    return;
                    
                }
                */
                // Change the language
                $translate.use(lang.code);
            }

            /**
             * Toggle horizontal mobile menu
             */
            function toggleHorizontalMobileMenu()
            {
                vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
            }

            /**
             * Toggle msNavigation folded
             */
            function toggleMsNavigationFolded()
            {
                msNavigationService.toggleFolded();
            }

            /**
             * Search action
             *
             * @param query
             * @returns {Promise}
             */
            function search(query)
            {
                var navigation = [],
                    flatNavigation = msNavigationService.getFlatNavigation(),
                    deferred = $q.defer();

                // Iterate through the navigation array and
                // make sure it doesn't have any groups or
                // none ui-sref items
                for ( var x = 0; x < flatNavigation.length; x++ )
                {
                    if ( flatNavigation[x].uisref )
                    {
                        navigation.push(flatNavigation[x]);
                    }
                }

                // If there is a query, filter the navigation;
                // otherwise we will return the entire navigation
                // list. Not exactly a good thing to do but it's
                // for demo purposes.
                if ( query )
                {
                    navigation = navigation.filter(function (item)
                    {
                        if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                        {
                            return true;
                        }
                    });
                }

                // Fake service delay
                $timeout(function ()
                {
                    deferred.resolve(navigation);
                }, 1000);

                return deferred.promise;
            }

            /**
             * Search result click action
             *
             * @param item
             */
            function searchResultClick(item)
            {
                // If item has a link
                if ( item.uisref )
                {
                    // If there are state params,
                    // use them...
                    if ( item.stateParams )
                    {
                        $state.go(item.state, item.stateParams);
                    }
                    else
                    {
                        $state.go(item.state);
                    }
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the PRAGMA
     */
    angular
        .module('pragma', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Authentication
            'app.auth',

            // Breakdown
            'app.breakdown',
			
            // Compare
           'app.compare',
			
            // Explore
            'app.explore',
            
            // Events
            'app.events',
			
            //Notifications
            'app.notification',
			
			//Notifications
            'app.preferences',

            //Administrator
            'app.admin',

            //Dashboard
            'app.dashboard',

            //Custom Directives
            'app.directives',

            // Prediction
            'app.prediction',

            // Reports
            'app.reporting',
			//'app.reporting2',

            // M&V
           // 'app.mv',
            
            // Landing
            'app.landing',

            // Rule Engine
            'app.rules',

            // Change Password
            'app.change_pass',

        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('pragma')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data
        $rootScope.HomeStarted=true;
		// Authentication
		
		$scope.$on('event:auth-loginRequired', function()
		{
			login.slideDown('slow', function() {
				main.hide();
			});
		});
		
        $scope.$on('event:auth-loginConfirmed', function()
		{
			main.show();
			login.slideUp();
		});

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, pragmaGenerator, pragmaConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        pragmaGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( pragmaConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, uiGmapGoogleMapApiProvider, $translateProvider, $provide, pragmaConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            key:       'AIzaSyBKyw2NgnkPRSC0SyHuVe_o_hLofBOyU5A',
            v        : '3.exp',
            libraries: 'weather,geometry,visualization'
        });

        // angular-translate configuration
        //$translateProvider.useLoader('$translatePartialLoader', {
        //    urlTemplate: '{part}/i18n/{lang}.json'
        //});
        //$translateProvider.preferredLanguage('en');
        //$translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // PRAGMA theme configurations
        pragmaConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('pragma')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $window, $state, $location, $timeout, msNavigationService, session, auth, PRAGMA, pragmaapi)
    {
        var vm = {};
        // Session start
        session.start();
        $rootScope.$on('change.module', function(event, args) {
            if (typeof args.parent!=='undefined')
            {
                if(args.token==='505f0dde-0437-46ff-9d4d-0cbdf6cf4864')
                {
                    msNavigationService.saveItem('mv', {
                        title : 'NAVIGATION.MV',
                        state: 'app.mv',
                        group : true,
                        weight: 1,
                        hidden:false
                    });
                }
                else
                {
                    msNavigationService.saveItem('mv', {
                        title : 'NAVIGATION.MV',
                        state: 'app.mv',
                        group : true,
                        weight: 1,
                        hidden:true
                    });
                }
            }
        });
        if(typeof session.getUser() !== "undefined") {
            vm.user = session.getUser();
            vm.user.authentication = vm.user.username + ":" + vm.user.password;
            vm.currentModule=vm.user.currentModule;
           /* if(vm.currentModule==='505f0dde-0437-46ff-9d4d-0cbdf6cf4864' || vm.currentModule==='')
            {
                msNavigationService.saveItem('mv', {
                    title : 'NAVIGATION.MV',
                    state: 'app.mv',
                    group : true,
                    weight: 1,
                    hidden:false
                });
            }
            else
            {
                msNavigationService.saveItem('mv', {
                    title : 'NAVIGATION.MV',
                    state: 'app.mv',
                    group : true,
                    weight: 1,
                    hidden:true
                });
            }*/
            // Navigation
                msNavigationService.saveItem('admin', {
                    title : 'NAVIGATION.ADMINISTRATION',
                    state: 'app.admin',
                    group : true,
                    weight: 1
                });
        }
        
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
            $rootScope.loadingProgress = false;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            $rootScope.$broadcast('stop-timmer');
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });
        });

        $window.onpopstate = function(event) {
            $state.go(
              $state.current.name, 
              {},
              {reload:true, notify: false}
            );
        };

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
		
        // return;
        
        if (auth.isLoggedIn()) {
            if (vm.user.role === "level01" || vm.user.role === "level02") {
                $rootScope.logo = PRAGMA.url + "/home.png";
            }
            else {
                pragmaapi.callRestService(PRAGMA.api, "/users/" + vm.user.username + "/tenants", "", true, vm.user.authentication, "GET").then(function(res){
                    if (res.data[0].logoUrl !== "") {
                        $rootScope.logo = res.data[0].logoUrl;
                    }
                    else {
                        $rootScope.logo = PRAGMA.url + "/home.png";
                    }
                });
            }
            $rootScope.$broadcast('userLogo');
        }
        
        if (auth.isLoggedIn() || $location.url().match(/\/auth\//) || $location.url().match(/\/landing/) || $location.url().match(/\/change_pass/)) {
            return;
        }

        $window.location.href = PRAGMA.url + PRAGMA.loginPage;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('pragma')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/dashboard');
		
        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: 'app/core/layouts/horizontal-navigation.html',
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: 'app/navigation/layouts/horizontal-navigation/navigation.html',
                        controller : 'NavigationController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('pragma')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(pragmaTheming, session, auth, PRAGMA, pragmaapi, $cookies, $translate, $scope, $rootScope, $timeout, Notification)
    {
        var vm = this;

        // Data
        vm.themes = pragmaTheming.themes;
		if (auth.isLoggedIn()) {
            var expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + 365);
            vm.user = session.getUser();
            vm.user.authentication=vm.user.username+":"+vm.user.password;
            
			if (vm.user.hasVerticals)
            {
                pragmaapi.callRestService(PRAGMA.api, "/verticalSolutions/tenant/",  vm.user.currentTenant, true, vm.user.authentication, "GET", true, false).then(function(res) {
                    var solutions=res.data.results;
                    
					for(var i=0;i<solutions.length;i++)
                    {
                        if(solutions[i].token==vm.user.currentModule)
                        {
                            var tmp={
                                logo:solutions[i].logo,
                                token:solutions[i].token
                            };
							
                            setTimeout(function(){$rootScope.$broadcast('change.module.login',tmp);},500) 
                            break;
                        }
                    }
                });
            }
			
            pragmaapi.callRestService(PRAGMA.api, "/userPreferences/userId/" + vm.user.username+"/", "", true, vm.user.authentication, "GET", true, false).then(function(res) {
                vm.userPreferences=res.data;
                if (Object.keys(vm.userPreferences.palette).length !== 0) {
                    pragmaTheming.setActiveTheme(Object.keys(vm.userPreferences.palette)[0]);
                }
                
                // Language
                if (vm.userPreferences.language !== "") {
                    $translate.use(vm.userPreferences.language);
                    moment.locale(vm.userPreferences.language);
                    // Cookie
                    $cookies.put("lang", vm.userPreferences.language, {'expires': expireDate})
                    
                }
                else {
                    // Default language
                    $translate.use("en");
                    moment.locale("en");
                }
            });
            connectToSockets();
		}
        function connectToSockets()
        {
            if (PRAGMA.wsckUrl) {
                $rootScope.client = mqtt.connect(PRAGMA.wsckUrl, {keepalive: 120});
                $rootScope.client.on('connect', function () {
                    console.log('WebSocket Client Connected');
                    $rootScope.client.subscribe('/Notifications/' + vm.user.username);
                    $rootScope.client.subscribe('SiteWhere/OutBound/json');
                    $rootScope.client.on('message', function (topic, message) {
                        if(topic==='/Notifications/'+vm.user.username)
                        {
                            $rootScope.$broadcast('notifications.broadcast');
                        }
                        else if(topic==='SiteWhere/OutBound/json')
                        {
                            $rootScope.$broadcast('new.measurement.broadcast',JSON.parse(message));
                        }
                    });
                });
            }
        }
        function showNotification(title,message,type) {
            if(type==="Error")
            {
                Notification.error({
                    title:title,
                    message: message,
                    delay: null,
                    startTop: 20,
                    startRight: 10,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'right',
                    positionY: 'bottom',
                });
            }
            else if(type==="Info")
            {
                 Notification.info({
                    title:title,
                    message: message,
                    delay: null,
                    startTop: 20,
                    startRight: 10,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'right',
                    positionY: 'bottom',
                });
            }
            else if(type==="Warning")
            {
                 Notification.warning({
                    title:title,
                    message: message,
                    delay: null,
                    startTop: 20,
                    startRight: 10,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'right',
                    positionY: 'bottom',
                });
            }
            else if(type==="Success")
            {   
                 Notification.success({
                    title:title,
                    message: message,
                    delay: null,
                    startTop: 20,
                    startRight: 10,
                    verticalSpacing: 20,
                    horizontalSpacing: 20,
                    positionX: 'right',
                    positionY: 'bottom',
                });
            }
        }	
    }
})();
(function ()
{
    'use strict';

    angular
        .module('pragma')
		.constant("pragmaApp", {
			"title": "PRAGMA - Energy Portal"
		})
})();

(function ()
{
    'use strict';

    angular
        .module('pragma')
        .config(config);

    /** @ngInject */
    function config($translateProvider, $compileProvider, PRAGMA)
    {
        // Put your common app configurations here

        // angular-translate configuration
		$translateProvider
			.useStaticFilesLoader({
				prefix: 'assets/lang/locale-',
				suffix: '.json'
			})
			.fallbackLanguage('en')
			.preferredLanguage('en')
			.useSanitizeValueStrategy('sanitize');
		
        $compileProvider.debugInfoEnabled(PRAGMA.DEV);
		
    }

})();
(function ()
{
    'use strict';

    angular
        .module('pragma')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

		// Sitewhere
		api.sitewhereUrl = 'https://hydra.iti.gr/PRAGMA/sitewhere_api';
        api.sitewhere = {
			tenants		: $resource(api.sitewhereUrl + '/tenants'),
			sites		: $resource(api.sitewhereUrl + '/sites'),
			locations	: $resource(api.sitewhereUrl + '/locations'),
			getMeasurementsByLocation	: $resource(api.sitewhereUrl + '/mongo/',
				{
					get: {
						method: 'GET',
						params: {
							action: 'getMeasurementsByLocation'
						}
					}
				}
			),
			getAggregatedMeasurementsByLocation	: $resource(api.sitewhereUrl + '/mongo/',
				{
					get: {
						method: 'GET',
						params: {
							action: 'getAggregatedMeasurementsByLocation'
						}
					}
				}
			)
		};
		
        return api;
    }

})();
(function () {
    'use strict';
    
    angular
        .module('pragma')
        .constant('PRAGMA', getPRAGMAConstants());

    function getPRAGMAConstants() {
        
        var DEV = false;
        
        if (DEV) {
            var url = "http://160.40.51.222:3000";
            var pragma =  "https://smarthome.iti.gr:8443/api";
            var php = "https://hydra.iti.gr/API/index.php";
            var weather = "https://hydra.iti.gr/API/weather.php";
            var api = "https://smarthome.iti.gr:8443/api";
            var huba="https://smarthome.iti.gr:5002/huba";
            var wsckUrl="wss://smarthome.iti.gr:9091";
            var appliancesUrl="https://smarthome.iti.gr:8442/";
            var graphServer="https://hydra.iti.gr/graph-server";
            var pdfServer="https://smarteverything.gr/pdf-server/";
            var imagesURL="https://smarteverything.gr/directory-list/";
            var loginPage="/auth/login";
        }
        else {
            var url = "https://smarthome.iti.gr/platform";
            var pragma =  "https://smarthome.iti.gr:8443/api";
            var php = "https://hydra.iti.gr/API/index.php";
            var weather = "https://hydra.iti.gr/API/weather.php";
            var api = "https://smarthome.iti.gr:8443/api";
            var huba="https://smarthome.iti.gr:5002/huba";
            var wsckUrl="wss://smarthome.iti.gr:9091";
            var appliancesUrl="https://smarthome.iti.gr:8442/";
            var graphServer="https://hydra.iti.gr/graph-server";
            var pdfServer="https://smarteverything.gr/pdf-server/";
            var imagesURL="https://smarteverything.gr/directory-list/";
            var loginPage="/auth/login";
        }
        
        var PRAGMA = {
                url: url,
                pragma: pragma,
                php: php,
                weather: weather,
                api: api,
                wsckUrl:wsckUrl,
                loginPage:loginPage,
                appliancesUrl:appliancesUrl,
                graphServer:graphServer,
                pdfServer:pdfServer,
                DEV:DEV,
                huba:huba,
                imagesURL:imagesURL
            };
        return PRAGMA;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.change_pass', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.change_pass', {
            url      : '/change_pass/:token',
			params   : {name: null},
            views    : {
                'main@'              : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.change_pass': {
                    templateUrl: 'app/main/change_pass/change_pass.html',
                    controller : 'ChangePassController as vm'
                }
            },
            data: {
                requireLogin: false
            },
            bodyClass: 'changePass'
        });
		
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth', [
            'app.auth.login'
        ])
        .config(config);

    /** @ngInject */
    function config()
    {
    }
    
})();
angular.module("pragma").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-2dp background-image md-background-bg md-hue-1\" layout=\"column\" \nlayout-align=\"space-between start\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" \nui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation-wrapper\" layout=\"column\" layout-align=\"end end\"><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" flex></div></div></div><div id=\"header-container\" \nclass=\"md-whiteframe-3dp md-background-bg md-hue-1 grocery-hack\" layout=\"column\" \nng-controller=\"VerticalSolutionsController as vm\"><md-tabs ng-if=\"vm.showModules\" md-selected=\"vm.selectedIndex\">\n<md-tab ng-repeat=\"solution in vm.solutions\" ng-click=\"vm.changeVerticalSolution(solution)\"><md-tab-label><span>smart\n</span> <span style=\"color: {{solution.color}}\">{{solution.notsmart}}</span></md-tab-label></md-tab><md-tab></md-tab>\n</md-tabs></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"md-primary-bg md-hue-3\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/theme-options/theme-options.html","");
$templateCache.put("app/directives/bloodpressure-card/bloodpressure-card.html","<div flex layout=\"row\"><div flex=\"30\" layout=\"column\"><md-icon md-font-icon=\"pragma-icon-blood-pressure\" \nng-style=\"{\'color\':vm.widget.graph.fontColor}\"></md-icon></div><div flex=\"70\" layout=\"column\"><div flex><h2 \nng-style=\"{\'color\':vm.widget.graph.fontColor}\">\n{{vm.device.measurements.systolic}} / {{vm.device.measurements.diastolic}} <span>{{vm.device.specs.systolic.unit}}\n</span></h2><p ng-style=\"{\'color\':vm.labelColor}\">\n{{vm.device.specs.systolic.friendlyName}} / {{vm.device.specs.diastolic.friendlyName}}</p></div><div flex><h2 \nng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.device.measurements.pulse}} <span>{{vm.device.specs.pulse.unit}}\n</span></h2><p ng-style=\"{\'color\':vm.labelColor}\">{{vm.device.specs.pulse.friendlyName}}</p></div></div></div><div \nclass=\"timestamp\" ng-style=\"{\'color\':vm.dateColor}\">{{vm.device.measurements.timestamp | date:\'dd/MM/yyyy h:mma\'}}\n</div>");
$templateCache.put("app/directives/consumption-production/consumption-production.html","<div class=\"consumptionProduction\"><div ng-style=\"{\'color\':vm.widget.graph.fontColor}\" layout=\"row\" \nstyle=\"padding: 0 20px\"><div layout=\"column\" flex=\"25\" ng-if=\"vm.widget.graph.total\"><div class=\"measureTitle\">\n{{ \'DASHBOARD.TOTAL\' | translate }}</div><div class=\"measureText\">{{vm.metadata.total | number:2 }} <span \nclass=\"measureUnit\">{{vm.unit}} </span></div></div><div layout=\"column\" flex=\"25\" ng-if=\"vm.widget.graph.average\"><div \nclass=\"measureTitle\">{{ \'DASHBOARD.AVERAGE\' | translate }}</div><div class=\"measureText\">\n{{vm.metadata.mean | number:2 }} <span class=\"measureUnit\">{{vm.unit}} </span></div></div><div layout=\"column\" \nflex=\"25\" ng-if=\"vm.widget.graph.min\"><div class=\"measureTitle\">{{ \'DASHBOARD.MIN\' | translate }}</div><div \nclass=\"measureText\">{{vm.metadata.min | number:2 }} <span class=\"measureUnit\">{{vm.unit}} </span></div></div><div \nlayout=\"column\" flex=\"25\" ng-if=\"vm.widget.graph.max\"><div class=\"measureTitle\">{{ \'DASHBOARD.MAX\' | translate }}</div>\n<div class=\"measureText\">{{vm.metadata.max | number:2 }} <span class=\"measureUnit\">{{vm.unit}} </span></div></div>\n</div><div layout=\"row\" style=\"margin-top:10px\" \nng-if=\"!vm.widget.graph.total && !vm.widget.graph.average && !vm.widget.graph.min && !vm.widget.graph.max\"><canvas \nheight=\"230\" id=\"chart-aggregated\" class=\"chart chart-bar\" chart-data=\"vm.result.chart.data\" \nchart-labels=\"vm.result.chart.labels\" chart-options=\"vm.result.chart.options\" chart-series=\"vm.result.chart.series\" \nchart-colors=\"vm.result.chart.colors\" chart-dataset-override=\"vm.result.chart.override\"></canvas></div><div \nlayout=\"row\" style=\"margin-top:10px\" \nng-if=\"vm.widget.graph.total || vm.widget.graph.average || vm.widget.graph.min || vm.widget.graph.max\"><canvas \nheight=\"230\" id=\"chart-aggregated\" class=\"chart chart-bar\" chart-data=\"vm.result.chart.data\" \nchart-labels=\"vm.result.chart.labels\" chart-options=\"vm.result.chart.options\" chart-series=\"vm.result.chart.series\" \nchart-colors=\"vm.result.chart.colors\" chart-dataset-override=\"vm.result.chart.override\"></canvas></div></div>");
$templateCache.put("app/directives/doorsensor-card/doorsensor-card.html","<div flex layout=\"row\"><div ng-repeat=\"device in vm.devices track by $index\" flex layout=\"column\"><div flex><md-icon \nflex ng-if=\"!device.measurements.doorAlarm || device.measurements.doorAlarm===0\" md-font-icon=\"pragma-icon-door-close\" \nclass=\"door-closed\"></md-icon><md-icon flex ng-if=\"device.measurements.doorAlarm===1\" \nmd-font-icon=\"pragma-icon-door-open\" class=\"door-open\"></md-icon></div><div flex><p>{{device.name}}</p><div \nclass=\"timestamp\" ng-style=\"{\'color\':vm.dateColor}\">{{device.measurements.timestamp | date:\'dd/MM/yyyy h:mma\'}}</div>\n</div></div></div>");
$templateCache.put("app/directives/entries-exits/entries-exits.html","<div id=\"entriesExits\"><div style=\"color:{{vm.widget.graph.entriesColor}};margin-bottom:15px\"><md-icon \nmd-font-icon=\"icon-share\" style=\"color:{{vm.widget.graph.entriesColor}}\"></md-icon><span \nng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.result.entries}} Entries</span></div><div \nstyle=\"color:{{vm.widget.graph.exitsColor}}\"><md-icon md-font-icon=\"icon-reply\" \nstyle=\"color:{{vm.widget.graph.exitsColor}}\"></md-icon><span ng-style=\"{\'color\':vm.widget.graph.fontColor}\">\n{{vm.result.exits}} Exits</span></div><div class=\"dates\" ng-style=\"{\'color\':vm.dateColor}\">\n{{vm.dateResult | date:\'dd/MM/yyyy h:mma\'}}</div></div>");
$templateCache.put("app/directives/entries-exits-plot/entries-exits-plot.html","<div id=\"entriesExitsPlot\"><div ng-style=\"{\'color\':vm.widget.graph.fontColor}\" layout=\"row\" style=\"padding: 0 20px\">\n<div layout=\"column\" flex=\"25\" ng-if=\"vm.widget.graph.total\"><div class=\"measureTitle\">\n{{ \'DASHBOARD.TOTAL\' | translate }}</div><div class=\"measureText\">{{vm.metadata.total | number:2 }} <span \nclass=\"measureUnit\">{{vm.result.unit}} </span></div></div><div layout=\"column\" flex=\"25\" \nng-if=\"vm.widget.graph.average\"><div class=\"measureTitle\">{{ \'DASHBOARD.AVERAGE\' | translate }}</div><div \nclass=\"measureText\">{{vm.metadata.avg | number:2 }} <span class=\"measureUnit\">{{vm.result.unit}} </span></div></div>\n<div layout=\"column\" flex=\"25\" ng-if=\"vm.widget.graph.min\"><div class=\"measureTitle\">{{ \'DASHBOARD.MIN\' | translate }}\n</div><div class=\"measureText\">{{vm.metadata.min | number:2 }} <span class=\"measureUnit\">{{vm.result.unit}} </span>\n</div></div><div layout=\"column\" flex=\"25\" ng-if=\"vm.widget.graph.max\"><div class=\"measureTitle\">\n{{ \'DASHBOARD.MAX\' | translate }}</div><div class=\"measureText\">{{vm.metadata.max | number:2 }} <span \nclass=\"measureUnit\">{{vm.result.unit}} </span></div></div></div><div layout=\"row\" style=\"margin-top:10px\" \nng-if=\"!vm.widget.graph.total && !vm.widget.graph.average && !vm.widget.graph.min && !vm.widget.graph.max\"><canvas \nheight=\"230\" id=\"chart-aggregated\" class=\"chart chart-bar\" chart-data=\"vm.result.chart.data\" \nchart-labels=\"vm.result.chart.labels\" chart-options=\"vm.result.chart.options\" chart-series=\"vm.result.chart.series\" \nchart-colors=\"vm.result.chart.colors\" chart-dataset-override=\"vm.result.chart.override\"></canvas></div><div \nlayout=\"row\" style=\"margin-top:10px\" \nng-if=\"vm.widget.graph.total || vm.widget.graph.average || vm.widget.graph.min || vm.widget.graph.max\"><canvas \nheight=\"230\" id=\"chart-aggregated\" class=\"chart chart-bar\" chart-data=\"vm.result.chart.data\" \nchart-labels=\"vm.result.chart.labels\" chart-options=\"vm.result.chart.options\" chart-series=\"vm.result.chart.series\" \nchart-colors=\"vm.result.chart.colors\" chart-dataset-override=\"vm.result.chart.override\"></canvas></div></div>");
$templateCache.put("app/directives/floor-plan/floor-plan.html","<div class=\"pl-16 pr-16 pb-8\" layout=\"column\" id=\"floorPlan\"><div id=\"{{vm.plotId}}\"></div><div layout=\"row\" \nlayout-align=\"start center\" flex><small>Low</small><div class=\"grad ml-8 mr-8\" flex></div><small>High</small></div>\n</div>");
$templateCache.put("app/directives/fridge-ditector/fridge-ditector.html","<div id=\"fridgeDitector\"><div layout=\"row\"><div flex class=\"titles\" style=\"color:{{ vm.fontColor}}\">Shelves</div><div \nflex class=\"titles\" style=\"color:{{ vm.fontColor}}\">Door</div></div><div layout=\"row\"><div flex class=\"fridgeOut\"><div \nlayout=\"row\" ng-repeat=\"r in vm.fridge.shelf track by $index\" class=\"selvesOut\" \nstyle=\"background-color:{{ vm.gridLinesColor}}\"><div flex ng-repeat=\"c in vm.fridge.shelf[$index]\" class=\"selvesIn\">\n<md-icon md-font-icon=\"pragma-icon-{{c.name}}\" style=\"color:{{c.color}}\"></md-icon></div></div></div><div flex \nclass=\"fridgeOut\" style=\"margin-left:1%\"><div layout=\"row\" ng-repeat=\"r in vm.fridge.door track by $index\" \nclass=\"selvesOut\" style=\"background-color:{{ vm.gridLinesColor}}\"><div flex ng-repeat=\"c in vm.fridge.door[$index]\" \nclass=\"selvesIn\"><md-icon md-font-icon=\"pragma-icon-{{c.name}}\" style=\"color:{{c.color}}\"></md-icon></div></div></div>\n</div><div layout=\"row\"><div flex class=\"titles\" style=\"margin-top:5%;color:{{ vm.fontColor}}\">Missing</div></div><div \nlayout=\"row\" class=\"missing\" style=\"background-color:{{ vm.gridLinesColor}}\"><div flex \nng-repeat=\"c in vm.fridge.missing\" class=\"selvesIn\"><md-icon md-font-icon=\"pragma-icon-{{c.name}}\" \nstyle=\"color:{{c.color}}\"></md-icon></div></div><div class=\"dates\" ng-style=\"{\'color\':vm.fontColor}\">\n{{vm.date | date:\'dd/MM/yyyy h:mma\'}}</div></div>");
$templateCache.put("app/directives/gauge-card/gauge-card.html","<div id=\"gaugeCard\"><ng-gauge ng-if=\"vm.max!=0\" type=\"{{vm.widget.graph.style}}\" thick=\"{{vm.widget.graph.thick}}\" \nmin=\"0\" max=\"vm.max\" value=\"vm.result\" cap=\"{{vm.widget.graph.cap}}\" label=\"Total: {{vm.max | number: 1}} {{vm.unit}}\" \nforeground-color=\"{{vm.widget.graph.foregroundColor}}\" background-color=\"{{vm.widget.graph.backgroundColor}}\" \nappend=\"{{vm.unit}}\"></ng-gauge><div ng-if=\"vm.max==0\"><md-icon md-font-icon=\"{{vm.icon}}\" \nstyle=\"color:{{vm.widget.graph.foregroundColor}};font-size:40px;margin-bottom:25px;margin-right:20px\"></md-icon><div \nng-style=\"{\'color\':vm.widget.graph.foregroundColor}\">{{vm.result}} {{vm.unit}}</div></div></div>");
$templateCache.put("app/directives/glucose-card/glucose-card.html","<div flex layout=\"row\"><div flex=\"30\" layout=\"column\"><md-icon md-font-icon=\"pragma-icon-glucose\" \nng-style=\"{\'color\':vm.widget.graph.fontColor}\"></md-icon></div><div flex=\"70\" layout=\"column\"><div flex \nng-repeat=\"(key, value) in vm.device.specs track by $index\" ng-if=\"key===\'glucose\' || key===\'glucoseType\'\"><h2 \nng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.device.measurements[key]}} <span>{{value.unit}}</span></h2><p \nng-style=\"{\'color\':vm.labelColor}\">{{value.friendlyName}}</p></div></div></div><div class=\"timestamp\" \nng-style=\"{\'color\':vm.dateColor}\">{{vm.device.measurements.timestamp | date:\'dd/MM/yyyy h:mma\'}}</div>");
$templateCache.put("app/directives/ha-dishwasher/ha-dishwasher.html","<div class=\"pl-16 pr-16 pb-8\" layout=\"column\" id=\"ha-dishwasher\"><div layout=\"column\" class=\"p-8 pt-16\" \nlayout-align=\"center center\" ng-if=\"vm.dishwasher.operationState === \'Aborting\'\"><md-icon \nmd-font-icon=\"pragma-icon-aborting\" class=\"open icon-size-72\" aria-hidden=\"true\"></md-icon><span \nclass=\"p-8 font-size-20\"><span translate=\"DASHBOARD.WIDGET.MESSAGE.ACTIVATED\">The activated program </span>\n({{vm.Progs[vm.dishwasher.program].name}})<span translate=\"DASHBOARD.WIDGET.MESSAGE.ABORTING\"> is currently aborting.\n</span></span> <span class=\"p-8 font-size-20\" translate=\"DASHBOARD.WIDGET.MESSAGE.PLEASE_WAIT\">Please wait...</span>\n</div><div layout=\"column\" class=\"p-8 pt-16\" layout-align=\"center center\" \nng-if=\"vm.dishwasher.operationState === \'Disconnected\'\"><md-icon md-font-icon=\"icon-close-network\" \nclass=\"open icon-size-72\" aria-hidden=\"true\"></md-icon><span class=\"p-8 font-size-20\" \ntranslate=\"DASHBOARD.WIDGET.MESSAGE.DISCONNECTED\">Cannot connect to the appliance. Possibly disconnected from network.\n</span></div><div class=\"pt-8\" layout=\"column\" ng-if=\"vm.evaluate()\"><div class=\"mb-16\" layout-gt-sm=\"row\" \nlayout=\"column\" layout-align=\"center center\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"progress_container\"><div class=\"progress_icon\"><md-icon md-font-icon=\"{{vm.Progs[vm.dishwasher.program].icon}}\" \nclass=\"icon program icon-size-72\" aria-hidden=\"true\"></md-icon></div><md-progress-circular md-mode=\"determinate\" \nmd-diameter=\"110\" value=\"{{vm.dishwasher.progress}}\"></md-progress-circular></div><div class=\"mt-8\" \nstyle=\"color: #259de1\"><span ng-if=\"vm.dishwasher.operationState===\'Ready\'\">~{{vm.dishwasher.remainingProgramTime}} \n<span translate=\"DASHBOARD.WIDGET.MINS\">minutes</span></span> <span ng-if=\"vm.dishwasher.operationState===\'Run\'\">\n~{{vm.dishwasher.remainingProgramTime}} <span translate=\"DASHBOARD.WIDGET.MINS\">minutes</span></span><div \nng-if=\"vm.dishwasher.operationState===\'DelayedStart\'\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"DASHBOARD.WIDGET.START_IN\">Program will start in:</span> <span>~{{vm.dishwasher.startInRelative}} <span \ntranslate=\"DASHBOARD.WIDGET.MINS\">minutes</span></span></div><span ng-if=\"vm.dishwasher.operationState===\'Finished\'\" \ntranslate=\"DASHBOARD.WIDGET.FINISHED\">Program has finished</span></div></div><div layout=\"column\" \nclass=\"pt-24 pb-24 ml-8 mr-8 middle_col\" layout-align=\"center center\" flex><md-icon \nmd-font-icon=\"pragma-icon-electricity\" class=\"icon consumption icon-size-48\" aria-hidden=\"true\"></md-icon><span \nclass=\"mt-8 font-size-32 consumption\">{{vm.dishwasher.consumption}} <span>W</span></span></div><div layout=\"column\" \nlayout-align=\"center center\" flex><div layout=\"row\" layout-align=\"center center\" class=\"pt-8 pb-8\" \nng-if=\"vm.dishwasher.doorState == \'0\'\"><md-icon md-font-icon=\"pragma-icon-dishwasher-door-closed\" \nclass=\"closed icon-size-48\" aria-hidden=\"true\"></md-icon><span class=\"ml-16\" style=\"white-space: nowrap\">\n{{vm.dState[vm.dishwasher.doorState]}}</span></div><div layout=\"row\" layout-align=\"center center\" class=\"pt-8 pb-8\" \nng-if=\"vm.dishwasher.doorState == \'1\'\"><md-icon md-font-icon=\"pragma-icon-dishwasher-door-open\" \nclass=\"open icon-size-48\" aria-hidden=\"true\"></md-icon><span class=\"ml-16\" style=\"white-space: nowrap\">\n{{vm.dState[vm.dishwasher.doorState]}}</span></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"pt-8 pb-8\"><span style=\"white-space: nowrap\" ng-if=\"vm.dishwasher.powerState === true\" \ntranslate=\"DASHBOARD.WIDGET.ACTIVE\">Active (switched on)</span> <span style=\"white-space: nowrap\" \nng-if=\"vm.dishwasher.powerState === false\" translate=\"DASHBOARD.WIDGET.OFF\">Inactive (switched off)</span><md-switch \nng-disabled=\"vm.user.username === \'siemens-user\'\" class=\"m-0\" style=\"margin-left: 8px !important\" \nng-model=\"vm.dishwasher.powerState\" aria-label=\"Dishwasher Power\" \nng-change=\"vm.ChangePowerState(vm.dishwasher.powerState)\"></md-switch></div></div></div><div carousel3d \nng-if=\"vm.user.username != \'siemens-user\'\" ng-model=\"vm.slides\" options=\"vm.options\" \non-selected-click=\"vm.selectedClick(index)\"><div carousel3d-slide layout=\"column\" layout-align=\"start stretch\" \nng-repeat=\"Prog in vm.slides track by $index\" ng-class=\"vm.CheckSlideClass(Prog.key)\" style=\"cursor: pointer\"><div \nlayout=\"row\" layout-align=\"space-between start\" class=\"p-8\"><span><md-icon md-font-icon=\"{{Prog.icon}}\" \nclass=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon>({{Prog.name}})</span><div \nng-if=\"vm.dishwasher.powerState\"><md-button aria-label=\"Start Program\" class=\"md-icon-button\" \nng-click=\"doOptionsAction($event, Prog)\" \nng-if=\"selectedProg == Prog.key && vm.disStart == true && vm.dishwasher.operationState !== \'Finished\'\"><md-tooltip \nmd-direction=\"top\"><span translate=\"DASHBOARD.WIDGET.START\">Start Program</span></md-tooltip><md-icon \nmd-font-icon=\"icon-play\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button><md-button aria-label=\"Stop Program\" \nclass=\"md-icon-button\" ng-click=\"vm.StopProgram()\" ng-if=\"selectedProg == Prog.key && vm.disStart == false\"><md-tooltip\n md-direction=\"top\"><span translate=\"DASHBOARD.WIDGET.STOP\">Stop Program</span></md-tooltip><md-icon \nmd-font-icon=\"icon-stop\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button></div></div><md-divider></md-divider>\n<div class=\"pl-8 pr-8 pt-8\" layout=\"column\" layout-align=\"start start\" ms-scroll flex><span class=\"mb-8\" \ntranslate=\"DASHBOARD.WIDGET.PROGRAM_DESCR\">Program description:</span> <span>{{Prog.descr}}</span></div></div></div>\n<div carousel3d ng-if=\"vm.user.username === \'siemens-user\'\" ng-model=\"vm.slides\" options=\"vm.options\"><div \ncarousel3d-slide layout=\"column\" layout-align=\"start stretch\" ng-repeat=\"Prog in vm.slides track by $index\" \nng-class=\"vm.CheckSlideClass(Prog.key)\"><div layout=\"row\" layout-align=\"space-between start\" class=\"p-8\"><span><md-icon\n md-font-icon=\"{{Prog.icon}}\" class=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon>({{Prog.name}})</span>\n</div><md-divider></md-divider><div class=\"pl-8 pr-8 pt-8\" layout=\"column\" layout-align=\"start start\" ms-scroll flex>\n<span class=\"mb-8\" translate=\"DASHBOARD.WIDGET.PROGRAM_DESCR\">Program description:</span> <span>{{Prog.descr}}</span>\n</div></div></div></div></div>");
$templateCache.put("app/directives/ha-dryer/ha-dryer.html","<div class=\"pl-16 pr-16 pb-8\" layout=\"column\" id=\"ha-dryer\"><div layout=\"column\" class=\"p-8 pt-16\" \nlayout-align=\"center center\" ng-if=\"vm.dryer.operationState === \'Aborting\'\"><md-icon \nmd-font-icon=\"pragma-icon-aborting\" class=\"open icon-size-72\" aria-hidden=\"true\"></md-icon><span \nclass=\"p-8 font-size-20\"><span translate=\"DASHBOARD.WIDGET.MESSAGE.ACTIVATED\">The activated program </span>\n({{vm.Progs[vm.dryer.program].name}})<span translate=\"DASHBOARD.WIDGET.MESSAGE.ABORTING\"> is currently aborting.</span>\n</span> <span class=\"p-8 font-size-20\" translate=\"DASHBOARD.WIDGET.MESSAGE.PLEASE_WAIT\">Please wait...</span></div><div\n layout=\"column\" class=\"p-8 pt-16\" layout-align=\"center center\" ng-if=\"vm.dryer.operationState === \'Disconnected\'\">\n<md-icon md-font-icon=\"icon-close-network\" class=\"open icon-size-72\" aria-hidden=\"true\"></md-icon><span \nclass=\"p-8 font-size-20\" translate=\"DASHBOARD.WIDGET.MESSAGE.DISCONNECTED_OFF\">\nCannot connect to the appliance. Possibly disconnected from network or appliance is switched off.</span></div><div \nclass=\"pt-8\" layout=\"column\" ng-if=\"vm.evaluate()\"><div class=\"mb-16\" layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"center center\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"progress_container\"><div class=\"progress_icon\"><md-icon md-font-icon=\"{{vm.Progs[vm.dryer.program].icon}}\" \nclass=\"icon program icon-size-72\" aria-hidden=\"true\"></md-icon></div><md-progress-circular md-mode=\"determinate\" \nmd-diameter=\"110\" value=\"{{vm.dryer.progress}}\"></md-progress-circular></div><div class=\"mt-8\" style=\"color: #259de1\">\n<span ng-if=\"vm.dryer.operationState===\'Ready\'\">~{{vm.dryer.finishInRelative}} <span translate=\"DASHBOARD.WIDGET.MINS\">\nminutes</span></span> <span ng-if=\"vm.dryer.operationState===\'Run\'\">~{{vm.dryer.remainingProgramTime}} <span \ntranslate=\"DASHBOARD.WIDGET.MINS\">minutes</span></span> <span ng-if=\"vm.dryer.operationState===\'Finished\'\" \ntranslate=\"DASHBOARD.WIDGET.FINISHED\">Program has finished</span></div></div><div layout=\"column\" \nclass=\"pt-24 pb-24 ml-8 mr-8 middle_col\" layout-align=\"center center\" flex><md-icon \nmd-font-icon=\"pragma-icon-electricity\" class=\"icon consumption icon-size-48\" aria-hidden=\"true\"></md-icon><span \nclass=\"mt-8 font-size-32 consumption\">{{vm.dryer.consumption}} <span>W</span></span></div><div layout=\"column\" \nlayout-align=\"center center\" flex><div layout=\"row\" layout-align=\"center center\" class=\"pt-8 pb-8\" \nng-if=\"vm.dryer.doorState == \'0\'\"><md-icon md-font-icon=\"pragma-icon-washer-door-closed\" class=\"closed icon-size-48\" \naria-hidden=\"true\"></md-icon><span class=\"ml-16\" style=\"white-space: nowrap\">{{vm.dState[vm.dryer.doorState]}}</span>\n</div><div layout=\"row\" layout-align=\"center center\" class=\"pt-8 pb-8\" ng-if=\"vm.dryer.doorState == \'1\'\"><md-icon \nmd-font-icon=\"pragma-icon-washer-door-open\" class=\"open icon-size-48\" aria-hidden=\"true\"></md-icon><span class=\"ml-16\" \nstyle=\"white-space: nowrap\">{{vm.dState[vm.dryer.doorState]}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"pt-8 pb-8\"><span style=\"white-space: nowrap\" \nng-if=\"vm.dryer.powerState === true\" translate=\"DASHBOARD.WIDGET.ACTIVE\">Active (switched on)</span> <span \nstyle=\"white-space: nowrap\" ng-if=\"vm.dryer.powerState === false\" translate=\"DASHBOARD.WIDGET.OFF\">\nInactive (switched off)</span><md-tooltip md-direction=\"top\"><span translate=\"DASHBOARD.WIDGET.MESSAGE.SWITCH_OFF\">\nIf you switch off this device, it can only be activated again locally!</span></md-tooltip><md-switch class=\"m-0\" \nstyle=\"margin-left: 8px !important\" ng-model=\"vm.dryer.powerState\" \nng-disabled=\"!vm.dryer.powerState || vm.user.username === \'siemens-user\'\" aria-label=\"Dryer Power\" \nng-change=\"vm.ChangePowerState(vm.dryer.powerState)\"></md-switch></div></div></div><div carousel3d \nng-if=\"vm.user.username != \'siemens-user\'\" ng-model=\"vm.slides\" options=\"vm.options\" \non-selected-click=\"vm.selectedClick(index)\"><div carousel3d-slide layout=\"column\" layout-align=\"start stretch\" \nng-repeat=\"Prog in vm.slides track by $index\" ng-class=\"vm.CheckSlideClass(Prog.key)\" style=\"cursor: pointer\"><div \nlayout=\"row\" layout-align=\"space-between start\" class=\"p-8\"><span><md-icon md-font-icon=\"{{Prog.icon}}\" \nclass=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon>({{Prog.name}})</span><div ng-if=\"vm.dryer.powerState\">\n<md-button aria-label=\"Start Program\" class=\"md-icon-button\" \nng-click=\"doOptionsAction($event, Prog, vm.dryer.dryingTarget)\" \nng-if=\"selectedProg == Prog.key && vm.disStart == true && vm.dryer.operationState !== \'Finished\'\"><md-tooltip \nmd-direction=\"top\"><span translate=\"DASHBOARD.WIDGET.START\">Start Program</span></md-tooltip><md-icon \nmd-font-icon=\"icon-play\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button><md-button aria-label=\"Stop Program\" \nclass=\"md-icon-button\" ng-click=\"vm.StopProgram()\" ng-if=\"selectedProg == Prog.key && vm.disStart == false\"><md-tooltip\n md-direction=\"top\"><span translate=\"DASHBOARD.WIDGET.STOP\">Stop Program</span></md-tooltip><md-icon \nmd-font-icon=\"icon-stop\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button></div></div><md-divider></md-divider>\n<div class=\"pl-8 pr-8 pt-8\" layout=\"column\" layout-align=\"start start\" ms-scroll flex><span class=\"mb-8\" \ntranslate=\"DASHBOARD.WIDGET.PROGRAM_DESCR\">Program description:</span> <span>{{Prog.descr}}</span></div></div></div>\n<div carousel3d ng-if=\"vm.user.username === \'siemens-user\'\" ng-model=\"vm.slides\" options=\"vm.options\"><div \ncarousel3d-slide layout=\"column\" layout-align=\"start stretch\" ng-repeat=\"Prog in vm.slides track by $index\" \nng-class=\"vm.CheckSlideClass(Prog.key)\"><div layout=\"row\" layout-align=\"space-between start\" class=\"p-8\"><span><md-icon\n md-font-icon=\"{{Prog.icon}}\" class=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon>({{Prog.name}})</span>\n</div><md-divider></md-divider><div class=\"pl-8 pr-8 pt-8\" layout=\"column\" layout-align=\"start start\" ms-scroll flex>\n<span class=\"mb-8\" translate=\"DASHBOARD.WIDGET.PROGRAM_DESCR\">Program description:</span> <span>{{Prog.descr}}</span>\n</div></div></div></div></div>");
$templateCache.put("app/directives/ha-fridge/ha-fridge.html","<div class=\"pl-16 pr-16 pb-8\" layout=\"column\" id=\"ha-fridge\"><div layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"center center\" flex><div layout=\"column\" class=\"pt-24 pb-24 ml-8 mr-8 middle_col\" \nlayout-align=\"center center\" flex><md-icon md-font-icon=\"pragma-icon-electricity\" \nclass=\"icon consumption icon-size-48\" aria-hidden=\"true\"></md-icon><span class=\"mt-8 font-size-32 consumption\">\n{{vm.fridge.consumption}} <span>W</span></span></div><div layout=\"column\" layout-align=\"center center\" flex><div \nlayout=\"column\" layout-align=\"center center\" class=\"pt-8 pb-8\" ng-if=\"vm.fridge.doorState == \'0\'\"><md-icon \nmd-font-icon=\"pragma-icon-fridge-door-closed\" class=\"closed icon-size-48\" aria-hidden=\"true\"></md-icon><span \nclass=\"mt-16\">{{vm.dState[vm.fridge.doorState]}}</span></div><div layout=\"column\" layout-align=\"center center\" \nclass=\"pt-8 pb-8\" ng-if=\"vm.fridge.doorState == \'1\'\"><md-icon md-font-icon=\"pragma-icon-fridge-door-open\" \nclass=\"open icon-size-48\" aria-hidden=\"true\"></md-icon><span class=\"mt-16\">{{vm.dState[vm.fridge.doorState]}}</span>\n</div></div></div><md-divider></md-divider><div layout=\"row\" class=\"p-8\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"blue-400-fg ml-8\" md-font-icon=\"pragma-icon-fridge-temp\" \naria-hidden=\"true\"></md-icon><span class=\"ml-8\" translate=\"DASHBOARD.WIDGET.FRIDGE\">Fridge</span></div><div \nng-if=\"vm.user.username != \'siemens-user\'\" ng-click=\"vm.ChangeInpState(\'fridge\')\" ng-show=\"vm.FridgeShow\">\n{{vm.fridge.tempFridge}} °C</div><div ng-if=\"vm.user.username === \'siemens-user\'\" ng-show=\"vm.FridgeShow\">\n{{vm.fridge.tempFridge}} °C</div><div ng-hide=\"vm.FridgeShow\" layout=\"row\" layout-align=\"end center\">\n<md-input-container class=\"md-block m-0\"><input ng-model=\"vm.fridge.tempFridge\" type=\"number\" step=\"1\" min=\"2\" max=\"8\" \nng-blur=\"vm.ChangeInpState(\'fridge\', vm.fridge.tempFridge)\" aria-label=\"Fridge Temp\"></md-input-container><span>°C\n</span></div></div><div layout=\"row\" class=\"p-8\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"cyan-800-fg ml-8\" md-font-icon=\"pragma-icon-freezer-temp\" \naria-hidden=\"true\"></md-icon><span class=\"ml-8\" translate=\"DASHBOARD.WIDGET.FREEZER\">Freezer</span></div><div \nng-if=\"vm.user.username != \'siemens-user\'\" ng-click=\"vm.ChangeInpState(\'freezer\')\" ng-show=\"vm.FreezerShow\">\n{{vm.fridge.tempFreezer}} °C</div><div ng-if=\"vm.user.username === \'siemens-user\'\" ng-show=\"vm.FreezerShow\">\n{{vm.fridge.tempFreezer}} °C</div><div ng-hide=\"vm.FreezerShow\" layout=\"row\" layout-align=\"end center\">\n<md-input-container class=\"md-block m-0\"><input ng-model=\"vm.fridge.tempFreezer\" type=\"number\" step=\"1\" min=\"-24\" \nmax=\"-16\" ng-blur=\"vm.ChangeInpState(\'freezer\', vm.fridge.tempFreezer)\" aria-label=\"Freezer Temp\"></md-input-container>\n<span>°C</span></div></div><md-divider></md-divider><div layout=\"row\" class=\"p-8\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\"><md-icon class=\"blue-400-fg ml-8\" \nmd-font-icon=\"pragma-icon-fridge-supercooling\" aria-hidden=\"true\"></md-icon><span class=\"ml-8\" \ntranslate=\"DASHBOARD.WIDGET.FRIDGE_SUPER\">Fridge Super Cooling</span></div><md-switch \nng-disabled=\"vm.user.username === \'siemens-user\'\" class=\"m-0\" ng-model=\"vm.fridge.superModeRefrigerator\" \naria-label=\"Fridge Super Cooling Switch\" ng-change=\"vm.ChangeSuperState(\'fridge\', vm.fridge.superModeRefrigerator)\">\n</md-switch></div><div layout=\"row\" class=\"p-8\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"cyan-800-fg ml-8\" md-font-icon=\"pragma-icon-freezer-supercooling\" \naria-hidden=\"true\"></md-icon><span class=\"ml-8\" translate=\"DASHBOARD.WIDGET.FREEZER_SUPER\">Freezer Super Cooling</span>\n</div><md-switch ng-disabled=\"vm.user.username === \'siemens-user\'\" class=\"m-0\" ng-model=\"vm.fridge.superModeFreezer\" \naria-label=\"Freezer Super Cooling Switch\" ng-change=\"vm.ChangeSuperState(\'freezer\', vm.fridge.superModeFreezer)\">\n</md-switch></div></div>");
$templateCache.put("app/directives/ha-laundry/ha-laundry.html","<div class=\"pl-16 pr-16 pb-8\" layout=\"column\" id=\"ha-laundry\"><div layout=\"column\" class=\"p-8 pt-16\" \nlayout-align=\"center center\" ng-if=\"vm.laundry.operationState === \'Aborting\'\"><md-icon \nmd-font-icon=\"pragma-icon-aborting\" class=\"open icon-size-72\" aria-hidden=\"true\"></md-icon><span \nclass=\"p-8 font-size-20\"><span translate=\"DASHBOARD.WIDGET.MESSAGE.ACTIVATED\">The activated program </span>\n({{vm.Progs[vm.laundry.program].name}})<span translate=\"DASHBOARD.WIDGET.MESSAGE.ABORTING\"> is currently aborting.\n</span></span> <span class=\"p-8 font-size-20\" translate=\"DASHBOARD.WIDGET.MESSAGE.PLEASE_WAIT\">Please wait...</span>\n</div><div layout=\"column\" class=\"p-8 pt-16\" layout-align=\"center center\" \nng-if=\"vm.laundry.operationState === \'Disconnected\'\"><md-icon md-font-icon=\"icon-close-network\" \nclass=\"open icon-size-72\" aria-hidden=\"true\"></md-icon><span class=\"p-8 font-size-20\" \ntranslate=\"DASHBOARD.WIDGET.MESSAGE.DISCONNECTED_OFF\">\nCannot connect to the appliance. Possibly disconnected from network or appliance is switched off.</span></div><div \nclass=\"pt-8\" layout=\"column\" ng-if=\"vm.evaluate()\"><div class=\"mb-16\" layout-gt-sm=\"row\" layout=\"column\" \nlayout-align=\"center center\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"progress_container\"><div class=\"progress_icon\"><md-icon md-font-icon=\"{{vm.Progs[vm.laundry.program].icon}}\" \nclass=\"icon program icon-size-72\" aria-hidden=\"true\"></md-icon></div><md-progress-circular md-mode=\"determinate\" \nmd-diameter=\"110\" value=\"{{vm.laundry.progress}}\"></md-progress-circular></div><div class=\"mt-8\" \nstyle=\"color: #259de1\"><span ng-if=\"vm.laundry.operationState===\'Ready\'\">~{{vm.laundry.remainingProgramTime}} <span \ntranslate=\"DASHBOARD.WIDGET.MINS\">minutes</span></span> <span ng-if=\"vm.laundry.operationState===\'Run\'\">\n~{{vm.laundry.remainingProgramTime}} <span translate=\"DASHBOARD.WIDGET.MINS\">minutes</span></span> <span \nng-if=\"vm.laundry.operationState===\'Finished\'\" translate=\"DASHBOARD.WIDGET.FINISHED\">Program has finished</span></div>\n</div><div layout=\"column\" class=\"pt-24 pb-24 ml-8 mr-8 middle_col\" layout-align=\"center center\" flex><md-icon \nmd-font-icon=\"pragma-icon-electricity\" class=\"icon consumption icon-size-48\" aria-hidden=\"true\"></md-icon><span \nclass=\"mt-8 font-size-32 consumption\">{{vm.laundry.consumption}} <span>W</span></span></div><div layout=\"column\" \nlayout-align=\"center center\" flex><div layout=\"row\" layout-align=\"center center\" class=\"pt-8 pb-8\" \nng-if=\"vm.laundry.doorState == \'0\'\"><md-icon md-font-icon=\"pragma-icon-washer-door-closed\" class=\"closed icon-size-48\" \naria-hidden=\"true\"></md-icon><span class=\"ml-16\" style=\"white-space: nowrap\">{{vm.dState[vm.laundry.doorState]}}</span>\n</div><div layout=\"row\" layout-align=\"center center\" class=\"pt-8 pb-8\" ng-if=\"vm.laundry.doorState == \'1\'\"><md-icon \nmd-font-icon=\"pragma-icon-washer-door-open\" class=\"open icon-size-48\" aria-hidden=\"true\"></md-icon><span class=\"ml-16\" \nstyle=\"white-space: nowrap\">{{vm.dState[vm.laundry.doorState]}}</span></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"pt-8 pb-8\" ng-if=\"vm.laundry.doorState == \'2\'\"><md-icon \nmd-font-icon=\"icon-lock-outline\" class=\"locked icon-size-48\" aria-hidden=\"true\"></md-icon><span class=\"ml-16\" \nstyle=\"white-space: nowrap\">{{vm.dState[vm.laundry.doorState]}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"pt-8 pb-8\"><span style=\"white-space: nowrap\" \nng-if=\"vm.laundry.powerState === true\" translate=\"DASHBOARD.WIDGET.ACTIVE\">Active (switched on)</span> <span \nstyle=\"white-space: nowrap\" ng-if=\"vm.laundry.powerState === false\" translate=\"DASHBOARD.WIDGET.OFF\">\nInactive (switched off)</span><md-tooltip md-direction=\"top\"><span translate=\"DASHBOARD.WIDGET.MESSAGE.SWITCH_OFF\">\nIf you switch off this device, it can only be activated again locally!</span></md-tooltip><md-switch class=\"m-0\" \nstyle=\"margin-left: 8px !important\" ng-model=\"vm.laundry.powerState\" \nng-disabled=\"!vm.laundry.powerState || vm.user.username === \'siemens-user\'\" aria-label=\"Laundry Power\" \nng-change=\"vm.ChangePowerState(vm.laundry.powerState)\"></md-switch></div></div></div><div carousel3d \nng-if=\"vm.user.username != \'siemens-user\'\" ng-model=\"vm.slides\" options=\"vm.options\" \non-selected-click=\"vm.selectedClick(index)\"><div carousel3d-slide layout=\"column\" layout-align=\"start stretch\" \nng-repeat=\"Prog in vm.slides track by $index\" ng-class=\"vm.CheckSlideClass(Prog.key)\" style=\"cursor: pointer\"><div \nlayout=\"row\" layout-align=\"space-between start\" class=\"p-8\"><span><md-icon md-font-icon=\"{{Prog.icon}}\" \nclass=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon>({{Prog.name}})</span><div \nng-if=\"vm.laundry.powerState\"><md-button aria-label=\"Start Program\" class=\"md-icon-button\" \nng-click=\"doOptionsAction($event, vm.laundry.temperature, vm.laundry.rpm, Prog)\" \nng-if=\"selectedProg == Prog.key && vm.disStart == true && vm.laundry.operationState !== \'Finished\'\"><md-tooltip \nmd-direction=\"top\"><span translate=\"DASHBOARD.WIDGET.START\">Start Program</span></md-tooltip><md-icon \nmd-font-icon=\"icon-play\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button><md-button aria-label=\"Stop Program\" \nclass=\"md-icon-button\" ng-click=\"vm.StopProgram()\" ng-if=\"selectedProg == Prog.key && vm.disStart == false\"><md-tooltip\n md-direction=\"top\"><span translate=\"DASHBOARD.WIDGET.STOP\">Stop Program</span></md-tooltip><md-icon \nmd-font-icon=\"icon-stop\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button></div></div><md-divider></md-divider>\n<div class=\"pl-8 pr-8 pt-8\" layout=\"column\" layout-align=\"start start\" ms-scroll flex><span class=\"mb-8\" \ntranslate=\"DASHBOARD.WIDGET.PROGRAM_DESCR\">Program description:</span> <span>{{Prog.descr}}</span></div></div></div>\n<div carousel3d ng-if=\"vm.user.username === \'siemens-user\'\" ng-model=\"vm.slides\" options=\"vm.options\"><div \ncarousel3d-slide layout=\"column\" layout-align=\"start stretch\" ng-repeat=\"Prog in vm.slides track by $index\" \nng-class=\"vm.CheckSlideClass(Prog.key)\"><div layout=\"row\" layout-align=\"space-between start\" class=\"p-8\"><span><md-icon\n md-font-icon=\"{{Prog.icon}}\" class=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon>({{Prog.name}})</span>\n</div><md-divider></md-divider><div class=\"pl-8 pr-8 pt-8\" layout=\"column\" layout-align=\"start start\" ms-scroll flex>\n<span class=\"mb-8\" translate=\"DASHBOARD.WIDGET.PROGRAM_DESCR\">Program description:</span> <span>{{Prog.descr}}</span>\n</div></div></div></div></div>");
$templateCache.put("app/directives/ha-oven/ha-oven.html","<div class=\"pl-16 pr-16 pb-8\" layout=\"column\" id=\"ha-oven\"><div layout=\"column\" class=\"p-8 pt-16\" \nlayout-align=\"center center\" ng-if=\"vm.oven.operationState === \'Aborting\'\"><md-icon \nmd-font-icon=\"pragma-icon-aborting\" class=\"open icon-size-72\" aria-hidden=\"true\"></md-icon><span \nclass=\"p-8 font-size-20\"><span translate=\"DASHBOARD.WIDGET.MESSAGE.ACTIVATED\">The activated program </span>\n({{vm.Progs[vm.oven.program].name}})<span translate=\"DASHBOARD.WIDGET.MESSAGE.ABORTING\"> is currently aborting.</span>\n</span> <span class=\"p-8 font-size-20\" translate=\"DASHBOARD.WIDGET.MESSAGE.PLEASE_WAIT\">Please wait...</span></div><div\n layout=\"column\" class=\"p-8 pt-16\" layout-align=\"center center\" ng-if=\"vm.oven.operationState === \'Disconnected\'\">\n<md-icon md-font-icon=\"icon-close-network\" class=\"open icon-size-72\" aria-hidden=\"true\"></md-icon><span \nclass=\"p-8 font-size-20\" translate=\"DASHBOARD.WIDGET.MESSAGE.DISCONNECTED\">\nCannot connect to the appliance. Possibly disconnected from network.</span></div><div class=\"pt-8\" layout=\"column\" \nng-if=\"vm.evaluate()\"><div class=\"mb-16\" layout-gt-sm=\"row\" layout=\"column\" layout-align=\"center center\" flex><div \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"progress_container\"><div class=\"progress_icon\"><md-icon \nmd-font-icon=\"{{vm.Progs[vm.oven.program].icon}}\" class=\"icon program icon-size-72\" aria-hidden=\"true\"></md-icon></div>\n<md-progress-circular md-mode=\"determinate\" md-diameter=\"110\" value=\"{{vm.oven.progress}}\"></md-progress-circular>\n</div><div class=\"mt-8\" style=\"color: #259de1\"><span ng-if=\"vm.oven.operationState===\'Ready\'\">~{{vm.oven.duration}} \n<span translate=\"DASHBOARD.WIDGET.MINS\">minutes</span></span> <span ng-if=\"vm.oven.operationState===\'Run\'\">\n~{{vm.oven.remainingProgramTime}} <span translate=\"DASHBOARD.WIDGET.MINS\">minutes</span></span> <span \nng-if=\"vm.oven.operationState===\'Finished\'\" translate=\"DASHBOARD.WIDGET.FINISHED\">Program has finished</span></div>\n</div><div layout=\"column\" class=\"pt-24 pb-24 ml-8 mr-8 middle_col\" layout-align=\"center center\" flex><md-icon \nmd-font-icon=\"pragma-icon-electricity\" class=\"icon consumption icon-size-48\" aria-hidden=\"true\"></md-icon><span \nclass=\"mt-8 font-size-32 consumption\">{{vm.oven.consumption}} <span>W</span></span></div><div layout=\"column\" \nlayout-align=\"center center\" flex><div layout=\"row\" layout-align=\"center center\" class=\"pt-8 pb-8\" \nng-if=\"vm.oven.doorState == \'0\'\"><md-icon md-font-icon=\"pragma-icon-oven-door-closed\" class=\"closed icon-size-48\" \naria-hidden=\"true\"></md-icon><span class=\"ml-16\" style=\"white-space: nowrap\">{{vm.dState[vm.oven.doorState]}}</span>\n</div><div layout=\"row\" layout-align=\"center center\" class=\"pt-8 pb-8\" ng-if=\"vm.oven.doorState == \'1\'\"><md-icon \nmd-font-icon=\"pragma-icon-oven-door-open\" class=\"open icon-size-48\" aria-hidden=\"true\"></md-icon><span class=\"ml-16\" \nstyle=\"white-space: nowrap\">{{vm.dState[vm.oven.doorState]}}</span></div><div layout=\"row\" \nlayout-align=\"center center\" class=\"pt-8 pb-8\" ng-if=\"vm.oven.doorState == \'2\'\"><md-icon \nmd-font-icon=\"icon-lock-outline\" class=\"locked icon-size-48\" aria-hidden=\"true\"></md-icon><span class=\"ml-16\" \nstyle=\"white-space: nowrap\">{{vm.dState[vm.oven.doorState]}}</span></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"pt-8 pb-8\"><span style=\"white-space: nowrap\" \nng-if=\"vm.oven.powerState === true\" translate=\"DASHBOARD.WIDGET.ACTIVE\">Active (switched on)</span> <span \nstyle=\"white-space: nowrap\" ng-if=\"vm.oven.powerState === false\" translate=\"DASHBOARD.WIDGET.STANDBY\">\nInactive (standby)</span><md-switch ng-disabled=\"vm.user.username === \'siemens-user\'\" class=\"m-0\" \nstyle=\"margin-left: 8px !important\" ng-model=\"vm.oven.powerState\" aria-label=\"Oven Power\" \nng-change=\"vm.ChangePowerState(vm.oven.powerState)\"></md-switch></div></div></div><div carousel3d \nng-if=\"vm.user.username != \'siemens-user\'\" ng-model=\"vm.slides\" options=\"vm.options\" \non-selected-click=\"vm.selectedClick(index)\"><div carousel3d-slide layout=\"column\" layout-align=\"start stretch\" \nng-repeat=\"Prog in vm.slides track by $index\" ng-class=\"vm.CheckSlideClass(Prog.key)\" style=\"cursor: pointer\"><div \nlayout=\"row\" layout-align=\"space-between start\" class=\"p-8\"><span><md-icon md-font-icon=\"{{Prog.icon}}\" \nclass=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon>({{Prog.name}})</span><div ng-if=\"vm.oven.powerState\">\n<md-button aria-label=\"Start Program\" class=\"md-icon-button\" \nng-click=\"doOptionsAction($event, Prog, vm.oven.duration, vm.oven.setPointTemperature)\" \nng-if=\"selectedProg == Prog.key && vm.disStart == true && vm.oven.operationState !== \'Finished\'\"><md-tooltip \nmd-direction=\"top\"><span translate=\"DASHBOARD.WIDGET.START\">Start Program</span></md-tooltip><md-icon \nmd-font-icon=\"icon-play\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button><md-button aria-label=\"Stop Program\" \nclass=\"md-icon-button\" ng-click=\"vm.StopProgram()\" ng-if=\"selectedProg == Prog.key && vm.disStart == false\"><md-tooltip\n md-direction=\"top\"><span translate=\"DASHBOARD.WIDGET.STOP\">Stop Program</span></md-tooltip><md-icon \nmd-font-icon=\"icon-stop\" class=\"icon\" aria-hidden=\"true\"></md-icon></md-button></div></div><md-divider></md-divider>\n<div class=\"pl-8 pr-8 pt-8\" layout=\"column\" layout-align=\"start start\" ms-scroll flex><span class=\"mb-8\" \ntranslate=\"DASHBOARD.WIDGET.PROGRAM_DESCR\">Program description:</span> <span>{{Prog.descr}}</span></div></div></div>\n<div carousel3d ng-if=\"vm.user.username === \'siemens-user\'\" ng-model=\"vm.slides\" options=\"vm.options\"><div \ncarousel3d-slide layout=\"column\" layout-align=\"start stretch\" ng-repeat=\"Prog in vm.slides track by $index\" \nng-class=\"vm.CheckSlideClass(Prog.key)\"><div layout=\"row\" layout-align=\"space-between start\" class=\"p-8\"><span><md-icon\n md-font-icon=\"{{Prog.icon}}\" class=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon>({{Prog.name}})</span>\n</div><md-divider></md-divider><div class=\"pl-8 pr-8 pt-8\" layout=\"column\" layout-align=\"start start\" ms-scroll flex>\n<span class=\"mb-8\" translate=\"DASHBOARD.WIDGET.PROGRAM_DESCR\">Program description:</span> <span>{{Prog.descr}}</span>\n</div></div></div></div></div>");
$templateCache.put("app/directives/hubaHours/hubaHours.html","<div class=\"hubaHours\" id=\"{{vm.plotId}}\"></div>");
$templateCache.put("app/directives/hubaPeak/hubaPeak.html","<div class=\"hubaTable\" ng-if=\"vm.mode==\'table\'\"><div layout=\"row\" layout-align=\"space-between left\"><div \nlayout=\"column\"><data-md-table-pagination md-limit=\"vm.table.query.limit\" md-limit-options=\"vm.table.limitOptions\" \nmd-page=\"vm.table.query.page\" md-total=\"{{vm.numericResults.length}}\" \nmd-boundary-links=\"vm.table.options.boundaryLinks\"></data-md-table-pagination></div><div layout=\"column\" \nng-if=\"vm.showRefresh\"><md-button class=\"md-icon-button\" ng-click=\"vm.reload()\" aria-label=\"Refresh\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon></md-button></div></div><md-table-container><table data-md-table \nmd-progress=\"promise\" class=\"sites card\"><thead ng-if=\"!vm.table.options.decapitate\" md-head \ndata-md-order=\"vm.table.query.order\"><tr md-row><th md-column md:order:by=\"space\"><span>Space</span></th><th md-column>\n<span>Peak Hour</span></th><th md-column md:order:by=\"peakValue\"><span>Peak Value</span></th><th md-column><span>\nLow Demand Hour</span></th><th md-column md:order:by=\"lowValue\"><span>Low Demand Value</span></th><th md-column \nmd:order:by=\"type\"><span>Type</span></th></tr></thead><tbody md-body><tr md-row \ndata-ng-repeat=\"result in vm.numericResults | filter: vm.table.filter.search | orderBy: vm.table.query.order | limitTo: vm.table.query.limit : (vm.table.query.page - 1) * vm.table.query.limit\">\n<td md-cell>{{result.space}}</td><td md-cell>\n{{result.peakHourStart | date:\'dd/MM/yyyy h:mma\'}} - {{result.peakHourEnd | date:\'dd/MM/yyyy h:mma\'}}</td><td md-cell>\n{{result.peakValue}} Occupants</td><td md-cell>\n{{result.lowHourStart | date:\'dd/MM/yyyy h:mma\'}} - {{result.lowHourEnd | date:\'dd/MM/yyyy h:mma\'}}</td><td md-cell>\n{{result.lowValue}} Occupants</td><td md-cell>{{result.type | capitalize}}</td></tr></tbody></table>\n</md-table-container></div><div class=\"hubaPeakNumeric\" ng-if=\"vm.mode==\'numeric\'\"><div ng-if=\"vm.peakFl\"><div \nclass=\"hubaClock\"><ds-widget-clock start-time=\"vm.numericResults[0].peakClockTime\" show-analog theme=\"vm.clockTheme\" \nstop-clock=\"true\" show-secs=\"false\" show-digital=\"false\" show-analog=\"false\"></ds-widget-clock></div><div \nng-style=\"{\'color\':vm.gridLinesColor}\"><md-icon md-font-icon=\"pragma-icon-parking-peak-hour\" \nstyle=\"color:{{vm.gridLinesColor}}\"></md-icon>{{vm.numericResults[0].peakHourStart | date:\'dd/MM/yyyy\'}}</div><div \nng-style=\"{\'color\':vm.gridLinesColor}\">\n{{vm.numericResults[0].peakHourStart | date:\'h:mma\'}} - {{vm.numericResults[0].peakHourEnd| date:\'h:mma\'}}</div><div \nng-style=\"{\'color\':vm.gridLinesColor}\">{{vm.numericResults[0].peakValue}} Occupants</div></div><div ng-if=\"vm.lowFl\">\n<div class=\"hubaClock\"><ds-widget-clock start-time=\"vm.numericResults[0].lowClockTime\" show-analog \ntheme=\"vm.clockTheme\" stop-clock=\"true\" show-secs=\"false\" show-digital=\"false\" show-analog=\"false\"></ds-widget-clock>\n</div><div ng-style=\"{\'color\':vm.gridLinesColor}\"><md-icon md-font-icon=\"pragma-icon-parking-lowdemand-hour\" \nstyle=\"color:{{vm.gridLinesColor}}\"></md-icon>{{vm.numericResults[0].lowHourStart | date:\'dd/MM/yyyy\'}}</div><div \nng-style=\"{\'color\':vm.gridLinesColor}\">\n{{vm.numericResults[0].lowHourStart | date:\'h:mma\'}} - {{vm.numericResults[0].lowHourEnd | date:\'h:mma\'}}</div><div \nng-style=\"{\'color\':vm.gridLinesColor}\">{{vm.numericResults[0].lowValue}} Occupants</div></div></div>");
$templateCache.put("app/directives/hubaPlot/hubaPlot.html","<div id=\"plotCard\" ng-if=\"vm.widget.graph.value===\'occupancy\'\"><div ng-style=\"{\'color\':vm.widget.graph.fontColor}\" \nlayout=\"row\" style=\"padding: 0 20px\"><div layout=\"column\" flex=\"33\" ng-if=\"vm.widget.graph.average\"><div \nclass=\"measureTitle\">{{ \'DASHBOARD.AVERAGE\' | translate }}</div><div class=\"measureText\">\n{{vm.metadata.mean | number:2 }} <span class=\"measureUnit\">{{vm.unit}} </span></div></div><div layout=\"column\" \nflex=\"33\" ng-if=\"vm.widget.graph.min\"><div class=\"measureTitle\">{{ \'DASHBOARD.MIN\' | translate }}</div><div \nclass=\"measureText\">{{vm.metadata.min | number:2 }} <span class=\"measureUnit\">{{vm.unit}} </span></div></div><div \nlayout=\"column\" flex=\"33\" ng-if=\"vm.widget.graph.max\"><div class=\"measureTitle\">{{ \'DASHBOARD.MAX\' | translate }}</div>\n<div class=\"measureText\">{{vm.metadata.max | number:2 }} <span class=\"measureUnit\">{{vm.unit}} </span></div></div>\n</div><div layout=\"row\" style=\"margin-top:10px\" \nng-if=\"!vm.widget.graph.total && !vm.widget.graph.average && !vm.widget.graph.min && !vm.widget.graph.max\"><canvas \nheight=\"230\" id=\"chart-aggregated\" class=\"chart chart-bar\" chart-data=\"vm.result.chart.data\" \nchart-labels=\"vm.result.chart.labels\" chart-options=\"vm.result.chart.options\" chart-series=\"vm.result.chart.series\" \nchart-colors=\"vm.result.chart.colors\" chart-dataset-override=\"vm.result.chart.override\"></canvas></div><div \nlayout=\"row\" style=\"margin-top:10px\" \nng-if=\"vm.widget.graph.total || vm.widget.graph.average || vm.widget.graph.min || vm.widget.graph.max\"><canvas \nheight=\"230\" id=\"chart-aggregated\" class=\"chart chart-bar\" chart-data=\"vm.result.chart.data\" \nchart-labels=\"vm.result.chart.labels\" chart-options=\"vm.result.chart.options\" chart-series=\"vm.result.chart.series\" \nchart-colors=\"vm.result.chart.colors\" chart-dataset-override=\"vm.result.chart.override\"></canvas></div></div><div \nid=\"plotCard\" ng-if=\"vm.widget.graph.value===\'entriesExits\'\"><div ng-style=\"{\'color\':vm.widget.graph.fontColor}\" \nlayout=\"row\" style=\"padding: 0 20px\"><div layout=\"column\" flex=\"25\" ng-if=\"vm.widget.graph.total\"><div \nclass=\"measureTitle\">{{ \'DASHBOARD.TOTAL\' | translate }}</div><div class=\"measureText\" ng-if=\" vm.meta.entries\">\n{{vm.metadata.entries.total | number:0 }} <span class=\"measureUnit\">{{ \'DASHBOARD.HUBAENTRIES\' | translate }} </span>\n</div><div class=\"measureText\" ng-if=\" vm.meta.exits\">{{vm.metadata.exits.total | number:0 }} <span \nclass=\"measureUnit\">{{ \'DASHBOARD.HUBAEXITS\' | translate }}</span></div></div><div layout=\"column\" flex=\"25\" \nng-if=\"vm.widget.graph.average\"><div class=\"measureTitle\">{{ \'DASHBOARD.AVERAGE\' | translate }}</div><div \nclass=\"measureText\" ng-if=\" vm.meta.entries\">{{vm.metadata.entries.mean | number:2 }} <span class=\"measureUnit\">\n{{ \'DASHBOARD.HUBAENTRIES\' | translate }} </span></div><div class=\"measureText\" ng-if=\" vm.meta.exits\">\n{{vm.metadata.exits.mean | number:2 }} <span class=\"measureUnit\">{{ \'DASHBOARD.HUBAEXITS\' | translate }} </span></div>\n</div><div layout=\"column\" flex=\"25\" ng-if=\"vm.widget.graph.min\"><div class=\"measureTitle\">\n{{ \'DASHBOARD.MIN\' | translate }}</div><div class=\"measureText\" ng-if=\" vm.meta.entries\">\n{{vm.metadata.entries.min | number:0 }} <span class=\"measureUnit\">{{ \'DASHBOARD.HUBAENTRIES\' | translate }} </span>\n</div><div class=\"measureText\" ng-if=\" vm.meta.exits\">{{vm.metadata.exits.min | number:0 }} <span class=\"measureUnit\">\n{{ \'DASHBOARD.HUBAEXITS\' | translate }} </span></div></div><div layout=\"column\" flex=\"25\" ng-if=\"vm.widget.graph.max\">\n<div class=\"measureTitle\">{{ \'DASHBOARD.MAX\' | translate }}</div><div class=\"measureText\" ng-if=\" vm.meta.entries\">\n{{vm.metadata.entries.max | number:0 }} <span class=\"measureUnit\">{{ \'DASHBOARD.HUBAENTRIES\' | translate }} </span>\n</div><div class=\"measureText\" ng-if=\" vm.meta.exits\">{{vm.metadata.exits.max | number:0 }} <span class=\"measureUnit\">\n{{ \'DASHBOARD.HUBAEXITS\' | translate }} </span></div></div></div><div layout=\"row\" style=\"margin-top:10px\" \nng-if=\"!vm.widget.graph.total && !vm.widget.graph.average && !vm.widget.graph.min && !vm.widget.graph.max\"><canvas \nheight=\"230\" id=\"chart-aggregated\" class=\"chart chart-bar\" chart-data=\"vm.result.chart.data\" \nchart-labels=\"vm.result.chart.labels\" chart-options=\"vm.result.chart.options\" chart-series=\"vm.result.chart.series\" \nchart-colors=\"vm.result.chart.colors\" chart-dataset-override=\"vm.result.chart.override\"></canvas></div><div \nlayout=\"row\" style=\"margin-top:10px\" \nng-if=\"vm.widget.graph.total || vm.widget.graph.average || vm.widget.graph.min || vm.widget.graph.max\"><canvas \nheight=\"230\" id=\"chart-aggregated\" class=\"chart chart-bar\" chart-data=\"vm.result.chart.data\" \nchart-labels=\"vm.result.chart.labels\" chart-options=\"vm.result.chart.options\" chart-series=\"vm.result.chart.series\" \nchart-colors=\"vm.result.chart.colors\" chart-dataset-override=\"vm.result.chart.override\"></canvas></div></div>");
$templateCache.put("app/directives/hubaTotal/hubaTotal.html","<div flex layout=\"row\" ng-if=\"vm.widget.graph.graphType==\'numeric\' && vm.widget.graph.value===\'occupancy\'\"><div \nng-repeat=\"(key,value) in vm.numericResults[0]\" flex layout=\"column\" layout-align=\"center center\"><div><md-icon \nmd-font-icon=\"{{vm.icon}}\" \nstyle=\"color:{{vm.widget.graph.fontColor}};font-size:40px;margin-bottom:25px;margin-right:20px\"></md-icon></div><div>\n<h2 ng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{value}} <span>{{vm.unit}}</span></h2></div></div></div><div flex \nlayout=\"row\" ng-if=\"vm.widget.graph.graphType==\'numeric\' && vm.widget.graph.value===\'entriesExits\'\"><div \nng-repeat=\"(key,value) in vm.numericResults[0]\" flex layout=\"column\" layout-align=\"center center\"><div><md-icon \nmd-font-icon=\"{{vm.icon}}\" \nstyle=\"color:{{vm.widget.graph.fontColor}};font-size:40px;margin-bottom:25px;margin-right:20px\"></md-icon></div><div>\n<h2 ng-style=\"{\'color\':vm.widget.graph.fontColor}\"><div ng-repeat=\"(key1,value1) in value\">\n{{value1}} {{key1 | capitalize}}</div></h2></div></div></div><div layout=\"row\" style=\"margin-top:10px\" \nng-if=\"vm.widget.graph.graphType==\'bar\'\"><canvas height=\"230\" id=\"chart-aggregated\" class=\"chart chart-bar\" \nchart-data=\"vm.result.chart.data\" chart-labels=\"vm.result.chart.labels\" chart-options=\"vm.result.chart.options\" \nchart-series=\"vm.result.chart.series\" chart-colors=\"vm.result.chart.colors\" \nchart-dataset-override=\"vm.result.chart.override\"></canvas></div><div ng-if=\"vm.widget.graph.graphType==\'radar\'\">\n<canvas class=\"chart chart-radar\" chart-data=\"vm.result.chart.data\" chart-options=\"vm.result.chart.options\" \nchart-labels=\"vm.result.chart.labels\" chart-colors=\"vm.result.chart.colors\" chart-series=\"vm.result.chart.series\" \nchart-dataset-override=\"vm.result.chart.override\"></canvas></div>");
$templateCache.put("app/directives/hubaTransitions/hubaTransitions.html","<vis-network data=\"vm.data\" options=\"vm.options\"></vis-network>");
$templateCache.put("app/directives/hvac-card/hvac-card.html","<div flex layout=\"row\"><div flex layout=\"column\" layout-align=\"center center\"><div flex><div flex>Status</div><div \nflex><md-switch ng-model=\"vm.result.status\" layout-align=\"center center\" aria-label=\"Switch 1\" \nng-change=\"vm.changeStatus(vm.result,\'On|Off\')\"></md-switch></div></div><div flex><div flex>Operation Mode</div><div \nflex><md-icon md-font-icon=\"pragma-icon-mode-cool\" ng-class=\"{\'md-primary-fg\': vm.result.operationMode===1}\" \nng-click=\"vm.hvacSetOperationMode(vm.result,1)\" style=\"cursor:pointer\"></md-icon><md-icon \nmd-font-icon=\"pragma-icon-mode-heat\" ng-class=\"{\'md-primary-fg\': vm.result.operationMode===5}\" \nng-click=\"vm.hvacSetOperationMode(vm.result,5)\" style=\"cursor:pointer\"></md-icon><md-icon \nmd-font-icon=\"pragma-icon-mode-fan\" ng-class=\"{\'md-primary-fg\': vm.result.operationMode===3}\" \nng-click=\"vm.hvacSetOperationMode(vm.result,3)\" style=\"cursor:pointer\"></md-icon><md-icon \nmd-font-icon=\"pragma-icon-mode-dry\" ng-class=\"{\'md-primary-fg\': vm.result.operationMode===2}\" \nng-click=\"vm.hvacSetOperationMode(vm.result,2)\" style=\"cursor:pointer\"></md-icon><md-icon \nmd-font-icon=\"pragma-icon-mode-auto\" ng-class=\"{\'md-primary-fg\': vm.result.operationMode===4}\" \nng-click=\"vm.hvacSetOperationMode(vm.result,4)\" style=\"cursor:pointer\"></md-icon></div></div></div><div flex \nlayout=\"column\" layout-align=\"center center\"><div flex><div flex>Temperature</div><div flex>\n{{vm.result.temperature | number: 0}} °C<md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\" \nclass=\"md-primary-fg\" ng-click=\"vm.changeStatus(vm.result,\'down\')\" style=\"cursor:pointer\"></md-icon><md-icon \nmd-font-icon=\"icon-arrow-up-bold-circle-outline\" class=\"md-primary-fg\" ng-click=\"vm.changeStatus(vm.result,\'up\')\" \nstyle=\"cursor:pointer\"></md-icon></div></div><div flex><div flex>Fun Speed</div><div flex><md-icon \nmd-font-icon=\"pragma-icon-fanspeed-low\" ng-class=\"{\'md-primary-fg\': vm.result.fanSpeed===1}\" \nng-click=\"vm.hvacSetFanSpeed(vm.result,1)\" style=\"cursor:pointer\"></md-icon><md-icon \nmd-font-icon=\"pragma-icon-fanspeed-middle\" ng-class=\"{\'md-primary-fg\': vm.result.fanSpeed===2}\" \nng-click=\"vm.hvacSetFanSpeed(vm.result,2)\" style=\"cursor:pointer\"></md-icon><md-icon \nmd-font-icon=\"pragma-icon-fanspeed-high\" ng-class=\"{\'md-primary-fg\': vm.result.fanSpeed===3}\" \nng-click=\"vm.hvacSetFanSpeed(vm.result,3)\" style=\"cursor:pointer\"></md-icon><md-icon \nmd-font-icon=\"pragma-icon-fanspeed-auto\" ng-class=\"{\'md-primary-fg\': vm.result.fanSpeed===4}\" \nng-click=\"vm.hvacSetFanSpeed(vm.result,4)\" style=\"cursor:pointer\"></md-icon></div></div></div></div>");
$templateCache.put("app/directives/lamp-card/lamp-card.html","<div flex layout=\"row\"><div flex layout=\"column\" layout-align=\"center center\"><div flex><md-icon \nmd-font-icon=\"pragma-icon-dimming\" style=\"color:{{vm.device.color}};font-size:40px\" \nng-if=\"vm.device.lampType===\'lamp\'\"></md-icon><md-icon md-font-icon=\"pragma-icon-dimming\" \nstyle=\"color:#ffea00;font-size:40px\" ng-if=\"vm.device.lampType===\'spot\'\"></md-icon></div><div flex><h2>\n{{vm.device.percent}}<span>%</span></h2></div></div><div flex layout=\"column\" layout-align=\"center center\"><md-switch \nng-model=\"vm.device.state\" layout-align=\"center center\" aria-label=\"Switch 1\" \nng-change=\"vm.changePlugState(vm.device.state,\'on\')\"></md-switch><div flex><md-slider flex min=\"0\" step=\"10\" max=\"255\" \nng-model=\"vm.device.bri\" aria-label=\"red\" ng-change=\"vm.changePlugState(vm.device.bri,\'bri\')\" \nng-disabled=\"!vm.device.state\"></md-slider></div><div flex ng-if=\"vm.device.lampType===\'lamp\'\"><md-icon \nmd-font-icon=\"icon-lightbulb\" style=\"color:#ffea00;cursor:pointer\" \nng-style=\"vm.device.color==\'#ffea00\' && {\'font-size\':\'40px\'} || {\'font-size\': \'30px\'}\" \nng-click=\"vm.changePlugState(\'#ffea00\',\'color\')\"></md-icon><md-icon md-font-icon=\"icon-lightbulb\" \nstyle=\"color:red;cursor:pointer\" ng-style=\"vm.device.color==\'red\' && {\'font-size\':\'40px\'} || {\'font-size\': \'30px\'}\" \nng-click=\"vm.changePlugState(\'red\',\'color\')\"></md-icon><md-icon md-font-icon=\"icon-lightbulb\" \nstyle=\"color:green;cursor:pointer\" \nng-style=\"vm.device.color==\'green\' && {\'font-size\':\'40px\'} || {\'font-size\': \'30px\'}\" \nng-click=\"vm.changePlugState(\'green\',\'color\')\"></md-icon><md-icon md-font-icon=\"icon-lightbulb\" \nstyle=\"color:blue;cursor:pointer\" ng-style=\"vm.device.color==\'blue\' && {\'font-size\':\'40px\'} || {\'font-size\': \'30px\'}\" \nng-click=\"vm.changePlugState(\'blue\',\'color\')\"></md-icon></div></div></div>");
$templateCache.put("app/directives/lighting-card/lighting-card.html","<div flex layout=\"row\" ng-if=\"vm.widget.graph.graphType!==\'enocean\'\"><div \nng-repeat=\"result in vm.results track by $index\" flex layout=\"column\"><div flex><md-icon md-font-icon=\"{{vm.icon}}\" \nstyle=\"color:{{result.color}};font-size:40px;margin-bottom:15px;margin-right:20px\"></md-icon></div><div flex><h2 \nng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{result.cons}} <span>{{vm.unit}}</span></h2><md-slider flex min=\"0\" \nstep=\"5\" max=\"100\" ng-model=\"result.dim\" aria-label=\"red\" ng-change=\"vm.dimInteli(result)\" \nng-if=\"vm.widget.graph.graphType===\'inteli\'\"></md-slider><p ng-style=\"{\'color\':vm.labelColor}\">{{result.deviceName}}\n</p><div class=\"timestamp\" ng-style=\"{\'color\':vm.dateColor}\">{{result.timestamp | date:\'dd/MM/yyyy h:mma\'}}</div></div>\n</div></div><div flex layout=\"row\" \nng-if=\"vm.widget.graph.orientation==\'vertical\' && vm.widget.graph.graphType===\'enocean\'\"><div flex layout=\"column\" \nlayout-align=\"center center\"><div><md-icon flex md-font-icon=\"pragma-icon-lamp\" \nng-style=\"{\'color\':vm.widget.graph.fontColor}\"></md-icon></div><div><h2 ng-style=\"{\'color\':vm.widget.graph.fontColor}\">\n{{vm.result.consumption | number : 2}} <span>W</span></h2><md-slider flex min=\"0\" step=\"5\" max=\"100\" \nng-model=\"vm.result.dim\" aria-label=\"red\" ng-change=\"vm.changeStatusDim(vm.result)\"></md-slider></div></div></div><div \nng-if=\"vm.widget.graph.orientation==\'horizontal\' && vm.widget.graph.graphType===\'enocean\'\" flex layout=\"column\" \nlayout-align=\"center center\"><div flex layout=\"row\" layout-align=\"center center\"><div class=\"md-icon-cnt\"><md-icon \nmd-font-icon=\"pragma-icon-lamp\" ng-style=\"{\'color\':vm.widget.graph.fontColor}\"></md-icon></div><div class=\"desc-cnt\">\n<h2 ng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.result.consumption | number : 2}} <span>W</span></h2><md-slider\n flex min=\"0\" step=\"5\" max=\"100\" ng-model=\"vm.result.dim\" aria-label=\"red\" ng-change=\"vm.changeStatusDim(vm.result)\">\n</md-slider></div></div></div>");
$templateCache.put("app/directives/localization/localization.html","<div class=\"pl-16 pr-16 pb-8\" layout=\"column\" id=\"localization\"><canvas id=\"floorplanCanvas\" width=\"550\" height=\"610\">\n</canvas></div>");
$templateCache.put("app/directives/map-card/map-card.html","<div id=\"mapCard\"><div ng-style=\"{\'color\':vm.widget.fontColor}\"><ui-gmap-google-map center=\"vm.googleMapCenter\" \nzoom=\"vm.googleMapZoom\" control=\"vm.mapControl\" id=\"map1\" options=\"vm.options\"><ui-gmap-marker \nng-repeat=\"g in vm.googlmapLocations\" coords=\"g.coords\" idkey=\"g.id\" events=\"g.markersEvents\" \noptions=\"g.markerOptions\"><ui-gmap-window options=\"vm.windowOpt\" ng-if=\"g.type===\'Lighting\'\"><div \nstyle=\"color:black;min-width:180px\"><div style=\"font-weight:bold\">{{g.title}}</div><div style=\"margin-top:10px\"><div>\nStatus : {{g.text.status}}</div><div>Dimming : {{g.text.dimming}} %</div><div>Consumption : {{g.text.consumption}} W\n</div><div><md-slider flex min=\"0\" step=\"5\" max=\"100\" ng-model=\"g.text.dimming\" aria-label=\"red\" \nstyle=\"margin-left:10px;min-width:100px;width:150px\"></md-slider></div></div></div></ui-gmap-window><ui-gmap-window \noptions=\"vm.windowOpt\" ng-if=\"g.type===\'Parking\'\"><div style=\"color:black\"><div style=\"font-weight:bold\">{{g.title}}\n</div><div style=\"margin-top:10px\"><div>Status : {{g.text.state}}</div><div>\nSince : {{g.text.since | date:\'MM/dd/yyyy h:mma\'}}</div></div></div></ui-gmap-window><ui-gmap-window \noptions=\"vm.windowOpt\" ng-if=\"g.type===\'Building\'\"><div style=\"color:black\"><div style=\"font-weight:bold\">{{g.title}}\n</div><div style=\"margin-top:10px\"><div>Today {{g.text.type}} consumption : {{g.text.cons}} {{g.text.unit}}</div><div>\nToday {{g.text.type}} cost : {{g.text.cost}} €</div></div></div></ui-gmap-window><ui-gmap-window \noptions=\"vm.windowOpt\" ng-if=\"g.type===\'Waste\'\"><div style=\"color:black\"><div style=\"font-weight:bold\">{{g.title}}\n</div><div style=\"margin-top:10px\"><div>Type : {{g.text.name}}</div><div>Current : {{g.text.current}}</div><div>\nToday : {{g.text.total}}</div></div></div></ui-gmap-window></ui-gmap-marker></ui-gmap-google-map></div></div>");
$templateCache.put("app/directives/numeric-card/numeric-card.html","<div flex layout=\"row\" ng-if=\"vm.widget.graph.orientation==\'vertical\' || !vm.widget.graph.orientation\"><div \nng-repeat=\"result in vm.results track by $index\" flex layout=\"column\" layout-align=\"center center\"><div><md-icon flex \nmd-font-icon=\"{{result.icon}}\" ng-style=\"{\'color\':vm.widget.graph.fontColor}\"></md-icon></div><div><h2 \nng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{result.value | number : 2}} <span>{{result.unit}}</span></h2><p \nng-style=\"{\'color\':vm.labelColor}\">{{result.deviceName}}</p><div class=\"timestamp\" ng-style=\"{\'color\':vm.dateColor}\">\n{{result.timestamp | date:\'dd/MM/yyyy h:mma\'}}</div></div></div></div><div \nng-if=\"vm.widget.graph.orientation==\'horizontal\'\" flex layout=\"column\" layout-align=\"center center\"><div \nng-repeat=\"result in vm.results track by $index\" flex layout=\"row\" layout-align=\"center center\"><div \nclass=\"md-icon-cnt\"><md-icon md-font-icon=\"{{result.icon}}\" ng-style=\"{\'color\':vm.widget.graph.fontColor}\"></md-icon>\n</div><div class=\"desc-cnt\"><h2 ng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{result.value | number : 2}} <span>\n{{result.unit}}</span></h2><p ng-style=\"{\'color\':vm.labelColor}\">{{result.deviceName}}</p><div class=\"timestamp\" \nng-style=\"{\'color\':vm.dateColor}\">{{result.timestamp | date:\'dd/MM/yyyy h:mma\'}}</div></div></div></div>");
$templateCache.put("app/directives/occupancy-card/occupancy-card.html","<div flex layout=\"row\" \nng-if=\"(vm.widget.graph.orientation==\'vertical\' || !vm.widget.graph.orientation) && vm.widget.graph.value===\'occupancy\'\">\n<div flex layout=\"column\" layout-align=\"center center\"><div><md-icon flex md-font-icon=\"pragma-icon-occupancy\" \nng-style=\"{\'color\':vm.widget.graph.fontColor}\"></md-icon></div><div><h2 ng-style=\"{\'color\':vm.widget.graph.fontColor}\">\n{{vm.result.occupancy}} <span>Occupants</span></h2><div class=\"timestamp\" ng-style=\"{\'color\':vm.dateColor}\">\n{{vm.result.timestamp | date:\'dd/MM/yyyy h:mma\'}}</div></div></div></div><div \nng-if=\"vm.widget.graph.orientation==\'horizontal\' && vm.widget.graph.value===\'occupancy\'\" flex layout=\"column\" \nlayout-align=\"center center\"><div flex layout=\"row\" layout-align=\"center center\"><div class=\"md-icon-cnt\"><md-icon \nmd-font-icon=\"pragma-icon-occupancy\" ng-style=\"{\'color\':vm.widget.graph.fontColor}\"></md-icon></div><div \nclass=\"desc-cnt\"><h2 ng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.result.occupancy}} <span>Occupants</span></h2>\n<div class=\"timestamp\" ng-style=\"{\'color\':vm.dateColor}\">{{vm.result.timestamp | date:\'dd/MM/yyyy h:mma\'}}</div></div>\n</div></div><div flex layout=\"row\" \nng-if=\"(vm.widget.graph.orientation==\'vertical\' || !vm.widget.graph.orientation) && vm.widget.graph.value===\'entriesExits\'\">\n<div flex layout=\"column\" layout-align=\"center center\"><div><md-icon flex md-font-icon=\"pragma-icon-entries-exits\" \nng-style=\"{\'color\':vm.widget.graph.fontColor}\"></md-icon></div><div ng-if=\"vm.result.showEntries\"><h2 \nng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.result.entries}} <span>Entries</span></h2></div><div \nng-if=\"vm.result.showExits\"><h2 ng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.result.exits}} <span>Exits</span>\n</h2></div><div class=\"timestamp\" ng-style=\"{\'color\':vm.dateColor}\">{{vm.result.timestamp | date:\'dd/MM/yyyy h:mma\'}}\n</div></div></div><div ng-if=\"vm.widget.graph.orientation==\'horizontal\' && vm.widget.graph.value===\'entriesExits\'\" \nflex layout=\"column\" layout-align=\"center center\"><div flex layout=\"row\" layout-align=\"center center\"><div \nclass=\"md-icon-cnt\"><md-icon md-font-icon=\"pragma-icon-entries-exits\" ng-style=\"{\'color\':vm.widget.graph.fontColor}\">\n</md-icon></div><div class=\"desc-cnt\" ng-if=\"vm.result.showEntries\"><h2 ng-style=\"{\'color\':vm.widget.graph.fontColor}\">\n{{vm.result.entries}} <span>Entries</span></h2></div><div class=\"desc-cnt\" ng-if=\"vm.result.showExits\"><h2 \nng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.result.exits}} <span>Exits</span></h2></div><div class=\"timestamp\" \nng-style=\"{\'color\':vm.dateColor}\">{{vm.result.timestamp | date:\'dd/MM/yyyy h:mma\'}}</div></div></div>");
$templateCache.put("app/directives/oximeter-card/oximeter-card.html","<div layout=\"column\"><div flex layout=\"row\" ng-repeat=\"(key, value) in vm.device.specs track by $index\"><div flex=\"30\">\n<md-icon md-font-icon=\"{{\'pragma-icon-\'+value.type}}\" ng-style=\"{\'color\':vm.widget.graph.fontColor}\"></md-icon></div>\n<div flex=\"70\"><h2 ng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.device.measurements[key]}} <span>{{value.unit}}\n</span></h2><p ng-style=\"{\'color\':vm.labelColor}\">{{value.friendlyName}}</p></div></div></div><div class=\"timestamp\" \nng-style=\"{\'color\':vm.dateColor}\">{{vm.device.measurements.timestamp | date:\'dd/MM/yyyy h:mma\'}}</div>");
$templateCache.put("app/directives/panic-button/panic-button.html","<div flex layout=\"column\" class=\"panic-button\" layout-align=\"center center\"><img ng-if=\"vm.buttonActive\" \nsrc=\"assets/images/panic_v1.gif\" alt=\"panic\" ng-click=\"vm.stopAnimation()\"><md-icon ng-if=\"!vm.buttonActive\" \nmd-font-icon=\"pragma-icon-motion-no\" class=\"panic-icon\"></md-icon></div>");
$templateCache.put("app/directives/parking-demand-hour/parking-demand-hour.html","<div id=\"parkingDemandHour\"><div ng-if=\"vm.widget.graph.widgetType===\'peak\'\"><md-icon \nmd-font-icon=\"pragma-icon-parking-peak-hour\" \nstyle=\"color:{{vm.widget.graph.fontColor}};font-size:40px;margin-bottom:25px;margin-right:20px\"></md-icon><div \nng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.result}}</div></div><div \nng-if=\"vm.widget.graph.widgetType===\'low\'\"><md-icon md-font-icon=\"pragma-icon-parking-lowdemand-hour\" \nstyle=\"color:{{vm.widget.graph.fontColor}};font-size:40px;margin-bottom:25px;margin-right:20px\"></md-icon><div \nng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.result}}</div></div></div>");
$templateCache.put("app/directives/parking-lot/parking-lot.html","<div id=\"parkingLot\"><canvas id=\"{{vm.plotId}}\"></canvas></div>");
$templateCache.put("app/directives/parking-occupancy/parking-occupancy.html","<div id=\"parkingOccupancy\"><div ng-if=\"vm.widget.graph.widgetType===\'occupancy\'\"><md-icon \nmd-font-icon=\"pragma-icon-parking-occupancy\" \nstyle=\"color:{{vm.widget.graph.fontColor}};font-size:40px;margin-bottom:25px;margin-right:20px\"></md-icon><div \nng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.result | number: 1}} %</div></div><div \nng-if=\"vm.widget.graph.widgetType===\'availability\'\"><div><span ng-style=\"{\'color\':vm.widget.graph.availableColor}\">\n{{vm.result.available}} Available</span></div><div><span ng-style=\"{\'color\':vm.widget.graph.occupiedColor}\">\n{{vm.result.occupied}} Occupied</span></div></div></div>");
$templateCache.put("app/directives/ph-card/ph-card.html","<div id=\"phCard\"><canvas id=\"{{vm.plotId}}\"></canvas></div>");
$templateCache.put("app/directives/pie-card/pie-card-report.html","<div id=\"pieCardReport\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"!loadingProcess\"><md-progress-circular \nclass=\"md-warn\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div><div id=\"report-image-container\">\n<img src=\"assets/images/reports/pie-default.png\" alt=\"graph\"></div></div>");
$templateCache.put("app/directives/pie-card/pie-card.html","<div id=\"pieCard\" ng-if=\"vm.showPie\"><canvas id=\"doughnut\" ng-if=\"widget.graph.graphType===\'doughnut\'\" \nclass=\"chart chart-doughnut\" chart-data=\"vm.chart.data\" chart-labels=\"vm.chart.labels\" chart-colors=\"vm.chart.colors\" \nchart-options=\"vm.chart.options\" chart-dataset-override=\"vm.override\" height=\"240\"></canvas><canvas id=\"pie\" \nng-if=\"widget.graph.graphType===\'pie\'\" class=\"chart chart-pie\" chart-data=\"vm.chart.data\" \nchart-labels=\"vm.chart.labels\" chart-colors=\"vm.chart.colors\" chart-options=\"vm.chart.options\" \nchart-dataset-override=\"vm.override\" height=\"240\"></canvas><canvas id=\"polar-area\" \nng-if=\"widget.graph.graphType===\'polar\'\" class=\"chart chart-polar-area\" chart-data=\"vm.chart.data\" \nchart-labels=\"vm.chart.labels\" chart-options=\"vm.chart.options\" chart-colors=\"vm.chart.colors\" \nchart-dataset-override=\"vm.override\" height=\"240\"></canvas></div><div id=\"txt\" ng-if=\"!vm.showPie\"><md-icon \nmd-font-icon=\"{{vm.icon}}\" \nstyle=\"color:{{vm.widget.graph.foregroundColor}};font-size:40px;margin-bottom:25px;margin-right:20px\"></md-icon><div \nng-style=\"{\'color\':vm.widget.graph.foregroundColor}\">0 {{vm.unit}}</div></div>");
$templateCache.put("app/directives/plot-card/plot-card-report.html","<div id=\"plotCardReport\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"!loadingProcess\"><md-progress-circular \nclass=\"md-warn\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div><div id=\"report-image-container\">\n<img src=\"assets/images/reports/chart-default.png\" alt=\"graph\"></div><div layout=\"row\" style=\"padding: 0 20px\"><span>\nThe total calculated value was at {{vm.metadata.total | number:2 }} {{vm.result.unit}}. During the selected period an average of {{vm.metadata.avg | number:2 }} {{vm.result.unit}} was estimated, having a minimum and a maximum value of {{vm.metadata.min | number:2 }} {{vm.result.unit}} and {{vm.metadata.max | number:2 }} {{vm.result.unit}} respectively.\n</span></div></div>");
$templateCache.put("app/directives/plot-card/plot-card.html","<div id=\"plotCard\"><div ng-style=\"{\'color\':vm.widget.graph.fontColor}\" layout=\"row\" style=\"padding: 0 20px\"><div \nlayout=\"column\" flex=\"25\" ng-if=\"vm.widget.graph.total\"><div class=\"measureTitle\">{{ \'DASHBOARD.TOTAL\' | translate }}\n</div><div class=\"measureText\">{{vm.metadata.total | number:2 }} <span class=\"measureUnit\">{{vm.unit}} </span></div>\n</div><div layout=\"column\" flex=\"25\" ng-if=\"vm.widget.graph.average\"><div class=\"measureTitle\">\n{{ \'DASHBOARD.AVERAGE\' | translate }}</div><div class=\"measureText\">{{vm.metadata.mean | number:2 }} <span \nclass=\"measureUnit\">{{vm.unit}} </span></div></div><div layout=\"column\" flex=\"25\" ng-if=\"vm.widget.graph.min\"><div \nclass=\"measureTitle\">{{ \'DASHBOARD.MIN\' | translate }}</div><div class=\"measureText\">{{vm.metadata.min | number:2 }} \n<span class=\"measureUnit\">{{vm.unit}} </span></div></div><div layout=\"column\" flex=\"25\" ng-if=\"vm.widget.graph.max\">\n<div class=\"measureTitle\">{{ \'DASHBOARD.MAX\' | translate }}</div><div class=\"measureText\">\n{{vm.metadata.max | number:2 }} <span class=\"measureUnit\">{{vm.unit}} </span></div></div></div><div layout=\"row\" \nstyle=\"margin-top:10px\" \nng-if=\"!vm.widget.graph.total && !vm.widget.graph.average && !vm.widget.graph.min && !vm.widget.graph.max\"><canvas \nheight=\"230\" id=\"chart-aggregated\" class=\"chart chart-bar\" chart-data=\"vm.result.chart.data\" \nchart-labels=\"vm.result.chart.labels\" chart-options=\"vm.result.chart.options\" chart-series=\"vm.result.chart.series\" \nchart-colors=\"vm.result.chart.colors\" chart-dataset-override=\"vm.result.chart.override\"></canvas></div><div \nlayout=\"row\" style=\"margin-top:10px\" \nng-if=\"vm.widget.graph.total || vm.widget.graph.average || vm.widget.graph.min || vm.widget.graph.max\"><canvas \nheight=\"230\" id=\"chart-aggregated\" class=\"chart chart-bar\" chart-data=\"vm.result.chart.data\" \nchart-labels=\"vm.result.chart.labels\" chart-options=\"vm.result.chart.options\" chart-series=\"vm.result.chart.series\" \nchart-colors=\"vm.result.chart.colors\" chart-dataset-override=\"vm.result.chart.override\"></canvas></div></div>");
$templateCache.put("app/directives/plugwise-card/plugwise-card.html","<div flex layout=\"row\" ng-if=\"vm.widget.graph.orientation==\'vertical\'\"><div \nng-repeat=\"result in vm.results track by $index\" flex layout=\"column\" layout-align=\"center center\"><div><md-icon flex \nmd-font-icon=\"pragma-icon-smart-plug\" ng-style=\"{\'color\':vm.widget.graph.fontColor}\"></md-icon></div><div><h2 \nng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{result.consumption | number : 2}} <span>W</span></h2><md-switch \nng-model=\"result.status\" layout-align=\"center center\" aria-label=\"Switch 1\" ng-change=\"vm.changeStatus(result)\">\n</md-switch><p ng-style=\"{\'color\':vm.labelColor}\">{{result.deviceName}}</p></div></div></div><div \nng-if=\"vm.widget.graph.orientation==\'horizontal\'\" flex layout=\"column\" layout-align=\"center center\"><div flex \nlayout=\"row\" layout-align=\"center center\" ng-repeat=\"result in vm.results track by $index\"><div class=\"md-icon-cnt\">\n<md-icon md-font-icon=\"pragma-icon-smart-plug\" ng-style=\"{\'color\':vm.widget.graph.fontColor}\"></md-icon></div><div \nclass=\"desc-cnt\"><h2 ng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{result.consumption | number : 2}} <span>W</span>\n</h2><md-switch ng-model=\"result.status\" layout-align=\"center center\" aria-label=\"Switch 1\" \nng-change=\"vm.changeStatus(result)\"></md-switch><p ng-style=\"{\'color\':vm.labelColor}\">{{result.deviceName}}</p></div>\n</div></div>");
$templateCache.put("app/directives/prediction-plot/prediction-plot.html","<div id=\"predictionPlot\"><div layout=\"row\" style=\"margin-top:10px\"><canvas id=\"{{vm.plotId}}\" ng-show=\"vm.showGraph\">\n</canvas></div></div>");
$templateCache.put("app/directives/presence-card/presence-card.html","<div flex layout=\"row\"><div ng-repeat=\"device in vm.devices track by $index\" flex layout=\"column\"><div flex><md-icon \nflex ng-if=\"!device.measurements.bulgrarAlarm || device.measurements.bulgrarAlarm===0\" \nmd-font-icon=\"pragma-icon-motion-no\" class=\"motion-no\"></md-icon><md-icon flex \nng-if=\"device.measurements.bulgrarAlarm===1\" md-font-icon=\"pragma-icon-motion\" class=\"motion\"></md-icon></div><div \nflex><p>{{device.name}}</p><div class=\"timestamp\" ng-style=\"{\'color\':vm.dateColor}\">\n{{device.measurements.timestamp | date:\'dd/MM/yyyy h:mma\'}}</div></div></div></div>");
$templateCache.put("app/directives/section-widget/section-widget.html","<div class=\"h1\" flex>{{vm.widget.title}}</div>");
$templateCache.put("app/directives/spyder-card/spyder-card-report.html","<div id=\"spyderCardReport\"><div layout=\"row\" layout-align=\"center center\" ng-if=\"!loadingProcess\"><md-progress-circular\n class=\"md-warn\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div><div \nid=\"report-image-container\"><img src=\"assets/images/reports/radar-default.png\" alt=\"graph\"></div></div>");
$templateCache.put("app/directives/spyder-card/spyder-card.html","<div id=\"spyderCard\"><canvas id=\"radar\" class=\"chart chart-radar\" chart-data=\"vm.chart.data\" \nchart-options=\"vm.chart.options\" chart-labels=\"vm.chart.labels\" chart-colors=\"vm.chart.colors\"></canvas></div>");
$templateCache.put("app/directives/string-card/string-card.html","<div id=\"stringCard\"><div ng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.result}}</div><div class=\"dates\" \nng-style=\"{\'color\':vm.dateColor}\">{{vm.eventTime | date:\'dd/MM/yyyy h:mma\'}}</div></div>");
$templateCache.put("app/directives/table-card/table-card.html","<md-table-container><table data-md-table md-progress=\"promise\" class=\"sites card\"><thead \nng-if=\"!vm.table.options.decapitate\" md-head><tr md-row><th md-column ng-repeat=\"resp in vm.response.series\"><span>\n{{resp}}</span></th><th md-column><span>Timestamp</span></th></tr></thead><tbody md-body><tr md-row \ndata-ng-repeat=\"resp in vm.response.cli\"><td md-cell ng-repeat=\"r in vm.response.count\">{{vm.response.data[resp][r]}}\n</td><td md-cell>{{vm.response.timestamp[resp] | date:\'dd/MM/yyyy h:mma\'}}</td></tr></tbody></table>\n</md-table-container>");
$templateCache.put("app/directives/tv-card/tv-card.html","<div flex layout=\"row\"><div flex layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/tv/power_on.png\" \nclass=\"tvButton\" ng-click=\"vm.changeTVState(\'powerOff\')\"><div flex><img src=\"assets/images/tv/volume_up.png\" \nclass=\"tvButton\" ng-click=\"vm.changeTVState(\'volumeUp\')\"></div></div><div flex layout=\"column\" \nlayout-align=\"center center\"><img src=\"assets/images/tv/mute.png\" class=\"tvButton\" ng-click=\"vm.changeTVState(\'mute\')\">\n<div flex><img src=\"assets/images/tv/volume_down.png\" class=\"tvButton\" ng-click=\"vm.changeTVState(\'volumeDown\')\"></div>\n</div></div>");
$templateCache.put("app/directives/waste-bin/waste-bin.html","<div id=\"{{vm.plotId}}_\" class=\"wasteBin\"><canvas id=\"{{vm.plotId}}\"></canvas></div>");
$templateCache.put("app/directives/waste-table/waste-table.html","<div id=\"wasteTable\"><div layout=\"row\" layout-align=\"space-between left\"><div layout=\"column\"><data-md-table-pagination\n md-limit=\"vm.table.query.limit\" md-limit-options=\"vm.table.limitOptions\" md-page=\"vm.table.query.page\" \nmd-total=\"{{vm.results.length}}\" md-boundary-links=\"vm.table.options.boundaryLinks\"></data-md-table-pagination></div>\n<div layout=\"column\" ng-if=\"vm.showRefresh\"><md-button class=\"md-icon-button\" ng-click=\"vm.reload()\" \naria-label=\"Refresh\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button></div></div><md-table-container><table \ndata-md-table md-progress=\"promise\" class=\"sites card\"><thead ng-if=\"!vm.table.options.decapitate\" md-head \ndata-md-order=\"vm.table.query.order\"><tr md-row><th md-column md:order:by=\"wasteBin\"><span>Waste Bin</span></th><th \nmd-column md:order:by=\"delta\"><span>Delta Weight</span></th><th md-column md:order:by=\"weight\"><span>Total Weight\n</span></th><th md-column md:order:by=\"cardId\"><span>Card ID</span></th><th md-column md:order:by=\"timestamp\"><span>\nTimestamp</span></th></tr></thead><tbody md-body><tr md-row \ndata-ng-repeat=\"result in vm.results | filter: vm.table.filter.search | orderBy: vm.table.query.order | limitTo: vm.table.query.limit : (vm.table.query.page - 1) * vm.table.query.limit\">\n<td md-cell>{{result.wasteBin}}</td><td md-cell>{{result.delta}} g</td><td md-cell>{{result.weight}} g</td><td md-cell>\n{{result.cardId}}</td><td md-cell>{{result.timestamp | date:\'dd/MM/yyyy h:mma\'}}</td></tr></tbody></table>\n</md-table-container></div>");
$templateCache.put("app/directives/wind-direction/wind-direction.html","<div flex layout=\"row\"><div flex layout=\"column\" layout-align=\"center center\"><div><md-icon flex \nmd-font-icon=\"{{vm.icon}}\" ng-style=\"{\'color\':vm.widget.graph.fontColor}\"></md-icon></div><div><h2 \nng-style=\"{\'color\':vm.widget.graph.fontColor}\">{{vm.result}}</h2><div class=\"timestamp\" \nng-style=\"{\'color\':vm.dateColor}\">{{vm.dateResult | date:\'dd/MM/yyyy h:mma\'}}</div></div></div></div>");
$templateCache.put("app/main/admin/admin.html","<div id=\"admin\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><md-progress-circular ng-if=\"vm.spinner\">\n</md-progress-circular><div id=\"content-wrapper\" class=\"md-primary-bg md-hue-3\"><div class=\"content sidenav\" \nlayout=\"row\"><div hide show-md show-sm show-xs \nng-if=\"vm.selectedTab!=0 && vm.selectedTab!=1 && vm.selectedTab!=9  && vm.selectedTab!=10 && vm.assetShow == 0\"><button\n class=\"toggle-left-sidenav md-background-bg md-hue-1\" type=\"button\" ng-click=\"vm.toggleSidenav(\'left-sidenav\')\" \naria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button>\n</div><div hide show-gt-md \nng-if=\"vm.selectedTab!=0 && vm.selectedTab!=1 && vm.selectedTab!=9  && vm.selectedTab!=10 && vm.assetShow == 0\"><button\n class=\"toggle-left-sidenav md-background-bg md-hue-1\" type=\"button\" ng-click=\"vm.lockLeft=!vm.lockLeft\" \naria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button>\n</div><md-sidenav \nng-if=\"vm.selectedTab!=0 && vm.selectedTab!=1 && vm.selectedTab!=9 && vm.selectedTab!=10 && vm.assetShow == 0\" \nclass=\"sidenav sidenav-width-300 md-sidenav-left\" md-is-locked-open=\"vm.lockLeft && $mdMedia(\'gt-md\')\" \nmd-component-id=\"left-sidenav\" md-disable-backdrop ms-scroll ms-sidenav-helper><md-toolbar \nclass=\"md-toolbar-admin md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding><div \nclass=\"toolbar\"><div hide show-gt-md><md-icon ng-click=\"vm.changeStatusL(\'left-sidenav\')\" class=\"s16 sidhov\" \nmd-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\"></md-icon></div><div hide show-md show-sm show-xs><md-icon \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\">\n</md-icon></div></div><div class=\"heading\">{{ \'DASHBOARD.MONITORED_POINTS\' | translate }}</div></md-toolbar><md-content\n class=\"content md-background-bg md-hue-1\" ms-scroll layout-padding><div \nclass=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input class=\"md-background-bg md-hue-1\" flex \nng-model=\"vm.searchtree\" type=\"text\" ng-change=\"vm.applySearch()\" \nplaceholder=\"{{ \'DASHBOARD.SEARCH_TREE\' | translate }}\"></div></div><div layout=\"row\"><div \nid=\"tree_{{vm.selectedTab}}\" class=\"tree\" js-tree=\"vm.treeConfig\" ng-model=\"vm.treeData\" tree=\"vm.treeInstance\" \ntree-events-obj=\"vm.treeEvents\"></div></div><md-content></md-content></md-content></md-sidenav><div \nclass=\"page-content\" ms-scroll flex><md-tabs md-dynamic-height ng-show=\"vm.assetShow == 0\" md-autoselect><md-tab \nui-sref=\"app.admin.users\" md-on-select=\"vm.changeTab(0)\" \nng-if=\"vm.user.role==\'level01\' || vm.user.role==\'level02\' || vm.user.role==\'level03\'\"><md-tab-label><span \ntranslate=\"ADMINISTRATION.TABS.USERS\">Users</span></md-tab-label><md-tab-body><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start end\" layout-align-xs=\"center center\"><div layout=\"row\" flex><div \nclass=\"custom-icon-button-wrapper\"><md-button flow-btn class=\"add-button md-icon-button\" \nng-click=\"vm.openNewUserDialog($event)\" aria-label=\"Add User\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ADD_USER\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_USER\">Add User</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-hidden=\"true\">\n</md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div class=\"md-title\" \ntranslate=\"ADMINISTRATION.USER_ADMINISTRATION\">User Administration</div><span \ntranslate=\"ADMINISTRATION.MESSAGE.USER_CAN_DO_MORE\">\nCreate, edit and delete users. Select user roles to apply special permissions. Disable existing users and manage passwords. Upload avatar images. Edit contact details.\n</span></div></div><div class=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.usersTable.filter.search\" placeholder=\"Search Users\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_USERS\"></div></div></div><data-md-table-pagination \nmd-limit=\"vm.usersTable.query.limit\" md-limit-options=\"vm.usersTable.limitOptions\" md-page=\"vm.usersTable.query.page\" \nmd-total=\"{{(vm.users.results|filter:vm.usersTable.filter.search).length}}\" \nmd-boundary-links=\"vm.usersTable.options.boundaryLinks\"></data-md-table-pagination><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"users card\"><thead class=\"\" ng-if=\"!vm.usersTable.options.decapitate\" md-head \ndata-md-order=\"vm.usersTable.query.order\"><tr md-row><th md-column>&nbsp;</th><th md-column md:order:by=\"username\">\n<span translate=\"ADMINISTRATION.USER_NAME\">User Name</span></th><th md-column md:order:by=\"firstName\"><span \ntranslate=\"ADMINISTRATION.FIRST_NAME\">First Name</span></th><th md-column md:order:by=\"lastName\"><span \ntranslate=\"ADMINISTRATION.LAST_NAME\">Last Name</span></th><th md-column md:order:by=\"metadata.email\"><span \ntranslate=\"ADMINISTRATION.EMAIL\">Email</span></th><th md-column md:order:by=\"metadata.role\"><span \ntranslate=\"ADMINISTRATION.ROLE\">Role</span></th><th md-column md:order:by=\"status\"><span \ntranslate=\"ADMINISTRATION.FORMS.USER_STATUS\">Status</span></th><th md-column><span translate=\"ADMINISTRATION.ACTIONS\">\nActions</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.users.results.length\"><td md-cell></td><td \nmd-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NO_DATA\">No data available in table...</h3>\n<p translate=\"ADMINISTRATION.MESSAGE.ADD_USER\">Click on the \'Add User\' button to add a new user.</p></div></td></tr><tr\n md-row \nng-if=\"vm.users.results.length && vm.usersTable.filter.search && !(vm.users.results|filter:vm.usersTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">\nNothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"user in vm.users.results | filter: vm.usersTable.filter.search | orderBy: vm.usersTable.query.order | limitTo: vm.usersTable.query.limit : (vm.usersTable.query.page - 1) * vm.usersTable.query.limit\">\n<td md-cell><div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" \nng-click=\"vm.openEditUserDialog($event, user)\" aria-label=\"Edit User\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_USER\"><md-tooltip md-direction=\"right\"><span \ntranslate=\"ADMINISTRATION.EDIT_USER\">Edit User</span></md-tooltip><md-icon md-font-icon=\"icon-account\" \naria-hidden=\"true\"></md-icon></md-button></div></td><td md-cell>{{user.username}}</td><td md-cell>{{user.firstName}}\n</td><td md-cell>{{user.lastName}}</td><td md-cell>{{user.metadata.email}}</td><td md-cell \nng-if=\"user.metadata.role===\'level01\'\" translate=\"ADMINISTRATION.ROLES.SUPER\">Super Administrator</td><td md-cell \nng-if=\"user.metadata.role===\'level02\'\" translate=\"ADMINISTRATION.ROLES.ADMIN\">Administrator</td><td md-cell \nng-if=\"user.metadata.role===\'level03\'\" translate=\"ADMINISTRATION.ROLES.WHITE_LABEL\">White Label</td><td md-cell \nng-if=\"user.metadata.role===\'level04\'\" translate=\"ADMINISTRATION.ROLES.PORTFOLIO\">Portfolio</td><td md-cell \nng-if=\"user.metadata.role===\'level05\'\" translate=\"ADMINISTRATION.ROLES.SITE\">Site</td><td md-cell>{{user.status}}</td>\n<td md-cell><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.openEditUserDialog($event, user)\" \naria-label=\"Edit User\" translate translate-attr-aria-label=\"ADMINISTRATION.EDIT_USER\"><md-tooltip md-direction=\"top\">\n<span translate=\"ADMINISTRATION.EDIT_USER\">Edit User</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s24\" aria-hidden=\"true\"></md-icon></md-button><md-button class=\"delete-button md-icon-button\" \nng-click=\"vm.openDeleteUserDialog($event, user)\" aria-label=\"Delete User\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.DELETE_USER\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.DELETE_USER\">Delete User</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"s24\" \naria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div></md-tab-body></md-tab>\n<md-tab ui-sref=\"app.admin.clients\" md-on-select=\"vm.changeTab(1)\" \nng-if=\"vm.user.role==\'level01\' || vm.user.role==\'level02\'\"><md-tab-label><span translate=\"ADMINISTRATION.TABS.CLIENTS\">\nClients</span></md-tab-label><md-tab-body><div layout=\"row\" layout-xs=\"column\" layout-align=\"start end\" \nlayout-align-xs=\"center center\"><div layout=\"row\" flex><div class=\"custom-icon-button-wrapper\"><md-button flow-btn \nclass=\"add-button md-icon-button\" ng-click=\"vm.openNewTenantDialog($event)\" aria-label=\"Add Client\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ADD_CLIENT\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_CLIENT\">Add Client</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-hidden=\"true\"></md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div class=\"md-title\" \ntranslate=\"ADMINISTRATION.CLIENT_ADMINISTRATION\">Client Administration</div><span \ntranslate=\"ADMINISTRATION.MESSAGE.CLIENT_CAN_DO\">\nCreate, edit and delete clients. Each white label user needs her own entry in this table. Make sure to start a new client database by clicking on the corresponding action button.\n</span></div></div><div class=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.tenantsTable.filter.search\" placeholder=\"Search Clients\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_CLIENTS\"></div></div></div><data-md-table-pagination \nmd-limit=\"vm.tenantsTable.query.limit\" md-limit-options=\"vm.tenantsTable.limitOptions\" \nmd-page=\"vm.tenantsTable.query.page\" md-total=\"{{(vm.tenants|filter:vm.tenantsTable.filter.search).length}}\" \nmd-boundary-links=\"vm.tenantsTable.options.boundaryLinks\"></data-md-table-pagination><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"card clients\"><thead ng-if=\"!vm.tenantsTable.options.decapitate\" md-head \ndata-md-order=\"vm.tenantsTable.query.order\"><tr md-row><th md-column>&nbsp;</th><th md-column md:order:by=\"name\"><span \ntranslate=\"ADMINISTRATION.NAME\">Name</span></th><th md-column md:order:by=\"authenticationToken\"><span \ntranslate=\"ADMINISTRATION.AUTH_TOKEN\">Authentication Token</span></th><th md-column md:order:by=\"id\"><span \ntranslate=\"ADMINISTRATION.ID\">ID</span></th><th md-column><span translate=\"ADMINISTRATION.AUTH_USERS\">Authorized Users\n</span></th><th md-column><span translate=\"ADMINISTRATION.ACTIONS\">Actions</span></th></tr></thead><tbody md-body><tr \nmd-row ng-if=\"!vm.tenants.length\"><td md-cell></td><td md-cell colspan=\"4\"><div class=\"p-25\"><h3 \ntranslate=\"ADMINISTRATION.MESSAGE.NO_DATA\">No data available in table...</h3><p \ntranslate=\"ADMINISTRATION.MESSAGE.ADD_CLIENT\">Click on the \'Add Client\' button to add a new client.</p></div></td></tr>\n<tr md-row \nng-if=\"vm.tenants.results.length && vm.tenantsTable.filter.search && !(vm.tenants|filter:vm.tenantsTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">\nNothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"tenant in vm.tenants | filter: vm.tenantsTable.filter.search | orderBy: vm.tenantsTable.query.order | limitTo: vm.tenantsTable.query.limit : (vm.tenantsTable.query.page - 1) * vm.tenantsTable.query.limit\">\n<td md-cell><div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" \nng-click=\"vm.openEditTenantDialog($event,tenant)\" aria-label=\"Edit Client\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_CLIENT\"><md-tooltip md-direction=\"right\"><span \ntranslate=\"ADMINISTRATION.EDIT_CLIENT\">Edit Client</span></md-tooltip><md-icon md-font-icon=\"icon-account-key\" \naria-hidden=\"true\"></md-icon></md-button></div></td><td md-cell>{{tenant.name}}</td><td md-cell>\n{{tenant.authenticationToken}}</td><td md-cell>{{tenant.id}}</td><td md-cell>{{tenant.authorizedUserIds}}</td><td \nmd-cell><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.openEditTenantDialog($event,tenant)\" \naria-label=\"Edit Client\" translate translate-attr-aria-label=\"ADMINISTRATION.EDIT_CLIENT\"><md-tooltip \nmd-direction=\"top\"><span translate=\"ADMINISTRATION.EDIT_CLIENT\">Edit Client</span></md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s24\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"delete-button md-icon-button\" ng-click=\"vm.openDeleteTenantDialog($event,tenant)\" aria-label=\"Delete Client\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.DELETE_CLIENT\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.DELETE_CLIENT\">Delete Client</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"s24\" aria-hidden=\"true\"></md-icon></md-button><md-divider class=\"vertical-divider\"></md-divider><md-button \nclass=\"start-button md-icon-button\" aria-label=\"Start Client Database\" ng-click=\"vm.startStopTenant(\'start\',tenant)\" \nng-show=\"tenant.lifecycleStatus===\'Stopped\'\" translate translate-attr-aria-label=\"ADMINISTRATION.START_CLIENT_DB\">\n<md-tooltip md-direction=\"top\"><span translate=\"ADMINISTRATION.START_CLIENT_DB\">Start Client Database</span>\n</md-tooltip><md-icon md-font-icon=\"icon-play\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"stop-button md-icon-button\" aria-label=\"Stop Client Database\" ng-click=\"vm.startStopTenant(\'stop\',tenant)\" \nng-show=\"tenant.lifecycleStatus===\'Started\' || tenant.lifecycleStatus===\'Starting\'\" \nng-disabled=\"tenant.lifecycleStatus===\'Starting\'\" translate translate-attr-aria-label=\"ADMINISTRATION.STOP_CLIENT_DB\">\n<md-tooltip md-direction=\"top\"><span translate=\"ADMINISTRATION.STOP_CLIENT_DB\">Stop Client Database</span></md-tooltip>\n<md-icon md-font-icon=\"icon-power\" aria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table>\n</md-table-container></div></md-tab-body></md-tab><md-tab ui-sref=\"app.admin.portfolios\" \nmd-on-select=\"vm.changeTab(2)\" ng-if=\"vm.user.role==\'level01\' || vm.user.role==\'level02\' || vm.user.role==\'level03\'\">\n<md-tab-label><span translate=\"ADMINISTRATION.TABS.PORTFOLIOS\">Portfolios</span></md-tab-label><md-tab-body><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start end\" layout-align-xs=\"center center\"><div layout=\"row\" flex><div \nclass=\"custom-icon-button-wrapper\"><md-button flow-btn class=\"add-button md-icon-button\" \nng-click=\"vm.openNewSiteGroupDialog($event)\" aria-label=\"Add Portfolio\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ADD_PORTFOLIO\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_PORTFOLIO\">Add Portfolio</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-hidden=\"true\"></md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div class=\"md-title\" \ntranslate=\"ADMINISTRATION.PORTFOLIO_ADMINISTRATION\">Portfolio Administration</div><span \ntranslate=\"ADMINISTRATION.MESSAGE.PORTFOLIO_CAN_DO\">\nCreate, edit and delete portfolios. Portfolios are used to organize sites into groups. Click on \"Manage Portfolio\" to add sites to a portfolio. You may want to create your sites first.\n</span></div></div><div class=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.siteGroupsTable.filter.search\" placeholder=\"Search Portfolios\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_PORTFOLIOS\"></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"space-between center\"><div class=\"md-title\" flex>\nClient: \'{{ vm.selectedTenant.name }}\'</div><div flex><data-md-table-pagination \nmd-limit=\"vm.siteGroupsTable.query.limit\" md-limit-options=\"vm.siteGroupsTable.limitOptions\" \nmd-page=\"vm.siteGroupsTable.query.page\" md-total=\"{{(vm.portfolios|filter:vm.siteGroupsTable.filter.search).length}}\" \nmd-boundary-links=\"vm.siteGroupsTable.options.boundaryLinks\"></data-md-table-pagination></div></div><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"card portfolios\"><thead ng-if=\"!vm.siteGroupsTable.options.decapitate\" md-head \ndata-md-order=\"vm.siteGroupsTable.query.order\"><tr md-row><th md-column>&nbsp;</th><th md-column md:order:by=\"name\">\n<span translate=\"ADMINISTRATION.NAME\">Name</span></th><th md-column md:order:by=\"token\"><span \ntranslate=\"ADMINISTRATION.TOKEN\">Token</span></th><th md-column><span translate=\"ADMINISTRATION.AUTH_USERS\">\nAuthorized Users</span></th><th md-column><span translate=\"ADMINISTRATION.FORMS.DESCRIPTION\">Description</span></th><th\n md-column><span translate=\"ADMINISTRATION.ACTIONS\">Actions</span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"!vm.portfolios.length\"><td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 \ntranslate=\"ADMINISTRATION.MESSAGE.NO_DATA\">No data available in table...</h3><span \ntranslate=\"ADMINISTRATION.MESSAGE.ADD_PORTFOLIO\">Click on \"Add Portfolio\" to add a new portfolio</span> <span \nng-if=\"vm.tenants.length > 1\" translate=\"ADMINISTRATION.MESSAGE.SELECT_ANOTHER_CLIENT\">, or select another client\n</span></div></td></tr><tr md-row \nng-if=\"vm.portfolios.length && vm.siteGroupsTable.filter.search && !(vm.portfolios|filter:vm.siteGroupsTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">\nNothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"portfolio in vm.portfolios | filter: vm.siteGroupsTable.filter.search | orderBy: vm.siteGroupsTable.query.order | limitTo: vm.siteGroupsTable.query.limit : (vm.siteGroupsTable.query.page - 1) * vm.siteGroupsTable.query.limit\">\n<td md-cell><div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" \nng-click=\"vm.openEditSiteGroupDialog($event,portfolio)\" aria-label=\"Edit Portfolio\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_PORTFOLIO\"><md-tooltip md-direction=\"right\"><span \ntranslate=\"ADMINISTRATION.EDIT_PORTFOLIO\">Edit Portfolio</span></md-tooltip><md-icon md-font-icon=\"icon-folder\" \naria-hidden=\"true\"></md-icon></md-button></div></td><td md-cell>{{portfolio.name}}</td><td md-cell>{{portfolio.token}}\n</td><td md-cell>{{portfolio.userId}}</td><td md-cell>{{portfolio.description}}</td><td md-cell><md-button \nclass=\"manage-button md-icon-button\" ng-click=\"vm.fillSiteGroupSitesTable(portfolio)\" aria-label=\"Manage Portfolio\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.MANAGE_PORTFOLIO\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.MANAGE_PORTFOLIO\">Manage Portfolio</span></md-tooltip><md-icon \nmd-font-icon=\"icon-playlist-plus\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.openEditSiteGroupDialog($event,portfolio)\" aria-label=\"Edit Portfolio\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.EDIT_PORTFOLIO\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.EDIT_PORTFOLIO\">Edit Portfolio</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s24\" aria-hidden=\"true\"></md-icon></md-button><md-button class=\"delete-button md-icon-button\" \nng-click=\"vm.openDeleteSiteGroupDialog($event,portfolio)\" aria-label=\"Delete Portfolio\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.DELETE_PORTFOLIO\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.DELETE_PORTFOLIO\">Delete Portfolio</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"s24\" aria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div>\n</md-tab-body></md-tab><md-tab ui-sref=\"app.admin.sites\" md-on-select=\"vm.changeTab(3)\" \nng-if=\"vm.user.role==\'level01\' || vm.user.role==\'level02\' || vm.user.role==\'level03\'\"><md-tab-label><span \ntranslate=\"ADMINISTRATION.TABS.SITES\">Sites</span></md-tab-label><md-tab-body><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start end\" layout-align-xs=\"center center\"><div layout=\"row\" flex><div \nclass=\"custom-icon-button-wrapper\"><md-button flow-btn class=\"add-button md-icon-button\" \nng-click=\"vm.openNewSiteDialog($event)\" aria-label=\"Add Site\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ADD_SITE\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_SITE\">Add Site</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-hidden=\"true\">\n</md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div class=\"md-title\" \ntranslate=\"ADMINISTRATION.SITE_ADMINISTRATION\">Site Administration</div><span \ntranslate=\"ADMINISTRATION.MESSAGE.SITES_CAN_DO\">\nCreate, edit and delete sites. Sites are the main asset of the PRAGMA platform. Sites include devices which are used to monitor energy consumption and production at different levels of detail.\n</span></div></div><div class=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.sitesTable.filter.search\" placeholder=\"Search Sites\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_SITES\"></div></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-title\" flex>Client: \'{{ vm.selectedTenant.name }}\'</div><div flex>\n<data-md-table-pagination md-limit=\"vm.sitesTable.query.limit\" md-limit-options=\"vm.sitesTable.limitOptions\" \nmd-page=\"vm.sitesTable.query.page\" md-total=\"{{(vm.sites.results|filter:vm.sitesTable.filter.search).length}}\" \nmd-boundary-links=\"vm.sitesTable.options.boundaryLinks\"></data-md-table-pagination></div></div><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"sites card\"><thead ng-if=\"!vm.sitesTable.options.decapitate\" md-head data-md-order=\"vm.sitesTable.query.order\">\n<tr md-row><th md-column>&nbsp;</th><th md-column md:order:by=\"name\"><span translate=\"ADMINISTRATION.NAME\">Name</span>\n</th><th md-column md:order:by=\"token\"><span translate=\"ADMINISTRATION.TOKEN\">Token</span></th><th md-column><span \ntranslate=\"ADMINISTRATION.AUTH_USERS\">Authorized Users</span></th><th md-column md:order:by=\"createdDate\"><span \ntranslate=\"ADMINISTRATION.DATE_CREATED\">Date Created</span></th><th md-column><span translate=\"ADMINISTRATION.ACTIONS\">\nActions</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.sites.results.length\"><td md-cell></td><td \nmd-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NO_DATA\">No data available in table...</h3>\n<p translate=\"ADMINISTRATION.MESSAGE.ADD_SITES\">Click on the \'Add Site\' button to add a new site.</p></div></td></tr>\n<tr md-row \nng-if=\"vm.sites.results.length && vm.sitesTable.filter.search && !(vm.sites.results|filter:vm.sitesTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">\nNothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"site in vm.sites.results | filter: vm.sitesTable.filter.search | orderBy: vm.sitesTable.query.order | limitTo: vm.sitesTable.query.limit : (vm.sitesTable.query.page - 1) * vm.sitesTable.query.limit\">\n<td md-cell><div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" \nng-click=\"vm.openEditSiteDialog($event, site)\" aria-label=\"Edit Site\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_SITE\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.EDIT_SITE\">Edit Site</span></md-tooltip><md-icon md-font-icon=\"icon-home\" aria-hidden=\"true\">\n</md-icon></md-button></div></td><td md-cell>{{site.name}}</td><td md-cell>{{site.token}}</td><td md-cell>\n{{site.authorizedUserIds}}</td><td md-cell>{{site.createdDate | date:\'MM/dd/yyyy h:mma\'}}</td><td md-cell><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.openEditSiteDialog($event, site)\" aria-label=\"Edit Site\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_SITE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.EDIT_SITE\">Edit Site</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" class=\"s24\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"delete-button md-icon-button\" \nng-click=\"vm.openDeleteSiteDialog($event, site)\" aria-label=\"Delete Site\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.DELETE_SITE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.DELETE_SITE\">Delete Site</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"s24\" \naria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div></md-tab-body></md-tab>\n<md-tab ui-sref=\"app.admin.costs\" md-on-select=\"vm.changeTab(4)\" \nng-if=\"vm.user.role==\'level01\' || vm.user.role==\'level02\' || vm.user.role==\'level03\'\"><md-tab-label><span \ntranslate=\"ADMINISTRATION.TABS.COSTS\">Costs</span></md-tab-label><md-tab-body><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start end\" layout-align-xs=\"center center\"><div layout=\"row\" flex><div \nclass=\"custom-icon-button-wrapper\"><md-button flow-btn class=\"add-button md-icon-button\" \nng-click=\"vm.openNewCostProfileDialog($event)\" aria-label=\"Add Cost Profile\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ADD_COST_PROFILE\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_COST_PROFILE\">Add Cost Profile</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-hidden=\"true\"></md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div class=\"md-title\" \ntranslate=\"ADMINISTRATION.COST_PROFILE_ADMINISTRATION\">Cost Profile Administration</div><span \ntranslate=\"ADMINISTRATION.MESSAGE.COST_CAN_DO\">\nCreate, edit and delete cost profiles. Each cost profile includes various types of costs (per unit costs, distribution charges, taxes etc.). Click on \'Manage Cost Profile\' to set up costs.\n</span></div></div><div class=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.costProfilesTable.filter.search\" placeholder=\"Search Cost Profiles\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_COST_PROFILES\"></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"space-between center\"><div class=\"md-title\" flex>\nClient: \'{{ vm.selectedTenant.name }}\'</div><div flex><data-md-table-pagination \nmd-limit=\"vm.costProfilesTable.query.limit\" md-limit-options=\"vm.costProfilesTable.limitOptions\" \nmd-page=\"vm.costProfilesTable.query.page\" md-total=\"{{vm.costProfiles.numResults}}\" \nmd-total=\"{{(vm.costProfiles.results|filter:vm.costProfilesTable.filter.search).length}}\" \nmd-boundary-links=\"vm.costProfilesTable.options.boundaryLinks\"></data-md-table-pagination></div></div><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"card cost-profiles\"><thead ng-if=\"!vm.costProfilesTable.options.decapitate\" md-head \ndata-md-order=\"vm.costProfilesTable.query.order\"><tr md-row><th md-column>&nbsp;</th><th md-column md:order:by=\"name\">\n<span translate=\"ADMINISTRATION.NAME\">Name</span></th><th md-column md:order:by=\"token\"><span \ntranslate=\"ADMINISTRATION.TOKEN\">Token</span></th><th md-column md:order:by=\"type\"><span \ntranslate=\"ADMINISTRATION.MEASURE\">Measure</span></th><th md-column md:order:by=\"startDate\"><span \ntranslate=\"ADMINISTRATION.START_DATE\">Start Date</span></th><th md-column><span translate=\"ADMINISTRATION.ACTIONS\">\nActions</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.costProfiles.results.length\"><td md-cell></td><td \nmd-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NO_DATA\">No data available in table...</h3>\n<span translate=\"ADMINISTRATION.MESSAGE.ADD_COST\">Click on \'Add Cost Profile\' to add a new cost profile</span> <span \nng-if=\"vm.tenants.length > 1\" translate=\"ADMINISTRATION.MESSAGE.SELECT_ANOTHER_CLIENT\">, or select another client\n</span></div></td></tr><tr md-row \nng-if=\"vm.costProfiles.results.length && vm.costProfilesTable.filter.search && !(vm.costProfiles.results|filter:vm.costProfilesTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">\nNothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"costProfile in vm.costProfiles.results | filter: vm.costProfilesTable.filter.search | orderBy: vm.costProfilesTable.query.order | limitTo: vm.costProfilesTable.query.limit : (vm.costProfilesTable.query.page - 1) * vm.costProfilesTable.query.limit\">\n<td md-cell><div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" \nng-click=\"vm.openEditCostProfileDialog($event, costProfile)\" aria-label=\"Edit Cost Profile\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_COST_PROFILE\"><md-tooltip md-direction=\"right\"><span \ntranslate=\"ADMINISTRATION.EDIT_COST_PROFILE\">Edit Cost Profile</span></md-tooltip><md-icon \nmd-font-icon=\"icon-document\" aria-hidden=\"true\"></md-icon></md-button></div></td><td md-cell>{{costProfile.name}}</td>\n<td md-cell>{{costProfile.token}}</td><td md-cell>{{costProfile.measure}}</td><td md-cell>\n{{costProfile.startDate | date:\'MM/dd/yyyy h:mma\'}}</td><td md-cell><md-button class=\"manage-button md-icon-button\" \nng-click=\"vm.fillCostProfileCostsTable(costProfile)\" aria-label=\"Manage Cost Profile\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.MANAGE_COST_PROFILE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.MANAGE_COST_PROFILE\">Manage Cost Profile</span></md-tooltip><md-icon \nmd-font-icon=\"icon-playlist-plus\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.openEditCostProfileDialog($event, costProfile)\" \naria-label=\"Edit Cost Profile\" translate translate-attr-aria-label=\"ADMINISTRATION.EDIT_COST_PROFILE\"><md-tooltip \nmd-direction=\"top\"><span translate=\"ADMINISTRATION.EDIT_COST_PROFILE\">Edit Cost Profile</span></md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s24\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"delete-button md-icon-button\" ng-click=\"vm.openDeleteCostProfileDialog($event, costProfile)\" \naria-label=\"Delete Cost Profile\" translate translate-attr-aria-label=\"ADMINISTRATION.DELETE_COST_PROFILE\"><md-tooltip \nmd-direction=\"top\"><span translate=\"ADMINISTRATION.DELETE_COST_PROFILE\">Delete Cost Profile</span></md-tooltip><md-icon\n md-font-icon=\"icon-delete\" class=\"s24\" aria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table>\n</md-table-container></div></md-tab-body></md-tab><md-tab ui-sref=\"app.admin.assets\" md-on-select=\"vm.changeTab(5)\" \nng-if=\"vm.user.role==\'level01\'\"><md-tab-label><span translate=\"ADMINISTRATION.TABS.ASSETS\">Assets</span></md-tab-label>\n<md-tab-body><div layout=\"row\" layout-xs=\"column\" layout-align=\"start end\" layout-align-xs=\"center center\"><div \nlayout=\"row\" flex><div class=\"custom-icon-button-wrapper\"><md-button flow-btn class=\"add-button md-icon-button\" \nng-click=\"vm.openNewAssetDialog($event)\" aria-label=\"Add Portfolio\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ADD_ASSET\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_ASSET\">New Asset Category</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-hidden=\"true\"></md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div class=\"md-title\" \ntranslate=\"ADMINISTRATION.ASSET_ADMINISTRATION\">Asset Category Administration</div><span \ntranslate=\"ADMINISTRATION.MESSAGE.ASSET_CATEGORY_CAN_DO\">\nCreate, edit and delete asset categories. Asset Categories are used to organize assets into categories. Click on \'Manage Asset Category\' to add assets to a category. You may want to create your asset category first.\n</span></div></div><div class=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.assetsTable.filter.search\" placeholder=\"Search Asset Categories\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_ASSET_CATEGORIES\"></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"space-between center\"><div class=\"md-title\" flex>\nClient: \'{{ vm.selectedTenant.name }}\'</div><div flex><data-md-table-pagination md-limit=\"vm.assetsTable.query.limit\" \nmd-limit-options=\"vm.assetsTable.limitOptions\" md-page=\"vm.assetsTable.query.page\" \nmd-total=\"{{(vm.assets|filter:vm.assetsTable.filter.search).length}}\" \nmd-boundary-links=\"vm.assetsTable.options.boundaryLinks\"></data-md-table-pagination></div></div><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"card portfolios\"><thead ng-if=\"!vm.assetsTable.options.decapitate\" md-head \ndata-md-order=\"vm.assetsTable.query.order\"><tr md-row><th md-column>&nbsp;</th><th md-column md:order:by=\"name\"><span \ntranslate=\"ADMINISTRATION.NAME\">Name</span></th><th md-column md:order:by=\"assetType\"><span \ntranslate=\"ADMINISTRATION.TYPE\">Type</span></th><th md-column md:order:by=\"id\"><span translate=\"ADMINISTRATION.AC_ID\">\nAsset Category ID</span></th><th md-column><span translate=\"ADMINISTRATION.ACTIONS\">Actions</span></th></tr></thead>\n<tbody md-body><tr md-row ng-if=\"!vm.assets.length\"><td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 \ntranslate=\"ADMINISTRATION.MESSAGE.NO_DATA\">No data available in table...</h3><span \ntranslate=\"ADMINISTRATION.MESSAGE.ADD_ASSET_CATEGORY\">Click on \'Add Asset Category\' to add a new category</span> <span \nng-if=\"vm.tenants.length > 1\" translate=\"ADMINISTRATION.MESSAGE.SELECT_ANOTHER_CLIENT\">, or select another client\n</span></div></td></tr><tr md-row \nng-if=\"vm.assets.length && vm.assetsTable.filter.search && !(vm.assets|filter:vm.assetsTable.filter.search).length\"><td\n md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">Nothing found...\n</h3></div></td></tr><tr ng-if=\"vm.assets.length!=0\" md-row \ndata-ng-repeat=\"asset in vm.assets | filter: vm.assetsTable.filter.search | orderBy: vm.assetsTable.query.order | limitTo: vm.assetsTable.query.limit : (vm.assetsTable.query.page - 1) * vm.assetsTable.query.limit\">\n<td md-cell><div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" \nng-click=\"vm.openEditAssetDialog($event,asset)\" aria-label=\"Edit Asset Category\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_AC\"><md-tooltip md-direction=\"right\"><span \ntranslate=\"ADMINISTRATION.EDIT_AC\">Edit Asset Category</span></md-tooltip><md-icon md-font-icon=\"icon-folder\" \naria-hidden=\"true\"></md-icon></md-button></div></td><td md-cell>{{asset.name}}</td><td md-cell>{{asset.assetType}}</td>\n<td md-cell>{{asset.id}}</td><td md-cell><md-button class=\"manage-button md-icon-button\" \nng-click=\"vm.fillAssetsCategoryTable(asset)\" aria-label=\"Manage Asset Category\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FILL_ASSET_CATEGORY\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.MANAGE_ASSET_CATEGORY\">Manage Asset Category</span></md-tooltip><md-icon \nmd-font-icon=\"icon-playlist-plus\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.openEditAssetDialog($event,asset)\" aria-label=\"Edit Asset Category\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.EDIT_AC\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.EDIT_AC\">Edit Asset Category</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s24\" aria-hidden=\"true\"></md-icon></md-button><md-button class=\"delete-button md-icon-button\" \nng-click=\"vm.openDeleteAssetDialog($event,asset)\" aria-label=\"Delete Asset Category\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.DELETE_AC\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.DELETE_AC\">Delete Asset Category</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"s24\" aria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div>\n</md-tab-body></md-tab><md-tab ui-sref=\"app.admin.specifications\" md-on-select=\"vm.changeTab(6)\" \nng-if=\"vm.user.role==\'level01\'\"><md-tab-label><span translate=\"ADMINISTRATION.TABS.SPECIFICATIONS\">Specifications\n</span></md-tab-label><md-tab-body><div layout=\"row\" layout-xs=\"column\" layout-align=\"start end\" \nlayout-align-xs=\"center center\"><div layout=\"row\" flex><div class=\"custom-icon-button-wrapper\"><md-button flow-btn \nclass=\"add-button md-icon-button\" ng-click=\"vm.openNewSpecificationDialog($event)\" aria-label=\"Add Specification\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.ADD_SPECIFICATION\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_SPECIFICATION\">New Specification</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-hidden=\"true\"></md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div class=\"md-title\" \ntranslate=\"ADMINISTRATION.SPECIFICATION_ADMINISTRATION\">Specification Administration</div><span \ntranslate=\"ADMINISTRATION.MESSAGE.SPECIFICATION_CAN_DO\">\nCreate, edit and delete specifications. Specifications are used to organize your device specifications.</span></div>\n</div><div class=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.specificationsTable.filter.search\" placeholder=\"Search Specifications\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_SPECIFICATIONS\"></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"space-between center\"><div class=\"md-title\" flex>\nClient: \'{{ vm.selectedTenant.name }}\'</div><div flex><data-md-table-pagination \nmd-limit=\"vm.specificationsTable.query.limit\" md-limit-options=\"vm.specificationsTable.limitOptions\" \nmd-page=\"vm.specificationsTable.query.page\" \nmd-total=\"{{(vm.specifications|filter:vm.specificationsTable.filter.search).length}}\" \nmd-boundary-links=\"vm.specificationsTable.options.boundaryLinks\"></data-md-table-pagination></div></div><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"card portfolios\"><thead ng-if=\"!vm.specificationsTable.options.decapitate\" md-head \ndata-md-order=\"vm.specificationsTable.query.order\"><tr md-row><th md-column><span>&nbsp;</span></th><th md-column \nmd:order:by=\"name\"><span translate=\"ADMINISTRATION.NAME\">Name</span></th><th md-column md:order:by=\"token\"><span \ntranslate=\"ADMINISTRATION.TOKEN\">Token</span></th><th md-column><span translate=\"ADMINISTRATION.ACTIONS\">Actions</span>\n</th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.specifications.length\"><td md-cell></td><td md-cell colspan=\"6\">\n<div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NO_DATA\">No data available in table...</h3><span \ntranslate=\"ADMINISTRATION.MESSAGE.ADD_SPECIFICATION\">Click on the \'Add Specification\' button to add a new specification\n</span> <span ng-if=\"vm.tenants.length > 1\" translate=\"ADMINISTRATION.MESSAGE.SELECT_ANOTHER_CLIENT\">\n, or select another client</span></div></td></tr><tr md-row \nng-if=\"vm.specifications.length && vm.specificationsTable.filter.search && !(vm.specifications|filter:vm.specificationsTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">\nNothing found...</h3></div></td></tr><tr ng-if=\"vm.specifications.length!=0\" md-row \ndata-ng-repeat=\"spec in vm.specifications | filter: vm.specificationsTable.filter.search | orderBy: vm.specificationsTable.query.order | limitTo: vm.specificationsTable.query.limit : (vm.specificationsTable.query.page - 1) * vm.specificationsTable.query.limit\">\n<td md-cell><div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" \nng-click=\"vm.openEditSpecificationDialog($event,spec)\" aria-label=\"Edit Specification\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_SPECIFICATION\"><md-tooltip md-direction=\"right\"><span \ntranslate=\"ADMINISTRATION.EDIT_SPECIFICATION\">Edit Specification</span></md-tooltip><md-icon \nmd-font-icon=\"icon-note-text\" aria-hidden=\"true\"></md-icon></md-button></div></td><td md-cell>{{spec.name}}</td><td \nmd-cell>{{spec.token}}</td><td md-cell style=\"text-align:center\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.openEditSpecificationDialog($event,spec)\" aria-label=\"Edit Specification\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_SPECIFICATION\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.EDIT_SPECIFICATION\">Edit Specification</span></md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s24\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"delete-button md-icon-button\" ng-click=\"vm.openDeleteSpecificationDialog($event,spec)\" \naria-label=\"Delete Specification\" translate translate-attr-aria-label=\"ADMINISTRATION.DELETE_SPECIFICATION\"><md-tooltip\n md-direction=\"top\"><span translate=\"ADMINISTRATION.DELETE_SPECIFICATION\">Delete Specification</span></md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" class=\"s24\" aria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table>\n</md-table-container></div></md-tab-body></md-tab><md-tab ui-sref=\"app.admin.devices\" md-on-select=\"vm.changeTab(7)\" \nng-if=\"vm.user.role==\'level01\' || vm.user.role==\'level02\' || vm.user.role==\'level03\'\"><md-tab-label><span \ntranslate=\"ADMINISTRATION.TABS.DEVICES\">Devices</span></md-tab-label><md-tab-body><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start end\" layout-align-xs=\"center center\"><div layout=\"row\" flex><div \nclass=\"custom-icon-button-wrapper\"><md-button flow-btn class=\"add-button md-icon-button\" \nng-click=\"vm.openNewDeviceDialog($event)\" aria-label=\"Add User\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ADD_USER\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_DEVICE\">Add Device</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-hidden=\"true\"></md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div class=\"md-title\" \ntranslate=\"ADMINISTRATION.DEVICE_ADMINISTRATION\">Device Administration</div><span \ntranslate=\"ADMINISTRATION.MESSAGE.DEVICES_MESSAGE\">Create, edit and delete devices.</span></div></div><div \nclass=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.deviceTable.filter.search\" placeholder=\"Search Devices\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_DEVICES\"></div></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-title\" flex>Site: \'{{ vm.selectedSite }}\' <small>\n[{{ vm.selectedTenant.name }}]</small></div><div flex><data-md-table-pagination md-limit=\"vm.deviceTable.query.limit\" \nmd-limit-options=\"vm.deviceTable.limitOptions\" md-page=\"vm.deviceTable.query.page\" \nmd-total=\"{{(vm.devices|filter:vm.deviceTable.filter.search).length}}\" \nmd-boundary-links=\"vm.deviceTable.options.boundaryLinks\"></data-md-table-pagination></div></div><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"users card\"><thead ng-if=\"!vm.deviceTable.options.decapitate\" md-head \ndata-md-order=\"vm.deviceTable.query.order\"><tr md-row><th md-column>&nbsp;</th><th md-column \nmd:order:by=\"metadata.name\"><span translate=\"ADMINISTRATION.NAME\">Name</span></th><th md-column \nmd:order:by=\"hardwareId\"><span>ID</span></th><th md-column md:order:by=\"assignment.token\"><span \ntranslate=\"ADMINISTRATION.ASS_TOKEN\">Device Assignment</span></th><th md-column md:order:by=\"metadata.notification\">\n<span translate=\"ADMINISTRATION.DEVICE_NOTIFICATION\">Send Inactive Notifications</span></th><th md-column><span \ntranslate=\"ADMINISTRATION.ACTIONS\">Actions</span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"!vm.devices.length\"><td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 \ntranslate=\"ADMINISTRATION.MESSAGE.NO_DATA\">No data available in table...</h3><p \ntranslate=\"ADMINISTRATION.MESSAGE.ADD_DEVICE\">Click on the \'Add Device\' button to add a new device.</p></div></td></tr>\n<tr md-row \nng-if=\"vm.devices.length && vm.deviceTable.filter.search && !(vm.devices|filter:vm.deviceTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">\nNothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"device in vm.devices | filter: vm.deviceTable.filter.search | orderBy: vm.deviceTable.query.order | limitTo: vm.deviceTable.query.limit : (vm.deviceTable.query.page - 1) * vm.deviceTable.query.limit\">\n<td md-cell><div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" \nng-click=\"vm.openEditDeviceDialog($event,device)\" aria-label=\"Edit Device\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_DEVICE\"><md-tooltip md-direction=\"right\"><span \ntranslate=\"ADMINISTRATION.EDIT_DEVICE\">Edit Device</span></md-tooltip><md-icon md-font-icon=\"icon-tablet-android\" \naria-hidden=\"true\"></md-icon></md-button></div></td><td md-cell>{{device.metadata.name}}</td><td md-cell>\n{{device.hardwareId}}</td><td md-cell>{{device.assignment.token}}</td><td md-cell><md-checkbox ng-disabled=\"true\" \naria-label=\"Notification for inactive sensor\" ng-checked=\"device.metadata.notification===\'true\'\"></md-checkbox></td><td\n md-cell><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.openEditDeviceDialog($event,device)\" \naria-label=\"Edit Device\" translate translate-attr-aria-label=\"ADMINISTRATION.EDIT_DEVICE\"><md-tooltip \nmd-direction=\"top\"><span translate=\"ADMINISTRATION.EDIT_DEVICE\">Edit Device</span></md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s24\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"delete-button md-icon-button\" ng-click=\"vm.openDeleteDeviceDialog($event,device)\" aria-label=\"Delete Device\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.DELETE_DEVICE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.DELETE_DEVICE\">Delete Device</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \nclass=\"s24\" aria-hidden=\"true\"></md-icon></md-button><md-button class=\"delete-button md-icon-button\" \nng-if=\"device.assignment!==undefined\" ng-click=\"vm.openReleaseAssignmentDialog($event,device)\" \naria-label=\"Release Assignment\" translate translate-attr-aria-label=\"ADMINISTRATION.RLS_DVC\"><md-tooltip \nmd-direction=\"top\"><span translate=\"ADMINISTRATION.RLS_DVC\">Release Assignment</span></md-tooltip><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"s24\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"delete-button md-icon-button\" ng-click=\"vm.openAssignDeviceDialog($event,device)\" \nng-if=\"device.assignment===undefined\" aria-label=\"Assign Device\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ASS_DVC\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.ASS_DVC\">Assign Device</span></md-tooltip><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"s24\" aria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div>\n</md-tab-body></md-tab><md-tab ui-sref=\"app.admin.device-groups\" md-on-select=\"vm.changeTab(8)\"><md-tab-label><span \ntranslate=\"ADMINISTRATION.TABS.DEVICE_GROUPS\">Device Groups</span></md-tab-label><md-tab-body><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start end\" layout-align-xs=\"center center\"><div layout=\"row\" flex><div \nclass=\"custom-icon-button-wrapper\"><md-button flow-btn class=\"add-button md-icon-button\" \nng-click=\"vm.openNewDeviceGroupDialog($event)\" aria-label=\"Add Device Group\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ADD_DEVICE_GROUP\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_DVC_GROUP\">Add Device Group</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-hidden=\"true\"></md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div class=\"md-title\" \ntranslate=\"ADMINISTRATION.DVC_GROUP_ADMINISTRATION\">Device Group Administration</div><span \ntranslate=\"ADMINISTRATION.MESSAGE.DVC_GROUP_CAN_DO\">\nCreate, edit and delete device Groups. Device Groups are used to organize devices into groups. Click on \'Manage Device Group\' to add devices to a device group.\n</span></div></div><div class=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.deviceGroupsTable.filter.search\" placeholder=\"Search Device Groups\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_DEVICE_GROUPS\"></div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"space-between center\"><div class=\"md-title\" flex>Site: \'{{ vm.selectedSite }}\' <small>\n[{{ vm.selectedTenant.name }}]</small></div><div flex><data-md-table-pagination \nmd-limit=\"vm.deviceGroupsTable.query.limit\" md-limit-options=\"vm.deviceGroupsTable.limitOptions\" \nmd-page=\"vm.deviceGroupsTable.query.page\" \nmd-total=\"{{(vm.deviceGroups|filter:vm.deviceGroupsTable.filter.search).length}}\" \nmd-boundary-links=\"vm.deviceGroupsTable.options.boundaryLinks\"></data-md-table-pagination></div></div><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"card portfolios\"><thead ng-if=\"!vm.deviceGroupsTable.options.decapitate\" md-head \ndata-md-order=\"vm.deviceGroupsTable.query.order\"><tr md-row><th md-column>&nbsp;</th><th md-column md:order:by=\"name\">\n<span translate=\"ADMINISTRATION.NAME\">Name</span></th><th md-column md:order:by=\"token\"><span \ntranslate=\"ADMINISTRATION.TOKEN\">Token</span></th><th md-column><span translate=\"ADMINISTRATION.FORMS.DESCRIPTION\">\nDescription</span></th><th md-column><span translate=\"ADMINISTRATION.ACTIONS\">Actions</span></th></tr></thead><tbody \nmd-body><tr md-row ng-if=\"!vm.deviceGroups.length\"><td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 \ntranslate=\"ADMINISTRATION.MESSAGE.NO_DATA\">No data available in table...</h3><span \ntranslate=\"ADMINISTRATION.MESSAGE.ADD_DVC_GROUP\">Click on \'Add Device Group\' to add a new device Group</span> <span \nng-if=\"vm.tenants.length > 1\" translate=\"ADMINISTRATION.MESSAGE.SELECT_ANOTHER_CLIENT\">, or select another client\n</span></div></td></tr><tr md-row \nng-if=\"vm.deviceGroups.length && vm.deviceGroupsTable.filter.search && !(vm.deviceGroups|filter:vm.deviceGroupsTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">\nNothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"deviceGroup in vm.deviceGroups | filter: vm.deviceGroupsTable.filter.search | orderBy: vm.deviceGroupsTable.query.order | limitTo: vm.deviceGroupsTable.query.limit : (vm.deviceGroupsTable.query.page - 1) * vm.deviceGroupsTable.query.limit\">\n<td><div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" \nng-click=\"vm.openEditDeviceGroupDialog($event,deviceGroup)\" aria-label=\"Edit Device Group\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_DVC_GROUP\"><md-tooltip md-direction=\"right\"><span \ntranslate=\"ADMINISTRATION.EDIT_DVC_GROUP\">Edit Device Group</span></md-tooltip><md-icon md-font-icon=\"icon-folder\" \naria-hidden=\"true\"></md-icon></md-button></div></td><td md-cell>{{deviceGroup.name}}</td><td md-cell>\n{{deviceGroup.token}}</td><td md-cell>{{deviceGroup.description}}</td><td md-cell><md-button \nclass=\"manage-button md-icon-button\" ng-click=\"vm.fillDeviceGroupDevicesTable(deviceGroup)\" \naria-label=\"Manage Device Group\" translate translate-attr-aria-label=\"ADMINISTRATION.MANAGE_DVC_GROUP\"><md-tooltip \nmd-direction=\"top\"><span translate=\"ADMINISTRATION.MANAGE_DVC_GROUP\">Manage Device Group</span></md-tooltip><md-icon \nmd-font-icon=\"icon-playlist-plus\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.openEditDeviceGroupDialog($event,deviceGroup)\" \naria-label=\"Edit Device Group\" translate translate-attr-aria-label=\"ADMINISTRATION.EDIT_DVC_GROUP\"><md-tooltip \nmd-direction=\"top\"><span translate=\"ADMINISTRATION.EDIT_DVC_GROUP\">Edit Device Group</span></md-tooltip><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s24\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"delete-button md-icon-button\" ng-click=\"vm.openDeleteDeviceGroupDialog($event,deviceGroup)\" \naria-label=\"Delete Device Group\" translate translate-attr-aria-label=\"ADMINISTRATION.DELETE_DVC_GROUP\"><md-tooltip \nmd-direction=\"top\"><span translate=\"ADMINISTRATION.DELETE_DVC_GROUP\">Delete Device Group</span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"s24\" aria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table>\n</md-table-container></div></md-tab-body></md-tab><md-tab ui-sref=\"app.admin.notifications\" \nmd-on-select=\"vm.changeTab(9)\"><md-tab-label><span translate=\"ADMINISTRATION.TABS.NOTIFICATIONS\">Notifications</span>\n</md-tab-label><md-tab-body><div layout=\"row\" layout-xs=\"column\" layout-align=\"start end\" \nlayout-align-xs=\"center center\"><div layout=\"row\" flex><div class=\"custom-icon-button-wrapper\"><md-button flow-btn \nclass=\"add-button md-icon-button\" ng-click=\"vm.openNewNotificationDialog($event,null)\" aria-label=\"Add User\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ADD_NOTIFICATION\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_NOTIFICATION\">Add Notification</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-hidden=\"true\"></md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div class=\"md-title\" \ntranslate=\"ADMINISTRATION.NOTIFICATION_ADMINISTRATION\">Notification Administration</div><span \ntranslate=\"ADMINISTRATION.MESSAGE.NOTIFICATIONS_MESSAGE\">Create, edit and delete notifications.</span></div></div><div \nclass=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.notificationTable.filter.search\" placeholder=\"Search Devices\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_NOTIFICATIONS\"></div></div></div><data-md-table-pagination \nmd-limit=\"vm.notificationTable.query.limit\" md-limit-options=\"vm.notificationTable.limitOptions\" \nmd-page=\"vm.notificationTable.query.page\" \nmd-total=\"{{(vm.notifications|filter:vm.notificationTable.filter.search).length}}\" \nmd-boundary-links=\"vm.notificationTable.options.boundaryLinks\"></data-md-table-pagination><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"users card\"><thead ng-if=\"!vm.notificationTable.options.decapitate\" md-head \ndata-md-order=\"vm.notificationTable.query.order\"><tr md-row><th md-column></th><th md-column md:order:by=\"title\"><span \ntranslate=\"ADMINISTRATION.NOTIFICATION_TITLE\">Notification Title</span></th><th md-column md:order:by=\"type\"><span \ntranslate=\"ADMINISTRATION.NOTIFICATION_TYPE\">Notification Type</span></th><th md-column md:order:by=\"active\"><span \ntranslate=\"ADMINISTRATION.NOTIFICATION_ACTIVE\">Is Active</span></th><th md-column><span \ntranslate=\"ADMINISTRATION.NOTIFICATION_PLATFORMS\">Notify via Portal/Mail/Sms</span></th><th md-column><span \ntranslate=\"ADMINISTRATION.ACTIONS\">Actions</span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"!vm.notifications.length\"><td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 \ntranslate=\"ADMINISTRATION.MESSAGE.NO_DATA\">No data available in table...</h3><p \ntranslate=\"ADMINISTRATION.MESSAGE.ADD_NOTIFICATION\">Click on the \'Add Notification\' button to add a new notification.\n</p></div></td></tr><tr md-row \nng-if=\"vm.notifications.length && vm.notificationTable.filter.search && !(vm.notifications|filter:vm.notificationTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">\nNothing found...</h3></div></td></tr><tr md-row \ndata-ng-repeat=\"notification in vm.notifications | filter: vm.notificationTable.filter.search | orderBy: vm.notificationTable.query.order | limitTo: vm.notificationTable.query.limit : (vm.notificationTable.query.page - 1) * vm.notificationTable.query.limit\">\n<td md-cell><div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" \nng-click=\"vm.openEditNotificationDialog($event,notification)\" aria-label=\"Edit Notification\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_NOTIFICATION\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.EDIT_NOTIFICATION\">Edit Notification</span></md-tooltip><md-icon md-font-icon=\"icon-bell\" \nclass=\"s24\" aria-hidden=\"true\"></md-icon></md-button></div></td><td md-cell>{{notification.title}}</td><td md-cell>\n{{notification.type}}</td><td md-cell><md-checkbox ng-disabled=\"true\" aria-label=\"Notification for inactive sensor\" \nng-checked=\"notification.active\"></md-checkbox></td><td md-cell><md-checkbox ng-disabled=\"true\" \naria-label=\"Notification for inactive sensor\" ng-checked=\"notification.portal\"></md-checkbox><md-checkbox \nng-disabled=\"true\" aria-label=\"Notification for inactive sensor\" ng-checked=\"notification.mail\"></md-checkbox>\n<md-checkbox ng-disabled=\"true\" aria-label=\"Notification for inactive sensor\" ng-checked=\"notification.sms\">\n</md-checkbox></td><td md-cell><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.openEditNotificationDialog($event,notification)\" aria-label=\"Edit Notification\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_NOTIFICATION\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.EDIT_NOTIFICATION\">Edit Notification</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s24\" aria-hidden=\"true\"></md-icon></md-button><md-button class=\"delete-button md-icon-button\" \nng-click=\"vm.openDeleteNotificationDialog($event,notification)\" aria-label=\"Delete Notification\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.DELETE_NOTIFICATION\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.DELETE_NOTIFICATION\">Delete Notification</span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"s24\" aria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table>\n</md-table-container></div></md-tab-body></md-tab></md-tabs><div class=\"manage\" ng-show=\"vm.assetShow==1\"><div \nclass=\"manage-top md-background-bg md-hue-1\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\"><span \ntranslate=\"ADMINISTRATION.MANAGE_ASSET_CATEGORY\">Manage Asset Category</span></div><md-button \nclass=\"close-page md-icon-button md-mini\" ng-click=\"vm.assetShow=0\" aria-label=\"Close Asset Category\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.CLOSE_ASSET_CATEGORY\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"ADMINISTRATION.CLOSE_ASSET_CATEGORY\">Close Asset Category</span></md-tooltip><md-icon \nmd-font-icon=\"icon-window-close\" aria-hidden=\"true\"></md-icon></md-button></div><div class=\"manage-bottom\"><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start end\" layout-align-xs=\"center center\"><div layout=\"row\" flex><div \nclass=\"custom-icon-button-wrapper\"><md-button flow-btn class=\"add-button md-fab md-primary\" \nng-click=\"vm.openNewAssetCategoryDialog($event)\" aria-label=\"Add Device to Group\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ADD_ASSETS\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_ASSETS\">New Asset</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-hidden=\"true\"></md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div class=\"md-title\">\n{{vm.currentAsset.name}} <small>[{{vm.currentAsset.assetType}}]</small></div><span \ntranslate=\"ADMINISTRATION.MESSAGE.ADD_REMOVE_ASSETS\">\nAdd or remove asset to your category. Click on \'Close Asset Category\' to close the Asset Category and go back to \'Asset Category Adminstration\'\n</span></div></div><div class=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.assetCategoriesTable.filter.search\" placeholder=\"Search Assets\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_ASSETS\"></div></div></div><data-md-table-pagination \nmd-limit=\"vm.assetCategoriesTable.query.limit\" md-limit-options=\"vm.assetCategoriesTable.limitOptions\" \nmd-page=\"vm.assetCategoriesTable.query.page\" \nmd-total=\"{{(vm.assetCategories|filter:vm.assetCategoriesTable.filter.search).length}}\" \nmd-boundary-links=\"vm.assetCategoriesTable.options.boundaryLinks\"></data-md-table-pagination><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"manage-portfolio card\"><thead ng-if=\"!vm.assetCategoriesTable.options.decapitate\" md-head \ndata-md-order=\"vm.assetCategoriesTable.query.order\"><tr md-row><th md-column>&nbsp;</th><th md-column \nmd:order:by=\"name\"><span translate=\"ADMINISTRATION.NAME\">Name</span></th><th md-column md:order:by=\"id\"><span \ntranslate=\"ADMINISTRATION.DEVICE_ID\">Device ID</span></th><th md-column><span translate=\"ADMINISTRATION.ACTIONS\">\nActions</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.assetCategories.length\"><td md-cell></td><td \nmd-cell colspan=\"4\" style=\"padding: 15px 0\"><h3 translate=\"ADMINISTRATION.MESSAGE.NO_DATA\">\nNo data available in table...</h3><span translate=\"ADMINISTRATION.MESSAGE.ADD_ASSET\">\nClick on \'Add Asset\' to add a asset to the category.</span></td></tr><tr md-row \nng-if=\"vm.assetCategories.length && vm.assetCategoriesTable.filter.search && !(vm.assetCategories|filter:vm.assetCategoriesTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"4\" style=\"padding: 25px 0\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">\nNothing found...</h3></td></tr><tr md-row \ndata-ng-repeat=\"asset in vm.assetCategories | filter: vm.assetCategoriesTable.filter.search | orderBy: vm.assetCategoriesTable.query.order | limitTo: vm.assetCategoriesTable.query.limit : (vm.assetCategoriesTable.query.page - 1) * vm.assetCategoriesTable.query.limit\">\n<td md-cell><md-button class=\"edit-button md-fab md-primary\" aria-label=\"Edit Asset\" \nng-click=\"vm.openEditAssetCategoryDialog($event,asset)\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_ASSET\"><md-icon md-font-icon=\"icon-tablet-android\" \nng-show=\"vm.currentAsset.assetType==\'Device\'\" aria-hidden=\"true\"></md-icon><md-icon \nmd-font-icon=\"icon-laptop-chromebook\" ng-show=\"vm.currentAsset.assetType==\'Hardware\'\" aria-hidden=\"true\"></md-icon>\n<md-icon md-font-icon=\"icon-map-marker\" ng-show=\"vm.currentAsset.assetType==\'Location\'\" aria-hidden=\"true\"></md-icon>\n<md-icon md-font-icon=\"icon-account\" ng-show=\"vm.currentAsset.assetType==\'Person\'\" aria-hidden=\"true\"></md-icon>\n</md-button></td><td md-cell>{{asset.name}}</td><td md-cell>{{asset.id}}</td><td md-cell><md-button \nclass=\"remove-button md-icon-button\" ng-click=\"vm.openEditAssetCategoryDialog($event,asset)\" aria-label=\"Edit Asset\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.EDIT_ASSET\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.EDIT_ASSET\">Edit Asset</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"remove-button md-icon-button\" \nng-click=\"vm.openDeleteAssetCategoryDialog($event,asset)\" aria-label=\"Delete Asset\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.DELETE_AC\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.DELETE_AC\">Delete Asset</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \naria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div></div></div><div \nclass=\"manage animate-slide-down-hide\" ng-show=\"vm.assetShow==2\"><div class=\"manage-top md-background-bg md-hue-1\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"title\"><span translate=\"ADMINISTRATION.MANAGE_DVC_GROUP\">\nManage Device Group</span></div><md-button class=\"close-page md-icon-button md-mini\" ng-click=\"vm.assetShow=0\" \naria-label=\"Close Device Group\" translate translate-attr-aria-label=\"ADMINISTRATION.CLOSE_DVC_GROUP\"><md-tooltip \nmd-direction=\"left\"><span translate=\"ADMINISTRATION.CLOSE_DEVICE_GROUP\">Close Device Group</span></md-tooltip><md-icon \nmd-font-icon=\"icon-window-close\" aria-hidden=\"true\"></md-icon></md-button></div><div class=\"manage-bottom\"><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start end\" layout-align-xs=\"center center\"><div layout=\"row\" flex><div \nclass=\"custom-icon-button-wrapper\"><md-button flow-btn class=\"add-button md-fab md-primary\" \nng-click=\"vm.openNewDeviceGroupDevicesDialog($event)\" aria-label=\"Add Device to Group\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ADD_DEVICE_TO_GROUP\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_DVC_TO_GROUP\">Add Device to Group</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-hidden=\"true\"></md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div class=\"md-title\"><span \ntranslate=\"ADMINISTRATION.ADD_DVC_TO_GROUP\">Add Device to Group</span><small> [{{vm.currentDeviceGroup.name}}]</small>\n</div><span translate=\"ADMINISTRATION.MESSAGE.ADD_REMOVE_DEVICES\">\nAdd or remove devices to your group. Click on \'Close Device Group\' to close the device group and go back to \'Device Group Adminstration\'\n</span></div></div><div class=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.deviceGroupDevicesTable.filter.search\" placeholder=\"Search Devices\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_DEVICES\"></div></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><div class=\"md-title\" flex>Site: \'{{ vm.selectedSite }}\' <small>\n[{{ vm.selectedTenant.name }}]</small></div><div flex><data-md-table-pagination \nmd-limit=\"vm.deviceGroupDevicesTable.query.limit\" md-limit-options=\"vm.deviceGroupDevicesTable.limitOptions\" \nmd-page=\"vm.deviceGroupDevicesTable.query.page\" \nmd-total=\"{{(vm.deviceGroupDevices|filter:vm.deviceGroupDevicesTable.filter.search).length}}\" \nmd-boundary-links=\"vm.deviceGroupDevicesTable.options.boundaryLinks\"></data-md-table-pagination></div></div><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"manage-portfolio card\"><thead ng-if=\"!vm.deviceGroupDevicesTable.options.decapitate\" md-head \ndata-md-order=\"vm.deviceGroupDevicesTable.query.order\"><tr md-row><th md-column>&nbsp;</th><th md-column \nmd:order:by=\"name\"><span translate=\"ADMINISTRATION.NAME\">Name</span></th><th md-column md:order:by=\"token\"><span \ntranslate=\"ADMINISTRATION.TOKEN\">Token</span></th><th md-column md:order:by=\"type\"><span \ntranslate=\"ADMINISTRATION.TYPE\">Type</span></th><th md-column><span translate=\"ADMINISTRATION.ACTIONS\">Actions</span>\n</th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.deviceGroupDevices.length\"><td md-cell></td><td md-cell \ncolspan=\"4\" style=\"padding: 15px 0\"><h3 translate=\"ADMINISTRATION.MESSAGE.NO_DATA\">No data available in table...</h3>\n<span translate=\"ADMINISTRATION.MESSAGE.ADD_DEVICE_TO_GROUP\">Click on \'Add Device\' to add a device to the group.</span>\n</td></tr><tr md-row \nng-if=\"vm.deviceGroupDevices.length && vm.deviceGroupDevicesTable.filter.search && !(vm.deviceGroupDevices|filter:vm.deviceGroupDevicesTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"4\" style=\"padding: 25px 0\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">\nNothing found...</h3></td></tr><tr md-row \ndata-ng-repeat=\"device in vm.deviceGroupDevices | filter: vm.deviceGroupDevicesTable.filter.search | orderBy: vm.deviceGroupDevicesTable.query.order | limitTo: vm.deviceGroupDevicesTable.query.limit : (vm.deviceGroupDevicesTable.query.page - 1) * vm.deviceGroupDevicesTable.query.limit\">\n<td md-cell><md-icon md-font-icon=\"icon-source-fork\" ng-if=\"device.type==\'group\'\" aria-hidden=\"true\"></md-icon><md-icon\n md-font-icon=\"icon-tablet-android\" ng-if=\"device.type==\'device\'\" aria-hidden=\"true\"></md-icon></td><td md-cell>\n{{device.name}}</td><td md-cell>{{device.token}}</td><td md-cell>{{device.type}}</td><td md-cell><md-button \nclass=\"remove-button md-icon-button\" ng-click=\"vm.openDeleteDeviceGroupDevicesDialog($event,device)\" \naria-label=\"Remove Device\" translate translate-attr-aria-label=\"ADMINISTRATION.REMOVE_DEVICE\"><md-tooltip \nmd-direction=\"top\"><span translate=\"ADMINISTRATION.REMOVE_DEVICE\">Remove Device</span></md-tooltip><md-icon \nmd-font-icon=\"icon-close-circle\" aria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table>\n</md-table-container></div></div></div><div class=\"manage animate-slide-down-hide\" ng-show=\"vm.assetShow==3\"><div \nclass=\"manage-top md-background-bg md-hue-1\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\"><span \ntranslate=\"ADMINISTRATION.MANAGE_PORTFOLIO\">Manage Portfolio</span></div><md-button \nclass=\"close-page md-icon-button md-mini\" ng-click=\"vm.assetShow=0\" aria-label=\"Close Portfolio\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.CLOSE_PORTFOLIO\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"ADMINISTRATION.CLOSE_PORTFOLIO\">Close Portfolio</span></md-tooltip><md-icon \nmd-font-icon=\"icon-window-close\" aria-hidden=\"true\"></md-icon></md-button></div><div class=\"manage-bottom\"><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start end\" layout-align-xs=\"center center\"><div layout=\"row\" flex><div \nclass=\"custom-icon-button-wrapper\"><md-button flow-btn class=\"add-button md-fab md-primary\" \nng-click=\"vm.openNewSiteGroupSitesDialog($event)\" aria-label=\"Add Site to Portfolio\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ADD_SITE_TO_PORTFOLIO\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_SITE_TO_PORTFOLIO\">Add Site to Portfolio</span></md-tooltip><md-icon \nmd-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div \nclass=\"md-title\"><span translate=\"ADMINISTRATION.PORTFOLIO\">Portfolio</span>: {{vm.currentDeviceGroup.name}} <small>\n[{{ vm.selectedTenant.name }}]</small></div><span translate=\"ADMINISTRATION.MESSAGE.ADD_REMOVE_SITES_PF\">\nAdd or remove sites to your portfolio. Click on \'Close Portfolio\' to close the portfolio and go back to \'Portfolio Adminstration\'\n</span></div></div><div class=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.siteGroupSitesTable.filter.search\" placeholder=\"Search Sites\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_SITES\"></div></div></div><data-md-table-pagination \nmd-limit=\"vm.siteGroupSitesTable.query.limit\" md-limit-options=\"vm.siteGroupSitesTable.limitOptions\" \nmd-page=\"vm.siteGroupSitesTable.query.page\" \nmd-total=\"{{(vm.siteGroupSites|filter:vm.siteGroupSitesTable.filter.search).length}}\" \nmd-boundary-links=\"vm.siteGroupSitesTable.options.boundaryLinks\"></data-md-table-pagination><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"manage-portfolio card\"><thead ng-if=\"!vm.siteGroupSitesTable.options.decapitate\" md-head \ndata-md-order=\"vm.siteGroupSitesTable.query.order\"><tr md-row><th md-column>&nbsp;</th><th md-column \nmd:order:by=\"siteGroupSite.deviceGroup.name\"><span translate=\"ADMINISTRATION.NAME\">Name</span></th><th md-column \nmd:order:by=\"siteGroupSite.deviceGroup.token\"><span translate=\"ADMINISTRATION.TOKEN\">Token</span></th><th><span \ntranslate=\"ADMINISTRATION.AUTH_USERS\">Authorized Users</span></th><th md-column><span \ntranslate=\"ADMINISTRATION.ACTIONS\">Actions</span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"!vm.siteGroupSites.length\"><td md-cell></td><td md-cell colspan=\"4\" style=\"padding: 15px 0\"><h3 \ntranslate=\"ADMINISTRATION.MESSAGE.NO_DATA\">No data available in table...</h3><span \ntranslate=\"ADMINISTRATION.MESSAGE.ADD_SITE\">Click on \'Add Site\' to add a site to the portfolio.</span></td></tr><tr \nmd-row \nng-if=\"vm.siteGroupSites.length && vm.siteGroupSitesTable.filter.search && !(vm.siteGroupSites|filter:vm.siteGroupSitesTable.filter.search).length\">\n<td md-cell></td><td md-cell colspan=\"4\" style=\"padding: 25px 0\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">\nNothing found...</h3></td></tr><tr md-row \ndata-ng-repeat=\"site in vm.siteGroupSites | filter: vm.siteGroupSitesTable.filter.search | orderBy: vm.siteGroupSitesTable.query.order | limitTo: vm.siteGroupSitesTable.query.limit : (vm.siteGroupSitesTable.query.page - 1) * vm.siteGroupSitesTable.query.limit\">\n<td md-cell><md-icon md-font-icon=\"icon-home\" aria-hidden=\"true\"></md-icon></td><td md-cell>{{site.name}}</td><td \nmd-cell>{{site.token}}</td><td md-cell>{{site.users}}</td><td md-cell><md-button class=\"remove-button md-icon-button\" \nng-click=\"vm.openDeleteSiteGroupSitesDialog($event,site)\" aria-label=\"Remove Site\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.REMOVE_SITE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.REMOVE_SITE\">Remove Site</span></md-tooltip><md-icon md-font-icon=\"icon-close-circle\" \naria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div></div></div><div \nclass=\"manage animate-slide-down-hide\" ng-show=\"vm.assetShow==4\"><div class=\"manage-top md-background-bg md-hue-1\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"title\"><span \ntranslate=\"ADMINISTRATION.MANAGE_COST_PROFILE\">Manage Cost Profile</span></div><md-button \nclass=\"close-page md-icon-button md-mini\" ng-click=\"vm.assetShow=0\" aria-label=\"Close Cost Profile\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.CLOSE_COST_PROFILE\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"ADMINISTRATION.CLOSE_COST_PROFILE\">Close Cost Profile</span></md-tooltip><md-icon \nmd-font-icon=\"icon-window-close\" aria-hidden=\"true\"></md-icon></md-button></div><div class=\"manage-bottom\"><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start end\" layout-align-xs=\"center center\"><div layout=\"row\" flex><div \nclass=\"custom-icon-button-wrapper\"><md-button flow-btn class=\"add-button md-fab md-primary\" \nng-click=\"vm.openNewCostDialog($event)\" aria-label=\"Add Cost to Cost Profile\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.ADD_COST_TO_COST_PRFL\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"ADMINISTRATION.ADD_COST_TO_COST_PRFL\">Add Cost to Cost Profile</span></md-tooltip><md-icon \nmd-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></md-button></div><div class=\"pr-16 pl-16\" flex><div \nclass=\"md-title\">{{vm.currentCostProfile.name}} <small>[{{ vm.selectedTenant.name }}]</small></div><span \ntranslate=\"ADMINISTRATION.MESSAGE.ADD_REMOVE_COSTS_PF\">\nAdd or remove costs to your cost profile. Click on \'Close Cost Profile\' to close the cost profile and go back to \'Cost Profile Adminstration\'\n</span></div></div><div class=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.costsTable.filter.search\" placeholder=\"Search Costs\" translate \ntranslate-attr-placeholder=\"ADMINISTRATION.SEARCH_COSTS\"></div></div></div><data-md-table-pagination \nmd-limit=\"vm.costsTable.query.limit\" md-limit-options=\"vm.costsTable.limitOptions\" md-page=\"vm.costsTable.query.page\" \nmd-total=\"{{(vm.costs|filter:vm.costsTable.filter.search).length}}\" \nmd-boundary-links=\"vm.costsTable.options.boundaryLinks\"></data-md-table-pagination><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"manage-cost-profile card\"><thead ng-if=\"!vm.costsTable.options.decapitate\" md-head \ndata-md-order=\"vm.costsTable.query.order\"><tr md-row><th md-column>&nbsp;</th><th md-column md:order:by=\"name\"><span \ntranslate=\"ADMINISTRATION.NAME\">Name</span></th><th md-column md:order:by=\"token\"><span \ntranslate=\"ADMINISTRATION.TOKEN\">Token</span></th><th md-column md:order:by=\"type\"><span \ntranslate=\"ADMINISTRATION.TYPE\">Type</span></th><th md-column><span translate=\"ADMINISTRATION.ACTIONS\">Actions</span>\n</th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.costs.length\"><td md-cell></td><td md-cell colspan=\"5\" \nstyle=\"padding: 15px 0\"><h3 translate=\"ADMINISTRATION.MESSAGE.NO_DATA\">No data available in table...</h3><span \ntranslate=\"ADMINISTRATION.MESSAGE.ADD_COST_TO_PFL\">Click on \'Add Cost\' to add a new cost to the cost profile.</span>\n</td></tr><tr md-row \nng-if=\"vm.costs.length && vm.costsTable.filter.search && !(vm.costs|filter:vm.costsTable.filter.search).length\"><td \nmd-cell></td><td md-cell colspan=\"5\" style=\"padding: 25px 0\"><h3 translate=\"ADMINISTRATION.MESSAGE.NOTHING\">\nNothing found...</h3></td></tr><tr md-row \ndata-ng-repeat=\"cost in vm.costs | filter: vm.costsTable.filter.search | orderBy: vm.costsTable.query.order | limitTo: vm.costsTable.query.limit : (vm.costsTable.query.page - 1) * vm.costsTable.query.limit\">\n<td md-cell><md-button class=\"md-fab md-primary\" ng-click=\"vm.openEditCostDialog($event, cost)\" aria-label=\"Edit Cost\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.EDIT_COST\"><md-tooltip md-direction=\"right\"><span \ntranslate=\"ADMINISTRATION.EDIT_COST\">Edit Cost</span></md-tooltip><md-icon md-font-icon=\"icon-currency-eur\" \naria-hidden=\"true\"></md-icon></md-button></td><td md-cell>{{cost.name}}</td><td md-cell>{{cost.token}}</td><td md-cell \nng-if=\"cost.type===\'unit\'\"><span translate=\"ADMINISTRATION.PER_UNIT\">Per Unit</span></td><td md-cell \nng-if=\"cost.type===\'return\'\"><span translate=\"ADMINISTRATION.REWARD_BENEFIT\">Reward benefit</span></td><td md-cell \nng-if=\"cost.type===\'fixed\'\"><span translate=\"ADMINISTRATION.FIXED_COST\">Fixed cost</span></td><td md-cell \nng-if=\"cost.type===\'formula\'\"><span translate=\"ADMINISTRATION.FORMULA\">Formula</span></td><td md-cell><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.openEditCostDialog($event, cost)\" aria-label=\"Edit Cost\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_COST\"><md-icon md-font-icon=\"icon-pencil\" class=\"s24\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"delete-button md-icon-button\" \nng-click=\"vm.openDeleteCostDialog($event, cost)\" aria-label=\"Delete Cost\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.DELETE_COST\"><md-icon md-font-icon=\"icon-delete\" class=\"s24\" \naria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div></div></div></div></div>\n</div></div>");
$templateCache.put("app/main/breakdown/breakdown.html","<div id=\"breakdown\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"content-wrapper\" \nclass=\"md-primary-bg md-hue-3\" style=\"top: 0\"><div class=\"content sidenav\" layout=\"row\"><div hide show-md show-sm \nshow-xs><button class=\"toggle-left-sidenav md-background-bg md-hue-1\" type=\"button\" \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"Toggle\"><md-icon class=\"s20\" \nmd-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button></div><div hide show-gt-md><button \nclass=\"toggle-left-sidenav md-accent\" type=\"button\" ng-click=\"vm.lockLeft=!vm.lockLeft\" aria-label=\"Toggle\"><md-icon \nclass=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button></div><md-sidenav \nclass=\"sidenav sidenav-width-300 md-sidenav-left\" md-is-locked-open=\"vm.lockLeft && $mdMedia(\'gt-md\')\" \nmd-component-id=\"left-sidenav\" md-disable-backdrop ms-scroll ms-sidenav-helper><md-toolbar \nclass=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding><div class=\"toolbar\"><div hide \nshow-gt-md><md-icon ng-click=\"vm.changeStatusL(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" \naria-hidden=\"true\" style=\"color: #fff\"></md-icon></div><div hide show-md show-sm show-xs><md-icon \nng-click=\"vm.toggleClose(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\" \nstyle=\"color: #fff\"></md-icon></div></div><div class=\"heading\" style=\"font-weight: 300; padding-top: 10px\">\n{{ \'BREAKDOWN.MONITORED_POINTS\' | translate }}</div></md-toolbar><md-content class=\"content md-background-bg md-hue-1\" \nms-scroll layout-padding><div class=\"md-background-border md-hue-2\" layout=\"row\" style=\"padding: 0\"><div flex><button \nclass=\"jstree-open md-button md-accent md-raised\" type=\"button\" ng-click=\"vm.openTree()\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px; margin-right: 0\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></button> <button \nclass=\"jstree-close md-button md-accent md-raised\" type=\"button\" ng-click=\"vm.closeTree()\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-minus\" aria-hidden=\"true\"></md-icon></button></div><div><button \nclass=\"jstree-search md-button md-accent md-raised\" type=\"button\" ng-click=\"vm.openSearchDialog()\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-magnify\" aria-hidden=\"true\"></md-icon></button> <button \nclass=\"jstree-reset md-button md-accent md-raised\" type=\"button\" ng-click=\"vm.resetTree()\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-refresh\" aria-hidden=\"true\"></md-icon></button></div></div><div class=\"search-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input \nclass=\"md-background-bg md-hue-1\" flex ng-model=\"vm.searchtree\" type=\"text\" ng-change=\"vm.applySearch()\" \nplaceholder=\"{{ \'BREAKDOWN.SEARCH_TREE\' | translate }}\"></div></div><div layout=\"column\" \nstyle=\"padding: 0; padding-top: 16px\"><div class=\"tree\" js-tree=\"vm.treeConfig\" ng-model=\"vm.treeData\" \ntree=\"vm.treeInstance\" ng-if=\"vm.showTree\" tree-events-obj=\"vm.treeEvents\" style=\"padding: 4px\"></div></div>\n</md-content></md-sidenav><div class=\"page-content\" ms-scroll flex><div class=\"top-toolbar md-background-bg md-hue-1\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"daterange-wrapper md-background-border md-hue-1\"><div class=\"daterange\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-calendar\" class=\"icon\" aria-hidden=\"true\"></md-icon><input\n flex date-range-picker id=\"daterange\" name=\"daterange\" class=\"form-control date-picker md-background-bg md-hue-1\" \ntype=\"text\" ng-model=\"vm.date\" options=\"vm.dateOptions\"></div></div></div><div class=\"button-group\" layout=\"row\" \nlayout-align=\"start center\"><md-button \nclass=\"chartType-button active bar-button md-button-icon md-raised groupX middle\" ng-click=\"vm.setChartType(\'bar\')\" \naria-label=\"Bar Chart\" translate translate-attr-aria-label=\"BREAKDOWN.BAR_CHART\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"BREAKDOWN.BAR_CHART\">Bar Chart</span></md-tooltip><md-icon md-font-icon=\"icon-chart-bar\" aria-hidden=\"true\">\n</md-icon></md-button><md-button class=\"chartType-button line-button md-button-icon md-raised groupX middle\" \nng-click=\"vm.setChartType(\'line\')\" aria-label=\"Line Chart\" translate translate-attr-aria-label=\"BREAKDOWN.LINE_CHART\">\n<md-tooltip md-direction=\"top\"><span translate=\"BREAKDOWN.LINE_CHART\">Line Chart</span></md-tooltip><md-icon \nmd-font-icon=\"icon-chart-line\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"chartType-button pie-button md-button-icon md-raised groupX middle\" ng-click=\"vm.setChartType(\'pie\')\" \naria-label=\"Pie Chart\" translate translate-attr-aria-label=\"BREAKDOWN.PIE_CHART\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"BREAKDOWN.PIE_CHART\">Pie Chart</span></md-tooltip><md-icon md-font-icon=\"icon-chart-pie\" aria-hidden=\"true\">\n</md-icon></md-button><md-button class=\"chartType-button heatmap-button md-button-icon md-raised groupX middle\" \nng-click=\"vm.setChartType(\'heatmap\')\" aria-label=\"Heatmap Chart\" translate \ntranslate-attr-aria-label=\"BREAKDOWN.HEATMAP_CHART\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"BREAKDOWN.HEATMAP_CHART\">Heatmap Chart</span></md-tooltip><md-icon md-font-icon=\"icon-blur\" \naria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"chartType-button functional-button md-button-icon md-raised groupX middle\" style=\"\" \nng-click=\"vm.setChartType(\'functional\')\" aria-label=\"Functional Chart\" translate \ntranslate-attr-aria-label=\"BREAKDOWN.FUNCTIONAL_CHART\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"BREAKDOWN.FUNCTIONAL_CHART\">Functional Chart</span></md-tooltip><md-icon md-font-icon=\"icon-calendar-clock\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"stacked-button md-button-icon md-raised groupX middle\" \nng-click=\"vm.buttonToggle(\'stacked\', true)\" aria-label=\"Compare\" translate \ntranslate-attr-aria-label=\"BREAKDOWN.COMPARE\"><md-tooltip md-direction=\"top\"><span translate=\"BREAKDOWN.COMPARE\">\nCompare</span></md-tooltip><md-icon md-font-icon=\"icon-compare\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"temperature-button md-button-icon md-raised groupX middle\" style=\"\" ng-click=\"vm.buttonToggle(\'temperature\')\" \naria-label=\"Average Temperature\" translate translate-attr-aria-label=\"BREAKDOWN.AVERAGE_TEMPERATURE\"><md-tooltip \nmd-direction=\"top\"><span translate=\"BREAKDOWN.AVERAGE_TEMPERATURE\">Average Temperature</span></md-tooltip><md-icon \nmd-font-icon=\"icon-thermometer-lines\" aria-hidden=\"true\"></md-icon></md-button><md-menu id=\"compensate-menu\" \nmd-offset=\"0 48\"><md-button class=\"compensate-button md-button-icon md-raised groupX middle\" \nstyle=\"height: 34px !important; margin-right: 20px\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Compensate\" translate \ntranslate-attr-aria-label=\"BREAKDOWN.COMPENSATE\"><md-tooltip md-direction=\"top\"><span translate=\"BREAKDOWN.COMPENSATE\">\nCompensate</span></md-tooltip><md-icon md-font-icon=\"icon-division\" aria-hidden=\"true\"></md-icon></md-button>\n<md-menu-content width=\"3\" class=\"md-background-bg md-hue-1\"><md-menu-item><md-button \nng-click=\"vm.selectCompensate(\'\')\" aria-label=\"Select none\" translate=\"BREAKDOWN.NONE\" \ntranslate-attr-aria-label=\"BREAKDOWN.NONE\">None</md-button></md-menu-item><md-menu-item \nng-repeat=\"compensate in vm.compensates\"><md-button ng-click=\"vm.selectCompensate(compensate.id)\" \nng-class=\"{\'md-primary\': vm.selectedCompensate.indexOf(compensate.id) >= 0}\" aria-label=\"{{compensate.name}}\"><span \ntranslate=\"{{compensate.translation}}\">{{compensate.name}}</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div><div layout=\"column\" flex><div><div layout=\"row\" flex><div class=\"h1\" \nstyle=\"font-weight: 300; padding: 16px 26px\" flex translate=\"BREAKDOWN.TITLE\">Breakdown</div><div \nstyle=\"padding: 8px 26px\"><div layout=\"row\" layout-align=\"start center\"><div class=\"input-block\" flex>\n<md-input-container style=\"margin: 0; margin-right: 6px\"><md-select ng-model=\"vm.savedGraph[vm.chartType]\" \naria-label=\"Select Graph\" ng-change=\"vm.loadGraph(vm.savedGraph[vm.chartType])\" style=\"min-width: 200px\"><md-option \nng-repeat=\"savedGraph in vm.savedGraphs[vm.chartType]\" ng-value=\"savedGraph.id\">{{savedGraph.name}}</md-option>\n</md-select></md-input-container><button ng-click=\"vm.saveGraph()\" class=\"md-button md-raised md-accent\" \ndisabled=\"disabled\" aria-label=\"Save Graph\" ng-disabled=\"!vm.chart.data.length && !vm.chart.heatmapData.length\" \nstyle=\"min-width: 36px; border-radius: 4px\"><md-tooltip md-direction=\"top\"><span translate=\"BREAKDOWN.SAVE_GRAPH\">\nSave Graph</span></md-tooltip><md-icon class=\"s16\" md-font-icon=\"icon-content-save\"></md-icon></button> <button \nng-click=\"vm.deleteGraph()\" class=\"md-button md-raised md-accent\" disabled=\"disabled\" aria-label=\"Delete Graph\" \nng-disabled=\"vm.isDefault(vm.savedGraph[vm.chartType])\" style=\"min-width: 36px; border-radius: 4px\"><md-tooltip \nmd-direction=\"top\"><span translate=\"BREAKDOWN.DELETE_GRAPH\">Delete Graph</span></md-tooltip><md-icon class=\"s16\" \nmd-font-icon=\"icon-close\"></md-icon></button></div></div></div></div></div><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" style=\"padding-top: 0; padding-bottom: 6px\"><ms-widget-front \nclass=\"md-background-bg md-hue-1\" style=\"border-radius: 4px\"><div class=\"h3 md-primary-bg md-hue-2\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start center\" style=\"padding: 8px 16px; min-height: 52px\"><div class=\"chart-title\" \nflex=\"100\" layout=\"row\" layout-align=\"start center\" style=\"height: 36px\"><div id=\"kpi-ctrl\" layout=\"row\"><button \nclass=\"kpi-cost md-button md-raised md-accent\" ng-click=\"vm.setKPI(\'cost\')\" aria-label=\"Cost\"><span \ntranslate=\"BREAKDOWN.COST\">Cost</span> <button><button class=\"kpi-measurements md-button md-raised\" \nng-click=\"vm.setKPI(\'measurements\')\" aria-label=\"Measurements\"><span translate=\"BREAKDOWN.MEASUREMENTS\">Measurements\n</span> <button></button></button></button></button></div><small ng-if=\"vm.measureTypes.length\"><md-input-container>\n<md-select ng-model=\"vm.selectedMeasureType\" aria-label=\"Select Measure Type\" ng-change=\"vm.selectMeasureType();\">\n<md-option ng-repeat=\"measureType in vm.measureTypes\" ng-value=\"measureType.id\" \ntranslate=\"{{measureType.translation}}\">{{measureType.name}}</md-option></md-select></md-input-container></small><small\n ng-if=\"vm.units.length\"><md-input-container><md-select ng-model=\"vm.selectedUnit\" aria-label=\"Select Unit\" \nng-change=\"vm.selectUnit();\"><md-option ng-repeat=\"unit in vm.units\" ng-value=\"unit\" ng-bind-html=\"unit | toTrusted\">\n{{unit}}</md-option></md-select></md-input-container></small></div><div class=\"toolbar\" layout=\"row\"><div \nid=\"zoom-ctrl\" layout=\"row\" layout-align=\"center center\"><md-button class=\"groupX zoom-m\" \nng-click=\"vm.setZoom(\'15 m\')\" aria-label=\"15Min\" translate=\"BREAKDOWN.15MIN\" \ntranslate-attr-aria-label=\"BREAKDOWN.15MIN\">15Min</md-button><md-button class=\"groupX middle zoom-h\" \nng-click=\"vm.setZoom(\'1 h\')\" aria-label=\"Hourly\" translate=\"BREAKDOWN.HOURLY\" \ntranslate-attr-aria-label=\"BREAKDOWN.HOURLY\">Hourly</md-button><md-button class=\"active groupX middle zoom-d\" \nng-click=\"vm.setZoom(\'1 d\')\" aria-label=\"Day\" translate=\"BREAKDOWN.DAY\" translate-attr-aria-label=\"BREAKDOWN.DAY\">Day\n</md-button><md-button class=\"groupX middle zoom-w\" ng-click=\"vm.setZoom(\'1 w\')\" aria-label=\"Week\" \ntranslate=\"BREAKDOWN.WEEK\" translate-attr-aria-label=\"BREAKDOWN.WEEK\">Week</md-button><md-button \nclass=\"groupX righ zoom-M\" ng-click=\"vm.setZoom(\'1 M\')\" aria-label=\"Month\" translate=\"BREAKDOWN.MONTH\" \ntranslate-attr-aria-label=\"BREAKDOWN.MONTH\">Month</md-button></div><md-menu><md-button \nclass=\"md-icon-button download-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Download\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg md-hue-1\">\n<md-menu-item><md-button ng-click=\"vm.saveImage(\'chart-aggregated-canvas\')\" aria-label=\"Download PNG\" \ntranslate=\"BREAKDOWN.DOWNLOAD_PNG\" translate-attr-aria-label=\"BREAKDOWN.DOWNLOAD_PNG\">Download PNG</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.exportCSV()\" aria-label=\"Download CSV\" \ntranslate=\"BREAKDOWN.DOWNLOAD_CSV\" translate-attr-aria-label=\"BREAKDOWN.DOWNLOAD_CSV\">Download CSV</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><md-divider></md-divider><div layout=\"column\" class=\"\"><div \nflex style=\"background-color: rgba(0,0,0,0.1); padding: 12px 16px\" ng-if=\"vm.chartType==\'functional\'\"><v-accordion \nclass=\"vAccordion--default\"><v-pane expanded><v-pane-header><span translate=\"BREAKDOWN.TIME_SCHEDULE\">Time Schedule\n</span></v-pane-header><v-pane-content><div class=\"schedulePicker-overlay\" ng-if=\"vm.schedule.is_disabled\"><span>\n{{vm.schedule.is_disabled}}</span></div><table cellpadding=\"0\" cellspacing=\"0\" class=\"schedulePicker\" \nid=\"schedulePicker\"><thead><tr><th></th><th class=\"th-time\" ng-repeat=\"time in vm.schedule.times\">{{time}}</th></tr>\n</thead><tbody><tr ng-init=\"i = $index\" ng-repeat=\"day in vm.schedule.days\"><th class=\"th-day\">{{day}}</th><td \nng-init=\"j = $index\" ng-repeat=\"time in vm.schedule.times\" data-i=\"{{i}}\" data-j=\"{{j}}\">&nbsp;</td></tr></tbody>\n</table><div style=\"text-align: center; margin-top: 8px\"><md-button class=\"md-raised md-primary\" \nng-click=\"vm.applySchedule()\" ng-disabled=\"vm.schedule.is_disabled || !vm.scheduleChanged\" aria-label=\"Apply\" \ntranslate=\"BREAKDOWN.APPLY\" translate-attr-aria-label=\"BREAKDOWN.APPLY\">Apply</md-button></div></v-pane-content>\n</v-pane></v-accordion></div><div layout=\"column\" class=\"border-bottom p-16\" style=\"padding-bottom: 0; height: 78px\">\n<div flex ng-if=\"vm.chart.stats.total && vm.chart.stats.total != null && vm.chartType == \'functional\'\"><div \nlayout=\"row\"><div layout=\"column\" flex=\"40\"><div class=\"h4 secondary-text\"><span translate=\"BREAKDOWN.TOTAL\">TOTAL\n</span></div><div class=\"md-display-1 light-blue-fg\">{{vm.chart.stats.total}} <small>{{vm.chartUnits[0]}}</small></div>\n</div><div layout=\"column\" flex=\"20\"><div class=\"h4 secondary-text\"><span translate=\"BREAKDOWN.FUNCTIONAL\">FUNCTIONAL\n</span></div><div class=\"md-display-1\">{{vm.chart.stats.func}} <small>{{vm.chartUnits[0]}}</small></div></div><div \nlayout=\"column\" flex=\"20\"><div class=\"h4 secondary-text\"><span translate=\"BREAKDOWN.NON_FUNCTIONAL\">NON FUNCTIONAL\n</span></div><div class=\"md-display-1\">{{vm.chart.stats.nfunc}} <small>{{vm.chartUnits[0]}}</small></div></div><div \nlayout=\"column\" flex=\"20\"><div class=\"h4 secondary-text\"><span translate=\"BREAKDOWN.RATIO\">RATIO</span></div><div \nclass=\"md-display-1\">{{vm.chart.stats.ratio}} <small>%</small></div></div></div></div><div flex \nng-if=\"vm.chart.stats.total && vm.chart.stats.total != null && vm.chartType != \'functional\'\"><div layout=\"row\"><div \nlayout=\"column\" flex=\"40\"><div class=\"h4 secondary-text\"><span translate=\"BREAKDOWN.TOTAL\">TOTAL</span></div><div \nclass=\"md-display-1 light-blue-fg\">{{vm.chart.stats.total}} <small>{{vm.chartUnits[0]}}</small></div></div><div \nlayout=\"column\" flex=\"20\"><div class=\"h4 secondary-text\"><span translate=\"BREAKDOWN.AVG\">AVG</span></div><div \nclass=\"md-display-1\">{{vm.chart.stats.avg}} <small>{{vm.chartUnits[0]}}</small></div></div><div layout=\"column\" \nflex=\"20\"><div class=\"h4 secondary-text\"><span translate=\"BREAKDOWN.MIN\">MIN</span></div><div class=\"md-display-1\">\n{{vm.chart.stats.min}} <small>{{vm.chartUnits[0]}}</small></div></div><div layout=\"column\" flex=\"20\"><div \nclass=\"h4 secondary-text\"><span translate=\"BREAKDOWN.MAX\">MAX</span></div><div class=\"md-display-1\">\n{{vm.chart.stats.max}} <small>{{vm.chartUnits[0]}}</small></div></div></div></div><div \nng-if=\"!vm.chart.stats.total && vm.chart.stats.total != null\" class=\"status\" flex \nstyle=\"font-size: 13px; height: 62px; padding: 16px 0 0\"><span class=\"msg-spinner static\"></span> &nbsp; <span \ntranslate=\"EXPLORE.SELECT_DATA\">Please select a monitored point...</span></div><div flex=\"100\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.chart.stats.total == null\" class=\"heatmap-controls\" \nstyle=\"height: 62px; padding: 16px 0 0\"><div class=\"input-block\" style=\"margin-right: 20px\"><md-input-container><label>\n<span translate=\"BREAKDOWN.HEATMAP_SHAPE\">Shape:</span></label><md-select ng-model=\"vm.heatmapPointStyle\" \naria-label=\"Select Shape\" ng-change=\"vm.changeOptions()\" style=\"width: 100px\"><md-option \nng-repeat=\"style in vm.heatmapPointStyles\" ng-value=\"style.id\"><span translate=\"{{style.translation}}\">{{style.name}}\n</span></md-option></md-select></md-input-container></div><div class=\"input-block\" style=\"margin-right: 20px\">\n<md-input-container><label><span translate=\"BREAKDOWN.HEATMAP_COLOR\">Color:</span></label><md-select \nng-model=\"vm.heatmapColor\" aria-label=\"Select Color\" ng-change=\"vm.changeOptions()\" style=\"width: 100px\"><md-option \nng-repeat=\"color in vm.heatmapColors\" ng-value=\"color.id\"><span class=\"heatmap-color\" style=\"{{color.css}}\"></span> \n<span translate=\"{{color.translation}}\">{{color.name}}</span></md-option></md-select></md-input-container></div><div \nclass=\"input-block\" style=\"margin-right: 20px\"><md-input-container><label><span translate=\"BREAKDOWN.HEATMAP_RADIUS\">\nRadius:</span></label><input ng-model=\"vm.heatmapRadius\" type=\"number\" step=\"5\" ng-change=\"vm.changeOptions()\" \nstyle=\"width: 100px\"></md-input-container><md-input-container><md-tooltip md-direction=\"top\"><span \ntranslate=\"BREAKDOWN.HEATMAP_RADIUS_LOCKED\">Locked</span></md-tooltip><md-checkbox ng-model=\"vm.heatmapRadiusLocked\" \naria-label=\"Size Locked\" ng-change=\"vm.changeOptions()\" style=\"margin-top: 16px\"></md-checkbox></md-input-container>\n</div><div class=\"input-block\" style=\"margin-right: 20px\"><md-input-container><label><span \ntranslate=\"BREAKDOWN.HEATMAP_DISTRIBUTION\">Distribution:</span></label><md-select ng-model=\"vm.heatmapDistribution\" \naria-label=\"Select Distribution\" ng-change=\"vm.changeOptions()\" style=\"width: 100px\"><md-option \nng-repeat=\"distribution in vm.heatmapDistributions\" ng-value=\"distribution.id\"><span \ntranslate=\"{{distribution.translation}}\">{{distribution.name}}</span></md-option></md-select></md-input-container>\n</div><div class=\"input-block\"><md-input-container><label><span translate=\"BREAKDOWN.HEATMAP_LEVELS\">Levels:</span>\n</label><input ng-model=\"vm.heatmapLevels\" type=\"number\" ng-change=\"vm.changeOptions()\" style=\"width: 100px\">\n</md-input-container></div></div></div><div layout=\"column\" class=\"pb-16\"><div class=\"chart-container m-16\"><canvas \nid=\"chart-aggregated-canvas\"></canvas></div><div layout=\"column\" class=\"chart-aggregated-zoom m-16\" \nstyle=\"display: none; position: relative; height: 70px\"><div class=\"zoom-ctrl\"><div class=\"zoom-left\"></div><div \nclass=\"zoom-box\"><div></div></div><div class=\"zoom-right\"></div></div><canvas id=\"chart-zoom-canvas\" \nstyle=\"pointer-events: none\"></canvas></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"60\" \nstyle=\"padding-top: 6px; padding-bottom: 6px\"><ms-widget-front class=\"md-background-bg md-hue-1\" \nstyle=\"border-radius: 4px\"><div class=\"h3 p-16 md-primary-bg md-hue-2\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start space-between\"><div class=\"chart-title\" flex=\"100\" layout=\"row\" layout-align=\"start center\" \nstyle=\"height: 36px\"><span translate=\"BREAKDOWN.DETAILS\">Details</span> <span \nclass=\"ml-16 mr-0 text-boxed pink-bg white-fg\"><ng-pluralize count=\"vm.selectedSites.length\" \nwhen=\"{\'one\': \'1 site\', \'other\': \'{} sites\'}\"></ng-pluralize></span><span \nclass=\"ml-16 text-boxed deep-orange-bg white-fg\"><ng-pluralize count=\"vm.detailsData.length\" \nwhen=\"{\'one\': \'1 assignment\', \'other\': \'{} assignments\'}\"></ng-pluralize></span></div><data-md-table-pagination \nflex=\"100\" md-limit=\"vm.tableOptions.limit\" md-page=\"vm.tableOptions.page\" md-total=\"{{vm.detailsData.length}}\">\n</data-md-table-pagination></div><md-divider></md-divider><md-table-container><table data-md-table \nclass=\"details card\"><thead md-head data-md-order=\"vm.tableOptions.order\"><tr md-row><th md-column \nmd:order:by=\"site.name\"><span translate=\"BREAKDOWN.SITE\">Site</span></th><th md-column \nmd:order:by=\"device.metadata.name\"><span translate=\"BREAKDOWN.ASSIGNMENT\">Assignment</span></th><th md-column \nmd:order:by=\"value\" style=\"padding-left: 24px; text-align: right\" colspan=\"2\"><span translate=\"BREAKDOWN.MEASUREMENT\">\nMeasurement</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.detailsData.length\"><td md-cell colspan=\"3\" \nstyle=\"padding: 15px 24px\"><span translate=\"BREAKDOWN.SELECT_DATA\">Please select data to display...</span></td></tr><tr\n md-row \ndata-ng-repeat=\"row in vm.detailsData | orderBy: vm.tableOptions.order | limitTo: vm.tableOptions.limit : (vm.tableOptions.page - 1) * vm.tableOptions.limit\">\n<td md-cell>{{row.site.name}}</td><td md-cell>{{row.device.metadata.name}}</td><td md-cell \nstyle=\"padding-right: 5px; text-align: right\">{{row.value}}</td><td md-cell style=\"padding-right: 56px; width: 50px\">\n{{row.unit}}</td></tr></tbody></table></md-table-container></ms-widget-front></ms-widget><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" flex-gt-md=\"40\" style=\"padding-top: 6px; padding-bottom: 6px\"><ms-widget-front \nclass=\"md-background-bg md-hue-1\" style=\"border-radius: 4px\"><div class=\"h3 p-16 md-primary-bg md-hue-2\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start space-between\"><div class=\"chart-title\" flex=\"100\" layout=\"row\" \nlayout-align=\"start center\" style=\"height: 36px\"><span translate=\"BREAKDOWN.OPTIONS\">Options</span></div></div>\n<md-divider></md-divider><table data-md-table class=\"details card secondary-text\" \nstyle=\"padding-left: 24px; padding-right: 24px\"><thead md-head></thead><tbody md-body><tr md-row><th md-cell \nclass=\"md-column\" style=\"border-top: none\"><span translate=\"BREAKDOWN.DATES\">Dates:</span></th><td md-cell \nstyle=\"border-top: none\">{{vm.optionsData.dates}}</td></tr><tr md-row><th md-cell class=\"md-column\"><span \ntranslate=\"BREAKDOWN.CHART_TYPE\">Chart type:</span></th><td md-cell>{{vm.optionsData.chartType}}</td></tr><tr md-row>\n<th md-cell class=\"md-column\"><span translate=\"BREAKDOWN.AVG_TEMP\">Avg Temperature:</span></th><td md-cell>\n{{vm.optionsData.temperature}}</td></tr><tr md-row><th md-cell class=\"md-column\"><span translate=\"BREAKDOWN.COMPARE\">\nCompare:</span></th><td md-cell>{{vm.optionsData.compare}}</td></tr><tr md-row><th md-cell class=\"md-column\"><span \ntranslate=\"BREAKDOWN.COMPENSATE\">Compensate for:</span></th><td md-cell>{{vm.optionsData.compensate}}</td></tr><tr \nmd-row><th md-cell class=\"md-column\"><span translate=\"BREAKDOWN.KPI\">KPI:</span></th><td md-cell>\n{{vm.optionsData.chartKPI}}</td></tr><tr md-row><th md-cell class=\"md-column\"><span translate=\"BREAKDOWN.ZOOM_LEVEL\">\nZoom level:</span></th><td md-cell>{{vm.optionsData.chartZoom}}</td></tr></tbody></table></ms-widget-front></ms-widget>\n</div></div></div></div></div>");
$templateCache.put("app/main/change_pass/change_pass.html","<div ng-attr-id=\"{{vm.changePassClass}}\" layout=\"row\" layout-align=\"start\"><div id=\"login-intro\" flex hide show-gt-sm>\n<div class=\"title\" translate=\"LOGIN.CHANGEPASS_TITLE\">Welcome to Smart Energy!</div><div class=\"description\" \ntranslate=\"LOGIN.CHANGEPASS_DESCR\"><strong>Smart Energy</strong>\n offers you valuable features to help you save energy, lower your bills, and budget better than ever before.</div>\n</div><div id=\"login-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-form\"><div \nclass=\"title\" translate=\"PREFERENCES.USER_DETAILS\">User Details</div><form id=\"changePassForm\" name=\"changePassForm\" \nng-submit=\"vm.submit(vm.master)\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.master.userData.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN.PASSWORD\" required><div ng-messages=\"changePassForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"confirm_password\" ng-model=\"vm.master.userData.confirm_password\" placeholder=\"Retype Password\" translate \ntranslate-attr-placeholder=\"LOGIN.RETYPE_PASSWORD\" required><div ng-messages=\"changePassForm.confirm_password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required\n</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"LOG IN\" \nng-disabled=\"changePassForm.$pristine || changePassForm.password.$error.required || changePassForm.confirm_password.$error.required\" \ntranslate=\"PREFERENCES.SUBMIT\" translate-attr-aria-label=\"PREFERENCES.SUBMIT\" style=\"text-transform: none\">Submit\n</md-button></form></div></div></div>");
$templateCache.put("app/main/compare/compare.html","<div id=\"compare\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"content-wrapper\" \nclass=\"md-primary-bg md-hue-3\" style=\"top: 0\"><div class=\"content sidenav\" layout=\"row\"><div hide show-md show-sm \nshow-xs><button class=\"toggle-left-sidenav md-background-bg md-hue-1\" type=\"button\" \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"Toggle\"><md-icon class=\"s20\" \nmd-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button></div><div hide show-gt-md><button \nclass=\"toggle-left-sidenav md-accent\" type=\"button\" ng-click=\"vm.sidebarLock.left=!vm.sidebarLock.left\" \naria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button>\n</div><md-sidenav class=\"sidenav sidenav-width-300 md-sidenav-left\" \nmd-is-locked-open=\"vm.sidebarLock.left && $mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" md-disable-backdrop \nms-scroll ms-sidenav-helper><md-toolbar class=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" \nlayout-padding><div class=\"toolbar\"><div hide show-gt-md><md-icon ng-click=\"vm.changeStatus(\'left-sidenav\', \'left\')\" \nclass=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\" style=\"color: #fff\"></md-icon></div><div \nhide show-md show-sm show-xs><md-icon ng-click=\"vm.toggleClose(\'left-sidenav\')\" class=\"s16 sidhov\" \nmd-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\" style=\"color: #fff\"></md-icon></div></div><div class=\"heading\" \nstyle=\"font-weight: 300; padding-top: 10px\">{{ \'BREAKDOWN.MONITORED_POINTS\' | translate }}</div></md-toolbar>\n<md-content class=\"content md-background-bg md-hue-1\" ms-scroll layout-padding><div class=\"md-primary-bg md-hue-3\" \nlayout=\"row\" style=\"padding: 0\"><div flex><button class=\"md-button md-accent md-raised\" type=\"button\" \nng-click=\"vm.openFilters(\'left\')\" aria-label=\"\" \nstyle=\"min-width: 68px; min-height: 20px; line-height: 16px; padding: 6px; margin-right: 0\"><span \ntranslate=\"COMPARE.FILTERS\">Filters</span></button> <button ng-if=\"vm.filter.left.schedule.schedule.length\" \nnclass=\"md-button\" type=\"button\" ng-click=\"vm.resetFilters(\'left\')\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px; margin-left: 0\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-refresh\" aria-hidden=\"true\"></md-icon></button></div><div id=\"mode-ctrl-left\" layout=\"row\"><button \nng-disabled=\"vm.modeCtrl[\'left\']\" class=\"mode-left-avg md-button md-accent md-raised\" type=\"button\" \nng-click=\"vm.setMode(\'avg\', \'left\')\" aria-label=\"\" \nstyle=\"min-width: 48px; min-height: 20px; line-height: 16px; padding: 6px; margin-right: 0\"><span \ntranslate=\"COMPARE.AVG\">AVG</span></button> <button ng-disabled=\"vm.modeCtrl[\'left\']\" \nclass=\"mode-left-sum md-button md-raised\" type=\"button\" ng-click=\"vm.setMode(\'sum\', \'left\')\" aria-label=\"\" \nstyle=\"min-width: 48px; min-height: 20px; line-height: 16px; padding: 6px; margin-left: 0\"><span \ntranslate=\"COMPARE.SUM\">SUM</span></button></div></div><div class=\"md-background-border md-hue-2\" layout=\"row\" \nstyle=\"padding: 0\"><div flex><button class=\"jstree-open md-button md-accent md-raised\" type=\"button\" \nng-click=\"vm.openTree(\'left\')\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px; margin-right: 0\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></button> <button \nclass=\"jstree-close md-button md-accent md-raised\" type=\"button\" ng-click=\"vm.closeTree(\'left\')\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-minus\" aria-hidden=\"true\"></md-icon></button></div><div><button \nclass=\"jstree-reset md-button md-accent md-raised\" type=\"button\" ng-click=\"vm.resetTree(\'left\')\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-refresh\" aria-hidden=\"true\"></md-icon></button></div></div><div class=\"search-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input \nclass=\"md-background-bg md-hue-1\" flex ng-model=\"vm.searchtree.left\" type=\"text\" ng-change=\"vm.applySearch(\'left\')\" \nplaceholder=\"{{ \'BREAKDOWN.SEARCH_TREE\' | translate }}\"></div></div><div layout=\"column\" \nstyle=\"padding: 0; padding-top: 16px\"><div id=\"left-tree\" class=\"tree\" js-tree=\"vm.treeConfig.left\" \nng-if=\"vm.showTree\" ng-model=\"vm.treeData.left\" tree=\"vm.treeInstance.left\" tree-events-obj=\"vm.treeEvents.left\" \nstyle=\"padding: 4px\"></div></div></md-content></md-sidenav><div class=\"page-content\" ms-scroll flex><div \nclass=\"top-toolbar md-background-bg md-hue-1\" layout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"daterange-wrapper md-background-border md-hue-1\"><div \nclass=\"daterange\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-calendar\" class=\"icon\" \naria-hidden=\"true\"></md-icon><input flex date-range-picker id=\"daterangeL\" name=\"daterangeL\" \nclass=\"form-control date-picker md-background-bg md-hue-1\" type=\"text\" ng-model=\"vm.date.left\" \noptions=\"vm.dateOptions.left\"></div></div></div><div class=\"button-group\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"to_left-button md-button-icon md-raised groupX middle\" ng-disabled=\"vm.lock\" \nng-click=\"vm.buttonAction(\'to_left\')\" aria-label=\"Copy to left\" translate \ntranslate-attr-aria-label=\"COMPARE.COPY_TO_LEFT\"><md-tooltip md-direction=\"top\"><span translate=\"COMPARE.COPY_TO_LEFT\">\nCopy to left</span></md-tooltip><md-icon md-font-icon=\"icon-chevron-double-left\" aria-hidden=\"true\"></md-icon>\n</md-button><md-button class=\"lock-button md-button-icon md-raised groupX middle\" ng-click=\"vm.buttonToggle(\'lock\')\" \naria-label=\"Swap\" translate translate-attr-aria-label=\"BREAKDOWN.LOCK\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMPARE.LOCK\">Lock</span></md-tooltip><md-icon md-font-icon=\"icon-lock\" aria-hidden=\"true\"></md-icon>\n</md-button><md-button class=\"to_right-button md-button-icon md-raised groupX middle\" ng-disabled=\"vm.lock\" \nng-click=\"vm.buttonAction(\'to_right\')\" aria-label=\"Copy to right\" translate \ntranslate-attr-aria-label=\"BREAKDOWN.COPY_TO_RIGHT\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"COMPARE.COPY_TO_RIGHT\">Copy to right</span></md-tooltip><md-icon md-font-icon=\"icon-chevron-double-right\" \naria-hidden=\"true\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"end center\" flex><div \nclass=\"daterange-wrapper md-background-border md-hue-1\"><div class=\"daterange\" layout=\"row\" \nlayout-align=\"start center\" flex><input flex date-range-picker id=\"daterangeR\" name=\"daterangeR\" \nclass=\"form-control date-picker md-background-bg md-hue-1\" type=\"text\" ng-disabled=\"vm.lock\" ng-model=\"vm.date.right\" \noptions=\"vm.dateOptions.right\"><md-icon md-font-icon=\"icon-calendar\" class=\"icon\" aria-hidden=\"true\"></md-icon></div>\n</div></div></div><div layout=\"column\" flex><div><div layout=\"row\" flex><div class=\"h1\" \nstyle=\"font-weight: 300; padding: 16px 26px\" flex translate=\"COMPARE.TITLE\">Compare</div><div \nstyle=\"padding: 8px 26px\"><div layout=\"row\" layout-align=\"start center\"><div class=\"input-block\" flex>\n<md-input-container style=\"margin: 0; margin-right: 6px\"><md-select ng-model=\"vm.savedGraph[vm.chartType]\" \naria-label=\"Select Graph\" ng-change=\"vm.loadGraph(vm.savedGraph[vm.chartType])\" style=\"min-width: 200px\"><md-option \nng-repeat=\"savedGraph in vm.savedGraphs[vm.chartType]\" ng-value=\"savedGraph.id\">{{savedGraph.name}}</md-option>\n</md-select></md-input-container><button ng-click=\"vm.saveGraph()\" class=\"md-button md-raised md-accent\" \ndisabled=\"disabled\" aria-label=\"Save Graph\" ng-disabled=\"!vm.chart.data.length && !vm.chart.heatmapData.length\" \nstyle=\"min-width: 36px; border-radius: 4px\"><md-tooltip md-direction=\"top\"><span translate=\"BREAKDOWN.SAVE_GRAPH\">\nSave Graph</span></md-tooltip><md-icon class=\"s16\" md-font-icon=\"icon-content-save\"></md-icon></button> <button \nng-click=\"vm.deleteGraph()\" class=\"md-button md-raised md-accent\" disabled=\"disabled\" aria-label=\"Delete Graph\" \nng-disabled=\"vm.isDefault(vm.savedGraph[vm.chartType])\" style=\"min-width: 36px; border-radius: 4px\"><md-tooltip \nmd-direction=\"top\"><span translate=\"BREAKDOWN.DELETE_GRAPH\">Delete Graph</span></md-tooltip><md-icon class=\"s16\" \nmd-font-icon=\"icon-close\"></md-icon></button></div></div></div></div></div><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" style=\"padding-top: 0; padding-bottom: 6px\"><ms-widget-front \nclass=\"md-background-bg md-hue-1\" style=\"border-radius: 4px\"><div class=\"h3 md-primary-bg md-hue-2\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start center\" style=\"padding: 8px 16px; min-height: 52px\"><div class=\"chart-title\" \nflex=\"100\" layout=\"row\" layout-align=\"start center\" style=\"height: 36px\"><div id=\"kpi-ctrl\" layout=\"row\"><button \nclass=\"kpi-cost md-button md-raised md-accent\" ng-click=\"vm.setKPI(\'cost\')\" aria-label=\"Cost\"><span \ntranslate=\"BREAKDOWN.COST\">Cost</span> <button><button class=\"kpi-measurements md-button md-raised\" \nng-click=\"vm.setKPI(\'measurements\')\" aria-label=\"Measurements\"><span translate=\"BREAKDOWN.MEASUREMENTS\">Measurements\n</span> <button></button></button></button></button></div><small ng-if=\"vm.measureTypes.length\"><md-input-container>\n<md-select ng-model=\"vm.selectedMeasureType\" aria-label=\"Select Measure Type\" ng-change=\"vm.selectMeasureType();\">\n<md-option ng-repeat=\"measureType in vm.measureTypes\" ng-value=\"measureType.id\" \ntranslate=\"{{measureType.translation}}\">{{measureType.name}}</md-option></md-select></md-input-container></small><small\n ng-if=\"vm.units.length\"><md-input-container><md-select ng-model=\"vm.selectedUnit\" aria-label=\"Select Unit\" \nng-change=\"vm.selectUnit();\"><md-option ng-repeat=\"unit in vm.units\" ng-value=\"unit\" ng-bind-html=\"unit | toTrusted\">\n{{unit}}</md-option></md-select></md-input-container></small></div><div class=\"toolbar\" layout=\"row\"><div \nid=\"zoom-ctrl\" layout=\"row\" layout-align=\"center center\"><md-button class=\"groupX zoom-m\" \nng-click=\"vm.setZoom(\'15 m\')\" aria-label=\"15Min\" translate=\"BREAKDOWN.15MIN\" \ntranslate-attr-aria-label=\"BREAKDOWN.15MIN\">15Min</md-button><md-button class=\"groupX middle zoom-h\" \nng-click=\"vm.setZoom(\'1 h\')\" aria-label=\"Hourly\" translate=\"BREAKDOWN.HOURLY\" \ntranslate-attr-aria-label=\"BREAKDOWN.HOURLY\">Hourly</md-button><md-button class=\"active groupX middle zoom-d\" \nng-click=\"vm.setZoom(\'1 d\')\" aria-label=\"Day\" translate=\"BREAKDOWN.DAY\" translate-attr-aria-label=\"BREAKDOWN.DAY\">Day\n</md-button><md-button class=\"groupX middle zoom-w\" ng-click=\"vm.setZoom(\'1 w\')\" aria-label=\"Week\" \ntranslate=\"BREAKDOWN.WEEK\" translate-attr-aria-label=\"BREAKDOWN.WEEK\">Week</md-button><md-button \nclass=\"groupX righ zoom-M\" ng-click=\"vm.setZoom(\'1 M\')\" aria-label=\"Month\" translate=\"BREAKDOWN.MONTH\" \ntranslate-attr-aria-label=\"BREAKDOWN.MONTH\">Month</md-button></div><md-menu><md-button \nclass=\"md-icon-button download-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Download\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg md-hue-1\">\n<md-menu-item><md-button ng-click=\"vm.saveImage(\'chart-aggregated-canvas\')\" aria-label=\"Download PNG\" \ntranslate=\"BREAKDOWN.DOWNLOAD_PNG\" translate-attr-aria-label=\"BREAKDOWN.DOWNLOAD_PNG\">Download PNG</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><md-divider></md-divider><div layout=\"column\" class=\"\"><div \nlayout=\"row\" class=\"border-bottom p-16\" style=\"padding-bottom: 0; height: 78px\"><div flex=\"50\" \nng-if=\"vm.stats.left.total\"><div layout=\"row\"><div flex=\"40\"><div class=\"h4 secondary-text\"><span \ntranslate=\"BREAKDOWN.TOTAL\">TOTAL</span></div><div class=\"md-display-1 light-blue-fg\">{{vm.stats.left.total}} <small>\n{{vm.chartUnits[0]}}</small></div></div><div flex=\"60\"><div layout=\"row\" flex><div class=\"h4 secondary-text\"><span \ntranslate=\"BREAKDOWN.AVG\">AVG</span></div><div class=\"h4 secondary-text\">: <b>{{vm.stats.left.avg}}</b> <small>\n{{vm.chartUnits[0]}}</small></div></div><div layout=\"row\" flex><div class=\"h4 secondary-text\"><span \ntranslate=\"BREAKDOWN.MIN\">MIN</span></div><div class=\"h4 secondary-text\">: <b>{{vm.stats.left.min}}</b> <small>\n{{vm.chartUnits[0]}}</small></div></div><div layout=\"row\" flex><div class=\"h4 secondary-text\"><span \ntranslate=\"BREAKDOWN.MAX\">MAX</span></div><div class=\"h4 secondary-text\">: <b>{{vm.stats.left.max}}</b> <small>\n{{vm.chartUnits[0]}}</small></div></div></div></div></div><div flex=\"50\" ng-if=\"vm.stats.right.total\"><div \nlayout=\"row\"><div flex=\"60\"><div layout=\"row\" flex layout-align=\"end\"><div class=\"h4 secondary-text\"><span \ntranslate=\"BREAKDOWN.AVG\">AVG</span></div><div class=\"h4 secondary-text\">: <b>{{vm.stats.right.avg}}</b> <small>\n{{vm.chartUnits[0]}}</small></div></div><div layout=\"row\" flex layout-align=\"end\"><div class=\"h4 secondary-text\"><span \ntranslate=\"BREAKDOWN.MIN\">MIN</span></div><div class=\"h4 secondary-text\">: <b>{{vm.stats.right.min}}</b> <small>\n{{vm.chartUnits[0]}}</small></div></div><div layout=\"row\" flex layout-align=\"end\"><div class=\"h4 secondary-text\"><span \ntranslate=\"BREAKDOWN.MAX\">MAX</span></div><div class=\"h4 secondary-text\">: <b>{{vm.stats.right.max}}</b> <small>\n{{vm.chartUnits[0]}}</small></div></div></div><div flex=\"40\"><div class=\"h4 secondary-text\" style=\"text-align: right\">\n<span translate=\"BREAKDOWN.TOTAL\">TOTAL</span></div><div class=\"md-display-1 light-blue-fg\" style=\"text-align: right\">\n{{vm.stats.right.total}} <small>{{vm.chartUnits[0]}}</small></div></div></div></div><div ng-if=\"!vm.stats.left.total\" \nclass=\"status\" flex style=\"font-size: 13px; height: 62px; padding: 16px 0 0\"><span class=\"msg-spinner static\"></span>\n &nbsp; <span translate=\"COMPARE.SELECT_DATA\">Please select a monitored point...</span></div></div><div \nlayout=\"column\" class=\"pb-16\"><div class=\"chart-container m-16\"><canvas id=\"chart-aggregated-canvas\" \nclass=\"chart chart-bar\" ng-if=\"vm.chart.data[0].length\" chart-data=\"vm.chart.data\" chart-labels=\"vm.chart.labels\" \nchart-options=\"vm.chart.options\" chart-series=\"vm.chart.series\" chart-click=\"vm.chart.click\" \nchart-hover=\"vm.chart.hover\" chart-colors=\"vm.chart.colors\" chart-dataset-override=\"vm.chart.override\"></canvas></div>\n<div layout=\"column\" class=\"chart-aggregated-zoom m-16\" style=\"display: none; position: relative; height: 70px\"><div \nclass=\"zoom-ctrl\"><div class=\"zoom-left\"></div><div class=\"zoom-box\"><div></div></div><div class=\"zoom-right\"></div>\n</div><canvas id=\"chart-zoom-canvas\" style=\"pointer-events: none\"></canvas></div></div></div></ms-widget-front>\n</ms-widget></div></div><div hide show-md show-sm show-xs><button \nclass=\"toggle-right-sidenav md-background-bg md-hue-1\" type=\"button\" ng-click=\"vm.toggleSidenav(\'right-sidenav\')\" \naria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\"></md-icon></button>\n</div><div hide show-gt-md><button class=\"toggle-right-sidenav md-accent\" type=\"button\" \nng-click=\"vm.sidebarLock.right=!vm.sidebarLock.right\" aria-label=\"Toggle\"><md-icon class=\"s20\" \nmd-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\"></md-icon></button></div><md-sidenav \nclass=\"sidenav sidenav-width-300 md-sidenav-right\" md-is-locked-open=\"vm.sidebarLock.right && $mdMedia(\'gt-md\')\" \nmd-component-id=\"right-sidenav\" md-disable-backdrop ms-scroll ms-sidenav-helper><md-toolbar \nclass=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding><div class=\"heading\" \nstyle=\"font-weight: 300; padding-top: 10px\">{{ \'COMPARE.AGAINST\' | translate }}</div><div class=\"toolbar\"><div hide \nshow-gt-md><md-icon ng-click=\"vm.changeStatus(\'right-sidenav\', \'right\')\" class=\"s16 sidhov\" \nmd-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\" style=\"color: #fff\"></md-icon></div><div hide show-md show-sm \nshow-xs><md-icon ng-click=\"vm.toggleClose(\'right-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-right-bold\" \naria-hidden=\"true\" style=\"color: #fff\"></md-icon></div></div></md-toolbar><md-content \nclass=\"content md-background-bg md-hue-1\" ms-scroll layout-padding><div class=\"md-primary-bg md-hue-3\" layout=\"row\" \nstyle=\"padding: 0\"><div flex><button class=\"md-button md-accent md-raised\" type=\"button\" \nng-click=\"vm.openFilters(\'right\')\" aria-label=\"\" \nstyle=\"min-width: 68px; min-height: 20px; line-height: 16px; padding: 6px; margin-right: 0\"><span \ntranslate=\"COMPARE.FILTERS\">Filters</span></button> <button ng-if=\"vm.filter.right.schedule.schedule.length\" \nclass=\"md-button\" type=\"button\" ng-click=\"vm.resetFilters(\'right\')\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px; margin-left: 0\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-refresh\" aria-hidden=\"true\"></md-icon></button></div><div id=\"mode-ctrl-right\"><button \nng-disabled=\"vm.modeCtrl[\'right\']\" class=\"mode-right-avg md-button md-accent md-raised\" type=\"button\" \nng-click=\"vm.setMode(\'avg\', \'right\')\" aria-label=\"\" \nstyle=\"min-width: 48px; min-height: 20px; line-height: 16px; padding: 6px; margin-right: 0\"><span \ntranslate=\"COMPARE.AVG\">AVG</span></button> <button ng-disabled=\"vm.modeCtrl[\'right\']\" \nclass=\"mode-right-sum md-button md-raised\" type=\"button\" ng-click=\"vm.setMode(\'sum\', \'right\')\" aria-label=\"\" \nstyle=\"min-width: 48px; min-height: 20px; line-height: 16px; padding: 6px; margin-left: 0\"><span \ntranslate=\"COMPARE.SUM\">SUM</span></button></div></div><div class=\"md-background-border md-hue-2\" layout=\"row\" \nstyle=\"padding: 0\"><div flex><button class=\"jstree-open md-button md-accent md-raised\" type=\"button\" \nng-click=\"vm.openTree(\'right\')\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px; margin-right: 0\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></button> <button \nclass=\"jstree-close md-button md-accent md-raised\" type=\"button\" ng-click=\"vm.closeTree(\'right\')\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-minus\" aria-hidden=\"true\"></md-icon></button></div><div><button \nclass=\"jstree-reset md-button md-accent md-raised\" type=\"button\" ng-click=\"vm.resetTree(\'right\')\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-refresh\" aria-hidden=\"true\"></md-icon></button></div></div><div class=\"search-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input \nclass=\"md-background-bg md-hue-1\" flex ng-model=\"vm.searchtree.right\" type=\"text\" ng-change=\"vm.applySearch(\'right\')\" \nplaceholder=\"{{ \'BREAKDOWN.SEARCH_TREE\' | translate }}\"></div></div><div layout=\"column\" \nstyle=\"padding: 0; padding-top: 16px\"><div id=\"right-tree\" class=\"tree\" js-tree=\"vm.treeConfig.right\" \nng-if=\"vm.showTree\" ng-model=\"vm.treeData.right\" tree=\"vm.treeInstance.right\" tree-events-obj=\"vm.treeEvents.right\" \nstyle=\"padding: 4px\"></div></div></md-content></md-sidenav></div></div></div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"dashboard\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"content-wrapper\" \nclass=\"md-primary-bg md-hue-3\"><div class=\"content sidenav\" layout=\"row\"><div hide show-md show-sm show-xs \nng-if=\"vm.showLeftSideNav\"><button class=\"toggle-left-sidenav md-background-bg md-hue-1\" type=\"button\" \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"Toggle\"><md-icon class=\"s20\" \nmd-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button></div><div hide show-gt-md \nng-if=\"vm.showLeftSideNav\"><button class=\"toggle-left-sidenav\" type=\"button\" ng-click=\"vm.lockLeft=!vm.lockLeft\" \naria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button>\n</div><md-sidenav ng-if=\"vm.showLeftSideNav\" class=\"sidenav sidenav-width-300 md-sidenav-left\" \nmd-is-locked-open=\"vm.lockLeft && $mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" md-disable-backdrop ms-scroll \nms-sidenav-helper><md-toolbar class=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding>\n<div class=\"toolbar\"><div hide show-gt-md><md-icon ng-click=\"vm.changeStatusL(\'left-sidenav\')\" class=\"s16 sidhov\" \nmd-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\"></md-icon></div><div hide show-md show-sm show-xs><md-icon \nng-click=\"vm.toggleClose(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\">\n</md-icon></div></div><div class=\"heading\">{{ \'DASHBOARD.MONITORED_POINTS\' | translate }}</div></md-toolbar><md-content\n class=\"content md-background-bg md-hue-1\" ms-scroll layout-padding><div \nclass=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input class=\"md-background-bg md-hue-1\" flex \nng-model=\"vm.searchtree\" type=\"text\" ng-change=\"vm.applySearch()\" \nplaceholder=\"{{ \'DASHBOARD.SEARCH_TREE\' | translate }}\"></div></div><div layout=\"row\"><div class=\"tree\" \njs-tree=\"vm.treeConfig\" ng-model=\"vm.treeData\" tree=\"vm.treeInstance\" tree-events-obj=\"vm.treeEvents\"></div></div>\n<md-content></md-content></md-content></md-sidenav><div class=\"page-content\" ms-scroll flex><div \nclass=\"top-toolbar md-background-bg md-hue-1\" layout=\"row\" layout-xs=\"column\" layout-align=\"start center\" \nstyle=\"padding-bottom: 5px\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"daterange-wrapper md-background-border md-hue-1\"><div class=\"daterange\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-calendar\" class=\"icon\" aria-hidden=\"true\"></md-icon><input\n ng-disabled=\"vm.showDates\" flex date-range-picker id=\"daterange\" min=\"\'2017-01-01\'\" name=\"daterange\" \nclass=\"form-control date-picker md-background-bg md-hue-1\" type=\"text\" ng-model=\"vm.date\" options=\"vm.dateOptions\">\n</div></div></div><div class=\"button-group\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-button-icon md-raised groupX middle\" ng-click=\"vm.lockDashboard()\"><md-tooltip md-direction=\"left\">\n{{ \'DASHBOARD.LOCK\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-lock\" ng-if=\"vm.dashboardLocked\"></md-icon>\n<md-icon md-font-icon=\"icon-lock-unlocked\" ng-if=\"!vm.dashboardLocked\"></md-icon></md-button><md-button \nclass=\"md-button-icon md-raised groupX middle\" ng-click=\"vm.controlDashboard($event,null,\'New\')\" \nng-if=\"!vm.dashboardLocked\"><md-tooltip md-direction=\"left\">{{ \'DASHBOARD.NEW_DASHBOARD\' | translate }}</md-tooltip>\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-button-icon md-raised groupX middle\" \nng-click=\"vm.controlDashboard($event,vm.selectedDashboard,\'Duplicate\')\" ng-if=\"!vm.dashboardLocked\"><md-tooltip \nmd-direction=\"left\">{{ \'DASHBOARD.DUPLICATE_DASHBOARD\' | translate }}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-duplicate \"></md-icon></md-button><md-button class=\"md-button-icon md-raised groupX middle\" \nng-click=\"vm.controlDashboard($event,vm.selectedDashboard,\'Edit\')\" \nng-if=\"vm.selectedDashboard.userId!=\'\' && !vm.dashboardLocked\"><md-tooltip md-direction=\"left\">\n{{ \'DASHBOARD.EDIT_DASHBOARD\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button class=\"md-button-icon md-raised groupX middle\" \nng-click=\"vm.controlDashboard($event,vm.selectedDashboard,\'Save\') \" \nng-if=\"vm.selectedDashboard.userId!=\'\' && !vm.dashboardLocked\"><md-tooltip md-direction=\"left\">\n{{ \'DASHBOARD.SAVE_DASHBOARD\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n</md-button><md-button class=\"md-button-icon md-raised groupX middle\" \nng-click=\"vm.controlDashboard($event,vm.selectedDashboard,\'Delete\')\" ng-if=\"!vm.dashboardLocked\"><md-tooltip \nmd-direction=\"left\">{{ \'DASHBOARD.DELETE_DASHBOARD\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button><md-button class=\"md-button-icon md-raised groupX middle\" style=\"margin-right:10px\" \nng-click=\"vm.controlDashboard($event,vm.selectedDashboard,\'Restore\')\"><md-tooltip md-direction=\"left\">\n{{ \'DASHBOARD.RESTORE_DASHBOARD\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-sync\"></md-icon></md-button>\n<md-button class=\"md-button-icon md-raised groupX middle\" \nng-click=\"vm.addWidget($event,vm.selectedDashboard,null,\'new\')\" \nng-if=\"vm.selectedDashboard.userId!=\'\' && !vm.dashboardLocked\"><md-tooltip md-direction=\"left\">\n{{ \'DASHBOARD.NEW_WIDGET\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-comment-plus-outline\"></md-icon>\n</md-button></div></div><div ng-if=\"vm.dashboards.length>0 && vm.selectedDashboard.widgets.length == 0\" \nclass=\"emptyDashboard\" layout=\"column\" layout-align=\"center center\" style=\"height: 100%\"><div class=\"h2 box\" \nlayout=\"column\" layout-align=\"center center\"><button class=\"md-fab md-button white-fg\" \nng-click=\"vm.addWidget($event, vm.selectedDashboard, null, \'new\')\" ng-if=\"!vm.dashboardLocked\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s40 icon\"></md-icon></button> <span>{{ \'DASHBOARD.EMPTY_DASHBOARD\' | translate }}\n</span></div></div><div ng-if=\"vm.dashboards.length == 0\" class=\"emptyDashboard\" layout=\"column\" \nlayout-align=\"center center\" style=\"height: 100%\"><div class=\"h2 box\" layout=\"column\" layout-align=\"center center\">\n<button class=\"md-fab md-button white-fg\" ng-click=\"vm.controlDashboard($event,null,\'New\')\" \nng-if=\"!vm.dashboardLocked\"><md-icon md-font-icon=\"icon-plus\" class=\"s40 icon\"></md-icon></button> <span>\n{{ \'DASHBOARD.NO_DASHBOARDS\' | translate }}</span></div></div><div class=\"p-10 pt-20\" \nng-if=\"vm.selectedDashboard.widgets.length > 0 && vm.dashboards.length>0\"><div gridstack class=\"grid-stack\" \nid=\"grid-stack\" options=\"vm.gridStackOptions\" on-change=\"vm.onChange(event,items)\" \non-drag-start=\"vm.onDragStart(event,ui)\" on-drag-stop=\"vm.onDragStop(event,ui)\" \non-resize-start=\"vm.onResizeStart(event,ui)\" on-resize-stop=\"vm.onResizeStop(event,ui)\"><div gridstack-item \nclass=\"grid-stack-item\" ng-repeat=\"widget in vm.selectedDashboard.widgets\" data-gs-min-width=\"1\" \ndata-gs-min-height=\"1\" gs-item-x=\"widget.dimentions.x\" gs-item-y=\"widget.dimentions.y\" \ngs-item-width=\"widget.dimentions.width\" data-gs-auto-position=\"false\" gs-item-height=\"widget.dimentions.height\" \non-item-added=\"vm.onItemAdded(item)\" on-item-removed=\"vm.onItemRemoved(item)\"><div \nclass=\"ms-widget-front grid-stack-item-content md-background-bg md-hue-1\" ng-if=\"widget.type!==5\" \nng-style=\"{\'background-color\': ((widget.type===0 || widget.type===16 || widget.type===20 || widget.type===22) && widget.graph.widgetHasColor) ? widget.graph.widgetColor : \'none\'}\">\n<div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\" \nstyle=\"font-size:14px\">{{widget.title}}</div><div layout=\"row\"><div ng-if=\"!vm.dashboardLocked\"><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.addWidget($event,vm.selectedDashboard,widget,\'edit\')\" \naria-label=\"Edit Widget\"><md-tooltip md-direction=\"top\">{{ \'DASHBOARD.EDIT_WIDGET\' | translate }}</md-tooltip><md-icon \nmd-font-icon=\"icon-pencil-box\" class=\"s24\"></md-icon></md-button></div><div ng-if=\"!vm.dashboardLocked\"><md-button \nclass=\"delete-button md-icon-button\" ng-click=\"vm.removeWidget(widget)\" aria-label=\"Remove Widget\"><md-tooltip \nmd-direction=\"top\">{{ \'DASHBOARD.REMOVE_WIDGET\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-close-circle\" \nclass=\"s24\"></md-icon></md-button></div></div></div><numeric-card widget=\"widget\" dashboard-date=\"vm.date\" \nng-if=\"widget.type===0\"></numeric-card><plot-card widget=\"widget\" dashboard-date=\"vm.date\" ng-if=\"widget.type===1\" \nstyle=\"text-align:center\"></plot-card><pie-card widget=\"widget\" dashboard-date=\"vm.date\" ng-if=\"widget.type===2\" \nstyle=\"text-align:center\"></pie-card><gauge-card widget=\"widget\" dashboard-date=\"vm.date\" ng-if=\"widget.type===3\" \nstyle=\"text-align:center\"></gauge-card><spyder-card widget=\"widget\" dashboard-date=\"vm.date\" ng-if=\"widget.type===4\" \nstyle=\"text-align:center\"></spyder-card><huba-plot widget=\"widget\" dashboard-date=\"vm.date\" ng-if=\"widget.type===6\" \nstyle=\"text-align:center\"></huba-plot><huba-total widget=\"widget\" dashboard-date=\"vm.date\" ng-if=\"widget.type===7\" \nstyle=\"text-align:center\"></huba-total><huba-hours widget=\"widget\" dashboard-date=\"vm.date\" ng-if=\"widget.type===8\" \nstyle=\"text-align:center\"></huba-hours><huba-transitions widget=\"widget\" dashboard-date=\"vm.date\" \nng-if=\"widget.type===9\" style=\"text-align:center\"></huba-transitions><huba-peak widget=\"widget\" \ndashboard-date=\"vm.date\" ng-if=\"widget.type===10\" style=\"text-align:center\"></huba-peak><floor-plan widget=\"widget\" \ndashboard-date=\"vm.date\" ng-if=\"widget.type===11\"></floor-plan><ph-card widget=\"widget\" ng-if=\"widget.type===12\" \nstyle=\"text-align:center\"></ph-card><wind-direction widget=\"widget\" ng-if=\"widget.type===13\" style=\"text-align:center\">\n</wind-direction><waste-bin widget=\"widget\" ng-if=\"widget.type===14\" style=\"text-align:center\"></waste-bin><waste-table\n widget=\"widget\" dashboard-date=\"vm.date\" ng-if=\"widget.type===15\" style=\"text-align:center\"></waste-table>\n<lighting-card widget=\"widget\" ng-if=\"widget.type===16\"></lighting-card><parking-lot widget=\"widget\" \nng-if=\"widget.type===17\" style=\"text-align:center\"></parking-lot><table-card widget=\"widget\" dashboard-date=\"vm.date\" \nng-if=\"widget.type===18\" style=\"text-align:center\"></table-card><map-card widget=\"widget\" ng-if=\"widget.type===19\">\n</map-card><plugwise-card widget=\"widget\" ng-if=\"widget.type===20\"></plugwise-card><hvac-card widget=\"widget\" \nng-if=\"widget.type===21\" style=\"text-align:center\"></hvac-card><occupancy-card widget=\"widget\" \ndashboard-date=\"vm.date\" ng-if=\"widget.type===22\"></occupancy-card><ha-dishwasher widget=\"widget\" \nng-if=\"widget.type===100\"></ha-dishwasher><ha-dryer widget=\"widget\" ng-if=\"widget.type===101\"></ha-dryer><ha-laundry \nwidget=\"widget\" ng-if=\"widget.type===102\"></ha-laundry><ha-oven widget=\"widget\" ng-if=\"widget.type===103\"></ha-oven>\n<ha-fridge widget=\"widget\" ng-if=\"widget.type===104\"></ha-fridge><fridge-ditector widget=\"widget\" \nng-if=\"widget.type===105\" style=\"text-align:center\"></fridge-ditector><tv-card widget=\"widget\" \nng-if=\"widget.type===106\"></tv-card><lamp-card widget=\"widget\" ng-if=\"widget.type===107\"></lamp-card>\n<consumption-production widget=\"widget\" dashboard-date=\"vm.date\" ng-if=\"widget.type===108\" style=\"text-align:center\">\n</consumption-production><prediction-plot widget=\"widget\" dashboard-date=\"vm.date\" ng-if=\"widget.type===109\" \nstyle=\"text-align:center\"></prediction-plot></div><div class=\"grid-stack-item-content\" \nstyle=\"overflow-y: hidden;box-shadow:none\" ng-if=\"widget.type===5\"><div class=\"pr-8 pt-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><section-widget widget=\"widget\" ng-if=\"widget.type===5\"></section-widget><div \nlayout=\"row\"><div ng-if=\"!vm.dashboardLocked\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.addWidget($event,vm.selectedDashboard,widget,\'edit\')\" aria-label=\"Edit Widget\"><md-tooltip \nmd-direction=\"top\">{{ \'DASHBOARD.EDIT_WIDGET\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s18\"></md-icon></md-button><md-button class=\"delete-button md-icon-button\" ng-click=\"vm.removeWidget(widget)\" \naria-label=\"Remove Widget\"><md-tooltip md-direction=\"top\">{{ \'DASHBOARD.REMOVE_WIDGET\' | translate }}</md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon></md-button></div></div></div></div></div></div></div></div>\n<div hide show-md show-sm show-xs><button class=\"toggle-right-sidenav\" type=\"button\" \nng-click=\"vm.toggleSidenav(\'right-sidenav\')\" aria-label=\"Toggle\"><md-icon class=\"s20\" \nmd-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\"></md-icon></button></div><div hide show-gt-md><button \nclass=\"toggle-right-sidenav\" type=\"button\" ng-click=\"vm.lockRight=!vm.lockRight\" aria-label=\"Toggle\"><md-icon \nclass=\"s20\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\"></md-icon></button></div><md-sidenav \nclass=\"sidenav sidenav-width-300 md-sidenav-right\" md-is-locked-open=\"vm.lockRight && $mdMedia(\'gt-md\')\" \nmd-component-id=\"right-sidenav\" md-disable-backdrop ms-scroll ms-sidenav-helper><md-toolbar \nclass=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding><div class=\"heading\">\n{{ \'DASHBOARD.MY_DASHBOARDS\' | translate }}</div><div class=\"toolbar\"><div hide show-gt-md><md-icon \nng-click=\"vm.changeStatusR(\'right-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-right-bold\" \naria-hidden=\"true\"></md-icon></div><div hide show-md show-sm show-xs><md-icon \nng-click=\"vm.toggleClose(\'right-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\">\n</md-icon></div></div></md-toolbar><md-content class=\"content\" ms-scroll layout-padding><md-input-container \nlayout=\"row\"><label><span class=\"hint-text\" translate=\"DASHBOARD.ORDER_BY\">Order By</span></label><md-select \nng-model=\"vm.dashboardOrder\" ng-change=\"vm.getDashboards(\'Start\',null)\"><md-option value=\"name\" \ntranslate=\"DASHBOARD.DASBOARD_NAME\">Dashboard Name</md-option><md-option value=\"date\" \ntranslate=\"DASHBOARD.CREATED_DATE\">Created Date</md-option><md-option value=\"order\" \ntranslate=\"DASHBOARD.USER_PREFERENCE\">User Preference</md-option></md-select></md-input-container><ul \nui-sortable=\"vm.sortableOptions\" ng-model=\"vm.dashboards\" class=\"list\" \nng-if=\"vm.dashboards.length > 0 && vm.dashboardOrder==\'order\'\"><li ng-repeat=\"dashboard in vm.dashboards\" \nclass=\"dashboardItem\" ng-click=\"vm.changeDashboard(dashboard);\" aria-label=\"{{dashboard.name}}\" \nng-class=\"{\'md-primary-bg md-hue-3\': vm.selectedDashboard.name == dashboard.name}\"><p style=\"margin-left:15px\"><md-icon\n md-font-icon=\"icon-view-dashboard\" class=\"icon s18\"></md-icon>{{dashboard.name}}</p></li></ul><ul class=\"list\" \nng-if=\"vm.dashboards.length > 0 && vm.dashboardOrder!=\'order\'\"><li ng-repeat=\"dashboard in vm.dashboards\" \nclass=\"dashboardItem\" ng-click=\"vm.changeDashboard(dashboard);\" aria-label=\"{{dashboard.name}}\" \nng-class=\"{\'md-primary-bg md-hue-3\': vm.selectedDashboard.name == dashboard.name}\"><p style=\"margin-left:15px\"><md-icon\n md-font-icon=\"icon-view-dashboard\" class=\"icon s18\"></md-icon>{{dashboard.name}}</p></li></ul></md-content>\n</md-sidenav></div></div></div>");
$templateCache.put("app/main/events/events.html","<div id=\"events\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"content-wrapper\" \nclass=\"md-primary-bg md-hue-3\"><div class=\"content sidenav\" layout=\"row\"><div hide show-md show-sm show-xs><button \nclass=\"toggle-left-sidenav md-background-bg md-hue-1\" type=\"button\" ng-click=\"vm.toggleSidenav(\'left-sidenav\')\" \naria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button>\n</div><div hide show-gt-md><button class=\"toggle-left-sidenav md-accent\" type=\"button\" \nng-click=\"vm.lockLeft=!vm.lockLeft\" aria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" \naria-hidden=\"true\"></md-icon></button></div><md-sidenav class=\"sidenav sidenav-width-300 md-sidenav-left\" \nmd-is-locked-open=\"vm.lockLeft && $mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" md-disable-backdrop ms-scroll \nms-sidenav-helper><md-toolbar class=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding>\n<div class=\"toolbar\"><div hide show-gt-md><md-icon ng-click=\"vm.changeStatusL(\'left-sidenav\')\" class=\"s16 sidhov\" \nmd-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\" style=\"color: #fff\"></md-icon></div><div hide show-md show-sm \nshow-xs><md-icon ng-click=\"vm.toggleClose(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" \naria-hidden=\"true\" style=\"color: #fff\"></md-icon></div></div><div class=\"heading\" \nstyle=\"font-weight: 300; padding-top: 10px\">{{ \'EVENTS.MONITORED_POINTS\' | translate }}</div></md-toolbar><md-content \nclass=\"content md-background-bg md-hue-1\" ms-scroll layout-padding><div class=\"md-background-border md-hue-2\" \nlayout=\"row\" style=\"padding: 0\"><div flex><button class=\"jstree-open md-button md-accent md-raised\" type=\"button\" \nng-click=\"vm.openTree()\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px; margin-right: 0\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></button> <button \nclass=\"jstree-close md-button md-accent md-raised\" type=\"button\" ng-click=\"vm.closeTree()\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-minus\" aria-hidden=\"true\"></md-icon></button></div><div><button \nclass=\"jstree-reset md-button md-accent md-raised\" type=\"button\" ng-click=\"vm.resetTree()\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-refresh\" aria-hidden=\"true\"></md-icon></button></div></div><div class=\"search-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input \nclass=\"md-background-bg md-hue-1\" flex ng-model=\"vm.searchtree\" type=\"text\" ng-change=\"vm.applySearch()\" \nplaceholder=\"{{ \'DASHBOARD.SEARCH_TREE\' | translate }}\"></div></div><div layout=\"column\" \nstyle=\"padding: 0; padding-top: 16px\"><div class=\"tree\" js-tree=\"vm.treeConfig\" ng-model=\"vm.treeData\" \ntree=\"vm.treeInstance\" tree-events-obj=\"vm.treeEvents\" style=\"padding: 4px\" ng-if=\"vm.showTree\"></div></div>\n</md-content></md-sidenav><div class=\"page-content\" ms-scroll flex><div class=\"top-toolbar md-background-bg md-hue-1\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"daterange-wrapper md-background-border md-hue-1\"><div class=\"daterange\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-calendar\" class=\"icon\" aria-hidden=\"true\"></md-icon>\n<md-select style=\"min-width: 208px\" class=\"periodSelect\" ng-model=\"vm.period\" ng-change=\"vm.applyPeriod(period.value)\" \naria-label=\"Select period\" translate translate-attr-aria-label=\"EVENTS.SELECT_PERIOD\"><md-option \nng-value=\"period.value\" ng-repeat=\"period in vm.periods\">{{period.name}}</md-option></md-select></div></div></div>\n</div><div layout=\"column\" flex><div><div layout=\"row\" flex><div class=\"h1\" \nstyle=\"font-weight: 300; padding: 16px 26px\" flex translate=\"EVENTS.EVENTS_TITLE\">Events</div><div \nstyle=\"padding: 8px 26px\"><button ng-click=\"vm.openNewEventDialog($event)\" class=\"md-button md-raised md-accent\" \ndisabled=\"disabled\" aria-label=\"Add Event\" translate translate-attr-aria-label=\"EVENTS.ADD_EVENT\" \nng-disabled=\"vm.selectedNode == {}\" style=\"min-width: 36px; border-radius: 4px\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"EVENTS.ADD_EVENT\">Add Event</span></md-tooltip><md-icon class=\"s16\" md-font-icon=\"icon-plus\"></md-icon>\n</button></div></div></div><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" style=\"padding-top: 0\">\n<ms-widget-front class=\"md-background-bg md-hue-1\" style=\"border-radius: 4px\"><div \nclass=\"h3 p-16 md-primary-bg md-hue-2\" layout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><div class=\"status\" \nflex style=\"font-size: 13px\"><span class=\"msg-spinner static\"></span> &nbsp; <span translate=\"EXPLORE.SELECT_DATA\">\nPlease select a monitored point...</span></div></div><md-divider></md-divider><div layout=\"column\" class=\"\" flex \nstyle=\"padding: 48px 24px; height: 250px\"><ng-dygraphs style=\"width: 100%; height: 250px\" \nng-if=\"vm.chart.data.length && vm.chart.data[0].length == vm.events.length + 1\" data=\"vm.chart.data\" \noptions=\"vm.chart.options\"></ng-dygraphs></div></ms-widget-front></ms-widget><div id=\"timeline-content\" \nclass=\"ms-timeline\" ng-if=\"vm.events.length\" ms-timeline=\"vm.eventsOptions\" ms-timeline-load-more=\"\" flex><div \nms-timeline-item layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" \nng-repeat=\"eventItem in vm.events | orderBy: \'-date\'\"><div class=\"event-point\" ng-cloak><md-fab-speed-dial \nclass=\"md-fling\" md-open=\"eventItem.isOpen\" md-direction=\"down\" ng-mouseenter=\"eventItem.isOpen=true\" \nng-mouseleave=\"eventItem.isOpen=false\"><md-fab-trigger><md-button class=\"md-fab {{eventItem.color}}\" \naria-label=\"Manage Event\" translate translate-attr-aria-label=\"EVENTS.MANAGE_EVENT\"><md-icon \nmd-font-icon=\"{{eventItem.icon}}\" aria-hidden=\"true\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button \nclass=\"md-fab md-primary md-raised md-mini\" ng-click=\"vm.openEditEventDialog($event, eventItem)\" \naria-label=\"Edit Event\" translate translate-attr-aria-label=\"EVENTS.EDIT_EVENT\"><md-tooltip md-direction=\"right\"><span \ntranslate=\"EVENTS.EDIT_EVENT\">Edit Event</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\">\n</md-icon></md-button><md-button class=\"md-fab md-primary md-raised md-mini\" \nng-click=\"vm.openDeleteEventDialog($event, eventItem)\" aria-label=\"Delete Event\" translate \ntranslate-attr-aria-label=\"EVENTS.DELETE_EVENT\"><md-tooltip md-direction=\"right\"><span translate=\"EVENTS.DELETE_EVENT\">\nDelete Event</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-hidden=\"true\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div><div class=\"event-detail\" flex=\"50\"><div class=\"date\">\n{{eventItem.formattedDate}}</div><div class=\"event\" ng-bind-html=\"eventItem.card.text | toTrusted\"></div><div \nclass=\"event\"><small><span translate=\"EVENTS.ATTACHED\">Attached to:</span> \"{{eventItem.attachedTo}}\"</small></div>\n</div><div class=\"event-card\" layout=\"row\" flex=\"50\"><ms-card template=\"eventItem.card.template\" \nng-model=\"eventItem.card\"></ms-card></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/expert/expert.html","<div id=\"expert\"><div class=\"header md-primary-bg\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\" style=\"margin-top: -16px\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><span class=\"md-display-1 font-weight-300\">Expert</span>\n</div><div class=\"content\" md-background-bg layout=\"row\" ms-scroll><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"padding-10\">\n<div class=\"md-title\"><p class=\"mb-0 mt-10\">Monitored points</p></div><md-content class=\"content\"><div \nclass=\"search-wrapper\" layout=\"row\" layout-align=\"start center\"><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex \nng-model=\"vm.searchtree\" type=\"text\" ng-change=\"vm.applySearch()\" placeholder=\"Search Tree\"></div><md-button \nclass=\"refresh-button md-icon-button\" ng-click=\"vm.refreshTree()\" aria-label=\"Refresh Tree\"><md-tooltip \nmd-direction=\"top\">Refresh Tree</md-tooltip><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button></div><div \nlayout=\"row\"><div class=\"tree\" js-tree=\"vm.treeConfig\" ng-model=\"vm.treeData\" tree=\"vm.treeInstance\" \ntree-events-obj=\"vm.treeEvents\"></div></div></md-content></div></md-sidenav><div class=\"content\" flex><div \nclass=\"pl-15 pr-20\" layout=\"row\" layout-align=\"start center\" style=\"margin-top: 8px\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"md-title\"><p class=\"m-0\">Dates:</p></div><div \nclass=\"daterange-wrapper md-whiteframe-1dp\"><div class=\"daterange\" flex layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-calendar\" class=\"icon\"></md-icon><input flex date-range-picker id=\"daterange\" \nname=\"daterange\" class=\"form-control date-picker\" type=\"text\" ng-model=\"vm.date\" options=\"vm.dateOptions\"></div></div>\n</div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"chartType-button active bar-button md-button-icon md-raised groupX middle\" ng-click=\"vm.setChartType(\'bar\')\" \naria-label=\"Bar Chart\"><md-tooltip md-direction=\"top\">Bar Chart</md-tooltip><md-icon md-font-icon=\"icon-chart-bar\">\n</md-icon></md-button><md-button class=\"chartType-button line-button md-button-icon md-raised groupX middle\" \nstyle=\"margin-right: 20px\" ng-click=\"vm.setChartType(\'line\')\" aria-label=\"Line Chart\"><md-tooltip md-direction=\"top\">\nLine Chart</md-tooltip><md-icon md-font-icon=\"icon-chart-line\"></md-icon></md-button><md-button \nclass=\"stack-button md-button-icon md-raised groupX middle\" ng-click=\"vm.stackToggle()\" aria-label=\"Compare\">\n<md-tooltip md-direction=\"top\">Compare</md-tooltip><md-icon md-font-icon=\"icon-compare\"></md-icon></md-button></div>\n</div><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\" \nstyle=\"min-height: 690px\"><div class=\"h3 p-16\" layout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><div \nclass=\"chart-title\" flex=\"100\" layout=\"row\" layout-align=\"start center\" style=\"height: 36px\"><div id=\"kpi-ctrl\" \nlayout=\"row\">Measurements</div><small ng-if=\"vm.measureTypes.length\"><md-input-container><md-select \nng-model=\"vm.selectedMeasureType\" aria-label=\"Select Measure Type\" ng-change=\"vm.selectMeasureType();\"><md-option \nng-repeat=\"measureType in vm.measureTypes\" ng-value=\"measureType.id\">{{measureType.name}}</md-option></md-select>\n</md-input-container></small><small ng-if=\"vm.units.length\"><md-input-container><md-select ng-model=\"vm.selectedUnit\" \naria-label=\"Select Unit\" ng-change=\"vm.selectUnit();\"><md-option ng-repeat=\"unit in vm.units\" ng-value=\"unit\" \nng-bind-html=\"unit | toTrusted\">{{unit}}</md-option></md-select></md-input-container></small></div><div layout=\"row\">\n<div id=\"zoom-ctrl\" layout=\"row\" layout-align=\"center center\"><md-button class=\"groupX left zoom-m\" \nng-click=\"vm.setZoom(\'15 m\')\">15Min</md-button><md-button class=\"groupX middle zoom-h\" ng-click=\"vm.setZoom(\'1 h\')\">\nHourly</md-button><md-button class=\"active groupX middle zoom-d\" ng-click=\"vm.setZoom(\'1 d\')\">Day</md-button><md-button\n class=\"groupX middle zoom-w\" ng-click=\"vm.setZoom(\'1 w\')\">Week</md-button><md-button class=\"groupX righ zoom-M\" \nng-click=\"vm.setZoom(\'1 M\')\">Month</md-button></div><md-menu><md-button class=\"md-icon-button download-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Download\"><md-icon md-font-icon=\"icon-download\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.saveImage(\'chart-aggregated\')\" \naria-label=\"Download PNG\">Download PNG</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.exportCsv()\" \naria-label=\"Download CSV\">Download CSV</md-button></md-menu-item></md-menu-content></md-menu></div></div><md-divider>\n</md-divider><div layout=\"column\" class=\"\"><div layout=\"row\" class=\"p-16\"><div flex=\"60\"><div layout=\"row\" \nng-if=\"vm.chart.stats.total\"><div layout=\"column\" flex=\"40\"><div class=\"h4 secondary-text\">TOTAL</div><div \nclass=\"md-display-1 light-blue-fg\">{{vm.chart.stats.total}} <small>{{vm.chartUnits[0]}}</small></div></div><div \nlayout=\"column\" flex=\"20\"><div class=\"h4 secondary-text\">AVG</div><div class=\"md-display-1\">{{vm.chart.stats.avg}}\n</div></div><div layout=\"column\" flex=\"20\"><div class=\"h4 secondary-text\">MIN</div><div class=\"md-display-1\">\n{{vm.chart.stats.min}}</div></div><div layout=\"column\" flex=\"20\"><div class=\"h4 secondary-text\">MAX</div><div \nclass=\"md-display-1\">{{vm.chart.stats.max}}</div></div></div></div><div layout=\"row\" class=\"graph-message m-16\" \nflex=\"50\" layout-align=\"end center\"><p>Please select data to display...</p><span \nng-bind-html=\"vm.chartLegend | toTrusted\"></span></div></div><div layout=\"column\" class=\"\" flex><div class=\"m-16\">\n<canvas id=\"chart-aggregated\" class=\"chart chart-bar\" chart-data=\"vm.chart.data\" chart-labels=\"vm.chart.labels\" \nchart-options=\"vm.chart.options\" chart-series=\"vm.chart.series\" chart-click=\"vm.chart.click\" \nchart-hover=\"vm.chart.hover\" chart-colors=\"vm.chart.colors\" chart-dataset-override=\"vm.chart.override\"></canvas></div>\n</div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/explore/explore.html","<div id=\"explore\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"content-wrapper\" \nclass=\"md-primary-bg md-hue-3\"><div class=\"content sidenav\" layout=\"row\"><div hide show-md show-sm show-xs><button \nclass=\"toggle-left-sidenav\" type=\"button\" ng-click=\"vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"Toggle\"><md-icon \nclass=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button></div><div hide show-gt-md>\n<button class=\"toggle-left-sidenav md-accent\" type=\"button\" ng-click=\"vm.lockLeft=!vm.lockLeft\" aria-label=\"Toggle\">\n<md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button></div><md-sidenav \nclass=\"sidenav sidenav-width-300 md-sidenav-left\" md-is-locked-open=\"vm.lockLeft && $mdMedia(\'gt-md\')\" \nmd-component-id=\"left-sidenav\" md-disable-backdrop ms-scroll ms-sidenav-helper><md-toolbar \nclass=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding><div class=\"toolbar\"><div hide \nshow-gt-md><md-icon ng-click=\"vm.changeStatusL(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" \naria-hidden=\"true\" style=\"color: #fff\"></md-icon></div><div hide show-md show-sm show-xs><md-icon \nng-click=\"vm.toggleClose(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\" \nstyle=\"color: #fff\"></md-icon></div></div><div class=\"heading\" style=\"font-weight: 300; padding-top: 10px\">\n{{ \'BREAKDOWN.MONITORED_POINTS\' | translate }}</div></md-toolbar><md-content class=\"content md-background-bg md-hue-1\" \nms-scroll layout-padding><div class=\"md-background-border md-hue-2\" layout=\"row\" style=\"padding: 0\"><div flex><button \nclass=\"jstree-open md-button md-accent md-raised\" type=\"button\" ng-click=\"vm.openTree()\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px; margin-right: 0\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></button> <button \nclass=\"jstree-close md-button md-accent md-raised\" type=\"button\" ng-click=\"vm.closeTree()\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-minus\" aria-hidden=\"true\"></md-icon></button></div><div><button \nclass=\"jstree-reset md-button md-accent md-raised\" type=\"button\" ng-click=\"vm.resetTree()\" aria-label=\"\" \nstyle=\"min-width: 20px; min-height: 20px; line-height: 16px; padding: 6px\"><md-icon class=\"s16\" \nmd-font-icon=\"icon-refresh\" aria-hidden=\"true\"></md-icon></button></div></div><div class=\"search-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input \nclass=\"md-background-bg md-hue-1\" flex ng-model=\"vm.searchtree\" type=\"text\" ng-change=\"vm.applySearch()\" \nplaceholder=\"{{ \'DASHBOARD.SEARCH_TREE\' | translate }}\"></div></div><div layout=\"column\" \nstyle=\"padding: 0; padding-top: 16px\"><div class=\"tree\" js-tree=\"vm.treeConfig\" ng-model=\"vm.treeData\" \ntree=\"vm.treeInstance\" tree-events-obj=\"vm.treeEvents\" style=\"padding: 4px\" ng-if=\"vm.showTree\"></div></div>\n</md-content></md-sidenav><div layout=\"column\" class=\"page-content\" ms-scroll flex><div \nclass=\"top-toolbar md-background-bg md-hue-1\" layout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"daterange-wrapper md-background-border md-hue-1\"><div \nclass=\"daterange\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-calendar\" class=\"icon\" \naria-hidden=\"true\"></md-icon><input flex date-range-picker id=\"daterange\" min=\"\'2017-01-01\'\" name=\"daterange\" \nclass=\"form-control date-picker md-background-bg md-hue-1\" type=\"text\" ng-model=\"vm.date\" options=\"vm.dateOptions\">\n</div></div></div></div><div layout=\"column\" flex><div><div layout=\"row\" flex><div class=\"h1\" \nstyle=\"font-weight: 300; padding: 16px 26px\" flex translate=\"EXPLORE.TITLE\">Explore</div><div \nstyle=\"padding: 8px 26px\"><md-menu><md-button class=\"md-button md-raised md-accent\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"Download\" style=\"min-width: 36px; border-radius: 4px\"><md-icon class=\"s16\" md-font-icon=\"icon-download\">\n</md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg md-hue-1\"><md-menu-item><md-button \nng-click=\"vm.saveImage(\'dgraph\')\" aria-label=\"Download PNG\" translate=\"BREAKDOWN.DOWNLOAD_PNG\" \ntranslate-attr-aria-label=\"BREAKDOWN.DOWNLOAD_PNG\">Download PNG</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.exportCSV()\" aria-label=\"Download CSV\" disabled=\"disabled\" ng-disabled=\"!vm.chart.data.length\" \ntranslate=\"BREAKDOWN.DOWNLOAD_CSV\" translate-attr-aria-label=\"BREAKDOWN.DOWNLOAD_CSV\">Download CSV</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" \nstyle=\"padding-top: 0; max-height: 730px\"><ms-widget-front class=\"md-background-bg md-hue-1\" \nstyle=\"border-radius: 4px\"><div class=\"h3 p-16 md-primary-bg md-hue-2\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start center\"><div class=\"status\" flex style=\"font-size: 13px\"><span class=\"msg-spinner static\"></span>\n &nbsp; <span translate=\"EXPLORE.SELECT_DATA\">Please select a monitored point...</span></div></div><md-divider>\n</md-divider><div id=\"dgraph\" layout=\"column\" class=\"\" flex style=\"padding: 48px 24px\"><ng-dygraphs \nng-if=\"vm.chart.data.length && vm.selectedTab == \'chart\'\" data=\"vm.chart.data\" options=\"vm.chart.options\">\n</ng-dygraphs></div></ms-widget-front></ms-widget></div></div></div></div></div>");
$templateCache.put("app/main/graphs/graphs.html","<div id=\"graphs\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"header-container\" \nclass=\"md-primary-bg md-hue-1\" layout=\"column\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"title\">Raw Data</div></div></div><div id=\"content-wrapper\" class=\"md-primary-bg md-hue-3\"><div \nclass=\"content sidenav\" layout=\"row\"><div hide show-md show-sm show-xs><button \nclass=\"toggle-left-sidenav md-background-bg md-hue-1\" type=\"button\" ng-click=\"vm.toggleSidenav(\'left-sidenav\')\" \naria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button>\n</div><div hide show-gt-md><button class=\"toggle-left-sidenav\" type=\"button\" ng-click=\"vm.lockLeft=!vm.lockLeft\" \naria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button>\n</div><md-sidenav class=\"sidenav sidenav-width-300 md-sidenav-left\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"left-sidenav\" md-disable-backdrop ms-scroll ms-sidenav-helper><md-toolbar \nclass=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding><div class=\"toolbar\"><div hide \nshow-gt-md><md-icon ng-click=\"vm.changeStatusL(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" \naria-hidden=\"true\"></md-icon></div><div hide show-md show-sm show-xs><md-icon \nng-click=\"vm.toggleClose(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\">\n</md-icon></div></div><div class=\"heading\">Monitored points</div></md-toolbar><md-content \nclass=\"content md-background-bg md-hue-1\" ms-scroll layout-padding><div \nclass=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input class=\"md-background-bg md-hue-1\" flex \nng-model=\"vm.searchtree\" type=\"text\" ng-change=\"vm.applySearch()\" placeholder=\"Search Tree\"></div><md-button \nclass=\"refresh-button md-icon-button\" ng-click=\"vm.refreshTree()\" aria-label=\"Refresh Tree\"><md-tooltip \nmd-direction=\"top\">Refresh Tree</md-tooltip><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button></div><div \nlayout=\"row\"><div class=\"tree\" js-tree=\"vm.treeConfig\" ng-model=\"vm.treeData\" tree=\"vm.treeInstance\" \ntree-events-obj=\"vm.treeEvents\"></div></div></md-content></md-sidenav><div class=\"page-content\" ms-scroll flex><div \nclass=\"content-card\" ms-scroll><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"md-background-bg md-hue-1\" style=\"min-height: 690px\"><div class=\"h3 p-16 md-primary-bg md-hue-2\" layout=\"row\" \nlayout-align=\"start end\"><div flex=\"95\">Raw Data</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-download\"></md-icon></md-button><md-menu-content\n width=\"3\" class=\"md-background-bg md-hue-1\"><md-menu-item><md-button ng-click=\"vm.saveImage(\'chart-details\')\" \naria-label=\"Download PNG\">Download PNG</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.exportCsv()\" \naria-label=\"Download CSV\">Download CSV</md-button></md-menu-item></md-menu-content></md-menu></div><md-divider>\n</md-divider><div class=\"graph-message m-16\"><p>Please select data to display...</p></div><div class=\"mt-16 mb-16\">\n<c3chart id=\"chart-details\" bindto-id=\"details\" subchart-on-brush-function=\"vm.onbrush\" \non-zoom-end-function=\"vm.onbrush\" callback-function=\"vm.chartCallBack\" chart-data=\"vm.details.data\" \nchart-columns=\"vm.details.columns\" chart-x=\"vm.details.x\" show-subchart=\"true\" enable-zoom=\"true\" ng-if=\"vm.showgraph\">\n<chart-size chart-height=\"600\"></chart-size><chart-points pointradius=\"5\"></chart-points><chart-grid show-x=\"true\" \nshow-y=\"true\"></chart-grid><chart-axis><chart-axis-x axis-id=\"x\" axis-type=\"timeseries\" \naxis-x-format=\"%Y-%m-%d %H:%M:%S\"><chart-axis-x-tick tick-rotate=\"10\" tick-format-function=\"vm.tickformat\">\n</chart-axis-x-tick></chart-axis-x><chart-axis-y axis-id=\"y\" axis-position=\"outer-bottom\"></chart-axis-y></chart-axis>\n</c3chart></div></ms-widget-front></ms-widget></div></div><md-sidenav \nclass=\"sidenav sidenav-width-300 md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" \nmd-component-id=\"right-sidenav\" md-disable-backdrop ms-scroll ms-sidenav-helper><md-toolbar \nclass=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding><div class=\"heading\">\nConfiguration</div><div class=\"toolbar\"><md-icon ng-click=\"vm.toggleSidenav(\'right-sidenav\')\" class=\"s16 hide-gt-sm\" \nmd-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></div></md-toolbar><md-content class=\"content\" \nms-scroll layout-padding><div layout=\"row\"><div layout=\"column\" flex=\"10\"></div><div layout=\"column\" flex=\"80\">\n<md-input-container class=\"md-icon-float md-block\"><label>Select Graph Type</label><md-icon \nmd-font-icon=\"icon-chart-bar\" class=\"name\"></md-icon><md-select ng-model=\"vm.graphType\" ng-change=\"vm.vizualizeData()\">\n<md-option ng-value=\"graphType.type\" ng-repeat=\"graphType in  vm.graphTypes\">{{graphType.name}}</md-option></md-select>\n</md-input-container></div></div><section layout=\"row\" layout-align=\"center center\"><md-button class=\"groupX left\" \nng-click=\"vm.changeDate(\'today\')\">Today</md-button><md-button class=\"groupX right\" \nng-click=\"vm.changeDate(\'yesterday\')\">Yesterday</md-button></section><section layout=\"row\" \nlayout-align=\"center center\" style=\"margin-bottom: 20px\"><md-button class=\"groupX left\" \nng-click=\"vm.changeDate(\'year\')\">Year</md-button><md-button class=\"groupX middle\" ng-click=\"vm.changeDate(\'month\')\">\nMonth</md-button><md-button class=\"groupX right\" ng-click=\"vm.changeDate(\'week\')\">Week</md-button></section><div><div \nlayout=\"row\" layout-align=\"center center\"><div layout=\"column\"><label>Date from:</label><md-datepicker \nng-model=\"vm.date.from\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div></div><div \nlayout=\"row\" layout-align=\"center center\"><div layout=\"column\"><label>Date to:</label><md-datepicker \nng-model=\"vm.date.to\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div></div><div \nlayout=\"row\" layout-align=\"center center\"><div layout=\"column\" flex=\"100\" flex-gt-xs=\"80\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.vizualizeData()\">Apply</md-button></div></div>\n</div></md-content></md-sidenav></div></div></div><script src=\"app/html2canvas.js\"></script><script \ntype=\"text/ng-template\" id=\"custom_template.html\">\n<div class=\"ui-notification\">\r\n		<h3 ng-show=\"title\" ng-bind-html=\"title\"></h3>\r\n		<div class=\"message\" ng-bind-html=\"message\"></div>\r\n	</div>\n</script>");
$templateCache.put("app/main/graphs/main-sidenav.html","");
$templateCache.put("app/main/landing/landing.html","<div id=\"landing\" layout=\"column\" flex><input type=\"checkbox\" class=\"toggle-nav\" id=\"toggle-nav\"><div \nclass=\"mobile-bar\" layout=\"row\" layout-align=\"space-between center\"><div><img \nsrc=\"assets/logos/SmartEverything_small.png\"></div><div><label for=\"toggle-nav\"></label></div></div><div \nclass=\"header body_container\" layout=\"row\" layout-align=\"space-between center\" layout-sm-padding><div id=\"smevlogo\">\n<img src=\"assets/logos/SmartEverything_small.png\" hide-xs>&nbsp;</div><nav><ul><li><a \nng-class=\"{active : activeMenu === \'home\'}\" ng-click=\"vm.SmoothScroll(\'home\')\"><span translate=\"LANDING.HOME\">Home\n</span></a></li><li><a ng-class=\"{active : activeMenu === \'characteristics\'}\" \nng-click=\"vm.SmoothScroll(\'characteristics\')\"><span translate=\"LANDING.CHARACTERISTICS\">Characteristics</span></a></li>\n<li><a ng-class=\"{active : activeMenu === \'solutions\'}\" ng-click=\"vm.SmoothScroll(\'solutions\')\"><span \ntranslate=\"LANDING.SOLUTIONS\">Solutions</span></a></li><li><a ng-class=\"{active : activeMenu === \'about\'}\" \nng-click=\"vm.SmoothScroll(\'about\')\"><span translate=\"LANDING.ABOUT\">About</span></a></li><li><a \nng-class=\"{active : activeMenu === \'contact\'}\" ng-click=\"vm.SmoothScroll(\'contact\')\"><span translate=\"LANDING.CONTACT\">\nContact</span></a></li><li><a id=\"loginBtn\" ng-click=\"vm.openShowLoginDialogue()\">LOGIN</a></li><li class=\"langBtns\"><a\n ng-click=\"vm.setlang(\'en\')\" ng-class=\"{active : activeLang === \'en\'}\">en</a><span class=\"seperator\">|</span><a \nng-click=\"vm.setlang(\'el\')\" ng-class=\"{active : activeLang === \'ελ\'}\">ελ</a></li></ul></nav></div><div \nid=\"content-wrapper\" layout=\"column\" flex><div id=\"home\"></div><div id=\"main_container\"><div id=\"imgcontainer\"><div \nclass=\"grdimg\"><img width=\"100%\" src=\"assets/images/backgrounds/header_IoT.png\"></div></div><div id=\"holistic\" \nlayout=\"column\" layout-align=\"center center\" class=\"max_cont\" layout-padding><div class=\"title\"><span \ntranslate=\"LANDING.HOL_IOT_SOL\">Holistic IoT Solution</span></div><div class=\"smdescr\"></div></div><div id=\"istogr\" \nlayout=\"row\"><div layout=\"column\" id=\"istogramma\" layout-align=\"start center\"><div><img \nsrc=\"assets/images/logos/smarteverything_white1.png\"></div><div class=\"istdescr\" layout-padding><span \ntranslate=\"LANDING.DESCR.ISTOGR1\">\nSmarteverything is a complete end-to-end platform-as-a-service solution for the IoT world. The smarteverything ecosystem provides turnkey IoT solutions that include hardware, software and networking frameworks for a variety of verticals including energy, lighting, agriculture, parking, health, environmental and water management.\n</span><br><br><span translate=\"LANDING.DESCR.ISTOGR2\">\nWe leverage the power of the IoT and Analytics to create engagement and business value for our customers.</span></div>\n</div><div id=\"istcontainer\" layout=\"column\"><img src=\"assets/images/backgrounds/istogramma.png\"></div></div><div \nid=\"characteristics\"></div><p class=\"title\" \nstyle=\"color:#971881; background: #f2f2f2; margin: 0; padding: 30px 0 30px 0;text-align: center\"><span \ntranslate=\"LANDING.PAAS_CHARS\">PaaS Features and Characteristics</span></p><div id=\"itmcontainer\" layout=\"row\"><div \nid=\"item\" layout=\"column\" layout-align=\"start\"><div class=\"itmtop\" layout=\"column\" layout-align=\"start center\"><div>\n<img src=\"assets/icons/icon1.png\"></div><div class=\"itmtitle\"><span translate=\"LANDING.ITM_1\">\nDynamic Dashboards & Widgets</span></div></div><div class=\"itmbtm\" layout=\"column\"><ul><li><span \ntranslate=\"LANDING.ITM_1_LST_1\">Drag and drop style widgets</span></li><li><span translate=\"LANDING.ITM_1_LST_2\">\nUser adjustable graphical widgets</span></li><li><span translate=\"LANDING.ITM_1_LST_3\">\nCustomizable multi-product dashboard templates</span></li></ul></div></div><div id=\"item\" layout=\"column\" \nlayout-align=\"start\"><div class=\"itmtop\" layout=\"column\" layout-align=\"start center\"><div><img \nsrc=\"assets/icons/icon2.png\"></div><div class=\"itmtitle\"><span translate=\"LANDING.ITM_2\">Multi Layer User Support\n</span></div></div><div class=\"itmbtm\" layout=\"column\"><ul><li><span translate=\"LANDING.ITM_2_LST_1\">\nNetwork determined user policies</span></li><li><span translate=\"LANDING.ITM_2_LST_2\">\nSimplification of users experience</span></li><li><span translate=\"LANDING.ITM_2_LST_3\">\nIntelligent administration of user groups</span></li></ul></div></div><div id=\"item\" layout=\"column\" \nlayout-align=\"start\"><div class=\"itmtop\" layout=\"column\" layout-align=\"start center\"><div><img \nsrc=\"assets/icons/icon3.png\"></div><div class=\"itmtitle\"><span translate=\"LANDING.ITM_3\">Device & Protocol Agnostic\n</span></div></div><div class=\"itmbtm\" layout=\"column\"><ul><li><span translate=\"LANDING.ITM_3_LST_1\">\nNeutrality in the architecture decision making</span></li><li><span translate=\"LANDING.ITM_3_LST_2\">\nAny physical device, any protocol stack</span></li><li><span translate=\"LANDING.ITM_3_LST_3\">\nConnectivity between disparate could-based systems</span></li></ul></div></div><div id=\"item\" layout=\"column\" \nlayout-align=\"start\"><div class=\"itmtop\" layout=\"column\" layout-align=\"start center\"><div><img \nsrc=\"assets/icons/icon4.png\"></div><div class=\"itmtitle\"><span translate=\"LANDING.ITM_4\">\nPrediction, Forecasting & Trend Analytics</span></div></div><div class=\"itmbtm\" layout=\"column\"><ul><li><span \ntranslate=\"LANDING.ITM_4_LST_1\">Awareness of unknown future events</span></li><li><span \ntranslate=\"LANDING.ITM_4_LST_2\">Improved operations</span></li><li><span translate=\"LANDING.ITM_4_LST_3\">\nAnalyses of significant future probabilities</span></li></ul></div></div><div id=\"item\" layout=\"column\" \nlayout-align=\"start\"><div class=\"itmtop\" layout=\"column\" layout-align=\"start center\"><div><img \nsrc=\"assets/icons/icon5.png\"></div><div class=\"itmtitle\"><span translate=\"LANDING.ITM_5\">Third-Party Integration</span>\n</div></div><div class=\"itmbtm\" layout=\"column\"><ul><li><span translate=\"LANDING.ITM_5_LST_1\">Enhased data integrity\n</span></li><li><span translate=\"LANDING.ITM_5_LST_2\">Secure data exchange</span></li><li><span \ntranslate=\"LANDING.ITM_5_LST_3\">Infrastructure decision flexibility</span></li></ul></div></div><div id=\"item\" \nlayout=\"column\" layout-align=\"start\"><div class=\"itmtop\" layout=\"column\" layout-align=\"start center\"><div><img \nsrc=\"assets/icons/icon6.png\"></div><div class=\"itmtitle\"><span translate=\"LANDING.ITM_6\">Intelligent Rules Engine\n</span></div></div><div class=\"itmbtm\" layout=\"column\"><ul><li><span translate=\"LANDING.ITM_6_LST_1\">Easy rules setup\n</span></li><li><span translate=\"LANDING.ITM_6_LST_2\">Turning requirements into rules</span></li><li><span \ntranslate=\"LANDING.ITM_6_LST_3\">Definition of complex decision-making logic</span></li></ul></div></div><div id=\"item\" \nlayout=\"column\" layout-align=\"start\"><div class=\"itmtop\" layout=\"column\" layout-align=\"start center\"><div><img \nsrc=\"assets/icons/icon7.png\"></div><div class=\"itmtitle\"><span translate=\"LANDING.ITM_7\">Flexible Hosting Solutions\n</span></div></div><div class=\"itmbtm\" layout=\"column\"><ul><li><span translate=\"LANDING.ITM_7_LST_1\">\nWeb hosting according to bussiness needs</span></li><li><span translate=\"LANDING.ITM_7_LST_2\">\nScalabitity and efficiency of solutions</span></li><li><span translate=\"LANDING.ITM_7_LST_3\">\nEasily achieved desired performance</span></li></ul></div></div><div id=\"item\" layout=\"column\" layout-align=\"start\">\n<div class=\"itmtop\" layout=\"column\" layout-align=\"start center\"><div><img src=\"assets/icons/icon8.png\"></div><div \nclass=\"itmtitle\"><span translate=\"LANDING.ITM_8\">Increased Security</span></div></div><div class=\"itmbtm\" \nlayout=\"column\"><ul><li><span translate=\"LANDING.ITM_8_LST_1\">Application identity protection</span></li><li><span \ntranslate=\"LANDING.ITM_8_LST_2\">Data privacy management</span></li><li><span translate=\"LANDING.ITM_8_LST_3\">\nMulti-layer data encryption</span></li></ul></div></div></div><div id=\"democontainer\" layout=\"row\"><div \nclass=\"demodescr\" layout-padding><span translate=\"LANDING.DESCR.DEMO\">\nsmarteverything offers a variety of applications and services adding value to the unlimited interconnected IoT verticals and facilitating integration with other innovative applications\n</span></div><div style=\"margin: auto\"><button class=\"demo-button\" style=\"vertical-align:middle\" \nng-click=\"vm.openShowRequestDialogue($event)\" aria-label=\"REQUEST DEMO\"><span translate=\"LANDING.REQ_DEMO\">REQUEST DEMO\n</span></button></div></div><div id=\"solutions\"></div><p class=\"title\" \nstyle=\"color:#971881; margin: 0; text-align: center; padding-top: 50px\"><span translate=\"LANDING.VERT_IOT_SOL\">\nUnlimited Vertical IoT Solutions</span></p><p class=\"stitle\"><span translate=\"LANDING.VERT_IOT_STITLE\">\nJust tell us what you want to measure and analyze!</span></p><div layout=\"column\" class=\"iotsol\"><img width=\"100%\" \nsrc=\"assets/images/logos/smarteverything.png\"></div><div id=\"about\"></div><p class=\"title\" \nstyle=\"color:#971881; margin: 0; text-align: center; padding-top: 50px\"><span translate=\"LANDING.ABOUT_US\">About Us\n</span></p><p class=\"stitle\" style=\"color:#6b6b6b; margin: auto; max-width: 900px\"><span \ntranslate=\"LANDING.ABOUT_STITLE\">\nWhen the fastest growing and most innovative energy utility in Greece join forces with one of the most prestigious research centers\n</span></p><div id=\"aboutus\"><div class=\"about\"><img class=\"watt_volt\" src=\"assets/images/logos/WattVolt_logo.png\"><div\n class=\"aboutdescr\" layout-padding><span translate=\"LANDING.DESCR.ABOUT_WATT\">\nWATT+VOLT is an innovative private utility offering integrated energy solutions and a range of smart IoT vertical ecosystems to clients from almost any market sector. With innovation lying at its core, the company\'s systematic investment in pioneering technology infrastructure and its research and development of new services, WATT+VOLT offers reliable, robust and scalable solutions to a broad range of private bussiness and end consumers.\n</span></div></div><div class=\"about\"><img class=\"certh\" style=\"margin-bottom: 100px\" src=\"assets/logos/Pragma.png\">\n<div class=\"aboutdescr\" layout-padding><span translate=\"LANDING.DESCR.ABOUT_PRAGMA\">\nPragma.IoT is a spin-off company of CERTH-ITI that aims to be involved in the Low Power Computing and Internet of Things domain. Pragma.IoT specializes in providing end-to-end software solutions and consulting services in the domain of Internet of Things, including, but not limited to, services related to low-power computing, fog networking and computing using embedded intelligence, OEM platform development and design of next generation gateways for IoT ecosystems.\n</span></div></div></div><div id=\"contact\"></div><p class=\"title\" \nstyle=\"color:#971881; background: #f2f2f2; margin: 0; text-align: center; padding-top: 50px\"><span \ntranslate=\"LANDING.CONTACT_TITLE\">Contact</span></p><div style=\"background: #f2f2f2\"><p class=\"stitle\" \nstyle=\"color:#6b6b6b; margin: auto; max-width: 900px\"><span translate=\"LANDING.CONTACT_STITLE\">\nFind out more about smarteverything</span></p></div><div \nstyle=\"background: #f2f2f2; text-align: center; padding-bottom: 60px\"><button class=\"demo-button\" \nstyle=\"vertical-align:middle; width: 150px; height: 40px; background:#f3802d\" \nng-click=\"vm.openShowContactDialogue($event)\" aria-label=\"CONTACT US\"><span translate=\"LANDING.CONTACT_BUT\">CONTACT US\n</span></button></div><div id=\"lanfooter\"><div><span translate=\"LANDING.FOOTER\">Powered by WATT+VOLT and CERTH/ITI\n</span></div></div></div></div></div>");
$templateCache.put("app/main/home/home.html","<div id=\"home\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"header-container\" \nclass=\"md-primary-bg md-hue-1\" layout=\"column\"><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"title\">{{vm.selectedLocation.name}}</div><md-menu id=\"location-menu\" md-offset=\"0 48\" \nng-if=\"vm.locations.length > 1\"><md-button class=\"md-icon-button location-selector white-fg\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Select location\" md-menu-origin md-menu-align-target><md-icon class=\"s16\" \nmd-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\">\n<md-menu-item ng-repeat=\"location in vm.locations\"><md-button ng-click=\"vm.selectLocation(location)\" \naria-label=\"{{location.name}}\"><span>{{location.name}}</span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div><div id=\"content-wrapper\" class=\"md-primary-bg md-hue-3\"><div class=\"content sidenav\" layout=\"row\"><button \nclass=\"toggle-right-sidenav hide-gt-md\" type=\"button\" ng-click=\"vm.toggleSidenav(\'right-sidenav\')\" \naria-label=\"Toggle Right Sidenav\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\">\n</md-icon></button><div class=\"page-content\" ms-scroll flex><md-tabs md-dynamic-height md-selected=\"vm.selectedTab\">\n<md-tab label=\"Overview\"><div class=\"mb-10\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-order=\"2\" flex-order-gt-sm=\"1\"><md-select id=\"range-select\" \nclass=\"pt-30 pb-10 mb-20 simplified font-size-18\" ng-model=\"vm.range[0].selected\" aria-label=\"Select range\" \nng-change=\"vm.selectRange(0)\"><md-option ng-repeat=\"(key, range) in vm.ranges\" value=\"{{key}}\">{{range}}</md-option>\n</md-select></div><div layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-order=\"1\" flex-order-gt-sm=\"2\" \nclass=\"md-blue-grey-50-bg\" style=\"padding: 10px 20px\" layout-wrap><div layout=\"column\" flex=\"50\" flex-gt-xs=\"40\">\n<label>Date from:</label><md-datepicker ng-model=\"vm.dates[0].from\" md-placeholder=\"Enter date\" \nmd-max-date=\"vm.maxDate\"></md-datepicker></div><div layout=\"column\" flex=\"50\" flex-gt-xs=\"40\"><label>Date to:</label>\n<md-datepicker ng-model=\"vm.dates[0].to\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div>\n<div layout=\"column\" flex=\"100\" flex-gt-xs=\"20\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.selectDates(0);\">Apply</md-button></div></div></div><md-divider></md-divider><div layout=\"column\" \nflex=\"100\" class=\"padding-10\" ng-if=\"vm.data[0].empty\" layout-align=\"space-between center\"><p>No data found...</p>\n</div><div class=\"padding-10\" ng-if=\"!vm.data[0].empty\"><div class=\"md-title\">Overview</div><div layout=\"row\" \nflex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-md=\"50\" flex-order=\"2\" flex-order-gt-md=\"1\"><div \nclass=\"widget-group p-10\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget ng-repeat=\"w in vm.data[0].data\" \nflippable=\"w.flip\" layout=\"column\" flex=\"100\" flex-gt-xs=\"{{w.flex}}\" flex-gt-md=\"{{w.flex}}\" ng-if=\"w.overview\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"more\" ng-if=\"w.flip\"><md-icon \nmd-font-icon=\"icon-rotate-right-variant\"></md-icon></md-button></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"font-size-48 line-height-48\" style=\"color:{{w.color}}\">{{w.data[0].count[0]}}\n<span class=\"unit\" ng-bind-html=\"w.data[0].unit | toTrusted\"></span></div><div \nclass=\"h3 secondary-text font-weight-500\"><i class=\"{{w.icon}} s20\" style=\"color:{{w.color}}\"></i> {{w.label}}</div>\n</div></ms-widget-front><ms-widget-back class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-rotate-left-variant\"></md-icon></md-button></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"font-size-48 line-height-48\" style=\"color:{{w.color}}\">{{w.data[1].count[0]}}\n<span class=\"unit\" ng-bind-html=\"w.data[1].unit | toTrusted\"></span></div><div \nclass=\"h3 secondary-text font-weight-500\"><i class=\"{{w.icon}} s20\" style=\"color:{{w.color}}\"></i> {{w.label}}</div>\n</div></ms-widget-back></ms-widget></div></div><div layout=\"column\" layout-align=\"center center\" flex=\"100\" \nflex-gt-md=\"50\" flex-order=\"1\" flex-order-gt-md=\"2\" ng-if=\"vm.radar[0].show\" style=\"margin: 20px 0\"><canvas id=\"radar\" \nclass=\"chart chart-radar\" chart-series=\"vm.radar[0].series\" chart-colors=\"vm.radar[0].colors\" \nchart-data=\"vm.radar[0].data\" chart-options=\"vm.radar[0].options\" chart-labels=\"vm.radar[0].labels\" width=\"400\" \nheight=\"300\" style=\"max-width: 500px\"></canvas></div></div><div class=\"md-title\">Sites</div><p>\nThe following list presents all available sites. Click on the map or on a site to get an overview.</p><div \nclass=\"widget-group p-10\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><ui-gmap-google-map center=\"vm.googleMapCenter\" zoom=\"vm.googleMapZoom\"><ui-gmap-marker \nng-repeat=\"g in vm.googlmapLocations\" coords=\"g.coords\" idkey=\"g.id\"><ui-gmap-window><div><div \nstyle=\"padding-top: 10px\">{{g.labelContent}}</div></div></ui-gmap-window></ui-gmap-marker></ui-gmap-google-map>\n</ms-widget-front></ms-widget><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"simple-table-container\" ms-responsive-table><md-content class=\"portfolio-list-pane\" flex \nng-include=\"\'app/main/home/views/list/list-view.html\'\" ms-scroll=\"vm.msScrollOptions\"></md-content></div>\n</ms-widget-front></ms-widget></div></div></md-tab><md-tab label=\"Historical Data\" ng-if=\"!vm.data[0].empty\"><div \nclass=\"mb-10\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-order=\"2\" \nflex-order-gt-sm=\"1\"><md-select id=\"range-select\" class=\"pt-30 pb-10 mb-20 simplified font-size-18\" \nng-model=\"vm.range[0].selected\" aria-label=\"Select range\" ng-change=\"vm.selectRange(0)\"><md-option \nng-repeat=\"(key, range) in vm.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div><div layout=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-order=\"1\" flex-order-gt-sm=\"2\" class=\"md-blue-grey-50-bg\" style=\"padding: 10px 20px\" \nlayout-wrap><div layout=\"column\" flex=\"50\" flex-gt-xs=\"40\"><label>Date from:</label><md-datepicker \nng-model=\"vm.dates[0].from\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div><div \nlayout=\"column\" flex=\"50\" flex-gt-xs=\"40\"><label>Date to:</label><md-datepicker ng-model=\"vm.dates[0].to\" \nmd-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"20\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.selectDates(0);\">\nApply</md-button></div></div></div><md-divider></md-divider><div class=\"padding-10\"><div class=\"md-title\">\nAggregated Data</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nng-repeat=\"g in vm.data[0].data\" flippable=\"g.flip\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" ng-if=\"g.historical\">\n<ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\" layout=\"row\" layout-align=\"space-between center\"><div><md-button\n class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"more\" ng-if=\"g.flip\"><md-icon \nmd-font-icon=\"icon-rotate-right-variant\"></md-icon></md-button>{{g.label}} ({{g.data[0].count[0] | number}} <span \nng-bind-html=\"g.data[0].unit | toTrusted\"></span>)</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-download\"></md-icon></md-button><md-menu-content\n width=\"3\"><md-menu-item><md-button ng-click=\"vm.downloadCanvasPng(\'chart-\' + g.id)\" aria-label=\"Download PNG\">\nDownload PNG</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.downloadExcel(g.id)\" \naria-label=\"Download CSV\">Download CSV</md-button></md-menu-item></md-menu-content></md-menu></div><md-divider>\n</md-divider><div class=\"p-16\"><canvas id=\"chart-{{g.id}}\" class=\"chart chart-line\" chart-colors=\"g.colors\" \nchart-data=\"g.rawData[1]\" chart-labels=\"g.rawData[0]\" chart-series=\"g.series\" chart-options=\"vm.line[0].options\">\n</canvas></div></ms-widget-front><ms-widget-back class=\"white-bg\"><div class=\"h3 p-16\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"more\" ng-if=\"g.flip\"><md-icon \nmd-font-icon=\"icon-rotate-left-variant\"></md-icon></md-button>{{g.label}} ({{g.data[1].count[0] | number}} <span \nng-bind-html=\"g.data[1].unit | toTrusted\"></span>)</div><md-divider></md-divider><div class=\"p-16\"><canvas \nclass=\"chart chart-line\" chart-colors=\"g.colors\" chart-data=\"g.rawData[2]\" chart-labels=\"g.rawData[0]\" \nchart-series=\"g.series\" chart-options=\"vm.line[0].options\"></canvas></div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" ng-if=\"vm.comperable_production.show\"><ms-widget-front \nclass=\"white-bg\"><div class=\"h3 p-16\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"more\" \nng-if=\"true\"><md-icon md-font-icon=\"icon-rotate-right-variant\"></md-icon></md-button>PV excess - Electricity (kWh)\n</div><md-divider></md-divider><div class=\"p-16\"><canvas class=\"chart chart-line\" \nchart-colors=\"vm.comperable_production.colors\" chart-data=\"vm.comperable_production.rawData[1]\" \nchart-labels=\"vm.comperable_production.rawData[0]\" chart-series=\"vm.comperable_production.series\" \nchart-options=\"vm.line[0].options\"></canvas></div></ms-widget-front><ms-widget-back class=\"white-bg\"><div \nclass=\"h3 p-16\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"more\" ng-if=\"true\"><md-icon \nmd-font-icon=\"icon-rotate-left-variant\"></md-icon></md-button>PV excess - Electricity (kg CO<sub>2</sub>)</div>\n<md-divider></md-divider><div class=\"p-16\"><canvas class=\"chart chart-line\" \nchart-colors=\"vm.comperable_production.colors\" chart-data=\"vm.comperable_production.rawData[2]\" \nchart-labels=\"vm.comperable_production.rawData[0]\" chart-series=\"vm.comperable_production.series\" \nchart-options=\"vm.line[0].options\"></canvas></div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" ng-if=\"vm.comperable_prediction.show\"><ms-widget-front class=\"white-bg\"><div\n class=\"h3 p-16\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"more\" ng-if=\"true\"><md-icon \nmd-font-icon=\"icon-rotate-right-variant\"></md-icon></md-button>\nPV excess - Electricity production provided to Grid & Prediction (kWh)</div><md-divider></md-divider><div class=\"p-16\">\n<canvas class=\"chart chart-line\" chart-colors=\"vm.comperable_prediction.colors\" \nchart-data=\"vm.comperable_prediction.rawData[1]\" chart-labels=\"vm.comperable_prediction.rawData[0]\" \nchart-series=\"vm.comperable_prediction.series\" chart-options=\"vm.line[0].options\"></canvas></div></ms-widget-front>\n<ms-widget-back class=\"white-bg\"><div class=\"h3 p-16\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"more\" ng-if=\"true\"><md-icon md-font-icon=\"icon-rotate-left-variant\"></md-icon></md-button>\nPV excess - Electricity production provided to Grid & Prediction (kg CO<sub>2</sub>)</div><md-divider></md-divider><div\n class=\"p-16\"><canvas class=\"chart chart-line\" chart-colors=\"vm.comperable_prediction.colors\" \nchart-data=\"vm.comperable_prediction.rawData[2]\" chart-labels=\"vm.comperable_prediction.rawData[0]\" \nchart-series=\"vm.comperable_prediction.series\" chart-options=\"vm.line[0].options\"></canvas></div></ms-widget-back>\n</ms-widget></div></div></md-tab><md-tab label=\"Compare Dates\" md-on-select=\"vm.onTabSelected(1)\" \nng-if=\"!vm.data[0].empty\"><div class=\"mb-10\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-order=\"2\" flex-order-gt-sm=\"1\"><md-select id=\"range-select\" \nclass=\"pt-30 pb-10 mb-20 simplified font-size-18\" ng-model=\"vm.range[0].selected\" aria-label=\"Select range\" \nng-change=\"vm.selectRange(0, 1)\"><md-option ng-repeat=\"(key, range) in vm.ranges\" value=\"{{key}}\">{{range}}</md-option>\n</md-select></div><div layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-order=\"1\" flex-order-gt-sm=\"2\" \nclass=\"md-blue-grey-50-bg\" style=\"padding: 10px 20px\" layout-wrap><div layout=\"column\" flex=\"50\" flex-gt-xs=\"40\">\n<label>Date from:</label><md-datepicker ng-model=\"vm.dates[0].from\" md-placeholder=\"Enter date\" \nmd-max-date=\"vm.maxDate\"></md-datepicker></div><div layout=\"column\" flex=\"50\" flex-gt-xs=\"40\"><label>Date to:</label>\n<md-datepicker ng-model=\"vm.dates[0].to\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div>\n<div layout=\"column\" flex=\"100\" flex-gt-xs=\"20\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.selectDates(0);\">Apply</md-button></div></div></div><md-divider></md-divider><div class=\"vs\">VS</div><div \nclass=\"mb-10 mt-10\" layout=\"row\" flex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-order=\"2\" \nflex-order-gt-sm=\"1\"><md-select id=\"range-select\" class=\"pt-30 pb-10 mb-20 simplified font-size-18\" \nng-model=\"vm.range[1].selected\" aria-label=\"Select range\" ng-change=\"vm.selectRange(1, 1)\"><md-option \nng-repeat=\"(key, range) in vm.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div><div layout=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-order=\"1\" flex-order-gt-sm=\"2\" class=\"md-blue-grey-50-bg\" style=\"padding: 10px 20px\" \nlayout-wrap><div layout=\"column\" flex=\"50\" flex-gt-xs=\"40\"><label>Date from:</label><md-datepicker \nng-model=\"vm.dates[1].from\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div><div \nlayout=\"column\" flex=\"50\" flex-gt-xs=\"40\"><label>Date to:</label><md-datepicker ng-model=\"vm.dates[1].to\" \nmd-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"20\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.selectDates(1);\">\nApply</md-button></div></div></div><md-divider></md-divider><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" ng-if=\"vm.radar[1].show\"><ms-widget-front \nclass=\"white-bg\"><div class=\"h3 p-16\">Summary</div><md-divider></md-divider><div class=\"p-16\"><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" style=\"margin: 20px 0\"><canvas id=\"radar\" class=\"chart chart-radar\" \nchart-series=\"vm.datesPlot.series\" chart-colors=\"vm.datesPlot.colors\" chart-data=\"vm.radar[1].data\" \nchart-options=\"vm.radar[1].options\" chart-labels=\"vm.radar[1].labels\" width=\"400\" height=\"300\" \nstyle=\"max-width: 500px\"></canvas></div></div></ms-widget-front></ms-widget><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget ng-repeat=\"g in vm.data[1].data\" flippable=\"g.flip\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" ng-if=\"g.datesCompare\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"more\" ng-if=\"g.flip\"><md-icon \nmd-font-icon=\"icon-rotate-right-variant\"></md-icon></md-button>{{g.label}} - Difference ({{g.difference[0] | number}} \n<span ng-bind-html=\"g.data[0].unit | toTrusted\"></span>)</div><md-divider></md-divider><div class=\"p-16\"><canvas \nclass=\"chart chart-line\" chart-series=\"vm.datesPlot.series\" chart-colors=\"vm.datesPlot.colors\" \nchart-data=\"g.rawData[1]\" chart-labels=\"g.rawData[0]\" chart-options=\"vm.line[1].options\"></canvas></div>\n</ms-widget-front><ms-widget-back class=\"white-bg\"><div class=\"h3 p-16\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"more\" ng-if=\"g.flip\"><md-icon md-font-icon=\"icon-rotate-left-variant\"></md-icon>\n</md-button>{{g.label}} - Difference ({{g.difference[1] | number}} <span ng-bind-html=\"g.data[1].unit | toTrusted\">\n</span>)</div><md-divider></md-divider><div class=\"p-16\"><canvas class=\"chart chart-line\" \nchart-series=\"vm.datesPlot.series\" chart-colors=\"vm.datesPlot.colors\" chart-data=\"g.rawData[2]\" \nchart-labels=\"g.rawData[0]\" chart-options=\"vm.line[1].options\"></canvas></div></ms-widget-back></ms-widget></div></div>\n</md-tab><md-tab label=\"Compare Buildings\" md-on-select=\"vm.onTabSelected(2)\" ng-if=\"vm.locations.length > 1\" \nng-if=\"!vm.data.empty && vm.showCompareBuildings\"><div class=\"mb-10\" layout=\"row\" flex=\"100\" layout-wrap><div \nlayout=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-order=\"2\" flex-order-gt-sm=\"1\"><div layout=\"column\" flex=\"30\"><md-select \nid=\"range-select\" class=\"pt-30 pb-10 mb-20 simplified font-size-18\" ng-model=\"vm.range[0].selected\" \naria-label=\"Select range\" ng-change=\"vm.selectRange(0)\"><md-option ng-repeat=\"(key, range) in vm.ranges\" \nvalue=\"{{key}}\">{{range}}</md-option></md-select></div><div class=\"buildings\" layout=\"column\" flex=\"70\"><div \nclass=\"pb-10 mb-10\" style=\"padding-top: 32px\"><md-icon md-font-icon=\"icon-home\"></md-icon><span \nstyle=\"width: 85%; display: inline-block\">{{vm.selectedLocation.name}}</span></div></div></div><div layout=\"row\" \nflex=\"100\" flex-gt-sm=\"50\" flex-order=\"1\" flex-order-gt-sm=\"2\" class=\"md-blue-grey-50-bg\" style=\"padding: 10px 20px\" \nlayout-wrap><div layout=\"column\" flex=\"50\" flex-gt-xs=\"40\"><label>Date from:</label><md-datepicker \nng-model=\"vm.dates[0].from\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div><div \nlayout=\"column\" flex=\"50\" flex-gt-xs=\"40\"><label>Date to:</label><md-datepicker ng-model=\"vm.dates[0].to\" \nmd-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div><div layout=\"column\" flex=\"100\" \nflex-gt-xs=\"20\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.selectDates(0);\">\nApply</md-button></div></div></div><md-divider></md-divider><div class=\"vs\">VS</div><div class=\"mb-10 mt-10\" \nlayout=\"row\" flex=\"100\" layout-wrap><div layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-order=\"2\" flex-order-gt-sm=\"1\">\n<div layout=\"column\" flex=\"30\"><md-select id=\"range-select\" class=\"pt-30 pb-10 mb-20 simplified font-size-18\" \nng-model=\"vm.range[2].selected\" aria-label=\"Select range\" ng-change=\"vm.selectRange(2)\"><md-option \nng-repeat=\"(key, range) in vm.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div><div class=\"buildings\" \nlayout=\"column\" flex=\"70\"><div style=\"padding-top: 9px\"><md-icon md-font-icon=\"icon-home\"></md-icon><md-select \nng-model=\"vm.compareLocations\" multiple=\"\" style=\"display: inline-block; width: 85%\" aria-label=\"Select buildings\">\n<md-select-header value=\"Select All\" ng-click=\"vm.selectAllLocations()\">{{vm.selectAll}}</md-select-header><md-option \nng-value=\"location.id\" ng-repeat=\"location in vm.locations\" \nng-if=\"location.id != vm.selectedLocation.id && location.id!=\'all\'\">{{location.name}}</md-option></md-select></div>\n</div></div><div layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" flex-order=\"1\" flex-order-gt-sm=\"2\" \nclass=\"md-blue-grey-50-bg\" style=\"padding: 10px 20px\" layout-wrap><div layout=\"column\" flex=\"50\" flex-gt-xs=\"40\">\n<label>Date from:</label><md-datepicker ng-model=\"vm.dates[2].from\" md-placeholder=\"Enter date\" \nmd-max-date=\"vm.maxDate\"></md-datepicker></div><div layout=\"column\" flex=\"50\" flex-gt-xs=\"40\"><label>Date to:</label>\n<md-datepicker ng-model=\"vm.dates[2].to\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div>\n<div layout=\"column\" flex=\"100\" flex-gt-xs=\"20\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.selectDates(2);\">Apply</md-button></div></div></div><md-divider></md-divider><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" ng-if=\"vm.radar[2].show\">\n<ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">Summary</div><md-divider></md-divider><div class=\"p-16\"><div \nlayout=\"column\" layout-align=\"center center\" flex=\"100\" style=\"margin: 20px 0\"><canvas id=\"radar\" \nclass=\"chart chart-radar\" chart-series=\"vm.buildingsPlot.series\" chart-colors=\"vm.buildingsPlot.colors\" \nchart-data=\"vm.radar[2].data\" chart-options=\"vm.radar[2].options\" chart-labels=\"vm.radar[2].labels\" width=\"400\" \nheight=\"300\" style=\"max-width: 500px\"></canvas></div></div></ms-widget-front></ms-widget><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget ng-repeat=\"g in vm.data[2].data\" flippable=\"g.flip\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" ng-if=\"g.buildingsCompare\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\"><md-button\n class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"more\" ng-if=\"g.flip\"><md-icon \nmd-font-icon=\"icon-rotate-right-variant\"></md-icon></md-button>{{g.label}} (<span \nng-bind-html=\"g.data[0].unit | toTrusted\"></span>)</div><md-divider></md-divider><div class=\"p-16\"><canvas \nclass=\"chart chart-line\" chart-colors=\"vm.buildingsPlot.colors\" chart-data=\"g.rawData[1]\" chart-labels=\"g.rawData[0]\" \nchart-series=\"g.series\" chart-options=\"vm.line[2].options\"></canvas></div></ms-widget-front><ms-widget-back \nclass=\"white-bg\"><div class=\"h3 p-16\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"more\" \nng-if=\"g.flip\"><md-icon md-font-icon=\"icon-rotate-left-variant\"></md-icon></md-button>{{g.label}} (<span \nng-bind-html=\"g.data[1].unit | toTrusted\"></span>)</div><md-divider></md-divider><div class=\"p-16\"><canvas \nclass=\"chart chart-line\" chart-colors=\"vm.buildingsPlot.colors\" chart-data=\"g.rawData[2]\" chart-labels=\"g.rawData[0]\" \nchart-series=\"g.series\" chart-options=\"vm.line[2].options\"></canvas></div></ms-widget-back></ms-widget></div></div>\n</md-tab><md-tab></md-tab></md-tabs></div><md-sidenav class=\"sidenav sidenav-width-300 md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"right-sidenav\" md-disable-backdrop ms-scroll ms-sidenav-helper>\n<md-toolbar class=\"md-primary-bg md-hue-2 hide-gt-md\" layout=\"row\" layout-align=\"space-between\" layout-padding><div \nclass=\"heading\"></div><div class=\"toolbar\"><md-icon ng-click=\"vm.toggleSidenav(\'right-sidenav\')\" \nclass=\"s16 hide-gt-md\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></div></md-toolbar><md-content\n class=\"\" ms-scroll layout-padding><div class=\"widget-group\"><ms-widget flippable=\"false\" class=\"sidenav-widget\">\n<ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div>\n</div><div class=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\"><div class=\"h1 secondary-text\"><span>\n{{vm.nowWidget.now.month}}</span></div><div class=\"font-size-72 line-height-88 secondary-text font-weight-400\">\n{{vm.nowWidget.now.day}}</div><div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div>\n<md-divider></md-divider></ms-widget-front></ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\" \nng-if=\"vm.selectedLocation.id != \'all\'\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4\"><md-icon md-font-icon=\"icon-map-marker\" class=\"icon mr-8\">\n</md-icon>{{vm.weather[vm.selectedLocation.id].name}}</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target aria-label=\"Options\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.refreshWeather()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"p-16 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"{{vm.weather[vm.selectedLocation.id].weather[0].icon}}\" class=\"icon s40 mr-16\"></md-icon><span \nclass=\"md-display-2 font-weight-300 secondary-text ml-15\">{{vm.weather[vm.selectedLocation.id].main.temp | number:0}} \n</span><span class=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span \nclass=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.tempUnit}}</span></div></div><div \nclass=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weather[vm.selectedLocation.id].wind.speed | number:0}} </span><span class=\"secondary-text ml-5\">\n{{vm.weatherWidget.speedUnit}}</span></div><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{vm.weather[vm.selectedLocation.id].wind.icon}}\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weather[vm.selectedLocation.id].wind.dir}}</span></div><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-cloud\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weather[vm.selectedLocation.id].weather[0].clouds.all}}%</span></div></div><div class=\"pv-16\"><div \nclass=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"day in vm.weather[vm.selectedLocation.id].forecast\"><span class=\"h4\">{{day.name}}</span><div layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"icon mr-16\" md-font-icon=\"{{day.icon}}\"></md-icon><span class=\"h2\">\n{{day.temp | number:0}}</span> <span class=\"h2 font-weight-300 secondary-text text-super\">&deg;</span> <span \nclass=\"h2 font-weight-300 secondary-text\">{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider>\n</md-divider></ms-widget-front></ms-widget></div></md-content></md-sidenav></div></div></div>");
$templateCache.put("app/main/mv/mv.html","<div id=\"mv\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"content-wrapper\" \nclass=\"md-primary-bg md-hue-3\"><div class=\"content sidenav\" layout=\"row\"><div hide show-md show-sm show-xs><button \nclass=\"toggle-left-sidenav md-background-bg md-hue-1\" type=\"button\" ng-click=\"vm.toggleSidenav(\'left-sidenav\')\" \naria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button>\n</div><div hide show-gt-md><button class=\"toggle-left-sidenav\" type=\"button\" ng-click=\"vm.lockLeft=!vm.lockLeft\" \naria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button>\n</div><md-sidenav class=\"sidenav sidenav-width-300 md-sidenav-left\" \nmd-is-locked-open=\"vm.lockLeft && $mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" md-disable-backdrop ms-scroll \nms-sidenav-helper><md-toolbar class=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding>\n<div class=\"toolbar\"><div hide show-gt-md><md-icon ng-click=\"vm.changeStatusL(\'left-sidenav\')\" class=\"s16 sidhov\" \nmd-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\"></md-icon></div><div hide show-md show-sm show-xs><md-icon \nng-click=\"vm.toggleClose(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\">\n</md-icon></div></div><div class=\"heading\">{{ \'MV.MONITORED_POINTS\' | translate }}</div></md-toolbar><md-content \nclass=\"content md-background-bg md-hue-1\" ms-scroll layout-padding><div \nclass=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input class=\"md-background-bg md-hue-1\" flex \nng-model=\"vm.searchtree\" type=\"text\" ng-change=\"vm.applySearch()\" placeholder=\"{{ \'MV.SEARCH_TREE\' | translate }}\">\n</div></div><div layout=\"row\"><div class=\"tree\" js-tree=\"vm.treeConfig\" ng-model=\"vm.treeData\" tree=\"vm.treeInstance\" \ntree-events-obj=\"vm.treeEvents\"></div></div><md-content></md-content></md-content></md-sidenav><div \nclass=\"page-content\" ms-scroll flex><div class=\"top-toolbar md-background-bg md-hue-1\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-input-container><label \ntranslate=\"MV.ORDER_BY\">Order by:</label><md-select ng-model=\"vm.selectedOrder\"><md-option ng-value=\"opt\" \nng-repeat=\"opt in vm.ordOpts\">{{ opt }}</md-option></md-select></md-input-container></div><div class=\"button-group\" \nlayout=\"row\" layout-align=\"end center\" flex><md-button class=\"md-button-icon md-raised groupX\" \nstyle=\"margin-right:15px\" ng-click=\"vm.openNewPlanDialog($event)\" aria-label=\"Create New Plan\" translate \ntranslate-attr-aria-label=\"MV.ADD_PLAN\"><md-tooltip md-direction=\"left\"><span translate=\"MV.ADD_PLAN\">Create New Plan\n</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-button-icon md-raised groupX left viewType-button list-button active\" ng-click=\"vm.setViewType(\'list\')\" \naria-label=\"List View\" translate translate-attr-aria-label=\"MV.LIST_VIEW\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"MV.LIST_VIEW\">List View</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-list\" aria-hidden=\"true\">\n</md-icon></md-button><md-button class=\"md-button-icon md-raised groupX right viewType-button tiles-button\" \nng-click=\"vm.setViewType(\'tiles\')\" aria-label=\"Tiles View\" translate translate-attr-aria-label=\"MV.TILES_VIEW\">\n<md-tooltip md-direction=\"left\"><span translate=\"MV.TILES_VIEW\">Tiles View</span></md-tooltip><md-icon \nmd-font-icon=\"pragma-icon-tiles\" aria-hidden=\"true\"></md-icon></md-button></div></div><div class=\"p-16\" \nng-if=\"vm.planShow == 0\" layout=\"column\" flex><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h1 mb-10\" translate=\"MV.MV_TITLE\">Measurements & Verifications</div><div \nclass=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" placeholder=\"{{ \'MV.SEARCH_PLANS\' | translate}}\"></div></div></div><div ng-if=\"vm.viewType == \'list\'\" \nlayout=\"column\"><md-table-pagination md-limit=\"\" md-limit-options=\"[5, 10, 15]\" md-page=\"\" md-total=\"\" \nmd-on-paginate=\"\" md-page-select></md-table-pagination><div class=\"md-background-bg md-hue-1 md-whiteframe-4dp\">\n<md-table-container><table md-table><thead md-head md-order=\"title\"><tr md-row><th md-column></th><th md-column \nmd-order-by=\"title\"><span translate=\"MV.TITLE\">Title</span></th><th md-column md-order-by=\"type\"><span \ntranslate=\"MV.TYPE\">Type</span></th><th md-column md-order-by=\"date\"><span translate=\"MV.UPDATE_DATE\">Last Update\n</span></th><th md-column><span translate=\"MV.ACTIONS\">Actions</span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"vm.plans.length == 0\"><td md-cell></td><td md-cell colspan=\"4\"><div class=\"p-25\"><h3 \ntranslate=\"MV.MESSAGE.NO_DATA\">No data available in table...</h3><p translate=\"MV.MESSAGE.ADD_PLAN\">\nClick on the \'Create New Plan\' button to add a new plan.</p></div></td></tr><tr md-row ng-if=\"\"><td md-cell></td><td \nmd-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"MV.MESSAGE.NOTHING\">Nothing found...</h3></div></td></tr><tr \nmd-row ng-if=\"vm.plans.length > 0\" ng-repeat=\"plan in vm.plans\"><td md-cell><div class=\"custom-icon-button-wrapper\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.managePlan(plan)\" aria-label=\"Manage Plan\" translate \ntranslate-attr-aria-label=\"MV.MANAGE_PLAN\"><md-tooltip md-direction=\"right\"><span translate=\"MV.MANAGE_PLAN\">\nManage Plan</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-plan\" aria-hidden=\"true\"></md-icon></md-button></div>\n</td><td md-cell>{{plan.title}}<br><small>{{plan.description}}</small></td><td md-cell>{{plan.type}}</td><td md-cell>\n{{plan.date | date:\'dd/MM/yyyy\'}}</td><td md-cell><md-button class=\"md-icon-button\" \nng-click=\"vm.openCopyPlanDialog($event, plan)\" aria-label=\"Copy Plan\" translate \ntranslate-attr-aria-label=\"MV.COPY_PLAN\"><md-tooltip md-direction=\"top\"><span translate=\"MV.COPY_PLAN\">Copy Plan</span>\n</md-tooltip><md-icon md-font-icon=\"icon-content-duplicate\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.managePlan(plan)\" aria-label=\"Manage Plan\" translate \ntranslate-attr-aria-label=\"MV.MANAGE_PLAN\"><md-tooltip md-direction=\"top\"><span translate=\"MV.MANAGE_PLAN\">Manage Plan\n</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.openDeletePlanDialog($event, plan)\" aria-label=\"Delete Plan\" translate \ntranslate-attr-aria-label=\"MV.DELETE_PLAN\"><md-tooltip md-direction=\"top\"><span translate=\"MV.DELETE_PLAN\">Delete Plan\n</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-hidden=\"true\"></md-icon></md-button><md-button \nng-if=\"plan.progress == 100\" class=\"md-icon-button\" aria-label=\"Download Plan\" translate \ntranslate-attr-aria-label=\"MV.DOWNLOAD_PLAN\"><md-tooltip md-direction=\"top\"><span translate=\"MV.DOWNLOAD_PLAN\">\nDownload Plan</span></md-tooltip><md-icon md-font-icon=\"icon-download\" aria-hidden=\"true\"></md-icon></md-button>\n<md-button ng-if=\"plan.progress != 100\" ng-disabled=\"true\" class=\"progress-button md-primary\" \naria-label=\"Plan Progress\" translate translate-attr-aria-label=\"MV.PLAN_PROGRESS\"><span class=\"progress-label\">\n{{plan.progress}}%</span></md-button></td></tr></tbody></table></md-table-container></div></div><div \nng-if=\"vm.viewType == \'tiles\'\" layout=\"column\"><div ng-if=\"vm.viewType == \'tiles\'\" layout=\"row\" layout-wrap><md-card \nflex=\"auto\" ng-if=\"vm.plans.length == 0\" style=\"min-height:100px\"><md-card-content layout=\"column\"><md-card-title-text>\n<span class=\"md-headline\" translate=\"MV.MESSAGE.NO_DATA\">No data available in table...</span></md-card-title-text>\n<md-card-title-text><span class=\"md-subhead\" translate=\"MV.MESSAGE.ADD_PLAN\">\nClick on the \'Create New Plan\' button to add a new plan.</span></md-card-title-text></md-card-content></md-card>\n<md-card flex=\"auto\" ng-if=\"\" style=\"min-height:120px\"><md-card-content><md-card-title-text><span class=\"md-headline\" \ntranslate=\"MV.MESSAGE.NOTHING\">Nothing found...</span></md-card-title-text></md-card-content></md-card><md-card \nng-if=\"vm.plans.length > 0\" ng-repeat=\"plan in vm.plans\" flex=\"auto\"><md-card-actions layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.openCopyPlanDialog($event, plan)\" \naria-label=\"Copy Plan\" translate translate-attr-aria-label=\"MV.COPY_PLAN\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"MV.COPY_PLAN\">Copy Plan</span></md-tooltip><md-icon md-font-icon=\"icon-content-duplicate\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.managePlan(plan)\" \naria-label=\"Manage Plan\" translate translate-attr-aria-label=\"MV.MANAGE_PLAN\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"MV.MANAGE_PLAN\">Manage Plan</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.openDeletePlanDialog($event, plan)\" \naria-label=\"Delete Plan\" translate translate-attr-aria-label=\"MV.DELETE_PLAN\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"MV.DELETE_PLAN\">Delete Plan</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-hidden=\"true\">\n</md-icon></md-button></md-card-actions><md-card-title layout=\"column\"><md-card-title-text><span class=\"md-headline\">\n{{plan.title}}<br><small>{{plan.description}}</small></span></md-card-title-text><md-card-title-text><span \nclass=\"md-subhead\">{{plan.type}}</span> <span class=\"md-subhead\">{{plan.date | date:\'dd/MM/yyyy\'}}</span>\n</md-card-title-text></md-card-title><md-card-actions><div class=\"progress-wrapper\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"plan.progress != 100\"><progress max=\"100\" value=\"{{plan.progress}}\" \nstyle=\"width:100%\"></progress><span class=\"progress-label\">{{plan.progress}}%</span></div><div \nclass=\"download-wrapper\" layout=\"row\" layout-align=\"end center\" ng-if=\"plan.progress == 100\"><md-button \nclass=\"md-icon-button md-mini\" aria-label=\"Download Plan\" translate translate-attr-aria-label=\"MV.DOWNLOAD_PLAN\">\n<md-tooltip md-direction=\"top\"><span translate=\"MV.DOWNLOAD_PLAN\">Download Plan</span></md-tooltip><md-icon \nmd-font-icon=\"icon-download\" aria-hidden=\"true\"></md-icon></md-button></div></md-card-actions></md-card></div></div>\n</div><div class=\"p-16 manage animate-slide-down-hide\" ng-if=\"vm.planShow==1\" layout=\"column\" flex><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><div class=\"p-16 pb-24 md-primary-bg md-hue-2\" layout=\"row\" flex \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.planShow=0\" \naria-label=\"Close Plan Management\" translate translate-attr-aria-label=\"MV.MANAGE.CLOSE\"><md-tooltip \nmd-direction=\"left\"><span translate=\"MV.MANAGE.CLOSE\">Close Plan Management</span></md-tooltip><md-icon \nmd-font-icon=\"icon-chevron-left\" aria-hidden=\"true\"></md-icon></md-button><div class=\"h1\">{{vm.currentPlan.title}}\n</div></div><md-tabs md-dynamic-height md-selected=\"vm.selectedTab\" md-autoselect><md-tab ui-sref=\"app.mv.general\">\n<md-tab-label><span translate=\"MV.MANAGE.TABS.GENERAL\">General</span></md-tab-label><md-tab-body><div \nclass=\"form-content p-24\" flex=\"75\" flex-sm=\"100\"><div class=\"form-title pb-16\" layout=\"column\"><span class=\"h2\" \ntranslate=\"MV.MANAGE.TABS.GENERAL_TITLE\">Plan General Details</span> <span style=\"font-weight:300\" \ntranslate=\"MV.MANAGE.TABS.GENERAL_DESCRIPTION\"></span></div><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-block\"><label><span translate=\"MV.TITLE\">Title</span></label>\n<input type=\"text\" ng-model=\"vm.currentPlan.title\" ng-required=\"true\"></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container \nclass=\"md-block\"><label><span translate=\"MV.TYPE\">Plan Type</span></label><md-select ng-model=\"vm.currentPlan.type\" \nng-required=\"true\"><md-option ng-value=\"ptype\" ng-repeat=\"ptype in vm.protoTypes\">{{ptype}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container class=\"md-block\"><label><span \ntranslate=\"MV.COST\">Cost</span></label><input type=\"text\" ng-model=\"vm.currentPlan.cost\" ng-required=\"true\">\n</md-input-container></div></div><div layout=\"row\"><div class=\"input-block\" flex><label><span \ntranslate=\"MV.FORMS.DESCRIPTION\">Description</span></label><text-angular ng-model=\"vm.currentPlan.description\">\n</text-angular></div></div></div></md-tab-body></md-tab><md-tab ui-sref=\"app.mv.ecm\"><md-tab-label><span \ntranslate=\"MV.MANAGE.TABS.ECM\">ECM</span></md-tab-label><md-tab-body><div class=\"p-24\" layout=\"column\"><div \nlayout=\"column\" class=\"form-title pb-16\"><span class=\"h2\" translate=\"MV.MANAGE.TABS.ECM_TITLE\">\nEnergy Conservation Measure</span> <span style=\"font-weight:300\" translate=\"MV.MANAGE.TABS.ECM_DESCRIPTION\"></span>\n</div><div class=\"pb-16\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-primary md-fab\" \nng-click=\"vm.openNewActionDialog($event)\" aria-label=\"Create New Action\" translate \ntranslate-attr-aria-label=\"MV.CREATE_ACTION\"><md-tooltip md-direction=\"top\"><span translate=\"MV.CREATE_ACTION\">\nCreate New Action</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></md-button>\n<md-button class=\"md-icon-button md-primary md-fab\" ng-click=\"vm.openAddActionDialog($event, vm.actions)\" \naria-label=\"Add Existing Action\" translate translate-attr-aria-label=\"MV.ADD_ACTION\"><md-tooltip md-direction=\"top\">\n<span translate=\"MV.ADD_ACTION\">Add Existing Action</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-link\" \naria-hidden=\"true\"></md-icon></md-button></div><md-table-pagination md-limit=\"\" md-limit-options=\"[5, 10, 15]\" \nmd-page=\"\" md-total=\"\" md-on-paginate=\"\" md-page-select></md-table-pagination><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table md-table><thead md-head \nmd-order=\"title\"><tr md-row><th md-column></th><th md-column md-order-by=\"title\"><span translate=\"MV.TITLE\">Title\n</span></th><th md-column md-order-by=\"reference\"><span translate=\"MV.REFERENCE\">Type</span></th><th md-column \nmd-order-by=\"startdate\"><span translate=\"MV.START_DATE\">Start Date</span></th><th md-column md-order-by=\"enddate\"><span\n translate=\"MV.END_DATE\">End Date</span></th><th md-column><span translate=\"MV.ACTIONS\">Actions</span></th></tr>\n</thead><tbody md-body><tr md-row ng-if=\"vm.currentPlan.actions.length == 0\"><td md-cell></td><td md-cell colspan=\"4\">\n<div class=\"p-25\"><h3 translate=\"MV.MESSAGE.NO_DATA\">No data available in table...</h3><p \ntranslate=\"MV.MESSAGE.ADD_ACTION\">\nClick on the \'Create New Action\' button or the \'Add Existing Action\' to include an action to the plan .</p></div></td>\n</tr><tr md-row ng-if=\"\"><td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"MV.MESSAGE.NOTHING\">\nNothing found...</h3></div></td></tr><tr md-row ng-if=\"vm.currentPlan.actions.length > 0\" \nng-repeat=\"action in vm.currentPlan.actions\"><td md-cell><div class=\"custom-icon-button-wrapper\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.openEditActionDialog($event,action)\" aria-label=\"Edit Action\" translate \ntranslate-attr-aria-label=\"MV.EDIT_ACTION\"><md-tooltip md-direction=\"right\"><span translate=\"MV.EDIT_ACTION\">\nEdit Action</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-action\" aria-hidden=\"true\"></md-icon></md-button>\n</div></td><td md-cell>{{action.title}}<br><small>{{action.description}}</small></td><td md-cell>{{action.reference}}\n</td><td md-cell>{{action.startdate | date:\'dd/MM/yyyy\'}}</td><td md-cell>{{action.enddate | date:\'dd/MM/yyyy\'}}</td>\n<td md-cell><md-button class=\"md-icon-button\" ng-click=\"vm.openCopyActionDialog($event,action)\" \naria-label=\"Copy Action\" translate translate-attr-aria-label=\"MV.COPY_ACTION\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"MV.COPY_ACTION\">Copy Action</span></md-tooltip><md-icon md-font-icon=\"icon-content-duplicate\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.openEditActionDialog($event,action)\" aria-label=\"Edit Action\" translate \ntranslate-attr-aria-label=\"MV.EDIT_ACTION\"><md-tooltip md-direction=\"top\"><span translate=\"MV.EDIT_ACTION\">Edit Action\n</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.openDeleteActionDialog($event,action)\" aria-label=\"Delete Action\" translate \ntranslate-attr-aria-label=\"MV.DELETE_ACTION\"><md-tooltip md-direction=\"top\"><span translate=\"MV.DELETE_ACTION\">\nDelete Action</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-hidden=\"true\"></md-icon></md-button></td>\n</tr></tbody></table></md-table-container></div></div></md-tab-body></md-tab><md-tab ui-sref=\"app.mv.base-period\">\n<md-tab-label><span translate=\"MV.MANAGE.TABS.BASE_PERIOD\">Base Period</span></md-tab-label><md-tab-body><div \nclass=\"form-content p-24\"><div layout=\"column\" class=\"form-title pb-16\"><span class=\"h2\" \ntranslate=\"MV.MANAGE.TABS.BASE_PERIOD_TITLE\">Base Period</span> <span style=\"font-weight:300\" \ntranslate=\"MV.MANAGE.TABS.BASE_PERIOD_DESCRIPTION\"></span></div><div layout=\"column\" layout-gt-sm=\"row\"><div flex><div \nclass=\"p-16\" style=\"min-height:64px\" layout=\"row\" layout-align=\"start start\"><div class=\"input-block pr-16\" \nlayout=\"column\"><label><span translate=\"MV.START_DATE\">Start Date</span></label><md-datepicker \nng-model=\"vm.currentPlan.baseline.startdate\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker>\n</div><div class=\"input-block\" layout=\"column\"><label><span translate=\"MV.END_DATE\">End Date</span></label>\n<md-datepicker ng-model=\"vm.currentPlan.baseline.enddate\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\">\n</md-datepicker></div></div><div class=\"p-16\"><div class=\"input-block\" flex><label><span \ntranslate=\"MV.FORMS.DESCRIPTION\">Description</span></label><text-angular \nng-model=\"vm.currentPlan.baseline.description\"></text-angular></div></div></div><div flex><div class=\"p-16\" \nstyle=\"min-height:64px\" layout=\"row\" layout-align=\"space-between start\"><md-button \nclass=\"md-icon-button md-primary md-fab\" ng-click=\"vm.openAddDataDialog($event, vm.currentPlan.baseline)\" \naria-label=\"Include Action\" translate translate-attr-aria-label=\"MV.INCLUDE_DATA\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"MV.INCLUDE_DATA\">Include Data</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-link\" \naria-hidden=\"true\"></md-icon></md-button><div class=\"input-block\" layout=\"column\"><label><span \ntranslate=\"MV.DATA_PERIOD\">Data Period:</span></label><md-select ng-model=\"vm.currentPlan.baseline.period\" \nng-required=\"true\" style=\"margin:0\" aria-label=\"Data Period\"><md-option ng-value=\"period\" \nng-repeat=\"period in vm.periods\">{{period}}</md-option></md-select></div></div><div class=\"p-16\"><label><span \ntranslate=\"MV.DATA\">Data</span></label><div layout=\"column\" layout-align=\"center center\" class=\"\"><span \nng-if=\"!vm.chart.baseline.data.length\" translate=\"MV.NO_DATA_AVAILIABLE\">No data availiable</span><ng-dygraphs \nng-if=\"vm.chart.baseline.data.length\" data=\"vm.chart.baseline.data\" options=\"vm.chart.baseline.options\" \nlegend=\"vm.chart.baseline.legend\"></ng-dygraphs></div></div></div></div></div></md-tab-body></md-tab><md-tab \nui-sref=\"app.mv.report-period\"><md-tab-label><span translate=\"MV.MANAGE.TABS.REPORT_PERIOD\">Report Period</span>\n</md-tab-label><md-tab-body><div class=\"form-content p-24\"><div layout=\"column\" class=\"form-title pb-16\"><span \nclass=\"h2\" translate=\"MV.MANAGE.TABS.REPORT_PERIOD_TITLE\">Report Period</span> <span style=\"font-weight:300\" \ntranslate=\"MV.MANAGE.TABS.REPORT_PERIOD_DESCRIPTION\"></span></div><div layout=\"column\" layout-gt-sm=\"row\"><div flex>\n<div class=\"p-16\" style=\"min-height:64px\" layout=\"row\" layout-align=\"start start\"><div class=\"input-block pr-16\" \nlayout=\"column\"><label><span translate=\"MV.START_DATE\">Start Date</span></label><md-datepicker \nng-model=\"vm.currentPlan.report.startdate\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div>\n<div class=\"input-block\" layout=\"column\"><label><span translate=\"MV.END_DATE\">End Date</span></label><md-datepicker \nng-model=\"vm.currentPlan.report.enddate\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div>\n</div><div class=\"p-16\"><div class=\"input-block\" flex><label><span translate=\"MV.FORMS.DESCRIPTION\">Description</span>\n</label><text-angular ng-model=\"vm.currentPlan.report.description\"></text-angular></div></div></div><div flex><div \nclass=\"p-16\" style=\"min-height:64px\" layout=\"row\" layout-align=\"space-between start\"><md-button \nclass=\"md-icon-button md-primary md-fab\" ng-click=\"vm.openAddDataDialog($event, vm.currentPlan.report)\" \naria-label=\"Include Action\" translate translate-attr-aria-label=\"MV.INCLUDE_DATA\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"MV.INCLUDE_DATA\">Include Data</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-link\" \naria-hidden=\"true\"></md-icon></md-button><div class=\"input-block\" layout=\"column\"><label><span \ntranslate=\"MV.DATA_PERIOD\">Data Period:</span></label><md-select ng-model=\"vm.selectedPeriod\" ng-required=\"true\" \nstyle=\"margin:0\" aria-label=\"Data Period\"><md-option ng-value=\"period\" ng-repeat=\"period in vm.periods\">{{period}}\n</md-option></md-select></div></div><div class=\"p-16\"><label><span translate=\"MV.DATA\">Data</span></label><div \nlayout=\"column\" layout-align=\"center center\" class=\"\" style=\"min-height:348px\"><span \nng-if=\"!vm.chart.report.data.length\" translate=\"MV.NO_DATA_AVAILIABLE\">No data availiable</span><ng-dygraphs \nng-if=\"vm.chart.report.data.length\" data=\"vm.chart.report.data\" options=\"vm.chart.report.options\" \nlegend=\"vm.chart.report.legend\"></ng-dygraphs></div></div></div></div></div></md-tab-body></md-tab><md-tab \nui-sref=\"app.mv.adjust-typical\"><md-tab-label><span translate=\"MV.MANAGE.TABS.ADJUST_TYPICAL\">Typical Adjustments\n</span></md-tab-label><md-tab-body><div class=\"form-content p-24\" ng-show=\"vm.variableShow==0\"><div layout=\"column\" \nclass=\"form-title pb-16\"><span class=\"h2\" translate=\"MV.MANAGE.TABS.ADJUST_TYPICAL_TITLE\">Typical Adjustments</span> \n<span style=\"font-weight:300\" translate=\"MV.MANAGE.TABS.ADJUST_TYPICAL_DESCRIPTION\"></span></div><div class=\"pb-16\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button md-primary md-fab\" \nng-click=\"vm.openNewVariableDialog($event)\" aria-label=\"Create New Variable\" translate \ntranslate-attr-aria-label=\"MV.CREATE_VARIABLE\"><md-tooltip md-direction=\"top\"><span translate=\"MV.CREATE_VARIABLE\">\nCreate New Variable</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></md-button>\n</div><md-table-pagination md-limit=\"\" md-limit-options=\"[5, 10, 15]\" md-page=\"\" md-total=\"\" md-on-paginate=\"\" \nmd-page-select></md-table-pagination><div class=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container>\n<table md-table><thead md-head md-order=\"title\"><tr md-row><th md-column></th><th md-column md-order-by=\"title\"><span \ntranslate=\"MV.TITLE\">Title</span></th><th md-column md-order-by=\"description\"><span translate=\"MV.DESCRIPTION\">\nDescription</span></th><th md-column><span translate=\"MV.ACTIONS\">Actions</span></th></tr></thead><tbody md-body><tr \nmd-row ng-if=\"vm.currentPlan.variables.length == 0\"><td md-cell></td><td md-cell colspan=\"4\"><div class=\"p-25\"><h3 \ntranslate=\"MV.MESSAGE.NO_DATA\">No data available in table...</h3><p translate=\"MV.MESSAGE.ADD_VARIABLE\">\nClick on the \'Create New Variable\' button to create a new variable.</p></div></td></tr><tr md-row ng-if=\"\"><td md-cell>\n</td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"MV.MESSAGE.NOTHING\">Nothing found...</h3></div></td></tr>\n<tr md-row ng-if=\"vm.currentPlan.variables.length > 0\" ng-repeat=\"variable in vm.currentPlan.variables\"><td md-cell>\n<div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" ng-click=\"vm.manageVariable(variable)\" \naria-label=\"Manage Variable\" translate translate-attr-aria-label=\"MV.MANAGE_VARIABLE\"><md-tooltip md-direction=\"right\">\n<span translate=\"MV.MANAGE_VARIABLE\">Manage Variable</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-variable\" \naria-hidden=\"true\"></md-icon></md-button></div></td><td md-cell>{{variable.title}}</td><td md-cell>\n{{variable.descrition}}</td><td md-cell><md-button class=\"md-icon-button\" \nng-click=\"vm.openCopyVariableDialog($event,variable)\" aria-label=\"Copy Variable\" translate \ntranslate-attr-aria-label=\"MV.COPY_VARIABLE\"><md-tooltip md-direction=\"top\"><span translate=\"MV.COPY_VARIABLE\">\nCopy Variable</span></md-tooltip><md-icon md-font-icon=\"icon-content-duplicate\" aria-hidden=\"true\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.openEditVariableDialog($event,variable)\" \naria-label=\"Edit Variable\" translate translate-attr-aria-label=\"MV.EDIT_VARIABLE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"MV.EDIT_VARIABLE\">Edit Variable</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\">\n</md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.openDeleteVariableDialog($event,variable)\" \naria-label=\"Delete Variable\" translate translate-attr-aria-label=\"MV.DELETE_VARIABLE\"><md-tooltip md-direction=\"top\">\n<span translate=\"MV.DELETE_VARIABLE\">Delete Variable</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.manageVariable(variable)\" \naria-label=\"Manage Variable\" translate translate-attr-aria-label=\"MV.MANAGE_VARIABLE\"><md-tooltip md-direction=\"top\">\n<span translate=\"MV.MANAGE_VARIABLE\">Manage Variable</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-variable\" \naria-hidden=\"true\"></md-icon></md-button></td></tr></tbody></table></md-table-container></div></div><div \nclass=\"p-24 animate-slide-down-hide\" ng-if=\"vm.variableShow==1\" layout=\"column\" flex><div class=\"\" layout=\"row\" flex \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.variableShow=0\" \naria-label=\"Close Variable Management\" translate translate-attr-aria-label=\"MV.VARIABLE.CLOSE\"><md-tooltip \nmd-direction=\"left\"><span translate=\"MV.VARIABLE.CLOSE\">Close Variable Management</span></md-tooltip><md-icon \nmd-font-icon=\"icon-chevron-left\" aria-hidden=\"true\"></md-icon></md-button><div class=\"h3\">{{vm.currentVariable.title}}\n</div></div><div layout=\"column\" layout-gt-sm=\"row\"><div flex><div class=\"p-16\" style=\"min-height:64px\" layout=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" layout=\"column\"><label><span translate=\"MV.VARIABLE.EQUATION\">\nEquation:</span></label><md-select ng-model=\"vm.selectedEquation\" ng-required=\"true\" style=\"margin:0\" \naria-label=\"Equation\"><md-option ng-value=\"equation\" ng-repeat=\"equation in vm.equations\">{{equation}}</md-option>\n</md-select></div></div><div class=\"p-16\"><div class=\"input-block\" flex><label><span \ntranslate=\"MV.FORMS.VARIABLE_DESCRIPTION\">Variable Usage Description</span></label><text-angular \nng-model=\"vm.currentVariable.description\"></text-angular></div></div></div><div flex><div class=\"p-16\" \nstyle=\"min-height:64px\" layout=\"row\" layout-align=\"space-between start\"><md-button \nclass=\"md-icon-button md-primary md-fab md-mini\" ng-click=\"vm.openAddDataDialog($event,vm.currentVariable)\" \naria-label=\"Include Action\" translate translate-attr-aria-label=\"MV.INCLUDE_DATA\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"MV.INCLUDE_DATA\">Include Data</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-link\" \naria-hidden=\"true\"></md-icon></md-button><div class=\"input-block\" layout=\"column\"><label><span \ntranslate=\"MV.DATA_PERIOD\">Data Period:</span></label><md-select ng-model=\"vm.selectedPeriod\" ng-required=\"true\" \nstyle=\"margin:0\" aria-label=\"Data Period\"><md-option ng-value=\"period\" ng-repeat=\"period in vm.periods\">{{period}}\n</md-option></md-select></div></div><div class=\"p-16\"><md-tabs md-dynamic-height><md-tab label=\"Data\"><md-content \nstyle=\"background:none !important\"><div layout=\"column\" layout-align=\"center center\" class=\"\" style=\"min-height:348px\">\n<span ng-if=\"!vm.chart.variable.data.length\" translate=\"MV.NO_DATA_AVAILIABLE\">No data availiable</span><ng-dygraphs \nng-if=\"vm.chart.variable.data.length\" data=\"vm.chart.variable.data\" options=\"vm.chart.variable.options\" \nlegend=\"vm.chart.variable.legend\"></ng-dygraphs></div></md-content></md-tab><md-tab label=\"correlated\" \nmd-on-select=\"vm.plotVariableCorrelationGraph()\"><md-content style=\"background:none !important\"><div layout=\"column\" \nlayout-align=\"center center\" class=\"\" style=\"min-height:348px\"><span ng-if=\"!vm.correlationVariable.data.length\" \ntranslate=\"MV.NO_DATA_AVAILIABLE\">No data availiable</span><ng-dygraphs ng-if=\"vm.correlationVariable.data.length\" \ndata=\"vm.correlationVariable.data\" options=\"vm.correlationVariable.options\"></ng-dygraphs></div><div layout=\"column\" \nlayout-align=\"center center\"><span>\nEquation: y = {{vm.correlationVariable.coeffs[1][1]}} * variable + {{vm.correlationVariable.coeffs[1][0]}}, R: {{vm.correlationVariable.coeffs[1][2]}}\n</span></div></md-content></md-tab></md-tabs></div></div></div></div></md-tab-body></md-tab><md-tab \nui-sref=\"app.mv.adjust-atypical\"><md-tab-label><span translate=\"MV.MANAGE.TABS.ADJUST_ATYPICAL\">Atypical Adjustments\n</span></md-tab-label><md-tab-body><div class=\"form-content p-24\"><div layout=\"column\" class=\"form-title pb-16\"><span \nclass=\"h2\" translate=\"MV.MANAGE.TABS.ADJUST_ATYPICAL_TITLE\">Atypical Adjustments</span> <span style=\"font-weight:300\" \ntranslate=\"MV.MANAGE.TABS.ADJUST_ATYPICAL_DESCRIPTION\"></span></div><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button md-primary md-fab\" \nng-click=\"vm.openNewFactorDialog($event)\" aria-label=\"Create New Factor\" translate \ntranslate-attr-aria-label=\"MV.CREATE_FACTOR\"><md-tooltip md-direction=\"top\"><span translate=\"MV.CREATE_FACTOR\">\nCreate New Factor</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></md-button></div>\n<md-table-pagination md-limit=\"\" md-limit-options=\"[5, 10, 15]\" md-page=\"\" md-total=\"\" md-on-paginate=\"\" \nmd-page-select></md-table-pagination><div class=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container>\n<table md-table><thead md-head md-order=\"title\"><tr md-row><th md-column></th><th md-column md-order-by=\"title\"><span \ntranslate=\"MV.TITLE\">Title</span></th><th md-column md-order-by=\"startdate\"><span translate=\"MV.START_DATE\">Start Date\n</span></th><th md-column md-order-by=\"enddate\"><span translate=\"MV.END_DATE\">End Date</span></th><th md-column><span \ntranslate=\"MV.ACTIONS\">Actions</span></th></tr></thead><tbody md-body><tr md-row \nng-if=\"vm.currentPlan.factors.length == 0\"><td md-cell></td><td md-cell colspan=\"4\"><div class=\"p-25\"><h3 \ntranslate=\"MV.MESSAGE.NO_DATA\">No data available in table...</h3><p translate=\"MV.MESSAGE.ADD_FACTOR\">\nClick on the \'Create New Factor\' button to include a new factor to the plan.</p></div></td></tr><tr md-row ng-if=\"\"><td\n md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"MV.MESSAGE.NOTHING\">Nothing found...</h3></div>\n</td></tr><tr md-row ng-if=\"vm.currentPlan.factors.length > 0\" ng-repeat=\"factor in vm.currentPlan.factors\"><td \nmd-cell><div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" \nng-click=\"vm.openEditFactorDialog($event,factor)\" aria-label=\"Edit Factor\" translate \ntranslate-attr-aria-label=\"MV.EDIT_FACTOR\"><md-tooltip md-direction=\"right\"><span translate=\"MV.EDIT_FACTOR\">\nEdit Factor</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-factor\" aria-hidden=\"true\"></md-icon></md-button>\n</div></td><td md-cell>{{factor.title}}</td><td md-cell>{{factor.startdate | date:\'MM/dd/yyyy\'}}</td><td md-cell>\n{{factor.enddate | date:\'MM/dd/yyyy\'}}</td><td md-cell><md-button class=\"md-icon-button\" \nng-click=\"vm.openCopyFactorDialog($event,factor)\" aria-label=\"Copy Factor\" translate \ntranslate-attr-aria-label=\"MV.COPY_FACTOR\"><md-tooltip md-direction=\"top\"><span translate=\"MV.COPY_FACTOR\">Copy Factor\n</span></md-tooltip><md-icon md-font-icon=\"icon-content-duplicate\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.openEditFactorDialog($event,factor)\" aria-label=\"Edit Factor\" translate \ntranslate-attr-aria-label=\"MV.EDIT_FACTOR\"><md-tooltip md-direction=\"top\"><span translate=\"MV.EDIT_FACTOR\">Edit Factor\n</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.openDeleteFactorDialog($event,factor)\" aria-label=\"Delete Factor\" translate \ntranslate-attr-aria-label=\"MV.DELETE_FACTOR\"><md-tooltip md-direction=\"top\"><span translate=\"MV.DELETE_FACTOR\">\nDelete Factor</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-hidden=\"true\"></md-icon></md-button></td>\n</tr></tbody></table></md-table-container></div></div></md-tab-body></md-tab><md-tab ui-sref=\"app.mv.estimation-model\">\n<md-tab-label><span translate=\"MV.MANAGE.TABS.ESTIMATION_MODEL\">Estimation Model</span></md-tab-label><md-tab-body><div\n class=\"form-content p-24\"><div layout=\"column\" class=\"form-title pb-16\"><span class=\"h2\" \ntranslate=\"MV.MANAGE.TABS.ESTIMATION_MODEL_TITLE\">Estimation Model</span> <span style=\"font-weight:300\" \ntranslate=\"MV.MANAGE.TABS.ESTIMATION_MODEL_DESCRIPTION\"></span></div><div layout=\"column\" layout-gt-sm=\"row\"><div flex>\n<h3 translate=\"MV.MODEL_DETAILS\">Model Details</h3><div class=\"p-16\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"input-block pr-16\" layout=\"column\"><label><span translate=\"MV.MODEL_TYPE\">Model Type:</span></label><md-select \nng-model=\"vm.selectedModelType\" ng-required=\"true\" style=\"margin:0\" aria-label=\"Model Type\"><md-option \nng-value=\"modelType\" ng-repeat=\"modelType in vm.modelTypes\">{{modelType}}</md-option></md-select></div><div \nclass=\"input-block\" layout=\"column\"><label><span translate=\"MV.MODEL_DAYS\">Days:</span></label><md-select \nng-model=\"vm.selectedModelDay\" ng-required=\"true\" style=\"margin:0\" aria-label=\"Model Days\"><md-option \nng-value=\"modelDay\" ng-repeat=\"modelDay in vm.modelDays\">{{modelDay}}</md-option></md-select></div></div><h3 \ntranslate=\"MV.MODEL_VARIABLE_USAGE\">Variable Usage</h3><div layout=\"row\" layout-wrap flex><div class=\"pr-16\" \nng-repeat=\"modelVariable in vm.currentPlan.variables\"><md-checkbox \nng-model=\"vm.selectedModelVariables[modelVariable.title]\">{{modelVariable.title}}</md-checkbox></div></div><div \nclass=\"p-16\"><div class=\"input-block\" flex><label><span translate=\"MV.FORMS.DESCRIPTION\">Description</span></label>\n<text-angular ng-model=\"vm.currentPlan.model.description\"></text-angular></div></div></div><div flex><md-button \nng-click=\"vm.plotModelCorrelationGraph()\" class=\"md-raised md-button md-primary md-ink-ripple\" aria-label=\"Calculate\" \ntranslate translate-attr-aria-label=\"MV.FORMS.CALCULATE\"><span translate=\"MV.FORMS.CALCULATE\">Calculate</span>\n</md-button><h3 translate=\"MV.MODEL_ESTIMATION_RESULTS\">Model Estimation Results</h3><div \nng-if=\"vm.correlationModel.coeffs\" layout=\"column\" layout-align=\"center center\"><h4>\nEquation: y = {{vm.correlationModel.coeffs[1][1]}} * variable + {{vm.correlationModel.coeffs[1][0]}}, R: {{vm.correlationModel.coeffs[1][2]}}\n</h4></div><div class=\"p-16\"><label><span translate=\"MV.DATA\">Data</span></label><div layout=\"column\" \nlayout-align=\"center center\" class=\"\" style=\"min-height:348px\"><span ng-if=\"!vm.correlationModel.data.length\" \ntranslate=\"MV.NO_DATA_AVAILIABLE\">No data availiable</span><ng-dygraphs ng-if=\"vm.correlationModel.data.length\" \ndata=\"vm.correlationModel.data\" options=\"vm.correlationModel.options\"></ng-dygraphs></div></div></div></div></div>\n</md-tab-body></md-tab><md-tab ui-sref=\"app.mv.savings\" md-on-select=\"vm.plotSavingsGraph()\"><md-tab-label><span \ntranslate=\"MV.MANAGE.TABS.SAVINGS\">Savings</span></md-tab-label><md-tab-body><div class=\"form-content p-24\"><div \nlayout=\"column\" class=\"form-title pb-16\"><span class=\"h2\" translate=\"MV.MANAGE.TABS.SAVINGS_TITLE\">Savings</span> <span\n style=\"font-weight:300\" translate=\"MV.MANAGE.TABS.SAVINGS_DESCRIPTION\"></span></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><div flex><md-table-container class=\"p-16\"><table md-table class=\"savings-table\"><tbody md-body><tr \nmd-row><td md-cell><span translate=\"MV.MANAGE.TABS.BASE_PERIOD\">Base Period</span>:</td><td md-cell><span \nclass=\"secondary-text text-italic font-weight-300\">\n{{vm.plans[0].baseline.startdate | date:\'MM/dd/yyyy\'}} - {{vm.plans[0].baseline.enddate | date:\'MM/dd/yyyy\'}}</span>\n</td><td md-cell><span translate=\"MV.MANAGE.TABS.REPORT_PERIOD\">Report Period</span>:</td><td md-cell><span \nclass=\"secondary-text text-italic font-weight-300\">\n{{vm.plans[0].report.startdate | date:\'MM/dd/yyyy\'}} - {{vm.plans[0].report.enddate | date:\'MM/dd/yyyy\'}}</span></td>\n</tr></tbody></table></md-table-container><div class=\"p-16\"><label><span translate=\"MV.DATA\">Data</span></label><div \nlayout=\"column\" layout-align=\"center center\" class=\"\" style=\"min-height:348px\"><span \nng-if=\"!vm.savingsGraph.data.length\" translate=\"MV.NO_DATA_AVAILIABLE\">No data availiable</span><ng-dygraphs \nng-if=\"vm.savingsGraph.data.length\" data=\"vm.savingsGraph.data\" options=\"vm.savingsGraph.options\"></ng-dygraphs></div>\n</div></div><div flex><md-table-container class=\"p-16\"><table md-table class=\"savings-table\"><tbody md-body><tr md-row>\n<td md-cell><span translate=\"MV.SAVINGS_INFO_NO_PLAN\">Expected energy consumption without the Plan:</span></td><td \nmd-cell><span class=\"secondary-text text-italic font-weight-300\">{{vm.savingsGraph.savings.actualTotal}}KWh</span></td>\n<td md-cell><span class=\"secondary-text text-italic font-weight-300\">{{vm.savingsGraph.savings.actualTotalCost}}&euro;\n</span></td></tr><tr md-row><td md-cell><span translate=\"MV.SAVINGS_INFO_REAL\">Real annual consumption:</span></td><td \nmd-cell><span class=\"secondary-text text-italic font-weight-300\">{{vm.savingsGraph.savings.calculatedTotal}}KWh</span>\n</td><td md-cell><span class=\"secondary-text text-italic font-weight-300\">\n{{vm.savingsGraph.savings.calculatedTotalCost}}&euro;</span></td></tr><tr md-row><td md-cell><span \ntranslate=\"MV.SAVINGS_INFO_PER_YEAR\">Savings per year:</span></td><td md-cell><span \nclass=\"secondary-text text-italic font-weight-300\">{{vm.savingsGraph.savings.savings}}KWh</span></td><td md-cell><span \nclass=\"secondary-text text-italic font-weight-300\">{{vm.savingsGraph.savings.savingsCost}}&euro;</span></td></tr><tr \nmd-row><td md-cell><span translate=\"MV.SAVINGS_INFO_GAIN\">Repayment period:</span></td><td md-cell><span \nclass=\"secondary-text text-italic font-weight-300\">1year</span></td><td md-cell></td></tr></tbody></table>\n</md-table-container><div class=\"p-16\"><div class=\"input-block\" flex><label><span translate=\"MV.FORMS.DESCRIPTION\">\nDescription</span></label><text-angular ng-model=\"vm.currentPlan.savings.description\"></text-angular></div></div></div>\n</div></div></md-tab-body></md-tab></md-tabs></div></div></div></div></div></div>");
$templateCache.put("app/main/notification/notification.html","<div id=\"notifications\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"content-wrapper\" \nclass=\"md-primary-bg md-hue-3\"><div class=\"content sidenav\" layout=\"row\"><div hide show-md show-sm show-xs><button \nclass=\"toggle-left-sidenav\" type=\"button\" ng-click=\"vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"Toggle\"><md-icon \nclass=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button></div><div hide show-gt-md>\n<button class=\"toggle-left-sidenav\" type=\"button\" ng-click=\"vm.lockLeft=!vm.lockLeft\" aria-label=\"Toggle\"><md-icon \nclass=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button></div><md-sidenav \nclass=\"sidenav sidenav-width-300 md-sidenav-left\" md-is-locked-open=\"vm.lockLeft && $mdMedia(\'gt-md\')\" \nmd-component-id=\"left-sidenav\" md-disable-backdrop ms-scroll ms-sidenav-helper><md-toolbar \nclass=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding><div class=\"toolbar\"><div hide \nshow-gt-md><md-icon ng-click=\"vm.changeStatusL(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" \naria-hidden=\"true\"></md-icon></div><div hide show-md show-sm show-xs><md-icon \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\">\n</md-icon></div></div><div class=\"heading\">{{ \'DASHBOARD.MONITORED_POINTS\' | translate }}</div></md-toolbar><md-content\n class=\"content md-background-bg md-hue-1\" ms-scroll layout-padding><div class=\"search-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input \nclass=\"md-background-bg md-hue-1\" flex ng-model=\"vm.searchtree\" type=\"text\" ng-change=\"vm.applySearch()\" \nplaceholder=\"{{ \'DASHBOARD.SEARCH_TREE\' | translate }}\"></div></div><div layout=\"row\"><div class=\"tree\" \njs-tree=\"vm.treeConfig\" ng-model=\"vm.treeData\" tree=\"vm.treeInstance\" tree-events-obj=\"vm.treeEvents\"></div></div>\n<md-content></md-content></md-content></md-sidenav><div class=\"page-content\" ms-scroll flex id=\"notificationsScroll\">\n<div class=\"top-toolbar md-background-bg md-hue-1\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"button-group\" layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.presentationType===\'calendar\'\"><md-button \nclass=\"presentationType-button timeline-button md-button-icon md-raised groupX middle\" \nng-click=\"vm.changeCalendarDate(\'today\')\" aria-label=\"Timeline View\" style=\"margin-right: 20px\"><md-tooltip \nmd-direction=\"top\">{{ \'NOTIFICATION.TODAY\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-calendar-today\">\n</md-icon></md-button><md-button \nclass=\"presentationType-button timeline-button md-button-icon md-raised groupX middle\" \nng-click=\"vm.changeCalendarDate(\'prev\')\" aria-label=\"Timeline View\"><md-tooltip md-direction=\"top\">\n{{ \'NOTIFICATION.PREV_MONTH\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-arrow-left-bold\"></md-icon>\n</md-button><md-button class=\"presentationType-button timeline-button md-button-icon md-raised groupX middle\" \nng-click=\"vm.changeCalendarDate(\'next\')\" aria-label=\"Timeline View\"><md-tooltip md-direction=\"top\">\n{{ \'NOTIFICATION.NEXT_MONTH\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-arrow-right-bold\"></md-icon>\n</md-button></div><div flex class=\"title\"></div><div class=\"button-group\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"presentationType-button active timeline-button md-button-icon md-raised groupX middle\" \nng-click=\"vm.setPresentationType(\'timeline\')\" aria-label=\"Timeline View\"><md-tooltip md-direction=\"top\">\n{{ \'NOTIFICATION.TIMELINE_VIEW\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-presentation-play\"></md-icon>\n</md-button><md-button class=\"presentationType-button table-button md-button-icon md-raised groupX middle\" \nng-click=\"vm.setPresentationType(\'table\')\" aria-label=\"Table View\"><md-tooltip md-direction=\"top\">\n{{ \'NOTIFICATION.TABLE_VIEW\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-table-large\"></md-icon></md-button>\n<md-button class=\"presentationType-button calendar-button md-button-icon md-raised groupX middle\" \nng-click=\"vm.setPresentationType(\'calendar\')\" aria-label=\"Calendar View\"><md-tooltip md-direction=\"top\">\n{{ \'NOTIFICATION.CALENDAR_VIEW\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-calendar-blank\"></md-icon>\n</md-button><md-button class=\"onlyunread-button md-button-icon md-raised groupX middle\" style=\"margin-right: 20px\" \nng-click=\"vm.buttonToggle(\'onlyunread\')\" aria-label=\"Only Unread\"><md-tooltip md-direction=\"top\">\n{{ \'NOTIFICATION.UNREAD_ONLY\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-eye\"></md-icon></md-button></div>\n</div><div class=\"p-16\" ng-if=\"!vm.notifications.length && vm.presentationType!==\'calendar\'\" flex layout=\"row\"><div \nflex><p><b><span translate=\"NOTIFICATION.NO_NOT_DATA\">No Notification data</span></b></p></div></div><div class=\"p-16\" \nng-if=\"vm.showcalendar && vm.presentationType===\'calendar\'\"><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"p-16 md-background-bg md-hue-1 calendarWidget\" style=\"height: 620px\"><div id=\"calendarView\" \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.calendarEvents\" calendar=\"main\"></div></ms-widget-front>\n</ms-widget></div><div class=\"p-16\" ng-if=\"vm.notifications.length  && vm.presentationType===\'table\'\"><div \nlayout=\"row\" layout-align=\"space-between left\"><div layout=\"column\"><data-md-table-pagination \nmd-limit=\"vm.table.query.limit\" md-limit-options=\"vm.table.limitOptions\" md-page=\"vm.table.query.page\" \nmd-total=\"{{vm.notifications.length}}\" md-boundary-links=\"vm.table.options.boundaryLinks\"></data-md-table-pagination>\n</div><div layout=\"column\" ng-if=\"vm.showRefresh\"><md-button class=\"md-icon-button\" ng-click=\"vm.reload()\" \naria-label=\"Refresh\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button></div></div><div \nclass=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table md-progress=\"promise\" \nclass=\"sites card notificationTable\"><thead ng-if=\"!vm.table.options.decapitate\" md-head \ndata-md-order=\"vm.table.query.order\"><tr md-row><th md-column md:order:by=\"title\"><span translate=\"NOTIFICATION.TYPE\">\nType</span></th><th md-column md:order:by=\"title\"><span translate=\"NOTIFICATION.NTITLE\">Title</span></th><th md-column \nmd:order:by=\"message\"><span translate=\"NOTIFICATION.MESSAGE\">Message</span></th><th md-column md:order:by=\"eventDate\">\n<span translate=\"NOTIFICATION.DATE\">Date</span></th><th md-column md:order:by=\"read\"><span \ntranslate=\"NOTIFICATION.READ\">Read</span></th></tr></thead><tbody md-body><tr md-row \ndata-ng-repeat=\"result in vm.notifications | filter: vm.table.filter.search | orderBy: vm.table.query.order | limitTo: vm.table.query.limit : (vm.table.query.page - 1) * vm.table.query.limit\">\n<td md-cell><md-icon md-font-icon=\"{{result.typeIcon}}\" class=\"s32\" ng-style=\'{\"color\":result.color}\'></md-icon></td>\n<td md-cell>{{result.title}}</td><td md-cell>{{result.message}}</td><td md-cell>\n{{result.eventDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td md-cell><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.toggleRead(result)\" aria-label=\"Toogle Read\"><md-tooltip md-direction=\"top\">\n{{ \'NOTIFICATION.TOGGLE_READ\' | translate }}</md-tooltip><md-icon md-font-icon=\"{{result.readIcon}}\" class=\"s24\">\n</md-icon></md-button></td></tr></tbody></table></md-table-container></div></div><div class=\"p-16 ms-timeline\" \nng-if=\"vm.notifications.length  && vm.presentationType===\'timeline\'\" ms-timeline=\"vm.eventsOptions\" \nms-timeline-load-more=\"vm.getNotifications()\" flex><div ms-timeline-item layout=\"column\" layout-align=\"center center\" \nlayout-gt-md=\"row\" layout-align-gt-md=\"center start\" ng-repeat=\"eventItem in vm.notifications\"><div \nclass=\"event-point\" ng-cloak><md-button class=\"md-fab\" aria-label=\"Toogle Read\" ng-click=\"vm.toggleRead(eventItem)\">\n<md-tooltip md-direction=\"top\">{{ \'NOTIFICATION.TOGGLE_READ\' | translate }}</md-tooltip><md-icon \nmd-font-icon=\"{{eventItem.readIcon}}\"></md-icon></md-button></div><div class=\"event-detail\" flex=\"50\"><div \nclass=\"date\">{{eventItem.eventDate | date:\'dd/MM/yyyy HH:mm\'}}</div></div><div class=\"event-card\" layout=\"row\" \nflex=\"50\"><ms-card template=\"eventItem.template\" ng-model=\"eventItem\"></ms-card></div></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/prediction/prediction.html","<div id=\"breakdown\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"content-wrapper\" \nclass=\"md-primary-bg md-hue-3\"><div class=\"content sidenav\" layout=\"row\"><div hide show-md show-sm show-xs><button \nclass=\"toggle-left-sidenav md-background-bg md-hue-1\" type=\"button\" ng-click=\"vm.toggleSidenav(\'left-sidenav\')\" \naria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button>\n</div><div hide show-gt-md><button class=\"toggle-left-sidenav md-background-bg md-hue-1\" type=\"button\" \nng-click=\"vm.lockLeft=!vm.lockLeft\" aria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" \naria-hidden=\"true\"></md-icon></button></div><md-sidenav class=\"sidenav sidenav-width-300 md-sidenav-left\" \nmd-is-locked-open=\"vm.lockLeft && $mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" md-disable-backdrop ms-scroll \nms-sidenav-helper><md-toolbar class=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding>\n<div class=\"toolbar\"><div hide show-gt-md><md-icon ng-click=\"vm.changeStatusL(\'left-sidenav\')\" class=\"s16 sidhov\" \nmd-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\"></md-icon></div><div hide show-md show-sm show-xs><md-icon \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\">\n</md-icon></div></div><div class=\"heading\">{{ \'DASHBOARD.MONITORED_POINTS\' | translate }}</div></md-toolbar><md-content\n class=\"content md-background-bg md-hue-1\" ms-scroll layout-padding><div \nclass=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input class=\"md-background-bg md-hue-1\" flex \nng-model=\"vm.searchtree\" type=\"text\" ng-change=\"vm.applySearch()\" \nplaceholder=\"{{ \'DASHBOARD.SEARCH_TREE\' | translate }}\"></div></div><div layout=\"row\"><div class=\"tree\" \njs-tree=\"vm.treeConfig\" ng-model=\"vm.treeData\" tree=\"vm.treeInstance\" tree-events-obj=\"vm.treeEvents\" \nng-if=\"vm.showTree\"></div></div><md-content></md-content></md-content></md-sidenav><div class=\"page-content\" ms-scroll \nflex><div class=\"top-toolbar md-background-bg md-hue-1\" layout=\"row\" layout-xs=\"column\" layout-align=\"start center\" \nstyle=\"padding-bottom: 5px\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"daterange-wrapper md-background-border md-hue-1\"><div class=\"daterange\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-calendar\" class=\"icon\" aria-hidden=\"true\"></md-icon><input\n flex date-range-picker id=\"daterange\" name=\"daterange\" class=\"form-control date-picker md-background-bg md-hue-1\" \ntype=\"text\" ng-model=\"vm.date\" options=\"vm.dateOptions\"></div></div></div><div class=\"button-group\" layout=\"row\" \nlayout-align=\"start center\"><md-button \nclass=\"chartType-button active line-button md-button-icon md-raised groupX middle\" ng-click=\"vm.setChartType(\'line\')\" \naria-label=\"Line Chart\" translate translate-attr-aria-label=\"BREAKDOWN.LINE_CHART\"><md-tooltip md-direction=\"top\"><span\n translate=\"BREAKDOWN.LINE_CHART\">Line Chart</span></md-tooltip><md-icon md-font-icon=\"icon-chart-line\" \naria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"chartType-button bar-button md-button-icon md-raised groupX middle\" ng-click=\"vm.setChartType(\'bar\')\" \naria-label=\"Bar Chart\" translate translate-attr-aria-label=\"BREAKDOWN.BAR_CHART\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"BREAKDOWN.BAR_CHART\">Bar Chart</span></md-tooltip><md-icon md-font-icon=\"icon-chart-bar\" aria-hidden=\"true\">\n</md-icon></md-button></div></div><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"md-background-bg md-hue-1\" style=\"height: 773px\"><div class=\"h3 p-16 md-primary-bg md-hue-2\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start center\"><div class=\"toolbar\" layout=\"row\"><md-menu><md-button \nclass=\"md-icon-button download-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"Download\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.saveImage(\'chart-aggregated-canvas\')\" aria-label=\"Download PNG\" translate=\"BREAKDOWN.DOWNLOAD_PNG\" \ntranslate-attr-aria-label=\"BREAKDOWN.DOWNLOAD_PNG\">Download PNG</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.exportCsv()\" aria-label=\"Download CSV\" translate=\"BREAKDOWN.DOWNLOAD_CSV\" \ntranslate-attr-aria-label=\"BREAKDOWN.DOWNLOAD_CSV\">Download CSV</md-button></md-menu-item></md-menu-content></md-menu>\n</div></div><md-divider></md-divider><div layout=\"column\" class=\"\"><div layout=\"column\" class=\"pb-16\"><div \nclass=\"chart-container m-16\" ng-show=\"vm.showGraph\"><canvas id=\"chart-aggregated-canvas\"></canvas></div><div \nlayout=\"column\" class=\"chart-aggregated-zoom m-16\" style=\"display: none; position: relative; height: 100px\"><div \nclass=\"zoom-ctrl\"><div class=\"zoom-left\"></div><div class=\"zoom-box\"><div></div></div><div class=\"zoom-right\"></div>\n</div><canvas id=\"chart-zoom-canvas\"></canvas></div></div></div></ms-widget-front></ms-widget></div></div></div></div>");
$templateCache.put("app/main/preferences/preferences.html","<div id=\"preferences\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><span \nus-spinner=\"{radius:30, width:8, length: 16}\"></span><div id=\"header-container\" class=\"md-primary-bg md-hue-1\" \nlayout=\"column\"></div><div id=\"content-wrapper\" class=\"md-primary-bg md-hue-3\"><div class=\"content\" layout=\"row\"><div \nclass=\"page-content\" ms-scroll flex><div layout=\"row\" layout-align=\"center center\" flex><div \nclass=\"md-whiteframe-1dp p-20 md-background-bg md-hue-1\" flex-xl=\"70\" flex-lg=\"70\" flex-md=\"80\" flex-sm=\"100\" \nflex-xs=\"100\" flex><form id=\"preferencesForm\" name=\"preferencesForm\" ng-submit=\"vm.submit(vm.master)\" novalidate><h4 \nclass=\"md-title form-title\" translate=\"PREFERENCES.USER_DETAILS\">User Details</h4><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.USER_NAME\">Username</span></label><input ng-model=\"vm.master.userData.username\" \ntype=\"text\" disabled=\"disabled\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.PASSWORD\">Password</span></label><input \nng-model=\"vm.master.userData.password\" type=\"password\"></md-input-container></div></div><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.CONTACT_DETAILS\">Contact details</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FIRST_NAME\">First name</span></label><input name=\"firstName\" \nng-model=\"vm.master.userData.firstName\" type=\"text\" ng-required=\"true\"><div style=\"color:Red\" \nng-show=\"preferencesForm.firstName.$error.required\" translate=\"PREFERENCES.REQUIRED\">Required field!</div>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.LAST_NAME\">Last name</span></label><input name=\"lastName\" \nng-model=\"vm.master.userData.lastName\" type=\"text\" ng-required=\"true\"><div style=\"color:Red\" \nng-show=\"preferencesForm.lastName.$error.required\" translate=\"PREFERENCES.REQUIRED\">Required field!</div>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.EMAIL\">E-mail</span></label>\n<input name=\"email\" ng-model=\"vm.master.userData.metadata.email\" type=\"email\" \nng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\" ng-required=\"true\"><div style=\"color:Red\" \nng-show=\"preferencesForm.email.$error.required\" translate=\"PREFERENCES.REQUIRED\">Required field!</div><div \nstyle=\"color:Red\" ng-show=\"preferencesForm.email.$dirty&&preferencesForm.email.$error.pattern\" \ntranslate=\"PREFERENCES.VALID_EMAIL\">Please Enter Valid Email</div></md-input-container></div><div class=\"input-block\" \nflex><md-input-container class=\"md-input-has-placeholder\" flex><label><span translate=\"ADMINISTRATION.FORMS.PHONE\">\nPhone</span></label><input id=\"phone\" name=\"phone\" ng-change=\"vm.checkDialCode(this)\" type=\"text\" \nng-model=\"vm.master.userData.metadata.phone\" international-phone-number default-country=\"gr\" \npreferred-countries=\"gr, us, gb, de\"><div style=\"color:Red\" ng-show=\"preferencesForm.phone.$invalid\" \ntranslate=\"PREFERENCES.VALID_PHONE\">Please Enter Valid Phone Number</div></md-input-container></div></div><h4 \nclass=\"md-title form-title\" translate=\"PREFERENCES.LANGUAGE\">Language</h4><md-input-container class=\"md-block\">\n<md-radio-group name=\"languageGroup\" ng-model=\"vm.master.language\" layout=\"row\"><md-radio-button \nng-repeat=\"language in vm.languages\" value=\"{{language.code}}\" aria-label=\"{{language.code}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"mr-10\" ng-src=\"assets/images/flags/{{language.flag}}.png\"> <span \ntranslate=\"{{language.translation}}\">{{language.title}}</span></span></md-radio-button></md-radio-group>\n</md-input-container><h4 class=\"md-title form-title\" translate=\"PREFERENCES.PALETTE\">Theme</h4><div class=\"themes\" \nlayout=\"row\" layout-xs=\"column\"><div class=\"mt-20 mb-20\" flex><md-radio-group name=\"paletteGroup\" \nng-model=\"vm.master.palette\" layout-xs=\"row\" layout-align=\"start center\" layout-wrap><md-radio-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" value=\"{{themeName}}\" aria-label=\"{{themeName}}\" flex=\"33\"><span \nlayout=\"row\" layout-align=\"start center\"><span>{{themeName === \"default\" ? \"Pragma\" : themeName}}</span></span>\n</md-radio-button></md-radio-group></div><div class=\"theme-preview md-whiteframe-1dp mt-20 mb-20\" layout=\"column\" \nflex-xl=\"50\" flex-lg=\"50\" flex-md=\"50\" flex-sm=\"60\" flex-xs=\"60\" flex><div class=\"header\" layout=\"column\"><div \nclass=\"top p-10 white-fg\" ng-style=\"{\'background-color\': vm.themes.list[vm.master.palette].primary.hue1.color}\">\n<md-icon class=\"s20\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\"></md-icon></div><div class=\"toolbar\" \nng-style=\"{\'background-color\': vm.themes.list[vm.master.palette].primary.hue2.color}\"><h1 layout=\"column\" \nlayout-align=\"center center\" class=\"m-15 white-fg\">{{vm.master.palette === \"default\" ? \"Pragma\" : vm.master.palette}} \n<span translate=\"PREFERENCES.THEME_PREVIEW\">Theme Preview</span></h1><div class=\"preferences-button md-button md-fab\" \nng-style=\"{\'background-color\': vm.themes.list[vm.master.palette].primary.color}\"><md-icon class=\"s20\" \nmd-font-icon=\"icon-star\" aria-hidden=\"true\"></md-icon></div></div></div><div class=\"body\" layout=\"row\" flex><div \nclass=\"side\" flex ng-style=\"{\'background-color\': vm.themes.list[vm.master.palette].background.hue1.color}\"></div><div \nclass=\"content p-10\" layout=\"column\" layout-align=\"center center\" \nng-style=\"{\'background-color\': vm.themes.list[vm.master.palette].primary.hue3.color}\" flex><span \nng-style=\"{\'color\': vm.themes.list[vm.master.palette].primary.hue3.contrast1}\" translate=\"PREFERENCES.SUBMIT_TO_SAVE\">\nSubmit the form to save your theme choice!</span></div></div></div></div><div layout=\"row\" layout-align=\"end center\">\n<md-button \nng-disabled=\"preferencesForm.$pristine || preferencesForm.phone.$invalid || preferencesForm.email.$error.required || preferencesForm.email.$error.pattern || preferencesForm.firstName.$error.required || preferencesForm.lastName.$error.required\" \ntype=\"submit\" class=\"md-button md-default md-raised\" \nng-class=\"{\'md-primary\': (preferencesForm.paletteGroup.$dirty || preferencesForm.languageGroup.$dirty)}\" \naria-label=\"Submit\" translate=\"PREFERENCES.SUBMIT\" translate-attr-aria-label=\"PREFERENCES.SUBMIT\">Submit</md-button>\n</div></form></div></div></div></div></div></div>");
$templateCache.put("app/main/reporting/reporting.html","<div id=\"reporting\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"content-wrapper\" \nclass=\"md-primary-bg md-hue-3\"><div class=\"content sidenav\" layout=\"row\"><div hide show-md show-sm show-xs \nng-if=\"vm.showLeftSideNav\"><button class=\"toggle-left-sidenav md-background-bg md-hue-1\" type=\"button\" \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"Toggle\"><md-icon class=\"s20\" \nmd-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button></div><div hide show-gt-md \nng-if=\"vm.showLeftSideNav\"><button class=\"toggle-left-sidenav\" type=\"button\" ng-click=\"vm.lockLeft=!vm.lockLeft\" \naria-label=\"Toggle\"><md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button>\n</div><md-sidenav ng-if=\"vm.showLeftSideNav\" class=\"sidenav sidenav-width-300 md-sidenav-left\" \nmd-is-locked-open=\"vm.lockLeft && $mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" md-disable-backdrop ms-scroll \nms-sidenav-helper><md-toolbar class=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding>\n<div class=\"toolbar\"><div hide show-gt-md><md-icon ng-click=\"vm.changeStatusL(\'left-sidenav\')\" class=\"s16 sidhov\" \nmd-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\"></md-icon></div><div hide show-md show-sm show-xs><md-icon \nng-click=\"vm.toggleClose(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\">\n</md-icon></div></div><div class=\"heading font-weight-300\">{{ \'REPORTS.TOOLS\' | translate }}</div></md-toolbar>\n<md-content class=\"content md-background-bg md-hue-1\" ms-scroll layout-padding><v-accordion \nclass=\"vAccordion--default\"><v-pane><v-pane-header><div class=\"h2 font-weight-300\" flex>\n{{ \'REPORTS.BLOCKS\' | translate }}</div></v-pane-header><v-pane-content><div id=\"layout-selector\"><div \nclass=\"layout-list\" layout=\"column\"><div class=\"layout-list-item\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"block in vm.blockFormats\" ng-mouseenter=\"vm.blockHovered=block.id\" ng-mouseleave=\"vm.blockHovered=-1\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"{{block.icon}}\" class=\"icon s24\"></md-icon><span \nclass=\"ml-8\" flex>{{block.title}}</span></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.blockHovered===block.id && !vm.reportLocked\"><md-icon md-font-icon=\"icon-arrow-right-bold\" class=\"s16\" \nng-click=\"vm.addWidgetToReport(\'format\',block)\"></md-icon></div></div></div></div></v-pane-content></v-pane><v-pane \nexpanded><v-pane-header><div class=\"h2 font-weight-300\" flex>{{ \'REPORTS.WIDGETS\' | translate }}</div></v-pane-header>\n<v-pane-content><v-accordion class=\"vAccordion--default\"><v-pane ng-repeat=\"dashboard in vm.dashboards\"><v-pane-header>\n<div class=\"h3 font-weight-300\" flex>{{dashboard.name}}</div></v-pane-header><v-pane-content><div id=\"layout-selector\">\n<div class=\"layout-list\" layout=\"column\"><div class=\"layout-list-item\" layout=\"row\" \nlayout-align=\"space-between center\" ng-repeat=\"widget in dashboard.widgets\" \nng-if=\"vm.checkSupportedWidgetType(widget.type)\" aria-label=\"{{widget.title}}\" \nng-mouseenter=\"vm.widgetHovered=widget.token\" ng-mouseleave=\"vm.widgetHovered=-1\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon \nmd-font-icon=\"{{widget.graph.graphType ? vm.widgetTypes[widget.graph.graphType].icon : \'icon-numeric-5-box-outline\'}}\" \nclass=\"icon s24\"></md-icon><span class=\"ml-8\">{{widget.title}}</span></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.widgetHovered===widget.token && !vm.reportLocked\"><md-icon md-font-icon=\"icon-arrow-right-bold\" class=\"s16\" \nng-click=\"vm.addWidgetToReport(\'widget\',widget)\"></md-icon></div></div></div></div></v-pane-content></v-pane>\n</v-accordion></v-pane-content></v-pane></v-accordion><md-content></md-content></md-content></md-sidenav><div \nlayout=\"column\" class=\"page-content\" ms-scroll flex><div class=\"top-toolbar md-background-bg md-hue-1\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start center\" style=\"padding-bottom: 5px\"><div layout=\"row\" \nlayout-align=\"start center\" flex></div><div class=\"button-group\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-button-icon md-raised groupX middle\" ng-click=\"vm.lockReport()\" ng-if=\"vm.selectedReport\"><md-tooltip \nmd-direction=\"left\">{{ \'REPORTS.LOCK\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-lock\" \nng-if=\"vm.reportLocked\"></md-icon><md-icon md-font-icon=\"icon-lock-unlocked\" ng-if=\"!vm.reportLocked\"></md-icon>\n</md-button><md-button class=\"md-button-icon md-raised groupX middle\" ng-click=\"vm.controlReport($event,null,\'New\')\">\n<md-tooltip md-direction=\"left\">{{ \'REPORTS.NEW_REPORT\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button><md-button class=\"md-button-icon md-raised groupX middle\" ng-if=\"!vm.reportLocked\" \nng-click=\"vm.controlReport($event,vm.selectedReport,\'Duplicate\')\"><md-tooltip md-direction=\"left\">\n{{ \'REPORTS.DUPLICATE_REPORT\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon>\n</md-button><md-button class=\"md-button-icon md-raised groupX middle\" ng-if=\"!vm.reportLocked\" \nng-click=\"vm.controlReport($event,vm.selectedReport,\'Edit\')\"><md-tooltip md-direction=\"left\">\n{{ \'REPORTS.EDIT_REPORT\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button class=\"md-button-icon md-raised groupX middle\" ng-if=\"!vm.reportLocked\" \nng-click=\"vm.controlReport($event,vm.selectedReport,\'Delete\')\"><md-tooltip md-direction=\"left\">\n{{ \'REPORTS.DELETE_REPORT\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n<md-button class=\"md-button-icon md-raised groupX middle\" ng-if=\"!vm.reportLocked\" \nng-click=\"vm.controlReport($event,vm.selectedReport,\'Save\')\" ng-if=\"vm.selectedDashboard.userId!=\'\'\" \nstyle=\"margin-right:10px\"><md-tooltip md-direction=\"left\">{{ \'REPORTS.SAVE_REPORT\' | translate }}</md-tooltip><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon></md-button><md-button class=\"md-button-icon md-raised groupX middle\" \nng-if=\"!vm.reportLocked\" ng-click=\"vm.addPage(\'empty-page\')\" style=\"margin:0 10px 0 10px\"><md-tooltip \nmd-direction=\"left\">{{ \'REPORTS.PAGE_LAYOUTS.EMPTY_PAGE\' | translate }}</md-tooltip><md-icon \nmd-font-icon=\"icon-crop-portrait\"></md-icon></md-button><md-button class=\"md-button-icon md-raised groupX middle\" \nng-if=\"!vm.reportLocked\" ng-click=\"vm.zoomReport(\'in\')\" ng-disabled=\"!vm.selectedReport.pages.length\"><md-tooltip \nmd-direction=\"left\">{{ \'REPORTS.ZOOMIN\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-magnify-plus\"></md-icon>\n</md-button><md-button class=\"md-button-icon md-raised groupX middle\" ng-if=\"!vm.reportLocked\" \nng-click=\"vm.zoomReport(\'out\')\" ng-disabled=\"!vm.selectedReport.pages.length\"><md-tooltip md-direction=\"left\">\n{{ \'REPORTS.ZOOMOUT\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-magnify-minus\"></md-icon></md-button>\n<md-button class=\"md-button-icon md-raised groupX middle\" ng-if=\"!vm.reportLocked\" ng-click=\"vm.toggleGrid()\" \nng-disabled=\"!vm.selectedReport.pages.length\" style=\"margin-right:10px\"><md-tooltip md-direction=\"left\">\n{{ \'REPORTS.TOGGLE_GRID\' | translate }}</md-tooltip><md-icon \nmd-font-icon=\"{{vm.gridOnPage === true ? \'icon-grid-off\' : \'icon-grid\'}}\"></md-icon></md-button><md-button \nclass=\"md-button-icon md-raised groupX middle\" style=\"margin-right:10px\" ng-click=\"vm.downloadPDF()\" \nng-disabled=\"!vm.selectedReport.pages.length\"><md-tooltip md-direction=\"left\">\n{{ \'REPORTS.DOWNLOAD_REPORT\' | translate }}</md-tooltip><md-icon md-font-icon=\"icon-download\"></md-icon></md-button>\n</div></div><div flex><div class=\"p-16 mb-8\" layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"ml-16 h1 font-weight-300\" flex>{{vm.selectedReport.title}}</div></div><div id=\"report-cnt p-16\" layout=\"column\" \nflex layout-align=\"start center\"><div id=\"empty-report\" ng-if=\"vm.selectedReport.pages.length == 0\" layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><h2 class=\"mb-0\">\n{{ \'REPORTS.EMPTY_REPORT\' | translate }}</h2><p class=\"mt-0\">{{ \'REPORTS.EMPTY_REPORT_MESSAGE\' | translate }}</p></div>\n</div><div id=\"report\"><div ng-model=\"vm.selectedReport\"><div ng-repeat=\"page in vm.selectedReport.pages\" layout=\"row\" \nlayout-align=\"start start\"><div id=\"page_{{$index}}\" class=\"page-cnt a4 md-white-bg md-whiteframe-4dp\" \nng-class=\"{\'active-page\' : vm.activePage === $index}\" ng-click=\"vm.activatePage($index)\" flex><div \nclass=\"page normal-margins {{vm.selectedTheme.name}}\"><div class=\"header\" ng-if=\"$index != 0\"><div \nui-tinymce=\"vm.tinymceOptions\" ng-disabled=\"vm.reportLocked\" ng-model=\"vm.selectedReport.header\">\n{{vm.selectedReport.header}}</div></div><div class=\"content\" ng-class=\"vm.gridOnPage === true ? \'grid\' : \'no-grid\'\">\n<div class=\"blocks\" ng-repeat=\"block in page.blocks\" ui-draggable-resizable \nenabled=\"(vm.activePage === $parent.$index ? true : false) && vm.activeBlock == $index && !vm.reportLocked\" \non-drag-resize-event=\"onDragResizeEvent($evt, $ui)\" ng-click=\"vm.activeBlock=$index\" \nng-class=\"{\'active-block\' : (vm.activePage === $parent.$index) && vm.activeBlock == $index}\" ng-style=\"block.style[0]\">\n<div id=\"block-selector-{{$parent.$index}}-{{$index}}\"><div class=\"block\" ui-tinymce=\"vm.tinymceOptions\" \nng-disabled=\"vm.reportLocked\" ng-if=\"block.type === \'format\'\" ng-model=\"block.html\">{{block.html}}</div><div \nclass=\"block\" ng-if=\"block.type === \'widget\'\" ng-model=\"block.widget\"><numeric-card id=\"numeric-card\" \nwidget=\"block.widget\" dashboard-date=\"block.widget.dates[0].date\" report=\"true\" ng-if=\"block.widget.type===0\" \nstyle=\"text-align:center\"></numeric-card><plot-card-report widget=\"block.widget\" \ndashboard-date=\"block.widget.dates[0].date\" report=\"true\" ng-if=\"block.widget.type===1\" style=\"text-align:center\">\n</plot-card-report><pie-card-report widget=\"block.widget\" dashboard-date=\"block.widget.dates[0].date\" report=\"true\" \nng-if=\"block.widget.type===2\" style=\"text-align:center\"></pie-card-report><spyder-card-report widget=\"block.widget\" \ndashboard-date=\"block.widget.dates[0].date\" report=\"true\" ng-if=\"block.widget.type===4\" style=\"text-align:center\">\n</spyder-card-report></div></div><div class=\"block-actions\" \nng-if=\"vm.activePage === $parent.$index && vm.activeBlock == $index && !vm.reportLocked\" layout=\"row\"><md-icon \nclass=\"s24 blue-grey-200-fg\" md-font-icon=\"icon-calendar-select\" ng-if=\"block.type === \'widget\'\" \nng-click=\"vm.changeWidgetDates($event, $index, block.widget)\"></md-icon><md-icon class=\"s24 blue-grey-200-fg\" \nmd-font-icon=\"icon-pencil-box-outline\" ng-click=\"vm.changeBlockProperties($event, $parent.$index, $index, block)\">\n</md-icon><md-icon class=\"s24 blue-grey-200-fg\" md-font-icon=\"icon-delete\" \nng-click=\"vm.removeWidgetFromReport($index)\"></md-icon><md-icon class=\"s24 blue-grey-200-fg handle\" \nmd-font-icon=\"icon-cursor-move\"></md-icon></div></div></div><div class=\"footer\" ng-if=\"$index != 0\"><div \nui-tinymce=\"vm.tinymceOptions\" ng-disabled=\"vm.reportLocked\" ng-model=\"vm.selectedReport.footer\">\n{{vm.selectedReport.footer}}</div></div></div><div ng-if=\"vm.selectedReport.pages.length > $index+1\" \nclass=\"page_break\"></div></div><div class=\"page-settings\" layout=\"row\" layout-align=\"end center\" \nng-if=\"!vm.reportLocked\" ng-cloak><md-fab-speed-dial class=\"md-fling\" md-direction=\"down\"><md-fab-trigger><md-button \naria-label=\"Page Settings\" class=\"md-fab blue-600-bg\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><md-button ng-click=\"vm.removePage($index)\" aria-label=\"Remove Page\" \nclass=\"md-fab md-mini red-300-bg\"><md-tooltip md-direction=\"top\"><span>Remove Page</span></md-tooltip><md-icon \nclass=\"s16\" md-font-icon=\"icon-minus\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div></div></div>\n</div></div></div></div><div hide show-md show-sm show-xs><button class=\"toggle-right-sidenav\" type=\"button\" \nng-click=\"vm.toggleSidenav(\'right-sidenav\')\" aria-label=\"Toggle\"><md-icon class=\"s20\" \nmd-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\"></md-icon></button></div><div hide show-gt-md><button \nclass=\"toggle-right-sidenav\" type=\"button\" ng-click=\"vm.lockRight=!vm.lockRight\" aria-label=\"Toggle\"><md-icon \nclass=\"s20\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\"></md-icon></button></div><md-sidenav \nclass=\"sidenav sidenav-width-300 md-sidenav-right\" md-is-locked-open=\"vm.lockRight && $mdMedia(\'gt-md\')\" \nmd-component-id=\"right-sidenav\" md-disable-backdrop ms-scroll ms-sidenav-helper><md-toolbar \nclass=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding><div class=\"heading\">\n{{ \'REPORTS.YOUR_REPORTS\' | translate }}</div><div class=\"toolbar\"><div hide show-gt-md><md-icon \nng-click=\"vm.changeStatusR(\'right-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-right-bold\" \naria-hidden=\"true\"></md-icon></div><div hide show-md show-sm show-xs><md-icon \nng-click=\"vm.toggleClose(\'right-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\">\n</md-icon></div></div></md-toolbar><md-content class=\"content md-background-bg md-hue-1\" ms-scroll layout-padding>\n<v-accordion class=\"vAccordion--default\" ng-if=\"vm.user.role!=\'level04\' && vm.user.role!=\'level05\'\"><v-pane expanded>\n<v-pane-header><div class=\"h2 font-weight-300\" flex>{{ \'REPORTS.REPORTS\' | translate }}</div></v-pane-header>\n<v-pane-content><div id=\"layout-selector\"><div class=\"layout-list\" layout=\"column\"><div class=\"layout-list-item\" \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"report in vm.reports\" ng-click=\"vm.changeReport(report);\" \nng-class=\"{\'selected-report\': vm.selectedReport.token == report.token}\" aria-label=\"{{report.title}}\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon s24\"></md-icon><span class=\"ml-8\" flex>{{report.title}}</span></div></div>\n</div></v-pane-content></v-pane><v-pane><v-pane-header><div class=\"h2 font-weight-300\" flex>\n{{ \'REPORTS.TEMPLATES\' | translate }}</div></v-pane-header><v-pane-content><div id=\"layout-selector\"><div \nclass=\"layout-list\" layout=\"column\"><div class=\"layout-list-item\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"report in vm.reportsTemplates\" ng-click=\"vm.changeReport(report);\" \nng-class=\"{\'selected-template\': vm.selectedReport.token == report.token}\" aria-label=\"{{report.title}}\"><md-icon \nmd-font-icon=\"icon-format-color-fill\" class=\"icon s24\"></md-icon><span class=\"ml-8\" flex>{{report.title}}</span></div>\n</div></div></v-pane-content></v-pane></v-accordion><ul class=\"list\" \nng-if=\"vm.user.role===\'level04\' || vm.user.role===\'level05\'\"><li ng-repeat=\"report in vm.reports\" \nclass=\"dashboardItem\" ng-click=\"vm.changeReport(report);\" aria-label=\"{{report.title}}\" \nng-class=\"{\'md-primary-bg md-hue-3\': vm.selectedReport.token == report.token}\"><p style=\"margin-left:5px\"><md-icon \nmd-font-icon=\"icon-file-pdf\" class=\"icon s18\"></md-icon>{{report.title}}</p></li></ul></md-content></md-sidenav></div>\n</div></div>");
$templateCache.put("app/main/reports/report.html","<div id=\"reports\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"content-wrapper\" \nclass=\"md-primary-bg md-hue-3\"><div class=\"content sidenav\" layout=\"row\"><div hide show-md show-sm show-xs><button \nclass=\"toggle-left-sidenav\" type=\"button\" ng-click=\"vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"Toggle\"><md-icon \nclass=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button></div><div hide show-gt-md>\n<button class=\"toggle-left-sidenav md-accent\" type=\"button\" ng-click=\"vm.lockLeft=!vm.lockLeft\" aria-label=\"Toggle\">\n<md-icon class=\"s20\" md-font-icon=\"icon-arrow-right-bold\" aria-hidden=\"true\"></md-icon></button></div><md-sidenav \nclass=\"sidenav sidenav-width-300 md-sidenav-left\" md-is-locked-open=\"vm.lockLeft && $mdMedia(\'gt-md\')\" \nmd-component-id=\"left-sidenav\" md-disable-backdrop ms-scroll ms-sidenav-helper><md-toolbar \nclass=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding><div class=\"toolbar\"><div hide \nshow-gt-md><md-icon ng-click=\"vm.changeStatusL(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" \naria-hidden=\"true\" style=\"color: #fff\"></md-icon></div><div hide show-md show-sm show-xs><md-icon \nng-click=\"vm.toggleClose(\'left-sidenav\')\" class=\"s16 sidhov\" md-font-icon=\"icon-arrow-left-bold\" aria-hidden=\"true\" \nstyle=\"color: #fff\"></md-icon></div></div><div class=\"heading\" style=\"font-weight: 300; padding-top: 10px\">\n{{ \'REPORTS.TOOLS\' | translate }}</div></md-toolbar><md-content class=\"content md-background-bg md-hue-1\" ms-scroll \nlayout-padding><v-accordion class=\"vAccordion--default\"><v-pane expanded><v-pane-header><div class=\"h2\" \nstyle=\"font-weight: 300\" flex>Layouts</div></v-pane-header><v-pane-content><div id=\"layout-selector\"><div \nclass=\"layout-list\" layout=\"row\" layout-align=\"center center\" layout-wrap><div class=\"layout-list-item\" \nlayout=\"column\" layout-align=\"center center\" ng-repeat=\"layout in vm.layouts\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"icon s48\"></md-icon></div></div></div></v-pane-content></v-pane><v-pane>\n<v-pane-header><div class=\"h2\" style=\"font-weight: 300\" flex>Blocks</div></v-pane-header><v-pane-content>\n</v-pane-content></v-pane></v-accordion></md-content></md-sidenav><div layout=\"column\" class=\"page-content\" ms-scroll \nflex><div class=\"top-toolbar md-background-bg md-hue-1\" layout=\"row\" layout-xs=\"column\" layout-align=\"start center\">\n<div layout=\"row\" layout-align=\"start center\" flex><div class=\"daterange-wrapper md-background-border md-hue-1\"><div \nclass=\"daterange\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-calendar\" class=\"icon\" \naria-hidden=\"true\"></md-icon><input flex date-range-picker id=\"daterange\" name=\"daterange\" \nclass=\"form-control date-picker md-background-bg md-hue-1\" type=\"text\" ng-model=\"vm.date\" options=\"vm.dateOptions\">\n</div></div></div></div><div flex><div><div layout=\"row\" flex><div class=\"h1\" \nstyle=\"font-weight: 300; padding: 16px 26px\" flex>{{vm.report.name}}</div><div style=\"padding: 8px 26px\"><button \nng-click=\"vm.zoomDocument(\'in\')\" class=\"md-button\" aria-label=\"Zoom in\" ng-disabled=\"!vm.report.pages.length\" \nstyle=\"min-width: 36px; border-radius: 4px; margin-right: 0\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"REPORTS.ZOOM_IN\">Zoom in</span></md-tooltip><md-icon class=\"s16\" md-font-icon=\"icon-plus\"></md-icon>\n</button> <button ng-disabled=\"vm.zoom <= 0.1\" ng-click=\"vm.zoomDocument(\'out\')\" class=\"md-button\" \naria-label=\"Zoom out\" ng-disabled=\"!vm.report.pages.length\" \nstyle=\"min-width: 36px; border-radius: 4px; margin-left: 0\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"REPORTS.ZOOM_OUT\">Zoom out</span></md-tooltip><md-icon class=\"s16\" md-font-icon=\"icon-minus\"></md-icon>\n</button> <button ng-click=\"vm.logModel()\" class=\"md-button md-raised md-accent\" disabled=\"disabled\" \naria-label=\"Download CSV\" ng-disabled=\"!vm.report.pages.length\" style=\"min-width: 36px; border-radius: 4px\"><md-tooltip\n md-direction=\"top\"><span translate=\"BREAKDOWN.DOWNLOAD_CSV\">Download CSV</span></md-tooltip><md-icon class=\"s16\" \nmd-font-icon=\"icon-download\"></md-icon></button> <button ng-click=\"vm.downloadPDF()\" \nclass=\"md-button md-raised md-accent\" disabled=\"disabled\" aria-label=\"Download CSV\" \nng-disabled=\"!vm.report.pages.length\" style=\"min-width: 36px; border-radius: 4px\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"BREAKDOWN.DOWNLOAD_CSV\">Download CSV</span></md-tooltip><md-icon class=\"s16\" md-font-icon=\"icon-download\">\n</md-icon></button></div></div></div><div id=\"report-cnt\" style=\"padding: 16px\" layout=\"column\" flex \nlayout-align=\"start center\"><div id=\"report\"><div class=\"page-a4 md-white-bg md-whiteframe-4dp p-16\" flex \nng-repeat=\"page in vm.report.pages\" ng-init=\"i = $index + 1\"><div class=\"page\"><div class=\"header\"><div \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.report.header\"></div></div><div class=\"content\"><div \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"page.content\" data-page=\"{{i}}\"></div></div><div class=\"footer\"><div \nui-tinymce=\"vm.tinymceOptions\" ng-model=\"vm.report.footer\"></div></div></div><div class=\"html2pdf__page-break\"></div>\n</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/reports/reports.html","<div id=\"reports\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"content-wrapper\" \nclass=\"md-primary-bg md-hue-3\"><div class=\"content sidenav\" layout=\"row\"><div layout=\"column\" class=\"page-content\" \nms-scroll flex><div layout=\"column\" flex><div><div layout=\"row\" flex><div class=\"h1\" \nstyle=\"font-weight: 300; padding: 16px 26px\" flex translate=\"REPORTS.TITLE\">Reports</div></div></div><div \nid=\"report-selector\" layout=\"column\" layout-align=\"start center\" flex><div class=\"report-list\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div class=\"report-list-item\" ng-repeat=\"report in vm.reports\" \nui-sref=\"app.reports.report({id:report.id})\" layout=\"column\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"icon s64\"></md-icon><div class=\"report-name\">{{report.name}}</div></div><div \nclass=\"report-list-item add-new-report\" layout=\"column\" layout-align=\"center center\" ui-sref=\"app.reports.addReport\">\n<md-icon md-font-icon=\"icon-plus-circle\" class=\"icon s64\"></md-icon><div class=\"report-name\" \ntranslate=\"REPORTS.ADD_NEW\">Add new report</div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/rules/rules.html","<div id=\"rules\" class=\"pragma-page-layout\" layout=\"column\" ms-scroll flex><div id=\"content-wrapper\" \nclass=\"md-primary-bg md-hue-3\"><div class=\"content\" layout=\"row\"><div class=\"page-content\" ms-scroll flex><div \nclass=\"p-16\" ng-if=\"vm.ruleShow==0\" layout=\"column\" flex><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"custom-icon-button-wrapper\"><md-button flow-btn class=\"add-button md-icon-button\" \nng-click=\"vm.openNewRuleDialog($event)\" aria-label=\"Create New Rule\" translate \ntranslate-attr-aria-label=\"RULES.CREATE_NEW_RULE\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"RULES.CREATE_NEW_RULE\">Create New Rule</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" \naria-hidden=\"true\"></md-icon></md-button></div><div class=\"pb-8\" layout=\"column\" flex><h1 class=\"m-0\" \ntranslate=\"RULES.RULES_TITLE\">Rules Engine</h1></div></div><div layout=\"row\" layout-align=\"end center\"><div \nclass=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\" aria-hidden=\"true\"></md-icon><input class=\"md-background-bg md-hue-1\" \nflex type=\"text\" ng-model=\"vm.rulesTable.filter.search\" placeholder=\"{{ \'RULES.RULES_SEARCH\' | translate}}\"></div>\n</div></div><div class=\"md-background-bg md-hue-1 md-whiteframe-4dp\"><md-table-container><table data-md-table \nmd-progress=\"promise\"><thead md-head ng-if=\"!vm.rulesTable.options.decapitate\" \ndata-md-order=\"vm.rulesTable.query.order\"><tr md-row><th md-column></th><th md-column md:order:by=\"title\"><span \ntranslate=\"RULES.TITLE\">Title</span></th><th md-column md:order:by=\"createdDate\"><span translate=\"RULES.CREATE_DATE\">\nCreated</span></th><th md-column md:order:by=\"updatedDate\"><span translate=\"RULES.UPDATE_DATE\">Modified</span></th><th \nmd-column md:order:by=\"status\"><span translate=\"RULES.STATUS\">Status</span></th><th md-column><span \ntranslate=\"RULES.ACTIONS\">Actions</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"vm.rules.length == 0\"><td \nmd-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"RULES.MESSAGE.NO_DATA\">\nNo data available in table...</h3><p translate=\"RULES.MESSAGE.CREATE_NEW_RULE\">\nClick on the \'Create New Rule\' button to add a new rule.</p></div></td></tr><tr md-row \nng-if=\"vm.rules.length && vm.rulesTable.filter.search && !(vm.rules|filter:vm.rulesTable.filter.search).length\"><td \nmd-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 translate=\"RULES.MESSAGE.NOTHING\">Nothing found...</h3>\n</div></td></tr><tr md-row \ndata-ng-repeat=\"rule in vm.rules | filter: vm.rulesTable.filter.search | orderBy: vm.rulesTable.query.order | limitTo: vm.rulesTable.query.limit : (vm.rulesTable.query.page - 1) * vm.rulesTable.query.limit\">\n<td md-cell><div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" ng-click=\"vm.manageRule(rule)\" \naria-label=\"Manage Rule\" translate translate-attr-aria-label=\"RULES.MANAGE_RULE\"><md-tooltip md-direction=\"right\"><span\n translate=\"RULES.MANAGE_RULE\">Manage Rule</span></md-tooltip><md-icon md-font-icon=\"icon-ruler\" aria-hidden=\"true\">\n</md-icon></md-button></div></td><td md-cell>{{rule.title}}<br><small>{{rule.description | htmlToPlaintext}}</small>\n</td><td md-cell>{{rule.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td md-cell>\n{{rule.updatedDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td md-cell ng-if=\"rule.status == \'incomplete\'\"><md-icon \nng-class=\"vm.statusIndicator[\'incomplete\'].class\" md-font-icon=\"icon-check-circle\" aria-hidden=\"true\"></md-icon>&nbsp;\n<span class=\"small\" ng-class=\"vm.statusIndicator[\'incomplete\'].class\">{{vm.statusIndicator[\'incomplete\'].title}}</span>\n</td><td md-cell ng-if=\"rule.status == \'complete\' && rule.active\"><md-icon \nng-class=\"vm.activeIndicator[\'active\'].class\" md-font-icon=\"icon-power\" aria-hidden=\"true\"></md-icon>&nbsp;<span \nclass=\"small\" ng-class=\"vm.activeIndicator[\'active\'].class\">{{vm.activeIndicator[\'active\'].title}}</span></td><td \nmd-cell ng-if=\"rule.status == \'complete\' && !rule.active\"><md-icon ng-class=\"vm.activeIndicator[\'inactive\'].class\" \nmd-font-icon=\"icon-power\" aria-hidden=\"true\"></md-icon>&nbsp;<span class=\"small\" \nng-class=\"vm.activeIndicator[\'inactive\'].class\">{{vm.activeIndicator[\'inactive\'].title}}</span></td><td md-cell>\n<md-button class=\"md-icon-button\" ng-click=\"vm.openCopyRuleDialog($event, rule)\" aria-label=\"Copy Rule\" translate \ntranslate-attr-aria-label=\"RULES.COPY_RULE\"><md-tooltip md-direction=\"top\"><span translate=\"RULES.COPY_RULE\">Copy Rule\n</span></md-tooltip><md-icon md-font-icon=\"icon-content-duplicate\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.openEditRuleDialog($event, rule)\" aria-label=\"Edit Rule\" translate \ntranslate-attr-aria-label=\"RULES.EDIT_RULE\"><md-tooltip md-direction=\"top\"><span translate=\"RULES.EDIT_RULE\">Edit Rule\n</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.openDeleteRuleDialog($event, rule)\" aria-label=\"Delete Rule\" translate \ntranslate-attr-aria-label=\"RULES.DELETE_RULE\"><md-tooltip md-direction=\"top\"><span translate=\"RULES.DELETE_RULE\">\nDelete Rule</span></md-tooltip><md-icon md-font-icon=\"icon-delete\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.manageRule(rule)\" aria-label=\"Manage Rule\" translate \ntranslate-attr-aria-label=\"RULES.MANAGE_RULE\"><md-tooltip md-direction=\"top\"><span translate=\"RULES.MANAGE_RULE\">\nManage Rule</span></md-tooltip><md-icon md-font-icon=\"icon-ruler\" aria-hidden=\"true\"></md-icon></md-button></td></tr>\n</tbody></table></md-table-container></div><data-md-table-pagination md-limit=\"vm.rulesTable.query.limit\" \nmd-limit-options=\"vm.rulesTable.limitOptions\" md-page=\"vm.rulesTable.query.page\" \nmd-total=\"{{(vm.rules|filter:vm.rulesTable.filter.search).length}}\" \nmd-boundary-links=\"vm.rulesTable.options.boundaryLinks\"></data-md-table-pagination></div><div \nclass=\"p-16 manage animate-slide-down-hide\" ng-if=\"vm.ruleShow==1\" layout=\"column\" flex><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"custom-icon-button-wrapper\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.ruleShow=0\" aria-label=\"Close Rule Management\" translate \ntranslate-attr-aria-label=\"RULES.MANAGE_CLOSE\"><md-tooltip md-direction=\"left\"><span translate=\"RULES.MANAGE_CLOSE\">\nClose Rule Management</span></md-tooltip><md-icon md-font-icon=\"icon-chevron-left\" aria-hidden=\"true\"></md-icon>\n</md-button></div><div layout=\"column\" layout=\"column\" flex><h1 class=\"m-0\"><span translate=\"RULES.MANAGE_RULE\">\nManage Rule</span>: {{vm.currentRule.title}}</h1><p class=\"m-0\">{{vm.currentRule.description | htmlToPlaintext}}</p>\n</div></div><div class=\"md-background-bg md-hue-1\"><form ms-horizontal-stepper name=\"ruleForm\" \nng-model=\"vm.currentRule\" ng-submit=\"vm.submitRule()\" linear=\"vm.isLinear\" novalidate><ms-horizontal-stepper-step \nng-form=\"measurementsForm\" step=\"1\" step-title=\"\'RULES.STEPPER.MEASUREMENTS\'\"><div layout=\"column\" \nclass=\"step-header pb-16\"><h2>{{ \'RULES.STEPPER.MEASUREMENTS\' | translate }}</h2><h3>\n{{ \'RULES.STEPPER.MEASUREMENTS_INFO\' | translate }}</h3><p class=\"small\">\n{{ \'RULES.STEPPER.MEASUREMENTS_INFO_MORE\' | translate }}</p></div><div class=\"step-content\" layout=\"row\" layout-wrap>\n<md-card ng-if=\"vm.currentRule.variableLibrary.length > 0\" ng-repeat=\"variable in vm.currentRule.variableLibrary\" \nflex=\"22\"><md-card-header class=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"h4 m-0\">{{ \'RULES.VARIABLE\' | translate}}</span> <span class=\"h4 m-0\">&nbsp;</span></md-card-header>\n<md-card-content class=\"secondary-text addVariable\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon class=\"mr-8\" md-font-icon=\"icon-pulse\" aria-hidden=\"true\"></md-icon><span class=\"h2\" flex>\n{{variable.variableName}}&nbsp;{{variable.specs.unit}}</span></div><span class=\"small\">\n{{variable.siteName}} / {{variable.parentDeviceText}} / {{variable.specs.friendlyName}}</span></md-card-content>\n<md-card-footer layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.removeVariable($index)\" aria-label=\"Remove Variable\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"RULES.REMOVE_VARIABLE\">Remove Variable</span></md-tooltip><md-icon md-font-icon=\"icon-close\" \naria-hidden=\"true\"></md-icon></md-button></md-card-footer></md-card><md-card flex=\"22\"><md-card-content \nclass=\"addVariable\" layout=\"row\" layout-align=\"center center\" style=\"min-height:200px\"><md-button \nclass=\"md-fab md-primary md-hue-3 md-icon-button\" ng-click=\"vm.openNewVariableDialog($event)\" \naria-label=\"New Variable\"><md-tooltip md-direction=\"top\"><span translate=\"RULES.NEW_VARIABLE\">New Variable</span>\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></md-button><input \nng-if=\"!vm.currentRule.variableLibrary.length > 0\" type=\"hidden\" name=\"library\" ng-model=\"library\" ng-required=\"true\">\n</md-card-content></md-card></div></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"conditionsForm\" \nstep=\"2\" step-title=\"\'RULES.STEPPER.CONDITIONS\'\"><div layout=\"column\" class=\"step-header pb-16\"><h2>\n{{ \'RULES.STEPPER.CONDITIONS\' | translate }}</h2><h3>{{ \'RULES.STEPPER.CONDITIONS_INFO\' | translate }}</h3><p \nclass=\"small\">{{ \'RULES.STEPPER.CONDITIONS_INFO_MORE\' | translate }}</p></div><div class=\"step-content\" layout=\"row\" \nlayout-wrap><md-card ng-if=\"vm.currentRule.conditions.length > 0\" ng-repeat=\"condition in vm.currentRule.conditions\" \nflex=\"22\"><md-card-header class=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"h4 m-0\">{{ \'RULES.CONDITION\' | translate}}</span> <span class=\"h3 m-0\" ng-if=\"$index != 0\">\n{{condition.argument | uppercase}}</span></md-card-header><md-card-content class=\"addCondition secondary-text\" \nlayout=\"column\"><div><div class=\"h2 m-0\" \nng-repeat=\"variable in vm.currentRule.variableLibrary | filter: {id:condition.firstPart.variable}\">\n{{variable.variableName}}</div><div class=\"small\" ng-if=\"condition.firstPart.statistical == \'CUR\'\" layout=\"row\"><span \nclass=\"pr-8\" ng-repeat=\"statistical in vm.statisticalRules | filter: {id:condition.firstPart.statistical}\">\n{{statistical.title}}</span></div><div class=\"small\" ng-if=\"condition.firstPart.statistical != \'CUR\'\" layout=\"row\">\n<span class=\"pr-8\" ng-repeat=\"statistical in vm.statisticalRules | filter: {id:condition.firstPart.statistical}\">\n{{statistical.title}}</span> <span class=\"pr-8\">{{ \'RULES.EVERY\' | translate }}</span> <span class=\"pr-8\">\n{{condition.firstPart.duration.value}}</span> <span \nng-repeat=\"duration in vm.statisticalDurationTypes | filter: {id:condition.firstPart.duration.type} : true\">\n{{duration.title}}</span></div></div><div class=\"h1\">{{condition.relation}}</div><div><div class=\"h2 m-0\" \nng-if=\"condition.secondPart.type == \'value\'\">{{condition.secondPart.value}}</div><div \nng-if=\"condition.secondPart.type == \'variable\'\"><div class=\"h2 m-0\" \nng-repeat=\"variable in vm.currentRule.variableLibrary | filter: {id:condition.secondPart.variable}\">\n{{variable.variableName}}</div><div class=\"small\" ng-if=\"condition.secondPart.statistical == \'CUR\'\"><span \nng-repeat=\"statistical in vm.statisticalRules | filter: {id:condition.secondPart.statistical}\">{{statistical.title}}\n</span></div><div class=\"small\" ng-if=\"condition.secondPart.statistical != \'CUR\'\" layout=\"row\"><span class=\"pr-8\" \nng-repeat=\"statistical in vm.statisticalRules | filter: {id:condition.secondPart.statistical}\">{{statistical.title}}\n</span> <span class=\"pr-8\">{{ \'RULES.EVERY\' | translate }}</span> <span class=\"pr-8\">\n{{condition.secondPart.duration.value}}</span> <span \nng-repeat=\"duration in vm.statisticalDurationTypes | filter: {id:condition.secondPart.duration.type} : true\">\n{{duration.title}}</span></div></div></div></md-card-content><md-card-footer layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-icon-button m-0\" \nng-click=\"vm.openEditConditionDialog($event, $index, condition, vm.currentRule.variableLibrary)\" \naria-label=\"Edit Condition\"><md-tooltip md-direction=\"top\"><span translate=\"RULES.EDIT_CONDITION\">Edit Condition</span>\n</md-tooltip><md-icon md-font-icon=\"icon-pencil\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button m-0\" ng-click=\"vm.removeCondition($index)\" aria-label=\"Remove Condition\"><md-tooltip \nmd-direction=\"top\"><span translate=\"RULES.REMOVE_CONDITION\">Remove Condition</span></md-tooltip><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></md-card-footer></md-card><md-card flex=\"22\">\n<md-card-content class=\"addCondition\" layout=\"row\" layout-align=\"center center\" style=\"min-height:250px\"><md-button \nclass=\"md-fab md-primary md-hue-3 md-icon-button\" ng-if=\"vm.currentRule.variableLibrary.length\" \nng-click=\"vm.openNewConditionDialog($event, vm.currentRule.conditions.length, vm.currentRule.variableLibrary)\" \naria-label=\"New Condition\"><md-tooltip md-direction=\"top\"><span translate=\"RULES.NEW_CONDITION\">New Condition</span>\n</md-tooltip><md-icon md-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></md-button><input \nng-if=\"vm.currentRule.conditions.length == 0\" type=\"hidden\" name=\"conditions\" ng-model=\"conditions\" ng-required=\"true\">\n</md-card-content></md-card></div></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"actionsForm\" \nstep=\"3\" step-title=\"\'RULES.STEPPER.ACTIONS\'\"><div layout=\"column\" class=\"step-header pb-16\"><h2>\n{{ \'RULES.STEPPER.ACTIONS\' | translate }}</h2><h3>{{ \'RULES.STEPPER.ACTIONS_INFO\' | translate }}</h3><p class=\"small\">\n{{ \'RULES.STEPPER.ACTIONS_INFO_MORE\' | translate }}</p></div><div class=\"step-content\" layout-gt-sm=\"row\" \nlayout=\"column\"><div layout=\"column\" flex><div class=\"md-primary-bg md-hue-2 heading\">\n{{ \'RULES.NOTIFY_REPETITION\' | translate }}</div><div layout=\"row\" flex><div class=\"input-block\"><md-input-container>\n<label><span translate=\"RULES.REPETITION_TYPE\">Duration Period</span></label><md-select \nname=\"repetitionType{{$index}}\" ng-model=\"vm.currentRule.actions.repetition.type\" \nng-required=\"{{vm.currentRule.actions.repetition.value && vm.currentRule.actions.repetition.times}}\"><md-option \nng-value=\"durationType.id\" ng-repeat=\"durationType in vm.durationTypes\">{{ durationType.title }}</md-option>\n</md-select></md-input-container></div><div class=\"input-block\" ng-if=\"vm.currentRule.actions.repetition.type != \'no\'\">\n<md-input-container><label><span translate=\"RULES.NUMERICAL_VALUE\">Numerical Value</span></label><input type=\"number\" \nname=\"repetitionValue\" ng-model=\"vm.currentRule.actions.repetition.value\" \nng-required=\"vm.currentRule.actions.repetition.type != \'no\'\" ng-min=\"1\"><div \nng-messages=\"actionsForm.repetitionValue.$error\" ng-show=\"actionsForm.repetitionValue.$touched\"><div \nng-message=\"number\"><span translate=\"RULES.NUMERICAL_VALUE_ERROR_NUMBER\">Not a valid number</span></div><div \nng-message=\"min\"><span translate=\"RULES.NUMERICAL_VALUE_ERROR_MIN\">Below the minimum allowed number</span></div></div>\n</md-input-container></div><div class=\"input-block\" ng-if=\"vm.currentRule.actions.repetition.type != \'no\'\">\n<md-input-container><label><span translate=\"RULES.FOR\">For:</span></label><input type=\"number\" name=\"times\" \nng-model=\"vm.currentRule.actions.repetition.times\" ng-required=\"vm.currentRule.actions.repetition.type != \'no\'\" \nng-min=\"1\"><div ng-messages=\"actionsForm.times.$error\" ng-show=\"actionsForm.times.$touched\"><div ng-message=\"number\">\n<span translate=\"RULES.NUMERICAL_VALUE_ERROR_NUMBER\">Not a valid number</span></div><div ng-message=\"min\"><span \ntranslate=\"RULES.NUMERICAL_VALUE_ERROR_MIN\">Below the minimum allowed number</span></div></div></md-input-container>\n</div></div></div></div><div class=\"step-content\" layout-gt-sm=\"row\" layout=\"column\"><div layout=\"column\" flex><div \nclass=\"heading md-primary-bg md-hue-2\">{{ \'RULES.NOTIFY_VIA\' | translate }}</div><div class=\"notifications\" \nng-repeat=\"notification in vm.notifications\" layout=\"row\" layout-align=\"start center\"><md-input-container class=\"mt-0\">\n<md-checkbox ng-checked=\"vm.checkboxSelected(notification.id, vm.currentRule.actions.selectedNotifications)\" \nng-click=\"vm.checkboxToggle(notification.id, vm.currentRule.actions.selectedNotifications)\">{{notification.title}}\n</md-checkbox></md-input-container></div></div><div ng-if=\"vm.users\" layout=\"column\" flex><div \nclass=\"heading md-primary-bg md-hue-2\">{{ \'RULES.NOTIFY_OTHER_USERS\' | translate }}</div><select \nclass=\"md-primary-bg md-hue-3\" id=\"users\" size=\"8\" ng-model=\"vm.currentRule.sendTo.users\" \nng-options=\"user.username as user.firstName + \' \' + user.lastName for user in vm.users\" multiple=\"multiple\"><option \nvalue=\"\">-- {{ \'RULES.USERS_SELECT\' | translate }} --</option></select></div><div layout=\"column\" flex><div \nclass=\"heading md-primary-bg md-hue-2\" translate=\"RULES.NOTIFY_OTHER_EMAILS\">Notify Others By Email</div><div \nng-repeat=\"email in vm.currentRule.sendTo.emails track by $index\" class=\"input-block\"><md-input-container><input \nname=\"sendToemail{{$index}}\" ng-model=\"vm.currentRule.sendTo.emails[$index]\" type=\"email\" \nplaceholder=\"{{ \'ADMINISTRATION.EMAIL\' | translate }}\" ng-required=\"true\"><div \nng-messages=\"actionsForm[\'sendToemail\'+$index].$error\" ng-show=\"actionsForm[\'sendToemail\'+$index].$touched\"><div \nng-message=\"required\"><span translate=\"RULES.EMAIL_EMPTY_ERROR\">Please enter a valid email address</span></div><div \nng-message=\"email\"><span translate=\"RULES.EMAIL_ERROR\">Not a valid email address</span></div></div><md-icon \nng-click=\"vm.removeMailAccountField($index)\" md-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon>\n</md-input-container></div><md-button ng-click=\"vm.addMailAccountField()\" class=\"md-fab md-mini md-primary\" \naria-label=\"Add\"><md-icon md-font-icon=\"icon-plus\" aria-hidden=\"true\"></md-icon></md-button></div></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"expirationForm\" step=\"4\" \nstep-title=\"\'RULES.STEPPER.EXPIRATION\'\"><div layout=\"column\" class=\"step-header pb-16\"><h2 \ntranslate=\"RULES.STEPPER.EXPIRATION\">Expiration</h2><h3 translate=\"RULES.STEPPER.EXPIRATION_INFO\">\nDecide what you want to do if a Condition happens.</h3><p translate=\"RULES.STEPPER.EXPIRATION_INFO_MORE\">\nSelect the way you want to be notified. You can select controls in order for the system to automatically execute some actions.\n</p></div><div class=\"step-content\" layout=\"column\" flex><div class=\"md-primary-bg md-hue-2 p-16 mb-16\" layout=\"row\" \nlayout-align=\"space-between center\" flex><div flex>{{ \'RULES.ACTIVATION\' | translate }}</div><md-switch \nng-model=\"vm.currentRule.active\" aria-label=\"activation\" class=\"m-0\"><span ng-if=\"!vm.currentRule.active\">\n{{vm.activeIndicator[\'inactive\'].title}}</span> <span ng-if=\"vm.currentRule.active\">\n{{vm.activeIndicator[\'active\'].title}}</span></md-switch></div><div class=\"content\" layout-gt-sm=\"row\" \nlayout-align=\"space-between start\" layout=\"column\"><div layout=\"column\" flex><h3 class=\"m-0 font-weight-400\">\n{{ \'RULES.START_DATE\' | translate }}</h3><md-input-container><md-datepicker name=\"expirationStartDate\" \nng-model=\"vm.currentRule.expiration.startDate\" md-placeholder=\"{{RULES.ENTER_DATE}}\" ng-required=\"true\" \naria-label=\"exiration start date\"></md-datepicker><div ng-messages=\"expirationForm.expirationStartDate.$error\" \nng-show=\"expirationForm.expirationStartDate.$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.START_DATE_ERROR\">Please enter starting date</span></div></div></md-input-container></div><div \nlayout=\"column\" flex><h3 class=\"m-0 font-weight-400\">{{ \'RULES.SPECIFIC_TIME\' | translate }}</h3><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"input-block\"><md-icon md-font-icon=\"icon-clock\" aria-hidden=\"true\">\n</md-icon><md-input-container><label><span translate=\"RULES.FROM\">From:</span></label><input type=\"time\" \nname=\"specificTimeFrom{{$index}}\" ng-model=\"vm.currentRule.expiration.specificTime.from\" \nng-required=\"vm.currentRule.expiration.specificTime.to\"></md-input-container></div><div class=\"input-block\"><md-icon \nmd-font-icon=\"icon-clock\" aria-hidden=\"true\"></md-icon><md-input-container><label><span translate=\"RULES.TO\">To:</span>\n</label><input type=\"time\" name=\"specificTimeTo{{$index}}\" ng-model=\"vm.currentRule.expiration.specificTime.to\" \nng-required=\"vm.currentRule.expiration.specificTime.from\"></md-input-container></div></div></div><div layout=\"column\" \nflex><h3 class=\"m-0 font-weight-400\">{{ \'RULES.SPECIFIC_DAYS\' | translate }}</h3><md-input-container layout=\"row\" \nlayout-wrap><md-checkbox ng-repeat=\"day in vm.days\" \nng-checked=\"vm.checkboxSelected(day.id, vm.currentRule.expiration.specificDays)\" \nng-click=\"vm.checkboxToggle(day.id, vm.currentRule.expiration.specificDays)\">{{day.title}}</md-checkbox>\n</md-input-container></div></div></div><div class=\"step-content\" layout-gt-sm=\"row\" layout=\"column\"><div \nlayout=\"column\" flex><div class=\"md-primary-bg md-hue-2 heading\">{{ \'RULES.EXPIRATION\' | translate }}</div><div \nclass=\"content\" layout=\"column\" layout-padding><md-radio-group layout=\"row\" \nng-change=\"vm.changeExpiration(vm.currentRule.expiration.end.type)\" ng-model=\"vm.currentRule.expiration.end.type\" \nng-required=\"true\"><md-radio-button ng-value=\"expiration.id\" ng-repeat=\"expiration in vm.expirationOptions\">\n{{expiration.title}}</md-radio-button></md-radio-group><div ng-if=\"vm.currentRule.expiration.end.type == \'number\'\">\n<md-input-container><label><span translate=\"RULES.STEPPER.PERFORMANCES\">Performances</span></label><input \ntype=\"number\" name=\"expirationPerformances\" ng-model=\"vm.currentRule.expiration.end.value\" ng-min=\"1\" ng-max=\"10\" \nng-required=\"true\"><div ng-messages=\"expirationForm.expirationPerformances.$error\" \nng-show=\"expirationForm.expirationPerformances.$touched\"><div ng-message=\"number\"><span \ntranslate=\"RULES.NUMERICAL_VALUE_ERROR_NUMBER\">Not a valid number</span></div><div ng-message=\"min\"><span \ntranslate=\"RULES.NUMERICAL_VALUE_ERROR_MIN\">Below the minimum allowed number</span></div><div ng-message=\"max\"><span \ntranslate=\"RULES.NUMERICAL_VALUE_ERROR_MAX\">Exceeded the maximum allowed number</span></div></div></md-input-container>\n</div><div ng-if=\"vm.currentRule.expiration.end.type == \'date\'\"><md-input-container><md-datepicker \nname=\"expirationEndDate\" ng-model=\"vm.currentRule.expiration.end.value\" md-placeholder=\"{{RULES.ENTER_DATE}}\" \nng-required=\"true\"></md-datepicker><div ng-messages=\"expirationForm.expirationEndDate.$error\" \nng-show=\"expirationForm.expirationEndDate.$touched\"><div ng-message=\"required\"><span translate=\"RULES.END_DATE_ERROR\">\nPlease enter ending date</span></div></div></md-input-container></div></div></div></div></ms-horizontal-stepper-step>\n</form></div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login\" layout=\"row\" layout-align=\"start\"><div id=\"login-intro\" flex hide show-gt-sm \nstyle=\"background: #628b45 url(\'assets/images/backgrounds/login-bg.png\') bottom left no-repeat; background-size: 100%\">\n<div class=\"title\" translate=\"LOGIN.INTRO_TITLE\" style=\"color: #cdd3dd\">Welcome to Smart Energy!</div><div \nclass=\"description\" translate=\"LOGIN.INTRO_DESCRIPTION\" style=\"color: #cfddcd\"><strong>Smart Energy</strong>\n offers you valuable features to help you save energy, lower your bills, and budget better than ever before.</div>\n</div><div id=\"login-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll style=\"background: #cfddcd\"><div\n id=\"login-form\"><div class=\"title\" translate=\"LOGIN.TITLE\" style=\"color: #242e42\">Log in to your account</div><div \nclass=\"description\" translate=\"LOGIN.DESCRIPTION\" style=\"color: #242e42\">Please provide your credentials...</div><form \nname=\"loginForm\"><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"username\" \nng-model=\"vm.form.username\" placeholder=\"Username\" translate translate-attr-placeholder=\"LOGIN.USERNAME\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-align=\"space-between center\"><md-checkbox class=\"remember-me\" \nng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\" style=\"color: #242e42\">Remember Me\n</span></md-checkbox><a href=\"#\" ng-click=\"vm.openForgotPassDialog($event)\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" ng-click=\"vm.handleLogin()\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\" style=\"text-transform: none\">LOG IN</md-button>\n</form></div></div></div>");
$templateCache.put("app/main/compare/dialogs/compare-filter.html","<md-dialog class=\"compare-filter-dialog\" aria-label=\"Filters\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"COMPARE.FILTERS\">Filters</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-tabs \nmd-dynamic-height md-selected=\"vm.selectedTab\" style=\"background-color: #fff\"><md-tab><md-tab-label><span \ntranslate=\"COMPARE.FILTER.TIME_SCHEDULE\">Time schedule</span></md-tab-label><md-tab-body><div class=\"m-16\"><table \ncellpadding=\"0\" cellspacing=\"0\" class=\"schedulePicker\" id=\"schedulePicker\"><thead><tr><th></th><th class=\"th-time\" \nng-repeat=\"time in vm.filter.schedule.times\">{{time}}</th></tr></thead><tbody><tr ng-init=\"i = $index\" \nng-repeat=\"day in vm.filter.schedule.days\"><th class=\"th-day\">{{day}}</th><td ng-init=\"j = $index\" \nng-repeat=\"time in vm.filter.schedule.times\" data-i=\"{{i}}\" data-j=\"{{j}}\">&nbsp;</td></tr></tbody></table></div>\n</md-tab-body></md-tab></md-tabs><md-dialog-actions layout=\"row\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.apply()\" aria-label=\"Apply\" \ntranslate translate-attr-aria-label=\"BREAKDOWN.APPLY\"><span translate=\"BREAKDOWN.APPLY\">Apply</span></md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/events/templates/event-card.html","<div class=\"event-card md-background-bg md-hue-1\"><div class=\"content pb-0 ph-16 pt-24\"><div class=\"title h3\" \nng-if=\"card.title\">{{card.title}}</div></div><div class=\"chart p-16\"><canvas class=\"chart chart-bar\" \nchart-data=\"card.barChart.data\" chart-labels=\"card.barChart.labels\" chart-colors=\"[\'#d70206\', \'#f05b4f\']\" \nchart-options=\"card.barChart.options\"></canvas><p class=\"caption\" translate=\"EVENTS.AVG_DAILY_COST\">\nAverage daily cost before / after event</p></div></div>");
$templateCache.put("app/main/notification/templates/notification-card.html","<div class=\"notification-card\" ng-style=\'{\"background-color\":card.color,\"color\":\"#fff\"}\'><div \nclass=\"content pb-0 ph-16 pt-24\"><div class=\"title h3\" ng-if=\"card.title\">{{card.title}}</div></div><div \nclass=\"chart p-16\"><p class=\"caption\">{{card.message}}</p></div></div>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><a href=\"home\"><img src=\"{{vm.user.logo}}\" style=\"height: 50px\"></a></div><div\n class=\"toolbar-separator\" hide show-gt-sm></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img gravatar-src-once=\"vm.user.email\" md-menu-align-target class=\"avatar\"><div \nclass=\"notificationCircle\"><span class=\"notificationNumber\">{{vm.notifications.count}}</span></div></div><span \nclass=\"username\" show-gt-sm>{{vm.user.firstname}} {{vm.user.lastname}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.notification\"><md-icon \nmd-font-icon=\"icon-bell\" class=\"icon\"></md-icon><md-button>Notifications</md-button></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button\n ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"row\" layout-align=\"start center\"><div\n class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon class=\"secondary-text\" md-font-icon=\"icon-menu\"></md-icon></md-button>\n</div><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><a href=\"home\"><img src=\"{{vm.logo}}\" \nstyle=\"width:200px\"></a></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><md-menu id=\"notifications-menu\" md-position-mode=\"left bottom\"><md-button \nclass=\"notifications-button\" ng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<notification-icon animation=\"bounce\" disappear-animation=\"bounce\" count=\"vm.unseenNotifications.length\"><md-icon \nmd-font-icon=\"icon-bell\" class=\"icon\"></md-icon></notification-icon></md-button><md-menu-content \nstyle=\"max-width:600px\" id=\"language-menu-content\"><md-button ng-click=\"vm.checkAllSeen()\" \nng-if=\"vm.unseenNotifications.length>0\" translate=\"NOTIFICATION.MARK_AS_READ\">Mark All As Read</md-button><md-list>\n<md-list-item class=\"md-2-line\" ng-style=\"!notification.seen && {\'background-color\':\'#e5e5e5\'}\" \nng-repeat=\"notification in vm.allNotifications | limitTo: 5\" ng-click=\"vm.seenNotification(notification)\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" style=\"color: #5cb85c; margin-right: 16px\" class=\"icon\" \nng-if=\"notification.type==\'Success\'\"></md-icon><md-icon md-font-icon=\"icon-information\" \nstyle=\"color: #5bc0de; margin-right: 16px\" class=\"icon\" ng-if=\"notification.type==\'Info\'\"></md-icon><md-icon \nmd-font-icon=\"icon-alert\" style=\"color: #f0ad4e; margin-right: 16px\" class=\"icon\" ng-if=\"notification.type==\'Warning\'\">\n</md-icon><md-icon md-font-icon=\"icon-alert-octagon\" style=\"color: #d9534f; margin-right: 16px\" class=\"icon\" \nng-if=\"notification.type==\'Error\'\"></md-icon><div class=\"md-list-item-text\" layout=\"column\"><h3>{{notification.title}}\n</h3><p>{{notification.message}}</p></div><md-divider></md-divider></md-list-item></md-list><md-button \nclass=\"md-button md-primary\" ui-sref=\"app.notification\" translate=\"NOTIFICATION.VIEW_ALL\">View All Notifications\n</md-button></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\" layout=\"row\" layout-align=\"center center\"><img gravatar-src-once=\"vm.user.email\" \ngravatar-default=\"https://hydra.iti.gr/assets/profile.jpg\" md-menu-align-target class=\"avatar\"></div><span \nclass=\"username secondary-text\" show-gt-sm>{{vm.user.firstname}} {{vm.user.lastname}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content \nid=\"user-menu-content\" width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.preferences\"><md-icon \nmd-font-icon=\"icon-monitor\" class=\"icon\"></md-icon><md-button><span>{{ \'TOOLBAR.PREFERENCES\' | translate }}</span>\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">{{ \'TOOLBAR.LOGOUT\' | translate }}\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<a href=\"home\"><img src=\"{{vm.user.logo}}\" style=\"height: 50px; margin: 0 20px\"></a></div><div \nclass=\"toolbar-separator\" hide show-gt-sm></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img gravatar-src-once=\"vm.user.email\" \ngravatar-default=\"https://hydra.iti.gr/assets/profile.jpg\" md-menu-align-target class=\"avatar\"><div \nclass=\"notificationCircle\" ng-show=\"vm.notifications.count\"><span class=\"notificationNumber\">{{vm.notifications.count}}\n</span></div></div><span class=\"username\" show-gt-sm>{{vm.user.firstname}} {{vm.user.lastname}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\" ui-sref=\"app.notification\"><md-icon md-font-icon=\"icon-bell\" class=\"icon\"></md-icon>\n<md-button>Notifications</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img gravatar-src-once=\"vm.user.email\" md-menu-align-target class=\"avatar\"><div \nclass=\"notificationCircle\"><span class=\"notificationNumber\">{{vm.notifications.count}}</span></div></div><span \nclass=\"username\" hide-sm>{{vm.user.firstname}} {{vm.user.lastname}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.notification\"><md-icon \nmd-font-icon=\"icon-bell\" class=\"icon\"></md-icon><md-button>Notifications</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.admin\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-button>Admin\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">E</span> <span class=\"logo-text\">PRAGMA</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img gravatar-src-once=\"vm.user.email\" md-menu-align-target class=\"avatar\"><div \nclass=\"notificationCircle\"><span class=\"notificationNumber\">{{vm.notifications.count}}</span></div></div><span \nclass=\"username\" hide-sm>{{vm.user.firstname}} {{vm.user.lastname}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.notification\"><md-icon \nmd-font-icon=\"icon-bell\" class=\"icon\"></md-icon><md-button>Notifications</md-button></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button\n ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal class=\"md-border md-background-bg md-hue-1\">\n</ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">E</span> <span class=\"logo-text\">\nPRAGMA Platform</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon class=\"secondary-text\" md-font-icon=\"icon-menu\"></md-icon></md-button>\n</div><ul class=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!node.hidden\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ng-if=\"node.uisref && node.group\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-fg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ng-if=\"!node.group\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/directives/ha-dishwasher/dialogs/Info/info.html","<md-dialog class=\"ha-info\" aria-label=\"Information\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"{{vm.program.icon}}\" class=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon><span \ntranslate=\"DASHBOARD.WIDGET.INFORMATION\">Information</span> ({{vm.program.name}})</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\">{{vm.program.descr}}</p></div></div><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"OK\">OK</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/directives/ha-dishwasher/dialogs/Options/options.html","<md-dialog class=\"ha-options\" aria-label=\"Options\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"{{vm.program.icon}}\" class=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon><span \ntranslate=\"DASHBOARD.WIDGET.OPTIONS\">Options</span> ({{vm.program.name}})</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-tooltip \nmd-direction=\"right\"><span>0 - 23 <span translate=\"DASHBOARD.WIDGET.HOURS\">hours</span></span></md-tooltip><label \nclass=\"first_letter\"><span translate=\"DASHBOARD.WIDGET.HOURS\">Hours</span></label><input ng-model=\"vm.program.hours\" \nng-change=\"vm.checkSecs(vm.program.hours, vm.program.mins)\" type=\"number\" step=\"1\" min=\"0\" max=\"23\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><md-tooltip md-direction=\"right\">\n<span>0 - 59 <span translate=\"DASHBOARD.WIDGET.MINS\">minutes</span></span></md-tooltip><label class=\"first_letter\">\n<span translate=\"DASHBOARD.WIDGET.MINS\">Minutes</span></label><input ng-model=\"vm.program.mins\" \nng-change=\"vm.checkSecs(vm.program.hours, vm.program.mins)\" type=\"number\" step=\"1\" min=\"0\" max=\"59\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><md-tooltip md-direction=\"right\">\n<span>0 - 59 <span translate=\"DASHBOARD.WIDGET.SECS\">seconds</span></span></md-tooltip><label class=\"first_letter\">\n<span translate=\"DASHBOARD.WIDGET.SECS\">Seconds</span></label><input ng-model=\"vm.program.secs\" \nng-disabled=\"vm.isDisabled\" type=\"number\" step=\"1\" min=\"0\" max=\"59\"></md-input-container></div></div><div layout=\"row\">\n<div class=\"input-block\" flex><span translate=\"DASHBOARD.WIDGET.MESSAGE.DELAYED\">\nIf this option is set, the program will be activated but not started until the defined time span elapses. Otherwise click apply to start the program directly.\n</span></div></div></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.applyOptions()\" aria-label=\"Save\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.APPLY\"><span \ntranslate=\"ADMINISTRATION.FORMS.APPLY\">Apply</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/directives/ha-dryer/dialogs/Info/info.html","<md-dialog class=\"ha-info\" aria-label=\"Information\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"{{vm.program.icon}}\" class=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon><span \ntranslate=\"DASHBOARD.WIDGET.INFORMATION\">Information</span> ({{vm.program.name}})</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\">{{vm.program.descr}}</p></div></div><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"OK\">OK</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/directives/ha-dryer/dialogs/Options/options.html","<md-dialog class=\"ha-options\" aria-label=\"Options\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"{{vm.program.icon}}\" class=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon><span \ntranslate=\"DASHBOARD.WIDGET.OPTIONS\">Options</span> ({{vm.program.name}})</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.DRYING_TARGET\">Drying Target</span></div><div ng-repeat=\"(key, Option) in vm.Options\">\n<label style=\"cursor: pointer\" ng-class=\"{checked: vm.program.optkey === key}\"><input class=\"hidden\" type=\"radio\" \nng-model=\"vm.program.optkey\" value=\"{{key}}\"> <span><md-icon md-font-icon=\"{{Option.icon}}\" \nng-class=\"{checked: vm.program.optkey === key}\" class=\"icon icon-size-32\" aria-hidden=\"true\"></md-icon>{{Option.name}}\n</span></label></div></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.applyOptions()\" aria-label=\"Save\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.APPLY\"><span \ntranslate=\"ADMINISTRATION.FORMS.APPLY\">Apply</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/directives/ha-laundry/dialogs/Info/info.html","<md-dialog class=\"ha-info\" aria-label=\"Information\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"{{vm.program.icon}}\" class=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon>\n{{vm.program.name}} Information</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\">{{vm.program.descr}}</p></div></div><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"OK\">OK</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/directives/ha-laundry/dialogs/Options/options.html","<md-dialog class=\"ha-options\" aria-label=\"Options\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"{{vm.program.icon}}\" class=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon><span \ntranslate=\"DASHBOARD.WIDGET.OPTIONS\">Options</span> {{vm.program.name}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div layout=\"column\" \nlayout-align=\"center stretch\"><div class=\"input-block\" flex><md-input-container flex=\"50\"><md-tooltip \nmd-direction=\"right\"><span translate=\"DASHBOARD.WIDGET.MESSAGE.OPTION_TEMP\">\nThis option defines the temperature of the washing program</span></md-tooltip><label><span \ntranslate=\"DASHBOARD.WIDGET.TEMP\">Temperature</span></label><md-select ng-model=\"vm.program.temperature\" \naria-label=\"Select Temperature\"><md-option ng-repeat=\"temp in vm.temperature[vm.program.key]\" ng-value=\"temp\">{{temp}}\n</md-option></md-select></md-input-container></div><div class=\"input-block\" flex><md-input-container flex=\"50\">\n<md-tooltip md-direction=\"right\"><span translate=\"DASHBOARD.WIDGET.MESSAGE.OPTION_SPEED\">\nThis option defines the maximum spinning speed in rpm</span></md-tooltip><label><span \ntranslate=\"DASHBOARD.WIDGET.SPIN\">Spin Speed</span></label><md-select ng-model=\"vm.program.rpm\" \naria-label=\"Select Spin Speed\"><md-option ng-repeat=\"speed in vm.rpm[vm.program.key]\" ng-value=\"speed\">{{speed}}\n</md-option></md-select></md-input-container></div></div></div></div><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.applyOptions()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.APPLY\"><span translate=\"ADMINISTRATION.FORMS.APPLY\">Apply</span>\n</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/dialogs/assignDevice/assign-device.html","<md-dialog class=\"new-user-dialog\" aria-label=\"New User\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.ASS_DVC\">Assign Device</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"row\" layout=\"column\"><div class=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span translate=\"ADMINISTRATION.DVC_ID\">Device ID</span></label><input ng-model=\"vm.assignment.deviceHardwareId\" \ntype=\"text\" ng-required=\"true\" ng-disabled=\"true\"></md-input-container></div><div class=\"input-block\" flex>\n<md-input-container class=\"md-icon-float md-block\"><label><span translate=\"ADMINISTRATION.ASS_TYPE\">Assignment Type\n</span></label><input ng-model=\"vm.assignment.assignmentType\" type=\"text\" ng-required=\"true\" ng-disabled=\"true\">\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.ASSET_PROVIDER\">Asset Provider</span></label><md-select \nng-model=\"vm.assignment.assetModuleId\" ng-required=\"true\" ng-change=\"vm.assetsFunction(vm.assignment.assetModuleId)\">\n<md-option ng-value=\"assetModule.id\" ng-repeat=\"assetModule in vm.assetModules\">{{assetModule.name}}</md-option>\n</md-select></md-input-container></div><div class=\"input-block\" flex><md-input-container \nclass=\"md-icon-float md-block\"><label><span translate=\"ADMINISTRATION.DEVICE_TYPE\">Device Type</span></label><md-select\n ng-model=\"vm.assignment.assetId\" ng-required=\"true\"><md-option ng-value=\"asset.id\" ng-repeat=\"asset in vm.assets\"><img\n src=\"{{asset.imageUrl}}\" width=\"30px\"> {{asset.name}}</md-option></md-select></md-input-container></div></div></div>\n</div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveAsset()\" aria-label=\"Save\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><md-icon md-font-icon=\"icon-floppy\" aria-hidden=\"true\">\n</md-icon><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteAsset/delete-asset.html","<md-dialog aria-label=\"Delete Asset Category\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.FORMS.DELETE_ASS_CAT\">\nDelete Asset Category</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_ASSET\">Are you sure you want to permanently delete Asset Category:\n</span> {{vm.asset.name}} ?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" \nng-click=\"vm.confirmDialog()\">OK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span\n translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteAssetCategory/delete-asset-category.html","<md-dialog aria-label=\"Delete Asset\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.FORMS.DELETE_ASS_CAT\">\nDelete Asset</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_ASS_CAT\">Are you sure you want to permanently delete Asset:</span>\n {{vm.assetCategory.name}} <span translate=\"ADMINISTRATION.FORMS.MESSAGES.OF_TYPE\">of type:</span> {{vm.type}} ?</p>\n</div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.confirmDialog()\">OK\n</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancel\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span \ntranslate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteCost/delete-cost.html","<md-dialog aria-label=\"Delete Cost\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.DELETE_COST\">Delete Cost\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_COST\">Are you sure you want to permanently delete cost:</span>\n \"{{vm.cost.name}}\"?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.confirmDialog()\">OK\n</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancel\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span \ntranslate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteCostProfile/delete-costProfile.html","<md-dialog aria-label=\"Delete Cost Profile\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.DELETE_COST_PROFILE\">\nDelete Cost Profile</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_COST_PF\">Are you sure you want to permanently delete cost profile:\n</span> \"{{vm.costProfile.name}}\"?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" \nng-click=\"vm.confirmDialog()\">OK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span\n translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteDevice/delete-device.html","<md-dialog aria-label=\"Delete Device\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.DELETE_DVC\">\nDelete Device</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_DEVICE\">Are you sure you want to permanently delete Device:</span>\n {{vm.device.metadata.name}} ?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" \nng-click=\"vm.confirmDialog()\">OK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span\n translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteDeviceGroup/delete-device-group.html","<md-dialog aria-label=\"Delete Device Group\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.FORMS.DELETE_DEVICE_GROUP\">Delete Device Group</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"row\"><div layout=\"column\"><h3><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_DEVICE_GROUP\">\nAre you sure you want to permanently detete Device Group:</span> {{vm.deviceGroup.name}} ?</h3></div></div>\n<md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button\n class=\"ok-button md-primary md-raised\" ng-click=\"vm.confirmDialog()\">OK</md-button><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span>\n</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteDeviceGroupDevices/delete-device-group-device.html","<md-dialog aria-label=\"Remove Device\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.FORMS.REMOVE_DEVICE\">\nRemove Device</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\" ng-if=\"vm.device.type===\'device\'\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_RMV_DEVICE\">Are you sure you want to remove device:</span>\n \"{{vm.device.name}}\"<br><span translate=\"ADMINISTRATION.FORMS.MESSAGES.FROM_GROUP\">from Group:</span>\n \"{{vm.thisGroup.name}}\"?</p><p class=\"message\" ng-if=\"vm.device.type===\'group\'\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_RMV_GROUP\">Are you sure you want to remove group:</span>\n \"{{vm.device.name}}\"<br><span translate=\"ADMINISTRATION.FORMS.MESSAGES.FROM_GROUP\">from Group:</span>\n \"{{vm.thisGroup.name}}\"?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" \nng-click=\"vm.confirmDialog()\">OK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span\n translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteNotification/delete-notification.html","<md-dialog aria-label=\"Delete Notification\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.DELETE_NOTIFICATION\">\nDelete Notification</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"content md-primary-bg md-hue-3\" \nms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_NOTIFICATION\">\nAre you sure you want to permanently delete Notification:</span> {{vm.notification.title}} ?</p></div></div>\n<md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button\n class=\"ok-button md-accent md-raised\" ng-click=\"vm.confirmDialog()\">OK</md-button><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span>\n</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteSite/delete-site.html","<md-dialog aria-label=\"Delete Building\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.FORMS.DELETE_SITE\">\nDelete Building</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_SITE\">Are you sure you want to permanently delete Building:</span>\n {{vm.site.name}} ?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.confirmDialog()\">OK\n</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancel\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span \ntranslate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteSiteGroup/delete-site-group.html","<md-dialog aria-label=\"Delete Portfolio\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.DELETE_PORTFOLIO\">\nDelete Portfolio</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_PORTFOLIO\">Are you sure you want to delete portfolio:</span>\n \"{{vm.deviceGroup.name}}\"?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" \nng-click=\"vm.confirmDialog()\">OK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span\n translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteSiteGroupSites/delete-site-group-site.html","<md-dialog aria-label=\"Remove Site\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.REMOVE_SITE\">Remove Site\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\"><span translate=\"ADMINISTRATION.FORMS.MESSAGES.RMV_SITE\">\nAre you sure you want to remove site:</span> \"{{vm.currentSite}}\"<br><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.FROM_PORTFOLIO\">from portfolio:</span> \"{{vm.thisGroup.name}}\"?</p></div>\n</div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.confirmDialog()\">OK</md-button><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span>\n</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteSpecification/delete-specification.html","<md-dialog aria-label=\"Delete Specification\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.DELETE_SPECIFICATION\">\nDelete Specification</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_SPEC\">Are you sure you want to permanently detete Specification:\n</span> {{vm.specification.name}} ?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" \nng-click=\"vm.confirmDialog()\">OK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span\n translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteTariff/delete-tariff.html","<md-dialog aria-label=\"Delete Tariff\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.FORMS.DELETE_TARIFF\">\nDelete Tariff</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_TARIFF\">Are you sure you want to permanently delete Tariff:</span>\n {{vm.tariff.name}}?</p></div></div><md-dialog-actions layout=\"row\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"ok-button md-accent md-raised\" ng-click=\"vm.confirmDialog()\">OK</md-button><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span>\n</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteTenant/delete-tenant.html","<md-dialog aria-label=\"Delete Client\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.DELETE_CLIENT\">\nDelete Client</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_CLIENT\">Are you sure you want to delete client:</span>\n \"{{vm.tenant.name}}\"?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.confirmDialog()\">OK\n</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancel\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span \ntranslate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteUser/delete-user.html","<md-dialog aria-label=\"Delete User\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.DELETE_USER\">Delete User\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_USER\">Are you sure you want to delete user:</span>\n \"{{vm.user.firstName}} {{vm.user.lastName}}\"?</p></div></div><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"ok-button md-primary md-raised\" ng-click=\"vm.confirmDialog()\">OK</md-button><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span>\n</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/dialogs/deleteVertical/delete-vertical.html","<md-dialog aria-label=\"Delete Vertical\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"ADMINISTRATION.DELETE_VERTICAL\">\nDelete Vertical Solution</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"ADMINISTRATION.FORMS.MESSAGES.CONFIRM_VERTICAL\">Are you sure you want to delete vertical solution:</span>\n \"{{vm.vertical.name}}\"?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" \nng-click=\"vm.confirmDialog()\">OK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span\n translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/dialogs/editAsset/edit-asset.html","<md-dialog class=\"edit-assetcat-dialog\" aria-label=\"Edit Asset Category\"><md-toolbar class=\"md-primary-bg md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.EDIT_AC\">Edit Asset Category</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.AC_NAME\">Asset Category Name</span></label><input ng-model=\"vm.asset.name\" type=\"text\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.AC_TYPE\">Asset Category Type</span></label><md-select ng-model=\"vm.asset.assetType\" \nng-required=\"true\"><md-option ng-value=\"assetType\" ng-repeat=\"assetType in vm.assetTypes\">{{assetType}}</md-option>\n</md-select></md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveAsset()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/editAssetCategory/edit-asset-category.html","<md-dialog class=\"edit-asset-dialog\" aria-label=\"Edit Asset\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.EDIT_ASSET\">Edit Asset</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"row\" layout=\"column\"><div class=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.assetCategory.name\" type=\"text\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.IMAGE\">Image</span></label><input type=\"text\" ng-model=\"vm.assetCategory.imageUrl\">\n</md-input-container></div></div><div layout=\"row\" ng-show=\"vm.type==\'Device\' || vm.type==\'Hardware\'\"><div \nclass=\"input-block\" flex><md-input-container flex><label>SKU</label><input ng-model=\"vm.assetCategory.sku\" type=\"text\" \nng-required=\"true\"></md-input-container></div></div><div layout=\"row\" \nng-show=\"vm.type==\'Device\' || vm.type==\'Hardware\'\"><div class=\"input-block\" flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.DESCRIPTION\">Description</span></label><text-angular \nng-model=\"vm.assetCategory.description\" ng-required=\"false\"></text-angular></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\" ng-show=\"vm.type==\'Person\'\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.USERNAME\">Username</span></label><input \nng-model=\"vm.assetCategory.userName\" type=\"text\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label>E-mail</label><input ng-model=\"vm.assetCategory.emailAddress\" \ntype=\"email\" ng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\" ng-show=\"vm.type==\'Location\'\"><div class=\"input-block\" flex><md-input-container flex><label>\n<span translate=\"ADMINISTRATION.FORMS.LAT\">Latitude</span></label><input ng-model=\"vm.assetCategory.latitude\" \ntype=\"number\" ng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.LONG\">Longitude</span></label><input \nng-model=\"vm.assetCategory.longitude\" type=\"number\" ng-required=\"true\"></md-input-container></div></div><div \nlayout=\"row\" ng-show=\"vm.type==\'Location\'\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.ELEVATION\">Elevation</span></label><input ng-model=\"vm.assetCategory.elevation\" \ntype=\"number\" ng-required=\"true\"></md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveAssetCategory()\" aria-label=\"Save\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/editCost/edit-cost.html","<md-dialog class=\"edit-cost-dialog\" aria-label=\"Edit Cost\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.EDIT_COST\">Edit Cost</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.COST_DETAILS\">Cost details</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.COST_TYPE\">Cost type</span></label><md-select ng-model=\"vm.cost.type\" \nng-required=\"true\" ng-change=\"vm.resetType()\"><md-option ng-value=\"tariffType.type\" \nng-repeat=\"tariffType in vm.tariffTypes\">{{tariffType.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex style=\"padding-bottom: 0\"><md-input-container flex><md-checkbox ng-model=\"vm.cost.inTotal\" \naria-label=\"In total\">In total</md-checkbox></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.cost.name\" type=\"text\" ng-required=\"true\" \nmd-autofocus></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.FORMULA_ID\">Formula ID</span></label><input ng-model=\"vm.cost.id\" type=\"text\">\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"vm.cost.type==\'fixed\' || vm.cost.type==\'return\'\"><div class=\"input-block\" flex><md-input-container flex><label>\n{{vm.getLabel(vm.cost.type)}}</label><input ng-model=\"vm.cost.tariffs[0].cost\" ng-required=\"true\" type=\"number\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.PERIOD\">Period</span></label><md-select ng-model=\"vm.cost.tariffs[0].period\" \nng-required=\"true\"><md-option ng-value=\"tariffPeriod.type\" ng-repeat=\"tariffPeriod in vm.tariffPeriods\">\n{{tariffPeriod.name}}</md-option></md-select></md-input-container></div><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.VAT\">VAT</span> (%)</label><input \nng-model=\"vm.cost.tariffs[0].vat\" type=\"number\"></md-input-container></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.cost.type==\'formula\'\"><div class=\"input-block\" flex>\n<md-input-container flex><label>{{vm.getLabel(vm.cost.type)}}</label><input ng-model=\"vm.cost.tariffs[0].cost\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.COST_BENEFIT\">Cost/Benefit</span></label><md-select \nng-model=\"vm.cost.tariffs[0].period\" ng-required=\"true\"><md-option ng-value=\"formulaType.type\" \nng-repeat=\"formulaType in vm.formulaTypes\">{{formulaType.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.VAT\">VAT</span> (%)\n</label><input ng-model=\"vm.cost.tariffs[0].vat\" type=\"number\"></md-input-container></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.cost.type==\'unit\' && !vm.schedule\"><div class=\"input-block\" \nflex><md-input-container flex><label>{{vm.getLabel(vm.cost.type)}}</label><input ng-model=\"vm.cost.tariffs[0].cost\" \nng-required=\"true\" type=\"number\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.VAT\">VAT</span> (%)</label><input ng-model=\"vm.cost.tariffs[0].vat\" \ntype=\"number\"></md-input-container></div></div><div ng-repeat=\"tariff in vm.scheduleTariffs | orderBy:\'name\'\" \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.schedule\"><div class=\"input-block\" flex>\n<md-input-container flex><label>{{tariff.name}} rate</label><input ng-model=\"tariff.cost\" ng-required=\"true\" \ntype=\"number\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.VAT\">VAT</span> (%)</label><input ng-model=\"tariff.vat\" type=\"number\">\n</md-input-container></div></div><div layout=\"row\" ng-if=\"vm.cost.type==\'unit\'\"><div class=\"input-block\" flex \nstyle=\"padding-bottom: 0\"><md-input-container flex><md-checkbox class=\"md-warn\" ng-model=\"vm.schedule\" \naria-label=\"Schedule\">Schedule</md-checkbox></md-input-container></div></div><div layout=\"row\" ng-if=\"vm.schedule\">\n<simple-handsontable data=\"vm.hotTable\" settings=\"vm.hotTableSettings\"></simple-handsontable></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.saveCost()\" aria-label=\"Save\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span \ntranslate=\"ADMINISTRATION.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/editCostProfile/edit-costProfile.html","<md-dialog class=\"edit-cost-profile-dialog\" aria-label=\"Edit Cost Profile\"><md-toolbar class=\"md-primary-bg md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.EDIT_COST_PROFILE\">Edit Cost Profile</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.COST_PROFILE_DETAILS\">Cost Profile details</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.CLIENT\">Client</span></label><md-select ng-model=\"vm.costProfile.tenant\" \nng-required=\"true\" ng-disabled=\"true\"><md-option ng-value=\"tenant.authenticationToken\" \nng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex></div></div><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label>\n<span translate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.costProfile.name\" type=\"text\" \nng-required=\"true\" md-autofocus></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.DATE_FROM\">Date from:</span></label><md-datepicker ng-model=\"vm.costProfile.startDate\" \nmd-hide-icons=\"calendar\" md-placeholder=\"Enter date\"></md-datepicker></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.MEASURE\">Measure</span>\n</label><md-select ng-model=\"vm.costProfile.measure\" ng-required=\"true\"><md-option ng-value=\"measureType.type\" \nng-repeat=\"measureType in vm.measureTypes\">{{measureType.name}}</md-option></md-select></md-input-container></div>\n</div><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.TABS.SITES\">Sites</span></label><md-select ng-model=\"vm.costProfile.siteIds\" \nng-required=\"true\" multiple=\"\"><md-option ng-value=\"site.token\" ng-repeat=\"site in vm.sites\">{{site.name}}</md-option>\n</md-select></md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveCostProfile()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/editDevice/edit-device.html","<md-dialog class=\"edit-device-dialog\" aria-label=\"Edit Device\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.EDIT_DVC\">Edit Device</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.DEVICE_DETAILS\">Device details</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span>ID</span></label><input ng-model=\"vm.device.hardwareId\" type=\"text\" ng-required=\"true\" ng-disabled=\"false\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span translate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.device.metadata.name\" type=\"text\" \nng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\">\n<div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.TYPE\">Type</span></label><md-select ng-model=\"vm.device.metadata.type\" ng-required=\"true\">\n<md-option ng-value=\"deviceType\" ng-repeat=\"deviceType in vm.deviceTypes\">{{deviceType}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span translate=\"ADMINISTRATION.COMMENTS\">Comments</span></label><input ng-model=\"vm.device.comments\" type=\"text\" \nng-required=\"false\"></md-input-container></div></div><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.DEVICE_ASSIGN\">Device Assign</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span translate=\"ADMINISTRATION.FORMS.TENANT\">Tenant</span></label><md-select ng-model=\"vm.device.tenant\" \nng-required=\"true\" ng-change=\"vm.fillSitesAndSpecifications(vm.device.tenant)\"><md-option \nng-value=\"tenant.authenticationToken\" ng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span translate=\"ADMINISTRATION.FORMS.SITE\">Site</span></label><md-select ng-model=\"vm.device.siteToken\" \nng-required=\"true\"><md-option ng-value=\"site.token\" ng-repeat=\"site in vm.sites\">{{site.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.SPECIFICATION\">Specification</span></label><md-select \nng-model=\"vm.device.specificationToken\" ng-required=\"true\"><md-option ng-value=\"spec.token\" \nng-repeat=\"spec in vm.specifications\"><img src=\"{{spec.assetImageUrl}}\" width=\"30px\"> {{spec.name}}</md-option>\n</md-select></md-input-container></div><div class=\"input-block\" flex ng-if=\"vm.solutions.length\"><md-input-container \nflex><label><span translate=\"ADMINISTRATION.FORMS.VERTICAL_SOLUTIONS\">Vertical Solutions</span></label><md-select \nng-model=\"vm.device.modules\" ng-required=\"true\" multiple=\"\"><md-option ng-value=\"solution.token\" \nng-repeat=\"solution in vm.solutions\">{{solution.name}}</md-option></md-select></md-input-container></div></div><div \nclass=\"form-title\"><span translate=\"ADMINISTRATION.FORMS.INACTIVE_DEVICE\">Inactive Device Details</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-checkbox \nng-model=\"vm.device.metadata.notification\" aria-label=\"Notification for inactive sensor\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.INACTIVE_SENSOR\">Notification for inactive sensor</span></label></md-checkbox></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.device.metadata.notification\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.NOTIFICATION_TYPE\">Notification Type</span></label><md-select \nng-model=\"vm.device.metadata.notificationType\" ng-required=\"true\"><md-option ng-value=\"notification.type\" \nng-repeat=\"notification in vm.notifications\">{{notification.name}}</md-option></md-select></md-input-container></div>\n<div class=\"input-block\" flex ng-if=\"vm.device.metadata.notificationType==\'custom\'\"><md-input-container \nclass=\"md-icon-float md-block\"><label><span translate=\"ADMINISTRATION.FORMS.NOTIFICATION_TIME\">\nNotification Time (miutes)</span></label><input ng-model=\"vm.notificationTime\" type=\"number\" ng-required=\"true\">\n</md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveDevice()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/editDeviceGroup/edit-device-group.html","<md-dialog class=\"edit-deviceGroup-dialog\" aria-label=\"Edit Device Group\"><md-toolbar class=\"md-primary-bg md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.EDIT_DVC_GROUP\">Edit Device Group</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.DEVICE_GROUP_DETAILS\">Device Group details</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.CLIENT\">Client</span></label><md-select ng-model=\"vm.deviceGroup.tenant\" \nng-required=\"true\" ng-change=\"vm.fillSites(vm.deviceGroup.tenant,\'other\')\"><md-option \nng-value=\"tenant.authenticationToken\" ng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.SITE\">Site</span></label><md-select ng-model=\"vm.deviceGroup.site\" ng-required=\"true\">\n<md-option ng-value=\"site.token\" ng-repeat=\"site in vm.sites\">{{site.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.deviceGroup.name\" type=\"text\" \nng-required=\"true\" md-autofocus></md-input-container></div></div><input ng-model=\"vm.deviceGroup.token\" type=\"hidden\" \nng-required=\"true\" ng-disabled=\"true\"><div layout=\"row\"><div class=\"input-block\" flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.DESCRIPTION\">Description</span></label><text-angular \nng-model=\"vm.deviceGroup.description\"></text-angular></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveDeviceGroup()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/editNotification/edit-notification.html","<md-dialog class=\"edit-notification-dialog\" aria-label=\"Edit Notification\"><md-toolbar class=\"md-primary md-hue-2\"><div\n class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.EDIT_NOTIFICATION\">Edit Notification</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div id=\"content-wrapper\" class=\"content md-primary-bg md-hue-3\" layout=\"row\"><md-sidenav \nclass=\"sidenav md-sidenav-left md-whiteframe-1dp\" md-is-locked-open=\"1\" md-component-id=\"sidenav\" md-disable-backdrop \nms-scroll ms-sidenav-helper><div class=\"padding-10\"><div class=\"md-title\"><p class=\"mb-0 mt-10\" \nstyle=\"font-size: 16px\">{{ \'DASHBOARD.MONITORED_POINTS\' | translate }}</p></div><md-content class=\"content\" ms-scroll>\n<div class=\"search-wrapper\" layout=\"row\" layout-align=\"start center\"><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex \nng-model=\"vm.searchtree\" type=\"text\" ng-change=\"vm.applySearch()\" \nplaceholder=\"{{ \'DASHBOARD.SEARCH_TREE\' | translate }}\" style=\"font-size: 13px\"></div></div><div layout=\"row\"><div \nclass=\"tree\" js-tree=\"vm.treeConfig\" should-apply=\"true\" ng-model=\"vm.treeData\" tree=\"vm.treeInstance\" \ntree-events-obj=\"vm.treeEvents\"></div></div><md-content></md-content></md-content></div></md-sidenav><div class=\"row\" \nlayout=\"column \"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.NOTIFICATION_DETAILS\">Device details</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container \nclass=\"md-icon-float md-block\"><label><span translate=\"ADMINISTRATION.NOTIFICATION_TITLE\">Notification Title</span>\n</label><input ng-model=\"vm.notification.name\" type=\"text\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.NOTIFICATION_TYPE\">Notification Type</span></label><md-select \nng-model=\"vm.notification.type\" ng-required=\"true\"><md-option ng-value=\"notificationType.type\" \nng-repeat=\"notificationType in vm.notificationTypes\">{{notificationType.name}}</md-option></md-select>\n</md-input-container></div></div><div ng-if=\"vm.notification.type === \'Prediction\'\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\">\n<md-radio-group ng-model=\"vm.group1\" layout=\"row\"><md-radio-button ng-repeat=\"chkbx in vm.checkboxes\" \nng-value=\"chkbx.value\" class=\"blue\">{{chkbx.name}}</md-radio-button></md-radio-group></md-input-container></div></div>\n<div ng-if=\"vm.notification.type === \'Prediction\' || vm.notification.type === \'Degradation\'\" layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container \nclass=\"md-icon-float md-block\"><label><span translate=\"ADMINISTRATION.FORMS.RENEWAL_PERIOD\">Time Renewal Period</span>\n</label><md-select ng-model=\"vm.notification.typePeriod\" ng-required=\"true\"><md-option ng-value=\"notification.type\" \nng-repeat=\"notification in vm.notificationsPeriod\">{{notification.name}}</md-option></md-select></md-input-container>\n</div><div ng-if=\"vm.notification.typePeriod === \'custom\'\" class=\"input-block\" flex><md-input-container \nclass=\"md-icon-float md-block\"><label for=\"exampleInput\"><span translate=\"ADMINISTRATION.FORMS.RENEWAL_TIME\">\nTime of renewal</span></label><input type=\"time\" id=\"exampleInput\" name=\"time\" ng-model=\"vm.time.value\" \nplaceholder=\"24:00:00\" required></md-input-container></div><div ng-if=\"vm.notification.typePeriod === \'interval\'\" \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.NOTIFICATION_INTERVAL\">Interval Number</span></label><input ng-model=\"vm.intervalNum\" \ntype=\"number\" min=\"0\" ng-required=\"true\"></md-input-container></div></div><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.MEASUREMENT_DETAILS\">Measurement Details</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container \nclass=\"md-icon-float md-block\"><label><span translate=\"ADMINISTRATION.FORMS.TENANT\">Tenant</span></label><input \nng-model=\"vm.notification.tenant\" type=\"text\" ng-disabled=\"true\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.SITE\">SITE</span></label><input ng-model=\"vm.notification.site\" type=\"text\" \nng-disabled=\"true\" ng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span translate=\"ADMINISTRATION.FORMS.ASSIGNMENT\">Assignment</span></label><input \nng-model=\"vm.notification.assignment\" type=\"text\" ng-disabled=\"true\" ng-required=\"true\"></md-input-container></div><div\n class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.MEASUREMENT\">Measurement</span></label><input ng-model=\"vm.notification.measurement\" \ntype=\"text\" ng-disabled=\"true\" ng-required=\"true\"></md-input-container></div></div><div class=\"form-title\" \nng-if=\"vm.notification.type === \'Stream\' || vm.notification.type === \'Median\' || vm.notification.type === \'Mean\' || vm.notification.type === \'Sum\'\">\n<span translate=\"ADMINISTRATION.FORMS.THRESHOLDS\">Measurement Thresholds</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"vm.notification.type === \'Stream\' || vm.notification.type === \'Median\' || vm.notification.type === \'Mean\' || vm.notification.type === \'Sum\'\">\n<div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.UPPER_LIMIT\">Upper Limit</span></label><input ng-model=\"vm.notification.max\" \ntype=\"number\" ng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container \nclass=\"md-icon-float md-block\"><label><span translate=\"ADMINISTRATION.FORMS.LOWER_LIMIT\">Lower Limit</span></label>\n<input ng-model=\"vm.notification.min\" type=\"number\" ng-required=\"true\"></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"vm.notification.type === \'Median\' || vm.notification.type === \'Mean\' || vm.notification.type === \'Sum\'\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.PERIOD_TYPE\">Period Type</span></label><md-select \nng-model=\"vm.notification.periodType\" ng-required=\"true\"><md-option ng-value=\"period.type\" \nng-repeat=\"period in vm.periods\">{{period.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.PERIOD\">Period</span></label><input ng-model=\"vm.notification.period\" type=\"number\" \nng-required=\"true\"></md-input-container></div></div><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.NOTIFY_VIA\">Notify Via</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-checkbox ng-model=\"vm.notification.portal\" \naria-label=\"Notification for active\"><label><span translate=\"ADMINISTRATION.FORMS.PORTAL\">Portal</span></label>\n</md-checkbox></div><div class=\"input-block\" flex><md-checkbox ng-model=\"vm.notification.mail\" \naria-label=\"Notification for active\"><label><span translate=\"ADMINISTRATION.FORMS.MAIL\">Mail</span></label>\n</md-checkbox></div><div class=\"input-block\" flex><md-checkbox ng-model=\"vm.notification.sms\" \naria-label=\"Notification for active\"><label><span translate=\"ADMINISTRATION.FORMS.SMS\">Sms</span></label></md-checkbox>\n</div></div><div class=\"form-title\"><span translate=\"ADMINISTRATION.FORMS.ACTIVE_NOTIFICATION_DETAILS\">\nActive Notification Details</span></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-checkbox ng-model=\"vm.activeNotification\" aria-label=\"Notification for active\"><label>\n<span translate=\"ADMINISTRATION.FORMS.ACTIVE_NOTIFICATION\">Active Notification</span></label></md-checkbox></div></div>\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-primary md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.saveNotification()\" aria-label=\"Save\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\">\n<span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/editSite/edit-site.html","<md-dialog class=\"edit-site-dialog\" aria-label=\"Edit Site\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.FORMS.EDIT_SITE\">Edit Site</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-tabs><md-tab><md-tab-label><span translate=\"ADMINISTRATION.FORMS.GENERAL\">General</span>\n</md-tab-label><md-tab-body><div class=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.BUILDING_NAME\">Building Name</span></label><input ng-model=\"vm.site.name\" type=\"text\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.SITE_TYPE\">Site Type</span></label><md-select ng-model=\"vm.site.metadata.siteType\" \nng-required=\"true\"><md-option ng-value=\"site\" ng-repeat=\"site in vm.siteTypes\">{{site}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.CLIENT\">Client</span>\n</label><md-select ng-model=\"vm.site.tenant\" ng-required=\"true\"><md-option ng-value=\"tenant.authenticationToken\" \nng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.AUTH_USERS\">Authorized users\n</span></label><md-select ng-model=\"vm.site.authorizedUserIds\" ng-required=\"true\" multiple=\"\"><md-option \nng-value=\"user.username\" ng-repeat=\"user in vm.users\" ng-if=\"user.metadata.role===\'level05\'\">\n{{user.firstName}} {{user.lastName}}</md-option></md-select></md-input-container></div></div><div layout=\"row\"><div \nclass=\"input-block\" flex><label><span translate=\"ADMINISTRATION.FORMS.DESCRIPTION\">Description</span></label>\n<text-angular ng-model=\"vm.site.description\"></text-angular></div></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"ADMINISTRATION.FORMS.LOCATION\">Location</span></md-tab-label><md-tab-body><div \nclass=\"form-content\"><div layout=\"row\"><div class=\"input-block\" flex><ms-widget layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><ui-gmap-google-map center=\"vm.map.center\" zoom=\"vm.site.map.metadata.zoomLevel\" \ndraggable=\"true\" events=\"vm.map.events\"><ui-gmap-marker ng-repeat=\"m in vm.map.markers\" coords=\"m.coords\" \nicon=\"m.icon\" idkey=\"m.id\"></ui-gmap-marker></ui-gmap-google-map></ms-widget-front></ms-widget></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.CENTER_LAT\">Center Latitude</span></label><input \nng-model=\"vm.site.map.metadata.centerLatitude\" type=\"number\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.CENTER_LONG\">\nCenter Longitude</span></label><input ng-model=\"vm.site.map.metadata.centerLongitude\" type=\"number\" ng-required=\"true\">\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.CITY\">City</span>\n</label><input ng-model=\"vm.site.metadata.city\" type=\"text\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.STREET_NAME\">Street Name\n</span></label><input ng-model=\"vm.site.metadata.street\" type=\"text\" ng-required=\"true\"></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.HOUSE_NUMBER\">House Number</span></label><input \nng-model=\"vm.site.metadata.houseNumber\" type=\"text\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.POST_CODE\">Post Code\n</span></label><input ng-model=\"vm.site.metadata.postCode\" type=\"text\" ng-required=\"true\"></md-input-container></div>\n</div></div></md-tab-body></md-tab><md-tab ng-if=\"vm.site.metadata.siteType===\'Building\'\"><md-tab-label><span \ntranslate=\"ADMINISTRATION.FORMS.BUILDING_TYPE\">Building Type</span></md-tab-label><md-tab-body><div \nclass=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.WALL_STRUCTURE\">Wall Structure</span></label>\n<md-select ng-model=\"vm.site.metadata.wallStructure\" ng-required=\"true\"><md-option ng-value=\"wall\" \nng-repeat=\"wall in vm.wallTypes\">{{wall}}</md-option></md-select></md-input-container></div><div class=\"input-block\" \nflex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.GROUND_FLOOR\">Ground Floor</span></label>\n<md-select ng-model=\"vm.site.metadata.groundFloor\" ng-required=\"true\"><md-option ng-value=\"ground\" \nng-repeat=\"ground in vm.floorTypes\">{{ground}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.ROOF_INSULATION\">Roof Insulation</span></label><md-select \nng-model=\"vm.site.metadata.roofInsulation\" ng-required=\"true\"><md-option ng-value=\"roof\" \nng-repeat=\"roof in vm.roofInsulation\">{{roof}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex ng-if=\"vm.site.metadata.roofInsulation===\'Yes\'\"><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.ROOF_INSULATION_TYPE\">Roof Insulation Type</span></label><md-select \nng-model=\"vm.site.metadata.roofInsulationType\" ng-required=\"true\"><md-option ng-value=\"roofInsulation\" \nng-repeat=\"roofInsulation in vm.roofInsulationTypes\">{{roofInsulation}}</md-option></md-select></md-input-container>\n</div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.HEATING_TYPE\">Heating Type</span></label>\n<md-select ng-model=\"vm.site.metadata.heating\" ng-required=\"true\"><md-option ng-value=\"heating\" \nng-repeat=\"heating in vm.heatingTypes\">{{heating}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.AC_TYPE\">\nAirconditioning Type</span></label><md-select ng-model=\"vm.site.metadata.airconditioning\" ng-required=\"true\"><md-option\n ng-value=\"airco\" ng-repeat=\"airco in vm.aircoTypes\">{{airco}}</md-option></md-select></md-input-container></div></div>\n<div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container \nflex><label><span translate=\"ADMINISTRATION.FORMS.VENTILATION_TYPE\">Ventilation Type</span></label><md-select \nng-model=\"vm.site.metadata.ventilation\" ng-required=\"true\"><md-option ng-value=\"ventilation\" \nng-repeat=\"ventilation in vm.ventilationTypes\">{{ventilation}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.BUILDING_TYPE\">\nBuilding Type</span></label><md-select ng-model=\"vm.site.metadata.buildingType\" ng-required=\"true\"><md-option \nng-value=\"key\" ng-repeat=\"(key, value) in vm.buildingTypes\">{{key}}</md-option></md-select></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.BUILDING_SUBTYPE\">Building Subtype</span></label>\n<md-select ng-model=\"vm.site.metadata.buildingSubType\" ng-required=\"true\"><md-option ng-value=\"type\" \nng-repeat=\"type in vm.buildingTypes[vm.site.metadata.buildingType]\">{{type}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.ENERGY_LABEL\">Energy Label</span></label><md-select \nng-model=\"vm.site.metadata.energyLabel\" ng-required=\"true\"><md-option ng-value=\"energy\" \nng-repeat=\"energy in vm.energyLabels\">{{energy}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.BUILT_YEAR\">Built Year</span></label><input \nng-model=\"vm.site.metadata.year\" type=\"number\" ng-required=\"false\"></md-input-container></div><div class=\"input-block\" \nflex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.WORKING_AREA\">Working Area</span> (m2)\n</label><input ng-model=\"vm.site.metadata.workingArea\" type=\"number\" ng-required=\"false\"></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.OCCUPANTS\">Occupants</span></label><input \nng-model=\"vm.site.metadata.occupants\" type=\"number\" ng-required=\"false\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.LENGTH\">\nDimensions Length</span> (m)</label><input ng-model=\"vm.site.metadata.dimensionsX\" type=\"number\" ng-required=\"false\">\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.WIDTH\">Dimensions Width\n</span> (m)</label><input ng-model=\"vm.site.metadata.dimensionsY\" type=\"number\" ng-required=\"false\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.HEIGHT\">Dimensions Height</span> (m)</label><input \nng-model=\"vm.site.metadata.dimensionsZ\" type=\"number\" ng-required=\"false\"></md-input-container></div></div></div>\n</md-tab-body></md-tab></md-tabs><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.saveSite()\" aria-label=\"Save\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span \ntranslate=\"ADMINISTRATION.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/dialogs/editSiteGroup/edit-site-group.html","<md-dialog class=\"edit-portfolio-dialog\" aria-label=\"Edit Portfolio\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.EDIT_PORTFOLIO\">Edit Portfolio</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.PORTFOLIO_DETAILS\">Portfolio details</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.CLIENT\">Client</span></label><md-select ng-model=\"vm.deviceGroup.tenant\" \nng-required=\"true\" ng-disabled=\"true\"><md-option ng-value=\"tenant.authenticationToken\" \nng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex></div></div><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label>\n<span translate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.deviceGroup.name\" type=\"text\" \nng-required=\"true\" md-autofocus></md-input-container></div></div><input ng-model=\"vm.deviceGroup.token\" type=\"hidden\" \nng-required=\"true\" ng-disabled=\"true\"><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label>\n<span translate=\"ADMINISTRATION.AUTH_USERS\">Authorized users</span></label><md-select ng-model=\"vm.deviceGroup.userId\" \nng-required=\"false\" multiple=\"\"><md-option ng-value=\"user.username\" ng-repeat=\"user in vm.users\" \nng-if=\"user.metadata.role===\'level04\'\">{{user.firstName}} {{user.lastName}}</md-option></md-select>\n</md-input-container></div></div><div class=\"form-title\"><span translate=\"ADMINISTRATION.FORMS.PORTFOLIO_DESCRIPTION\">\nPortfolio description</span></div><div layout=\"row\"><div class=\"input-block\" flex><text-angular \nng-model=\"vm.deviceGroup.description\"></text-angular></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveDeviceGroup()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/editSpecification/edit-specification.html","<md-dialog class=\"edit-spec-dialog\" aria-label=\"Edit Specification\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.EDIT_SPECIFICATION\">Edit Specification</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-tabs><md-tab><md-tab-label><span translate=\"ADMINISTRATION.FORMS.GENERAL\">General</span>\n</md-tab-label><md-tab-body><div class=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.specification.name\" type=\"text\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.CLIENT\">Client</span></label><md-select ng-model=\"vm.specification.tenant\" \nng-required=\"true\" ng-change=\"vm.assetModule(vm.specification.tenant)\"><md-option \nng-value=\"tenant.authenticationToken\" ng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.ASSET_PROVIDER\">Asset Provider\n</span></label><md-select ng-model=\"vm.specification.assetModuleId\" ng-required=\"true\" \nng-change=\"vm.assetsFunction(vm.specification.assetModuleId)\"><md-option ng-value=\"assetModule.id\" \nng-repeat=\"assetModule in vm.assetModules\" ng-if=\"assetModule.assetType==\'Device\'\">{{assetModule.name}}</md-option>\n</md-select></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.DEVICE_TYPE\">Device Type</span></label><md-select ng-model=\"vm.specification.assetId\" \nng-required=\"true\"><md-option ng-value=\"asset.id\" ng-repeat=\"asset in vm.assets\"><img src=\"{{asset.imageUrl}}\" \nwidth=\"50px\"> {{asset.name}}</md-option></md-select></md-input-container></div></div></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"ADMINISTRATION.FORMS.SPECS\">Specs</span></md-tab-label><md-tab-body><div \nclass=\"form-content\"><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.SPECIFICATION_PRIORITY\">Specification Priority</span></label><input \nng-model=\"vm.specification.metadata.priority\" type=\"number\" ng-required=\"true\"></md-input-container></div></div><hr>\n<div ng-repeat=\"spec in vm.specs\"><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.addNewSpec();\" aria-label=\"New Measurement\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.NEW_MEASUREMENT\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.NEW_MEASUREMENT\">New Measurement</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" \nclass=\"s24\" aria-hidden=\"true\"></md-icon></md-button></md-input-container></div><div class=\"input-block\" flex>\n<md-input-container flex><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.removeSpec(spec.id);\" \naria-label=\"Remove Measurement\" translate translate-attr-aria-label=\"ADMINISTRATION.REMOVE_MEASUREMENT\"><md-tooltip \nmd-direction=\"top\"><span translate=\"ADMINISTRATION.REMOVE_MEASUREMENT\">Remove Measurement</span></md-tooltip><md-icon \nmd-font-icon=\"icon-minus\" class=\"s24\" aria-hidden=\"true\"></md-icon></md-button></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.MEASUREMENT\">Measurement</span></label><input ng-model=\"spec.name\" type=\"text\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FRIENDLY_NAME\">Friendly Name</span></label><input ng-model=\"spec.friendlyName\" type=\"text\" \nng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\">\n<div class=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.MEASUREMENT_UNIT\">\nMeasurement Unit</span></label><input ng-model=\"spec.unit\" type=\"text\" ng-required=\"true\"></md-input-container></div>\n<div class=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.MEASUREMENT_TYPE\">\nMeasurement Type</span></label><md-select ng-model=\"spec.type\" ng-required=\"true\"><md-option ng-value=\"type.type\" \nng-repeat=\"type in vm.types\">{{type.name}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<md-checkbox ng-model=\"spec.cost\">Can assign Cost</md-checkbox></md-input-container></div><div class=\"input-block\" \nflex><md-input-container flex><md-checkbox ng-model=\"spec.expert\">For Expert Users</md-checkbox></md-input-container>\n</div><div class=\"input-block\" flex><md-input-container flex><md-checkbox ng-model=\"spec.metadata\">String Value\n</md-checkbox></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><md-checkbox ng-model=\"spec.aggregated\">Can be aggregated\n</md-checkbox></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-model=\"spec.cumulative\">Is Cumulative</md-checkbox></md-input-container></div></div><hr></div></div></md-tab-body>\n</md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.saveSpecification()\" aria-label=\"Save\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\">\n<span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/editTariff/edit-tariff.html","<md-dialog class=\"new-user-dialog\" aria-label=\"Edit Tariff\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.FORMS.EDIT_TARIFF\">Edit Tariff</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.TARIFF_TYPE\">Tariff type</span></label><md-select ng-model=\"vm.tariff.type\" \nng-required=\"true\" ng-change=\"vm.clearFields()\"><md-option ng-value=\"tariffType.type\" \nng-repeat=\"tariffType in vm.tariffTypes\">{{tariffType.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex ng-if=\"vm.tariff.type===\'unit\'\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.TARIFF_NAME\">Tariff Name</span></label><input ng-model=\"vm.tariff.name\" type=\"text\" \nng-required=\"true\" maxlength=\"2\"></md-input-container><md-input-container flex ng-if=\"vm.tariff.type!==\'unit\'\"><label>\n<span translate=\"ADMINISTRATION.FORMS.TARIFF_NAME\">Tariff Name</span></label><input ng-model=\"vm.tariff.name\" \ntype=\"text\" ng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.TARIFF_COST\">Tariff Cost</span></label><input ng-model=\"vm.tariff.cost\" type=\"number\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.VAT\">Vat</span></label><input ng-model=\"vm.tariff.vat\" type=\"number\" \nng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\">\n<div class=\"input-block\" flex ng-if=\"vm.tariff.type===\'fixed\' || vm.tariff.type===\'return\'\"><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.TARIFF_PERIOD\">Tariff Period (Days)</span></label><input \nng-model=\"vm.tariff.period\" type=\"number\" ng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex \nng-if=\"vm.user.role===\'level02\' || vm.user.role===\'level01\'\"><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.CLIENT\">Client</span></label><md-select ng-model=\"vm.tariff.tenant\" ng-required=\"true\" \nng-disabled=\"true\"><md-option ng-value=\"tenant.authenticationToken\" ng-repeat=\"tenant in vm.tenants\">{{tenant.name}}\n</md-option></md-select></md-input-container></div></div></div></div><md-dialog-actions layout=\"row\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.saveTariff()\" aria-label=\"Save\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><md-icon \nmd-font-icon=\"icon-floppy\" aria-hidden=\"true\"></md-icon><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/dialogs/editTenant/edit-tenant.html","<md-dialog class=\"edit-client-dialog\" aria-label=\"Edit Client\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.EDIT_CLIENT\">Edit Client</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.CLIENT_DETAILS\">Client details</span></div><div layout=\"row\"><div class=\"input-block\" \nflex><md-input-container flex><label><span translate=\"ADMINISTRATION.NAME\">Name</span></label><input \nng-model=\"vm.tenant.name\" type=\"text\" ng-required=\"true\" md-autofocus></md-input-container></div></div><input \nng-model=\"vm.tenant.id\" type=\"hidden\" ng-required=\"true\" ng-disabled=\"true\"> <input \nng-model=\"vm.tenant.authenticationToken\" type=\"hidden\" ng-required=\"true\" ng-disabled=\"true\"><div layout=\"row\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.AUTH_USERS\">Authorized users\n</span></label><md-select ng-model=\"vm.tenant.authorizedUserIds\" ng-required=\"true\" multiple=\"\"><md-option \nng-value=\"user.username\" ng-repeat=\"user in vm.users\" \nng-if=\"user.metadata.role===\'level01\' || user.metadata.role===\'level02\' || user.metadata.role===\'level03\'\">\n{{user.firstName}} {{user.lastName}}</md-option></md-select></md-input-container></div></div><div layout=\"row\"><div \nclass=\"input-block\" flex><choose-file layout=\"row\" flex file-url=\"vm.tenant.logoUrl\" file-name=\"vm.file\"><div \nclass=\"media\" style=\"background-image: url(\'assets/images/placeholder.png\')\" ng-show=\"!vm.tenant.logoUrl\"></div><div \nclass=\"media\" style=\"background-image: url(\'{{vm.tenant.logoUrl}}\')\" ng-show=\"vm.tenant.logoUrl\"></div><input \nid=\"fileInput\" type=\"file\" class=\"ng-hide\"><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.LOGO\">Logo image</span></label><input type=\"text\" ng-model=\"vm.file\" \ndisabled=\"disabled\"></md-input-container><md-button id=\"uploadButton\" class=\"upload-button\" aria-label=\"Upload image\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.FORMS.UPLOAD_IMAGE\"><md-icon md-font-icon=\"icon-upload\" \naria-hidden=\"true\"></md-icon></md-button></choose-file></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveTenant()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/editUser/edit-user.html","<md-dialog class=\"edit-user-dialog\" aria-label=\"Edit User\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.EDIT_USER\">Edit User</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.LOGIN_DETAILS\">Login details</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.USER_TYPE\">User type</span></label><md-select ng-model=\"vm.user.metadata.role\" \nng-required=\"true\"><md-option ng-value=\"userType.type\" ng-repeat=\"userType in vm.userTypes\">{{userType.name}}\n</md-option></md-select></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.USER_STATUS\">User status</span></label><md-select ng-model=\"vm.user.status\" \nng-required=\"true\"><md-option ng-value=\"stat\" ng-repeat=\"stat in vm.statuses\">{{stat}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.USER_NAME\">Username\n</span></label><input ng-model=\"vm.user.username\" type=\"text\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.PASSWORD\">Password\n</span></label><input ng-model=\"vm.user.password\" type=\"password\" ng-required=\"true\"></md-input-container></div></div>\n<div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><choose-file \nlayout=\"row\" flex file-url=\"vm.user.metadata.imageUrl\" file-name=\"vm.file\"><div class=\"avatar\" \nstyle=\"background-image: url(\'assets/images/avatars/profile.jpg\')\" ng-show=\"!vm.user.metadata.imageUrl\"></div><div \nclass=\"avatar\" style=\"background-image: url(\'{{vm.user.metadata.imageUrl}}\')\" ng-show=\"vm.user.metadata.imageUrl\">\n</div><input id=\"fileInput\" type=\"file\" class=\"ng-hide\"><md-input-container class=\"md-icon-float md-block\"><label><span\n translate=\"ADMINISTRATION.FORMS.IMAGE\">Image</span></label><input type=\"text\" ng-model=\"vm.file\" disabled=\"disabled\">\n</md-input-container><md-button id=\"uploadButton\" class=\"upload-button\" aria-label=\"Upload image\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.UPLOAD_IMAGE\"><md-icon md-font-icon=\"icon-upload\" aria-hidden=\"true\">\n</md-icon></md-button></choose-file></div><div class=\"input-block\" flex ng-if=\"vm.solutions.length\"><md-input-container\n flex><label><span translate=\"ADMINISTRATION.FORMS.VERTICAL_SOLUTIONS\">Vertical Solutions</span></label><md-select \nng-model=\"vm.userPreferences.modules\" ng-required=\"true\" multiple=\"\"><md-option ng-value=\"solution.token\" \nng-repeat=\"solution in vm.solutions\">{{solution.name}}</md-option></md-select></md-input-container></div></div><div \nclass=\"form-title\"><span translate=\"ADMINISTRATION.FORMS.CONTACT_DETAILS\">Contact details</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FIRST_NAME\">First name</span></label><input ng-model=\"vm.user.firstName\" \ntype=\"text\" ng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.LAST_NAME\">Last name</span></label><input ng-model=\"vm.user.lastName\" \ntype=\"text\" ng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.EMAIL\">E-mail</span></label><input ng-model=\"vm.user.metadata.email\" type=\"email\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.PHONE\">Phone</span></label><input ng-model=\"vm.user.metadata.phone\" type=\"text\" \nng-required=\"false\"></md-input-container></div></div></div></div><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveUser()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/dialogs/editVertical/edit-vertical.html","<md-dialog class=\"edit-vertical-dialog\" aria-label=\"Edit Vertical Solution\"><md-toolbar class=\"md-primary-bg md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.EDIT_VERTICAL\">Edit Vertical Solution</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.GENERAL\">General</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.vertical.name\" type=\"text\" ng-required=\"true\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.PARENT\">Parent</span></label><md-select ng-model=\"vm.vertical.parent\" ng-required=\"true\">\n<md-option ng-value=\"vertical.token\" ng-repeat=\"vertical in vm.verticals\">{{vertical.name}}</md-option></md-select>\n</md-input-container></div></div><div class=\"form-title\"><span translate=\"ADMINISTRATION.FORMS.APPEARANCE_DETAILS\">\nAppearance Details</span></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.LOGO\">Logo</span>\n</label><input ng-model=\"vm.vertical.logo\" type=\"text\" ng-required=\"true\"></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.PRIMARY_COLOR\">Primary Color</span></label><input \nng-model=\"vm.vertical.primary\" type=\"text\" ng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.SECONDARY_COLOR\">Secondary Color</span></label>\n<input ng-model=\"vm.vertical.secondary\" type=\"text\" ng-required=\"true\"></md-input-container></div></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.saveVertical()\" aria-label=\"Save\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span \ntranslate=\"ADMINISTRATION.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newAsset/new-asset.html","<md-dialog class=\"new-assetcat-dialog\" aria-label=\"New Asset Category\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.ADD_ASSET\">New Asset Category</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.AC_NAME\">Asset Category Name</span></label><input ng-model=\"vm.asset.name\" type=\"text\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.AC_TYPE\">Asset Category Type</span></label><md-select ng-model=\"vm.asset.assetType\" \nng-required=\"true\"><md-option ng-value=\"assetType\" ng-repeat=\"assetType in vm.assetTypes\">{{assetType}}</md-option>\n</md-select></md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveAsset()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newAssetCategory/new-asset-category.html","<md-dialog class=\"new-asset-dialog\" aria-label=\"New Asset\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.ADD_ASSETS\">New Asset</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"row\" layout=\"column\"><div class=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.assetCategory.name\" type=\"text\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.IMAGE\">Image</span></label><input type=\"text\" ng-model=\"vm.assetCategory.imageUrl\">\n</md-input-container></div></div><div layout=\"row\" ng-show=\"vm.type==\'Device\' || vm.type==\'Hardware\'\"><div \nclass=\"input-block\" flex><md-input-container flex><label>SKU</label><input ng-model=\"vm.assetCategory.sku\" type=\"text\" \nng-required=\"true\"></md-input-container></div></div><div layout=\"row\" \nng-show=\"vm.type==\'Device\' || vm.type==\'Hardware\'\"><div class=\"input-block\" flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.DESCRIPTION\">Description</span></label><text-angular \nng-model=\"vm.assetCategory.description\" ng-required=\"false\"></text-angular></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\" ng-show=\"vm.type==\'Person\'\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.USERNAME\">Username</span></label><input \nng-model=\"vm.assetCategory.userName\" type=\"text\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label>E-mail</label><input ng-model=\"vm.assetCategory.emailAddress\" \ntype=\"email\" ng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\" ng-show=\"vm.type==\'Location\'\"><div class=\"input-block\" flex><md-input-container flex><label>\n<span translate=\"ADMINISTRATION.FORMS.LAT\">Latitude</span></label><input ng-model=\"vm.assetCategory.latitude\" \ntype=\"number\" ng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.LONG\">Longitude</span></label><input \nng-model=\"vm.assetCategory.longitude\" type=\"number\" ng-required=\"true\"></md-input-container></div></div><div \nlayout=\"row\" ng-show=\"vm.type==\'Location\'\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.ELEVATION\">Elevation</span></label><input ng-model=\"vm.assetCategory.elevation\" \ntype=\"number\" ng-required=\"true\"></md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveAssetCategory()\" aria-label=\"Save\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newCost/new-cost.html","<md-dialog class=\"new-cost-dialog\" aria-label=\"New Cost\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.ADD_COST\">New Cost</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.FORMS.COST_DETAILS\">Cost details</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.COST_TYPE\">Cost type</span></label><md-select ng-model=\"vm.cost.type\" \nng-required=\"true\" ng-change=\"vm.resetType()\"><md-option ng-value=\"tariffType.type\" \nng-repeat=\"tariffType in vm.tariffTypes\">{{tariffType.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex style=\"padding-bottom: 0\"><md-input-container flex><md-checkbox ng-model=\"vm.cost.inTotal\" \naria-label=\"In total\">In total</md-checkbox></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.cost.name\" type=\"text\" ng-required=\"true\" \nmd-autofocus></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.FORMULA_ID\">Formula ID</span></label><input ng-model=\"vm.cost.id\" type=\"text\">\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"vm.cost.type==\'fixed\' || vm.cost.type==\'return\'\"><div class=\"input-block\" flex><md-input-container flex><label>\n{{vm.getLabel(vm.cost.type)}}</label><input ng-model=\"vm.cost.tariffs[0].cost\" ng-required=\"true\" type=\"number\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.PERIOD\">Period</span></label><md-select ng-model=\"vm.cost.tariffs[0].period\" \nng-required=\"true\"><md-option ng-value=\"tariffPeriod.type\" ng-repeat=\"tariffPeriod in vm.tariffPeriods\">\n{{tariffPeriod.name}}</md-option></md-select></md-input-container></div><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.VAT\">VAT</span> (%)</label><input \nng-model=\"vm.cost.tariffs[0].vat\" type=\"number\"></md-input-container></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.cost.type==\'formula\'\"><div class=\"input-block\" flex>\n<md-input-container flex><label>{{vm.getLabel(vm.cost.type)}}</label><input ng-model=\"vm.cost.tariffs[0].cost\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.COST_BENEFIT\">Cost/Benefit</span></label><md-select \nng-model=\"vm.cost.tariffs[0].period\" ng-required=\"true\"><md-option ng-value=\"formulaType.type\" \nng-repeat=\"formulaType in vm.formulaTypes\">{{formulaType.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.VAT\">VAT</span> (%)\n</label><input ng-model=\"vm.cost.tariffs[0].vat\" type=\"number\"></md-input-container></div></div><div \nng-if=\"vm.cost.type==\'unit\' && !vm.schedule\"><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\">\n<md-button class=\"edit-button md-icon-button\" ng-click=\"vm.newTariffPerUnit()\" aria-label=\"Edit Cost\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_COST\"><md-icon md-font-icon=\"icon-plus\" class=\"s24\" aria-hidden=\"true\">\n</md-icon></md-button><div class=\"input-block\" flex><md-input-container flex><label>{{vm.getLabel(vm.cost.type)}}\n</label><input ng-model=\"vm.cost.tariffs[0].cost\" ng-required=\"true\" type=\"number\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.VAT\">VAT</span> (%)\n</label><input ng-model=\"vm.cost.tariffs[0].vat\" type=\"number\"></md-input-container></div></div><div \nng-repeat=\"dt in vm.tariffsPerUnit track by $index\" layout=\"row\" layout-align=\"start center\"><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.deleteTariffPerUnit($index)\" aria-label=\"Edit Cost\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_COST\"><md-icon md-font-icon=\"icon-minus\" class=\"s24\" aria-hidden=\"true\">\n</md-icon></md-button><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.ABOVE\">ABOVE</span></label><input ng-model=\"vm.tariffsPerUnit[$index].above\" \nng-required=\"true\" type=\"number\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex>\n<label>{{vm.getLabel(vm.cost.type)}}</label><input ng-model=\"vm.tariffsPerUnit[$index].cost\" ng-required=\"true\" \ntype=\"number\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.VAT\">VAT</span> (%)</label><input ng-model=\"vm.tariffsPerUnit[$index].vat\" \ntype=\"number\"></md-input-container></div></div></div></div><div ng-if=\"vm.schedule\"><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.newTariffScedule()\" aria-label=\"Edit Cost\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_COST\"><md-icon md-font-icon=\"icon-plus\" class=\"s24\" aria-hidden=\"true\">\n</md-icon></md-button><div ng-repeat=\"tariff in vm.scheduleTariffs | orderBy:\'name\'\" layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label>\n{{tariff.name}} rate</label><input ng-model=\"tariff.cost\" ng-required=\"true\" type=\"number\"></md-input-container></div>\n<div class=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.VAT\">VAT</span> (%)\n</label><input ng-model=\"tariff.vat\" type=\"number\"></md-input-container></div></div><div \nng-repeat=\"dt in vm.tariffsScedule track by $index\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.deleteTariffScedule($index)\" aria-label=\"Edit Cost\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.EDIT_COST\"><md-icon md-font-icon=\"icon-minus\" class=\"s24\" aria-hidden=\"true\">\n</md-icon></md-button><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.ABOVE\">ABOVE</span></label><input ng-model=\"vm.tariffsScedule[$index].above\" \nng-required=\"true\" type=\"number\"></md-input-container></div><div \nng-repeat=\"tariff in vm.tariffsScedule[$index].tariffs | orderBy:\'name\'\" layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label>{{tariff.name}} rate</label>\n<input ng-model=\"tariff.cost\" ng-required=\"true\" type=\"number\"></md-input-container></div><div class=\"input-block\" \nflex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.VAT\">VAT</span> (%)</label><input \nng-model=\"tariff.vat\" type=\"number\"></md-input-container></div></div></div></div><div layout=\"row\" \nng-if=\"vm.cost.type==\'unit\'\"><div class=\"input-block\" flex style=\"padding-bottom: 0\"><md-input-container flex>\n<md-checkbox class=\"md-warn\" ng-model=\"vm.schedule\" aria-label=\"Schedule\">Schedule</md-checkbox></md-input-container>\n</div></div><div layout=\"row\" ng-if=\"vm.schedule\"><simple-handsontable data=\"vm.hotTable\" \nsettings=\"vm.hotTableSettings\"></simple-handsontable></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveCost()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newCostProfile/new-costProfile.html","<md-dialog class=\"new-cost-profile-dialog\" aria-label=\"New Cost Profile\"><md-toolbar class=\"md-primary-bg md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.FORMS.ADD_COST_PROFILE\">New Cost Profile</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.COST_PROFILE_DETAILS\">Cost Profile details</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.CLIENT\">Client</span></label><md-select ng-model=\"vm.costProfile.tenant\" \nng-required=\"true\" ng-change=\"vm.changeClient(vm.costProfile.tenant)\"><md-option ng-value=\"tenant.authenticationToken\" \nng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex></div></div><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label>\n<span translate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.costProfile.name\" type=\"text\" \nng-required=\"true\" md-autofocus></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.DATE_FROM\">Date from:</span></label><md-datepicker ng-model=\"vm.costProfile.startDate\" \nmd-hide-icons=\"calendar\" md-placeholder=\"Enter date\"></md-datepicker></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.MEASURE\">Measure</span>\n</label><md-select ng-model=\"vm.costProfile.measure\" ng-required=\"true\"><md-option ng-value=\"measureType.type\" \nng-repeat=\"measureType in vm.measureTypes\">{{measureType.name}}</md-option></md-select></md-input-container></div>\n</div><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.TABS.SITES\">Sites</span></label><md-select ng-model=\"vm.costProfile.siteIds\" multiple=\"\">\n<md-option ng-value=\"site.token\" ng-repeat=\"site in vm.sites\">{{site.name}}</md-option></md-select>\n</md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveCostProfile()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newDevice/new-device.html","<md-dialog class=\"new-device-dialog\" aria-label=\"New Device\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.ADD_DEVICE\">New Device</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.DEVICE_DETAILS\">Device details</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span>ID</span></label><input ng-model=\"vm.device.hardwareId\" type=\"text\" ng-required=\"true\" ng-disabled=\"false\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span translate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.device.metadata.name\" type=\"text\" \nng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\">\n<div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.TYPE\">Type</span></label><md-select ng-model=\"vm.device.metadata.type\" ng-required=\"true\">\n<md-option ng-value=\"deviceType\" ng-repeat=\"deviceType in vm.deviceTypes\">{{deviceType}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span translate=\"ADMINISTRATION.COMMENTS\">Comments</span></label><input ng-model=\"vm.device.comments\" type=\"text\" \nng-required=\"false\"></md-input-container></div></div><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.DEVICE_ASSIGN\">Device Assign</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span translate=\"ADMINISTRATION.FORMS.CLIENT\">Client</span></label><md-select ng-model=\"vm.device.tenant\" \nng-required=\"true\" ng-change=\"vm.fillSitesAndSpecifications(vm.device.tenant)\"><md-option \nng-value=\"tenant.authenticationToken\" ng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span translate=\"ADMINISTRATION.FORMS.SITE\">Site</span></label><md-select ng-model=\"vm.device.siteToken\" \nng-required=\"true\"><md-option ng-value=\"site.token\" ng-repeat=\"site in vm.sites\">{{site.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.SPECIFICATION\">Specification</span></label><md-select \nng-model=\"vm.device.specificationToken\" ng-required=\"true\"><md-option ng-value=\"spec.token\" \nng-repeat=\"spec in vm.specifications\"><img src=\"{{spec.assetImageUrl}}\" width=\"30px\"> {{spec.name}}</md-option>\n</md-select></md-input-container></div><div class=\"input-block\" flex ng-if=\"vm.solutions.length\"><md-input-container \nflex><label><span translate=\"ADMINISTRATION.FORMS.VERTICAL_SOLUTIONS\">Vertical Solutions</span></label><md-select \nng-model=\"vm.device.modules\" ng-required=\"true\" multiple=\"\"><md-option ng-value=\"solution.token\" \nng-repeat=\"solution in vm.solutions\">{{solution.name}}</md-option></md-select></md-input-container></div></div><div \nclass=\"form-title\"><span translate=\"ADMINISTRATION.FORMS.INACTIVE_DEVICE\">Inactive Device Details</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-checkbox \nng-model=\"vm.device.metadata.notification\" aria-label=\"Notification for inactive sensor\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.INACTIVE_SENSOR\">Notification for inactive sensor</span></label></md-checkbox></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.device.metadata.notification\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.NOTIFICATION_TYPE\">Notification Type</span></label><md-select \nng-model=\"vm.device.metadata.notificationType\" ng-required=\"true\"><md-option ng-value=\"notification.type\" \nng-repeat=\"notification in vm.notifications\">{{notification.name}}</md-option></md-select></md-input-container></div>\n<div class=\"input-block\" flex ng-if=\"vm.device.metadata.notificationType==\'custom\'\"><md-input-container \nclass=\"md-icon-float md-block\"><label><span translate=\"ADMINISTRATION.FORMS.NOTIFICATION_TIME\">\nNotification Time (miutes)</span></label><input ng-model=\"vm.notificationTime\" type=\"number\" ng-required=\"true\">\n</md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveDevice()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newDeviceGroup/new-device-group.html","<md-dialog class=\"new-deviceGroup-dialog\" aria-label=\"New Device Group\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div\n class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.ADD_DVC_GROUP\">New Device Group</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.DEVICE_GROUP_DETAILS\">Device Group details</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.CLIENT\">Client</span></label><md-select ng-model=\"vm.deviceGroup.tenant\" \nng-required=\"true\" ng-change=\"vm.fillSites(vm.deviceGroup.tenant,\'other\')\"><md-option \nng-value=\"tenant.authenticationToken\" ng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.SITE\">Site</span></label><md-select ng-model=\"vm.deviceGroup.site\" ng-required=\"true\">\n<md-option ng-value=\"site.token\" ng-repeat=\"site in vm.sites\">{{site.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.deviceGroup.name\" type=\"text\" \nng-required=\"true\" md-autofocus></md-input-container></div></div><input ng-model=\"vm.deviceGroup.token\" type=\"hidden\" \nng-required=\"true\" ng-disabled=\"true\"><div layout=\"row\"><div class=\"input-block\" flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.DESCRIPTION\">Description</span></label><text-angular \nng-model=\"vm.deviceGroup.description\"></text-angular></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveDeviceGroup()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newDeviceGroupDevices/new-device-group-device.html","<md-dialog class=\"new-dvc-grp-dialog\" aria-label=\"Add Device\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.ADD_DEVICE\">Add Device</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.SELECT_DEVICES\">Select Devices</span></div><div layout=\"row\"><div class=\"input-block\" \nflex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.TYPES\">Types</span></label><md-select \nng-model=\"vm.type\" ng-required=\"true\"><md-option ng-value=\"type.type\" ng-repeat=\"type in vm.types\">{{type.name}}\n</md-option></md-select></md-input-container></div><div class=\"input-block\" flex ng-if=\"vm.type===\'device\'\">\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.DEVICES\">Devices</span></label><md-select \nng-model=\"vm.deviceIds\" ng-required=\"true\" multiple=\"\"><md-option ng-value=\"device.token\" \nng-repeat=\"device in vm.listDevices\"><img src=\"{{device.image}}\" width=\"30px\"> {{device.name}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex ng-if=\"vm.type===\'group\'\"><md-input-container flex><label>\n<span translate=\"ADMINISTRATION.FORMS.DEVICES\">Devices</span></label><md-select ng-model=\"vm.deviceIds\" \nng-required=\"true\" multiple=\"\"><md-option ng-value=\"group.token\" ng-repeat=\"group in vm.listGroups\">{{group.name}}\n</md-option></md-select></md-input-container></div></div></div></div><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"vm.saveDeviceGroupDevice()\" class=\"save-button md-accent md-raised\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">SAVE</span>\n</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newNotification/new-notification.html","<md-dialog class=\"new-notification-dialog\" aria-label=\"New Notification\"><md-toolbar class=\"md-primary-bg md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.ADD_NOTIFICATION\">New Notification</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div id=\"content-wrapper\" class=\"content md-primary-bg md-hue-3\" layout=\"row\"><md-sidenav \nclass=\"sidenav md-sidenav-left md-whiteframe-1dp\" md-is-locked-open=\"1\" md-component-id=\"sidenav\" md-disable-backdrop \nms-scroll ms-sidenav-helper><div class=\"padding-10\"><div class=\"md-title\"><p class=\"mb-0 mt-10\" \nstyle=\"font-size: 16px\">{{ \'DASHBOARD.MONITORED_POINTS\' | translate }}</p></div><md-content class=\"content\" ms-scroll>\n<div class=\"search-wrapper\" layout=\"row\" layout-align=\"start center\"><div class=\"search md-background-bg md-hue-1\" \nflex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input \nclass=\"md-background-bg md-hue-1\" flex ng-model=\"vm.searchtree\" type=\"text\" ng-change=\"vm.applySearch()\" \nplaceholder=\"{{ \'DASHBOARD.SEARCH_TREE\' | translate }}\" style=\"font-size: 13px\"></div></div><div layout=\"row\"><div \nclass=\"tree\" js-tree=\"vm.treeConfig\" ng-model=\"vm.treeData\" tree=\"vm.treeInstance\" tree-events-obj=\"vm.treeEvents\" \nng-if=\"vm.showTree\"></div></div><md-content></md-content></md-content></div></md-sidenav><div class=\"row\" \nlayout=\"column \"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.NOTIFICATION_DETAILS\">Device details</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container \nclass=\"md-icon-float md-block\"><label><span translate=\"ADMINISTRATION.NOTIFICATION_TITLE\">Notification Title</span>\n</label><input ng-model=\"vm.notification.name\" type=\"text\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.NOTIFICATION_TYPE\">Notification Type</span></label><md-select \nng-model=\"vm.notification.type\" ng-required=\"true\"><md-option ng-value=\"notificationType.type\" \nng-repeat=\"notificationType in vm.notificationTypes\">{{notificationType.name}}</md-option></md-select>\n</md-input-container></div></div><div ng-if=\"vm.notification.type === \'Prediction\'\"><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-checkbox \nng-model=\"vm.notification.group\" aria-label=\"Notification for active\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.ACTIVE_NOTIFICATION\">Select group by function?</span></label></md-checkbox></div><div \nclass=\"input-block\" flex ng-if=\"vm.notification.group\"><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.GROUP_BY_FUNCTION\">Group by function</span></label><md-select \nng-model=\"vm.notification.function\" ng-required=\"true\"><md-option ng-value=\"func.type\" \nng-repeat=\"func in vm.functions\">{{func.name}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.notification.group\"><div class=\"input-block\" \nflex><md-input-container class=\"md-icon-float md-block\"><label><span translate=\"ADMINISTRATION.GROUP_BY_TYPE\">\nGroup by type</span></label><md-select ng-model=\"vm.notification.groupByType\" ng-required=\"true\"><md-option \nng-value=\"group.type\" ng-repeat=\"group in vm.groupByTypes\">{{group.name}}</md-option></md-select></md-input-container>\n</div><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.GROUP_BY_VAL\">Group by value</span></label><input \nng-model=\"vm.notification.groupByVal\" type=\"number\" min=\"1\" ng-required=\"true\"></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container \nclass=\"md-icon-float md-block\"><md-radio-group ng-model=\"vm.group1\" layout=\"row\"><md-radio-button \nng-repeat=\"chkbx in vm.checkboxes\" ng-value=\"chkbx.value\" class=\"blue\">{{chkbx.name}}</md-radio-button>\n</md-radio-group></md-input-container></div></div></div><div \nng-if=\"vm.notification.type === \'Prediction\' || vm.notification.type === \'Degradation\'\" layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container \nclass=\"md-icon-float md-block\"><label><span translate=\"ADMINISTRATION.FORMS.RENEWAL_PERIOD\">Time Renewal Period</span>\n</label><md-select ng-model=\"vm.notification.typePeriod\" ng-required=\"true\"><md-option ng-value=\"notification.type\" \nng-repeat=\"notification in vm.notificationsPeriod\">{{notification.name}}</md-option></md-select></md-input-container>\n</div><div ng-if=\"vm.notification.typePeriod === \'custom\'\" class=\"input-block\" flex><md-input-container \nclass=\"md-icon-float md-block\"><label for=\"exampleInput\"><span translate=\"ADMINISTRATION.FORMS.RENEWAL_TIME\">\nTime of renewal</span></label><input type=\"time\" id=\"exampleInput\" name=\"time\" ng-model=\"vm.time.value\" \nplaceholder=\"24:00:00\" required></md-input-container></div><div ng-if=\"vm.notification.typePeriod === \'interval\'\" \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.NOTIFICATION_INTERVAL\">Interval Number</span></label><input ng-model=\"vm.intervalNum\" \ntype=\"number\" min=\"0\" ng-required=\"true\"></md-input-container></div></div><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.MEASUREMENT_DETAILS\">Measurement Details</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container \nclass=\"md-icon-float md-block\"><label><span translate=\"ADMINISTRATION.FORMS.TENANT\">Tenant</span></label><input \nng-model=\"vm.notification.tenant\" type=\"text\" ng-disabled=\"true\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.SITE\">SITE</span></label><input ng-model=\"vm.notification.site\" type=\"text\" \nng-disabled=\"true\" ng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span translate=\"ADMINISTRATION.FORMS.ASSIGNMENT\">Assignment</span></label><input \nng-model=\"vm.notification.assignment\" type=\"text\" ng-disabled=\"true\" ng-required=\"true\"></md-input-container></div><div\n class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.MEASUREMENT\">Measurement</span></label><input ng-model=\"vm.notification.measurement\" \ntype=\"text\" ng-disabled=\"true\" ng-required=\"true\"></md-input-container></div></div><div class=\"form-title\" \nng-if=\"vm.notification.type === \'Stream\' || vm.notification.type === \'Median\' || vm.notification.type === \'Mean\' || vm.notification.type === \'Sum\'\">\n<span translate=\"ADMINISTRATION.FORMS.THRESHOLDS\">Measurement Thresholds</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"vm.notification.type === \'Stream\' || vm.notification.type === \'Median\' || vm.notification.type === \'Mean\' || vm.notification.type === \'Sum\'\">\n<div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.UPPER_LIMIT\">Upper Limit</span></label><input ng-model=\"vm.notification.max\" \ntype=\"number\" ng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container \nclass=\"md-icon-float md-block\"><label><span translate=\"ADMINISTRATION.FORMS.LOWER_LIMIT\">Lower Limit</span></label>\n<input ng-model=\"vm.notification.min\" type=\"number\" ng-required=\"true\"></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"vm.notification.type === \'Median\' || vm.notification.type === \'Mean\' || vm.notification.type === \'Sum\'\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.PERIOD_TYPE\">Period Type</span></label><md-select \nng-model=\"vm.notification.periodType\" ng-required=\"true\"><md-option ng-value=\"period.type\" \nng-repeat=\"period in vm.periods\">{{period.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.PERIOD\">Period</span></label><input ng-model=\"vm.notification.period\" type=\"number\" \nng-required=\"true\"></md-input-container></div></div><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.NOTIFY_VIA\">Notify Via</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-checkbox ng-model=\"vm.notification.portal\" \naria-label=\"Notification for active\"><label><span translate=\"ADMINISTRATION.FORMS.PORTAL\">Portal</span></label>\n</md-checkbox></div><div class=\"input-block\" flex><md-checkbox ng-model=\"vm.notification.mail\" \naria-label=\"Notification for active\"><label><span translate=\"ADMINISTRATION.FORMS.MAIL\">Mail</span></label>\n</md-checkbox></div><div class=\"input-block\" flex><md-checkbox ng-model=\"vm.notification.sms\" \naria-label=\"Notification for active\"><label><span translate=\"ADMINISTRATION.FORMS.SMS\">Sms</span></label></md-checkbox>\n</div></div><div class=\"form-title\"><span translate=\"ADMINISTRATION.FORMS.ACTIVE_NOTIFICATION_DETAILS\">\nActive Notification Details</span></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-checkbox ng-model=\"vm.activeNotification\" aria-label=\"Notification for active\"><label>\n<span translate=\"ADMINISTRATION.FORMS.ACTIVE_NOTIFICATION\">Active Notification</span></label></md-checkbox></div></div>\n</div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.saveNotification()\" aria-label=\"Save\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\">\n<span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newSite/new-site.html","<md-dialog class=\"new-site-dialog\" aria-label=\"New Site\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.FORMS.ADD_SITE\">New Site</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-tabs><md-tab>\n<md-tab-label><span translate=\"ADMINISTRATION.FORMS.GENERAL\">General</span></md-tab-label><md-tab-body><div \nclass=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.BUILDING_NAME\">Building Name</span></label><input\n ng-model=\"vm.site.name\" type=\"text\" ng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.SITE_TYPE\">Site Type</span></label><md-select \nng-model=\"vm.site.metadata.siteType\" ng-required=\"true\"><md-option ng-value=\"site\" ng-repeat=\"site in vm.siteTypes\">\n{{site}}</md-option></md-select></md-input-container></div></div><div layout=\"row\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.TENANT\">Tenant</span></label><md-select \nng-model=\"vm.site.tenant\" ng-required=\"true\"><md-option ng-value=\"tenant.authenticationToken\" \nng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"row\"><div class=\"input-block\" flex><label><span translate=\"ADMINISTRATION.FORMS.DESCRIPTION\">Description</span>\n</label><text-angular ng-model=\"vm.site.description\"></text-angular></div></div></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"ADMINISTRATION.FORMS.LOCATION\">Location</span></md-tab-label><md-tab-body><div \nclass=\"form-content\"><div layout=\"row\"><div class=\"input-block\" flex><ms-widget layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><ui-gmap-google-map center=\"vm.map.center\" zoom=\"vm.site.map.metadata.zoomLevel\" \ndraggable=\"true\" events=\"vm.map.events\"><ui-gmap-marker ng-repeat=\"m in vm.map.markers\" coords=\"m.coords\" \nicon=\"m.icon\" idkey=\"m.id\"></ui-gmap-marker></ui-gmap-google-map></ms-widget-front></ms-widget></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.CENTER_LAT\">Center Latitude</span></label><input \nng-model=\"vm.site.map.metadata.centerLatitude\" type=\"number\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.CENTER_LONG\">\nCenter Longitude</span></label><input ng-model=\"vm.site.map.metadata.centerLongitude\" type=\"number\" ng-required=\"true\">\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.CITY\">City</span>\n</label><input ng-model=\"vm.site.metadata.city\" type=\"text\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.STREET_NAME\">Street Name\n</span></label><input ng-model=\"vm.site.metadata.street\" type=\"text\" ng-required=\"true\"></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.HOUSE_NUMBER\">House Number</span></label><input \nng-model=\"vm.site.metadata.houseNumber\" type=\"text\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.POST_CODE\">Post Code\n</span></label><input ng-model=\"vm.site.metadata.postCode\" type=\"text\" ng-required=\"true\"></md-input-container></div>\n</div></div></md-tab-body></md-tab><md-tab ng-if=\"vm.site.metadata.siteType===\'Building\'\"><md-tab-label><span \ntranslate=\"ADMINISTRATION.FORMS.BUILDING_TYPE\">Building Type</span></md-tab-label><md-tab-body><div \nclass=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.WALL_STRUCTURE\">Wall Structure</span></label>\n<md-select ng-model=\"vm.site.metadata.wallStructure\" ng-required=\"true\"><md-option ng-value=\"wall\" \nng-repeat=\"wall in vm.wallTypes\">{{wall}}</md-option></md-select></md-input-container></div><div class=\"input-block\" \nflex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.GROUND_FLOOR\">Ground Floor</span></label>\n<md-select ng-model=\"vm.site.metadata.groundFloor\" ng-required=\"true\"><md-option ng-value=\"ground\" \nng-repeat=\"ground in vm.floorTypes\">{{ground}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.ROOF_INSULATION\">Roof Insulation</span></label><md-select \nng-model=\"vm.site.metadata.roofInsulation\" ng-required=\"true\"><md-option ng-value=\"roof\" \nng-repeat=\"roof in vm.roofInsulation\">{{roof}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex ng-if=\"vm.site.metadata.roofInsulation===\'Yes\'\"><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.ROOF_INSULATION_TYPE\">Roof Insulation Type</span></label><md-select \nng-model=\"vm.site.metadata.roofInsulationType\" ng-required=\"true\"><md-option ng-value=\"roofInsulation\" \nng-repeat=\"roofInsulation in vm.roofInsulationTypes\">{{roofInsulation}}</md-option></md-select></md-input-container>\n</div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.HEATING_TYPE\">Heating Type</span></label>\n<md-select ng-model=\"vm.site.metadata.heating\" ng-required=\"true\"><md-option ng-value=\"heating\" \nng-repeat=\"heating in vm.heatingTypes\">{{heating}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.AC_TYPE\">\nAirconditioning Type</span></label><md-select ng-model=\"vm.site.metadata.airconditioning\" ng-required=\"true\"><md-option\n ng-value=\"airco\" ng-repeat=\"airco in vm.aircoTypes\">{{airco}}</md-option></md-select></md-input-container></div></div>\n<div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container \nflex><label><span translate=\"ADMINISTRATION.FORMS.VENTILATION_TYPE\">Ventilation Type</span></label><md-select \nng-model=\"vm.site.metadata.ventilation\" ng-required=\"true\"><md-option ng-value=\"ventilation\" \nng-repeat=\"ventilation in vm.ventilationTypes\">{{ventilation}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.BUILDING_TYPE\">\nBuilding Type</span></label><md-select ng-model=\"vm.site.metadata.buildingType\" ng-required=\"true\"><md-option \nng-value=\"key\" ng-repeat=\"(key, value) in vm.buildingTypes\">{{key}}</md-option></md-select></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.BUILDING_SUBTYPE\">Building Subtype</span></label>\n<md-select ng-model=\"vm.site.metadata.buildingSubType\" ng-required=\"true\"><md-option ng-value=\"type\" \nng-repeat=\"type in vm.buildingTypes[vm.site.metadata.buildingType]\">{{type}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.ENERGY_LABEL\">Energy Label</span></label><md-select \nng-model=\"vm.site.metadata.energyLabel\" ng-required=\"true\"><md-option ng-value=\"energy\" \nng-repeat=\"energy in vm.energyLabels\">{{energy}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.BUILT_YEAR\">Built Year</span></label><input \nng-model=\"vm.site.metadata.year\" type=\"number\" ng-required=\"false\"></md-input-container></div><div class=\"input-block\" \nflex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.WORKING_AREA\">Working Area</span> (m2)\n</label><input ng-model=\"vm.site.metadata.workingArea\" type=\"number\" ng-required=\"false\"></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.OCCUPANTS\">Occupants</span></label><input \nng-model=\"vm.site.metadata.occupants\" type=\"number\" ng-required=\"false\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.LENGTH\">\nDimensions Length</span> (m)</label><input ng-model=\"vm.site.metadata.dimensionsX\" type=\"number\" ng-required=\"false\">\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.WIDTH\">Dimensions Width\n</span> (m)</label><input ng-model=\"vm.site.metadata.dimensionsY\" type=\"number\" ng-required=\"false\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.HEIGHT\">Dimensions Height</span> (m)</label><input \nng-model=\"vm.site.metadata.dimensionsZ\" type=\"number\" ng-required=\"false\"></md-input-container></div></div></div>\n</md-tab-body></md-tab></md-tabs><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.saveSite()\" aria-label=\"Save\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span \ntranslate=\"ADMINISTRATION.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newSiteGroup/new-site-group.html","<md-dialog class=\"new-portfolio-dialog\" aria-label=\"New Portfolio\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.FORMS.ADD_PORTFOLIO\">New Portfolio</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.PORTFOLIO_DETAILS\">Portfolio details</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.CLIENT\">Client</span></label><md-select ng-model=\"vm.deviceGroup.tenant\" \nng-required=\"true\" ng-change=\"vm.fillSites(vm.deviceGroup.tenant)\"><md-option ng-value=\"tenant.authenticationToken\" \nng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex></div></div><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label>\n<span translate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.deviceGroup.name\" type=\"text\" \nng-required=\"true\" md-autofocus></md-input-container></div></div><input ng-model=\"vm.deviceGroup.token\" type=\"hidden\" \nng-required=\"true\" ng-disabled=\"true\"><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label>\n<span translate=\"ADMINISTRATION.AUTH_USERS\">Authorized users</span></label><md-select ng-model=\"vm.deviceGroup.roles\" \nng-required=\"false\" multiple=\"\"><md-option ng-value=\"user.username\" ng-repeat=\"user in vm.users\" \nng-if=\"user.metadata.role===\'level04\'\">{{user.firstName}} {{user.lastName}}</md-option></md-select>\n</md-input-container></div></div><div class=\"form-title\"><span translate=\"ADMINISTRATION.FORMS.PORTFOLIO_DESCRIPTION\">\nPortfolio description</span></div><div layout=\"row\"><div class=\"input-block\" flex><text-angular \nng-model=\"vm.deviceGroup.description\"></text-angular></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveDeviceGroup()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newSiteGroupSites/new-site-group-site.html","<md-dialog class=\"manage-portfolio-dialog\" aria-label=\"Add Site\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.ADD_SITE\">Add Site</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.SELECT_SITES\">Select Sites</span></div><div layout=\"row\"><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.SITES\">Sites</span></label><md-select \nng-model=\"vm.siteIdsTemp\" ng-required=\"true\" multiple=\"\"><md-option ng-value=\"site.token\" \nng-repeat=\"site in vm.sites.results\">{{site.name}}</md-option></md-select></md-input-container></div></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-click=\"vm.saveDeviceGroupDevice()\" class=\"save-button md-accent md-raised\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">SAVE</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newSpecification/new-specification.html","<md-dialog class=\"new-spec-dialog\" aria-label=\"New Specification\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.ADD_SPECIFICATION\">New Specification</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><md-tabs><md-tab><md-tab-label><span translate=\"ADMINISTRATION.FORMS.GENERAL\">General</span>\n</md-tab-label><md-tab-body><div class=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.specification.name\" type=\"text\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.CLIENT\">Client</span></label><md-select ng-model=\"vm.specification.tenant\" \nng-required=\"true\" ng-change=\"vm.assetModule(vm.specification.tenant)\"><md-option \nng-value=\"tenant.authenticationToken\" ng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.ASSET_PROVIDER\">Asset Provider\n</span></label><md-select ng-model=\"vm.specification.assetModuleId\" ng-required=\"true\" \nng-change=\"vm.assetsFunction(vm.specification.assetModuleId)\"><md-option ng-value=\"assetModule.id\" \nng-repeat=\"assetModule in vm.assetModules\" ng-if=\"assetModule.assetType==\'Device\'\">{{assetModule.name}}</md-option>\n</md-select></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.DEVICE_TYPE\">Device Type</span></label><md-select ng-model=\"vm.specification.assetId\" \nng-required=\"true\"><md-option ng-value=\"asset.id\" ng-repeat=\"asset in vm.assets\"><img src=\"{{asset.imageUrl}}\" \nwidth=\"50px\"> {{asset.name}}</md-option></md-select></md-input-container></div></div></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"ADMINISTRATION.FORMS.SPECS\">Specs</span></md-tab-label><md-tab-body><div \nclass=\"form-content\"><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.SPECIFICATION_PRIORITY\">Specification Priority</span></label><input \nng-model=\"vm.specification.metadata.priority\" type=\"number\" ng-required=\"true\"></md-input-container></div></div><hr>\n<div ng-repeat=\"spec in vm.specs\"><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.addNewSpec();\" aria-label=\"New Measurement\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.NEW_MEASUREMENT\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"ADMINISTRATION.NEW_MEASUREMENT\">New Measurement</span></md-tooltip><md-icon md-font-icon=\"icon-plus\" \nclass=\"s24\" aria-hidden=\"true\"></md-icon></md-button></md-input-container></div><div class=\"input-block\" flex>\n<md-input-container flex><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.removeSpec(spec.id);\" \naria-label=\"Remove Measurement\" translate translate-attr-aria-label=\"ADMINISTRATION.REMOVE_MEASUREMENT\"><md-tooltip \nmd-direction=\"top\"><span translate=\"ADMINISTRATION.REMOVE_MEASUREMENT\">Remove Measurement</span></md-tooltip><md-icon \nmd-font-icon=\"icon-minus\" class=\"s24\" aria-hidden=\"true\"></md-icon></md-button></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.MEASUREMENT\">Measurement</span></label><input ng-model=\"spec.name\" type=\"text\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FRIENDLY_NAME\">Friendly Name</span></label><input ng-model=\"spec.friendlyName\" type=\"text\" \nng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\">\n<div class=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.MEASUREMENT_UNIT\">\nMeasurement Unit</span></label><input ng-model=\"spec.unit\" type=\"text\" ng-required=\"true\"></md-input-container></div>\n<div class=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.MEASUREMENT_TYPE\">\nMeasurement Type</span></label><md-select ng-model=\"spec.type\" ng-required=\"true\"><md-option ng-value=\"type.type\" \nng-repeat=\"type in vm.types\">{{type.name}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<md-checkbox ng-model=\"spec.cost\">Can assign Cost</md-checkbox></md-input-container></div><div class=\"input-block\" \nflex><md-input-container flex><md-checkbox ng-model=\"spec.expert\">For Expert Users</md-checkbox></md-input-container>\n</div><div class=\"input-block\" flex><md-input-container flex><md-checkbox ng-model=\"spec.metadata\">String Value\n</md-checkbox></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><md-checkbox ng-model=\"spec.aggregated\">Can be aggregated\n</md-checkbox></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-model=\"spec.cumulative\">Is Cumulative</md-checkbox></md-input-container></div></div><hr></div></div></md-tab-body>\n</md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.saveSpecification()\" aria-label=\"Save\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\">\n<span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newTariff/new-tariff.html","<md-dialog class=\"new-user-dialog\" aria-label=\"New Tariff\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.FORMS.ADD_TARIFF\">New Tariff</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.TARIFF_TYPE\">Tariff type</span></label><md-select ng-model=\"vm.tariff.type\" \nng-required=\"true\" ng-change=\"vm.clearFields()\"><md-option ng-value=\"tariffType.type\" \nng-repeat=\"tariffType in vm.tariffTypes\">{{tariffType.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex ng-if=\"vm.tariff.type===\'unit\'\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.TARIFF_NAME\">Tariff Name</span></label><input ng-model=\"vm.tariff.name\" type=\"text\" \nng-required=\"true\" maxlength=\"2\"></md-input-container><md-input-container flex ng-if=\"vm.tariff.type!==\'unit\'\"><label>\n<span translate=\"ADMINISTRATION.FORMS.TARIFF_NAME\">Tariff Name</span></label><input ng-model=\"vm.tariff.name\" \ntype=\"text\" ng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.TARIFF_COST\">Tariff Cost</span></label><input ng-model=\"vm.tariff.cost\" type=\"number\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.VAT\">Vat</span></label><input ng-model=\"vm.tariff.vat\" type=\"number\" \nng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\">\n<div class=\"input-block\" flex ng-if=\"vm.tariff.type===\'fixed\' || vm.tariff.type===\'return\'\"><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.TARIFF_PERIOD\">Tariff Period (Days)</span></label><input \nng-model=\"vm.tariff.period\" type=\"number\" ng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex \nng-if=\"vm.user.role===\'level02\' || vm.user.role===\'level01\'\"><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.CLIENT\">Client</span></label><md-select ng-model=\"vm.tariff.tenant\" ng-required=\"true\">\n<md-option ng-value=\"tenant.authenticationToken\" ng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option>\n</md-select></md-input-container></div></div></div></div><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveTariff()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><md-icon md-font-icon=\"icon-floppy\" aria-hidden=\"true\"></md-icon>\n<span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/dialogs/newTenant/new-tenant.html","<md-dialog class=\"new-client-dialog\" aria-label=\"New Client\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.FORMS.ADD_CLIENT\">New Client</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.CLIENT_DETAILS\">Client details</span></div><div layout=\"row\"><div class=\"input-block\" \nflex><md-input-container flex><label><span translate=\"ADMINISTRATION.NAME\">Name</span></label><input \nng-model=\"vm.tenant.name\" type=\"text\" ng-required=\"true\" md-autofocus></md-input-container></div></div><input \nng-model=\"vm.tenant.id\" type=\"hidden\" ng-required=\"true\" ng-disabled=\"true\"> <input \nng-model=\"vm.tenant.authenticationToken\" type=\"hidden\" ng-required=\"true\" ng-disabled=\"true\"><div layout=\"row\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.AUTH_USERS\">Authorized users\n</span></label><md-select ng-model=\"vm.tenant.authorizedUserIds\" ng-required=\"true\" multiple=\"\"><md-option \nng-value=\"user.username\" ng-repeat=\"user in vm.users\" \nng-if=\"user.metadata.role===\'level02\' || user.metadata.role===\'level03\'\">{{user.firstName}} {{user.lastName}}\n</md-option></md-select></md-input-container></div></div><div layout=\"row\"><div class=\"input-block\" flex><choose-file \nlayout=\"row\" flex file-url=\"vm.tenant.logoUrl\" file-name=\"vm.file\"><div class=\"media\" \nstyle=\"background-image: url(\'assets/images/placeholder.png\')\" ng-show=\"!vm.tenant.logoUrl\"></div><div class=\"media\" \nstyle=\"background-image: url(\'{{vm.tenant.logoUrl}}\')\" ng-show=\"vm.tenant.logoUrl\"></div><input id=\"fileInput\" \ntype=\"file\" class=\"ng-hide\"><md-input-container class=\"md-icon-float md-block\"><label><span \ntranslate=\"ADMINISTRATION.FORMS.LOGO\">Logo image</span></label><input type=\"text\" ng-model=\"vm.file\" \ndisabled=\"disabled\"></md-input-container><md-button id=\"uploadButton\" class=\"upload-button\" aria-label=\"Upload image\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.FORMS.UPLOAD_IMAGE\"><md-icon md-font-icon=\"icon-upload\" \naria-hidden=\"true\"></md-icon></md-button></choose-file></div></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveTenant()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newUser/new-user.html","<md-dialog class=\"new-user-dialog\" aria-label=\"New User\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.FORMS.ADD_USER\">New User</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.LOGIN_DETAILS\">Login details</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.USER_TYPE\">User type</span></label><md-select ng-model=\"vm.user.metadata.role\" \nng-required=\"true\"><md-option ng-value=\"userType.type\" ng-repeat=\"userType in vm.userTypes\">{{userType.name}}\n</md-option></md-select></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.USER_STATUS\">User status</span></label><md-select ng-model=\"vm.user.status\" \nng-required=\"true\"><md-option ng-value=\"stat\" ng-repeat=\"stat in vm.statuses\">{{stat}}</md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.USER_NAME\">Username\n</span></label><input ng-model=\"vm.user.username\" type=\"text\" ng-required=\"true\"></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.PASSWORD\">Password\n</span></label><input ng-model=\"vm.user.password\" type=\"password\" ng-required=\"true\"></md-input-container></div></div>\n<div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><choose-file \nlayout=\"row\" flex file-url=\"vm.user.metadata.imageUrl\" file-name=\"vm.file\"><div class=\"avatar\" \nstyle=\"background-image: url(\'assets/images/avatars/profile.jpg\')\" ng-show=\"!vm.user.metadata.imageUrl\"></div><div \nclass=\"avatar\" style=\"background-image: url(\'{{vm.user.metadata.imageUrl}}\')\" ng-show=\"vm.user.metadata.imageUrl\">\n</div><input id=\"fileInput\" type=\"file\" class=\"ng-hide\"><md-input-container class=\"md-icon-float md-block\"><label><span\n translate=\"ADMINISTRATION.FORMS.IMAGE\">Image</span></label><input type=\"text\" ng-model=\"vm.file\" disabled=\"disabled\">\n</md-input-container><md-button id=\"uploadButton\" class=\"upload-button\" aria-label=\"Upload image\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.UPLOAD_IMAGE\"><md-icon md-font-icon=\"icon-upload\" aria-hidden=\"true\">\n</md-icon></md-button></choose-file></div><div class=\"input-block\" flex ng-if=\"vm.solutions.length\"><md-input-container\n flex><label><span translate=\"ADMINISTRATION.FORMS.VERTICAL_SOLUTIONS\">Vertical Solutions</span></label><md-select \nng-model=\"vm.userPreferences.solutions\" ng-required=\"true\" multiple=\"\"><md-option ng-value=\"solution.token\" \nng-repeat=\"solution in vm.solutions\">{{solution.name}}</md-option></md-select></md-input-container></div></div><div \nclass=\"form-title\"><span translate=\"ADMINISTRATION.FORMS.CONTACT_DETAILS\">Contact details</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FIRST_NAME\">First name</span></label><input ng-model=\"vm.user.firstName\" \ntype=\"text\" ng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.LAST_NAME\">Last name</span></label><input ng-model=\"vm.user.lastName\" \ntype=\"text\" ng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.EMAIL\">E-mail</span></label><input ng-model=\"vm.user.metadata.email\" type=\"email\" \nng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.PHONE\">Phone</span></label><input ng-model=\"vm.user.metadata.phone\" type=\"text\" \nng-required=\"false\"></md-input-container></div></div></div></div><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveUser()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span translate=\"ADMINISTRATION.FORMS.SAVE\">Save</span>\n</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/dialogs/newVertical/new-vertical.html","<md-dialog class=\"new-vertical-dialog\" aria-label=\"New Vertical Solution\"><md-toolbar class=\"md-primary-bg md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"ADMINISTRATION.ADD_VERTICAL\">New Vertical Solution</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"ADMINISTRATION.FORMS.GENERAL\">General</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.NAME\">Name</span></label><input ng-model=\"vm.vertical.name\" type=\"text\" ng-required=\"true\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.PARENT\">Parent</span></label><md-select ng-model=\"vm.vertical.parent\" ng-required=\"true\">\n<md-option ng-value=\"vertical.token\" ng-repeat=\"vertical in vm.verticals\">{{vertical.name}}</md-option></md-select>\n</md-input-container></div></div><div class=\"form-title\"><span translate=\"ADMINISTRATION.FORMS.APPEARANCE_DETAILS\">\nAppearance Details</span></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.LOGO\">Logo</span>\n</label><input ng-model=\"vm.vertical.logo\" type=\"text\" ng-required=\"true\"></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"ADMINISTRATION.FORMS.PRIMARY_COLOR\">Primary Color</span></label><input \nng-model=\"vm.vertical.primary\" type=\"text\" ng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex>\n<md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.SECONDARY_COLOR\">Secondary Color</span></label>\n<input ng-model=\"vm.vertical.secondary\" type=\"text\" ng-required=\"true\"></md-input-container></div></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.saveVertical()\" aria-label=\"Save\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.SAVE\"><span \ntranslate=\"ADMINISTRATION.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/admin/dialogs/releaseAssignment/release-assignment.html","<md-dialog class=\"delete-user-dialog\" aria-label=\"Delete User\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><span \ntranslate=\"ADMINISTRATION.FORMS.RLS_DVC_ASS\">Release Device Assignment</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></span></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><p \nclass=\"message\"><span translate=\"ADMINISTRATION.FORMS.MESSAGES.RLS_ASS\">\nAre you sure you want to Release Assignment for the Device</span> {{vm.device.metadata.name}} ?</p></div></div>\n<md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button\n class=\"ok-button md-primary md-raised\" ng-click=\"vm.confirmDialog()\">OK</md-button><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><md-icon md-font-icon=\"icon-close\" aria-hidden=\"true\">\n</md-icon><span translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel</span></md-button></div></md-dialog-actions>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/breakdown/dialogs/breakdownSearch/breakdown-search.html","<md-dialog class=\"advanced-search-dialog\" aria-label=\"Advanced Search\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"COMPARE.ADVANCED_SEARCH\">Advanced Search</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"top-toolbar\" layout=\"row\" layout-xs=\"column\" layout-align=\"start center\" \nstyle=\"padding-left: 16px; padding-right: 16px; padding-bottom: 5px\"><div layout=\"row\" layout-align=\"start center\" \nflex><div class=\"graph-message\" style=\"height: 61.3594px; padding: 16px 0 0\"><p><span \ntranslate=\"BREAKDOWN.NOTHING_SELECTED\">Nothing selected...</span></p></div></div><div class=\"button-group\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"rect-button md-button-icon md-raised groupX middle\" \nng-click=\"vm.setSelect(\'rect\')\" aria-label=\"Rectangle\" translate \ntranslate-attr-aria-label=\"BREAKDOWN.SELECT_RECTANGLE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"BREAKDOWN.SELECT_RECTANGLE\">Rectangle</span></md-tooltip><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"rect-button md-button-icon md-raised groupX middle\" ng-click=\"vm.setSelect(\'rect\')\" aria-label=\"Circle\" \ntranslate translate-attr-aria-label=\"BREAKDOWN.SELECT_CIRCLE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"BREAKDOWN.SELECT_CIRCLE\">Circle</span></md-tooltip><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle-outline\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"rect-button md-button-icon md-raised groupX middle\" ng-click=\"vm.setSelect(\'rect\')\" aria-label=\"Freestyle\" \ntranslate translate-attr-aria-label=\"BREAKDOWN.SELECT_FREESTYLE\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"BREAKDOWN.SELECT_FREESTYLE\">Freestyle</span></md-tooltip><md-icon md-font-icon=\"icon-pencil\" \naria-hidden=\"true\"></md-icon></md-button></div></div><div class=\"row\" layout=\"column\"><ui-gmap-google-map \ncenter=\"vm.map.center\" zoom=\"vm.map.zoom\" control=\"vm.map.control\"><ui-gmap-window show=\"map.window.show\" \ncoords=\"map.window.model\" options=\"map.window.options\" closeclick=\"map.window.closeClick()\"><div ng-non-bindable=\"\">\ntest</div></ui-gmap-window><ui-gmap-markers models=\"vm.map.markers\" coords=\"\'coords\'\" type=\"\'spider\'\" fit=\"true\" \nevents=\"map.markersEvents\" labelcontent=\"\'labelContent\'\"></ui-gmap-markers></ui-gmap-google-map></div><md-tabs \nmd-dynamic-height md-selected=\"vm.selectedTab\" style=\"background-color: #fff\"><md-tab><md-tab-label><span \ntranslate=\"BREAKDOWN.SEARCH.SITES\">Sites</span></md-tab-label><md-tab-body><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"BREAKDOWN.SEARCH.SEARCH\">Search</span>\n</label><input ng-model=\"vm.search.sites.search\" ng-change=\"vm.search()\" type=\"text\"></md-input-container></div></div>\n<div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container \nflex><label translate=\"ADMINISTRATION.FORMS.BUILDING_TYPE\">Building Type</label><md-select \nng-model=\"vm.search.sites.type\"><md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.buildingTypes\">{{key}}\n</md-option></md-select></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label \ntranslate=\"ADMINISTRATION.FORMS.BUILDING_SUBTYPE\">Building Subtype</label><md-select \nng-model=\"vm.search.sites.subtype\"><md-option ng-value=\"type\" \nng-repeat=\"type in vm.buildingTypes[vm.search.sites.type]\">{{type}}</md-option></md-select></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container flex><label translate=\"ADMINISTRATION.FORMS.GROUND_FLOOR\">Ground Floor</label><md-select \nng-model=\"vm.search.sites.ground\"><md-option ng-value=\"ground\" ng-repeat=\"ground in vm.floorTypes\">{{ground}}\n</md-option></md-select></md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label \ntranslate=\"ADMINISTRATION.FORMS.WALL_STRUCTURE\">Wall Structure</label><md-select ng-model=\"vm.search.sites.wall\">\n<md-option ng-value=\"wall\" ng-repeat=\"wall in vm.wallTypes\">{{wall}}</md-option></md-select></md-input-container></div>\n<div class=\"input-block\" flex><md-input-container flex><label translate=\"ADMINISTRATION.FORMS.ROOF_INSULATION_TYPE\">\nRoof Insulation</label><md-select ng-model=\"vm.search.sites.roof\"><md-option ng-value=\"roof\" \nng-repeat=\"roof in vm.roofInsulation\">{{roof}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label translate=\"ADMINISTRATION.FORMS.HEATING_TYPE\">Heating Type</label><md-select ng-model=\"vm.search.sites.heating\">\n<md-option ng-value=\"heating\" ng-repeat=\"heating in vm.heatingTypes\">{{heating}}</md-option></md-select>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label \ntranslate=\"ADMINISTRATION.FORMS.AC_TYPE\">Airconditioning Type</label><md-select ng-model=\"vm.search.sites.airco\">\n<md-option ng-value=\"airco\" ng-repeat=\"airco in vm.aircoTypes\">{{airco}}</md-option></md-select></md-input-container>\n</div><div class=\"input-block\" flex><md-input-container flex><label translate=\"ADMINISTRATION.FORMS.VENTILATION_TYPE\">\nVentilation Type</label><md-select ng-model=\"vm.search.sites.ventilation\"><md-option ng-value=\"ventilation\" \nng-repeat=\"ventilation in vm.ventilationTypes\">{{ventilation}}</md-option></md-select></md-input-container></div></div>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start space-between\"><div class=\"chart-title\" flex=\"100\" layout=\"row\" layout-align=\"start center\" \nstyle=\"height: 36px\"><span translate=\"BREAKDOWN.DETAILS\">Details</span> <span \nclass=\"ml-16 mr-0 text-boxed pink-bg white-fg\"><ng-pluralize count=\"vm.selectedSites.length\" \nwhen=\"{\'one\': \'1 site\', \'other\': \'{} sites\'}\"></ng-pluralize></span><span \nclass=\"ml-16 text-boxed deep-orange-bg white-fg\"><ng-pluralize count=\"vm.detailsData.length\" \nwhen=\"{\'one\': \'1 assignment\', \'other\': \'{} assignments\'}\"></ng-pluralize></span></div><data-md-table-pagination \nflex=\"100\" md-limit=\"vm.tableOptions.limit\" md-page=\"vm.tableOptions.page\" md-total=\"{{vm.detailsData.length}}\">\n</data-md-table-pagination></div><md-divider></md-divider><md-table-container><table data-md-table \nclass=\"details card\"><thead md-head data-md-order=\"vm.tableOptions.order\"><tr md-row><th md-column \nmd:order:by=\"site.name\"><span translate=\"BREAKDOWN.SITE\">Site</span></th><th md-column \nmd:order:by=\"device.metadata.name\"><span translate=\"BREAKDOWN.ASSIGNMENT\">Assignment</span></th><th md-column \nmd:order:by=\"value\" style=\"padding-left: 24px; text-align: right\" colspan=\"2\"><span translate=\"BREAKDOWN.MEASUREMENT\">\nMeasurement</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.detailsData.length\"><td md-cell colspan=\"3\" \nstyle=\"padding: 15px 24px\"><span translate=\"BREAKDOWN.SELECT_DATA\">Please select data to display...</span></td></tr><tr\n md-row \ndata-ng-repeat=\"row in vm.detailsData | orderBy: vm.tableOptions.order | limitTo: vm.tableOptions.limit : (vm.tableOptions.page - 1) * vm.tableOptions.limit\">\n<td md-cell>{{row.site.name}}</td><td md-cell>{{row.device.metadata.name}}</td><td md-cell \nstyle=\"padding-right: 5px; text-align: right\">{{row.value}}</td><td md-cell style=\"padding-right: 56px; width: 50px\">\n{{row.unit}}</td></tr></tbody></table></md-table-container></ms-widget-front></ms-widget></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"BREAKDOWN.SEARCH.GROUPS\">Groups</span></md-tab-label><md-tab-body><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" \nflex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"BREAKDOWN.SEARCH.SEARCH\">Search</span></label><input ng-model=\"vm.search.groups.search\" \nng-change=\"vm.search()\" type=\"text\"></md-input-container></div></div></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start space-between\"><div class=\"chart-title\" flex=\"100\" layout=\"row\" \nlayout-align=\"start center\" style=\"height: 36px\"><span translate=\"BREAKDOWN.DETAILS\">Details</span> <span \nclass=\"ml-16 mr-0 text-boxed pink-bg white-fg\"><ng-pluralize count=\"vm.selectedSites.length\" \nwhen=\"{\'one\': \'1 site\', \'other\': \'{} sites\'}\"></ng-pluralize></span><span \nclass=\"ml-16 text-boxed deep-orange-bg white-fg\"><ng-pluralize count=\"vm.detailsData.length\" \nwhen=\"{\'one\': \'1 assignment\', \'other\': \'{} assignments\'}\"></ng-pluralize></span></div><data-md-table-pagination \nflex=\"100\" md-limit=\"vm.tableOptions.limit\" md-page=\"vm.tableOptions.page\" md-total=\"{{vm.detailsData.length}}\">\n</data-md-table-pagination></div><md-divider></md-divider><md-table-container><table data-md-table \nclass=\"details card\"><thead md-head data-md-order=\"vm.tableOptions.order\"><tr md-row><th md-column \nmd:order:by=\"site.name\"><span translate=\"BREAKDOWN.SITE\">Site</span></th><th md-column \nmd:order:by=\"device.metadata.name\"><span translate=\"BREAKDOWN.ASSIGNMENT\">Assignment</span></th><th md-column \nmd:order:by=\"value\" style=\"padding-left: 24px; text-align: right\" colspan=\"2\"><span translate=\"BREAKDOWN.MEASUREMENT\">\nMeasurement</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.detailsData.length\"><td md-cell colspan=\"3\" \nstyle=\"padding: 15px 24px\"><span translate=\"BREAKDOWN.SELECT_DATA\">Please select data to display...</span></td></tr><tr\n md-row \ndata-ng-repeat=\"row in vm.detailsData | orderBy: vm.tableOptions.order | limitTo: vm.tableOptions.limit : (vm.tableOptions.page - 1) * vm.tableOptions.limit\">\n<td md-cell>{{row.site.name}}</td><td md-cell>{{row.device.metadata.name}}</td><td md-cell \nstyle=\"padding-right: 5px; text-align: right\">{{row.value}}</td><td md-cell style=\"padding-right: 56px; width: 50px\">\n{{row.unit}}</td></tr></tbody></table></md-table-container></ms-widget-front></ms-widget></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"BREAKDOWN.SEARCH.DEVICES\">Devices</span></md-tab-label><md-tab-body><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" \nflex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"BREAKDOWN.SEARCH.SEARCH\">Search</span></label><input ng-model=\"vm.search.groups.search\" \nng-change=\"vm.search()\" type=\"text\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label>Device Type</label><md-select \nng-model=\"vm.search.devices.type\" multiple=\"true\"><md-option ng-value=\"key\" ng-repeat=\"(key, value) in vm.deviceTypes\">\n{{value}}</md-option></md-select></md-input-container></div><div class=\"input-block\" flex></div></div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"h3 p-16\" layout=\"row\" layout-xs=\"column\" layout-align=\"start space-between\"><div \nclass=\"chart-title\" flex=\"100\" layout=\"row\" layout-align=\"start center\" style=\"height: 36px\"><span \ntranslate=\"BREAKDOWN.DETAILS\">Details</span> <span class=\"ml-16 mr-0 text-boxed pink-bg white-fg\"><ng-pluralize \ncount=\"vm.selectedSites.length\" when=\"{\'one\': \'1 site\', \'other\': \'{} sites\'}\"></ng-pluralize></span><span \nclass=\"ml-16 text-boxed deep-orange-bg white-fg\"><ng-pluralize count=\"vm.detailsData.length\" \nwhen=\"{\'one\': \'1 assignment\', \'other\': \'{} assignments\'}\"></ng-pluralize></span></div><data-md-table-pagination \nflex=\"100\" md-limit=\"vm.tableOptions.limit\" md-page=\"vm.tableOptions.page\" md-total=\"{{vm.detailsData.length}}\">\n</data-md-table-pagination></div><md-divider></md-divider><md-table-container><table data-md-table \nclass=\"details card\"><thead md-head data-md-order=\"vm.tableOptions.order\"><tr md-row><th md-column \nmd:order:by=\"site.name\"><span translate=\"BREAKDOWN.SITE\">Site</span></th><th md-column \nmd:order:by=\"device.metadata.name\"><span translate=\"BREAKDOWN.ASSIGNMENT\">Assignment</span></th><th md-column \nmd:order:by=\"value\" style=\"padding-left: 24px; text-align: right\" colspan=\"2\"><span translate=\"BREAKDOWN.MEASUREMENT\">\nMeasurement</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"!vm.detailsData.length\"><td md-cell colspan=\"3\" \nstyle=\"padding: 15px 24px\"><span translate=\"BREAKDOWN.SELECT_DATA\">Please select data to display...</span></td></tr><tr\n md-row \ndata-ng-repeat=\"row in vm.detailsData | orderBy: vm.tableOptions.order | limitTo: vm.tableOptions.limit : (vm.tableOptions.page - 1) * vm.tableOptions.limit\">\n<td md-cell>{{row.site.name}}</td><td md-cell>{{row.device.metadata.name}}</td><td md-cell \nstyle=\"padding-right: 5px; text-align: right\">{{row.value}}</td><td md-cell style=\"padding-right: 56px; width: 50px\">\n{{row.unit}}</td></tr></tbody></table></md-table-container></ms-widget-front></ms-widget></div></md-tab-body></md-tab>\n</md-tabs><md-dialog-actions layout=\"row\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.excuteSearch()\" aria-label=\"Apply\" translate \ntranslate-attr-aria-label=\"BREAKDOWN.APPLY\"><span translate=\"BREAKDOWN.APPLY\">Apply</span></md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/breakdown/dialogs/deleteGraph/delete-graph.html","<md-dialog class=\"delete-user-dialog\" aria-label=\"Delete Graph\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"EVENTS.DELETE_GRAPH\">Delete Graph</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"BREAKDOWN.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><p class=\"message\" translate=\"BREAKDOWN.MESSAGE.DELETE_GRAPH\">\nAre you sure you want to delete this graph?</p></div></div><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"ok-button md-primary md-raised\" ng-click=\"vm.confirmDialog()\" aria-label=\"OK\" translate=\"BREAKDOWN.OK\" \ntranslate-attr-aria-label=\"BREAKDOWN.OK\">OK</md-button><md-button class=\"cancel-button md-raised\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate=\"BREAKDOWN.CANCEL\" \ntranslate-attr-aria-label=\"BREAKDOWN.CANCEL\">Cancel</md-button></div></md-dialog-actions></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/breakdown/dialogs/saveGraph/save-graph.html","<md-dialog class=\"new-event-dialog\" aria-label=\"Save Graph\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><span \ntranslate=\"BREAKDOWN.SAVE_GRAPH\">Save Graph</span></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"BREAKDOWN.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"md-foreground-fg\"><div class=\"row\" layout=\"column\"><div class=\"form-content\"><input ng-model=\"vm.graph.id\" \ntype=\"hidden\" ng-required=\"true\" ng-disabled=\"true\"><div class=\"form-title\" translate=\"BREAKDOWN.GRAPH_DETAILS\">\nGraph details</div><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label \ntranslate=\"BREAKDOWN.GRAPH_TITLE\">Title</label><input ng-model=\"vm.graph.name\" type=\"text\" ng-required=\"true\">\n</md-input-container></div></div><div layout=\"row\"><div class=\"input-block\" flex style=\"padding-bottom: 0\">\n<md-input-container flex><md-checkbox class=\"md-warn\" ng-model=\"vm.graph.is_datasource\" \naria-label=\"Include datasource\"><span translate=\"BREAKDOWN.INCLUDE_DATASOURCE\">Include datasource</span></md-checkbox>\n</md-input-container></div></div><div layout=\"row\"><div class=\"input-block\" flex style=\"padding-bottom: 0\">\n<md-input-container flex><md-checkbox class=\"md-warn\" ng-model=\"vm.graph.is_period\" aria-label=\"Include period\"><span \ntranslate=\"BREAKDOWN.INCLUDE_PERIOD\">Include period</span></md-checkbox></md-input-container></div></div><div \nclass=\"form-title\" translate=\"BREAKDOWN.GRAPH_DESCRIPTION\">Description</div><div layout=\"row\"><div class=\"input-block\" \nflex><text-angular ng-model=\"vm.graph.text\"></text-angular></div></div></div></div><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-click=\"vm.saveGraph()\" \nclass=\"save-button md-primary md-raised\" aria-label=\"SAVE\" translate=\"BREAKDOWN.SAVE\" \ntranslate-attr-aria-label=\"BREAKDOWN.SAVE\">SAVE</md-button><md-button ng-click=\"vm.closeDialog()\" \nclass=\"save-button md-raised\" aria-label=\"Cancel\" translate=\"BREAKDOWN.CANCEL\" \ntranslate-attr-aria-label=\"BREAKDOWN.CANCEL\">SAVE</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/directives/ha-oven/dialogs/Info/info.html","<md-dialog class=\"ha-info\" aria-label=\"Information\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"{{vm.program.icon}}\" class=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon><span \ntranslate=\"DASHBOARD.WIDGET.INFORMATION\">Information</span> ({{vm.program.name}})</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\">{{vm.program.descr}}</p></div></div><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"OK\">OK</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/directives/ha-oven/dialogs/Options/options.html","<md-dialog class=\"ha-options\" aria-label=\"Options\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"{{vm.program.icon}}\" class=\"icon program icon-size-32\" aria-hidden=\"true\"></md-icon><span \ntranslate=\"DASHBOARD.WIDGET.OPTIONS\">Options</span> ({{vm.program.name}})</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.DURATION\">Duration</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-tooltip md-direction=\"right\">\n<span>0 - 23 <span translate=\"DASHBOARD.WIDGET.HOURS\">hours</span></span></md-tooltip><label class=\"first_letter\"><span\n translate=\"DASHBOARD.WIDGET.HOURS\">Hours</span></label><input ng-model=\"vm.program.hours\" \nng-change=\"vm.checkSecs(vm.program.hours, vm.program.mins)\" type=\"number\" step=\"1\" min=\"0\" max=\"23\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><md-tooltip md-direction=\"right\">\n<span>0 - 59 <span translate=\"DASHBOARD.WIDGET.MINS\">minutes</span></span></md-tooltip><label class=\"first_letter\">\n<span translate=\"DASHBOARD.WIDGET.MINS\">Minutes</span></label><input ng-model=\"vm.program.mins\" \nng-change=\"vm.checkSecs(vm.program.hours, vm.program.mins)\" type=\"number\" step=\"1\" min=\"0\" max=\"59\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><md-tooltip md-direction=\"right\">\n<span>0 - 59 <span translate=\"DASHBOARD.WIDGET.SECS\">seconds</span></span></md-tooltip><label class=\"first_letter\">\n<span translate=\"DASHBOARD.WIDGET.SECS\">Seconds</span></label><input ng-model=\"vm.program.secs\" \nng-disabled=\"vm.isDisabled\" type=\"number\" step=\"1\" min=\"0\" max=\"59\"></md-input-container></div></div><div \nclass=\"form-title\"><span translate=\"DASHBOARD.WIDGET.TEMP\">Temperature</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-slider-container \nng-disabled=\"isDisabled\"><span class=\"temperature\"><md-icon md-font-icon=\"pragma-icon-fridge-temp\" \nclass=\"open icon-size-24\" aria-hidden=\"true\"></md-icon>(°C)</span><md-slider ng-model=\"vm.program.temp\" flex min=\"30\" \nmax=\"{{vm.isMax}}\" md-discrete aria-label=\"Temperature Slider\"></md-slider><md-input-container><input flex \ntype=\"number\" ng-model=\"vm.program.temp\" min=\"30\" max=\"{{vm.isMax}}\" aria-label=\"Temperature\" \naria-controls=\"temperature-slider\"></md-input-container></md-slider-container></div></div></div></div>\n<md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button\n class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.applyOptions()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.APPLY\"><span translate=\"ADMINISTRATION.FORMS.APPLY\">Apply</span>\n</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/events/dialogs/deleteEvent/delete-event.html","<md-dialog class=\"delete-user-dialog\" aria-label=\"Delete Event\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"EVENTS.DELETE_EVENT\">Delete Event</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"EVENTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" \naria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" \nlayout=\"column\"><div class=\"form-content\"><p class=\"message\" translate=\"EVENTS.MESSAGE.DELETE_EVENT\">\nAre you sure you want to delete this event?</p></div></div><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"ok-button md-primary md-raised\" ng-click=\"vm.confirmDialog()\" aria-label=\"OK\" translate=\"EVENTS.OK\" \ntranslate-attr-aria-label=\"EVENTS.OK\">OK</md-button><md-button class=\"cancel-button md-raised\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate=\"EVENTS.CANCEL\" translate-attr-aria-label=\"EVENTS.CANCEL\">\nCancel</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/events/dialogs/editEvent/edit-event.html","<md-dialog class=\"new-event-dialog\" aria-label=\"New Event\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><span \ntranslate=\"EVENTS.EDIT_EVENT\">Edit Event</span>: <small ng-if=\"vm.selectedNode.text\">({{vm.selectedNode.text}})</small>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"EVENTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\">\n<input ng-model=\"vm.event.token\" type=\"hidden\" ng-required=\"true\" ng-disabled=\"true\"><div class=\"form-title\" \ntranslate=\"EVENTS.DETAILS\">Event details</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label translate=\"EVENTS.TYPE\">Event type</label><md-select \nng-model=\"vm.event.type\" ng-required=\"true\" md-autofocus><md-option ng-value=\"eventType.type\" \nng-repeat=\"eventType in vm.eventTypes\"><md-icon md-font-icon=\"{{eventType.icon}}\" aria-hidden=\"true\"></md-icon>\n{{eventType.name}}</md-option></md-select></md-input-container></div><div class=\"input-block\" flex><md-input-container \nflex><label translate=\"EVENTS.DATE\">Event date</label><md-datepicker ng-model=\"vm.event.eventDate\" \nmd-hide-icons=\"calendar\" ng-required=\"true\"></md-datepicker></md-input-container></div></div><div layout=\"row\"><div \nclass=\"input-block\" flex><md-input-container flex><label translate=\"EVENTS.TITLE\">Title</label><input \nng-model=\"vm.event.title\" type=\"text\" ng-required=\"true\"></md-input-container></div></div><div layout=\"row\"><div \nclass=\"input-block\" flex style=\"padding-bottom: 0\"><md-input-container flex><md-checkbox class=\"md-warn\" \nng-model=\"vm.event.publish\" aria-label=\"Publish\"><span translate=\"EVENTS.PUBLISH\">Publish</span></md-checkbox>\n</md-input-container></div></div><div class=\"form-title\" translate=\"EVENTS.DESCRIPTION\">Description</div><div \nlayout=\"row\"><div class=\"input-block\" flex><text-angular ng-model=\"vm.event.text\"></text-angular></div></div></div>\n</div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-primary md-raised\" aria-label=\"SAVE\" \ntranslate=\"EVENTS.SAVE\" translate-attr-aria-label=\"EVENTS.SAVE\">SAVE</md-button><md-button ng-click=\"vm.closeDialog()\" \nclass=\"save-button md-primary md-raised\" aria-label=\"Cancel\" translate=\"EVENTS.CANCEL\" \ntranslate-attr-aria-label=\"EVENTS.CANCEL\">Cancel</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/events/dialogs/newEvent/new-event.html","<md-dialog class=\"new-event-dialog\" aria-label=\"New Event\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><span \ntranslate=\"EVENTS.NEW_EVENT\">New Event</span>: <small ng-if=\"vm.selectedNode.text\">({{vm.selectedNode.text}})</small>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"EVENTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"md-foreground-fg\"><div class=\"row\" layout=\"column\">\n<div class=\"form-content\"><input ng-model=\"vm.event.token\" type=\"hidden\" ng-required=\"true\" ng-disabled=\"true\"><div \nclass=\"form-title\" translate=\"EVENTS.DETAILS\">Event details</div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label translate=\"EVENTS.TYPE\">\nEvent type</label><md-select ng-model=\"vm.event.type\" ng-required=\"true\" md-autofocus><md-option \nng-value=\"eventType.type\" ng-repeat=\"eventType in vm.eventTypes\"><md-icon md-font-icon=\"{{eventType.icon}}\" \naria-hidden=\"true\"></md-icon>{{eventType.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label translate=\"EVENTS.DATE\">Event date</label><md-datepicker \nng-model=\"vm.event.eventDate\" md-hide-icons=\"calendar\" ng-required=\"true\"></md-datepicker></md-input-container></div>\n</div><div layout=\"row\"><div class=\"input-block\" flex><md-input-container flex><label translate=\"EVENTS.TITLE\">Title\n</label><input ng-model=\"vm.event.title\" type=\"text\" ng-required=\"true\"></md-input-container></div></div><div \nlayout=\"row\"><div class=\"input-block\" flex style=\"padding-bottom: 0\"><md-input-container flex><md-checkbox \nclass=\"md-warn\" ng-model=\"vm.event.publish\" aria-label=\"Publish\"><span translate=\"EVENTS.PUBLISH\">Publish</span>\n</md-checkbox></md-input-container></div></div><div class=\"form-title\" translate=\"EVENTS.DESCRIPTION\">Description</div>\n<div layout=\"row\"><div class=\"input-block\" flex><text-angular ng-model=\"vm.event.text\"></text-angular></div></div>\n</div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-primary md-raised\" \naria-label=\"SAVE\" translate=\"EVENTS.SAVE\" translate-attr-aria-label=\"EVENTS.SAVE\">SAVE</md-button><md-button \nng-click=\"vm.closeDialog()\" class=\"save-button md-primary md-raised\" aria-label=\"Cancel\" translate=\"EVENTS.CANCEL\" \ntranslate-attr-aria-label=\"EVENTS.CANCEL\">Cancel</md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dashboard/dialogs/controlDashboard/controlDashboard.html","<md-dialog class=\"new-user-dialog\" aria-label=\"vm.action\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"DASHBOARD.{{vm.action | uppercase}}_DASHBOARD\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"DASHBOARD.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll class=\"md-foreground-fg\"><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div \nng-if=\"vm.action===\'New\' || vm.action===\'Edit\' || vm.action===\'Duplicate\'\"><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label \ntranslate=\"DASHBOARD.DASBOARD_NAME\">Dashboard Name</label><input ng-model=\"vm.dName\" type=\"text\" ng-required=\"true\">\n</md-input-container></div></div></div><p class=\"message md-background-fg md-hue-2\" ng-if=\"vm.action===\'Delete\'\" \ntranslate=\"DASHBOARD.MESSAGE.DELETE_DASHBOARD\">Are you sure you want to delete dashboard: \"{{vm.dashboard.name}}\"?</p>\n<p class=\"message md-background-fg md-hue-2\" ng-if=\"vm.action===\'Save\'\" translate=\"DASHBOARD.MESSAGE.SAVE_DASHBOARD\">\nAre you sure you want to save current changes to dashboard: \"{{vm.dashboard.name}}\"?</p><p \nclass=\"message md-background-fg md-hue-2\" ng-if=\"vm.action===\'Restore\'\" \ntranslate=\"DASHBOARD.MESSAGE.RESTORE_DASHBOARD\">Are you sure you want to restore the default dashboards?</p></div>\n</div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-if=\"vm.action===\'New\' || vm.action===\'Edit\' || vm.action===\'Save\'\" ng-click=\"vm.save()\" \naria-label=\"Save\" translate=\"DASHBOARD.SAVE\" translate-attr-aria-label=\"DASHBOARD.SAVE\" \nclass=\"save-button md-primary md-raised\">SAVE</md-button><md-button ng-if=\"vm.action===\'Duplicate\'\" \nng-click=\"vm.save()\" aria-label=\"Duplicate\" translate=\"DASHBOARD.DUPLICATE\" \ntranslate-attr-aria-label=\"DASHBOARD.DUPLICATE\" class=\"save-button md-primary md-raised\">DUPLICATE</md-button>\n<md-button ng-if=\"vm.action===\'Delete\'\" ng-click=\"vm.save()\" aria-label=\"Delete\" translate=\"DASHBOARD.DELETE\" \ntranslate-attr-aria-label=\"DASHBOARD.DELETE\" class=\"save-button md-primary md-raised\">DELETE</md-button><md-button \nng-if=\"vm.action===\'Restore\'\" ng-click=\"vm.save()\" aria-label=\"Restore\" translate=\"DASHBOARD.RESTORE\" \ntranslate-attr-aria-label=\"DASHBOARD.RESTORE\" class=\"save-button md-primary md-hue-1 md-raised\">RESTORE</md-button>\n</div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dashboard/dialogs/newWidget/newWidget.html","<md-dialog class=\"new-widget-dialog\" aria-label=\"vm.action\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"DASHBOARD.WIDGET.NEW\">New Widget</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"DASHBOARD.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nid=\"content-wrapper\" class=\"content\" layout=\"row\" ms-scroll><md-sidenav \nclass=\"sidenav md-sidenav-left md-whiteframe-1dp md-background-bg md-hue-1\" md-is-locked-open=\"1\" \nmd-component-id=\"sidenav\" md-disable-backdrop ms-scroll ms-sidenav-helper style=\"width:350px\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\" layout=\"row\" layout-align=\"space-between\" layout-padding><div class=\"heading\">\n{{ \'DASHBOARD.MONITORED_POINTS\' | translate }}</div></md-toolbar><md-content class=\"content md-background-bg md-hue-1\" \nms-scroll><div class=\"search-wrapper md-background-border md-hue-2\" layout=\"row\" layout-align=\"start center\" \nlayout-padding><div class=\"search md-background-bg md-hue-1\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input class=\"md-background-bg md-hue-1\" flex \nng-model=\"vm.searchtree\" type=\"text\" ng-change=\"vm.applySearchTree()\" \nplaceholder=\"{{ \'DASHBOARD.SEARCH_TREE\' | translate }}\"></div></div><div layout=\"row\" layout-padding \nng-if=\"vm.showTree\"><div class=\"tree\" js-tree=\"vm.treeConfig\" ng-model=\"vm.treeData\" tree=\"vm.treeInstance\" \ntree-events-obj=\"vm.treeEvents\"></div></div><md-content></md-content></md-content></md-sidenav><div layout=\"column\" \nflex><div id=\"topGoj\" class=\"p-10 pt-20 pb-20 md-primary-bg md-hue-1\"><ms-widget flippable=\"false\" layout=\"column\" \nflex=\"100 \" style=\"min-height: 180px\"><ms-widget-front class=\"md-background-bg md-hue-1\" \nng-style=\"{\'background-color\': (vm.widget.type===0 && vm.widget.graph.widgetHasColor) ? vm.widget.graph.widgetColor : \'none\'}\">\n<div class=\"h3 p-16\" layout=\"row\" layout-xs=\"column\" layout-align=\"start center\">{{vm.widget.title}}</div><md-divider>\n</md-divider><div layout=\"column\" class=\"\"><div layout=\"column\" class=\"pb-16\"><div class=\"chart-container m-16\" \nng-if=\"vm.preview\"><numeric-card widget=\"vm.widget\" dashboard-date=\"vm.dashboardDate\" ng-if=\"vm.widget.type===0\" \nstyle=\"text-align:center\"></numeric-card><plot-card widget=\"vm.widget\" dashboard-date=\"vm.dashboardDate\" \nng-if=\"vm.widget.type===1\" style=\"text-align:center\"></plot-card><pie-card widget=\"vm.widget\" \ndashboard-date=\"vm.dashboardDate\" ng-if=\"vm.widget.type===2\" style=\"text-align:center\"></pie-card><gauge-card \nwidget=\"vm.widget\" dashboard-date=\"vm.dashboardDate\" ng-if=\"vm.widget.type===3\" style=\"text-align:center\"></gauge-card>\n<spyder-card widget=\"vm.widget\" dashboard-date=\"vm.dashboardDate\" ng-if=\"vm.widget.type===4\" style=\"text-align:center\">\n</spyder-card><huba-plot widget=\"vm.widget\" dashboard-date=\"vm.dashboardDate\" ng-if=\"vm.widget.type===6\" \nstyle=\"text-align:center\"></huba-plot><huba-total widget=\"vm.widget\" dashboard-date=\"vm.dashboardDate\" \nng-if=\"vm.widget.type===7\" style=\"text-align:center\"></huba-total><huba-hours widget=\"vm.widget\" \ndashboard-date=\"vm.dashboardDate\" ng-if=\"vm.widget.type===8\" style=\"text-align:center\"></huba-hours><huba-transitions \nwidget=\"vm.widget\" dashboard-date=\"vm.dashboardDate\" ng-if=\"vm.widget.type===9\" style=\"text-align:center\">\n</huba-transitions><huba-peak widget=\"vm.widget\" dashboard-date=\"vm.dashboardDate\" ng-if=\"vm.widget.type===10\" \nstyle=\"text-align:center\"></huba-peak><floor-plan widget=\"vm.widget\" dashboard-date=\"vm.dashboardDate\" \nng-if=\"vm.widget.type===11\"></floor-plan><ph-card widget=\"vm.widget\" ng-if=\"vm.widget.type===12\" \nstyle=\"text-align:center\"></ph-card><wind-direction widget=\"vm.widget\" ng-if=\"vm.widget.type===13\" \nstyle=\"text-align:center\"></wind-direction><waste-bin widget=\"vm.widget\" ng-if=\"vm.widget.type===14\" \nstyle=\"text-align:center\"></waste-bin><waste-table widget=\"vm.widget\" dashboard-date=\"vm.dashboardDate\" \nng-if=\"vm.widget.type===15\" style=\"text-align:center\"></waste-table><lighting-card widget=\"vm.widget\" \nng-if=\"vm.widget.type===16\" style=\"text-align:center\"></lighting-card><parking-lot widget=\"vm.widget\" \nng-if=\"vm.widget.type===17\" style=\"text-align:center\"></parking-lot><table-card widget=\"vm.widget\" \ndashboard-date=\"vm.dashboardDate\" ng-if=\"vm.widget.type===18\" style=\"text-align:center\"></table-card><map-card \nwidget=\"vm.widget\" ng-if=\"vm.widget.type===19\"></map-card></div></div></div></ms-widget-front></ms-widget></div>\n<md-tabs md-dynamic-height class=\"\" md-selected=\"vm.selectedTab\" style=\"min-height: 364px\"><md-tab><md-tab-label><span \ntranslate=\"DASHBOARD.WIDGET.GENERAL\">General</span></md-tab-label><md-tab-body><div class=\"form-content\"><div \nclass=\"form-title\"><span translate=\"DASHBOARD.WIDGET.TITLE\">Widget Title</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.TITLE\">Widget Title</span></label><input ng-model=\"vm.widget.title\" type=\"text\" \nng-required=\"true\"></md-input-container></div></div><div class=\"form-title\"><span translate=\"DASHBOARD.WIDGET.TYPE\">\nWidget Type</span></div><section layout=\"row\" layout-wrap class=\"add-button\">General Widgets</section><section \nlayout=\"row\" layout-wrap class=\"add-button\"><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==0}\" ng-click=\"vm.changeWidgetType(0,\'measurements\',\'\',0);\" \naria-label=\"Numeric Widget\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.NUMERIC\"><md-tooltip \nmd-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.NUMERIC\">Numeric Widget</span></md-tooltip><md-icon \nmd-font-icon=\"icon-numeric-5-box-outline\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==1}\" \nng-click=\"vm.changeWidgetType(1,\'measurements\',\'line\',1);\" aria-label=\"Line Chart Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.LINE_CHART\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.LINE_CHART\">Line Chart Widget</span></md-tooltip><md-icon md-font-icon=\"icon-chart-line\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==2}\" ng-click=\"vm.changeWidgetType(1,\'measurements\',\'step\',2);\" \naria-label=\"Step Line Chart Widget\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.STEP_LINE_CHART\"><md-tooltip \nmd-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.STEP_LINE_CHART\">Step Line Chart Widget</span></md-tooltip>\n<md-icon md-font-icon=\"icon-chart-histogram\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==3}\" \nng-click=\"vm.changeWidgetType(1,\'measurements\',\'bar\',3);\" aria-label=\"Bar Chart Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.BAR_CHART\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.BAR_CHART\">Bar Chart Widget</span></md-tooltip><md-icon md-font-icon=\"icon-chart-bar\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==4}\" ng-click=\"vm.changeWidgetType(1,\'measurements\',\'bubble\',4);\" \naria-label=\"Bubble Widget\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.BUBBLE\"><md-tooltip \nmd-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.BUBBLE\">Bubble Widget</span></md-tooltip><md-icon \nmd-font-icon=\"pragma-icon-bubble-chart\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==5}\" \nng-click=\"vm.changeWidgetType(2,\'measurements\',\'pie\',5);\" aria-label=\"Pie Chart Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.PIE_CHART\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.PIE_CHART\">Pie Chart Widget</span></md-tooltip><md-icon md-font-icon=\"icon-chart-pie\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==6}\" ng-click=\"vm.changeWidgetType(2,\'measurements\',\'doughnut\',6);\" \naria-label=\"Doughnut Chart Widget\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.DOUGHNUT_CHART\"><md-tooltip \nmd-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.DOUGHNUT_CHART\">Doughnut Chart Widget</span></md-tooltip><md-icon\n md-font-icon=\"icon-chart-arc\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==7}\" \nng-click=\"vm.changeWidgetType(2,\'measurements\',\'polar\',7);\" aria-label=\"Polar Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.POLAR\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.POLAR\">Polar Widget</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-polar-chart\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==8}\" ng-click=\"vm.changeWidgetType(3,\'measurements\',\'gauge\',8);\" \naria-label=\"Current Occupancy Widget\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.GAUGE\"><md-tooltip \nmd-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.GAUGE\">Gauge Widget</span></md-tooltip><md-icon \nmd-font-icon=\"icon-speedometer\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==9}\" \nng-click=\"vm.changeWidgetType(4,\'measurements\',\'\',9);\" aria-label=\"Spyder Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.SPYDER\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.SPYDER\">Spyder Widget</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-spider-chart\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==10}\" ng-click=\"vm.changeWidgetType(5,\'null\',\'\',10);\" \naria-label=\"Section Widget\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.SECTION\"><md-tooltip \nmd-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.SECTION\">Section Widget</span></md-tooltip><md-icon \nmd-font-icon=\"icon-tag-text-outline\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==29}\" \nng-click=\"vm.changeWidgetType(18,\'measurements\',\'\',29);\" aria-label=\"Table Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.TABLE\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.TABLE\">Table Widget</span></md-tooltip><md-icon md-font-icon=\"icon-table-large\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==30}\" ng-click=\"vm.changeWidgetType(19,\'devices\',\'\',30);\" \naria-label=\"Map Widget\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.MAP\"><md-tooltip md-direction=\"left\">\n<span translate=\"DASHBOARD.WIDGET.MAP\">Map Widget</span></md-tooltip><md-icon md-font-icon=\"icon-google-maps\" \naria-hidden=\"true\"></md-icon></md-button></section><section layout=\"row\" layout-wrap class=\"add-button\" \nng-if=\"vm.showFootfall\">Footfall Widgets</section><section layout=\"row\" layout-wrap class=\"add-button\" \nng-if=\"vm.showFootfall\"><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==11}\" ng-click=\"vm.changeWidgetType(6,\'devices\',\'line\',11);\" \naria-label=\"Line Chart Widget\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.LINE_CHART\"><md-tooltip \nmd-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.LINE_CHART\">Line Chart Widget</span></md-tooltip><md-icon \nmd-font-icon=\"icon-chart-line\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==12}\" \nng-click=\"vm.changeWidgetType(6,\'devices\',\'step\',12);\" aria-label=\"Step Line Chart Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.STEP_LINE_CHART\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.STEP_LINE_CHART\">Step Line Chart Widget</span></md-tooltip><md-icon \nmd-font-icon=\"icon-chart-histogram\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==13}\" \nng-click=\"vm.changeWidgetType(6,\'devices\',\'bar\',13);\" aria-label=\"Bar Chart Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.BAR_CHART\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.BAR_CHART\">Bar Chart Widget</span></md-tooltip><md-icon md-font-icon=\"icon-chart-bar\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==14}\" ng-click=\"vm.changeWidgetType(6,\'devices\',\'bubble\',14);\" \naria-label=\"Bubble Widget\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.BUBBLE\"><md-tooltip \nmd-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.BUBBLE\">Bubble Widget</span></md-tooltip><md-icon \nmd-font-icon=\"pragma-icon-bubble-chart\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==15}\" \nng-click=\"vm.changeWidgetType(7,\'devices\',\'numeric\',15);\" aria-label=\"Numeric Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.NUMERIC\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.OCCUPANCY_NUMERIC_TOTAL\">Numeric Widget Total</span></md-tooltip><md-icon \nmd-font-icon=\"icon-account-multiple\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==16}\" \nng-click=\"vm.changeWidgetType(7,\'devices\',\'bar\',16);\" aria-label=\"Bar Chart Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.BAR_CHART\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.OCCUPANC_BAR_CHART_TOTAL\">Bar Chart Widget Total</span></md-tooltip><md-icon \nmd-font-icon=\"icon-chart-bar\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==17}\" \nng-click=\"vm.changeWidgetType(7,\'devices\',\'radar\',17);\" aria-label=\"Spyder Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.SPYDER\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.OCCUPANCY_SPYDER_TOTAL\">Spyder Widget Total</span></md-tooltip><md-icon \nmd-font-icon=\"pragma-icon-spider-chart\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==18}\" \nng-click=\"vm.changeWidgetType(8,\'devices\',\'\',18);\" aria-label=\"Spyder Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.SPYDER\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.OCCUPIED_HOURS_WIDGET\">Occupies Hours Widget</span></md-tooltip><md-icon \nmd-font-icon=\"icon-timer\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==19}\" \nng-click=\"vm.changeWidgetType(9,\'devices\',\'\',19);\" aria-label=\"Spyder Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.SPYDER\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.TRANSITIONS_WIDGET\">Transitions Widget</span></md-tooltip><md-icon \nmd-font-icon=\"icon-repeat\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==20}\" \nng-click=\"vm.changeWidgetType(10,\'devices\',\'\',20);\" aria-label=\"Parking Demand Hour Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.PARKING_HOUR\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.PEAK_HOUR_WIDGET\">Peak Hour Widget</span></md-tooltip><md-icon \nmd-font-icon=\"pragma-icon-parking-peak-hour\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==21}\" \nng-click=\"vm.changeWidgetType(11,\'devices\',\'\',21);\" aria-label=\"Floor Plan Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.FLOOR_PLAN\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.FLOOR_PLAN\">Floor Plan Widget</span></md-tooltip><md-icon md-font-icon=\"icon-home-modern\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==34}\" ng-click=\"vm.changeWidgetType(22,\'devices\',\'numeric\',34);\" \naria-label=\"Occupancy Counters\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.OCCUPANCY_COUNTERS\"><md-tooltip \nmd-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.OCCUPANCY_COUNTERS\">Occupancy Counters</span></md-tooltip>\n<md-icon md-font-icon=\"pragma-icon-entries-exits\" aria-hidden=\"true\"></md-icon></md-button></section><section \nlayout=\"row\" layout-wrap class=\"add-button\" ng-if=\"vm.showAgriculture\">Agriculture Widgets</section><section \nlayout=\"row\" layout-wrap class=\"add-button\" ng-if=\"vm.showAgriculture\"><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==22}\" \nng-click=\"vm.changeWidgetType(12,\'devices\',\'\',22);\" aria-label=\"PH Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.PH\"><md-tooltip md-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.PH\">\nPH Widget</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-ph\" aria-hidden=\"true\"></md-icon></md-button><md-button\n class=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==23}\" \nng-click=\"vm.changeWidgetType(13,\'devices\',\'\',23);\" aria-label=\"Wind Direction Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.WIND_DIRECTION\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.WIND_DIRECTION\">Wind Direction Widget</span></md-tooltip><md-icon \nmd-font-icon=\"pragma-icon-windspeed\" aria-hidden=\"true\"></md-icon></md-button></section><section layout=\"row\" \nlayout-wrap class=\"add-button\" ng-if=\"vm.showWaste\">Recycling Widgets</section><section layout=\"row\" layout-wrap \nclass=\"add-button\" ng-if=\"vm.showWaste\"><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==24}\" ng-click=\"vm.changeWidgetType(14,\'devices\',\'\',24);\" \naria-label=\"Waste Bin Widget\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.WASTE_BIN\"><md-tooltip \nmd-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.WASTE_BIN\">Waste Bin Widget</span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete-variant\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==25}\" \nng-click=\"vm.changeWidgetType(15,\'devices\',\'\',25);\" aria-label=\"Waste Table Widget\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.WASTE_TABLE\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.WASTE_TABLE\">Waste Table Widget</span></md-tooltip><md-icon \nmd-font-icon=\"icon-table-large\" aria-hidden=\"true\"></md-icon></md-button></section><section layout=\"row\" layout-wrap \nclass=\"add-button\" ng-if=\"vm.showLighting\">Lighting Widgets</section><section layout=\"row\" layout-wrap \nclass=\"add-button\" ng-if=\"vm.showLighting\"><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==26}\" ng-click=\"vm.changeWidgetType(16,\'devices\',\'inteli\',26);\" \naria-label=\"Inteli Lighting\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.INTELI\"><md-tooltip \nmd-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.INTELI\">Inteli Lighting</span></md-tooltip><md-icon \nmd-font-icon=\"pragma-icon-lamp\" aria-hidden=\"true\"></md-icon></md-button><md-button \nclass=\"md-icon-button md-accent dashboardButton\" ng-class=\"{\'md-fab md-mini\' : vm.toggledButton==27}\" \nng-click=\"vm.changeWidgetType(16,\'devices\',\'finot\',27);\" aria-label=\"FinOT Lighting\" translate \ntranslate-attr-aria-label=\"DASHBOARD.WIDGET.FINOT\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.FINOT\">FinOT Lighting</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-lamp\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==31}\" ng-click=\"vm.changeWidgetType(16,\'measurements\',\'enocean\',31);\" \naria-label=\"EnoCean Lighting\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.ENOCEAN\"><md-tooltip \nmd-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.ENOCEAN\">EnoCean Lighting</span></md-tooltip><md-icon \nmd-font-icon=\"pragma-icon-lamp\" aria-hidden=\"true\"></md-icon></md-button></section><section layout=\"row\" layout-wrap \nclass=\"add-button\" ng-if=\"vm.showParking\">Parking Widgets</section><section layout=\"row\" layout-wrap \nclass=\"add-button\" ng-if=\"vm.showParking\"><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==28}\" ng-click=\"vm.changeWidgetType(17,\'devices\',\'\',28);\" \naria-label=\"Parking Lot Widget\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.PARKING_LOT\"><md-tooltip \nmd-direction=\"left\"><span translate=\"DASHBOARD.WIDGET.PARKING_LOT\">Parking Lot Widget</span></md-tooltip><md-icon \nmd-font-icon=\"icon-parking\" aria-hidden=\"true\"></md-icon></md-button></section><section layout=\"row\" layout-wrap \nclass=\"add-button\" ng-if=\"vm.showLighting\">Device Control Widgets</section><section layout=\"row\" layout-wrap \nclass=\"add-button\" ng-if=\"vm.showLighting\"><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==32}\" ng-click=\"vm.changeWidgetType(20,\'devices\',\'plugwise\',32);\" \naria-label=\"Plugwise\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.PLUGWISE\"><md-tooltip md-direction=\"left\">\n<span translate=\"DASHBOARD.WIDGET.PLUGWISE\">Plugwise</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-smart-plug\" \naria-hidden=\"true\"></md-icon></md-button><md-button class=\"md-icon-button md-accent dashboardButton\" \nng-class=\"{\'md-fab md-mini\' : vm.toggledButton==33}\" ng-click=\"vm.changeWidgetType(21,\'devices\',\'lg\',33);\" \naria-label=\"Hvac\" translate translate-attr-aria-label=\"DASHBOARD.WIDGET.HVAC\"><md-tooltip md-direction=\"left\"><span \ntranslate=\"DASHBOARD.WIDGET.HVAC\">Hvac</span></md-tooltip><md-icon md-font-icon=\"icon-fan\" aria-hidden=\"true\">\n</md-icon></md-button></section></div></md-tab-body></md-tab><md-tab ng-if=\"vm.showDetails\"><md-tab-label><span \ntranslate=\"DASHBOARD.GRAPH.DETAILS\">Graph Details</span></md-tab-label><md-tab-body><div ng-if=\"vm.widget.type==0\"><div\n class=\"form-content\"><div class=\"form-title\"><span translate=\"DASHBOARD.WIDGET.VALUE_TYPE\">Value Type</span></div><div\n layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<md-radio-group ng-model=\"vm.widget.graph.type\" ng-change=\"vm.change();\"><md-radio-button ng-value=\"\'lastValue\'\" \nclass=\"blue\"><span translate=\"DASHBOARD.WIDGET.LAST_VALUE\">Last Value</span></md-radio-button><md-radio-button \nng-value=\"\'aggregatedValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.AGGREGATED_VALUE\">Aggregated Value</span>\n</md-radio-button><md-radio-button ng-value=\"\'meanValue\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.AVERAGE_VALUE\">Average Value</span></md-radio-button><md-radio-button \nng-value=\"\'minValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.MINIMUM_VALUE\">Minimum Value</span>\n</md-radio-button><md-radio-button ng-value=\"\'maxValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.MAXIMUM_VALUE\">\nMaximum Value</span></md-radio-button></md-radio-group></md-input-container></div></div><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.APPEARANCE\">Appearance</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-model=\"vm.widget.graph.aggregated\" ng-change=\"vm.change();\" aria-label=\"DASHBOARD.GRAPH.MEASUREMENTS_STACKED\"><span \ntranslate=\"DASHBOARD.GRAPH.MEASUREMENTS_STACKED\">Show Measurements Stacked</span></md-checkbox></md-input-container>\n</div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><label \ntranslate=\"DASHBOARD.WIDGET.ORIENTATION\">Widget Orientation</label><md-input-container flex><md-radio-group \nng-model=\"vm.widget.graph.orientation\" ng-change=\"vm.change();\"><md-radio-button ng-value=\"\'vertical\'\" class=\"blue\">\n<span translate=\"DASHBOARD.WIDGET.VERTICAL\">Vertical</span></md-radio-button><md-radio-button ng-value=\"\'horizontal\'\" \nclass=\"blue\"><span translate=\"DASHBOARD.WIDGET.HORIZONTAL\">Horizontal</span></md-radio-button></md-radio-group>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><md-checkbox ng-model=\"vm.widget.graph.widgetHasFontColor\" \nng-change=\"vm.change();\" aria-label=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\"><span \ntranslate=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\">Custom font color</span></md-checkbox></md-input-container></div></div>\n<div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.widget.graph.widgetHasFontColor\"><div \nclass=\"input-block\" flex><label translate=\"DASHBOARD.WIDGET.FONT_COLOR\">Widget Font Color</label><color-picker \nng-model=\"vm.widget.graph.fontColor\" ng-change=\"vm.change();\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\">\n</color-picker></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" \nflex><md-input-container flex><md-checkbox ng-model=\"vm.widget.graph.widgetHasColor\" ng-change=\"vm.change();\" \naria-label=\"DASHBOARD.WIDGET.CUSTOM_BACKGROUND_COLOR\"><span translate=\"DASHBOARD.WIDGET.CUSTOM_BACKGROUND_COLOR\">\nCustom background color</span></md-checkbox></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\" ng-if=\"vm.widget.graph.widgetHasColor\"><div class=\"input-block\" flex><label \ntranslate=\"DASHBOARD.WIDGET.BACKGROUND_COLOR\">Widget Backgound Color</label><color-picker \nng-model=\"vm.widget.graph.widgetColor\" ng-change=\"vm.change();\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\">\n</color-picker></div></div></div></div><div ng-if=\"vm.widget.type==1\"><div class=\"form-content\"><div \nclass=\"form-title\"><span translate=\"DASHBOARD.WIDGET.VALUE_TYPE\">Value Type</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-radio-group \nng-model=\"vm.widget.graph.type\" ng-change=\"vm.change();\"><md-radio-button ng-value=\"\'rawData\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.RAW_DATA\">Raw Data</span></md-radio-button><md-radio-button ng-value=\"\'aggregatedValue\'\" \nclass=\"blue\"><span translate=\"DASHBOARD.WIDGET.AGGREGATED_VALUE\">Aggregated Value</span></md-radio-button>\n<md-radio-button ng-value=\"\'meanValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.AVERAGE_VALUE\">Average Value\n</span></md-radio-button><md-radio-button ng-value=\"\'minValue\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.MINIMUM_VALUE\">Minimum Value</span></md-radio-button><md-radio-button \nng-value=\"\'maxValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.MAXIMUM_VALUE\">Maximum Value</span>\n</md-radio-button></md-radio-group></md-input-container></div></div></div><div class=\"form-content\"><div \nclass=\"form-title\" translate=\"DASHBOARD.GRAPH.VISUALIZATION\">Visualization</div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-model=\"vm.widget.graph.aggregated\" ng-change=\"vm.change();\" aria-label=\"DASHBOARD.GRAPH.MEASUREMENTS_STACKED\"><span \ntranslate=\"DASHBOARD.GRAPH.MEASUREMENTS_STACKED\">Show Measurements Stacked</span></md-checkbox></md-input-container>\n</div><div class=\"input-block\" flex ng-if=\"vm.widget.graph.graphType!=\'bar\'\"><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.POINT_STYLE\">Select Point Style</span></label><md-select ng-model=\"vm.widget.graph.point\" \nng-required=\"true\" ng-change=\"vm.change();\"><md-option value=\"circle\"><span translate=\"DASHBOARD.WIDGET.CIRCLE\">Circle\n</span></md-option><md-option value=\"triangle\"><span translate=\"DASHBOARD.WIDGET.TRIANGLE\">Triangle</span></md-option>\n<md-option value=\"rect\"><span translate=\"DASHBOARD.WIDGET.RECTANGLE\">Rectangle</span></md-option><md-option \nvalue=\"rectRounded\"><span translate=\"DASHBOARD.WIDGET.ROUNDED_RECTANGLE\">Rounded Rectangle</span></md-option><md-option\n value=\"rectRot\"><span translate=\"DASHBOARD.WIDGET.ROTATED_RECTANGLE\">Rotated Rectangle</span></md-option><md-option \nvalue=\"cross\"><span translate=\"DASHBOARD.WIDGET.CROSS\">Cross</span></md-option><md-option value=\"crossRot\"><span \ntranslate=\"DASHBOARD.WIDGET.ROTATED_CROSS\">Rotated Cross</span></md-option><md-option value=\"star\"><span \ntranslate=\"DASHBOARD.WIDGET.STAR\">Star</span></md-option><md-option value=\"line\"><span \ntranslate=\"DASHBOARD.WIDGET.LINE\">Line</span></md-option><md-option value=\"dash\"><span \ntranslate=\"DASHBOARD.WIDGET.DASH\">Dash</span></md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex ng-if=\"vm.widget.graph.graphType!=\'bar\'\"><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.POINT_SIZE\">Select Point Size</span></label><input ng-model=\"vm.widget.graph.pointSize\" \ntype=\"number\" ng-required=\"true\" ng-change=\"vm.change();\"></md-input-container></div></div><div class=\"form-title\">\n<span translate=\"DASHBOARD.WIDGET.APPEARANCE\">Appearance</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-model=\"vm.widget.graph.widgetHasFontColor\" ng-change=\"vm.change();\" aria-label=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\">\n<span translate=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\">Custom font color</span></md-checkbox></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.widget.graph.widgetHasFontColor\">\n<div class=\"input-block\" flex><label translate=\"DASHBOARD.WIDGET.FONT_COLOR\">Widget Font Color</label><color-picker \nng-model=\"vm.widget.graph.fontColor\" ng-change=\"vm.change();\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\">\n</color-picker></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" \nflex ng-if=\"vm.widget.graph.aggregated\"><label translate=\"DASHBOARD.WIDGET.CHART_COLOR\">Chart Color</label>\n<color-picker ng-model=\"vm.widget.graph.backgroundColor\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\" \nng-change=\"vm.change();\"></color-picker></div><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-model=\"vm.widget.graph.fill\" aria-label=\"DASHBOARD.WIDGET.CHART_FILL_COLOR\" ng-change=\"vm.change();\"><span \ntranslate=\"DASHBOARD.WIDGET.CHART_FILL_COLOR\">Chart Fill Color</span></md-checkbox></md-input-container></div></div>\n<div class=\"form-title\" translate=\"DASHBOARD.GRAPH.METRICS\">Metrics</div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-change=\"vm.change();\" ng-model=\"vm.widget.graph.total\" aria-label=\"DASHBOARD.GRAPH.TOTAL_VALUE\"><span \ntranslate=\"DASHBOARD.GRAPH.TOTAL_VALUE\">Show Total Value</span></md-checkbox></md-input-container><md-input-container \nflex><md-checkbox ng-change=\"vm.change();\" ng-model=\"vm.widget.graph.average\" \naria-label=\"DASHBOARD.GRAPH.AVERAGE_VALUE\"><span translate=\"DASHBOARD.GRAPH.AVERAGE_VALUE\">Show Average Value</span>\n</md-checkbox></md-input-container><md-input-container flex><md-checkbox ng-change=\"vm.change();\" \nng-model=\"vm.widget.graph.min\" aria-label=\"DASHBOARD.GRAPH.MINIMUM_VALUE\"><span \ntranslate=\"DASHBOARD.GRAPH.MINIMUM_VALUE\">Show Minimum Value</span></md-checkbox></md-input-container>\n<md-input-container flex><md-checkbox ng-change=\"vm.change();\" ng-model=\"vm.widget.graph.max\" \naria-label=\"DASHBOARD.GRAPH.MAXIMUM_VALUE\"><span translate=\"DASHBOARD.GRAPH.MAXIMUM_VALUE\">Show Maximum Value</span>\n</md-checkbox></md-input-container></div></div></div></div><div ng-if=\"vm.widget.type==2\"><div class=\"form-content\">\n<div class=\"form-title\"><span translate=\"DASHBOARD.WIDGET.VALUE_TYPE\">Numeric Value Type</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<md-radio-group ng-model=\"vm.widget.graph.type\" ng-change=\"vm.change();\"><md-radio-button ng-value=\"\'lastValue\'\" \nclass=\"blue\"><span translate=\"DASHBOARD.WIDGET.LAST_VALUE\">Last Value</span></md-radio-button><md-radio-button \nng-value=\"\'aggregatedValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.AGGREGATED_VALUE\">Aggregated Value</span>\n</md-radio-button><md-radio-button ng-value=\"\'meanValue\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.AVERAGE_VALUE\">Average Value</span></md-radio-button><md-radio-button \nng-value=\"\'minValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.MINIMUM_VALUE\">Minimum Value</span>\n</md-radio-button><md-radio-button ng-value=\"\'maxValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.MAXIMUM_VALUE\">\nMaximum Value</span></md-radio-button></md-radio-group></md-input-container></div></div><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.PIE_OTHER_VALUE\">Other Value Type</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-model=\"vm.widget.graph.other\" aria-label=\"DASHBOARD.GRAPH.PIE_OTHER_DATA\" \nng-change=\"vm.changeWidgetPreview();vm.change();\"><span translate=\"DASHBOARD.WIDGET.PIE_OTHER_DATA\">Calculate Other \n</span></md-checkbox></md-input-container><md-input-container flex ng-if=\"vm.widget.graph.other\"><md-checkbox \nng-model=\"vm.widget.graph.otherValueType\" aria-label=\"DASHBOARD.GRAPH.PIE_OTHER_FROM_TREE\" \nng-change=\"vm.changeWidgetPreview();vm.putTreeMax();vm.change();\"><span \ntranslate=\"DASHBOARD.WIDGET.PIE_OTHER_FROM_TREE\">Calculate Other From Tree</span></md-checkbox></md-input-container>\n</div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"!vm.widget.graph.otherValueType && vm.widget.graph.other\"><div class=\"input-block\" flex><md-input-container \nflex><md-input-container flex><label><span translate=\"DASHBOARD.WIDGET.PIE_OTHER_VALUE\">Other Value</span></label>\n<input ng-model=\"vm.widget.graph.maximumValue\" type=\"number\" ng-required=\"true\" \nng-change=\"vm.changeWidgetPreview();vm.change();\"></md-input-container></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-show=\"vm.widget.graph.otherValueType && vm.widget.graph.other\"><div class=\"input-block\" flex><div class=\"tree\" \njs-tree=\"vm.treeConfig\" ng-model=\"vm.treeDataMax\" tree=\"vm.treeInstanceMax\" tree-events-obj=\"vm.treeEventsMax\"></div>\n</div></div></div></div><div ng-if=\"vm.widget.type==3\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.VALUE_TYPE\">Value Type</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-radio-group \nng-model=\"vm.widget.graph.type \" ng-change=\"vm.change();\"><md-radio-button ng-value=\"\'lastValue\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.LAST_VALUE\">Last Value</span></md-radio-button><md-radio-button \nng-value=\"\'aggregatedValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.AGGREGATED_VALUE\">Aggregated Value</span>\n</md-radio-button><md-radio-button ng-value=\"\'meanValue\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.AVERAGE_VALUE\">Average Value</span></md-radio-button><md-radio-button \nng-value=\"\'minValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.MINIMUM_VALUE\">Minimum Value</span>\n</md-radio-button><md-radio-button ng-value=\"\'maxValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.MAXIMUM_VALUE\">\nMaximum Value</span></md-radio-button></md-radio-group></md-input-container></div></div><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.GAUGE_TYPE\">Gauge Type</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-radio-group \nng-model=\"vm.widget.graph.style\" ng-change=\"vm.change();\"><md-radio-button value=\"full\" class=\"md-primary\"><span \ntranslate=\"DASHBOARD.WIDGET.GAUGE_FULL\">Full</span></md-radio-button><md-radio-button value=\"semi\"><span \ntranslate=\"DASHBOARD.WIDGET.GAUGE_SEMI\">Semi</span></md-radio-button><md-radio-button value=\"arch\"><span \ntranslate=\"DASHBOARD.WIDGET.GAUGE_ARCH\">Arch</span></md-radio-button></md-radio-group></md-input-container></div></div>\n<div class=\"form-title\"><span translate=\"DASHBOARD.WIDGET.GAUGE_CAP\">Cap</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-radio-group \nng-model=\"vm.widget.graph.cap\" ng-change=\"vm.change();\"><md-radio-button value=\"round\" class=\"md-primary\"><span \ntranslate=\"DASHBOARD.WIDGET.GAUGE_ROUND\">Round</span></md-radio-button><md-radio-button value=\"butt\"><span \ntranslate=\"DASHBOARD.WIDGET.GAUGE_BUTT\">Butt</span></md-radio-button></md-radio-group></md-input-container></div></div>\n<div class=\"form-title\"><span translate=\"DASHBOARD.WIDGET.APPEARANCE\">Appearance</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.GAUGE_THICK\">Thick</span></label><input ng-model=\"vm.widget.graph.thick\" type=\"number\" \nng-required=\"true\" ng-change=\"vm.change();\"></md-input-container></div><div class=\"input-block\" flex \nng-if=\"vm.widget.graph.graphType===\'gauge\'\"><label translate=\"DASHBOARD.WIDGET.GAUGE_INDICATOR_COLOR\">Indicator Color\n</label><color-picker ng-model=\"vm.widget.graph.foregroundColor\" options=\"vm.bgcolor\" event-api=\"vm.colorPickerApi\" \nng-change=\"vm.change();\"></color-picker></div><div class=\"input-block\" flex><label \ntranslate=\"DASHBOARD.WIDGET.GAUGE_COLOR\">Background Color</label><color-picker \nng-model=\"vm.widget.graph.backgroundColor\" options=\"vm.bgcolor\" event-api=\"vm.colorPickerApi\" ng-change=\"vm.change();\">\n</color-picker></div></div><div ng-if=\"vm.widget.graph.graphType===\'pue\'\"><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.GAUGE_SET_THRESHOLDS\">Set Thesholds</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-input-container flex><label><span\n translate=\"DASHBOARD.WIDGET.GAUGE_WARNING_THRESHOLD\">Warning Threshold</span></label><input \nng-model=\"vm.widget.graph.warning\" type=\"number\" ng-required=\"true\" ng-change=\"vm.change();\"></md-input-container>\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><md-input-container flex><label><span\n translate=\"DASHBOARD.WIDGET.GAUGE_ERROR_THRESHOLD\">Error Threshold</span></label><input \nng-model=\"vm.widget.graph.error\" type=\"number\" ng-required=\"true\" ng-change=\"vm.change();\"></md-input-container>\n</md-input-container></div></div></div><div class=\"form-title\"><span translate=\"DASHBOARD.WIDGET.GAUGE_COMPARE_TYPE\">\nCompare Value Type</span></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><md-checkbox ng-model=\"vm.widget.graph.maximumType\" \nng-change=\"vm.change();\" aria-label=\"DASHBOARD.GRAPH.GAUGE_MAX_FROM_TREE\" ng-change=\"vm.changeWidgetPreview();\"><span \ntranslate=\"DASHBOARD.WIDGET.GAUGE_MAX_FROM_TREE\">Calculate Max From Tree</span></md-checkbox></md-input-container>\n</div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"!vm.widget.graph.maximumType\">\n<div class=\"input-block\" flex><md-input-container flex><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.GAUGE_DEVIDE_VALUE\">Devide Value</span></label><input \nng-model=\"vm.widget.graph.maximumValue\" type=\"number\" ng-required=\"true\" ng-change=\"vm.change();\"></md-input-container>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-show=\"vm.widget.graph.maximumType\"><div class=\"input-block\" flex><div class=\"tree\" js-tree=\"vm.treeConfig\" \nng-model=\"vm.treeDataMax\" tree=\"vm.treeInstanceMax\" tree-events-obj=\"vm.treeEventsMax\"></div></div></div></div></div>\n<div ng-if=\"vm.widget.type==4\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.VALUE_TYPE\">Value Type</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-radio-group \nng-model=\"vm.widget.graph.type\" ng-change=\"vm.change();\"><md-radio-button ng-value=\"\'lastValue\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.LAST_VALUE\">Last Value</span></md-radio-button><md-radio-button \nng-value=\"\'aggregatedValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.AGGREGATED_VALUE\">Aggregated Value</span>\n</md-radio-button><md-radio-button ng-value=\"\'meanValue\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.AVERAGE_VALUE\">Average Value</span></md-radio-button><md-radio-button \nng-value=\"\'minValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.MINIMUM_VALUE\">Minimum Value</span>\n</md-radio-button><md-radio-button ng-value=\"\'maxValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.MAXIMUM_VALUE\">\nMaximum Value</span></md-radio-button></md-radio-group></md-input-container></div></div><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.APPEARANCE\">Appearance</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><label translate=\"DASHBOARD.WIDGET.CHART_COLOR\">\nBackground Color</label><color-picker ng-model=\"vm.widget.graph.backgroundColor\" options=\"vm.bgcolor\" \nevent-api=\"vm.colorPickerApi\" ng-change=\"vm.change();\"></color-picker></div><div class=\"input-block\" flex>\n<md-input-container flex><md-checkbox ng-model=\"vm.widget.graph.fill\" ng-change=\"vm.change();\" \naria-label=\"DASHBOARD.WIDGET.CHART_FILL_COLOR\"><span translate=\"DASHBOARD.WIDGET.CHART_FILL_COLOR\">Chart Fill Color\n</span></md-checkbox></md-input-container></div></div><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.PIE_OTHER_VALUE\">Other Value Type</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-model=\"vm.widget.graph.other\" aria-label=\"DASHBOARD.GRAPH.PIE_OTHER_DATA\" \nng-change=\"vm.changeWidgetPreview();vm.change();\"><span translate=\"DASHBOARD.WIDGET.PIE_OTHER_DATA\">Calculate Other \n</span></md-checkbox></md-input-container><md-input-container flex ng-if=\"vm.widget.graph.other\"><md-checkbox \nng-model=\"vm.widget.graph.otherValueType\" aria-label=\"DASHBOARD.GRAPH.PIE_OTHER_FROM_TREE\" \nng-change=\"vm.changeWidgetPreview();vm.putTreeMax();vm.change();\"><span \ntranslate=\"DASHBOARD.WIDGET.PIE_OTHER_FROM_TREE\">Calculate Other From Tree</span></md-checkbox></md-input-container>\n</div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"!vm.widget.graph.otherValueType && vm.widget.graph.other\"><div class=\"input-block\" flex><md-input-container \nflex><md-input-container flex><label><span translate=\"DASHBOARD.WIDGET.PIE_OTHER_VALUE\">Other Value</span></label>\n<input ng-model=\"vm.widget.graph.maximumValue\" type=\"number\" ng-required=\"true\" \nng-change=\"vm.changeWidgetPreview();vm.change();\"></md-input-container></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-show=\"vm.widget.graph.otherValueType && vm.widget.graph.other\"><div class=\"input-block\" flex><div class=\"tree\" \njs-tree=\"vm.treeConfig\" ng-model=\"vm.treeDataMax\" tree=\"vm.treeInstanceMax\" tree-events-obj=\"vm.treeEventsMax\"></div>\n</div></div></div></div><div ng-if=\"vm.widget.type==6\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.VALUE_TYPE\">Value Type</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-radio-group \nng-model=\"vm.widget.graph.value\" ng-change=\"vm.change();\"><md-radio-button ng-value=\"\'occupancy\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.OCCUPANCY\">Occupancy</span></md-radio-button><md-radio-button ng-value=\"\'entriesExits\'\" \nclass=\"blue\"><span translate=\"DASHBOARD.WIDGET.ENTRIES_EXITS\">Entries Exits</span></md-radio-button></md-radio-group>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"vm.widget.graph.value===\'entriesExits\'\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.ENTRIES_EXITS_VALUE\">Entries Exits Value</span></label><md-select \nng-model=\"vm.widget.graph.values\" ng-required=\"true\" multiple=\"\" ng-change=\"vm.change();\"><md-option value=\"entries\">\n<span translate=\"DASHBOARD.WIDGET.ENTRIES\">Entries</span></md-option><md-option value=\"exits\"><span \ntranslate=\"DASHBOARD.WIDGET.EXITS\">Exits</span></md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"DASHBOARD.WIDGET.SELECT_SPACES\">Select Spaces</span></label><md-select \nng-model=\"vm.widget.graph.spaces\" ng-required=\"true\" multiple=\"\" ng-change=\"vm.change();\"><md-option \nng-repeat=\"space in vm.spaces\" value=\"{{space.value}}\"><span>{{space.name}}</span></md-option></md-select>\n</md-input-container></div></div></div><div class=\"form-content\"><div class=\"form-title\" \ntranslate=\"DASHBOARD.GRAPH.VISUALIZATION\">Visualization</div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-change=\"vm.change();\" ng-model=\"vm.widget.graph.aggregated\" aria-label=\"DASHBOARD.GRAPH.MEASUREMENTS_STACKED\"><span \ntranslate=\"DASHBOARD.GRAPH.MEASUREMENTS_STACKED\">Show Measurements Stacked</span></md-checkbox></md-input-container>\n</div><div class=\"input-block\" flex ng-if=\"vm.widget.graph.graphType!=\'bar\'\"><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.POINT_STYLE\">Select Point Style</span></label><md-select ng-model=\"vm.widget.graph.point\" \nng-required=\"true\" ng-change=\"vm.change();\"><md-option value=\"circle\"><span translate=\"DASHBOARD.WIDGET.CIRCLE\">Circle\n</span></md-option><md-option value=\"triangle\"><span translate=\"DASHBOARD.WIDGET.TRIANGLE\">Triangle</span></md-option>\n<md-option value=\"rect\"><span translate=\"DASHBOARD.WIDGET.RECTANGLE\">Rectangle</span></md-option><md-option \nvalue=\"rectRounded\"><span translate=\"DASHBOARD.WIDGET.ROUNDED_RECTANGLE\">Rounded Rectangle</span></md-option><md-option\n value=\"rectRot\"><span translate=\"DASHBOARD.WIDGET.ROTATED_RECTANGLE\">Rotated Rectangle</span></md-option><md-option \nvalue=\"cross\"><span translate=\"DASHBOARD.WIDGET.CROSS\">Cross</span></md-option><md-option value=\"crossRot\"><span \ntranslate=\"DASHBOARD.WIDGET.ROTATED_CROSS\">Rotated Cross</span></md-option><md-option value=\"star\"><span \ntranslate=\"DASHBOARD.WIDGET.STAR\">Star</span></md-option><md-option value=\"line\"><span \ntranslate=\"DASHBOARD.WIDGET.LINE\">Line</span></md-option><md-option value=\"dash\"><span \ntranslate=\"DASHBOARD.WIDGET.DASH\">Dash</span></md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex ng-if=\"vm.widget.graph.graphType!=\'bar\'\"><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.POINT_SIZE\">Select Point Size</span></label><input ng-model=\"vm.widget.graph.pointSize\" \ntype=\"number\" ng-required=\"true\" ng-change=\"vm.change();\"></md-input-container></div></div><div class=\"form-title\">\n<span translate=\"DASHBOARD.WIDGET.APPEARANCE\">Appearance</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-model=\"vm.widget.graph.widgetHasFontColor\" ng-change=\"vm.change();\" aria-label=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\">\n<span translate=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\">Custom font color</span></md-checkbox></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.widget.graph.widgetHasFontColor\">\n<div class=\"input-block\" flex><label translate=\"DASHBOARD.WIDGET.FONT_COLOR\">Widget Font Color</label><color-picker \nng-model=\"vm.widget.graph.fontColor\" ng-change=\"vm.change();\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\">\n</color-picker></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" \nflex ng-if=\"vm.widget.graph.aggregated\"><label translate=\"DASHBOARD.WIDGET.CHART_COLOR\">Chart Color</label>\n<color-picker ng-model=\"vm.widget.graph.backgroundColor\" options=\"vm.bgcolor\" event-api=\"vm.colorPickerApi\" \nng-change=\"vm.change();\"></color-picker></div><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-model=\"vm.widget.graph.fill\" ng-change=\"vm.change();\" aria-label=\"DASHBOARD.WIDGET.CHART_FILL_COLOR\"><span \ntranslate=\"DASHBOARD.WIDGET.CHART_FILL_COLOR\">Chart Fill Color</span></md-checkbox></md-input-container></div></div>\n<div class=\"form-title\" translate=\"DASHBOARD.GRAPH.METRICS\">Metrics</div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-change=\"vm.change();\" ng-model=\"vm.widget.graph.total\" aria-label=\"DASHBOARD.GRAPH.TOTAL_VALUE\"><span \ntranslate=\"DASHBOARD.GRAPH.TOTAL_VALUE\">Show Total Value</span></md-checkbox></md-input-container><md-input-container \nflex><md-checkbox ng-change=\"vm.change();\" ng-model=\"vm.widget.graph.average\" \naria-label=\"DASHBOARD.GRAPH.AVERAGE_VALUE\"><span translate=\"DASHBOARD.GRAPH.AVERAGE_VALUE\">Show Average Value</span>\n</md-checkbox></md-input-container><md-input-container flex><md-checkbox ng-change=\"vm.change();\" \nng-model=\"vm.widget.graph.min\" aria-label=\"DASHBOARD.GRAPH.MINIMUM_VALUE\"><span \ntranslate=\"DASHBOARD.GRAPH.MINIMUM_VALUE\">Show Minimum Value</span></md-checkbox></md-input-container>\n<md-input-container flex><md-checkbox ng-change=\"vm.change();\" ng-model=\"vm.widget.graph.max\" \naria-label=\"DASHBOARD.GRAPH.MAXIMUM_VALUE\"><span translate=\"DASHBOARD.GRAPH.MAXIMUM_VALUE\">Show Maximum Value</span>\n</md-checkbox></md-input-container></div></div></div></div><div ng-if=\"vm.widget.type==7\"><div class=\"form-content\">\n<div class=\"form-title\"><span translate=\"DASHBOARD.WIDGET.VALUE_TYPE\">Value Type</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-radio-group \nng-model=\"vm.widget.graph.value\" ng-change=\"vm.change();\"><md-radio-button ng-value=\"\'occupancy\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.OCCUPANCY\">Occupancy</span></md-radio-button><md-radio-button ng-value=\"\'entriesExits\'\" \nclass=\"blue\"><span translate=\"DASHBOARD.WIDGET.ENTRIES_EXITS\">Entries Exits</span></md-radio-button></md-radio-group>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"vm.widget.graph.value===\'entriesExits\'\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.ENTRIES_EXITS_VALUE\">Entries Exits Value</span></label><md-select \nng-model=\"vm.widget.graph.values\" ng-required=\"true\" multiple=\"\" ng-change=\"vm.change();\"><md-option value=\"entries\">\n<span translate=\"DASHBOARD.WIDGET.ENTRIES\">Entries</span></md-option><md-option value=\"exits\"><span \ntranslate=\"DASHBOARD.WIDGET.EXITS\">Exits</span></md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"DASHBOARD.WIDGET.SELECT_SPACES\">Select Spaces</span></label><md-select \nng-model=\"vm.widget.graph.spaces\" ng-required=\"true\" multiple=\"\" ng-change=\"vm.change();\"><md-option \nng-repeat=\"space in vm.spaces\" value=\"{{space.value}}\"><span>{{space.name}}</span></md-option></md-select>\n</md-input-container></div></div></div><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.APPEARANCE\">Appearance</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-model=\"vm.widget.graph.widgetHasFontColor\" ng-change=\"vm.change();\" aria-label=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\">\n<span translate=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\">Custom font color</span></md-checkbox></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.widget.graph.widgetHasFontColor\">\n<div class=\"input-block\" flex><label translate=\"DASHBOARD.WIDGET.FONT_COLOR\">Widget Font Color</label><color-picker \nng-model=\"vm.widget.graph.fontColor\" ng-change=\"vm.change();\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\">\n</color-picker></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" \nflex><md-input-container flex><md-checkbox ng-model=\"vm.widget.graph.fill\" ng-change=\"vm.change();\" \naria-label=\"DASHBOARD.WIDGET.CHART_FILL_COLOR\"><span translate=\"DASHBOARD.WIDGET.CHART_FILL_COLOR\">Chart Fill Color\n</span></md-checkbox></md-input-container></div></div></div></div><div ng-if=\"vm.widget.type==8 || vm.widget.type==9\">\n<div class=\"form-content\"><div class=\"form-title\"><span translate=\"DASHBOARD.WIDGET.VALUE_TYPE\">Value Type</span></div>\n<div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container \nflex><label><span translate=\"DASHBOARD.WIDGET.SELECT_SPACES\">Select Spaces</span></label><md-select \nng-model=\"vm.widget.graph.spaces\" ng-required=\"true\" multiple=\"\" ng-change=\"vm.change();\"><md-option \nng-repeat=\"space in vm.spaces\" value=\"{{space.value}}\"><span>{{space.name}}</span></md-option></md-select>\n</md-input-container></div></div></div></div><div ng-if=\"vm.widget.type==10\"><div class=\"form-content\"><div \nclass=\"form-title\"><span translate=\"DASHBOARD.WIDGET.VALUE_TYPE\">Value Type</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-radio-group \nng-model=\"vm.widget.graph.value\" ng-change=\"vm.change();\"><md-radio-button ng-value=\"\'occupancy\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.OCCUPANCY\">Occupancy</span></md-radio-button><md-radio-button ng-value=\"\'entriesExits\'\" \nclass=\"blue\"><span translate=\"DASHBOARD.WIDGET.ENTRIES_EXITS\">Entries Exits</span></md-radio-button></md-radio-group>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"vm.widget.graph.value===\'entriesExits\'\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.ENTRIES_EXITS_VALUE\">Entries Exits Value</span></label><md-select \nng-model=\"vm.widget.graph.values\" ng-required=\"true\" multiple=\"\" ng-change=\"vm.change();\"><md-option value=\"entries\">\n<span translate=\"DASHBOARD.WIDGET.ENTRIES\">Entries</span></md-option><md-option value=\"exits\"><span \ntranslate=\"DASHBOARD.WIDGET.EXITS\">Exits</span></md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"DASHBOARD.WIDGET.SELECT_SPACES\">Select Spaces</span></label><md-select \nng-model=\"vm.widget.graph.spaces\" ng-required=\"true\" multiple=\"\" ng-change=\"vm.change();\"><md-option \nng-repeat=\"space in vm.spaces\" value=\"{{space.value}}\"><span>{{space.name}}</span></md-option></md-select>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"DASHBOARD.WIDGET.SELECT_LOW_PEAK\">\nSelect Peak/Low Demand Hour</span></label><md-select ng-model=\"vm.widget.graph.hours\" ng-required=\"true\" multiple=\"\" \nng-change=\"vm.change();\"><md-option value=\"peak\"><span translate=\"DASHBOARD.WIDGET.PEAK_HOUR\">Peak Hour</span>\n</md-option><md-option value=\"low\"><span translate=\"DASHBOARD.WIDGET.LOW_DEMAND_HOUR\">Low Demand Hour</span>\n</md-option></md-select></md-input-container></div></div></div></div><div ng-if=\"vm.widget.type==13\"><div \nclass=\"form-content\"><div class=\"form-title\"><span translate=\"DASHBOARD.WIDGET.APPEARANCE\">Appearance</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<md-checkbox ng-model=\"vm.widget.graph.widgetHasFontColor\" ng-change=\"vm.change();\" \naria-label=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\"><span translate=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\">Custom font color\n</span></md-checkbox></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\" ng-if=\"vm.widget.graph.widgetHasFontColor\"><div class=\"input-block\" flex><label \ntranslate=\"DASHBOARD.WIDGET.FONT_COLOR\">Widget Font Color</label><color-picker ng-model=\"vm.widget.graph.fontColor\" \nng-change=\"vm.change();\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\"></color-picker></div></div></div></div>\n<div ng-if=\"vm.widget.type==16 || vm.widget.type==20\"><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.APPEARANCE\">Appearance</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><label translate=\"DASHBOARD.WIDGET.ORIENTATION\">\nWidget Orientation</label><md-input-container flex><md-radio-group ng-model=\"vm.widget.graph.orientation\" \nng-change=\"vm.change();\"><md-radio-button ng-value=\"\'vertical\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.VERTICAL\">Vertical</span></md-radio-button><md-radio-button ng-value=\"\'horizontal\'\" \nclass=\"blue\"><span translate=\"DASHBOARD.WIDGET.HORIZONTAL\">Horizontal</span></md-radio-button></md-radio-group>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><md-checkbox ng-model=\"vm.widget.graph.widgetHasFontColor\" \nng-change=\"vm.change();\" aria-label=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\"><span \ntranslate=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\">Custom font color</span></md-checkbox></md-input-container></div></div>\n<div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.widget.graph.widgetHasFontColor\"><div \nclass=\"input-block\" flex><label translate=\"DASHBOARD.WIDGET.FONT_COLOR\">Widget Font Color</label><color-picker \nng-model=\"vm.widget.graph.fontColor\" ng-change=\"vm.change();\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\">\n</color-picker></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" \nflex><md-input-container flex><md-checkbox ng-model=\"vm.widget.graph.widgetHasColor\" ng-change=\"vm.change();\" \naria-label=\"DASHBOARD.WIDGET.CUSTOM_BACKGROUND_COLOR\"><span translate=\"DASHBOARD.WIDGET.CUSTOM_BACKGROUND_COLOR\">\nCustom background color</span></md-checkbox></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\" ng-if=\"vm.widget.graph.widgetHasColor\"><div class=\"input-block\" flex><label \ntranslate=\"DASHBOARD.WIDGET.BACKGROUND_COLOR\">Widget Backgound Color</label><color-picker \nng-model=\"vm.widget.graph.widgetColor\" ng-change=\"vm.change();\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\">\n</color-picker></div></div></div></div><div ng-if=\"vm.widget.type==18\"><div class=\"form-content\"><div \nclass=\"form-title\"><span translate=\"DASHBOARD.WIDGET.VALUE_TYPE\">Value Type</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-radio-group \nng-model=\"vm.widget.graph.type\" ng-change=\"vm.change();\"><md-radio-button ng-value=\"\'rawData\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.RAW_DATA\">Raw Data</span></md-radio-button><md-radio-button ng-value=\"\'aggregatedValue\'\" \nclass=\"blue\"><span translate=\"DASHBOARD.WIDGET.AGGREGATED_VALUE\">Aggregated Value</span></md-radio-button>\n<md-radio-button ng-value=\"\'meanValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.AVERAGE_VALUE\">Average Value\n</span></md-radio-button><md-radio-button ng-value=\"\'minValue\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.MINIMUM_VALUE\">Minimum Value</span></md-radio-button><md-radio-button \nng-value=\"\'maxValue\'\" class=\"blue\"><span translate=\"DASHBOARD.WIDGET.MAXIMUM_VALUE\">Maximum Value</span>\n</md-radio-button></md-radio-group></md-input-container></div></div></div><div class=\"form-content\"><div \nclass=\"form-title\" translate=\"DASHBOARD.GRAPH.VISUALIZATION\">Visualization</div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-model=\"vm.widget.graph.aggregated\" ng-change=\"vm.change();\" aria-label=\"DASHBOARD.GRAPH.MEASUREMENTS_STACKED\"><span \ntranslate=\"DASHBOARD.GRAPH.MEASUREMENTS_STACKED\">Show Measurements Stacked</span></md-checkbox></md-input-container>\n</div></div><div class=\"form-title\"><span translate=\"DASHBOARD.WIDGET.APPEARANCE\">Appearance</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<md-checkbox ng-model=\"vm.widget.graph.widgetHasFontColor\" ng-change=\"vm.change();\" \naria-label=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\"><span translate=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\">Custom font color\n</span></md-checkbox></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\" ng-if=\"vm.widget.graph.widgetHasFontColor\"><div class=\"input-block\" flex><label \ntranslate=\"DASHBOARD.WIDGET.FONT_COLOR\">Widget Font Color</label><color-picker ng-model=\"vm.widget.graph.fontColor\" \nng-change=\"vm.change();\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\"></color-picker></div></div><div \nclass=\"form-title\" translate=\"DASHBOARD.GRAPH.METRICS\">Metrics</div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-checkbox \nng-change=\"vm.change();\" ng-model=\"vm.widget.graph.total\" aria-label=\"DASHBOARD.GRAPH.TOTAL_VALUE\"><span \ntranslate=\"DASHBOARD.GRAPH.TOTAL_VALUE\">Show Total Value</span></md-checkbox></md-input-container><md-input-container \nflex><md-checkbox ng-change=\"vm.change();\" ng-model=\"vm.widget.graph.average\" \naria-label=\"DASHBOARD.GRAPH.AVERAGE_VALUE\"><span translate=\"DASHBOARD.GRAPH.AVERAGE_VALUE\">Show Average Value</span>\n</md-checkbox></md-input-container><md-input-container flex><md-checkbox ng-change=\"vm.change();\" \nng-model=\"vm.widget.graph.min\" aria-label=\"DASHBOARD.GRAPH.MINIMUM_VALUE\"><span \ntranslate=\"DASHBOARD.GRAPH.MINIMUM_VALUE\">Show Minimum Value</span></md-checkbox></md-input-container>\n<md-input-container flex><md-checkbox ng-change=\"vm.change();\" ng-model=\"vm.widget.graph.max\" \naria-label=\"DASHBOARD.GRAPH.MAXIMUM_VALUE\"><span translate=\"DASHBOARD.GRAPH.MAXIMUM_VALUE\">Show Maximum Value</span>\n</md-checkbox></md-input-container></div></div></div></div><div ng-if=\"vm.widget.type==22\"><div class=\"form-content\">\n<div class=\"form-title\"><span translate=\"DASHBOARD.WIDGET.VALUE_TYPE\">Value Type</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-radio-group \nng-model=\"vm.widget.graph.value\" ng-change=\"vm.change();\"><md-radio-button ng-value=\"\'occupancy\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.OCCUPANCY\">Occupancy</span></md-radio-button><md-radio-button ng-value=\"\'entriesExits\'\" \nclass=\"blue\"><span translate=\"DASHBOARD.WIDGET.ENTRIES_EXITS\">Entries Exits</span></md-radio-button></md-radio-group>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"vm.widget.graph.value===\'entriesExits\'\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.ENTRIES_EXITS_VALUE\">Entries Exits Value</span></label><md-select \nng-model=\"vm.widget.graph.values\" ng-required=\"true\" multiple=\"\" ng-change=\"vm.change();\"><md-option value=\"entries\">\n<span translate=\"DASHBOARD.WIDGET.ENTRIES\">Entries</span></md-option><md-option value=\"exits\"><span \ntranslate=\"DASHBOARD.WIDGET.EXITS\">Exits</span></md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"DASHBOARD.WIDGET.SELECT_REVERSED_COUNTERS\">Select Reversed Counters</span></label><md-select \nng-model=\"vm.widget.graph.reversed\" ng-required=\"true\" multiple=\"\" ng-change=\"vm.change();\"><md-option \nng-repeat=\"clients in vm.widget.clients\" value=\"{{clients.device.token}}\"><span>{{clients.device.name}}</span>\n</md-option></md-select></md-input-container></div></div></div><div class=\"form-content\"><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.APPEARANCE\">Appearance</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><label translate=\"DASHBOARD.WIDGET.ORIENTATION\">\nWidget Orientation</label><md-input-container flex><md-radio-group ng-model=\"vm.widget.graph.orientation\" \nng-change=\"vm.change();\"><md-radio-button ng-value=\"\'vertical\'\" class=\"blue\"><span \ntranslate=\"DASHBOARD.WIDGET.VERTICAL\">Vertical</span></md-radio-button><md-radio-button ng-value=\"\'horizontal\'\" \nclass=\"blue\"><span translate=\"DASHBOARD.WIDGET.HORIZONTAL\">Horizontal</span></md-radio-button></md-radio-group>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><md-checkbox ng-model=\"vm.widget.graph.widgetHasFontColor\" \nng-change=\"vm.change();\" aria-label=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\"><span \ntranslate=\"DASHBOARD.WIDGET.CUSTOM_FONT_COLOR\">Custom font color</span></md-checkbox></md-input-container></div></div>\n<div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.widget.graph.widgetHasFontColor\"><div \nclass=\"input-block\" flex><label translate=\"DASHBOARD.WIDGET.FONT_COLOR\">Widget Font Color</label><color-picker \nng-model=\"vm.widget.graph.fontColor\" ng-change=\"vm.change();\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\">\n</color-picker></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" \nflex><md-input-container flex><md-checkbox ng-model=\"vm.widget.graph.widgetHasColor\" ng-change=\"vm.change();\" \naria-label=\"DASHBOARD.WIDGET.CUSTOM_BACKGROUND_COLOR\"><span translate=\"DASHBOARD.WIDGET.CUSTOM_BACKGROUND_COLOR\">\nCustom background color</span></md-checkbox></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\" ng-if=\"vm.widget.graph.widgetHasColor\"><div class=\"input-block\" flex><label \ntranslate=\"DASHBOARD.WIDGET.BACKGROUND_COLOR\">Widget Backgound Color</label><color-picker \nng-model=\"vm.widget.graph.widgetColor\" ng-change=\"vm.change();\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\">\n</color-picker></div></div></div></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.showPeriod && vm.widget.graph.type!==\'lastValue\'\"><md-tab-label><span translate=\"DASHBOARD.WIDGET.PERIOD\">\nPreiod</span></md-tab-label><md-tab-body><div class=\"form-content\" ng-if=\"vm.showPeriodRange\"><div class=\"form-title\">\n<span translate=\"DASHBOARD.WIDGET.DATE_RANGE\">Select Date Range</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.DATE_RANGE\">Select Date Range</span></label><md-select ng-model=\"vm.widget.dates[0].date\" \nng-required=\"true\" ng-change=\"vm.change();\"><md-option value=\"custom\"><span translate=\"DATERANGE.CUSTOM_RANGE\">\nCustom Range</span></md-option><md-option value=\"thisYear\"><span translate=\"DATERANGE.THIS_YEAR\">This Year</span>\n</md-option><md-option value=\"last3Months\"><span translate=\"DATERANGE.LAST_3_MONTS\">Last 3 Months</span></md-option>\n<md-option value=\"lastMonth\"><span translate=\"DATERANGE.LAST_MONTH\">Last Month</span></md-option><md-option \nvalue=\"thisMonth\"><span translate=\"DATERANGE.THIS_MONTH\">This Month</span></md-option><md-option value=\"last30Days\">\n<span translate=\"DATERANGE.LAST_30_DAYS\">Last 30 Days</span></md-option><md-option value=\"lastWeek\"><span \ntranslate=\"DATERANGE.LAST_WEEK\">Last Week</span></md-option><md-option value=\"thisWeek\"><span \ntranslate=\"DATERANGE.THIS_WEEK\">This Week</span></md-option><md-option value=\"last7Days\"><span \ntranslate=\"DATERANGE.LAST_7_DAYS\">Last 7 Days</span></md-option><md-option value=\"yesterday\"><span \ntranslate=\"DATERANGE.YESTERDAY\">Yesterday</span></md-option><md-option value=\"today\"><span translate=\"DATERANGE.TODAY\">\nToday</span></md-option></md-select></md-input-container></div></div></div><div class=\"form-content\" \nng-if=\"vm.showPeriodResolution && vm.widget.graph.type!==\'rawData\'\"><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.DATE_RESOLUTION\">Select Resolution</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.DATE_RESOLUTION_TYPE\">Select Resolution Type</span></label><md-select \nng-model=\"vm.widget.time.resolutionType\" ng-required=\"true\" ng-change=\"vm.change();\"><md-option value=\"m\"><span \ntranslate=\"DASHBOARD.WIDGET.MINUTES\">Minutes</span></md-option><md-option value=\"h\"><span \ntranslate=\"DASHBOARD.WIDGET.HOURS\">Hours</span></md-option><md-option value=\"d\"><span \ntranslate=\"DASHBOARD.WIDGET.DAYS\">Days</span></md-option><md-option value=\"M\"><span \ntranslate=\"DASHBOARD.WIDGET.MONTHS\">Months</span></md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"DASHBOARD.WIDGET.RESOLUTION_VALUE\">Select Resolution Value</span></label><input type=\"number\" \nng-model=\"vm.widget.time.resolutionValue\" ng-required=\"true\" min=\"1\" ng-change=\"vm.change();\"></md-input-container>\n</div></div></div><div class=\"form-content\" ng-if=\"vm.showPeriodTime\"><div class=\"form-title\"><span \ntranslate=\"DASHBOARD.WIDGET.TIME_RANGE\">Select Custom Time</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><md-radio-group \nng-model=\"vm.widget.time.type\" layout=\"row\" ng-change=\"vm.change();\"><md-radio-button ng-value=\"\'null\'\" class=\"blue\">\n<span translate=\"DASHBOARD.WIDGET.NONE\">None</span></md-radio-button><md-radio-button ng-value=\"\'time\'\" class=\"blue\">\n<span translate=\"DASHBOARD.WIDGET.TIME\">Time</span></md-radio-button><md-radio-button ng-value=\"\'minutes\'\" \nclass=\"blue\"><span translate=\"DASHBOARD.WIDGET.MINUTES\">Minutes</span></md-radio-button></md-radio-group>\n</md-input-container></div></div></div><div class=\"form-content\" ng-if=\"vm.widget.time.type===\'minutes\'\"><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex>\n<label><span translate=\"DASHBOARD.WIDGET.LAST_MINUTES\">Select Last Minutes</span></label><input type=\"number\" \nng-model=\"vm.widget.time.minutes\" ng-required=\"true\" min=\"1\" ng-change=\"vm.change();\"></md-input-container></div></div>\n</div><div class=\"form-content\" ng-if=\"vm.widget.time.type===\'time\'\"><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.START_HOUR\">Start Hour</span></label><input type=\"time\" ng-model=\"vm.widget.time.start\" \nng-required=\"true\" ng-change=\"vm.change();\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.END_HOUR\">End Hour</span></label><input type=\"time\" ng-model=\"vm.widget.time.end\" \nng-required=\"true\" ng-change=\"vm.change();\"></md-input-container></div></div></div></md-tab-body></md-tab></md-tabs>\n</div></div></md-dialog-content><md-dialog-actions class=\"md-primary-bg md-hue-2\" layout=\"row\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-click=\"vm.saveWidget()\" \nclass=\"save-button mt-10 md-raised md-primary md-button md-ink-ripple\" aria-label=\"SAVE\" translate=\"DASHBOARD.SAVE\" \ntranslate-attr-aria-label=\"DASHBOARD.SAVE\">SAVE</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/landing/dialogs/ContactUs/contact_us.html","<md-dialog class=\"contact-us-dialog\" aria-label=\"Contact Us\"><md-toolbar md-colors=\"{background: \'grey-A100\'}\"><div \nclass=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start center\"><span class=\"title\" style=\"color: #971881\" \ntranslate=\"LANDING.CONTACT\"><strong>Contact Us</strong></span> <span class=\"stitle\" style=\"color: #6b6b6b\" \ntranslate=\"LANDING.FORMS.CONTACT_STITLE\">Find out more about Smarteverything!</span></div></md-toolbar>\n<md-dialog-content layout-padding><div><form id=\"request_form\" name=\"RequestForm\"><div layout=\"column\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block-left\" flex-gt-sm><label><span translate=\"LANDING.FORMS.NAME\">\nFirst Name</span></label><input ng-required=\"true\" name=\"first_name\" ng-model=\"vm.request.first_name\"><div \nng-messages=\"RequestForm.first_name.$error\"><div ng-message=\"required\"><span translate=\"LANDING.FORMS.REQUIRED\">\nThis is required.</span></div></div></md-input-container><md-input-container class=\"md-block-right\" flex-gt-sm><label>\n<span translate=\"LANDING.FORMS.SURNAME\">Last Name</span></label><input ng-required=\"true\" name=\"last_name\" \nng-model=\"vm.request.last_name\"><div ng-messages=\"RequestForm.last_name.$error\"><div ng-message=\"required\"><span \ntranslate=\"LANDING.FORMS.REQUIRED\">This is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block-left\" flex-gt-sm><label>Email</label><input ng-required=\"true\" \nname=\"email\" ng-model=\"vm.request.email\"><div ng-messages=\"RequestForm.email.$error\"><div ng-message=\"required\"><span \ntranslate=\"LANDING.FORMS.REQUIRED\">This is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block-right\" flex-gt-sm><label><span translate=\"LANDING.FORMS.SUBJECT\">Subject</span></label><input \nng-required=\"true\" name=\"subject\" ng-model=\"vm.request.subject\"><div ng-messages=\"RequestForm.subject.$error\"><div \nng-message=\"required\"><span translate=\"LANDING.FORMS.REQUIRED\">This is required.</span></div></div>\n</md-input-container></div><div layout-gt-sm=\"column\"><md-input-container class=\"md-block-left\" flex-gt-sm><label><span\n translate=\"LANDING.FORMS.MESSAGE\">Message</span></label><textarea ng-model=\"vm.request.message\" md-maxlength=\"500\" \nrows=\"5\" md-select-on-focus></textarea></md-input-container></div><div layout-gt-sm=\"column\"><div \nstyle=\"margin: 0 0 32px\"><no-captcha g-recaptcha-response=\"vm.request.gRecaptchaResponse\" \ncontrol=\"vm.noCaptchaControl\" expired-callback=\"vm.expiredCallback\"></no-captcha></div></div></div><div \nlayout-gt-sm=\"row\" layout-align=\"end\"><div layout=\"column\" flex=\"30\" hide-gt-sm></div><div layout=\"column\" flex=\"15\">\n<md-button class=\"reqsub mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.SubmitDialog()\" \naria-label=\"Submit\" translate translate-attr-aria-label=\"LANDING.FORMS.SUBMIT\"><span translate=\"LANDING.FORMS.SUBMIT\">\nSubmit</span></md-button></div><div layout=\"column\" flex=\"15\"><md-button \nclass=\"reqcancel mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel\n</span></md-button></div></div></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/landing/dialogs/RequestDemo/request_demo.html","<md-dialog class=\"request-demo-dialog\" aria-label=\"Request Demo\"><md-toolbar md-colors=\"{background: \'grey-A100\'}\"><div\n class=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start center\"><strong><span class=\"title\" \nstyle=\"color: #971881\" translate=\"LANDING.REQ_DEMO\">Request Demo</span></strong> <span class=\"stitle\" \nstyle=\"color: #6b6b6b\" translate=\"LANDING.FORMS.REQ_STITLE\">Find out smarteverything IoT Vertical Solutions!</span>\n</div></md-toolbar><md-dialog-content layout-padding><div><form id=\"request_form\" name=\"RequestForm\"><div \nlayout=\"column\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block-left\" flex-gt-sm><label><span \ntranslate=\"LANDING.FORMS.NAME\">First Name</span></label><input ng-required=\"true\" name=\"first_name\" \nng-model=\"vm.request.first_name\"><div ng-messages=\"RequestForm.first_name.$error\"><div ng-message=\"required\"><span \ntranslate=\"LANDING.FORMS.REQUIRED\">This is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block-right\" flex-gt-sm><label><span translate=\"LANDING.FORMS.SURNAME\">Last Name</span></label><input \nng-required=\"true\" name=\"last_name\" ng-model=\"vm.request.last_name\"><div ng-messages=\"RequestForm.last_name.$error\">\n<div ng-message=\"required\"><span translate=\"LANDING.FORMS.REQUIRED\">This is required.</span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block-left\" flex-gt-sm><label><span \ntranslate=\"LANDING.FORMS.COMPANY\">Company</span></label><input ng-required=\"true\" name=\"company\" \nng-model=\"vm.request.company\"><div ng-messages=\"RequestForm.company.$error\"><div ng-message=\"required\"><span \ntranslate=\"LANDING.FORMS.REQUIRED\">This is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block-right\" flex-gt-sm><label><span translate=\"LANDING.FORMS.PHONE\">Phone Number</span></label><input \nng-required=\"true\" name=\"phone_number\" ng-model=\"vm.request.phone_number\"><div \nng-messages=\"RequestForm.phone_number.$error\"><div ng-message=\"required\"><span translate=\"LANDING.FORMS.REQUIRED\">\nThis is required.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block-left\" flex-gt-sm><label>Email</label><input ng-required=\"true\" name=\"email\" \nng-model=\"vm.request.email\"><div ng-messages=\"RequestForm.email.$error\"><div ng-message=\"required\"><span \ntranslate=\"LANDING.FORMS.REQUIRED\">This is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block-right\" flex-gt-sm><label><span translate=\"LANDING.FORMS.SUBJECT\">Subject</span></label><input \nng-required=\"true\" name=\"subject\" ng-model=\"vm.request.subject\"><div ng-messages=\"RequestForm.subject.$error\"><div \nng-message=\"required\"><span translate=\"LANDING.FORMS.REQUIRED\">This is required.</span></div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block-left\" flex-gt-sm><label><span \ntranslate=\"LANDING.FORMS.MESSAGE\">Message</span></label><textarea ng-model=\"vm.request.message\" md-maxlength=\"300\" \nrows=\"5\" md-select-on-focus></textarea></md-input-container><md-input-container class=\"md-block-right\" flex-gt-sm>\n<label><span translate=\"LANDING.FORMS.IOT_SELECT\">Which IoT solution do you want to try?</span></label><md-select \nng-required=\"true\" ng-model=\"vm.request.solution\"><md-option ng-value=\"solution\" ng-repeat=\"solution in vm.solutions\">\n{{solution}}</md-option></md-select><div style=\"margin: 32px 0\"><no-captcha \ng-recaptcha-response=\"vm.request.gRecaptchaResponse\" control=\"vm.noCaptchaControl\" \nexpired-callback=\"vm.expiredCallback\"></no-captcha></div></md-input-container></div></div><div layout-gt-sm=\"row\" \nlayout-align=\"end\"><div layout=\"column\" flex=\"30\" hide-gt-sm></div><div layout=\"column\" flex=\"15\"><md-button \nclass=\"reqsub mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.SubmitDialog()\" aria-label=\"Submit\" \ntranslate translate-attr-aria-label=\"LANDING.FORMS.SUBMIT\"><span translate=\"LANDING.FORMS.SUBMIT\">Submit</span>\n</md-button></div><div layout=\"column\" flex=\"15\"><md-button \nclass=\"reqcancel mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" \ntranslate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CANCEL\"><span translate=\"ADMINISTRATION.FORMS.CANCEL\">Cancel\n</span></md-button></div></div></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/home/dialogs/location-edit/location-edit-dialog.html","<md-dialog class=\"location-edit-dialog\"><form name=\"locationEditForm\" class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Edit Site</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-tabs md-dynamic-height><md-tab label=\"General Information\"><md-input-container class=\"md-block\"><label>\nOwner</label><input type=\"text\" name=\"owner\" ng-model=\"vm.location.owner\" required><div \nng-messages=\"locationEditForm.owner.$error\" ng-show=\"locationEditForm.owner.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Owner is required</span></div></div></md-input-container><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"40\"><label>Address</label><input type=\"text\" name=\"address\" \nng-model=\"vm.location.address\" required><div ng-messages=\"locationEditForm.address.$error\" \nng-show=\"locationEditForm.address.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Address is required</span>\n</div></div></md-input-container><md-input-container flex=\"20\"><label>Zip</label><input type=\"text\" name=\"zip\" \nng-model=\"vm.location.zip\" required><div ng-messages=\"locationEditForm.zip.$error\" \nng-show=\"locationEditForm.zip.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Zip is required</span></div>\n</div></md-input-container><md-input-container flex=\"40\"><label>City</label><input type=\"text\" name=\"city\" \nng-model=\"vm.location.city\" required><div ng-messages=\"locationEditForm.city.$error\" \nng-show=\"locationEditForm.city.$touched\" role=\"alert\"><div ng-message=\"required\"><span>City is required</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\"><label>Telephone\n</label><input type=\"text\" name=\"phone_number\" ng-model=\"vm.location.phone_number\"></md-input-container>\n<md-input-container flex=\"50\"><label>Email</label><input type=\"text\" name=\"zip\" ng-model=\"vm.location.email\">\n</md-input-container></div><div class=\"notes\"><label>Description</label><text-angular \nng-model=\"vm.location.general_description\"></text-angular></div></md-tab><md-tab label=\"Energy Costs\"><div \nstyle=\"font-size: 18px\"><b>Gas</b></div><md-input-container class=\"md-block\"><label>Energy Supplier</label><input \ntype=\"text\" name=\"gas_supplier\" ng-model=\"vm.location.gas_supplier\"></md-input-container><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"33\"><label>Tarrif</label><input type=\"text\" name=\"gas_tarrif\" \nng-model=\"vm.location.gas_tarrif\" flex=\"50\" placeholder=\"0.2504€\"> <span flex>(m<sup>3</sup>&nbsp;ex&nbsp;VAT)</span>\n</md-input-container><md-input-container flex=\"33\"><label>Tax</label><input type=\"text\" name=\"gas_tax\" \nng-model=\"vm.location.gas_tax\" flex=\"50\" placeholder=\"0.1911€\"> <span flex>(m<sup>3</sup>&nbsp;ex&nbsp;VAT)</span>\n</md-input-container><md-input-container flex=\"33\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"33\"><label>SDE</label><input type=\"text\" name=\"gas_sde\" ng-model=\"vm.location.gas_sde\" \nflex=\"50\" placeholder=\"0.0074€\"> <span flex>(m<sup>3</sup>&nbsp;ex&nbsp;VAT)</span></md-input-container>\n<md-input-container flex=\"33\"><label>Delivery</label><input type=\"text\" name=\"gas_delivery\" \nng-model=\"vm.location.gas_delivery\" flex=\"50\" placeholder=\"28.80€\"> <span flex>(<sup></sup>year&nbsp;ex&nbsp;VAT)\n</span></md-input-container><md-input-container flex=\"33\"><label>Network</label><input type=\"text\" name=\"gas_network\" \nng-model=\"vm.location.gas_network\" flex=\"50\" placeholder=\"160.71€\"> <span flex>(<sup></sup>year&nbsp;inc&nbsp;VAT)\n</span></md-input-container></div><div style=\"margin-top: 20px; font-size: 18px\"><b>Electricity</b></div>\n<md-input-container class=\"md-block\"><label>Energy Supplier</label><input type=\"text\" name=\"electricity_supplier\" \nng-model=\"vm.location.electricity_supplier\"></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"33\"><label>High Tarrif</label><input type=\"text\" name=\"electricity_high_tarrif\" \nng-model=\"vm.location.electricity_high_tarrif\" flex=\"50\" placeholder=\"0.0450€\"> <span flex>(<sup></sup>\nKWh&nbsp;ex&nbsp;VAT)</span></md-input-container><md-input-container flex=\"33\"><label>Low Tarrif</label><input \ntype=\"text\" name=\"electricity_low_tarrif\" ng-model=\"vm.location.electricity_low_tarrif\" flex=\"50\" \nplaceholder=\"0.0395€\"> <span flex>(<sup></sup>KWh&nbsp;ex&nbsp;VAT)</span></md-input-container><md-input-container \nflex=\"33\"><label>Tax</label><input type=\"text\" name=\"electricity_tax\" ng-model=\"vm.location.electricity_tax\" flex=\"50\" \nplaceholder=\"0.1196€\"> <span flex>(<sup></sup>KWh&nbsp;ex&nbsp;VAT)</span></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"33\"><label>SDE</label><input type=\"text\" \nname=\"electricity_sde\" ng-model=\"vm.location.electricity_sde\" flex=\"50\" placeholder=\"0.0036€\"> <span flex>(<sup></sup>\nKWh&nbsp;ex&nbsp;VAT)</span></md-input-container><md-input-container flex=\"33\"><label>Delivery</label><input \ntype=\"text\" name=\"electricity_delivery\" ng-model=\"vm.location.electricity_delivery\" flex=\"50\" placeholder=\"81.50€\"> \n<span flex>(<sup></sup>year&nbsp;ex&nbsp;VAT)</span></md-input-container><md-input-container flex=\"33\"><label>Network\n</label><input type=\"text\" name=\"electricity_network\" ng-model=\"vm.location.electricity_network\" flex=\"50\" \nplaceholder=\"240.12€\"> <span flex>(<sup></sup>year&nbsp;inc&nbsp;VAT)</span></md-input-container></div></md-tab><md-tab\n label=\"PV Installation\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\"><label>\nInstallation Technician</label><input type=\"text\" name=\"installation_technician\" \nng-model=\"vm.location.installation_technician\"></md-input-container><md-input-container flex=\"50\"><label>\nInstallation Date</label><md-datepicker name=\"pv_panel_installation_date\" \nng-model=\"vm.location.pv_panel_installation_date\" md-hide-icons=\"calendar\" style=\"width: 100%\"></md-datepicker>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\"><label>PV Panel Type\n</label><input type=\"text\" name=\"pv_panel_type\" ng-model=\"vm.location.pv_panel_type\"></md-input-container>\n<md-input-container flex=\"50\"><label>PV Panel Supplier</label><input type=\"text\" name=\"pv_panel_supplier\" \nng-model=\"vm.location.pv_panel_supplier\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"50\"><label>Production Indication (KWh)</label><input type=\"text\" name=\"pv_panel_production\" \nng-model=\"vm.location.pv_panel_production\"></md-input-container><md-input-container flex=\"50\"><label>Supplier Guarantee\n</label><input type=\"text\" name=\"pv_panel_guarantee\" ng-model=\"vm.location.pv_panel_guarantee\"></md-input-container>\n</div></md-tab><md-tab></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><md-button type=\"submit\" ng-click=\"vm.saveLocation()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"locationEditForm.$invalid || locationEditForm.$pristine\">SAVE\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/home/views/list/list-view.html","<div class=\"portfolio-items\" ng-model=\"vm.locations\"><div class=\"portfolio-item\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"location in vm.locations\" ng-if=\"location.id != \'all\'\" \nng-class=\"{\'error\': location.error}\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex><div \nlayout=\"row\" layout-align=\"start start\" flex><div style=\"padding-right: 16px\"><md-button class=\"md-fab md-primary\" \nng-click=\"vm.selectLocation(location)\"><md-icon md-font-icon=\"icon-home\"></md-icon></md-button></div><div flex \nstyle=\"padding-top: 5px\"><div class=\"title\">{{location.owner}}</div><div class=\"notes\">{{location.name}}</div></div>\n</div><div class=\"tags\" layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\" data-ng-repeat=\"tag in location.tags\"><div class=\"tag-color\" \nng-style=\"{\'background-color\': tag.color}\"></div><div class=\"tag-label\">{{tag.label}}</div></div></div></div><div \nclass=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"is-important red-600-fg\" ng-if=\"location.important\"></md-icon><am-chart id=\"{{location.id}}\" \noptions=\"location.sparkline\" height=\"30px\" width=\"100px\"></am-chart><md-button class=\"md-raised\" \nng-click=\"vm.selectLocation(location)\" style=\"min-width: 36px; margin: 0 10px 0 20px\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"s18 hide-gt-xs\"></md-icon><span class=\"hide-xs\" \nstyle=\"display: inline-block; min-width: 88px\">Select</span></md-button></div></div></div></div>");
$templateCache.put("app/main/mv/dialogs/addAction/add-action.html","<md-dialog class=\"edit-plan-dialog\" aria-label=\"Edit Plan\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.ADD_ACTION\">Add Existing Action</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"md-background-bg md-hue-1\"><md-table-container><table md-table><thead md-head \nmd-order=\"title\"><tr md-row><th md-column></th><th md-column md-order-by=\"title\"><span translate=\"MV.TITLE\">Title\n</span></th><th md-column md-order-by=\"reference\"><span translate=\"MV.REFERENCE\">Type</span></th><th md-column \nmd-order-by=\"startdate\"><span translate=\"MV.START_DATE\">Start Date</span></th><th md-column md-order-by=\"enddate\"><span\n translate=\"MV.END_DATE\">End Date</span></th></tr></thead><tbody md-body><tr md-row ng-if=\"vm.actions.length == 0\"><td \nmd-cell></td><td md-cell colspan=\"4\"><div class=\"p-25\"><h3 translate=\"MV.MESSAGE.NO_DATA\">No data available in table...\n</h3></div></td></tr><tr md-row ng-if=\"\"><td md-cell></td><td md-cell colspan=\"6\"><div class=\"p-25\"><h3 \ntranslate=\"MV.MESSAGE.NOTHING\">Nothing found...</h3></div></td></tr><tr md-row ng-if=\"vm.actions.length > 0\" \nng-repeat=\"action in vm.actions\"><td md-cell><div class=\"custom-icon-button-wrapper\"><md-button class=\"md-icon-button\" \naria-label=\"Add Existing Action\" translate translate-attr-aria-label=\"MV.ADD_ACTION\"><md-tooltip md-direction=\"right\">\n<span translate=\"MV.ADD_ACTION\">Add Existing Action</span></md-tooltip><md-icon md-font-icon=\"pragma-icon-action\" \naria-hidden=\"true\"></md-icon></md-button></div></td><td md-cell>{{action.title}}</td><td md-cell>{{action.reference}}\n</td><td md-cell>{{action.startdate | date:\'MM/dd/yyyy h:mma\'}}</td><td md-cell>\n{{action.enddate | date:\'MM/dd/yyyy h:mma\'}}</td></tr></tbody></table></md-table-container></div><md-table-pagination \nmd-limit=\"\" md-limit-options=\"[5, 10, 15]\" md-page=\"\" md-total=\"\" md-on-paginate=\"\" md-page-select>\n</md-table-pagination></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.closeDialog()\" aria-label=\"Save\" translate translate-attr-aria-label=\"MV.FORMS.SAVE\"><span \ntranslate=\"MV.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/addData/add-data.html","<md-dialog class=\"add-data-dialog\" aria-label=\"Add Data\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.ADD_DATA\">Add Data</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"md-background-bg md-hue-1\"><md-tabs md-dynamic-height md-autoselect><md-tab>\n<md-tab-label><span tanslate=\"MV.MONITORED_POINTS\">Monitored Points</span></md-tab-label><md-tab-body><div \nclass=\"p-16\" flex><md-radio-group class=\"p16\" layout=\"column\" ng-model=\"vm.selectedMonitoredPoint\"><md-radio-button \nng-value=\"point.name\" ng-repeat=\"point in vm.monitoredPoints\"><md-icon md-font-icon=\"pragma-icon-{{point.icon}}\" \naria-hidden=\"true\"></md-icon>&nbsp;{{point.name}}</md-radio-button></md-radio-group></div></md-tab-body></md-tab>\n<md-tab><md-tab-label><span tanslate=\"MV.EXTERNAL_FILES\">External File</span></md-tab-label><md-tab-body><div \nclass=\"p-16\" flex><div class=\"mb-8 p-8\" layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"file in vm.files\">\n<span>{{file.name}}</span> <span>{{file.date | date:\'MM/dd/yyyy h:mma\'}}</span> <span><md-icon \nmd-font-icon=\"icon-close s16\" aria-hidden=\"true\"></md-icon></span></div></div></md-tab-body></md-tab></md-tabs></div>\n</div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.closeDialog()\">OK</md-button><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate \ntranslate-attr-aria-label=\"MV.FORMS.CANCEL\"><span translate=\"MV.FORMS.CANCEL\">Cancel</span></md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/copyAction/copy-action.html","<md-dialog class=\"copy-action-dialog\" aria-label=\"Copy action\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.COPY_ACTION\">Copy action</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"MV.FORMS.MESSAGES.CONFIRM_COPY_ACTION\">Are you sure you want to copy action:</span>\n&nbsp; \"{{vm.action.title}}\"?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.closeDialog()\">\nOK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancel\" translate translate-attr-aria-label=\"MV.FORMS.CANCEL\"><span translate=\"MV.FORMS.CANCEL\">Cancel\n</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/copyFactor/copy-factor.html","<md-dialog class=\"copy-factor-dialog\" aria-label=\"Copy factor\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.COPY_FACTOR\">Copy factor</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"MV.FORMS.MESSAGES.CONFIRM_COPY_FACTOR\">Are you sure you want to copy factor:</span>\n&nbsp; \"{{vm.factor.title}}\"?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.closeDialog()\">\nOK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancel\" translate translate-attr-aria-label=\"MV.FORMS.CANCEL\"><span translate=\"MV.FORMS.CANCEL\">Cancel\n</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/copyPlan/copy-plan.html","<md-dialog class=\"copy-plan-dialog\" aria-label=\"Copy Plan\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.COPY_PLAN\">Copy Plan</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"MV.FORMS.MESSAGES.CONFIRM_COPY_PLAN\">Are you sure you want to copy plan:</span>&nbsp; \"{{vm.plan.title}}\"?\n</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.closeDialog()\">OK\n</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancel\" translate translate-attr-aria-label=\"MV.FORMS.CANCEL\"><span translate=\"MV.FORMS.CANCEL\">Cancel\n</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/copyVariable/copy-variable.html","<md-dialog class=\"copy-variable-dialog\" aria-label=\"Copy Variable\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.COPY_VARIABLE\">Copy Variable</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"MV.FORMS.MESSAGES.CONFIRM_COPY_VARIABLE\">Are you sure you want to copy variable:</span>\n&nbsp; \"{{vm.variable.title}}\"?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.closeDialog()\">\nOK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancel\" translate translate-attr-aria-label=\"MV.FORMS.CANCEL\"><span translate=\"MV.FORMS.CANCEL\">Cancel\n</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/deleteAction/delete-action.html","<md-dialog class=\"delete-action-dialog\" aria-label=\"Delete Action\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.DELETE_ACTION\">Delete Action</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"MV.FORMS.MESSAGES.CONFIRM_DELETE_ACTION\">Are you sure you want to delete action:</span>\n&nbsp; \"{{vm.action.title}}\"?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.closeDialog()\">\nOK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancel\" translate translate-attr-aria-label=\"MV.FORMS.CANCEL\"><span translate=\"MV.FORMS.CANCEL\">Cancel\n</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/deleteFactor/delete-factor.html","<md-dialog class=\"delete-factor-dialog\" aria-label=\"Delete Factor\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.DELETE_FACTOR\">Delete Factor</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"MV.FORMS.MESSAGES.CONFIRM_DELETE_FACTOR\">Are you sure you want to delete factor:</span>\n&nbsp; \"{{vm.factor.title}}\"?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.closeDialog()\">\nOK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancel\" translate translate-attr-aria-label=\"MV.FORMS.CANCEL\"><span translate=\"MV.FORMS.CANCEL\">Cancel\n</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/deletePlan/delete-plan.html","<md-dialog class=\"delete-plan-dialog\" aria-label=\"Delete Plan\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.DELETE_PLAN\">Delete Plan</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"MV.FORMS.MESSAGES.CONFIRM_DELETE_PLAN\">Are you sure you want to delete plan:</span>\n&nbsp; \"{{vm.plan.title}}\"?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.closeDialog()\">\nOK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancel\" translate translate-attr-aria-label=\"MV.FORMS.CANCEL\"><span translate=\"MV.FORMS.CANCEL\">Cancel\n</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/deleteVariable/delete-variable.html","<md-dialog class=\"delete-variable-dialog\" aria-label=\"Delete Variable\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.DELETE_VARIABLE\">Delete Variable</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"MV.FORMS.MESSAGES.CONFIRM_DELETE_VARIABLE\">Are you sure you want to delete variable:</span>\n&nbsp; \"{{vm.variable.title}}\"?</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.closeDialog()\">\nOK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancel\" translate translate-attr-aria-label=\"MV.FORMS.CANCEL\"><span translate=\"MV.FORMS.CANCEL\">Cancel\n</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/editAction/edit-action.html","<md-dialog class=\"edit-action-dialog\" aria-label=\"Edit Action\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.EDIT_ACTION\">Edit Action</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-content p-24\"><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-block\"><label><span \ntranslate=\"MV.TITLE\">Title</span></label><input type=\"text\" ng-model=\"vm.action.title\" ng-required=\"true\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container class=\"md-block\"><label><span translate=\"MV.REFERENCE\">Reference</span></label><input type=\"text\" \nng-model=\"vm.action.reference\" ng-required=\"true\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" layout=\"column\"><label><span translate=\"MV.START_DATE\">Start Date\n</span></label><md-datepicker date-type=\"string\" ng-model=\"vm.action.startdate\" md-placeholder=\"Enter date\" \nmd-max-date=\"vm.maxDate\"></md-datepicker></div><div class=\"input-block\" layout=\"column\"><label><span \ntranslate=\"MV.END_DATE\">End Date</span></label><md-datepicker date-type=\"string\" ng-model=\"vm.action.enddate\" \nmd-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div></div><div layout=\"row\"><div \nclass=\"input-block\" flex><label><span translate=\"MV.FORMS.DESCRIPTION\">Description</span></label><text-angular \nng-model=\"vm.action.description\"></text-angular></div></div></div></div></div><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"MV.FORMS.SAVE\"><span translate=\"MV.FORMS.SAVE\">Save</span></md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/editFactor/edit-factor.html","<md-dialog class=\"edit-factor-dialog\" aria-label=\"Edit Factor\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.EDIT_FACTOR\">Edit Factor</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-content p-24\"><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-block\"><label><span \ntranslate=\"MV.TITLE\">Title</span></label><input type=\"text\" ng-model=\"vm.factor.title\" ng-required=\"true\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex>\n<md-input-container class=\"md-block\"><label><span translate=\"MV.OPERATOR\">Operator</span></label><md-select \nng-model=\"vm.selectedOperator\" ng-required=\"true\"><md-option ng-value=\"operator\" ng-repeat=\"operator in vm.operators\">\n{{operator}}</md-option></md-select></md-input-container></div><div class=\"input-block\" flex><md-input-container \nclass=\"md-block\"><label><span translate=\"MV.VALUE\">Value</span></label><input ng-model=\"vm.factor.value\" type=\"text\">\n</md-input-container></div></div><h4><span translate=\"MV.APPLICATION\">Application</span><md-icon \nmd-font-icon=\"icon-information-outline\" aria-hidden=\"true\"><md-tooltip md-direction=\"right\"><span \ntranslate=\"MV.FACTOR_APPLICATION_EXPLAIN\">The factor can apply to the report period itself or a specific section.\n</span></md-tooltip></md-icon></h4><div layout=\"row\" layout-align=\"start start\"><div class=\"input-block\" \nlayout=\"column\"><label><span translate=\"MV.START_DATE\">Start Date</span></label><md-datepicker \nng-model=\"vm.factor.startdate\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div><div \nclass=\"input-block\" layout=\"column\"><label><span translate=\"MV.END_DATE\">End Date</span></label><md-datepicker \nng-model=\"vm.factor.enddate\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div></div><div \nlayout=\"row\"><div class=\"input-block\" flex><label><span translate=\"MV.FORMS.DESCRIPTION\">Description</span></label>\n<text-angular ng-model=\"vm.factor.description\"></text-angular></div></div></div></div></div><md-dialog-actions \nlayout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"MV.FORMS.SAVE\"><span translate=\"MV.FORMS.SAVE\">Save</span></md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/editPlan/edit-plan.html","<md-dialog class=\"edit-plan-dialog\" aria-label=\"Edit Plan\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.EDIT_PLAN\">Edit Plan</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label>\n<span translate=\"MV.TITLE\">Title</span></label><input type=\"text\" ng-model=\"vm.plan.title\" ng-required=\"true\">\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-icon-float md-block\"><label><span translate=\"MV.TYPE\">Plan Type\n</span></label><md-select ng-model=\"vm.plan.type\" ng-required=\"true\"><md-option ng-value=\"ptype\" \nng-repeat=\"ptype in vm.protoTypes\">{{ptype}}</md-option></md-select></md-input-container></div></div></div></div>\n<md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button\n class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"MV.FORMS.SAVE\"><span translate=\"MV.FORMS.SAVE\">Save</span></md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/editVariable/edit-variable.html","<md-dialog class=\"edit-variable-dialog\" aria-label=\"Edit Variable\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.EDIT_VARIABLE\">Edit Variable</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-content p-24\"><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-block\"><label><span \ntranslate=\"MV.TITLE\">Title</span></label><input type=\"text\" ng-model=\"vm.variable.title\" ng-required=\"true\">\n</md-input-container></div></div><div layout=\"row\"><div class=\"input-block\" flex><label><span \ntranslate=\"MV.FORMS.DESCRIPTION\">Description</span></label><text-angular ng-model=\"vm.variable.description\">\n</text-angular></div></div></div></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.closeDialog()\" aria-label=\"Save\" translate translate-attr-aria-label=\"MV.FORMS.SAVE\"><span \ntranslate=\"MV.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/newAction/new-action.html","<md-dialog class=\"new-action-dialog\" aria-label=\"New Action\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.CREATE_ACTION\">Create New Action</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content p-24\"><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-block\"><label><span translate=\"MV.TITLE\">Title</span></label>\n<input type=\"text\" ng-required=\"true\"></md-input-container></div></div><div layout=\"row\" layout-align=\"start start\">\n<div class=\"input-block\" flex><md-input-container class=\"md-block\"><label><span translate=\"MV.REFERENCE\">Reference\n</span></label><input type=\"text\" ng-required=\"true\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" layout=\"column\"><label><span translate=\"MV.START_DATE\">Start Date\n</span></label><md-datepicker ng-model=\"vm.date\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker>\n</div><div class=\"input-block\" layout=\"column\"><label><span translate=\"MV.END_DATE\">End Date</span></label>\n<md-datepicker ng-model=\"vm.date\" md-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div></div><div\n layout=\"row\"><div class=\"input-block\" flex><label><span translate=\"MV.FORMS.DESCRIPTION\">Description</span></label>\n<text-angular></text-angular></div></div></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\">\n<div layout=\"row\" layout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.closeDialog()\" aria-label=\"Save\" translate translate-attr-aria-label=\"MV.FORMS.SAVE\"><span \ntranslate=\"MV.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/newFactor/new-factor.html","<md-dialog class=\"new-factor-dialog\" aria-label=\"New Factor\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.CREATE_FACTOR\">Create New Factor</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content p-24\"><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-block\"><label><span translate=\"MV.TITLE\">Title</span></label>\n<input type=\"text\" ng-required=\"true\"></md-input-container></div></div><div layout=\"row\" layout-align=\"start start\">\n<div class=\"input-block\" flex><md-input-container class=\"md-block\"><label><span translate=\"MV.OPERATOR\">Operator</span>\n</label><md-select ng-model=\"vm.selectedOperator\" ng-required=\"true\"><md-option ng-value=\"operator\" \nng-repeat=\"operator in vm.operators\">{{operator}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container class=\"md-block\"><label><span translate=\"MV.VALUE\">Value</span></label>\n<input type=\"text\"></md-input-container></div></div><h4><span translate=\"MV.APPLICATION\">Application</span><md-icon \nmd-font-icon=\"icon-information-outline\" aria-hidden=\"true\"><md-tooltip md-direction=\"right\"><span \ntranslate=\"MV.FACTOR_APPLICATION_EXPLAIN\">The factor can apply to the report period itself or a specific section.\n</span></md-tooltip></md-icon></h4><div layout=\"row\" layout-align=\"start start\"><div class=\"input-block\" \nlayout=\"column\"><label><span translate=\"MV.START_DATE\">Start Date</span></label><md-datepicker ng-model=\"vm.date\" \nmd-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div><div class=\"input-block\" layout=\"column\">\n<label><span translate=\"MV.END_DATE\">End Date</span></label><md-datepicker ng-model=\"vm.date\" \nmd-placeholder=\"Enter date\" md-max-date=\"vm.maxDate\"></md-datepicker></div></div><div layout=\"row\"><div \nclass=\"input-block\" flex><label><span translate=\"MV.FORMS.DESCRIPTION\">Description</span></label><text-angular>\n</text-angular></div></div></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.closeDialog()\" aria-label=\"Save\" translate translate-attr-aria-label=\"MV.FORMS.SAVE\"><span \ntranslate=\"MV.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/newPlan/new-plan.html","<md-dialog class=\"new-plan-dialog\" aria-label=\"New Plan\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.ADD_PLAN\">Create New Plan</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content p-24\"><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-block\"><label><span translate=\"MV.TITLE\">Title</span></label>\n<input type=\"text\" ng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-block\"><label><span \ntranslate=\"MV.TYPE\">Plan Type</span></label><md-select ng-model=\"vm.selectedProtoType\" ng-required=\"true\"><md-option \nng-value=\"ptype\" ng-repeat=\"ptype in vm.protoTypes\">{{ptype}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container class=\"md-block\"><label><span translate=\"MV.COST\">Cost</span></label>\n<input type=\"text\" ng-model=\"vm.currentPlan.cost\" ng-required=\"true\"></md-input-container></div></div><div \nlayout=\"row\"><div class=\"input-block\" flex><label><span translate=\"MV.FORMS.DESCRIPTION\">Description</span></label>\n<text-angular></text-angular></div></div></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\">\n<div layout=\"row\" layout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.closeDialog()\" aria-label=\"Save\" translate translate-attr-aria-label=\"MV.FORMS.SAVE\"><span \ntranslate=\"MV.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/mv/dialogs/newVariable/new-variable.html","<md-dialog class=\"new-variable-dialog\" aria-label=\"New Variable\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MV.FORMS.CREATE_VARIABLE\">Create New Variable</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"VM.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content p-24\"><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-block\"><label><span translate=\"MV.TITLE\">Title</span></label>\n<input type=\"text\" ng-required=\"true\"></md-input-container></div></div><div layout=\"row\"><div class=\"input-block\" flex>\n<label><span translate=\"MV.FORMS.DESCRIPTION\">Description</span></label><text-angular></text-angular></div></div></div>\n</div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" aria-label=\"Save\" \ntranslate translate-attr-aria-label=\"MV.FORMS.SAVE\"><span translate=\"MV.FORMS.SAVE\">Save</span></md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/notification/dialogs/edit-calendar-notification/edit-calendar-notification.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"Notification Details\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.notification.title}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon \nmd-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span class=\"h4\">\n{{vm.notification.eventDate | date:\'dd/MM/yyyy HH:mm\'}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" style=\"color: #5cb85c\" class=\"icon\" \nng-if=\"vm.notification.type==\'Success\'\"></md-icon><md-icon md-font-icon=\"icon-information\" style=\"color: #5bc0de\" \nclass=\"icon\" ng-if=\"vm.notification.type==\'Info\'\"></md-icon><md-icon md-font-icon=\"icon-alert\" style=\"color: #f0ad4e\" \nclass=\"icon\" ng-if=\"vm.notification.type==\'Warning\'\"></md-icon><md-icon md-font-icon=\"icon-alert-octagon\" \nstyle=\"color: #d9534f\" class=\"icon\" ng-if=\"vm.notification.type==\'Error\'\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.notification.message}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-eye\"></md-icon><div layout=\"column\" flex><md-checkbox md-no-ink \naria-label=\"No Ink Effects\" ng-model=\"vm.notification.read\" ng-change=\"vm.changeRead()\">Toggle as Read</md-checkbox>\n</div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/reporting/dialogs/blockProperties/blockProperties.html","<md-dialog class=\"change-block-properties-dialog\" aria-label=\"Change Block Properties\" flex=\"55\" flex-sm=\"80\">\n<md-toolbar class=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"REPORTS.CHANGE_BLOCK_PROPERTIES\">\nChange Block Properties</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close\" \ntranslate translate-attr-aria-label=\"REPORTS.CLOSE\"><md-icon md-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"row\" layout=\"column\" style=\"min-height: 664px\">\n<div class=\"m-16 pb-16\" layout=\"column\" ng-model=\"vm.block\" ng-style=\"vm.block.style[0]\"><div class=\"block\" \nng-if=\"vm.block.type === \'format\'\" ng-bind-html=\"vm.block.html\">{{block.html}}</div><div class=\"block\" \nng-if=\"vm.block.type === \'widget\'\"><numeric-card id=\"numeric-card\" widget=\"vm.block.widget\" \ndashboard-date=\"vm.block.widget.dates[0].date\" report=\"true\" ng-if=\"vm.block.widget.type===0\" \nstyle=\"text-align:center\"></numeric-card><plot-card-report widget=\"vm.block.widget\" \ndashboard-date=\"vm.block.widget.dates[0].date\" report=\"true\" ng-if=\"vm.block.widget.type===1\" \nstyle=\"text-align:center\"></plot-card-report><pie-card-report widget=\"vm.block.widget\" \ndashboard-date=\"vm.block.widget.dates[0].date\" report=\"true\" ng-if=\"vm.block.widget.type===2\" \nstyle=\"text-align:center\"></pie-card-report><spyder-card-report widget=\"vm.block.widget\" \ndashboard-date=\"vm.block.widget.dates[0].date\" report=\"true\" ng-if=\"vm.block.widget.type===4\" \nstyle=\"text-align:center\"></spyder-card-report></div></div><div class=\"form-content\"><div class=\"form-title\">General\n</div><div layout=\"row\" layout-align=\"start end\" flex><div class=\"input-block\" flex><label \ntranslate=\"REPORTS.FONT_COLOR\">Block Font Color</label><color-picker ng-model=\"vm.block.style[0][\'color\']\" \noptions=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\"></color-picker></div><div class=\"input-block\" \nng-if=\"vm.block.widget.type != 1 && vm.block.widget.type != 2 && vm.block.widget.type != 4\" flex><label \ntranslate=\"REPORTS.BACKGROUND_COLOR\">Block Background Color</label><color-picker \nng-model=\"vm.block.style[0][\'background\']\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\"></color-picker></div>\n</div><div class=\"form-title\">Borders</div><div layout=\"column\" layout-align=\"start start\"><label \ntranslate=\"REPORTS.BORDER_WIDTH\">Border Width</label><div class=\"input-block\" flex><input type=\"number\" \nng-model=\"vm.block.style[0][\'border-width\']\" min=\"0\"></div><label translate=\"REPORTS.BORDER_STYLE\">Border Style</label>\n<div class=\"input-block\" flex><md-input-container flex><md-select ng-model=\"vm.block.style[0][\'border-style\']\" \naria-label=\"Border Style\"><md-option value=\"none\">none</md-option><md-option value=\"dotted\">dotted</md-option>\n<md-option value=\"dashed\">dashed</md-option><md-option value=\"solid\">solid</md-option></md-select></md-input-container>\n</div><label translate=\"REPORTS.BORDER_COLOR\">Border Color</label><div class=\"input-block\" flex><color-picker \nng-model=\"vm.block.style[0][\'border-color\']\" options=\"vm.fontcolor\" event-api=\"vm.colorPickerApi\"></color-picker></div>\n<label translate=\"REPORTS.BORDER_RADIUS\">Border Radius</label><div class=\"input-block\" flex><input type=\"number\" \nng-model=\"vm.block.style[0][\'border-radius\']\" min=\"0\"></div></div></div></div><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.changeProperties()\" aria-label=\"Save\" \ntranslate translate-attr-aria-label=\"REPORTS.SAVE\"><span translate=\"REPORTS.SAVE\">Save</span></md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/reporting/dialogs/controlReport/controlReport.html","<md-dialog class=\"new-user-dialog\" aria-label=\"vm.action\"><md-toolbar class=\"md-primary-bg md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \ntranslate=\"REPORTS.{{vm.action | uppercase}}_REPORT\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"DASHBOARD.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll class=\"md-foreground-fg\"><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div \nng-if=\"vm.action===\'New\' || vm.action===\'Edit\'\"><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div\n class=\"input-block\" flex><md-input-container flex><label translate=\"REPORTS.REPORT_TITLE\"></label><input \nng-model=\"vm.report.title\" type=\"text\" ng-required=\"true\"></md-input-container></div><div class=\"input-block\" flex>\n<md-input-container flex><label translate=\"REPORTS.REPORT_DESCRIPTION\"></label><input ng-model=\"vm.report.description\" \ntype=\"text\" ng-required=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label \ntranslate=\"REPORTS.REPORT_HEADER\"></label><input ng-model=\"vm.report.header\" type=\"text\" ng-required=\"true\">\n</md-input-container></div><div class=\"input-block\" flex><md-input-container flex><label \ntranslate=\"REPORTS.REPORT_FOOTER\"></label><input ng-model=\"vm.report.footer\" type=\"text\" ng-required=\"true\">\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-checkbox ng-model=\"vm.report.details.auto\" aria-label=\"\"><label><span \ntranslate=\"REPORTS.REPORT_AUTO\"></span></label></md-checkbox></div><div class=\"input-block\" flex \nng-if=\"vm.report.details.auto\"><md-input-container flex><label translate=\"REPORTS.REPORT_START_DATE\"></label>\n<md-datepicker name=\"expirationStartDate\" ng-model=\"vm.report.details.startDate\" \nmd-placeholder=\"{{REPORTS.REPORT_START_DATE}}\" ng-required=\"true\"></md-datepicker></md-input-container></div></div><div\n layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" ng-if=\"vm.report.details.auto\"><div class=\"input-block\" \nflex><md-input-container flex><label translate=\"REPORTS.REPORT_DURATION_TYPE\"></label><md-select \nng-model=\"vm.report.details.type\" ng-required=\"true\"><md-option ng-value=\"duration.type\" \nng-repeat=\"duration in vm.durations\">{{duration.name}}</md-option></md-select></md-input-container></div><div \nclass=\"input-block\" flex><md-input-container flex><label translate=\"REPORTS.REPORT_DURATION_VALUE\"></label><input \nng-model=\"vm.report.details.value\" min=\"1\" type=\"number\" ng-required=\"true\"></md-input-container></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" \nng-if=\"vm.user.role!==\'level04\' && vm.user.role!==\'level05\'\"><div class=\"input-block\" flex><md-checkbox \nng-model=\"vm.report.isTemplate\" aria-label=\"\"><label><span translate=\"REPORTS.REPORT_ISTEMPLATE\"></span></label>\n</md-checkbox></div><div class=\"input-block\" flex><md-input-container flex><label translate=\"REPORTS.REPORT_TENANTS\">\n</label><md-select ng-model=\"vm.report.tenants\" ng-required=\"true\" multiple=\"multiple\"><md-option \nng-value=\"tenant.authenticationToken\" ng-repeat=\"tenant in vm.tenants\">{{tenant.name}}</md-option></md-select>\n</md-input-container></div></div></div><p class=\"message md-background-fg md-hue-2\" ng-if=\"vm.action===\'Delete\'\" \ntranslate=\"REPORTS.MESSAGE.DELETE_REPORT\"></p><p class=\"message md-background-fg md-hue-2\" ng-if=\"vm.action===\'Save\'\" \ntranslate=\"REPORTS.MESSAGE.SAVE_REPORT\"></p><p class=\"message md-background-fg md-hue-2\" \nng-if=\"vm.action===\'Download\'\" translate=\"REPORTS.MESSAGE.DOWNLOAD_REPORT\"></p><p \nclass=\"message md-background-fg md-hue-2\" ng-if=\"vm.action===\'Duplicate\'\" translate=\"REPORTS.MESSAGE.DUPLICATE_REPORT\">\n</p></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-if=\"vm.action===\'New\' || vm.action===\'Edit\' || vm.action===\'Save\'\" \nng-click=\"vm.save()\" aria-label=\"Save\" translate=\"DASHBOARD.SAVE\" translate-attr-aria-label=\"DASHBOARD.SAVE\" \nclass=\"save-button md-primary md-raised\">SAVE</md-button><md-button ng-if=\"vm.action===\'Duplicate\'\" \nng-click=\"vm.save()\" aria-label=\"Duplicate\" translate=\"DASHBOARD.DUPLICATE\" \ntranslate-attr-aria-label=\"DASHBOARD.DUPLICATE\" class=\"save-button md-primary md-raised\">DUPLICATE</md-button>\n<md-button ng-if=\"vm.action===\'Delete\'\" ng-click=\"vm.save()\" aria-label=\"Delete\" translate=\"DASHBOARD.DELETE\" \ntranslate-attr-aria-label=\"DASHBOARD.DELETE\" class=\"save-button md-primary md-raised\">DELETE</md-button><md-button \nng-if=\"vm.action===\'Download\'\" ng-click=\"vm.save()\" aria-label=\"Restore\" translate=\"REPORTS.DOWNLOAD\" \ntranslate-attr-aria-label=\"REPORTS.DOWNLOAD\" class=\"save-button md-primary md-hue-1 md-raised\">DOWNLOAD</md-button>\n</div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/reporting/dialogs/widgetDates/widgetDates.html","<md-dialog class=\"change-widget-dates-dialog\" aria-label=\"Change Widget Dates\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"REPORTS.CHANGE_WIDGET_DATES\">Change Widget Dates</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"REPORTS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"DASHBOARD.WIDGET.DATE_RANGE\">Select Date Range</span></label><md-select ng-model=\"vm.dates\" \nng-required=\"true\"><md-option value=\"custom\"><span translate=\"DATERANGE.CUSTOM_RANGE\">Custom Range</span></md-option>\n<md-option value=\"thisYear\"><span translate=\"DATERANGE.THIS_YEAR\">This Year</span></md-option><md-option \nvalue=\"last3Months\"><span translate=\"DATERANGE.LAST_3_MONTS\">Last 3 Months</span></md-option><md-option \nvalue=\"lastMonth\"><span translate=\"DATERANGE.LAST_MONTH\">Last Month</span></md-option><md-option value=\"thisMonth\">\n<span translate=\"DATERANGE.THIS_MONTH\">This Month</span></md-option><md-option value=\"last30Days\"><span \ntranslate=\"DATERANGE.LAST_30_DAYS\">Last 30 Days</span></md-option><md-option value=\"lastWeek\"><span \ntranslate=\"DATERANGE.LAST_WEEK\">Last Week</span></md-option><md-option value=\"thisWeek\"><span \ntranslate=\"DATERANGE.THIS_WEEK\">This Week</span></md-option><md-option value=\"last7Days\"><span \ntranslate=\"DATERANGE.LAST_7_DAYS\">Last 7 Days</span></md-option><md-option value=\"yesterday\"><span \ntranslate=\"DATERANGE.YESTERDAY\">Yesterday</span></md-option><md-option value=\"today\"><span translate=\"DATERANGE.TODAY\">\nToday</span></md-option></md-select></md-input-container></div></div></div></div><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.changeDates()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"REPORTS.SAVE\"><span translate=\"REPORTS.SAVE\">Save</span></md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/rules/dialogs/copyRule/copy-rule.html","<md-dialog class=\"copy-rule-dialog\" aria-label=\"Copy Rule\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"RULES.COPY_RULE\">Copy Rule</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"RULES.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"RULES.FORMS.CONFIRM_COPY_RULE\">Are you sure you want to copy rule:</span>&nbsp; \"{{vm.rule.title}}\"?</p><div\n layout=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-block\"><label>\n<span translate=\"RULES.NEW_TITLE\">Title</span></label><input ng-model=\"vm.newTitle\" type=\"text\" ng-required=\"true\">\n</md-input-container></div></div></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" \nng-click=\"vm.confirmDialog()\">OK</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cancel\" translate translate-attr-aria-label=\"MV.FORMS.CANCEL\"><span \ntranslate=\"RULES.FORMS.CANCEL\">Cancel</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/rules/dialogs/deleteRule/delete-rule.html","<md-dialog class=\"delete-rule-dialog\" aria-label=\"Delete Rule\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"RULES.DELETE_RULE\">Delete Rule</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"RULES.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><p class=\"message\"><span \ntranslate=\"RULES.FORMS.CONFIRM_DELETE_RULE\">Are you sure you want to delete rule:</span>&nbsp; \"{{vm.rule.title}}\"?</p>\n</div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"ok-button md-primary md-raised\" ng-click=\"vm.confirmDialog()\">OK\n</md-button><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancel\" translate translate-attr-aria-label=\"RULES.FORMS.CANCEL\"><span translate=\"RULES.FORMS.CANCEL\">\nCancel</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/rules/dialogs/editCondition/edit-condition.html","<md-dialog class=\"edit-condition-dialog\" aria-label=\"Edit Condition\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"RULES.EDIT_CONDITION\">Edit Condition</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"RULES.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n ng-form=\"conditionsForm\" class=\"form-content p-24\"><div ng-if=\"vm.index != 0\"><h3 class=\"m-0 font-weight-700\"><span \ntranslate=\"RULES.ARGUMENT\">Argument</span></h3><div layout=\"row\" layout-padding><md-radio-group layout=\"row\" \nng-model=\"vm.condition.argument\" ng-required=\"true\"><md-radio-button ng-value=\"argument\" \nng-repeat=\"argument in vm.arguments\">{{ argument }}</md-radio-button></md-radio-group></div></div><h3 \nclass=\"m-0 font-weight-700\"><span translate=\"RULES.FIRST_PART\">First Part</span></h3><div layout-gt-xs=\"row\" \nlayout=\"column\" layout-padding><md-input-container><label><span translate=\"RULES.VARIABLE\">Variable</span></label>\n<md-select name=\"firstVariable\" ng-model=\"vm.condition.firstPart.variable\" ng-required=\"true\"><md-option \nng-value=\"variable.id\" ng-repeat=\"variable in vm.variables\">{{ variable.variableName }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'firstVariable\'].$error\" ng-show=\"conditionsForm[\'firstVariable\'].$touched\"><div \nng-message=\"required\"><span translate=\"RULES.VARIABLE_CONDITION_ERROR\">You must select a variable</span></div></div>\n</md-input-container><md-input-container><label><span translate=\"RULES.STATISTICAL\">Statistical Rule</span></label>\n<md-select name=\"statisticalFirstVariable\" ng-model=\"vm.condition.firstPart.statistical\" \nng-change=\"vm.statisticalFirstChanged()\" ng-required=\"true\"><md-option ng-value=\"statistical.id\" \nng-repeat=\"statistical in vm.statisticalRules\">{{ statistical.title }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'statisticalFirstVariable\'].$error\" \nng-show=\"conditionsForm[\'statisticalFirstVariable\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.STATISTICAL_ERROR\">You must Assign a statistical rule to your variable</span></div></div>\n</md-input-container><md-input-container ng-if=\"vm.condition.firstPart.statistical != \'CUR\'\"><label><span \ntranslate=\"RULES.DURATION_TYPE\">Duration Period</span></label><md-select name=\"durationTypeFirstVariable\" \nng-model=\"vm.condition.firstPart.duration.type\" ng-required=\"true\"><md-option ng-value=\"durationType.id\" \nng-repeat=\"durationType in vm.statisticalDurationTypes\">{{ durationType.title }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'durationTypeFirstVariable\'].$error\" \nng-show=\"conditionsForm[\'durationTypeFirstVariable\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.DURATION_TYPE_ERROR\">You must Assign a duration period to your variable</span></div></div>\n</md-input-container><md-input-container ng-if=\"vm.condition.firstPart.statistical != \'CUR\'\"><label><span \ntranslate=\"RULES.NUMERICAL_VALUE\">Numerical Value</span></label><input type=\"number\" name=\"durationValueFirstVariable\" \nng-model=\"vm.condition.firstPart.duration.value\" ng-required=\"true\"><div \nng-messages=\"conditionsForm[\'durationValueFirstVariable\'].$error\" \nng-show=\"conditionsForm[\'durationValueFirstVariable\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.NUMERICAL_VALUE_ERROR\">You must select a numerical value for your condition</span></div><div \nng-message=\"number\"><span translate=\"RULES.NUMERICAL_VALUE_ERROR_NUMBER\">Not a valid number</span></div></div>\n</md-input-container></div><h3 class=\"m-0 font-weight-700\"><span translate=\"RULES.RELATION\">Relation</span></h3><div \nlayout=\"column\" layout-align=\"start start\" layout-padding><md-input-container><label><span translate=\"RULES.RELATION\">\nRelation</span></label><md-select name=\"relation\" ng-model=\"vm.condition.relation\" ng-required=\"true\"><md-option \nng-value=\"relation\" ng-repeat=\"relation in vm.relations\">{{ relation }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'relation\'].$error\" ng-show=\"conditionsForm[\'relation\'].$touched\"><div \nng-message=\"required\"><span translate=\"RULES.RELATION_ERROR\">You must define the relation of your condition</span>\n</div></div></md-input-container></div><h3 class=\"m-0 font-weight-700\"><span translate=\"RULES.SECOND_PART\">Second Part\n</span></h3><div layout=\"column\" layout-padding flex><md-radio-group layout=\"row\" ng-change=\"vm.changeSecondPart()\" \nng-model=\"vm.condition.secondPart.type\" ng-required=\"true\"><md-radio-button value=\"variable\"><span \ntranslate=\"RULES.VARIABLE\">Variable</span></md-radio-button><md-radio-button value=\"value\"><span \ntranslate=\"RULES.NUMERICAL_VALUE\">Numerical Value</span></md-radio-button></md-radio-group><div \nng-if=\"vm.condition.secondPart.type == \'variable\'\" layout-gt-xs=\"row\" layout=\"column\"><md-input-container><label><span \ntranslate=\"RULES.VARIABLE\">Variable</span></label><md-select name=\"secondVariable\" \nng-model=\"vm.condition.secondPart.variable\" ng-required=\"true\"><md-option ng-value=\"variable.id\" \nng-repeat=\"variable in vm.variables\">{{ variable.variableName }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'secondVariable\'].$error\" ng-show=\"conditionsForm[\'secondVariable\'].$touched\"><div \nng-message=\"required\"><span translate=\"RULES.VARIABLE_CONDITION_ERROR\">You must select a variable</span></div></div>\n</md-input-container><md-input-container><label><span translate=\"RULES.STATISTICAL\">Statistical Rule</span></label>\n<md-select name=\"statisticalSecondVariable\" ng-model=\"vm.condition.secondPart.statistical\" \nng-change=\"vm.statisticalSecondChanged()\" ng-required=\"true\"><md-option ng-value=\"statistical.id\" \nng-repeat=\"statistical in vm.statisticalRules\">{{ statistical.title }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'statisticalSecondVariable\'].$error\" \nng-show=\"conditionsForm[\'statisticalSecondVariable\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.STATISTICAL_ERROR\">You must Assign a statistical rule to your variable</span></div></div>\n</md-input-container><md-input-container ng-if=\"vm.condition.secondPart.statistical != \'CUR\'\"><label><span \ntranslate=\"RULES.DURATION_TYPE\">Duration Period</span></label><md-select name=\"durationTypeSecondVariable\" \nng-model=\"vm.condition.secondPart.duration.type\" ng-required=\"true\"><md-option ng-value=\"durationType.id\" \nng-repeat=\"durationType in vm.statisticalDurationTypes\">{{ durationType.title }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'durationTypeSecondVariable\'].$error\" \nng-show=\"conditionsForm[\'durationTypeSecondVariable\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.DURATION_TYPE_ERROR\">You must Assign a duration period to your variable</span></div></div>\n</md-input-container><md-input-container ng-if=\"vm.condition.secondPart.statistical != \'CUR\'\"><label><span \ntranslate=\"RULES.NUMERICAL_VALUE\">Numerical Value</span></label><input type=\"number\" \nname=\"durationValueSecondVariable\" ng-model=\"vm.condition.secondPart.duration.value\" ng-required=\"true\"><div \nng-messages=\"conditionsForm[\'durationValueSecondVariable\'].$error\" \nng-show=\"conditionsForm[\'durationValueSecondVariable\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.NUMERICAL_VALUE_ERROR\">You must select a numerical value for your condition</span></div><div \nng-message=\"number\"><span translate=\"RULES.NUMERICAL_VALUE_ERROR_NUMBER\">Not a valid number</span></div></div>\n</md-input-container></div><div ng-if=\"vm.condition.secondPart.type == \'value\'\" layout=\"column\" \nlayout-align=\"start start\"><md-input-container><label><span translate=\"RULES.NUMERICAL_VALUE\">Numerical Value</span>\n</label><input type=\"number\" name=\"value\" ng-model=\"vm.condition.secondPart.value\" ng-required=\"true\"><div \nng-messages=\"conditionsForm[\'value\'].$error\" ng-show=\"conditionsForm[\'value\'].$touched\"><div ng-message=\"required\">\n<span translate=\"RULES.NUMERICAL_VALUE_ERROR\">You must select a numerical value for your condition</span></div><div \nng-message=\"number\"><span translate=\"RULES.NUMERICAL_VALUE_ERROR_NUMBER\">Not a valid number</span></div></div>\n</md-input-container></div></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"conditionsForm.$invalid\" \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.saveCondition()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"RULES.FORMS.SAVE\"><span translate=\"RULES.FORMS.SAVE\">Save</span></md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/rules/dialogs/editRule/edit-rule.html","<md-dialog class=\"edit-rule-dialog\" aria-label=\"Edit Rule\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"RULES.EDIT_RULE\">Edit Rule</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"RULES.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content\"><div class=\"form-content p-24\"><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container class=\"md-block\"><label><span \ntranslate=\"RULES.TITLE\">Title</span></label><input type=\"text\" ng-model=\"vm.rule.title\" ng-required=\"true\">\n</md-input-container></div></div><div layout=\"row\"><div class=\"input-block\" flex><label><span \ntranslate=\"RULES.DESCRIPTION\">Description</span></label><text-angular ng-model=\"vm.rule.description\"></text-angular>\n</div></div></div></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"mt-10 md-raised md-button md-primary md-ink-ripple\" \nng-click=\"vm.saveRule()\" aria-label=\"Save\" translate translate-attr-aria-label=\"RULES.FORMS.SAVE\"><span \ntranslate=\"RULES.FORMS.SAVE\">Save</span></md-button></div></md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/rules/dialogs/newCondition/new-condition.html","<md-dialog class=\"new-condition-dialog\" aria-label=\"New Condition\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{ \'RULES.NEW_CONDITION\' | translate }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"RULES.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n ng-form=\"conditionsForm\" class=\"form-content p-24\"><div ng-if=\"vm.index != 0\"><h3 class=\"m-0 font-weight-700\"><span \ntranslate=\"RULES.ARGUMENT\">Argument</span></h3><div layout=\"row\" layout-padding><md-radio-group layout=\"row\" \nng-model=\"vm.condition.argument\" ng-required=\"true\"><md-radio-button ng-value=\"argument\" \nng-repeat=\"argument in vm.arguments\">{{ argument }}</md-radio-button></md-radio-group></div></div><h3 \nclass=\"m-0 font-weight-700\"><span translate=\"RULES.FIRST_PART\">First Part</span></h3><div layout-gt-xs=\"row\" \nlayout=\"column\" layout-padding><md-input-container><label><span translate=\"RULES.VARIABLE\">Variable</span></label>\n<md-select name=\"firstVariable\" ng-model=\"vm.condition.firstPart.variable\" ng-required=\"true\"><md-option \nng-value=\"variable.id\" ng-repeat=\"variable in vm.variables\">{{ variable.variableName }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'firstVariable\'].$error\" ng-show=\"conditionsForm[\'firstVariable\'].$touched\"><div \nng-message=\"required\"><span translate=\"RULES.VARIABLE_CONDITION_ERROR\">You must select a variable</span></div></div>\n</md-input-container><md-input-container><label><span translate=\"RULES.STATISTICAL\">Statistical Rule</span></label>\n<md-select name=\"statisticalFirstVariable\" ng-model=\"vm.condition.firstPart.statistical\" \nng-change=\"vm.statisticalFirstChanged()\" ng-required=\"true\"><md-option ng-value=\"statistical.id\" \nng-repeat=\"statistical in vm.statisticalRules\">{{ statistical.title }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'statisticalFirstVariable\'].$error\" \nng-show=\"conditionsForm[\'statisticalFirstVariable\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.STATISTICAL_ERROR\">You must Assign a statistical rule to your variable</span></div></div>\n</md-input-container><md-input-container ng-if=\"vm.condition.firstPart.statistical != \'CUR\'\"><label><span \ntranslate=\"RULES.DURATION_TYPE\">Duration Period</span></label><md-select name=\"durationTypeFirstVariable\" \nng-model=\"vm.condition.firstPart.duration.type\" ng-required=\"true\"><md-option ng-value=\"durationType.id\" \nng-repeat=\"durationType in vm.statisticalDurationTypes\">{{ durationType.title }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'durationTypeFirstVariable\'].$error\" \nng-show=\"conditionsForm[\'durationTypeFirstVariable\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.DURATION_TYPE_ERROR\">You must Assign a duration period to your variable</span></div></div>\n</md-input-container><md-input-container ng-if=\"vm.condition.firstPart.statistical != \'CUR\'\"><label><span \ntranslate=\"RULES.NUMERICAL_VALUE\">Numerical Value</span></label><input type=\"number\" name=\"durationValueFirstVariable\" \nng-model=\"vm.condition.firstPart.duration.value\" ng-required=\"true\"><div \nng-messages=\"conditionsForm[\'durationValueFirstVariable\'].$error\" \nng-show=\"conditionsForm[\'durationValueFirstVariable\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.NUMERICAL_VALUE_ERROR\">You must select a numerical value for your condition</span></div><div \nng-message=\"number\"><span translate=\"RULES.NUMERICAL_VALUE_ERROR_NUMBER\">Not a valid number</span></div></div>\n</md-input-container></div><h3 class=\"m-0 font-weight-700\"><span translate=\"RULES.RELATION\">Relation</span></h3><div \nlayout=\"column\" layout-align=\"start start\" layout-padding><md-input-container><label><span translate=\"RULES.RELATION\">\nRelation</span></label><md-select name=\"relation\" ng-model=\"vm.condition.relation\" ng-required=\"true\"><md-option \nng-value=\"relation\" ng-repeat=\"relation in vm.relations\">{{ relation }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'relation\'].$error\" ng-show=\"conditionsForm[\'relation\'].$touched\"><div \nng-message=\"required\"><span translate=\"RULES.RELATION_ERROR\">You must define the relation of your condition</span>\n</div></div></md-input-container></div><h3 class=\"m-0 font-weight-700\"><span translate=\"RULES.SECOND_PART\">Second Part\n</span></h3><div layout=\"column\" layout-padding flex><md-radio-group layout=\"row\" ng-change=\"vm.changeSecondPart()\" \nng-model=\"vm.condition.secondPart.type\" ng-required=\"true\"><md-radio-button value=\"variable\"><span \ntranslate=\"RULES.VARIABLE\">Variable</span></md-radio-button><md-radio-button value=\"value\"><span \ntranslate=\"RULES.NUMERICAL_VALUE\">Numerical Value</span></md-radio-button></md-radio-group><div \nng-if=\"vm.condition.secondPart.type == \'variable\'\" layout-gt-xs=\"row\" layout=\"column\"><md-input-container><label><span \ntranslate=\"RULES.VARIABLE\">Variable</span></label><md-select name=\"secondVariable\" \nng-model=\"vm.condition.secondPart.variable\" ng-required=\"true\"><md-option ng-value=\"variable.id\" \nng-repeat=\"variable in vm.variables\">{{ variable.variableName }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'secondVariable\'].$error\" ng-show=\"conditionsForm[\'secondVariable\'].$touched\"><div \nng-message=\"required\"><span translate=\"RULES.VARIABLE_CONDITION_ERROR\">You must select a variable</span></div></div>\n</md-input-container><md-input-container><label><span translate=\"RULES.STATISTICAL\">Statistical Rule</span></label>\n<md-select name=\"statisticalSecondVariable\" ng-model=\"vm.condition.secondPart.statistical\" \nng-change=\"vm.statisticalSecondChanged()\" ng-required=\"true\"><md-option ng-value=\"statistical.id\" \nng-repeat=\"statistical in vm.statisticalRules\">{{ statistical.title }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'statisticalSecondVariable\'].$error\" \nng-show=\"conditionsForm[\'statisticalSecondVariable\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.STATISTICAL_ERROR\">You must Assign a statistical rule to your variable</span></div></div>\n</md-input-container><md-input-container ng-if=\"vm.condition.secondPart.statistical != \'CUR\'\"><label><span \ntranslate=\"RULES.DURATION_TYPE\">Duration Period</span></label><md-select name=\"durationTypeSecondVariable\" \nng-model=\"vm.condition.secondPart.duration.type\" ng-required=\"true\"><md-option ng-value=\"durationType.id\" \nng-repeat=\"durationType in vm.statisticalDurationTypes\">{{ durationType.title }}</md-option></md-select><div \nng-messages=\"conditionsForm[\'durationTypeSecondVariable\'].$error\" \nng-show=\"conditionsForm[\'durationTypeSecondVariable\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.DURATION_TYPE_ERROR\">You must Assign a duration period to your variable</span></div></div>\n</md-input-container><md-input-container ng-if=\"vm.condition.secondPart.statistical != \'CUR\'\"><label><span \ntranslate=\"RULES.NUMERICAL_VALUE\">Numerical Value</span></label><input type=\"number\" \nname=\"durationValueSecondVariable\" ng-model=\"vm.condition.secondPart.duration.value\" ng-required=\"true\"><div \nng-messages=\"conditionsForm[\'durationValueSecondVariable\'].$error\" \nng-show=\"conditionsForm[\'durationValueSecondVariable\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.NUMERICAL_VALUE_ERROR\">You must select a numerical value for your condition</span></div><div \nng-message=\"number\"><span translate=\"RULES.NUMERICAL_VALUE_ERROR_NUMBER\">Not a valid number</span></div></div>\n</md-input-container></div><div ng-if=\"vm.condition.secondPart.type == \'value\'\" layout=\"column\" \nlayout-align=\"start start\"><md-input-container><label><span translate=\"RULES.NUMERICAL_VALUE\">Numerical Value</span>\n</label><input type=\"number\" name=\"value\" ng-model=\"vm.condition.secondPart.value\" ng-required=\"true\"><div \nng-messages=\"conditionsForm[\'value\'].$error\" ng-show=\"conditionsForm[\'value\'].$touched\"><div ng-message=\"required\">\n<span translate=\"RULES.NUMERICAL_VALUE_ERROR\">You must select a numerical value for your condition</span></div><div \nng-message=\"number\"><span translate=\"RULES.NUMERICAL_VALUE_ERROR_NUMBER\">Not a valid number</span></div></div>\n</md-input-container></div></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"conditionsForm.$invalid\" \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.createNewCondition()\" aria-label=\"Save\" \ntranslate translate-attr-aria-label=\"RULES.FORMS.SAVE\"><span translate=\"RULES.FORMS.SAVE\">Save</span></md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/rules/dialogs/newRule/new-rule.html","<md-dialog class=\"new-rule-dialog\" aria-label=\"New Rule\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"RULES.CREATE_NEW_RULE\">Create New Rule</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"RULES.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div class=\"form-content p-24\"><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container class=\"md-block\"><label><span translate=\"RULES.TITLE\">Title</span></label>\n<input ng-model=\"vm.rule.title\" type=\"text\" ng-required=\"true\"></md-input-container></div></div><div layout=\"row\"><div \nclass=\"input-block\" flex><label><span translate=\"RULES.DESCRIPTION\">Description</span></label><text-angular \nng-model=\"vm.rule.description\"></text-angular></div></div></div></div><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.createNewRule()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"RULES.FORMS.SAVE\"><span translate=\"RULES.FORMS.SAVE\">Save</span></md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/main/rules/dialogs/newVariable/new-variable.html","<md-dialog class=\"new-variable-dialog\" aria-label=\"New Rule\" flex=\"55\" flex-sm=\"80\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"RULES.NEW_VARIABLE\">New Variable</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"RULES.FORMS.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div\n class=\"row\" layout=\"column\"><div ng-form=\"measurementsForm\" class=\"form-content p-24\"><div class=\"mb-16\" \nlayout=\"column\"><h3 class=\"m-0 font-weight-600\">{{ \'RULES.SITES\' | translate }}</h3><select \nclass=\"md-primary-bg md-hue-3\" id=\"site\" size=\"6\" ng-disabled=\"!vm.allSites.length\" \nng-model=\"vm.currentNodeSelects.site\" ng-change=\"vm.getSiteDevices(vm.currentNodeSelects.site)\" \nng-options=\"site.id as site.text for site in vm.allSites\"><option value=\"\">-- {{ \'RULES.CHOOSE_SITE\' | translate }} --\n</option></select></div><div class=\"mb-16\" layout=\"column\"><h3 class=\"m-0 font-weight-600\">\n{{ \'RULES.DEVICES\' | translate }}</h3><select class=\"md-primary-bg md-hue-3\" id=\"device\" size=\"6\" \nng-disabled=\"!vm.devices.length\" ng-model=\"vm.currentNodeSelects.device\" \nng-options=\"device.id as device.text for device in vm.devices\" \nng-change=\"vm.getDeviceMeasurements(vm.currentNodeSelects.device)\"><option value=\"\">\n-- {{ \'RULES.CHOOSE_DEVICE\' | translate }} --</option></select></div><div class=\"mb-16\" layout=\"column\"><h3 \nclass=\"m-0 font-weight-600\">{{ \'RULES.MEASUREMENTS\' | translate }}</h3><select class=\"md-primary-bg md-hue-3\" \nid=\"measurement\" size=\"6\" ng-model=\"vm.variable\" \nng-options=\"measurement as measurement.text for measurement in vm.measurements\"><option value=\"\">\n-- {{ \'RULES.CHOOSE_MEASUREMENT\' | translate }} --</option></select></div><div class=\"mb-16\" layout=\"column\">\n<md-input-container><label><span translate=\"RULES.VARIABLE_NAME\">Variable Name</span></label><input \nng-disabled=\"vm.variable | isEmpty\" type=\"text\" name=\"variableName\" ng-model=\"vm.variable.variableName\" \nng-required=\"true\"><div ng-messages=\"measurementsForm[\'variableName\'].$error\" \nng-show=\"measurementsForm[\'variableName\'].$touched\"><div ng-message=\"required\"><span \ntranslate=\"RULES.VARIABLE_ΝΑΜΕ_ERROR\">A variable should have a custom name</span></div></div></md-input-container>\n</div></div></div><md-dialog-actions layout=\"row\" class=\"md-primary-bg md-hue-2\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-disabled=\"(vm.variable | isEmpty) || measurementsForm.$invalid\" \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.createNewVariable()\" aria-label=\"Save\" \ntranslate translate-attr-aria-label=\"RULES.FORMS.SAVE\"><span translate=\"RULES.FORMS.SAVE\">Save</span></md-button></div>\n</md-dialog-actions></md-dialog-content></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/auth/login/dialogs/ForgotPass/forgot_pass.html","<md-dialog class=\"forgot-pass-dialog\" aria-label=\"Request to Change Password\"><md-toolbar \nclass=\"md-primary-bg md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"LOGIN.REQ_CHANGE_PASS\">Request to change password</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.CLOSE\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close\" aria-hidden=\"true\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div class=\"row\" layout=\"column\"><div class=\"form-content\"><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label><span \ntranslate=\"ADMINISTRATION.FORMS.USER_NAME\">Username</span></label><input ng-model=\"vm.user.username\" type=\"text\" \nng-required=\"true\"></md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nclass=\"md-primary-bg md-hue-2\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"mt-10 md-raised md-button md-primary md-ink-ripple\" ng-click=\"vm.applyRequest()\" aria-label=\"Save\" translate \ntranslate-attr-aria-label=\"ADMINISTRATION.FORMS.APPLY\"><span translate=\"ADMINISTRATION.FORMS.APPLY\">Apply</span>\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/auth/login/dialogs/LanLogin/lan_login.html","<md-dialog class=\"lan-login-dialog\" aria-label=\"LOGIN\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"column\" \nlayout-align=\"start center\" ng-if=\"!vm.fPass\"><strong><span class=\"title\" style=\"color: #971881\">LOGIN</span></strong>\n</div><div class=\"md-toolbar-tools\" layout=\"column\" layout-align=\"start center\" ng-if=\"vm.fPass\"><strong><span \nclass=\"title\" style=\"color: #971881\">FORGOT PASS?</span></strong></div></md-toolbar><md-dialog-content layout-padding>\n<div id=\"lan-login-form-wrapper\"><form name=\"loginForm\" ng-if=\"!vm.fPass\"><md-input-container class=\"md-block\"><input \ntype=\"text\" name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Username\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div\n class=\"remember-forgot-password\" layout=\"row\" layout-align=\"space-between center\"><md-checkbox class=\"remember-me\" \nng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\" style=\"color: #242e42\">Remember Me\n</span></md-checkbox><a href=\"#\" ng-click=\"vm.forgotPass()\" class=\"forgot-password\" translate=\"LOGIN.FORGOT_PASSWORD\">\nForgot Password?</a></div><div layout=\"column\" layout-align=\"center center\"><md-button type=\"submit\" \nng-click=\"vm.handleLogin()\" class=\"reqsub md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\" style=\"text-transform: none\">LOG IN</md-button></div></form><form \nname=\"applyForm\" ng-if=\"vm.fPass\"><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\"><div \nclass=\"input-block\" flex><md-input-container flex><label><span translate=\"ADMINISTRATION.FORMS.USER_NAME\">Username\n</span></label><input ng-model=\"vm.user.username\" type=\"text\" ng-required=\"true\"></md-input-container></div></div><div \nlayout=\"column\" layout-align=\"center center\"><md-button class=\"reqsub md-raised md-accent submit-button\" \nng-click=\"vm.applyRequest()\" aria-label=\"Save\" translate translate-attr-aria-label=\"ADMINISTRATION.FORMS.APPLY\" \nng-disabled=\"applyForm.$pristine || applyForm.username.$error.required\"><span translate=\"ADMINISTRATION.FORMS.APPLY\">\nApply</span></md-button></div></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);